let advancedJson = [
  {
    ID: "513756",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.22132873",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjksLwjAQhP/LnkNIX7GpJ1FB0EMRwUPpocWQBmJWahRK6X830vo6edvZb5iZooe81ofuIiGDLdY6R9MptEAgR23dFbKiH09viAWdccHnQZDSUEQRDOQDeUITFv5lKYvSH/YdOsLyVb5o26rzC/xjpauzdLKFjFFGYCetcs0k9ugqp/3oUR716Y02UqvGPUVCYG3kfTLGnAoRBwSWaNCH2psxQ/kAqxI4+g4BAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACdVk1Lw0AQ/S97XsPmu2lPooKgh6KCh9JDSkO7ELMSV6GU/Hc3NdGkyWtmpaR0Z/a9eZPZme3qyJYb+XJ4z9icPaiNfFa53DLOlkoW+oPNV8efn8YtFubDKv5nuXKFWJy+zMOqdQu7Lsv0YLBB4sRREnHXnTleMgt5EDteELi86wiD2hE5SXLm8GM3rhEiin1OomoRgSeSkRjGcR4jtlYFg08kaBN8QtUYlRf6o5m3jsFLhAn2gkehEwpvWI6OvUfUsXuAp5fDCP8pBQLPZf6hHpQXsiOdKG6vBASe/+kZyQtVGAmFXYIqAAG2pUEB4LEmnRVSg9AQFE2TrUY+AGA/tJPGBSKiDR4SgqQJncqeg9IOaD+ww7lm3T94QpIQFE3wirMdtmg/stNuMURkdRnXCPPP4Famb5nOSjYXjuDsMSt2et8snpROtVRFs3yV21/XfSZ3e90s7vLsq7vxRuXKEBafeV6tvwEEnG17ywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "2",
    "Bottom Elevation": "3424",
    "Calculated Heating Load": "200",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "3500",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "14326",
    Length: "4795",
    Mark: "1",
    Material: "Copper",
    "Middle Elevation": "3500",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "124",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3500",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3576",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "513769",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.31950932",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABAA1jMsKwjAURP/lrkNIJOnLlagg6KIUwUXpItVLGoiJ1CiU0n83tHU3M+cw9Qhla67DC6GAs29NhfegnLYIBEpvXHhDUY9LjIrIacpSvuU8o1JkEqbm7+36Xg1RjsPBqCcG7KFglBG4oNOhm0uykQQqH1Qw3q34Zh4LlZxFekKjuzB3AkeL39UVCc1zwQnsvfXx2n2snZofpcMZp8EAAAA=",
    Pbi3DGeometry:
      "KREAAB+LCAAAAAAABADtVl1rwjAU/S957krSpkmjT2MbDLYH2QZ7EB8Uiwa6ZrhuIOJ/X6fWqendTUpfBkUU42nO/fB+nPGGjGb6Zf2ekQF5MDP9bHI9JwEZGV2UH2Qw3uy/VjAdVi+yDX5/uWKUDncf1ZtsJ/W169Vquq7uchVKoUTAWBpGKk0CLsOIcxacArFk8gegQsaNAI+oOgMkRJXwPcAVYMOiQgHLK8S4CNWlcRklsR9VfcPyCgwQpvJOuxUHlWx/I2XqjKoGeEx3VLFg6gwQQvBGoI6DSskbqVgkIjfjoA3Qq2MSGU3dqCRLoj+NW+6CAaJxWFQg4J4S9K+13MVr9xJAI/cP0Eo7WNQglXOr4c2JewV1rQU415V/Rx2LGhwZjlXSNGScxxLqlftARrsW7HMQsBoH3FEglfNWswIEbYBeoQvS6kF0UlutBgLgZABniUWFLkgwwA41Q3tpgKe9vS7xlwaw8e40g7s0aL8N/MVEh5qhQ2ngrxn8FyR4w39/oEnsNUOvGXrN0GuG/6QZJgG51dO3rMxWZEBDGpDHrFiUy8PhyZTTUpvicHzV8yN0n+nFsjwc7vLs6/TBG5ObirD4zPPt5BtiqRIYKREAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3500",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "19",
    Length1: "38",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "88",
    "Maximum Size": "150",
    "Minimum Size": "100",
    "Nominal Diameter 0": "100",
    "Nominal Diameter 1": "150",
    "Nominal Radius 0": "50",
    "Nominal Radius 1": "75",
    OffsetHeight: "50",
    OffsetHeightTemp: "0.01367",
    OffsetWidth: "50",
    OffsetWidthTemp: "0.01367",
    "Overall Size": "150 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "193.9",
    R0: "51",
    R1: "76",
    Size: "150 mmø-100 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "513770",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.28425973",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9jkELgkAQhf/LnJdFzd1WO0UFQR0kgg7iwWjRgW0nbAtE/O9taEIQ3ebN93jv5R1kZzy2Nw0p7OiMGZm2IgsMMkLr7pDm3XB6g5Q8mCmxCEPFVZQo6NkPGCk+l/KbCS4i9RdNkcWnetk0Zev7/WON5VU73UAa8IDBXtvK1aM4kCsd+smDPOFlQluNVe3eQjDYGP0cjbHkSRKHDFZkyIfahzF98QK2yLKDDAEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACdld9LwzAQx/+XPMeQdl36Y0+igqAPQwUfxh46VrZAbaRGYYz+70bb2jbNJZmMjeW+l0/uLsllc0brHX85vRcoQw9ix59FyfcIo7XglfxA2ebc/lUyXakPavBguQooXf3+qC9qtv2067rOT2ouW5I4WYQ4CBKShGmCI0bSNAqwEpaLiRCTMGoFRlk0ESiLF9iGSpnBnxEKraCBYhK5YgKXBoT/LA4IFpSWdxTS1FjAXvBNb4ipRYUJiRkbb0VLGuxTUG/XqzH3/8lgTjdTYLtfNHqldTscJbTuNPq2yr4UVzRwVvqeTNcFjonuDh4eW04ztu/G9nB7CQznz4YB3A05Oa7cPB7wBoGCnTRPAbJDm+7olhDIp706Z9gPoqFRg4LvkZ6CLm0QhjZtB4ETLnmEbE3CwAHMfq1mDNGt0J30bhDO59MQunr5b3n+VsiiRhklFKPHojrIYzd4EjKXXFTd8JXv/6T7gh+OshvclcXX2PFGlEIBq8+ybLbfwwjCIasIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "3424",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "3500",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "14326",
    Length: "3029",
    Mark: "2",
    Material: "Copper",
    "Middle Elevation": "3500",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "124",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3500",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3576",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "513778",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.9930395",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjMsKwjAURP/lrkPoK22sK1FB0EUpgovSRaqX9kJMpEahlP67USu4m5lzmGqEoqHjcEPIYW8bKvHslGk1AoPCknF3yKvxG72SCp7JOFqGoeQikQKm+uet+l4NXvbDhtQVHfaQBzxgcEDTuu5dhIhCBqV1ypE1Mz7R5Z/ukNrOfXoUSAZbjc9ZT1K+kHHGYG219e/mofVUvwBtTNwKxAAAAA==",
    Pbi3DGeometry:
      "lScAAB+LCAAAAAAABADtWE1r3DAQ/S8+u4s+R1JyKm2h0B5CW+gh7GFDTGLYrst2Wwhh/3vdlfbDtp5sh1wKIiTEsjTvzcwbSZ7b5+Lmrv729LMqropPzV39tVnX90VZ3DT1ZveruLp99v+2r9l1+1Psy/PIG87Y9eFP+1vsl8dlb7fb1VO7lvRCM1FybhdGClMqs2BUXoxqZXWpaOGsNGVkthJWTJkvSSlk3bTPSk+xbpl1/8aFUjw2v2s9jnkcjTMfckHz49aFtTzGcK6n/Tg6MsqHQDh7hjVWiovh8/zeizPwwJBHpgVTkjovji5Mgz4jQE7aOR4xNBg+xgIiAEPAtfkeIKJC2GiEoAfEya8gp72IrKDp6R/KZVAAxDyyMdwb4t4OJ+MXcN2ZD11AhpBrU0vyNB8BAI+Ja+8BMeq9mBlTvABQMsJpv4CUTig7IZiThJEpSAr6DVOKAvt6ap3vBZYNYqtYKFGmDnriUrjgRlhgLXVegHgQGRkCKETq6ApFbaXzw8ocgNt9MI2LFkTNj7IZO2C7x8ug2nCdx9kboT0fw+kSFvPE8Zkor+ABTDByDSYgHqE4LPIXugXYo+nzZQtXAAjoAXAYnr4wYZAREJflFLYDZuUBmWmexLZOuC5X4VJ3C+e6VxEeprch8rFQThwoMSPUAbm9jflbmdUidhyhe5mU2kxCQJScCsHQTstOlJCl1wlG6sI2nxLKKOSKtq/R/U5pf6wxwW1qHBrCXGHqYDysH1eK7LQ4gQVQftBS+isCBamv1rgVTP/F5YOA+0TnJwfvGcgUVkYfQ3Ft0+kB+ey7p9qLTxKhvfZ4BOJc+osQEwntpaq3V+5Sh50JQYx9Mwyc6Ne0GkOAH1YwHqMfz0FPR+emb1mniKPaRU7g71V0u0Vkp1f7SYAIG7KFSUKk0EEHycKQQwEi79CC+bIZ1VNfy0hnWAVjye5XEXYCpm7Midxpy522+NafO22505Y7bbMEkzttudOWO22505Y7bbnTljttlwtypy132jrQudOWO22505Y7bZP09N922pZl8b5e/ah21ba4YgtWFp+rzcPuMTx8aXarXd1swuP3+v706mNVPzzuwsOHdfXncuK7Zt20Bje/1+v98i8SGRRllScAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "86",
    "Center Spacing": "86",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3500",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "79",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "90",
    "Maximum Size": "150",
    "Minimum Size": "150",
    "Nominal Diameter": "150",
    "Nominal Radius": "75",
    Offset: "60",
    "Overall Size": "150 mmø-150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "83.3",
    Radius: "79",
    Size: "150 mmø-150 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "64",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
  },
  {
    ID: "513840",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.96266477",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkGpu0nkQFQQ9FBA+lhxZDG4hZqVEope9upPXv5J529htmJ+sgLc2hvWhIYIulSdG2FTogkKJx/gpJ1g1rMIiYSib5nHNFpzKKoCcfGEmqFI//Qzlh4gd+xw4wf71fNE3Rhg7hsDLFWXvdQMIoI7DTrvL1KPboC29C7UEezemNNtpUtX+KaRgCa6vvo1cIOuNKEFiixZDrbtb2+QOiLxDEEwEAAA==",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVtFqgzAU/Zc8Z5LYmKT2aWyDwfZQtsEeSh8slTbgzHBuUIr/vuh0i+itV4YoJsdzzr1JbuLmTNY783J6T0lMHuzOPNvM7Akla2vy8oPEm/PPq4PZyl2kon89V5yxVfNwN6m2He26KJKT44ploJjilHMdLDRfUiECqSPq90ei7hBBxLXoAWLBVANIFVKMUkfQLFyOWuiIq3nAIKjZWYAWikfhmBLUDwpJKcVo2h0wGEAwWN9bqkDXyQ6mwgd6Sj7gj9MYoclizKLJAqM05TAICbSGsgYJoEVvKv7lPRUTaH2xWsABB8sIxZg7RaADrlBRMYFSOAYqqsnKw68DkAECmP0DFMJsOCgCJiJwafYAzOoHCSAwuS/jCwmUwjFQUYFn3vwdGGSAAHS2TZXx7AO6Jrh/hVuTvKVlWpCYBYySxzQ/lMe28WTLpDQ2b5uvZv8L3afmcCzbxl2Wfvkf3tjMOsH8M8uq7TfH9/pn3QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "2",
    "Bottom Elevation": "2669",
    "Calculated Heating Load": "200",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "2720",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "30.6 /",
    "Flow State": "Turbulent",
    Friction: "1259.64 /",
    "Friction Factor": "0.014686",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "13571",
    Length: "5540",
    Mark: "5",
    Material: "Copper",
    "Middle Elevation": "2720",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6978",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000026",
    "Reynolds Number": "305492.0679",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2720",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2771",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "513847",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.57980098",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnJfFtdVd7RQVBHWQCDqIB6VFF7adsC0Q8b+3oQlB0Jzmzfd48/IeskqfupuCFPZY6QxNV6MFAhlq6+6Q5v24ekMsaRgxsWRMUsFjDgP5AUNJJU/CbyhoEojkD5xji8/7VduWne/gDxtdXpVTLaQBDQgclK1dM4kjutJpX3uUZ32Z0U7punFvsfBDYGvUc/JyTiMmOYE1GvS59mHMULwAj9BsjRMBAAA=",
    Pbi3DGeometry:
      "zQgAAB+LCAAAAAAABACVVt1LwzAQ/1/yHENS0yTdnkQFQR+GCj6MPWysbIHayKzCGPvfrftsyF3SUlaa++V+95G7y6Y7MlnY9+1XSUbk2S3sm6vsklAycbZuvsloujt+tjAftw/Z06vkRnA+PrzaH9nPzmp3m8182+oqw7guDBXCMC2VpFKyXBhJlWaFuBUeoEx+kKvM3690RnEiw0ShNaiRSZWHFgAmkwuNuxQxjQIDTUcAjCmI2vCsgPJ3kfcN7pKNf6LMMCOL7JrWM1EH8Ii6Cl4yQoVjCIGFCBMCDPDJzzcAYM6iPgVRHBM+gCnhExZdeEK+ZaxmAAWkmJLBhSZ6n/WZKJENoCMSVKgGEF6iHaGjwLoLlKeIgiAicqwGYmMU5UmP3eT+WE0Gwzgi71nbHs/wmQFdQFEmTGHIzZSYGQAVCvQfPz4VAGAt2ntqpO5XMIj2v8GDnX+WTbkhI844JS9lvWrWp8Wra+aNdfVp+WGXF+iptKt1c1o8VuVvd+O9q1xLWP9U1X72B5yNXFTNCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2669",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "2720",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "30.6 /",
    "Flow State": "Turbulent",
    Friction: "1259.64 /",
    "Friction Factor": "0.014686",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "13571",
    Length: "3079",
    Mark: "6",
    Material: "Copper",
    "Middle Elevation": "2720",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3878.8",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000026",
    "Reynolds Number": "305492.0679",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2720",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2771",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "513854",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.3838044",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyGkmmisJ1FB0EMpgofSQ6pLG4iJ1FUopf9u1AreZuY9pughq+yxuyGksA+VzfFMxtcOgUEWrKc7pEX/jVGZaS7mC71MEs2V1AqG8uet2tZ0UY7DxporEraQCi4YHNDX1LzLVCvFIA9kyAY/4pO9/NMd2rqhT1dywmDr8DnqUnIlNIN1cCGe+4dzQ/kCMtBGcMMAAAA=",
    Pbi3DGeometry:
      "ByUAAB+LCAAAAAAABADtWE1r20AQ/S86q2K/P5xTaQuF9hDaQg/BB4eIROBaxVULIfi/d+2VbK+1T17lGJbgxNrJzJt5MzvanbuX4va++fH8uy4WxZf2vvnerpuHoixu22bT/SkWdy/+qxOTG/dT7MrTyjtKyM3hl/sUu+Wg9n67XT07XaUrY6gtKTWV0lyXQlRSWlOeC6Qw8iAg4fqgYCjhSQqCcT6JYBSjaRCaSbUXKKc4K4gRBHRqEIywrwpGprimYsrbZAbDKEzFiPR0CCVOyKYi2v0NBCS+jgx5j9y6VDYQHEJAwLqyUqioobhHEQUYwuBqsqVjDCi2VPKGmgEIMAgnIEyP6XPrXDJfAVz6WhKunvcCpqhXIIztBdpa9qotgS1Z1TvLqT5XQL4iQ5CO5F165O9q1JeFTxj1OVJEBfsaMDuVVcN7U1oHCnGIV9VHFGJiHQaBwoZJhckD2YYNE5YszioschT27ErDGgAimSepicW1PNGFLPeGlOXeEBNyskckv2dPPZZyLxBChRBIEHcqUk+X2NeayoimkbOQD2QKN1MYHjQFwVN73TG+aN1gAjHjoG4wgZin2XSgqOeWJoBGdODzCJU8XObm8GqmpBdIK7yAcRGetYy0XoPbCQ0noH0Xcj7Tg0Dp+CtkdFwNIBAbe2jmoYXwCJetFB3/wvMiZm8+G5BvxBKEjrOXdH6+8In1O+JYfIyJqSMm1VYEvg7rUbonEj3P0ER+MAIUwKoEhY/OpBgBGQJsQzJmx4ZcjSOj7TAjDeP7Vl9hhisWddWQeDcxQumeDDUIzrt66q3nqkf4vJZ6oxsuK5d5NpzGC8NM3lZnbJ+RoUu2Eavw4Iw14F0PmoKpBtGBTENaYckAYBgCtgSgYQWgkFFo8xKasuHyiCiPiPKIKI+I8ogoj4giDTOPiPKIKI+I8ogoj4jyiCiPiPKIKI+I8ogoj4je/IhoWRYfm9Wvuqu3xYJUpCy+1pvH7ql/+NZ2q65pN/3jz+bhKPpcN49PXf/waV3/O//HD+26dQY3f9fr3fI/ao4lmAclAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "60",
    "Center Spacing": "60",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2720",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "54",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "95",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    Offset: "60",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "4282.5",
    Radius: "54",
    Size: "100 mmø-100 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "43",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "513870",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.67391673",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABAC1TksKwjAUvMtbh5C00p8rUUHQRRHBRemixZA+iHkSoxBK726g1Ru4mx8z04xQ93gJDwUVHKnHmkzQZIFBTWj9E6pmnGEMZAUXeVmsZVJyscolTOw/Zvud3zjXhfghCjvs7sorB5XggsFJWe2HhZzJdx7j7Zle8fazDgr1EFek5GkmEgZ7o95LOE25TLKSwZYMxWL7MmZqPxygD1MUAQAA",
    Pbi3DGeometry:
      "3wgAAB+LCAAAAAAABACtVlFLwzAQ/i95riFJY5psT6KCoA9DBR/GHjpWtkBtpEZhjP53w+y6rdk1KUppafLlvrvL5b52vkOzpX7dfhRogh7NUr+YUq9QgmZGV/YTTea731cHk6m7UJMcZ64oIdP9w92oWRzMbuo63zpbkWElWEKZwlRwlaQppkyoREhMMiUdILGUhB+Bg4HEiikWNU9TuvdAeEZ9g77nYEQKM5pmEaFKTFWWXaRiXFxfiKmz6GcxAIBRgc7BcENUgT3nHHPp0vFcdEBvb2Pmz4rnGUR77icXdN1P+gQ4L55vAVL5ABDUgHMQAKngWkQ1BrRTMetBB8NVHbFPwJGNZfqHrgdr51OFOjJEFQOAhzMkOSGqP8laqGVG6F0k1YiWAbUCFPQQ1QjdBlUY0s7YD18sUcw82K7DChJiCuTg/hbudP5e2KJGE4JJgp6Kam037eDZ2NxqU7XDN73qoIdCrze2HdyXxffpwltTGkdYfZVls/gBwwOiT98IAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "-803",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "2660",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "30.6 /",
    "Flow State": "Turbulent",
    Friction: "1259.64 /",
    "Friction Factor": "0.014686",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "10097",
    Length: "3463",
    Mark: "8",
    Material: "Copper",
    "Middle Elevation": "-803",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4361.6",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000026",
    "Reynolds Number": "305492.0679",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-803",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2660",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "513871",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.72124166",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAQRf9l1iE0bZqXK1FB0EUpgovSRauhDcREahRK6b8bX+BuzuXcO9UERWsO41WDgp1vTalPoXGd1YCg8MaFG6hq+pxRYQInXIoFSSVOKCcw1z9vOQzNGOUYrE1z0UEPoBKcINhr14X+BZnIcwSlD00w3oEiOOdxj2Up45IKyRiCozn/y1ttuj68mUfcWP34linFVHCCYOWtj7/c3dq5fgKnTN4V0gAAAA==",
    Pbi3DGeometry:
      "FSUAAB+LCAAAAAAABADtWE1r3DAQ/S8+u0aSJVnanEpbKLSH0BZ6CHvYEJMYtuuydQsh7H+v1vJ6/aEn2emtiJAQa6R5857G8mjuXpLb++rb888y2SSf6vvqa72vHpI0ua2rQ/Mr2dy92H+NmdyYn+SUXkfeUEJu2j/mNzltL8veHo+7Z7NWFpkWXKaUqUwzqlPOM64Kmp4NhBXGoDPCzUBvUBkjYs2CHkJntGD5yJOQegWEykihVWtQhQNgPh8A+EJqkZeOexx1oeqMMc7+Qb4wCaMG1y2EoiQfuLoapBIDT/PxLqSxn6HcF4NkPuS5JyGMBxiRw5FdgEL1UHMCI2o+Bgs16pkhBjPxBLERccJtAkjSZow4DxgD1XZc6Zy34znlq18G7OY6XebaxmP8eQINxYMJF+F897iHh8JlZ7TSrUGyzoAUhXvZL6BKtguU9iOsSgoPQHAcMZhGBHczvP2TdIRyw5jAhuIFgPXaBIPzgX+gkXlnpZABkcbfF3R6UfPYAhNm/WjlPl0m56DnLJ99FnoMQa0nKZeNT2O6kMCpNCbtFmlRqFPooKuZTogd9OTGRnm/KAemWeMWcInk6Ks3UzBMb5EeHtrrMxNBQzkQ6zwfDRdCMQugmEUm1BoosQhM2ZAo0ePUhCsktUUXUUy0hvNZ4g0WYqByrC/sqOgwSCE8FR+sEb0ZtVoSeEQhTxAbaghpuIMyipiZ4yIrl8xTWA407MNVvPCoDsN9lStIEEoCDVB29BLAWh5COD2FRZ8K8ip6qHoOg0+vQ/B1gjexnDqTjerCnQiMU+7Yi5Eg5nC0grhL90t6oosSiilUUOKb7wyBSencbkwb6AcFx54QOySsp1IPrUA31qknGGz4eJ7uNpQWRouVghcOxBtigzwI857SW7+t/lZH7BTFTlHsFMVO0SDQ2CmKnaLYKYqdotgpip2i2CmKnaLYKYqdotgpcl8aYqdoKGzsFP1vnaJtmryvdj/KpjwmG5KRNPlcHh6bp+7hS93smqo+dI/fq4fe9LGsHp+a7uHDvvwznPiu3tfG4eH3fn/a/gUZJLRnFSUAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "60",
    "Center Spacing": "60",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2720",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "54",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "102",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    Offset: "60",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "4282.5",
    Radius: "54",
    Size: "100 mmø-100 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "43",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "513911",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.55910439",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjV0LgjAYhf/Lez3GnHNzdhUVBHUhEnQhXmi96GBtYSsQ8b9nX9DdeQ7P4ZQj5I05DFeEDHa+MQWeQu1ai0Ag98aFG2Tl+ImzIhOq0pgvIq4pE4rDVP28Zd/XwyzPxdrUFwzYQ8YoI7BH14buBUnCIwKFD3Uw3kEW0UQxpWXMpdIi1VISOJrzv7xF03bhzSJSBDYWH9+1kFRLnhJYeevnM3e3dqqe+UcL8dMAAAA=",
    Pbi3DGeometry:
      "sycAAB+LCAAAAAAABADtWMtq20AU/RetVTHvR7IqbaHQLkJb6CJ4kRCTCFyruG4hBP97JY0sydKcGSntcggO9jzuuY9z78zc25fs5r789vxzm11ln6r78mu1Kx+yPLupyv3xV3Z1++K+1tPkuv7LTvkw8oYSct3+qz/ZaXPe9vZwuHuu9ypZWKVFTpkptFK50AVRuVIFEVyNR5kQNK9XS2vp8tVT2YIZ1kphzCyVLgttOBtGVWEN1z7pbjXEnMheq8t5PZJ/qaUuJBFyra1RT9qCcSpaJ6ha7LDB1l80GyZ6XM+EA56K6i2wBSdajScAOMQIaNV7zyhOPVp5JpAdMVFzddfaEcAYom2UWWaHENpNGGLagFvNMekRbVAyKCq5E8/qhY0YNllviG43aK2CFiBJ0DKkkt8wKB7lyXncaKubCWoUfY1D0fKoQtZy2QJfVgyYWZDDHlHQBmQ1jOcCAvwzU9ebgTCQtsaKLuGIcClqtLmY0I0jmg1EBPwxqqSWU94qa90OcGwY0SkktG2HG5sCwHBD5EC9VGf52Rk+CyEt/OqP9TGWteONxKDfkMGQYbB6wigj82AQwleAS1xo9JJgTk2I82Upg+EGABEyI2L4vGTB2C0I0TThGHPXB2KIqw6N/sHLgDVuB5Ve4swPanPewS4vKFI6OYS3lOWEjGtfjdz4urmsES3mPBsua5384XInlQ0BAH16XEY7V3T1EMn5b56Ad7iVKsFwQl1RJQuVPtJi9xs4Vyw4DgVBXWPEmHqjn6CiTTkuZJAAaD1kHmSA91mBfBFgKnieQNy1qeMHDgRtXWxguYgXmPmRpSh9XWGYxVMqYn1hgAhSaPcIIdYhUEP5MupNU1cpwz2pDhHgTRrYUKexv/hgBPTCwu4Ar+nOthmNoZfiIZ1GLuIm+HKeX3Ojyk7ZhN0BsaG2KEgRpWZHXJz6M5f7+QeNQ3xdTRrsPsRk1OOJpgp446GujaeFgCCgEanxlhpvqfGWGm+p8ZYab6nxlhpvqfHmDWZqvKXGW2q8BXRNjbfx+tR4S4231HhLjbfUeEuNN48Rmzx7X9792B63h+yKFCTPPm/3j8en7seX6nh3LKt99/N7+dBPfdyWj0/H7seH3fbPeOG7alfVAve/d7vT5i/ZXBRssycAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "86",
    "Center Spacing": "86",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3500",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "79",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "107",
    "Maximum Size": "150",
    "Minimum Size": "150",
    "Nominal Diameter": "150",
    "Nominal Radius": "75",
    Offset: "60",
    "Overall Size": "150 mmø-150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "83.3",
    Radius: "79",
    Size: "150 mmø-150 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "64",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
  },
  {
    ID: "527395",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.66484559",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjk8LgkAUxL/LOy/L6v4B7RQZBHWQCDqIB6VFH2y7YVsg4ndvSRPq0u3N+w0zUwyQ13jqbxpS2Lsac2f6xlkgkDu0/g5pMUxnMEhGYyXVKmKSyoQJGMkX5CL5y5Ti/JctoRMsP+Xrrqv6sCA8Mqyu2usOUkYZgYO2jW9ncXS+8hhGT/KMlwXtNDatfwsVSwJbo5+zl3MqhIgIbJxxIdc+jBnLFyaSoXERAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACdVlFrgzAQ/i95ziTWJK32aWyDwfZQtsEeSh9aGtqAM8Nlg1L87wtOO40eF0uxmPu877u75E7XZ7La6bfTpyIZeTI7/WpyvSeUrIwu7BfJ1ue/WwezpfuRiv5bbmLGlvWfu0i1ad1uy3J7cr6CRTMpJI2ZiETqbpIk4nPBaReQM5nWAOdxH2B8UQMiSWgYVeuRzsWohmBS9gGxiKdFBYqjCU4Qx6IaUvF0PPHG7pcQLronnTiCsc242D2i1u5Xw3++zWDA32SA8WD8fjxgXpAdiBPU7W8Amu6V4QzS6u8vGiXUIMGnGmUKBqASgYcdd4AUApWBvQzovqlEYXboUODNCjoAAmG6wKGbPs9QojA71BzglMMdAIEwXWhWBkzdyUyhADQR0AbHX7J+NTp29yVwr7cfyqqSZCxilDyr4mCPzeLF2K3VpmiW73p/gR6VPhxts3jI1U/3wTuTG0dYfOd5tfkFHPrdlbsIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2894",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2903",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10399.60 /",
    "Friction Factor": "0.02244",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10195",
    Length: "25",
    Mark: "246",
    Material: "Copper",
    "Middle Elevation": "2903",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "264.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "40176.96154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "139",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2903",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2913",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527396",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.76170026",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbh5BUE2pdiQqCLooILkoXLYb2QcyTGIVQencDrd7A3fyYmWqAssVLfBgo4EgtlmRjRw4YlIQuPKGohgmmgBJ8KaVaS6G4zvQKRvYfs/7Ob7xvYvqQhB02dxOMh0JwweBkXBf6mZwpNAHT7Yle8fazDga7Pq1IrjKdMdhb856zC8nzXGsGW7KUet3L2rH+AHKw4qUTAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVlFrgzAQ/i95ziTRmKl9KttgsD2UbbCH0gdLpQ04M1w2KMX/vqy61livnogoJl/uu+9yl9PlgSzW6m3/mZGEPOm1etW52hBKFloV5osky0P9amE2sxep6HnmhjM2Oz7sTarVv9m8LNO9tQ2ZJ4R/SzkLPenLmAaBJ7gf0z+A8/AIhHEoHSAIZG3BROQAINXJQvS7kGHE20AQMX+kKND3YHxo58OqLqli0Rf4eb67hVB8sG83G9yLIil7qFqAuyM9FnUYLcDJH4Zp0EVXVCc+BACrhZy72UAwTRB1GZ+TcVAtdGigZCDWI08GIt3gjkP1j2Sa0Cmu5G7o6F31MFw18DyuaCBJow3Gdy6wLBEdCkuFKX2wQ8FdEEc1pdPCqsDvHgggqTAAstViPgxIixqw/wz3Kv3ITFaShHmMkues2JpdM3jRJjVKF83wXW1O0GOmtjvTDB7y7Ke98E7n2hIW33lerX4Bs54GTOUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10399.60 /",
    "Friction Factor": "0.02244",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9719",
    Length: "465",
    Mark: "247",
    Material: "Copper",
    "Middle Elevation": "2884",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4837.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "40176.96154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "139",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2884",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2884",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527397",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.69217295",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzGkTZuaehIVBD0UETyUHiqGdiEmUqNQSt/dYOvfzdvOfsPM5B1kR9y3FwUpbOwRM6vbyhogkFk07gpp3g2nN0SUSyFnAYupEJxDTz5sEoR0GonkDxpLFv3Qr9yBFa/6edOUrd/gH0ssz8qpBlJGGYGtMpWrR7GzrnToZw/ygKc3WiusavcUIowJrLS6j14e0ESGksDCautzzU3rvngASddXqhMBAAA=",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABAClVlFLwzAQ/i95zkqSpV3bPYkKgj4MFXwYe+hY2QK1kRqFMfrfzWqnac2t10lZab67++675JJseSCLtXrev+UkJfd6rZ50oTaEkoVWpXkn6fLw/WnNbG4fUtNfZMIZmzcv+yP16hR2VVXZ3sbKYJpECeUsDKIw5nTKg1hITl1c2A+LzxKRdHDZwDETFMPSestI+MjjMJQuHiZhNEoMlHagKGzeIT19nojJ2FvvCWfeaeiX1Uk74eLIN+vPfhd3mboWdyq8MU0R3izHKrBkg2n+SoPLPDMBsGhYgbsqSLb/aPMsArD+sGRg34ALA/hfsl5gDqjpUX2E2T0Id5yioW04ohHOxIAW1HECc2EOIIw/ShPUmg6MbX8oBDZAx/rojQQRIdxxivy33vjTGIqAcMwFBzGNuJ+ZsP8RblT2mpu8IikLGCUPebk1u3bwqE1mlC7b4Yva/JjucrXdmXZwW+SfruO1LrQlLD+Kol59AbrwkKHVCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.1 /",
    "Flow State": "Turbulent",
    Friction: "568804.11 /",
    "Friction Factor": "0.015582",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "5256",
    Mark: "248",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2989551.5",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "356570.5336",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "119",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "34.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527398",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.65058898",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjUsLgkAUhf/LXQ8y4wu0VWQQ1EIkaCEuxrrohWkm7BaI+N+byqDdeXycU09QtnQcbwg57F1LFZ5Z284gCCgdWb5DXk9f6ZFEBrFSyUrJJEjDNIO5+XHrYdCjh31QkL4i4wC5DKSAA9qO+7dRKk4FVI41k7NLfaLLf7tD6nr+eBmHArYGnwseRf49zARsnHF+3T6MmZsXF6w6lsQAAAA=",
    Pbi3DGeometry:
      "ex0AAB+LCAAAAAAABADtV0tP4zAQ/i8+Zyu/k5TTakFCggNakPaAeigigkjZBpWAhFD/O17qhMb2F6ec9mBVrZpxZr55j+f2nVzd1TdvTxVZkov2rr5um/qeZOSqrTfdM1nevu//mmN6Yj5kl31RfjBKTz5/zJfsVj3bz+12/WZ4FV0IWWaMqoUqFM+EWMhcyeyQXubyH11RQziga6VFiA7f57r8pLOczZGjdaGm9JFSjXGB/r18730gB+FCfSK4yA9SiHyWPo7+kjE1BmZ8z1DwsSBLHxgGC/oDSR0I9wCKQtiuJKST0GUx9kZUJwSNzVOCTWN45kXBXQxoH/IHSqZS8PGBClfJkB3aZM/IOJ7rOWmGysGjQ40iofboUU0900BuYEnHqoRsw3HuOYbsc+LjVS9KjKigSBue3cbc+EPn4QMUh1ij8boDNDpSPh4dGY1skJzaA8b3yIUMdt2+S0smtD2wkvJc7SXpXicWTibXuOPdATGwVnTc4hQVLJQF7tBFQxrTmXVf+U03TcyUI22DMTVBdxq+KqYHAWKAuiIGqBKSBPMPSopE2usb8Y7lhBQbjVRCkZsoCcQBlEJ5HM175/L1ZYNkKhggf+RbVc3BOC2jM8KbKn1NaM2DSWDoKlhdLjYeytH7A7zVOtDIUdCzqEqh/6DHo25yoaGbkHHRG6GvU7jgJ24QyOyjrYMpiyEQB+ykkf7nuwMhID+l5TItl2m5nAeelsu0XKblMi2Xc4xLy+XMmZKWy7RcpuUyVF1puZyETsvl/7xcrjJyWq//Vl21JUu6oBm5rDYP3aN9+N12665uN/bxT30/HJ1X9cNjZx/Omur18MVfbdMagZuXptmtPgD5HCmjex0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2903",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "552",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527400",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.62727034",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yyibrppp6ggqMMYQYexw1ayCaaxLBhj3z17g27Py+/hqSYoWnMYrxoU7HxrSn0KjeusBgSFNy7cQFXTR0aEE5xSyheUcCyYkDDXP245DM0Y4RisTXPRQQ+gCCYI9tp1oX8ZSlOBoPShCcY7UBTzjGRSJExkMs2liO3RnP/hrTZdH96epAzBxurHd51QnOWMI1h56+OZu1s7108xE/KX0wAAAA==",
    Pbi3DGeometry:
      "ex0AAB+LCAAAAAAABADtV0trGzEQ/i86b43eKzmn0hYKySG0hR6CDw5ZkoWttzjbQgj+71G7j0aPL1rTqzA2Xs3O4/tmNNLcPJPr2/bb08+GbMllf9t+7bv2jlTkum8PwyPZ3jyPf52YXrgPOVX/Vt4xSi/+/rgvOe1mtffH4/7J6Sq6kYypilG1UUbxSrCNMVpXfwSS2lFga5kUaKXFOg0l2KjBtV1nao5Ka6NeC4ThaRcIxqwQesgaCj3nBZDByLe2JskHCgqCkNb3zCXz1mc7SnjvLxCC92f7tZV1yk60DvwucQZ+YTwzD1qZVfEgvwjXZL82XK3Bhfwi+xBXwAMuayu4L5BTpCjzWtQ+dTWzq2oLbYRoHYaUSXK0DkPNVHVUFdDQuRFloYV5nhWWwgvSE21YVBjIULZ/oZYQrcP844rJ0Qp2J6r6aHdC9nKGwnWIGSCQnE4CxkfPTNq3jyrmXI2CyZRT9EJiYylRK9dhO58M3wOKSArLfdBCrjxt4YkeCbhaguL/RRNouOeDQxkVVgaoqVGpKl7OgJxCdDggBRwTQo35RvUK+YB9A3YalFMYLQwKFQFuciDbsMxgKUM+4I1yQSGZSiUpPPOXYJ0gVeLwjMCHCpfexp5RO0FwoQSeoQckwHdW6BvRhInFpZkhEF6yAp7wkJB2AMHlroNRRLBFYMJzRbMWG8wDBI0UUH7yHTPcEXALwc5YhssyXJbhsgyXZbgsw2UZLstwmbyDluGyDJdluCzDZYrYMlwmKrwMl7uKfGz3P5qhOZIt3dCKXDWH++FhevjSD/uh7Q/T4/f2bhF9btr7h2F6+NQ1v1+/+KHvemfw8KvrTrsXHvMzKHsdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "554",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527402",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.02714942",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkSbWmnkQFQQ9FBA+lhxZDuxATqVEopf9utK0HEbzN7BtmJ20hKfDYXBXEsLMFJlY3pTVAILFo3A3itO2lD0wCQVnA54uQioiH0JEf7CVExMQX5VQK+Y+Ovdn4flnXeeM3+MMa84tyqoaYUUZgr0zpqsEcrMsd+tm9PeH5g7YKy8q9zYxPCWy0egxZEdBIcklgZbX1veaudZc9AYrNJD4TAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVt9rgzAQ/l/yHCXGWGv7VLbBYHso22APpQ8tlTbgzHBuUEr/96XOrWbenQapNN/dffcjyYerE1tu9cvxPWcz9mC2+tkUesc4Wxpd1h9stjr9/LVmMbcPO/MrEkRCzJuX/bHz+jdsUVWbo40NIhlm6STmKoxTqXgchdMkUTyI4lCIdNLFpYp4459NVRdXE8lxHosnSoL+KolAfpcnzWRG14PlxXCvvASO8fzrV0hwbA08uqtr1gvNJTBORdyZZ8vkWBwux+LMAo65dAHkIdkQi1dt7txhC141XluvHyF9yQZLIxvtbdzQCUB2mriB9Nno5fArd+T+QzeO5sIifDSG3neICcM9TpDDBVvww0WpB841Qm8G/ek7DygXAntoh8AGJZCpD6svSYUFAF1Qqg9XBAk5DtM8YAekUgAT99GQMaLjdGG/GW715i2v84rNRCg4e8zLfX1oF0+m3tTalO3yVe/+TPe53h/qdnFX5F9dxxtTGEtYfhbFef0NMOYSi+UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "232318.90 /",
    "Friction Factor": "0.016571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "5408",
    Mark: "249",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1256376.5",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "220973.2884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "109",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527403",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.32126615",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjssKwjAQRf9l1jE0TZuSuhIVBF0UEVyULloMbSBmpEahlP67wdbXzt3cOZfLyXvIKn3oLgpS2GKlMzRdjRYIZKitu0Ka9+PpC3FEQyHFfMY4jYTkMJAPZIGgLImTPyiX4pd+D4+weAks2rbsvIV/rHR5Vk61kAY0ILBTtnbNFPboSqe9+BiP+vRGG6Xrxj2DCGMCa6PuU5czmshQEliiQb9rb8YMxQMsasqIFQEAAA==",
    Pbi3DGeometry:
      "DwkAAB+LCAAAAAAABAClVl1PgzAU/S99ZqQt5XNPRk1M9GFREx+WPbCMbE2QGkSTZeG/2+FQcJxwmSF8lMM599y2t2V5YIu1ft6/ZSxh92atn0yuN8xhC6OL6p0ly8P3o4X53B6sdn7fzATn8+ZiT1avWtpVWaZ7y/WVK4M4cGbCc1WghOMJN5L23gM8GR2BMJZxH/BV3DC4dGhKLUEFcjBE5PuqD3ARTDQFg4/lNyH4mKtzKcHD4cxb4G8fwvy6sQUPXBH64dlw9IGuVh/p9skgp8lkOMwxFaraaJwBbzhRjGDX2EF3aKhq//A2kCmaA9gzLCQ8OJByyajhMLACaBOKVk0kBtHXaGVOmReYgxHSKoPFaAsTiUH0haZr5z21JiAFAnBdnF5eUIpCILpCW+QFazWkQIC0FUKtaVs6l/bv4kanr1mVlSzhLnfYQ1Zsq92p8WiqtNKmODVf9OYHusv0dledGrd59tn98NrkxgoWH3ler74AuRJRwA8JAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "1.6 /",
    "Flow State": "Turbulent",
    Friction: "36250.24 /",
    "Friction Factor": "0.019555",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "15821",
    Mark: "250",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "573514.2",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "80353.92307",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "101",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527404",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.47157458",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjc0KwjAQhN9lz2lomjZp6klUEPRQiuCh9JBqaAMxkRqFUvruxj/wNrPzzU49Qdnqw3hVUMDOtbpSJy9tZxQgKJ22/gZFPX1kQCKSYMEZXUSE4pQmOczND1wOgxwDHQ5rLS/KqwGKGMcI9sp2vn8ZQlKGoHJeeu0sFARnPOaC0YRxkeaChfSoz//wVumu9+9POaUINkY9vm1KMM+TDMHKGRfG7N2YuXkCXGXKLtQAAAA=",
    Pbi3DGeometry:
      "5x4AAB+LCAAAAAAABADtV01r4zAQ/S86O0Gftpyelt2Fwu6hbAs9lBwSalqDN15S70Ip+e/rxmpU23qS0ltBhIbak5l58/Q00ty9kKttffP8pyIr8qPd1tdtU9+TjFy19a57Iqu7l+Hf3kwv+g85ZPbNglF6cfzq/8hh/eb2Zb/fPPe+C8aXZZGLbMHEUhRUZIItC83V8QWlSo8tpSzcFq1EHvJhExcumTeYA5rOjz/tLTJ3psHlOHxsnvhoFkG8BRNqEQiZu9jxYsP1MDFYpOB6zMHJQsUk2tTH1nOy5BzlMRYcDSNwRIPYRMnYmJ0IbBgBrrSQyp/HUWkQgSMPXoUZO1hvRlSSGdBwk9hgXA+KFHpSZ7wO8e6xFogsXgQRmMP7YK4bGOwjyMJlzhQwccFNCkvDWmCw+F6Iu4q1YG1ANoM0e3Z0sEPZaiAB8RsthgBYjVYDM1LyoRpa+o/Q17XR0lSjjGFKgCxMNdqtM9zRzmFmlsUN7LUW855zOT7Ao092fIGwvJR0YtFafZgx3LbPrBIv8pHk0li0BGKeHSgRPjPM2AdjA9G8S+CRMyIHdxqoQLzQmAFcJxQHbo7IAwDzCh1tDXzjm5UidPC+NYGs1UwzoYPGcTaZTaNVCXZgb9GB/DALNODrDE4PKPPPI1CxQS7xhW5MmX+EQWlwmfG30PdXENQa8AoECTijTKxmmMazmmjN4ptmDDIcLY3EaSROI3EaidNInEbiNBKnkTiNxO77WBqJ00icRmJ3/jQSp5EYqPlzjcTrjHyrN7+rrtqTFV3SjPysdg/do3n41Xabrm535vG2vj+ZLqv64bEzD9+b6t/7H35tm7YPuPvbNIf1fzsxdd7nHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "556",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "168399.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527405",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.17455174",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkTRq0nqQKgh6KCB5KDy2GNhCzUqNQSv/dYGtBL9529g0zk/eQVebU3TQksMfKZGi7Gh0QyNA4f4ck78czGASnkVCLFWcxjZdMwkC+oIgY/w+VEuIXzrEjLD7167Ytu7AhPDamvGqvW0gYZQQO2tW+mcQRfelNmD3Ks7nMaKdN3fi3UFFMYGv1c/IKQaWUnECKFkOue1g7FC/eS5ruEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVt9rgzAQ/l/ynEk0P6r2aWyDwfZQtsEeSh9aKm3AmeGyQSn+7xOnrRqPnEOU5j7v++4uuavrM1nt9NvpMyMpeTI7/WpyvSeUrIwu7BdJ1+e/nzXMlvVFKnq13ISMLZtHfZNq07ndluX2VPvyMIi4imnIZCATqSjngVhIQfuAilTSAEKEQ4CJuAEk5xRH1XkkCzmpIZlSQ0DG4byoQHFvgjPEfVG5VCKZTry1j0sIF30kzSMWTu7GFRhRXYBxQRyPLgtXo03DT+XVcKKCEwQBKFxYfLgbiMT/HZSb33DHEcFCTYM+6X4qNACWCmwBhAeogRWHNhbRl7OZcHbwgCAaGfSAJJDS0BGcP+/8TDg72C3gHER4QBJIaXCgImbzfCosAI4Jf9P7/42dkvSA+pvhXm8/MpuVJGUBo+Q5Kw722C5ejN1abYp2+a73F+gx04ejbRcPefbTf/HO5KYmLL7zvNr8AiD3aaDlCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2894",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2903",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10399.60 /",
    "Friction Factor": "0.02244",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10195",
    Length: "25",
    Mark: "251",
    Material: "Copper",
    "Middle Elevation": "2903",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "264.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "40176.96154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "138",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2903",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2913",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527406",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.33960467",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzyGkLQ22nkQFQQ9BBA+lhxZDuxCzEqNQSv/dhVb/wNvOzjBvqhFMi5fhYaGEI7VoyA0deRBgCH18QlmN88mBLJHZKtXrROVSp7qASfzHrL/4TQjNwBv4scPmbqMNUCqpBJys72K/iDPFJiLPnuUVbz/rYLHrmZLIXGkBe2ffS5SxhdKFgC054lr/cm6qPzRomWYSAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVt9rgzAQ/l/y7CQxJtP2aWyDwfZQtsEeSh8sDW3AmeGyQSn+7wvVtcZ69UTEH7kv991d7nJxeSCLtX7ffykyI89mrd9MrjckIAujC/tNZstD/elgOncXqYKz5IZROj8+3E2q1b/aXVlme6fLWcgF4wGjIpSRTAMnSGn95kkkj4BIhfQASUWtQePEA0Cqk0bcb0KKhLWBmPFkpFOg7cH40MaHvbqgovFtX+BneXcJofhg2342uJsZ9VG1AH9FejTqMFqAlz8M06CJrlOd+BAA7C1k3M8GgmmCUxfx+RkHvYU2DZQMxHzkzkCkG1xxqP6RTBM6BZy7wa131cJw1YByZNFALo1WGN+5wLJEdCgsFab0wQ4FdkEk1ZROC3sFnnsggKTCAMhWizkYkBo14P4ZHnT2qawqyYyGNCAvqtjaXTN4NTaz2hTN8ENvTtCT0tudbQaPufptT7w3uXGExU+eV6s/SR4s5+UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2884",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10399.60 /",
    "Friction Factor": "0.02244",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "459",
    Mark: "252",
    Material: "Copper",
    "Middle Elevation": "2425",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4773.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "40176.96154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "138",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2425",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2884",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527409",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.81374274",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjMsKwjAURP/lrkPIowZbV1IFQRelCC5KF6le2kBMpEahlP67USu4m5lzmGqEojHH4YaQwd43psRz0K61CAQKb1y4Q1aN3xgVyalcCrXibEGVUClM9c9b970eohyHjdFXDNhDxigjcEDXhu5dOE8UgdIHHYx3Mz6Zyz/doWm78OksEQS2Fp+zLiVNuEgJ5N76+O4e1k71C6Opv2bEAAAA",
    Pbi3DGeometry:
      "AR4AAB+LCAAAAAAABADtV01r3DAQ/S86u4u+ZW9OpS0UmkNICz2EPWyISQzuumzdQAj736PEsltJfta6l17Ekk2c55k3b2b0MTfP5Oq2+fb0syZb8qW7bb52bXNHCnLVNYf+F9nePA9/Wphe2A85FX/+845RevH2ZX/IaTeavT8e90/WVrCN4JQVjKqNKhUvhNhIo2ThAZWRr4CisvIArbSYBbAF19UbwAw7z5XWpVqMSkoVkCMdI0dsgVxBchxVihymRAphzowq1FFy7ZMzPgBKBK5GYLSYdDjA/g44QgC6guShKxyVpJWfklRUmBwK5FIsc4RRpclDDiwQpgT2lR7DHQEFFs7UDEKWvkBu9HkNB9dHBMCokjWPgHS4ITnqEuxqfVRQIKz5aDF1YlioaDnDLkm7Su3UK3a4sBlgEiEA65HcfaJVC5UnV1QEQOVQR8WcDsYH8lLOb8jTFv76wgA4V8aowZVxOio231eRwPUpgRwwKmN1eYcwFWy2GaLTGZ7nCwBzSaz+MVcLJ85qgbC0VelbSFUunhLQAAYLDGBI2BPMOVSXLHi0kZyxi/l1XRCOooLlw4sDWcBugx2dXgPhPW3SIZmaLVR8L3DhWsAPN3l4RMfNuDi05vPNYAE1u84icsiRvmLgW3BAjnKFswvrgXTgtKdzFZLDXCGB6dtjHBVY//iGgYJarw+WA3MgC7y1JjbEOCGIAmUqz6d5Ps3zaZ5P83ya59M8n+b5NM+neT7N82meT/N8mufT/zyf7grysdn/qPv6SLZ0QwtyWR/u+wf3cN31+77pDu7xe3M3QZ/r5v6hdw+f2vrx7xc/dG1nHR5+t+1p9wIUFNZFAR4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2903",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "557",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527411",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.93896039",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjkELgkAQhf/LnJdldVZDO0UFQR0kgg7iQWnRhW0nbAtE/O8taRJdus2b7/Hey3vIKn3qbgpS2FOlMzJdTRYYZKStu0Oa9+PpDZIjYrIMRMSjREgY2DeTwSL8y+IY8YfNmSMrPtWrti073+8fG11elVMtpIILBgdla9dM4kiudNpPHuVZX2a0U7pu3FvEYcRga9Rz8iJyKWXAYE2GfK59GDMUL2PqHJ0PAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVVFrgzAQ/i95ziQ2iVb7NLbBYHso22APpQ+WhjbgzHBuUIr/fcHa1qjHxSKK+XL57rvLXbI6kuVGfxy+FUnJi9nod5PrLaFkaXRR/ZB0dTz92mm2sA+p6RW5CxlbNB/7knp9XnZfltnBrhUB5zyhIZOBTGREOQ9ELAXt4NEsShpciNDBmZg3uOSc+vCc7ZNYjvFLFkUOLufhFD2QXywub7+IngGPSEbDbeFe1sAsu15FGM/Gsn/FXZ4L3svCwL5VP+Q/yUd5MP6+HjAuCAd0gn6d7OPh3ihnEJazu7hKoCc8axnl8cSh9EA1jttD/H5+gV3EW24ijQ8MlQLeoZA9QO/lFSi0qYcXSuMDQ80AnWm4PUDv5RU6GfETdiqPHw71PtrL6P3Zz0MHt/f7o86+VKVKkrKAUfKqil21bwdvpsoqbYp2+Km3l6lnpXf7qh085eqva/hgcmMJi988r9f/57vcgpEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2894",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2903",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10399.60 /",
    "Friction Factor": "0.02244",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10195",
    Length: "25",
    Mark: "253",
    Material: "Copper",
    "Middle Elevation": "2903",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "264.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "40176.96154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "137",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2903",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2913",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527412",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.11421659",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xBSbVNSV1IFQRdFBBelixRDOxAzEqNQSu9uoNUbuPtfzDf1CFWLl+FhoIAjtViRHTpywKAidOEJRT3OMg5SnuYq3yQi43IlFUzsD13zRW+910Pkx2CH+m6C8VAILhicjOtCv5gzBR0wvjzbK95+1cFg10dIwjMhGeyteS/TdcKVkIpBSZbiWfeydmo+1tnfbA4BAAA=",
    Pbi3DGeometry:
      "gwgAAB+LCAAAAAAABACdVVtLwzAU/i95riXZkl62J1FB0Iehgg9jDx0LW6A2UqMwRv+7Ya1rU3t20lJ6yZeTL9+55HR9Iqutejt+SrIgT3qrXnWudiQgK60K80UW61P9aafp0l6kClrkhlG6PD/sTarN37LbssyOdi0POU9EwKgIo1mUBnMWptS+LR6n8RkXqYi6uIij2p7ypItDPBd7PkgfiYR1cMHYKDXQrphXfttiavoslCUDvrZwL2SAU9CubuTnIWezAZoWd2Pw375W3+JOpnAajL4nx/UKg0GRwK5u6FGaiWL6LrmJhUQCZwEIPGrtV/JoWqEAA7XtRzP12IN5wk7UNXasOCDYpzYAKeOsx7UfqOzQPuNHg1c11GegNubHM7lNgnqgPxSE+/HguF+jxPu5n32N2z/6vco+pJElWdCQBuRZFntzaAYv2mRG6aIZvqvdZepRqv3BNIOHXP50De90ri1h8Z3n1eYXIP4qRYMIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2884",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10399.60 /",
    "Friction Factor": "0.02244",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "459",
    Mark: "254",
    Material: "Copper",
    "Middle Elevation": "2425",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4773.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "40176.96154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "137",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2425",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2884",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527415",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.58105749",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjFELgjAUhf/LfR5j06VoT1FBUA8iQQ/iw6yLXlhb2ApE/O+tMujtnPN9nGqEoqHjcEPIYe8aKvHstW0NAoPCkfV3yKvxG4OiuEqzdCnFgidRksFU/7RV3+shuGHYkL6ixx5ywQWDA9rWd+8ipUoYlM5rT87O+ESXf7pDajv/6UJFDLYGn7Mex1zJKGOwdsaFd/swZqpfwOqZLsMAAAA=",
    Pbi3DGeometry:
      "uxwAAB+LCAAAAAAABADtV01r20AQ/S97Vs2u9kvrnEJbKLSH0BZ6CD44RCQC1SquWgjB/72Kveta431eKYeclpAQPY/fvPnYWc3tM7u5a74//arZkn3u7ppvXdvcs4LddM2m/82Wt8+Hf4eP+dXww3bFf+Sd4Pxq/2f4ZbtV+Nr1drt+Gr6rFkrYshBcL3Sly0LKhbJaFae4s+oF11y5U9xoI2M4tC+N2+PCiik8xlT6kh6l9Ngv0B/4z+wBD/IL9ST8ojwoKe0kPUS/dXbsV5R7XHPC4/Fgf9R/wDV3hJ/giAf5JTxQj6zGabgsB7pFYZVCXeQncpJ+CT8MC6UBtY8JOgOu48cilF0KN46rtGZKW6H2pzjSkyovxZM6aVzRdoA0c+WgsFB5g/2x3UhZ6ClF7ZDkSUzbydOKlB3lDeLx9KeGCT2NKNzUaaE4ChfJrzwsyoPbSkVnapjBlag87mms1S+4U16+E9HuoWHNTQPiR3qMk+M7k0sRqzq9S9Hdi3Hh8+Zekx94V8yNC5TR6bG50tWFEY/Mkci4OdACWWCrxUNKVZbOhfQ8GlUQVyQuBxYKuEX2qKFQwyYbnLw8BflK6FhR6NQPMgd8JDM19ektEfremDJa9AHXsfND/SL+5EsAfBclfqPpgdmExzAuH6Y5mR5aRZAeEFbyXe5MT/xEoywjObPDimcf0QNzVJTEVDtr/Tg7SE1e/vLyN+VCz8tfXv4mxJuXv7z85eUvL3+z4srLX17+8vKXl7+8/L3h8rcq2Idm/bPu6y1b8gUv2Jd689A/+oevXb/um27jH38098ePPtXNw2PvHz629d9Tw/dd2w2Emz9tu1v9A0C/4MG7HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2903",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "559",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527417",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.2465901",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjssKwjAQRf9l1jEkTezLlagg6KKI4KJ0UTG0gZiRGoVS+u9GWgvixt3cOZfLyTvIzvrY3hSksMOzztC0FVogkKG27g5p3g2nL3AWUhkmwWLGJeXJPIKefFMRx9EfVHAmfui0PNDio7BsmrL1Hv6x1uVVOdVAyigjsFe2cvUYDuhKp736EE/6MqGt0lXt3oEzGRDYGPUcu0LQSIYxgRUa9Lv2YUxfvAAqZ8G0FwEAAA==",
    Pbi3DGeometry:
      "MQkAAB+LCAAAAAAABACdVl1rwjAU/S95jiVp+pHWp7ENBtuDbIM9iA+KQQNdM7psINL/vqx2Om2vuS3FYjy5557cm5w435PZSr/uPhTJyaNZ6RdT6DWhZGZ0aT9JPt8fvjqYTd1Danr6ZcIZmzYv9yH14i/spqqWOxfLWRJESRbSCY+CUGYZFSKQIk7pOcKT8BdJk5D3I4NiGGvypJnM0Gytth62WDRAlEi0AHChgsUckAYL8JatBzmIljHABRcakV9Imfbn7yBHthMyhu2yoZg8MHLR0I40WHQX6TQUs9Dz5mAKAHN5yzlkNf5C92w1+LSNYcMjUD2hQ+Cf793OA3oJH9qhamEmPALvV9iaEDFj9qX/xHQtaIxqv6EiENA0wOsBETHCZuAssG0PV+y9hREI7CUYX/De3NeN3v3/uNPLd2VVRXIWMEqeVLmx23bwbOzSalO2wze9PkIPSm+2th3cF+r7/8RbUxhHWH4VRb34ASSCYgUxCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2986",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10288",
    Length: "25",
    Mark: "255",
    Material: "Copper",
    "Middle Elevation": "3002",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "17.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "99",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3002",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3018",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527418",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.42095312",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5CYVmtdiQqCLooILkoXLYb0QcyTGoVQencDrd7A3fyYmbKHosFLeGjI4UgNFmSDIQcMCkLnn5CX/QhjQIoFVyJN1jOZ8HmqYGD/Mavv/Kbr6hA/RGGH9V173UEuuGBw0s74diJn8rXHeHukV7z9rING08YVyTORSQZ7q99TVkm+EsuUwZYsxV73snaoPikiCGUTAQAA",
    Pbi3DGeometry:
      "LQkAAB+LCAAAAAAABAClVlFrgzAQ/i95TiVRo9U+jW0w2B7KNthD6YOloQ04M1w2KMX/vlBda6an14koiZ/33Xe53MXVkSw36vXwIUlKHvVGvehcbQklS60K80nS1bEeWpgt7EUqenkz44wtTg97k2r9a3ZTltnB2nIWeYGIQzrjoeeLgAaBF3Mh6AlgogbsgLtI6Pu1yTxJXAQkO5vwyO934zPmklmO4FploP/RKPHux3V1uaK56A//gnTWEowSFuAmhnsJi3vJ2oizMn0mdTRtxE0mimzUS0eYGyUGGFAMuf+TGBTZBGHdIN30g5LhUoLzgrPBVQwu+/D6g5WBZpvYTAbSiajNET+oDTWA4DYUrOwfJtc3OnjXotoZlgxXHHA7g7smlm1idx7QBp+bMIJlwyG4/ow7UpAmNWL/Pe5U9i6NLEnKPEbJkyx2Zt9MnrXJjNJFM31T2zP0INVub5rJfS6/2x/e6lxbwuIrz6v1DyfaqLUtCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "551",
    Mark: "256",
    Material: "Copper",
    "Middle Elevation": "2977",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "384.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "99",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2977",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2977",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527419",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.2778931",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjj0LwjAURf/Lm2PIl4nWSVQQdCgiOJQOFUMbiInUKJTS/26krYuC27vvXC4nayE9m2Nz05DAzp9N6m1TegcIUm9cuEOStf0ZC5RIzCVTiwkVmMq5gg79pBxPuRRflInZPzju5qPAsq6LJlrEx9oUVx10DQnBBMFeuzJUQzj4UAQTxft4MpcP2mpTVuEdKBEMwcbq59DlFCvFKIKVtz7uuoe1Xf4ClS8PkBUBAAA=",
    Pbi3DGeometry:
      "OQkAAB+LCAAAAAAABACdVl1rwjAU/S95jiVp0o/Vp7ENBtuDbIM9iA8Vgwa6ZnTZQKT/fd1aq425TSyiGE/PyT333ty4PKDFWr7tPwXK0JNay1dVyA3CaKFkqb9Qtjy0XxuYzJsXqvHplxklZP7/0bxRvTrSbqsq3zdcSuKAkYjjGeUBjW8SzGiQJCHFf0gYMTZA0pB3SJxGQ06aMDyuxngYApwo4fZ9YASObYqfkQhMtTSJQxcCq5k5SGMgoT3g77PfvxNjQcRiPsh0p3ZCTLUzTl+31o2N07qx7DOiBiIjscERmGpmDSyckX1MP8ciTAoAROAALgpnBAB3lIUCtZrLJXw8rkqZKzG2c+MQgykWl65zaysMeAghwKl16QUG4LZwzWFQzGd0e1BcDWuZ6SOIf/ubalMmje0ecKnBnOtuPDg2+C6EEZeazQ+MwEfaf9b43OA2P83/kHuZfwgtKpSRgGD0LMqt3nWLF6VzLVXZLd/lpocehdzudLd4KMTP+YN3qlCNYPldFPXqF/F+bgQ5CQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "193",
    Mark: "257",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "134.8",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "99",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527427",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.78078311",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNoHn3Flagg6KIUwUXpIuqlDcREahRK6b9bWrqbM5xhqgGKu7n2bwQFZ383JT6Cdo1FIFB448IHVDUscVJYlFCZcb7dMEl5LGCsV2/Xdbqf5Kk4GP3CgB2oiEYELuia0M7ABIHSBx2Md6AEZZLFOU9iEWd5mgtG4Gaei8uYTAic0DRtmDmSnMDR4m9dC5rKJCOw99ZPX+5r7Vj/AeykdxLSAAAA",
    Pbi3DGeometry:
      "nREAAB+LCAAAAAAABADtVl1rwjAU/S95riVNapvo09gGg+1BtsEexAfFooGuHa4biPjfV7Sd03iaNPo0iigmp7n35PZ+nPGGjGbqdf2RkAF5zGfqJU/VnHhklKus+CSD8Wb/t4TpsPyQrXfY6QWUDnc/5ZdsJ/Wxm9Vqui7PBjTyw0gyrxeEPhNSepz7gvdj7xjp8x3QD473OS13SiCWQp6coFQCpPISR8zaWoMfwKzBP0b2tuIwEraUWRAxgEBj7sz0W1buD29MsDpijB3bqhEmYrGnHAYnSCAYQCr/oTgFKmOCc3sC2A2mVkdTxtbGKBfNBHTS8J7m25wxBpE2sUEpACnj3DBnDX7PDrfUXwBOdGzNojjwRbEfzA1XtIbYp5pDsR1yHbYU66w504XsG5eZF26PGmIuaNwDIKLXEx4c2JrFsGkxuszcGsathti39TN1iBHYO1Cz0UwZJxS8pDnMODBtxq0xOW3if4l4aNGeLAhcVXC0FnwOo8NJiVxVb1xVVbjoDYepCo+4jBpTNDu10amNTm10auNfqY2JR+7U9D0pkhUZUJ965CnJFsWyWjznxbRQeVYt39T8F3pI1GJZVIv7NPn+++BtnualwewrTbeTH/ZoT3+dEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "565",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "34.2",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527428",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.1495274",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzc0KwjAQBOB32XMMSZP0J55EBUEPpQgeSg9RQxuIidQolNJ3NyoFbzvDN2w9Qnk2x+GuQcLen02lL0G51mpAUHrjwgNkPf7OSChJMSOCLxeU40QwmJrZrfpeDRHHYmPUTQfdgySYIDho14buE6hIGYLKBxWMdyAZppyKIkkFE3mRFYwiOJnrP95p03bhm7nIEWytfs1rhrOIEKy99fGZe1o7NW+fida30wAAAA==",
    Pbi3DGeometry:
      "iSAAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+fzin0BYK7SG0hR6CDw4RicC1iqsWQvB/r2yt0q6ktys51yUkRB7PzJs3T7M7dy/k9r769vyzJGvyqb6vvta76oEU5Lau9s0vsr576f5tzfS6/SHH4t8nV4zS6/Of9pccN73bzeGwfW59GdUrYa0prphccWd4IcTKSsGKwMIcVSeLcdaFFk6tnfaJWJQ4GzSTxUwAfTCjpJkNzUdb4iOYWhwN+6SxTVQK83jajNBD2obkcM14GOwEMbT0Pr1FUCVD0GOfUTTJXQDtLWmEdDrh88r02GcIbY7PMA8uNIL6gjxCm2naIuUYGWqAipRs3hALCg1rc8HbwbQKLar1TVguUQBkGdWPQ2ELJgAXIwfTwZohm6Nph7WUDJae3RPtxJahNhCZ6PO09peMDFR8hC9owcWDWrjrcbXMngzGdQxzq2znweV5ylOru0iC9tlVZ+HSJSZmJIsQ3uJM6GJ42C3tpQeBRQY26138qS2ZnXucwxtAj9hylmgkJCyi7xmvRJgeUhw5FDH5uJOQfdhiHAsevct7jzxmtH7YYax8FAtzD9uI5wHUV1pGY7Gi/BgxfrshLTj9DMjDFy/dL3jtbLPJ8JUw3B9ftDvYjEjdlbmz/f1Jd/RT7aMpbzCKzb1y4fMzAgCB5h5Zqx03mK7QBUPDdGKVQ2rw7RpDw9Fw2/AVCjKNhwzsJ54+oAEYV6z+tDhHeoaUQcjQ5ZI2wyyISqyyCDBUft7x846fd/z4VM87fkKbecfPO35AZt7xp670eccPEOcdP9HivOPnHT/v+HnHzzt+WH/e8aeBTZS/Kcj7avujbMoDWdMVLcjncv/YPPmHL3Wzbap67x+/Vw+vpo9l9fjU+IcPu/LP/198V+/qNuD+92533PwFxkk5i4kgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "566",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527430",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.16165114",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImiZt40pUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6sGCVt/NJU+BeVaqwFB6Y0LN5D1+IlRoURgRng6n9EUJ5zB1Py8Rd+rIcqxWBl10UH3IAkmCHbataF7AeWCIah8UMF4B5JinpGsECwRWZHmhRAIDub8L2+0abvw5pTnCNZWP75rRnEmaJwsvfXxzN2tnZonBeAF0NMAAAA=",
    Pbi3DGeometry:
      "dyAAAB+LCAAAAAAABADtV8tq20AU/ZdZK2ZmNC85q5AWCu0itIUughcOEYnAtYqrFkLwv1fRw6pmdGbG3mYICbGO7+vch+69fyV3D9X3l18lWZPP9UP1rd5VjyQjd3W1b36T9f1r/28L0+v2hxyz6ckVo/S6+9P+kuNmFLs5HLYvrSyjapWLQmVXTKx4oXmWs1VBtczeEC540SMynwOKcSACkZxK0SE5k3KOYAdO2qgxca5NyuJFlD5XFxSJ8MshBlsZKWMFlZHEnLQxVeg3RJu5hP18dHh8brhgXk2TV+NzxdSFNhwJo0w+ZzjsV4SMxw7iC/NyiRWbM2OUCkVzkjFCdEjBdahiLtEGqyzCTnxnTABjvQO5zGORc4oAUx0mNFweLuKhwI5nmg6CFb02abWnO7ZgUXm0hQc3NHPGFIqpKYzY6YkI1O24MKGutjDi4cCOh8tRJu8BNgJa9SJc8d4MFUOgsp0xHaIL1iGiEP4BCo1IKxTK5/5y3pdga0mG3ALGJ11twXfVLKx+ct7onv1gcJhrycCL08kkpguWuUcZsg8pxsUHyIdZ9FQEMh7KifMOviTzWAbm3pPhCDO2siD3eMLBrCxkONh2ng3YLSTYktBMuPUW+gVp8+zTsGHxDiqNXmYtV1wOtWH6OFVwaWZDlJT3EsPkb3XPa1ZT4980I1YGZ8sA7kpjN+toHEkgpzCJHt4BJTBw6BNQFMoS3mJdbvFswRnEE8RDPPYNRQOTi6oXEoYdDotEpxcbCffC0p0IzPjCT6f9mbrSab/U+um0T6d9Ou3TaZ9Oe/8in077dNpbFZFOey/36bRPp/3yypBO+6gspdP+nZ32m4x8qLY/y6Y8kDVd0Yx8KfdPzfPw4WvdbJuq3g8ff1SPJ+hTWT09N8OHj7vy7/9fvK13datw/2e3O27+AVTzhr93IAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "568",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527432",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.70062537",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEk3dTWehIVBD0UETyUHloMbSAmUqNQSv/dSGtBL9529g0zk3WQlurU3iQksLelSq1uK2uAQGqVcXdIsm44vSEUFBnGyxkXlC/CCHryBYMA8T9EzvAXTrEDzD/1q6YpWr/BPzaquEonG0gYZQQO0lSuHsXRusIpP3uQZ3WZ0E6qqnZvwZkICGy1fI5eRBqJeUxgbbX1ueahdZ+/AHjfLrkTAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABACVVl1rgzAU/S95TiUaP6J9GttgsD2UbbCH0gdLQxtwZjg3KMX/vszadTbe3gRRjCc59+Z+nLg8kMVave4/JCnIo16rF12pDaFkoVXdfpJieTi+GpjNzUU6ev4yCxmb9w9zk251WnbTNOXerE3igDMu6CyMg0jkOeU8EDzJ6AgI0+gXyNIonAQ8VjDW28hykTtSDV7ZVAnvv8epcLQN7Y+zJJx2CrSNhcoGjt6KZJoIDC1qOoo4nzRtASeqM+BPdZE+BxsgME6f5RTorQVcps9hf6NkOGwbJMIi6L4LNLR2SYG95E/lCgAhBMocnY2VrHPmwH70cxOkcQXAogTFBl/hX31oR1iq4u8uqo0oAEkBpPD4fG/pAC2A6uvrKnZ0ogAoEA7tjh22V9Xa/CvcqfJdtrIhBQsYJU+y3ra7YfCs27JVuh6Gb2rzBz1Itd21w+C+kt//J97qShvC+ququtUPddmqaN0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2986",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10288",
    Length: "25",
    Mark: "258",
    Material: "Copper",
    "Middle Elevation": "3002",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "17.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "127",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3002",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3018",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527433",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.5439082",
    Cost: "0",
    Pbi2DGeometry: "BwEAAB+LCAAAAAAABACtjksKwjAQhu8y6xgS22Ctq6KCoIsggovSRYshHYgZqVEopXc30OoJ3P0v5ptyAN3gpX8YyOFIDWpyvSUPDDShD0/Iy2GScaBSLtPNQqZ8qRIY2V+b6ossuq7uIzcGO6zvJpgOcsEFg5PxNrSzOVOoA8ZXJ3vF2686GLRtREieiUwy2DvznreJ5GuxUgy25Cje9S/nxuoDl6CoHAcBAAA=",
    Pbi3DGeometry:
      "xQgAAB+LCAAAAAAABAClVk1rwzAM/S8+u0HOR/PR09gGg+1QtsEOpYeUmtaQxSPzBqXkv89rsi4JUa0SQkLsF70nWZac1ZEtN+r18CFZxh71Rr3oQm0ZZ0utSvPJstWxebUwLOzFav4/MxMAi9PD3qxe/5ndVFV+sLZR6AkIfD4ToecnacqDwItFFPFfIJ4nDkDMfZpF6osGiAIaE+pUeJoOIBI05TPRQAGSOB11CVXGmPAgGl99AISIvK5EaeGlEI+tRwfoi49ZDKl6uaNIoEA3dxSXMKCfuzGDYQzdTFBiRolQwE01jI5WE6gExQKTcKaUuH7IBifRTCggxBu0SlCAREQAsA3pbjIXiSa0MXeJoO1tABCZKABS/0hLJ9FMODIQb9yn3iX+Sf0RK0tnp7i6tXRCsP8Edyp/l0ZWLAMPOHuS5c7s28GzNrlRumyHb2p7hh6k2u1NO7gv5Hf3w1tdaEtYfhVFvf4BI/bmocUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "551",
    Mark: "259",
    Material: "Copper",
    "Middle Elevation": "2977",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "384.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "127",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2977",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2977",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527434",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.54604533",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsELgjAYxf+X77zG5qZLO0UFQR0kgg7iQXHoYG1hKxDxf2+hdoig2/e+3+O9l/WQlurc3SQkcLClSq3uamsAQWqVcXdIsn48vSHkmCwDsVpQhkMWcRjQL8gxjWLxDWks2D84x+Zz/bpti85v8I+tKq7SyRYSggmCozS1ayZxsq5wys8e5UVVH7SXqm7cW1DCAwQ7LZ+Tl1EsREARbKy2Ptc8tB7yFzSZXjATAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACVVltrwjAU/i95jiW92LT1SaYw2B5kG+xBfKgYNNA1o8sGIv3vy7TtjPb0pIjSnMt3bvlOXZ/Iaivfjp+CZORJbeWrKuSOULJSstRfJFufLo9GzWbmQ2r6L5n4jM3OP+ZL6k3rNq+q/Gh8p5HnszCgEz/0pmEc0dD3eMJD2qdIYv8s53HSK4fsI1vK42AUTJsPS3hqOwTRcODbCF1ldkacB8ORYSCohtQgOqWKIiGhzUOc8vv24XIUKLKl7dhc8Rt5M7Urud2KnoRAhZ1RN7bbAjr7yxR6QkMlg0jOCqzb2CWGkCCaQP2+D+A+COQCAHQeQgHNnZcFkIsra5CSXO+DTe+eVoK8H0YCHUZsFuSyj9lqzrzB+QFQFljAgzCgvfuCB7JxfgNiZY1eaSAp3ffE+Nfjn4f5J7CQ+YfQoiIZ8xglz6Lc60NzeFE611KVzfFd7jrVo5D7g24Oy0L8XBs+qEIZwPK7KOrNL1LwmCG7CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "193",
    Mark: "260",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "134.8",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "127",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527441",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.30610841",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le72Gcx/quooKgroQCboQL1YNHawtbAUi/veG4t15Ds/h1COUd3Md3hoknP3dVPoRlGutBgSlNy58QNbjEqPCGaZE5NsNYTjlFKZm1XZ9r4boxuJg1EsH3YNMcILgol0buhkIRVD5oILxDiTFhBFepIJTnhdZQQmCm3kuLiFMIDhp03Zh5oSlCI5W/9Y1xRkTOYK9tz5+ua+1U/MH6urecdEAAAA=",
    Pbi3DGeometry:
      "9RAAAB+LCAAAAAAABADtVstKw0AU/ZdZp2EeeUzalagg6KKo4KJ00dLQDsREahRK6b8b26SaTI4zKVm4CKGhMydzX3MfZ7Yn06V63r3FZEzus6V6yhK1Ig6ZZirN38l4tj/9LWA6KR5ycH52RozSyfFV/MhhXh272m4Xu+Ks77mCCumMmOdyGUWOEK4UfujUAF8c931W2xa02Cj2w0hG9e8pjdqBUkMYcEtRWEe7TVg1BE6CQi+QdrZyFvB2AEm61CbNuVLz+YJYUEWJ85qgCuAylCdbPVYHmOTtQKnak6xVkhTCVjdUAY2qAhiFlpK+I/OXbs1a5J7RC10SAuwDAq4b2QrTwJgf8FI7O6dFHOYyFGXOfugf1AGtgrXaBKxTqnMpndMZ9Qnb/NAbi20nMloEe10TMJYqrG0EaOUCWz8UZR4W1nPHaBUekk3AujnrRQYB1BFAA2nKMc0X5JsxsDAa9kPSlILmgF8+6q0bjll3f+SgIxvr3PwvIA39cYP+KEB3btB5GKID3UeFIYADMxiYwcAMBmbwr5nB3CE3avEa5/GWjKlLHfIQp+t8Uy4es3yRqywtly9qdYbuYrXe5OXiNok/f394nSVZITD9SJLD/AuPonL29RAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "574",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "34.2",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527442",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.26394003",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNzcsKwjAQBdB/mXUMTZP05UpUEHRRiuCidBF1aAMxkRqFUvrvRqXgbu5w7kw9QnnWx+GOUMDenXWFF69saxAIlE5b/4CiHn9jIFJQJpYLJmgsOUzNjFZ9r4Ygw2Kj1Q099lBENCJwQNv67hOYTDiBynnltbNQ8HCKyTxOJJdZnuacETjp6z/eoW47/81CZgS2Bl9zm9M0IAJrZ1x4Zp/GTM0bEbAR8NAAAAA=",
    Pbi3DGeometry:
      "Sx8AAB+LCAAAAAAABADtV11r2zAU/S96doM+LSl9GttgsD2UbbCHkoeUmtbgxSPzBqXkv0+O5S5yciS7e5wICbGu7te5x7q6t8/k5q7++vSjImvysb2rv7RNfU8KctPWu+4nWd8+D3+dmF67DzkUf1euGKXXxx/3JYfNqPZmv98+OV0lV5wLUVwx98dqXgixMlKw4lTALFW9QFtjAwGnxlzUwAIljuslk8Us36MlraSeGZQ3NV9DMLXQFNRIRnWeIPLhodKilFFEqFUmtNQHFwhGDS9w2Aexnu2fGtJaBSG90gEzksf2v6B6tn8SUHL/xD7MDAW60D6n/CJAMAFnoAyLTEWUFf9gCdEI8m4u6ZliPBQopxkVLKwzwhUljQkDPUDAYQ6G6ZA0Rk8AnLygmPZJU8mT97x6UDDhAeINXE9RfO4ZAHKOoITeOpgzogf366yHsxdoOzCZ0yFazuXxkO4N9OulGl2rQcCljZ980AXT1gusDjSoDgtUep6BmLBrNSr4HiuZmdd7UbMeQzWcxUuHYII8nsP80DfEFdAMwR2pHOAA8gwtoXa5tNJwf7LQk4JCB8AQBhsy4HIVYDWThDlLAXqGsSIfCA3sOx1t+GalC4Qug4KW8hQnwYxvQnToTlrEr65M8PGmUw6I0/JoyiU5AMi1YvPuRqgDRpyDcBnzzgVVNvCBNGBUEENIZogITBymgUxhDXDhQdDCmzaqHjwjIOIgIpxzkoJTziKQUKhQYWlFkQeIHiYTcoGyzkN0HqLzEJ2H6DxEB4DnIToP0XmIzkN0HqLzEJ2H6NMOmIfoPETHOPu/DdGbgryrt9+rrtqTNV3Rgnyqdg/do3/43Hbbrm53/vFbff8i+lDVD4+df3jfVL9PN75tm9YZ3P1qmsPmD552/o9LHwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "575",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527444",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.19935429",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomldbV6KCoItSBBeli6ihDcREahRK6b8bX+BuznCGqUcoj2Y/XDUUsPVHU+lTUK61GhCU3rhwg6IePzEqnGHC5jPCcMopTM1PWvS9GqIZi5VRFx10D0WCEwQ77drQvYBwQRFUPqhgvIOCYC4TmQuaCpmzLBcCwcGc/+WNNm0X3sx4hmBt9eO7pgRLQeJk6a2PZ+5u7dQ8AYvZwpfQAAAA",
    Pbi3DGeometry:
      "vx4AAB+LCAAAAAAABADtV8Fu2zAM/Red3UCUJVlKT8VaYMB2KLYBOxQ5pKjRGsjiIfMGFEX+fW5kJ7HsJzk9C0WbhqIeyUdKIh/e2P1j9eP1d8mW7Ev9WH2vN9UTy9h9XW2bP2z58Ob+bZf5dfvD9tlJckWcXx/+tL9sv+q33ex269d2r5ILMlJkVyQXwhYiy2lheaGydoEX7edhQeUDuVVmegNaIHkQ56TUQAwtH4G4MXNcOiHN3CC4uAwIbYh75HOBLHQkkeVqFhdHINK2eF8ozEDfE/d+9mIjJAVgem96oSb9EfSRvtEmH/AZ9Se6A9pADCFnP2BhyJIxWgdj6PWNlAexFUW4Ji4Fmq6hOP7ccj/JiZzlXOXzFmYnGpEa4S6a/dECDtqL4XTIJVkHpYaHbXTvoIrBUNHbFpmYeZFESgaIvSTE4xqdnSh3I6joAorYi4GbXj93cupiI3JiLRw+l11wwgGJwtJhQVoZuvUAPje6GAbAxZmbQrjqao2osDuTVnsUq12JyvPT4T+x+K3ufRSFoukHbZQvxA6qXIgEbSNCYXEBphF1iGlkN5gB/228ML1IfTK9uLWKoHswMYLhrQSZH+UweohwnzmqE5QWYCJ6ksaNJkICHev02YO9ns3lJEn0ruiyb1xkOtyV5h3Zmgun7y4yLWhYigU3gc5nxuvtGZ72k6zwbmje2QX6oMeEvAGaAQsAHfkCUCIpgc2izyW6HWCuwD2AOMYNFUoWEKPaRAQBPyPqM3MIwKMFPh6vUHphuGn8TePvzCc+jb9p/I08oGn8DVVMGn/T+JvG3zT+YvU0/qbxN42/kzSn8TfYUKXxN5TeiXBXGbut1r/KptyxJV/wjH0tt8/NS/flW92sm6redl9/Vk/Hpc9l9fzSdF/uNuW/c8VP9aZuAbd/N5v96j8KOaiUvx4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "577",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527446",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.14467791",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkp6ZaT6KCoIcigofSQ8XQBmJWahRK6bsbaS3ixdvOfsPMZC2kZ3NsbhoS2OHZpGibEh0QSNE4f4cka/szGBQVTMWLCY8on09j6Mg340KJv0xyJn/YmNmz/FO9rOuiCf3hsTbFVXtdQ8IoI7DXrvTVIA7oC2/C5F6ezGVEW23Kyr8FZ5EgsLH6OXilpHGkZgRWaDHkuoe1Xf4C0VPIDQ8BAAA=",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVd9LwzAQ/l/ynJWkXX/uSVQQ9GGo4MPYQ8fCFqiN1CiM0f/d2FXXtbldQmlpvly++3K5u6yOZLmRr4cPQQryqDbyRVVySyhZKlnrT1KsjqdfM80W5iEtPSMzztii+5iXtOu/ZTdNUx7M2iQIWZLSGZ8HYZbnNIqCLIpTOsR5Ev7iaRJyG+5sz1jHn+ZZ7sTT65nwxFEHz5PMyS2wrYjF3CoHcouEZ4KfZGaxlQUKJuKVh8bM4nWC9zxn3Jfn8rBwfgi/OKyJHEjmGB8dFr6tYfDxzUIsSNBc1WPBnKQOVCm+PG64PWr2RMZskbR0PCeo1Hz0QRxuOJR5UPtA7X1zDMv4caPw1Ym1OQQHChxo0qi1ZzuA2KEm6qcRue8QHKp6vIqR+/FayzX3+p0s34UWDSlYwCh5EvVO7/vBs9Kllqruh29y+z/1IORur/vBfSW+h4a3qlKGsP6qqnb9A8EsO7eJCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2986",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10288",
    Length: "25",
    Mark: "261",
    Material: "Copper",
    "Middle Elevation": "3002",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "17.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "129",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3002",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3018",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527447",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.34121827",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACtjksKwjAQhu8y6xiSPrStK1FB0EURwUXposXQDsSMxCiE0rsbaPUE7v4X8001QNnixT8UFHCkFkvSviMDDEpC455QVMMkw2DJRRLl64VMeJTGMLJ/V/UXu7G28YEdgh02d+WUhUJwweCkTOf62ZzJNQ7Du5O94u1XHRR2fWBInolMMthr9Z63seS5WKUMtqQp3DUvrcf6A3HjdIsLAQAA",
    Pbi3DGeometry:
      "hwgAAB+LCAAAAAAABACdVVFrwyAQ/i8+W9GkJjV9KttgsD2UbbCH0oeUSitkcWRuUEr++6RJ1yTzqg0hIX6e332ed+fqiJYb9Xb4lChDT3qjXnWhtgijpVal+ULZ6tj82mk6tw+q8QWZMErnp499Ub0+L1tUVX6waxNCacLwhE1JNBMCxzFJGefY4qlIr+MsiULsBW9gHoewQGqmkTjhMeXM65UTIehslNtAHOI5y4woFSHbcvKEymdE0NQRhQved+uwH/B0z8rPDuH9s/Kr6QfZo3IYnP9um9j7N+t0C9N7aQa7Csl7iN1v72b3nN+AAwoYlMRhPOOLBNJza3GG8YxLBLg2g1g84gFzOCmhvuLEQ2n8OFThUJcO4xl/C0B6vHfYVf7xHdBdh56OcFv/6Ci3t/q9yj+kkRXKKKEYPctyZ/bt4EWb3ChdtsN3tf2bepRqtzft4KGQP13DO11oS1h+F0W9/gUAPPCIhwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "551",
    Mark: "262",
    Material: "Copper",
    "Middle Elevation": "2977",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "384.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "129",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2977",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2977",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527448",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.95311717",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk/UltPYkKgh6KCB5KDy0N7UJMpEahlL67kbaCIHjb2W+YmayHtMRzd5OQwMGUmBrV1UYDgdSgtndIsn48nSGk8TIUqwX3aeiLAAbygwWUizj6YoJyxrw/bM7M5+p12xad63ePLRZXaWULCaOMwFHq2jaTOBlbWHSTR3nB6oP2EuvGvgVngUdgp+Rz8vqcRpHHCWyMMi5XP5Qa8hezrPnqDwEAAA==",
    Pbi3DGeometry:
      "gwgAAB+LCAAAAAAABACVVV1rgzAU/S95TiXxK7V9KttgsD2UbbCH0gdLpQ04M5wblOJ/X6jaJtprrkilOV7PPTm597o5k/VOfpy+M7IgL2on31Uu94SStZJF9UMWm3PzVz9mS32Rmt6QGWdsebnpH6m33WurskxP+t3YYyzmdMYDLwrikAbcE3MR0Dv4XK81HPqJDYvYH8NFIjA0QvicRl6SsLkd7od8RA0k/i49rKYPdzRYvKVJIpR2SCRkZSe+wUOPxzq9Ed/wG7jpzQ220xq45c2ABpvVrhub5nqwBtya089qW+xU04m/WO9mt84bb80kD5xVDJwUUNyAkz3yEYeBpNCeoKocpYHCJ46PoRpkwzr2hCwDs42HPgLdPUYCRWMnx2hV48cVsjmg1sN1BzRsIR73cHbFQ3qwXzTXvrATzu76ns8TpgFuetj69Rf9UaZfWZWVZME8RslrVhyqY7t4U1VaSVW0y0+5vz56zuThWLWLpzz7MwMfVK40YfGb5/X2H7jaLdqDCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "193",
    Mark: "263",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "134.8",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "129",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527455",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.68830041",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le72Gcx86u4oKgroQCboQL1YNHawtbAUi/veG4t15Ds/h1COUd3Md3hoKOPu7qfQjKNdaDQhKb1z4QFGPS4yKwCmR2XZDGE45halZrV3fqyGqsTgY9dJB91AkOEFw0a4N3QyEIqh8UMF4BwXFhBEuU8Epz2UmKUFwM8/FJYQJBCdt2i7MnLAUwdHq37qmOGMiR7D31scv97V2av5xGHQh0AAAAA==",
    Pbi3DGeometry:
      "TRAAAB+LCAAAAAAABADtV11rwjAU/S95riUftU31aWyDwfYg22AP4oNi0UDXDtcNRPzvC9puGntMIrKnIoo5bc89ubn3Hh1vyGimXtcfGRmQx3KmXspczUlARqUqqk8yGG/2X/VlOtQvsg3+kB6jdLj70G+ynTSP3axW07V+Ng45jZOgx6KQyzQNhAil6CfBId4XO7jPDlFB9VrDSSrTo7spTVvxmj2JuRMP5G9VA6MifM+SRLF0EclZzFtxQHOZGnNPddDmPFjaZIbzQ5YG5zKRe5ERO8KZ5K14HTWSrI1GCuEWFtEjOU3O0sSJhgp5LqwpE+zKpv6EBuCuWWg/WiASnbitEtAJeu7JTDEqV8RjLW+0LcSP9KAuNHDX0vFslKZiQfM7VsLJrHAbLTYtaHAZuK0JUc8C3OwGNLwRj3XYO5qGTQ+0NgN3HbEnHYRw0OftQ8EgsbgD2JItlSgFrtZmKTRbhi81ZscRYg17JSP3+qnkOb69/f1KPn4lv/b1cU8PA7f7jvrzOetcvHPxzsU7F/9XF9f/ze/U9D2rshUZ0JAG5CkrFtWyXjyX1bRSZVEv39T899JDphbLql7c59n34Y23ZV5qwuIrz7eTH6Pp20ZNEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "583",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "34.2",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527456",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.52276253",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNzVELwiAUBeD/cp9N5tRt2lNUENTDGEEPYw9WsgmmsSwYY/89Kwa93XP4DrceoTyb43DXIGHvz6bSl6BcazUgKL1x4QGyHn9nJBlOWCqWC8JwyilMzaxWfa+GSGOxMeqmg+5BJjhBcNCuDd0nEJ5RBJUPKhjvQFJMGOEizTjlhcgFJQhO5vqPd9q0XfhmxgsEW6tf85riPCIEa299fOae1k7NGyzPgcjRAAAA",
    Pbi3DGeometry:
      "PR4AAB+LCAAAAAAABADtV11r2zAU/S96do1kfadPZRsMtoeyDfZQ8pBS0xqyeGTeoJT899mx3FqJjuT0WYSG+ub66Nxzjy3duxdye9/8eP5dkxX50t4339tt80AKcts2u+4PWd29jP/2P9Pr/kMOxVvkilF6ffzq/8hhPd12s99vnvt7VckqVRVXTJSV1VXBeWkEZ8UsziyVQ1xbY+fxihoTyodxyY9hxUSxYNkJRkuhF9FxOEvzOZMX4aD8FJ+zugC+k0dzJaAMsrTWaB9moDWPT/lDXJVUVNaneZp/gmOo8Oi8B76PG82i+a9qnubP6SzJn+OjsiI8L8Lv20LluTyYPmNM+s2lPOKFd8MA6yCnLXN4Xyrz47K/LxK/sLdAS1AsdAhCRxoj9kYo3yFGa/ggRhyewkm9Ts+6heJ+04FFQDhl46VPebhWrA14qlCtwArchdkg4RDX9mjYivMxvRLHNy81aggrM60qx3glbOydBuGpcXGr5/mM+h1Ro6FCbCKryindbZOCmSW7J9hsJ46mYrFGBaXBZl1gbm9ZpCTyU1DhiGag4cFlEQzY8y7rK85OtdXvHwIPo0B9UbuB7qh9KXeckkfLIpoAH4gAl03S9B6dZEfAuY1TJebWFtptI3TcXjSPHS8pl9PBRI0SU8WO3rPuFaclW3KQAdsXXjfMkzK3LqfSei+/UD7mg2SDjgUyoHIR/SBOJB+dTYJy4mNwsFv44UciIzaw2pTZTrwJxAEsUfolLQToWDJoHAAPas3Ta55eEzt5nl7z9Pq2UebpNU+veXpNH13y9Jqn1zy9xmjm6TVPr3l6XVJtnl5Dta4L8rHZ/Kq7ek9WtKQF+VrvHrsnd/Gt7TZd0+7c5c/m4fWnz3Xz+NS5i0/b+t888UO7bXvA3d/t9rD+DwqqBNg9HgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "584",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527458",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.17524327",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomkcfrkQFQRelCC5KF1UvbSAmUqNQSv/d+AJ3c4YzTDVCcdT74YqQw9YddYkn39jWIBAonLb+Bnk1fmJQFI1EnM1nTNBYcpjqn7Xo+2YIaihWurmgxx7yiEYEdmhb372AScUJlM43XjsLOaMyiZJM8VglmUgzpQgc9Plf3qBuO/9mIVMCa4OP75ozmigWJktnXDizd2Om+gm2plKv0QAAAA==",
    Pbi3DGeometry:
      "/x0AAB+LCAAAAAAABADtV02L2zAQ/S8+e4Mk6zN7Km2h0B6WttDDkkOWNbsGNy6pW1iW/Pc6VpyVHT1JufQkQkL8MnmaeTOSZu5fi7uH5vvLr7pYF5+7h+Zb1zaPRVncdc2u/12s71/t1+Fncju8ikP5htxQQm7Hj+FdHDbT397t99uX4b9yRbSi5Q3lK2YUKyu6MkSJUqyMJtzionJho5XX3IsP9JyZEa+oEC6Olj3zEK1j7rg0SeaUiHQWYJ7gy0ICwH6WhhoiohI4PFQadcSVdq3n6OTihGrGKeBwPZlQSeWV3B5rLXXlqhjzJWiP+YEuQIGr2ZfaaC1lwPs3e835iBumQlVwLY+3ahL4U2rbhSm1y1aiSsETkwvljMkWS/oSh+G6/rt7mVNjeYQOnUPeMgnwxI5RQJ90VqRUCcJd+RPCWu6WmGxLnhgO43X9P6472VcWpjYsWllzJpmlJ9yGNag+4srQEeeGBw42D/kRNmLuO2Gui4zZihqWEEFfLtd0WYy0Zcln22F2bQau38lHpgT1XlXLPAFhQLnC6kbLAiVRNXkUhoohfcGaYdlnN961SQ3Y+9Ia6JKi9HOaiLzoDEKyL7MX2zWwVVyuCzLio0/YOBetIuBBLSfYaqhtM5JdqnO8ScjJnmkblQx1lsPxamMizFqP55Wc17tSRMPuLH4lL25wn3/EiMUBTIjG1v42ESmFhPXHDoL0++GliKQAdXwL/eAZAJKDtjpUFrnjd96fNX8NImmRizHzpLwh8kgtX0xDfnYYaR5P83iax9M8nubxdNa/5/E0j6d5PM3jaR5P83iax9M8nubx9L+Pp5uy+NBsf9Z9vS/WZEXK4ku9e+qfTw9fu37bN93u9PijeTz/9Klunp7708PHtv7rGr7v2m4g3P1p28PmH2D1EgL/HQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "586",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527460",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.32987145",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lz7Gk3WhjPYkKgh6KCB5KDy2GdiEmUqNQSv/dSKsXBW87+4aZyTpISzq2VwUJ7GxJqdVtZQ0wSC0Zd4Mk64bTGyYhBjHOo4UIECVCz34yEcr4i8kpyj9syMzf1cumKVrf7x9rKi7KqQYSHnAGe2UqV4/iYF3hyE8e5InOH7RVVNXuJUIuIgYbrR6jF/1aMZMMVlZbn2vuWvf5E4S34K0PAQAA",
    Pbi3DGeometry:
      "mQgAAB+LCAAAAAAABACVVd9rgzAQ/l/ynIouUaN9GttgsD2UbbCH0gdLQxtwZrhsUIr/+1z9ueglEVG8z8vd5+Xuy/aCNnvxdv7kKEVPci9eZS4OCKONFIX6Qun20rzWn/11faEKD8gq8P319VHfqNp1y27LMjvXa1cB8RghBFOPEEYw+TPDGM/gcXQTXPE4TOI5HPRPonCM04gtiTPwoSwa+ycsWcKzj6PxYaE5LRgGoB9TSh1o2uOY89KAxXNls+HWOG15erzbLsf4A95sV49rdZjwAXn+59Ntl0Z/cG/KP0kL/i4Uxw23l9mNj+4/aR8QN/N0b2egzPPDYt4UW8/aklpaASADDDTUaDa903Vn2siQHpkbH8o75ek2QPrAQXwgQYI6eam+TwQD1H2zwEB5nYXKImwQH+h8ghTD+VwEFcA86ZBiQHnHPOtz/l5kH1zxEqW+52P0zIujOrXGi1SZErJozXdx6D89cnE8qdZ4yPnP2PFO5rIOWHznebX7BWh6KR6ZCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2986",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10288",
    Length: "25",
    Mark: "264",
    Material: "Copper",
    "Middle Elevation": "3002",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "17.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "131",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3002",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3018",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527461",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.46970298",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACtjksKwjAQhu8y6xgSa+3Dlagg6KKI4KJ00dLQDsSMxCiE0rsbaPUE7v4X8005QNHg1T8U5HCiBgvSviMDDApC456Ql8Mkw2AhI55k63iz4rFYwsj+XVVf7Nba2gd2CPZY35VTFnLBBYOzMp3rZ3MhVzsM7072hu2vOirs+sCQPBWpZHDQ6j1vI8kzkcQMdqQp3DUvrcfqA9jApXMLAQAA",
    Pbi3DGeometry:
      "cQgAAB+LCAAAAAAABACtld9LwzAQx/+XPGcltUl/7UlUEPRhqODD2EPHwhaojdQojNH/3bhWzZpcGn9QWppvL59c7nLX5QEt1uJh/8xRiW7kWtzLWmwQRgspGvWCyuWhf9WfyVxfqMPfyiwmZH586Bt1q89p521b7fXcWZxEGaUU04iRM5zoUcwYPspFyrRM2anKiuxDTdnIGoD05izJCxecMRr/RB874140T5LEtWhO8xQ2t7YEYQBfAM8hupsCrmmGPY4KklkUUzXiYhv3Lpq6maQAjJc+dgVY8yQspm7kyDa3XYS25HQGokzQ3RQ7FwElAEU9xB7AA9mAKP6A2YUXwvmvgodSEl6Ufk6IDpw/b+vwUv7QmLy1APUrWw/AhBxvX32725iP8esWCfgB/ZcgfZoSok93yJAmHmDe6/r/fSmqJ654i0oSEYxuebNVu2FwJ1WlhGyG4aPYfH265mK7U8PgquZvpuGFrKUGNq913a3eAa/oIctxCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "551",
    Mark: "265",
    Material: "Copper",
    "Middle Elevation": "2977",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "384.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "131",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2977",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2977",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527462",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.73618049",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkbUpoPYkKgh6KCB5KDxVDuxCzUqNQSv/dSKsgHrzt7BtmpughP+GhuxrIYEsnzMl2NTlgkBM6f4Os6MczGGYy5kKn6VzxJEkVDOybaRlHf5hSSv+wKXNk5bt60bZVF/rDY4XVxXjTQia4YLAzrvbNJPbkK49h8iiPeP6gjcG68S8hhYoYrK15TN5Ycq0jyWBJlkKuu1s7lE864NdJDwEAAA==",
    Pbi3DGeometry:
      "YwgAAB+LCAAAAAAABACdVV1LwzAU/S957kqSfqTtnkQFQR+GCj6MPWwsbIHaSI3CGP3vZrOdM/Qmd6O0NLen556b3JzM92S2Uq+7D0kq8qhX6kXXak0iMtOqMZ+kmu9/X+1nOrUX6aK/yIRROj0+7E26xfDbTdsud/bfCUtiKsoySuMsKcooYXGRs+g8TPkhKgT/H+7RohAJKp6l7MjO01EeN6tXTCFyjtCY5hkfIUmzMSED2BUOxQEpQE5oFv0kp5yCJXxscoe4w+7ABy2BsLtCVyZ1SvInhSp11shBAyRuQeNKwJTQpAMFASsamMVAnwfQEDkyKVAR0IwBLQAJDu1XAm3cq9YZ1yyAKaDaEOUrfrBfBdaaUJvnwr4HLMvd9gGbhKw5BA9owR5COJ9E2y10lmEdFHkmHvD2xL5Ty3dpZEsqGtOIPMlmY7b94FmbpVG66Ydvan369CDVZmv6wX0tv8+Bt7rWlrD5qutu8QODclGdYwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "193",
    Mark: "266",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "134.8",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "131",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527469",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.16481024",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jssKwjAQRf9l1jHk1fThSlQQdFGK4KJ0ETW0gZhIjUIp/XdDq7s5w5l7px6hvJrz8NRQwNFfTaVvQbnWakBQeuPCC4p6XMaorCjHaS6TtcCcJQym5q9t+l4N0Y2LnVEPHXQPBcEEwUm7NnQzUI6g8kEF4x0UFCcpiWmcyTQXWS4lgou5Ly6lIuJBm7YLMxPBEOyt/vyuefxEyAzB1lsfu9zb2qn5Aoa71YvRAAAA",
    Pbi3DGeometry:
      "dxAAAB+LCAAAAAAABADtV9FqwjAU/Zc819KatEn1aWyDwfYg22AP4oNi0UDXDNcNRPz3Re3a6nJqgsJeiijm9Pbcm9ubc3S8IaOZfF1/pGRAHtVMvqhMzolHRkrmxScZjDeHr/pyMNQvsvVqpBcGwXD/od9kO/m97Wa1mq71vb2Q+oJS6jGfUkE9ultG3NvhPImjJh6Fe1gwETdgnojkEM4YM+En9Dzut/NAfnM5KC3Ej2k4i0VrmTxKuBEHPBfWU23rOG31UASL9ng/6p90OaRNPGYlTxxyI16mLXHd9NDEo7vSnhfxw3qO83KW8PY6GacWeas64b7s6q95AO7aB/R4QZnosUMc8ThuC7YZTS3kAfGofnhaQD3oNCLcbnxcj0s9tkgF7MahjndVGVAPFFukbpDHfHwhjmQJiTzkQfGuJoJk0ux1ELeT21oeAA7PKfDYMzR/wlH1Vt1EXTg7hZbTdrbLrl7tqiYw75W83fEXlKuYO3v+lbz9ah7u6u2upobiXcXfrm+dt3fe3nl75+3/5u36X/ydnL6nRboig8APPPKU5otiWS6eVTEtpMrL5ZucV5ceUrlYFuXiPku/m4G3KlOaMP/Ksu3kBwVw5e93EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "592",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "34.2",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527470",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.91002184",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNzskKwjAQBuB3mXMMadOkiydRQdBDKYKH0kPUoQ3ERGoUSum7GzfwNv/wzVKPUB71frgiFLB1R13hySvbGgQCpdPW36Cox08ZyCziNM2lmCdUsBim5qcWfa+GQENjpdUFPfZQMMoI7NC2vnuFSEhOoHJeee0sFBEVKQvbeCzTPMlyKQkc9Pkfb1C3nX/nRGQE1gYf32kePgmIwNIZF47ZuzFT8wTbFlKa0QAAAA==",
    Pbi3DGeometry:
      "Jx4AAB+LCAAAAAAABADtV01r20AQ/S97Vsyu9kvrnEJaKLSH0BZ6CD44RCQC1SquWgjB/73Kau3a3n0jmVyXkBCNx2/fvJkdzdy/sruH5vvLr5ot2efuofnWtc0jK9hd12z632x5/zr+O3zMr4cftiv+W64E59f+z/DLdqv912622/XL8N0rIReV4rZQCyUqW8i3RymKN7uV6shsXeVGsy5l0h3ZndHHdiNUQR57imO1shSdM5hJd+0uQQHu87gcQoIcT6Wx0ihSgoCjlSm9XWh97B/bPU3NT60QZWSjjdLvQN9z19adnuqVBFxmekNsFFE6/ouw9zmSTs9ifvAfzvY55ZKusAtxUM1M4c+s7GB2fGSjbTltnptUJOWUZCDd0A5CPScfLrHh46mVtXT/QQUCYGZ1zwh9douYKA9oP9eejCq6JLRkEciEHQUbkVelZyPkSN66IKaxvmOVwvh+yysT/CufcWsqby/Vifhxn0D4SpYeX4lkp5Rq5G/2FYX4oHNDvC74D4KQr0z4ih15HuylILOF1AEVi1DSZyIp0/WEBEaCwYSDU2nh41fdpYlF/iixKIE0foxDqgx6ERA/ziB5edCYGNcHulMAnr47iZoHOOjuACnxzOZcQp1KSz9qiCCmlVNzpS9w7soxKhNgxBDeYNdazZpk6Ndy/BIHJJXz16E8PxX6AzZodMcap1WA0UI+aRwyKen5Lx4HQE9AqUJ3H4ucJoOowxQmyxIog0mS/rMzCPHp+k5tSKBCULh5Zc0ra15Z88qaV1ai/+SVNa+seWXNK2teWVNjYl5ZwUSYV9a8slJk8spKVsh5uKuCfWjWP+u+3rIlX/CCfak3T/1zePja9eu+6Tbh8UfzePjoU908Pffh4WNb/z12vO3abgDc/Gnb3eof65BphCceAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "593",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527472",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.03712794",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjT0LwjAYhP/LO8eQNE3S1klUEHQoRXAoHaKGNhATqVEopf/d+AVud8dzd/UI5dHsh6uGArb+aCp9Csq1VgOC0hsXblDU40dGZEYZlrng8xRzksDU/KhF36shojFYGXXRQfdQEEwQ7LRrQ/cylAuGoPJBBeMdFBRzSeIaS4TM0ywXAsHBnP/hjTZtF94+5RmCtdWPb5tRLAWNlaW3Pp65u7VT8wQNOrDs0QAAAA==",
    Pbi3DGeometry:
      "7R0AAB+LCAAAAAAABADtV02L2zAQ/S86e4NkfWdPpV0otIelLfSw5JBlza4hjZfULSxL/nsdW25sS092chYhIR6Pn968GXk0D+/k/rH88fZakDX5Uj2W36td+UQycl+V+/o3WT+8d3+b2/S2+ZBjdrbcMEpv25/mS46b/rEPh8P2rXn2hvGVEVRnYiWkthlnK0u1zE52bZVs7FIJObI7fylUvswu7clMg97+qjLnIRTExvkvZu/sgtuLcHz/uDooLt/ORUAdqALj+QBFm6G1955YHUOTC7YAoyOiFVPXQ/feRhk+WtKJiKgs9Yf44ZCQABeiO2mMUSpOPteDgjc21/ECuBAmVi/Lqw7uAmGH0nDJ4/brEutJCWKdKQ/PDlUA7I0UwwJR0izZfX6BIJz4O8vHR/ZwzoFoUS1BEcOa9/YOCnUGx7OjUAF7rVslpYNhzm6oauE5a81UdFGZPFctulWtXVgRe5sB8N5bNiG36HlnVmJAUVsmY1TCS5pTKZ7D5D3vWKv0GyszasDvrCHIEVQFlSnCQevO6Ii6xVTfsGJA3pk1w31r2uQuyyjwBilFyQOVG0aBYc5sx6nkKHWoNBB7uC7apwgfqIBEQzDhfRPNiNclnDZCGD0pa9b2SiG6btMXDWihhvIOvnnTte7jXqZtd0TRdJSp6dEFdSzUtwFHBy5sJwHtF427j7lAvYC88fgncYaJIIw4be8QEj+0gKOun6HwfofaIjaAPFAAFCNSBr3Bgt4XZi4e/1QuWC6ACwo0TaXXnN/TVJqm0jSVpqk0hpOm0jSVpqk0TaVpKk1TaZpK01QaIp+m0mmgm4x8Kre/iro4kDVd0Yx8LfbP9Yu7+FbV27qs9u7yZ/n0/9bnonx+qd3F3a74O3T8WO2qBnD/Z7c7bv4BetPEVe0dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "595",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527474",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.80875929",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAUhP/LO6/L6uKadooKgjpIBB3Eg9KyLmz7wrZAxP/ekhpEh25v3jfMTNFDXutTd5OQwR5rnaPpFFogkKO27g5Z0Y+nNwQJFSLlyyCMKGM8hoF8wXgh/rCQppz9sCl0huVcvmrbqvML/GOjq6t0soWMUUbgIK1yzSSO6Cqn/ehRnvXlg3ZSq8a9hYhiAlsjn5OXc5qIRBBYo0Gfax/GDOULgYPObREBAAA=",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACVVVFrgzAQ/i95VolLG6N9GttgsD2UbbCH0gdLQxtwZrhsUIr/fcHabsaelyCK+e7y5cvd5bI6kuVGvR0+JSnIk96oV12pLYnIUqvafJFidTz9WjNd2Ie00R8Sp5Quuo99Sbs+T7ttmvJg58ZZwnnOojhNk3w2yyPGkizjIhoYRJ5OGsRN6jkhF6wzWA8/JlATzzqcZ9xz6Z5ptAKbi+uSwKUhJmgPJ6mCUd+9IcHo8bng19xd+Ex/wZ1lMRonZSg9hA8ThqqBcCddrr+rfhh7bK8ASVjcIeVIIEfZBs9KKJEfDoQMKmPUfboqPfMEHbVAjRCNHw7VHthD8AlhhYbU/LiBBAvFeh1qAI451K9R99C2ANCDt0GgTOwGRA1QF8BPNXZlTjVge9/fq/JDGtmQgiY0Is+y3pl9P3jRpjRK1/3wXW0vpkepdnvTDx4q+fPf8U5X2hLW31XVrn8BRQ2ww6EIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2992",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "6225.42 /",
    "Friction Factor": "0.023881",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10294",
    Length: "25",
    Mark: "267",
    Material: "Copper",
    "Middle Elevation": "3002",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "158.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30132.72115",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "132",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3002",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3011",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527475",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.01203457",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jk0LgkAQhv/LnNdFMz87RQVBHSSCDuJBcdGBbSdsCxbxvzeg9Q+6zfvBPG85QtHg1T0U5HCiBgvSriMDAgpCY5+Ql+N8csFLZLQKo40XBDKLE5jEH7Lqi94OQ+2Yz8Ye67uyaoDcl76AszKd7RdxIVtb5MmzvGH7i44Ku54hgUzXWSLgoNV76YbspXEsYEea+K95aT1VH/WNZ2QPAQAA",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABAClVt9rgzAQ/l/yrJKY+LNPYxsMtoeyDfZQ+tDS0AacGS4blOL/vlCdNeLNc0UUk8/77rvc5eLqRJZb9Xr8kCQnj3qrXnShdsQjS61K80ny1al5tTBd2IvU3mXGZ5Quzg97k3r9a3ZTVZujtfWTQGRh6PmMBVmceJwHCY+FZ+ejkEfNfJZyB6BMNECasT4AMnUGQmTjLniUOkAkklmaINfTwWE9TyoaEokoHg+6AwbLBy845NtNBAvSNI5HmC6AuxxjBucoeoCbummmaQ8DSW5wiHlIKujZTQQm6H9LGsbmphrSCu4UMA8IC9yOQGQaXiaw9JFUV3UIUNX0vvvbB6ZyQABVOaCm2QZz+xZYmpj2hGPCAOB+ATsgkuqqLguqgs47GEBSIQBcn0WcCUiDBrD/CXdq8y6NrEhOA+qRJ1nuzaEdPGuzMUqX7fBN7TroQar9wbSD+0J+9z+81YW2hOVXUdTrH1VCn4DZCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "6225.42 /",
    "Friction Factor": "0.023881",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9719",
    Length: "564",
    Mark: "268",
    Material: "Copper",
    "Middle Elevation": "2983",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3509.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30132.72115",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "132",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2983",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2983",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527476",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.5058892",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9jkELgkAUhP/LO6/LuraadooKgjpIBB3Eg+KiD7bdsC0Q8b+3pHaI6PbmfcPMZD2kJZ67m4QEDqbE1KiuNhoIpAa1vUOS9ePpDF5EF8to5fkBDQTzYSA/GKeMx+KbifA/mhPzuXjdtkXn2t1ji8VVWtlCwigjcJS6ts0kTsYWFt3gUV6w+qC9xLqxbxFyQWCn5HPyBj6NYh4T2BhlXK5+KDXkL95N0b4NAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVtFqwjAU/Zc8pyVJG2vr09gGg+1BtsEexIeKRQNdM7puINJ/X2ZbtU1uk4ooJsd77j03N6eujmi5Ee+Hrwwl6FluxJvMxRZhtJSiqL5Rsjo2XxVMFuqFanzZ8Sghi9OHeqN63YXdlWV6ULFe5HMWcOzRwA84oTigfhSzGP8DPIx6wJyF9ASEfNYHCMOjTISGpoAwZsycYcg0V8WM1wTmhoAbkkMATKUJD2fM3MIOcBZ4rqqhYj5hMb8+jYbpar/PdAEGHTFENDL0FBATDDgXNWi6DsDVgsk1GW3T3amsVcECtWPqJweHR4+Ap8oiUM8x4ci7HJaWGAbUQgVGGARarqahKvCigYCFyqADBMBhsFgrSOVixtYIy4jqvg7tu886ARrl5iMGVx9nAgMmPLMsLqIzQfvudkSAW0zGXWqCg9ieuwYN6j/Dg0g/syorUUJ8gtFLVuyqfbt4lVVaCVm0yw+xPUNPmdjtq3bxmGe/1z+8l7lUhMVPntfrP5dOnqPlCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "6225.42 /",
    "Friction Factor": "0.023881",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "402",
    Mark: "269",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2505.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30132.72115",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "132",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527479",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.01870918",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjMsKwjAURP/lrtPQNH1gXYkKgi5KEVyULlK9tBdiIjUKpfTfjVrB3cycw1QjFA0dhxtCDnvbUIlnp0yrERgUloy7Q16N3+iVIONJJJNlIARfpBlM9U9b9b0avOuHDakrOuwhD3nI4ICmdd27CBGnDErrlCNrZnyiyz/dIbWd+/QwjhhsNT5nXUqeyTRmsLba+nfz0HqqX5cFTP3DAAAA",
    Pbi3DGeometry:
      "Jx0AAB+LCAAAAAAABADtV0tr20AQ/i97lsU+tA85p5AWCu0htIUegg8OEYlAtYqrFkLwf69tSa53PZ9WPgaWkBDN7M73zWNndx7e2P1j/f31V8WW7HP7WH9rm/qJZey+rTfdb7Z8eOv/3av5zf6H7bL/koXg/Ob4Z//Ldqtx2+12u37d713YXDuTLYTMOXc2Uyq3pSuzk1zkZWn0Qe6kU55cWUPK0XpzNO8KrmeZkbqYomNNWWRz6A/2/fXIzgQuKY/jgjBYbeUsOiF9qbSPq0yv0LL0LY2KfseZB4OiOFg8hwjltKEp6MAS5mS08KIRoYShoXNOuEmEgFEE+RIA+wajgSqpGKmOCsfNZA1YIf1aEmJOiaGTEMohn3ieQ0WMaQgN6gLauZ4RdA4mut9xVnthesKjCytj2lK8Bc/uYUEBoOghOcpCpMUQxxN6HD89oQL5jJwQxSB3or94uCM77qlBS6EGxbC+t3Ng3rsgqUoifLs+GhADcFKq9O5UaQyR/4urFt3MpPzIprcj1CQbxB5fJNd5BTPJrbfBOqGnej9cj3iC9ZAQNIQCDT2bTDDRKOKdxU8lZAoZgZzhQ0CvR6UFKjdW6OEj60Rfy4LMzMX1PtJUHs3IZUBcH/0hOBgSdO6VKOjDpIiAEgDRVwJ6uIbAKEYwqCgJtAcw1PEIBbggQsCv6Ivvgg843fiFQPO52i+YAAAA16PExPpcGAkIgEKURsZZuGlkTCPjLN/SyJhGRroy0siYRsY0MqaRMY2MaWRMI2MaGd/jyLjK2Id6/bPqqi1b8pxn7Eu1ee5eho+vbbfu6nYzfP6on06qT1X9/NINHx+b6u/5wru2afcGN3+aZrf6B70rpkgnHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "597",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3131.4",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527481",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.03178789",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LgjAcxr/L/zzHNt2mdooKgjqIBB3Eg9bQwdrCViDid2+9Qbfn5ffwVBMUrT6MVwU57FyrS3Xyje2MAgSF09bfIK+mjwxIJDFnMV9ElOJMSJjrH7YchmYMbAjWurkorwbICSYI9sp2vn8ZShOBoHS+8dpZyCnmkshMxEzILEkzEdqjPv/DW6W73r89SRiCjVGP7zqmWKaMI1g548KZvRsz108kJUtJ0gAAAA==",
    Pbi3DGeometry:
      "px0AAB+LCAAAAAAABADtV1Fr2zAQ/i96doxkS5aUPo1uMFgfSjfYQ8lDSk1r8OKReYVS8t+rRnacKfqkuHsqiNJS3/nuu+/urNPdvpDru+bH8++aLMm37q753rXNPcnIddds+j9kefti/zVqemF+yC6bJAtG6cX+j/klu9Vo9mm7XT8b24XMuWIqWzCW60pmJcuVqqrsTa65FZeyOpYLUWivAhoUpbCKQvCzPIlKsGBIuhL/yAGFCcA1AI4QMAwoCuzPRZFTqs6ihilYaOOp0FZRcDZ5OpKL8pjDqcEAMSmk5tLn6SBH0CeeRmwY0yEdo6ISKhwTxIb0XAypChGiB7EhBKSH8hHvM/PmXsFtrLANJnaMq71CMh3sNOwKKiJRzSEOw40TdFsk4upd5XAJwoofPnzHAh5RoEWwo9ixfO6RBvsg3jlQ4ZQiQm52+s4/QOKsXQ5UDchC2nQwrkPTi+txelXmxT2HwlKQTjPRNw/xis7JBsQAQU2jttTWU8nDMxjTBnIlx/wV4v/yhKbLbG6opJOF4pY0VSI4EqAFnBUQItxnaNh6bgxxdk4+4MkRaDNUU8Aak0NNAL932DX+kPBlErYHvIuVivkzCy8AArQmvHvgyen/KIyc+XmHoeHoCincOyuCjuQpdOM/qQVggTOO8oSgIQJiB88CGBP85nG1YVAz2eFSAARoEJ8ULjuYjziGe5qmlTOtnIEpmFbOtHKmlTOtnGnlTCtnWjnTyhkml1ZOz6UkrZxp5QRBzWT38VfOVUY+N+tfdV9vyZLmNCNX9eahfxwebrp+3TfdZnj82dwfVF/r5uGxHx6+tPXT8YuXXdsZh5u/bbtbvQKHUh9mpx0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "599",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3131.4",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527483",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.72486295",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnDdZXSXXTlJBUAeJoIN4UFp0YdsJ2wIR/3tTWpeIbvPme7z38h6ySh+6i4IEtljpDE1XowUGGWrrrpDk/XiSYeYLby5ksIh8T/o8hIH9gJLLLxhHIv4PX7HFuz5t27KjDfRY6fKsnGoh4R5nsFO2ds0k9uhKp2n2KI/69EEbpevGPQUlBwzWRt0nr6DBYRwyWKJByrU3Y4biARYd7yQTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1rwjAU/S95riVd0k+fxjYYbA+yDfYgPigWDXTN6LqBSP/7OtcPTXu8KaIYT+89J/fenLg8ssVGvR0+U5awJ71RrzpTW+awhVZ5+cWS5fH/aw3zef1ildP/MvM4n58+6jerVm3YbVGsD3XszBNuJIRwfM+NPS4d8bcOpTMGhIEIT0Dox+EogCPiwL8AZCSnpepVySi4ADj3p8ntUpmqIv8muE6OU6F9hFJKK7kWqUjymMfjRaQAOlVXqxZoO2jN0QNtB1vyQUlMVViuoarroLmPPqLth0mOdw5T2QIWZbdVNYww5woDpFz7aYdlRyeKbhQ11DQ5PSVQFTQAOImUWQ79ajDt0MjI8wHJB3Jtj9rwcEJV0MjgtE+/JkyTwfcHaUuQ3NrhaE+EquB1B03G+q7FlkE6AzQZSH4mt/4Pca/WH2mZFizhLnfYc5rvyn2zeNHlulQ6b5bvattBj6na7ctm8ZClP+cP3ulM1wnz7yyrVr9juV7f9QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2987",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10288",
    Length: "25",
    Mark: "270",
    Material: "Copper",
    "Middle Elevation": "3002",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "17.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "134",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3002",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3018",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527484",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.41080632",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1Tt0KgjAYfZfveo1Ns6VdRQVBXUgEXYgXikM/WPvCVjDEd2+g9QbdnT/OOcUAeY1X/9CQwYlqzMn4liwwyAmte0JWDBMMgYWMuUpXySaJuFDLCEb2H7P8zm/7vvLhQxD2WN210z1kggsGZ21b183kQq5yGG5P9IbNzzpqbLuwIvlapIrBwej3nI0lT4VKGOzIUOi1L2PG8gNAZGs2EwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiUxatQ+jW0w2B7KNthD6UNLpQ04M1w2KMX/vtTZzaBHTlQU4+d9d5fLfXF9Jqudej19FCQnj3qnXnSp9oSSlVaV+ST5+vz7aGG2tCdp6P+bBWds2d7sRZrN1eymrrcna7vgIkiFEDQOA24PKkQguQzpBZBxJi8AEzIaBSZYRFHUAjIKcVTXqIZUWRK3QBginYMJplGajEYFOvfO1RDowuVhIpAJTs7Ddc6DjMl4hKoHuFQjFkPAqSDGBww4FRyJCgx3CDgVRCXo1AOTOUjlnUR8Hsj+AMNFWYA+fKWdMInQakdSzeooMCpYAMCOwlGhAHCJ+tTHQzVP4XyNA6rPEMBRodoAUgZQ9JFU8zYWMCrfBunxMU9Fwa71acl09ennYf8h7tT2vTBFTXIWMEqeiupgjt3gWZutUbrqhm9q/wc9FOpwNN3gviy++x/e6lJbwuqrLJvND46ZmOL1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "552",
    Mark: "271",
    Material: "Copper",
    "Middle Elevation": "2977",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "385.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "134",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2977",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2977",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527485",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.35351782",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzFkE2toPYkKgh6KCB5KDy2GNhATqVEopf9upK0gHrzt7BtmJusgLfWpvSlIYO9KnTrTVs4CgdRp6++QZN1wBsMMBWUyjpcRpygwgp58Q4mC/4UMF/EPnGIHmE/1q6Yp2rAhPDa6uCqvGkgYZQQOyla+HsXR+cLrMHuQZ335oJ3SVe3fAtmcE9ga9Ry9AqmUHAmsnXEh1z6M6fMXZ9iddBMBAAA=",
    Pbi3DGeometry:
      "2wgAAB+LCAAAAAAABACVVt9LwzAQ/l/ynJX8qE3XPYkKgj4MFXwYe9hY2AK1kRqFMfq/G2s7R9rz0paWJpfvvkvu8qWrE1luzcvxXZOCPNitebal2RFKltZU7oMUq9Pvpzezhb9JQ/96ZpyxRfvyD2nWPey6rjdHj51xmTA1n9MrkTCpUip5onIl6aWB++tfQ57xSIDIZAsQ6Tgi9ATGxFQqWoMSkdy9qwGFEHw0Jpgb8AROoos1V5mIY8CWo+9XXIqx8WH/maA3DJhRT2HmUAqYO0wdGhRsCHMXIsJpDFKBzRt0NDETcKqxhcWqDB0PEsQyg4sHFjgWE+gpGoDHBG33qZUxtQJgPYkt1mhlQgF4TJjGTd9yE3YvpOHxCoEeB/EINCr0GIxXuumiCZ+c0cIcfQj/IPyfwq3ZvGmna1KwhFHyqKu9O3SNJ+s2ztiqa76a3dl0r83+4LrGXam/Lgfe2NJ6h9VnWTbrb6WHqxfbCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "193",
    Mark: "272",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "134.8",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "134",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527492",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.92321313",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jkEKwjAQRe8y6xiSJk2auhIVBF2UIrgoXVQNbSAmUqNQSu9uaHU3b3jz/1QjFFdzHp4acjj6qyn1LTSutRoQFN648IK8GpcxKivKsFQiXacUZ0pymOq/t+n7ZohyXOxM89BB95ATTBCctGtDNwNlCEofmmC8g5ziVJIYxxIhFc+UEAgu5r64lPKIB23aLsxMeIJgb/Xnd83iKzzjCLbe+tjl3tZO9RfhdZXL0gAAAA==",
    Pbi3DGeometry:
      "KREAAB+LCAAAAAAABADtVl1rwjAU/S95jpIsSdPq09gGg+1BtsEexAfFooGuGa4biPjfV7VrtfTYZPNlUEQxHu+5H72594w3ZDQzL+v3mAzIg52ZZ5uYOaFkZE2afZDBeHP4msNsmL/Illa/9Dhjw/1H/ibbyY/Z9Wo1Xee2PS76oRCCKt6POJNU7M5a0h2go0CdAOoq2AOhDIMTgDF1sJBSNgJ1HzoQ+jwV9oGigs4xUKPSMpTnw9Uq0s0Aovp7VFWCNeflgwql2gNhpOtl5+IY0IEqwg24bgYK5yWVjHQjVSiUOO8c+sBR1ZxrxUVLuFILJ+dluDhB1zwqKgT4lwQ/cxQubAYMQCrvBHHZYVNjKmQB88A3CkUFby0EXPvK/0ZVTQ1HhmuXVBb+YwlFhSc1nImYCtxzDMBBBtcEpoIW/qsIjlewOTHgOqmrWYIAfJ3h2m6jarCAeThWF5akvUWdO7G97P4KwH/6YOeX0wz+Us1/G/xCTFxOM1xSGvhrBv8FCS3894drETvN0GmGTjN0muE/aYYJJbdm+hZn8YoMWJ9R8hini2xZHJ5sNs2MTYvjq5mX0H1sFsusONwl8dfxH29sYnPC9DNJtpNvKLuiNCkRAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "605",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "34.2",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527493",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.30779468",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjssKwjAQRf9l1rG0TZO0cSUqCLooRXBRuog6tIGYSI1CKf134wvc3XM586hHKI96P1wRJGzdUVd48sq2BoFA6bT1N5D1+IlBmSU0EgVnc5ZGschSmJqft+h7NQQ5FCutLuixBxlHMYEd2tZ3L0gYpwQq55XXzoJMIibisI+mXBRZXnBO4KDP//IGddv5N2csJ7A2+PhO0/BLIlICS2dcOGbvxkzNExQ6zN3TAAAA",
    Pbi3DGeometry:
      "Px8AAB+LCAAAAAAABADtV0tr20AQ/i97Vsy+tI/kVNpCoT2EttBD8MEhIhG4VnHVQgj+75W9kmtb+81KKfS0GBtrR/P6vtnZnbsXdntff33+UbFr9rG5r7806/qBFey2qTftT3Z99xL+dmJ+033Yrvi7ciU4vzn8dF+2Ww5qb7bb1XOneyXUwmlui1IsvOe+UPtnbYu9wCp9ts55GdZLqeIKUOBNeSYwqqBdX1iyZa+BYrq0lFYo/TxDSGFqRMfccKgXKFnlaDCCJbkQwumDQFh5ohET7IOVC261PFvHlg4xdQJl7L+5GBS4Ove8h5WIaOLryDrMCwExz/4ADxfCTgn/+D4vTaBY+ETZzTSEiijhYEbBDxAZJcL7zk9an8gwhDSBHeQ+uozyjcQ/lIqSwa3zOtGjQK0gOxPb7IX9OQ2ELhZKMCKBzm20bUjsxmaoZZhwLH4tg2PXC5wwQWBs0PAdNnu0Be99aBfo14EFaUyiz0EXWsngwsQrW3AT0jBDhcGgoPMhcdNraFWSJy0+mg/RngikNDR1CChUxtAOcgyBRUUGAYfw4SpAvlNMjA/I+WxDDcg2ZDXlY2wqhXq0bUE2orxSOwzdP6OVA3ce8EDvr+iuAJbQ9kKwErdA76MwuVKFY8vJUGm2TN5YQ/k7oYPA9i6EM4d6ktZMuxWRR3j0KoBi1T40cn/pGmugmOCMQGAOAMF546iAKZIl4mI5ul2g/gHZg22CAB3FBJPAvIKqRUAR0SY0pvOKfdA7ID6codrBmefxOY/PeXx+hf08PufxOY/PxKbP43Men/P4PJHtPD6P7595fM7jcx6fJzWWPD7/5/F5WbB39ep71VZbds0XvGCfqs1j+9Q/fG7aVVs3m/7xW/1wFH2o6sentn94v65+n774tlk3ncHNr/V6t/wDYLonNT8fAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "606",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527495",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.55364539",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjT0LwjAYhP/LO8eQNE3S1klUEHQoRXAoHaKGNhATqVEopf/d+AVud8dzd/UI5dHsh6uGArb+aCp9Csq1VgOC0hsXblDU40dGZEYZlrngc55gItMEpubHLfpeDRGOwcqoiw66h4JggmCnXRu6l6FcMASVDyoY76CgmEsS91giZJ5muRAIDub8D2+0abvw9inPEKytfnzbjGIpaKwsvfXxzN2tnZongsojq9MAAAA=",
    Pbi3DGeometry:
      "AR8AAB+LCAAAAAAABADtV01r3DAQ/S86O4u+JW9OpS0U2kNoCz2EPWyISQzuumzdQgj73+usrOxa8lvZ7a2IkBBrNG9m3ow0mttncnNXf336UZE1+dje1V/apr4nBblp6133k6xvn92/vZhe9z/kUJxWrhil18c//S85bLzam/1++9TrXjGxspKaQvEVFYVgq5IaVbwsm1Krl2UmtBkJ/H7GrJwpUOXRgJF8UiG0rLiYxIEueY25IXgBZWwRULw/RRIILVwWcpIgzAQT/IRj7GjR7w6XBx8tlywN4n0xmul/Qvf7rbZibGEgE/gzfz+2MMkOpGE5/sCRtVpfjICb0QGwJTcXy2EpTKJ8ZhYhPhSyHBEklEgI/jbFEaEw5ARQsIyIQP5bJUe1opWddyDjWoFQqcsstgEFKP+QvSStqLLhWYiPFQw8CRUJYOAwDmMcuXyAYoPAUu1sUOE0qHQBWs6102D2KJClvHjvIQuv+7nRzgJ361qOfDUlU5ddApatKNUoaOFDSLTZuC8zq89dPfGKcodZgtUMoaDxJLOw1YSUAwIh4UnL070v7pXLcw01YLZhVmGJIygcd/IMh6mAWYWVA+PAxuHhhjYgJZBECIUOWSpPQe/xRFFOy6D82dCGXdS+pFB3tlQM+FQ5heAqV5wdK8rQoGpHryPYCuGrAPjp0TlzyaHebGL/uTeIM8hxioNRqNOOQIyE39ETJ/koQi/rOFPoUsAkQ69AFIALVJyQJHzhTSssT2WSi5A9VETIIxhzno/zfJzn4zwf5/k4z8d5Ps7zcZ6P83yc5+M8HydeBXk+nn7i5Pn4v5mPNwV5V2+/V121J2u6ogX5VO0eusfh43Pbbbu63Q2f3+r7V9GHqn547IaP9031+3zj27Zpe8Ddr6Y5bP4ApCtSPwEfAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "608",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527497",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.13080633",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzFs2ial9SQqCHooIngoPVQMbSAmUqNQSt/dSH/Qk7ed/YaZyTvILurU3iWksLcXlVndVtYAgcwq4x6Q5t1wesMiphhhsGTIaRIKAT35goImPIn/QUGRs+AXzrETLKb6VdOUrd/gHxtV3qSTDaRIkcBBmsrVozhaVzrlZw/yrK4z2klV1e4jGEYBga2Wr9EbhpRHyAisrbY+1zy17os3uvryHBMBAAA=",
    Pbi3DGeometry:
      "1wgAAB+LCAAAAAAABACdVt9rwyAQ/l98tsEkJpnp09gGg+2hbIM9lD60VFohiyNzg1Lyv0/SbM0Pr15KSFA/7/vuTk+zPJLFRr0dPiXJyZPeqFddqC2hZKFVab5IvjyemhZmc/uQmp5HZiFj8+ZjX1Kv/sxuq2p9sLazLGCcRTRkSSB4eEPjOEhEFNEeIGLRAJyFfSDJwgZIEk5xVK1FGgmnRMp53AFS20gn+gRK+8JDavt9GhPFLBtHfR4f588d3UA6tekUmWMlukCPqQv00uGwOEXh0GiiQDH5JAZOQeFdCBv01S09WAo/0/UujWPrLTYqTVCx4LY4hgkzDmYJ3PooC0gCJQ2tqL8aJzMhx6Gt4S3eC/MhfowuuPOmHnAoIhwAlgl49PktQA20OHiMoq6b6VQ4ADwgUPXuu3/HGh3A/iXcq/WHNLIiOQsYJc+y3Jl923nRZm2ULtvuu9r+Q49S7fam7TwU8qc78U4X2hKW30VRr34B954mtdcIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2923",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2939",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "420.76 /",
    "Friction Factor": "0.027068",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10225",
    Length: "25",
    Mark: "273",
    Material: "Copper",
    "Middle Elevation": "2939",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "10.3",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "17144.66163",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "136",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2939",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2955",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527498",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.32015078",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5DQn6mrooKgiyKCi9JFiyF9EPOkRqGU3t1AqzdwNz9mphqhbPEyPDTkcKQWS7KDIQcMSkLnn5BX4wxDYJXydZbGGykSrlSkYGL/MevvfNH3zRA+BGGHzV173UMuuGBw0s74biFn8o3HcHumV7z9rING04UVyVMhYwZ7q99LNpJciSxhsCVLode9rJ3qDxOXXacTAQAA",
    Pbi3DGeometry:
      "5wgAAB+LCAAAAAAABACtVt9LwzAQ/l/ynJWk6a90T6KCoA9DBR/GHjoWtkBtpEZhjP7vRlu13XL2yqS0NPl633eXy126PJDFWj/uXxTJya1Z6wdT6g2hZGF0ZV9Jvjy0rw5mc3eRhv7OzDhj86+Hu0mz+ja7qOti72xnSZCFkaCcxYGUQlIhgphlkn4CaRK1QMSzASBk0gJxygcASNVaJAETLPVoOCBKJsx7fJoeBSAhwyz2MoEAyMRF6I26AzwLCDkLaw9zwQPJ0thD1QOGK3Vi0YXRmx8mD8M0IuFxCtA+ihvhLKRwlIwzpMd8ArU9SUIWDJgMjAWoAWYJpPp70U+rFUf0b30CzDaiJpFMGAC5cUCnpltM717g5kR0KSwVpgBGGoKnEyKpzum2sFfgyQcCSCoMgGy3mMMBadEC7q/hShfPyqqa5CxglNypamt33eDe2MJqU3XDJ735gW6U3u5sN7gu1Xv/w0tTGkdYvZVls/oAqkqUpecIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "420.76 /",
    "Friction Factor": "0.027068",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "488",
    Mark: "274",
    Material: "Copper",
    "Middle Elevation": "2914",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "205.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "17144.66163",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "136",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2914",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2914",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527499",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.92495447",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkqU1NPYkKgh6KCB5KDy0NbSAmUqNQSt/dSH/Qk7ed/YaZSTtICnVp7xJiONpCJVa3lTWAILHKuAfEaTec3rDgWIQiWlPCMQkpgx59QcrwSgT/YIhFwPkvnGMnmE31m6bJW7/BP3Yqv0knG4gJJghO0lSuHsXZutwpP3uQV1XO6CBVVbuPoGTJEOy1fI3egOIoYhTB1mrrc81T6z57A4WPne8TAQAA",
    Pbi3DGeometry:
      "1wgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynErir0T7NLbBYHso22APpQ+WShtwZjg3KMX/fal11dpcEimimHx+393lcheXB7RYi/f9V45S9CzX4k0WYoMwWkhR1t8oXR5Orwomc3WhBvczM0rIvH2oGzWrf9pdVWV7xZ3FXhIlDFMSeySMcUA97ocU9/ORlyRBcgQY84eAIgSEtQBnAbYr9QQe6y1wFvuXQEj5RJ8g05bgJpi2+XQtFTGqDbubH60fGN3YNvU9ngSaVJyBsdSQMVwQDeEUhcZEG4VVyG5g5BEYnAkAfYVsDzNhF7rFp+vw9Nk2LKC2WgyJgL6flCBI37S/nbaMvVJcCU4+WWrOfQdABGjerW9ASk6Nxong5BPYgS4Ap30PMkAA7HITS8gk5cawe2U67ab3Xj3DBLgca6DQhKP5SFB/CQ8i+8zrvEIp8QhGL3m5rXfd4FXWWS1k2Q0/xOYMPeViu6u7wWOR/w4/vJeFVILlT1E0qz9J11s61wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "420.76 /",
    "Friction Factor": "0.027068",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "1808",
    Mark: "275",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "760.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "17144.66163",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "136",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527500",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.67130951",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdl1k1FO0UFQR0kgg7iQWnRhW0nbAtE/O9taB2C6DZvvvceL+8hq/SxuypIYUeVzsh0NVlgkJG27gZp3o+nN8yE5ChltBAY8kRgBAP7QWOJ4RcNfCT5D8fe4j1g2bZl51f4x1qXF+VUCylyZLBXtnbNJA7kSqf98FGe9PmDtkrXjXsJgfOAwcaox+SVgsdxIBisyJDvtXdjhuIJXrBASBUBAAA=",
    Pbi3DGeometry:
      "MQkAAB+LCAAAAAAABACdVltrgzAY/S95VslFjdqnsQ0G20PZBnsofbBU2oAzw2WDUvzvc6vXxs/EUVqaHr/7+U66OaP1TryePjKUoEe5Ey8yF3vkoLUUhfpEyeZ8+VrDeFW/UOX0v7gE49XfR/1G1bY1uynL9FTbuoR6MQ+ZQ3DgxQSHDiMe55Q4LmEeJoyMkCj8BSZMIh5SE8LiwM5ZH59G/tiE+rOZTQA84mw2zFxm10DvzB7pnFGfWhbTOFsygL6YFuEMB4MBDJx1yLWzFoCd6T0zOoPj62WOnQ0I0AGXnk3E1wewoMx2NOYwGjX0+ECYuTLhzgANsOmZzjPzOoGZGffMNH8r0YA5A8a35Z8NMf6jZiAxjGKiCYPOPkAyrBgLxtcytmd/T3JzZjpiXllYTeE1M8v5EhvrdV606DYZmG9hWDfhiwNWlCXXkL1wzCtX/f/jTqTvmcpKlGAPO+gpKw7q2ByepUqVkEVzfBP7DnrIxOGomsN9nn0PH7yVuawdFl95Xm1/ALGywVwxCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "420.76 /",
    "Friction Factor": "0.027068",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "55",
    Mark: "276",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "23.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "17144.66163",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "136",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527507",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.8011198",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jFELgjAUhf/LfV5jc1poT1FBUA8iQQ/iw6yLXlhb2ApE/O8NtbdzzvdxygHymq79CyGDs6upwLvXtjEIDHJH1r8hK4c5BmW14SJR0VaKhKepSmGs/t6u63Qf5DAcSD/RYweZ4ILBBW3j26lIxaBwXntydqE3esxQynjN4ITUtH7qIo4YHA1+F10pnsRCMtg748K5/RgzVj8gjkdNwwAAAA==",
    Pbi3DGeometry:
      "8BAAAB+LCAAAAAAABADtVltrwjAU/i95jiVpktbq09gGg+1BtsEexAfFooGuHV03EPG/r7pabZuTi/NhD0UUc77mO5ee23SLJgv5uvmI0Qg9Zgv5kiVyiTCaZDItPtFouv39W8JkXH7QDp8kA0rI+PBTftFudrx2k+fzTXl3EHqEEx9TEniEkRAz5gV+hE9y4UURiw5yzhluXODBXi4i329e4HSoAE4ahBDcgkmjQW0SqFoHVFSCE2pjbHlDhFQNqKn+YlXXwUr58SUJdowUow2mGvCHlRshPwP2TBFVA7VuypVUgR/a6AZV6IyqQ8gsjeU81OpuGqvzzuRFh0kpdwkH+LZBY6E00KcH6LWrc4p4g6kMMZlzH/IN1ADaBFZqG7BOJ/cyEu0KbncJ6/To9hXrTqQ3SteZ24C+UsHS1gHteoG6P8hkHCO2c8dsknJGduXWbbnTPJRyXSdQ944uk3mcQ74ZogrFwnY+WmSfKdyXTnmHZmNUfa2twHkRc+76F20LV1oKrjr73ZcC5zEIXnAfFKYI9mtBvxb0a0G/FvzftWCG0Z2cv8dFnKMR8QhGT3G6KtbV4Tkr5oXM0ur4Jpc19BDL1bqoDvdJ/H3+4G2WZCVh+pUku9kPdV4BgvAQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2939",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "614",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "19.2",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527508",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.72062164",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjNEKgjAYhd/lv15jMmfOrqKCoC5Egi7Ei5k/Olhb2ApEfPdWGXR3zvk+TjlCXuvTcEPI4OBqXeDFK9saBAK509bfISvHbwzKIqHpMolXERNUSi5hqn7euu/VEOQwbLW6osceMkYZgSPa1nfvEomEEyicV147O+Ozbv7pHnXb+U+PRUpgZ/A565xTwVJJYOOMC+/2YcxUvQBFTAtIxAAAAA==",
    Pbi3DGeometry:
      "fx8AAB+LCAAAAAAABADtV11r2zAU/S96do1kfVhKn8Y2GGwPZRvsoeQhpaY1ePHIvEEp+e/TInmJXB/J7utESIh1fb/OPVfSvX0mN3ft16cfDdmQj/1d+6Xv2ntSkJu+3Q8/yeb22f21YnptP+RYnFeuGKXXpx/7JcftqPbmcNg9Wd0rVRpp6oJRVVKuWcF5qbgSxVkgS8OZ+CuQpqpCgbB/ZjWgwHBzEkhRF8uce1NS6CVBnS0tV5BqjSWosCCmSXaRYD1OsjJ1DA7NrafAENXmQnChMApqG0IQbKgxY4rZWIKgXu3DVFTFNC6wDTVmokpozPiACUJIVvswXM9jBfMwQk4qzlWUIq80BDkV4flC/muLUyiQVMYFq8uNgUVpQ0tQAPKGWRhm3wt4Y59jexdkTdJQagd+sX+g9SkHEHpoPcHvNXsBShqiBAUoa5CEVn6dG31ar7njsVTaCZRwpxRlzgFlo2fFTwKmq/gOCF0I7hVsMpcKgk8qpHyroKCwbz1qjIctl9UsCyancPRAd+EqZuOPFQ8hhamcbqLQNYQW7uIQc4ggxBz5hpbg2bm+3lAjXe9JWbEPZAoljqqHux4yKs2cKTmRbxQr7GLY99B1OthJi6WKFLsjipqHDaD9PUYyd06pOn6j1cqMN5/adYAxjggVd+tsrjFmbkrwKMSuQbBaetdCTXZOpICCgghG2IzwgInDqKApqIHuPvi2BDcRUD68twDMYUg47SQHX7AWAQWjhRrr6wp9zCOIKYU8wLzzeJ3H67ipPF7n8Tp6hObxOo/XebwO7yV5vM7jdR6v83idx+s8Xufx+v8cr7cFedfuvjdDcyAbWtKCfGr2D8Ojf/jcD7uh7ff+8Vt7/0/0oWkfHgf/8L5rfl+++Lbvemtw/6vrjts/vNaQkn8fAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2939",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "615",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "291.8",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527510",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.68852173",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNoTJs0cSUqCLooRXBRukg1tIGYSI1CKf134wvczRnOMNUIRWMOw1WDhJ1vTKlPQbnWakBQeOPCDWQ1fmJUZgznnKULkmRYCCpgqn/esu/VEOVYrI266KB7kAlOEOy1a0P3ApIxiqD0QQXjHUiCM55wweiccZHmgjEER3P+l7fatF14c5rlCDZWP75rSjBnJE5W3vp45u7WTvUTdiLu09MAAAA=",
    Pbi3DGeometry:
      "YR8AAB+LCAAAAAAABADtV0uL2zAQ/i86e41kPSxlT6UtFNrD0hZ6WHLIsmbX4MYldQvLkv9e1VbWkeNPsreHXkRIiDSa1zczGs3tM7m5q78+/ajIhnxs7+ovbVPfk4zctPW++0k2t8/DX0um1/ZDjtm4c8Uove5/7Jcctye2N4fD7snyXqlc86LIGFU55ZplnOWGljL7SyiVsASZG86ERxg4LEGYchmBcTMQjP1zyXGp3BRUzYtCVjmONX4MBMsh1SpRlxwxrKCDMwSu57GCkBhp1+eiSn22PZ6fbjtTdSHYIjHOnlIx9Q/yx/Naae4rdqhCi5ZyhHQA5yAYKzWMOGmtVNgLIX0GU5Th1FgtKZJLK9ISFwuzBz2kuORhwmvjPYMtcjyeOVMCRAS5oS0kfu4oqZcU6mXuQFGx225GByTAXEAYhrGFiR4qjUmVYQjjoqYE6DdwQxt5gtbonsAcQSmnQomBg4rePy2p4xCK9wRhROAmhBrOzlujew1Fv0+1f9MaJoMWIcWcC99n7jyI9OGZdisF90x9IcCURSjhHolFIeVxZHHz8SEHCMIcWBDT+W447Z6rY40YYLBhTKFzUBSslXgBT0sexhTmDfQD5g00F+rAkMDCQKJwjYUDNdNzB6wsQZTcu9MoOzVjNnSxIanw+1SZk4pySH826ZOs3y5Lqv19/7kEeyF8HQBLRwVCDfc4dZqjDJ5FGDuIdhQK32UENRITtX/66Ik8k+DD+zJo4IbAWEObkBMIDJSoGCV0+82fXx/NKBY+djiPkEXQ5TRPp3l6kZg0Ty976ad5Os3ToUJN83Sap9M8nebplbFO83Sap9M8nebpNE8vieZ/mae3GXlX775XXXUgG5rTjHyq9g/do1t8brtdV7d7t/xW37+QPlT1w2PnFu+b6vf5wbdt01qB+19Nc9z+AQ2YSithHwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "617",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "291.8",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527512",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.06132739",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUEKwjAURO/y1zE0jUlNXYkKgi5KEVyULqJ+2kBMpEahlN7dqBTczRveMNUAxdkc+ztCDnt/NiVegnaNRSBQeOPCA/Jq+MWozFhKVSb5kiWCKsUVjPUkrrpO99GOxcboGwbsIE9oQuCArgntB5iQnEDpgw7GO8g5ZXMmVCoFFwuVKc4InMz1X96hadrw5VQQ2Fp8TWNGM8kkgbW3Pn65p7Vj/QY9aYbS0wAAAA==",
    Pbi3DGeometry:
      "FSAAAB+LCAAAAAAABADtV11r2zAU/S96do1k2fpon8Y2GGwPZRvsoeQhpaY1ZPHIvEEp+e/zKjmJbZ0rJ2NvIiTEOr5f5x5Lvncv7Pa++fr8o2bX7GN733xpN80Dy9ht22y7n+z67sX97WF+03/YPjuuXAnOb15/+i/brwazN7vd+rm3vRJFbqzMBFc5l0ZkUuRGGZkdgSq3Vtq/gFZCZSELbRYtV6p89V+UInj/PHBp9cwRzOd4/9IKjoAx6kxXc4sYS7C8OSBFiKkJITLnBa/ceh/nxFMA8RRareR43WVL+pLGjBGX1vlRekQWYpHFgd6ZxYGtM2wifJEZnxmlXxcyyBdZC9faIUUlydYfTf7FWUxgZ2h1+jxYVfm8qqJYilzSfkwzrJ/wBhHcAFyOLJVDTKHJnWqQDJJS3FFsL5zunWB5KgiCQ4wsF/6CjQJVjrkKryPKcRlmQHTpuNVu3VbWbehcugB94x1SCeEQYb2FArvqEB3GMOX4fs393sWtA1QxSRekRQRXg4VUNnwix47q6dEuTpMluweoIhQdewgC4RG7WG6Yd0QiVkMwOvJEnq8X9ByaxJs+7i1RIHQFicd6gC2BzY0oaF4IDo7ShSEwKSh4PNvps7a8U5Mz6sBVX1blCyy95JTxp7SIHd9GVr5C4YNo6/Vr9VinpQIbzYIzkkgA5WztNIGhX8CEygxySakbUwMJwNUAb6QNfk8CRNOv77CheONBLcCZEQzQ6gzpGXYAZoxpvqTR4TCYS0poMDNUfprU06SeJvU0qadJPU3qaVJPk3qa1Ee8p0k9TeppUk+TeprUyRakSf2/TuqrjL1r1t/rrt6xa57zjH2qt4/dk7/43Hbrrmm3/vJb83CAPtTN41PnL95v6t+nN75tN23vcPtrs9mv/gBqEkMaFSAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "619",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "291.8",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527513",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.49896417",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjssKwjAQRf9l1jEkpk0frkQFQRdFBBeli4qhHYiJ1CiU0n830loQN+7mzrlcTt5BdsZje1OQws6eMbO6rawBAplF4+6Q5t1w+gIXksZcJosZDyhPwgh68k0jIcM/qOBM/NBpeaDFR2HZNGXrPfxjjeVVOdVAyigjsFemcvUYDtaVDr36EE94mdBWYVW7d+AsmBPYaPUcu0LQKJAxgZXV1u+ah9Z98QJdrNBzFwEAAA==",
    Pbi3DGeometry:
      "MQkAAB+LCAAAAAAABACdVtFqwjAU/Zc8x5I0Nk3r09gGg+1BtsEexIeKQQNdM7puINJ/X1Y7nbbX3JZiMZ7cc0/uTU5c7Ml8ZV53H5qk5NGuzIvNzZpQMremqD5JutgfvjqYzdxDanr6ZcIZmzUv9yH18i/spiyznYvlQgaKy4RO+DQIVZJQIQIlopieI1yGv0gsQ96PDIphrMkTJypBs7Xaetgi0QBTqdACwIUKFnFAGizAW7Ye5CBaRQAXXGhE/ljIqD9/BzmynZAxbJcNxeSBkYuGdqTBortIp6GYhZ43B1MAmMtbziGr8Re6Z6vBp20MGx6B6gkdAv9873Ye0Ev40A5VCzPhEXi/wtaEiBmzL/0npmtBY1T7DRWBgKYBXg+IiBE2A2eBbXu4Yu8tjEBgL8H4gvfmvm707v/HncnedaVLkrKAUfKki021bQfPtsoqY4t2+GbWR+hBm822agf3uf7+P/HW5tYRFl95Xi9/AKw6pk0xCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2986",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10288",
    Length: "25",
    Mark: "277",
    Material: "Copper",
    "Middle Elevation": "3002",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "17.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "141",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3002",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3018",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527514",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.87560227",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5AYW2tdiQqCLooILkoXLYb0QcyTGoVQencDrd7A3fyYmbKHosFLeGjI4UgNFmSDIQcMCkLnn5CX/QhjQKqUp4mS65lc8HmiYGD/Mavv/Kbr6hA/RGGH9V173UEuuGBw0s74diJn8rXHeHukV7z9rING08YVyTORSQZ7q99TVkm+EsuEwZYsxV73snaoPr/JiM4TAQAA",
    Pbi3DGeometry:
      "BQkAAB+LCAAAAAAABACtVlFrgzAQ/i95TiUxi077NLbBYHso22APpQ8tDW3AmeGyQSn+9wXrOkUvOekQxdyX++5yyX26PJLFRr8ePhTJyaPZ6BdT6C2hZGF0aT9JvjyeXh3M5u4iNf2zzDhj8+bhblKvft1uqmp9cL5cJFGS0Rm/imKexFSIKOVS0sYuBW8QwSTvI63HdZah7CmT8QmRYtRhEDqUUsxYhk2WJwJgY3w8q7PHYIEwAmcGx4dzRrB5i8+jjKWjUbpIt8oIe38bRxwmhO4vEJNUf+FdpLuNox4w1wCB84LjwwjMBlYG1ytQwRDzwQDB7Z1QLPj84rj+Rws8mzhgC3dpiA2HQIc1qEVepsv0LthAE3QQxzWtfWD58Kh9gG2aqsMKDaoq9uOIZELYwQYOaoqfyb8I909xp9fvyqqK5CxilDypcmf37eDZ2LXVpmyHb3p7hh6U3u1tO7gv1Hd34q0pjCMsv4qiXv0Au427MAUJAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9725",
    Length: "551",
    Mark: "278",
    Material: "Copper",
    "Middle Elevation": "2977",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "384.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "141",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2977",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2977",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527515",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.75528427",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjk0LgkAURf/LW0/DPMePtFVUENRCImghLhQHHZhmwqZAxP/ehCZEm3bvvnO5nKyHtJTn7iYggYMpZWpUVxsNBFIjtb1DkvXj6QrIQxqE8XK1QJ9iHEQwkG/KYo5/UI6M/9B5eaT5R2HdtkXnPNxjK4ursKKFhFFG4Ch0bZspnIwtrHTqY7zIakZ7IevGvgMy3yOwU+I5dTnSKPKQwMYo43b1Q6khfwHGrOXsFwEAAA==",
    Pbi3DGeometry:
      "GQkAAB+LCAAAAAAABAClVltrwjAU/i95jiVp7NWnsQ0G24Nsgz2IDxWDBrpmdNlApP990XW6NT3kxCGK6ed36WnOiYs9ma/U8+5NkpLc65V60rVaE0rmWjXmnZSL/fdXC7OZfZGOnq9MOGOz44d9k275Q7tq22pnuVykUZIWOZ3waRTzNKaCR3nK6V8gEYfrWRYPgZ6R5ZlAI4wVR5d4Cqi5/p5geWZxZOK8KEalBEs4EKunjNwKJAbbg4FhE+ytsELw8dqfkYGWQwG1XGD4GP9lPygLwn5YrxPiPEiH44qB9mBgUMrjAUshOgUsC9gpCAZsgrYHCwnue0QuUArLQKQC+zd8pwRvCHjg4HdwwPTyUxDJ/KPwkn4cGRQw4pmsQf3lm6x+CiIX/ojEj+kRCozA5y1+hAec3geO/Z9xo6pXaWRLShYxSh5kszHbfvGoTWWUbvrli1qfoDupNlvTL25r+fn7h9e61law+ajrbvkFMGOCWBkJAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "145",
    Mark: "279",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "101.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "141",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527516",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.00981336",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACFjssKwjAQRf9l1jFk+khoXYkKgi6KCC5KFy2GNhATqVEopf9upK0LEdzNnXO5nLyHrFKn7iYhhb2tVGZ1V1sDBDKrjLtDmvfj6QsYcsq4wOUCI4o8ETCQnzSkMXL8ojFN4iD6S+flYlZYtW3ZeQ//2KjyKp1sIWWUEThIU7tmCkfrSqe8+hjP6vJBO6nqxr0DsiggsNXyOXVDpEIESGBttfW75qH1ULwA696aRxcBAAA=",
    Pbi3DGeometry:
      "NQkAAB+LCAAAAAAABACdVl1rwjAU/S95riXpR9Lqk2yDwfYg22AP4kPFooGuGV03EOl/X1i7tstym1sRpfF4T879dnshm718Ob/nZEke1F4+q0IeiEc2Spb1B1luL+2jhulKv0jjDd8sGKWrnw/9Js3u12xdVdlZ27KQ+5SmwluwyGdcP4TMTwQPPBbGfiqC9A8iEhF6VhshAuZCIs6RbIOCWBhIELFJbRYk4YC07ppJaSbSk6GBgYuzBOlMSzYrA4MzLRL6MdMsQwZ6thFisA0IzGYGDcMGKzAc/UfWl8DIpI2aRYCRgnl+tsnBXGMWh0UAcM2kn/bQwGXjDgBYnLMuwQfG5T6iBUEyTNciTFyJQbTgFUkGq7wHgCJHTECQbNacgU1gZfgJ7GzmWY3hnDPwFkKwwTbX7EGbNvyywXiKn07mIrK1NH7WONca4I/+D3Irs7e8ziuypD71yGNeHutTd3hSdVZLVXbHV3nooftcHk91d7gr8q/xD29UoTRh+VkUze4blSBVOzUJAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "199",
    Mark: "280",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "139.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "141",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527517",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.62364281",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjlELgjAUhf/LfV5jc1PRnqKCoB4kgh7EB6Whg7UbtgIR/3sLLeypt3vudzh8eQ9ZpU/dTUEKe6x0hqar0QKBDLV1d0jzfjx9gYuQJkEklwsuqIjDEAYyoyyikiX/oUwY/4Xz3ZEWH4FV25adt/CPjS6vyqkWUkYZgYOytWumcERXOu3Fx3jWly/aKV037h04kwGBrVHPqSs4jeOAE1ijQb9rH8YMxQslNk8+FQEAAA==",
    Pbi3DGeometry:
      "8QgAAB+LCAAAAAAABAClVl9LwzAQ/y55zkraxjTtnkQFQR+GCj6MPXSsbIHaSI3CGP3udrPTxvTIhTE2mrv+/vSau2x5IIu1etm/V6QgD3qtnnWtNoSShVaN+SDF8vBz2afZvP+Qjv5FZjFj89NP/yXd6gy7btty32Pj9CrKE8HpLE6jNBc0jSMpYmrFeZrIYyLLkn+ZAZHJLMUmJMtOIgmf5nLUfa5kJhKsXy4gMsnzaVtniPsoMBmsD3uGZXBPw0TEWe4WfxS3mVwAwOOErVd4ia5dDr+yXaRxwnp9EwiHCVKGvUJMHgWQyNcbQDmg1sDcDvJjhMHqwRsc4QmmwiFwrsBODd4eobsAniuoLRs2ozwQnC/vvAvvPhcBJryjM6Cf/JPTh0E5wx2CAXPYAYBx+DBFzeigg/kI6f8/3KryrTJVSwoWMUoeq2ZrdsPiSZvSKN0My1e1+U3dV2q7M8Pirq6+xjfe6Fr3hM1nXXerb6U+k5fxCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "698.14 /",
    "Friction Factor": "0.025263",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "9686",
    Length: "8997",
    Mark: "281",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6281.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "22859.54884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "141",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527524",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.2827128",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le72Gcx86u4oKgroQCboQL1YNHawtbAUi/veG4t15Ds/h1COUd3Md3hoKOPu7qfQjKNdaDQhKb1z4QFGPS4wKoQLnqZTbDWE45RSmZvV2fa+GKMfiYNRLB91DkeAEwUW7NnQzEIqg8kEF4x0UFBNGuEwFpzyXmaQEwc08F5cQJhCctGm7MHPCUgRHq3/rmuKMiRzB3lsfv9zX2qn5Azdoh9zSAAAA",
    Pbi3DGeometry:
      "nREAAB+LCAAAAAAABADtVl1rwjAU/S95riUftU30aWyDwfYg22APwwfFooGuHa4biPjfV7Sd03iaNPNpiCgmp7n35PZ+nNc1GU318+o9JQNyX0z1U5HpGQnIqNB5+UEGr+vd3wqmw+pDNsF+p8coHW5/qi/ZjJtjV8vlZFWdZSIOJYtV0GNRyKVSgRChFP0kOET6Ygv02eG+oNVOBSRKqqMTlCqA1F6SmDtba/EDmLX4x8jOVhLF0pUyZzEHCDTmz8y8Ze1+/8a4aiLG+aGtBuEykTvKETtCmOQAqf1H8hiojUkh3AlgN5haE02VOBujQrYTMEnDe9pvc8IYRLrEBqUApIxzw541+D173NJ8ATjRsTWH4sAXxX4wN1zRBuKeah7Fts912FKcs+ZEF3JvXHZeuD0aiL2gcQ+AiFlPeHBgaw7DpsPosnNrGbcG4t7WT9QhRmDvQM3GMGWdUPCS9jDjwHQZt9bkdIn/X8RDh/bkQOCsgqOz4PMYHV5K5Kx646yqwkdveExVeMRn1NiieVEbF7VxURsXtfGv1MY4IDd68paW6ZIMaEgD8pDm83JRLx6LclLqIq+XL3r2A92ler4o68Vtln79fvC6yIrKYP6ZZZvxN7bcIQWdEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "624",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "34.2",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527525",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.51310948",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzcsKwjAQBdB/mXUMTdP0EVeigqCLUgQXpYuoQxuIidQolNJ/NyoFd3OHc2fqEcqzPg53BAl7d9YVXryyrUEgUDpt/QNkPf7GQBhPaSo4Wy5YQmPBYWpmt+p7NQQcFhutbuixBxnRiMABbeu7T2Ai5QQq55XXzoLklCVMFHE4KfIiKzgjcNLXf7xD3Xb+mxORE9gafM1tTrOACKydceGZfRozNW+QCnXd0wAAAA==",
    Pbi3DGeometry:
      "pyAAAB+LCAAAAAAABADtV01r20AQ/S97Vsyu9ts5lbZQaA+hLfQQfHCISASqVVy1EIL/e9fWyu1KfrtSculhMTaWxzPz5s3bj7l9Jjd39denHxVZk4/tXf2lbep7UpCbtt51P8n69rn/6sz02r3Iofj7yxWj9Pr04d7ksBnc3uz32yfny7haaa5kccXEqrS6LDhfGcFZEViYpfJo0dbY0FJSYy77RCySnwyKiWImgCGYlkLPhuajLfHhTC6Ohn3S2C5UCvN42tzzmLYxOYq6fEGwI8TQMvicLdIhCUBPfcbRpKUqgPaqNFbzhM+Z6anPpNAZPpM8mDaM+gV53BdAGyxHl0yHIqA8oZtXBYNSw+qcvz6UEjy0SOebsLxAA5BnSEBETzgL7gCuxgoT6snoMZ+TRY11m46W3sAvdBRbxvKAgoKG9BJYsnOg+mOcwdWJ64eyEd7AjvQeLdp6qXPu6yzFab+nRvUGbYb8sreUwqb2zkiagRqrQxcXPoCsBgVCYDi94uH5LZiZe7DDu8CA2JQs1UvIGFb5rJUxAoBJxgKE9GMyIf84PwyGz+Hl7Yce6e6Pm4yToFiR4rEuYFtwj9NSmhaDAWDQeJEjaiIAZoAerb8ZPYP3UE6VCNeFsP4wo/0xp3nq8qyEL9Kqnn+qmBes7ckstWRz72DwNI0BQKBV6RFwKu1ol4U+EBvmMyJ1wE2EAYwMBsMu+EIFiYb7TKSfcD/BDcDIIgSk1TkRNOIMQoYey5uMcmAmIxpDWWDteeTPI38e+eO05ZE/j/x55M8jfx75owNEHvnzyJ9H/jzy55E/j/x55P8vR/5NQd7V2+9VV+3Jmq5oQT5Vu4fu0T98brttV7c7//itvj+bPlT1w2PnH9431e9///i2bVoXcPeraQ6bPwY0LRSnIAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3002",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "625",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527527",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.97333076",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomiZp40pUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6sGCVt/NJU+BeVaqwFB6Y0LN5D1+IlRIZRjziiZz0iGU0Zhan7eou/VEOVYrIy66KB7kAlOEOy0a0P3AsI4RVD5oILxDiTBTCSi4DTlosjygnMEB3P+lzfatF14c8ZyBGurH981JVhwEidLb308c3drp+YJCmOmutMAAAA=",
    Pbi3DGeometry:
      "ZyAAAB+LCAAAAAAABADtV11r2zAU/S96doNkWV/p09gGg+2hbIM9lDyk1LQGLx6ZNygl/31uZCeVlCPL66sIDbVP7tfRuZLu7TO5uWu+P/2qyZp87u6ab13b3JOC3HTNrv9N1rfP9t8BptfDhxyK85srRun18Wv4I4fNZPZuv98+DbaMy5U0ihdXrFqVVOuCs5WhShRHRHB2RDgTwkVONkaViYhiQlpEcGASJEC1AWFwaiebBeVMCDN0sbfQJoE2XKmPCEMBbZAcIY12nCntvR8t/PdTwrqsWKInm5SSTL45xGihpeYuMjGM01pkA+OgInHO/xXFUqa19CkLitGVcExMqebUstxZgsDS1RrpCsaEyxkXfAZ5kwICniEBCb58JMIArrMqXTlJoZM72ZcTdpawMwa7KU4AiQOzOU8zbADYM0EHwvJTGjDgEpcPO5BPCdDRGZsQWY5htAVoZcuUykwmA6cvSGWq6KaJg5yJobKyUUprUjInYWWYiKcFgxvJnNL5aJBwjgf6UqJ00j0jUMaQrYjAsTMYP4FiuPv75EMqoSTmo6Nz1D94ly88tkArH1lgGAT6wg0029rhboDXF8sIFwNlhHPGYTAzuFuQs0jrzS5ZcE5NnDFjlIu8pGoRYU+9SWP4cJd0CmNsAszXMafmqDJFfSW7t67I+YnDo4xfBaEj/WP4FBM3L8wkJH+eFS8GZB55mi8juDolXLfwrd5fRbiJYOYjmcHyIYBFjBmDGyWyWLy+CawERGJ5wSi4+DzS55E+j/SRIvNIn0f6PNLnkT6P9InneB7p80ifR/o5ZvJIf+nWlUf6S8znkf4ykEd6r/hNQT402591X+/Jmq5oQb7Uu4f+cXz42vXbvul24+OP5v4Efaqbh8d+fPjY1n9f//B913aDw92ftj1s/gEd1GYdZyAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "627",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527529",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.65385627",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjUELwiAcxb/L/2yic7pcp6ggqMMYQYexgyvZBNNYFoyx754Vg27v9/g9XjVC0ZjTcNeQw8E3ptSXoFxrNSAovHHhAXk1/mJUKBOYEJmtFjTFCWcw1bO37ns1RDkWW6NuOugecoIJgqN2beg+QLlgCEofVDDeQc4wTSmXieCML2UmGUVwNtd/ea9N24UvJxzBzurXPKY4E1Qg2Hjr45d7WjvVbyxHq+vSAAAA",
    Pbi3DGeometry:
      "WSAAAB+LCAAAAAAABADtV99r2zAQ/l/87Ab9sCQrfSrbYLA9lG2wh5KHlJrWkMUj8wal5H+fGslNHes7K3kWoaHW5Tt9993p5Lt7KW7v2x/Pv5tiWXzp7tvv3aZ9KMritmu3/Z9ieffi/3Vmdu0+xb48rlxxxq4PX+6v2K8G2M1ut352WC71glnJyyteLYQ1opR8YepyvK7k63Jda11GAbWuZapFcqUOFlHxOGayPatrsAskFiDpkXiD0fw8TxHAnFgovNN1bhkSaiyIWljtND1gtDVvviLrRwmZWxhZPF/CV+XojxCe1yW7OIuSNhFzlPgUMyiWjphRjGR89i7OYkRUMyIW46CH9bqq6OwPiMs9zVdYaq1OToNgnpTgvEq1nJ94LC8OHvlC6yh0HIdyCwdLxS3dno6FgksowdtcF4w0TmiZ1gSWkrAk131Sr4ASELJBC9YAxOO6hQ0WIb3BDG3EMh+o0MJvo2QIVFahPozlHsMN2S6pbWqjxxBjlLcYE6IR/JRznBrZr8WAsTreGOZv74jQRvF3pMmEAtWoak84IGMCUGjyWsQpIPIJUwAzjZ3h+/eSGgCYlBo4yTR5CuLOqAzgdOIGgSstoZ4mdQsYUKTxYcfSYALzpKfHMDlrk3staGYMG16BuAql4S88HT+B7y5uoUOMLGzBKh+90tU4Ze4H5OsXvlXx7jG6rwf2ZG9X8ZJGIFJIQqg5FgS+dgLNgScKAd+igLZka4EJxD2H0B1Sg8HMleK0eKH0uONhkS/IMBYmriVRX5gXjj/P8nmWz7P8HOM8y+dZPumtI8/yeZbPs3ye5fMsn2f5PMtHxpc8y+dZPiGHeZY/a5ZflcXHdv2r6ZtdsWQLVhZfm+1j/xQevnX9um+7bXj82T68mT437eNTHx4+bZp/73/4odt0zuH272azX/0HF4wPN1kgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "629",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527530",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.1602651",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImjZp6kpUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6uGArb+aCp9Csq1VgOC0hsXblDU4ydGhTKOCZFiPqMMpyzJYWp+4qLv1RDtWKyMuuigeygIJgh22rWhewHNOENQ+aCC8Q4KijNBhOQs4UKmueQcwcGc/+WNNm0X3pxkCNZWP75jRrHgNC6W3vr45e7WTs0TaUdvbdMAAAA=",
    Pbi3DGeometry:
      "XyAAAB+LCAAAAAAABADtV1Fr2zAQ/i9+doNkSZbcPo1tMNgeyjbYQ8lDSk1ryOKReYNS8t/nWXITy/5OSvoqQkOty313991nSXf3kt3eN9+ff9XZdfa5vW++tdvmIcuz27bZdb+z67sX+29vZjf9Jzvkx5UrztjN8NX/ZYf16PZuv988975clCumRJVfcbFSvOS54CtTGpEPFlbpiUWXvMwXfbSh13VRTGMUki97uOhqVZVKLWKBrBY8YirxLcaUZ6M5n7MYw3UeLVIvsoa46deLUg7rok9piuVbfA8pCjNlMwJLMzHN6/IoUmvK4dgWz2GeVdAlniwi3XODyEoBrmaFSM5tcxmXdNsXMo4Hi1dXUKv0e2RsBlLKSMNbmj+jGRMQBvMNBDGolqrXlsWSit6tZoqZCgkAnbUhjlhoHUuCkFGY35D0w7sEZjEENV2GhcMiKmYsUGEtPd5AOq9cAC6G4nSlCmsRynkoW4T2xetvjoshTmvgzBahmfPQo9oYK6bHKUgLRf9/MBXaKVd4WPGH9ogluJmuv2aM1btMFylrAgwnECIZb/Uz+hGVmPxQdHRezk/YS1qPfXDzUYux7gEWUX3EWz3tCu4wJaTFUsjw6KWHIQhW0KuCoIi3LrpZx2PZp8torWyNRo41Snv7MTx4veVl5XyUuzHpyhdsNXBpZAn2ndCZSd4lQNKnimEugVFkYRcvM5JP3IMIbmYM4B5gtAgKZtem4E2LuMnPGgp2E6oHODNcDeYGaJpkjdg2l30u7HWYHI9QUm04N8xBGufBGJLG+RBWGufTOJ/G+TTOB/hN43wa59M4T0VP4zx9zKZxPo3zaZxP43wa54lxfp1nH5rNz7qr99k1W7E8+1LvHrsn9/C17TZd0+7c44/m4dX0qW4enzr38HFb/z394ft22/aAuz/b7WH9D5WYWJpfIAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "630",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527531",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.62044074",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkadqSehIVBD0UETyUHiqGNhCzUqNQSt/d0NYfvHjb2W+YmbyD7KQP7VVBCls86QxNW6EFAhlq626Q5t14esMsppIncykol0JAT75QQlnAxF/Ggx/2iRxQ8SpeNE3Z+nb/WOnyopxqIGWUEdgpW7l6Ent0pdN+8CiP+vxGG6Wr2g0i5hGBtVGPyRuGNIqZJLBEgz7X3o3piyeLwdf6DQEAAA==",
    Pbi3DGeometry:
      "VwgAAB+LCAAAAAAABACdVd9rgzAQ/l/ynEqMGhv7NLbBYHso22APpQ8tDW3AmeGyQSn+7wtqt/jjTByimC+X77673CWbC1rv5ev5Q6AMPaq9fFG5PCCM1koW+hNlm0vza6bJyjyown/IIiRkVX/Mi6rtddlNWe7OZu2CBZymmMcBXfIQR1GQcEqxBScpr2FGuA0vazAlIXZT1LYsjKMRXkaj2IYpY3NUAA4nQ/F0Oa2kTxIlo1G2cD9RQDgdl2lAQhL3k22hHRLb2o5+aN8o77M3wj1YHOwDNVBMEA6qBPx2Eu/B8089g7g6O+uTt7Hy8KlfJ4cDhHIClLTbHKiXWbsAtMtMgdNNNwlDO+9uRsAcYvfyCtXVvEPKzeIDQ7UPnF5uc4jdy+v4Keg8SWdxuECouz0aduJCHHJfUXNL38ndu9CiRBkJCEZPojjqUzt4VnqnpSra4Zs8/E49CHk86XZwn4tv2/BW5coQFl95Xm1/AA6pjbNXCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2929",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2939",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10231",
    Length: "25",
    Mark: "282",
    Material: "Copper",
    "Middle Elevation": "2939",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "114.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "142",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2939",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2948",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527532",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.5154878",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jskKwjAQht9lzjF0s0s8iQqCHooIHkoPKQ3tQMxIjUIofXcDrb6Bt39jvqlGKBu8uocCASdqsCTtOjLAoCQ09gmiGmfpB6uMB1lUbIqER+usgIn9oau/6O0wSOf5PtijvCurBhABDxiclelsv5gLWWnRvzzbG7a/6qiw6z0k5GkSMzho9V6mccjzPE0Z7EiTP2teWk/1B4d+PDcOAQAA",
    Pbi3DGeometry:
      "cQgAAB+LCAAAAAAABACdVVFrgzAQ/i95TiVq1cQ+jW0w2B7KNthD6YOloQ04M1w2KMX/vszaNbpcE0UU8+Xy3XeXy2V1RMuNeD18cJSjR7kRL7IUW4TRUopKfaJ8dTz96mmy0A9q8AWZhYQs2o9+UbM+L7up6+Kg186ygMzDFLN5ECUZw3EcJBHL8C+eRazFozTt4QmhLR4ntIdDPGd7amWnLDTxUNOMUgN5dUXl6depZ8BDWGIJtgOHGQNiAn32Mh8GlOp1/3gMvJcDi32r3cCNnfJgcbEP1PSjcuOgSsjvJfNukslihik2dxbSaD8L9rw7bb3q3bmnUG6hqvZgmXriQS3XTtIVZldF2EC/crDKGGU8tt8AhebsLF4sbhgqeqgX+9BM7oqgGug+gnAvHg/cqy96dG8v+xOu7+87UbxzxWuUk4Bg9MSrndp3g2epCiVk1Q3fxPZv6oGL3V51g/uSf5uGt7KUmrD6Kstm/QNXAdS2cQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9719",
    Length: "501",
    Mark: "283",
    Material: "Copper",
    "Middle Elevation": "2920",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2255.5",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "142",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2920",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2920",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527533",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.87655711",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0aWpNPYkKgh6KCB5KDxVDuxATqVEopf9uaKsUL9529g0zk7WQXvDU3BUksLcXTK1uSmuAQGrRuAckWTuc3jBjnC5kGC2loJwzAR2ZwJiyMBJ/mRQ/bBraw/xTvqrrovEL/GODxU05VUMS0IDAQZnSVaM4Wlc49KMHecbrF+0UlpXrxZxHBLZavUZvyGgsuSSwttr6XPPUusvfEJ4R5REBAAA=",
    Pbi3DGeometry:
      "mwgAAB+LCAAAAAAABACdVd1LwzAQ/1/ynJUk/e6eRAVBH4YKPow9dKxsgdpIjcIY/d+NXaftmluuo7Q09/G73yW5u+WBLNbydf9RkIw8qrV8UaXcEEoWSlb6k2TLw/HXqNncPKSh/5IZZ2zefsxLmtXJ7aau873xnXHhJakf0jTwhIgi6nMvEQGnA0UYp7+KOBXpUOGHSevBBMUhnRyCSFhDJGEYDBVJyieSAoO78psQ3MXKAmXP275/YG6DuLHHfRPm/CB64gFOTz7YibH9kb0FvqWPwHHgj/hAaUFyiCcU184eQrmSzTgrd21AewzWDMZh6qlAAcC7jLomqKrAeWA4Xawv9MlbrQEpqjfYYXA9BmGP4mO9htZ+cZn6ubGz44AtzVkkcAN0m2PYQINrYh8FzAExbjABOJPGKxNm0t/J/L3QRU0y5jFKnopqq3fd4lnpXEtVdcs3uflTPRRyu9Pd4r4svvuGt6pUBrD6Kstm9QPCx5OhmwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "1755",
    Mark: "284",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7904.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "142",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527536",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.48849562",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjUELwiAcxb/L/2wydc5cp6ggqMMYQYexgyvZBNNYFoyx754Vg27v9/g9XjVC0ZjTcNeQw8E3ptSXoFxrNSAovHHhAXk1/mJUFgIngsqVTDHlQsJUz9q679UQ3VhsjbrpoHvIE5wgOGrXhu4DhKQZgtIHFYx3kDNMUsIlzTjjSykkIwjO5vov77Vpu/DlJKUIdla/5jXDnEqBYOOtj2fuae1UvwGwQ1z/0gAAAA==",
    Pbi3DGeometry:
      "yRwAAB+LCAAAAAAABADtV01v2zAM/S86u4E+LSs9DWuBAduh2AbsUOSQokZrwIuHzBtQFPnv82I7q2i9SNlZKRLUDEM+PlIUef/K7h6ary8/arZmH7uH5kvXNo+sYHdds+t/svX96/jv8DW/Hv7YofgnuRKcXx8/hjc7bOafvdvvty/Db6/siguuC6dX0rmyUGplnJTFW3ll9V95KYX15LIKy5G+se4oV8ol2RGlPIfHlNLXR/gn+wt9ZAf5RfKIX8SDMdwk4aH4rXSeX+lGuVa+nVk+68/4J7ngUnn2qRzZQX6JHYhHCenxEMED/aK4hDZn7RM8Ub/EPowL8YDqx+jSk9vwuTjlXRrhxaW1TqorVP9UjvDE8kvlMZzUL6gHaOdSPCgulN9Zf643mhd6TlE9xOxE+m1yv6J5R7whOeI/1k/oeUTxxs4LlaN4Ef5KjnIrzbHfchHsq6c+bM0kHs04rUYzdoKvTFJYl9KA7AM4pfRvTeFcKOuL2xTdvkjuVDmyVv4PO/iyuCwqlMOq8nu51dW5Hg/1EUygj/BAO4hlFFcsu7Q3RHuJn0UcL8AD0gVrP6yOagrVbIwFOkHN6LWSwawsbvARpiQwY42fXhRz7cvBTSjpwyt0hKhbZD42B6C5k7oF7EA2Efth+JDkKDtVsP1SdkBU0WluAQecaDgFhOFcGhUiH5kH6rA/RvraggVgH7GTd8C8AyZd63kHTJpp8w6Yd8CkuS3vgCnzdN4Bg/Nx3gFDNZt3wLwD5h0w74B5B0zeATcFu2m23+u+3rM1X/GCfap3T/3z9PC567d90+2mx2/N4+mrD3Xz9NxPD7dt/fut4vuu7QaDu19te9j8AeS79rfJHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2939",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "631",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527538",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.94280607",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizulcp6ggqMMYQYexwyrZBNNYFoyx7569Qbfn5ffwVCMUR7Mfrhpy2PqjKfUpNK61GhAU3rhwg7waPzIiM4mJZGquOGapVDDVP2zR980Q2RisTHPRQfeQE0wQ7LRrQ/cylHKBoPShCcY7yClOJZFKJExIxTMlYnsw5394o03bhbcnnCFYW/34rhOKZcZSBEtvfTxzd2un+gmG9bJe0gAAAA==",
    Pbi3DGeometry:
      "yRwAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+anedU2kLhfYQ2kIPwQeHiESgWsVVCyH4v1extW52uk8r0+tibKzx+M2bN7Mfc/vMbu7ar08/GrZmH/u79kvftfesYjd9uxt+svXt8+nr+DO/Hl/sUP21XAnOr48f45sdNuFvb/b77dP43yu74lb6yuuVFLWslFg5V9fVi10rfbRLp5N2Z9N26q+EPNqN9YtwAh/v69d2waVK4gP+Z3+Cn8UhcbN2pBuNK7RJ6YD4QP7K6Ciu1CKyBxyjYv/An/pP+NZrm8L5x47iBp40LuITdKiNW8QHxUV5TfjWSbMoLxQX4aO8iA6wf/y0LoJdTzxR3SWvI92s8Iv6CvU/XXeIT66+1I545vqZ9gPCuZBPNi9S37N/6DdaF7pOQT8gnOx+hfYBakd1R7rl9ETrEfU5WY9QtxwOtaN8AX9eq5Ndq1Ncof3seWS5PdknHCljOmP4FzP3elFaF8tA8NN0uDYiylbpZacpOq2p3bhAR/6HOmhTvTQrVEPPVeTPnUn1bNjjs/6UJvBHfCAOUhn2JtAB3SnQXgKqCHkiPqBccAtLu6Oegj0LVEA3w8DejjRSVSEn+JmmS/cy2vjhQaFMtHJDul6Ri2EyLIKHdnRvQGGBOvi+jnpwXjV4TSLqwOt9Wh2QVfY2R2uOVjRUOdMjC7NC4oNsYa1ATXL7GlUB4SN1ygxYZsDUoi4zYJkBl9S3zIBlBpzTrcyAs/hlBiwzYJkBIxXKDDh3bygz4FzNyww4h5/A2VTsXbv93gzNnq35ilfsU7N7GB6nh8/9sB3afjc9fmvvzz99aNqHx2F6eN81v187vu27fgTc/eq6w+YPKkSbNckcAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "633",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527540",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.10033106",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjkELgkAUhP/LO6/LurqadooKgjpIBB3Eg9KiD7bdsC2Q8L+3qEmdur153zAz+QuyCk/dTUIKe1NhZlRXGw0EMoPa3iHNX+PpDF5EEx4vvYQywX3oyReKKfNZ+I/5XPyiOXEgxad21bZl57rdY4PlVVrZQsooI3CQurbNJI7Glhbd3FGe8TKjncS6sYOIuCCwVfI5eYOACrYICayNMi5XP5TqizecAm9eCwEAAA==",
    Pbi3DGeometry:
      "dwgAAB+LCAAAAAAABACVVV1rgzAU/S95jhJnTdQ+jW0w2B7KNthD6YOloQ04M1w2KMX/vuBsrc7rTRDFnNyc3O+7PpHVVr0dPyXJyZPeqlddqh2hZKVVZb5Ivj79/dpttrQPaWiPBBFjy/ZjX9Jszsdu67o42rMBD7MbQYMsjCImaByHSSQ47WHGeTIH8yh1kE5E3MJxJnASSJM05S3M0gV+5YVkzJ2lE5oAVwIkkPFnBQXLHMxBjG9hEbKILf6LT+Ate48Pb3XgGYQI5wfxQZRwfWD8OlAT8mP9B87H7YV4fP0P+hnz5yh3gArxZHGBIZ8BeYyLY5npGCmo2PyUBOveAYayD+geDuJ+OYbm/Lg7eSo53+PmYKi+geaMivt2A5AemDeeSiIzbg6GKh4vYWQmzvRbO8XvVfEhjaxJzkJGybOs9ubQLV60KYzSVbd8V7vL1qNU+4PpFg+l/LkWvNOltoTVd1k2m19BVmYodwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2913",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2923",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "6225.42 /",
    "Friction Factor": "0.023881",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10215",
    Length: "25",
    Mark: "285",
    Material: "Copper",
    "Middle Elevation": "2923",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "158.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30132.72115",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "143",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2923",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527541",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.08160896",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jssKwjAQRf9l1mlIFftyJSoIuggiuChdtBjagZiRGIVS+u8OtPoH7uY+mHPLAXSDl/5hoIAjNajJ9i05EKAJXXhCUQ7TyYUolSpd5OsolyrLEhjFH7Lqi954X/fMZ2OH9d0E46FQUgk4GdeGbhZnCnVAnjzJK95+0cFg2zEklqtcJQL21rzn7jKWTGNvS5b4r3tZO1Yf5aXxzA8BAAA=",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVVFrgzAQ/i95VklqNWqfyjYYbA9lG+yh9MHS0AacGS4blOJ/XzrdZqrXnCKK+XL57rvL5bI+kdVWvhzfBcnIg9rKZ1XIHfHISslSf5BsfWp+zTRdmIfU3j/iM0oXPx/zknrzu2xZVfnRrPV5QOcs9vw0oEkSe2EYzDmfeWecz9IzzliaWHhEkwan3MIhntaexnE0xE8jHnZxZohG6YH8OuLC+nXpueShaTQYbgP3sgZEBXq1ss8CMx33eTq4lYW+faO+g1u7heBx8F/qseNy46BOyG83+26aqXJ6ae7uLqQSOhNQ9hH2qNpH7C6UZajGUTzTewCo5+rZus7urpFhGFcigJiR5mO7EVCAzq6DYnHD0GGAOjWGZnLHBNVA9xWEo3gQOKpjIjo7yr7Bzf1+K/M3oUVFMhpQjzyKcq8P7eBJ6VxLVbbDV7n7m7oXcn/Q7eCuEF9dwxtVKENYfhZFvfkGbivSUJEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "6225.42 /",
    "Friction Factor": "0.023881",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9719",
    Length: "485",
    Mark: "286",
    Material: "Copper",
    "Middle Elevation": "2904",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3018.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30132.72115",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "143",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2904",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2904",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527542",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.81069329",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9jkELgkAUhP/LO6/LrpvK2ikqCOogEXQQD0qLPth2w7ZAxP/ekual6PbmfcPM5D1kFZ66m4IU9rbCzOqutgYIZBaNu0Oa9+PpDUFCmYgXy4ALKiLGYSA/oKQ84l+MMyn+szm0+JSv2rbs/AL/2GB5VU61kDLKCByUqV0ziaN1pUM/epRnvMxop7Bu3FvEYURgq9Vz8gpOExlKAmurrc81D62H4gWwZUe+EQEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACVVdtqwkAQ/Zd9TsJsLubik7SFQvsgbaEP4kPEoAtptqRpQST/3o0mmsSZzYoo7pmdM5edPbs6suVGfBy+M5awF7kR7zIXW2axpRRF9cOS1fH8V5lhrj6stq6IzQHmpx/1ZfW6c1uUZXpQvnboQOjGls09xwuAWx53wrgBQoeDzweGyG0A5REHQxxcS0cEAUSog89neIAxUxQEvj4lMjZpuDs4bSCpbgr3Zy7awRY3r+8Su2GKHR7wfmfPPD14QHPFh81A9p8KuKEnaQjcNJ1hpxGcSpPKZ5x+135Dnql8yLpGhzIIS84J4kDOj7YwLILpAXdE2k5gc6glIh2w2vT3D8mJuEwkruNBKsBh6uz1qknxmKjslIN2GhH1xWHTmQa0OSb6gImxhobafs8DpNUHhIjCTXUG8FsKevUxloep5xNJX738jyL9yqqsZAk4YLHXrNhV+3bxJqu0ErJol59iezE9Z2K3r9rFU5799Tc+yFwqwuI3z+v1P7JFlEKrCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "6225.42 /",
    "Friction Factor": "0.023881",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "1280",
    Mark: "287",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7967.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30132.72115",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "143",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527545",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.91602295",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrtOQ9JUmrkQFQRelCC5KF6mGNhATqVEopf9uVAru5gxnmHqCstWn8a5AwMG1ulIXL21nFCAonbb+AaKefjEoEcOExXwVcUyKIoe5WbT1MMgxuKHYanlTXg0gCCYIjsp2vv8ApWmOoHJeeu0siATTlGY8zrMkKzjjCUVw1td/ea901/svkzRGsDPqtawTnDIWuo0zLpzZpzFz8wZAKCff0gAAAA==",
    Pbi3DGeometry:
      "dRwAAB+LCAAAAAAABADtV01r20AQ/S97ls1+SrvOqTSBQnoIbaGH4INDRCJQreIogRD836taK1e72qeVe15CQjQev3nzZnZWc/9B7h6qH++/S7Iht81D9b2pq0eSkbum2rcvZHP/0f/bfUyvuh9yzP5ZVozSq9Of7pcct8PXPh0Ou/fuu6tiTRmV2cqsqcxNJsRaCVNkY7sy7GTPDR/bGdMhM3KnWucnu2ZyAQwTlM+yYdSFB+wHeN8dwKCwkE4kLBBBGr2IjUe+4GYcVBZFb5fCgTnbrf9AfrB3cGIE75sRDArrwUA2gnFHg3k2MCpKikk1B+/TiYT14WFWQATUN0rmjp2HT8NQca6Y2zfMLOgn0PS+GXGZr6tvjlD0g4IugDCXkUEpoapa//Mx9soxOZioC2I4sdm6cDz59UaiITsSPzJAJmcQpRs5JBM7Shfx17y3F6KPK00QZpi6RT8RlL15JOtV00XPXolFSV0qAoAHZHLuXo95IUMV969NeM1CO+9ZKvkf2uCr4bKkQP20dka34n+j4ZEO/RFL4A/oQBgkMcgqVll/JkRnkVtBnG2YDigV7PqwO2on1K4REfz3JMudUcEDFZnc1cpaXY6RYT+5HGzPMy6D9e7sPHB0JmERfOzKR6+cftiwNkhJJHyYPFI4Jo0XFCgDMoq9sk3IgGMML/0wmwtzArIj8LA3HIjzk2yiQBgdCZM2uwXHLG12abObe2lNm13a7NJmlzY7DJ82u7TZzc6EtNmlzW4ubNrs0ma3eLPbZuS62v0q2/JANnRNM/K13D+1z/bhW9Pu2qrZ28ef1eP5oy9l9fTc2oebunwbO35u6qYD3L/W9XH7B/7Czbp1HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2923",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "635",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3131.4",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527547",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.49374446",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAYhN/lP6ch3bLUk6gg6KEUwUPpIdXQBmIiNQql9N2NG3ib5RumnqBs9WG8Kihg51pdqZOXtjMKEJROW3+Dop4+MiARw4QlYhEJTDinMDc/bDkMcgxsCNZaXpRXAxQEEwR7ZTvfv0wcZxRB5bz02lkoYpwzwgRNE8pExgUN7VGf/+Gt0l3v355kCYKNUY/vOo0x40mOYOWMC2f2bszcPAFJWqx20gAAAA==",
    Pbi3DGeometry:
      "oxwAAB+LCAAAAAAABADtV01r3DAQ/S86exfJkixpcwptoZAcQlvoIexhQ0xicNdl4xZC2P8e11+NZT3JJuQmluzGb7Uzb55GM5rbF3JzV/x4/p2THbmq7orvVVnck4TcVMWxfiK725fu3+ZretG8yDn5j2wYpRftW/NHzvvhZ5en0+G5+e1GbSlnabIxW6p1lnC2bT6y5B8uuGhxadhbnNGUu3C0nqrUtLjIzBI7jAnp48OYnsCA/mDeXu62gpxCMgGvSATGabqEDiDfe2WSddZTwSZWBlzyCXt7/Wi+x5URymVnxIFf287gF/EZVRjwTGovH+QXxGXbVzqVvriQX2gf6Qx0CGUVo/2REB1PtO1j8mS8xRUzvqQCZhAcIrMwWMQyFJSVC0EzK7WfhYX2dsg1az0qOyjFkZlAlV1WpmAZCWYIwG3xQ1GtFW1pYQiFa9GXuhNTmQ5nwnhbkOhbkM5ERz/t2Ktp6lAjluzhYhWQfUBnaJQZ7cxw4W2gOFqAc9WrJt6lDmoSK6NCezjsOe3OCdXSW9rBckQSLA8kFGqUM4kDQc1EQFUBZxTYQsATxgW2HB1nlCFuNihhgQrw0qSVdLGHbZs6acJbEGx8WrgSn7XJMg835BY1IIDPr5RutyF14D18rr6TPhQZqQOu88g8iAqcc3hFdB9oz6UGsFkVlEd750EBy0MV3w4KaRAwbxe7OPDFgS8OfBM8Dnxx4IsDnyOqOPCtUSEOfHHgiwNfHPjiwBcHvlVl4cMGvn1CPheHX3mdn8iObmlCrvPjQ/3YP3yr6kNdVMf+8WdxP371NS8eHuv+4UuZ/3278FNVVo3B45+yPO9fAbte2dmjHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "637",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3131.4",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527549",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.41863998",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eQD5s0dRIVBB1KERxKh1ZDG4iJ1CiU0v9utLrdHc/dlSPkjTkNdw0ZHHxjCn0JtWutBgS5Ny48ICvHWUZkQRlWUvAVJQkWTCiYqj+47vt6iHQMtqa+6aB7yAgmCI7ataH7GEYkQ1D4UAfjHWQUJ5JIJTgTUi1TJQSCs7nOMJUkRbDXpu3C1zOuEOysfv3anGIpWBzceOvjmXtaO1VvZkKNp9QAAAA=",
    Pbi3DGeometry:
      "qScAAB+LCAAAAAAABADtWE1r20AQ/S97VszuStpdJafSFgrtIbSFHoIPDhGJwLWKqxZC8H+van3Y1ujth3xdQkKU55n3ZnY0s5mHN3b/WH1//VWyW/a5fqy+1dvqiSXsvq52zW92+/DW/drC/K79Yofk9Jcbwfnd8Uf7zQ7rwezdfr95bW1vhFwVWqWJ4PlKpzxPUrEyRonkiKQyv0SULuYRbXjmshFZdonIDPCcvE21aSVli6QrLrkAPCCeIBvM49QWlNHeG+ZpkdTIubxZ4xl4cpmm8+czIDQHI0JUU2/DmY425Ey9ec7icdvQ86Ha/G188oazE8xzdqaTvHnFo6Qq5uttSXZw9U54rDUKeLwivabiQ3ioNve7TXPgz0NPm8bjjpR6c3exQbWz83m9c0v66ESBl7aQjmTpsKLrSEoL03lTxjnNoA3mwZEOPVEZYy57ov8EpFOTersmHprRTKgOKdpK/4/oHLwLITbuWXJSLU0HaKOOQFYY15AZEZUVlwh0hjVjZVgApHE7o0XQO1M6PyrThcld9yNoMoSplDgq01o6r27Yxj166BiB0nACcK27pVEBOFBcNpZ7U/9O5UZ0KTAid9lgHlxRYJZbDwFrw94WxGO01P2Zcm1HxnI/IdPu4eNtWgdX8eQmFXabMTvEZkab02aGB0eKs7OAh9QbjgdXFVZgqx2EXJVrqtryBkNt0MZHgfeACTiEkNGHnRFlcMLhasMz3mLj5rFUKEkBnsswOUtEW66HCAloYfiV97rQQW3QxkcB4UGTOaDvetxAPDT7j3lLM1rSwDx4nCPO594EkxN3bnHnFvZ/Uty5xZ3bfPXGnVvcuQXd6uLOzXNqxp1b3LnFnVvcucWd21KeuHOLO7fA7MSdW9y5xZ1b3LnZUxC0c1sn7EO1+Vk25Z7d8hVP2Jdy99y89A9f62bTVPWuf/xRPY3Qp7J6fmn6h4/b8u/5B9/X27p1uPuz3R7W/wDlaC9PqScAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "639",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527551",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.08695626",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jHk0SamrkQFQRelCC5KF62GNhATqVEopf9uaHU3595zmXKEvDGX4akhg5NvTKFvoXat1YAg98aFF2TluJxRWVGGlRR8Q0mKU8Y5TNVf3PZ9PUQ7BntTP3TQPWQEEwRn7drQzcAEgsKHOhjvIKM4lUQqwZmQKlkrEduruS8upUnEozZtF2YmCUNwsPrzW3OKpWQUwc5bH3+5t7VT9QWlzTim0wAAAA==",
    Pbi3DGeometry:
      "rREAAB+LCAAAAAAABADtVtFqwjAU/Zc8x5ImbdPq09gGg+1BtsEexAfFooGuHa4biPjvC5rVaXvaJvg2EcV4vOfe3NucnMmWjOfqdfORkiF5LObqpcjUglAyLlRefpLhZHv4qmE20i+yo8dfBj5jo/2HfpPd9DfsZr2ebXTswOdeksQB9VnoBYnkVPhezDjdAzISJ4BMeKIR4TEmo9MQHvjNMXEYBrQ5TRDxVjarPKY2jYQBb94OBILQB1lqIYea8T5ba8ZsALFjYybEF4fthFyIPRCd9awCZARCZCxFF8LNPCu2amq2BWiEm810k5kCdIxIQruicZ6G2qTkrhVY5Tn24JytapvF88na+9mKQDK8TYzg8wka3RqD88CisRB1H+r6bDCC2eA8HQaNp4ZjYBoXtcHqjXUAIK1szdrRR1Tqg+4eZ129YRpQcutj23mz4jNQR5rJHMUbX7l4nDgGKyTsAD421j7B5Z52zGNrldyMCj7Sl3AqTqX18GoOtqO/hei0HY7q7eIhoK5ike6+Jy9jO/rnudqOq+242o6r7fg3tmNKyZ2avadluiZD5jFKntJ8Wa7M4rkoZ6UqcrN8U4sKekjVclWaxX2Wfv/9422RFZow/8qy3fQHKlDmXK0RAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "641",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "148782.1",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527553",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.61111371",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jEEKwjAURO/y1zEksTZaV6KCoItSBBeli1Q/aSAmUqNQSu9uaOtuZt5jyh7y2ly7F0IGZ1+bAu9BOW0RCOTeuPCGrOynGJUFF3QthdxytqKpSDcwVH9x17aqi3YcDkY9MWALGaOMwAWdDs1YREqg8EEF491Mb+YxQc6TSE9odBPGzhJB4GjxO+tLTqUUnMDeWx/P3cfaofoBe8AzfMQAAAA=",
    Pbi3DGeometry:
      "aBEAAB+LCAAAAAAABADtVlFrwjAQ/i95jiWJbZLqk2yDwfYg22AP4oNi0UDXDNcNRPzv61ztZtNr0rinUUQxd/3uu+Sau2+2R9Oletq9JmiE7vRSPepUrRBGU62y/A2NZvvvv4WbjIsPOuAfy4ASMj7+FF90mJ9gk+12sSuwA8oCGXKBKYkCTkKJhzSQhOFzB+Pxl0PELD73RHHEjxAW0maMjKIQN9OEnLlGs/OYufEwbt4NZI8kBThKhJEwvMmWhMFgkMMe67QVwU6Io5nTc3OVruCNACHF0NEuyhpWKXlTcyHjtlAmOedD0S1dmKN6fQS7mN3O0rD7Mlp1YO5vY73oLfSGxxoL3qThgW8ifMgOGJgHur9wx6nfLIe6GB57sHopPWrsUDEYA9J4NBajRzvcfMPjEK25W9TMcIUdygViIBJwPLWMmvrktLeXljsBBXNt0nB57aVqwQAssGoAB52HAPAYwV403SWQhwCBW7u/BPFJzOFg/BWFRSF00RRd2vQFIgHs3/BghcfkX+oKK0uvK3pd0euKXlf8U10xx+haLV6SPNmiEQkIRvdJts435eJB54tc6axcPqtV5bpN1HqTl4ubNPn4/eCVTnURMHtP08P8E67/7khoEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "642",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "69117.7",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527554",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.9665523",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPIo+kjrkQFQRelCC5KF1FDG4iJ1CiU0n83WrqbGc7M1COUV3MenhokHP3VVPoWlGutBgSlNy68QNbjLCNCSYo5Ecl6RTlOOMthahZw0/dqiHQMdkY9dNA9SIIJgpN2beh+hpGMIah8UMF4B5JjmlBRsFRwkRdZwSmCi7nPMM1IjuCgTduFv2e8QLC3+rO0Kc5SFge33vp45t7WTs0XCkuiUNQAAAA=",
    Pbi3DGeometry:
      "LycAAB+LCAAAAAAABADtWMFu2zAM/Red3UCyZMlOT8M2YMB2KLYBOxQ5pKjRGvDiIfMGFEX+fYHjJrXlJ9LuYRehaBH7hXwkRZEsb5/FzV31/elXKdbic3NXfWvq6l4k4qapdu1vsb59Pn08wvL6+CMOyeXNlZLyuvtz/BWHzYvYu/1++3SUVdKujCySK6VXRqd5otUqz61KBoCztgOsKyYBl0vDlCiM64DUTHP4qnqrnE3TAaDzYpoCuUEJIAa+SWQEPVWIQjtZTMZp7EQqVT5N4SETMmN7OdrGJ/gmHuzOOMZjkQnLKJFZQcOhmU/jnSZ0RsvMECz8yMB8xSwoL+noUxk7O8UZFKTnC8JLknj1AzsyX9XovWcvWdRICrYmzI0R/r32S6THkkndX1J3qjjW5uEuwxDh+6Kt00TPoprZxTBaF9+XQI1y0p0Q67IOcRlIfIbMjDZxOeesV5Yr1QGmGBvt9Q+jDUCgMobNuBnxaaAymAE600Nlrsiz8CiARbSRauCmcykxgGERuub7bYJ2xvMfJjrDGWiY16VxyuDObqUZ3CeXq4ySYfBghN91ObYtkfGzozidQaatCSN+Gzgj5wKJtb1kwVnmkgXzeVKrLFPmVXRGMv4IQMtceLCnODoLeM755sWN4Q/OtwkLYO5AZEmsAwi+Wdi2gAzJ40cUVn3+ITDaHrYZ09BdHGcbHnD8e4W7KHYUI1gbCs4So/FYFED4JQxfecYsF7Ag0BZJHr+I4omBX3g58we2OsBDDiBeAVlSwgI8/CbHGZvoGSiuzeLaLK7N4tosFOS4Notrs7g2i2uzuDYDk3Ncm6H/D+LaLK7N4tosrs2ImxXXZnFtFtdmcW1GyPzPtdkmER+q7c+yLfdiLVcyEV/K3UP72D98bdptWzW7/vFHdX+GPpXVw2PbP3ysy7+vv/i+qZujwt2fuj5s/gEFJQghLycAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "643",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527556",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.5793865",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMM2ST99SQqCHooRfBQeqga2kBMpEahlL67oaW3neEbthqhuOvr8FaQw9nddakevrGtUUCgcNr6D+TVuJyBIIspZ5huNyioFDyFqV7hru+bIehQHHTzUl71kDPKCFyUbX03Bx4TKJ1vvHYWckFRYpTxOBJRmiWZQAI3/Vwsogz4pHTb+TkzyQkcjfqta6RJwsNk74wLv+zXmKn+AwyGoerTAAAA",
    Pbi3DGeometry:
      "lhEAAB+LCAAAAAAABADtVl1PwjAU/S99Lku7j3aDJ6MmJvpA1MQHwgOEBZrMzcxpQgj/3QkDpfSwbvPNhUDozu49t729957Jhozn6nn9FpMhuc/m6ilL1IJQMs5UWryT4WSz/1vCbFR+yJb+PBlwxka7n/JLttOD2VWez9alLWfC4TKQdMA9x+dMUo87IXPpKeC54TcgIzfSEMbFzsT1udkmDAKfmml8ofNgb7U8htgCPzJvBwKi9G5mOZicx4z3iWPG3jBS763ajst4uAO8aG8h+OnzY8hSmC1kKD1bIKySeQirA7sfVhtBvs7pfdE4YsxyvErS7c5fT2M4AHF6Zk0upp78C/w6YuEMb1NHcGHic7axwTywmnFl6lVmkxsdsfEmUA1YJ9oma9gG0rRpM3rbtukBOmLjDZyZh/aip9kmZdAGsuChhQeQNk8tGs2F0kDOrHs2zrFNvrANpIFyAt++NtKgzWhuw9NCHbXQJrjTdxAnrUKrP5suSqNONzSRGg26diflANs5nrV4cP6p2Kil6cVGLzZ6sdGLjX8gNqaU3KjZa1zEORkyh1HyEKfLYlUtHrNiVqgsrZYvanGE7mK1XBXV4jaJP3+/eJ0lWekw/UiS7fQLM1/GyZYRAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "645",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3510",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527561",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.12053403",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyGc226dYoKgjqIBB3Ew6yhg7WFrUDE797EvL3f4/d41QhFY67DS4OEs29Mqe9BudZqQFB448IbZDUuMSqUYJqnfEsShnnKBUz16u36Xg1RjsXBqKcOugeZ4ATBRbs2dDMQzhiC0gcVjHcgKSYbwkTKGWW5yAQlCG7m8ZdTEfGkTduFhalAcLT6u64JzvJ5svfWxzP3sXaqf5gp18nTAAAA",
    Pbi3DGeometry:
      "nSMAAB+LCAAAAAAABADtWMFq3DAQ/Red3UWWLFvenEoTKKSH0BZ6CHvYEJMY3HXZuIUQ9t9r4pU3lv2skdNLExESYr2deTOj0cj7rp/Y1U35/fFXwdbssr4pv9VVecsidlWXu+aBra+fun9bmJ+1P+wQnVY+xJyfPf9pf9lhY8w+7vfbx9ZWxqskVTKKuVqlqY7aZy2SOBqsK5U/A0qKAaDyTE8C0CIVaQekiuhKaTUfVZYrC3CkMTKAFCYougXixukhClOpTMv5NESe60mOHrB34wQMoyV4srZvOQXOwiqtG3AWxKNSqCAwKEQBg7L3VWqRLkyc3J6QA7YhIUHUn/4dTeYgZG4B7upCDjxf4Mn0d2UBfbjUGUagIHpC1Gid0OmI2VqPRWIcxd2pTCYj7Wen04CWQSJkNn8pYcAOye2KmASqnlS5SYJ3jpJMzO4bMiCPZo97xMpaJrHyuy+gBUzDXXL8dkK2gBxcHcdKLvQgKgQQRrANQA7ye4uzuvBGlEoYQKdT7elPgbmpt5U7KG8De8PjOB0AOe+C7gHTuAawj9/IYOTJ7qnFFFJJNW9g6jGysINyW9gcMD8YrTfFqKX804AtdXI13SFw3b+0EMAjD3BjAyoFvbTOzXDOeuwKXmXUOw71GrrxCcyuo0RkgO8mYN05PuC5GwHwrkIhYQMqBX2mOadgT+6MauTq9Xfx8vmByWG470RtwV8D/WWYf6a2kEUV+hfjt6q2wLwXyzCvV1vIogpMI6gtQW0JasvU20BQW14mEdSWoLYEtSWoLUFtCWpLUFuC2hLUlv9PbdlE7Lzc/iyaYs/WfMUj9qXY3TX3x4evdbNtynp3fPxR3vbQ56K8u2+ODxdV8eflBz/VVd063P2uqsPmL4L1JTCdIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "649",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527562",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.06848502",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjksLwjAQhP/LnkNIm4e2nkQFQQ9FBA+lh4qhXYiJ1CiU0v9usPV187az3zAzeQfZEfftRUMKG3fEzJm2chYIZA6tv0Kad8MZDILRaST4LGKSKsU59OQDeUSFkn9AmTDxA79jB1i86udNU7ZhQ3gssTxrrxtIGWUEttpWvh7FzvnSY5g9yAOe3mitsar9U6hYElgZfR+9YdQkiRMCC2dcyLU3Y/riAUZmePMTAQAA",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABACdVlFLwzAQ/i95jiXtkthuT6KCoA9DBR/GHjpWtkBtpFZhjP53s9ppY/vRq4xuzX25777LXZKtjmy5Mc+Ht4zN2b3dmCebmy3jbGlNUb2z+er4/epgsXAfVvNfy0UoxKL5cg+r12e3q7JMD85XiiAO5YyHQgVaxSGfhUEcyZB7QKSTE3CZRIkPyMYei4jTiNr5UkeDAWKlpAeoROmJkmDssezowUdV9ai0kPFw5mfg7xKi/LzY7ldq1auFZ+4SeUB3PYY8miSGIpxyoDGNheiJgtnhtKFaGLxbCxLV/1X1Vx3VG6pFWwYVA82fXiQUATY5pXFo24XiQNM0uvHIXYA9EEA7QCAV7cgheZBUwd7s2GndDxygHR7mk7cRZKI40DSBO2/q8QvmAzPpVgNEk65mEbn/CDcmfc2qrGRzEQjOHrJiV+3bwaOt0srYoh2+mO0PdJeZ3b5qB7d59tmdeG1z6wiLjzyv11+lwvoK1QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.7 /",
    "Flow State": "Turbulent",
    Friction: "834924.19 /",
    "Friction Factor": "0.015233",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "2850",
    Mark: "288",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2379158.2",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "436924.4567",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "121",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "42.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527564",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.09869723",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyGU7e5dYoKgjqIBB3Ew6qhg7WFrUDE797EvL3f4/d49QjlzVyGlwYJJ38zlb4H5VqrAUHpjQtvkPW4xKjkOOeCb0hCMUuZgKlZtW3fqyG6sdgb9dRB9yATnCA4a9eGbgbCKEVQ+aCC8Q5khklOqEgZzWghuMgIgqt5/OVURDxq03Zh4UwgOFj9XdcE82Ke7Lz18cx9rJ2aHw6BuILSAAAA",
    Pbi3DGeometry:
      "NSIAAB+LCAAAAAAABADtWMFq20AQ/Zc9q2Yl7Uq7zqm0hUJ7CG2hh+CDQ0QiUK3iqoUQ/O8VseRIaz3NrJKTWUJC9Dx6+3Y0OyO/mydxfVv+ePxdiLX4Ut+W3+uqvBORuK7LXfNHrG+ejv+2H8ur9kccohfkXSzl1fOf9lccNv1t7/f77WN7r1rpLNFRLPUqy0yUxiuTqDgawlrbZ1ynyRDXNjdTOIrPkuyIZ5rFo42e1ZNbPcbn5bvhiL6Xw40Hy8JdAfo+O7lJ5+Sntg2b4D/hTvZf8JFMmmb8sJbSQ/XjZJI4lQV2dkAWkBxAj+Q4D1HlNl+0XWYNIn5UbPS+QBH6Fi2Tn97vGCfzifhhy0CHzpdnjJ908loSTc+iAasCmK5lsOgYlvakJT4eODU3C6hwjnKdSDM7UCDuiCF5WOJBwpTOevHyyKLyZOYpgXBug2WPgfFeVWoyn36P4pF8MsfwJYIZj/hl0nUKm5ihHoDTndTBET/37YLIJxpkStkeb288r0Ffergsb9CQcjzDnYcrjRnhVraBA7wvzg53j5Yb7tK4tbOMXmmZzYb3SXDjHTlkvMOPtoVketKflY6vfFQ6ffx0LSDYN5kIR/0LLAvbHZOem0wq+US7hjxoCDGHEygpMJ/JRYmDwmJHrxDTMNUS0JlycThmpsXAcCY9t0NRHa1fl9Jz1mBfOT0X9gS8LtB52c4F/Nbl62i8jXPBdCjYXz4vzLlAu13oaLzSuWA6FEh+cC6Cc8HoYMG5CM5FcC6CczGV/+BcTL1YB+ciOBfBuZjQE5yL4FxMrHuJzsUmEh/L7a+iKfZiLVcyEl+L3X3z0F18q5ttU9a77vJneXf66HNR3j803cWnqvg3DPxQV3VLuPtbVYfNf+aY0Yk1IgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "651",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527565",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.53014958",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjksLwjAQhP/LnkNIH6mmnkQFQQ9FBA+lh4qhDcSs1CiU0v/uYuvr5G1nv2Fm8g6yo9m3Fw0pbPBoMrRthQ4YZGicv0Kad8NJhijgoVLTWSAkT5Iogp59YMxlEsq/TCoR/7Dv0AEWr/J505QtLaDH0pRn7XUDqeCCwVa7ytej2KEvvaHRgzyY0xuttalq/xQ0gMHK6vvopd6JChWDBVqkXHezti8e5cYixREBAAA=",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACdVd9LwzAQ/l/yHEsak5p2T6KCoA9DBR/GHjpWtkBtpEZhjP7vZrVzaZej11HWLt/dfffd5ddiT+Yr/bb7LEhGnsxKv5pSrwklc6Mr+0Wyxf7vrzOzmXtIQ0/IVczYrH25H2mWx7Dbus53LvY6jniaKhozGSVSxdQBiov2ezLwJD0ANylP+wbRjhXjFEfU+YuEBxMoKUXPIFOZTJQE5h6rDp98VNUZVcKECld+NAxbCNXXyy0imXA5nAof9Wl83G9GwL8tIMB+kI+hGaEfyoGKAouFZEJ5/fYjeC7Vc9ZmaHYhndD+ANoPuU+dFoAeXM2IVYLbFpgAlKLR/YWcedAfwHFnBESEO1RQERhN4HL0cMxqD7tDMHhST900IBEmAKUIuM6mHa1h7zCKuqzCNJMuXMbdzX+v84/CFjXJWMQoeS6qjd12gxdjc6tN1Q3f9frf9FjozdZ2g4ey+PEd70xpHGH1XZbN8hdDAHGOqwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.9 /",
    "Flow State": "Turbulent",
    Friction: "695694.13 /",
    "Friction Factor": "0.015394",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "8150",
    Mark: "289",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5669594.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "396747.4952",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "120",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "38.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527569",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.74577539",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jE0LgkAURf/LW0/DfFiaraKCoBYiQQtxMdpDB6aZsCkQ8b83pe3uvedwiwGySl/6B0IKJ1fpHGuvbGMQCGROW/+EtBimGJRlRHm0WXBJIykSGMu/te061Qc1DHut7uixg5RRRuCMtvHttwgWCwK588prZ2d81beJ8pglBI6om9b/upBrAgeD71mXnMYrER52zrjwbl/GjOUHJQbzDcIAAAA=",
    Pbi3DGeometry:
      "oSUAAB+LCAAAAAAABADtWE1r3DAQ/S86O4vkD0nenEpbKLSH0BZ6CHvYEJMY3HXZuoUQ9r/X9TreWvLzjMipIEJC7Kd58+HRzDC3z+Lmrv769KMSW/Gxvau/tE19LxJx09aH7qfY3j6f/+1hed3/iFNyeXOlpLwe/vS/4rR7EXtzPO6fetki38hM58mVyjZ5ltokUxuj0zSZAUbrAbAyXwSsNiVToszNIJHmikk1WmWtnktktlxWgdygBJAGvklkBD0qpCIzslyMk+NEmmd6UYMH+BKOsQwq5+O9Qgd0wwmtK+DbRAgEBArGI1SF+/GQE2o5nYKDARMTKEDZRwabysrgNCY1kC4HhpTi94oD9iCYaf5ehVUrkp5LBPSC1+wL65c8FygLNV5AY85UqlhvGrQEzwnZCxLdh2pLk000FdcLGEJleuoB0KYYAJMuJTd5nl/qp+SwNjsDVqkBKK1jrNsDpCoXAUjFMBe2E64OSIW/eKnMjMrmpV3v4UhCySKbOWhNsT43QQmqgHsA7YXrN0pohhfQKrfFohyBTVn1ds8ujdXarrdxWgcEeF2TYVO4hJdTOh2A4m8s1wCnnE+vp2qLiF6+9wRMFyBMg7KZ5Zy/BMM577Rs8vyloALXkKGB/FMmuRGiPAB55CsGWYGB0IgiYKVYo0zFEpQOP3yoWLMDTrcpWAWgDqLZgmwCk4d3GrJj1xCAqVCjDTIVT1sI4JYeeHHpoQrahCUoHX7dQy2TXSnJiQCbi3RQE4FXC8JKEOzt7P5Dji6MUSTum+K+aZUq7ptYKuK+Ke6b4r4p7pvivmlxDI77prhvivsmkFNx3xT3TXHfFPdNcd+0alPcN/2X+6ZdIt7V++9VVx3FVm5kIj5Vh4fucXz43Hb7rm4P4+O3+n6CPlT1w2M3Prxvqt//HnzbNm1PePjVNKfdH3thgpyhJQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "655",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527570",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.57414678",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkTZuSehIVBD0UETyUHloMaSAmUqNQSt/dYOvfydvOfsPMFD3ktT50FwkZbF2tc2c65SwgyJ22/gpZ0Y9nMHBM0yiZzyjDMRcMBvRhSYwJJfF/yAT/hV+pIytf5Yu2rbqwIDxWujpLL1vICCYIdtIq30xi73zldRg9yqM+vdFGatX4p+BRgmBt5H3yMopTEQkES2dcyLU3Y4byAa2Rqf0RAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACdVt9LwzAQ/l/ynJUkTX/uSVQQ9GGo4MPYw8bCFqiN1CiM0f/drLaa0h69jtGt+e7uu++SS7L1max2+vX0oUhOHs1Ov5hC7wklK6NL+0ny9fn31ZnZ0n1ITf+RBWds2Xy5h9SbLuymqrYnFxsHPBERXfAwkLHkNORBKtyvj4civeBJJrIeHsms8WeCYmg6dxmLMfo0imQPZzyeJQfKO1EWOu+EngEPZ8lovR3ORqdhUJafNpIB40wOpr+H+0Q9gz8RYxFNBaMpLiXgqKZyDFWB9YEGUC6Y3F8KHNXVqoYFAusNioX2CbgYUMD8RQJTQD2O6hzMZsH4oxRN7Tp8C4ARoAFzcoBMmKMG449SBPSkB+OaHgqAcOiQm7t5IB6EO0oPcLXNPnKhAAjH3GEQ0Zw7mAn3T+BOb9+VVRXJWcAoeVLlwR7bwbOxW6tN2Q7f9P7P9KD04WjbwX2hvn3HW1MYR1h+FUW9+QGLDhw3uwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "2.4 /",
    "Flow State": "Turbulent",
    Friction: "75915.41 /",
    "Friction Factor": "0.018201",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "14581",
    Mark: "290",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1106920.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "120530.8846",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "104",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "11.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527571",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.25977928",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUMefblSlQQdFGK4KJ0ETW0gZhIjUIp/XdDS3dzL+cy9Qjl3VyHt4YCzv5uKv0IyrVWA4LSGxc+UNTjckYiBSY8EdsN5VhwlsHUrG7X92qIOBYHo1466B4KggmCi3Zt6ObAEgSVDyoY76DgmAoqc5ZILrM8zTlFcDPPxVIqIj5p03ZhzkQwBEerf+ua4jRlcbL31sdf7mvt1PwBRVYHFNIAAAA=",
    Pbi3DGeometry:
      "5BAAAB+LCAAAAAAABADtVk1Lw0AQ/S973obdfKc9iQqCHooKHkoPLQ3tQkykRqGU/ndDTNRu8zq70YsQSj82r/PezM7uzMz2bLpUj7uXlI3ZbbFUD0WmVoyzaaHy8pWNZ/vPnxUsJtWLHfj3k5EUYlJ/VG92mLdmF9vtYlfZBr4jpPD5SHqOH/gJ96QT+6HLjwDPjWsgCPxjIPRlDbjVd5dFlLgJ79QQriETJXHqlBRRdxgQEDLs1mgtdG9heNBbxISek0RtEF7YWiR1EFEcecdA62zkyk6LODR8Hje5a33qL+3FTRSIStf27FzF/O2picD2GQqTAqcha3tkfvj0TEPtE4CmMgoaXjm4q6QFUoBXFN447QLRp14HKCY9cdYJpdMDLZCEddXQyi59pXWAZII1QAdgSukMQQuogdoNbB56D6QLBzz7kMqw7sKs0kmCFkgCtn500qz7uHUrtVawH1/sRwhYrPuOED2cojbkFxMB1eHNRwLj8tu3w6OqDJsj4P+rgeA8/TAODOPAMA4M48D/GwfmnF2pxXNapls2Fo7g7C7N1+WmWdwX5aJURd4sn9TqC7pJ1XpTNovrLH3/+cfLIisqwvwtyw7zDzTwJkjkEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "656",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "7897.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527572",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.6683473",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jMsKwjAURP/lrmNoHrZSV6KCoItSBBeli1QvaSAmUqNQSv/d0NbdzJzDVAMUjbn2L4Qczr4xJd6DctoiECi8ceENeTXMMSprSbkU6XbFBJWCb2Cs/96u61Qf5TgcjHpiwA7yhCYELuh0aKfCUwKlDyoY7xZ6M48ZMiYjPaHRbZh6IjmBo8XvogtGs4wzAntvfTx3H2vH+gezKi1jwwAAAA==",
    Pbi3DGeometry:
      "4hAAAB+LCAAAAAAABADtVlFrgzAQ/i95TiVqjNo+jW0w2B7KNthD6UNLpQ04HZ0blNL/PrHarakfZ6QvA5FKc+d9310uubvZnk2X+nX3kbAxe8yX+iVP9YpxNs11Vnyy8Wx//FuqxaR82IH/SkauEJPqVf7YYd6Y3Wy3i11pG0jHU7HiI9d3pCtC7rtOJJXHzxS+F1WKIJDnCuGqSuFJt9UijL2Yt3IIryMSRXHpVCDj9jCgQpXYrRyNhektDA96i5CQnARqgpD+UeHHlUEYhf6Z/ORr6LltBpHqJo7qxDUO9eaVUR0BQDKZpbJyFMKfDkzYvnNdeUmCy4iVsUfdD56ZZUxuKmgoFJ8hhxcObixtgSjgDYUXzrg/dC5MBYlkJs8+q3SOoAXksK4bRuGl77WpIJHAPplymFM6RcgCUqBuA3uH2QLJ4oEPP4LqVndhQun8QAvAANs+OmPWPdy6jVoz2I8u9uMDLNZ9x4ceTlEb0n8aIPp753mge+Xt2+BhQYa9EXW6a00EBP4wEAwDwTAQDAPBPxwI5pzd6cV7UiRbNhaO4OwpydbFpl4858Wi0HlWL9/06qR6SPR6U9SL+zT5/vvhbZ7mJWD2laaH+Q93kA224hAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "657",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "9015",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527574",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.94362695",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv15jbuLUrqKCoC5Egi7Ei1k/Olhb2ApEfPdW2t055/s41QhFo8/DAyGHo2t0iVevbGsQCBROW/+EvBrnGJSEsphn61UkaCx4ClP91zZ9r4bghmGn1R099pAzygic0La++xbOJCdQOq+8dnbBF32baSRZSuCAuu38r3OREdgbfC+6iKhMeHjYOuPCu30ZM9UfJlJ3jsMAAAA=",
    Pbi3DGeometry:
      "cSQAAB+LCAAAAAAABADtWF1r2zAU/S96do1ky/pIn8o2GGwPZRvsoeQhpaY1ePHIvEEp+e/z8jVb1pGu21cREuKT45Oj66t7xb17Ybf3zbfnnzVbsU/dffO1a5sHlrHbrtn2v9jq7uX4dfiZXw8vts/+I1eC8+vDx/Bm+/X5tpvdbvM83FvltrRldiXKXJaFyUqRa1UU2RjXSh1ww6UPN0pbEt9KfeAXUpB0Tn6MURN+aaxXHtiP0IE61UwsaK4OkC81t77YjM2rXEhVzdU9+Iw/dknRGT+qN+gj++NgzukzN2E6OTgoCMvkJ48KmueysEF1SgxQ/iF5kGfxCEfSb2G2BtXjS10YyIi6u++h94Uyk+SYmQwVobg4TcX/pxin7spZKXNwa07bTOujjKhC5T9Gp5gf+EaEm0ikuZzdxGQI5nFJ4VqrI650dcB14c3hCJ9ct8+ZYEVxxI0QB9yaqU+nnnNpfDjSiftEfYGm79cJPF0r1UTHyOFBBbqvlz/44aaYrMvoCh9xEJ9QjV086t9Zry9rKfaRHadDgnRAHZUbPd0WRikT6sBRfYRTmh7Fz1K+mz72GP+qVDKEu4X5gp8rJ9AxDnzO8iXy/5alNIl/CYPDdztujH8pkr5lBXwu0h+lzyQ+BP8ofWb/608HiC+NJ8BhFUbpCfkRfTduqApT4xzrOmi7I/1Y10T5g44OLh/po3UhHOmgrrnIJz4p+c8g5CKDdmnkRATMIHZYfFbZQP8jFsJgW8cmfeqEpu5u86XlBXVpalcJHj4oh4k01xFprkM64KW5TprrROhprpPmOmmuk+Y6aa7jwdNcJ811RjpprpPmOuN1pblOmuukuU6a67x+rrPO2Ptm86Pu6x1b8Zxn7HO9feyfThdfun7TN932dPm9ebj89LFuHp/608WHtv4zJr7r2m4Q3P5u2/36L+LrmelxJAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "659",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527575",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.40710197",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2loGhtJPRUVBD0UETyUHloM7UJMpEahlL67wda/k7ed/YaZyXvIKjx0FwUJbG2FmdVdbQ0QyCwad4Uk78fTGwJBpQzZImCczoTkMJAPjKlknP9lXIpf9h06wuJVnrZt2fkF/rHC8qycaiEJaUhgp0ztmknsrSsd+tGjPOLpjTYK68Y9hYhiAmut7pOXMzqXkSSwtNr6XHPTeigebEIpAREBAAA=",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACdVltPgzAU/i99BtJyG2xPRk1M9GFREx+WPbCs2ZogNYgmy8J/t0PQInzhYAiXnst3vtNz2rI5s/VOPZ/eJFuye71TTzpXe+awtVZF9c6Wm/P3p1HzlblY7fxKXMH5qnmYm9Xbzu2qLLOT8XVjL025cFwReGEcCicQXuKbd08R+MlFsUj9tK+IwrTx4L5DQ+ocwtgfDZFEUdhXcBHPJAWDT+U3I/gUqyGU4IvxzDvF3zmE+dmxIy8VQTAohi22cWy5PRsj9k0GY/CXBCg4E/gDPigtJEc8UVy7ABScf/IZ5IXqi3jCJYIKAB3mVgYFgD1NaRXa6iB5kDhNrjNq/ZE9kpP2CgRE21xIHiROqCktOaXngTkQwx1t7tKBQBQHEiN0sM3cY4E5EJMOLoAz7/jlvvkTuFHZq6xkyZbc4w57kMWhOraDR11lldJFO3xR+x/VnVSHY9UObnP5aRte61wbwOIjz+vtFzkd2BC7CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.2 /",
    "Flow State": "Turbulent",
    Friction: "128813.34 /",
    "Friction Factor": "0.017372",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "3933",
    Mark: "291",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "506615.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "160707.8461",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "107",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "15.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527576",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.84051077",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/XcP/U2VNUENSDSNCD+LBq6GBtYSsQ8bs3FN/uOfwOtx6hvJvr8NZQwNnfTaUfQbnWakBQeuPCB4p6XM5IBJZMsu2GMMwZzWFqVrbrezVEG4uDUS8ddA9FghMEF+3a0M2BpggqH1Qw3kHBMOFESJoKJnKZSUYQ3MxzsYTwiE/atF2Yc8IpgqPVv3VNcJbRONl76+Mv97V2av7eitnB0QAAAA==",
    Pbi3DGeometry:
      "PBAAAB+LCAAAAAAABADtV11rwjAU/S95riVp+qlPYxsMtgfZBnsQHxSLBrp2dN1AxP++0qWbrTkmKYO9FNGa09uTm/t1dHEg87V43r+lZErui7V4KjKxIQ6ZFyKv3sl0cfj+Wt+ms/pFjs4vMmGUzpqP+k2Oy/axq7Jc7etnAzdhnDsTxl0/8BOHMzf2Q885xbkXN3gQ+B089FmDe/VVYR8lXuKo+KlnRKOhP3OH0UjpPsIpC5X8rT1VRuHsVMhNQANgHYt0nietfdI4H8UR7+Ctl5HHVPZxaATHMlPSm6G78lh6D3h623IbHyF3Wx6ROmJGe+rIzw7ajYtxifWyirbt41oeg6OidkJx1NkDdtR8qJu67aEt6x6uoeHq8jXMnjYbyB7QW06C7vTUtmoP19Ggzg6B8738aROC7BE/0Ao0+3vSpR0GqLgRj9H4RCnU5gTZA3qk06CgLGXXUv4s2W1/Y9iKPZq4w8Te2p3LURis3ho9NpVvwyk6TI/BbEWSpub+E/G+SD1K9yjdo3SP0v3v0l3/Fb8Rq9e0SksypS51yEOab6udXDwW1aoSRS6XL2Lzc+suFdtdJRe3Wfp5anhdZEVNmH9k2XH5BUHMsHI8EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "660",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "14040.2",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527577",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.80949029",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jFELgjAUhf/LfV7DTZthT1FBUA8iQQ/iw6yLDtYWdgtE/O8NtbdzzvdxygHy2lz7F0IGZ1+bAu+kXWMRGOTeOHpDVg5zDIriIlHr7UrEPInlBsbqr+26TvfBDcPB6CcSdpBFPGJwQddQOxWpGBSeNBnvFnozjxmK8MzghKZpaepRIhkcLX4XPRY8TaVgsPfWh3P3sXasfirHrsXCAAAA",
    Pbi3DGeometry:
      "OhAAAB+LCAAAAAAABADtV11rgzAU/S95tpJojNo+jW0w2B7KNthD6UNLpQ04HZ0blNL/PrG2qzbHJDLYixRLc7ye3NyvU2d7Ml3K191HQsbkMV/KlzyVK+KQaS6z4pOMZ/vjz/I2nZQfcnB+kRGjdFJ9lRc5zE+P3Wy3i135rHBZ6AXOiPkuZzR0fOZGXHjOJe57UYUHAW/glIkK9zhT2YexFzsqfuoZ0Wjor9wJeKx0H+Gi5FXxn+ypMgpXp0JuAhoA61hq57k44n5cmYdR6F/CZydDjynMI2GCRnWaald6bsmj2nM1TWtTLiw8RNTnygiVwTLbUkd+dU7RjItxebUyCvdt4VoecKwmjJoJhVJrD+hR76FmanaHNvYtXEcjQAkbplCbEmSP+C1nQXN+avu1heto1LHxgeutBGozAuwRPZAKNPpbyqUbCLC6AY/J+ETZ06YD2avZkUaDUrKUXEvps2S3/X9hK/Ro4vYTemt3uqPQV7m71dhQu00HaD85RmMVKRpQqD9R727uQbwH8R7EexDv/xfv8kX8Ti7ekyLZkjF1qUOekmxdbOrFc14sCpln9fJNrs63HhK53hT14j5Nvi8Nb/M0LwmzrzQ9zH8ARMXdhToQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "661",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "20283.7",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527579",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.81661658",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NI0zZp4iQqCDqUIjiUDlFDG4iJ1CiU0nc3Wt3uju/u6hHKszkOdw0S9v5sKn0JyrVWA4LSGxceIOtxlhFZJBQLztJlhnNCYWr+1Krv1RDRGGyMuumge5AEEwQH7drQfQwlnCKofFDBeAcywTknXLCUMi6yQjCG4GSuM5xwUiDYadN24etpKhBsrX792mmCOaNxcO2tj2fuae3UvAErI9w20QAAAA==",
    Pbi3DGeometry:
      "USQAAB+LCAAAAAAABADtWFFr2zAQ/i96doJkS7KdPo21MNgeyjbYQ8lDSk1ryOKReYNS8t/n2K6TSPpOctijCA31+cun706nO3EPb+z+sf7++qtiK/a5eay/Ndv6iSXsvql37W+2engb/u1e85vuww7JybIQnN/0X90fO6zff/Zhv9+8dr9diHRZ5jpL5FJzpZNMLHOdpslCZEuecnFuL7h02QudlzQ+K9JzfCoFwWPpKQotBnuWKpsf6Q/GI36/nrC4nXgQv5DSjg/SP/FnZaFc8X+3m/5OdkOnzTPs12Q39iuQf9Lvw5vxN/QE4z3xIXTO4p/2y4iPV7/iqSt95oYBpaFFj7IN0dNeXZu1ofy2Hvo0Wu6G0ZubaMun3bJ56CIzyvTXJPqszK1t1rKkmvATDSueOFYMJfOBRihPA3HACV9d4qcypbS8rFJh3cbsThbNVdrtGiuOLFLnPXuep64kDkT7CviZRqmPPCobRB7fk4V9sEvZ0V3GAPC4ZBJyYD8B9DSPY2d7HqX4sIWyLDz3FIDv3VKZ7uUUufJcd1xwX7U3qjchBjkL0pUU41gV+AQzAV05+tMgVT7gtS5oPOJ3pgjRI11BRnIQzRXy87LsD78qKPspY0e7ecw9NObeXsXeoTMCforBJdwSQ8MtduQTCME8djtvnOJxfoBVYRoA+1WRtO3wsIFlEd6zbnBZDwtyaJuBPJYdtBNX5uDWCfKM5IZ5ZtlRx3NFYLZGdHtym4NqCjqX/muPe1GA9ixqkYNeF1T3/P2bFhnSMcHZnl1QaG5P+6BvGMj/OMeJc5w4xwnnj3OcOMeJc5w4x4lznDjHseFxjhNytYhznDjHiXOcOMeJc5w4x4lznP8wx1kn7Lbe/Kzaas9WfMkT9qXaPbcv48PXpt20dbMbH3/UT9OrT1X9/NKOD3fb6u858GOzbTrC3Z/t9rD+B78RyJhRJAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "663",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527580",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.0739067",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzE0SX9MPYkKgh6KCB5KDxVDG4hZqVEope9usLUHEW87+w0zk3eQnfWxvSlIYYdnnaFpK7RAIENt3R3SvBtOb5gxQQPG54uIURmGMfTkBwxpLFjyxTiVQv5nU2jxKV82Tdn6Bf6x1uVVOdVAGtCAwF7ZytWjOKArnfajB3nSlwltla5q9xYxjwhsjHqOXsFoIrkksEKDPtc+jOmLF/3eMpgRAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACVVlFrgzAQ/i95TiWJUat9GttgsD2UbbCH0oeWShtwZjg3KMX/vrRzq9HLGRHF3OW+++7OfLg6keVWvR4/cpKRR71VL7pQO0LJUquy/iTZ6vT7atxsYS7S0KtlxhlbXB7mJs36L+ymqjZHEzvjIkiTOKQRD1IpYxryYB5Fks54GDCWxJZDSE4vEelcWg4ZC4pAGUckBRwhIw7n6EElqUhHWDmTOx0Tk2MOJ1S/cibgHl7sE8q7pj4jySAOedJpbYvUsVtAHbvVDWj/uYIBPoID2r352L2G7C6eLj49/kxMgRmhg5TVG8vofMExYocNm/swgz9TrwGD5wkDcgZMExJsyCCS0+H5uVhAkN31HaGK4ALykpDxCOwoQ2LksntKAoNbxMBOe4gpguPcD9FHZRxiBIoyYsdwgAIQSRh0eYJUeEmLTd/8CdypzXte5xXJWMAoecrLfX1oF8+63tRKl+3yTe3+XQ+52h/qdnFf5N/djbe60Aaw/CqKZv0Ddzwsx7sIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.2 /",
    "Flow State": "Turbulent",
    Friction: "317168.29 /",
    "Friction Factor": "0.016198",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "14421",
    Mark: "292",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4573876",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "261150.25",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "112",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "25.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527581",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.77258925",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm3Nr9hQVBPUgEvQgPmgNHawtbAUi/veG1tv9zvkOtxwhb8xleGrI4OQbU+hbqF1rNSDIvXHhBVk5LmdUVpRhJUWy4ViQVMBU/bVt39dDdGOwN/VDB91DRjBBcNauDd0MTCAofKiD8Q4yilNJpBIJE1LxtRKxvZr74lLKIx61abswM+EMwcHqz2+dUCwlowh23vr4y72tnaovT0ENMdEAAAA=",
    Pbi3DGeometry:
      "URAAAB+LCAAAAAAABADtV11rwjAU/S95riVJv/VpbIPB9iDbYA/ig2LRQNcM1w1E/O8Lbf1ac9JGX3woojSntycnubn31MmWjOfiffOVkiF5lnPxJjOxIA4ZS5EX32Q42VaX6jYdqQ/ZOUdkwCgdlT/qS3bT/WN36/Vso54dMO4mSew7vht6LHI85sZ+yJ0Sj0LvFA8CX+GeS2kUnuLcZ7r4KOGJo+On3EDTmb6Wo/DA51r5CPcDpuX/F0+1u1CvyiAT0Ojg7iyVeBXPvFI8DcJSTRx5Zyr3eMSZLj4OzTCvMrWHDymxmlXhvFLfwlNNq8K9JOgqEpE3xMSRfsuMk3ZmPy71nOa4NR1P2eFUonkRjnjAsgCMakq7l4Z4QI9Eok5hLsHG3iMc0KBU2aYQpQTFI37LlgDaKKpZLY5ptCXeXvqNFLbkqtFGEb9OpuEAtngYOsgNXMtj3UeRtaFcoXjQutBiwbm38V9LH7Rnt3rZuMD1URFe5frWctrecWxtvJsxm338gkZqZ8yoz6F+afakK328E3lv472N9zbe2/it2Lj6f/4gZp9pka7JkLrUIS9pvixW9eBVFrNCyLwefojF4dZTKparoh48ZunvaeC9zKQizH+ybDf9A/kOIkpREAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "664",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "37074.9",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527582",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.20143331",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm7o5e4oKgnoQCXoQH1YNHawtbAUi/veG1tv9zvkOtx6hvJrz8NRQwNFfTaVvQbnWakBQeuPCC4p6XM6orCjDUvBkneJE5hlMzV/b9L0aohuDnVEPHXQPBcEEwUm7NnQzMI6g8kEF4x0UFGeCCMkTxoVMc8ljezH3xaU0jXjQpu3CzCRlCPZWf37rhGIhGEWw9dbHX+5t7dR8AeY7WjDRAAAA",
    Pbi3DGeometry:
      "URAAAB+LCAAAAAAABADtV81rwjAc/V9yriVJ0y89jW0w2A6yDXYQD4pFA107XDcQ8X9fZmura17a4GWHIop9/fXl5feRp7M9mS7l6+4jIWPymC/lS57KFXHINJdZ8UnGs335Vd2mE/UiB6dBRozSyfFDvclhfnrsZrtd7NSzI8bd2BfcEa4XcuF4zI1EwJ0jHgbeOe77osSFz85xLpguPox57Oj4KTfT9KNv5MSR0MrX4p5LaRho+f/EU20Wml0hmYAGwD1Z6k15sf+Lx5F/VBOF3oXKEx5ypouPAjPMy0qd4FqN1aoqxbxU38FTLqvCmcf6ijSQX4qJQn3KjIv2Zm+2eklTpaZ/l9VdqV3XoAfxgG2BFKOZQrnUxmN61MVopswj2GpuhOtoDKWyKqGhVChey29/JIBjFM0swgENGvGO0W+VsKNWrXjED2Sihu3wMNTILRzx2J2jqISoJige0CORoKEs/dfSBy3ZbX9sWLm+YQivcn1rOV1ZsLXxfsbc6eNWB6m1MaNzFJ2XZk+60sd7kQ82Ptj4YOODjf8XG1f/z+/k4j0pki0ZU5c65CnJ1sWmunjOi0Uh86y6fJOr+tZDIteborq4T5Pv88DbPM0VYfaVpof5D+4fx31REAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "665",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "68175.7",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527584",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.36731005",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1zFELgjAQwPHvcs9zuK2l2VNUENSDSNCD+DDt0MHawlYg4ndvlb3d3f/HlSPktT4Pd4QMjq7WBTZe2dYgEMidtv4BWTn+xkCihEou5Dpigi4ET2Gq/m7T92oIOBx2Wt3QYw9ZTGMCJ7St7z4LW0pJoHBeee3snC/6Ole+YgQOqNvOf1vKOYG9wdfMBaNJKoLZOuPCd/s0Zqregn31Z8QAAAA=",
    Pbi3DGeometry:
      "0SMAAB+LCAAAAAAABADtWMFq20AQ/Zc9y2al3ZW0zqm0hUJ7CG2hh+CDQ0QiUK3iqoUQ/O8VsSw7u3qa2SSXtouJiTR+82ZGszP2u3oQl9f11/sflViJj+11/aVt6huRiMu23nY/xerq4fBvb5YX/Uvsk9OdRSrlxeNb/yf26yPszW63ue+xi2KZyzxLFqlaapWViUqXZW76G+cGqQ4Go6YNhTUpD6FsWjwaMj2N8F0NURWlcgx5aqejgnlQCMgREBVVRN8V5CiUna6Vk4fWspjk8Aw+wgmXduU+wZdwwDyc6jIM0JVTXUatYLgUue8KRuU8WpMp88LMyRaFHLATGQlSLRre1CQHI3PHwKguxeGPDJhHuCvH4IVLDjIGB9cVJIcG/nH2yV0Oo9TxcB48ZXp2r9AAbhYm1/n8hiJX1xgU6YqbBqygkVIPADt4Kon8EIK/CuC68QzejigzHbg8EAJnzq66Ny/YCMhhdG6eRFVYSRjoaezOb+SK8aXE3XXs5zEirCrOO7S/b+cBJAXm5i4uOqhggPvATXagVqav9ZzBm5+jYZxtyNXYVEfEsamCObTVmoc4VcRBeDuTRJyGGEoQliSY49RVTq3oPGBX+eSgScD98NpiAzw0KCYMICncCrJLS85oflRj78CpTi462FRw9XsIuBrJ48TnABse3mePEXj8yK8jkBsDSAp3hLFnG71i2VGNrp6/lN2jHD5FMAcK9//TYeAPtwCB5hV1GK7cwvjJ+s/rMDDzcIHm9XUYUm6BeUQdJuowUYeJOkzUYaIOE3WYqMNEHSbqME/TizpM1GHmh0LUYf5eHWadiHf15nvVVTuxkkuZiE/V9ra7Gy4+t92mq9vtcPmtvhlNH6r69q4bLt431e/zD75tm7Z3uP3VNPv1H6avbvnRIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "667",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527585",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.02466474",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjrEKwjAURf/lzWloEk1NnUQFQYcggkPp0GJoAzGRGoVS+u8GW6W4uL37zuVysg5kqU/tTUEKe1dq6UxbOQsIpNPW3yHNuuEMhYhQLAhbLCPC8IwLBj2a0ATzmNP/kAn+A6e7A80/AqumKdpgER4bXVyVVw2kMY4RHJStfD2Go/OF10F8iGd9+aKd0lXt34HTOYKtUc+xywhOBBUI1s64sGsfxvT5C5WwpbYVAQAA",
    Pbi3DGeometry:
      "DwkAAB+LCAAAAAAABACdVstqwzAQ/BedbSP5bedU2kKhPYS20EPIwSEmEbhWcd1CCP73qo7d+jV4HUIe0nhmZ7VaKZszW+/k6+kjZTF7VDv5ojK5ZwZbK5mXnyzenC8/NcxX+sUq43/GFJyv6g/9ZtW2pd0URXLSXFPYViSc0DCFY7m+KwxHWKGtv/uIY4e/SBDZ0QDx3KjmcNugirUU1x9ymjCh57kDhAt/sTXsYDbRRQ5mvU2oCR6ANWiR0YLiRHsGAsvnteigON35nlQX6C3MBOOSyVSIOhGS1FyMsSuYHwSgXRi8VxCS1NWuxgnCmkO7uIdgQTBlealgELzjaTuI2D5EDs3ZfC/SNwVkQIB4rkAt4lFE5NCcwf3aBUgtgQhoHh+Cy5sLa9EoNF/wglx8OCMCmifef0hq4W3Obf3v4k4m72mZFizmFjfYU5ofymMzeFZlUkqVN8M3uf+DHlJ5OJbN4D5Lv7sP3qpMacH8K8uq7Q+WSJfkDwkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "232318.90 /",
    "Friction Factor": "0.016571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "1618",
    Mark: "293",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "375833.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "220973.2884",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "109",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527587",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.28841555",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NI0zZp4iQqCDqUIjiUDlFDG4iJ1CiU0nc3Wt3uju/u6hHKszkOdw0S9v5sKn0JyrVWA4LSGxceIOtxlhFZJBQLztJlTjHhGYWp+XOrvldDhGOwMeqmg+5BEkwQHLRrQ/cxlHCKoPJBBeMdyATnnHDBUsq4yArBGIKTuc5wwkmBYKdN24Wvp6lAsLX69WunCeaMxsG1tz6euae1U/MG6nLKFtMAAAA=",
    Pbi3DGeometry:
      "EyYAAB+LCAAAAAAABADtWE1r20AQ/S97lsXu6mvlnEJaKLSH0BZ6CD44RCQC1yquWgjB/71CsitbO29npVyXkBBrPPPezI7mLfPwJu4f6++vvyqxFp+bx/pbs6ufRCTum3rf/hbrh7fh384sb7ofcYzGJysl5U3/p/sVx83Z7fZw2L52viul47LIkyjTsSoKEyUqLnKto5VKYqmlujIYmZIGkxcl45EYfeWhU+UKZbMyJleDIdEZgQHzmOEBMTxY+RZxDAUxVJoStYJ5nDFUR0LmxHmMhknmF4ZrulSo/gQvDNcn6I9xzsPDY3IeFqsZHlytXHRnYpxP0KoVm4eOZZFqoq/ml8TRojYG7ESI4U7wPU3ti0Gx4t5aO3NfjMnRUnm4E6RCcWPpTNdjkLnfqCUz0QZ3s5o1APCwVINMqFINoVTGSRHp4cqczuNCo5JcX084X/Gy5c4KtTAPalKrPpJMyqx/Xmi62T0dPLTggmya96F0VvaG0mSMSJwKIpVOJgVBoUi2LlJYoBCEOxR54EMopXXPyqSl4W5EyGPIT0nTkzJFxt2tSAdWOiwhcHGCecN+ZkgR2Cg93CHwcjO8MlKXg0eeG8YDYtC945JfuuqQFQy1KI+iLIdhYVzPx34+PbdHAhfIOu+lCDLpvunyGMsx8bBIsR4WBkoPs50NYbcUnYarcyA4bhBkWF5cy4DfSwQOPVhwf3XwLbuvZrlCWQYkTXRbuSQZNiIHAfvQMkAdJeuxiCy+tSGD50BCb7LPRQtBQw8O2oZAMuo5PT0uCSxZP0GGE2HROGIgGFViLjSwGmFRFRZVYVEVFlW4RcOiKiyqwqLKR7zCoiosqsKiKiyqCFZhURUWVWFRFRZVYVEVFlVhUcXcgOxqbCLxod7+rNrqINYylpH4Uu2f25fTh69Nu23rZn/6+KN++m/6VNXPL+3pw8dd9ffyi3fNrukC7v/sdsfNP61YUmwTJgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "669",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527588",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.84954696",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkx1pTT6KCoIcigofSQ8XQBmJWahRK6bsbbO1BBG87+w0zk7WQns2xuWlIYIdnk6JtSnRAIEXj/B2SrO3PYJhwSRkX84WaUh5HHDryA0aCCibVFxRUSfUHjrH5p35Z10UTNoTH2hRX7XUNCaOMwF670leDOKAvvAmze3kylxFttSkr/xYzERHYWP0cvJLTWAlFYIUWQ657WNvlL1UVRdwTAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1rgzAU/S95jpLEWGv7NLbBYHso22APpQ8tDW3AmeHcoJT+96XOrcbeXA2imHu8534lB5dHstjo18OHIjPyaDb6xRR6SyhZGF3Wn2S2PP6+WpjN7UVO9GKJOGPz5mFvclr9ud1U1fpgfSMu4jybJDSXMc9SThMeT9NU0ognMWPZxAGE5LTxyKfSAeREUITKAqkUsIe0BjBGjyrLRT6QlTe4FwgMjgFeqn7lTMA9bOwB5V1Cn5lSEQuW5J3etlRdwKHqAk5DQI9zFdcxMCoYCMjKbToIeNP1ZtWvg4kwpqGksPr6cxqcODxY7PyhW+E6Rki24yYOHjOUyusRJjDoxEEqLzB68zhUIODdVqhceKlGCcywB3rKIa3y2UfLBfM0isEtH6G3GJPXAaoBlXowJ1C5ETtKBNWACcV1u0MUZJTkuDXYf4Y7vX5XtarIjMWMkidV7up9u3g29brWpmyXb3r7Dz0ovdvX7eK+UN/dD29NYSxh+VUUp9UPczBAjeUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.0 /",
    "Flow State": "Turbulent",
    Friction: "414558.71 /",
    "Friction Factor": "0.015902",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "12793",
    Mark: "294",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5303385",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "301327.2115",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "115",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "29.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527589",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.2595522",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm7o5e4oKgnoQCXoQH1YNHawtbAUi/veG1tv9zvkOtx6hvJrz8NRQwNFfTaVvQbnWakBQeuPCC4p6XM6orCjDUvBknTFMhchhav7epu/VEOUY7Ix66KB7KAgmCE7ataGbgXEElQ8qGO+goDgTREieMC5kmkse24u5Ly6lacSDNm0XZiYpQ7C3+vNbJxQLwSiCrbc+/nJva6fmC8RU70bSAAAA",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVl1rwjAU/S95jiVJv/VpbIPB9iDbYA/ig2LRQNcO1w1E/O8LbVenzWma+jQQUWxO7z335ib3ntmeTJfydfeRkDF5zJfyJU/lilAyzWVWfJLxbF/9VTCbqA850OPKiDM2KX/Ulxzmv2Y32+1ip2xHXDhxHHnUF45gbkxd7kReIGgJhIF7Avi+pwDXYSwMTgDhca1FGIuYajmY6PJkQVEHpQDfE/o0IOD5XM9xbsH0G1Kn1xUt8qRdt3FUJaEsuFsmwcMwKmOKQvck2AYIBddaRIFhXVS1a9abGllSK0BUWRhdVdzKwI39/rFCgnZIUQj2r5vZguGY9Jmn4zb1Pn/NiYXkEICuUH5oHd47/c52WSAKGCtsK4aL2q4FBJAnWDz7qsIaQQvIYd0+UP+Fd1sPdHjSN4MeXaJdVVP12v0Xcmij7TqbpmEIj3kb0Lsa0IDhkITVgxao28G00b2wG+jWM3UIg6WOGaQl4FW9VEsMCMqooeylQd9Rb9AGgzqw7aiHzRH2WcNou1wb9CS4SoOrNLhKg6s0+LfSYE7JnVy8J0WyJWPmMEqekmxdbOqH57xYFDLP6sc3uWqgh0SuN0X9cJ8m339fvM3TXDnMvtL0MP8Bg6Hon/kQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "670",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "49360",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527590",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.66843646",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUEKwjAQRe8y61iStE1MXIkKgi5KEVyULlINbSAmUqNQSu9uaHU1/828z1QjFI25DE8NEk6+MaW+BeVaqwFB4Y0LL5DVuMSorAhNBGfpJidxYgZT/fe2fa+GKMfF3qiHDroHiROM4KxdG7oZKENQ+qCC8Q4kSXKOuWApZVxka8Hi9Wrui0tIFvGoTduFmXFGERys/vzaKUk4pwTBzlsff7m3tVP9Ba4Jt5rSAAAA",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVk1rwkAQ/S97XsPuZvOlp9IWCu1B2kIP4kEx6EKaFJsWRPzvDSYm1ezLZu2pEEQx+zLz5mtnZrYn06V63X3EZEwes6V6yRK1IpRMM5Xmn2Q825d/C5hNig850OZkxBmbHH+KLznMT2I32+1iV8iOuHAiTwrqcSeS0qcud0LpC3oEAt89AzxPloD0+BkgJNdKBJGIqJaDCYOmvhSNUVEo9W7oAddhLPD1HJcSTB+Qxj1oLdKEznsrqr1zI+8IBKy0KQzcc2NPQCC4ViL0Deeiyt3pvLbJkrqIuKi8MKkquQsB7vL+tnYRXJgUBiB+3cwWDI3TF5qqMNnUX12xevIuq6Aq5B+KOLx3MLJ6iQ4KWOPw3pkuaqv2IaDV1JU8y6x2JQ9K6DmuaR+o/8K7DQGkCTYDY5doZdWYvZYE5EDWwmo2DkNY5i0AqrJtwDCrMElQAlFAW1GlWQ9065lqzWC/x1juEl1X9a+7xBVGGQNivxr0HfXm3cCyA18x6mEDhn3WNNr+vBv0JBhWg2E1GFaDYTX4t6vBnJI7tXiP83hLxsxhlDzF6TrfVA/PWb7IVZZWj29qVUMPsVpv8urhPom/f794myVZoTD9SpLD/Ae8On1h+RAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "671",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "95220.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "527592",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.20826767",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zbEKwjAQBuB3uTmGJm2TJk6igqBDKYJD6RA1tIGYSI1CKX13o9bt7ue7/+oRyrM5DncNEvb+bCp9Ccq1VgOC0hsXHiDr8TdGsiAUC87SpcgwzbmAqfm7Vd+rIeIYbIy66aB7kAlOEBy0a0P3WQjLcwSVDyoY70ASnPOEC5ZSxkVWCMYQnMx1xlQQBDtt2i58mwpKEWytfs3XKcG8SKNZe+vjM/e0dmreI5BWU9MAAAA=",
    Pbi3DGeometry:
      "0yMAAB+LCAAAAAAABADtWE1r3DAQ/S86O0b+ljen0gQK7SG0hR7CHjbEJAZ3XbZuIYT973XXsnej8fNISXpoK0JCnMnMmzcazXjf9aO4uqk/P3yrxEq8b2/qT21T34pAXLX1tvsuVtePw6+9WZ73X2IfHP9yFkl5fvjRf4v9enR7s9ttHnrfsygOyyJPgjINk1QWQRKFKs/i4GBIi6eGLJk3FGUWMR5JH/PUEKfzHsdQRlaFSn4bklDKLJ3HmOfh4AExuKwciqhDQYzeEBXpTK2WeGiMqOhDzJ3HaCDMJ4OZLg2lT3DyME/QFuPIg/Ug1TUMMBQ1wJKQo6UlsQUnR0uz0kdLi6gx4qwon8fcvkUNjKVOhATnebxGU9tjwLLDW0uZ22KQE6Q8OIKwReFYGtPlBpnFjXKfiQa4RVYOQwYPyzw7YKhCZxWn3CpCHhADEtQTLi7Lp3fTdneRbUciPZsFLWGWDCySdMDIFEeP82B3Adw3hDidb2NFolxZbg/oAXlYVp2sNIeXEgQx5qTkMGBKyRm4gU/HNxeKerA0uNM42Zq6QWM1Gkq79wWKAXuE2/60VjArGMqZh+rzHcqel4uGqXMng3kD+VBGW70AIlZq0WOqiOlBk+I8KAbkB9N1xzDbCvKA3QPBF5oEGF5QXZIuvpsoK+TBg0MPLpTFmLbN6hgKDnZkgH0FlyD2YDFIuu4Y+O0GGKxHCbyDFu8kKCngwEMjByYQv2UtMzoGcl7LeCa4TxEWg6T7vwkx8JMbp9C8rhDjqLcsfdD8t4UYC9XBVqH5o0IMp7dY8PBCjBdivBDjhRgvxHghxgsxXojxQowXYrwQ44UYL8Q4ZPQXCjHrQFzUm69VV+3ESoYyEB+q7V13rx8+tt2mq9utfvxS306md1V9d9/ph8um+nn6j2/bpu0Dbn80zX79C4z6hxHTIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "673",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527593",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.44449281",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjssKwjAQRf9l1jHk0VpTV6KCoIsggovSRYuhDcREahRK6b8bbFUQwd3cOZfLyTqQpT60FwUpbF2ppTNt5SwgkE5bf4U064YzFCaUY0LZbE5JjCORMOjRDyoizCOSfEGGBRd/4Gc3fwksmqZog0V4rHRxVl41kBJMEOyUrXw9hr3zhddBfIhHfXqjjdJV7Z9hymIEa6PuY5dTnAgmECydcWHX3ozp8wdF92WuFQEAAA==",
    Pbi3DGeometry:
      "DwkAAB+LCAAAAAAABACVVlFrgzAQ/i95TiWJsdb2aWyDwfZQtsEeSh9aKm3AmdG5QSn+96WdW9XenQmiGD/vy3d3yaeLI5uvzevhI2dT9mjX5sUWZsM4m1tTVp9sujj+3jpYzNzBan55MpJCzM4Xd7J6+Rd2s9+vDi52JFWUpeOYS5FEOksVj2U0SRLNRzKOhEjHXURpyc8x2UR3ET1WnGJzSKIVEqMTiczTZ0szlQ1pwxXgSLACEsHZrmogFFLQMxCU52X+E1mmo1iLtFXohqwNdLjaQKcwYMQpk+s5KCoYCFDVLT0IoHJRVf08hApjGhJF5dfv03DP4c6SG5JcDMAsIYL9mg5vOZILDwl1HbLxMBmOeK+iDhcIoOuLNg+Uy9NvPGLILQ+aFwp4u4dAyiXgwvuYMEWFR4Bp0N8AUBfs5xRAUkGJUO5xXfQgW/Ezol4a7u/izqze8yrfs6mIBGdPebmtds3g2VarytiyGb6ZzT/0kJvtrmoG90X+3X7x1hbWEZZfRVEvfwBmZbmpDwkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.5 /",
    "Flow State": "Turbulent",
    Friction: "481759.69 /",
    "Friction Factor": "0.015746",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "3401",
    Mark: "295",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1638236",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "326437.8125",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "116",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "31.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "527595",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.96697726",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1zD0LwjAQgOH/cnMamsTaDydRQdChFMGhdEj1SAMxkRqFUvrfjVq3u3sfrh6hbPVpuCMUcHCtrvDipVUGgUDptPUPKOrxNwYSpTROeb6KmKALwTOYmr9b970cAg6HrZY39NhDEdOYwBGt8t1nYcskIVA5L712ds5nfZ0rzxmBPWrV+W/LOCewM/iauWA0zUQwG2dc+G6fxkzNGzUvpQPEAAAA",
    Pbi3DGeometry:
      "ryMAAB+LCAAAAAAABADtWFFr2zAQ/i96doxk2ZGVPpVtMFgfyjbYQ8lDSk1r8OKReYNS8t9rEtuJJZ3u1PZhdCIkxD7dfXen05393Tyx69v6++Oviq3Yl/a2/tY29R1L2HVbb7vfbHXzdPzbi/lF/2H75HRnITi/OPz0X7Zfj2qXu93msdddqFQUxTJZCJnmMisTKdJyWWTJTMDlUVBIt0DpQtA0pBbqIMhyt4ZtavBKldIQLIV2ewXGgWmAGAFeYUm0TYEYSmp3rmZxLFOtuXBgOAS2xsxdiqn5Dr4OA4xjll2SADQ1yy4pV6C7GLhtCvTK2FquMv3KyNESBTDASiQFiJVoeFEjGKTIDQEhuxiG3TLAOMJNGQLLXaSRkTCoPREEBwQhx9kGNwU8U+PhPFrKcv9cQRVoUfQaIvcPKHRyTT5hlmhBePLHc10OCnqwVCKb59YIGQTgsLEEZuBcijJkdIAansjJSbeaBV0DgOC60DOf1CEsnwDvxGbvhkwRHkiMMOi7MWnk8rw81cEX33oUAYamzizUp9D15mZzcQSWRb/CJ7Aa5ySYmhpkaiyoUWGswGCIPrqSpnGWj9LpFF3j1L6A+GB3gzFOJWXkCo8DLCkHuF0i8O3wzIICuNu5oT3rMQQzfeS84q2Z7NVkChxj6HwDKwqc9/aRAcGxs0TGAJ9OgPv0FgKePfQhBHIJXI8BmM2L2tSwsUr2aCryl89h6wyHNw9wQINx/3e0C/ieFsDHvCHtQmNXSG+o7552ASMP52PennZB2BUPYxBpl0i7RNol0i6Rdom0i7N3R9ol0i6Rdom0C7Y+0i6RdvHOw0i7/AO0yzphH+vNz6qrdmzFU56wq2p73z0MF1/bbtPV7Xa4/FHfTaLPVX3/0A0Xn5rq7/nCD23T9ga3f5pmv34Gb2vrEK8jAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "675",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "527596",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.66653111",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LO6+LurqydpIKgjpIBB3Eg9KiD7bdsC0Q8b+3pAnRodub9w0zUwyQ13jqbxJS2Jsac6P6xmggkBvU9g5pMUynM3gJjSI/WXkBoxEXDEbyBYM45v8hE/wHLrETLD/1WddVvdvgHhusrtLKDlKf+gQOUje2ncXR2Mqimz3JM14WtJPYtPYteBgT2Cr5nL0soIkIBYG1Ucbl6odSY/kCAYc7WhMBAAA=",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdll1LwzAUhv9LrtuSpOnnroYKgl4MFbwYu9hY2AK1kVqFMfrfjbO1Nu2hJ2Nsa/Luec85SXO69Zmsdurl9C5JTh70Tj3rQu2JR1ZalfUHydfn30sj04V5kcbrZ3xG6eLyYd6k2XTYsqq2J8P6SSAETTyfhYGIBfNCFqTcfA+EkKc/QpLxbChEIrsQlHs4pw4QMZ8MkUaRGAqUxY5JgcHn6nMIPpfV2IqZi8nKO8FeQ7A+KzaLonhqN/p5y6kXrAUZEV0V4xBtFQiruRjjrMD6QAFMFwxu7QbC6uqsxgUOdxzMFnFqsARiRUACvKNBwd0KJNytwHOGJRD3Aki49wt3K5C43spuPUgAcQYgAGxuoODsBAHORtBDDgkgGgIEQPPYJxzk5NBAKDf/GW7V9k3WsiI5DahHHmV5qI/t4EnX21rpsh2+qv2fdC/V4Vi3g7tCfv3/4Y0utDEsP4ui2XwDGs/j0eUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.8 /",
    "Flow State": "Turbulent",
    Friction: "176976.75 /",
    "Friction Factor": "0.016925",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "87",
    Mark: "296",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15379",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "190840.5673",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "108",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "18.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528040",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.76860234",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyGkTRNoPYkKgh6KCB5KDxVDuxCzUqNQSv/dYGtBL9529g0zU/SQn/HY3QxksKMz5mS7mhwwyAmdv0NW9OMZDErwWCu9iITiKhUJDOwLyiT9y7SW8pfNoSMsP+XLtq26sCA81lhdjTctZIILBnvjat9M4kC+8hhGj/KElxltDdaNfwsdKwYba56TVyY8ErFksCJLIdc9rB3KF6nc8A0RAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACdVlFrgzAQ/i95ziRRI9U+jW0w2B7KNthD6YOloQ04M1w2KMX/vuBip7HHxVJazHe577u75M6uT2S1VW/HT0kK8qS36lVXakcoWWlVmy9SrE9/j9bMlvZDWvqP3HDGlt2P/ZJ207vdNk15tL6CRXEmMsqZiERuH5I04kki6NCQxVneGVicjA0sXXQGzlMaRtV7CAtc1MjshpFBLPi8qEBxPMFwcTSqCVWaX07c4X4J4aJ70okluHQYZ9wj6nG/GpP9LoMJv8sA40H5vXjAvCAciBPUHR8Amu614fhpjc8XjRJqkOBbjTIFG6ASgZcdd4AUApWBswzovrlEYTh0KfBmBR0AgTBd4NLNn2coURgONQc45XAHQCBMF5qVAVN3NlOoAZoIaIPjL1m/GgPc/hO4V+WHNLIhBYsYJc+y3puDW7xoUxqla7d8V7uz6VGq/cG4xUMlf4Yb73SlLWH9XVXt5hd3KFIOuwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3094",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3104",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10396",
    Length: "25",
    Mark: "297",
    Material: "Copper",
    "Middle Elevation": "3104",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "254.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "122",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3104",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3113",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528041",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.87104947",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TssKwjAQ/Jc9h5DYptB6EhUEPRQRPJQeWgztQsxKjEIp/XcXWv0Db/NiZqoRyhYvw8NCAUdqsSQ3dORBQEno4xOKapwhB4ySqdZmrZWR2SrLYRL/Mevv/CaEZuAPLOywudtoAxRKKgEn67vYL+RMsYnIt2d6xdvPOljsel7RUiWZFrB39r1kk4S1NBewJUfc61/OTfUHSY0yqRMBAAA=",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABAClVt9rgzAQ/l/y7CRRY9U+jW0w2B7KNthD6YOloQ04M1w2KMX/fZm61l/XnC2imO/uvrvLXU6XB7JYy7f9pyAJeVJr+aoyuSEOWSiZ6y+SLA/1qxHTublI6ZyQG0bpvHqYm5Srf7Pbokj3xpZTNwi8mcMod0MvjB0/cOmMOX84Y7zCeczDNu77Ya1Pg6iNQzxH/WCUPuQRa+F+RL1J4UBubWkh/VrjGfDEwUi6J7i3a0BaoNvu7vsu9Y2fIVFL0N2IEYs6g5agUzEMk9VFP6heeggBHC3kvFsJBNMVQQ3z65QbjBY4JVAt7Oq404CoNbjdQN8jiS4dC2eKZjlv5+jtzQLjuF4BApqqP3VMgZ1oHUhYIkyvgyMJHHo4pounKhwR9FGDcCQRRoCcqohPAM6gws2fwL1MP4QWBUmoSx3yLPKt3jWLF6VTLVXeLN/l5ih6FHK7083iIRM/bcU7lSlDmH9nWbn6BVmZL9W7CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2769",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2769",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10069",
    Length: "316",
    Mark: "298",
    Material: "Copper",
    "Middle Elevation": "3085",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3162.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "122",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3085",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3085",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528042",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.84954381",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAQhf/LnJdltVlFO0UFQR0kgg7iQWnRhW0nbAtE/O8tqR0i6DZvvsd7L+8hq/SpuylIYU+Vzsh0NVlgkJG27g5p3o+nN0jBF7FcBkJyGSHCwH4w5DFi8M0Q4+QfnFOLuXzVtmXnF/jHRpdX5VQLqeCCwUHZ2jWTOJIrnfajR3nWlw/aKV037i2iUDLYGvWcvIuQJxiEDNZkyOfahzFD8QIYKKbUEQEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVk1rwzAM/S8+Z8GO7WZpT2UbDLZD2QY7lB5SGlpDFo/MG5SS/z6vzecSVTYlJc6Lnp4kS876RFZb9Xb8zMicPOmtetW52pGArLQqzBeZr0+XWwvThf2RKuie3DBKF+c/e5Fq05gtyzI9WltJQ36biIBRGcqZEAGPwkRSHkwCiZB/gOB8NgnAFozJHsBDSnnsSdWqotEQiCPhKbem+qfKAoJFV53DVFAcQkSxo1yUCnEuwlgINpFEFwCjqnPVAF0FPXy0wLmCPWCYkrEqWO5QVVfBcRyNxaUeY+dw5CCVO4ClHdvUIBXYOGDap3w41wPbDGCfY1Sghc8sAVW5dxQaoPsuGQ6AiQ0HTQaMCrTwmD5YG/iMPveOQhsHbGdoUmNUoIXHaQCq8jg5sQD9R9+VrnWeJf5HqrWw3xD3Kv3ITFaSOQ1pQJ6zYm8O9eJFm9QoXdTLd7VrocdM7Q+mXjzk2U//xTuda0tYfOd5tfkFWCtcNfUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "250",
    Mark: "299",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2504.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "122",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528043",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.01770285",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzEkMW21nkQFQQ9FBA+lh5aGdiEmUqNQSt/dYOsPnrzt7DfMTNpBUuCxvSiIYWcLTKxuK2uAQGLRuCvEaTec3jCJKGPhgjNJIz7j0JMvxgWVgkd/0FAGP/STO7DsVb9smrz1G/xjjflZOdVAzCgjsFemcvUoDtblDv3sQZ6wfKOtwqp2TxGKgMBGq/vonQo6l1wQWFltfa65ad1nDyawpAYTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACdVt1rgzAQ/1/ynEoSv6p9KttgsD2UbbCH0gdLpQ04M1w2KMX/fZmrna65eIpUzH387nfJ3aXrE1lt5cvxPScpeVBb+awKuSOUrJQs9QdJ16ffT6NmC/OQmv5JZpyxRfMyP1JvWrdlVWVH4zuLPcYiylngxVzMqS+8JBYB7cijOY8aecBFVx4zP27kIfMpAudinwThNb5v1kbflf/gjuEDxXXmNSKuk48NJwmt+bbyf/sG5dWPy4UXCB5bTqCr6WP1fHq7ce3T5mGN02SCQxuKY+MGZ+rQwKxhBr2TwaFN52bP1F4Djv0EusdxNpDHhDODo4DVj6ym4T7C2aM4DXXkqHoAfRwazGSBsTAzCmOP4wRMqZ4c2yGwD6iBpuHonoLnKsYewwm8CafMZ9DHoUHdfDDWiLvb2Jv/ELcye8t1XpGUeYySx7zc68N58aR0pqUqz8tXubuo7nO5P+jz4q7Iv7qGN6pQBrD8LIp68w2KShOf9QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.5 /",
    "Flow State": "Turbulent",
    Friction: "471678.58 /",
    "Friction Factor": "0.015419",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "1651",
    Mark: "300",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "778596",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "390856.7284",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "101",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "31.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528044",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.97108931",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+LrmtrdooKgjpIBB3Eg+KiD7bdsC0Q8b+3pXYp6DbzvmHepB0kBZ7aq4QY9qbAxKi2MhoIJAa1vUGcdoN0gZnPaMg8seQ0EIxDT36wl4hExL4o5+IfnXqz6f2qafLWbXCHDeYXaWUDsUc9AgepK1uP5mhsbtHNHuwZyw/aSaxq+zZzFhLYKvkYswGjC+4zAmujjOvVd6X67AkUw2mHEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACdVt1rgzAQ/1/ybCXGWLV9GttgsD2UbbCH0gdLpQ04M5wblOL/vuisVZpLckX8yF3ud7/kPuL6RFZb8X78ysmCPMuteJOF2BGPrKQo62+yWJ/+P5WaLtVFGu8imQWULruHukmzOZvdVVV2VLazgPkRnYce98OYcS9kfhrR0NPJUx51cj5ngU4Ozk84G+ShT2kYo3AGPkHEx/L2jeF5xpnwUXIeMKNfEAfgzyOWuvC04pj8th9JnLDrnXPU2NG6fbpoRpHD+Bk0bfQmmsm+aLkZWE+5jaJ4vZ7Bpo2LloFhD2A0hMYeBWNuw1hQ9cAR0PlARMaeG1C1W7AgC0w/gTk5VpjD6hCZMukH+rwDOoUFC7JA9CJLLWC6IKKqHGoHrmuga1uwIAvEuQBzcj057au7pQca6ta5m2DPVjVf/UM8iOwzr/OKLKhPPfKSl/v60A9eZZ3VQpb98EPsBtVTLvaHuh88FvnveOK9LKQCLH+Kotn8ARgc+RT1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "226658.02 /",
    "Friction Factor": "0.01617",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "5258",
    Mark: "301",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1191763.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "264579.9392",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "94",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528045",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.84025352",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjjELwjAUhP/Lm2NIYpvQOokKgg5FBIfSocWQBmIiNQql9L8b2qp0c3v3vuPu8g6ySp/bu4QUDq7SmTOtchYQZE5b/4A078YzGOIIM57w1YIynAjBoEc/SAnHVMTiH0qiOZ0FD7D4DFg3TdmGFeGx1eVNetlASjBBcJRW+XoSJ+dLr8PwUV709Yv2UqvaD4KzGMHOyNfkXYa6iDIEG2dcyLVPY/riDeZPQ0cVAQAA",
    Pbi3DGeometry:
      "HwkAAB+LCAAAAAAABACdVl1rgzAU/S95TiXRaKp9GttgsD2UbbCH0oeWhjbgzHDZoBT/+1JntxS9ehXxIx7PPTe5H3F1Isutfj1+KJKRR7PVLybXO0LJ0ujCfpJsdfp9dDBbuINU9P/NjDO2qC/uJNX6Qrspy83RcWMRhEma0BkPg5TPExq5e8wiegUk4bwfSEWMZEie1oAMBdIU6JVgsgYED5HiF1MtDZaKbq9AcdAUOI/a3ShgLJJIjcElOQOcJQGXsWxTupGzyjXi62Ot+WHE6sCIH0msbzDiB7Ob056PHxzsGsDWpsQHzILhpe7NQSQFVsHpw8sJFgHSM9AWioH0CyznKSkzJTHADoTL5nHdrJeB9GuwM04pzDFlDrZ/XDfBbSUoBtKvwV10TGOc0mbBvRfXzcft447h/jbu9OZdWVWSjAWMkidV7O2hGTwbu7HaFM3wTe/+oAel9wfbDO5z9e1/eGty4wwWX3lerX8AlU05xx8JAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "1.6 /",
    "Flow State": "Turbulent",
    Friction: "35077.85 /",
    "Friction Factor": "0.018925",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "15821",
    Mark: "302",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "554965.8",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "96210.88699",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "86",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528046",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.41466792",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyEkNa1YT6KCoIdSBA+lh1SXNBATqatQSv/dqBW8zcx7TDVA0dhjf0PIYR8aW+KZtDcOgUERrKc75NXwjVFJBVdSpkspUp4l2QLG+uetuk73UY7DxuorEnaQCy4YHNAbat9FSpUxKANpssFP+GQv/3SH1rT06UIlDLYOn5M+U1zMJYN1cCGe+4dzY/0CTNSawcMAAAA=",
    Pbi3DGeometry:
      "AR0AAB+LCAAAAAAABADtV0tr4zAQ/i86u0Fv2+lp2V0o7B7KttBDySGlpjV44yX1LpSS/74iltNI8mfZvRVESIhGmplvntLcv5Hrh/r29U9F1uRH+1DftE39SDJy3da77oWs79/6v2abXpoPOWTvlAtG6eXxx3zJYTOwfdnvt6+GV9GVkGXGqFqpQvFMyBUTQmXn9DKXR7oW52StzDoko9Ncl0dybpTEpWhdqEksVLJsBvaTeP88kIP0QjwxveNeoCUrZ8Hx4EvGlKOX5v35gjtyLPl0fIA/0CV15ft0JAeo9cQANEKXheuFCBqgFVqlBJuU71sV0+vJR2YBJ6DMKQV3NxioiCEXtMhdswpVzEkqlPsBHSKaDq9PjuIMDBvPByxoGR5kFozvwHAqai8yQZWChIjKiTXauc3KDzx0HN4AIYj0E78PQIunS8YnI3sRfMmp3WC81yt5MSqpb8OSCW3p9jYSKu8F6QERG80h37DFnkAaMCTqNjNmbJxzoYL7F5KZdVzxIQfhG2OhWTCUkuceh2GZbPeQAWGFDBATkITSDsqJxDhoFPEO5YYTWowAobBNFALiGIeE0jea7u6D6t0CydRoaIJL3eI0dDchY7dBcH0MpaA1Hwu+IauxkvIV42s3+kKAj1RXM/IR8ikqTeg65OuYhzy90EPArtg7L4AD6nvihYAsXmgZzFKsAHHAvhnrdoE3kAbopjQfpvkwzYdpPkzzYZoP03yY5sMFDkrzYZoP03yY5sM0Hy7L0s8yH24y8q3e/q66ak/WdEUz8rPaPXXPdvGr7bZd3e7s8q5+PG1dVfXTc2cX35vq3/nBr23TGoG7v01z2PwHL7D5FwEdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3104",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "684",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528048",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.65417606",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yyim3PTTlFBUIcxgg5jB1eyCaaxLBhj3z17g27Py+/hqScoW3MYrxok7HxrKn0KynVWA4LSGxduIOvpIyOSEcwozRaUZJgnXMDc/LjlMKgxwjFYG3XRQQ8gCSYI9tp1oX8ZShlHUPmggvEOJMVZTnLB04TnghWCx/Zozv/wVpuuD29PWIJgY/Xju04TLFJSIFh56+OZu1s7N0+0JjBY0wAAAA==",
    Pbi3DGeometry:
      "oR0AAB+LCAAAAAAABADtV01r20AQ/S97VsV+a9c5laZQaA+hLfQQfHCISASKVVy1EIL/ezfWh6O13q7UXhcTY+1k5s2bGc3s3L6Qm7vq+/PPkmzI5+au+tbU1T3JyE1T7dtfZHP70v10YnrlPuSYnU/eMUqvTl/ujxy3g9r7w2H37HQVzaUSLGNU5ZprmwmRUyFt9iqQ1HYCpcVbgTB89hwqSMZUJ9BGLbEktDVhn5Qt5ESAWAwQFwrIEsTGTsWwYTyUUXyZU4jFAK20dAKe24LLqaWTwGlQNmXha4wQw7kUM4bO5wh5aucMDD06R2MQMMlCHkFkRM1DcAJBTYgcQMYAMNogGAuKjBp9grC0CFbAyK2w7CTglAeLDFmC51GXFpKGrsa5eZURt7Q6Dz43mOrxZfc0cGuChQ9NRVvy4m6GW028bqDAz0aU4D8EcXH3iDP3eXDdgwv34xVcCx6eX3KYX9x2NGjfG4spPVUUyxK7IiAAArk0jlolO0OGh2dwgDUUFL2zkv1fnNBsWU0OpnTUoFZ10NqERwLUQM5ChWidoVF7EfA4PT8gsIMECg0lFXiL6YHsYWhYNsAlWMsoHvCiabWZJYFuAGbeVXyrggOmUHb2pXACM8s6ig1nGBb4tw+IHYsTvvJfZAKwAAGHYUIZRfYRNdgJ0PUTve+BexJ0aSU3nAWAgBQWjAmfHchPHMFvi2nfTPtm4PVK+2baN9O+mfbNtG+mfTPtmyvun2nfTPtm2jfTvpn2zdHQNiPX1e6pbMsD2dCcZuRLuX9oH/uHr027a6tm3z/+qO5H0aeyenhs+4ePdfnn7T9+aOrGGdz/ruvj9i/Sy8nWoR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "686",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528050",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.56282233",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjc0KwjAQhN9lzyEkTZum8SQqCHooRfBQekg1tIGYSI1CKX134x94m9n5ZqeeoGzNYbxqkLDzran0KSjXWQ0ISm9cuIGsp4+MSEZwSmm2oCTFXFAOc/PjlsOgxgjHw9qoiw56AEkwQbDXrgv9y1CacgSVDyoY70BSnOUkLzhLeF6kouAxPZrzP7zVpuvD+5NgDMHG6se3zRJcMCIQrLz1cczdrZ2bJ3tdoozTAAAA",
    Pbi3DGeometry:
      "Mx0AAB+LCAAAAAAABADtV8tO6zAQ/RevQ2THjhOX1dW9SEiwQIDEAnXRiggi5TaoBCSE+u+kSUrtxCc2bLGqPjLTeZx52XP/Qa7W5e37c0EW5KJelzd1VT6QiFzV5aZ5IYv7j/5ny6an7YvsoiPlhFF62n20b7JbHsT+bLer91Y2pbFgLI0YFXEmBIs4jylrv/cMQZXJoExZGEmsBJ8XSDkzBbJEzGoyfWrpnOZ7Bs8TuwUEwhT4MuCp52jYlwHDdzQtVW4NBvIJQRC9epkzaSAe6BkztRh/1yJ6oKeJVXtHRmqA1YkW4EuW8MSIgMMXYBNC4kph9RZMc2an6hEo5lfJivdplWrw0lriWtnwbAia4gYqv3oCpX8kQ3/cmfVwcr6GJ4UA9XzHGReiSWJNATREQMo1MtLjOaVQ62t0mHNcJa6Igl6cHSMaAhg7j27xAQzcFwntGbIF0DHyzHF6MS4HCSV6xmg8SJn3dEdV/DQUIwPQIcHVQZGRGt/jFJ7YGiNJx4yc/ShKYLZ+HxxKKFeCDZZT+1gfj3unwPgcQALYJ4QaxxuVKwoHHBlwyKCUQmehT7AG8IBD2YZ1BmsZBQRdGSco0mzugjNydU8fVcf86WA5TrqO2NOlrbc6hq3hNdPQBGLgayk0juIEAwsr0xVAcJ0ahwnuAEA/hOZ379PuB2g+4Gi7IPtig0nAoJEESI/n9PPoHzgVw+IYFsewOLrMhsUxLI5hcQyLY1gcw+IYFsewOIbFMSyOv3dxXEbkX7n6XzTFlixoTCNyWWwem6fh4bpuVk1Zb4bHu/Lhi3VelI9PzfBwVhVv+h//1lXdKty8VtVu+Qks7hU/Mx0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "688",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528051",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.6460431",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjT0LwjAYhP/LO8fQfDQmdRIVBB1KERxKh1RDG4iJ1CiU0v9uVQpud8dzd+UAeW1P/d1ABodQ28JcovaNM4AgD9bHB2Tl8JMTsiAUc8npiiQcC0kEjNUMrrtO9xM9BVurbyaaDrIEJwiOxjex/RhCuEBQhKijDR4yhgknqaIiZalUS8UIgrO9/sN7Y5s2fpckYwh2zrzmNsWKJRLBJrgwnfmnc2P1BnQ0PjHUAAAA",
    Pbi3DGeometry:
      "5R4AAB+LCAAAAAAABADtV11r2zAU/S96do2+LFvp01gLg+2hbIM9lDyk1LQGLx6ZNygl/31ubLeSrSOpeRuIkBDnRPeec+/Vle7tM7m5a74//arJhnzu7ppvXdvck4zcdM2+/002t8/j1wGml8OLHLO3Xy4YpZenj+FNjtt52YfDYfc0rL1gPJeclRmjMlcVU5nguRa0yiykZOwESOH4XeSUMh25gAt+AkouI02NrAaESbZACu72goWMS5xu/Mac/gMIjKTTv9DaHRnMbCWmknxEmGa2/0KWNjIbs5cYYgomlI3MbhYINIb9m5whM8kLG5gjg5l5CGCdvKii/LxRiyZg1gbUiUODC00VekSUEL7NYVoTSk6VJipQaYEaxPvGRDC32CJ4J+sVA1g5HmvncMNKcRnYa3CPggViABG2Ap0QdhUXsKoOHE2M4NxEtihTDA5A5G6L0Y+1aDFp0XREijJwcFZKTHkR5Qi82qr0QqRyVhnuaXGBwX4wt1KMHbKkWoDT23+uo6uDK/xazbyqs2PmOaHOEInTrPV0dChpy8eHimcNJA2XYGrYGEoAVhlO/7rNRLSmZaI9+iE1nE7ProFrcA3iOo/YG8sr30pOVYauXAvSL8jsJvaoMRF747xYcybnBLAQAewm4paCr9ArBjBsONI4OVCOJwfBqK3846BBmdHXUYsZbBCeKwrk9n6dODUeL3CNpxNH9s44bjhqaSIOG0sTcZqI00ScJuI0EaeJOE3EaSIO3dDSRJwm4jQRp4k4TcT/10S8zchVs/tZ9/WBbGhOM/Kl3j/0j9PD167f9U23nx5/NPev0Ke6eXjsp4frtv5r/vFj13aDwf2ftj1u/wE/z3u/5R4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "689",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "367444.7",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528052",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.331866",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjs0KwjAQhN9lz7EkTWyaeBIVBD2UIngoPUQNbSAmUqNQSt/d1B/wNrvz7cxWAxQnc+hvGiTs/MmU+hyUa6wGBIU3LtxBVsNHRmRG0oTlLF1MQjDMYax/4LLrVB/puFgbddVBdyBxghHstWtCOw2EsAxB6YMKxjuQJJlzzEVG04wLlossukdz+Ye32jRteCfllCLYWP38XtP4A8U5gpW3Ppa5h7Vj/QL0dONF1AAAAA==",
    Pbi3DGeometry:
      "0R4AAB+LCAAAAAAABADtV11r2zAU/S96doM+bSl9GttgsD2UbbCHkoeUmtbgxSPzBqXkv8+xvUyydSQtz6KkxD65H+fo6kr3/pXcPTRfX37UZEs+dg/Nl65tHklB7rrm0P8k2/vX6esA09vhj5yKf29uGKW347/hQ067v2Zvjsf9y2B7w/hGasmL8xddaV4IvjGC6vGFYqJ0ESl8gNhQykzEhCvtAhWXEWeLzAaESTYhSlbeMJjMwsQOk+jMjp+KYDXtBCRXfm1wapgNZxNiJK1cBS4IY64z18Rmc0EqykCYEYHOcHyvM5SZNsYVJiExHB/T1IP/QBwfzUgC3jBwAVbK4EIr1fQTw885481hexOlnOXkCz1TSxDvGxvBuaXWQFrW8V2wKhzs7JrUEoiuqsC1wS0K1ocFYF+pjRD2FAvAxYHVjOuM93S4P9lcMP/EvZZCH1MxYhLGqPG9qiIHp9SlmJlwPQEr8krNTEpvjeGG9p+6rOLA3BSby33wItyzO/VUh3cHSxujF/qLUl+vGmzcV9BE6yzLOUOjSgFqeXWiJNgsU8YmKDHkKqA+KmUoCu4wuPrwGkPyiCIuikBThDYwsVCJw22Br3oLNrqKXrTcnM/Iql4iR4z3WBo3zNmbd2VGgMUSwGEwgi80OAMgWmgMwVUblxPf6BaihUYXGAbTTL2FOhcQ2BoCSxCXIJ0oKuiAAGg14ZqltsyUvLCvPAfnOTjPwUkdyEczz8F5Ds5zcJ6DeZ6D8akO7w6WNnkOznOwh3yeg/McnOfgPAcntMxr5+BdQd41++91Xx/Jlm5oQT7Vh6f+eX743PX7vukO8+O35vECfaibp+d+fnjf1r/tH77t2m5wePjVtqfdHxlsuADRHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "690",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "168372.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528053",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.67594561",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEk2TZoPUkVBD0UETyUHloMbSAmUqNQSv/dYGtBL9529g0zk/eQVfrU3RQksHeVzpzpameBQOa09XdI8n48gwE5FSgXK85iGi9ZBAP5gigY/w+lRPyFc+wIi0/9um3LLmwIj40ur8qrFhJGGYGDsrVvJnF0vvQ6zB7lWV9mtFO6bvxbSBET2Br1nLwYUc4EEkidcSHXPowZihdRBcuSEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVt9rgzAQ/l/ynElijKh9GttgsD2UbbCH0gdLpQ04M1w2KMX/falLW38dOYcoJl/u++4uudPVkSw36u3wWZCMPOmNetWl2hJKllpV5otkq+Pfq4XZwl6kodeZG87Yon3YmzTrs9ltXecHayt4EIo4oZzJQKYypiIKuBCSdoE4jNMWYKHoAyxKWoDziOKozhbytGBKIz4t6AIy4fO8AsX9AeLFvV6NqKJ0OnA3P0whnPSBtAgZn9yNKzCgugDDhIwtXBRjDReGn8qvMfQKDhAEIHdh8f5uIAL/v1Oj+Po7jnAWKhr0SfdToQEwVWAJICxADaw4tLGIupzNhJsHDwiikEELSAIpDR3B+f3Oz4SbB6sF7IMIC0gCKQ02VERvnk+FBcA24S96/9d4lJIOYP8Z7lX+UZiiJhkLGCXPRbUzezd40SY3Sldu+K62F+ixULu9cYOHsvjpLrzTpbaE1XdZNutfwIsOgeUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3094",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3104",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10396",
    Length: "25",
    Mark: "303",
    Material: "Copper",
    "Middle Elevation": "3104",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "254.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "121",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3104",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3113",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528054",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.36356675",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TssKwjAQ/Jc9h5A0Gmw9iQqCHooIHkoPLYZ2IWalRqGU/rsLrf6Bt3kxM8UAeY2X/uEggyPVmJPvGwogICcM8QlZMUyQA0ZLs0rsWqultIlNYRT/Mcvv/Kbrqp4/sLDD6u6i6yBTUgk4udDEdiZnilVEvj3RK95+1sFh0/KKlspYLWDv3XvOGsPaIhWwJU/cG17ej+UHmrAzbxMBAAA=",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABAClVt9LwzAQ/l/yHEuypFm3PYkKgj4MFXwYe+hY2AK1kVqFMfq/G9u6/ljPXCelpfnu7ru73OXa1ZEsN+bl8K7JnDzYjXm2idkSSpbWpPkHma+O1asTs4W7SEEb5Ioztigf7ibF+tfsOsvig7MVPJBcRJSzMFATNaNCBmzKqcNFNFElHs5C1cIlk9NKn8mojQM8jb4cpFdhxNt4yMWocCC3vrSwfn3x9HkUC4fSPcHdXYPSgtz2dl8ETPz4OSNqBL2NGLCoMmhZdCqGYPK76AfVSw8jAKMFnXcqgWD6R1Bn+XXLDUYLnBKoFn513Gnw1xreJKDvkUQXjwUwHt95+4se0SwQjuwVIKCx+mPHFNiJ/oGEJMIIwNMBDT0k0+VTFRyS0EcNwLFEGAFyqvo/AUiDEnd/ArcmftO5zsicBYySR53u8n29eLJ5nBub1stXsz2J7rXZ7fN6cZfor7bijU2sI0w/k6RYfwPNKyBjuwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2769",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2769",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10069",
    Length: "316",
    Mark: "304",
    Material: "Copper",
    "Middle Elevation": "3085",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3162.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "121",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3085",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3085",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528055",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.16122173",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyE0zTbSehIVBD0UETyUHloMaSAmUqNQSv/dYFsPInjb2TfMTNFDXutTd5OQwd7VOnemU84Cgdxp6++QFf14BgNnFFnKlixCuhDIYSC/YEITgfgNOYq/cI4t5/pV21Zd2BAeG11dpZctZBGNCBykVb6ZxNH5yuswe5RnffmgndSq8W8h4oTA1sjn5OUxTZHFBNbOuJBrH8YM5Qu0JAOYEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1rgzAU/S95diGaRFv7NLbBYHso22APpQ+WhjbgzHDZoBT/+7Kpq6J3N6FYjMd77kfuPXFzJuudfjm9K5KTB7PTz6bUexKRtdGV/SD55tzeOpit3I800eXJVczY6vfPXaTZ9mbXdV2cnC2PKU+ZjGImaJYKHvGELpdCRrOAZPwHEExkswBowRdJOgZEnARS9VHJmI+BLBGB4fZU46g4ZYxn/zoHqcA8RMwXnuGiVIhzSWUqxEwRfQCUqq3VAOh2MMBHD7Q7OADGJZlGBQPjqC47OM2jT7Ddj6lzMHOYyh9Ayw51CebDpxlQH/4lwcoOThRGBVqETC0Ylb/CoQmGtyjY7YiQgVQBWgJbIDMYou3+44wqAygy0PmBUYEWAWcUGFWAUmMJBqjP+GCZmVp/LcHOqNk83DfErS7elFU1yRllEXlU1cEeu8WTsYXVpuqWr3r/B90rfTjabnFXqq/hizemNI6w+izLZvsN8YHqdvUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "244",
    Mark: "305",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2442.3",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "121",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528058",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.64318501",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyEkbY1aT6KCoIdSBA+lh9QubSAmUlehlP67USt4m5n3mGKArDKn/oaQwsFXJscLaddYBAaZN47ukBbDNwYlljxeRGolxYyrSC1hLH/euut0H+QwbI2+ImEHqeCCwRFdQ+27SJkoBrknTca7CZ9N/U/3aJqWPl0kEYOdxeekxwkXc8lg460P5+5h7Vi+ANwkDEvDAAAA",
    Pbi3DGeometry:
      "hx0AAB+LCAAAAAAABADtV02L2zAQ/S86u0HflrOn0l0otIelLfSw5JBlza7BjUvqFpYl/71KIqWR5Bc5PYuQEI88M+/Nh6R5eCP3j923158tWZJPw2P3dei7J1KR+6HbjL/I8uHt+Ncu0xv7Ibvqn+Qdo/Tm8GO/ZLfyau+32/Wr1RVsIThlFaNqoYzilZALJoSqgoWmlocFLQK5VntBKofvc90c5PXe0QxDWht1GRGVrJrF4eQi0UCmoHOMKuscBIQ2rJkJKqZhuA580/ooVyK05OX+fU/CySXjoYNYjuwgv5EdiEfSJgzFZTzQL+LFpbhoP8KT9RvZh7xQHGARaQ/ULzDUJD71QpqQmlFmXnnBZkgWIKpcnmN5HmzsGlQGtnQtJMgN5dornPo8TlHStqg68paye/H8fSyuAhhAuIBSkdtk4iaFtHNdFMshaUhhT/6wwPjRteRm2pTbo42sndwdWkLVR0u1I9GwyXJKyF0dDeQBQqotp+CAtSznnbzoqMZy5sJn/itK+Dy5mhvMaGMiDaty6SzACggsUoCYoCUUb0gum+pk55ixawU5xawRJpg73BJIA9UZLOR86Ud3rxMLydRkipKT32G18hBr7phIzhXfE1rzySKwcjXVXIln6CF/icCX2tA3ChOMK0wEYgEDng1T5BmGCXDL3gkTQKjd8Q0CQbqWG0wD9oA08Eaa2/6SeCAXMFBlxJy+mpURs4yYZcQsI2YZMcuIWUbMMmKWEbOMmOdYy4h5HtcyYpYRc8rSqiK33fpHO7ZbsqQLWpHP7eZ5fHEPX4ZxPXbDxj1+755OSx/b7vlldA93ffvn/MUPQz9Yg5vffb9b/QVXIkeghx0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3104",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "691",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528060",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.58144284",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjckKwjAYhN/lP4eQpU2beBIVBD2UIngoPbQa2kBMpEahlL67cQNvs3zDVBMUrTmMVw0Kdr41pT6FxnVWA4LCGxduoKrpIyPCKeY5EwtKUiyYkDDXP245DM0Y4RisTXPRQQ+gCCYI9tp1oX8ZShOBoPShCcY7UBSnGcmk4ExkMsmliO3RnP/hrTZdH96eJAzBxurHd80ZlpzkCFbe+njm7tbO9RPABAct0wAAAA==",
    Pbi3DGeometry:
      "1R0AAB+LCAAAAAAABADtV01r3DAQ/S86u0bftjan0hYKzSGkhR7CHjbEJAZ3XbZuIIT97xG2dx3LfpK2vYqQD+/LzJs3Gmtm7l7JzX394+V3RTbkW3tff2+b+oFk5Kat990fsrl7Hf60ML2yX+SYTZ98YJRe9T/sNzluT2YfD4fdi7UVLJdcioxRlWuuTSZEToW0vy3AOBsApcV7QCixDmCLkusB0KWKciUkNf6olCnkDEA6zhwLC+QKkuOoguQwJapUPC4qqONErrS0AM9NweXcVQ9YC8rmOlyLieMEWNdLT9PniNpxNFHjmM4JOQFMMm9MkBuqm1NYQNDSJw9RQwasDuUjotZoqXsOQwtvHUzyCsN6gFPurTXsCgLhqKKVw3DDAt0SCbu6/DxcgfDMz+++Y4GvKlQl2FXwko6/3GAxhMsHAs55hAX+QxJjL5II5a4OG8VALjTrybXg3oZmgbGhcTPIoOM9WfK5PlUUcSd7QUYQBwhq6r5KDp5K7m/LPt0IKMdoJfvPTKFWc7E6dKqTBTVqoNaltz9AC9g4IEWw1FDnXQwQYXlOQvAl4ik1eKrruj3y1svA896julkPCc+YsEDgbKYLs55aNA8oUJtwEsFdplh9K4TUZl12iBr2MQwsJhHEHcwTXgQWZwFkwAkM5AkywzwhcfAyQCHBdx7PTCimS8XhgwAM0CDcK1x1KB1hCvcyTZto2kTTJpo20bSJxjXqtImmTTRtomkT9TaOtImmTTRtomkTDcxMaRMdPW0z8rne/aq66kA2NKcZua72j93T+HDbdruubvfj48/64Qx9rerHp258+NJUz+//8VPbtNbh/m/THLdvNqEcU9UdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "693",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528062",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.60852165",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjkELgkAQhf/LnJdldVZDO0UFQR0kgg7iQWnRgW03bAtE/O8taRJdus2b7/Hey3vIKjp1NwUp7G1FmdVdbQ0wyCwZd4c078fTGyRHxGQZiIhHiZAwsG8mg0X4l8Ux4g+bM0dWfKpXbVt2vt8/NlRelVMtpIILBgdlatdM4mhd6chPHuWZLjPaKaob9xZxGDHYavWcvCh5IEJksLba+lzz0HooXuykTeEPAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVd9rgzAQ/l/ynEliElfbp7ENBttD2QZ7KH2wNLQBZ4Zzg1L83xfUtpp6XByimO8u3/3I3WV1JMuNeT98aTInz3Zj3mxutoSSpTVF9U3mq2P768Rs4R5S0wtywxlbNB/3knp92nZXltnB7ZWRECKlnKlIpSqhQkZcCEV7eBInaYOzWAxwJmcNzrmkITwnfeXkY/yJk/dxNeNT/IHsonGF2sX88XlkOhpuB3tZA7M8tCr5bTyW/Qs+5DnjXhau9Vvvr/lb91EelN/zB4wLwgE/QbuD7OPh/tcdP6zB6eJeAj0RWMsoTyAOpQeqcVwf4g+zC5wi3nITaUJgqBTwDoX0Afogq0ChTR1eKE0IDDUDNNNwfYA+yCo0GfEJO5UnDId6H+1l9P7089DD3f3+YLJPXemSzFnEKHnRxa7ad4tXW2WVsUW3/DDbs+hJm92+6haPuf7tK97b3DrC4ifP6/UfcVLXuJEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3094",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3104",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10396",
    Length: "25",
    Mark: "306",
    Material: "Copper",
    "Middle Elevation": "3104",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "254.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "120",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3104",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3113",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528063",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.40661491",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1js8KgkAQxt9lzsuypq1op7AgqINE0EE8KC06sO3EtgUivnsDWm/Qbb4/zO+rRihbvAwPAzkcqcWS7NCRAwEloQtPyKtxPrmQyCTN0k2k1lKvdAaT+ENWf9Fb75uB+WzssLmbYDzkSioBJ+O60C/iTKEJyJNnecXbLzoY7HqGRFLFOhKwt+a9dOOYvSQTUJAl/ute1k71B391PSEPAQAA",
    Pbi3DGeometry:
      "WQgAAB+LCAAAAAAABACdVU1rhDAQ/S85W0lq4teeSlsotIelLfSw7MFlZTdgTbG2sCz+9wa1fm1mJ4oo5mXy5s1kMtmcyXon309fKYnJs9rJN5XJPXHIWsm8/Cbx5tz86mm60g+pnB65YZSu6o9+SbX9X3ZXFMlJr+WuYMxhVLj+rR85HndpwBzu8iAKalhEwu9hQVnYWFMeDmAjR2/MTcy+CNkA5qGYocPs8Hoodg4RHRMSEfiGEDt0lCUgFsDjJNWeSz3t44Klw8fBX5o3wnvz0eZgLBj5RMskJByHRAJuR1lHWRarmUY13lZApbn6gbxjxhZlju0omBVzRduxLDvikBLkEF2hRksCgO0qwixlnvW8dgPVGtZZ7FhwHKp8oHPZ0Sxsi1CfA64gM2zJguM2fRFr3VbWNazv6QeZfKZlWpCYutQhL2l+KI/t4FWVSSlV3g4/5L6bekrl4Vi2g8cs/R0a3qtMacL8J8uq7R9EVYqJWQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2769",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2769",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10069",
    Length: "316",
    Mark: "307",
    Material: "Copper",
    "Middle Elevation": "3085",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3162.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "120",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3085",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3085",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528064",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.98919497",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyG06SZiPYkKgh6KCB5KDxVDuxATqVEopf9usK0HEbzt7BtmJu8gO9OxvWlIYefOlDnTVs4Cg8yR9XdI8244gwG5jJVYxBHymcIEevaDSS4V4hdDTP6xKbOYqpdNU7ahPzzWVF611w2kEY8Y7LWtfD2Kg/OlpzB5kCe6fNBWU1X7t1BCMtgY/Ry9ieBzjAWDlTMu5NqHMX3xAv1sresPAQAA",
    Pbi3DGeometry:
      "mQgAAB+LCAAAAAAABACVVdFqgzAU/Zc8Z5JootU+jW0w2B7KNthD6UNLpQ04M1w2KMV/X6hZp+hNrohiTm5OTm5yT9Znstqpt9NnSQrypHfqVVdqTyhZaVWbL1Ksz92v7WZL+5CW/iM3nLHl5WNf0m7+ht02zfZkx4pIyCylnIkoS0VCkzjKcyHpFC5ZYnHJ+GIKh+JFlmdDXPB4Fo/TIxZyiGexmKXT8Qz1JBFjSeaZF+KB9EvOcTIDNP5pZSRTIcZpQ+ABni49PbzbLjy/w7vt6uGDPIz0gPhQz3W7xvrdui7pH00LLRekQeOBNE+fhgA9Ytf99Ngk+HMMlUqAB4rHlyKkB21VgXXNPYPQWfZbEsSD9gYw3l9beGtG12ig1iHPAKw/wAPFo68WSA/ea/3rwptJ/0oYlyPWG7wXy6R4e8/fq+1HacqGFCxilDyX9cEcXeNFm61RunbNd7W/dj2W6nA0rvFQlT/9wDtdaUtYf1dVu/kFLz4TaZkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "244",
    Mark: "308",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2442.3",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "120",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528067",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.83229521",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjFELgjAUhf/LfR5js6VoT2FBUA8iQQ/iw6yLXlhb2ApE/O+tMujtnPN9nGqEoqHjcEPIYO8aKvHstW0NAoPCkfV3yKrxG4OiuErSZCXFksdRnMJU/7R13+shuGHYkL6ixx4ywQWDA9rWd+8ipYoZlM5rT87O+ESXf7pDajv/6UJFDLYGn7O+UFwkkkHujAvn9mHMVL8Aewx538IAAAA=",
    Pbi3DGeometry:
      "QRwAAB+LCAAAAAAABADtV11r2zAU/S969oJkS7KUPo1tMNgeyjbYQ8lDSk1r8OKReYNS8t+nJVIW3elENuxRlJb65Obccz905Xv3wm7v+y/P3zu2Zh/G+/7zOPQPrGK3Y7+bfrD13cvpX/cxv3E/7FD9RV4Jzm+Of9wvO2zC117v99tn9125kqKtK8HVShlVV41ciaZR1SVuW3nEdXMJa+We/4WRda3tEW6dkzyL1kZd1cKlqGZoP9NTe8CD/EI9Ob/pLHAr7Cw5RH5r28gtb4+w4jGNh4N1EH+CFbcxOYEBCXAZkyAljYnDvyYEeQTR1EJe446F5FzG3CgaEDvqFR0UBlyAI+CL3LjeiCIyysxpItTrFEd6MiUlcFYljSrVApBlmRYUEShrMD8fXlIQehpBG2RpcvN07kwi9UY5g3gy85mZQQ4fijVzQgiMIkXKjYdFfXIqa5OkOQ1ZI4yH/VXTqPYPbqXXbkWqaWhICzMA2JEYbZv4PnTBzbknwbUKYeEzZpZnBt0ES0MC1bOKmDt7PMihORAJzIEYxII6LB1RrqZ0EOTnz2X1YDnSYmCVgFNkD1oJ9Wm2r+MXoiBeCpUqB5nvQaODI42Z+U6vg9DuWtepYjtYJQ4NdYrYs9c8fLWM3SYzg/IIz15aPEpwLjOkeCAz6Yhyb2hUCjjAKL1IzMKQ0llH5MAcVSM3w2i7p9lRZsr+Vva3sr+lLoKyv2G47G9lfyv7W9nfyv5W9rc5fV32t7K/lf3tf+9vm4q97bffuqnbszVf8Yp97HaP05N/+DRO26kfd/7xa/9w/uh91z8+Tf7h3dD9ujR8Mw6jI9z9HIbD5jffGnM+QRwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3104",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "695",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528069",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.05813244",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yziNqfTTlFBUIcxgg5jB1eyCaaxLBhj3z17g27Py+/hqScoW3MYrxok7HxrKn0KynVWA4LSGxduIOvpIyNCMeWCLxKSY5YyAXPzw5bDoMbIxmBt1EUHPYAkmCDYa9eF/mWShDIElQ8qGO9AJjjnhAuWpYwLWggW26M5/8Nbbbo+vD2hKYKN1Y/vOkuxyEiBYOWtj2fubu3cPAFWrGhm0gAAAA==",
    Pbi3DGeometry:
      "hxwAAB+LCAAAAAAABADtV01r3DAQ/S86u0bftjan0hYK7SG0hR7CHjbEJAZ3XbZuIYT971Vtr71W9SSbHnoRISF+O/tm3mg047l7Ibf39Zfn7xXZkQ/tff25beoHkpHbtj52P8ju7mX4135Mb+wPOWcz8opRetP/sb/kvL987fXpdHi235W54kxmjKpcc20yIXIqpMksTg0fcKXFFS4V9eLQvjDFgOtSreCRogyGo0whr3EQ/kTv2gMe4BZFE/OKkqBKxddEg6K/+FVaWpznpuBywdPj1p6y6/Ad85n+gkvxN8sEA6cOy+QUBjMl4YIzyQLRILdA05Ld4oKWWBRwCsihJJCCWDXRUvfshhaB054lFYb1OLeGuJogD8Jj4awUi8KMynLqIMqzMfmOLHC001VemsOGA0oB8sT669oGhQ49WiQIX2Y/qmtz3tZ1hbheJ/4/F7X3KzTr/WrBA/PH4uP84WYIn/bdhSmxlKWKYs0xrk0D4veHM09JJQeakoemZ0CtH2dqDFOyf8kOmBAbRYEjnO2pUYNXXQZaO7JHLR/RxyoKTEl3xkdVLbMAGwOuKHSEXrVYlffE8XUGBeINBr7toVJAL0xaMW8ywdiW/gIErwpgQEjJfEVvca/UsE8wfRDsvCgAl7GswHdvJ+sgdJRckBfkFbADTehyg2DQJUZnimLZJgklHtAj82iXd0SBHETpnX6YVry04qUVL614acVLK15IV1rxNqUhrXhpxUsrXlrx0oqXVrz/ueLtM/K2PnyruupEdjSnGflYHR+7p/HhU9sduro9jo9f64fpo/dV/fjUjQ/vmurXteGbtmkt4fFn05z3vwE3LfExhxwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "697",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5566",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528071",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.71170826",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjssKwjAQRf9l1rEkTd+uRAVBF0UEF6WLFkM6EBOpUSil/26ktSBu3M2dc7mcooe8xlN3E5DB3tSYG9VJo4FAblDbO2RFP56uwGjkBVHqLxcs8FgaxjCQb8qTJP6Dckb5D52XR1p+FFZtW3XOwz02WF2FFS1k1KMEDkJL20zhaGxl0amP8YyXGe0Eysa+A6OBT2CrxHPqcqcaElgbZdyqfig1lC/rISP4FQEAAA==",
    Pbi3DGeometry:
      "KQkAAB+LCAAAAAAABACdVl1LwzAU/S95zkqSfth2T+IGgj4MFXwYe+hY2AK1kRqFMfrfzWzd3NprbkrpR3Jy7z03Nznp8kAWa/Wyf5ckJw96rZ51qTaEkoVWlfkg+fLQflqYTe1FGnrumXDGpj8Pe5Nm9Wt2W9fF3tpylgRRkgk64VEg0iyjoX2HaUYvEZ6II8KTOBxGvGwYa+MwwdHeOm4D3mzHEYjR4cE0QxZzgBgc3jlpA0hLWcSRQIfBpxOm6c0wgR5y8nZGxni7ricmDoxc1LNHDKbcR3r1xKR5VRtM/rAz52z6pOOe54GlBu+1Md7wCDih4C5AWDgXtE894Y3rzxj2hUfgZQsLFMJmzOp0b5y+Do1h7ZZVBAIoB3BAOEeP0BkoAqzZfkydpy8CgVUEowjOE/t/hbf/HTNVvEkja5KzgFHyKKut2XWNJ20Ko3TVNV/V5gTdS7Xdma4xL+XX34F3utTWYfVZls3qGw1yGlkpCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3109",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10411",
    Length: "25",
    Mark: "309",
    Material: "Copper",
    "Middle Elevation": "3125",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3125",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3141",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528072",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.72415923",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5CYpkhdiQqCLooILkoXLYb0QcyTGIVSencDrd7A3fyYmWqAssVL/zBQwJFaLMn1ljwwKAl9fEJRDRNMASlyroTO1guZ8aVWMLL/mPV3fhNC06cPSdhhczfRBCgEFwxOxtvYzeRMsYmYbk/0irefdTBou7QiucgVg70z7zmqFBdarxhsyVGq9S/nxvoDVJL66BIBAAA=",
    Pbi3DGeometry:
      "LQkAAB+LCAAAAAAABAClVlFrgzAQ/i95TiVR46x9GutgsD2UbbCH0gdLQxuwZrhsUIr/faG61kxPrxVREj/vu+9yuYvLI1ms1fvhU5KEPOu1etOZ2hBKFlrl5osky2M1tDCb2YuU9PJmwhmbnR72JuXqz+y+KNKDteUs8gJxF9IJDz1fBDQIPc7jmJ4AJirADriLhL5fmcTTqYuAZGcTHvndbnzGXDLLEVyrDPQ/GCXe/bCuNlcUi+7wL0hrLcEoYQFuYgKPCdFJ1kSclekyqaJpIm4yUWSDXlrC3CgxQI9iyP2/xKDIRghrB+mmH5QMlxKcF5wNrmJw2YfXH6wMNNvIZtKTTkRtDvhBbageBLehYGU3mFzf6OBdi2pnWDJcccDtDO6aWLaR3blHG3xuwgiWDYfg+jPuSEGaVIj995irdC+NLEjCPEbJi8y3ZldPXrVJjdJ5Pf1QmzP0JNV2Z+rJYyZ/mh8+6Exbwvw7y8rVL7v09hItCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "324",
    Mark: "310",
    Material: "Copper",
    "Middle Elevation": "3099",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "216.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3099",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3099",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528073",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.28997594",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjk0LgkAURf/LW0/DfKFpq6ggqIVE0EJcGA36YJoJmwIR/3sTapuCdu++c7mcvIPsjMf2piGFnTtj5kxbOQsEMofW3yHNu+EMBc4iKiMRL2ZcUR4lMfTkJ5WUKSW/qFDzf3DaLSaBZdOUbbAIjzWWV+11AymjjMBe28rXYzg4X3oM4kM84eWDthqr2r8DZ0oQ2Bj9HLtS0EQwRWDljAu79mFMX7wAMVFTThUBAAA=",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABACdVlFLwzAQ/i95zkqapK3dnkQFQR+GCj6MPXSsbIHaSK3CGP3vRltns94lXRkbS799X+67y122OpLlRr0c3nMyJw96o551obaEkqVWZf1B5qtj+9XAbGFepKH/T2YhY4vfD/MmzfqPdl1V2cFwQxYHgkWSzkIZhHGaUMGDlDNJfxAeCWEjCe+Q+CqyERHF1K0mJOcIJ0okvA+O4LFN8eOIwFYTAeMy8iG4mp0Dw2GpgDLaR8Y67UXQqZknUgor151aDzlT6yGnyrV+IE7rB9jHoYYijtjwCGy1YRUAjmMf20+vCpMiQBE8grPKDSPATxXEQc+b1yneJZflzZcdqH98ajgHcurrYKg+eDeiiFcN8ONA8BPim8q4mn+Sj+P4Ti8w4x3I2F4Yqk2ZO9C94FPDOZfdgHhs+N2IIz41yA+O4L09du6Mu9EhP+Z/ya3K3vI6r8icBYySx7zc1ftu8aTrrFa67JavanuC7nO129fd4q7Iv/o/vNGFNoLlZ1E062+GIsuLSQkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "343",
    Mark: "311",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "229.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528080",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.84717714",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgkAURf/LW0/DvPkwtVVUENRCJGghLrQGHZhmwqZAxP+eKO7uuZzLLQbIanPr3xpSuPja5PoRKtdYDQQyb1z4QFoMS5wUZBGVMee7DUrKlYCxXL1911X9JE/F0VQvHXQHKaOMwFW7JrQzoCCQ+1AF4x2kgqJElfBICRUn20Qggbt5Li6ijAictWnaMDOTnMDJ6t+6lhQVgYO3fnpyX2vH8g9loyxs0AAAAA==",
    Pbi3DGeometry:
      "kREAAB+LCAAAAAAABADtVl1rwjAU/S95rpIPW1t9GttgsD3INtiD+KBYNNA1w3UDEf/7grZzmp4mDT6NIn7E09x7cnM/znRHJgv5uv1IyYg8qoV8UZlckoBMlMyLTzKa7o4/NUzH+kX2wemfHqN0fPjQb7KfVdtuNpv5Vu9lNOoPooQHPTbo8zhJAqG/RZwE50goDkA44OeAoCE7IJSziy2UJgAp3bBIW3W01uAHUWsggJGjMRa6MuYs4gABpvxZ1Ryx9H66sJhX8eL83FiF8HgYHxkPxQXCYg6QigC7BEpjXETuBLAbTK0KJk+cjVERNxMwScNz2k9TYwwibWIDcwByxslhTxt80R7HNG8Apzq25lAe+KDYD+aGK9pA3HPNo9pOyQ5ainPSGD3ItWnZGeHGaCD2WsblDxGzlPDEwNYcpkyLmWXn1jBoDcS9o9dUIEZg14B9xrBlH0/wmPZA49C4j1prcrrE3180tGhLDu6vKDTayzyPieGlQK6qM66qJnx0hscwhVt8Jowtmp3K6FRGpzI6lfF/VMYsIHdy/p4W6YaMaJ8G5CnNV8W6XDyrYl5IlZfLN7n8hR5SuVoX5eI+S7//PnirMqUN5l9Ztp/9ACzZsBGREQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "702",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "402",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528081",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.09528699",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUELwiAcxb/L/2yiU9dmp6ggqMMYQYexgyvZBNNYFoyx754Vg27v9/g9XjVC0ZjTcNcg4eAbU+pLUK61GhAU3rjwAFmNvxgVSlLMiOCrBeU4EQymevbWfa+GKMdia9RNB92DJJggOGrXhu4DVKQMQemDCsY7kAxTTkWepIKJLF/mjCI4m+u/vNem7cKXucgQ7Kx+zWuOKc1it/HWxzP3tHaq321R0XHTAAAA",
    Pbi3DGeometry:
      "lSAAAB+LCAAAAAAABADtV01r3DAQ/S86O4s+LWtzKm2h0B5CW+gh7GFDTGJw12XrFkLY/15hy22l9ZPsTY4iJJvd2Zl58+Z5pLl9Jjd3zdenHzXZko/dXfOla5t7UpCbrjn0P8n29nn815rptf0hp+LfJ1eM0uvhj/0lp93k9uZ43D9ZX0bLjagqXVwxueFG80LYV1mKwrMwQ9VgoZz5Fk6rat4nYlFiMJSyLBYCmIIxpc1iaC7aGh/B1Opo2CeNbaZSmMfRxoQJaQvJ4SXjfjBmv+FbJp/JIqiSHugZn7NokhsP2kvSCGnrivtMTM/4hNCW+IR5cKER1BfkEaWepy1Sjpa+BoRKyeYFsaDQsDZXPB2sVD5jJZUpyyUKgCyj+nEobMEE4GKkPx3sa8jm2bTDWkoGS8/umXZiS6gNRCb6PK39NSMDFR/hC1pw8aAWbiZclRkMlRgZ5pWqRg8uB+ptkjGSoFN2NVp4xRITM5JFCGcx2nfR3O+WpioOLDKw2eTiTm2pQhnB4xzeACbEFgZPdBIyFhH4gmciyA9JjhyLmH7cS8g/bDKOBQ/f9d1HHguaH/YYax/FwtzDPuKJgBWWFtK5XhEADBk/4JAXnH4B5PDZSzcM3jxtNhk8FJq7I4yOh5vWqfsyN9V0hyrHBlDjhKGcQVtIC69d+AyNAECguUNm1WOCCQtdMDTMJ9Y5pAbfsDE0HA23DV+jINN4zMB+4vkDGoBxxepPi/Nc0JAziBm6XNJnmAVxiWUWAQbrz5t+3vTzph+f63nTT2gzb/p50/fIzJv+3K0+b/oe4rzp500/b/p508+bft70Z3HlTf+VNv1dQd41++91Xx/Jlm5oQT7Vh4f+0b353PX7vukO7u235v6v6UPdPDz27s37tv79/xffdm1nAx5+te1p9wdCAXM1lSAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "703",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528083",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.67515951",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImkebuhIVBF2UIrgoXUQNbSAmUqNQSv/d+gJ3c4YzTDVAcbT7/mogh2042tKcovaNM4CgCNbHG+TV8ImTQonEjAg+n1GOE8FgrH/eout0P8lTsbL6YqLpICeYINgZ38T2BVRIhqAMUUcbPOQUi5SkSrJEpopnSkoEB3v+lzfGNm18MxcZgrUzj++aJVgRpRAsgwvTmb87N9ZPUeDgWdMAAAA=",
    Pbi3DGeometry:
      "ryAAAB+LCAAAAAAABADtV8uK2zAU/RetPUFvS5lVaQuFdjG0hS6GLDKMmTGkcUndwjDk3+vachw/jqQEZidCQpyT+zr3Id37V3L3UH5/+VWQNflcPZTfql35SDJyV5X7+jdZ3792XxuY3jYvcsyGX24YpbftR/Mmx00v9u5w2L40sozqlZBWZzdMrrjNeSbEiiplsv8Il9x2iBJjQDMORCAiqJItIphSYwQ7cNJGjYlzbVAWL6LzS3VBkQi/ZsRgKz1lzFIVScxJG9M2zwRfWW74WGaO9E6fkJzLgLbBtx6h1l5tZyLTxMO0HjMd8i1KxmMH84bZucbOmLcGaSyH4jnJGClbRLJQ6VyhDFZbhJn4DhkAxmRLmhE6FrmkCDDRQTpD1bGEeBiYhjMMCclsp8154Bl4sKI82sLzG5q5YBhFVBQEprmJCHPebGE659rCiIeBSThc9SKiS7R2v+e6E+Cady4r7sJUuemQ3LIWsfmiY+dzCFlREwFFxdhfzl0BCmtCjkHzg7am4Ntq5pN2mh3snmuC85nnioHzc5ZLTBksc48yZB+RjKsP0e/JpKcugPlwWmbn8DXpxzIw/Z4kR5iZKgvRj2ccTMxCjoPN57kKz0sJtSW0Eu6+hYZB2jz3atix+C6qTL5MmtBcucowXZiSB2/PzIVJeSei3GBqtI9zxuziCXxe5xHXhtlNA7mszKSbZG8fimDHMJke/hEznvixZ0hZMGX4RjtnGc8ZnE08TTwZwL7BcHCeUTVj0rDPETLxicZmws2xtEIiOz4K0tp/oa609qe1P639ae1Pa39cRaW1P639ae1Pa39a++O6L639ae1Pa39a+99m7d9k5EO5/VnUxYGs6Ypm5Euxf6qf3cPXqt7WZbV3jz/KxxP0qSifnmv38HFX/D3/4/tqVzUK9392u+PmH+9vjtqvIAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "705",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528085",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.66736309",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAQhf/LnDfZdZTKTlFBUAeJoIN4MFp0YNsJ2wIR/3sbmlCXbvPme7z3shbSMx2bm4YEdnymlE1TsgUBKZN1d0iytj+9IY4ClDhbTFQUqHk8hU58wTBE/A9RSfyFY2wP80/9sq6Lxm/wjzUVV+10DYkMpIC9tqWrBnFgVzjys3t5osuItprKyr2FklEoYGP0c/CiHxoLWLFhn2ofxnT5C71quyIRAQAA",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABACVVslqwzAQ/RedFaPFDrZzKm2h0B5CW+gh5OAQkQhcq7hqIQT/e5XaaRZ5OhLGi/SkNzOa0ZMXezJf6dfdhyIleTQr/WJqvSaUzI1u7CcpF/v+08Fs5i7S0VPPhDM2+324m3TL47Sbtq12bm6WJpLJnE54moi8KKh0b5kX9ALgU3EA+DSTo0DEDMZ6G0zwQKrBK5/KtQ/9WaBlKDrJMj7uEmgZWygf6H0VWSoCTYSGIYSUo7Y94Eh1AuKprrIXYAMEzrPnuQT66gHX2QuI7jIXAVGDTNgChoeBrqxfUuBOiqcKBaA1hOocH48VbXj2wD0Z6ypIFAqAtQlKDj4jvgbRjeFJS7y7qEKiwLgejGs8NjZaOwB2UHpjXMSOTBQApSFgo2OH7L8y7f4R7nT1rqxqSckSRsmTajZ2OzSeja2sNs3QfNPrP+hB6c3WDo37Wn2fD7w1tXGEzVddd8sfINkpHdUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3109",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10411",
    Length: "25",
    Mark: "312",
    Material: "Copper",
    "Middle Elevation": "3125",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "110",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3125",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3141",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528086",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.37169446",
    Cost: "0",
    Pbi2DGeometry: "BgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xgS04jUlVRB0EURwUXposWQDsSM1CiE0rsbaPUE7v4X8001QNniJT4M5HCkFkty0ZIHBiWhD0/Iq2GSaaAzLrPNQmZ8qRWM7K9N/UVu+76JiZuCHTZ3E0wPueCCwcl4G7rZnCk0AdOrk73i7VcdDNouISQXK8Vg78x7nirFhdZrBgU5Smf9y7mx/gBdiMCUBgEAAA==",
    Pbi3DGeometry:
      "xQgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynMrFH63ap7EOBttD2QZ7KH2wNLQBa4bLBqX4vy+rrlPxmisiisnnfd9dLndxdWLLjXo7fkiWsie9Ua86V1vG2VKrwnyydHWqXy0Mc3uxiv/PTATA/PywN6vWf2Z3ZZkdrW0UegICn09E6PlxkvDATog45r/AbBo7ADH1aRaJL2ogCmhMqFPheTqASNCUL0Q9BYhnyaBLqDLGhAdR++oDIETkdSVKBx5E0dB6tICu+JBFn6qTO4oECrRzR3EJA7q5GzLox9DOBCVmlAgF3FT96Gg1gUpQLDAJZ0qJ64dscBLNiAJCvEGrBAVIRAQA25DuJnOVaEQbc5cI2t56AJGJAiD1j7R0Es2IIwPxxn3qXeMf1R+xsnR2iptbSysE+0+wUNlBGlmyFDzg7FkWO7NvBi/aZEbpohm+q+0FepRqtzfN4CGX3+0P73WuLWHxlefV+gdLvfC5xQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "324",
    Mark: "313",
    Material: "Copper",
    "Middle Elevation": "3099",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "216.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "110",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3099",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3099",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528087",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.25585145",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkT2vrSVQQ9FBE8FB6qBjaQMxKjUIpfXcjbT2I4G1nv2FmshbSszk2Nw0J7PBsUrRNiQ4IpGicv0OStf0ZDFNF2VxEiwmXlCkloSO/oKJ8FkffkMeR/AfH2HysX9Z10YQN4bE2xVV7XUPCKCOw16701SAO6Atvwuxenszlg7balJV/C86UILCx+jl4paCxYIrACi2GXPewtstf97mzgBMBAAA=",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABACVVt9rgzAQ/l/ynEqMUat9GttgsD2UbbCH0oeWhjbgzHDZoBT/94Wq06DXnEjV5Lv77lfu7OZC1nv1fv6SJCfPeq/edKEOhJK1VqX5Jvnm0rxamK3sRWra7yxCxlbXm/2Retup3VXV7mx1YxGELOJ0EUYBEyKiEQ+yKE7oGLBPlkVXIE2W0wCoIdxtLuI5RL1PbJlmLpByMcfZQXjC3eZsimggDxKBUWQ8xDiLofIYty9Jlk6k0AtgqIS73VUPaaEH2uoNTLsJmfAJBIS73VXPjWEg39RiwjQYNUiFBBAp9x1nkApsGTDpYxvYavgPAtDdN2lAefz0ALxB9pA/LOTJGDX8REbBSeChAjXmTBvP0Z8z6pBdhGkWoIGBqXyTBpTHT33AG+S30R/W7AEHdid2Zsz/aDYa9j/Cg9p9SiMrkrOAUfIiy6M5tYtXbXZG6bJdfqjDP/Qk1fFk2sVjIX+Hgve60Jaw/CmKevsH59AnptUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "343",
    Mark: "314",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "229.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "110",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528093",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.38424738",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv17D322mdhUVBHUhEnQhXswaOlhb2ApEfPeG4t35Dt/hVCMUjb4NbwU5XFyjS/Xw0rZGAYHCaes/kFfjEoMiOGWYpLsNchoLBlO9avu+l0NwQ3HU8qW86iGPaETgqmzruxmQESidl147CzmjyFFkcSKYSLNtxpDAXT8XF5EnBM5Kt52fOeIxgZNRv3XNKQoCB2dceLJfY6b6D8zy6ETPAAAA",
    Pbi3DGeometry:
      "6RAAAB+LCAAAAAAABADtVltPwjAY/S99LqQXNjZ4Mmpiog9ETXwgPEBYoMlcDU4TQvjvVtjQXY5tCQ8+LGSw9tDzXfrdpjsyWajn7VtCRuReL9STTtWSUDLRKsvfyWi6O74amI3Nh+zpz06PMzY+fJmH7GflsavNZr41Z4NBXzIZ0R4f9EUUx1SaXxnFtAIE8rAfDERlX7KAHwAmePUAY3E7UIjgoaF0osIygFJYNgSOTDxwU1XwULQD7Tzn6tO0rBB8uh8elj4SosJUAiIaRkdVh7IK8Ei0A6VsLluZhAxdZUMRUKnSfyJ2ZPr2zF+yG9oi86xWNJkQ4O4QdN9IWRgH1gCBt+ptXcPlMJohlT3+oX1QBtQK5modcI4p71w6xXN7nXANj3pZcatCVl1glasD1iyFaY2ARqbAmg+p7F3CueFYtcLtsQ441+VmekEA1QJUO+pE1uaCrLO6FvrDtUHaQtDu8HNbvHOhsUu+1FDgO4N51/wzhoXLzQSXa/3+M4F3D0QH/DuExYHdRNBNBN1E0E0E/3cimFFyo+avSZ5syIj1GSUPSbbK18XiUefzXOmsWL6o5Qm6S9RqnReL2zT5/P3Ha51qQ5h9pOl+9gUBYPIM6RAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "710",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "402",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528094",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.56216687",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjsEKwjAQRP9lz7E0TVLbeBIVBD2UIngoPaS6tIGYSI1CKf13o1LwNjO83ZlqhKLRp+GOIOHgGl3ixSvbGgQChdPWP0BW408GRPCI8tWC8igRDKZ6htZ9r4ZAhmCr1Q099iDjKCZwRNv67mOoSBmB0nnltbMgWXhFRZ6kgoksX+aMEjjr6z+8R912/uu5yAjsDL7m67CEZiHbOONCmX0aM9Vv42gWNtAAAAA=",
    Pbi3DGeometry:
      "Vx8AAB+LCAAAAAAABADtV8Fq3DAQ/RednaCRLMvanEpbKLSH0BZ6CHvYEJMY3HXZuoUQ9t8rbLld2X6S3d6KWLJZezTzZt48W5q7F3Z7X39+/laxHXvf3tef2qZ+YBm7betj953t7l6Gn9bMb+yHnbM/d66I85v+y/6x8350e3U6HZ6tr8qvhZAyuyL7w2iRSfs/L2R2aSDDVW/ggjyD4GW56IENSvb3i7zIVmGPkUhpszIpF2q9hyS1MRT0iGY1LxBhOKpImiLICDeq9CORXeAZRg9noNzLdb5+Gkhr5aX0lwBU5iK0fmR1vn6SUHT9JD6sDCW6Mb7t9iJBsAAboPCbLFVQFf8QCckI6m6t6EmR8HkqeB42bOwz4hUVjQUDESDhsIaStC8awycETh5QLPtoqOibd949aJjoAOkG3o9JfO07ANQcYAk9dbBmJA/h7pMpTW8o5aBkwYdshch7ui1Ef79QI7QaDKKk8JsPQpDNbTAY7Xlw7TdIcxXKCUOr0cHtsbmiJQXM9160WY+p2gxEuHeIJyjkNdKfgENmgdAQ4YHeARUgZBgJbZhbew3XR1s9aSkEAIEw2VACy13A7YxKZlYDhIbJIgxEB8aOZ+s/XPEOofOg5EXuESWpdBsRH3YorcPHV5JiPO0UA+fc9Bj2tTgwKLTNZtX5CO2CAXCQLpEDl1wZDwN5wKwgiVDOkBFYOCwDhcIe4NCDqIWnbdQ9+JaAjIOMcM1RCc5Ei1hCuUKHrS1FCJA+rCYEActOo3QapdMonUbpNEp7hKdROo3SaZROo3QAOY3SFxJIo/Tlw5VG6TRKp1F6gaX/dpTeZ+xNffhaddWJ7fg1z9iH6vjYPbmLj2136Or26C6/1A+/Te+q+vGpcxdvm+rn5cLXbdPagMcfTXPe/wJJUHdVVx8AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "711",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528096",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.06583841",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPoI0mbuBIVBF2UIrgoXVS9tIGYSI1CKf134wvczRnOMNUIxVHvhyuCgq076hJPvrGtQSBQOG39DVQ1fmJQOKMxm89iRhOewlT/pEXfN0MwQ7HSzQU99qAiGhHYoW1994KYi5RA6XzjtbOgYsqzKJMiTUQmWS6FIHDQ5395g7rt/JsZzwmsDT6+6zShMpKSwNIZF87s3ZipfgLf2Sce0AAAAA==",
    Pbi3DGeometry:
      "9x4AAB+LCAAAAAAABADtV01v2zAM/S86u4Y+bSk9DWuBAduh2AbsUOSQokZrwIuHzBtQFPnvUyM7iW09S+lpB6Fo05DiI/lIffD+ldw91N9fflVkRT63D/W3tqkfSUbu2nrb/Sar+1f3r1XTa/tD9tlJcsUovT78sb9kvx7MPux2mxdrq2TOtOTZFZM5NyXPhMipUjqzClqWyimUGMmN/fQaIAWTB7FgSo3E0PMRiGodE9IJKdKAU34ZEDIIRzTlAnnoSWKGqigujkCsMGUmeG645iOLmWKI9agouVyEGmIaxNSY93mYWNgsWFGMeA3EFGEBfWCmULjv8CHHYiHNYhbDei3lQSzZcnNciOPvpTB8bNuf5Mz6eiNIiyJOEV1oROkyc4HiexQ450kKp70umXFQzjk+r1C7YKjgoYtcRJ4nyw3jl04qEM5qtm2CzM2gggqU7zgFqoflwtWycJkx5qQFd4Eq3qfGHQwvDTsoTOmL5+wM8TuguijH6xUVZ2Fy3veWMHo5IOB3wDGFa1F+vjmmNy2+socweamY/16bVQwxhDoXIkHfgFLYXYhrTB5iG3gOFGF6P15YY7TcW2H8yAqgT2ACHMNzCZI/q2JwK+EH56xTQFmAh+Bmmj84ERJ4ufo3H3zzGSG9HLG3ha722iUm+fLzVPRkF5Q7A+VOlYKzcXmY8d2Lp9aNuMEnvkGszCKOPcjeNTKAr03IH6AbkQEdwIgQUqg+8OE4ZRWdFLBu4ExAZOPnFSwbkqNehSSBUEPrY6sJ4IMdP5+8YJVhymk0TqNxGo3TaHxB26fROI3GC1ml0TiNxmk0TqPx8lZKo3EajdNonEbj/3I0Xmfkpt78rLpqR1Y0pxn5Um2fuuf+y9e223R1u+2//qgfj6pPVf303PVfbpvq7/nCj23TWsDtn6bZr/8B5Lpkr/ceAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "713",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528098",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.02770659",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz7Ek6R/WU1FB0EMRwUPpocXQLsSs1CiU0nc30lrEi7ed/YaZyXvIKjx1NwUJ7KnCjHRXkwEGGaGxd0jyfjydIfIkj+LVQgSeWIYxDOybCRnJv8wX3P9hc+bIik912rZl5/rdY4PlVVnVQsI9zuCgTG2bSRzJlhbd5FGe8TKjncK6sW8heCAZbLV6Tl7fzQwZrEmTSzUPrYfiBT22pqgNAQAA",
    Pbi3DGeometry:
      "gQgAAB+LCAAAAAAABACVVV1LwzAU/S95zkqSrnXtnsQNBH0YKvgw9tCxsAVqIzUKY/S/m9nqujbXm1D6kZPbk5P7lfWJrLbq5fguSU4e9FY961LtCCUrrSrzQfL1qf2002xuL9LQCzLhjM1/HvYmzeb3t9u6Lo723zQSLL2hEz6NxCzLaGzf8SyjfZyn4ozzNIlduLc9Yy0/E9yLp9Mz4rHDM5x4LQpsKmYJd4qBFkWcM8JbkSKZCi96P/lcWDPHsiO847ngoTzXscL5IbwXq5EYSOQQH8QK39SV7/G9QjSIz3zlY74cpQ5UJ6E8fjjgNiCTUWskMX1jBZVbmEaIxQ+HEhBqIqh9aKZhiT/sFqE6sWaH4M4qd7ZpxDKwH7iZoQ7qrw055xAcqne8fpFz8b9ea8/zhSrepJE1yVnEKHmU1d4cusGTNoVRuuqGr2r3N3Uv1f5gusGylF99wztdaktYfZZls/kGOL3g9YEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3109",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10411",
    Length: "25",
    Mark: "315",
    Material: "Copper",
    "Middle Elevation": "3125",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "112",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3125",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3141",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528099",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.14248146",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xjSpilaV6KCoIsigovSRYshHYgZiVEopXc30OoJ3P0v5ptqgLLFS//QUMCRWizJ9oYcMCgJXXhCUQ2TjIOciyxdrRdJxlMlYWT/ruovduN900d2DHbY3HXQHgrBBYOTdiZ0szlTaALGdyd7xduvOmg0XWQkXOSSwd7q9zyVkgullgy2ZCmedS9rx/oDVuZamgoBAAA=",
    Pbi3DGeometry:
      "hwgAAB+LCAAAAAAABACdVVFrwyAQ/i8+W9EkprF9KttgsD2UbbCH0oeUSitkcWRuUEr++6RJ1yTzqg0hIX6e332ed+fqiJYb9Xb4lGiGnvRGvepCbRFGS61K84Vmq2Pza6fp3D6oxhdkwiidnz72RfX6vGxRVfnBrk0JpSnDE5aQKBMCxwlhLMuwxadieh1naRRiL3gD8ziEBVKTROKEx5Qzr1dOhKDZKLeBOMRzlhlRKkK25eQJlR8TyrkjChe879ZhP+DpnpWfHcL7Z+VX0w+yR+UwOP/dNrH3b9bpFqb30gx2FZL3ELvf3s3uOb8BBxQwKInDeMYXCaTn1uIM4xmXCHBtBrF4xAPmcFJCfcWJh9L4cajCoS4dxjP+FoD0eO+wq/zjO6C7Dj0d4bb+0VFub/V7lX9IIys0o4Ri9CzLndm3gxdtcqN02Q7f1fZv6lGq3d60g4dC/nQN73ShLWH5XRT1+hca3ya2hwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "324",
    Mark: "316",
    Material: "Copper",
    "Middle Elevation": "3099",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "216.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "112",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3099",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3099",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528100",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.65470959",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjlELgjAUhf/LfV5jm9PSnqKCoB4kgh7EB6WhF9YWtgIR/3sLNQiC3u653+Gck3WQlnhqbwoS2NsSU6vbyhogkFo07g5J1g2nN4Q0XoTRcsYDyqQMoCc/mKQ8iudfLKKcMfGHTZn5VL1qmqL1/f6xweKqnGogYZQROChTuXoUR+sKh37yIM94+aCdwqp2b8GZFAS2Wj1HbyBoLJgksLba+lzz0LrPXyCUZ7wPAQAA",
    Pbi3DGeometry:
      "mQgAAB+LCAAAAAAABACVVV1rgzAU/S95TkPUqIt9GttgsD2UbbCH0gdLQxtwZrhsUIr/fVl1VWuvuUX8yMn15OQm52Z5IIu1ftt/KpKRJ7PWr6bQG0LJwujSfpFseWg+XTefu4vUtENmAefz48PdpF79/3ZbVfne/ZswzpOAzoKIcSEiGoVMRnFCR7h7cxn94alML+JQvAjlEA9FjOdp9cRMSn4zxNNQ4HV28xrqcXjIL/B08RAPpF/GCJl+mulhBQsS9zFKmw/38zTp6eHtcuH4W/y0XL1xB3kY64HwoZ5uuYb6u/hj+sfDQtOFaHC4J83eXQvxQK6A0nzGj06/f9kh907zQPH46gDpwdnFPy/cfjhz9TidgNknWaBwdCmZ3OL4AoZyit8RkEGhOjvNA8Xj6zikB3fO+ed1VQGDnIiuDNeef028O+fvdf6hrKpIxhmn5FmVW7trGy/G5labsm2+682p61Hp7c62jYdC/fQD70xhHGH5XRT16hcTULComQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "343",
    Mark: "317",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "229.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "112",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528106",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.08456692",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv17D322a6yoqCOpCJOhCvJg1dLC2sBWI+O6J4t35Dt/hlAPktbn1bw0SLr42hX4E5RqrgUDujQsfkOWwxElJaIxZutsgp7FgMFarte861U/qVByNeumgO5ARjQhctWtCOwMyAoUPKhjvQDKKHEUWJ4KJbZZmDAnczXNxEXlC4KxN04aZIx4TOFn9W9ecoiBw8NZPT+5r7Vj9AWXOVM3OAAAA",
    Pbi3DGeometry:
      "QRAAAB+LCAAAAAAABADtV11rwjAU/S95riUftrb6NLbBYHuQbbAH8UGxaKBrh+sGIv73BW23GnNMIrKnIlpzmp77kXvv0cmWjOfydfORkSF5LOfypczlggRkXMqi+iTDyfbwVd2mI/Uiu+AP6TFKR/sP9Sa7afPYzXo926hn45DTeBD0WD/kSZoGQl1FkgZtPBJ7OOrzNixoxPY45exoO6WpEa/pWaz4HHggv9kdaBbhBxoWufjIWcyNuJHkMk9OAqptNsfB0iYvnLdpGpwng+Tg40Ac4SzhRrwxy4SJhovYzSyiR+40KeOpEw0VyTmzupsgKpv3JzQAd80COFvgJTpyWymgI/QMSs8xKljEYy1wFBbiR/6gLtRw19rx7JSmZI3N71gI2qRwGSs2L9DI0nBb/6F2BbjeCGhqIx7rlHdUC5s/UNQ03HW6nvQOwkGHg3mgsdikAQRlSyZKgpusWQrNluHLBNlxdFiNXkXA/X4geU5tb12/kn5fSad99dtTusB23wl/Pmedenfq3al3p97/p97q//idnL1nVbYmQxrSgDxlxbJa1YvnsppVsizq5Ztc/N56yORyVdWL+zz7bm+8LfNSERZfeb6b/gCKcZH0QRAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "718",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "402",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528107",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.3493479",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjUELwiAcxb/L/2wyp65pp6ggqMMYQYexgyvZBNNYFoyx754Vg27v9/g9XjVC0ZjTcNcg4eAbU+pLUK61GhAU3rjwAFmNvxiVDCcsFasFYTjlFKZ6ttZ9r4aoxmJr1E0H3YNMcILgqF0bug8QnlEEpQ8qGO9AUkwY4SLNOOW5WApKEJzN9V/ea9N24cuM5wh2Vr/mNcOE5LHbeOvjmXtaO9Vv3heGDtEAAAA=",
    Pbi3DGeometry:
      "SR4AAB+LCAAAAAAABADtV1Fr2zAQ/i96dsNJsmQrfRrbYLA9lG2wh5KHlJrWkMUj8wal5L9PdeTVivVJTp9FaVOfL9+dvvuk090+s5u79vvTr4at2efurv3W7dp7VrCbrt33v9n69vn0r31N1/aHHYtXyxUnuh7+2F923Ixfe3c4bJ/sd/WKCy2KK16uhKlEIe1nqWUxsXNDarCT4FO7oLoO+UO7koNZl7pYEHaE4aoyi9JxOEv9JVcX4SD/VD6zdQF8Rw+XRkMa1MqYuvJhuH0/tY/+L3a9olIYL82Z/xlOTaWXzlvgrb2ueNR/ZHPmP01nif8UHy0rkudF+LYspOb04PQ558ovrlQRLbwZBkgHKW2Zwu1Suc+NttqI2C+sLeASLBYqBKEjjlH2tT2WPIUYMnAjRhSewkkdp7NqIbtfdCARYE7JeOkuD68VcwN2FVorkIJ0Zm5qM9hrOQhWSHlyF+XAsIV/Met6jKpOdmENkTMNwlPt7Kaa+nPyK1KRQtlEoqrR3bXJUvFAuWfdEzTbMUcbXMQqFeQGq3WBuv24iEukqCDHEdZAyYNhEQzoepdVFnunCutXEIGHUSC/qN6Ad1i/lD7Os0dxUZ4AH7AAwybT9HZPsiTg6iZJl564y8q1Ejq1mKqKXTFJqvFyok8kk5GD+ow75iqbx4LLDGhhOG44T+IuriRlvAMw5I/zQbxBzQIa0HJR+kGciD+6nwTpxFfhYLXw9kcko2zgalNiOxcnYAekidwvqSFAx5xB5QB4tNg8w+YZNtHN8wybZ9jXVpln2DzD5hk2fXnJM2yeYZcUNs+wc/w8w+YZNs+weYZdMsNuCvah3f5s+ubA1rSign1p9g/9o3v42vXbvu327vFHe///1aemfXjs3cPHXfN36vi+23UWcP9ntztu/gHlKnVuSR4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "719",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528109",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.21582687",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImzZt4kpUEHRRiuCidBH10gZiIjUKpfTfrS9wN2c4w1QDFEez768ICrb+aEo8Be0ai0Cg8MaFG6hq+MRJEZQlsZzPooTGKYex/lmLrtP9pE7FyugLBuxAMcoI7NA1oX1BlApOoPRBB+MdqIimGcuk4LHIZJJLIQgczPlf3qBp2vDmJM0JrC0+vmseU8mkJLD01k9n7m7tWD8B4qa3JtEAAAA=",
    Pbi3DGeometry:
      "Nx4AAB+LCAAAAAAABADtV02L2zAU/C8+e40+bSl7Km2h0B6WttDDkkOWNbuGNC6pW1iW/PcqdpKVZY2kHHoTISGevIxG854+3v1rcffQfX/51Rar4nP/0H3rt91jURZ3fbcbfher+9fpq/mZ3JpXcSjfkBtKyO34Yd7FYX3+27v9fvNi/ltXRDW0vKGiYrphJecVkVKVstKKiAmX3Ia1arzhXtzQC6ZHnFMpbRwNe+EhSsXk2DRJ4ZTIdBYQnqDFsQCwX6yhmsioBRYPrXVTclZpppgd7+JnmRe8YQLy2HrOONH6av5FvNFP69p2M6wnEo/5oT/Ah6v55/4YnAsd0P8Wr4QYcUFD5XAljbd6EuhTatyGKRWjOYrXKXhicqGZEdPCOV/icLa2fHtJC6onHjNuYDvy1kiAJ7abAvqkLSOhRgBse58wKXehxExzeWI4nK0l/zjsOZxPKazHSVE+BbOaTSIlmyZlHB/xRtMR141HjLVbLNmPqJbzaEm4LZGxUz1xrYJqfKPaPLqeypLNVsPs9AycwmeZrJHUe2K5mQLmgHKF1Y2G9XuJysnnccAz5LF/1Jjzs1Pv2swG4n2ZDdyXovRzmrDDaBdCzrv5i60deGd0x/VnxMeesHYWV0bAg66eYK2h65uu2dKc41FCTvFMTZMSLHTFNFvdNCnCpnA5biC1U/NUe867S7XGj2XnFPdqJFo6a0GMo6JwdGFEjiGDgQVwrkCNnyaWD3T7c5yE+wFIFFr20GIkB6gHCfTXJLQYqYzGp2UQ0UeKe9EoAXo429y65tY1t665dc2tq+9un1vX3Lrm1jW3rrl1za1rbl1z65pb1yvo/2Prui6LD93mZzu0+2JFKlIWX9rd0/B8evjaD5uh63enxx/d4+WnT2339DycHj5u27924Pt+2xvC3Z/t9rD+B0BMjJE3HgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "721",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528111",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.17324342",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0TUpjPYkKgh6KCB5KDy2GdCEmUqNQSv/dSKsXBW87+4aZKXrIazx2VwUZ7FyNuTOddhYI5A6tv0FW9OMZDDPGacrn8UJQziWHgfxkgsn0i8mEyz9szCzf1cu2rbrQHx5rrC7KqxayiEYE9spq30zi4HzlMUwe5QnPH7RVqBv/EiwSMYGNUY/JywVlCYGVMy6k2rsxQ/kEi++drA0BAAA=",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVVV1rgzAU/S95thJN4lefyjYYbA9lG+yh9MHS0AacGS4blOJ/X6hOXfSaiCjmmNxzvLn3ZHdF24N4u3xylKEneRCvshBH5KGtFKX6Qtnu2rzqz3itL1R7PbIKMF7fHvpG9f5v2aaq8oteuwqInxBCPOoTkhCPUD8kSepN4EHEyA2PWRpP4eD8NGJDnC2J0quhSTTEcRgsUdnFMdSEjIazvGAcQH9MKXXQaY8zz0uDJJ7Kmw23xmnz0+FsSfQeb3arYzWyMFIDqvyvptstQ30/v8n+iBf8WyiOG27Pspsec/6oekB8Xqd7NUN5BrrFsi+2qrXyWuoB0gN1NVRvNs8z3Wdcz5Arzdc/xDvW6dZHZt9BeiBXgup5qccbrgE4/5zDQIyOPmVxtWkl0ycT5BXO5yHY+/M9DnkFxDvUqc/3e5F/cMUrlGEfe+iZlyd1bgcvUuVKyLIdvotj9+mRi9NZtYOHgv8MJ97JQuqA5XdR1PtfHQgjzpEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3109",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10411",
    Length: "25",
    Mark: "318",
    Material: "Copper",
    "Middle Elevation": "3125",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "114",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3125",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3141",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528112",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.07754481",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xhSY6rWlagg6CKI4KJ00dLQDsSMxCiU0rsbaPUE7v4X803eg67w2j0MZHCiCjXZriEHDDShC0/I8n6UcTBLJF+uU7VZcCXmMLB/V8UXu/W+7CI7Bnss7yYYD5nggsHZuCa0k7lQKAPGd0d7w/pXHQ02bWQkXKSSwcGa9zSVkgulVgx2ZCmedS9rh+IDiybXKQoBAAA=",
    Pbi3DGeometry:
      "cQgAAB+LCAAAAAAABACtld9LwzAQx/+XPGclNUmXdk+igqAPQwUfxh42VrZAbaRGYYz+78a1atbk0viD0tJ8e/nkcpe7Lg5ovpYP++cSFehGreW9quQGYTRXstYvqFgculfzmczMhVr8rUxSQmbHh7lRu/ycdt40q72ZO0lpMmWMYZZwcoYpS9JUCHyU84wbmfFTlefTDzXjA2sA0plzKnIfnHOW/kQfOuNfVFBKfYsKJjLY3NkShAF8ATyH6H4KuKYddpoQzh2KrVpxcY07F23dTlIEJkgfugKseRIWW7dy5Jq7LkJb8joDUUbofoqbi4gSgKIeYw/ggWxAlHDA3MKL4fxXwUMpiS/KMCdGB85fsHUEKX9oTMFagPqVq0dgYo53qL79bSzE+HWLBPyA/kuQPk6J0cc7ZEwTjzDvdPP/vpSrp1KXDSpIQjC6Leut3vWDO6VXWqq6Hz7Kzden61Jud7ofXFXlm214oSplgPVrVbXLd5w5OE1xCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "324",
    Mark: "319",
    Material: "Copper",
    "Middle Elevation": "3099",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "216.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "114",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3099",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3099",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528113",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.52108863",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkaUp/PIkKgh6KCB5KDy2GNBCzUqNQSt/dSGsRL9529htmpughr/Wpu0nIYI+1ztF0Ci0QyFFbd4es6MfTGxYBp1ESJ0tBoygVMJBvFtI4CPkfJoSIf9icObLyU71q26rz/f6x0dVVOtlCxigjcJBWuWYSR3SV037yKM/6MqOd1KpxbxEwwQlsjXxO3pDTlDNBYI0Gfa59GDOUL47Duu8PAQAA",
    Pbi3DGeometry:
      "gQgAAB+LCAAAAAAABACVVV1rwyAU/S8+WzEam48+lW0w2B7KNthD6UNKpRWyODI3KCX/fdJkWdPmRiUkxJPjuTdXPXd9Qqutejt+SpSjJ71Vr7pUO4TRSqvKfKF8fWpf7We6sBdq8D8yiyhdnB/2Rs3mb9qyroujnTuLGBFpkuKYxHPBMGck42KOL3DB0wzGOaE04158EUdnPGGxjw6YD21hRkdkbumtzIi8GEsGCgqpgEWgLZ3ZMN41hmrQ45wkEWe3/Cu81+/xq7huneFaOfVBfLBWznRAXIwlAxZnUHvnv0IyobUH13ayls4t5eZD+n5xgbIBO9mdDaDiRXflAp7lsJ0QuuKAVfhsSi+7cbBdeUxaVthhCnAOwIW9DrzLy/3ozlwmG5e3WQV7HtTn/DzVs1+2fNvP71XxIY2sUU4JxehZVntz6AYv2hRG6aobvqtd/+lRqv3BdIOHUv5cEu90qa1g9V2WzeYXV7a1wIEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "343",
    Mark: "320",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "229.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "114",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528119",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.65539465",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV7Duam5nqKCoB5Egh7Eh1kXHawtbAUi/veG1tv9Dt85txqhaPRleCJIOLlGl3jzyrYGgUDhtPUvkNW4nEFZMU6zPE02gvI4iWGq/9q279UQ3BDstXqgxx5kRCMCZ7St72ZgnEDpvPLaWZCMJlkU1nicZrlY52lK4Krvi8uYCHhE3XZ+5kjEBA4GP782F5QlBHbOuPDJvo2Z6i9K+cHzzwAAAA==",
    Pbi3DGeometry:
      "axAAAB+LCAAAAAAABADtV01rwkAU/C97jiH7lQ89lbZQaA/SFnoQD4pBF9JssWlBxP/eVKOJdifuotBLEMWdvMybfXn7RkdrMpyq19VHSvrkUU/Vi87UjHhkqFVefJL+aL37Wl4OBuWLbLwa6dEgGGw/yjfZjPe33SyXk1V5b49yP+ace8LnPOYeFz7jceL94lESyiYuBdvisYjDJh4wuosXQpjwE34aSt7KA/mBHpQX4sc8VLaqjGQSGXEjy4Va6j0dZz08k1jILc4kO6kx5Q2chlGlMqSREa/y7nkk5SYexsP2vIgf6jnOSyVL2nWKiFvkPeiE+7LTX/MA3LUO8PkCnei5QxzxOO4L1hn1LeQB8Ug/PC9ADzqNCLfrH9fzUveteQrYdcM+2m3CACVwyqK5BnnMJxfiaCKh6Q55ULyre6AJaXY5iNtN2noyAByeUOSuZ3j+xiP9VvVEdTjThZbddrbKbh7tOkVg1qt4uuvvJtcZ7uz1V/L0q3m3q6e7ehmKd535dnXrPL3z9M7TO0//H08v/7nfqcl7WqRL0g/8wCNPaT4vFtXiWReTQum8Wr6p2eHSQ6rmi6Ja3GfpdzPwVme6JMy/smwz/gHGGDM+axAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "726",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "402",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528120",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.38295638",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjckKwjAYhN/lP8eQNEsXT6KCoIdSBA+lh6ihDcREahRK6bsbN/A2M3wzU49QHs1+uGooYOuPptKnoFxrNSAovXHhBkU9fmREZpThNJdizrEgCUzNj1r0vRoiGoOVURcddA8FwQTBTrs2dC9DhWQIKh9UMN5BQbFISVxjiUxznuVSIjiY8z+80abtwttzkSFYW/34thnHlGYxW3rr45m7Wzs1TynOVVzRAAAA",
    Pbi3DGeometry:
      "Mx4AAB+LCAAAAAAABADtV11r2zAU/S96doO+baVPYxsMtoeyDfZQ8pBS0xq8eGTeoJT899myksWRjqzQVxEa6uObo6Nzrz7u/Su5e2i+v/yqyZp87h6ab13bPJKC3HXNrv9N1vev07/Da3o7fMih+I/cMEpv7dfwRw6b48/e7ffbl+G3N0ysKknLQq4kq8pCyBWXWhQjXgp5DlPOJlhxEQxHuNHqHNdSF9Fh5zxMlSYm54JmMVyZa1hAeJqW05Sgxrk1TBgdtcDxKKm5xVlVncf7uJWp6ByFLJMapaV6A/tR+6h5Nqp1EmhJjIbcaEbh+V/FfcyRMCpJ+Sl+GNvmVKh4hV3Jg2pmiT+xsh1s6KRGU7kMpyYVWblkGUg3xMFUL8W7RTw+jvD4Orr/oAIBNEm7p8eevEUslAfEL72PzspbJHHLPJIFHE3WEy+5VcPEJL4Szkxd2h2LM21NHgZw8ZXNeKkri/NqZr6/TyB+Kbjllyy4Uwo56S+piutB47r5GhcvFYsemfCInXSecC55NF3IHlCyiAUMiswMVxSyGFkGUw5GjVvvH3bXphbFo9SiFMb5fZ6oy2A3AuYHUhhdP+im6FcIWlaAPr58AmUPeNDyAV7ia5sxIXsqJex1gzk7y3LpbmlLnBo+4cbRs0qPuFIy6TYTP5r9gxyIlMYuCH45KowHatD1HZscdgHOFuoJ80STEr4D+lcCsCugVKHVj00Oi0HSYQrDdQmswSqj8ckphPzxAg+1SaBE4Hxz45ob19y45sY1N665cc2Na25cQ4ddblyD4+bGNTeuuXHNjets9efGNaHA39K4bgryodn+rPt6T9Z0RQvypd499c/u4WvXb/um27nHH83j6dWnunl67t3Dx7b+ex74vmu7gXD3p20Pm38BSn6xMx4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "727",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528122",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.37081565",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjT0LwjAYhP/LO8eQNk3axElUEHQoRXAoHaKGNhATqVEopf/d+AVud8dzd/UI5dHsh6sGCVt/NJU+BeVaqwFB6Y0LN5D1+JERmSUU54KzeYYZSWFqftSi79UQ0RisjLrooHuQBBMEO+3a0L1MwjhFUPmggvEOZIJZTuIaTXkuskJwjuBgzv/wRpu2C2+fsQLB2urHt01TLIgQCJbe+njm7tZOzRNZOlVl0QAAAA==",
    Pbi3DGeometry:
      "JR4AAB+LCAAAAAAABADtV9Fq2zAU/Rc9u0aWrmQpfRrbYLA9lG2wh5KHlJrWkMUj8wal5N/nWE7qRDqy07I3UVrqk5ujo3OvfHVvn9nNXf396VfFFuxzc1d/a9b1PcvYTVNv2t9scfvs/u0+5tfdD9tlL8hVwfl1/6f7Zbvl4WvvttvVU/fdq0LmhniZUU6qtJmUOVfKZHu8tFp1uNKkTvAhXpEW83Bl9zAPRvurKiFDLEjNED9b/YCTtBfx+PFxd9C+fFxSwB3oQiHFkUXkVhgxxl18AO9VdngpaBYPdzTc2rfQH+UXWp8s25uJ5MyPh/xoW8iGC/kP2ZJk4/JFOS59KuKVcBlLrG7mVx88DWTHxhip4/jrEusZGd7qRHV4ODQBiDeKxke5OE0UOoR+dSCe+KvL50d4OOVhz2JOgvqF5e4dG7TRCR4PRxsNiy/L3kY1vIS0gw3XPbkselQJtycjhO65re5xWwa0jF8RYfZDuOp23NNz6XBNR4kdLK2JiUGLmn0pvrCYg/ZYx/T7a2H0UeLYRZAl6AwqU8SD1o07iXqF5zDyDFgcXxV1rvNGd1laQTTIKsofKOAwC9rnxJE8dx0lDxUHEg/XBYcV0QMPkGWIJnxwovnw2sRgDZEpz+q66HslkbtcaBLRHmq4dPxGunh1UthUWsdT2ECbG5cqaluodyOdAz9Z5wMd1p2IP9cDfQM2T9jgbRfIgTwT8r0rSfwKA66+frbCZx+ajNQg9cgFUJzQHfRCC4dfmsO4CeeewcpBatBm08T6mjt9mljTxJom1jSxpok1TaxpYk0Ta5pY08SaJtY0saaJ9X9OrMuMfahXP6u22rIFz3nGvlSbh/ZxePjatKu2bjbD44/6/vjRp6p+eGyHh4/r6u848H2zbjrCzZ/1erf8B0wKIbklHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "729",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528124",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.90557907",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lIG5v+eBIVBD0UETyUHloM7UJMpEahlL67wbaCePC2s98wM3kPWYWn7iYhhb2pMDOqq40GAplBbe+Q5v14OoMXUSESvvT8gDLGQxjIFwxj8Yf5NOHsh02hMyzm8lXblp1b4B4bLK/SyhZSRhmBg9S1bSZxNLa06EaP8oyXD9pJrBv7FiIICWyVfE5evqB+xGICa6OMy9UPpYbiBcsyt3YRAQAA",
    Pbi3DGeometry:
      "hwgAAB+LCAAAAAAABACVVU1rwzAM/S8+J8GO03z1VLbBYDuUbbBD6aGlpjVk8ci8QSn57zNJ2i0fimxCQvwkPz9Llry5kPVevp0/BcnJk9rLV1XIA/HIWslSf5F8c2l/jZkuzUNq7w/xGaXL5mNeUm+v01ZVtTubuX4SxHHGPZ+xIIuizONRwFKvB6cZm4HDMAqt/LOUN/40ZJZEgJ44adCE2unsWMb0fJFOCwLWBYnADbRKQ8651QJYIK6GRRpPThjiLf8N7a2KcgzShXBPo/1MIUKm0UGSht4j2f2Qo7uEaFwjPi0eieE40WCNODPZGoDAQWcYdUeOpG2+wFpzlAny2Bqggwi2EXyC65lDSmDYRZyFzre7WRiodKhXo+4unQGgBm4BR4Hzd94sDFU/XszYDQn1XHOr38vdh9CiIjkNqEeeRXnUp27wovROS1V2w3d5uJkehTyedDd4KMTPf8c7VShDWH4XRb39BeJ4BNaHCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3115",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5984.53 /",
    "Friction Factor": "0.02296",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10417",
    Length: "25",
    Mark: "321",
    Material: "Copper",
    "Middle Elevation": "3125",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "152",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "36079.08262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "115",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3125",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3134",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528125",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.30042783",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1js0KgkAQx99lzuuy22qinaSCoA4SQQfxoLSsA9tO2BaI+O4taL1Bt/8X85tqhLLFy/DQkMORWizJDoYcMCgJnX9CXo2zDIMo5clKJZtISp6tU5jYH7r6iy76vhkCPwQ7bO7a6x5ywQWDk3bGd4s5k288hpdne8XbrzpoNF2ASC5FnDLYW/1etkpxoeKMwZYshbvuZe1UfwApWOQQDwEAAA==",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABAClVt9rgzAQ/l/yHCUx8WefxjYYbA9lG+yh9MFSaQPODOcGpfi/L1RnjfPquSKKyed9913ucnF1JMuNej18ZCQhj3qjXnSutoSSpVZF9UmS1bF5NTBbmIvU9DzjcMYWp4e5Sb3+Nbspy/RgbJ3QlbHnUYdzNw5CKqTLRRxQM+97wm/m40hYAOOyAaKY9wGQqTOQMh53IfzIAnwZztIEuZ4ODut5UtGQSPrBeNAdMFg+eMEh33YihMuEcfWX6QzYyzFmcIqiB9ipm2aa9jCQZAeHmIekgp7tRGCC/rekYWx2qiGt4E4B84CwwO0IRKbhZQJLH0l1VYcAVU3vu8s+MJUDAqjKATXNNpjbt8DSxLQnHBMGAPcL2AGRVFd1WVAVdN7BAJIKAeD6LOJMQBo0gPlPuFPpe1ZlJUmYyyh5yopdtW8Hz7pKK6WLdvimth30kKndvmoH93n23f/wVufaEBZfeV6vfwDPVR+22QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2769",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2769",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5984.53 /",
    "Friction Factor": "0.02296",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10069",
    Length: "337",
    Mark: "322",
    Material: "Copper",
    "Middle Elevation": "3106",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2015",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "36079.08262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "115",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3106",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3106",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528126",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.0777767",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2loY9M/T6KCoIcigofSQ8XQLsSs1CiU0nc32OpBBG87+w0zU/SQn/DQXRVksKUT5qS7mgwwyAmNvUFW9OPpDF7MwySee4HgiYxTGNhP5otUfjMZ/UNjYvkuXrRt1bl291hhdVFWtZD53GewU6a2zST2ZCuLbvAoj3j+oI3CurEvEQnJYK3VY/LOBE/DQDBYkiaXa+5aD+UTNikh2g0BAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1LwzAU/S95TkuaJtZ2T6KCoA9DBR/GHjZWtkBtpEZhjP53w2zq+nG9CaOj6ek99zMnXZ3Icqtejx8lKcij3qoXXakdoWSpVW0+SbE6/d5amC3sj7T070mUMLY4/9mLtGtndtM0m6O1jbJYCnlFo4TH1zLLacrjPBeSzgKSpWeAJWIeAC14KoeASHgglYtKimwIZFwEhuuohlGlMWNp9r9zkArKQ+Sce4aLUeHOGc/lbBFxAKVyteoB10F/Hw5wHeyBcUkmUYHAMKqLDk7y6Cz6fkycg5lDVAEAVnZ4SlAf+DBgPgJKgpYd3FEoFWjhv2vBqPwVDk0wfETBaUeFDKTy1xLQAt2D/truv51RZQBFBjw/UCrQwv+MAqPyV2o0QX/1GR8s47IHaAl6Rs3lYb8h7tTmvTRlQwoWM0qeynpvDt3iWZuNUbrulm9q10MPpdofTLe4r8rvyxdvdaUtYf1VVe36B94fVt31CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5984.53 /",
    "Friction Factor": "0.02296",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "252",
    Mark: "323",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1511.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "36079.08262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "115",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528129",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.86848054",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNzE8LgkAQBfDvMud1cf2LdooKgjqIBB3Ew5qDDmy7YVsg4ndvK4Nu8977MdUERUOn8YaQw8E0VOLFSt0pBAaFIW3vkFfT93TES3kchPHKE4JnSQpz/WPrYZCjs67YkryixQFyn/sMjqg727+DEFHCoDRWWjJ6mc/U/q97pK63n+xHAYOdwufCw4iLMHNmY5Rx3/VDqbl+AWqeVUjDAAAA",
    Pbi3DGeometry:
      "Px0AAB+LCAAAAAAABADtV0tr3DAQ/i86e41Gkl+bU2kLhfYQ2kIPYQ8bYhKDuy5btxDC/vd614+stPNZ3px6ECEhHknzffOU5u5F3N5X359/lWItPjf31bemrh5EJG6batf+Fuu7l/7fblnedD/iEL1KViTlzelP9ysOm/HYu/1++9ydXWVxkqfRilQsZZ5F2sRKKoomOcVFkSYnuabUkussZeVof9qrNzpfpEYlZo4OZeps/wz9Qb+9H+mZwWXlflzgBkqlWUTHpa90YuGSLvqFRBW2pnGhP/FqwbhgCmNDuHJe0Ry0owlzShOyvOGhhKGhcTnlswgOIw/yJQC2DXoDZZIZqY4QOV8iUw5kpCzbEqOXpBiqBFcO+fjj7C74mLrQIC+gnusZQeNgoPsTZ7nnhsctXZgZ85r8LXhxD3MSAHkPyVEUPC2GKU9osb963AVkMzKCzCDPqXcqEdtxpwatSA8LQxCOCjr5kXpvg+JSiTHuendADERK68K6VVWRMxlwcdmiu5mVn+gMvkvf5iN8l1xpF4ymzKwDlJtsrv/D/Ygo2A8JQUXI1dCy2RAzzcLfXexgQqaQEQoaLgRwAKUXyF5fsrtPrcmARBk2NheX/MhT2zw9dwJzi/SFcNREfPg1Gb6iNOdTBsH7WkAPWBcZeQm6FYUBmAC97feRA4x8BCzzvv0uCIEax28FQOhqy2AMEAI8gILj63euLyAAclIYHxfhhvExjI+LbAvjYxgf+cwI42MYH/kTYXwM42MYH8P4GMbHMD7OIvxX4+MmEh+q7c+yLfdiLWMZiS/l7rF9Gj6+Nu22rZrd8PmjepiWPpXV41M7fHysy7/nG983ddMp3P2p68PmH9+AHPk/HQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "731",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3130.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528131",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.65309531",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LgjAcxr/L/zzH5nRzdooKgjqIBB3Eg9bQwdrCViDid2+9Qbfn5ffwVBMUrT6MVwU57FyrS3Xyje2MAgSF09bfIK+mjwxIJHAas3QRUYolFzDXP2w5DM0Y2BCsdXNRXg2QE0wQ7JXtfP8ylCYcQel847WzkFOcCiIkZzEXMskkD+1Rn//hrdJd79+eJDGCjVGP75rFWDKSIVg548KZvRsz10+hEImG0gAAAA==",
    Pbi3DGeometry:
      "pR0AAB+LCAAAAAAABADtV01r20AQ/S97lsV+SrvOKTSBQnsIbaGH4INDRCJQreIqgRD837vRh+Ws9Xal9hYWExPNeObNmx3N7Ny+kpu78sfL74KsyZf6rvxeV+U9SchNXe6aP2R9+9r9a9X0wn7IIRklK0bpRftl/8hhM5hd7vfbF2u7ylOpmU5WjKUmyxMhUiqkSd7kRnZikWencqW4mVRAAy5Up+BKzvKkMsW8IZlMvZMDCiOAawAcIWAYUBB4Ohc8pVTPooYpdNDWEzdWwVOTczl6GuTWgLJTDucGPcSJQopzR6MYATt+RmQY0TEZg4JJ5o0IQkNu7yGsQlDtIYeQIQDkhpIRLjGtRItgaO6tgJEbk7pVcMq9RYZdQUUgqiXEYbhhgm59BFz903G4BOGJH995xwJ2J1Ai2FGoI8/tZrAOwpUDFc5RBMgtTt/87hFm7XKgukdWed4iZ4L7Bpc0w+DKrKDlQPs+lDtd4s3jjCNdkg6IgaIa56wwnSvN/QMYEwdynQ8Z5Oo/MwWGy3Jy6FRHCy1lB51p70yAFmhYQAR/pYFJO3FbCHNzsgFbh6fM0JFOc8bUYAnAFx4XzXRM+CYJqwNexIRm06lFNwCFKhPePfDsnH4nrJxN8w5gw+nlU7g3VoQdSJTvvn92GIgGzDlKFILGCIgebAYoJvjS4+PGQS2kh88CQUCL8LBw+aGEhCHcdho3zrhx4jkYN04vQNw448YZN864ccaNc2Gm4sYZN864ccaN05/zuHF+sI1zk5CrcvuraIo9WdOUJuRrsXtoHvuHb3Wzbcp61z/+LO+Pqs9F+fDY9A/XVfF8+sNPdVVbh7unqjps/gJzhWnypR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "733",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3130.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528133",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.36387773",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkTUubehIVBD0UETyUHloM7UJMpEahlP670VYvIt529g0zk/eQVXjoLgpS2NoKM6u72hogkFk07gpp3o+nN8y4oLGQwTziVHIWwkB+QMnkF0wikfyHr9jiXb9o27LzG/xjheVZOdVCyigjsFOmds0k9taVDv3sUR7x9EEbhXXjnsInBwTWWt0nrwgpj3hMYGm19bnmpvVQPACTFvh3EwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1rwjAU/S95riW16adPYxsMtgfZBnsQHxSLBrpmdN1ApP99xTWtpj3eFFGMp/eek3tvTlyd2HIr349fGUvZs9rKN5XLHXPYUsmi+mbp6vT/tYH5onmx2ul/mXmcL84fzZvVax12V5abYxM783w39n3fCTw38bhwfOHOBQ+dMcALw+QMREESjQI4IgmDKyDwommpelUiDq8A7kfT5HapTFXzIIhvk+NUaB+REMJKrkUqkjzhyXgRKYBO1dVKA7qD1hw9oDuoyQclMVVhuYaqroPmPvoI3Q+THO8cprIFLMpuq2oYYc4VBki59tMOy45OFN0oaqhpcnpKoCpoAHASKbMc+tVg2qGRkecDkg/k2h614eGEqqCRwWmffk2YJoPvD9KWILm1w9GeCFXB6w6ajPVdiy2DdAZoMpD8Qm7zH+JBbj6zKitZyl3usJes2FeHdvGqqk0lVdEuP+Sug54yuT9U7eIxz34vH7xXuWoSFj95Xq//ANFt4/31CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3109",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10411",
    Length: "25",
    Mark: "324",
    Material: "Copper",
    "Middle Elevation": "3125",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "117",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3125",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3141",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528134",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.87376307",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5B+0mpdiQqCLoIILkoXLYb2QcyTGoVQencDrd7A3fyYmXIA1eDFPzQUcKQGFRnfkgUGitC6JxTlMMEQWEQJz1eZXMuYizyNYWT/Mavv/Kbvax8+BGGH9V073UMhuGBw0rZ13UzO5GqH4fZEr3j7WQeNbRdWIi6yNGOwN/o9Z5OECymXDLZkKPTalzFj9QGXJB4QEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEo08Uft09gGg+2hbIM9lD5YGtqAM8Nlg1L835c6uxn0yImKYvy87+5yuS9uzmS9U6+nD0ly8qh36kWXak8oWWtVmU+Sb86/jxZmK3uShv6/WYSMrdqbvUizvZrd1HVxsraLkAcZ55zGURDag3IRhBET9AKk8TK9AIynYhSYYCGEaIFURDiqa1RDqmUSt0AUIZ2DCWYiS0ajAp1752oIdOGGUcKRCU7Ow3XOAxbH2QhVD3CpRiyGgFNBjA8YcCo4EhUY7hBwKohK0KkHJnOQyjuJ+DyQ/QGGi7IAffhKO2ESodWOpJrVUWBUsACAHYWjQgHgEvWpj4dqnsL5GgdUnyGAo0K1AaQMoOgjqeZtLGBUvg3S42OeioJd69OS6erTz8P+Q9yp4l0aWZOcBYySJ1kdzLEbPGtTGKWrbvim9n/Qg1SHo+kG96X87n94q0ttCauvsmy2Px68pnn1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "325",
    Mark: "325",
    Material: "Copper",
    "Middle Elevation": "3100",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "217.2",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "117",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3100",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3100",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528135",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.47177554",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjksLwjAQhP/LnmPIo7UPT6KCoIcigofSQ8XQLsREahRK6X830vrAi7ed/YaZyTvIjrhvLwpS2NgjZla3lTVAILNo3BXSvBtOb5hwQcM4imehoFzyEHryDSWNuBR/IePT5Ad+YgdYvOrnTVO2foN/LLE8K6caSBllBLbKVK4exc660qGfPcgDnt5orbCq3VNwFggCK63uo1cKmggWEFhYbX2uuWndFw9Bw9MOEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVtFqgzAU/Zc8pyEmWlv7NLbBYHso22APpQ+WhjbgzHDZoBT/fcE6WyVXbywW09Nzz03uzYmbM1nv9PvpS5GMPJudfjOF3hNK1kaX9ptkm/Pl0cF85T6kptdfZhHnq+bL3aTe/tPuqio/Oe4sEixZpAuaCMZlGlMp2FImc3oLRO4aASTjfCmRDDGXDZCKGBcKzIqnsWgAwX2hfIwmlE9DiMibFSwOhYLn0aTrABEnOI2JJekAydJICg9jCHQaV2AgjgnVryBCAxbvVxCRFQz0KzhkeOYxqAdi5nCo4HrANR9f3emGwzBADaQ4uIhgtyOyAkNhGZisQAMI7pLwZoBNBtm7aL+aZmCyGre+8D0YtJ0hb8daBuKYwDIQWU0ckCHWF+6i8JGKdGr06XxhuHeIB51/KqsqknHGKXlR5cEe28GrsbnVpmyHH3rfQU9KH462HTwW6vf2j/emMC5g+VMU9fYPtX/cB/UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "343",
    Mark: "326",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "229.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "117",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528141",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.58537705",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV7DubmpPUUFQT2IBD2ID1YXHawtbAUi/veG1tv9Dt85txqhuOrz8ETI4eiuusSbb2xrEAgUTlv/grwalzMoK8apymSyThhNMyVgqv/epu+bIcgh2OnmgR57yCMaETihbX03A+MESucbr52FnNFERWGOx1JlIs2kJHDR98VlTAQ8oG47P3MkYgJ7g59fmwvKEqYIbJ1x4Zd9GzPVX2R+gpjSAAAA",
    Pbi3DGeometry:
      "HBEAAB+LCAAAAAAABADtVl1rwjAU/S95riUxSZPq09gGg+1BtsEexAfFooGuHV03EPG/r9Ou1dJjk82XQRHFeLznfvTm3jPdksnCPG/eIjIi9+nCPKWxWRKPTFKT5O9kNN0evhYwHRcvsvPqXwaM0vH+o3iT3ezH7CrL5pvCdsC4rznnnmR+yKjwuPCHggbeN6DCQJ4AUuo9oIUOTgDK1cFCCNEKNH2wIAjPU2EfKCroHAMNKiZZR7hKhqodQFR/j6pOsOG8elBayD2gQ9UsO+PHAAt0GW7AVDtQOq+oJG9lGnItz/uGLnBQDd9MCtkRrVDcynkVLszPNo2aCQHuFcFPHEQLOwEDiMk5PVxz2NCYClnANPBtQlHBGwsB26Zyv011R8NxYdsjtYX7SEJR4SkN5yGmApccA3CIwRWBqaCF+xqCoxVsTQzYTul6kiAA3ma4sbuYWixgGpbFhRXp7lDrRuyuuvvydx8+2Pnl5IK7SnPeBb+QERdTC5cUBe5qwXk5IgP31WFZwV4r9Fqh1wq9Vvg3WmHmkRszf43yKCMj6lOPPETJKl+Xh8c0n+cmTcrji1lW0F1kVuu8PNzG0efxH6/TOC0Ik4843s2+AKjxgPwcEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "738",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "402",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528142",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.72993621",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNI82zrSlQQdFGK4KJ0UTW0gZhIjUIp/XfjC9zNDGdmqhGKo9kPVw05bP3RlPoUGtdaDQgKb1y4QV6NHxmRWcKwyqSYC4qJ4hSm+sct+r4ZIhyDlWkuOugecoIJgp12beheJhGSISh9aILxDvIEC0XiHqNSZTzNpERwMOd/eKNN24W35yJFsLb68W0zjhNKOIKltz6eubu1U/0Ekn9ysNMAAAA=",
    Pbi3DGeometry:
      "Sx8AAB+LCAAAAAAABADtV01r20AQ/S97VsR+aT+cU2kLhfYQ2kIPwQeHiETgWsVVCyH4v1fWSq5t7RtJ9FRYTOxoRzPz5s3M7s79K7t7qL6+/CjZin2sH6ov9bZ6ZBm7q6td85Ot7l/Dv62Y37Yfdsj+rtwIzm+7r/aPHdaD2pv9fvPS6t4IlTvNbVaI3HvuM6Vzqa3PjgKr9MU6VzasF1LFFaDAm+JCYIzMaN9XpkThCxLUtaVphcIvM4QU5iI6xYahXtEktJA0G8GUzIVwuhNIrs80YoIjWplzq+XFOrbUgWoFyth/czEocHXp+cgrgWjm68g6jAsRscz+QA8Xws6Bf3qfF6YTqEJM1N1CQ7CKJjwsKPmBI6NE976RYtb6zBRDTifIg8mPLqN4I/iHWlEyuPXtL71LgWJBdmbutFf2F20hdLlQglEW6OBGjUOSNzZDLcOIY/i1DI5dL3DaBYGxQcMr19EtVO9Du5B/HdIgvZvY6aALrWRwYeKlLbgJYdihxCAo6HwI3PQa2lj6tMXncwf3TCALR+cOMYUKGdpBjiGzqMog45A/XAbI91Qqxmfk8nRDDZhumNUpH2NTU6xHNy6YjWheqRZDl9Bo5cDWAx7oBot2BbAE+wvxSlwFvY/y5AoVTi4nQ6lZNwjgtTXUvxM6hMd7F8KZrqCkNfNuRuQpHr0NIKzah63cX7vGGggTHBQIzgEhOG6MCpgis0RcLkcXDLSBwOzBfYIgHWGCQeC8gqpFRBFoJzTm5xX7oDsgPqGh2sGRpyE6DdFpiE5DdBqi0xCdhug0RKchOg3RUdbTEE32VxqiL7GmIToN0VNo//shep2xd9Xme9mUe7biOc/Yp3L31Dz3D5/rZtNU9a5//FY9nkQfyurpuekf3m/L3+cvvq23dWtw92u7Paz/AAAdWppLHwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "739",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528144",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.58337664",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjT0LwjAYhP/LO8eQJk3S1ElUEHQoRXAoHaqGNhATqVEopf/d+AVud8dzd9UIxdHsh6uGHLb+aEp9Co1rrQYEhTcu3CCvxo+MyCxhWCrB55xiIlMKU/3jFn3fDBGOwco0Fx10DznBBMFOuzZ0L5NwwRCUPjTBeAd5grkkcY9RIVWaKSEQHMz5H95o03bh7VOeIVhb/fi2GcWKKIVg6a2PZ+5u7VQ/AdbKxiLTAAAA",
    Pbi3DGeometry:
      "OR8AAB+LCAAAAAAABADtV01r3DAQ/S86O0bfljankhYK7SG0hR7CHjbEJAZnXbZuIYT973Use2NbftY6ORXEsstao5k382ak8dw8k+vb4sfTr5xsyJfqtvhelcUdSch1Vezr32Rz8+z+NmJ62XzIMXlduWCUXrY/zZcct73ah8Nh99ToXjCRGkmzRPGUikSIlCplkpflzGr1ssyEzkaCfj9jRp4pULYFyCSfVZgiKy5m7UCXeo1zQ+gFlLFVhvz9IZJAaNNlIWcJwkwwwXs7PLXc8NGy2z8naP1sBBmX5xhyHjUCau07EU4xMK3HGC2pwKc1+zECYAmSsR6hz5yQdjEGno2PgmSLdbHSSqCMzixGfDikHdFjhA4I3ppij04UccDOZBnxgNw3So5ON5ukC55Lv1CgqdCd5mNAAUo/Ii9EKipqeAz8EwXDDpryBDBsFEaWOWZ5d1Vpt26odghUuLtNcRee4Vw7BWZagc3mfBreJADipMAbCy1EU3KtQMuBr41AWLPsFMQ2wqqRKdOHEei2fntmRr96O2QWZQ8zBasZmoLgIW5ho/FIhxRC0kPYqPv5/XJ9wqEGTDhMLKx0ZAoGHjzH02zAvMLagWFgcHTCIQQkBFIITaFTFsrSpPn0PFFO7aT+WdeGHbFa8uX2bKjoAKhyGmpc/1Rx1gqY9bvnsJhhP4RvBsjXHoAzlyDZI4cUxh4h7iDXQSomEQN3sJ2Q/94LT/AVCb1p+1lDFwRmG3qFwkB8oGLFROH7D2i8IalBQqYUonqCPsG44+wcZ+c4O78PIc7Oi40hzs5xdo6zc5yd4+wcZ+c4O8fZOc7OcXb+z2fnbUI+FrvHvM4PZENTmpCv+f6+fugevlX1ri6qfff4s7g7iT7nxf1D3T18KvO/w41XVVk1Bvd/yvK4/QcP5M9bOR8AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "741",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528146",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.59110071",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzFsmzYl9SQqCHooIngoPVQMbSAmUqNQSt/dSH/Qk7ed/YaZyTvILurU3iWksLcXlVndVtYAgcwq4x6Q5t1wesMioRhhuAwwpoJxDj35gpyKWCT/IKcYB+EvnGMnWEz1q6YpW7/BPzaqvEknG0iRIoGDNJWrR3G0rnTKzx7kWV1ntJOqqt1HBBiFBLZavkYvY1REjBFYW219rnlq3RdvOpQBKBMBAAA=",
    Pbi3DGeometry:
      "5wgAAB+LCAAAAAAABACdVlFrgzAQ/i95TiWaqNU+jW0w2B7KNthD6YOloQ04M1w2KMX/vuB005rTs4hi/HLfd3fJXdycyXqnXk8fkqTkUe/Ui87VnlCy1qownyTdnH9fLcxW9iIV/f+y8Blb1Q97k2rbmt2UZXaytovYY4IF1Gehlwh/STn3kiQUtAckPKkBwXkfCGO/BsJlRHFUtYXwGA8Ch4YFRBx2gMi+RDOdArXH40NrT/nkIuIsdoTdAq4MusO70I6sYRI71qIL9Ji6QC8fA4s2jIFGGwaKalxj4BUU30jcoLNu6cvFmKa61idXcL3lRuUJLBjcNkdR4QAwU2AFoCxADZw4uLDTdTmfCg1Am2SykEfmgwIoZXAXzu13KCIcAJYM2AinLUANtDjYVFGnz3wqHAA2C1Tpj5/HLo0OYP8a7lT2Lo0sSco8RsmTLA7m2AyetcmM0kUzfFP7P+hBqsPRNIP7XH53J97qXFvC4ivPq+0P4eB1cecIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3046",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3062",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "402.78 /",
    "Friction Factor": "0.025916",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10348",
    Length: "25",
    Mark: "327",
    Material: "Copper",
    "Middle Elevation": "3062",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "20527.97225",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "119",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3062",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3078",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528147",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.56179855",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzFEYmJbT6KCoIcggofSQ4uhXYhZqVEopf9upNU/8DZvZtidvAdT4bm7W8jgQBUacl1NHhgYQh8ekOX9KGNhpnmy1IvVXCiepjKFgf0nLL7v121bdnFDNLZY3mywLWSCCwZH6+vQTHCiUAaMs0e84PUX7S3WTfhAorRksHP2NXWl5EKphMGGHMW7/uncULwBSApnlxMBAAA=",
    Pbi3DGeometry:
      "5wgAAB+LCAAAAAAABACtVt9LwzAQ/l/ynJWk6a90T6KCoA9DBR/GHjoWtkBtpEZhjP7vZrZW1+aWdEhpafL1vu8ul7t0eUCLtXzevwmUo3u1lk+qlBuE0ULJSr+jfHloXw1M5uZCDf6dmVFC5t8Pc6Nm9WN2VdfF3tjOkiALI4YpiQPOGceMBZyGFB+BNIlaIKLZCcB40gJxSk8AkKq1SALCSGrRMECUTJi3+DQ9CkCCh1lsZQIBkImy0Bp1B1gWEHIW1h7mgsRxZqXqgeFKDSz6MPr5YfLcTA4Ji1OA9ihup7OQwigZF0u7fAK1LUnyLhgwGW4LUAPMEkh1ftHH1epL9G99Asy2sya9mdyA98YBnZpuMb17gZvT2aX8qdwF4GgIlk7oTXV5t4W9Ak8+EPCmcgPe7dZ9OHhbHAHz13Aji1ehRY1yEhCMHkS11btu8Kh0oaWquuGL3PTQnZDbne4Gt6X4/PvhtSqVIaw+yrJZfQHhUH0+5wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "402.78 /",
    "Friction Factor": "0.025916",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "261",
    Mark: "328",
    Material: "Copper",
    "Middle Elevation": "3036",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "105.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "20527.97225",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "119",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3036",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3036",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528148",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.40918979",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk6W/qSVQQ9FBE8FB6aDGkgZhIjUIpfXcjbT2I4G1nv2Fmih7yWp26m4AM9rZWudWdtAYQ5FYZd4es6MfTGxYxTimnS0pCnKQRgwH9ghHmlMTfkAdB8g/OseVcv2rbqvMb/GOjqqtwooWMYILgIIx0zSSO1lVO+dmjPKvLB+2Eko17Cx/PEGy1eE7egGHOSIhgbbX1ueah9VC+AFSmEhQTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1LwzAU/S957kqa9HN7EhUEfRgq+DD20LGwBWojNQpj9L8bbbXp2mtuGBvLTu+5597knmxzJuudfD69CbIk92onn1Ql9yQgayVr/U6Wm3P31cB0ZV6kDYZfFhGlq58P8ybt9jfsqmnKk4ldpGERcRZENA6zPGEB5yGlBQ+mAAsLnqTfQM6LdBaAI7I0HgOMxj5UliqWJ+OIjMU+cgeqC1UGYHHyb3KYCqojZzHHyMVQOZInhpOmM010AgiqvlcW0O8gNocFdDtoAeOWTFXBcseqhh28qMOK6PZjmhyuHKRCApi2Q6fElcN5GDA5kC3BtB2aKBcVGOExtaAqrMMhCvQ/ovBpdxgZSOXhJXCEYwY9vB07zghnAE0GvD9cVGCEzx0FqkI6NaZApPtMLpaZqUV6CeKOmq3D/Ie4keWr0KIhSxrSgDyI+qCP/eJR6VJLVffLF7n/g+6EPBx1v7itxKf94LWqlCGsP6qq3X4BXUc5vvUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "402.78 /",
    "Friction Factor": "0.025916",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "343",
    Mark: "329",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "138.2",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "20527.97225",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "119",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528154",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.41631423",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv15jc1rMrqKCoC5Egi7Ei1k/c7C2sBWI+O4NtbtzzvdxqgGKxlz7F0IOZ9+YEu9BOW0RCBTeuPCGvBrmGJXVhrJMJFvOMiqlkDDWf2/XdaqPchwORj0xYAc5o4zABZ0O7VS4IFD6oILxbqE385gh5+mawAmNbsPUWZoQOFr8LroQVKYiPuy99fHcfawd6x+g4LR5wwAAAA==",
    Pbi3DGeometry:
      "HxEAAB+LCAAAAAAABADtVktrwkAQ/i973oZNdpMYPZW2UGgP0hZ6EA+KQRfSbLFpQcT/3jVqjHZmH+KlECTq5st888i8RmsynMq31WdO+uRJTeWrKuSMUDJUsqy+SH+03v3VMBvoD9nQ452bkLFB/aUvshkfxG6Xy8lKy96kARMsoiFLAsZZSrnQv1FEj0AcZBnPakCkMT2REAnlXOOxOBUQYQ8ADio0EPcSByaDBtgkVLUJqKk0IDh3MVZLxGkIAzDV5VZBDtbKW28p5odQ8fCEqgGi3s6PhCUtYEuVhTDQKBcJQLVVzpyUozpMVjVBTCJHc4VIDcr/mGty0OwHRAUDPiFB3zlqLpoMlixBPfd3EAg7mtQolb0MUAdRHahVaNWeA4555V9RraRGW4ZjlkBNxrktWawy9elzwFK1aJ2bgPPCwYYBymSdKq5jyG4SPDMBwLFNQ40EBkxtAW4kAJV9xKMOGmOLRsR9alqz0CXql05/n85jV36tfcF/R/OfBBctEtfaF667FvjvC/7DEZXwnx3mIHb7QrcvdPtCty/8o31hTMm9nHzkVb4kfRYwSp7zcl4t9ocXVU0qqcr98V3OGugxl/NFtT88FPlP+8E7VShNWH4XxWb8C/NYJFgfEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3062",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "746",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "226.1",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528155",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.73467823",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjNEKgjAYhd/lv17DNTVnV1FBUBciQRfixayfOVhb2ApEfPdWGXR3zvk+TjVA0ehjf0PIYe8aXeLZS6sMAoHCaevvkFfDNwZlltJskcZLFiVUCC5grH/equtkH+QwbLS8oscO8ohGBA5olW/fhSUpJ1A6L712dsInffmnO9Sq9Z8eJxmBrcHnpHNOBZszAmtnXHi3D2PG+gXVqq8GxAAAAA==",
    Pbi3DGeometry:
      "px8AAB+LCAAAAAAABADtV0tv2zAM/i86u4beltLTsBUYsB2KbcAORQ4parQGvLjIvAFFkf8+xY81cvTJds9CkIfFkB/5kZTEu1dye1/9eHkuyYZ8ae6r701dPZCM3DbVvv1NNnev/U8nptfuRY7Z28oVo/S6+3BvctyOah8Oh92L073SuVW2yBjVORWGZUK6b6uzN4HKrWAyEyK3VklfIN2PoAYUWGE7gSpstgy8M+XAFeNLvBpNrdJQepUpqDHr1UWAMXc7rpxAcBulxAjOfVOMszPBmcYoKJz7nru+RsAUc854Xr0bw3KqYxpn7PoaAa9mNAIYMEBIyWoMK0yYKxiHlcpX4NrEi+SdlmBVxWp9aRMYR5UvUKKIC1ZnHHOLAoeWoAAFDsOwzP3Rqx0jJ7083cVg7cybiu/GoY0ECqa1gDhE6zOFvmZTgHFDpqAAxg3CMHpYF9Z06ycnT+vKyTuBlv2pRVWPQNkIrUUn4EzGN0MIIcWg4KI5V5BikiMtTNQpjG1GjfHwFUYG6uDiVI4e8Cd3nYAVKp4+RBWu5wXN5INDcuGWDlmHHELWETa0BA/S9RmHGvMZnyQWYyBTKHCYPtz6sKjma2danxAceQs7GfY+xJ73dtJmc2mKXRplIfwWMMO1RrH+zCpo/I5rtB0vQkXPOuV9KXDRr7NQawQuTvBUxNDAWaMGaKknuydSQE5BBiP1jPiAgUOvoCmoge5B+OYEtxGQPry7AM6hSzjs2Rq8qFpEFPQWaqzPK8QIM4hLCiHAuNPInUbuNHKnkTuN3GnkTiN3GrkXHvBp5E4jdxq508idRu40cqeRO4gQjHubkU/V7lfZlgeyoTnNyNdy/9g+DQ/fmnbXVs1+ePxZPfwXfS6rx6d2eLipy7/nf/zY1I0zuP9T18ftP20t55OnHwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3062",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "747",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "291.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528157",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.2854856",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImzbtrStRQdBFKYKL0kXU0AZiIjUKpfTfjS9wN2c4w9QjlEe9H64KCti6o67UyUvbGgUESqetv0FRj58YlJmgeSaSecRSisgRpubnLfpeDkEOxUrLi/Kqh4JRRmCnbOu7F0Sp4AQq56XXzkIR0TRjGQoeiwyTHIUgcNDnf3mjdNv5NydpTmBt1OO75jFFhkhg6YwLZ/ZuzNQ8ASIiC1rTAAAA",
    Pbi3DGeometry:
      "oR8AAB+LCAAAAAAABADtV11r2zAU/S96do0+bFlKn8Y2GGwPZRvsoeQhpaY1ePHIvEEp+e9TIieOFR3J7utESbF1fL/OvVfSvX8ldw/N95dfNVmRz91D861rm0eSkbuu2fa/yer+1T4amN6aP7LPxpUbRunt8Z/5kf36JPZut9u8GNkbmWtOZcaozKlQLBMip2WpMgMoJrQBylxr83AJCM79EhCoZGGB0jxcANi4VWWMF7qa5dWgaomEUAtVQYmYV9cBYnctVwYQrJhFyajKGMoENwuKTyVc4OzuCah4EVZ19uoEUK3fZsORMHEwKafshr2aIYFtwAAhJYttOFwZQBQ6GMcowUtxBAoWLsSlmmBVzTAxtwlGoDTMHJhSQs4E5mYcchunMFwJPgAG7oQx1o7iVoINrMNdDNYOVBXZjUM2Zu8w0eJB624y4uG5zRSn0FUVB2DcThj8JFAZ9w9OSbteVMOpRYV1tuQ2PK6UBZi2Arry+XSxuyATXEy/L6mYuirNFwdAaBX2CZo+n71CWtOK6yngHMr4GD96ewhb+g8/N3eQJ1jMWJXfNOIV1hkiHNKHiwCYjiTCc4QuTzaUgMmGOY3Y8KiKcg63Lm8yPEkNt1foqnpVNqjvkIlIf/maAqmC/YWYDVwWzU7mYUoLMRxVUg3hFTx2tWVDfIxZidI2gFblNElM+w7QsZ5nnOpXFwTkLtdOzxSDcSyBvIITRYB1PyWByLFXQFU8UfDa6V424DaCMgh3iwDt0CsYB06tv3RhIWJvwxILMov3z0gXeOc4VD0w8DRvp3k7zdtp3k7z9szA07yd5u00b6d522s6zdtp3g73V5q307yd5u3/cN5eZ+RDs/lZ9/WOrGhOM/Kl3j71z8PL167f9E23HV5/NI9n6FPdPD33w8vHtv57+eH7ru2Mwu2ftt2v/wHk0/VSoR8AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "749",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "291.7",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528159",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.11204352",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjk0LgkAURf/LW08y0/iRtooKglpIBC3EhdKgD6Z5YVMg4n9vQhOiTbt337lcTtZBWuKpvSlIYE8lpqTbigwwSAmNvUOSdcPpCkKG3kKE8XImfE/EQQQ9+6aRDIM/qBRc/tBpeaD5R2HVNEXrPNxjg8VVWdVAwj3O4KBMZesxHMkWFp36EM94mdBOYVXbdxDcnzPYavUcu9KpBgzWpMmtmofWff4C0eg5lxUBAAA=",
    Pbi3DGeometry:
      "KQkAAB+LCAAAAAAABACdVt9LwzAQ/l/ynJWkWWPbPYkKgj4MFXwYe+hY2AK1kRqFMfq/m9m6uaVnrqX0R/Ll7r7LJV+62JP5Sr/s3hXJyYNZ6WdT6jWhZG50ZT9Ivti3nw5mM3eRhp56Jpyx2c/D3aRZ/ppd13Wxc7ZcyCjlMqMTPo3iNMuocG+RZvQc4TI+IFwmoh8ZZMNYG4fFHO2t49bjzXUcgAQdHkxTsIQDxODwwUnrQVrKcTKN0WHw6VwJmfQT8JCjtxMyxttlPTFxYOSsnh4xmLKPePXEpHlRG0z+sLPgbA5JJzzPPUsN3mtjvOERcELBXYCwCC7oIfWEN+5wxrAvPAIvW1igEDZjVmd44/g6NIZ1WFYRCKAcwAERHD1CZ6AIsGYPYxo8fREIrCIYRQie2P8rvPvvuNXFm7KqJjmLGCWPqtrYbdd4Mraw2lRd81Wvj9C90put7Rp3pfr6O/DGlMY5rD7Lsll+A0lk2nQpCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3109",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10411",
    Length: "25",
    Mark: "330",
    Material: "Copper",
    "Middle Elevation": "3125",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "124",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3125",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3141",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528160",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.46274241",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5AYE6SupAqCLooILkoXLYb2QcyTGoVQencDrd7A3fyYmXKAosFLfFjI4EgNFuRiSx4YFIQ+PCErhwmmgFSGG63kZiFXfKkVjOw/ZvWd3/Z9HdOHJOywvttge8gEFwxO1rehm8mZQh0w3Z7oFW8/62Cx7dKK5MIoBntn33NUKS60XjPIyVGq9S/nxuoDe10suRIBAAA=",
    Pbi3DGeometry:
      "BQkAAB+LCAAAAAAABACtVlFrgzAQ/i95TiUxjVP7NLbBYHso22APpQ8tDW3AmeGyQSn+9wXrOkUvOdkQxdyX++5yyX26OpHlVr8c3xXJyYPZ6mdT6B2hZGl0aT9IvjqdXx3MFu4iNf21zDhji+bhblKvf9yuq2pzdL5cJFGS0RmfRzFPYirmEedpShu7FLxBBJO8j7QeaZah7FdMxmdEilGHQehQSjFjGTZZngiAjfHxrC4egwXCCJwZHB/OGcHmLb6ImJSjUbpIt8oIe38bRxwmhO4vEJNUf+FdpLuNox4w1wCB84LjwwjMBlYG1ytQwRDzwQDB7Z1QLPj84rj+Rws8mzhgC3dpiA2HQIc1qEVepr/pXbCBJuggjmta+8Dy4VH7ANs0VYcVGlRV7McRyYSwgw0c1BQ/k38R7p/iVm/elFUVyVnEKHlU5d4e2sGTsRurTdkOX/XuAt0rvT/YdnBXqK/uxBtTGEdYfhZFvf4GkSChrwUJAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "324",
    Mark: "331",
    Material: "Copper",
    "Middle Elevation": "3099",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "216.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "124",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3099",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3099",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528161",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.76253422",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjlELgjAUhf/LfV5jm1PTnqKCoB4kgh7EB6OhF9YWtgIR/3sLtZeC3u653+Hw5R1kZzy2NwUp7OwZM6vbyhogkFk07g5p3g2nL/AgojFncjHjkvIoiaEnP2lAmZBfMEzC+T847RaTwLJpytZb+Mcay6tyqoGUUUZgr0zl6jEcrCsdevEhnvDyQVuFVe3ewcsJAhutnmM3EDQRTBJYWW39rnlo3RcvzG4oshUBAAA=",
    Pbi3DGeometry:
      "6wgAAB+LCAAAAAAABACdVl1rgzAU/S95TiUxfqB9GttgsD2UbbCH0gdLpQ04M5wblOJ/X7Bu1ppj4hDFeHLPvSc398b1iay28vX4kZOUPKqtfFGF3BFKVkqW9SdJ16fzq4bZUl+kof2XBWds2T70TZrNr9lNVWVHbctF5EU8EnTBA49HSUyF7yUijGiLhIIPEZ8FJkR4zA9Cm00CvCRDJpYIaojrEmFXLmI/MJm4SUHusURkAQTGLPRBvNgHFm/T2LKYctIBl9rPXD0wyElPNFBomD2fnw0NrhJo8Ay1gUhRSF0yDK6BNsAPlc1WMLE9JrKA9t94OuZ3WgunJEzXCmSaU1y2jmOIyrWGnCTCvEIA7XFL90JM9n7nZDJdeaa2ghGnKobF4dRBcN+2cGGT/5x0hshcjjMnifbGMz5Mxovu1kbcjqWxBP3ncCez97zOK5Iyj1HylJf7+tANnlWd1VKV3fBN7v6gh1zuD3U3uC/y78uJt6pQmrD8Kopm8wPkEwZk6wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "349",
    Mark: "332",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "233.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "124",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528162",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.25394322",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkbSxJPYkKgh6KCB5KDy2GNhCzUqNQSv/daKvUk7edfcPMZB2kpT62VwUJ7LDUKZq2QgsEUtTW3SDJuuH0hiCK6TyWYjELQipExKEnE8piypn8D6UUv2wa+4b5p37ZNEXrN/jHWhcX5VQDCaOMwF7ZytWjOKArnPazB3nS5y/aKl3V7iUCxkMCG6MeozfybSHjBFZo0OfauzF9/gTFRwPTEwEAAA==",
    Pbi3DGeometry:
      "HwkAAB+LCAAAAAAABACVVk1rwzAM/S8+u0GJ8+X0NLbBYDuUbbBD6aGlpjVk8ci8QSn57zNpujXUWmRCPpyXJz3ZspTlkS02+vXwoVjFHs1Gv5habxlnC6Mb+8mq5fH06GCYu4N1/O/NLAaY9xd3sm51pt207frguLHIoyyXJZ/FSSSLIuNCRABS8DECQnLh7iLLfUgYpyzLvEeKJCVb67V5FaRQ9EgCXmteDh6pTEpEG65gYt68SK/aIUmakf0Q44E8SkF6BFwBZ1uXQLCp8XKSfKDAaC2vVKFyfcBoIUkBjpaENImoqf8ncTIOfLegsvC0I1FQL0T36DziSU8LBTdG5NCU4Vs4PF3CswIvOrQsDqlg0xyasolyGL4lg3Y3XvRpJYTYQYgcmrKJJhpUD4NLK950ifU7pIOfOO5v406v35VVLasgAs6eVLOz+2HwbOzaatMMwze9/YUelN7t7TC4r9X35Ye3pjbOYPNV193qByXl954fCQAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2734",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "669.39 /",
    "Friction Factor": "0.024227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "10036",
    Length: "9193",
    Mark: "333",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6153.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "27370.62966",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "124",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2766",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528168",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.99043152",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv17D323m7CoqCOpCJOhCvNAaOlhb2ApEfPeG4t35Dt/hlCPkjb4NbwUZXFyjC/XwtW2NAgK509Z/ICvHJQYFWULTWMrdBjmNBYOpWr1939dDkENx1PVLedVDFtGIwFXZ1nczICNQOF977SxkjCJHIeNEMJHKrWRI4K6fi4vIEwJnpdvOzxzxmMDJqN+65hQFgYMzLjzZrzFT9QcrQwQg0AAAAA==",
    Pbi3DGeometry:
      "kREAAB+LCAAAAAAABADtVl1rwjAU/S95rpIPW1N9GttgsD3INtiD+KBYNNC1w3UDEf/7grZzmp4mDT6NIn7E09x7cnM/znRHJgv1uv1IyIg85gv1kqdqSQIyyVVWfJLRdHf8qWE61i+yD07/9Bil48OHfpP9rNp2s9nMt3ovE1FfsigOemzQ5zKOA6G/hYyDcyQUByAc8HNA0JAdEMrZxRZKY4CUblikrTpaa/CDqDUQwMjRGAtdGXMWcYAAU/6sao5Yej9dGI+reHF+bqxCuBzKI+OhuECY5ACpCLBLoDTGReROALvB1Kpg8tjZGBWymYBJGp7TfpoaYxBpExuYA5AzTg572uCL9jimeQM41bE1h/LAB8V+MDdc0Qbinmse1XZKdtBSnJPG6EGuTcvOCDdGA7HXMi5/iJilhCcGtuYwZVrMLDu3hkFrIO4dvaYCMQK7Buwzhi37eILHtAcah8Z91FqT0yX+/qKhRVtycH9FodFe5nlMDC8FclWdcVU14aMzPIYp3OIzYWzR7FRGpzI6ldGpjP+jMmYBuVPz96RINmRE+zQgT0m2Ktbl4jkv5oXKs3L5ppa/0EOiVuuiXNynyfffB2/zNNcGs6803c9+APg9WHyREQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "754",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "402",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528169",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.2994798",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUELgjAcxb/L/7yGf7eZ2ikqCOogEnQQD7OGDtYWtgIRv3urELq99/i996oRikafhruCHA6u0aW6eGlbo4BA4bT1D8ir8ScDgiyhiWC4WiCnsWAw1TO37ns5BDgEWy1vyqse8ohGBI7Ktr77GBQJI1A6L712FnJGkaPI4jAp0myZMSRw1td/eK902/mv5yIlsDPqNbc5RUxDtnHGhTP7NGaq32LSchvTAAAA",
    Pbi3DGeometry:
      "syAAAB+LCAAAAAAABADtV01r3DAQ/S86O4tkfVmbU2kLhfYQ2kIPYQ8bYhKDuy5btxDC/vcqazmtZD/JTuhNLNnEGc/MmzdPH3P9SK5umq8PP2qyJR+7m+ZL1za3pCBXXXPof5Lt9ePwpzXTS/shp+Lvfy4YpZfnL/tDTrvR7c3xuH+wvoyrjeZKFhdMbEqjy4Lb30LxwrMwQ+XZQkvmW0paVfM+EYvkZ4MSqlgIYAzGpDaLobloa3w4k6ujYZ80tplKYR5HG+MmpC0kR9HK+MGYfcO3jD7PFsmZB3rGJ4wmDVUetFelMZonfEamZ3wmhS7wmeTBtGHUL8ijmQS0wXJ0ybQvAi4TunlVMCg1rM7l60MpwX3OFBUpyws0AHmGBET0hLPgDuBqjKh8PRka8jlZ1Fi36WjpDXymo9gSygMKChrSS2DNzoHqj3EGVyeuH8pGOAMzdgd5slTcSZ1zV2cpzvzbNINBV2N+OVjKiqX2zkiakRqjfRcb3oOsqUwAw+kV989vIUMtwYMd3gVGxBZGmWompAzLfNHSCBFgmrEEYQMwnbADOD8Mhk/i9QKAHun+h23GSVCsSPFYGLAtkSanxTStBiPAqPE6R9xEACwAHSzBBU2DV1FOlQhWhjDuQKPDUad16gL9BGRIo4YOUMOdZM3AZqktpIX3MHiixgAg0Kp0CDiVJthpoQ/EhgmNiB1wE2EAI4PBsAu+VEGi4U4T6SfcUXADMLIIAWl1ThWNSIOYocf6LqMcmMqIyFAWXHwe/PPgnwf/OG158M+Dfx788+CfB//oDJEH/zz4e7fRPPjnwT8P/nnwz4P/mhz/f/DfFeRds/9e9/WRbOmGFuRTfbjr793D567f9013cI/fmttn04e6ubvv3cP7tv7974tvu7azAQ+/2va0+wMo6HRYsyAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3125",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "755",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528171",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.4417153",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImiZt4kpUEHRRiuCidBE1tIGYSI1CKf136wvczRnOMNUAxdHu+6sBBdtwtKU5Re0bZwBBEayPN1DV8ImTQpnAgjM6n9EUJ5zBWP+8RdfpfpKnYmX1xUTTgSKYINgZ38T2BZQLhqAMUUcbPCiKeUYyKVgiMpnmUggEB3v+lzfGNm18c8pzBGtnHt81S7AkUiJYBhemM393bqyfXmNDM9MAAAA=",
    Pbi3DGeometry:
      "qSAAAB+LCAAAAAAABADtV11r2zAU/S96doM+LNlKn0o3GGwPZRvsoeQhpaY1ePHIvEEp+e/TbMeuIx1JCfRNhIbYt/frnHule+9fyd1D/f3lV0XW5HP7UH9rm/qRZOSurXfdb7K+fx1+GjG9Nh9yyOY3V4zS6/7L/JHD5qh2s99vX4wuE2qldCGyK5avuC54JsSKSllm/yVSUzVIpFgIFC21W8UjkYL1EsGkXEpgALM1WpaRoU3GolUKJs+1BVUi4rKShF4myJimMhKYyRozvzLBV5qXfKljSaagJ0nB85C1KbajhGp9uZ+ljsmHKbVEOhRbnA70gzPFUV/kZ4mbkYhcB/KZdco87yU5C5XOBcZwtYXdxHfILGAs70ErhYqVnFEEHqCDcIaqwyXxIHCaznxI5EwP1o4R4L6GFYWtRZzf0M05h1G4oqDA4iacplUDEXDatIUlHgRO0pF61BADz2r0buIZ3is+RCz5MUtzBfaSQrNeogtnXItjyOnEvC6XCpKKZbicj/UndBkMDLmfrWk1FDM/6Sb7XoezwBQ0LyQD96fNJcIMlrmvM3AAAGZcfZAADCYkAJVSmBf7Hr6Ef6wD+ccTX4SbE2Mh9PERh3mxKI7oPs8o7CglN2PQSbj7HIMwtIbbDzIGR9GCKunGrGB01OHlkGbOQ8OzGvFXlA8qcuyLQvIlZ0w7L+A3ZR4zNViDBgr5tGTy0T3U8IzBeKzH8ENgPOnDyJCxMGN4nrVA9pwymEx4lngIwKHBbDDLoJY9BODjL0InnmfsJtwajv0RloAHgrTzp53f3Wpp5087f9r5087vL4+086edP+38aedPO3/a+dPOn3b+tPNf7Ob9d/5NRj7U259VV+3Jmq5oRr5Uu6fueXz42nbbrm534+OP+nESfarqp+dufPjYVH/f/uNt27TG4O5P0xw2/wCiSOJQqSAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "757",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528173",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.30539781",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjj0LwjAYhP/LO8eSNE1q4iQqCDqUIjiUDqmGNhATqVEopf/d+AVud8dz3FUjFI05DFcNEna+MaU+BeVaqwFB4Y0LN5DV+JERIZQnnFGymJE0ERnOYap/4LLv1RDpGKyNuuige5A4wQj22rWhexnCOEVQ+qCC8Q4kSViOc8FpynORzQXnCI7m/A9vtWm78PYpQ7Cx+vEt03gBC4Fg5a2PW+5u7VQ/AW8OtK3TAAAA",
    Pbi3DGeometry:
      "kyAAAB+LCAAAAAAABADtV01r3DAQ/S86O0YflixtTiUtFNpDaAs9hD1siEkMzrps3UII+9+rrLVZy/aTtUmPIiReZ3Zm3rx5+pibZ3J9W/94+lWRFfnS3tbf26a+Ixm5butt95usbp77j9ZML+0P2Wen/1wwSi8Pf+wv2a+Pbh92u82T9WVC5cqUIrtgIqe8yIR9MKWyg0EKdjLw3FBjsqmHNXDNw4aSSeUZSvsMJ6fazOeAqDyPqDo8g32I4qxQQ484rmCBA4M0FHCFKJHKaGvguTZK+rF8y5yPKWjpIY6JVtooQ2jvymO0JTHgM6B55DOHbcnnPN4CqM/OY79LBeBtWo8upPMxIiCDWdDxwSLFFqNbvDYYkz0uyUyk5R0SmKMZ1x8hqLEFM4ALLbiLFdy0ZtfAWE04VtzOOAwFsyNZBJhc4nhZ/lHbBiw/JtiES0gAXn7iCIA7C9Oityju0nDGDpZCOJ/SOB8lHYCxmicbJ85zKodp1VsM6334UYBU+6AhtAAAo9hRzcyLFnmaD2OVknuGV8RQzJAyLHMcC2WP4BgfAGP2A1RiZSwjwEfq5Bh+Q/+xC2w/7jLOgoPh5bS80Cd7A2w0VhMsBqoJI8ZZAszAJYOCBZZfXMuGR5bH2MtDaqcL7dIL3t+NuFk65xUVzkUcr1Njxeqyp8zY7TV8BQscphAAxDxYtC8ADnWKWJ8pNMgmbkAEN5M0uAUwWgwF4xtVxC0scOEfdxRuKLgHAWiYAmyBkg6wBvdN6PKGVi9TM2UTSg1ngfWnQT8N+nPnaBr0g6jToJ8G/TTop0E/Dfpp0F+iMg36adBHzKRBPw36adAH0NKg/18G/XVGPtabx6qrdmRFc5qRr9X2vntwL9/abtPV7da9/qzvXk2fq/r+oXMvn5rq7/CLV23T2oDbP02zX/8D+EWbD5MgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "759",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "518.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528174",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.77274319",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkaWxJPYkKgh6KCB5KDy2GNhCzUqNQSt/d0NYfvHjb2W+YmayDtNTH9qoggR2WOkXTVmiBQIrauhskWTee3jCLqOTxQgrKpRDQky8UUxYw8Zfx4Id9IgeUv4qXTVO0vt0/1rq4KKcaSBhlBPbKVq6exAFd4bQfPMqTPr/RVumqdoOI+JzAxqjH5A1DKiPBCazQoM+1d2P6/Ame3c0zDQEAAA==",
    Pbi3DGeometry:
      "VwgAAB+LCAAAAAAABACdVd9rwyAQ/l98tsH8tKZPYxsMtoeyDfZQ+pBSaYUsjswNSsn/PsmSzTReNCUkxM/zu+/OO92c0XonXk8fHOXoUe7EiyzFHmG0lqJSnyjfnH9/9TRZ6Qc1+B9ZhISs2o9+UbPtl93UdXHSaxdZwCKKWRJESxbiOA4YSxNswCllLZwlkQkvW5DGMXZTaNskICFNR7wajjJqwlGWzVEBOJwIxdvllJIxSZxao2zhcaKAcAYuqSYjyWWyDXRAYlqb0V/a98qH7L1wD5ZJdosaKCYIB1UCfgeJ9+C5So8lrsHO+uTNVh4+9evkcIBQToCSdpsD9TJrF4B2mSlwqukcMLTz7mYEzCF2L69QXc07pNwsPjBU+8Dp5TaH2L282k9B50k6i8MFQt3t0bDghWjj7lF9S9+J4p0rXqOcBASjJ14d1LEbPEtVKCGrbvgm9n9TD1wcjqob3Jf82zS8laXUhNVXWTbbHz1Hi1RXCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3052",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3062",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10354",
    Length: "25",
    Mark: "334",
    Material: "Copper",
    "Middle Elevation": "3062",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "109.8",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "125",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3062",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3071",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528175",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.48841646",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnTN9QzMjSytLU30jEzNLZVqdWggFwuz2rGoKLESaD9QwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhnCDc9MgUt5pGamZ5SAOBaWFjpKrjmpZVClxsZ6BsYmljpKzvk5+UBj80pzcmpjAf2o6NgOAQAA",
    Pbi3DGeometry:
      "cQgAAB+LCAAAAAAABACdVV1LwzAU/S95zkr63WxPooKgD0MFH8YeOha2QG2kRmGM/nfT2dU25jZpKf3Iyc25597c3G7OaL3jr6cPhpboUez4iyj4HmG0FryUn2i5Of9+qmmyUheq8R+y8AlZXR7qRvX2uuymqvKTWrtIPRL5CaaRF8QpxWHo0TCguMFT9W7wIEkGeEyyCx7G2QCHeK72mZE9o34f9xXNJDWQV1tUjn6tejQeQmNDsC2oZwyICfSpZZ6EkZGnw7Uc/LNvtXf4YKesLDZ2TY0elQ0HVUJ++5m3kcwWo6d4uLOQRvNZMOfdYutY75Y9hXILVbUTy7wTD2oZO0mjzOMVYQJdy8EoY5Lx1H4DFJqlsziy2GCo6KFe7EYzsyuCaqD/EYQ78lhxx75o7d6O9g2u/t93PH9nklVoSTyC0RMrD/LYDp6FzCUXZTt84/tu6oHxw1G2g/uCffcNb0UhFGH5VRT19gdlKvaicQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2769",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2769",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10069",
    Length: "274",
    Mark: "335",
    Material: "Copper",
    "Middle Elevation": "3043",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1183.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "125",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3043",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3043",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528176",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.6661491",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfFXddCO0UFQR0kgg7iwWjRgW0nbAtE/O8taiFdus2b7/Hey1pIL3hq7hoS2NMFUzJNSRYYpITWPSDJ2uH0hpmQXAVCLWPFpRQKOjaBCy7C6D+L1Q+bhvYw/5Sv6rpo/AL/2GBx007XkAQ8YHDQtnTVKI7kCod+9CDPeP2incaycr2Yy4jB1ujX6A0lj5WQDNZkyOfapzFd/gbqoQwdEQEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACdVd9LwzAQ/l/ynIU0Sde1exIVBH0YKvgw9tCxsAVqIzUKY/R/N9RWW81111Famvvx3XdJ7m59IquteT6+aZKRe7s1T7YwO0LJyprSvZNsffr+9Wq+9A+p6a9kFnG+bD7+JfWmc7uqqvzofWeRYIpHiqaKCTGfUylYmghFB4o4SRuFisRQIeNFo4i5pDioziNVcSCGZJzLZKhYpNFEVmDw8QQnBR9nFYQK5w1sIJjcIHDCIhkHjqInHwD15IO9+Gvf8Q/gNwkgcEbxA3ygvCA5xBOKG2YPoVzEJpQVojygTQbLBuMw9VigAOB1Rt0TVGHgPDCcRksMffRBa0CKag9hGFybQdij+ITvYbhljJP/Z32+7YCN7XylwH0QYY/hA46wqQ0VsofkuCkFAU0att7DT/4bk79qpyuSccYpedDl3h3axaN1uTO2bJcvZvejutNmf3Dt4rbQn33Da1tYD1h+FEW9+QL+1QkhqwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "1605",
    Mark: "336",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6941.5",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "125",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528179",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.26324259",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPIszF1JSoIuihFcFG6aDW0gZhIjUIp/XerUnA3ZzjDFANktT31dwMpHEJtc3OJlW+cAQRZsD4+IC2GX5yUhcJEMb3SAjOpNIzlrK27ruondyq2trqZaDpICSYIjsY3sf0ApSJBkIdYRRs8pBxTQaVmieRyqZXmFMHZXv/lvbFNG79MBEOwc+Y1rznWnGkEm+DCdOafzo3lG4cHz2XSAAAA",
    Pbi3DGeometry:
      "vRwAAB+LCAAAAAAABADtV02L2zAQ/S86e42sD8vKnkpbKLSHpS30sOSQZc2uwY1L6haWJf+9wh9tNNGz7J6VJWE9mTy9eTMaae5f2d1D8/XlR8127GP30Hzp2uaRZeyua479T7a7fx3/dV/zW/fHztk/y03B+e3w4d7svJ9/9uZ0Ory4396YnBdcZVblwtoykzK3Vqvs0l4ZlUmVc6GsZxdV2I78tbGDXZpiFU5RCszH2Uvt+yP+A37AH+GgdZF9cV2kg/PX0qziQ/kbYb11pRjtSvo4s332n/lP9oIL6eFTO8JB6xIcyEcWwtMhwgeui+IqlF7EJ3yi6xJ8GBfSAdWPVqVnN6F9cZF3oQsvLmXKVXWF6p/aEZ9Yfqk9xpOuC+oB4mzlg+JC+Z3953qjeaH7FNVDDGex327oVzTvSDdkR/rH+gndjyje2H6hdhQv4l+J0W6EHvotV4G+etGHjZ7MI4x1zwOMmehLvSqsrTIgfECnFP6pKWRxnfXAaYpOX2S3shxVs/+jDj4stkWFclhVfi831VKLR+6IZNgdkYEwSGIUVCy1tDFEG4mfQhwu4ANyBQs/7I4KChVsTAV6fZrZKymCWbk6vkeagtCMdX16SsyFL9wyoaS7V2j/0GURfOwSgC6ddFmgDlQTqR+mD0WOqlMFey9VB0QVvcpd0QlvaHgDCLPZGhTSHsEDd9gbl5valQYAHmiTpr80/aXpL01/afpL01+a/tL0t0WdNP0tSJymv6WCTdPfmktAmv62XBXT9Ldl+ttn7F1z+F739YnteM4z9qk+PvXP08Pnrj/0TXecHr81j3+/+lA3T8/99PC+rX9fOr7t2s4BHn+17Xn/BxGVumG9HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3062",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "760",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528181",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.89500223",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2zinNO5TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRmcBEUDmXDNNMSJiaH7boezVENgYroy466B4KggmCnXZt6F4mSRhHUPmggvEOigRnggjJU8qFZLnksT2Y8z+80abtwtsTRhGsrX581ynFMiU5gqW3Pp65u7VT8wQDwHCR0gAAAA==",
    Pbi3DGeometry:
      "xxwAAB+LCAAAAAAABADtV01r20AQ/S97VsR+arXOqbSFQnsIbaGH4INDRCJQreKqhRD837uRtXY01tPK5NDLYmys5/XMmzezszu3z+zmrv7+9KtiK/a5vau/tU19zzJ209bb7jdb3T4fvvqf+bV/sX12Qq4E59f9h3+z/Tr87d1ut3ny/72yObfSZU7nUhQyUyrnSrvsBddK97gs9SRe2mmcrldC9rixbpGdwMe54jUuuFST9gH/43piP2qH+I3iSDfqV2gzpQPiA/kro09+Ze6s1CM82OFivL7nP7G+t+9xrc7NnMPIa2BJvSI2QQWhxRI2yC0KqjfvccXLJVEBr8g6CoqIAEvHDVsi2HfczqZc8mIkmuRyUUmh0qdbDvGJJZfiiGeslGkxIDsX8onGRfJ7XB+qjeaFblFQD8hOtFWhFkBxlHekW0xPtBlRnZPdCHWL2aE4ihfw54U64Fod/BZKzh5F1vPq8aE7WE56nvf/ghtrF8V1sQ7EPuDDtRGjLlbKZUcpOqopbsrAR75FH9BVLw4LpdFxNVpvivK8bE9NPrqe0ATLER1kBokMixOogO4TqJmAJCKaiA5KFuxhYD2qKVizQAZ0LQz8rTSTWRkf4UeaJShl1PrhUaHMaOuGcJ0qJrdQCeQk9iGOrg7IL5AH39ZRFUZ0QzclIg+83AN5QFjR+xzJOtrSUOVYlSwMC6mPwoXZAlmJdTYiAzKP5EkjYBoB0wiYRsCZ8y+NgGkEnNmNaQRMI2AaAdMIOFlTaQScs59GwDQC/tcRcJ2xD/XmZ9VVO7biOc/Yl2r70D0OD1/bbtPV7XZ4/FHfH3/6VNUPj93w8LGp/r5e+L5tWm9w+6dp9ut/3N7RrsccAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "762",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528183",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.20438526",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjkELgkAUhP/LO6/L7pqKdpIKgjpIBB3Eg9KiD7bdsC0Q8b+3qEmdur153zAzeQ9ZhefuLiGBg6kwM6qrjQYCmUFtH5Dk/XQ6gxfSWERrL6YsEBwG8oUiyjhb/WNcBL9oSRxJ8alN27bsXLd7bLG8SStbSBhlBI5S17aZxcnY0qKbO8kLXhe0l1g3dhShCAjslHzNXt+nMecRgY1RxuXqp1JD8QY1lIoZCwEAAA==",
    Pbi3DGeometry:
      "XQgAAB+LCAAAAAAABACVVVtrgzAU/i95jpKo9dansQ0G20PZBnsofbA0tAFnhssGpfjflzlbq/PkGMTL+XL8cnKu6xNZbeXr8UOQnDyqrXxRpdwRSlZKVvqT5OvT36dZZktzkYb2iMcZW7YPc5Nmc/7tpq6Lo/nXi/0sSKiX+ZyzhIahEVlKe5jF8cIGmxeuvEjCFo6CDOWA7EjTuIU5T/AdLyQj6iydsAPYcZoDOPjZuiQKZpzFfvBfNPEZZ9E/5Qm4pe7x4ZY4zSA0OD2ID8KDmwPj1yGa0B+ZP/A7elqAxc3zoIcxVw4zBqgJNxIchXwFpC6ujqTjvPgAteVmIVTkKAqlG9AoZqi7pBWa4uM25GiivZnZYKicgSaMqrsWP0gPjBVHI5FJZoOhKsfrFhl9lvZqZvWdLN6FFjXJmc8oeRLVXh864VnpQktVdeKb3F2WHoTcH3Qn3Jfi+1rxVpXKEFZfZdlsfgChttdfXQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3036",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3046",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5984.53 /",
    "Friction Factor": "0.02296",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10338",
    Length: "25",
    Mark: "337",
    Material: "Copper",
    "Middle Elevation": "3046",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "152",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "36079.08262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "126",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3046",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528184",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.46815902",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnTN9QzMjSytdS31DCwszJRqdWggFwuz2rGoKLESaD9QwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhnCDc9MgUt5pGamZ5SAOBYmpqY6Sq45qWVQtcbGegbGJpY6Ss75OflAc/NKc3JqYwGJGZ8zDwEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVd9rgzAQ/l/yrHLO3/ZpbIPB9lC2wR5KHyyVNuDMcNmgFP/3xWldTb1eFFHMl8t3310ul9WRLTf87fCZs5Q9iQ1/FQXfMostBS/lF0tXx/ZXTcNCPay2/hHbBVj8fdTL6vVp2W1VZQe11o4c8N3QshMH4ji0PM+JY/CtBo9ukgZ33SQe4AHELQ7RAMd4OnsIw2CMH4LIO8ddRTRJD+aXiMvUL6VH54EkGA23hS+yhkSFetWyD56fjPH0uJYF3f6kvse13SJ5CH5djx4XhaM6Mb/D7FM0c+VcpHm4u5hK7Exg2SftDWuf3F0sy1iNG/LM7QGonqtni2KnamQcNi0RRMxE86ndCClAousYslAwdhiwTm1GM7Njomqw+wrDDXlI3LBjkp3d0L7B1f1+z7OPXOYVS8EBiz3n5U7uu8GLkJnkouyG73zbTz3mfLeX3eChyH/ODe9EIRRh+V0U9foXP4ckWJEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2769",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2769",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5984.53 /",
    "Friction Factor": "0.02296",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10069",
    Length: "258",
    Mark: "338",
    Material: "Copper",
    "Middle Elevation": "3027",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1542.2",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "36079.08262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "126",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3027",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3027",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528185",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.4061892",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9jssKwjAURP/lrtOQRx+mrkQFQRdFBBelixZDG4iJ1CiU0n832NqFiLs79wwzk/eQVerU3SSksLeVyqzuamsAQWaVcXdI8348vSFIMOFxuAwow4soETCgH1BgGlH6zSgR/D+bQ4tP+apty84v8I+NKq/SyRZSggmCgzS1ayZxtK50yo8e5VldZrSTqm7cW8QsQrDV8jl5OcMipAzB2mrrc81D66F4AVAHAWMRAQAA",
    Pbi3DGeometry:
      "sQgAAB+LCAAAAAAABACVVV1LwzAU/S95bkPSD7t0T6IDQR+GCj6MPXQsbIHajBqFMfrfDV2rrebmg9LSnJt7cu9Ncu7mgtY78Xo+cVSiR7kTL7IWexShtRSN+kDl5nL91Way1A/qol8kpoQs+49+Ubcd3W7btjpr37jAhOVRTBO8yAsWpQlmLNOAAc9J2uM5WZgNkEORsLkho0kY0xASJRmdG4okC4t1TG4eU4oJSQvb0jATmERGb/yCdTLZ12aY5pT+q58bdrH0NZrg47b5sQ/wdc8m+LQKhmAAeBbLZLv+xj7O74tvWBXKFeLxxR0lBs+Cld9ny50r+FbCVWnwxliJQIegSwnF5CtdrtyCziJ0ou3qBPEECAToYL1jAUrte1cdMgPpBtgHbDzQ/KBGA0Xkr7iu3Hx1ZdYcDJX2FgpnlzGloPv/vajeueItKgkmEXrizUEdh8GzVJUSshmGb2L/Y3rg4nBUw2BV86/pxDtZS03YfNZ1t/0Ga5q7LrEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5984.53 /",
    "Friction Factor": "0.02296",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "1130",
    Mark: "339",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6761.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "36079.08262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "126",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528188",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.94771802",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjUELgjAcxb/L/zzH5qZudooKgjqIBB3Eg9bQwdrCViDid28VQrf3e/wer5qgaPVpvCvI4eBaXaqLb2xnFCAonLb+AXk1/WJQogyTLJarSGIiRApzvWjrYWjG4IZiq5ub8mqAnGCC4Khs5/sPUMpTBKXzjdfOQs4w5TSRcZqwRMhMMorgrK//8l7prvdfJjxGsDPqtawZFoJwBBtnXDizT2Pm+g3giZK60gAAAA==",
    Pbi3DGeometry:
      "jxwAAB+LCAAAAAAABADtV02L2zAQ/S86O0Gftpw9lbZQ2D0sbaGHJYcsa3YNblyybmFZ8t/XieXElvQsu2cREuKJ8ubNm9FI8/BO7h/Ln29/CrIht/Vj+aOuyieSkPu63DevZPPw3n1tf6Y37Ysck6tlxSi9OX+0b3Lc9n/7dDjs3tr/rrI1ZVQmq3xNZZonQqxzyfNkaFc5O9szLod2xrTPjJZTrdOzXct0BgwTlE+yYUIlM9j38PZyAIPcQjoBt0gEyvgsOhb77OTl6lVr2sFLMYK52M36nn1vZ5SLAbxtRjDIrQUD2YhT0FcRAmygVxQUk2oK3qYTcGvDw6iACKhw1Kn8B3bu3w59xrlio6Dy03O4oEDZ22ZEZjqxtjnA0XYKygDCLCODQkJpNesvG9nKh7MzURmEcELddWaDchKOVEN2pH6ghTi7EMUb2CaOHcWL+Gve2TPR+VXc30n7zpt1TUEZ2WQPk3X0lZgV1VIVADwgk/JxbjOaenOuQW3OPYIVN5pl/6ENPh2WBYUSqPWofedcqam2DtcjmmA94gNxkMgorlBy7cYQbEjjJOJ4AR+QLlj5/uWopFDJBlSw70uGPKOC+5LinNnKWMckAz3fOSNM4TMuvSlv7dyzfxy3CD509KO7p+0WiIO0RNL72SOJQ9pYToE0IKTQ3c0hA/YyPPz9bBbGhHRH6GA5bIzTDc3RAMAjbeKYN2OrxTEvjnmT99c45sUxbwonjnl+exzz4pg3ecuJY14c8+KYN3Qbx7w45i0a87YJ+VLufhdNcSAbuqYJuSv2z82LefheN7umrPfm8Vf5dPnpW1E+vzTm4WtV/Bsu/FxXdQu4/1tVx+0HGOBvHI8cAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3046",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "764",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3130.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528190",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.37807436",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAYhN/lP6chTWuWehIVBD2UIngoPUQNbSAmUqNQSt/duIG3Wb5h6hHKo9kPVw0FbP3RVPoUlGutBgSlNy7coKjHj4xIwjHhVM4TiYkQDKbmhy36Xg2RjcHKqIsOuoeCYIJgp10bupdJ05whqHxQwXgHRYpnnHDJMsq4zIVksT2Y8z+80abtwtuTnCJYW/34rjOKZUYEgqW3Pp65u7VT8wTMb2650gAAAA==",
    Pbi3DGeometry:
      "oRwAAB+LCAAAAAAABADtV01r20AQ/S97ls3sh7Qr5xTaQqE9hLbQQ/DBISIRqFZx1UII/u/d6MOOpH27MrmFxdhY4/GbN29nZ3dun9nNXfnj6XfBNuxLfVd+r6vyniXspi73zR+2uX3uvtqf6cq+2DE5W1ac6Kr9sG923A5/uz4cdk/2vyu9JslFssrXZEyWSGmfVZ682JVUrT3N+Ws7JyFdduRPWuStXWX5EhzOVerjw7kZmQH9AX7q7kZBQSGZQFQkApckltAB5PuoPOUWXaxzLdQIpbVbf+Ij9lP/E/xgV3IOczaDqGOUc1TE5qTBYOeK+9igsCCpMby1SzKerEBUiI4kBiKECorTy26w+Dlp34qf6iaTrV3Y+vHUE4BB5hCZhckilqGkJoUQhLlQ+1laaG2HSpv4o46D6hvBBBrssg4FO0iwQoB9Kn4oq0tFW9oVQulO6KemE1Pnsg2bSeE9fVR/+phMdfSp7y56vP1TrZcs4mIZED7iM5ySGXU4RnhPT5wvsEvd66bepg84Iy5NCy3jsOyUdVEz4+3twB2QBN6BkgKn5EzhQEozCVBbwBUFVtBNE2aFFhztZ1ggbjqoYIEM8MZkdOrij85tctOEVyB49BnlqntrT13pBuOiMwjY5xdKd9yQPPAWPpffzR/JjOQBl3kID9ICGx3dEd072nOvQWwuysojvnuvAP9Q05+mBUQIoE/bXZz34rwX570478V5L857cd6L816c9+K8F+e9OO/Fee/dzXvbhH0sd7+KpjiwDa0pYV+L/UPz2D98q5tdU9b7/vFneX/66XNRPjw2/cOnqvj32vFDXdUWcP+3qo7b/3mc24ahHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "766",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3130.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528192",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.53580283",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jj0LwjAYhP/LO8eSj6Zt4iQqCDqUIjiUDlFDG4iJ1CiU0v9utHS7O57jrh6hvJrz8NQg4eivptK3oFxrNSAovXHhBbIeZxkRgrOEYZ6uV4QmIsU5TM0CbvpeDZGOwc6ohw66B4kTjOCkXRu6n6E4pwgqH1Qw3oFkCUkJFzTjjBciF4wguJj7DJMcFwgO2rRd+HvKBIK91Z+lHT8QzBFsvfVxzL2tnZovC+dp4NQAAAA=",
    Pbi3DGeometry:
      "RycAAB+LCAAAAAAABADtWE1v2zAM/S86u4FkybacnoZtwIDtUGwDdihySFGjNeDFQ+YNKIr89zlOmvhDT6S9q1C0qc08PpKiSIL3r+Luofz+8qsQa/G5fii/1VX5KCJxV5e75rdY37+e/m3F8rb9EYfo+uZGSXnb/Wl/xWHzBnu3329fWqyS6crIPLpR8So3Mou0XkltTDQQWJN0ApXGDkH7GduMg2hfyDjtEFns4nCp6qxqP5VMBgKbp7nbKuQHgYAcc6wiguhQBTlsZq0zVhM/Yqmsm2QkcWLGFpPaHMf4Xzwef8ZhHmGcnhKYmXHD0VnAMzlS7I+WiSF4ZkQH5i2mgfnJOAMidecnO4uEdn9JlCkaRz3BzizQNRaMTObUOZqFrwvTYwn7prvq5oQmkfp8aZP0pCxR/u7DgPCd0Wmmfb2MbHJ9wwhds3zx1KysfdFJstaroyTWzvxnYdido3/OyVmZPd2/3A5sdnUUow2QIF0Mi0F3msMCdcHj14ke6jKp9c8GEKGNVD0fjxDlSv6+Lgiha/+0XfhdcTkPU5zhC7Rr0q9xtuAen0rTu0lHSW4pDMXjtYDffDm2LcFMkyNXJ6uN0T7JtAP0JJfSiLVdsuBNcs2C+TxxqlIWZhCdAWY6A9CYPg/2FEdnAc8138ZxI/3B+ea0AOYOlCyJtUeCbxa2zYOheSYRRRWfewacfoctxixU98a5hgcb163C/RP7iSVYG4jNEpvxNOSRcOsXvu+sEc5jgacn0jyTCgqHBW7RZU0e2GYPDTF6OGrHkurl4eH2N97ARA5yYYUWVmgcbfSgOo8nrNDCCi2s0MIKLazQwgotrND8g2xYoYUVWlihhRVaWKERmLBC8w42rlsVVmhhhRZWaDNXaJtIfCi3P4um2Iu1XMlIfCl2T83z+eFr3Wybst6dH3+UjxfRp6J8em7ODx+r4m//i+/rqm4V7v5U1WHzDyTwxctHJwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "768",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528194",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.10945394",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zssKwjAQBdB/mXUMSZo+EleigqCLUgQXpYuooQ3ERGoUSum/G1q6mzucy0w9Qnk31+GtQcLZ302lH0G51mpAUHrjwgdkPS5jJJRkmBFabDeUYcFJDlOzwl3fqyHquDgY9dJB9yAJJggu2rWhmwPLEFQ+qGC8A5lgymkqWJYmaSFykVAEN/NcLKU84pM2bRfmTDhDcLT6t7bjC4xwBHtvfbzlvtZOzR9EFN7e0wAAAA==",
    Pbi3DGeometry:
      "0REAAB+LCAAAAAAABADtVl1rwjAU/S95jiXpVxp9km0w2B5kG+xBfFAsGuja4bqBiP99pbabiz1tjD6NIlrj8d5zkpvcnOmOTBbqZfsekyF5yBbqOUvUklAyyVSaf5DhdHf4WsBsVLzInv7+MuCMjcqP4k32szpsvNnMt0UsZ6HDRSDogLuO5FFIveIZMI/+RXwmSsTnroYw6ZeIcP2mGM9hzBO0mUf6gXG2Dp5GbaEbgflgRHAJeOqYU9V4plg1zoaR7mz1fFzGoyrGkwdtUkdq1W7Fo8UUTy8ITZEoqmpaa7tMgazmA7I1ahMiOFd1C0+9q1x2DQUdPI1rUGY7Wrdz9ujpPsAKdMQkG56pjuBzitfaJAbz4LONz6l+5kzqoyMm2fSa2lTbpHI4BvPY9B29kxv0gxPEIFtLD9ERXG2TyuEYzINvM3wz6TetSd/BpwRnM+/kuNomlYMxLTzYbeCdaOMcbO5tGx4b92TjXXD3t/Yultq6V+ciF9DlKZr2dUuMeSe/zFPgHo/vYMxzXR/SwdP7kN6H9D6k9yGtfecf+5AZJbdq/hbn8YYMmcMoeYzTVb6uBk9ZPs9VllbDV7X8ge5jtVrn1eAuib+O/3iTJVmRMP1Mkv3sG3FpXbzREQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "770",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "944.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528198",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.64629504",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO4fQJE1M4iQqCDqUIjiUDlVDG4iJ1CiU0v9u/Oh2dzx3V41QnO1xuBvQsA9nW5pLbHzrDCAogvXxAboafzIhjGAmqViSLMdCEgFTPXOrvm+GBKdgY5ubiaYHneEMwcH4NnYfQwTnCMoQm2iDB80wyQlXVHDGpVooRhCc7PUPU5Xszti2i98lSSmCrTOvuU1xajAE6+BCOvNP56b6Deid/6nTAAAA",
    Pbi3DGeometry:
      "6SMAAB+LCAAAAAAABADtWE1P20AQ/S97dq39tJ1wQm2lSu0BtZV6QDkEYYElN65Sg4RQ/nsNdsJ2s887C5xghYJwHjNvZjw7Y7/ze3Z20fy8+1OzJfvaXTQ/ura5ZBk765pN/5ctz+/HPweYnww/bJc9ffNBcH7y+Gv4sN1qb3a63a7vBlslcl0YlQmu86ISRaZkvlBCZTZQCj4CWmkPoHLOhSFaSFk+AqUkuhqjGgChHMBI4+WAeQQsIEdUVPNF9LmCHJobb63cPORiUXk5HMBj4YZLcOXcwRdwwDzc6hIA6MqpbjhBHO48uc8VjMq5taqSxYsyJ7Qo5ICdSEhwvkXjm5rAQcjcAQjVnefwjQyYR7wrB3DCJQwyAgfVFSSHAPU4+8hdQAw1Gw+n0KMrLecXS9CCnIeWqgzsqPnlZUUVdkXNAxZRmcWYR8n1BFSBO4gsqNsAbhwf4GSu9HAWo/YHtIB5UMvue2AhW0AObuyoHiwKMwsQBrILQI7gc4mbB/V+WBZGVlaLPgC8nLcIcyCAvLzCUcVbHN1zIaayF1rNAJ4pegAOEw65OvTV3mLfV9EcyihDsbBL8p+FZ3MGLOxBBhLE4UZzPPWVU6twHrCvjslBl2AgvroQwKMPkWOLIIdbRGJ1KZOaGJXlCm614LqDfQWfAI4PDiQPnSgyB35gQQB1lsAzSHkugVFhiyCHO8iIE46ya4lRWa6ev52PjnP0LMHkMNx3psnAl7goseYVNRmq9BJ+fX37mgx8cY8Wa15dkyFILzCPpMkkTSZpMkmTSZpM0mSSJhOzvJImkzSZpMkkTSZpMkmTeRuazCpjn5r177qvt2zJc56xb/Xmqr+eLr53/bpvus10+au5PEBf6ubqup8uPrf1rf2PH7u2Gxxubtp2t/oHKuMVNOkjAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "774",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528199",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.69866123",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkbfpjPYkKgh6KCB5KDy2GdCEmUqNQSt/dYKsUL9529htmpughr/HU3SRksLc15lZ3yhogkFs07g5Z0Y+nN4QpFSxNlpwJmvCUw0BmkFMRR+F/GIvoB85iR1h+6ldtW3V+g39ssLpKJ1vIGGUEDtIo10ziaF3l0M8e5RkvX7STqBr3FnEQEdhq+Zy8YUAXggcE1lZbn2seWg/lC4jANQQTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACdVt9LwzAQ/l/yHEPS9PeeRAVBH4YKPow9dKxsgdpIrcIY/d8NtZ2N5rrLKC1Nv3zf3eVyl66OZLlRL4f3kuTkQW/Us67UllCy1KpuP0i+Ov68GpgvzEU6+vvlSnC+6B/mJt16pF03TXEwXJmykKcJFTxkiQhSKgOWJUFIp0CcirgHQhFYQMJl0gMRlxQldWJkYeSwIRnvJ0yBXtvLK9D4fIBexue9ckplkTvyEfi7iGCAtnHBwjiSjnxMAFtqyrCW5B9jjMNlo48DI3XGhsMrMEAYAN0FjVv5wEhd6pUzQCDn8CJChQPnA2R4Jwq0Ae923PbBFA6SgfLqbA16bAaIAQOoXgJK4doSioHzCmpLFoCrD5ABAWDr866omS6KYmC8gs9B/4YMMWAAd9yBUl7HtmGYf4hbVbyVbdmQnDNOyWNZ79r9MHjSbdEqXQ/DV7U9Qfel2u3bYXBXlV/TiTe60kaw/qyqbv0NEmpM9vUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.7 /",
    "Flow State": "Turbulent",
    Friction: "819633.46 /",
    "Friction Factor": "0.014957",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "2116",
    Mark: "340",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1734625.5",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "523146.698",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "106",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "42.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528201",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.81758246",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkNoXm0TV6KCoItSBBeli1ZDG4iJ1CiU0n83PrqbGc7MVBMUrTmNdw0KDr41pb6ExnVWA4LCGxceoKrpJyPCMc9ktiIJx2lOUpjrBVsPQzNGNgZb09x00AOoBCcIjtp1of8YkgqBoPShCcY7UAwTToSkqWAil5lkBMHZXP8wldHuten68F3KKUWws/q1tCmODYZg462PZ+5p7Vy/AX41kOLSAAAA",
    Pbi3DGeometry:
      "gSIAAB+LCAAAAAAABADtWE1vm0AQ/S97pmiB5cs5VWmlSu0haiv1EPngKChBoqZyaaUo8n8vCWDYZd/ObuJTs7Jsmefx27fDMAPv+pFd3dTfH35VbMM+tzf1t7apb1nArtp63/1mm+vH4Wv/M7/oX+wYzMi7iPOL54/+zY7b6W/vD4fdQ/9fEaZZnAYRF2FWRFmQxGGZREmwwPOID7hIxBpPQs6j1Co+jvNnPI+teAY9PR4lMp72XzT8SL85HvE76DHmTcOD+AVPdflR9CdlVur4FXwdr+ikeeTz9WJ+pF/JJ40jHjmf5L6gTuO6Gh6kRz6PIi/zV+yXrEPEj+qN3pexDl3rluSn9yvjdD6N/Jo+gPS78si4opPsSzS/HQ9aF+GW16lmXQXn5dT3IjHwiNg0F6h4S/1pzAvzfDHOnVkPyWOnH+VNpNmgP+dixAvj+QLxlv0czQsNLu9XJEXm0v9RPNJvmWfNfYVlPOLn8VLPU3yWGnC6ryo44qfuHxT9lvmf40VZLurwCee5KZ7kB7jl3CH1uMar55cX4/nNRILxdT884VO/Ajyn+pnip/px4xcpzyzi5zzI8et5Z45f9CX9vqBOR/65fuT8kPpR/ajrgnqAuGs+EY76GFoX9j2KX8mbXT7pfmunZ+ZB84iaU6h+0LxeXRdoXeJ6seSH9xUAt+wP6Pqi7x+QHhhP8St9ya5f0fPRTs+i375wnqrXqWN/wOsCnW/D30DPTQ6+x7n8DTsfg3xO/G/9DfRc7Oh7nNffIH0MpN/7G97f8P6GZi54f8P7G97f8P6G9ze8v+H9De9veH/D+xvn9je2AftQ735WXXVgGx7ygH2p9nfd/Xjwte12Xd3ux8Mf9e3pp09VfXffjQcfm+rvMvCybdqecP+naY7bf46tNyCBIgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "776",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528202",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.15187502",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyE0aVrbehIVBD0UETyUHloM6UJMpEahlL67wda/k7ed/YaZKXrIazx0FwkZbG2NudWdsgYI5BaNu0JW9OPpDSGjPE2TOQsEnbGEwUA+UNAo5tFfFovol32HjrB8lS/atur8Av9YYXWWTraQBTQgsJNGuWYSe+sqh370KI94eqONRNW4p/ADCKy1vE/ekNNUME5gabX1ueam9VA+AKHybbwRAQAA",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACdVt9LwzAQ/l/yHEuS/u6eRAVBH4YKPow9dCxsgdpIjcIY/d+NtZup7dWLlJXmvrvv7nK5y1ZHstyop8OrJAW50xv1qCu1JZQstarNGylWx+9PC7OFfUhLfyQXnLFF97I/0q5PZpdNUx6sbcgDkecZ5SwKUi4yGoogT0VEXSDJeNIBERcDIGVh2gExCymK6myRR/GEjzBgnYILdNxeUYHO5xP0cj4f1SRVHk9nfgJ+byKY4MB5FMSJiMflcOQDIlff3Y+Rfp/DFP9XCgieef5xPFBeoByKE/LrlgDB8794pvICKgxuHNQlYAVAA8/SQA7gY405K6gGwVmgYvqz1dAHANAH5ZhxAREhBw/GAhcTNHdcANUOkD4gB+eab//MTEiMBSYm+IrzHbaAPihH3WIQkd9lbC3sP4NrVb5IIxtSsIBRci/rndn3iwdtSqN03S+f1fYM3Uq125t+cVPJD1fxSlfaEtbvVdWuPwFFLxlHywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.9 /",
    "Flow State": "Turbulent",
    Friction: "682352.75 /",
    "Friction Factor": "0.015101",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "8150",
    Mark: "341",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5560867.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "475041.2545",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "105",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "38.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528206",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.89356881",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jc0KgkAUhd/lrieZGRXTVlFBUAuRoIW4GPOiF6aZsCkQ8d2b0nbn5+OccoS8psvwQMjgZGsq8OaUaTUCg9yScU/IynGWHomjQESblZBBGvEEpupPbfteDR71wZ7UHR32kPGAMzijaV33NZInkkFhnXJkzVJfqZlbkfA1gyNS27mfl2HK4KDxveChPxU8ZrCz2vp189J6qj40TQkYwgAAAA==",
    Pbi3DGeometry:
      "uSUAAB+LCAAAAAAABADtWMFq3DAQ/RednUWyZFvenEpbKLSH0BZ6CHvYEJMY3HXZuoUQ9t+r2s7GK+tJI3oqiJBsvE8zb2Y0nhnm9pnd3LVfn340bMs+9nftl75r71nGbvr2MPxk29vn6V8D82vzw07Z6zdXgvPr8Y/5Zafdi9ib43H/ZGQLteGyVNmVyDe14lUmzafgRXYBaFWMQK4rByA3XJQ5RcKc5Hk5AlWuiKpGqwwg1aWErsvabRXyIyABOWKsCgTRoQpy6EprZ6xsP3IlSyeHBbgkLHNDqtY3+A8c2A8rupaEy0G/RFSsYEiiOewbhH4Id1bFBwQmKGCAWRgOeSA94xOawBH2OzayAQZHscBexKuyABFZwMIMZFWAGnxNfYVdddAG6kLML2QxFZa81v5mEpagecErLXxdKdiuFjYFVEV4AUMoKlVNQFWoSUII392h89Tqv8gOreUMTNetyqWtjq7ARe0EkCaCse7+QqeAmvB116K60FRr4W/qQMDEVy68MwK59I9SUCJUyFeA3weH0yiVCU5Ao+xmi9IDtmehVb14Xf4ChSs/6Bw+clrzJNgUL7HKKPM5GquU9ABWJV98fa6zSNH5vl8kztkfxyC01OHzy2BcnLd6dvD8spQC15ChkfpfM8mKkN8DkEcuYpAVGIiNKAI8dRplKpYIcqzCBwo1Md6E/gRrAKTwNlmQS2DicJyG2rFnCMCqQIeNshQPWQig1R341lJmKWgTlghyrIoeaJfEKhmeBbCxiMI/CzjKQFz1gW2d2HoIQ0t4kEq7p7R7SruntHuihTztntLuKe2e0u4pMNun3ZN3KEu7p7R78nmRdk9p9+QA0u4p7Z7S7intntxl4L/YPe0y9q7df2+G5si2fMMz9qk5PAyP88PnftgPbX+YH7+192foQ9M+PA7zw/uu+b08+LbveqPw8KvrTrs/5EBlnbklAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "780",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528207",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.02497597",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzEkMW2xnooKgh6KCB5KDy2GNhCzUqNQSt/d0Na/m7ed/YaZyTpIS31srwpi2GGpUzRthRYIpKitu0GcdePpDSHlkQiWMy7oIooE9OTDAkkZZ/IPyOQv/E4dWP4qT5qmaP0C/1jr4qKcaiBmlBHYK1u5ehIHdIXTfvQoT/r8Rlulq9oNIhQBgY1Rj8k793WSCwIrNOhz7d2YPn8Cv28FeBEBAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVt1PgzAQ/1/6zMgVCgz2ZNTERB8WNfFh2QPLmq0JUoPVZFn43+2QaXUcXEP46H387tfe9crqyJYb9Xx4k6xg93qjnnSltixgS61q886K1fH706phYS/WBr+SGQdYdA97s3Z9drtqmvJgfdOQZ1ESzHgU5nyeBrF9JxAHrjyN5qPyXCQk+4znnTyLBAkH4yMg6+SCR6S4Z5z/+JCLQT5YXAwH49/xjEOAOCPhT63DSZ6IEDiIS4dBxSnCH4UbmgblJo0WA1W4eaOxQhVu6gY9LubhJoM2cxTKPx9YxicXd6zUSA5oBFJodAWxMidxwoAo9iRG2Eb1Lw7/GsCaCqlifbrTmD2J0VSb89909P2LtXBSi6CcBRR7EqOpw4/e5fwbJnZgknqyz8lr7e2fwY0qX6WRDSsghIA9yHpn9v3gUZvSKF33wxe1/VHdSbXbm35wW8lP1/BaV9oC1h9V1a6/AJV+GazLCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "2.4 /",
    "Flow State": "Turbulent",
    Friction: "73687.97 /",
    "Friction Factor": "0.017669",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "14581",
    Mark: "342",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1074442.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "144316.3305",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "89",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "11.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528208",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.3587269",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zk0LgkAQBuD/Mudt2S817RQVBHUQCTqIB61BF7bdsC0Q8b+3KN7mHZ6XmXKEvNG34Y2QwcU1usCHr21rEAjkTlv/gawclzGQSFEmY7XbcEFTxRKYqtXt+74eAg6Lo65f6LGHjFFG4Iq29d0cREygcL722lnIJOWKR6mIIxlt0ySVnMBdPxfLuQr4jLrt/JyZEgROBn9rO7wgmCJwcMaFW/ZrzFT9AQ3EeCDSAAAA",
    Pbi3DGeometry:
      "KREAAB+LCAAAAAAABADtVk1PwkAQ/S97Xpptt18LJ6MmJnogauKBcIDQwCa1NVhNCOG/W2qrsOxju8WDh4ZAWR4zb3Zmd+ZNtmQ8l8+bt4QMyX0+l095KheEknEus+KdDCfb768lzEbli+zo7y8Dl7FR9VG+yW7amF2t17NNaRv4DnOZTweu54jQiykvn8IP6BHgs4hy7jDGo2MgckVlEXm+xmL/dD2q5QgYb+nqPIcuKjcO9fuAABO+nqOxOAkXbhCGC11BwOiq2QcPG4soqAAehMdAE67HfI3FPomCtwREXcEmqu7kcVzvQ+9KR864sAsXczTHx9Mm0YbcwKFLe+XqIFftT6Jac0h+ApiPD8yuCsA7CLNrtoAc8NbCO6jeKHM9VMDsSq2gfWnNhUIWmMO+l6gN2XzPVcDsCnYGFYClNRcKWkAOOIrgYFEHpLmXwGsAXbVuyLC05kJBC8gBpQE8cPaD3n7W2nPYSxx7lQFbeEeV0SkqY0ou0AznFYCVZmjdkLsrANip8diGHH+nGQwccOdtBkuvGXrN0GuGXjP8H80wpeRGzl6TIlmTIXMYJQ9JtixW9eIxL2aFzLN6+SIXP9BdIperol7cpsnn4R+v8zQvHWYfabqbfgFDuqsuKREAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "781",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2125.4",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528209",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.97906811",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jUELgkAQhf/LnDdZ183ITlFBUAeRoIN42GrQgW03bApE/O8tard57/t4U/aQ3+jSvRAyOPkbFXhn42qLICD35PgNWdlPZ1CWOlI6STeLWEVrLVcwVH9v27amC3Io9mSeyNhCJiMp4Iyu5mYMKhVQeDZM3s30So8JxrEO9IhUNzxmqZWAg8XvrCfhp5JawM5bH8bdx9qh+gHcwwBswwAAAA==",
    Pbi3DGeometry:
      "KREAAB+LCAAAAAAABADtVk1PAjEQ/S89l013u59wMmpiogeiJh4IBwgbaLJuDa4mhPDfXWCrUvroFjx42BBYymPmzXTamTdak+FUPK/ectIn93IqnmQhZoSSoRRl9U76o/X+aw2zQf0iG/rzS89nbLD7qN9kM1ZmV8vlZFXbRqEXxFlMe37gZX4aU14/szCiB0DIEsq5xxhPDgGWhTuLJAgNFtunH1AjR8R4S1enOUxRxUFqzgMCiZ+ZOZTFUbgwQRgudAUBqyuVR8iVBd/nwaP4EFDhBiw0WGw3MePtgDRtKqiiuoA8a/IwuzJFlSSRW7iYQx2fwLiJTuSnOUyZ71z92qv2J/Go5pBcB+yuYII6AO8g3F27BeSAtxbeQf1G2euhA3ZXegXdS2svFLSAHO69RG/I1nt+BFhd4c6gA7C09kJBC8gBRxEcLPqAtPcSeA2gq9YNGZbWXihkgTmgNIAHzn3Qu89adw53ieOuMmALP1NlnBWVdUvOH9sWBeCkGVo35AsUAOzUcHJCjj/UDKc5YOZtBkunGTrN0GmGTjP8H80wpuRGTF7zKl+SPvMYJQ95Oa8WzeJRVpNKyLJZvojZN3SXi/miaha3Rf75+4/XspC1w/KjKDbjL473CxcpEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "782",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "33487.4",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528211",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.88501612",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jc0KgkAUhd/lrie5jpZpq6ggqIVI0EJcTHXRC9NM2BSI+O5Nabvz83FO2UN+4VP3IMjgYC9c0NUpU2sCAbll456Qlf0oPbIIMJbpahbKII0xgaH6Y+u2VZ1nfbBldSdHLWQYoIAjmdo1XyMxkQIK65Rja6b6zLexDRNcCtgT1437eRmlAnaa3hMe+dMQ5wI2Vlu/bl5aD9UHNxmNm8MAAAA=",
    Pbi3DGeometry:
      "iSQAAB+LCAAAAAAABADtWMFq3DAQ/RedHSPbsi1vTqUtFNpDaAs9hD1siEkM7rps3UII++/Vrr1dWdaTRpTeREg2fvv8/DQaz4i5f2V3D93Xlx8t27CPw0P3Zei7R5awu6Hbjz/Z5v51+ld9zW/VDzsmV+Qm4/z2/Ef9suP2ctubw2H3ou4t06ZoiuQmy9NG8Dop1GfGy0THpSjPeC7rNV6kPKtyP1/xeF6d8ToXJJ2zH4UXYsGXTdVY/QD/bj7Sp/txx22tg/RlLaUtPgv/VZqJqlzrr3ALX/fp1TH26x/0oX89niu+ZV1OfkB8UBwC9Rf7hf1zkTdOfVIcUB4ifZRvhDi78zA0bz36hPWGxtOtv64D0H+ozjJPDJ+eukTQJ+rYn4tx4ntqqW8G3sj5tSunspErwNEWfHSKe8WXmaO5+JrO1Y1ThmYelxhe19WE16WY+Fnm2irAJ5byayo0WT7j086KSrO5rvBcSBsOZPwurY2CKm+XcWytum8hc9pTRzu20ZUZLnNtUYqeF/jUg/iEqmziTvfrxdryleIeuTF6JcgE1Fu5qpXaC3HCS0sqUPUdz6X0PoqfUL6ZPM0cfyEKjJs1WcMvNRPoSEPmkuIh8qdlVTWBr4VhwTdbro+vlUfbshw+g/T19NHj4/WP0sfyXHs6QDw0ngCHBRilJ+T79I24gQpMC7O33aCXHcm7uyXKHnRkWPORPloWwpEOaJdBNvEByX70IFYY9Ip6D0LADGJ7xM2yZu99pCLobujYok3c287Xb3hoZUENmtZQPMcOwiEozng0Pt1PnPHEGU+c8Xj4ccYTZzxxxhNnPHHGE2c8ccYTZzxxxhNnPHHGE2c8ccbz32c824S963bf27E9sA1PecI+tfun8Xm++DyMu7Eb9vPlt+7x71cf2u7peZwv3vftb534dugHJbj/1ffH7R+WbucFiSQAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "784",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528212",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.45185433",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI0j9ST6KCoIcigofSQ4shDcREahRK6bsb2qr05G1nv2Fmih7yWp27u4AMDrZWudWdtAYQ5FYZ94Cs6KfTG4IEc07oKqAM8zRlMKAfjDGnYfifkWjJFqEjLD/l67atOr/AP7aqugknWsgIJgiOwkjXzOJkXeWUHz3Ji7p+0V4o2bhRJCxGsNPiNXtDXxdRhmBjtfW55qn1UL4BZxGLPxEBAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVktPwzAM/i85Z1XS9LF0JwRISHCYAInDtEOnRVuk0qASkKap/52sdBBY3Tqq+oidz/4SO3ZXR7Lc6OfDmyIFuTcb/WQqvSWULI2u7TspVsfvT6dmC3eRlv5KZpyxRfdwN2nXZ9hV05QHh51lkZSM0xmPI8nnGRXunTJB/yiyeD6ukEmKRORcdoo8TpCmQFYJyztFwmOk87OpCx9MJsOsQOegKXAdHV0RMSZypI/JLTkpUjcU4hIwJD958OW+Z4wdP3gY+5DcjxyGDyT3wzY0/z9/PwSY9UJ2QvcfjPDUho5mFwoAecB4hrYOTGsUI9ASCoHiBB7O0MQITQCwjmAyNawijSJQnCZrW+hxwx5bsHBj6gKuBaAQKE6TvQ9b3EKLJNgpMVU4rOc6hPszuNHlq7KqIQWLGCUPqt7ZfT94NLa02tT98EVvf1R3Su/2th/cVurTn3htKuMM1h9V1a6/AHnFqqLLCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.2 /",
    "Flow State": "Turbulent",
    Friction: "125328.96 /",
    "Friction Factor": "0.016904",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "3933",
    Mark: "343",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "492911.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "192421.774",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "92",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "15.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528213",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.2041894",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zl0LgjAUBuD/cq6X7Ett6yoqCOpCJOhCvJg1dLC2sBWI+N8binfnPTwv51QjFI25DW8NEi6+MaV+BOVaqwFB4Y0LH5DVuIyRpIlggu02hCaC4xymemX7vldDtHFxNOqlg+5B4gQjuGrXhm4ONENQ+qCC8Q4kSwgnqaBZytKtyAUjCO7muVhCeMRnbdouzBlziuBk9W9txxco5ggO3vp4y32tneo/lhim9dEAAAA=",
    Pbi3DGeometry:
      "gRAAAB+LCAAAAAAABADtV9FugjAU/Zc+V1IoCNWnZVuyZHsw25I9GB80Em3CYHFsiTH++5DB1NpDKe6REMEeLqeXe3vvKdMdmSzk6/YjJiPymC3kS5bIJaFkksk0/ySj6e73b3GbjYuD7OkRGbiMjctT8SP7Wf3YzWYz3xbPBo5wOacD13PE0IsoL67CD+gp7rOQcu4wxsMzPHRFaR96/qX94ep6VMcfMN6Kp5Ff448bDbX+I5wJX8tf26t+ovdCfiIehJt4Kv+5qO3DoMR5MDzDaz895l/aH+ImeCtcVPmq/Ok6bxRV/mt5NPMyLmz8hPz1OvF0cWs/bzO/Js4lzzE+rdebkl80r4ob1wmKp4Kj+kLxNNojflSPqL6UejHGX8GNPEq+bPNozAuwh/y2/UHpq8b6VXAjD6p3BUd5NOYF2SN+pCNIFxRdM/YHtM4RT8u+ivJozAuyR/xIx9G6stVlW3205bfdh9juB1Af7rQf6OCPIQ6d9b1Rry30vWVf7arXqN9CnUX8/6Tvzfzofc260Ot7r++9vjfY9/p+tb4X3/N3cv4e5/GGjJjDKHmK01W+rgbPWT7PZZZWwze5/Lv1EMvVOq8G90n8fWp4myVZQZh+Jcl+9gOVpE8SgRAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "785",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3778.5",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528214",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.84007742",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jc0KgkAUhd/lricZp8nIVlFBUAuRoIW4GOuiF6aZsFsg4rs3qO3Oz8c5RQ9ZRdfuhZDC2VeU452Nqy2CgMyT4zekRT/JgCRRrJPVdhGraKPlGobyj+3a1nSBDcGBzBMZW0hlJAVc0NXcjEYlAnLPhsm7ub3RYyrjsCzghFQ3PHqplYCjxe+ML8OnklrA3lsfxt3H2qH8AUUug8rCAAAA",
    Pbi3DGeometry:
      "gRAAAB+LCAAAAAAABADtV11rwjAU/S95jiVN+qlPYxsMtgfZBnsQHxSLBrp2uG4g4n9f1XZqzGmabo9FtOb29uTk3tx70smWjOfydfORkCF5zOfyJU/lglAyzmVWfJLhZHv8W95mo/JDdvRkGbiMjQ4/5ZfspvVjN+v1bFM+GzhuyH06cLkTu1FARXmNPZ+e2z0WUiEcxkR4YWexd/APuXftv7+6nOrwfSZa4TTia/gEPNLyR/bQjbX4tb/KE60L8UQ4yG7Cqfh7Qe0vjvyFH1zYa56cedf++7jFoo09iqp8VXw6zxtX/LU4Gj5h6NvwhPj1PuG6uFnM24ivWe8B5xSf1vtNzS+aV7EbcdC6FDuqLxRPoz/CR/WI6kupF2P8FbsRR8mXbR6NeUH+CN+2Pyh91VS/qt2EA+tdsaM8GvOC/BE+0hGkC4quGfsD2ucIp2VfRXk05gX4Q3yk42hf2eqyrT7a4tueQ2zPA6gPdzoPdOBjiENXnW3Wawt9b9lXO+s16rdI7xD+f+l7Iz5ar1kXen3v9b3X9wb/Xt//rO/l+/ydnL0nRbImQ+YwSp6SbFmsqsFzXswKmWfV8E0ufm89JHK5KqrBfZp8nzve5mleAmZfabqb/gAfYlR+gRAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "786",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "75346.5",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528216",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.59956901",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELwiAcxb/L/2zi3KbTTlFBUIcxgg5jByvZBNNYFoyx7561ur3f4/d49Qjl2RyHuwYJe382lb4E5VqrAUHpjQsPkPU4x6gsEoqzIqPLDOeEwtT8rVXfqyGqsdgYddNB9yAJJggO2rWh+wAlnCKofFDBeAcywTknXLCUMi6yQjCG4GSus5xwUiDYadN24cs0FQi2Vr9+65RikZAcwdpbH8/c09qpeQMx0mv70QAAAA==",
    Pbi3DGeometry:
      "PSQAAB+LCAAAAAAABADtWFFr2zAQ/i96doMkS7bcPo1tMNgeyjbYQ8lDSk1ryOKReYNS8t/nRF7q5PSd5TwWERLiL5dP351Od+LuXsTtffP9+VctrsXn9r751q6bB5GJ27bZdL/F9d2L/9r/LG/6l9hlr8iVkvLm8NG/xW75/2/vttvVc//fK6UXxhmdmUUhbZHlelEpabM9brUbw9qVBM4XUhWatTaFGuOlNhzLiZYez403N0aaED3SHmWP+GP0RMRsTIPotc5D0UHyPX1eORuIvYeps0f8VCRl8Vt1ND/dqmj2QTtvT0NP5ETZT8cGypxJP2wVic6EfCt1KHHmRgElIKFHiYboea8uS9h4fqqHP4fE3Rh6uolUPu8W5eHLy0FmTDXij8rcqkaWZdXEH2hY66p9vbCm9DSV49tG0Bq6GtY+1ChbmNMSFdFlaFMiLJcop9VVuarHTVF6dq0U6xFvzhbvschc2z2Nzb1KUzi+qHu8zwV1iiMeIBPJQcsiepaG7qunsVZ6NZVTZAfHnQ2Ze6dsXpQHe53zVxxgzpd6UrqhGuQsyFZeDV0WOIUSAV01DofB2FJ53NI8iGEH+QHbYzjESA2imavele5w8q3D+DhdB/z8iE/QnG/sRey9dQ7NxyEYmwfEcOYBduQTCME8dpo2QDxKD7AqzAKAXxRJisOTBpZF9hPrRpf0mCDHtxjIQ3DUSsKpg/omSDSeHGYawREPCMJMlejqFIYjygo6mjG3nvCiwHpi0XNz1OsiSl9MA+dFRnZMcL5nFpUJcraHRFwyUAjS9CZNb9gbd5revG5Vmt6k6U2a3vBXkDS9Cd370vSGo0/TmzS94dpjmt6k6U2a3kStm6Y3aXoTxNP05m1Nb5aZ+NCsftZdvRXXciEz8aXePHZPw8PXtlt1TbsZHn80D8efPtXN41M3PHxc13/Hhu/bddsTbv6s17vlPxLhP449JAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "788",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528217",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.35219997",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9jkELgkAQhf/LnLfFXVclO0UFQR0kgg7iwWjRgW0nbAtE/O8taV6KbvPme7z38g6yMx7bm4YUdnTGjExbkQUGGaF1d0jzbji9YSYkj2SQLCLB50rF0LMfUPE4FMkXUyr5z6bQ4lO+bJqy9Qv8Y43lVTvdQBrwgMFe28rVoziQKx360YM84WVCW41V7d4ilhGDjdHP0RtKXyckgxUZ8rn2YUxfvABl4AnuEQEAAA==",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVt9rgzAQ/l/ynEoSo077VLbBYHso22APpQ+WShtwZrhsUIr/+1KnVjcvPxDF3OW+fLnLd7o5o/VOvJ4+CpShR7kTL7IUe4TRWopKfaJsc/591W6y1Bdq8NWyoIQs24e+UbPtw1Z1nZ907IKyICJxiCMapJzHOGRBGpEQzzpSHrUOHjM664Ajbji7OsKAkDDxhBpY0YhPHAnjnnR7qCkr7eCUmReHoaB98IilbnTtUMbFeRCHNPmfQwe7DafNU28fFc8Vf7BfSjeyT1IxwwfkOeYzKttf/sP8Sw1m1gX3C+E42m15Nh9hCAhUCZTp2RUcS2ArPShoIxAY4NczIE7OwrHuzvFgTEQ+d8Ag8RuBwACv/mI89H69zVE+VplAsoXasBEIDPDq9BAn94+ibXe+zQ1UqGvT8P9Q6gj9Z3An8vdCFTXKSEAweiqqgzp2g2epciVk1Q3fxH5wPRTicFTd4L4svscTb2UpNWD1VZbN9gfx0+8+ywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.2 /",
    "Flow State": "Turbulent",
    Friction: "309902.31 /",
    "Friction Factor": "0.01583",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "14421",
    Mark: "344",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4469093.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "312685.3827",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "97",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "25.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528218",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.31216752",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm3M6e4oKgnoQCXoQH1YNHawtbAUi/veG1tv9zvkOtx6hvJrz8NRQwNFfTaVvQbnWakBQeuPCC4p6XM6orCjDPOdszbEgqYCp+WubvldDdGOwM+qhg+6hIJggOGnXhm4GJhBUPqhgvIOC4jQjmRQJE5nkuRSxvZj74lLKIx60abswM+EMwd7qz2+dMCwZ4Qi23vr4y72tnZovtf7OftEAAAA=",
    Pbi3DGeometry:
      "ahAAAB+LCAAAAAAABADtV01PwkAQ/S97Ls12P1oLJ6MmJnogauKBcIDQwCa1NbWaEMJ/d/loXWwf3ZWLh4YUuq/Tt7MzO/OWyYaM5+pl/Z6QIXnI5+o5T9WCeGScq6z8IMPJ5nCrH9OR/pCt94MMAkpH+y99ke20eu26KGZr/e4gYL6kIfeEH/Ig8jjz41hIb4eLK8FqnPuU8miPy0AK0z5iommvcREwr41fUn6Wx4rf8EeELGj1H+GSxa38v+wrP+G6kJ+IB+C2PJX/8gBTGe5hrn9NNyucUdEw30Ut5mdhfkhWxVInxW1SwU/t22iMWYWIhIOTiP3EG23PWiJmMasVvblYk8cMjuVGqzcmmhfhiAetC+GosEA4oT3iR36CwuoqxEb8EY54UL5c84jyguwRv2NjgA0V1S7CEU97rXe0gEYWO7LVaKdgVuAkVKcONUObudEzAI9jO0UpRClB9oAeLRbtKEcpdpZEV6l3PHo4HwFQJV5yBPiDP51xcJR0C5G20HTnfuqo0qjdobbZIU+XqroNfa/qvar3qt6r+n9Tdf3H/VbN3pIyKciQ+tQjj0m2LFfHwVNezkqVZ8fhq1rUj+4TtVyVx8FdmnyZhjd5mmvC7DNNt9Nv/yNqSWoQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "789",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "9977.5",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528219",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.71883755",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm3M6e4oKgnoQCXoQH1YNHawtbAUi/veG1tv9zvkOtx6hvJrz8NRQwNFfTaVvQbnWakBQeuPCC4p6XM6orCjDPOdszXEi8xSm5q9t+l4N0Y3BzqiHDrqHgmCC4KRdG7oZmEBQ+aCC8Q4KitOMZFIkTGSS51LE9mLui0spj3jQpu3CzIQzBHurP791wrBkhCPYeuvjL/e2dmq+HISZf9EAAAA=",
    Pbi3DGeometry:
      "bBAAAB+LCAAAAAAABADtV8tOwkAU/ZdZl2Y6D6CwMmpioguiJi6ICwgNTFI7BqsJIfy7Q0trsT3tjGxcNITH3N6eOb2vM8z3ZLZUz7v3iEzIvV6qJx2rFfHITKsk/SCT+T7/aS7TqXmRg/djGQSUTrMP8yaH1+K2q+12sTP3DgLmiyELPOHzERMeZ34YCull9rFgpZ37lPJRbpcsrPofv2v+xi4C5jXhS8rbcWzwK3wkHfIm/tAeSNGE/9u/5ImeC/BEOBDfEqfMixhl/MOxzOxcDs94FnZGRd3/GLeQt9t5nq8Cp4y/476S5/xbcSr7ysq2FjQhfJWO8WdNYeve1gq++rTnQSuCY1tsZXGCbaEd4YCnAjFGrY5iiVoR7IoqGXRWVyfWKhzlBHUiyJVjClFKkD+AdxwLcJyitkV2hIPavKP9a+OxI1k1f4SPeKKa7ZAzVMs1O8JxHacojygvyB/hA56wrhzl2FkWXeXe9fjhegxA7XjJMeAPfDrj4CrrNjJtI+uuQ9VRpsHUQ8OzXaAuFXUL9F7Te03vNb3X9H+m6eav+41avEVptCUT6lOPPETJOt2cFo86XaRKJ6fli1qVl+4itd6kp8VtHH1VHa91rA1g8hnHh9dvWiA3GmwQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "790",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "253248.1",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528221",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.73448247",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jcEKwjAQRP9lz7E0ibG2nkQFQQ+lCB5KD6ku7UJMpEahlP67UettZ95jthwgr+nU3xEyOLiaCrx4bRuDwCB3ZP0DsnL4nUGZJZESUq1mXETpPE5grP7euut0H+RQbEnf0GMHWRzFDI5oG99+Al8oxaBwXntydsJnuk5UpJzBHqlp/ZcthWCwM/iadBmeSi4ZbJxxYd0+jRmrN4+SrxTEAAAA",
    Pbi3DGeometry:
      "6SMAAB+LCAAAAAAABADtWE1v2zAM/S86O4FsSf5IT0M3YMB2KLYBOxQ5pKjRGnDjIfMGFEX+++zESRVFT6LanjohaFKXeXwkTZHuu35iVzfNj8dfNVuwL91N871rm1uWsKuuWfe/2eL6af/rYOYXw4ttk+e/zFLOL3Zvww/bLg+wD5vN6nHAzop5zvMsmaXZvJK8SISY81So5MSQpvnOwFObYUQKSUOUVbVHFJkNYXO1i2r4FKk4NeRVYY8K5uFGQI6gqNxFtLmCHGVa2mtl5CFHThuHYbAhjHD9rsw7+BoOmIdRXYIBujKqS6gVDNdNbnMFozJurcpGrldkTmhRyAE7kZCgu0XDm5rAQcjcMBCq6+awjQyYR7grw2CESxhkBA6qK0gODdTjbCM3OZQQ0+Hk1d7V6MKxWAgIah4ql7l7R3mWlxaV1xU5D1hExbmcEMVU9tyTIEJQtwHcOBbD2ZooMxm4PxACZ04su2VkkBGQQ8lcaVGNQ6b0GPwD2RzhyBXhucRcd8T7oSEqUWgtOhpk5kZ4OTA5dXkRogpHmPdcZXvyUhWVw2CZokfDccIhV8e+OhgOfRXMIYeEKAi9JCcIy+b0IPRBhhKEJQnmeO4ro1b+PGBfnZOjLkGG8OpiAzw4MCqM8HKYRSRWlzCpqVFp7QNnu3fdwb6CTwBnCLggvSeKzoEWPTYQZwk8g4TnEkyOEV4Oc5ARJxxl1xKj0ly9fDubxzl8lmAOFO7/psnYOMLFmjfUZKjSC+Hf13evycDMw8Wat9ZkCNILzCNqMlGTiZpM1GTO84iaTNRkoiYTNZmoyURNJmoyrnUXNZmoybwHTWaZsI/N6qHu6w1b8DlP2Nd6fdffTxffun7VN916uvzZ3B5Nn+vm7r6fLj619V/9i5dd2w0O13/adrv8B0pDFd7pIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "792",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528222",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.64007434",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjkELgkAQhf/LnDdZN3PJTlJBUAeJoIN4UFp0YNsJ2wIR/3ubWlSnbu/N93jz0haSAg/NRUEEWyowId2UZIBBQmjsFaK0HaQLTHzhBcKXi6eYSymgYx9UeiEPxR+QBz/wq7en2WtAXNd541a4wwrzs7Kqhoh7nMFOmdJWo9mTzS264YM94umNNgrLyvYmFDMGa63uY3bq3gW+YLAkTa7X3LTusgfHU7bkFQEAAA==",
    Pbi3DGeometry:
      "HwkAAB+LCAAAAAAABACVVt9LwzAQ/l/y3JUkzZp1exoqCPowVPBh7KFjYQvURmoUxuj/boydLqxHLpT+SL9+d19yl7uuT2S11S/Hd0Xm5MFs9bNp9I5kZGV0az/IfH36fXQwXbiD9Nn/mwmjdOEv7iT95kxbdl19dNwJ47ngTGY/DxWblVnh7lNaZCFS8lkEqcQUzZGs8ojkAm0N1iao9IhgHK3gbO3aD60EoA1WAFuD5+NVFzmlhUT7ia+OR2Re0pKPUMYA7+USCNyjTAXhRPkAgSCWKFUgEARyjHE1jyAkqJmDptLjAUc9uryRtMNRQC849+A6wkmP0wUbQ3JwyuAtnJ4u6VkBFx1cFidWsAgHpyxeDtO3JH53w0UfV0KQHQTJwSmLN1F8PUwvrXDTxdXvxA7uOO5v41bXb8qqjsxpTjPyqNq9PQyDJ2Nrq007DF/17g+6V3p/sMPgrlFflx/emMY4g+1n0/Sbb9vvzSMfCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "226658.02 /",
    "Friction Factor": "0.01617",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "1468",
    Mark: "345",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "332676.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "264579.9392",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "94",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528224",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.11626097",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv15j/urm7CoqCOpCJOhCvLAaOlhb2ApEfPdW1t35Dt/hVCMUZ30c7gpy2LuzLtXFN7Y1CggUTlv/gLwa5xiURYQ0yRJcpkiZSBCm+u+t+r4ZghyKjW5uyqseckYZgYOyre8+gEwggdL5xmtnIY9oKpiQPEYuZJJJzgmc9HWWI8EyAjul285/GWNJYGvU67eOkcqIpQTWzrhwZp/GTPUbJO4hmtMAAAA=",
    Pbi3DGeometry:
      "/yUAAB+LCAAAAAAABADtWE1r3DAQ/S86O0ZftuXNKaSFQnsIbaGHsIcNMYnBXZetWwhh/3sVy0ltpCfJzlWExLHGM2/eaDQj5vaZ3Ny1359+NWRHPvd37be+a+9JRm769jj8JrvbZ/OvFtNL/UPO2f+VC0bp5fhH/5Lz/lXt6nQ6PGndC8ZzqSTPCp6zqlKZ4HnNaJG9CAquFutcVfa6yCkruf97WbKFoOLSa2jpkRYIaRSkpNIJATlEakCMKK+iAji3BCE4F85IQRojBNMf0tLei9d1i/ZMsPDVZWjcvJnCYvPWIBgOQQ1rKxxORWpExAl7uxrCbJ4jUgEaPKeVftoZtT4inuS0MWASQgw/we35HI/h8ip0Xm3mcRjW1rp4+Am6TIUKknE3qoT5D9SWamiD+71adf5xmaxNf2D6OZqqVaABAQVMHNF4602i5MvyFtW0XF3OsrSNhatGM1WPLERdGA3GAvT8GqE+MPdW8GK0xIt6FMhSBRrEFBDK9BlZCKAp5C10CmJDCK8l13ZPlhjnxqdaMXtb5w0TKkzsGNXPFw0uAvcppBDoG44ugJ2CvGE6h7yywRE/mCDwUmNODOW1MILCkR9RCChxcOdFMYdOQVPraajKRJApvD5P5mndLgchQ9Zmb0WgQrcHrDGPxkLD4VRAw4GB6GFvV0PYGYVo4MSB4Dg/kGB7cC0BPpQIHGoEweM7Q1zY4/uVz5QlgG0J5RXuxzATgxgwEy0BNIVCssFdfGVDgqiahA5z3D0LQUONELSlANtoVAGNuiUEnY1uyLAqbChJIQxva4q508CApPFUGk+l8VQaT6XxVBpPpfFUGk+l8VQaT6XxVBpPvQshjafSeCqNp9J4Ko2n0nhq83hqn5EP7eFnMzQnsqM5zciX5vgwPE4vX/vhMLT9cXr90d6/iT417cPjML187Jq/8w+v+67XBo9/uu68/wcINS9G/yUAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "794",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528225",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.5750855",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaWJpPYkKgh6KCB5KDxVDuxATqVEopf9usLUXBW87+4aZyTvIznhsbxpS2LkzZs60lbNAIHNo/R3SvBvOYJhxQZVg8SKRlMeKQ09+QCWoYFHyBaWM/8AptvjUL5umbMOG8FhjedVeN5Ayygjsta18PYqD86XHMHuQJ7xMaKuxqv1bzIUisDH6OXojQRPJBYGVMy7k2ocxffECBkWD1RMBAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVt9rgzAQ/l/ynEoSkzrtU9kGg+2hbIM9lD5YKm3AmeGyQSn+70udtUq9/KBYjJ/33Xd3uYvrE1pt5fvxq0AZelZb+aZKuUMYrZSs9DfK1qf/WwOThfmhBl+fzCghi/bPXKjZXMyWdZ0fje2MskiQeYxTHtFEUByzKBUkxpNAykUL8DmjkwBsccfZFYgjQuIkkKpXRQUfAQnjgXIvVGNVBuCU2Z3DVFAcXLDUT66byupcsIiROL1NohfgpGpz1QODCvr76IFzBYfAKCVTqmC5I1WDCt7E0Vuc6zHlHI4cpPIGnGm3b2qQCmwcMO2TPrzr4dwMYJ/bqUCLsFkCqvLuKHeA3rtkNAAmNxw0GexUoEXQ9LG3Qdjo8+4od+OA7QxNajsVaBF0GoCq/E9OZ4Dhow/uWu9ZEn6kGgvzDfEg889CFzXKSEQweimqvT50i1elcy1V1S0/5K6Hngq5P+hu8VgWv8MX71WpDGH1U5bN5g9YdIyX9QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.0 /",
    "Flow State": "Turbulent",
    Friction: "405587.48 /",
    "Friction Factor": "0.015561",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "12793",
    Mark: "346",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5188617.5",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "360790.8262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "100",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "29.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528226",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.53946702",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm3Nz9hQVBPUgEvQgPlgNHawtbAUi/veG1tv9zvkOtxqhuJrz8NSQw9FfTalvoXGt1YCg8MaFF+TVuJxRWVGGecbZOmWYSpnBVP+9Td83Q5RjsDPNQwfdQ04wQXDSrg3dDEwgKH1ogvEOcopTSaQSCRNS8UyJ2F7MfXEp5REP2rRdmJlwhmBv9ee3ThhWjHAEW299/OXe1k71F6jYRFHSAAAA",
    Pbi3DGeometry:
      "EhEAAB+LCAAAAAAABADtVk1rwkAQ/S97XsNmP4zRU2kLhfYgbaEH8aAYdCFNSpoWRPzvjV8xMXlmN+2lEEQx+zLzZnZ2Z95kQ8Zz/br+CMiQPMZz/RKHekEoGcc6Sj/JcLI5/M1gNso+ZEvPKz2XsdH+J/uS7fRkdpMks3Vm23O5o1hfUMUdzoRPBXd8Xyq6A+RA8jMgHMaEtweUq2TJwuOyxiIDpMtpLYdi4rorQ45CVLLP3fo8IKC4X89xaXEKFycIw4WuEGDu6pSHOqy7njfYrwvVL0WbA5zJqsFuC31xfV0cypc7yqtkyyzFhUWtpwK1lJ60ihUylGPKLHjd9plQG1IU0y65Km6U8RHMDy0khwB0BROEALx8aHOxBeSA4aLL13hdq/WAAHQFK2hfWlgoaAE5rJsI7sTwjkMAugJdoalbVAvbVL9qH0bUKFY85JrGIjzq1QaDXFn3YVhVWCNogShg2vCoWc/2FuPVXj9Yq5oWwgLe118Ki1ZRNW+JtUwwGvsmOqFFI7ae+7BHwnbbNOX+QCmYUXRKoVMKnVLolMK/VwpTSu707D1Ig4QMmcMoeQqiZbo6PjzH6SzVcXR8fNOLHHoI9HKVHh/uw+C7+OJtHMaZw+grDLfTH8HNAWISEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "795",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "13283.7",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528227",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.3784528",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm3Nz9hQVBPUgEvQgPlgNHawtbAUi/veG1tv9zvkOtxqhuJrz8NSQw9FfTalvoXGt1YCg8MaFF+TVuJxRWVGGecbZOqVYSSJgqv/epu+bIcox2JnmoYPuISeYIDhp14ZuBiYQlD40wXgHOcWpJFKJhAmpeKZEbC/mvriU8ogHbdouzEw4Q7C3+vNbJwwrRjiCrbc+/nJva6f6C8KFHI3SAAAA",
    Pbi3DGeometry:
      "FBEAAB+LCAAAAAAABADtVk1rwkAQ/S97XsNmP5JGT6UtFNqDtIUexINi0IU0KTYtiPjfm5oYY5PX3dVTIYhifM68+Z6ZbMl4rl827zEZkodsrp+zRC8IJeNMp/kHGU625dcCZqPiRXb0+MvAZ2y0/yjeZDc9iF2v17NNITvwuScD7lPle5GUARXciyKp6B64kvwICI8xEZaA4tGJRMhlh0QBSJ/TTg7FhEGVHUfDKsUC0ekHBnwlOzlaErW50EFkLlSFOaxV1YmSYelHyEpAqODU3APAmeyQ+AliJAyAqDJ4UFXnw5lcicqPv1U1yFWT28ZaTHFiVCHBO2NowW1J0fT7VwQPgbIvw7pwETcGoCrkHgo5HAowsrBhETWsc9R95n5tNQBMEuxXlD3nrMIcQQlE4TxC8ByG7Q0BqAoOBOOkaE1VY/paEpADmgsL2rgXYaW3AKjKfQ7D1MJEQQnIgczFBee8389Yse43hPtl435cwKa98Lg4yypzSNxPBbvFb3UquE9j58WPRiUcuqY9d/mhYMXQ3wn9ndDfCf2d8N/vhCklt3r2FufxmgyZxyh5jNNlvqoenrJ8lussrR5f9aKG7mO9XOXVw10SfzX/eJMlWaEw/UyS3fQbKw4+RBQRAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "796",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "353710.2",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528229",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.08973582",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNt3c7BQVBHUQCTqIB6uhg7WFrUDE795KvL3f4/d41QjF1ZyHp4Ycjv5qSn0LjWutBgSFNy68IK/GOUZlJbDMRLqmJMVCUgFTvXibvm+GKMdiZ5qHDrqHnGCC4KRdG7ofMJIxBKUPTTDeQZ5gmlKumOAJlypTCUVwMfdZphmRCA7atF34M0sUgr3Vn2XNsKKEI9h66+OZe1s71V/K6XDG0wAAAA==",
    Pbi3DGeometry:
      "lSUAAB+LCAAAAAAABADtWF1r2zAU/S96do31YVlKn0o3GGwPZRvsoeQhpaY1ePHIvEEp+e/z4iR1ZB3rqs8iJMQ+uud+6Opece9f2d1D8/3lV81W7HP30Hzr2uaRZeyua7b9b7a6fx3/DnBxPXzYPnt7c8WL4vrwM3zZfn0Su9ntNi+D7JXOq0qYjBcq14brTIrc8qLMpkAlSnUAhKk8gMwLrgVRQsnyAFRC0ahGqwZAqksJLSvj1QH9CEhAHVFWLQfRRwV1cKu9sXL9sH4N1r8X1m9ogMTZt3dxA7vdWFp/XCirqTFBBkZxu/sD7DaVVovsNPdh6kF+mGGBAC+nXXyiBjUEPY6N6BK/7/hD+2OJHMAxlFCSghqoRFA1BCiH1KfY5Ze8PB49PZYMMVAsNYewBNkHw1UZ6DPLDWhiVZiK6gcqOpzzcT3Xclw/vFjcIiRBqemTLRWqOgLWHgClp4bOir000g9AooChoG/Q+SOvGUYYfklkDV9sz1DCKF5NXBskhFy+FUEJQuV2a33YD9dzlMZhP6BVs6YK8wOsF1xODsp/oJxnRwS//zW5UYbsiV0/SwAp9AiYUiwAnup9Bs7VFVGd9/kkcdrnaB1WFIIiMQ3IhYSnUwckpkUUOQhDEq3jLZ+cWIX9gDk1V45yBAHx0cUALtjIKiwR1DELIiraxLBTGhU0F+oINluYV/D2MTs4sOthBxGAqUBI4s2F9xUMEMsSPM6E6xVWjiWCOtyaCJs7sYpS7gnQXKgjeE9wK0N8WcI6iD2Kcq0JXlLSpClNmtKkKU2a0qQpTZrSpClNmtKkyXuDTJOmNGlKk6Y0aUqTpjRpSpOmNGlKkybKpGmdsQ/N5mfd1zu2KvIiY1/q7VP/fHz42vWbvum2x8cfzeMZ+lQ3T8/98eFjW/+dLrzt2m4g3P5p2/36H/xLlEaVJQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "798",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528230",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.22801067",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNo2jR9eBIVBD0UETyUHloMbSBmpUahlP53g62vk7ed/YaZyXvIKnXoLhJS2GKlMtRdjQYIZKiMvUKa9+PpDJwGiUjmzOM0YjGDgXzYTNCIi/g/FDz8hV+pIyte5Yu2LTu3wD1WqjxLK1tIPeoR2ElT22YSe7SlVW70KI/q9EYbqerGPoXwQwJrLe+TN/BpwplPYIkaXa65aT0UDwnrQlURAQAA",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACdVktrwzAM/i8+u8Z5P3oa22CwHco22KH0kNLQGrJ4ZN6glPz3OVnaOYvVyiU0xJ+kT5JlyV0eyGItXvcfJcnJo1yLF1mJDaFkIUWtPkm+PPx+ajGf64e09A+ZeZzP+5f+kXZ1NLtpmmKvbUMWZHFGPR6yxPNTGvgsS/yQGnicenGPh55v4gkPkh6PeEARPCf9LIym/AHjndzEO16XeCC/Z/Ny8Hs2HhtPFlnzPeL/9g3Ka+R3FrMkjNNpAUzBiGlkYW7F1GLIweqjSwJFdcGHJSowQVgAhgs6N4uBoro2KmuC9orDewi0ClwNyMC5SqAL8Jijjg6iX1D6qIguNZ7DGYAsYAFieIBMqCmE0MdFBIwhE0c2BGgBCaBR59pB8MxE6GMiAi8599kLWcACzIUGMrncyFpf/zO4E8V7qcqG5JxxSp7Keqt2w+JZqkIJWQ/LN7E5iR5Ksd2pYXFfld+m4q2spCasv6qqXf0AKSCU68sIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.1 /",
    "Flow State": "Turbulent",
    Friction: "557351.50 /",
    "Friction Factor": "0.015271",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "3397",
    Mark: "347",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1893100.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "426935.811",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "104",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "34.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528231",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.88634632",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv15jW2OaXUUFQV2IBF2IF7N+dLC2sBWI+O4NtbtzzvdxygHy2lz7F0IGZ1+bAu9Bu8YiEMi9ceENWTnMMSorRZNEpFvOJFUpVzBWf2/XdbqPchwORj8xYAcZo4zABV0T2qkIRaDwQQfj3UJv5jFDzmWkJzRNG6bOpCBwtPhd9LWgG8Ekgb23Pp67j7Vj9QNmUiVUwwAAAA==",
    Pbi3DGeometry:
      "KREAAB+LCAAAAAAABADtVlFrwjAQ/i95jiVN0rTVp7ENBtuDbIM9iA+KRQtdO1w3EPG/r3atczGfaeueRhGl8evdd8nl7r7Jlozn8fPmLSJDcp/N46csiReEknEWp/k7GU62348FzEbFh+zozz8Dl7FR+VN8yW5am12t17NNYTtQji9VQF0mHZ8JnwruhKH06DGgAldRIRy2f+GXhcuD0sLn0mBRANLl1MjhMdHMlYXDEJXyQs+8DwwU0Rg5ags9XLxBGC50hQC7q3ofPq8tAlkCwlO/gEO4nEmDxf4QQ9EQEFUG66i6kyte7cPsykCupPTbhQs5DteHGw+xDbmFw7Tz0tXRWTW/iXrOMbkO2F3BDeoArEF4unYLyAGrFtXgSUXZ86EDdld6BtuntkGikAXmaNtLThqyvc51wO4KdYYTAKbWnihkATngKMLjTh+Q1l4CywC6at6QYWrtiYIWkANKA3jhWg/6DrO2vZhoLXG6qAzYwrupjE5RWY/kAs1wXgG00QzNG/IFCgB2ajg54Rz8Q81wnqPXDL1m6DVDrxn+iWaYUnITz16jPFqTIXMYJQ9RusxX1eIxy2d5nKXV8iVeHKC7KF6u8mpxm0Sfxy9eZ0lWOEw/kmQ3/QLlZnZZKREAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "799",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "18600.9",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528232",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.63067196",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/X2OZczp6igqAeRIIexIdZQwdrC1uBiP+9ofh2z+E73GqEojG34a0hh4tvTKkfQbnWakBQeOPCB/JqXM5INgLLbEcJxyKjAqZ6Vfu+V0OksTga9dJB95ATTBBctWtDNwcmEJQ+qGC8gzzBlNNUMpEmaSa3MqEI7ua5WEp5xGdt2i7MmXCG4GT1b10zLBnhCA7e+vjLfa2d6j/h03wj0AAAAA==",
    Pbi3DGeometry:
      "LRAAAB+LCAAAAAAABADtV11rwjAU/S95jiVN0i99GttgsD3INtiD7EGxaKBrh+sGIv73xdq6Zs1tkjLYSxHFe3pzcpP7cXRxQPOVeN6/p2iK7ouVeCoysUYYzQuRlx9oujicv8rHZCZf6Ih/kIlPyKz6kG90fG2WXe12y71cO4k8QkLsE+6FQRJgRr0k4QFu47EfYsakzSIFDwir/CPKu/4S5z7FOv7TOhueXv5uPNHJ1sQP4j6NdfwX/99xgufSxwnxgPwmnir+0EviszvnZ5gFYRtuoqSEd7xPl5YwC5jWqapCGbhlxOq4dSSdLSM/5vYBQtxNaVDNVdlu2cvdPWVF0tyJQ3Wp2QQ2VWEzC3AiBYY6CbhFozvEDvUd1EdqXxgLWoGNLGqaHLNnTgfgDrE7TgB1chq7VIHNLEBTKzCUPWM6IHeIHdIIUIPammWcA1BhAyw2MxPKnkU69O4gu16d4VpyU1t31XNVc8dfF64qD83bQSo/IJ7eexiq2n06bK3aNgN0qA4DYxVQM4D7T1S7j3tU7VG1R9UeVftfVVv+974Ry7e0THdoSjyC0UOab8ptbTwW5bIURV6bL2J9eXSXis22rI3bLP1qO14XWSEJ888sO75+AxEeGiotEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "800",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "552672.2",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528234",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.0313939",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2No0iZp6iQqCDqUIjiUDlFDG4iJ1CiU0nc3at3uju/u6hHKszkOdw0F7P3ZVPoSlGutBgSlNy48oKjHn4zIglCc5RldygxTJiRMzZ9b9b0aIhyDjVE3HXQPRYITBAft2tB9DOGMIah8UMF4BwXBTCRC8pRyIbNcco7gZK4zTCVBsNOm7cJ3KacUwdbq19xOKZYpSRGsvfXxzD2tnZo38agdudMAAAA=",
    Pbi3DGeometry:
      "0yMAAB+LCAAAAAAABADtWE1v00AQ/S97dqNdr53Y6QkBEhIcKkDiUOWQqlZrKcQoGKSqyn/HStbBzuzzzAY4AKuqH+lk5s2bnZ1x3u2zurmrPz59qdRSvW3u6g/Npr5Xibpp6m37VS1vn49/dmZ93X2pffLzP1dG6+vDj+5b7Ve924vdbv3U+V6ZdJYVWZqU2cxmepFYO9PG5snBkOdmZNDGZ0hnZWYzxiOzY49F6vMYhhpl1RmssQdDbmzqx0A8hB4QQ5KVsIiDUBAjT3PrrRXm4TDMovvtO4+jwcP8ZDhPl4ZyJ3gynJ+gHKPnwXh4qksMMNTYAEviOVpaEhm452hpVu5oaREdRpovykuYh7QowcCdCAkiHr/a1CEYsOzw1lLmMgzPCVIeHEHYonAsHdOVDDL2RoXPRALOZhUwZPCwzLIDRrFwWXVvYFYR8oAYkKCbcGlZju+mbHd5th2JdDELWsK5ObKw2ZGFnnP0OA9mF8B94yFO51tfETMvhNsDekAeoqp7VlrAQwmC6HMqtBswBWfgBj4d31wo6sHSmD6N0dZ0DZoWztBhip4XKAbsEW7701rBrGCocB7auKs5LycMw87tDeQGsqHO2+pyiLQoJjyGFRl5+JKa9vBhQH4w3XAM0laQB+weCI6bBBkury4x4LuJwKEHCw49pkOJxrQsq2EoONihAfYVXILQg8Ug6YZj4KcbZJCNEngHRc8kCBs5sNDIYTKQZMuKMhoGCl/L8CKHTxEWg6T7fwkx8JObRKH5nUJMsN6CP2j+60IMqzrIFZo/JsRI9BaWRxRiohAThZgoxEQhJgoxUYiJQkwUYqIQE4WYKMREIUac0V8pxKwS9apef67aaqeWeqYT9a7aPrSP7sX7pl23dbN1Lz/V9yfTm6p+eGzdi9eb6vvwjS+bTdMF3H7bbParHzRcutTTIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "802",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528235",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.76627238",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjlELgjAUhf/LfV5jm1PRnqKCoB4kgh7EB6WhF9YWtgIR/3sjrR4KervnfofDl/eQVXjoLgpS2NoKM6u72hogkFk07gpp3o+nL8y4oKFg8ZwzSSOecBjID5pIGkgWf0Ep4z/ws1u8BBZtW3bewj9WWJ6VUy2kjDICO2Vq10xhb13p0IuP8YinN9oorBv3DJEICay1uk/dQNBEckFgabX1u+am9VA8AJ7+r+IVAQAA",
    Pbi3DGeometry:
      "HwkAAB+LCAAAAAAABACdVl1LwzAU/S957kKSpq3dnkQFQR+GCj6MPXSsbIHaSI3CGP3vZrWrrcvNh4yOpqf35NzPdHVEy414ObyXaI4e5EY8y0psUYSWUtTqA81Xx59bDZOF/qE2+n0yo4Qsuj99oXZ9NrtumuKgbWeU4YSkcUQJxynNaRQznCckjsxIzpMO4SmjZsRic8XZCIkxIXEWzDZoowmfIhnjwarPbH+0aYRT5lBgYQP94QnLfVV7sNkV5BzHnGSXAfUCnFRdzAZglE7/PQbglMwxMImKSRUsd6JqlMgLPwaLU05Mm8Oeg1TegDPsjvoGueA2AgNv3sU7Jc56gBvfzgWbhM4XUFlAa7nd9C6XyTQwVh44JuxcsEngNLL3ROg49G4wdx+B3Q0OcDsXbBJ4ToDKQo5Xp5vh8xDuY/8B858zV9vor41bUbyVqmzQnGASocey3ql9v3iSqlBC1v3yVWwH6L4Uu73qF3dV+TV+8UZWUhPWn1XVrr8Bd7R+zR8JAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.5 /",
    "Flow State": "Turbulent",
    Friction: "471678.58 /",
    "Friction Factor": "0.015419",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "3133",
    Mark: "348",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1477704.3",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "390856.7284",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "101",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "31.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528237",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.39323057",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jUELgkAQhf/LnFfZXTPTTlFBUAeRoIN4WG3QhW03bApE/O9tZbd57/t4U46Q1/o83BEyOLpaF9iQsq1BYJA7bekBWTn+Tq8EScgTma4DIcN0wROYqr+36Xs1eNkXO61uSNhDxkPO4IS2pe4TxDKOGRSOFGlnZ3zR15nKVDA4oG47+rKVlAz2Bl+zHvmnkYgYbJ1xft0+jZmqNzjA/3DEAAAA",
    Pbi3DGeometry:
      "xyMAAB+LCAAAAAAABADtWE1r20AQ/S97lsWu9bnOqbSBQnsIbaGH4INDRCJQreCqhRD83yvbsiOt5+3OJrm0XUI+pPGbNzOanVHe9ZO4uqm/PT5UYiE+tTf117apb0Ukrtp63f0Ui+unw5+9WV70X2IbPd+ZKSkv9j/6b7FdHmHvNpvVY4+dFbHKsjyaqXmsU1lESRJLlWTRxKBUvjdIRRl2yCTlIUqtD4hiTiEoV/uo+t+JSqaGXBd0VDAPOwJyeEVlLyLlCnKUqqRrNckjj7WWiuA4M1CISbgcV9Mn+DoOmMekuiwDdDWpLqtWMFw7OeUKRmU8WlnM9asyZ7Qo4ICdyErQ3qL+Te3kYGVuGBjVtXNQIwPm4e/KMBjhOgcZi4M7EyE5MPCPM0VuGuS8GA6n1AdX/Qesi8WN4OXRI1RqX1GO3TUKyuWJmYWlhDLV5YAohqLnjudHI/i7AO4bwmBmLhNV+mwPiLBkzqw6MS/4CEAhdaZHMe0GTOkwuIexOb6RK8Y7iZEG92mMEGky6s/d/XRuBzgpMDd3b7mD8gaYz1uqA3WZFdpiIMbnyXAabcjVsaeO949N6E3Rp1dyEJOClGRQXMR4hIH8cLjeHM9NZdTKnQdsKoKc6BHLff/aQgMeeYDbAnBRmBVklpYzoJlRjVzBZebccrCp4No/PzWQ3HWc2Bz4LQUZuHMEHkDG2wgMCgJcDOYI4402935lRjTq85cv5LNz7D9C4KaGef9nEgzF4a/NvKEEw1NaWP+t/vMSDMzcX5t5awnGqbRY1IMgwQQJJkgwQYIJEkyQYIIEEySYF1EECSZIMEGCCRJMkGD+JglmGYkP9epH1VUbsZCxjMTnan3X3Q8XX9pu1dXterj8Xt+eTB+r+u6+Gy4um+r3+IPv26btHa5/Nc12+QfUEEruxyMAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "804",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528238",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.92819859",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKwjAQRP9lz2lJY9pgPYkKgh6KCB5KDy2GNBCzUqNQSv/d0FZFvHjb2TfMTN5BVulje5WQwg4rnaFpFVogkKG27gZp3o2nNwQi5JyKRRCxcC4Eg558wSiOkz8g5T/wEzvA4lW/bJqy9Rv8Y63Li3SygZSGlMBeWuXqSRzQlU772aM86fMbbaVWtRtEwmICGyMfk3fm63jECKzQoM+1d2P64gn9+rr2EwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVtFOgzAU/Zc+F9JCgcGejJqY6MOiJj4se2BZszVBarCaLAv/bofMKezKvSFAy+Gc2/beHlge2GJtnvdvmhXs3q7Nk63MhnG2sKZ276xYHr6bHhZzf7CWn58EUoh5d/Ena1cn2lXTlHvPDbJQKZHxQEZhLmcpj/09ETH/A6TR7H8gVwmSkcm8A7JIIaXAUR0bR0DJCBn8JDWKIXJ1eVRgcFAKnEc33DgUIs6QMSaXpAdkkqQXGWOgj3EGBsERUoMMImKAwCCDiFGBwCCDY8ZoHoN8IGYOStHzAc6Dvj+wDEIGp9YKUdR0qcnaxUuBmxPLQFQJyAC9ZNJk8FL0SqQ7HJZB2INTBoDwdroU3UvoHxYsA2F9dBcFDQDr1AQv8Qz/D3FjylftdMMKEQrOHnS9dbu+82hd6Yyt++6L2fxAd9psd67v3Fb68/eL17ayXrD+qKp29QV3FupQ9QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.8 /",
    "Flow State": "Turbulent",
    Friction: "172442.69 /",
    "Friction Factor": "0.016494",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "87",
    Mark: "349",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "14985",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "228500.8566",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "93",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "18.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528249",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.63994295",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LOy/L6rrq2ikqCOogEXQQD0aLLmz7wrZAxP/ehuYhgm5v3jfMTNFDftbH7qYggx2edY6mq9ECgRy1dXfIin48vSFiVHIuFgETNGEyhoH8gGFKZRol3zCN2T84x5af+mXbVp3f4B9rXV2VUy1kjDICe2Vr10zigK5y2s8e5UlfZrRVum7cW4RShAQ2Rj0nLw+oEJITWKFBn2sfxgzlC4OZj9YTAQAA",
    Pbi3DGeometry:
      "4QgAAB+LCAAAAAAABACVVl1rwjAU/S957kqSJmlSn8Y2GGwPsg32ID4oFg10zei6gYj/fTH2Q7feNEUUk+M9596b3FMXBzRf67f9Z44y9GTW+tUUeoMiNDe6rL9Qtjicv1oYz+wLHaN+54ZgPHMf9o2OyzbstqpWexvLcKyIIhHBPE6xklFCYsk4iywgU6ZGAeYATKg/QnDZAsIBNEm8VHBWKm33ldvnTHi1L5muJahMBpMCtUEquCN9tslpP1WU+MsLaciANpWxshwngAvJ/wKuVYLQtKcaAGAqd35nIHWAwsKrAQOnjrh9pyAokd6cYMAd30BOlxHXVXTSzHWQc5V4ywaZYIkQqoEywFsIdgS8npM0QnoYcnzQVPp5wIApcw8kFGJe/wUgokk3HBwWvwuCVCO+Gei0/hGeZGohbhA2FuBIAr7pJwIDJjgzlBH8GAGN2cs0yW7AMQ0xjwGqkYdeV4b9v3CvVx95nVcowzGO0HNebutds3gx9arWpmyW73rTQY+53u7qZvFQ5D+XP7wzhbGE5XdRHJe/n5Sh7uEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2319",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2329",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.5 /",
    "Flow State": "Turbulent",
    Friction: "986461.08 /",
    "Friction Factor": "0.015094",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9621",
    Length: "7095",
    Mark: "350",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6998550.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "477101.4182",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "122",
    Size: "20 mmø",
    Slope: "1.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2409",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528257",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.92036508",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jMsKwjAURP/lrkNI0nddiQqCLkoRXJQuUr2kgZhIjUIp/Xej1t3MnMM0E1SdPo13hBIOrtM1Xry0yiAQqJy2/gFlM/1iUGJG8yJbcZbQVKQFzO1fWw+DHIMbhq2WN/Q4QMkoI3BEq3z/KTxNEgK189JrZxd81teFioIT2KNWvf+yPIoJ7Ay+Fj3iNMuFILBxxoV3+zRmbt9Uevf1wwAAAA==",
    Pbi3DGeometry:
      "OyMAAB+LCAAAAAAABADtWE1r20AQ/S97Vs1qtZ/OqaSFQnsIbaGH4INDRCJQreKqhRD836taGyda62lHTnppFmNj7WjmzczOzkjv8p5dXFVf736UbMk+NlfVl6aurlnGLppq0/5ky8v7/m8n5mfdh+2yx5U3Oedn+5/uy3arB7W32+36rtOVfGFzWWQ5VwstTJEV+cJqJbKBQGmxFyjhAoHSfwXGSUvU0Ha/LgpDtCS03AtskQ8Eytm8hyhURgpjQgNiGNV7pSRNYyKHIECIoazyuZJ6Mg5nnB3FeCIYbsejIHCXYGq4gc+AwGEEyY0LoKkwuYT4YEYwOMDAXoU768zJgVMLFEDAMiSEh+tzfkUTMeKBHwliuZ2AAO0ChzHfVCg4eEvsYXEIejtE2GCdcpBRMwwF2gh/LI1vIkFbDedJVIEYhFXKTQ8mOLACj6KGiCHgTiR47hW4t2Tc5AYhBUr7R90cCoK5UNh83rxACjDqeMLRIwVVASEY2S9L199vnZtcj/XeIwEyFH/8CMdafBsCBaEP+yN9H9XTGlEItE4cUQSX5muEW+0VDHeFXy+CdeerdTBVTN/4tJSTVh4KqRNon4sTzHdh5dO3cyf6PAgRKgwdIigMEVBk43mYa/5QQ2GCohGgIhqBBiWBBLOTigWwtSGfsEIE4Sh/lMSObwW1oUNDcPrE5th4MaGJHp4RiBo5PDT78MEDrccaBTpmw3U0iRAqvD9i/6hBETrXeKsLkeMeDe2cOGPD0zq3T0D7yM/XQ57AF665rMpLkidUjiT+qvm/kyc48NmsyouSJ0SOBL/5J/IkkSeJPBl5CEjkSSJPEnmSyJOIS4k8GX0TSORJIk8SeZLIk0Se/BPyZJWxd9X6e9mWW7bkC56xT+Xmpr31F5+bdt1WzcZffquuD6IPZXVz2/qL93X5++mN503ddAY3v+p6t/oDqJStCTsjAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "808",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528258",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.07833217",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGkTdOaehIVBD0UETyUHloM7UJMpEahlL67wda/k7ed/YaZyXvIKjx0FwUpbG2FmdVdbQ0QyCwad4U078fTGwSjPJLzgAkax5zDQD4sYlQmcvYfCsmiH/iVOrLiVb5o27LzC/xjheVZOdVCyigjsFOmds0k9taVDv3oUR7x9EYbhXXjniIOBYG1VvfJywOayFASWFptfa65aT0UD9vAZYgRAQAA",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACdVVFLwzAQ/i95jiXtkq7pnkQFQR+GCj6MPXQsbIHaSI3CGP3vZrXTtMvRq5SW5svdd9/lcsnqSJYb/XJ4VyQnD2ajn02pt4SSpdGV/SD56vjz66bZwj2koX/IVczYov24lzTrs9t1XRcH5ytYNOOSxkxEqchiOoujLOEx9fEklSd8LhPZw3kLZyyhGJbOmqdJiDwTgvu4kCKdJAYKO5IUNu6YniFPyngWzPeMs+AyDNPqheUsknOZDRe/B/s8vQl/HUIebQKhCKcEcExjIS5EgdnBaYNqweB+IVBU/1d1uepAtUGxQJNApQDMp1cICgDtbsymwXQJwhylZ6zb0MWHPaAJ1IkBMmGOGIw9RhG0Gz0Yt90BBxCHzuypbQPxIMxResIX2tSTFrAHYMy9BfBMuHVZ4m7+W128KatqkrOIUfKoqp3dd4MnYwurTdUNX/X2d+pe6d3edoO7Un35hjemNI6w+izLZv0NhuZMN6sIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10399.60 /",
    "Friction Factor": "0.02244",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9692",
    Length: "2856",
    Mark: "351",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "29698.4",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "40176.96154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "139",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528286",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.29291261",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKwjAQRP9lzyEkTdPaehIVBD0UETyUHiqGdiEmUqNQSv/daKvSm7edfcPM5B1kJzy0VwUpbO0JM6vbyhogkFk07gZp3g2nN0SSChnFcx4klM1EDD35wZDRRCbyD8jZFE5i37D41C+apmz9Bv9YYXlRTjWQMsoI7JSpXD2KvXWlQz97kEc8f9FGYVW7lxBMBgTWWj1Gr+BUcBkSWFptfa65a90XT2a5JXkTAQAA",
    Pbi3DGeometry:
      "2wgAAB+LCAAAAAAABACdVt9LwzAQ/l/yXEuS5ke7PYkKgj4MFXwYPmysbIHayKzCGPvfDW02G5vrFRkdzX2977tr7i5dHslibV4OHyWZkQe7Ns+2MhuSkIU1dfNJZstjd+tgOnc/ckp+LVeM0nn75y5yeju7Xe/3q4PzVTLNpBIJ40VKheZJxtKMSZF0gO4Aplq7UMrbZWfnkrUAFzJBmLyHKrI/Hl5C5zLU0CGT1gUSEyiNZTdZGgsJIjonrXId2M+v72KHcosIC5oW0vH2iZw/94DsE8ncPdjZecAkZc5CB59CzyMLcuhJgFSYxiCoPHBQnCoMAKMFtcOtUIwJjOrfUQ3yC7e71QbrBowWKqhxB1gCzBt8U5G8x6sTyQLqL6hdhgJIRIP+itiRLY1sHQIMiwBq7WnFAcyCKbNjPCBwhkeA8foGpxAIRNoUnNUg1bQTZ9IZhUQFHl4RAJlD4DgFgUijIq0doRo/pyJ5uC+FW7N6L5tyT2Y0pQl5LOtts/OLJ9usGmNrv3w1mwt0X5rtrvGLu6r87j94YyvrCOuvqjq9/QD5xxUK2wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2245",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2328",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.5 /",
    "Flow State": "Turbulent",
    Friction: "986461.08 /",
    "Friction Factor": "0.015094",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "9546",
    Length: "7437",
    Mark: "352",
    Material: "Copper",
    "Middle Elevation": "2254",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7335956.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "477101.4182",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "122",
    Size: "20 mmø",
    Slope: "0.99%",
    "Start Middle Elevation": "2254",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2338",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528301",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.30812628",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA9jkELgjAcxb/L/zzGdLq5dYoKgjqIBB3Ew6yhg7WFrUDE797C6vbe4/d4r56gbM1pvGuQcPCtqfQlKNdZDQhKb1x4gKynRUaE5ZgXNF0lqcAk4ynMzY9bD4MaIxyDrVE3HfQAkmCC4KhdF/qPYYQiqHxQwXgHMsE5J1wwmjIuskIwhuBsrgub8yxDsNem68O/u7P69S3TJD4gAsHGWx+n3NPauXkDjfbEeNEAAAA=",
    Pbi3DGeometry:
      "ZSkAAB+LCAAAAAAABADtWEtr3DAQ/i8+u4tkSba0OZW2UGgPoS30EPawISYxbNdluy2EsP+9ih/rtaVPj9BCDiIk7PrzzDcz0jwyN0/Z9W3z7fFnna2zT+1t87XdNXdZnl23zf74K1vfPPUfNUyu9E92yqcnbyghV90f/ZudNqPY28Nh+6hlS7GqJCtyWqgVIxXNGV2VnKlcA0Ip0QEFI8oCyJUsmQiTKBjvAMKrIkjVYJXUHyp+CaiyslJAN3oBk8GjyGT2ATCCS+5Sh4FRazyQUcgJI+KEE7tNC2DyYgQMY8/A8vAWEpDc5IBWLf2ePzdtggxIEfYu2gk7heVQo52AN43xgvvvcgDDqMjj3FITdA5eZe8dD3ci9Lknet4DWmZddJpGMPie+9J3AhYniupfQMGEmua3DxUnmHMRtVpLsFFCPgOikNQJQFXQC7MXES5DmlRIWxtVOVpnoB9jEEtWDBJCVs8A1Rpc/gULeCugWfil6E+jpD1AmaJuiRGoKtVLCNbZ5GlfEQyjTYABKoLUdkUorKKStKs2itPufcFVecGsAdErOt8BQfrCpRTvXNCMhXuuQhzaKNlLMNGVOq44d1sFOZC5kCO8ufg9h6mHMizcKv/UCsmhufBo4e3E44dUA9BZS/WbkdPYSIFyzzeNmQeIjHLMjpFecMnKWfaJQtEeoNWirAl+AVwaOwKdqoljUsXZ4u6IIoTcxoGsqpSaqaKlfnMCJqvOAOSAqrCD0X44zKXLWyWcfsDLA8nxJbE/93lhiS0CHHkJbEICLm5nBM2Yg0aj3xezjkULVvpsAhL/kMHuHOqKMGHg2AIlIIUn9UwAt3BrmOJNjR9fHeUO5jYAXMMosApJOMjdJdWsUXAQ0RJq1kNFOTRX1HVd5HZVUCJiEPHNG7BKxRdIB4e7A5hA/GCIzwOOkiiI8RtF39D2GjeKEV4Ebypevnq1U7xg0/g6N4qeBdd/XCj6/m1OG8W0UUwbxbRRTBvFtFFMG8UZR9oopo1i2iimjWLaKLoE0kYxbRTTRjFtFNNG0R7ETZ69b7Y/6mN9yNZkRfLsc72/Pz4MX760x+2xaffD1+/N3Rn6WDf3D8fhy4dd/efyxXftrtUK9793u9PmL83TNmVlKQAA",
    Angle: "90.57°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-1347",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "79",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "92",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "816",
    "Maximum Size": "150",
    "Minimum Size": "150",
    "Nominal Diameter": "150",
    "Nominal Radius": "75",
    "Overall Size": "150 mmø-150 mmø-150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "79",
    Size: "150 mmø-150 mmø-150 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
  },
  {
    ID: "528302",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.95151494",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TssKgkAU/Ze7HgbH8ZG2igqCWkgELcSF0qAXprlhUyDiv3dB6w/anRfnnHKEosHL8DCQw5EaLMgOLTkQUBA6/4S8HGfIgSSW6UqHaxVmMojSECbxH7P6zm/6vh74Aws7rO/Gmx7yQAYCTsa1vlvImXztkW/P9Iq3n3Uw2Ha8omKpVSZgb817yWolk0iztiVL3Ote1k7VBzkcp4QTAQAA",
    Pbi3DGeometry:
      "xQgAAB+LCAAAAAAABAClVk1rwzAM/S8+e8b5qBOnp7ENBtuhbIMdSg8tNa0hi0eWDUrJf5/JsjZfipWWkBA/yU9Plq1keSSLjX47fCqSkCez0a8m1VtCycLorPgiyfL492rNfG4vUtIzcuNxPq8e9ibl6n/abZ6vD3auEIwHgU89XzIeRj4NBZPCj6mYsSiuDDGLZNsgRQXHEQ/P8AhR5S+Z74cD9Bbv0M8mCgIju3ObENylqk8luAiHEq/x7gKOLDgYu1mJwGMiDGSf6GTorkd/Rp1Ew9ConZvHHaArqZsbxgBoHQneqgQm64tF9fNrVxtUO3xchgvh8EWfB0eZR9YH3PMYnss7A6jHcdQcERA7BcKRGwWSNHnC9E4FbkVMR0JSYQzgAQG7HpLqqs4Kqhr8xoEwisYFo9uq6wOA9K9h+09wr9cfqlA5STjjlDyrbFfs68GLKdaFNlk9fNfbk+lR6d2+qAcPqfppOt6Z1FjC7DtNy9Uv75OyssUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "2",
    "Bottom Elevation": "-1255",
    "Calculated Heating Load": "200",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "-1255",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "9645",
    Length: "4669",
    Mark: "353",
    Material: "Copper",
    "Middle Elevation": "3414",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "124",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3414",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3414",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528306",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.28109823",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfR5jVzen9hQVBPUgEvQgPmgNHawtbAUi/vdW4tv9zvkOt5qgaPVlfCrI4eRaXaqbb2xnFBAonLb+BXk1LWdQEkF5inKDUUYZlxHM9epth6EZgxyCvW4eyqsBckYZgbOyne9/gJEgUDrfeO0s5DHFGBMuMM5SJkUqQ3vV98UVyAIele56/2eGEYGDUZ91jZRlghPYOePCL/s2Zq6/zsO5ndIAAAA=",
    Pbi3DGeometry:
      "vhAAAB+LCAAAAAAABADtVl1rwjAU/S957kqS5qPVp7ENBtuDbIM9iA+KRQNdO1w3EPG/r2vrR2tPa6TsSUQx5+aee5Pc5Nzxhoxm5m39GZIBeUpm5jWJzJw4ZJSYOP0ig/Gm+JuZ6TD7kK1zQG4YpcP8J/uS7WTndrtaTdeZr5KuJ5V0GA9cyiVzPOZ6XEinMOjCwFSOC6VKXBS40Dw3MCmqDtqXNY8yhAq8WghI1RWjnpSuLkL5uoLveLQOKvguo/38CxaHPKxD2K1B6IBXDDQoiISfw5yLP5QpX+1R3/U1rcGerBgk56wwMJ0bdFDGFUf0TUQYbkiGFYviJ+TQ4MljpkOaoroLMqg4NC0MJAqJoAEQwSUAos4qrVVEN9GJA9wLYEAXDVYFdoARUK5g+1quYPNNa2FCDqjGmnF4M20PujNAPVF09dver+Y3uI0KeODn5QSFZ2Z/yjAAytKyUKEQtjEhD5sXEp6Z/SnjCEjjoUZZKzZk6rEpsO5U+m0Wzm8iLsvn3E7BVlNbG4WGOsXzL1RtCxHuT+Vt2xdbieyvVbnq/1X/r/p/1f9/1f+JQ+7N9CNMwxUZUJc65DmMF+myHLwk6TQ1SVwO3818b3oMzWKZloOHKPw5nniXRElGGH9H0XbyC9safKW+EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-1346",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "38",
    Length1: "19",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "819",
    "Maximum Size": "150",
    "Minimum Size": "20",
    "Nominal Diameter 0": "150",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "75",
    "Nominal Radius 1": "10",
    OffsetHeight: "75",
    OffsetHeightTemp: "0.020505",
    OffsetWidth: "75",
    OffsetWidthTemp: "0.020505",
    "Overall Size": "150 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    R0: "76",
    R1: "10",
    Size: "150 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528309",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.61154256",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjs0KwjAQhN9lzyEkbdo08SQqCHooRfBQekg1tIGYSI1CKX134x94m935ZnfqCcrWHMarBgk735pKn4JyndWAoPTGhRvIevrIiDCCC8EXNBGYMJ7A3Pyw5TCoMbJxsTbqooMeQBJMEOy160L/GihlOYLKBxWMdyApzjjhIk+TnAtWiDy6R3P+h7fadH14XyoyhmBj9eObTmM8dkCw8tbHZ+5u7dw8AbNq7abSAAAA",
    Pbi3DGeometry:
      "tx0AAB+LCAAAAAAABADtV99r20AM/l/u2Qu+8/1S+jS2wWB7KNtgDyUPKTWtwYtH5g1Kyf8+Jyd3i/End3kbHKGhlnKSPuk7ybp5Ute3zZfH77Vaqw/dbfO5a5s7Vajrrtn1P9T65in9O6jLq+GjDsUfyStdllenr+FPHTbjsdf7/fZxOGvLVaRgC23iiqLTRaVXvjKmOCp8oFFxkpuyYnnFcmuPCue1FQ84N3qw4XSAtGyIvB8V1UlhIx0VZHw886ApFBKG4YCZuCijbAm4FhQ4f/PwqIphko/SSEFhFI6OGadVaYNPvjXLY5LryIZGuebf+5hAhMAKkxTBJw+O/LmlEJKlITTZMxvSwXGoZiEkl+SlSwciLYaEXENw7CIOJTu5YDphcNA1dIHQzacDU1xbRmcSCQZFJZPAWmYNkeUM0hLP4K0AChiVUG+ggOEKLAcUgab+PSoBICi5doFPUMU09OItRhxBhqSuhvrEvBwSASZQyCy8rugGzN9WmD5saF6OQCMIMQaOyPkU0VBacX6RY9JY4j7xnAy25E3CYOwCNy7IxrwLGFT0VCVFxYSlxTGM5vy8PBo6p6Xx9sI8gQZ8AThU1OFi29F3ZBr4cyZPp4JwYn5coAM4KIQbphxSFuUD9g7YbVBZYbAwKMgD3OlQvSHXIJlRQuDLZgx+hJEmcXCT0TZ5C4hk/Rgty0eao1GxOD299slUNRZjMgudE11DD0iB32eRa5QnYR+A5IQJhO9dIE94hZh3gdBJ74ggJtgmcMqXYL8YHawFhA2LB2okdUFwLeBFgv0xr55nlvLqObn0efXMq2dePfPqmVfPvHrK60BePfPqKfIgr5559ZQTmFfPF6H7/1fPTaHeNttvdV/v1bpclYX6WO/u+wd++NT1277pdvz4tbl7Vr2vm/uHnh/etfWvv3/4pmu7weDuZ9seNr8B8fAdpbcdAAA=",
    Angle: "89.99°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2329",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "821",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "784976.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528315",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.22717717",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9jkELgkAUhP/LOy+L66652UkqCOogEXQQD0qLLmz7wrZAxP/ehuahoNub+YaZl/eQVfrU3RQksMdKZ2i6Gi0QyFBbd4ck78fTB7ikUShXLBA0FiKGgfyycEklW3wjEUV/0dxYfIbTti07v+6NjS6vyqkWkoAGBA7K1q6ZxBFd6bR/eJRnfZnRTum6cW/BGQ8JbI16TlnOKZPeWqNBX2sfxgzFC4lkXqgMAQAA",
    Pbi3DGeometry:
      "2ggAAB+LCAAAAAAABACVVl1rwjAU/S957ko+20afxjYYbA+yDfYgPigWDXTNcN1ApP99Ma1Wa2+SIpXmnt5zP5J72vkBzVbqY/+dowl60Sv1rgu1RhGaaVVWP2gyPzS3BsZT80N11FnuCMZT+2cuVC9Obve73XJvfFkWC8KSiGAep5zLiLGYZ0lk7DyR3GcX1s5J5nbA9GRPrT1h0skEpiSJaO3N81JQV+RLnusAlKaDKUGRQSa4G12unFuAmZiB/Qa7MRCbyjgjIjsCRBLSAxJ6BCgTrKMaABxUx81rPKwDYdQZAgZsQxqAWcCW40gKBuz23SZ14dCroost7H6TrF/FtQPIBIcIoBqqAjyEYEOg0zkqhL+DgbsHzaSHCXIYMfRgRgHCdRsAJBp1xsFpcUogyOQRzUCVdU3wKEnza0HgTIDzCImmhwn0GCPMUFLwWwQUZifTKLmB5jRAO4aYPK+8cxXmQ+FRLb/yKt+hCY5xhF7zclNt28WbrpaV0mW7/FTrM/Scq822ahdPRf53+eCDLrQhLH+Lol78A31erEvaCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2814",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2823",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.5 /",
    "Flow State": "Turbulent",
    Friction: "969167.74 /",
    "Friction Factor": "0.014832",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10115",
    Length: "7642",
    Mark: "354",
    Material: "Copper",
    "Middle Elevation": "2900",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7406482.1",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "571252.1415",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "107",
    Size: "20 mmø",
    Slope: "1.00%",
    "Start Middle Elevation": "2900",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2909",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528325",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.90656331",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCowt9EwsDU2tDQ1M9MwsDM2UanVoIxkLs96xqCixEugGoIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSCXQ2hBuemQKX8kjNTM8oAXGMTcyMdJRcc1LLoGqNjfUMTE2BYs75OflAc/NKc3JqYwGeS+RfEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVl1rgzAU/S95ziQxxq8+jW0w2B7KNthD6YOl0gacGS4blOJ/X7qqbdXb3K6IYjzec79yj862ZLpQb5vPnKTkSS/Uqy7UklAy1ao0XySdbfe3FmYTe5CaHp7ccMYmfxd7knremt1WVbaxtiL2gpD5lLPAC2MeUiE8JqVPd0DC5R6QTJwAYRI0QCJPAYiqtYiYiEZ9RNyPjwHp+9GlUYHOXQminbujGlBxEY5m3gGDIkIJws77/QgYD0apOqBfkoFFm8fBotdBN5XTRz+qQYJO4Ey4gPNBP5xUV0Q1SLDfc0QRocG5fNTQPtwAWHZoDPBUV0gG1Fr3DOKjAncJ6By9fdx5oC3cQgbtRFCWYAu0WLrHANQrUBPRVP/X3TMqCn4HIQBNhQCwuuv+TKAtdoD9h7hX2Udu8oqkzGOUPOflyqybxYs2mVG6bJbvatlBj7larU2zeCjyn+MX73ShLWH5XRT1/BelrKMa9QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2775",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2881",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.5 /",
    "Flow State": "Turbulent",
    Friction: "969167.74 /",
    "Friction Factor": "0.014832",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10075",
    Length: "106",
    Mark: "355",
    Material: "Copper",
    "Middle Elevation": "2775",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "102279.7",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "571252.1415",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "107",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2775",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2881",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528327",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.98667375",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jFELgjAUhf/LfR7DORVnT1FBUA8iQQ/iw6yLDtYWdgtE/O8ttLdzzvdx6gnK1lzGJ0IBJ9+aCm+kXWcRGJTeOHpBUU9LDIrMeaJEuhFRwrNcZDA3f287DHoMchj2Rj+QcIAi4hGDM7qO+l8RWZoyqDxpMt6t+GruK42VYHBE0/W0dKkYHCx+Vl3GXEkhGey89eHdva2dmy9Jky1TxAAAAA==",
    Pbi3DGeometry:
      "6SMAAB+LCAAAAAAABADtWE1r20AQ/S97VsV+SrJzCmmh0B5CW+gh+OAQkQhUq7hqIQT/9y6R5VgrPe2snVOyhIQoLzNvZnZ2Rn43T+z6tvrx+LtkS/alua2+N3V1xxJ23VSb9g9b3jx1v1qYX9gvtkte/vJBcH7x/MN+s92qN7vcbteP1lYVqeZFngiu00xzkyiZLnKpkwFgpAVUyrkwAyAXPJsEoEVWiM5CKKKrXMp8JioLaOUA83lMWECOLqoQC0iOE0QcXa0soISazcPkWk5yHAD3PF4AJ1yCK+cEz+DAeTjV9QOekgTVCpYERoU4YFSjo13YIE7LnN6iiAN2IiFB1KLhTU3mIGTuAt7qQg48ZODlDHflAn245EFG4CDPREiOAEK3Q3IXyEQflVLd5ZRTo+9oivotqHlow/X8jsKAG5XfFTUPPJaE7vPIO2BhzPxBIQvqpA5aLO6aUDIL3B/QAmbuLTt+YSFbQI6s2A8ZYbJBVBDwD2QXgK6IbzKU6sIFKe1Aewb4ophs0XAOTE5dXoSowi3cM8+kHgLGyAFw6N0eGN7BCYuRq1FfncxhJDfzFl1JJixGUXktRhwwQViSYI5xXwXmAfvq2BXqEgSEVxcD8OLAqLAFmYNcXf95eIc+dAV3FHHdwYaDbwAUcu+NInPgFxYIeGcJvIMjAC8vRI4tyBzkCeefiT25N6rxpD5zO58zS2bIUbjvRpPBHxTDxZrX02TI0gv1s/Nb1mRg5ieKNa+iyZClFywnRE0majJRk4maTNRkoiYTNZmoyURNJmoyU/cjajJRk4mazJvWZFYJ+1itf5VtuWVLnvKEfS039+3D/uFb067bqtnsH39Wdwfoc1ndP7T7h091+e/4H6+aurEON3/rerf6D7uk5TPpIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "827",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528328",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.90152283",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjssKwjAURP/lrkNI0qQvV0UFQRdFBBelixZDG4iJ1CiU0n832PpaubtzzzAzxQB5rQ79RUIKW1ur3Oq+sQYQ5FYZd4W0GKbTGwTBAU8WlHAc0ZjCiD4siLGIOPsPQy5+4VfqxMpXedZ1Ve8X+MdKVWfpZAcpwQTBTprGtbPYW1c55UdP8qhOb7SRqmndU4RMIFhreZ+9AcMJpwzB0mrrc81N67F8AH2HNgIRAQAA",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACdVktPwzAM/i85hyh9rY+dECAhwWECJA7TDp0WbZFKg0pAmqb+d9LSjZTGm4OqVc1n+7Mdx86WB7JYy5f9uyAFeVBr+awquSGULJSs9QcploefTyPmc/OQlv4iVwHn8/5lfqRdHc2um6bcG9uEsyjOacBjlgZhRqOQ5WkYUwufZcGsx+MgtPGUR2mPJzyiCJ6Tfh4nU/6I8U5u4x2vTzyQ37N5efg9G4+LJ0+c+R7xP/sG5TXyG2UsSeNwWgBbMGIaWdhbMbUYcnD66JJAUV3w4YgKTBAWgOGCzu1ioKj+G5UzQXfF4T0EWgWuBmTgXSXQBXjMUUcH0S8ofVRElxrP4wxAFrAAMTxAJtQUQujjIgLGkI0jGwK0gATQqPPtIHhmIvQxEYGXnP/shSxgAeZCA5l8bmSjb/4Z3MryTWjRkIIzTsmjqLd6NyyelC61VPWwfJWbk+heyO1OD4u7SnzZijeqUoaw/qyqdvUNVLPSn8sIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2740",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "10015.52 /",
    "Friction Factor": "0.021614",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10042",
    Length: "3589",
    Mark: "356",
    Material: "Copper",
    "Middle Elevation": "2750",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "35945",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "48105.4435",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "122",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2750",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2760",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528329",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.12792414",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/zzGpnNz6xQVBHUQCTqIB62hg7WFrUDE79568fa8/B6eaoKiNafxrkHBwbem1JfQuM5qQFB448IDVDX9ZETSHDNJsxUlDPOccpjrhVsPQzNGOAZb09x00AMoggmCo3Zd6D+GUsYRlD40wXgHiuJMECF5mnAhWS55bM/musCZQLDXpuvD1xOWINhZ/fqv0xQzQhmCjbc+nrmntXP9Blg5Fq/TAAAA",
    Pbi3DGeometry:
      "ZR0AAB+LCAAAAAAABADtV11r2zAU/S969oJsSZaVPpVtMNgeyjbYQ8lDSk1r8OKReYNS8t+n2aodKTqSTZ8KIiTEurof59xrXd3bZ3Jz13x/+lWTLfnc3TXfura5Jxm56ZpD/5tsb5/Hv1pMr/SHnLJ55V1O6dXwo7/ktHtRuz4e909al1UbXhZZTvmmFEWeMbbhNOeZXheMGUGVl5ZA7/MqgHWucjEKmFKWAHk2hmS+LCDOVeUXGAeuIb99bAYJcEQA2USFLLTmgpAAgBe/knM5CDS1lhnO+bDOuLAQuAqTg//79LJidjjOMvI7m7H9wngmHjhng6AoWCge6BgCmz2IgTtBRRmABhxD+xAZYCJeXJLSMclcqEDuz0pIjR5yvTFUW8gQWI7GsxQxDDQGzK2JqKG1ObiABrM81Z2jgY4oUBXYTuyQXXh0wdwvqBYkcNIQx7aavIWnRRy0DUHQ0nQiWYykSma9+56Gw42CMhBKI5BTSNVoqZLLErqCDeQDRTU3VDHiFqwKNtq1HVuHZKqylK8lCnSStdhgTmcFpYxAyWAHgBqoNcD9sToDXfWC7jg2hwx4agSKDGbUG2oAGqiAwNsOa8YfE74wosJH1y1ZKj+xoNuXmk5vVcJrBmwpQijvC6EFlR913DlsW0hwcdmAzmNM4Uu9mwqEAlAOeUKOoQOIDR4EICR4ouCrEY5pJTqcB+QCakS7hAsP0BF3AAyliTJNlGmiTBNlmigXjQFpokwTZSihaaJME2WaKCM1kybK836cJspzntJEaefhbUyUu4x8aPY/674+ki3d0Ix8qQ8P/aN5+Nr1+77pDubxR3M/iT7VzcNjbx4+tvXf843vu7bTBg9/2va0+wdsA19KZR0AAA==",
    Angle: "90.57°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2900",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "828",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "788227.8",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528332",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.46120965",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjksLwjAQhP/LnkNomj7SeioqCHooIngoPbQY2kDMSo1CKf3vRlpfJ2878w0zWwyQ1+rQXySksMVa5aj7Bg0QyFEZe4W0GKbTBbigYRgsmJ9QEfgwkg+KBPVYzP+yhAXJD/zqnFj5ms66rurdvjNWqjpLKztIPeoR2EnT2HYWe7SVVe7lSR7V6Y02UjWtfQoexozAWsv7nOU+FSJy3hI1ul5z03osHxrppg8PAQAA",
    Pbi3DGeometry:
      "0QgAAB+LCAAAAAAABACdVt9LwzAQ/l/yXEN+tU22J1FB0Iehgg9jDxsrW6A2Mqswxv53s/7QhuaSKqOjua/3fXfN3aXLE1ps9MvxvUAz9GA2+tmUeosStDC6qj/QbHlqby1M5vaHzsmv5YoSMm/+7IXOq97t+nBYH60vlzhNeZ5QprDMZZpwjqkkedIAorErovKLnVHWmrns7CRrn1cqCRN1HjLNhOvRKkiRM0chaB7H88f4IXbu0DDBowBAxJxsGRfUAfoXNwCAQD3CmcSE5nRAxLBUaQ/wARPD6mJogQGTdZAZdRzaHBwHOkjCkYCYwgqekEDpzKFSQmYxD1AjdbJQXIl/i0eiAsX7XWrEgboBgwULKuIBKIBZg+/Jk3WkNsGYwDYC+wXUAKMCO8wDRLbVs3sRwFMIQHtPqY/xOJg+PsLxwAPcA0RqHJxEIDCeE+AUB5kmHTfTDqhwUNDB5QPCYxCcpyDgadZgc3uIQseUJwX7fXCr129FXRzQjGCSoMei2tX7bvFk6nWtTdUtX/X2B7ov9G5fd4u7svgaPnhjSmMJq8+yPK++AXjwyVTRCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2724",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2733",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.5 /",
    "Flow State": "Turbulent",
    Friction: "969167.74 /",
    "Friction Factor": "0.014832",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10025",
    Length: "8981",
    Mark: "357",
    Material: "Copper",
    "Middle Elevation": "2823",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "8703974.6",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "571252.1415",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "107",
    Size: "20 mmø",
    Slope: "1.00%",
    "Start Middle Elevation": "2823",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2833",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528337",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.28725471",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNo+sjLlagg6KIUwUXpItXQBmIiNQql9N+NL3A3c+fMnXqCsjWH8apBws63ptKnoFxnNSAovXHhBrKePjIiGce5IMWCpAJzxguYmx+3HAY1Rjge1kZddNADyAQnCPbadaF/GUJyiqDyQQXjHUiCC5YwQbOUMpFzQWN6NOd/eKtN14f3J17kCDZWP77tLMOECoFg5a2PY+5u7dw8AR4ltGfTAAAA",
    Pbi3DGeometry:
      "qx0AAB+LCAAAAAAABADtV01r20AQ/S86q2a/tLvjnEpTKLSH0BZ6CD44RCQCxyquWgjB/72ydpTG6r5V7FtgCQnxjndm3puvneun4uqm+f74sy6Wxef2pvnWbprboiyu2mbb/SqW10/h314sLvqfYl/+O3knhbgY/vS/xX41Xnu/260f+7vaL4yVrpSKFl5WrtR6Ib2R5UFAklhgzUGgKkODwCo9CvQgMDp5bsiP58Ox1LZMWa6UVBNFyqRdIilHVYMN6aQNqsTUhq7mbMRVpQSIKARQa3XMiPJJpzCMypggcJ6C7UBuL+BgGGJVvTODoP8C3wgohObzYIKEC/C8UkeaSHjFmuSMbVbljWdvGR92ijVp65kQc66zkI9wQQkZLEg7g26OjwizCHYcBc5aQYyiIsc3KJ0HmtgpLRwzaNOpBgsDCaBTCdxAAL1N5Hk8QaCm051K4IsnoRRMrRWW616nyximDlIFe0uiVSABygScOpBbVK24vEFVQgoTqoAA4wYwjFfslXfBK+VUcpB54kTwgtjEpNnSIV0PAmfm8J3NyMQG9MpYzXN3DNPMOD5xrDtnJud0JkuoB58MDUW0Ep7LiAy3f6VfpvJ/YyFxAcwLdAM7BWHD/IMJG6cDNg/YbkBMExFCLsEsgLZhsFGiwUSOswEful7JEUMYw3Q8KaYvADNG2gvN5+PMiQ+K+clCim9YjoN99pVfBs4lTUMTSICfs9h2nCdMLKpSSB96cSGacEjjJiA2/DxEPsEGAQmfzZrXowOBQKhh4KLxSfQ+WBCggmBPzEtnXjrTJZ+XzigfeenMS2d8P8hLZ14689KZl868dEayIC+deelE9OWl83Xo3vLSuSqLy2b9UHf1rliKhSiLL/X2rrvnD1/bbt017ZY//mhun0Wf6ubuvuMPHzf1n5df/NBu2l7h9vdms1/9BV3njQmrHQAA",
    Angle: "89.99°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2823",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "831",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "784850.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528340",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.18124216",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkTYmxnkQFQQ9FBA+lhxZDuhATqVEopf9usNWLgredfcPMFD3kNR67q4YMdr7G3NvOeAcEco8u3CAr+vGMBqko51IseDKnIlUSBvIbKv7FWCr+szG0fJcv27bq4oL4WGN10UG3kDHKCOy1M6GZxMGHKmAcPcoTnj9oq9E04SXkjMDG6sdkFQlViqUEVt76GOvu1g7lEwno+PoQAQAA",
    Pbi3DGeometry:
      "4QgAAB+LCAAAAAAABACVVl1rwjAU/S957krSz0SfZBsMtgfZBnsQHxSLBrpmdN1AxP++2K/Z1GOiYmlyes+5N8k9dXEg87V8339lZEKe1Vq+qVxuiEfmShbVN5ksDs2thulUf8nR+5+5Y5RO64v+keOyC5uV5WqvYxPu04gnHguEH55uwsAXjCXeCUgF74CwBqJA1ECcph0Q1UAYpt5VqrMIfgI4F7GpIRqARs7AMKvb60AaTH8uUkEAU1EmLlZ+DgwXEaWLxbvV5SzmDRUPBlQaSBuqNBqsFWctU8KMgCRsso2EIZEENSCuE9kFjIyQcl+1c6pIol9xs4ZbpR1SgsrDDYIK6HDgk2mNQBKjnBBg37vRibVSwQjnrsBZQZeCgJVqVAcEbH3h3sMunurowigp6M4QsDGZLYbmrU08sn8bEwy4/dUz8gMXL7+sAamMMuC8zYqgHyCiawbS16D/LzzI1WdWZSWZUJ965CUrttWuHbyqalVJVbTDD7npoadMbndVO3jMs9/zB+9VrjRh8ZPnx+UfYIyDu+EIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2722",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2733",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.5 /",
    "Flow State": "Turbulent",
    Friction: "969167.74 /",
    "Friction Factor": "0.014832",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "10023",
    Length: "142",
    Mark: "358",
    Material: "Copper",
    "Middle Elevation": "2731",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "138077.9",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "571252.1415",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "107",
    Size: "20 mmø",
    Slope: "0.96%",
    "Start Middle Elevation": "2731",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2742",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528351",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.03665797",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjcsKwjAQRf9l1iGkbczLlagg6KIUwUXpImpoAzGRGoVS+u9GrLibeznnTj1CebbH4W5AwT6cbWUuUfvWGUBQBuvjA1Q9fs+EMIEJl2KZ5RITyjOYmh+36ns9JDgVG6tvJpoeFMEEwcH4NnafQAtGEVQh6miDB5XhBU97rMgZl1RIxhCc7HWGCRMIdsa2XfzLW2des13kmEmSlHVwIT3zT+em5g1q0IzK0wAAAA==",
    Pbi3DGeometry:
      "JzYAAB+LCAAAAAAABADtWUtr20AQ/i86q2If0j6SU2kLhfYQ2kIPIYeEmETgWsV1CyHkv1eWLFla7bcPNZfCEhJijeab9+ys5/o5u7qrvz393GQX2afmrv7abOv7LM+umnp3+JVdXD/3/7Zkctn+ZC/5+ckbSshl96f9zV5uBra3+/3tU8srZKEJ5zlluiClpDlnhdBE5EdCVXXPqaT6/FwVjJTCQsAMRGrVERjjIgBpJKhCtyxLEZbn0Ag7oRVRCUCwy4YcLhmR9o2uUoWSRAQZPvM5LygT2qLTQFjoFEAwwjeRYZW9sM6rlGmdF2kRi/V2uzigDKCtEbwQMyJzzULQRMkYV0047PY5oKCBIG0dBGx5oK/WOHGwHNiBqiy6LIMlBDyHJWM2nd44bz8P6J0QaSQ4m5HXiAkQ7TsLpbJzq+LKzqAIj2OAxo1IkAOJQKcblWVP0FLOgJTUA0EdCbLSVcfBeU9glHQcshTS0mm9MlZBBXPI45tOA60egYa7CAgpLNyTTKODhKPSx0yT2hZu3lrFVRyH+9gLR4IFNigFj9wuenKIXkcg8sQxD5Lj9B56IESCx72SYhDRcwgisUOgThDJZYVdW0cwoLL2KKmWs1LWwmihpbWOacmYtSohBxwIMRTSChc4qmNWUmGpJss52fdI1xQSDAWGjRAZcHiGwiEBuh0FCnoXZ4kjgtqSuo4iN6AmBMmotW4gR+xQH6PuKbIrtEUi8N0EjqrlEECjmjEBQpmEoRnjnA6WMUJBAxEUcOK58TEhOgap5vMOExXrgCiZi54x4OfncAuh+zZScih4hlN2evLKpdAUZ/I+wpn4dIETZ7GLAYqwqzpxEa9OFcFX2BCSSbRip9wLzW+HO+ZKBWaxpZebSkGHwIofm0fLofr0prYGfO42/vZkykZtCDkE6uRvvwsOb6czZUNlUZQC5jjDIeOQNdc2ZCxbcEQWRvjQObtpRjQVNN2tMBqOnN45H7aoecE4L8Y+GQso4CkIBAdk7FvPZWyhko8B99l5ww699C/uVY4GNT3UXLfic96IniAIc1+X/Rds80T1XYvNo9muk+sbB2iFXVkcCqiqNUZB9xcjFJNmOtfVfw8zOSJnm5jb1hDtFdoiGXBCc0wNsRchCAXnDMfw65GxgEL2ISTgwrSy+p9XVq5NzKvtsiJXVq+6mUorq7SySiurgERPK6u0sgqDSiurtLKK+vYgrazSyiqtrNLKKq2s0soqrazSyiqtrNLKKq2sXHN+WlmllVVaWaWVlV3btLL6l5XVTZ69r29/bA6bfXZBCpJnnze7h8Pj6cOX5nB7qJvd6eP3+n4kfdzUD4+H04cP282f6Yvvmm3TAu5+b7cvN38BoNdGJSc2AAA=",
    Angle: "89.45°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-869",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "54",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "67",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "839",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "54",
    Size: "100 mmø-100 mmø-100 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "528352",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.33547928",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABAC1TssKwjAQ/Jc9h7BbxD48iRUEPRQRPJQeWgztQsxKjUIp/XcDrf6Bt3kxM+UIRcOX4WEgg6M0XIgdWnGgoBB2/glZOc4wBNaJxjhNNhSlGlcxwaT+Y1bf+W3f10P4EISc67vxpocMNSo4Gdf6biFn8bXncHumV779rIPhtgsrhJpiJAV7a95LmEhjRJGCnVgJxe5l7VR9AKC+XagUAQAA",
    Pbi3DGeometry:
      "3wgAAB+LCAAAAAAABACtVt9rgzAQ/l/y7EIuOjX2aWyDwfZQtsEeSh8slTbgzHBuUIr/+0JnN61ecmVDFHOf992PeJ8u9my+0s+7t4Jl7N6s9JMp9ZoFbG501byzbLH/vrWwmNmDtcGv5QKEmB0u9mTt8uh2Vdf5zvrGKQeVJAFIxSGOVCDBGiAMLCASlVog5Wkqoj7QeaRcSSVJgIziy0MMESUw4TEO7stKcQlhQkg34SqWE0zWDiFMJHV0OK0Cs6MpYZEdnfUw+ToOwIUEOQ7RA4aNpQDDzRt7nBF8WJ8/+Enhfftg80YOGNG4OiQlR+RJu6M2tBvEqUDbRPFAY/h2ldwpx0gSqf5j7LH9mxh791B6iCh29NV0C46P6U+S5h4XqtZRiejjgmoEpuM+Jrpeo/KLiuYZXzwiFQVAJ9WnHz4qXx32b+FG569FU9QsE1wE7KGoNs22WzyaJm+0qbrli17/QHeF3mybbnFbFp/9B69NaSxh9VGW7fILtrHTO98IAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "-7541",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-7541",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "175.81 /",
    "Friction Factor": "0.018021",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3359",
    Length: "3100",
    Mark: "359",
    Material: "Copper",
    "Middle Elevation": "-4441",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "545",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000026",
    "Reynolds Number": "103029.8731",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "7",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-4441",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "-4441",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "528356",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.53740759",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jc8LgjAcxf+X73kM3eZ+2CkqCOogEnQQD1pDB2sLW4GI/3tD6/be4/PeqyYoWnMZnxpyOPnWlPoWGtdZDQgKb1x4QV5Nq4wIlzgRSm5SojDhGYG5/nPbYWjGCMdgb5qHDnqAPMEJgrN2XegXIylFUPrQBOMd5CnORNzjlHChmFScI7ia+wpTRiWCozZdHxZPWYrgYPXn16YEC8YIgp23Pp65t7Vz/QXOz2c70wAAAA==",
    Pbi3DGeometry:
      "+hAAAB+LCAAAAAAABADtVk1PwkAQ/S97rs1+dT/gZNTERA9ETTwYDhAaaFJbg9WEEP677VKwrZ3tFjiZQmjYfZ2Zt7uzM+9tiybz6GXzEaIRekjn0XMaRwvkoUkaJdknGr1t939zGI/zL9p5vzNXBOOxeeQ/tJsezK7X69kmtxXKJ5hoj1DtM664x6ivGZNeAeSfAyAMQIgoACy1OgDMAJxqAxQvtloEUrbGgF1BAMiqug5VAErpoOlK7wHMm6xAC8cFgha9Y/Rdh/S1oGaeCk48xnxMlTTzhJESCOieLVYmhC5J1S0swDE2FUwYQMrgpNgVT8IsT3JOXUkJkzxSM1ey9RCUi+DkDanFBkKA665uFLQIlwCWbO709McASjRww6GrB+8reFmhEO2cgO2zpVn7TQXPwal0dTOyVZueJwpH6GbkdHnBGuTgyVbmKgXe4gk8nzNOtBECajrgbT8rjxuFw6VNubHq7pGO52qjC7GC+1f/lg66upxs6C9mLqkneguN/qz66onzOnQ9rU5QB2A3dJAmLs2+uwxbZEbN4HLaoH1+kAaDNBikwSAN/oc0mHroNpq9h1m4RiPsYw89hskyW5WDpzSbZVGalMPXaHGE7sNoucrKwV0cfldfvEnjNHeYfMXxbvoDdxRrBvoQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-869",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "25",
    Length1: "13",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "842",
    "Maximum Size": "100",
    "Minimum Size": "20",
    "Nominal Diameter 0": "100",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "50",
    "Nominal Radius 1": "10",
    OffsetHeight: "50",
    OffsetHeightTemp: "0.01367",
    OffsetWidth: "50",
    OffsetWidthTemp: "0.01367",
    "Overall Size": "100 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1109428.8",
    R0: "51",
    R1: "10",
    Size: "100 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "528360",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.36852205",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "1QAAAB+LCAAAAAAABABNjkELgkAQhf/LnBdZTd3VTlFBUAeRoIN4WGvQhW03bAtE/O9NVtCDgZk3H2+mGqFo9HG4IeSwd40u8eyVbQ0Cg8Jp6++QV+OnJSSVAReZXIZRFkghE5jqH7fqezUQTMZGqyt67CHnAWdwQNv67j2EYZwyKJ1XXjs7r3lGSkmSKomESBic9OWf36FuOz/TMokZbA0+vwGLiN4ga+2Mo3P2YcxUvwAHYOJS1QAAAA==",
    Pbi3DGeometry:
      "sR0AAB+LCAAAAAAABADtV0tr20AQ/i97Vs2+d9Y5hbZQaA+hLfQQfHCISASuVVy1EIL/e2XvKPVD3wrnmiUksWa88803jx3N7bO4uWu+P/2qxVx8bu+ab+2quReVuGmbdfdbzG+f08deLa/6H7Gt/kveKSmv9n/6X7FdDMeuN5vlU3/W00yqUCkdZ1GSroyeEfX/kzwpKJDaKaKLLPd8oP+wk9ugphQmKbRMlnam89DJElkKyZJ3eZ98HORxbym4IwSy0SSE3nIeAVrCEChOiFyKBhlPKRo+TrEeJ0FSJ4VyKeAu0F7hpB8UbIl9CtGywttEwu4hlIyDnCF6fZKfWTJT2OrEVMj7ZOjlAIcj6xJGhuS0cscIKXOQHIRGCJgcigasJq/4gJeOFSpbBIajYWTg8IWpMkMtMS6HHuFMj8uxp4DZeGFAO5f6A4nBNHvFWXMxxdSRzbcuLIyMqfy1O3I7QAWoABRAKAeJgORgi0LWmQYCCkgbsaDICuLxZNRx8s7mFmkOIEnDEMlUtPGEn5ookMsjAjGgV57LNkqvecxOzt/LRzlXZ9TslXllrDKj5WKCMLXRcSfvej0Vg82NBHwAeotOQKewKVyIiF8m5eO3yPS1c5LYTJqQUzh/sDvQCVhusKQzERl/HSOKA439JI5SD8TB+8cwr0hGVoSpsQEGTbT6BEPaQ2cpGpYrymNDCPw+MfXKfIYNAgUji9sVsIAhn4rTeVJRnAC5zCsi8Ah1PYw3dOlycigREAKegCnK3IOgKxAEjFTZO48Qyt55UE5l7zyCLnvnoUdl7yx75zi5sneWvbPsnWXvLHtnftCUvbPsnW9x71xU4kOz/Fl39UbM5UxW4ku9fuge+eFr2y27pl3z44/m/kX1qW4eHjt++Liq/x5+8X27anuD6z+r1XbxD2NW2IaxHQAA",
    Angle: "89.99°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2733",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "844",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "784852",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529090",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.44727046",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKwjAQRP9lzyEksTVtPYkKgh6KCB5KDy2GNhCzUqNQSv/d0FZFT9529g0zk3WQlvrYXhUksMNSp2jaCi0QSFFbd4Mk68bTG+Sc8iDkC844lcFMQk++oBBy9geMw+gXfmIHmL/ql01TtH6Df6x1cVFONZAwygjsla1cPYkDusJpP3uUJ31+o63SVe0GEXBJYGPUY/IKQVkYxQRWaNDn2rsxff4ElFoSZBMBAAA=",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABACdVlFrgzAQ/i95ziSKMdU+ja0w2B7KNthD6YOloQ1YM1w2KMX/vqyLdcYeOYco5r7c990ludPViSw36vX4LklBHvVGvehKbQklS61q80GK1en31cJsbi/S0t5yEzM2Pz/sTdp153bbNOXR+oosilMe05jFkUhnOU2SiIlc0AGQWcMPwO2EAcD52Z5xiiNy8/OUXxWwMWZDILeGaSGB2qHsJoiHohpTzVIg8w7wlxDMz9NOEpFc2Yve7BH1gLceI48uiZGCywHBFJIYBwVmBwJgtKC4txcIqn9HNU5wuN+IaKGSwZ7zMBPODi4TePoRHpAEUhrcU0RFTqfCAuDxQBQx6AFqYMWhIzi93YWZcHawWsAuiPCAJJDSQDtF9OWpRBgz2B4Q1R76BvsKF7P9R7hX5UEa2ZCCRYySJ1nvzN4NnrUpjdK1G76p7QV6kGq3N26wqOTX34l3utKWsP6sqnb9DRVsFbPVCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2924",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2930",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6725",
    Length: "25",
    Mark: "360",
    Material: "Copper",
    "Middle Elevation": "2930",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "49",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2930",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2936",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529091",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.05313845",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1Tt0KgjAYfZfveozpZEO7igyCupAIuhAvlIZ+sPbFWoGI795A6w26O3+cc+oJqg4v48NAAUfqsCI79uSAQUXowhOKelpgDGjFU53LTSISrlWuYWb/MZvv/Nb7dowfolBiezfBeCgEFwxOxvVhWMmZQhsw3l7oFW8/62CwH+JKwpXMMgZ7a95rNhVc5lIy2JGl2Ote1s7NB4r8eVgTAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVk1rwzAM/S8+e8H5jtPT2AaD7VC2wQ6lh5Sa1pDFI/MGpeS/zzRZGptoUQilJdaLnp4sS+7mTNY7+Xb6FCQnT2onX1Up94SStZKV/iL55tw+GpitzIc09Gq58RlbXX7MlzTbP7fbui5OxjdNvJCxgPrM99KEpzQIPBakCTVAkPKwBaKMWwCP/BaI46EdZuodsigeD8FZYgFxFs8TBQZH5IcOPq3KpUqiZDzzHoiBHXE3HYxtVYN5IQ/DEaYr4GzImMcliwFg1w9BhYjhqHLywwCQXDi4XQ1M5gtUuQlaFQfVgl0DlgPhgW0ORMnhrQJ7AEm1aF6AqqYb8P8YmNMDAsjTA6qa7zF/ikEnFDGrcEQIO9gz4DTEMS2Zt6Am4PYD7TiiaTt22E5fDUiH1m7+M9zL4kNoUZOceYySZ1Ed9LFbvChdaKmqbvku9z30KOThqLvFQyl+hi/eqVIZwuq7LJvtL5DN8N7lCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2416",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2416",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6216",
    Length: "498",
    Mark: "361",
    Material: "Copper",
    "Middle Elevation": "2914",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "49",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2914",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2914",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529092",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.0600582",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyHk15Z6EhUEPRQRPJQeWgxpICZSo1BK391gWw8ieNvZb5iZooe8NqfupiCDva9N7m2nvQMEuTcu3CEr+vGMhmSBOZFiSQnFKaMpDOgXFFhIKr8hk5z/g3NsOdev2rbq4ob42JjqqoJqISOYIDgop0MziaMPVTBx9ijP5vJBO2V0E95C0ATB1qrn5GUEc0YEgrW3Pua6h7VD+QLH7F6qEwEAAA==",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACVVtFqgzAU/Zc8Z5KoSdU+jW0w2B7KNthD6YOl0gacGc4NSvHf56rddMkxSrE0OT3n5tzc3Lg+kdVWvRzfM5KQB71VzzpXO0LJSqui+iDJ+tT+bGC2bD6kpn8zV5yx5fmreUi9udCuyzI9NtyF9PxFHFDOuBf5PKI+8wKfhfQHEJEYAiH3z4AM5T+GFHRUKg65lREw5ltjQACvarYPHMOQkqPzWMjwLURsT+EFmG5P9jcj9ELBxWAzWqUeMFTqM9pEdTYsjNaGJQaSwgBaFQ5uSEkHARo3bHRJnx0bzsPQxi4NQ8PSMRm4phz24AGYkSlHQszqdAghgsXd+Jk0VwRPGATGlSweIADLwNFSodSUJuxkOIrT0s8hML3Oh1LzW4ilnzukIGPOhQVXhW4yDDikLD4QAM/rjC7iunitPpr3hluVvmVVVpKEeYySx6zYV4du8KSrtFK66IavavcL3Wdqf6i6wV2effX/eKNz3QgWn3leb74BI5iUKekIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "802",
    Mark: "362",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "49",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529093",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.70031083",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzGk6WpqPYkKgh6KCB5KDy0NbSAmUqNQSt/dYOvfzdvOfsPMpB0khTq2Fwkx7GyhEqvbyhogkFhl3BXitBtOb0AaMowWAUM65XMBPfmwSRBS5JH4g6IQsx/6lTuw7FW/bJq89Rv8Y63ys3SygZhRRmAvTeXqURysy53yswd5UuUbbaWqavcUGAgCGy3vo5czGnKGBFZWW59rblr32QPQsqZgEwEAAA==",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABAClVt9rwjAQ/l/yHEuapl2sT2MbDLYH2QZ7EB8Ugwa6ZnTZQKT/+zKtrtGcvSrF0tyP775L7i5ONmQ812/rT0Vy8mTm+tUUekEoGRtd2i+STza7T6dmI/eQmv5LBjFjo+3L/Ug93bvdVtVs7XxFlDAhacxElHKRUs6iRMSctuUsybZyzoQnj6XYybOUYnD29mk6DOJnnrmQXPaiA4XtSgsXtpPOMYwchpI9yI83DcjKCzuIk0hweXO6/b6mjeVr2nsR9smgMH+JYMG6w5xQgxM9swUgaZCAdy44sKuYBfIECgDeM6hv4JOBPC45MThKuPJxldTdQRhzDJ/OTuxTCZDLOQ1insBYqMmEsEdyCtemJ0f3BuwDacDR3r+bwHGKsMdxgm6/S8Yy7ANrMNcdjNXnvnb27n/DvZ59KKsqkrOIUfKsyqVdNYsXY2dWm7JZvuvFQfWo9HJlm8VDoX7ahnemMA6w/C6KevoLf32ak+kIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.9 /",
    "Flow State": "Turbulent",
    Friction: "7129922.40 /",
    "Friction Factor": "0.015427",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "5405",
    Mark: "363",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "38538485.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "676622.8098",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "44",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "99.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529094",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.60295501",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjkELgkAUhP/LO6/Luq4adooKgjpIBB3Eg9KyPth2w7ZAxP/eotaloNvM+4aZV/SQ13jqbhIy2Nsac6s7ZQ0QyC0ad4es6CfpA0EY0Zgli2XAaQID+UW8SBj/piIW6T86tpbv6VXbVp3f94cNVlfpZAsZo4zAQRrlmtkcrasc+pcne8bLB+0kqsaNRoQpga2WzznLGY04EwTWVlvfax5aD+ULRZc0kg8BAAA=",
    Pbi3DGeometry:
      "fwgAAB+LCAAAAAAABACVVd1rgzAQ/1/yrBJTE6p9KttgsD2UbbCH0gdLpQ04M1w2KMX/fUGdTbrLhxSLuY/f3f1yd24vaLPnb+fPChXoSez5q6j5AUVoI3gjv1CxvQyvSo1X6oe66CqJU4xX/Z96ULf7c1u3bXlWvnG6SLKc0igmCYsIThaEqcM/KaX5IF3i5VXKiEPImM+d4KyXUpxqtllKXAnAyYK4cAq6cPL3Cid3mue+XOGsQLKmVHupemGYmOY9sq4wmdA1ZlxDozMCgoXHNxsEAhvuU9dMPN3GN7gOS2yqpb+JoCjG3c9kbD4xrna2XyTc6HZ6b/EdpNsjW4sDO9eDA5rPWCBQHt4J9pcS3AzmiINMwsPvBgLNA9eKu8XDtlj4mFiHMXRMwAVsB3Lua4+pPZOAr1lAPTPWnjn3ENOhGyFkg2g1qK/5PS8/Klm1qMAJjtBz1RzlaTy8CFlKLprx+M4Pk+qx4seTHA8PdfWjG96JWijA5ruuu90voCMGZH8IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.0 /",
    "Flow State": "Turbulent",
    Friction: "926406.90 /",
    "Friction Factor": "0.017026",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "3354",
    Mark: "364",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3106804.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "232159.5194",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "72",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "34.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529096",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.9754719",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1zMEKwjAQBNB/2XMoSbSNqSdRQdBDKYKH0kPUpV2IidQolNJ/N9R625l5bDVAcaVz/0TI4eivVOItGNdYBAaFJxdekFfD74xEZYlYaL0WXCQq0wrG+u82XWf6iGOxI/PAgB3kPOEMTuia0E6Bp5JB6YMJ5N08X+g+r6kUDA5ITRumvBSKwd7iZ+ZSRrPSDLbe+vjdva0d6y/1oEnTxAAAAA==",
    Pbi3DGeometry:
      "9hAAAB+LCAAAAAAABADtVk1PwjAY/i89z6WDtaNwMmpiogeiJh4IBwgLNJmrwWlCCP/dohvYbQ9tlYOHhcBYn/Z5P/p+TbZkPJdPm9eUDMmdmstHlckFCchYybx4I8PJ9vuvhulIf8guOK5cRJSOvn70l+ym1bHL9Xq20WcTHkYxi4KIRmEyiFnQ64VU6KcBcJHsAU3BTUDohf2JRG8wgHgg2oFKBmeOTBCASkHZECipKNMbnLRl7cuQ59cqNa1j5h31hShVFbHBdAT6SanswASYXmgFKjOEpmylEn3uKBzKgFpVwrkjEaPRadENZbF5NisaVBBwdgi8cKguigRrhEC7/c2rOx3GM6SyZwAyD4tASoFsNZfdA8o/kXjrVR/KhHNwNAuLYyGyaYTqXG3dlqQwqTFQyxNY9iGVvVG4thy7UrBB1gH3qtysHAiAdQBWjjqVvblAA63OhS5x7pG2GLQ6/Q993rXW2GWfbTLwH8a8677/yHDGyeB8A4D3ZODfCPEJ72ZhdWE3GXSTQTcZdJPBv50MpgG5lrOXtEjXZEhDGpD7NF8Wq/LlQRWzQqq8fH2WiwN0m8rlqihfbrL04+fGK5UpTZi/Z9lu+gnJ6mN59hAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2930",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "2",
    Length1: "3",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "851",
    "Maximum Size": "15",
    "Minimum Size": "12",
    "Nominal Diameter 0": "12",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "6",
    "Nominal Radius 1": "8",
    OffsetHeight: "6",
    OffsetHeightTemp: "0.00164",
    OffsetWidth: "6",
    OffsetWidthTemp: "0.00164",
    "Overall Size": "15 mmø-12 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "7058780",
    R0: "6",
    R1: "6",
    Size: "15 mmø-12 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529097",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.0572968",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyGkCTRtPYkKgh5KETyUHqIu7UJMpEahlP67oVbwNjPvMfUI5YVOwwOhgIO/UIXXYFxrERiUnlx4QlGP3xgVnXKpc7VKRMJ1mmuYmp+37nszRDkOWzJ3DNhDIbhgcETXhm4uucoYVD6YQN4t+Ey3f7pHarsw90wpBjuL70WXkgupUwYbb318dy9rp+YD1WG92sQAAAA=",
    Pbi3DGeometry:
      "gxwAAB+LCAAAAAAABADtV01P4zAQ/S8+h8p2HH+UE4KVVloOCJD2gHooIoJIoVl1s0gI9b9jqNPFTp6dcrYqSuOX+Xgz47Hn7o1c3Te3r39qsiS/uvvmpmubB1KQq67Z9H/J8u5t/9PC9NR+yK74v3LCKD39/LJ/ZLcaxM622/WrlVVywbniBaNsoQzTBecL+1sXHlDq6gOgyigfEEpOS0BAWhUfAGPFPNtOE63s/1lOacqizo40QQHn03wBGCfIDpkY4kSFVRlloUzpG+cOqEKJETAYd0BJmUgAoaq08UAV9kpo5jMPbQxRT3kLnSoZlZMmIL/jbWDigAYsKimYty5FFS8dEVYOFzNLChZhCCCf0tkOgaSzI3aoPJCm431C7FDmhvcPNTBKUbhXYfGnVaVa8Dh5EAjrAEUQrqNUQHpwt0De6eYVApA3oqGF2gOVLj8B0GkPTVsZty6VS4VIrIM+BNup1Mb31ZiZx+fxB7HgexPamCgLmCKYVKgJsUOZ0Eb5ArJU0UaOJWDIkQRyCmuCIUf00tkON/2MjuNnNcIbOPWNMpgWgIWGajkdjvAWdeCgGZtM0fgMdutcT+7gYD19/KPDXBmpJ3dXaBmdOanTH99ZA8MgRjiox6cBcUM+zbiHhfGGuxRnNH5mp25VqRqDhtH7uPklW9YoGMAEDFIe8PKAFy2pPODlAS/qUx7wwHUrD3jx3ZIHPD8cecCbc2PJA14e8CI33Tzg5QEvD3h7TauCXDTr57qvt2RJF7Qgl/XmsX9yD9ddv+6bbuMefzcPB+hn3Tw+9e7hR1u/fH3xvGs7q3Dzr213q3duDf9GgxwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2930",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "852",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5137219.8",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529099",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.04248252",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjUELwiAcxb/L/yyis3TaKSoI6jBG0GHs4Eo2wTSWBWPsuyeroNv7PX6PV41QNPY03A0oOITGluYStW+dAQRFsD4+QFXjJyZFcJwJyVaUUCy4FDDVP2/d93pIciq2Vt9MND0oggmCo/Ft7GaQLEdQhqijDR4UxUtBhOQs40Iucsk5grO9/st7Y9suzpwzhmDnzOu7zghmFMEmuJCu/NO5qX4DKBNvgtEAAAA=",
    Pbi3DGeometry:
      "txwAAB+LCAAAAAAABADtV8tO4zAU/RevQ2XHr7isRsNISLBAgMQCdVFEBJFCMyoBCaH+OxFxU/I4ue4sZmVVrZqe3sc5vtf2vf9kVw/F7cffnC3ZRfVQ3FRl8cgSdlUVm/qVLe8/268NzE+bF9slh19OBOen3x/Nm+1We7Nf2+36o7G1ZiG5UIngYmGVNUnKF9JJmTRAqjLRAsbZHqBtOm0BAetkC8hM/wRw8M6VE1lQVlJwQ6Q7cAUtDlmFWuCsEEEYo9Mq4+I4RbLUA0qkPYsOMIPYNCCcmHa1B1BwGANmdSC+B2yqe6rTMaisxjHm6R0fAWsLWcAy7ADfNNro0NKxbe3YzMzVFC50ugNATsG1BpMNoDcoENpVeAcgfmj1Dp3fN8DtCusfeaL3YRQieG8JKBwEDNeCpHe0guE7SADvAQ1jnddWqW9AakecccYfZdZrqISeB8L35/3m0h2XyrXBteirPjxH/+FI1ql3pV0gQao+x/yQJ8gPLkdnkem2ByTP5jZ0+H9a86EFWSLwsBxpTtMbCgJ7HzYNXFaULeZ3bCHg1kBJwXpGguALo+N2kgY8wiVP1WS6MwByhW8oRk0yxzGoAwj+Prp5gtC0Uvj6HroaMxKirKYbGV/AUL/SyuILGLpnhdcaiA0tArb6ET+kCB0DuYqjXxz94ugXR7/ADoijXxz9ptYijn5x9Iuj37TmcfSLo18c/eZLIY5+/2X0WyXsrFi/5HW+ZUu+4Am7zDdP9bN/uK7qdV1UG/94Vzx20HlePD3X/uFPmb///OPvqqwah5u3stytvgBRMopitxwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "854",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5137219.8",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529102",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.68878304",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjUELwiAcxb/L/2yicy61U1QQ1GGMoMPYwUo2wTSWBWPsu7dWQbf3e/wer+whP9lDdzOgYBdOtjDnqH3tDCDIg/XxDqrsP3FUZpThVBCxoCTFnLAMhuonLttWd6M9FmurryaaFhTBBMHe+Do2E0gmEBQh6miDB8UwTSmXScYZF3IuGUVwtJd/eWts3cSJs4Qj2Djz/K4Tgt+DVXBhvPIP54bqBQFuXUzSAAAA",
    Pbi3DGeometry:
      "sx0AAB+LCAAAAAAABADtV01r20AQ/S97Vsx+a+WcQlsoJIfQFnoIPjhEJALVKo5aCMH/PcLSqrVXbz98XkxMpOeZnTfzdnbn4Z3cPzY/3n7XZE1uu8fme9c2T6Qg912z61/J+uF9/HeA6fXwIYfi35srRun18Wv4I4eNNbvZ77dvg+0VEyvJTVkwKleKq7LgdCW0EMUpQoU+IqxYtmBVPCJkdUQk48DGWV8apoA3FJl9X3KV7Avb4Mw4NsGcYZYuUnK5nDOXjaFmRJRFxvfKWqhzCwex6yvKq1gkff2ZJY5MVuoUmfk7q9j845hRZGrwubgIJpm+iIc+pOIRmVZTYoyRsZKVQo6I1gKIKSyzCNHi2BIkkBK1yxTKBnu7JDbMFNfUsWGADd6eMxLyhVoQboEexNEGzqUHgZXBLNGOQuwTGl0Ef8zFaDZl2YwHGq9M6BA0VNrKjN6Y4WFkuW3hFlxaX1yU4KgNH8IpRzoTZkRkkA2qGqoy9oRZ4spUttebUp/2enQIeExwAaANDs3jzSMnSDRCAmfNIdhMzovsuwPAuC4RBrLA8sMyj8iLcz9z2Ciuw9eAs6g13Boa5jPlimBzoE0wAnxsha8VnvuuGwHKmyfXF9UHMoWxJdz55mU8m9pT7Oh7gJvQeCH6IoA2ONUJLS8iNpy3PHjmwXNRTXnwzINnHjzz4LmsjTx45sEzD56LBciDZx488+CZB888eAJvm4J8bra/6r7ekzVd0YLc1bvn/mV6+Nb1277pdtPjz+Zphr7WzfNLPz18aeu////wU9d2g8Pdn7Y9bD4AzB7hjLMdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "857",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3883713.9",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529103",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.79200592",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNIX0kbV6KCoItSBBeli1QvbSAmUqNQSv/dWhXczRnOMOUAea2P/Q1Bwt7VusCzV7YxCARyp62/gyyHT5yURRDROGXp8h14EgsYq5+46jrVT/ZUbLS6oscOJKOMwAFt49sZsiglUDivvHYWZEATwUTGo5CLLE4zzgmc9OVf3qFuWj8zDxMCW4PP7zpkNAoIrJ1x05V9GDNWL83Hx0fSAAAA",
    Pbi3DGeometry:
      "ix0AAB+LCAAAAAAABADtV0tL60AU/i+zjmUyr0zqSlQQdCHeC3chXVQMGoiN1CiI9L+b26axyeSbR7cOpaWZL2fmfOc55/6L3D6Ufz9fCzIn1/VD+aeuykeSkNu6XDVvZH7/tfvbwvS0/ZBN8rNyklJ6uv1pv2Sz2IudrdfLz1b2JOUzSVme/P+jKFMJozOuON8uCE31EEmTaYk0dyIpGwKiW7AcL3U2vRlSzFzPmAzeC8tgw/Qy3ibDLHtE5HLaZhY2bI9IkR1apl/nUIKPz++RTGkHEn6+uRfWjHEx5G+c0tvfQ2ekmZY5OAWzDD8F8ze44ChTsosMngvfmBWtEbdImvEhz4A484harFtADHhojTXAcYN3O0Y3D6aGTw2Z1DujjfxAe6HqiM/ACI4NSzy5rYwzGleBUUYh9gGVzoc/5KLV7hW1k2C5BpX+oNOIPZNOY81ciLOejGuTpLQ7v9V92Gn9W7C7n4ucjhHhJON02Ygk3AmTRG4RSnRJoWQKQs9oAB4yRmvAMkgziytxKKHgw3YBRQH5BPsXc0cMwyMCS0C9LOENM8Jy9R1SkS0+Tf7gTjhSWcGEUNCUHrcCwwBKOzXAnQoj+PZh0WDaatjOx/kG8sSaBdzyfvo7TmW3R92df48cEYWWWEMegIUhoMg59YJ7xSEzDpkDJA6ZcciMQ2YcMh2xEYfMOGQOkDhk2mXikBmHzDhkxiHzlw2Zi4RclMuXoinWZE5nNCE3xeqpee4e7upm2ZT1qnv8Vz720FVRPj033cNlVXwcvnheV3W74eq9qjaLb3rofIGLHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "858",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "457221.8",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529104",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.94965739",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkW1OaehIVBD0UETyUHloMaSAmUqNQSv/dSKsgHrzt7Btmpughr/Wxu0rIYOdqnTvTKWeBQO609TfIin48g2HGaRIlfCGQxhxTGMg3E4n4xzBO8YdNmSMr39XLtq260B8ea11dpJctZIwyAntplW8mcXC+8jpMHuVJnz9oK7Vq/EtEbI4ENkY+Ji8iZSLlBFbOuJBr78YM5RMQJUC3DwEAAA==",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACdVV1LwzAU/S95zkqaNP3ak6gg6MNQwYexh42FLVAbqVEYo//dOtta015uKqWlOTk996P33qzPZLXTz6c3RXJyb3b6yRR6TyhZGV3ad5Kvzz+vzTZbNhep6S+yCBlbXh7NTepN99lVVW1PzbcLGcRhLGnGAxElMeU8CCWL6QDnmZTfOMtSOcSF4OLCD0VKPXR6fppEU/qc8eQPHololj+QXSQub7uIPyMdmSaT8Xa4kzcorpHdLM4m89/iI52O7+bB4ff+u/qd/4gOpu/6A8UF4pCfkF03/4jOf/0ZxeX+XyxvQF941zOm44tD+YHqHOGD9eNrF/qPWN/N1fHFoXpA+hTkQ/q+dqF6mzvHMB1fHOoLaL5hfEjf1y40J7F5O1PHG4fmANbX2Hnq6g/w5ry/0dtXZVVFchYwSh5UebDHdvFo7NZqU7bLF73vt+6UPhxtu7gt1OeQeG0K0wiWH0VRb74ASO3VfqEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6737",
    Length: "25",
    Mark: "366",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "39",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2967",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529105",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.89185019",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xhibKytK1FB0EURwUXpIsXQDsSMxCiU0rsbaPUG7v4X803ZQ1HjpXsYyOFINRZku4YcMCgIXXhCXvajjIOZ4ulKLNaZ5DJTCgb2h676ojfe6y7yY7BDfTfBeMgFFwxOxjWhncyZgg4YXx7tFW+/6mCwaSNkzpeJTBnsrXlPWyl4IhPFYEuW4l33snaoPtaArq0PAQAA",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACtldFqgzAUht8l16nEJFZrr8Y2GGwXZRvsovTCUmkDzgyXDUrx3afVboZ4yLEMUcyf45ffk+RkfSKrrXo9fuQkJY96q150oXaEkpVWpfkk6frUvTbdbNlcpKZ/yixkbHl+NDepN5fPbqoqOzbfzqIg5gmnCx7wRRRRzgM2jwVt9YSJsy6FtPS23epREls6xOnjheBijC9kPJ+iO36m+gf4ieByjAPpICeMw7H/vehO3gCf4LhW/lkguYxczkC38uPGd/4HujVfCI6H7/gBxrX/F+ET4Nv5v35cnx9oXGdeUPsCyj8iHuJD8wJxPHl29iOK8191AJpf/77DcRA6ap1AfqbGT61L0Dr01x8cB7HOPfvdqW8ozvX1E/QDnV+QjuIgdFT9RNR5VHynN+f9ncrec5NXJGUBo+QpL/fm0DeetcmM0mXffFO7366HXO0Ppm/cF/n3MPBWF7oBll9FUW9+AL0gg0ihCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6225",
    Length: "501",
    Mark: "367",
    Material: "Copper",
    "Middle Elevation": "2926",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "319.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "39",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2926",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2926",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529106",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.88986242",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkG9um9SQqCHooIngoPVQMbSAmUqNQSv/dSKvUk7edfcPM5B1kZ3VsbxJS2NmzyqxuK2uAQGaVcXdI8244vWEWcMrjGBcJUuQCoScTGFIR8egf4yGKXzYJHWDxKV82Tdn6Bf6xVuVVOtlAyigjsJemcvUoDtaVTvnRgzypyxdtpapq9xYBmyOBjZbP0YuMokgCAiurrc81D6374gXs22M1EQEAAA==",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACdVt1LwzAQ/1/ynJU0ST/3JCoI+jBU8GHsoWNhC9RGahTG6P9utnWzsT16lbLS3Mfv7pfLXbY8kMVav+4/FMnJo1nrF1PqDaFkYXRlP0m+PJw/nZrN3UMa+iuZhYzNTy/3I83q4nZT18Xe+c5CEYgk4TTjAZdCUs4CIUNOPUUWRUcFT7PQV0RpcvJgUlIc1MUjSQdDiEwITyFkEk9MCow9xg8ffDSrPpTgYoj4Vd7bQoifHzsK0ljE/WJ05B5QR+5tR9/+TGEA/8gAATMC/zcdiBZIF0oTiOsVYBzmv+n0aIH1hfYH6hBg+yHzqWUB4KHzjDolmMbAOSAyGu0wZOGHzSExbkIAOKhRg3LAZASdRF+BaAHIHpDDk3pyz4AzEeeByQm80qaOV8gekuOuLQho0uXrPNw/gTtdvCurapKzgFHypKqt3bWLZ2MLq03VLt/05qp6UHq7s+3ivlTfXcNbUxoHWH2VZbP6AfywoBe7CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6186",
    Length: "2290",
    Mark: "368",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1460.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "39",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529113",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.30506282",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GPpw5u4oKgroQCboQL2YNHawtbAUi/veG1t15Ds/hVCMUjbkMTw05nHxjSn0LyrVWA4LCGxdekFfjEqOyEjglXGwkw0wKAVP917Z9r4boxmJv1EMH3UNOMEFw1q4N3QyUIyh9UMF4BznHNKFCslRwkcm15BTB1dwXl9IkRXDUpu3CzCRhCA5Wf35rxjCRmUCw89bHL/e2dqq/GDPCdNEAAAA=",
    Pbi3DGeometry:
      "gRAAAB+LCAAAAAAABADtV11rwjAU/S95riVtkn7o09gGg+1BtsEexAfFooGuGV03EPG/r3Otq23PkoiwlyKKOU3PPbm99x6d7ch0KZ+3bwkZk3u1lE8qlSvikKmSWfFOxrPdz9fyMp2UL7J3fpGRR+nk8FG+yX5e33aV54ttee9IuIEXCCf2XV9EoeP7rheF3GnisRDfuE/98ATnjB/2Cxo0ccbDoA8/8nssMuGBONCD4kI9FQ+NI2GikzGf9eoHPOfq6Zyrjls/F8qq/ATshKfGA1rpF1ETZ4yyPryO68Vx1MsTCaO4kB/oOcalHjfhYZyHf8Zt60Tn0ulv8UB+0zyg54t0oueuqwdwXttzdfKM6hbx6OofnQvxIz2gHzu4af3Y9ktdt2gOGNZDZ26YzhmdHjRv27imH2H/IrzdF2ieIx7d/Df1EZ0e5Hdt3HTetucDwkG/w/nQ5tH5MjqXLp8oD4Z+p603XZ7P9GvjeaKLeyF/t/0dZTvPbX3/Uv5+MR+39HdbX4P7Lee/Nm+Dvw/+Pvj74O//6O/l//kbuXhNiiQnY+pShzwk2brYVItHVSwKqbJq+SJXx0t3iVxvimpxmyafzY3XKlUlYfaRpvv5F1WjKpOBEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "862",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529114",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.95657494",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNzcsKwjAQBdB/mXUMeTRtU1eigqCLUgQXpYuooQ3ERGoUSum/G1/gbu7lXKYeoTya/XDVUMDWH02lT0G51mpAUHrjwg2KevyckcwEznLC55JhJoWAqfmxRd+rIdpYrIy66KB7KAgmCHbataF7BSpSjqDyQQXjHRQc04QKyVLBRS4zySmCgzn/4402bRfeORE5grXVj++aMUzSLJqltz4+c3drp+YJ42AgftIAAAA=",
    Pbi3DGeometry:
      "Px4AAB+LCAAAAAAABADtV8tq20AU/ZdZK2beD2cV0kKhXYS20EXwwiEiEahWcdVCCP73ytY4lSZzNFI22QzGxjq+PnPm3DuPe/tMbu6q70+/SrImn5u76ltTV/ekIDdNtWt/k/Xtc/+1+5ledi9yKP4jF4zSy9NH9yaHzflvV/v99qn774Vaaadd4fiKKyYKzlfMSVsMcKHsCVZUj2DhTDQc4NwpdcQ5E6yYM+yZh2o5Q84LzcxwIZawgPCUltACxO6todayKQssl2rIQ7URQ/wcf8aNpWIgMwx/RSO5Hcl5G70Rmk2Fey/D8FBNIjxkR5NCIpexG2ai1kDxjJlxZvlUIbyVBtQNrLN51W20Y0OYWjcFL0wrcjI+VUgDcOgwEC+sHi5k4cabR7AAYXkkaBI7aLhlATxMN7IMwdMlPHt1R6eKnYnj0GEg3vWwkD5csL5UnTtNShxX/xHXtB9WqX5Y2R02R9xoPbmVAX5Luezxrl6Guw3jo5Qw5usJ6IHjajfmcULHUh4emvDw9TqZ4WYqW8AeULCp8g4HRckCxxHyGOYK5BzlEPDA425pblF8IrdhDuG8AA+0GeQ87j5MYqpEQvVgVCQS0CMT4LAJmeECSi44dHWTnI/ssba/bgjbx3M1db801khP71eWOdFbIU6ucSPkrNtM/BiDo8ZFdpWg/aSCLR/EAzXINFixyAV4d4vrQTw4Pn5FiZsJ9wWUK7D+sctxNVB8otJeVSYwGW1TyMylSUQ2ANtg8QB+NN/cvub2NbevuX3N7WtuX+es7ty+5vY1t6+5fc3tq8vta25fc/v6fu3rpiAfqu3Psi33ZE1XtCBfyt1D++gfvjbttq2anX/8Ud2//PSprB4eW//wsS7/DgOvm7rpCHd/6vqw+Qe4lUmZPx4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "863",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529116",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.71811767",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNI0yZp4kpUEHRRiuCidFE1tIGYSI1CKf134wvczRnOMNUIxdHsh6sGBVt/NKU+hca1VgOCwhsXbqCq8ROjMmNY5CSdS4qpZAym+qct+r4ZohuLlWkuOugeFMEEwU67NnQvSBhPEZQ+NMF4ByrBTBAheUq5kFkuOUdwMOd/eaNN24U3ZyxHsLb68V1TgqnIBYKltz6eubu1U/0EkOuAAtIAAAA=",
    Pbi3DGeometry:
      "Fx4AAB+LCAAAAAAABADtV11r2zAU/S96doM+LSl9Gt1gsD2UbbCHkoeUmtbgxSPzBqXkv8+x5cyWfSy7o2+itGlObo6Ozr3y1b17Ibf3+bfnnxnZkk/lff61LPIHkpDbMj9Uv8j27qX9t/6YXtc/5JT8Q64YpdfNn/qXnHbd194dj/vn+rtXaqNFyhLLN0JYnXC6kVyq5IwbKs44F2IAu3Cu2DKcadPgVqmpeH9Zc36d4pmW04UvVe9gocwaFi88YA3a0giXfNIaZIFJRdrn4fVLD+7CfbgVKSTjS0icFq7Nf5B30cIoOVi09RFpWRgO2cGWgAHryC9JokLPapfGDuOtmS2CtTyBollafPAkMNt3R3E5B78uryMv0V5D9eHj0INJ9doy2S8Qw+2S4+dXCKAJPLBG7AhH+Yb1Me8lqmNY98PTgzwLsfg43O20em0tb3DpeLjDNW3501S1OGt2pZV08do2eJpO6nGPCkR/CZecNzizrMEZG8gU1Kg5OWhZocWARrF0Sc8c9UZleF/mBQeVCcxBbQ2xoEUDXoKW4VsMLEMJD60K+pff7tYmFsWjzKIMom0hHnQeAsfTO8wohahAkHpQIUgkoocmoLIHPPD4zCdl1CKdPeL8UOo/pKhqccXb9lNve+ayqEXH3ha4GPYwptOmAo0epMq/zIAWBrr4tMILtzRtQphbMxA+lALtQvYGDPA2CswFJAHl3r1k/haD7r6jFIFDD+0FaoB2YAAoRmQMfJBNhq/NXcgBzzFYMkAN2mscVeOoGkfVOKrGUTWOqnFUjaNqHFXjqBpH1ZkbcxxV46g6dejjqPqGo+ouIe/z/Y+syo5kSzc0IZ+zw2P15N58Kat9lZcH9/Z7/nD56GOWPz5V7s2HIvvTD7wpi7ImPPwuitPuL7HDpf4XHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "865",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529118",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.33333301",
    Cost: "0",
    Pbi2DGeometry: "CQEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzyGkIYGmnkQFQQ9FBA+lhxZDuxCzUqNQSv/dSKsHEW87+4aZKQbIazz2VwsZ7KjGnFzfkAcGOaEPN8iKYTqjQfFEm3ShFFcy1TCyX0gL80WE0vI/meLKd+my66o+NsfHGquLDbaDTHDBYG99E9pZHChUAePYSZ7w/EFbi00bXiIRSjLYOPuYvVJyYUzKYEWOYq6/OzeWT2UqbLgJAQAA",
    Pbi3DGeometry:
      "FwgAAB+LCAAAAAAABACVVVFLwzAQ/i95riXtktluT0MFQR+GCj6MPXQsbIHaSI3CGP3vZu6qTUyuGWXt8vX63dfLfdfVkSw38uXwLsiMPKiNfFa13JKELJVs9AeZrY7nv+Y2nZuDdMkfcpVROv85mR/p1v1ji7atDuZZltIpv04YS1le8CTP06wozPo/nPHMwBnN+RCmZVkg8KScRJDklJ0y8tNlEMyzMiwkINtPHdLhwsARCQMJZ9MY2X59gfqBbEA5LQexPTOgTj161E4HqF0NmyAumd0cjgTYwB49F8LNZhcT1QByocA4rb2jMVW44H3jJNixTj+EYLQ6kY2JvR7aUQF3+LcISYY3n1+CY360z8ZmE8De/guNFX8wntBRh1L4vRFQERgefouPTULMzyPzx2+GQMKY+YH7/LKviN/qYzPdntKOg3Gv+u0eSDhQZ76yt7J6E1q0ZEZTmpBH0ez0HhZPSldaqgaWr3L7e+teyN1ew+KuFl/DwBtVK0PYfNZ1t/4GxQqBEhcIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6738",
    Length: "25",
    Mark: "369",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "53",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2968",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529119",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.91675735",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xDSOBGsK1FB0EURwUXpIsXQDsSM1CiU0rsbaPUE7v4X8005QFHTpX84yOHINRXs+4YDCCiYQnxCXg6TTAOUmdJmjSjNSi9gFP+uqi9203W2T+wU7MjeXXQd5EoqAScXmtjO5szRRkrvTvZKt191cNS0iZHJJaKAvXfveaqVRI1GwJY9p7Ph5f1YfQD1ftvaCgEAAA==",
    Pbi3DGeometry:
      "TQgAAB+LCAAAAAAABACdld9PgzAQx/+XPldSyhWFPRk1MdGHRU18WPawZc3WBKnBarIs/O82yOb4cW0HBEK/PT69o3fH4kDma/W2/5QkJ096rV51oTaEkrlWpfki+eLw92in2cyepKb/ylXM2Ky52YvUy+Nrt1W12tt3IWKpuKYAkbAH5dyOb1IKUZxkiUNOeRYHWAtIGznjiR+CecK4aGRg3L/kEdJnCwYjniBLIhAs+NbBFAACwnEH71ySRcBBDII/yd0lB9Z9SGd3fGxM7uyOzxNM7uzOwLrvd+d7+6JEIBjbDekHH5LfCNtrjbDdmxb4qcYzNggysRoQT7ByRaohBOKVkWRzdwgnZGr3cac90pT6cgjEm8jjVYy03iDI1LaOeOL+HTnZUzsbUmnumr+sQ5z7bf/N92r1IY2sSM4iRsmzLLdm1w5etFkZpct2+K42p6lHqbY70w4eCvlzbninC22B5XdR1Mtfcsypa00IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6225",
    Length: "501",
    Mark: "370",
    Material: "Copper",
    "Middle Elevation": "2927",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "319.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "53",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2927",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2927",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529120",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.9214401",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkadraehIVBD0UETyUHiqGdiEmUqNQSt/dSOvfydvOfsPM5B1kR9y3FwUpbOwRM6vbyhogkFk07gpp3g2nN0x4QIM4FjMpaRiE0JMPk5Tx5A+JZBL9oO/AARav4nnTlK1v948llmflVAMpo4zAVpnK1aPYWVc69IMHecDTG60VVrV7Cs6kILDS6j56BaNimnACC6utzzU3rfviAXsRpO4NAQAA",
    Pbi3DGeometry:
      "hwgAAB+LCAAAAAAABACVVV1rwjAU/S95jiVNstXWJ3GDwfYg22AP4kPFoIHajC4biPS/L7pO49bb3CgWcz/OPb03OVkcyHylX/fvihTk0az0i6n0mlAyN7q2H6RYHH7+OjebuC9p6cUyShmbnB7uR9rlb9q0acq9yx2lIhFZxqmUyS3PU8pZIpiU1HfcuM+wIxsjEyTjJ4dMOQoJ5pRzcXTwsQtA1T5D/S0hXWAfJ7A2hAS2o+MqciGQbxdqh7PLhKX5v+ge6xH8Yr6qGcTw5xWEhsz+qIJEILM/pZ7oa9p+w0Pv2A8R02l4jIH2DewfRDQAHq4JNArcsgguIA4mAcEHPLwx84+ZNKwK4Y0Ypy5DCRg+QZWKO0g4tQDVF3HWUTKOy8AwCl5eKLWKlDzwnkMIatyF6TLcrX6ny52yqiEFSxglT6re2G23eDa2tNrU3fJNr8+uB6U3W9st7iv15QfOTGUcYP1ZVe3yG9bHp1+HCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6186",
    Length: "5302",
    Mark: "371",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3381.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "53",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529126",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.51856627",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzGNrfp7BQVBHUQCTqIB62hg7WFrUDE797Qur3f4/d41QRFay7jU0MOJ9+aUt9C4zqrAUHhjQsvyKtpjVHhmBImNpxjToWAuf5b22FoxqjGYm+ahw56gJxgguCsXRf6BWiCoPShCcY7yCkWKUmVTJhMFc+UlAiu5r66lPKIR226PixMOENwsPrzWzOGiVIZgp23Pn65t7Vz/QVxmDdI0AAAAA==",
    Pbi3DGeometry:
      "zw8AAB+LCAAAAAAABADtV01PwkAU/C97rs1u22VbOBk1MdEDURMPhAOEBjaprcFqQgj/3cUWhPqm7MYeGwJlp6/zZj/eG5hs2XiuXzbvKRuyh2Kun4tML5jHxoXOyw82nGyrr+Y2H5kX23m/yJXgfPTzYd5sNz08dr1ezzbm2cjnA6m8KPKjIJZeEPgijs3YFzyQp3DAI4Nyub+cBEuR7INlNCDgP9QGxySImxQCMiK4wcGTJMb6RJiEFEyT/E9JPZtmxmoPuAwrWMjzZVXqDBaqkq1CCj5krOGAC0GRxIOWlIAbKWmkNGPVIlAKZZOyEoimY6m7JqFht8mDraT1gR1GMCJxmQ1aV3AwEQmIpnWjWgA7TNcZgC2PiVMxHE4mKG27jT9GO7UNWglqmaBTIRKyLBEMugzo0ogERLs5AOh3pEMh2LJp1iVPw6gAaVO8wNEIBqrt1g9MvfWo2Z6p1mV1c1a3/oBSduHDTj9v3Nqxoz134cPdGK6bD7t5EYh2a96WS9X7cO/DvQ/3PtyVD5t/x7d69paW6ZoNuc899pjmy3JVD56KclbqIq+Hr3pxvHWf6uWqrAd3Wfp1GnhTZIUhzD+zbDf9BmBfiFLPDwAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "870",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529127",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.81632003",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNI0yRt4kpUEHRRiuCidNFqaAMxkRqFUvrvxhe4mzOcYaoJitYcxqsGBTvfmlKfQuM6qwFB4Y0LN1DV9IlRYTghlC8Yw1zSFOb6Zy2HoRmjGou1aS466AEUwQTBXrsu9C9IuEgRlD40wXgHKsE8I5kUKRWZZLkUAsHRnP/lrTZdH97MeI5gY/Xju6YUE5HHycpbH8/c3dq5fgJGvb4G0QAAAA==",
    Pbi3DGeometry:
      "dRwAAB+LCAAAAAAABADtV01v2zAM/S86e4Zk68NKT8M6YMB2KLYBOxQ5pKjRGnDjIfMGFEX++1xLSR2FT3Z22EkIGtQM/US+R0ri7Qu7uWu+P/+s2Yp97u6ab13b3LOM3XTNtv/FVrcv7t/hZ341fNg+e7O8E5xfjV/DH9uvD6+93+02z8O7MueqKjMpc8VtVhS5sFpkMhdaTY1K2Fej1IZwpa28mCIUQsoMLhYgcGNQCCFAzFUufZ3yXLS6Cx/EdEoAr6yEqR4QdDms+uqsKz1xDs0+NFuUEyvC8GFoJat/hT4GLSsxXVFGwljii3BBJnTaFwAfJSlsNR/ym3dpnIJliUvoIgy6NmaQZ0vW2yoxRiCGRWaMi5QDpM2xQ0uKzFRupyEf1Fdcj1bJDd45gPw0xJKdLsBd0ugzyiOzpboUJBIUfZyhAGLGTGcYBK38HsKdWZTFyF0p3I4jhAPRYoRWXIwg2jhdjZkyHTY7wFbKOuzhOCE2uWLEEAUvI4GAFQ9JVt7bSgvPMXDm+egOViOxLIANshgBArUYoI0uGEAm4AfJSq8YJzk8jS7Sj3YG8tFCxZFDjDip9HZCUx2IFe0I+kIWFgFoExo53hBhMdMYdD/QzIH7krTFGRlcKnfoc+5l1ZFLXOU4ts5V2RG2cs5aKj1/m4idi8GpCgKzjnmhzAks7Q2CoK/DkEwybZQfCoQEibJP3riC45lubKAJ3cKQUjIIEDASi6g4mgoQW9x5mVQAOl63Z7MGrR+dYJrs8HGaJrs02aXJ7py0NNmlyS5NdmmyS5NdmuzSZJcmuzTZzUv1Pye7dcaum81T3dc7tuI5z9iXevvQP/qHr12/6Ztu6x9/NPfHnz7VzcNj7x8+tvWfqeOHru0GwO3vtt2v/wJMQEZudRwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "871",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529129",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.0837415",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNI0zzauBIVBF2UIrgoXaQa2kBMpEahlP679QXu5gxnmGqEorGH4WpAwS40tjSnqH3rDCAogvXxBqoaP3FWGE4I5QvGMM9pClP9s5Z9r4dZnYu11RcTTQ+KYIJgb3wbuxckXKQIyhB1tMGDSjCXROYipULmLMuFQHC05395a2zbxTczniHYOPP4rinBVGYSwSq4MJ/5u3NT/QS6nfTX0QAAAA==",
    Pbi3DGeometry:
      "9RwAAB+LCAAAAAAABADtV01r20AQ/S97Vs1+S+ucSlsotIfQFnoIPjhEJALVKq5aCMH/vbK1crXLPK2dY1lCQjQev3nzZlazc/fCbu+bb88/a7Zmn7r75mvXNg+sYLdds+t/sfXdy/jv8DG/GX7YofhneSM4vzn9GX7ZYTN97e1+v30evqtXQtuy0HpllTWF5CsttSkGM5fmaDbSVXOz9za6EheY7YjhpCKco4jcVIrCoIlM3hfS9mY7gF8OEnknJAHpxGZNKAJS58LJOYR05cw6OUdWT05pIdMQnoYsq1cjT86qMnoe0GsHeFzmjbDpZEDmV0GfC8NVuUBbKRd6D6Fxya8DWWqQy3oMdbvlLlDESL1gflUhY/1AjoluiMwgecDbCR20QyVd+ojF7UCDJN5FMTYwkwUGQi3rB7oV9XZ0QIBQCZDIDHIEvCs16qc8iDyZhZAjtlVqNItjOkJWdsTW5clsLcXEvwVo6LPzwOdoFU4crSUP6CleGcyDDii0CYabMsImR14826S2M3aTeKD5aDlQTyIQMmJCPPDmDzWlVQKSJgLSAyiaVtcVEXiDKoJ6gUalQVCSiXMXik0XDPUCTRtFBKcRYKPcQWfTIOB0LBYhnm5eEauNnSdZluPQ024cHgPNhaucm6BH32D8CK1PfVaV88JEtw56+qDRS5I7I2szFkCMAZedAxpII6DoYtphfkBOCmCZb3R/WL5tgBtpXBL6MCM9AROaNp033XNADvpNQ/leVadE0qFEcK2jWIDs8maYN8O8GebNMG+Gs5B5M8ybYd4M82aYN8O8GebNcCZn3gyTbfRfbIabgr1vtj/qvt6zNV/xgn2ud4/9k3/40vXbvul2/vF783D+6GPdPD71/uFDW/+ZO77r2m4A3P1u28PmL5UHVrn1HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "873",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529144",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.23097301",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkr7apJ1FB0EMRwUPpoWJoAzGRGoVS+u5GWgt68baz3zAzeQfZWR/bm4IUdu6sM2fayllAkDlt/R3SvBvOYEg4FnHCFzMqMBM0gh59QS5j+R/yaE5/4RQ7wOJTv2yasg0bwmOty6vyqoGUYIJgr2zl61EcnC+9DrMHedKXCW2Vrmr/FpQIhmBj1HP0MoaJlAmClTMu5NqHMX3xAtgzrEETAQAA",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABAClVt9LwzAQ/l/ynJWk6Y+kexIVBH0YKvgw9rCxsAVqI7UKY/R/N866uqZHrkhpae76fXe53n3t8kgWG/N8eNOkIPd2Y55sabaEkoU1VfNOiuXx59a52dwdpKW9ZcYZm58u7iTt6hd2Vdfrg8NKESW5FHTGkyjOYhrHEZcypxd2JeW3gykl6RiApxxnT7L85Ei5GgV4kQMZxSzBZSpEmo0yiZSp0ZTOiOEmQCq4TEC2YAj0NoTK1VjFe/uAyQNARJ598Or+EfmyGsHIwyr1jsGr8xHeJqDQUK4gUzAETOUVKlRZr8/AKZrMhLND9YMaPPz81OYD+IOjiE0UlgesA+xKUGkQiMndFx4JT82mpxsUxpADHBZQAMMIWCWwwSFFw+s7nglnByUCMfGhL60Xore7f4Qbs37Vja5JwSJGyYOuds2+WzzaZt0YW3XLF7M9u+602e2bbnFb6s+/D17b0jrC6qMs29UXrxIf4tUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6738",
    Length: "25",
    Mark: "375",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "64",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2968",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529145",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.11944872",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TssKgkAU/Ze7ngYdxzBbRQVBLSSCFuJCadAL09yYpkDEf++C1h+0Oy/OOeUARYOX/mEghyM1WJDtW3IgoCB04Ql5OUyQA1kik1in60WspVplGYziP2b1nd94X/f8gYUd1ncTjIc8kpGAk3Ft6GZyplAH5NsTveLtZx0Mth2vxHKptYC9Ne85qiKplU4FbMkS17qXtWP1AQGAftASAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiVGjdY+jW0w2B7KNthD6YOloQ04M1w2KMX/vqzazlRvnogoJl/uu+9yl9PVkSw36vXwIUlKHvVGvehcbQklS60K80nS1bF+tTBb2ItU9G9m5jO2OD3sTar12eymLLODtU0CLxBC0JkfenyeJJRzj4lE0F/AD6MTEERs7gCRH9ZAEAkHAKnOFlzwXhc8FHEbsOvCkaJA34PxoZ0Pq+pQxXHcF/hlvrOFUHywbzcbzAu5pehStQB3R3os6jBagJM/DNOgi2tRV/EhAFgt5NzNBoJpgqhOfG7GQbXQoYGSgViPPBmIdIM7DtU/kmlCp4BzN3T0/vcwXDXgPLJoIEmjDcZ3LrAsER0KS4UpfbBDgV0QSTWl08KqwO8eCCCpMACy1WI+DEiLGrD/DHcqe5dGliRlHqPkSRY7s28Gz9pkRumiGb6p7QV6kGq3N83gPpff7YW3OteWsPjK82r9AzVs2jzlCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6225",
    Length: "501",
    Mark: "376",
    Material: "Copper",
    "Middle Elevation": "2927",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "319.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "64",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2927",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2927",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529146",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.5066404",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdld1U0O0UFQR0kgg7iwWjRgW0nbAtE/O9tqB0i6DZvvsd7L+8gO+OxvWlIYUdnzMi0FVlgkBFad4c074bTG5KAB7FMFjMZciWjCHr2CwY8DoX8hiqK1T84xRZT/bJpytZv8I81llftdAOp4ILBXtvK1aM4kCsd+tmDPOHlg7Yaq9q9hRShYrAx+jl6leAqmUsGKzLkc+3DmL54ATTMNa8TAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVl1rwjAU/S95jiVp0g/1aWyDwfYg22AP4oNi0UDXDNcNRPrfF2z9aJNj2iEVk+M5N+fm5qbzA5mt1Pv+KyMT8qxX6k3nak0omWlVlN9kMj/UPw3MpuZDKnqZGXHGpscv85BqcaLd7XbLveGmIhBcRnTEZRDyKKIhC8J0zKkBwjiULUBIHh6BJEnaAJOS3pISEZduRhzHzhgQgKsa7gMH70qJsRC3AShlOU9Sdw6b+d72TqEbJREkkvHr3DZSV0Bb6gKct6l24WDULuwYWAoBeFUweFeqk3SbgWNYPuqs/yM2AmBse59asWHp2ARQUh5zsP4HpMmTDce5uK0ECbY5z5F0bAQ6YWDeJ2R5gPOwAjwNFSn16cA+gqcq7c6Mgf4F3pYa3j0cvdwjBRlDLiu4KniLQcAj5fABAXhY+/cP76Xr8mHeGR7U8jMrsx2ZsIBR8pIVm3LbDF51uSyVLprhh1qfoadMbbZlM3jMs9/rP97rXBvB4ifPq8UfXBhoDOUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6186",
    Length: "145",
    Mark: "377",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "92.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "64",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529152",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.70649311",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GvrTNrqKCoC5Egi7EC62hg7WFrUDE/97QujvP4TmccoS8MZfhqSGDk29MoW+hdq3VgCD3xoUXZOW4xKhIjoWifLOiAjMlJUzV39v2fT1EORZ7Uz900D1kBBMEZ+3a0M1AOYLChzoY7yDjmAqaKJYmPJFqrThFcDX3xaVUpAiO2rRdmJkIhuBg9ee3ZgwTpSSCnbc+frm3tVP1BVmVtk/SAAAA",
    Pbi3DGeometry:
      "6xAAAB+LCAAAAAAABADtVstqwkAU/ZdZxzCPmEx0VdpCoV1IW+hCXCgGHUiTYtOCiP/e1I6peZzOjLjoIgSDc0/mvubOuXe6I5OFet6+JWRE7vOFespTtSQemeQqK97JaLr7+VvCdFw+ZO/9SgaM0vHhVf7IfnbcdrXZzLflXin8IJLCG7DAF2IYepz7TMrIOwV4LOU3wGlQk4shjQ8bhiyubwjCqBOoTJSInSpsAzgFbWNAa6JxLO285SHvliNN5zvVCk+bPp5RzLSvgazpqeRC6BgiVgN4GHTLK8OMdWuSoZ1pZAG7pE0zyiM7X4M4/NN001UcnCGGliIgt80FOmboKDp/U13AiF0ja+UaljDSZK55FBu0AH1CF7Qhty4k19tTlTCkBtvKaHOJLfkYfcJs3ASMNxTeaQw0bgokfKjJ3Dusu43RKdQaW4A1H7eYAwGYCgB3tDQZ+ziMzphZmA/r1mguQmPOz+/w1oxjtn2xkcB5DHOmfvdZ4WIzwQV7v/NM4NwJ4QbnbmHMXz8X9HNBPxf0c8G/nQtmHrlR89ekSDZkRH3qkYckWxVrvXjMi3mh8kwvX9Sygu4StVoXenGbJp+nH17naV4qzD7SdD/7Auj2gSbrEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "886",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529153",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.78523221",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomqSmdSUqCLooRXBRumj10gZiIjUKpfTfjS9wN2c4w5Qj5I0+DFeEDHau0QWefG1bg0Agd9r6G2Tl+IlBUZxyJuRixgSNU6Vgqn7esu/rIcihWOv6gh57yCIaEdijbX33AiYTTqBwvvbaWcg4ZYLJNE4klyqdp5wROOrzv7xF3Xb+zUIqAhuDj+86jmmUqITAyhkXzuzdmKl6AoIELVvTAAAA",
    Pbi3DGeometry:
      "ax8AAB+LCAAAAAAABADtV01r20AQ/S97VszOfmqdU2kLhfYQ2kIPwQeHiESgWsVVCyH4v1e1Vq137aeVcgssISHWeGbevHk7q7l9Zjd39denHxVbs4/tXf2lbep7VrCbtt51P9n69nn4tzfz6/6HHYr/T66I8+vjn/6XHTaj25v9fvvU+5ZyJZ11xRWplVSyEGJFzlBx+lxIMxg0udCglbnsAQ2uLP8aBClVzMo9RuLWzgM1RprvYGhZJOiQxBRXB7F6mnjp1CQdwnJ5Gomb0gTPR4fRIEnpAOuZRxxJixDSizNIXdppj5HYM48IU9ohToGqw2AXp5DWXiQKFlFKipot5aQ6XhwIygkqfK7yhbahgbiYNizuNaIVVo0CoeeoaFiCNiI87opHxzceWlAz6VDJ2Xs2O6AhVgFkEBpSEl8wC1DhmCpkgIXDMvhoUN5DiiO5wnm0xh0dyNCQos/hU5A4Gqx100MQpxDKG7QKJlRJYZtIcDkFCucWKorklLuohLNbGN/bHi1ZNd0+xBQWdPoIRLkRtfhqg5wjCqEQYFthJHR9Lm43cpjR7qirsDoYCVIOmwcPPupqWjixNmFuiBYeY0QIzJ1GGx+xZJfgO6IWFMjf+DcZPUDqQU/f0dwqn0DoweAGGRgaCJSCu1kvS/BGxLkvgxVuTK0pmpvAAUFC7GEpIzZQBsQ3CgQd4JsPohXODtg4PFQQ3xAULDslv1iuiG84zyCxy3sK+UAMQj1BUKjuvFTnpTov1Xmpzkt1UHReqvNSnZfqvFSfCiEv1Xmpnoc2L9UTYPNSPYfWvFS/zqV6U7B39fZ71VV7tuYrXrBP1e6he/QfPrfdtqvbnf/4rb7/Z/pQ1Q+Pnf/wvql+n37xbdu0fcDdr6Y5bP4AvDN2BmsfAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "887",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529155",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.15785782",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNo0jaPuhIVBF2UIrgoXUQNbSAmUqNQSv/d+AJ3c4YzTD1CeTT74aqhgK0/mkqfgnKt1YCg9MaFGxT1+IlRESlOSZbPZyTDVAoBU/PzFn2vhijHYmXURQfdQ5HgBMFOuzZ0LyA5SxFUPqhgvIOC4JwnXLKUMi4zIRlDcDDnf3mjTduFN2e5QLC2+vFd0wRTLjiCpbc+nrm7tVPzBDJhVpvTAAAA",
    Pbi3DGeometry:
      "Lx8AAB+LCAAAAAAABADtV01r3DAQ/S86O4u+LMmbU2kKhfYQ2kIPYQ8bYhKDsy5btxDC/vc6lr2uZT9J21tBLNmNZzwzb96MPubuldzeV99efpRkSz4199XXpq4eSEZum+rQ/iTbu1f7b6em192HnLJJcsUove6/uj9y2o1m747H/Utna8RG5EZnV0xuhBQZpxvJZZ51cp7zXswLY2ZyTcXq+0AuWPfbyxWbK1Dg0RHPpYpBdHYUbaD1ZY6QQRCRywUMMJLEhYojY3LF8vxNwQs9N3DkI9RBLCTjPj8TolGuzT8FWLwvTC5npIYQhQxwBMQR4uLiAC5Jkgrtz2EqNOXWojD+1rjcFWqmiBiRjX+W55r1mHIuo+TRtYbMhgkMdcFSgbJ2sjj3jdHKOuKFf8dCjQM9hTZdHCF2R4lpG6RwahFOz11IQQJdR2EFznueBVdUWoUuem4FHxQmHw4oamwMzmx6ShVWwaW1UGod1bivwBCKOYSwgs3RqqHV3jB4QYHY0zEruxf7pmXKe/7Cg3wEKzgtVk87t3qQJ9TN0BGKDIlFjYYIh6XDTYBChwrhHpyX1xpawGLDmgZDLDwFKUdbFyrFsqih5YVupIu2gcsORQiursWaAJ7w7RauR3Q3VLpY5UloNhxHWtjYQgRusQPh1NIkLNIO8rwvjS68N8DQWb64EwCcSktnLQ6BkQEChJjzUL3KBEwY4ll1E6oLul26fMINA1YM7guYaoQJ5QBrCZoUcASRBt6PLSX0H+z25Wi2GsCTcBqb09icxuY0NqexOY3NXkUam9PYnMbmNDZ7t640NocGgDQ2p7E5jc3/79i8y8hNtX8u2/JItnRDM/K5PDy2T8PDl6bdt1VzGB6/Vw9n1ceyenxqh4cPdfn77xffN3XTOTz8quvT7g8YPwsELx8AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "889",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529157",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.81703396",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjj0LwjAURf/Lm2NI0vTTSVQQdCgiOJQOLYY0EBOpUSil/91Ia0Fc3N5953I5RQ95rU7dTUAGe1ur3OpOWgMIcquMu0NW9OPpC5RRnEScLheUY8ZpCAP6pnESxH/QIIzoD52XR1p+FFZtW3Xewz82qroKJ1rICCYIDsJI10zhaF3llFcf41ldZrQTSjbuHSjhDMFWi+fUZQyTNE0QrK22ftc8tB7KF34sswgXAQAA",
    Pbi3DGeometry:
      "KQkAAB+LCAAAAAAABAClVl1rgzAU/S95TiWJX9E+jW0w2B7KNthD6UNLQxtwZrhsUIr/fVnn6ma8JlpEMR7PuTc3N0eXR7TYyOfDm0A5ulcb+aQKuUUYLZQs9TvKl8efWwOTuTlQjdsnM0rI/HQxJ6pXv7SrqlofDJcyGvAkYnhGo4AlDDMWUM5T/B/IOP9GSJZx3EuhMfUFoiQ9ITHN+il2eFdejES+CYdhnPSLhTHJ+hM7c6zJwGoDJYOShsOMmE7Kw7R3AVqgK2ZRQC0b6C7mReE7hXGHtyrWIt3FtDn2ZMD4YMqwmDvMgJpdNGed7QaE99kEMV8ALCbY/h6M8W0JxXDvV/98B5zEH4EbFvYlH86EvvTYMrb/Tcna7aZuBN5NsGl6cAYMxT8D0ANHfBzGiPkCsJv4WIPzs22HaQHz33Ej169CiwrlJCAYPYhyp/fN4FHptZaqbIYvcnuG7oTc7XUzuC3E598Xr1WhjGD5URT16guFx148KQkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6738",
    Length: "25",
    Mark: "378",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2968",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529158",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.20352285",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzEkIWqNJ1FB0EMRwUPpocXQLsSsxCiU0n830OofeNvZGWZe0UNe46V7WDBwpBpzcl1DHhjkhD4+wRT9eKaAVJIvhdDrmdRcrbIMBvY3t/wibEKousSRHjus7jbaAEZwweBkfRPbSZwpVhET+iivePtZB4tNm2YkX2jNYO/se4oqwbXScwZbcpRq/cu5ofwA6GUE2hYBAAA=",
    Pbi3DGeometry:
      "OQkAAB+LCAAAAAAABAClVl1rgzAU/S95TiXGGK19KttgsD2UbbCH0oeWhjbgzHDZoBT/+6Tazkyv3lZEMZ7ck3NzP+LySBYb/Xb4VCQhT2ajX02qt4SShdGZ/SLJ8li9ljCblRcp6N+Xic/Y7PQob1KszmbzPF8fSluf+14UckEnvvD4NI4p5x6TsaQnhLEKCUI2dZEg4hUShNJFYLazDZe8exkuZOQgUsTB1dJgAcOOXqEAoa3NJoOwcwsuQHs/QUd7BLjRYZ7gIuxiayLu5nTZVO40ESeiOLLhZVrS/jmKQnpEgwrc6KDIRklrO+pmASwarCowOCgLbOWgUgAOAFgeWLJxTaUnmoPlObAKJplgAJtLoLAbTG5pdXDGojoamg1XGXBHgzsnlm1kh+7RBp+fMIJlwyHYFo07V7A2FVL+h9zr9YeyKicJ8xglzyrb2X09eDF2bbXJ6uG73l6gR6V3e1sPHlL105x4Z1JTEmbfaVqsfgFrTo/1OQkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6225",
    Length: "501",
    Mark: "379",
    Material: "Copper",
    "Middle Elevation": "2927",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "319.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2927",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2927",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529159",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.38815502",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjlELgjAUhf/LfV5jd04re4oKgnqQCHoQHxSHDtYWtgIR/3sLNYheervnfofDl3aQFOrc3iTEcLCFSqxuK2uAQGKVcXeI0244fQE50gjnqxkKygWG0JNviIIFf9AgjPCHTsMDzCaBddPkrbfwj63Kr9LJBmJGGYGjNJWrx3CyLnfKiw/xosoP2ktV1e4dkAlOYKflc+xyRvliiQQ2Vlu/ax5a99kL3Sl2exUBAAA=",
    Pbi3DGeometry:
      "8QgAAB+LCAAAAAAABAClVl1LwzAU/S95zkq+1q89iQqCPgwVfBh72FjYArWRGoUx+t+Ns66a9C6pUlqae3POPbnNvenigOZr9bh/kahEt3qtHnSlNgijuVa1eUXl4vD1at1kZi/U4t4yoYTMjg97o3b5DbtomtXeYimjSUozPKEiYSnDjCQ8y/Evc5Hnn3aWFxQPzSdCxNlFmh0dgrJBgBv4vB5ecB4nlPNpOsTEp6QYFHQCuEuAmOAcQWLBENGroILwwXz3DpfKg0BUnt39dP8K7uYkGN5LVu9xP6GP8dYChwclg2TBKGe4gvUB5QUokOB0mD82MpxEcMMHVYFMkfPDmsD6H79Fxm8EuMlEb934fhUCRKgKtr6/1KCPAT3BVjqmooK9NIiI0BV5DI5oyz4EdIBnanTHjj6eLcD+P1yp1bM0skElSQhGd7Leml03uNdmZZSuu+GT2pxcN1Jtd6YbXFfy/efES11pS1i/VVW7/ACqeRwY8QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6186",
    Length: "145",
    Mark: "380",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "92.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529160",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.68328599",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzFk01abehIVBD0UETyUHloMbSAmUqNQSv/dSFsPInjb2TfMTNZBWqpTe5OQwN6WKrW6rawBAqlVxt0hybrh9AbkSBHDYDnDkHKMIujJTxrQRRB/QUaFEPN/cMrNpwGrpilav8I/Nqq4SicbSBhlBA7SVK4exdG6wik/fJBndfmgnVRV7d4CWcgJbLV8jl7fy2OBBNZWW59rHlr3+QuWoMNCFQEAAA==",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACVVl1rgzAU/S95TiUxih99GttgsD2UbbCH0gdLpQ04M5wblOJ/X6hWp+ZEpbSYe3LPved6c9PthWz28v38lZKYPKu9fFOZPBBKNkrm5TeJt5f6UcNsrT+kop1lxRlbX3/0l1S7m9tdUSRn7ctd7jA/oCvuOS73feoyxw0jTq8A86IeIjzu1ojLeB9hnkftZJEIzS6cgSgQsCS2XAuOMuASkRB2AFONxAchKOQNmC2xS6vmEk6gg/XeSc3VAX2q1t4Wq9Zh2F/LMEQARNCOMoKR+0SDihv2Q8lDCU29lwaGdhh4+HZ6gXHPjBxwL1mlwc6fXyN7LUwdaSXCDgZt9rNoyAkeLAjYmcYikB12wNQ4RVSzBvC0y0RnmoY5Rma3+YBr6ewwjXI7E/ZYdF2hrOA1ZkHsXAYhCEAndv4Qmbx0jTL0/4YHmXymZVqQmDmMkpc0P5anZvGqyqSUKm+WH/LQQk+pPJ7KZvGYpb//N96rTGnC/CfLqt0fMFHqaekIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6186",
    Length: "146",
    Mark: "381",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "92.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529161",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.77188919",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjk8LgkAUxL/LO2/L/rF07RQVBHWQCDqIB8VFF7bdsC0Q8bu3pRWeur15v2Fm0g6SQp3aq4QY9rZQidVtZQ0gSKwy7gZx2g2nN1BGsAj5YjmjHM9FGECPfjTimAsh/sOQsgmbxL5h9qlfNU3e+g3+sVH5RTrZQEwwQXCQpnL1KI7W5U752YM8q/KLdlJVtXsJSgKGYKvlY/T6WhYJimBttfW55q51nz0BI6HNdBMBAAA=",
    Pbi3DGeometry:
      "BwkAAB+LCAAAAAAABAClVtFqgzAU/Zc8p5IYq8Y+jW0w2B7KNthD6YOloQ04M1w2KMV/X9bZTatXbxiimBzPucdr7o2rI1lu9PPhTZGM3JuNfjKF3hJKlkaX9p1kq+PPrYPZwh2kpn8zM87Y4nRxJ6nXZ9pVVeUHx+UhC2QiYjrjIoh5IqmbEElKu8A8Sr6BMJWcDlNYFKERFsYnJOIhwOkZmHImpBBoz5LPB8USFqeAsTOl/zKQ2Eh82DMcBvU2qXCiUvbz3wHaUoMMSOlyvv0d/xm6nRJU7Ham2kDnGw4yLpXA0KBZSGkiAiw0XiJQPsAKwRHAEJjYYAbhlY5zBWuhKEhfYNF6LxLPtQC3GNTC9W1XoxScL0Tr86/BXmMAgcku6lNV0010nIN0htsT/XpyjwEC8O6K6te+W7XjuL+KG52/KqsqkrGAUfKgyp3dN4NHY3OrTdkMX/T2F7pTere3zeC2UJ/tB69NYZxg+VEU9foLu5+5lgcJAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6186",
    Length: "11452",
    Mark: "382",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7303.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "84",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529167",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.29674048",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPITV9JXYkKgi5KEVyULqqGNhATqVEopf9uaHU3ZzjDVCMUV30engpyOLqrLtXNN7Y1CggUTlv/grwalxgU5EhFlvH1CmPKpRAw1X9x0/fNEOxQ7HTzUF71kDPKCJyUbX03A0YESucbr52FPKIYYyJ5mkSJkJmMkMBF3xcXMU4JHJRuOz8zizmBvVGf35pzyqQUBLbOuPBl38ZM9Rd43xyz0wAAAA==",
    Pbi3DGeometry:
      "kxEAAB+LCAAAAAAABADtVl1rwjAU/S95jiVJ0zbVp7ENBtuDbIM9iA+KRQNdM1w3EPG/r3NZXY03SatPo0jF9Jh7z03ux5ls0XgunzdvGRqiezWXTyqXC4TRWMmifEfDyfbnZwWTUfVBO3x4M6CEjPZf1YN2099tV+v1bFPtpYwGIuYMDygPwjCKMWMBFSLBDYSlQnwjjPAmEEYk3W+JaHq0hcfJaaR2U0G+1ix+IGowAQuijZE0Fb6kWcwAADR2DjUzTu2/vrQk0ZS5aJqqgTDUsSS0ibCYA0DtnVLAmIh9/YNeLMS0f0pY4kuZp7Hdv8HYEqUrFtMWBPgfC3j1MF8wKZzZAsfePkTz6OH8Bo15lAQYJOwFZgaW8THgn2Dt6+uQ33AX8c6XE43Hv1e5mVn6uIG46xiufQtyXErwuICNeQyfFgPLTQ0csibi38nNLgMilqYB9RnTmFsYwGG6zxk+mhZD1iM9Pa7gHM3Qoj95ELikzOig9DoMji4C5JI647JyooPO6DBS4S0dpo37MHut0WuNXmv0WuPfaI0pRjdy9pqV2RoNSUAwesiKZbnSi0dVzkqpCr18kYsausvkclXqxW2eff7947XKVWWw+Mjz3fQLSL9YFJMRAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "894",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529168",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.02916941",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPIo2mTuhIVBF2UIrgoXUQNbSAmUqNQSv/d+gJ3c4YzTDVAcbT7/mogh2042tKcovaNM4CgCNbHG+TV8ImTQhnFGSHJfEYTzJSUMNY/cdF1up/sqVhZfTHRdJATTBDsjG9i+wIqUo6gDFFHGzzkHNOECsVSwYVUmeIUwcGe/+WNsU0b35wIiWDtzOO7ZgyTVKYIlsGF6czfnRvrJ7zAWo3UAAAA",
    Pbi3DGeometry:
      "nSAAAB+LCAAAAAAABADtV01r20AQ/S97VszOfmqdU2gLhfYQ2kIPwQeHiESgWsVVCyH4v1e1V2mk5e3KCrktxsby88y8fTM7u3PzxK5v62+PPyu2Zp/a2/pr29R3rGDXbb3rfrH1zdPpaw/zy/7FDsX/Xy6I88vjR/9mh81gdrXfbx97WxK0sqW0xQWplVSyEGJFzlAxAoQ0J0STmyBaGWCDEVeW/xBBShUzCQzOuLVzqQ3OzjExdK4zbJJmFiwTU/aS8dKphDJGG/HSGTelGQODyTNiOVcjyqFN4ExaN2b2mjBWKZ2wGXQObabUZpgEYeA6I5wXhLFGANXwaszEopQyUTTLXeEyw/U/f2MQ6TFCXKSQBenHGsP1Q18QgMvHS1Fi3BYUn27yoMnhQko7S7fssMtgJCgMqCUGkrV/VsdAAkQ0gwgWAK3GlKVHlDeRwnmElyfEuKMNGfJhhDY+DIkjYq1L9MxInJ61R7Qa2xg7zhoJLhPcIl2bBpvBm1PTioIHeuQS4FmTVYmEQtUitZ7eHpPwWOfI4YgzEMknzADONPaGT+ElNQBt5tTANNORfQC9RbIAM4pbBCy1GRUV1C2KH6GMtzuWBhOYQTrYhum04auoFjTaIE74G5I+Eeu5Jw584+RwqRL6hDhfG8qbCO5m3sPwuRqJDygPdS41TfYTtIC8oJC4yLEs8LYNeWFfMF/4SgU1jvQZmEncgJD6mFlk/cmqDOoYKoYZQ5tFWcZxkJiwyiLMkAB52s/Tfp7287Sfp/087edpfyxAnvbztJ+n/Tzt52k/T/uzLgJ52s/T/uI4bzztbwr2vt7+qLpqz9Z8xQv2udrddw/+4Uvbbbu63fnH7/XdM/Sxqu8fOv/woan+vPzju7Zpe4e7301z2PwFILPinJ0gAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "895",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529170",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.06916833",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNI0jaPuhIVBF2UIrgoXUQNbSAmUqNQSv/d+gJ3c4YzTDVAcbT7/mogh2042tKcovaNM4CgCNbHG+TV8ImTQhnFgpB0PqMpZkpKGOufuOg63U/2VKysvphoOsgJJgh2xjexfQHNeIKgDFFHGzzkFGeCCMUTxoVKpeIcwcGe/+WNsU0b35xmEsHamcd3zQhmQgoEy+DCdObvzo31EwylIU3UAAAA",
    Pbi3DGeometry:
      "JyAAAB+LCAAAAAAABADtV0uL2zAQ/i86e4P1lrOn0hYK7WFpCz0sOWRZs2tw45K6hWXJf6/WlrOVlU9y0lNBhIR4xvP6ZkajuX0mN3fN16cfNVmTj91d86Vrm3tSkJuu2fU/yfr2efxr2eW1/ZBD8Uq5omV5PfzYLzlsJrE3+/32ycpSRldaCFlcUbFiUqiClSvBLGHglKUYOFxR7nMmGS6WMhSrRiuVMadFAvtKKnZaGXTsKHJOMBOHcXW2tkBmAWg40JDDNYANgqOo9nSxSnt0935Adu5yQdkiPZNHTJt/M+De50YK34CDFnq0XAKaQBhBMM62MOWt5DoRBKdmJlKZVHlcoCxdUWfUZ6x3zAwyyUSKc3nmA5gxAEldASMCDAzFVMwvJWMPwEWNG5QSVLXgHAyMQAaui0gtJUFG5Y/6Jew8DGRK1ZyOQ4dhGOoAltboizLmOJqOdHv6jXQ6xqeZchLC/nnhKHXSreORA00cBSSjA4NWdGQo46PLSyOjXgHbWnDuK5JULR3XwVBmTHr+vuKLCxiiFSntiDbsQRJkOJ0C9AGWCPq06dPzMpyv56cdS+DMw/yiioeqIqGnm3qeD5zcSBGhWCL2ccdjMxAZ2CpQVaTvkhkLp/OEmSUIHwAt3dwWdBx2VnvqYqsnM3LsCD6bm1rpoWCN9nMZ3LLg1IxcJ5DDRyNuaNPJeFJg5lUERgx9EpN56Bh3pCkZR3BZSt+v0NU9TCE8QSDu0C0YCMQEli9GC594SOSS7KZRmQMZ27KRYzj8vLLnlT2v7AvByCv74t7JK/vpS2Fe2SP9klf2vLInSjuv7Hll9wsvr+xgOueVPa/seWWPi/xfK/umIO+a7fe6r/dkXa7Kgnyqdw/9o3v43PXbvul27vFbc39kfaibh8fePbxv699/v/i2azurcPerbQ+bP/usW+onIAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "897",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529172",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.18454228",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPIo+nLlagg6KIUwUXpIuqlDcREahRK6b9bX+BuznCGqQYojmbfXxFy2PqjKfEUtGssAoHCGxdukFfDJ04KF5wylcxnPKIiS1MY65+36DrdT/JUrIy+YMAOckYZgR26JrQv4CqWBEofdDDeQS4pj7jKRKykSrMkk5zAwZz/5Q2apg1vForA2uLjOxaMiiRNCCy99dOXu1s71k9ojNCe0gAAAA==",
    Pbi3DGeometry:
      "jyAAAB+LCAAAAAAABADtV01r20AQ/S97VsR+Sdp1TiEtFNpDaAs9BB8cIhKBahVXLYTg/17V2rUiad9q5VwXY2N5/GbevJn9mPtXcvdQfX/5VZIN+dw8VN+aunokCblrqn37m2zuX/uvnZledy9yTIZfrhil16eP7k2OWwu7ORx2Lx2WcZYySUVyxWQqpEg4TbkuktHvXCv139A9TywGIVQmQw056y2ScSdkHj2TudsX5mUxK1KxFl6otc4ckCXFYJZzg8iBYDNhKOOqt7Ase+tsZhggWTEynAkDXzTVWmZjX5bYBVFYhwmDDBpPIeckgxEBgkFZ1gdhTAPBYCqMZ7kpPuX+4p8h7/G12GIr2nW6JmiumIEULNSyuvgekXH+0Bk0oPQ9qWhlwqsi929WQ8fghg3wtrgpOjZSbJm1BpYTW8JXQMDGhCXASxBbsAQwHSqtpdAnqYW2pEUh+12eqj5OQQ1G8Z6B4LLHqK5MC7umJ47UY4zu2J8sXJp88r4RB9aYG2aQW4xkBTi1l85zxxWAUz0mDUuKZcP9HrBG5gyw1LAPcQ2wnrgGmADw5j2JL+kCjAnogkmtPWGgM48EuD/gxQKXermlZtng+JgzXvBQG0wggPN0HYZXbXa6Wc26dLVJU5keLER/uitwFR/OPamVydKelFlvoCIfdy3TbOE2Bk9XX3xAmYpJfK6sBUIQMaSkr8mRLDB5yAq6ggh0rUICe/cYXEfP7gO1h9Rw+ks96WhjpBhmDCEXlBhHgVrCDkNBcPZxzHduFHHMd/iKY34c89etiTjmxzE/jvlxzI9jfhzzF67HccyPY77zNhbHfBerOOb7ezKO+Tb7bUI+VLufZVseyIamNCFfyv1T+2wevjbtrq2avXn8UT2eTZ/K6um5NQ8f6/Lv2z/eNnXTOdz/qevj9h8IOzO1jyAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "899",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529173",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.38594998",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNI0iZp60pUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6uGArb+aCp9Csq1VgOC0hsXblDU4ydGhTKKCZfzGU2w4KmEqfl5i75XQ5RjsTLqooPuoSCYINhp14buBZSLBEHlgwrGOygo5pLIXCRMyDzNciEQHMz5X95o03bhzYwjWFv9+I4ZwUxmEsHSWx+/3N3aqXkCP4kx9NIAAAA=",
    Pbi3DGeometry:
      "MSAAAB+LCAAAAAAABADtV11r2zAU/S96do2+bEnp09gGg+2hbIM9lDyk1LQGLx6ZNygl/31erCaW7SPJK3sTISHW9f069+hK9/aZ3NzVX59+VGRDPrZ39Ze2qe9JRm7aet/9JJvb5+FvL6bX/Yccs8vKFaP0+vTTf8lx+6L25nDYPfW6jLOcUcazKyZyJXTGaS50IbO/Alqo8TpXWmVLCtwE1pkpHAeyf8/vmXG9ZAlFNH0/mMJkXVKxztBFIRIjmJoV0NwYuYzSMhi9ghLlab1ktHBNTSVzlUKqUbxRxgrD+SiwV7ox2nhVLMILKgtpBnXWYIZjXu9GMYUwm2WjtRx0uBBeAizEHGtsBc1CjPVtokIMYZWFiZK8sv5zlHH6EWxyJV5kYKKy0NZYKb2tas5Mh0teU5Hd8GwJuV6mhBfGMMBh6ofaBc49ytgUR5Q93nfCOpeDgGvFBkFZWh+iYCcVxq2KtoRQxjrvo/H0SuhkrCF4aSVmUOEvtHMaMo7L5970gVoKM/dwjj21z6aUYc76OV7M4GW4PNTGpqD3MMC447vQ+3DElAj7R8fn5MT9h8r7VHDlUYGxE2gL76GIrT1rB7DGiEcwFcwjGDDkKoQFeofhoj0XX6zL4TQBSxhp4xXcZlgOVyCjA+d5KZnVUPbSJKfbgbKhd5Y9ar6LlvfQRP6XA3b2qXVvZKzGNCyMI+Z2BC6z7CH4wFhUMu6dKeqe5bnNu7WELQTi740M5g8FkMcYMdwmocrqKkfhMoUSswx7QfmnuT3N7WluT3N7mtvT3J7m9jS3p7k9ze1pbk9ze5rbQ9xOc3ua2/24/Ke5fZuRd/Xue9VVB7KhOc3Ip2r/0D3ah89tt+vqdm8fv9X3Z9GHqn547OzD+6b6PX7xbdu0vcH9r6Y5bv8AqaA0jjEgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "900",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529174",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.94270691",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzF0Y2t/PIkKgh6KCB5KDy2GNhCzUqNQSt/dYGsRL9529htmJusgLdWpvUlIYE+lSkm3FRlgkJIy9g5J1g2nMyAXXozLGfrcn0c+9OyboQiivyxA/GVT5sDyT/WqaYrW9bvHRhVXaWUDicc9BgdpKluP4ki2sMpNHuRZXSa0k6qq7VssRMBgq+Vz9ArkYRwKBmvS5HLNQ+s+fwEsu26ADwEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVUtrwzAM/i8+u8F27bx6GttgsB3KNtih9NDS0BqyeGTeoJT893ltujyFnBESos/yp4cleXUiy61+PX5kJCWPZqtfTK53hJKl0YX9JOnqdPl1y2zhHlLRBplxxhbnj3tJtb5uuynLzdHt5YFgCaczLgMp5yEVPIhFLGkbj2Tyi0dJJDq4EvFZn4Vz6sNz1VdMjfHHKonauGIhn+QPZBeJy9cu5k+fRzpxLNwa7mcNiKpnlQsVj2W/wbs8Dd7NwkC/9n7If3Ef50H4+/5AcYHxQn5CdjvZR2n+684gzZ3Txb2EesKvlnEePxxKD1TjuD7E72cXOEW85SbS+MBQKaAdCs4LoDK9rAKFNnV4YTReMNQM0EzD9QF6L6vQZMTvjak8fjjU+3gvY/dnn7+Fu/v9Tm/eM5uVJGUBo+QpK/b2UAvPxm6sNkUtvund39JDpvcHWwv3efbdVrw1uXGExVeeV+sfLNrzdJEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2844",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2853",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6645",
    Length: "25",
    Mark: "383",
    Material: "Copper",
    "Middle Elevation": "2853",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "86",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2853",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2863",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529175",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.98968477",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xjSJrRYV1IFQRdBBBelixZDOhAzUqNQSu9uoNUbuPtfzDfVCLrFy/AwUMCRWtTkBkseGGhCH55QVOMs4yDhIpNys0oUV7law8T+0NVf9LbvmyHyY7DD5m6C6aEQXDA4GW9Dt5gzhSZgfHm2V7z9qoNB20VIwmWWpgz2zryXbSq4EjJnUJKjeNe/nJvqD8W93EUPAQAA",
    Pbi3DGeometry:
      "hAgAAB+LCAAAAAAABACdlVFrgzAQx79Lnq0kGrXap7ENBttD2QZ7KH2wNLQBZ4bLBqX43ReqU2O9XRyimJ/nP/+Ld3FzJuudfD19CJKRR7WTL6qQe+KRtZKl/iTZ5tzcmsd0ZQ5Sez1ZMEpXl4s5Sb39fe2mqvKTeZf5NOWRt2Dc5wlPvYD5SRylnuFxGF54RGM25MuIN/FpMsSQTBceBcspec7DeMjDYJYbaFosK8dpETdjFc6CyWQ7bq8ZlJTTrNTnNEyuc+25LX/Nxzr2p8L1IW5ViLudMbcWrcfW4kxEj8xDyQIyAIZUIO9u3QAtPR7vVvb4p8XyGhe4m87/ux/ygzbWn/p4lUDcpUogNzPD5+1FQJugW46LCIrdOhnwMjMc3y0hN8CPCsBOKih22yoBMzPDG2x+6XcyfxdaVCSjPvXIkygP+tgOnpXOtVRlO3yT++7Rg5CHo24H94X4HgbeqkIZwfKrKOrtD1EczIqECAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6219",
    Length: "415",
    Mark: "384",
    Material: "Copper",
    "Middle Elevation": "2834",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3939.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "86",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2834",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2834",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529176",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.56367949",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaW1tPYkKgh6CCB5KDy2GdiEmUqNQSv/dYFsvCt529g0zk3UgSzy1NwUp7G2J0uq2sgYISIvG3SHNuuH0Bk6ZiBbLGQ9oHMQh9OQHC2nIxRdLkn9sysyn6lXTFK3v948NFlflVAMpo4zAQZnK1aM4Wlc49JMHecbLB+0UVrV7i0jMCWy1eo5ewWjACayttj7VPLTu8xdP4NgYDQEAAA==",
    Pbi3DGeometry:
      "eQgAAB+LCAAAAAAABACVlVFPgzAQx79LnxlpKYhjT0ZNTPRhURMflj2wrNmaIDVYTZaF725xqJTjbjXLxvrn+uu/Pe5YHdlyo58Pb4oV7N5s9JOp9JZFbGl0bd9ZsTqe/rrbfOE+rI3+lJngfPH9476sXf9Mu2qa8uDmiphfSBnNhIxzmadRwmOZJ1nkdJn4ciqSTu4unt7NJzCXWToZP0+zST7gCMIMtiim/2/RaRVjgI2KuZg8sF4P3dIAksbu6p2iHMkeZKB7+4fxJ+8Qj3EwPdSOwFXMIrYksN4fbzCH8IJsBySDziiWO6ySyFxDfKjJoJTCkqE5WHx4f6DzCjmYHvx8eByoY88NXfYYJ6BNnImnSxa2FUwPLn2PA3WqfsZdi2ZMR0PnVHMe+8CaLaZTFOibLHx4tKH9IKR9+Nbde/xGl6/KqoYVPOYRe1D1zu77waOxpdWm7ocvevt7607p3d72g9tKfQ4Dr01lHLD+qKp2/QWLk8Q2eQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "206",
    Mark: "385",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "86",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529179",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.91273255",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImqQ1dSUqCLooRXBRumj10gZiIjUKpfTfrS9wN2c4wxQDZLU59FeEFHa+NjmeQuUai0Ag88aFG6TF8ImTwimLhVjMuKQykRrG8qctu67qJ3cq1qa6YMAOUkYZgT26JrQv4FzGBHIfqmC8g1RQLrnSUayEmutEC07gaM7/8hZN04Y3MxkR2Fh8fNcRp0msNIGVt346c3drx/IJjBjzudIAAAA=",
    Pbi3DGeometry:
      "mxwAAB+LCAAAAAAABADtV11L40AU/S/zHMtM5iupT6LCwu6DrIIP0oeKQQOxkW52QaT/fUM6qZ3rnE7i8yCKub0999zv3IcPdvNY372/VWzJfraP9W3b1E8sYzdtven+sOXDx/7f/mN+3v+wXfYpOROcnw9/+l+2W41fu9hu1+/9d8VC5LrIzoRaKCnzLBeLIi9UdixXWg1ybctjueYqKEf6yqpykFsupuBoYcwpPrb04QH9EZ6qh1GQUUgmYhUFwRbGTqHjkedGSs+qNXqQl7n1UZx81B/Zj3IpCTyRIxxkl+IAPoL3zntRiPBBdpFfuTAn8alfMbsUH8UZxAFVDy8cz4NchFvCVYMQpHa4mVJToPJJTQEu0dxSXyMkCRlQCQBlLhnoFErsqH9oZ5IQvz1hHURhIiN22oyi+QaRB2LUg7EZQnsQ+BrtEToTgLOgEHqdQWy4HIxKGxyjbuxyM8Iot3vkHkYV2pEv5RSn5gYB4SM+Vlp/R2ojQimnuxPuWiSX5Z6nyr8VH7gg5vkF0siV9ed3IcSpsQ7UEUmgDrgAFFhqACaaWX8kTBghfgaRs4AOShQs/LA+ooMKNhoG8r50oF+UOpSULwvb0dTcdys27+l+GOteC67Di5ybUP9Quwg/uvjh66dvNxweGE3Uhog+CnM0PMQuwIduxd7fvvAJdzTc/sDduW6B4kTwQB0lJTLVaAwAehglHXvTui0de+nYS8deOvZO1UE69tKxl469uF/p2EvHXjr2Qos/HXtz3g/TsTfn2Ftl7Kpev1ZdtWVLvuAZ+1VtnrsX9/C77dZd3W7c4339dPjoR1U/v3Tu4bqp/h0rXrZN2wNu/jbNbvUfrx3ab5scAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2853",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "901",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529181",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.34628177",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yim3Npp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw0Sdr4xpT4F5VqrAUHhjQs3kNX4kRGhmPA0XcwowyxnAqb6hy37Xg2RjcHaqIsOugdJMEGw164N3ctQyjiC0gcVjHcgKc5ykgueJjwXbC54bI/m/A9vtWm78PaEJQg2Vj++64TgRIgMwcpbH8/c3dqpfgIVTNfN0gAAAA==",
    Pbi3DGeometry:
      "vRwAAB+LCAAAAAAABADtV01r4zAQ/S86u0GflpWeSlso7B7K7sIeSg4pNY3BjUvWLYSS/77CX61VPcumh15ESLAn8ps3b0Yjz90bub0v/hyfc7ImP6r74ndVFg8kIbdVsa//kfXdW3tp/6bn9kNOybvljFF63vzYLzlt+scuDoft0T7LVpSzNDljciW1NAmnK0mFTqxdiKyxKyrlR7vh2mtH61MhWjtL0xk4jFoaU3ykVCN8xL/Hd9cDHOQX8gn5RTpIIficuBD/wS/jjV3YixFOb9d0zN9ZP+D3dsa0F6ezI7+fcFq/iM+7Dr0942aKD/AL43LxuTFqKi7gF+KjuIAO4bpS7b4QquWJ8j7ExTVrdTNTZYVggD1MZ164iGYwKqcaQjBLxR9HBZM7FJujAtqkqBgQTqjZzmxWMOuhIgFmR/xgVEtVm9kagtGO6cusc5vJRgQh2Ij+5xOqg9G6XW5Yw147tcNTNSuHM1VA+IDOcF5S3sFY3IlzFEfrt3Pdq2a+og5qpwujQjkcUq60at2q1FeyfXdH6xFNtD5UU+i0dFUOxeXqgBoDLiqURT9PHJc/63BHgyLxs0E1i1RA705aGy979M5gvDRR18dnX5Z5a99kxhtuyC06hJDdfbMEbkPqwDdyV31/cqHISB3gFsGDqNBOR3TAjsbJRXSWRQXF98Oj5aGu7/YppEII38WJ01+c/nznWZz+4vS3fN6K01+c/uL0F6e/OP3F6S9Of3H6C6oTp79vm/42Cbkqtk95nR/Imq5oQn7m+8d61938quptXVT77vZv8TD8dZMXj7u6u7ku89ePCy+rsrKA+5eyPG3+A+on/D+9HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "903",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529183",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.51803496",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LO6+Lu65r2EkqCOogEXQQD0qLPth2w7ZAxP/ektaloNub9w0zUwyQ13jsrwpS2Nkac6v7xhogkFs07gZpMUynNwRMUC5FvAw4lSIRMJLfMJaCfcEoSv7DKbZ812ddV/V+g3+ssboopzpIQxoS2CvTuHYWB+sqh372JE94/qCtwqZ1LyF5TGCj1WP2ck4ZWxBYWW19rLlrPZZP6sn2ThIBAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVt9rwjAQ/l/yHEuSVlv1aWyDwfYg22AP4oNi0UDXDNcNRPq/r2jtbK6fVymW5i757rvL/XB+ELOVfd9/pWIint3KvrnMroUUM2fz4ltM5ofTZ6VW0+oRpfyXDLRS0+Or+olycT52t9st99XZgY6CUGk5MMEoiiNpTKB1Io/i0JiWPBqHJ4UJ2wdMbOQVIBMn4879ZjSOuy14QIkaMpSAC4DQzXaBHAIRl2MddceuUfR1reFUIw1HkW7fQo3UKDykRu5Fg+w/O0EtdAMhcV8+XrSJHBJFjvn8z7HuDcQxwq75l8OaZsnSHOOSj0KhrMTpej0gqFDo1XGWCVdoGUX21trFQLBEudqlaQCLmkscaJzS7Z2DfoOArGDHp1BwFDAzAvQO0MDJbs5s35bFtbi+AwXB4NHHzUTaILg+AFsKNH5Jt/pn8GCXn2mR7sREBUqKlzTfFNt68eqKZWFdXi8/7LpRPaV2sy3qxWOW/l5uvHeZqwDznywrF3/UrjYsywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6743",
    Length: "25",
    Mark: "386",
    Material: "Copper",
    "Middle Elevation": "2951",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "87",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2951",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529184",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.86256004",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6zQkba1SV6KCoIsggovSRYshHYgZiVEopXc30OoN3P0v5ptqANXipX9oKOFILSqyvSEHDBShC08oq2GScZDInGdCrpOUL4QsYGR/6OoveuN900d+DHbY3HXQHkrBBYOTdiZ0szlTaALGlyd7xduvOmg0XYRIXqwyyWBv9XvepoLnIlsy2JKleNe9rB3rD2AvStMPAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVt9rgzAQ/l/yrBIT668+jW0w2B7KNthD6YOloQ04M1w2KMX/fZm1m0GPnBXxR+7zu+8ul5yuT2S1la/HD0Fy8qi28kWVckc8slKy0p8kX5/OjwamS3OQxvu3+CGly/ZiTtJsLrSbui6OhuuHUcDiLPF8FixoGHuMBTSNU+8X4DRs7Zyllp0ladYCjCc2AHm6MKIkW4xJRAnltp3xcFQCjMmRxFCBMzZOAKVBhiOJQdbTg4VisktBg4ia+2CeenZbekg4S/cJVukwnlwSg5js7FCAVQpEFnYpMARQAYwJmkDcPIG7BawFigFqgFFBrsCZAtYsztGsJoEqNmZDTl82IACuG1e/cbhCpQEycKt5ehect4uhfgD0eJyjOV8RsGuCXzwIwHlCAVf3D4crRxrmX+FOFu9Ci5rkNKAeeRLVXh+6wbPShZaq6oZvcvcHPQi5P+hucF+K7/6Lt6pUxmH1VZbN5gdAy2i03QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6219",
    Length: "513",
    Mark: "387",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4867.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "87",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529185",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.61009753",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzG0SVNKPYkKgh6KCB5KDy2GdiFmpUahlL67wdYfvHjb2W+YmbyHrMJDd9GQwpYqzMh0NVlgkBFad4U078fTG2ah5CqWaj4TPIpVCAP7hhEXMvkPlUx+4Sd2hMWrftG2Zec3+McKy7N2uoU04AGDnba1ayaxJ1c69LNHecTTG2001o17ilgoBmuj75NXBFyGDJZkyKfamzFD8QCyH6yXEQEAAA==",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACdVt9rgzAQ/l/yHCUmRlv7NLbBYHso22APpQ8tDW3AmeHcoBT/94XqWiOeOYsoJt9998u7i6sTWW71+/FLkYw8m61+M7neEUqWRhfVN8lWp+bVwmxhL1LT604QMbY4P+xN6vU/7a4sN0fLDSIRykRIGvAwTpmgnIUijjjtApJFyRmIqCs/l832vA8Aii6MRIhhCymXLsBFOs5AmpaCz6YEBxuGAH/6wOD6CYR8cmOIQy5mQ1/iCjiKuvKOqwPyjasDFpqoEar8NnquunnFAIAiKEsjwUGugqa9NoDgPK0CJhzsIRRj6icCbcCljCwcRFdgGRivkE2MqJEbyhOcOGDxgO6CqpAMjFfgMHIBTBOADBAABt7EbvLN8lF5rzcj593U8QvIjwDgiepr4emHs2XY/4QHvflUlSpJxkJGyYsq9tWhXbyaalNpU7TLD727QE9K7w9Vu3jM1W9X8N7kxiosfvK8Xv8BTkqWSdkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "206",
    Mark: "388",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "87",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529188",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.48068149",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAYhN/lP6chSdN08SQqCHooRfBQekg1tIGYSI1CKX134wbeZvmGqScoW30YrwoK2LlWV+rkpe2MAgSl09bfoKinjwxIRDmOCV1EDCeECpibH7YcBjkGNgRrLS/KqwEKggmCvbKd71+GUi4QVM5Lr52FguIkJWkuYibSnGe5CO1Rn//hrdJd79+ecIZgY9Tju2YMk0xkCFbOuHBm78bMzRNNRemR0gAAAA==",
    Pbi3DGeometry:
      "Xx0AAB+LCAAAAAAABADtV01r3DAQ/S86exd9WbY2p9IWCu0htIUewh42xCQGd122biGE/e+1V7ablfUkGXIUISHWeObNmxnPaO5eyO19/f35V0V25HN7X39rm/qBZOS2rY/db7K7ezH/9mJ60/+Qc/b/ZMMovbn86X/JeT+pvTudDs+97obJLc+1yDZ8myvJMs63TA7Pg6Bg+ZWgKIuLQAgqnQKsQdnVuabab0lIXsQ5xXSZeWksMGYNZAqCY6+iwVFEaKECTkEaEzZlahDQUln8BLs6n1nYChOELDhzWloKEPbsrXBbWvg0hkMKHukSRIbsDITMtY4jB7EhBGQHohEuNGacZb2itwjm+PUGLuU0OOIpM2wICkIuxXJGngap2aURMrQ2CTYxmOWp9CwF3JpAWUBD0R053MpQ/gP1As+tJASprQ5eZMMIMrYZ8FJdgKXmRpCXoOO+mmZGQUujwKQ5V7npC4Mvq/IZHQyIAFyaSDNuGPinro8xEKj8uiKV8DvkYwBGySpqMJtTly/VGFDtbf7gdTwTwPuh4oIjdRnqADM7ELBX4NqCqQSuesi5k4+/cVQsbpfgtdFd7vCuxXLlDimc8AIUI7xcwOmolPM76AWFm3MIGo0pdL68kiLkUJjgJdbOA2CAow2DhIAhBOKGvn/oE+gjMM/QobXUcBYABFTwDYUFMRiIgPlFK0zrZFon/SWV1sk4iLROpnUyrZP+ppTWybROghmzglpaJ9M6mdbJqPO0Tvq+/7ROvt06uc/Ih/rws+qqE9nRLc3Il+r42D2ND1/b7tDV7XF8/FE/zKJPVf341I0PH5vq7+sX37dN2xs8/mma8/4fWm40Q18dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "905",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529190",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.521084",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/+xEnXO5TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRhHKcEjpPGM4IFTA1P2zR92qIbAxWRl100D0UBBMEO+3a0L0MpVwgqHxQwXgHBcVZTnIpUiZyyWdSxPZgzv/wRpu2C29POEOwtvrxXTOCmZQZgqW3Pp65u7VT8wSshQMh0gAAAA==",
    Pbi3DGeometry:
      "sx0AAB+LCAAAAAAABADtV01v2zAM/S86O4EkWraVnoZtwIDtUGwDdihySFGjNeDFQ+YNKIr89wm23NWmXuV2xwlBk5o0+fhI6oNXD+Lyuvl6/6MWO/Gxu26+dG1zIzJx2TXH/qfYXT2M/zq1vHAfcc7+SjZKyovhy/2J834ye3M6He6d7UblW5Iq2+htbqzNtNzmkspskJPMB0WpVVBhKCznBrkuBwOpinWexpBMTnom16UyYQTAYTJYAsQcMeSIHCaPARtLwVTAiCAFqsxTaMqVniu8Jyrl3GIiwSw8BClVhj0xBcKePC2hcUw+H1Rpuy4mCA3ZeQhtrVlHD2FDCExvkQ/Y4JVfKROCmWJFXWDci7P82XV9hlYEk8OIIqVmchRppL95ZyBHLw0oyoyV2Vs89t6yOnzxwsZArmI7GdwfuAK2AOyZSGLRGoVtzxcpzGDUFVNg3mEapOSQj7wqRmxSNnJuSRqLUXpPZNU8qGKU68KspPfyhCwgYEykq9khS8b9rjp94QHPFcr4oIz9x0yhvfcV/FBddUXFzEKbInIixCz4UYEscFSQOc46alyYErSJwF0HFRZHC4OCrYC3PFRy2G6wpWFG0E3T03Dv6WCZlneAKVgnD3c6PDWeOUFLNV/jnrdTLG+bCBxiIAW80EJslCmYWtydsRSiexdLFJwfAAJkF70kspjgVoEzHqW9lh4sBeaNLFCR4pvncmHAlQS3yDR4psEzDZ5p8EyDZxo8n01sGjzT4JkGz3X3zzR4psEzDZ6gO9PgGab93wye+0y8aw7f674+iZ3cykx8qo+3/Z1/+Nz1h77pjv7xW3PzqPpQN7d3vX9439a/n774tms75/D4q23P+z8ek75asx0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "907",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529192",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.32921047",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzE06Z+tJ1FB0EMRwUPpoWJoF2JWahRK6bsb2upFBG87+w0zk3eQnfHY3hSksKMzZqTbigwwyAiNvUOad+PpDDMRcBkF4UJEPPaSEHr2AyYy+YK+H/8Bh9jiXb9smrJ1G9xjjeVVWdVA6nGPwV6ZytaTOJAtLbrZozzh5YO2CqvaDiKSIYONVs/JKyUXYs5gRZpcrHlo3RcvvHjzSxIBAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVl1rwjAU/S95jiVJq/3waWyDwfYg22AP4oNi0UDXjK4biPS/r2jb2aTHWymW5t7k3HNv7ofLI1ts9PvhK2UJezYb/WYyvWWcLYzOy2+WLI/nz1ot5vXDKv4vmUgh5qdX/WPVqj12VxTrQ312IgPPF5LLmReKeMqV8qSM+EnsK9WTB7F/Vii/f0CFil8BUmEUD+5XszgctmABRWJKUAIuAEI32wVyCOS4HMpgOHadYqxrHacWKVZx/xZapFZhI7VyOxr2/s4Jx8IwEBKP5WNH25ZDosgxm38b69FAFCPsmn05pGmarJNjZPI5UCgrcboSAUGF4lwdadnmCi2jyN5auxgIlihZu04awKImEwcad+iOzkGnQUBWsOM7UHAUUDMC9A7QwO3dpNmRLYtscSMHCoLBo4+ciU6DIPsAbCnQ+AXd+p/Bg15/pmVasER4grOXNN+V+2bxasp1qU3eLD/0tlM9pXq3L5vFY5b+Xm68N5mpAfOfLKtWf4y2qlHLCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6743",
    Length: "25",
    Mark: "389",
    Material: "Copper",
    "Middle Elevation": "2951",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "88",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2951",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529193",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.18818225",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xgSm9ZSV6KCoIsggovSRYshHYgZqVEopXc30OoN3P0v5ptyAN3gpX8YKOBIDWpyvSUPDDShD08oymGScbCQiidCrmXG8zRVMLI/dNUXvem6uo/8GOywvptgOigEFwxOxtvQzuZMoQ4YX57sFW+/6mDQthEieZYnksHemfe8XQquRLJisCVH8a5/OTdWH88M6yIPAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVktrg0AQ/i97NrIPXzGn0hYK7SG0hR5CDoYsyYJ1i90WQvC/d2tM6kYnjg2iuPM538zsPNbFnsxX6nX3IUlKHvVKvehcrYlH5loV5pOki/3h1cJ0Zi9SeX+SCaN0Vj/sTarlUe2mLLOd1Z2wwOfRNPZY5CdhGHic+zSJEu8XEJTVch4wR87jZFoDQggXgJhOGnEc9ppIosiVC87H+QSaHooOb3rIpw4TF6w/6iNwvoFQdKBpNxXUD6iIu0wtubsdPQp1EG0FJ3UYpkET5z650aEAyFnQtJMKBNP/fepE5yQbdBbsFjAXKA1cW2DyDe4UUP04oquGBOTRYN9dtIAqGxDA1Q3o1HiN8aMLLE7UiMJRoQCoY6ApiCK6as5CUxM88SAAx4QCcHMWcyggNQ6A/Ve4U9m7NLIkKfWpR55ksTHbZvGsTWaULprlm1qfoAepNlvTLO5z+d3+8Fbn2hIWX3leLX8APoNCd90IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6219",
    Length: "513",
    Mark: "390",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4867.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "88",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529194",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.0427697",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACNjkELgkAQhf/LnLfFdVPUTlFBUAeJoIN4UFp0YNsJ2wIR/3uLWkinbvPme7z3sg7SEs/tXUECByoxJd1WZIBBSmjsA5KsG09nWAjJg1AGKxHyKBYx9GwOl9yX0R9QRL9wFjvA/FO/bpqidRvcY4vFTVnVQOJxj8FRmcrWkziRLSy62aO84PWL9gqr2g4i9AMGO61ek9f3uBQMNqTJpZqn1n3+Bj+6CrYRAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABACdVl1rwyAU/S8+26AxX0ufxjYYbA9lG+yh9CGl0gpZHJkblNL/PmmSLbZevCmhIXo859yrXu3yQBZr9bb/lKQkT3qtXnWtNoSShVaN+SLl8tB9WpjN7UOO9L9nxhmbn172R46rgXbbttXecmdcRGkmUsqzqCiyjMYsEgmPqQOkaXICuNud52nXfXMGgEIDIxPC75DHqQvECZ8UE2gdTA5vHYzpQkrYfL15D8DFFALpudZJFIvCtxYjYCw06nanwzO+y8Hj0OWAkQp6nMUEJgcCYLCgtbsSGKnro+J+60C5gFMO1hGGMX2RQA9wlyO3DqZgkAxMVMHaw28FkAECyDMElMKcOkgGJipwi7oApghABggAR97UagJkUOPD0YB33tQDGBwPAsirDZSackFbhv2vcK+qD2lkS0oWMUqeZbM1u77xok1llG765rva/EGPUm13pm881PJnPPBO19oKNt91fVz9AvRSXQDdCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "206",
    Mark: "391",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "88",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529197",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.56220681",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizjm3TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRGeU4IXROBZZpymFqftii79UQ2RisjLrooHsoCCYIdtq1oXsZSrlAUPmggvEOCorTjGS5SJjIci5zEduDOf/DG23aLrw94QzB2urHd80YJlJIBEtvfTxzd2un5gmNETic0gAAAA==",
    Pbi3DGeometry:
      "cx0AAB+LCAAAAAAABADtV01r3DAQ/S86O4tkfXpzKm2h0BxCWugh7GFDTGJw12XrBkLY/x7FH9vY0pPsWw5i2WWtkWbmzTzPaG5fyPVd9fP5T0m25HtzV/1o6uqeZOS6qQ7tX7K9fen/WjG9tB9yyv6vXDBKL7sf+yWn3Xjs0/G4f7ZnL5jY5LLgGVMbXeRFlucbJuxzJ9BMTgTa6E7AORVeAT5B2WS9oEVYExe5XuYUK0wWhOHYOJ9AqqBx7NVi4ygiVKuIUxDGYNtIKd4E1KgpPmN3TAQjDOfEaMMYYfyqHAEyflY1N4696iNiGNcLnYK2Ib7BRKGXoYOmoQWMDsUjSjbDNesEnIWJMKJ7o1JHKetKiGpYERREXFqBGvkaA+ewI6JofSIccDDXI/9mB3CJQuSAmhaX5nhNQyQIkwauz/MQx7Y2fMsrRwy0AyI3qjetRIeCSQOq77vO1oPQsj/ARL+uZM8mTdmqlC4PB7QAXBpBi35ZhztwCDEQKDklpeJhh0IIQFdZBQ1mc9x+DmgR6gJgN24OYH+MW7C5upGOAZvFAVYLTC2YSeBqAJw/9/glR1zxuwRvkH62w2sXk8ofUtjqOeAivGTAJqmU9zWwAu3HHDONOhVY99xOkeVYmNB91skDQICjDYOEDEMTCBt4/aFLoIrANEN/1iLDSQAm4IFQS3CAwUDE1M8rYRos02CZBkt/mUuDpe/FSINl5NKUBss0WKbBMg2WPm6lwTLMlTRYpsEyDZbhJHz0wXKXkS/V/nfZlkeypRuakavy8NA+Dg83Tbtvq+YwPP6q7s+ib2X18NgOD1/r8un9xs9N3ViFh391fdq9Asr70IpzHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "909",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529199",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.23273659",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yim3PTTlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhokbP3RVPoUlGutBgSlNy7cQNbjR0ZkRhlOCZ1TjossYzA1P2zR92qIbAxWRl100D1IggmCnXZt6F6GUsYRVD6oYLwDSXGWk1zwNOG5YIXgsT2Y8z+80abtwtsTliBYW/34rhOCEyEyBEtvfTxzd2un5gls0dIs0gAAAA==",
    Pbi3DGeometry:
      "sR0AAB+LCAAAAAAABADtV01P4zAQ/S8+h8r2xIldTgiQkOCA2JX2gHooIoJIoUElICHU/07UOF1i++Gwe7WqVo0nM28+nsee2w92fVf/fn+u2JJdtnf1r7ap71nGrtt6072w5e3H8LcX8+P+w3bZ35Ujwfnx/qf/st1qVDvZbtfvve6RyBfERSaKhTZlJvki51Rm+2Xi+X5d5zoskMrM1MhluRcolc80ZX0SNHVKlkKFIcJBHN53AaKGXOTYOsqeB6wMBXMBPcIxkFZfsCkXcrpuLVHJHQUbhK9hIUiIMmzKEyDs0ZKHDZ2yCSEtzUynEDYMz0JIY9TM8CA2xIDxuRmBHNd2t4wQavQWEkGRnKbQzOQa3BaeADoVLbgnQN5Gee4xBFn6uU/R8Lx6jxoGFMnbxpAgwFKspcE+4QkgDSBvInmFWxWS392qKHtRQ54ARx0OggQfsjEgkzCRw4vTUAdt7ZARTmx8IJMs1LzgfpoMFwC6RFJPDlpSoph5AsNT3hMIZb0S/5sn1H3/Ib5wUaWmYvK+VEXkRIhqeEcF0kA+wahxxsOMhckAjQP1GVBQ7CjwBxIANjhUZkQxyGKYCnjBHGPIOSiPe/IfvJWI3/CIwIeK0dONPQYu3OskBIcYSAAvshAbpQonFzMzlkN833JThUcHgAEDjF8PPa9gl8BZj7JndoCwHjhypIEKFW+D3vaAGwr2xzR3prkzzZ1hiDR3prnz+0tFmjvT3JnmzjR3prkzzZ1p7owxM82dae5UxSpjZ/X6qeqqLVvyBc/YVbV56B7tw03brbu63djHP/X9QXRR1Q+PnX04b6q3ry+etk3bG9y8Ns1u9QniKDe+sR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "911",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529201",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.85367858",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0adJKPYkKgh6KCB5KDy2GdCEmUqNQSv/dYKsXBW87+4aZKXrIazx2VwUZ7FyNuTOddhYI5A6tv0FW9OMZDDMmKE+EXMiIslQwGMhvyGUqvmAcp//hGFu+65dtW3VhQ3issboor1rIIhoR2CurfTOJg/OVxzB7lCc8f9BWoW78SyRcEtgY9Zi8nFPG5gRWzrgQa+/GDOUTx/jhzxIBAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVk1rwkAQ/S97XsPuJmn8OElbKLQHaQs9iAfFoAtptqRpQcT/3qAxNTt5TiQYsjO7b97MzofzvZit7PvuKxVj8exW9s1ldi2kmDmbl99iPN+fPiu1mlSPOMh/yUArNTm+qp84LM7HpkWx3FVnBzoKQqVlrAKdRFoaE2g9lEdxaExLHo3Ck8KE7QMmMfIKkEmGo8795m6UdFvwgIYqZigBFwChm+0COQQiLic66o5do+jrWsOpRjJxErVvoUZqFB5SI/eiQfafnaAWuoGQuC8fL9pEDokix3z+51j3BuIYYdf8y2FNs2RpjnHJR6FQVuJ0vR4QVCj06jjLhCu0jCJ7a+1iIFiiXO3SNIBFzSUONE7p9s5Bv0FAVrDjUyg4CpgZAXoHaOBkN2e2b8viWlzfgYJg8OjjZiJtEFwfgC0FGr+kW/0zeLDLz7RMCzFWgZLiJc035bZevLpyWVqX18sPu25UT6ndbMt68Zilv5cb713mKsD8J8sOiz8dVLxhywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6743",
    Length: "25",
    Mark: "392",
    Material: "Copper",
    "Middle Elevation": "2951",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "89",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2951",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529202",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.05589047",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xgSUx+NK1FB0EURwUXpoqWhHYgZiVEopXc30OoN3P0v5pu8h6zCa/cwoOFEFWZku4YcMMgIXXiCzvtRxsFMJlwJuVkIrmSawsD+0BVf9Nb7sov8GOyxvJtgPGjBBYOzcU1oJ3OhUAaML4/2hvWvOhps2giRfLlWksHBmve0nQueCLVisCNL8a57WTsUH7R0X+YPAQAA",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEpMbI32aWyDwfZQtsEeSh8sDW3AmeGyQSn+78uq3XR65oaIYu5y33c/cqfrE1lt9fPxTZGU3JutfjK53hFKVkYX9p2k61P96tRs6S5S0V/JLGRseX64m1Sbi9lVWWZHZzsLo0BwEdI5C3gSS8p5wORC0m8Fj2UyqhARRxoskvhsECYJCgn0SbBaLmWMo74g9RgE54MuwdQAEhhD7aqYh8jYfMkYJWZBxEQ8kIuWoss8YNFD6tQNQwFztwuH8QlWdCo3YPE3ik4hEFGDOIDch9NPEqodIAbMfpDAV1Bs7qDDjcKZ0jyQP1CbQ3IMDkYOHkbffBlHmjTBfA0Cjra+AgeFUkADAJjoOKAp3wzII+93b5xh0piEG9Q3M/4/ZdphuD+DG529KqtKkrKAUfKgir09NItHYzOrTdEsX/TuR3Wn9P5gm8Vtrj7bG69Nbhxg8ZHn1eYLzZbd+8sIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6219",
    Length: "513",
    Mark: "393",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4867.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "89",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529203",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.7993999",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzG0SVNKPYkKgh6KCB5KDy2GdiFmpUahlL67wdYfvHjb2W+YmbyHrMJDd9GQwpYqzMh0NVlgkBFad4U078fTG2ah5CqWaq4CLlUcwcC+YcSFTP5DkUj1Az+xIyxe9Yu2LTu/wT9WWJ610y2kAQ8Y7LStXTOJPbnSoZ89yiOe3mijsW7cU8RCMVgbfZ+8wg8NGSzJkE+1N2OG4gEA9scJEQEAAA==",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVt1rgzAQ/1/ynEpitH70qWyDwfZQtsEeSh8sDW3AmeGyQSn+7wvTtjq95oL4kfvO3eV3rk9ktVVvx09JcvKkt+pVl2pHKFlpVZkvkq9P7adls4W9SEOvlBlnbPH3sDdpNme1ZV0XR6s74yKI5yKmMQvCLElpyALBM077DBGFN+lzIXDyMW8ZkX1jDMER8SxrGSjHFzsjB2maTEYEegZNgck4h5qEMXJzrmy0jCgIRTqhMKa3Dq70f54RhoaFc3sA6f26IQKCGcPCTWiM9jCsg3vToCXvOsCVduX1dpMh5EEHOM9g+sD+RsQEWsIpIGKCz7t3d/h3AYwpyJ71gSeHBiYqJ9L5nz084AA4joIJ5zjAybujcYw/JMh5YyU4LXFo7DF3rYL9M7hXxYc0siY5Cxglz7Lam0O3eNGmMEpX3fJd7S6sR6n2B9MtHkr50xe806W2Bqvvsmw2vwJUxL/LCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "206",
    Mark: "394",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "89",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529206",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.50084059",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizrm5TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRGeU4IXSeEpxQKWFqftii79UQ2RisjLrooHsoCCYIdtq1oXsZSrlAUPmggvEOCorTjGRSJExkkudSxPZgzv/wRpu2C29POEOwtvrxXTOGSS5yBEtvfTxzd2un5gl09Wff0gAAAA==",
    Pbi3DGeometry:
      "kR0AAB+LCAAAAAAABADtV99r2zAQ/l/07Ab9lpU+jbUw6B7KNthDyUNKTWvw4pG6hVLyv0+L7Kyx9Un26xChSaXz6bvv7nynu3snt/f1j7ffFVmTm/a+/t429QMpyG1b77pnsr579/86Mb10H3Io/u1cMEovj1/ujxw2g9qn/X775nQvmFxxZUWhqPs1suB8xaRbHwWGqTOBKc1RIASVQQHWoOxs31IbP0lIbuYZxWxZRGlMME4a6CgIjq2aDY48Qo1OGAVp9NiCWftXQEs94mepOhMMNCYaA4aQVgaPmgoQ+MncMTi2qveIKcVMoyA25OchhGZ6Hj2IDSEwPeSQZLY5q4/mMsHimXDyIOc+p5wpsVzDB0FByqT5rJGtSXLj9EgdtDgQE3Iw1kMCjhRwjULJAU+aXZvTRQ0lQSJp4P4oDmlui903u3QkSY9J8FJ7aG69QJWg/H5obV6BM6/ApN/XylcIIc2ikM53B0QAJg1VjlrlKcR7cIwyEGh1npVaxC2KUQB9ZRk3GM/heaEGn9poJ0DP4w6BFFIZBnvs1N0pcmNnwKKBMwzGE9gaYRfOAPyuo4wJmwRvkiDp4f2LuYAFnQpbvgApCW8bsFlqHXwbnMCESaegUccC+4FrKkJOuQldbKeBABSwu6GXEDKEQORQEYA2oWoCIw0tWsoNxwFAQIVod5hSg75IAUwqYp4z85yZ50xQ7PKcGXoz8pyZuDzlOTPPmXnOzHNmnjPznJnnzBiFPGf+/3PmpiBX9fZX1VV7sqYrWpCv1e6xe+oX39pu29Xtrl/+rB9Ooi9V/fjU9Yvrpnr9+ODntmndgbuXpjls/gDUwQf9kR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "913",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529208",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.38897832",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizrlcp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0ZkRjlOCF2kBCdUSpjqH7bsezVENgZroy466B5yggmCvXZt6F6GUi4QlD6oYLyDnOI0I5kUCROZ5HMpYns05394q03bhbcnnCHYWP34rhnBTMoUwcpbH8/c3dqpfgKVNY1v0gAAAA==",
    Pbi3DGeometry:
      "7R0AAB+LCAAAAAAABADtV01r3DAQ/S86O4ukkWxrcypNoZAeQlroIexhQ0xicNZl6xRC2P8es7a2sccvUtqrWLLEnp15M28+pLl5EVe39Y/nX5VYi8v2tv7eNvWdyMRVW++632J98zL824vlef8Rh+zvmzMl5fnxq/8Th41X+7Tfb5973TNlViRVZuWKcpVnWq6MpCI7vidpjgLjzKJAO2kjNYwujgLlXKSpwSldlDR5rwtllyFAFF6BIYQsMejAe8gfR7aOFtmALuEgqLRvwckoPRWMpqiQUw0fBtPwGKRUsWyKCRD4ydQcHHrlKaFSu0ivIDgK0GNo52xcgBAcY0Da55TAQi+HljlBWO8trAVLesqhiys32BpcAJ0KZZwLkLfBUmclgix93KdgeCzfo8apCudZ4q0MKwSZCk02OC24AFYCLJ33qYXtihuctStkMGiKCXDcy2GQkgMfZAbs/geBg0ySGgWDJXJq6pS1Q03p3EbG93FG5hjQK9Ll5Nwl25uMOpDhoc8Fynqv8v/lCg3ifwgQpVaXlE80tM0Dx0NQg50bSAN7BSPHtKPahZSgOQIHD8os9hY6BWsBTz2UclhvsKYhI/D26eOQlhbzxG4E3l1dgmKHRwc+bEpjpm0+Rt4L5jdQBA4xkABeciE2ogqTiws0xCG8hzGq8F4BMGCAwWsj9woODMx6KPL4AGE+cORIAyUqOBF5e8CGgqMybaVR0GkrTVtp2krTVhq3QaStdLnB01aattK0laatNG2laStNW2naShdMbTJxUW8fq67ai7VcyUx8q3b33cP4cN12265ud+Pjz/ruJPpa1fcP3fjwpan+vP3h57Zpe4O7p6Y5bF4B0DENdO0dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "915",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529210",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.49341999",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkp22wnkQFQQ9FBA+lh4qhDcSs1CiU0nc3tNWLgred/YaZyTvIzubY3jSksMOzydC2FTogkKFx/g5p3o1nMMx4REUSxQulKFMKevKb8YTJLyil+g+H1OJdvmyasg0LwmNtyqv2uoGUUUZgr13l60kc0JfehNGjPJnLB221qWo/iETEBDZWPyevEJTzuSSwQosh1z2s7YsXMRtvYxEBAAA=",
    Pbi3DGeometry:
      "rwgAAB+LCAAAAAAABACVVVFrgzAQ/i95TiWJq1H7VLbBYHso22APpQ8tlTbgzHBuUIr/fdKq08TPWEpLc0m+++5y9936TFY79X76SkhMnvVOvelU7QklK62y4pvE6/P1b7XNFtWHlPTfMuOMLS4/1ZeUm+baMs+3p+rujN95PuNUSo9JSYXwOI98ejH7QnTtcxZc7cLvnRfhnI7ACBlGQ8dFEMlB+D5MyMNxNoA8IHOj02EzQjFDlUIOZqy1T4upZVPD8ID5/czXOO2GAdTazTRYF5oIbBcACdqnUjJSbdkhVRibGUKT7clILko4NvOBnK6dZK0Sc5SeDQRqEtbqeDJAh9jP5nBr8YR+UU5va1kMg3rT0bP246NmdlUL8mxTnVx3pjAgTkjabSCk+eOzAMkFUGv7uMPtZJly6drU8YFg4JBzDD9bEBx9DxUEee5Srab/g9p+JkWSk5h5jJKXJDsUx3rxqottoXRWLz/Uvt16StThWNSLxzT57R6816muALOfNC03f6Vb242vCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6743",
    Length: "25",
    Mark: "395",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "90",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529211",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.19918959",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xjSNJhSV1IFQRdFBBelixZDOxAzUqMQSu9uoNUbuPtfzDfVCGWLl/AwkMORWizJho4cMCgJnX9CXo2zjINVongqko3WXEqZwcT+0NVf9HYYmhD5MdhhczfeDJALLhicjOt8v5gz+cZjfHm2V7z9qoPBro+QhK8zpRjsrXkvWym4EqlmUJCleNe9rJ3qDxjnPbYPAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiWJrlH7NNbBYHso22APpQ+WhjZgzXDZoBT/+9JqOzN781wRxdzn991dLrk435PZUr/u3hVJyaNZ6heT6xWhZGZ0YT9IOt/Xrw5mE3eRiv5YRpyxyfHhblItTrTbssx2jjviUSDGiaRSBkKImAoRsDjm9ACEjB/sPOFjzy5knBwJjEkfgJTOjChKLrkQNxH37aEQw2ICXfdkN8B1T0xdJRHyy1mfgN8TCGUHuvZLwYKIhbKr1LL709El1Em0CV7pMEp9Ljox+dmhAChY0LVXCoTSv2PqZucVGwwW3C1gLVAM3LbA1BucKWD144SuahJQRL377k8PqGUDArh1AwY1nDG8dYGLE9WicFIoANoxUBdECV3VZ6GuCZ54EIBTQgG4Pos5FJCMGnD/ClOdbZVVJUlZwCh5UsXabprBs7GZ1aZohm96dYYelF5vbDO4z9VX+8M7kxsnWHzmebX4BtQD0bPdCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6219",
    Length: "513",
    Mark: "396",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4871.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "90",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529212",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.32415159",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjk8LgkAUxL/LO2+L7rpqdooKgjpIBB3Eg+KiD7bdsC0Q8bu3pP2hS7c37zfMTNZDWuKxu0hIYGdKTI3qaqOBQGpQ2yskWT+ezjDzORUhF4sookzMOQzkGwaU8fg/9OMw+IGf2BHmr/pl2xad2+AeayzO0soWEo96BPZS17aZxMHYwqKbPcoTVm+0lVg39ilCJghslLxPXuZR7hNYGWVcqr4pNeQPs9FfGxEBAAA=",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVl1rwyAU/S8+22A0H/14GttgsD2UbbCH0oeUSitkcWRuUEr++6RJtph58YYSGqLHc8696tVuzmS9U6+nD0mW5FHv1Isu1Z5QstaqMp9kuTm3nxZmK/uQhv71zGLGVpeX/ZFm29Nu6ro4We4sFlGaiZTmecTTJKacRSKJOXUAzucXIHa7k2TRdi9GACjUMzIh/A45Tx3ASmeTYgKtg8mhrcMxjaU4Y7k/7x74N4X+9EbWScTF3LcWA2AoNOh2p8Mzvs3B49DmgJEKergxgcnBWYPBgtbuSiCkrogq9lsHygWccrCOMIzpiwR6gLscuXUwBYNkYKIK1h56K8AMCMCeIaAU5tRBMhBRwVvUBTBFADFgADjRp1YTIIMaH44GvPOmHsDgeBBAXm2g1JQL2jLsf4U7VbxLI2uyZBGj5ElWB3PsGs/aFEbpqmu+qf0v9CDV4Wi6xn0pv4cDb3WprWD1VZbN9gfYyu183QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "206",
    Mark: "397",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "90",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529215",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.76941749",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yiztStU1QQ1GGMoMPYYSvZBNNYFoyx7569Qbfn5ffwlCPkjTkMVw0Z7HxjCn0KtWutBgS5Ny7cICvHj4zIjHKcELqQEjPGFEzVD1v2fT1ENgZrU1900D1kBBMEe+3a0L0MpVwgKHyog/EOMornkshUJEzIlKtUxPZozv/wVpu2C29POEOwsfrxXTOGiVIUwcpbH8/c3dqpegK4AZAS0gAAAA==",
    Pbi3DGeometry:
      "oR0AAB+LCAAAAAAABADtV02L2zAQ/S86e4M0smQ5eyptodAelrbQw5JDljW7BjcuqVtYlvz3qv5IE0tPsnsWYZO1x9KbN/M8o7l/ZXcP9deXHxXbso/tQ/2lbepHlrG7tj50P9n2/nX415r5rf2wU/bvzo3g/Lb/sn/stJuWvTke9y927Y3IN6RKmRXFRmguM6KNUFxnvaEQ6spguOgNUvLca8Ar7O/l/ZJkeCeZU7HMKRIjNqLhYJxXoK0gOPZqMTiKCDdlxClIY8QmIvPXwI2Z8StlfmWYaDgrJgxSJL1buQYEfnZ3Do69GiNiBC10CmJDfgME6VwtowexIQSmhwISVRvxwV0h0Vtz1sgYwkKJQVTWuZDY8EbQEPVpOW/kbIydI5DYRqtT4bKD6Z40OF+B6xQSCN5qcYGOVzYkhIhw0P15KuLk1gdwcQGJsp6zIKMHbEmDQZWgCF80uIHF4KuyquhvazWUCVnodTldEQ+I4fdpqnWC+iiJwshgKw5xBgatrnWp1X9GCXaXddRgPqcF0owxlRTsB+h53CfQgpjCYKd1ox0j50QDlo2AxGBCgbcBfl4JBN52IBm/R/BAiVQPz2FCaX9YYeuXflHCQwdumVp73wdrKPysI9CwbSGD57yKoGNxQidcTyr8JHC8YZgQMkJA3FAZgC6heoJTjTxaSw2nwY8Anw+3B5cajEUMwamJad5M82aaN0GtS/Om99VI82aaN9O8meZN7/ktzZtp3kzzZpo307yZ5s2rnXYZe1fvv1dddWRbvuEZ+1Qdnrrn8eJz2+27uj2Ml9/qx7PpQ1U/PXfjxfum+n354Nu2ae2Gh19Nc9r9Ab16SjahHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "917",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529217",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.32975097",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAYhN/lP8eQpEuaeBIVBD2UIngoPUQNbSAmUqNQSt/duIG3Wb5h6hHKo9kPVw0Stv5oKn0KyrVWA4LSGxduIOvxIyMyoylOCJ1zjhljBUzND1v0vRoiG4OVURcddA+SYIJgp10bupehNM0RVD6oYLwDSXHGCRd5wnIu0kLksT2Y8z+80abtwtuTlCFYW/34rhnBTIgMwdJbH8/c3dqpeQIRNyU+0gAAAA==",
    Pbi3DGeometry:
      "7R0AAB+LCAAAAAAABADtV01r3DAQ/S86O4uksSxrcypNoZAeQlroIexhQ0xicNZl6xRC2P8es7a2sccvUtOrWLLEnp15M28+pLl5EVe39Y/nX5VYi8v2tv7eNvWdyMRVW++632J98zL824vlef8Rh+zvmzMl5fnxq/8Th41X+7Tfb5973TOVr0iqzNqVLnKTabnKJdns+J5kfhQYTYsC5SiP1Mi1PQq0LiNNDU6pUunJe22VWYYAUXgFhhCyxKAD7yF/HNk4WmQDuoSDoNK8Bae8d24iGE2RlVMNHwbT8BiklF02xQQI/GRqDg698pRQqV2kVxAcBegxtHMmLkAIjjEg7XNKYKGXQ8ucIIz3FtaCIT3l0MWVG2wNLoBOhTLOBcjbYKmzEkGW/t2nYHgs36PGqQrnWeKtDCsEmQpNNjgtuABWAiyd96mF7YobnLUrZDBoiglw3MthkJIDH2QHbFIucJBJUqNgsEROzZwqh5rShYmM7wOMzDCgV6TLyblLRhVxBzI89LlAGe+V+V+u0CD+QIAotbqkYqKhTRE4HoIa7NxAGtgrGDmmHdUupATNETh4UGaxt9ApWAt46qGUw3qDNQ0ZgbdPH4cs9WKe2I3Au6scKHZ4dLxz2FiatvkYeS+Y30AROMRAAnjJhdiIKkwuLtAQh/geNqcK7xUAAwYYvDZyr+DAwKwHqyc6QJgPHDnSQIkKTkTeHrCh4KhMW2kUdNpK01aattK0lcZtEGkrXW7wtJWmrTRtpWkrTVtp2krTVpq20gVTm0xc1NvHqqv2Yi1XMhPfqt199zA+XLfdtqvb3fj4s747ib5W9f1DNz58aao/b3/4uW3a3uDuqWkOm1f2M97q7R0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "919",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529219",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.27350973",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjk8LgkAQxb/LnJdF1/yzdooKgjpIBB3Eg9KiA9tO2BaI+N1b1DpE0G3e/B7vvbyHrMJTd1OQwp4qzEh3NRlgkBEae4c076fTGSQPAhEtA8FDL1nAwH4i6cdfSITyLxoDi3ftqm3LznW7xwbLq7KqhdTjHoODMrVtZnEkW1p0cyd5xssH7RTWjR1FJEIGW62es1f4PJZxwmBNmlyueWg9FC/KUxCkCwEAAA==",
    Pbi3DGeometry:
      "LQgAAB+LCAAAAAAABACVVVFrgzAQ/i95ziSJVqN9GttgsD2UbbCH0gdLpQ04M5wblOJ/X7Zqa665aCktzWf87rvLfZflgSzW6m3/WZCMPOm1etWl2hBKFlpVzRfJlofjX/OYzc2HtPSM3HDG5v8/5kvaVf/abV3ne/NuGog05jQUwYzJiAoeJGkiqYHjSA5hKVL+ByeRhbKEohQhl+JycyiS0EUMOGTMQo8MRDQi5LqQbhghuUhyxoWjTh06LZteSMeR8mRQ656iRwFFB8PM7d0n0Ta1mwODpwmBRbVhRB+WDZR9rOpEEr8SLB1wBt6IY/pA54w0FCBx9xnWfiO5Ix0PDmckpC0QC+ks4HXWQzjcFvMbD5wu4kd/L7gDAnHT2sm2NKLCPYFtCudY9s5qxOTIQAW7feGmzJSRATRtqjs5kEvHfxUBG4/4FTG9O+BZnLl771X+UTRFTTIWMEqei2rb7LrFi27yRumqW76rzenRY6G2u6ZbPJTFz3DjnS61Iay+y7Jd/QI6SJNSLQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2844",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2854",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6645",
    Length: "25",
    Mark: "398",
    Material: "Copper",
    "Middle Elevation": "2854",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "114.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "91",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2854",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2863",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529220",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.23239118",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACtjksKwjAQhu8y6xDStEZaV1IFQRdBBBelixZDOhAzUqNQSu9uoNUTuPtfzDfVCLrFy/AwUMCRWtTkBkseGGhCH55QVOMs4yDnMlfJJpVcrTIJE/t3VX+x275vhsiOwQ6buwmmh0JwweBkvA3dYs4UmoDx3dle8farDgZtFxkJT5XMGeydeS9bKXgm0jWDkhzFu/7l3FR/AB2oaBQLAQAA",
    Pbi3DGeometry:
      "KwgAAB+LCAAAAAAABACdlV1rgzAUhv9LrjOJUeNHr8Y2GGwXZRvsovTC0tAGnBkuG5Tif19w2vmReFKRSvN6fM6bj3PcnNF6J95Onxxl6EnuxKssxB5htJaiVF8o25z//urHZKUvVON/5cYnZNXc9A/V2+6126rKT/rd1KNxiAPqsYD6mPpezBjDqRf4CZ2TYxY4RNM4aOQopDDEbISmzG9k6pCwQ4zALEwMNiz5jAib5c5cEkUgGZj2XELihSSIJ/O+yIOE0+ARY7ArENqWsb8tgA+LOtiVSfDQ83ChoRlaGEYVQIwWw+VAW9BgtIUN7JbTOlnOqRNkaQ1YnJgr1Kw6ICDVcsjmO8IcY2GvmT/s5hY0Uh0QkGouWmOHdSAs6txmD9DnZoa8sIHZ6gqo8Ov6Qc+2/vLei/yDK16hjHgEo2deHtSxHbxIlSshy3b4LvaXR49cHI6qHTwU/KcfeCcLqYHld1HU21/d7UyeKwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6219",
    Length: "415",
    Mark: "399",
    Material: "Copper",
    "Middle Elevation": "2834",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1870.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "91",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2834",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2834",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529221",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.49292814",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkCba2nkQFQQ9FBA+lh4qhXYhZqVEope9uaOvfydvOfsPMZC2kJzw0Vw0JbOmEKZmmJAsMUkLrbpBk7XB6wyRQXMWzuZI8DKIIOvZhMZdKhf9QLH7Rd2LP8lfxoq6Lxrf7xwqLi3a6hkRwwWCnbemqUezJFQ794EEe8fxGG41l5XoRyimDtdGP0SsFVwGDJRnyqfZuTJc/Aesu4e4LAQAA",
    Pbi3DGeometry:
      "XwgAAB+LCAAAAAAABACVVV1LwzAU/S95zko+1m7dnkQFQR+GCj6MPXQsbIHaSI3CGP3vZrZ1Yfb2JpSW5vTk3NN7k5v1iay2+vX4ociCPJqtfjGl3hFKVkZX9pMs1qf21X1mS3eRhl6QCWds+ftwN2k2/bSbui6Obu6Ey0TmcypFks0ySQVLJM859XEp+CieSRnEF638lIsgGchOOhUtHhS0V7lWn6fpoBsoKqQDue9dzkQapI9l4YzniZAy+0cfgM/qHuwHxUW8OuHSAHwpEm4DgP0KDbCvTPv5xn8REIlLNlTK8fyNLaAA+rA4HhJIFbRkA5xAMiH8ADfQhourf1yhoaYQsBRjessYP8AN1qLi9lHYZhxuuugux/s2zkZdYOdTSGuK627ASYY3zojj0NHdaX2ni3dlVU0WLGGUPKlqbw/d4NnYwmpTdcM3vfv79KD0/mC7wX2pvn3irSmNE6y+yrLZ/ABlre6uXwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "6898",
    Mark: "400",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "31067.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "91",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529224",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.70400329",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjV0LgjAYhf/Ley3Dzbk1u4oKgroQCboQL7RedLC2sBWI+N+bfUB35+M5nHKEvNHH4YaQwd41usCzr21rECLInbb+Dlk5fmRAFGFK0GXCiEg5g6n6Uau+r4eAhmCj6yt67CGLSRzBAW3ru9lQykUEhfO1185CRkkqY6lEwoRUfKFEaE/68g/vULedf/uYswi2Bp/fNaNEinmydsaFM/swZqpea9gc1dEAAAA=",
    Pbi3DGeometry:
      "tRsAAB+LCAAAAAAABADtV01r20AQ/S97Vo12V/vlnEJaKKSH0BZ6CD44RCQC1SquUgjB/70b6yPWZp5WLj0uISEaj9+8NzOa3bl9YTd31ffnXyVbs+vmrvrW1NU9y9hNU+3a32x9+9L96z/OL/wPO2Rvlg88zy+Of/wvO2yGr13u99tn/123ktLYTIqVctxkgq+scDzzZqH0xKys8mahNWVG3k7zidnkBoMIVRQLmBjndAZ5h9iDNw0CQiImy0IC8caaYoYJ4N2H1KoQR/Or2xuIFoU5MQ+8A+8BW1tpKJDATIccQaYhEZNevOZCLWACQgI5A7ZTLi4HhATYSA4tPtI+WnYELc8tLvEoJ9dF1ydc4vZBIMA8z2ShSkAwIieo/DzIefkO5YBaDl019UbzhK48Alk2NSPTB5R4viGQeZrvmJyzUrXsnY+oDHhL7s+CV7OPeQwprcQniRQ9iNKy8+biyJv3INYtL9pC8QCbZjKqLKTteGuLT0CokjZLPm22Qv5DTsC0P0sOKNrorV3nzbnBgxp4o/kNvOfbBxx1YWIjcgLx4J2H7UMXjSaI5IASg9cVNQTFBF3OQCODS47lisogOHQ13WzgnEeHV66I/vbmglIZCQlOEtr87uJHh5zPCbgmvs83yRslFuSEDomwaTngLQZMwCiAFxHA5Bw5MN8kNvCen9+hHCA+gh2MsLR5pc0rbV5p80qbV9q80uY1uTqnzSttXifi0+aVNq+0eaXN639sXpuMfay2P8u23LN1vsoz9qXcPbSP/cPXpt22VbPrH39U9+NHn8vq4bHtHz7V5Z9Tx6umbjzg7qmuD5u/WCwdnrUbAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2854",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "921",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529226",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.28164492",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjssKwjAQRf9l1iEkMU1NXIkKgi5KEVyULlINbSAmUqNQSv/d+AJ3c+aeYW41QtHYw3A1oGAXGluaU9S+dQYQFMH6eANVjZ8xKRIzKehixrDIOIOp/lnLvtdDUtNibfXFRNODIpgg2Bvfxu4FlHKBoAxRRxs8KIqznORSzJjIJZ9LkdKjPf/LW2PbLr6ZcIZg48zje81I6iIzBKvgQnrm785N9RMA9Xlt0QAAAA==",
    Pbi3DGeometry:
      "qRsAAB+LCAAAAAAABADtV01r20AQ/S97VsV+aFe7zqk0hUJ7CG2hh+CDQ0QiUKziqoUQ/N+r2pIrTeZ55R7LYmys8fjNezOzH3P7Im7u6q/P3yuxEh/bu/pL29T3IhM3bb3tfojV7cvxa/+zvOpfYp/9tbxRUl4dPvq32K/Hv73d7TbP/X9DroNTmdG5U9pmWuaFNGUWcqOtO5h1UXJmb1gz8TalP5htoeMgJybBhqnZOQ4b8D55E+wICAkZMYNUkZC2KBjxiAngbYybhjSF0lPzAGJKOfMeeFPvAdsoVXIgxAxCjiAkJGAyiDdehwVMQEggZ8DWIdgFckBIgA3kEPGgT8qh7UdseyQISlx4M09VWNA9oL2JGRCJlJKYeX6RfiV15zEu4xERQwo5eo8tRWpAVh8oOwCJbD1gZRMzKDCfqfP5A4sM9DBZZEBjBISYgUaWtpH2qNwEd7AaFfAZooPXg/mIYYKaqfFHEO3sAjWXaSfYPBOjzeyQM1a5BWcfOFeJWcmRif33nICN8TI5fNF06cuZ9x8deIuOeBOCvDdiwoOgxKIeZMWjBc+3DyoaIAjkgBKjHYmvJc8EtiZfeXDlG3k777kykON2JOj5jgWbNzq3gp/090mlD/PbGh8SYAMzf8KDkCAn8NIMmu18qsA9huQEXbFZbJTByEWLMAGLGyU2onKJHNSDQCWqDl+GyF41F4+YAJA0c70OmWYuHDLNXGnmSjPXua0nzVxp5kozF7dFp5nrNcE0c+HNO81caeb632audSau681T1VU7sZK5zMSnavvQPQ4Pn9tu09Xtdnj8Vt+ffvpQ1Q+P3fDwvql+TR3ftU3bA25/Ns1+/RuItGwcqRsAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "923",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529228",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.08831943",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGk6W/qSVQQ9FBE8FB6aGloAzErNQql9N2NtAriwdvOfsPM5ANklTr1Vwkp7LFSGeq+QQMEMlTG3iDNh+l0hkVMfcH9pYho6PMQRvLNPC/5x6Ig5j9szpxY8a5edV3Zu3732KjyIq3sIGWUEThI09h2Fke0pVVu8iTPqv6gnVRNa1/CYwEnsNXyMXs5p0yIhMAaNbpcc9d6LJ4lnwX6DwEAAA==",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACdlV1rgzAUhv9LrlNJtGpir8Y2GGwXZRvsovSipaENODOcG5Tif1/WaeuipycWUczryXM+zEkWBzJf69f9hyIZeTRr/WJyvSGUzI0uqk+SLQ5/r/Yzm9mL1PSsTDhjs+PD3qRettNuynK1t3MnaRDJMKIyCeIoFTQMAx5zSbu6kPJXZ1KKf3ocHc2tPfXBNOZCpEP0kE27cjLlclQwkFckKU+3WDguJkzSoWRPulszIKueW87FUOlb2cW0ulsEx76N3qG3wWMUhO5GAyUFJgtECbjt1f4y5tpoelm5vxarDtAOvusYwfjJQGmAxY1YA2w/l9DPu9xnIyneOrQGkLYE7SG+r19ojY3dtTCOrw71ArSdIfYQ39svsC1iZ8ZIjJ8M9T3WyMix6eLPsj3T7/TqXVWqJBkLGCVPqthWu2bwbKpVpU3RDN/05vTpQentrmoG97n67hremtxYYPGV5/XyB3nAV1aFCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6738",
    Length: "25",
    Mark: "401",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "93",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2968",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529229",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.40268996",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xhqSGpbV6KCoIsigovSRYshHYgZqVEIpXc30OoN3P0v5ptqgLLFS3hoKOBILZZkgyEHDEpC559QVMMk42Cx4kJkap2nXGV5DiP7Q1d/0Zu+b0Lkx2CHzV173UOR8ITBSTvju9mcyTce48uTveLtVx00mi5CljyVksHe6vc8FQmXQioGW7IUz7qXtWP9AbPOZWUOAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACtld9rgzAQx/+XPKcSrcYffRrbYLA9lG2wh9KHloY24Mxw2aAU//cFtatRj5zrEMV8c/nc5ZJcViey3MrX44cgGXlUW/micrkjlCyVLPQnyVan5td0s4V5SEUvysxnbFF/zEuq9XnYTVlujmbsLPb8mIc05V6UpCkNAo/xhFOjB0ES1fo8Trq6n/q81qO5JQOYszkPeDyG56E/6hbSB+FMDB/kJ4yPciAd4nCTl7H5tnovbWCYgFsr+8wLgzAaYi66nZ2hfRN9x95aLTfHxe/HA/m1p4uwh/hW9q/w64gH8ttbFtyhgNKPsIf40HIBHFea+5scx/mvIgAtL+LQoTgIHbVNoHim2k8tSsA2dNceDMUtO476oLJhMH+vm1AhBG6tcRlFccuooums7SjzRjb3+53cvAstSpIxj1HyJIq9PrSNZ6U3Wqqibb7J3W/Xg5D7g24b97n47hreqlwZYPGV59X6B+NIm7yRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6225",
    Length: "501",
    Mark: "402",
    Material: "Copper",
    "Middle Elevation": "2927",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "319.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "93",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2927",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2927",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529230",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.60266706",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjk8LgkAUxL/LO2/L/lFX7RQVBHWQCDqIB6VFF7bdsC0Q8bu3oYWdur15v2Fm8h6ySp26m4QU9rZSmdVdbQ0gyKwy7g5p3o+nNywox1wItkwiHHIWwoBmUGBOafyPRYFgv2wWOsLiU75q27LzC/xjo8qrdLKFlGCC4CBN7ZpJHK0rnfKjR3lWly/aSVU37i0oCRiCrZbPycsIZnFCEayttj7XPLQeihc2d2CZEQEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACdVd9rgzAQ/l/ynEpirJr2aWyDwfZQtsEeSh8sDW3AmeGyQSn+70tb15nFw7OIYu7Hd99dLpflgSzW+nX/ociMPJq1fjGl3hBKFkZX9pPMlofzr1OzuXtIQ/8kE87Y/PRxL2lWv243dV3sne+Ei0hkWUxlGk1FltOYRSLhMfUUuZRHRZxL7ium4uTAkoTikFoHp+4LIKQQniJNuBxJCQw9lB0++CCrECpOs77EL/KgglB+fuwsEpznwVZ0xB5OR+5VI7Q/ZxDCH/kjUAbQ/7OBkgKThVgCcb3yD8NcSydIC9xdqD7A8egvPmA8dk/6waFOxjQI5kSg7BF8Bk8Wcsv7zSExbjIAOKgRg3LAMIJ60Fcgmh+yB+TwhB59WsBZiPPAcIIuspFTFTAHxLirCsAZc906B3fz3+niXVlVkxmLGCVPqtraXbt4Nraw2lTt8k1vLqoHpbc72y7uS/XdNbw1pXGA1VdZNqsfOi2EiasIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6186",
    Length: "1849",
    Mark: "403",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1179",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "93",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529236",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.49779759",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jMsKwjAURP/lrmNInzZ1JSoIuihFcFG6iHppAzGRehVK6b8b2rqbmXOYaoDipi/9CyGHk7vpEu+kbGMQGBROW3pDXg1z9MpqzWORRBuZ8iSTEsb6r227TvXe9cNeqycSdpALLhic0TbUTiWIGJSOFGlnF3rVjxkGQZwyOKJuWpq6iEMGB4PfRQ9DLqTMGOyccf7cfowZ6x9GbHnLwgAAAA==",
    Pbi3DGeometry:
      "ZhAAAB+LCAAAAAAABADtV11rwjAU/S95riVpm37o09gGg+1BtsEexAfFooGuHa4biPjfl2nsuqzHJCJ7KqK1J+m5J8m99+hkS8Zz8bx5y8mQ3Fdz8VQVYkE8Mq5EWb+T4WR7+CqH6Ui+yM77QQaM0tH+Q77Jbnp87Gq9nm3ks4PED7Mg9LLYj4M48YLAZ2maeC2cp1n2jQc0asNxxPYw4/Lanh4maRfe0MsBGx7I3y0HhYW4oqFZltrI5DzshAHNuXL0Vamo6kgiyg8iw4y1WRo8iJT4hLVxzjnrxJuojHXypLFVXMQP9ai4jAaJlc6Ixifjajrhukz6dR6A2+4DOF0kE5y6IRnQYl0XpW8ySlnEY0xxsCpEj+SAQvwNW2eOY6UcMxbVv20m/OkXdu3FJAc2WQ03FSIqXIhrBYGaOOIxmoGleRj1AI/TcetGqzcGgMNK724MOo3JitGqTLuJdsHS5IzZZtjlcz3aspMYw17G0h1/Nzl2cWerv5ClX8y6XS3d1c3QfNfGb9q33tJ7S+8tvbf0/7d0+af9Rsxe8zpfkyH1qUce8nJZr9TNY1XPalGV6vZFLJqhu1wsV7W6uS3yz/bE66qoJGH5URS76Rc3a0UiZhAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "928",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529237",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.57453358",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjEEKwjAURO/y1zHUaGJaV6KCoItSBBeli1Q/aSAmUqNQSu9u1AruZuY9puwhr82xuyFksPe1KfAclNMWgUDujQt3yMr+G6MyWVDGJF+mgnKZpjBUP23VtqqLbhw2Rl0xYAtZQhMCB3Q6NO8y5WJGoPBBBePdiE/m8k93aHQTPn3OJYGtxeeoM0YTIQWBtbc+vruHtUP1AmQwSaXDAAAA",
    Pbi3DGeometry:
      "ZR4AAB+LCAAAAAAABADtV8Fq3DAQ/RednUUayZK1OYUmUGgPoS30EPawISYxbNdl6xZC2H+vY8uprerJds4iJMRvZ988vRnJmrsXdntffXv+WbIt+1TfV1/rQ/XAMnZbV8fmF9vevfT/th/zy/aHnbN/yIXg/LL70/6y82742tXptH9uv3thNlKIIrN6o6USGdFGWC2yEZ6TUR2eCzvBVW6C8QgvrH3FSSiVLck78HBjluh541kan9MqHhQ/q8dbF9Tp/OGFVTEfRKHkmIfrQo/xIX7AiYp8rNOP/49H64mcd9KTIROLH+z04305c/E+P1oW1LmSn6wI2QPlWzONL6SMdcN7eVD3wG5e2OUkrZ7gglMUX1teYCdYLqQBOLQZyTdcTDa14tNN6m1G2CVzPHOHqn84INwrO/QN4tFuXr7Zw8vF9oRxaDOSLxwuXbykvmtbPzpc8y5eaNHnzaXLS7LDjbHRww3ya9XjOp8cPjaflEUQlzE9MK908QOPVTZUdv9dCt+9TqcwKlouYA/q2tku99IiN1FXIZeRa6jqIC/iQW/AtcVF8XPF9YoIlwV4oM2o6sB+VMW5JvHlo7RIJuBHNsC8czq9PTRXFnifU5LG9rxWuYN7NaSjt04i4a4rUve47diFyTt3tKBFtxvwPsNpgyqJu6yKvHM/GI7UIMtgxyIT4F0urB7QwHBwVQFeomMBVAqeFshioAaJj7eZ35TAYCQSObm2gIAfeAb7BtCD1aaJNk20S97naaJNE22aaNNEG97saaKNX2PSRJsm2jTRTtKmiTZyWU8TbfQulybaNNEGV7vL2HW1/1E25Ylt+YZn7HN5fGye3MOXutk3VX10j9+rh7ePPpbV41PjHm4O5Z9x4If6ULeEx9+Hw3n3F9QTYkdlHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "929",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529239",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.30033081",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNo0+bpSlQQdFGK4KJ0UTW0gZhIjUIp/XfjC9zNGc4w1QjF0eyHqwYFW380pT6FxrVWA4LCGxduoKrxE6My45gQQeeSYSqkhKn+aYu+b4boxmJlmosOugeV4ATBTrs2dC9IKcsQlD40wXgHKsWUJ1yyjDAucyEZQ3Aw5395o03bhTfnVCBYW/34rkmCCRccwdJbH8/c3dqpfgI2Yvn10gAAAA==",
    Pbi3DGeometry:
      "PR4AAB+LCAAAAAAABADtV11r2zAU/S96doO+LadPYxsMtoeyDfZQ8pBS0xqyeGTeoJT89yn+yCxZx7K3V1Ha1CfXR/eee2T53r+Su4fq68uPkmzJx/qh+lIfqkeSkbu6OjY/yfb+tfvXfk1v7Q85Z3+RG0bpbfvH/pLzbrjtzem0f7H33uQbZqTICr3RQrKM043kUmUW59yoC654Lsf4EK+kyhfhWrewKYpQ+GTZnOchGpTOEL80/QHXiq/imcRH5EF1TfCCheRBMgjGzJiGF/kYHsJ9uE/S3sSXsPTJ8Nz8D/sQLoySzqq9lCibpfGQH1SFRFhJf20VFflc+nZ5t7W0MHNOWM0z75zFBoQbgjJHnsvnDP6v3fXlROVGXeLLBnUAdYlCOzYxvFiyE32bQJ7IA2zywEM4aDt0ybycyM3Q/d4uQuVGeXzZYLmgLpl3coqeh/c4Mx2/pkWHs85W1La55eeixbUO5tM/NBD9NVxo1eLMtuMSr6mTpqBGzaUDlmVGKYdGMb3gEJ2IRrUcZ3nFkTeBONCzkAesG1MTnSCeyqhZqOexZcF55h1/a3uL4mFzURcBP+KBWyK2Rf0tjboIXALzRy5BeSIXQh2Q+0GeaBPNt2VygPTyaCm4g9t6OryrSoj590fWswvdhbunGWu5ucmdVnmvNvAsQ4sGU7ySS97BrFs0Eu2mgtSCZo3U7xUKtA1yRPL23k9i7zPoZdjrENr0SFyYTrjSMIqcCHRBz7Fw+MrORQVw9cJjZ5gdlJqm1zS9pul1BX2aXtP0OmOTNL2m6TVNr2l6TdNrml5n3x/T9DpXf5pe0/Q6Zg+UusvIu2r/vWzKE9nSDc3Ip/L41Dz3F5/rZt9U9bG//FY9Xr/6UFZPz01/8f5Q/h4Hvq0PtSU8/joczrs/tyK4oz0eAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "931",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529241",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.47717787",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGkSX+knqQKgh6KCB5KDy2GdiFmpUahlL67wVYRL9529htmphggr/HYXzWksKMaczJ9QxYY5ITW3SAthun0hpDLeBmIiMtFomBk30SFSv1lKha/bE6cSPmuXXVd1ftu/1hjddFOd5AKLhjstW1cO4sDucqhnzvJE54/aKuxad1LxDJisDH6MXul5IEUCYOMDPlcezdmLJ9PKd91CwEAAA==",
    Pbi3DGeometry:
      "PQgAAB+LCAAAAAAABACdVclqwzAQ/RedVSPLdr3kVNpCoT2EttBDyCEhJhG4VnHVQgj+9wpv8aLxyMXYSE+jN29GM/LmQtZ78X7+SklCnuVevMlMHAglayly9U2SzaUe6mW20g8p6RW5cRlbVR/9knLbbrsrit1Z7/UdfktdFjg81gPOHTdwY9qhHveiCuUs7KHMDWs0jijG0NqGvoE28ngPDQLXVoLZGRKEjbd5DUMGP4inobXgIDdAHofOPN/zTPm94kOWDh+FPbWvZU/5K+EoDUo/kgOGBeGATNDvIO94tP+VMw5reLK4TFPlW9XtPIUFCOXEXM6YNUBt5RE4tPm+WkSBg9CJY11otgaorTxCtbTkSsI4bFCo1s23FWYNcdv5hG69+ZtzGYcNCvUz0qLIX28cew/X/+IHsftMVVqQhDmMkpc0P6pTM3mVaqeEzJvphzh0S0+pOJ5UM3nM0t++4b3MpCbMf7Ks3P4Bjay6Vj0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6744",
    Length: "25",
    Mark: "404",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "94",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529242",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.43671273",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jssKwjAQRf9l1iGkLw11JVUQdFFEcFG6aDG0AzEjMQql9N8daPUP3M19MOdWI5QtXoaHgRyO1GJJdujIgYCS0IUn5NU4n1xIZaoyvYlUJpM40TCJP2T1F731vhmYz8YOm7sJxkOupBJwMq4L/SLOFJqAPHmWV7z9ooPBrmdIJFc6WwvYW/NeurFibsJeQZb4r3tZO9Uf74XW5A8BAAA=",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACdVd9LwzAQ/l/yHEuatOuPPYkKgj4MFXwYe9hY2AK1kRqFMfq/G9a6ttnOS0tpab5cvvvucrksj2SxUW+HT0ly8qQ36lUXaksoWWhVmi+SL4/Nr51mc/uQmnbITcjY/PSxL6lXf8tuq2p9sGujIBJJSEMWB4KLlHIesDSLqMVZnJ5wnvFZH+dJ1tizMOnjEM/ZPoqza/wijsMeLpJoNkoP5BeLy9MvqsflSUVyLd4Od/IGxAX6HeafWQJLfMHT4cM8XNo3+jt8uF84D8bv6HHiQnFQJ+DXyT/KM1mPG9dwfyGd0LmA8o/b+9U/vr9QnoE69+SZ3AfA/ULP17/8aJ2AuF+dQHrG2o/tS1Adov3Hkwevc6j/QP3Nj2dy/wT1QPcXhPvx4Lhf/8T7vJ99g9v7/l6tP6SRFclZwCh5luXO7NvBizZro3TZDt/V9jz1KNVub9rBQyF/+oZ3utCWsPwuinr1C/9owC2hCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6219",
    Length: "514",
    Mark: "405",
    Material: "Copper",
    "Middle Elevation": "2933",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4875.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "94",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2933",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2933",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529243",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.48832835",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyGkSRq0nqQKgh6KCB5KDy2GNhCzUqNQSv/dYFsPInjb2TfMTN5DVplTd9OQwB4rk6HtanRAIEPj/B2SvB/PYJBUSi5WEZM0XigJA/nBYspVJL6YUMt/bM4s5up125Zd6A+PjSmv2usWEkYZgYN2tW8mcURfehMmj/JsLh+006Zu/FsoHhPYWv2cvJxRERFI0WJIdQ9rh+IF9xw4UA0BAAA=",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACVlV1LwzAUhv9LrmtIm/Rj3dVQQdCLoYIXYxcdK1ugNlKjMEb/u52Nrt3JSTPGxvL29Mmbk5OT1ZEsN/L18FGSnDyqjXxRldySgCyVrPUnyVfH/m/3mM27D2mDs3ITMjb//em+pF3/vbZomuLQvSuoYHEWhEzQOEtEEDHKw0BQnopkrIowOukZTy+iZ6d4O0VE6cwazdPQRoeUNIodbpBZ7eqVc6I6xgFrTTi3Zszo3msyOeg5MY2SkA9yaTgDfcQZxp/dw+jePaAjFKvq72SUYahjHu1egPM+v/4UtxtsVXA/RvNi9QHjkbqZWBfke++s4bjzAOvezcHi4brc5w3mHzs/iD7BAf5RHdt3d2fEOB6ddCLeXYegx6K6dz2PONd1hsvbxM2wR/veMa6uABmY7tlbRhSoY2fQuydM3I82992dfieL91KXDckZZQF5Kuud3pvBs9KFlqo2wze5/X/0UMrdXpvBfVV+DwNvVaU6YP1VVe36B3ZXCWCFCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "206",
    Mark: "406",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "94",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529246",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.23262329",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjFELgjAUhf/LfR5jzhlmT2FBUA8iQQ/iw6yLXlhb2ApE/O+tMujtnPN9nGqEoqHjcEPIYO8aKvHstW0NAoPCkfV3yKrxG4OiuBJJuopEwmMZpzDVP23d93oIbhg2pK/osYdMcMHggLb13btEkVowKJ3Xnpyd8Yku/3SH1Hb+04WSDLYGn7MuJRfpUjHInXHh3T6MmeoXfeDPicMAAAA=",
    Pbi3DGeometry:
      "pRwAAB+LCAAAAAAABADtV01r20AQ/S97Vs1+ylrnFNJCoT2EttBD8MEhIhGoVnHVQgj+711kraOd7PNKh9yWkMR+Hs+8eTM7q7l7Ybf3zY/n3zXbsC/dffO9a5sHVrDbrtn3f9jm7uX00n3Mr9wPOxavyAfB+dXwx/2y49Z/7fpw2D277+qV0koVgpuVrKQspFwJI2wxxa3WA14JPcWVcS8iOLSXqhpwq8o5flRpzEU+UoZxAf+zf2oP/KC4kE8qLtJBcDmLT8hfc1MFcXllB/t1GfoZ8bO95+9x5zfwT3HkB8UlfhAfVWoR6JDiA+LCvPTaXPRP80rFJf5hXkgH1D+V5+lxBc7F2A+ejm8f7nSc0Vao/SmO6KTKS/EUTRIWdANys5QNyAoW19ufDzUpCj2kqBmSflLDdu6wIlUHsgEYiZ8aJXQEoGxTR4XiKNs4fe3EO+HcnsKWIj5RTxNY85G9Hd2YAZXck6+irUOSWioC8h9no6z7F+S6tmW04BY05szb2LEZNSuXa4PviCU5ofppKYi90ubSZEf2iCWyR3yAH9hnqC9TtaVDIT1EwhqifFFe8WrBvo9aAy6wX5P9HT41vXJXlYnV5M2tXXl42sepcU+vB9/3ythoxR1uIqcnjAqv1OTNj55ASVSgDXwCRecwrhlSOK1NWMG4Niin1NPbGzbxs4wv/miuS3NCXRn3juqE6pGaZ1QDxAZpkze+vPHNus3zxpc3vrzx5Y0vb3xLRMgbX9748saXN75J/fLGlze+S/V4z41vW7CPze5X3dcHtuErXrCv9f6xfxrffOv6Xd90+/Htz+bh/NHnunl86sc3n9r639Twpms753D/t22P2//l5sD/pRwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "933",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529248",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.52675985",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yzinG7TTlFBUIcxgg5jB1eyCaaxLBhj3z17g27Py+/hqScoW3MYrxok7HxrKn0KynVWA4LSGxduIOvpIyPCMCO8WCSE45SmBczND1sOgxojG4O1URcd9ACSYIJgr10X+pdJEpYhqHxQwXgHMsE8J7nIUprlghUii+3RnP/hrTZdH96eMIpgY/Xju6YEUyE4gpW3Pp65u7Vz8wSEusD50gAAAA==",
    Pbi3DGeometry:
      "vRwAAB+LCAAAAAAABADtV01Lw0AQ/S97jmW/k9STqCDoQVTwID20GDQQG6lREOl/N3STtNnuyyZ48bCUlmY6ffPm7ezOztMPuV3lD9/vGZmT63KV35dF/kwiclvm6+qDzJ9+zNf6Z3pav8g22ltOGKWnu4/6TbaL9m9nm83yu/6vnEkZq4hRNRNcJBGnM0lFHNV2oYSxKyEO7CLWTjvyl1Qlxq6VGoEjtGSDfHgq5aEd8O/wbX+Ag+JCPr64SAeecD6GD+LfxuWa7fCFZLyH09pj2uNv+e/xWztjsROnsYO4xzgmLuKz16G1Jzwd4oPigryO8HmaqoG8UFyIj3QGOvjripp9IdSOJ1z3Lq9YM6NbOlBWCAbavXTGpQto+rPqV4MXZqr4VlZocbtN3feHhw8qcoTjO2xHHlbwMPEVCTBb4vuymqzayKPBm22fPqdNWCGMWbAe/eMO1XQiro17ynbsmeyz4VqNWcOxKiB8QKfrl4o1MEwP9NGBbN12yVrVkr+og9rExKzQGnb+VEsTVmlXybanO/JHNJG/r6ZQt7RV9uZl6YAOBlxUaBXdPHFe7lWHOxoUiZsNqlmgArwTpvUOc7CHvTt20oRXIdj7KHfVfm1nrnR9YVETgnb7ZgnC+tSBN3JbfTd9KDJSBywigndnhXY6vCeCHY0XF9GZlhUU3w0P3P2nvpUVWhQvvnXehekvTH+ufhamvzD9hekvTH+OrML0N0WFMP2F6S9Mf2H6C9NfmP7+1fS3iMhFvnzLqmxD5nRGI3KTrV+q1+bhrqyWVV6um8fH/Ln76SrLX16r5uGyyL4OHc/LoqwB159FsV38AmMnUUS9HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "935",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529259",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.25860196",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jssKwjAQRf9l1rEkTdKXK1FB0EUpgovSRdShDcREahRK6b8bte5mDufO3HqE8qyPwx2hgL076wovXtnWIBAonbb+AUU9/sagZDziTMjlgvEokSKFqfl7q75XQ5AD2Gh1Q489FDSiBA5oW999FiZESqByXnntLBQ8ECbzOJFcZnmac0bgpK+zTDNOYIe67fz3UsIEga3B15yOaShDJYG1My48s09jpuYNIMSoydMAAAA=",
    Pbi3DGeometry:
      "PSMAAB+LCAAAAAAABADtWEtL5EAQ/i99jkO6O8/xJO7CgnsQFTzIHEYMGshOltm4IDL/3TDmYbrzdVX0Js3gYKqm6qvqenT47l7F5X158/K3EGtxUd+X13VVPohAXNblrvkn1nev7/+26vC0/YhDMEpOZBieHr/aP3HY9GZn+/32pbXN9EpnSR6cSL1K4igNVLjSqcyDiSJNoqMiUUAh85hpkcXvikgqpqs+KhkaCq3nIWAalAFC4IdEnqDlCkEocEzTHFSk1CzyqKAMuhxGhRGqrViMbXlCMU2T/kqsMCSj/xjZQQyUBcra7BoZxUR6UMFtTASB+o9OgujLpX1M+KczNuT0mRIA1nJACSz1Y8itQIltRQNw1x5ERgr+LrGgTYVOsm6o0s6Tdt8bpAE3CR3F8xtgwdXUB0W7YqaB91We6s6gFRwtksRdJGTB2Ink6rMU5hbN9PwZYlfQAmbOP3VrSbAtIIaW6TQqGWduBb16TQV0Rb93mHcUvx69Ra70pENVKN0GNARUsC9CMqjFBmbBe+hUGdOksoncXJ69fKhdoqbyfF6O/CDcsTyz8QxV6OVDv4J4AC7Mqx8Iyv+46Hi4Y8Hm8wLngKcKA8x3BJCzA0WFIccDBeQwcCMYpYFyqoX4Sx0WDV1B5G2G2hFe79bcQGhikLkI8E0EybEf3uSQLxsI2GHgRjBnnDv75OXJjmjYmp++bc39tXRfOKBBrJ498eyJZ088e8JKwrMnnj3x7IlnTzx74tkTAsKzJ5498eyJZ088ezL149mTb8KebALxo9z+KZpiL9bhKgzE72L32Dx1D1d1s23Ketc93pYPg+pXUT4+Nd3Dz6r4//GH53VVtw53z1V12LwBo34D8T0jAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "9",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "22",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "941",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "Overall Size": "15 mmø-15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "9",
    Size: "15 mmø-15 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529267",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.0874959",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNJ00eauBIVBF2UIrgoXUS9tIGYSI1CKf13o9XdzHBmph6hPOvjcEeQsHdnXeHFK9saBAKl09Y/QNbjLAOyiJMoLWixFCxiIstgav7cqu/VEOAQbLS6occeJI0ogQPa1ncfwyhnBCrnldfOgoyjjFMu8oTlXKSFyHMCJ32d4ZjTgsAOddv5r2eJILA1+Pq1WRjkIiGwdsaFM/s0Zmre/UAzzNMAAAA=",
    Pbi3DGeometry:
      "0SUAAB+LCAAAAAAABADtWE1r20AQ/S97Vsx+SlrnVNpCoT2EttBD8MEhIhG4VnHVQgj+71X04cS7ejsr97oYG2tHM+/N7OzMMrfP7Oau/v70q2Jr9rm5q781u/qeZeymqfftb7a+fR7+dmJ+3X3YMXtduRKcX/c/3ZcdN5Pau8Nh+9TpXgm10iUvMytXylqRSb7SXImsF6ji7boqzdyytIUOvi7KM/NKCxm24/CRhVW9wEidzyIgB2IVIALNKTZ4J0sQwmhZzMYJejEgCCvs3D5M667T07rL1LczbtzJkLNx0QCTA5SCtw0+pVgNMkYwGEsRpm3zokQ6Ia0xs7m0PB4wLT0MnH4Ig3Tw8kyOx/BZUSfV9zwWw91Z3w3KP88SUYcmrmThok7S4groIZOU4ssKrozG9gLN9WBJleF+g96HCNC7qReZQp+XtMgm5TU1z9CFPvjh07nofci7F140rKS2jtKgKv8r2U7xxZAuZL+e55boCKNAKpU74UCmIFnACTcjhBA2NLPTgyGl1cBImJy47yCF0TeleE9JltaGLUEFqlX4hR+Sgn7DVKZYzYAD/3B6oCvMcFyk4fkgKPOwAkSAeYOaLY45JAVNLXVDFV0S9yHvLIQEUzZP614xoC25230xhDSiCCmcwuEqeJxIDRcCeofJLoXwMgp6ARMHYgfyAwj+I7YeXXwoESukQYNH94XosEc3K2zJI4V6Eswq2IuxBomB8tD1GzdQFJDlZPFNDQii6xE6yREXLMQJaZDQPgToodG1M+KOQLKNbse4vCwvSBQG2Zgi7jQwJGkOleZQaQ6V5lBpDpXmUGkOleZQaQ51fj9Kc6g0hwqSSnOokEKaQ6U5VJpDpTlUmkOlORQIySZjH+rtz6qtDmzNVzxjX6r9Q/s4Pnxt2m1bN/vx8Ud9fxJ9quqHx3Z8+Lir/r598X2zazqD+z+73XHzDwhtGV/RJQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "949",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529268",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.59467631",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkadpqPYkKgh6CCB5KDy2GdiEmUqNQSv/dYFsvCt529g0zk3UgSzy1NwUp7G2J0uq2sgYISIvG3SHNuuH0hlkQ0ojF8+UipiJmHHryC3IqeBR8QRGJ5A+cYvOpftU0Res3+McGi6tyqoGUUUbgoEzl6lEcrSsc+tmDPOPlg3YKq9q9hQgSAlutnqOXMxpyJgisrbY+1zy07vMXPDWfDBMBAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVl1rwjAU/S95jiWNTbD1SbbBYHuQbbAH8aFi0UDXjK4biPS/L7Rdlkhue4so5p7er5N7j+6uZHtQb5fPgmTkSR/Uqy7VkVCy1apqvki2u/ZfDczW5kVa+m9ZxIytuw/zJu3+z21T1/nF+C7iZZSkQtBURolknHIWLbkUNAgIkfbAiq08QPJxu5S4OJwlHSBY7HskMZ8oCWwCygEWdWO3gZB2G0ekKa4HsFSIVttCB/Ao4SL2HLoMjt1nyQH81C7gshSKhE3tD1MgUn/XDmB5ukntEY4pyfbQ3QQigzcCs1iay8bEgINXB04+SGwgB8w4mBzqD5rY8UCQw2ypCVSE3OrJzpCj4W97iFNQBkYjQQ6zhGZ07udIHHaBoBVFLhCk0mAkhKxPO4A1oX8Xp9tDq6IvEAHK8cqB1Bq/D/MP4V7lH0VT1CRjEaPkuahOzXk4vOgmb5SuhuO7OlrosVCnczMcHsrix33wTpfaBKy+y7Ld/wK7SUav0wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.1 /",
    "Flow State": "Turbulent",
    Friction: "5995705.54 /",
    "Friction Factor": "0.015521",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "1230",
    Mark: "410",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7374088.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "618582.9299",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "41",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "90.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529269",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.68446031",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm2tu9hQVBPUgEvQgPmgNHawtbAUi/veG1tv9zvkOtxwhb8xleGrI4OQbU+hbqF1rNSDIvXHhBVk5LmdUVjTBXBK5UQwnSlGYqr+37ft6iHIM9qZ+6KB7yAgmCM7ataGbgQkEhQ91MN5BRvE6JakSCROp4lKJ2F7NfXEp5RGP2rRdmJlwhuBg9ee3ZgQzqSiCnbc+/nJva6fqC+cRInrSAAAA",
    Pbi3DGeometry:
      "/RAAAB+LCAAAAAAABADtVl1rwjAU/S95riVNk9ro09gGg+1BtsEexAfFooGuGa4biPjfV7TW9eOQRPcyKFJtcrz33OR+TndkslCv24+EjMijXqgXnaol8chEqyz/JKPp7vhawHRcfMjeO+8MAkrHh6/iIfvZSexms5lvC9lBEPo8ijzJfM5E4DHqhywS3mE/pnEdoPwICClrAA9Yt0RU7jcYhJAGRdYMlU1SiO5TIEDQIOrmaEpU5qLjQWuhJghYq6rOx8ODRCjlERjGNWOrfRmG3QKUcwPA4mENqIxy5RYhk3aaTtwiGEZu1mKOhlUsLn4vI7fmOJ+8qaq8KvsorOIWcWOjoCp4PnjrMP/g5SIJzAFDHeWfKWHbOQABpAr6z9Wv2H1QAlBcUERQHYYJDgGkCVUEQ6VoudTkuZYAIkCGwkA2dEMY4G0AaXIvwNCh0D9QAnIga2GUOTd1577qzOA8yTiPEzhLrx8n3K0y34jzdGDd683TgXP1vaDZo/ILq6yps/3FdGDL0U8H/XTQTwf9dPAvp4OZR+7U/D3Jkw0ZUZ965CnJVvm6XDzrfJ4rnZXLN7WsoIdErdZ5ubhPk+/ff7zVqS4UZl9pup/9ADdMkqH9EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "950",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "8",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "86290.2",
    R0: "16",
    R1: "6",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529270",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.53409348",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm2tu9hQVBPUgEvQgPmgNHawtbAUi/veG1tv9zvkOtxwhb8xleGrI4OQbU+hbqF1rNSDIvXHhBVk5LmdUVjTBXBK5UQxTRRVM1d/b9n09RDkGe1M/dNA9ZAQTBGft2tDNwASCwoc6GO8go3idklSJhIlUcalEbK/mvriU8ohHbdouzEw4Q3Cw+vNbM4KZVBTBzlsff7m3tVP1BYe0bB3SAAAA",
    Pbi3DGeometry:
      "9xAAAB+LCAAAAAAABADtVl1rwjAU/S95riVpk9ro09gGg+1BtsEexAfFooGuGa4biPjfV7TRtfYsTbeXQRE/kuO9597e5N4z3ZHJQj1v3xIyIvd6oZ50qpbEIxOtsvydjKa7488CpuPiRfbeeWfAKB0fPoo32c+M2dVmM98WtgMW+lwK4cnAZ5GQXkD9MIiEdwBiGlcByg+AoCyqAJwFzRZRuV+nEMX3j57aU5igeBQ1Z4H2hZTNDDUDEytKDoeKHIH91o5MCoINj4BkR2AYVyM1+zIMmw0o5xYgDGQFOBXIlZsH8bCdJ8PNeSjdooUc9aiCWLKO5K05zpnXXZlH1fYEno4spIYA8gSzgwC8d+jRYgvIgaJFbcV2Uy8qAQHkCZXOuaSwQtACUTh3D9h84d1GAHYFuoG1S9Qraq1cvfkiAhQpPpXWMQgP+AWAXHXov3BAwuJBC9jqYOboVjiPc9eZ2oHBWcW4Kwl4VX8tJZxjsgsoZ23QetJbtUGH/us+6lF7hI3WOtn+QBu05ei1Qa8Nem3Qa4N/qQ1mHrlR89ckTzZkRH3qkYckW+XrcvGo83mudFYuX9TyBN0larXOy8Vtmnx+/+O1TnXhMPtI0/3sCx72aJj3EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "951",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "8",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1287191",
    R0: "16",
    R1: "6",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529272",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.63147394",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NIkzRp6iQqCDqUIjiUDlVDG4iJ1CiU0nc3Wt3uju/uqhGKszkOdw057P3ZlPoSGtdaDQgKb1x4QF6Ns4zIImGYZyRbco5TRRlM9Z9b9X0zRDgGG9PcdNA95AQTBAft2tB9DCWSIih9aILxDvIEp5JIJRgVUvFMCYHgZK4znEiSIdhp03bh6ylTCLZWv35tGgelYgjW3vp45p7WTvUbYbp5cNMAAAA=",
    Pbi3DGeometry:
      "uSUAAB+LCAAAAAAABADtWEtr3DAQ/i86O4usl+3NqTSBQnsIbaGHsIcNMYlhuy5btxDC/vcqfmwSjz+PvL2KkBBLmvm+eWhGzO2zuLmrvj/9KsVafK7vqm/1rroXibipq33zW6xvn7t//ba89D/imLyuXKRSXrZ//K84bgaxD4fD9snLXqR6ZXKZJ8asXGGLRMmVkTpN2g2dvV3XuZ1aVkVmZo+n+Tv12qRqXs+Ij8oK3W5YZdwkAjIgVAAi8JxCnXfSBCGsUdmkn6AVHYLJ82wqDsP62OhhfcyU6ukDd1I0ClwwwGAAJ0DCQCmFSrA+gs5YijCEjXiJNcIWSk/m0nJ/wLQkGDj9EAZr4PmZHI5BWXE3lVoeijGOLDWDs49oYurQwJUtXNxNWlwBCTJLKbys4MroF142dKY6TTqf7zfoPESA1g29yIfwfUkLbFKkqRFFZ9pA3Wdc2tpgM9dKFIoLHSfBVf5Xsl7wRZEx7bJzBdMQ+g2rpRl5A2iCVAEj3IoAwLyeiTB3epyRHaHUOuaxgwR605zqClZeFPOK0HmuS9CaDylBq2EWM6QmsIF1ODPQ46W7KNZkptvI3bwARIA5g9osdjkkBVUtNUNnvjC0BcJ7fm5jSOVhnZQBXtM42mdDWONPzgic3DEWIJxYiTEEtA6TXQpBMgpaARMHYs/kB9j4D98SuvhSIlZIggcPbQnBXg/tUlgRoYS6Ecwp2IOxBIuBsnBsNm6dwB/LueIHGtgILkboGge8qxAnJMFCUwjQP4MLZ8DrgGUb2opxaVlejBgItifxjxnojzh7irOnOHuKs6c4e4qzpzh7irOnOHuKs6c4e4qzpzh7irOnOHta9EqKs6c4ewpqxXH2tEnEVbX9WTblQazlSibiS7l/aB77j691s22qet9//qjuT1ufyurhsek/rnfl37cHP9a72ivc/9ntjpt/agBpDLklAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "953",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529273",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.01759574",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzEkadpqPYkKgh6KCB5KDy2GdiEmUqNQSv/dYGsviredfcPMZB2kJZ7am4IE9rbE1Oq2sgYIpBaNu0OSdcPpDTMe0JBF82XIqBA8gp78gFLSWPDFF5ShjP/DKTb/1K+apmj9Bv/YYHFVTjWQMMoIHJSpXD2Ko3WFQz97kGe8TGinsKrdW0geE9hq9Ry9gtFAMElgbbX1ueahdZ+/AHWGBeETAQAA",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVl1rgzAU/S95TiVJjav2aWyDwfZQtsEeSh8sDW3AmeHcoBT/+9Q6l0iuXiktzT3er5N7T7u9kM1ev50/FUnIk9nrV5PpA6FkY3RefpFke7l+rWG2rl+kov+WBWds3X7Ub1Lt/txuiyI9174LvgzCWEoqWSAEj6hgwVJEknoBKeMrsGIrB4jEuD2KcHEEC1tAMu56hFxMlAQ2AeUAixrY+0BIex9HxjGuB7BUiNa+hQYIw+BG8NhxaDLYdoclG3BSO4DFkjcSNrUzTL5I7V3bQM/TILVNOKqkvofmJjAZ7BGYx9JcNsYHHLw6cPJBYn05YMbB5FB/0MSOBoIcZkuNryLkVk92hhwNZ9u9nIIyMBYJcpgnNGNzP0visAsErShugSCVBiNhZH3aAawJ/bs43R5aFR2B8FGOVw6c1gz6qP8h3Ov0Q5WqIAkLGCXPKj+Wp+7wYsq01Cbvju/60EOPSh9PZXd4yNSP/eCdyUwdMP/Osmr3C4MK0hHTCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.8 /",
    "Flow State": "Turbulent",
    Friction: "3176205.23 /",
    "Friction Factor": "0.015926",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "1676",
    Mark: "411",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5324227.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "444463.2904",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "55",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "65.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529274",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.9082967",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm3Nu9hQVBPUgEvQgPlgNHawtbAUi/veG1tv9zvkOtxqhuJrz8NSQw9FfTalvoXGt1YCg8MaFF+TVuJxRWdEEc0nkmnMsVKpgqv/epu+bIcox2JnmoYPuISeYIDhp14ZuBiYQlD40wXgHOcVpRjIlEiYyxaUSsb2Y++JSyiMetGm7MDPhDMHe6s9vzQhmUlEEW299/OXe1k71F8/V+jXSAAAA",
    Pbi3DGeometry:
      "/RAAAB+LCAAAAAAABADtVl1LwzAU/S95jiVpk7bZnkQFQR+GCj6MPWysbIHayKzCGPvvlq3r7MchzfRFKGVlyem95yb3c7ojk4V+2b4nZEQezEI/m1QvCSUTo7P8g4ymu+PfAmbj4iF7et654oyND6/iR/azk9j1ZjPfFrJXPPBEGFIhvMjnivrMC/xQ0sN+zOI6wMQRkErVAMH9bomw3G8wSKksinozVDYpKbtPgQDJeNjN0ZSozEXHg9ZCTRDorao6nwgOEqGSRyCKa8ZW+yoIugWYEBbAj6MaUBnlyi0DX/XTdOKWPArdrMUcDav8WPELyXtznE/eVFVeVf8orOIWcWOjoCp4PnjrMP/g5SIJzAFDHeWfLWHbOQABpAr6z9Wv2H1QAlBcUERQHYYJDgGkCVUES6VoudTmuZYAIkCGwkC2dEMY4G0AaXIvwNCh0D9QAnIga2GUOTd1577qzOA8yTiPEzhLfz9OuFtlvxHn6aB3r7dPB87V94Jmj8ovrLK2zvYX00FfjmE6GKaDYToYpoN/OR3MKLnV87ckTzZkxDxGyWOSrfJ1uXgy+TzXJiuXr3pZQfeJXq3zcnGXJl8/P7wxqSkUZp9pup99A3Av/Tn9EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "954",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "8",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44549",
    R0: "16",
    R1: "6",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529275",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.3259649",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUEKwjAQRe8y6xiSNDZJXYkKgi5KEVyULloNbSAmUqNQSu9uaHU1/828z5Qj5I25DE8NGZx8Ywp9C7VrrQYEuTcuvCArxyVGZUUTzCWRG87jlAKm6u9t+74eohwXe1M/dNA9ZAQTBGft2tDNwFIEhQ91MN5BRvFaEKHShKVCcanSeL2a++JSyiMetWm7MDPhDMHB6s+vzQhmUlEEO299/OXe1k7VF3Vib7PSAAAA",
    Pbi3DGeometry:
      "9xAAAB+LCAAAAAAABADtVlFrwjAQ/i95jiVNk9ro09gGg+1BtsEexAfFooGuGa4biPjfV7TVtfZbmm4vgyKKyde7766X3H3THZks9PP2LSYjcm8W+skkekkomRidZu9kNN0d/+YwG+cfsqfnnYHP2Pjwk3/JflaaXW02821uO/ADTygpqRCeCPmQcuYFPJT0AEQsqgJMHADJ/LACCJ83W4TFfp1CSvWzp/YUZVAiDJuzQPtSqWaGmkEZK0oOh4ocgf3WjsoUpD88AlF0BIZRNdJyXwVBswETwgIEXFWAU4FcuQXPN1p5KrmFCJRbtJCjHhWPlN+RvDXHOfO6q/JVtT2BpyMLqSGAPMHsIADvHXq12AJyoGhRW7Hd1ItKQAB5QqVzLimsELRAFM7dAzZfeLcRgF2BbmDtEvWKWitXb76IAEWKT6V1DMIDfgEgVx36LxyQsHjQArY6mDm6Fc7j3HWmdmBwVjHuSgJe1V9LCeeY7ALKWRu0nvRWbdCh/7qPetQeYaO1TrY/0AZtOXpt0GuDXhv02uBfaoMZJTd6/hpn8YaMmMcoeYjTVbYuFo8mm2fapMXyRS9P0F2sV+usWNwm8ef3B69NYnKH6UeS7Gdf3DtmnfcQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "955",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "8",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "611718.9",
    R0: "16",
    R1: "6",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529278",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.9764755",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjjELwjAUhP/Lm2NIk1hjnUQFQYcggkPp0GJoAzGRGoVS+t8NbVW6ub1733F3aQuy0OfmriCBgyu0dKYpnQUE0mnrH5Ck7XAGA2d4OedsNYsYjgUR0KEfFAxTTukfkIp4AiexPcw+9eu6zpuwITy2Or8pr2pICCYIjsqWvhrFyfnc6zB7kBd9/aK90mXle8GjBYKdUa/RSwlmlHAEG2dcyLVPY7rsDfRO9uQTAQAA",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABAClVl1LwzAU/S95zkqaj85uT6KCoA9DBR/GHjoWtkBtpEZhjP53s1q1s73tzaSsNLkf59zc5GTLA1mszdP+VZMZubNr82hzsyGULKwp3BuZLQ9fn97M5v4hFf2dmcSMzeuX/5Fq9R12WZbZ3sdKEaVKCjqJRZQkqaScRUKplJ4YlJzWBs4k7Y3giUIapkrVBhnz/ogO+CirhCPZAnmESPspASUA0xCd0DUdznOEvRARl5x3V/rE0AbojThSwhnaTfsneKs6HDYA0G5ajz+QpjMN0QFQR6r9mwXs8eiCDp4CXASIgQKH6oO2Ko4TlAgTgGIEpDmr+9g9BOoHYo+GCNGgP47RqKKFnLHQ0wEqXUckRhQWEPZBfxwj1H0WprJ4wQavRpT8ht2yPsL/F7g22Yt2uiQzFjFK7nWxdbtm8GBd5owtmuGz2fyYbrXZ7lwzuMn1R9vxyubWJyze87xafQLb3zmRvQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "1.5 /",
    "Flow State": "Turbulent",
    Friction: "254856.75 /",
    "Friction Factor": "0.018735",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "11975",
    Mark: "412",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3051897.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "116079.7597",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "66",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "17.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529284",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.09128514",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1zE0LwjAMgOH/knMt/XBT50lUEPQwhuBh7FA1bIHayqzCGPvvVp23JO9Dyh7yMx27O0IGe3+mAi/BuNoiMMg9ufCArOx/YySSi1Tr5URqnibTGQzVn63a1nTRxsOGzA0DtpAJLhgc0NWh+SwyTRIGhQ8mkHdjPtF1rGohGeyQ6iZ821wpBluLr5ErwbUQ0ay99fG7e1o7VG/p4Y7jwwAAAA==",
    Pbi3DGeometry:
      "LSIAAB+LCAAAAAAABADtWE1r3DAQ/S86O0ay5I/dnEpbKLSH0BZ6CHvYEJMY3HXZuoUQ9r/XZOWNrdXTjNOcWhES4rfjp6fxaMb7rh/F1U3z9eFHLdbiY3fTfOna5lYk4qprdv1Psb5+PP47fCwvhx9xSJ6RCyXl5dOf4VccNuNtb/b77cNwr0xXlcyTC6XTIjdlkslUS6mSKV7pI66yzIuXUrPiV3n1hBvF4xn1VNkcz/LCy4/0U/GIn6uHypvLg/iVLrz5mepXqTLFOb0HdqKnImmS6aN6MTfQPU0jDQOSaQ7p7QCBxJIOCVAyfWoqlYXWf7PNUM0hdlRb9JaoiltaoQF6xl7nLGQmCXb3tCPtC2nmVXAuMtR8GPQ8Gv+yGOceSXdVh11rY4+ZyS3NCnZ+TjxPvcwGuuAEoSaL1UPycPTDtiKrwsovS4uXwYcF4rktG4wDB3Y6uTRmSYcH4XCr7Ay7Z58Tj/gH3MhsrqfMgzjZR52+6+XhvBs4A4mbfrvdlVbzAhzuC4w7ih3AnBnDELMw3NmqNscMl7o0QdzpgCd87FGAZ6ycE24rZyn/KtO8+DENbrwz3cj4sReBfSGdC/lPtePmh9KPqudsXX85QHxpPgEOOxgqTxhP8Dt54+cz3Gn5emydoM5MDSdUP2hGu/GInzovXH4wiyHO7g/ofIXeGQLrwniC360Tdr8iJiNbj+V56SR1z+nS/oD4vTr/J9cCfUviuhmv5Vpw3AnGd8J/zLUAu1xmZryqaxG0J4Du6FpE1yK6FtG18L0YRtciuhbRtYiuRXQtnsshuhbRtYiuhadOomuBXYtNIt412+91X+/FWqYyEZ/q3V1/by8+d/22b7qdvfzW3J4++lA3d/e9vXjf1r+ngW+7thsId7/a9rD5Az/9nngtIgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "963",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529285",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.06787639",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsELgjAYxf+X77zGnEOnnaKCoA4SQQfxoDTmYG1hKxDxf2+pFZ66vff9Hu97eQdZpU7tTUAKe1upzOpWWgMIMquMu0Oad6P0gUUQYkZ5vHyLiBMOPfpRgpOIJf8Z5dGMzVsHWnzer5qmbP0Gf9io8iqcaCAlmCA4CCNdPZmjdaVTfvZoz+ryRTuhZO0Gw4IYwVaL55SlBIeUMARrq63vNQ+t++IFu2AlVRMBAAA=",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABAClVl1PgzAU/S997kj5KAh7Mmpiog+Lmviw7IFlzdYEqcFqsiz8dwuiVuDSywyB0Ht7zj394JT1iay28un4KkhG7tRWPqpC7gglKyVL/Uay9enr1aTZ0lykpr+Rhc/Ysn2Ym9Sbb9hlVeVHg134oRcFFwltXuI4jWjAvJDzlP7N8ChpMwGL6DgmiDk6k3DeZiI/ADBDBW5tcZ8MFg1RhWEKCIOGAsVBUfNn2EHV1GZeGkfpcNrtuF1grH8jCRO3F+8/da1hYcqOk9sLNuw9ztGPAkLGC06PsUcBr6lrEqf3Pw4B1cDUBgYHbkycIpAJBUFpgnjOWHrc7oEtw70355nPNAKnyW1j+K9r3qcB+1rfGFyWCtn5NAKnCXeazbFVrD3DZyLGcOeerwZj/gWuZf4itKhIxjxGyb0o9/rQNR6UzrVUZdd8lruf1K2Q+4PuGjeF+LA7XqlCGcLyvSjqzSdLKFynvQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.0 /",
    "Flow State": "Turbulent",
    Friction: "926406.90 /",
    "Friction Factor": "0.017026",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "4387",
    Mark: "413",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4064297",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "232159.5194",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "72",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "34.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529286",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.58904822",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/X2Jybzp6igqAeRIIexAetoYO1ha1AxP/eMnu75/AdbjlC3ujz8FCQwdE1ulBXX9vWKECQO239E7Jy/J2BECxTwtcryrDgcQJT9Webvq+HYEOx0/VdedVDRjBBcFK29d0cKBcICudrr52FjGEaUy4jwRlPZSIZRXDRtwUnDMFB6bbzcxQRR7A36r2MI4K/fuuMC5/sy5ip+gDFYLE8zwAAAA==",
    Pbi3DGeometry:
      "LRAAAB+LCAAAAAAABADtl1FrwjAQx79LnmNJ0qba+jS2wWB7kG2wB/FBsWiga4brBiJ+94Wu3WzIeU0d7KWIYv69/nLJNffX+YHMVup5/5aRlNzrlXrSuVoTSmZaFeU7SeeH76/mMpuaFznSX2XEGZtWH+ZNjovmtqvdbrk397IgiaOEjngYxHESUcGCUMqEnuoyGld6LFryWMpKjrhwhgsWURdexLITB+Nb6bhzd6thmDjR7gShBUEJuil+i2/lPWGyjo4nlc4T3tKbDLkz2iy3kz6RrV3pOasIo7MUe1azJV5ZQvwmm7GQF82L8bmTUu9NxyfMris0p6UjFGhFlg4cJGgjsXCIfr6X2GepdTqQPW+pCMGqj2/d0EpA8RDfrwtYLRM9qZaOcqCTbelQ9ZCKQNEQHTIIoOFbdoU2Aui5hjgd2ydURLQoUDzEh+zZvWm+butnfb50z58WXhYPtdp+Ju+TCbL6ngaK2XBX2+7QPHubMNRWISOD+H9l2hh/MO3BtAfTHkz7P03b/Pe+UcvXrMx2JGUBo+QhKzblth486nJZKl3Uwxe1/rl0l6nNtqwHt3n2eRp4rXNtgMVHnh8XX7vB77wtEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "964",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "116829.3",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529290",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.77397984",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zUELgjAUB/Dv8s5zbFPntFNUENRBJOggHmYNHawtbAUifvdW2e29P7/3f/UEZatP411BAQfX6kpdvLSdUYCgdNr6BxT19BsDiWiME0HEKmI4JZTD3PzdehjkGHAItlrelFcDFAQTBEdlO99/FsrTFEHlvPTaWSgoTjOS5TxmPMsTkXOO4KyvC2Y5RbBXuuv9t0kwhmBn1Gu5ZgTHhASzccaFZ/ZpzNy8Ac9UItrTAAAA",
    Pbi3DGeometry:
      "6SMAAB+LCAAAAAAABADtWE1r20AQ/S97ls2upNWHcyptodAcQlvoIfjgEJEIVKu4aiAE//eolrSud/Q8KyW9pEtIiPMy82ZmZ2ekd/0krm7Kb48/C7ESn+ub8mtdlbciEFd1uW1+idX1U/drC8uL9kvsg+NfFkrKi8OP9lvs14PZu91u89jaLlS0jDOZBYtwGassC0K5jKRUwR9Ay/wUUGE4DqQyYixClZ8AsWJckaiysAe0Skc5YB7uFpCDj8q5iMYV5IjydLRWMI+BQ2dxNHoeBrAzN4AdLnXVn6AB7BN05xjy4C3s6lIAurIBWBL7aGm4zuT20dKo+qMlRTQcUiUzM3duUcoBOxFywDxe3tTOHLDs8NbSzJ057BOkeXAJwhaFY8mEyw8y7kZNn4mUnItqwgCAw1LJ5ACkaogqZxYLssCZozzMjkqkPp1wzsuLrDvianYeI5M66oAw7vNImRPkLdhtADeOnTldEwMQh6nb/jhjAfJwL7u91dyfS85wdFHFadYBqWYAduiTEc66GrFg8uDPw1j0LaojFR+AJNeOzwyEA3UJ/wRg1wpGBV3NyCOJdFf2UJ8HTO/2AL2DrCvSV7M5dCST8xamJLaFHRVvYXPABHG4kzloX6E8cPtActglEJhfXQLAiwPJoQVLDi1YV/ykdo7quFjQbIcA6iu8B2Enshx2uDM44CMOBJxnCbyD/HMJJIcWLDm0YF3xu9Y5quNr39TtDK/zjFnCcZBw/z9NBr7E8WLNK2oyk6UXmMfb12Q4AcJdrPmXmgwvvbB5eE3GazJek/GajNdkvCbjNRmvyXhNxmsykr47e03GazJek3mTmsw6EB/KzY+iKXZiJZcyEJfF9q657z98qZtNU9bb/uP38tZAn4ry7r7pP3ysioe///F9XdWtw+3vqtqvnwGgUgEC6SMAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "967",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529291",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.62370426",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9jkELgkAUhP/LO6/Luq5u2CkqCOogEXQQD0qLLmz7wrZAxP/ektql6PbmfcPM5D1klT51NwUp7LHSGZquRgsEMtTW3SHN+/H0hiCMaMySxTJMqIwlDOQHCzgVLOJfUMRC/odzajGXr9q27PwC/9jo8qqcaiFllBE4KFu7ZhJHdKXTfvQoz/ryQTul68a9hQglga1Rz8nLGY04EwTWaNDn2ocxQ/ECvTCaGBEBAAA=",
    Pbi3DGeometry:
      "qQgAAB+LCAAAAAAABACVVVFrgzAQ/i95jhKjsbV9GttgsD2UbbCH0gdLpQ04M1w2KMX/PrUuS0ZOT0pL89353d2Xu3N7IZu9fD1/FGRFHtVevqhSHgglGyUr/UlW28v1b2tm6/ZDGvqHBBFj6/6n/ZJm9/vYTV3n5/bZIIrDJBOCRmm4EAvKWRjzVFAfLkR2xZdsaeMpH4XTFEPCWdLjgkWOfxLx8WSg5AF+KB0XNiwo2JCILMPkDuUICGlS7/CAhwmLuePf0du4o41tcAI7BksdLxM2tNM7Pqb+fm2DEelfaFtrVEqmhu4WMBHsu5+n0lw1RpsavDmo20FZPRFgucHQUHFAs47yAP4zl4ovG9QYT9aE7AhnwL1qQpM/RgT4z1ksY60+Y51hJwaaSdzEANsYJJre3pPuYD7IV950YegF6OwCn9joJYHaKm4R7Xv/TubvhS5qsmIho+SpqI76NByelc61VNVwfJMHY3oo5PGkh8N9WXzbjreqVC1h9VWWze4H1uxUvqkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.8 /",
    "Flow State": "Turbulent",
    Friction: "1411160.97 /",
    "Friction Factor": "0.016598",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "5840",
    Mark: "414",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "8241215.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "290199.3992",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "75",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "42.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529292",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.61077603",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/zzHNnVOO0UFQR1Egg7iYdbQwdrCViDid2+Y3Z6X38NTT1C2+jI+FRRwcq2u1M1L2xkFCEqnrX9BUU8/GZCIxjgRRGwihhMqBMzNn9sOgxwDHIK9lg/l1QAFwQTBWdnO94uhKUdQOS+9dhYKitOMZDmPGc/yROQ8tFd9X+EsRnBUuuv9YjlLERyM+qxjRnBMEeycceHJvo2Zmy9JZWHD0AAAAA==",
    Pbi3DGeometry:
      "4xAAAB+LCAAAAAAABADtVk1rwkAQ/S97XsPuJhsTPZW2UGgP0hZ6EA+KQRfSpNi0IOJ/bxqT+JE8d1d7KQRR3JnMvJnM7JsZb8hopl7XHxEZkMd0pl7SWM0JJaNUJdknGYw3u7+5mg3zD9nSvaTHGRsWP/mXbCeV2c1qNV3ntj3uOl4oJe0Jx2OuoII5rpQhLRQBC44UvijkknH/SO5x0W4gmEdbIYQvz7syxyiD8ny/PQkkl2HYDnBiUIUKk8OhIk9AbuyoykEyscuBB0Gh4CE/jrVWtD/vu65G8RvBgXxfHjtkL+8AM0cVsieDvl2sEKMRU1/IC8HNMXi7o/o9mbZf3a8QGSpg56PkoALdOfRioQFEQLFCRtHd0pM6ADHygstmXU9YHmgBMax5A9IuutZAfoa/AQ/oCaJRUU3lmrSLEFCwsCu1AxD2d0OBXF1AvXA0Qk6GsxTRHEwc3QvrOW49TS+AsN1frFcIfFOv3SEsIzJYmyw3AtP5rlsILHnXfrhDUsT8qptmf7AOGGN060C3DnTrQLcO/Ld1YELJnZq+R1m0IgPmMEqeomSRLcvDc5pNM5Um5fFNzWvVQ6QWy6w83MfR9+GDt2mc5g6TrzjeTn4AA/YkAuMQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "968",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "182545.7",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529293",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.3994396",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/zzHdO5FO0UFQR1Egg7iQWvoYG1hKxDxuzfMbs/L7+GpJihafRmfCnI4uVaX6uYb2xkFCAqnrX9BXk0/GZAopjiVRG6iBDOZUpjrP7cdhmYMcAj2unkorwbICSYIzsp2vl9MzDiC0vnGa2chjzETRGScJlxkqcx4aK/6vsKCIjgq3fV+sTxhCA5GfdZxQjCNEeycceHJvo2Z6y83szDH0AAAAA==",
    Pbi3DGeometry:
      "7A8AAB+LCAAAAAAABADtV91rwjAQ/1/yHEuSNrXVp7ENBtuDbIM9iA+KRQNdM7puIOL/vvjRdta7NpGxpyJKc3f53SX38avTLZks1OvmIyEj8qgX6kWnakkomWiVFZ9kNN0eH42ajc2H7GgtGXDGxocf8yW7WbntJs/nG7N3wH0vCEM6EF5IBfN8KWN6EEYsqqWhOAplHNfCgAvAVLCAXqCKULYBWMCWEcRSAsGCUsl4CMCe2VaBwWeAA4MRYKkFQnUKGQ33UhkF/kHBY34WXK2A7UPf71AYx2eKOgNuruV+nw1O6VkyEbvFirpoRjQU8krf1i44jFNekk2hVUWJ+ERjQUobOxJ6z2A3oXcJWePYcDnDLdXafs0KR8QgRkt6nPKGZgi2xsCd5gE4K9FmRRXwyMVau6vnG4lrT1FzcGLYYIhgbbaxElqwlwoQxn1ywnnD5ynMcxg6GCRcQA606sJ0DrD2rwv2DI4117UMbh9B16uJIydbM2w3JzvNxCsIFh2L6ADs4Ja/oGRrHz0n95zcc3LPyf/Fyeav852avydFkpMR8xglT0m2KtanxbMu5oXS2Wn5ppaV6iFRq3VxWtynyfdvw1udagOYfaXpbvYDcQs91+wPAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "969",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "131474.3",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529295",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.51520493",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zbEKwjAQBuB3uTmGJG3SpE6igqBDKYJD6VA1tIGYSI1CKX13o9bt7ue7/6oRirM5DncNOez92ZT6EhrXWg0ICm9ceEBejb8xkgVNcCqJXFKBJecpTPXfrfq+GSKOwcY0Nx10DznBBMFBuzZ0n4UKzhGUPjTBeAc5xTwjmRIJE5lKpRICwclcZ8wURbDTpu3Ct0kyhmBr9Wu+ZgQnhESz9tbHZ+5p7VS/AQ8A89fTAAAA",
    Pbi3DGeometry:
      "6SMAAB+LCAAAAAAABADtWE1P20AQ/S97NtGu1+uPcKpopUpwQG2lHlAOQVhgyY2r1FRCKP8dN/5Is+OXWZv2AisEwgwzb97s7Izzbp7F9W3x7elnLpbisrotvlZlcScCcV0Vm/qXWN48t782ZnnefIldcPjLmZLyfP+j+Ra7Ve/2YbtdPzW+Z0ovolSmgYoXmU5VEMqFllIFfwxGZscGFYbjhkRqxiNU2ZEhUkwoklUadgajklEMyMPdA2LwWTkXcQgFMXSWjNYK8ugxkiSMR89jMNjMB4OdLg3VneBgsE/QHaPnwXvY1aUGGMo2wJLYR0vTdQa3j5Zm1R0tKWKPkRoTzWTu3KIUA3YixIA8Xt/Uzhiw7PDWUubOGPYJUh4cQdiicCwN6fKDjLtR02ciBeeymjAA4LBUMt5jpCbsQmXMYkEemDni0U+4NIvN8YRzXl72uqOhZvMYmdS65aGbZt4bEuYEWQ9+G8CNYzOna6IviYq02/444QF4uJfd3mru7yUnMLqskrQte2IYAzv0yQhnQ414cDzY8xg8+hYNTWuIM+P2zkAxUJewbwCkVjArGGoGj1ib9nJG0WnD0Lu9gdxBNhTpq/kYYaxPewwlsT1IVqwHwYAEYbrTMUhfIR64fSA47BJomF9dYoAXB4JDDxYcerCh+EntnNVhsaDZDg2or/AehJ3IYtjpzsCArzjQ4DxL4B3k30sgOPRgwaEHG4rftc5ZHT72Td3O8DrPmCUshp3u+9Nk4Ic4Xqz5h5rMZOkF8nj7mgwnQLiLNf9Tk+GlF46H12S8JuM1Ga/JeE3GazJek3F6EfaajNdkvCbjNRmvyXhN5i1oMqtAfCzWP/I634qlXMhAXOWb+/qhe/hS1eu6qDbd4/fibjB9zov7h7p7+FTmv//+x4uqrJqAm8ey3K1eAJ0uGfjpIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "971",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529296",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.88671143",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzGkTdLWehIVBD0UETyUHiqGNhCzUqNQSv/dYGsviredfcPM5B1kZ31sbwpS2OFZZ2jaCi0QyFBbd4c074bTG2YBp5JFyYKHVEqZQE9+wCCic8m/oZAi/g+n2OJTv2yasvUb/GOty6tyqoGUUUZgr2zl6lEc0JVO+9mDPOnLhLZKV7V7CxHEBDZGPUdvyCgPmSCwQoM+1z6M6YsXzxnCQRMBAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVl1rgzAU/S95TiVGI2qfyjYYbA9lG+yh9MFSaQPODJcNSvG/T61zieTqldLS3OP9Orn3tLsr2R7k2+UzJyl5Ugf5qgp5JJRslSz1F0l319vXBmbr5kVq+m9Z+Yytu4/mTer9n9umqrJL47vyAy9MhKAB94QQMeXMC3gkqBMQIrkBMYstIOLT9ijCxeEs7ADBfNsj9PlMSWATUA6wqJF9CIS0D3FEkuB6AEuFaB1aaAE/8hIR2A5tBtNusWQCVmoLMFhyRsKmtobJFam7axMYeBqlNglHlTT00N4EJoM5AstYWsrG9ICDVwdOPkisKwfMOJgc6g+a2MlAkMNiqXFVhNzq2c6Qo2Ftu5NTUAamIkEOy4Rmau4XSRx2gaAVxS0QpNJgJIyszzuANaF/F+fbQ6uiJRAuyvHKgdOaUR/NP4R7mX3kOq9IyjxGyXNenvS5P7wonWmpyv74Lo8D9JjL01n3h4ci/zEfvFOFagKW30VR738Bsp7kVNMIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.6 /",
    "Flow State": "Turbulent",
    Friction: "1994172.45 /",
    "Friction Factor": "0.016289",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "4756",
    Mark: "415",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9483297.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "348239.2791",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "78",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "51.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529297",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.95716871",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zG5nTTdYoKgjqIBB3Ew6qhg7WFrUDE794wuz0vv4enHqG8mvPw1CDh6K+m0regXGs1ICi9ceEFsh5/MiIrynCak3xNOS5YTmFq/tym79UQ4RjsjHrooHuQBBMEJ+3a0M2GZhxB5YMKxjuQFGeCiIKzhIsizQse24u5L7BgCA7atF2YLU8yBHurP8s4IZhRBFtvfXxyb2un5gsgwRmB0AAAAA==",
    Pbi3DGeometry:
      "4xAAAB+LCAAAAAAABADtVk1rwkAQ/S97XsPuJrsmeiptodAepC30IB4Ugy6kSbFpQcT/3hCT+JE8s5v2UgiiuDOZeTOZ2Tcz3ZHJQr9uP0IyIo/JQr8kkV4SSiaJjtNPMpruDn8zNRtnH7KnR8mAMzbOf7Iv2c9Ks5vNZr7NbAfcdbxASsqVE0jXp4I5rpQBzRU+888USuRyybg6k3tcNBsI5tFGCKHkdVfmGEVQnlLNSSC5DIJmgAuDMlSYHA4VeQJyY0dlDpKJQw6uz3MFD/h5rJWi+Xnlui2KLIJT+bE8dshe1gFmjkpkT/pDu1ghRi2moZAdwc0xeLOj6j2Ztl/VrxAZKmDno+SgAt059GKhAURAsUJGabulF3UAYuQFl826nrA80AJiWPMGpF10rYH8Cn8DHmgniFpFWypXp12EgIKFXdk6AGF/1xTIVQfqhaMRcjKcpYjmYOLoXljPcetp2gHCdn+xXiHwTf3tDmEZkcHaZLkRmM73toXAknfthzskRcyvbdPsD9YBY4x+HejXgX4d6NeB/7YOzCi50/P3MA03ZMQcRslTGK/SdXF4TtJ5qpO4OL7pZaV6CPVqnRaH+yj8Pn3wNomSzGH8FUX72Q8ah6wV4xAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "972",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "262865.9",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529298",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.37916133",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zGXnRTO0UFQR1Egg7iYdXQwdrCViDid2+Y3Z6X38NTj1BezXl4aijg6K+m0regXGs1ICi9ceEFRT3+ZERWlOMkI9maCiwlEzA1f27T92qIcAx2Rj100D0UBBMEJ+3a0M2GpgJB5YMKxjsoKE4lkbngTMg8yXIR24u5L7DkCA7atF2YrWApgr3Vn2XMCOYUwdZbH5/c29qp+QIxeSyO0AAAAA==",
    Pbi3DGeometry:
      "lBAAAB+LCAAAAAAABADtV89rwjAU/l9yriVJm9TqaWyDwXaQbbCDeFAsGuja4bqBiP/7QrVVaz+TuB12KKI0771876XvxxfHGzKaqdf1R0IG5DGfqZc8VXPikVGusuKTDMab3aNW06H+kK13kPQYpcPyR3/JdlJtu1mtpmu9t8cCP5TSY9KPRORx6gdCxF4p7tP+sVzynVjE8bE4ZLzVnNPQa0HnUlyGsYSvoomFaA0eyAVlshW+YV+HiU6FwkQ4SG6JU59L9KNSHnFZKljMTgOtFe32MggMCu36RHHIjJtrofdZ4VSeBeWxW6zQRTOiiIsrfVu7YO041UuyLby6UIFfGA8seHQw+LZBp8F32m6P8VFpo1YztWaj4oEYoFxImGMmYcaQPXLgPCvAhIWNDBVoVKPGN06EZioNKTsbsggfBAoq18BvsKDPFADIfcaiTOLZi9gSeQChotJyJGlXtnSEd7uQuN0McDv+7mbgFo35GuTI89asbeZ5p7l6BWnDwQoHqImp/oDmrX10PN/xfMfzHc//V57Xf/Hv1PQ9KZIVGVCfeuQpyRbFcr94zotpofJsv3xT81r1kKjFstgv7tPk+9jwNk9zDZh9pel28gMm6rYAlBAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "973",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "205428.6",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529300",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.28379338",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zsEKwjAMBuB3ybmWtlu7dp5EBUEPYwgexg5Ty1aorcwqjLF3t+q8JeFL8lcjFGdzHO4actj7syn1JTSutRoQFN648IC8Gn9lJAua4FQSueQEJ1QpmOq/W/V9M0QcBxvT3HTQPeQEEwQH7drQfRoqOEdQ+tAE4x3kFPOMZEokTGQqlUoIBCdznTFTFMFOm7YL30uSMQRbq1/zNosZCIlm7a2Pz9zT2ql+A/bkrJTTAAAA",
    Pbi3DGeometry:
      "sSMAAB+LCAAAAAAABADtWE1r20AQ/S97VsyuVh9e51TaQiE9hLbQQ/DBISIRqFZxlUAI/u9Vo5Uc7+h5VmoKpV1MTKTRzJu3Ozsjv6sncXldfnn8XoiVuKivy891Vd6ISFzW5bb5IVZXT92/rVmetx+xjw53zpSU589f7Z/Yr3u3N7vd5rH1PVN6kSzlMkrlIpFxHsVyoaVU0S9DKs2xQcXxuCGXmvGIlTkyJIoJRbJaxtaQqnwUA/Lw94AYfFbeiziEghja5KNrBXn0GLHO49H9GAwu88HgpktD2R0cDO4O+mP0PHgPd3WpAYZyDXBJ3K2l6XqDu1tLs7JbSxaxx9DKmJnMvUuUYsBKhBiQx+8XtTcGXHZ4ailzbwx3BykPjiAsUdiWhnT5RsadqOk9kYJzWU1oALBZKpk9YyTtIe1CGWawIA/MHPHoO5zO1HGD855d7rQjkWazGOnTujOYzLLImf1jPfhZAOeNS5wOid6QL43f9DjhAXh4r7o70vxfSjBEl5NOdPd8evo+2+5J8+YijTgwHPitGDxsdcZGdrQzk3q+LBAMVCDs6CdLBbOCoWbwyHRqz+XJ+0PR9vfJ4eMCuQU1F6DlxngMq+F6kJxYD4KB2MHlmAxBKwrRwIUDwWF9QMPsxaUGeGQgOPRgwaEHG4pvz95ZHaYJaujQgOoKDz9YiRwGSXcGBnyrgQbfPoJOIPsmApGRAweMnmfisJPVM5/Dz7tpkxie4Bntg4NwUv3/dBf4Q40XZF5Rd5ksr0Ae/77uwokM/oLMn9RdeHmF4xF0l6C7BN0l6C5Bdwm6i9dLXdBdgu7y0hB0l6C7BN0l6C5Bd/mbdZd1JN6Vm29FU+zESi5kJD4W29vmzl58qptNU9Zbe/m1vBlMH4ry9q6xF++r4uHlg2/rqm4Dbu+rar/+CW0vq8OxIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "975",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529301",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.87479477",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jkELgkAUhP/LO2/Lrq6t2EkqCOogEXQQD0qLPth2w7ZAxP/ekual6PbmfcPM5D1kFZ66m4IE9rbCzOqutgYIZBaNu0OS9+PpDQse0ogt45WUlAdCwEB+wIhRwePwC4pIyP9wji0+9Wnblp3f4B8bLK/KqRYSRhmBgzK1ayZxtK506GeP8oyXGe0U1o17C8Elga1Wz8kbMBoGTBBYW219rnloPRQvtNrVXhMBAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVl1rwjAU/S95riX9SG3rk2yDwfYg22AP4oNi0UDXjC4biPS/L61dlpTc9hZRzD29Xyf3Ht1eyebA3y6fBcnJkzjwV1HyI/HIRvBKfpF8e719VTBdqRdpvH/LIqB01X2oN2l2f27rut5flO8iiPw4Y8xbLv0gjJkXUj8KE+Y5AcayG5DS1AKScNyeJLg4IY07gNHA9oiDcKIksAkoB1jUwK4DIe06DssyXA9gqRCtuoUWYNSPgzSyHNoMpt1iyQSs1BZgsOSMhE1tDZMrUnfXJqB5GqQ2CUeVpHtobwKTwRyBeSzNZWN8wMGrAycfJNaVA2YcTA71B03saCDIYbbUuCpCbvVkZ8jRsLbdySkoA2ORIId5QjM297MkDrtA0IriFghSaTASRtanHcCa0L+L0+2hVdESCBfleOXAac2gD/UP4Z7vPwpZ1CSnPvXIc1Gd5Lk/vAi5l1xU/fGdHzX0WPDTWfaHh7L4MR+8E6VQAavvsmx2vwXnhBDTCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.6 /",
    "Flow State": "Turbulent",
    Friction: "4018755.99 /",
    "Friction Factor": "0.015765",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "8140",
    Mark: "416",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "32712774.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "502503.1702",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "58",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "73.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529302",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.3519663",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zGNnXTdYoKgjqIBB3Ew6qhg7WFrUDE794wuz0vv4enHqG8mvPw1CDh6K+m0regXGs1ICi9ceEFsh5/MiIrmuA0J/k6IzglTMDU/LlN36shwjHYGfXQQfcgCSYITtq1oZsNzTiCygcVjHcgKc4EEQVPGBdFmhc8thdzX2CRIDho03ZhtpxlCPZWf5YxIzihCLbe+vjk3tZOzRclRIvn0AAAAA==",
    Pbi3DGeometry:
      "4xAAAB+LCAAAAAAABADtVk1rwkAQ/S97XsPuJhsTPZW2UGgP0hZ6EA+KQRfSpNi0IOJ/b4hJ/Eieu5v2UgiiuDOZeTOZ2Tcz3ZHJQr1uPyIyIo/pQr2ksVoSSiapSrJPMpruDn9zNRvnH7KnR8mAMzYufvIv2c8qs5vNZr7NbQfcdbxQSiqZ4/HApYI5rpQhLRQBC84UvijkknH/TO5x0W4gmEdbIYQvr7syxyiD8ny/PQkkl2HYDnBhUIUKk8OhIk9AbuyoykEycciBiWGh4CE/j7VWtD/vu65GkUdwKj+Wxw7ZyzvAzFGF7MlgaBcrxGjENBSyI7g5Bm93VL8n0/ar+xUiQwXsfJQcVKA7h14sNIAIKFbIKLpbelEHIEZecNms6wnLAy0ghjVvQNpF1xrIr/A34AE9QTQqqqlck3YRAgoWdqV2AML+biiQqw7UC0cj5GQ4SxHNwcTRvbCe49bTtAOE7f5ivULgm/rbHcIyIoO1yXIjMJ3vuoXAknfthzskRcyvumn2B+uAMUa/DvTrQL8O9OvAf1sHZpTcqfl7lEUbMmIOo+QpSlbZujw8p9k8U2lSHt/UslY9RGq1zsrDfRx9nz54m8Zp7jD5iuP97Ad1KNBQ4xAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "976",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "547338.9",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529303",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.12604726",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zG3HTTdYoKgjqIBB3Ew6qhg7WFrUDE794wuz0vv4enHqG8mvPw1CDh6K+m0regXGs1ICi9ceEFsh5/MiKrhOE0J/k6I5gyQWFq/tym79UQ4RjsjHrooHuQBBMEJ+3a0M0myTiCygcVjHcgE5wJIgrOKBdFmhc8thdzX2DBEBy0abswW04zBHurP8uYEswSBFtvfXxyb2un5gvwgjBh0AAAAA==",
    Pbi3DGeometry:
      "6BAAAB+LCAAAAAAABADtVlFrwjAQ/i95jiVJTbX6NLbBYHuQbbAH8UGxaKBrhusGIv73hWrrqv1MonsZFFFMvt59l97l7htvyGimXtcfCRmQRz1TLzpVc0LJSKss/ySD8Wb318BsaD5kSw87Hc7YsPgxX7KdlGY3q9V0bWw7PAy6UUQlC4TgERUsCKWMabHfZ/0aEIndvozj2n6Xi2YDwbq0iUFE0uLJmaKMKZay+RAIkIxHzRTHFlW08HgwWugKAs6uqgPKfq8Awp4oAB7zergV0Px8FIYWwHDXgEOW/KilsXPyUzJLJmK/WCHFcUQ9IS/kdqbgzX7Kl+RegFXJAmYYEa59dDb4wtG9g+8VGGAGWODw2lkv6lHlg23k5kzmfFMKMwcNEMUFnQM1X3itIQDbOOoD1gZxklNL6k5bL2JAsaJCtg1BWOAnAPLk33hhSnFHhgMVcaBoYZ15z3L/eepN4atgfFXEmXt6tYrwjclBPHkqAuf5blcEXp33gvEOOy9ssLaB9geCwJmjVQStImgVQasI/psimFByp6bvSZ6syIAFjJKnJFvky/3iWefTXOlsv3xT8wp6SNRime8X92ny/fvBW51q4zD7StPt5Af5wL9Z6BAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "977",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "481880.8",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529305",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.44275518",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zbEKwjAQBuB3uTmGNG2TNE6igqBDKYJD6RA1tIGYSI1CKX13o9bt7ue7/+oRyrM5DncNEvb+bCp9Ccq1VgOC0hsXHiDr8TdGskhSnAkilpxjSqmAqfm7Vd+rIeIYbIy66aB7kAQTBAft2tB9loTlOYLKBxWMdyATnHPCC5ZSxotMFIwhOJnrjGmRINhp03bh2yQoRbC1+jVfU4JTQqJZe+vjM/e0dmrecuYExdMAAAA=",
    Pbi3DGeometry:
      "3SMAAB+LCAAAAAAABADtWE1v2zAM/S86u4Ekxx9KT0M3YMB2KLYBOxQ5pKjRGvDiIfMGFEX++7xYdhbRL5Td7dIKRT9slnx8EkUq7+ZJXN+WXx6/F2IlPtS35ee6Ku9EJK7rctv8EKubp+7P1iwv2y+xj45vLpSUl4cf7bfYr3u3N7vd5rH1vVDxYpnLPMqyRSyTNNKy/S1V9MeQSHNqUFqPGzIZMx5amRPDUjGhSFa5toZEZaMYkIe/B8Tgs/JexCEUxIhNNrpWkEePoZYt6Nh+DAaX+WBw06Wh7A4OBncH/TF6HryHu7rUAEO5Brgk7tbSdL3B3a2lWdmtJYvYY2it85nMvUuUYsBKhBiQx/OL2hsDLjs8tZS5N4a7g5QHRxCWKGxLQ7p8I+NO1PSeSMG5rCY0ANgslUwPGInObCjDDBbkgZkjHn2H02lsTjuc9/Byxx0NNZvHSKeOO4MxlkfG7CDrwU8DOHFc5nRM9IZcZX7z44wH4OG/7O5U87+XnMHostLLpDNkCWNgmz5p4WyoEQ+GB78fg4ctUWXiw/vUJJ5XBgKBioS9AJClQknBSNNZpHHSnUxlzhuGwu0N5ACyoUhRzcZo+eXnPYYVcT1IVqwHwYAE4ZJMxqBVhXjg4oHgqEjQ+9lrSw3w0CBs6MBiQw82FN+jvbM6jhTU1aEBFRWegLAMOQyS7gwMeLmBBu9GAg8gfyOB4NCDBYcebCh+ynpndfzAN3Uuw9M8o5GwGG66r0+NgR/feJnmH6oxk0UXyOPlqzGc9OAv0/xPNYYXXTgeQY0JakxQY4IaE9SYoMYENSaoMUGNCWpMUGOCGhPUmFegxqwj8bbcfCuaYidWciEj8bHY3jcP9uFT3Wyast7ax6/l3WB6X5T3D419eFcVv/7+x6u6qtuA259VtV//BpKgcLrdIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "979",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529306",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.97414737",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jsELgjAYxf+X77zGNqdLO0UFQR0kgg7iQXHoYG1hKxDxf2+keSm6fe/7Pd57WQ9pqc7dTUICB1uq1OqutgYQpFYZd4ck68fTGxY0wCGJlquYYRqFMQzoBxQCB4yyL8hDLv7DOTb/1K/btuj8Bv/YquIqnWwhIZggOEpTu2YSJ+sKp/zsUV5UNaO9VHXj3oJTgWCn5XPyMuK3EI5gY7X1ueah9ZC/ADoGGeoTAQAA",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVk1rwzAM/S8+u8Fx47RJT2MbDLZD2QY7lB5SalpDFo8sG5SS/z4nyzI7WIlC6Yf1qifpWVK7u5LtQb1ePiRJyaM+qBedqyOhZKtVUX2SdHf9/WhgtjEPUtN/yyJkbNO+mCep939uN2WZXYzvIlwGUSIETXgQxiKhnAVLHgvqBYR5b4E1WztAzMftcYzj4SxqAcFC1yMK+URKYBFQDDCpgb0nQtp7HpEkuBrAVCFZ+xIaYLUyBkNtOzQRbLujkg04oR3AUsnLhA3tNJOPqb1rG+h1GoS2BUel1NfQ3AQmgt0C81Saq8Z4g4NXB3Y+KKwvBqw4GByqD+rYUSLIYfaq8WWEnOrJypCt4Uy7V1NwDYwxQQ7zFs1Y389acdgBgkYUN0DQlgaZMGt92gHMCf27OF0eeis6C8InOX5z4HbNoA7zD+FOZe+ykiVJWcAoeZLFqTp3h2ddZZXSRXd8U8ceepDqdK66w30uv+0v3upcG8LiK8/r/Q+z4Kq10wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.3 /",
    "Flow State": "Turbulent",
    Friction: "4958624.12 /",
    "Friction Factor": "0.015632",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "4525",
    Mark: "417",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "22436039.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "560543.0501",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "61",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "82.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529307",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.78871067",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zG5tymdooKgjqIBB3Ew6qhg7WFrUDE794wuz0vv4enHqG8mvPw1FDA0V9NpW9BudZqQFB648ILinr8yYisKMNpRrK1lJgRLmBq/tym79UQ4RjsjHrooHsoCCYITtq1oZsN5QJB5YMKxjsoKOaSyFywRMg8zXIR24u5L7BkCA7atF2YrUg4gr3Vn2WcEMwogq23Pj65t7VT8wWFKUYI0AAAAA==",
    Pbi3DGeometry:
      "4xAAAB+LCAAAAAAABADtVk1rwkAQ/S97XsPuJpsYPZW2UGgP0hZ6EA+KQRfSpNi0IOJ/7xKT+JE8s5v2UgiiuDOZeTOZ2Tcz3ZHJQr1uPyIyIo/pQr2ksVoSSiapSrJPMpruDn+1mo31h+zpUTLgjI3zH/0l+1lpdrPZzLfadsBdxwulpEHguIILKpjjShnSXDFkwzOFL3K5ZNw/k3tcNBsI5tFGCOHL667MMYqgPN9vTgLJZRg2A1wYlKHC5HCoyBOQGzsqc5BMHHJg0s8VPOTnsVaK5ud9121RaMRT+bE8dsie7gAzRyWyJ4eBXawQoxZTIGRHcHMM3uyoek+m7Vf1K0SGCtj5KDmoQHcOvVhoABFQrJBR2m7pRR2AGHnBZbOuJywPtIAY1rwBaRddayC/wt+AB9oJolbRlsrVaRchoGBhV7YOQNjfNQVy1YF64WiEnAxnKaI5mDi6F9Zz3HqadoCw3V+sVwh8U3+7Q1hGZLA2WW4EpvO9bSGw5F374Q5JEfNr2zT7g3XAGKNfB/p1oF8H+nXgv60DM0ru1Pw9yqINGTGHUfIUJatsXRye02yeqTQpjm9qWakeIrVaZ8XhPo6+Tx+8TeNUO0y+4ng/+wHdkMmd4xAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "980",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "681077.6",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529308",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.07020469",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zG5nTTdYoKgjqIBB3Ew6qhg7WFrUDE794wuz0vv4enHqG8mvPw1CDh6K+m0regXGs1ICi9ceEFsh5/MiIrynCak3wtBKYpoTA1f27T92qIcAx2Rj100D1IggmCk3Zt6GZDM46g8kEF4x1IijNBRMFZwkWR5gWP7cXcF1gwBAdt2i7MlicZgr3Vn2WcEMwogq23Pj65t7VT8wXS2MJo0AAAAA==",
    Pbi3DGeometry:
      "6BAAAB+LCAAAAAAABADtVlFrwjAQ/i95jiVJm9bq09gGg+1BtsEexAfFooGuGa4biPjfV6qtq/Yzie5lUEQx+Xr3XXqXu2+8IaOZel1/JGRAHvVMvehUzQklI62y/JMMxpvd3wJmw+JDtvSw0+OMDcuf4ku2k8rsZrWargvbHve9IAxpFHlcBJIK5vlSxrTc77N+AwjFbl/GcWM/4KLdQLCAtjGIUBo8WVNUMcVSth8CAZLxsJ3i2KKOFh4PRgtdQcDaVX1A2Y9KIGC8BHjMm+HWQPvzoe8bgIK7ARyy5EYtCzsrPxWzZCJ2ixVSHEcUCXkhtzUFb/dTvST7AqxLFjDDiHDto7PBF47uHXyvwAAzwAKH1854UY8qH2wjN2cy55pSmDlogCgu6Byo+cJrDQHYxlEfMDaIk5waUnfaehEDihUVsmkIwgI/AZAn98YLU4o7MhyoiANFC+vMeZa7z1NnClcF46oiztzTq1WEa0wW4slREVjPd7MicOq8F4x32HlhgzUNtD8QBNYcnSLoFEGnCDpF8N8UwYSSOzV9T/JkRQbMY5Q8JdkiX+4Xzzqf5kpn++WbmtfQQ6IWy3y/uE+T798P3upUFw6zrzTdTn4AcT+5/+gQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "981",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "615950",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529310",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.5984143",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zbEKwjAQBuB3uTmGJG3Spk6igqBDKYJD6RA1tIGYSI1CKX13o9bt7ue7/+oRyrM5DncNBez92VT6EpRrrQYEpTcuPKCox98YyYImOM1JvkwYFjxlMDV/t+p7NUQcg41RNx10DwXBBMFBuzZ0n4UKzhFUPqhgvIOCYp6RTIqEiUymuRQCwclcZ8wkRbDTpu3CtylnDMHW6td8zQhOCIlm7a2Pz9zT2ql5A4XidU3TAAAA",
    Pbi3DGeometry:
      "HSMAAB+LCAAAAAAABADtWE1r20AQ/S97Vsx+SJbknEpbKLSH0BZ6CD44RCQC1SquWgjB/71CWsnO7j7NSmkuyWJiotnZNx87OyO/60d2dVN+f/hVsA37XN+U3+qqvGURu6rLffObba4f+3/bZX7ZftgxOkkuBOeX3Vf7x47bYdu7w2H30O69EGoVZzyLlFylKo0kX6lMqqiTJyI9l6fcLRdSTuur/Ik8Fm79Ecfwh3PRyROeZ0584L+vPsKn/PHN24CD8BMpcld+oP8aP0lF7DyAccGMeFwwXbWh9JmNC+ah+dsYwqB3mIm1FiCUtQBTYh6qnRJv4+a52l7pg7WTqG2sk1gujNy3OC0TsApheCiK59aztwGYcXRT7aC9TZhnZwVBBAdLE3Wh0VeqbZH3aG7/syyTLs1oLLg3dhayXn2dJ9SocaojdBiZbmctgHp6Ez1nkznLbKBlETg6ctobaIu6B0pAbXvvoLs+nCxm2HYnG/IhlPCcE3gHisM35+bw8n7hwAa0S2mq+0lKLVCd3erTFJK9gQiCPImz2dhtkPEgz/1eCmwTsDyoEW/nCTkFkeZGofpets6UmpQPBTvIzXtH4ZjFtBRfJmJSf0iEqW/6Q+mb+Cgu5OdcfLOIkP+wVJDhiYpwypcm1HJ04ga6HUIbKMtIn8Khe7CvR6eJgZo2WkBlBOcb3EBZsHydbwG9rLjEvn0C3TOfVwynO0ifMoz0KRx6bPp6dJpEc+csvPvzmwVhwfL1jbAl6LcWxaL8N7ZkJisCfxO+draEpAb8aZSXZEtIUoSMI7Aly/IX2JIl/S+wJYEtIXp4YEvcLgW2ZNpEYEsCWxLYksCWBLYksCWvly3ZRuxDuftZNMWBbfiKR+xLsb9r7vXD17rZNWW9148/yttx6VNR3t03+uFjVfw9V3xfV3ULuP9TVcftPyWCgVsdIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "983",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529311",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.18203521",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jkELgkAUhP/LO2/Luq5u2EkqCOogEXQQD0qLLmz7wrZAxP/ekual6PbmfcPM5D1klT51NwUJ7LHSGZquRgsEMtTW3SHJ+/H0hkUQ0ojFy5UQVMRcwkB+wJBTGfH4C4pIyP9wji0+9Wnblp3f4B8bXV6VUy0kjDICB2Vr10ziiK502s8e5VlfZrRTum7cW4hAEtga9Zy8nNGQM0FgjQZ9rn0YMxQv//0APxMBAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVl1rgzAU/S95TiVGY6t9KttgsD2UbbCH0gdLQxtwZjg3KMX/PrXOJZKrV0pLc4/36+Te0+6uZHtQb5dPSRLypA/qVWfqSCjZapWXXyTZXW9fa5it6xep6L9l4TO2bj/qN6n2f26bokgvte/CD7wwFoKGoRdGfEk58wIeCeoEhIhvwIqtLCDi4/YowsXhLGwBwXzbI/T5RElgE1AOsKiBvQ+EtPdxRBzjegBLhWjtW2iAgHtLwSPLoclg2i2WTMBKbQEGS85I2NTWMLkitXdtAj1Pg9Qm4aiS+h6am8BkMEdgHktz2RgfcPDqwMkHiXXlgBkHk0P9QRM7GghymC01roqQWz3ZGXI0rG13cgrKwFgkyGGe0IzN/SyJwy4QtKK4BYJUGoyEkfVpB7Am9O/idHtoVbQEwkU5XjlwWjPoo/6HcK/SD1nKgiTMY5Q8y/xUnrvDiy7TUum8O76rYw89SnU6l93hIZM/5oN3OtN1wPw7y6r9L+OvRabTCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.1 /",
    "Flow State": "Turbulent",
    Friction: "2431115.76 /",
    "Friction Factor": "0.016127",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "3569",
    Mark: "418",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "8677221.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "386423.4106",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "81",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "56.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529312",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.45335661",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zGXnRTO0UFQR1Egg7iYdXQwdrCViDid2+Y3Z6X38NTj1BezXl4aijg6K+m0regXGs1ICi9ceEFRT3+ZERWlOMkI9maMyy5hKn5Y5u+V0NkY7Az6qGD7qEgmCA4adeGbjY0FQgqH1Qw3kFBcSqJzAVnQuZJlovYXsx9gSVHcNCm7cJsBUsR7K3+LGNGMKcItt76+OTe1k7NF8WirMDPAAAA",
    Pbi3DGeometry:
      "oRAAAB+LCAAAAAAABADtV89rwjAU/l9yriVNTWv1NLbBYDvINthBPCgWDXTNcN1ApP/7Qq3VdvlMMi87lGJp3ku+95L344uzPZkuxevuIyVj8iiX4kVmYkU8MpUiLz7JeLY/fCo1naiHlN5JMggonVQv9SPl/LjsZrtd7NTaQRD6wyjyQubHnEUeo37IIu5V8hEdtRV0eFDwJGkphgHTr4hqeccC54kByNpC41PCuX4XSMFpEOltdFc07qLtQW8hElRYQzX746O4UoTxwacwbDtby2Omnx8kwWW5snwuP4XIzS5X6yxgjmY5ZYmLmwi+440BBBi1BG+22oE5Ho19xjU5qjeM/MGpDvaFDhlWmf440XSID5MZVZixJLtZjuQICMfMMZYoZHA+MPCHFoG6LKpgJIfdGlS8qRN0g2mK2a/2CvCRnzB7TUSnz+q2FGG4tlUYRdhvIVcCC8hTmFjOLO1MlM4WnK8mzveDC4V59f3A3SuLm5Ej3VvSt5HuHRutM3+jPovaqYG5ruN7S/Se8HvC7wm/J/x/S/jq//6dWLynRbolY+pTjzyl+brY1INnWSwKIfN6+CZWjeohFetNUQ/us/T7fOKtzKQCzL+yrJz/AFYzrcChEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "984",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "323672.3",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529313",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.8127316",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jHk0SZtXYkKgi5KEVyULqKGNhATqVEopf9uqHU3Z+6ZufUI5dWch6eGAo7+aip9C8q1VgOC0hsXXlDU42+MyopynGQkW3OGU0kTmJq/t+l7NUQ5LnZGPXTQPRQEEwQn7drQzUBTgaDyQQXjHRQ0PiEyF5wJmSdZLmJ6MfdFlhzBQZu2CzMKliLYW/1ZjhnBnCLYeutjk3tbOzVfiL4yJdAAAAA=",
    Pbi3DGeometry:
      "8BAAAB+LCAAAAAAABADtVlFrwjAQ/i95jiVpk9rq09gGg+1BtsEexAfFooGuGa4biPjfV7StWvuZRJ8GRRRz17vvrnf57sYbMpqp9/VXQgbkWc/Um07VnFAy0irLv8lgvNn/LdRsWHzIlh4kPc7YcPdTfMl2UpndrVbTdWHb44EnYilp4HtSyoj6zAv8UNKdImLRqYKJnUIyHp4oBPfbLcJS3oSQMr7syR6iCkqEYXsWSC7juB2hYVDFipLDoSJHQG7tqEpBMn+fQp+LfURBcBpqpej7wILH3KAoYjiWHwrkii2KLrBzVWELGfXdooUYZ1GZHCFoe4Q676ar+k3ZdmDdshAbKmDzo/SgAt679jeLn4cIKFZEKqZ7elYIqECecOWcSworBC0ghjN9QPZFdxvIL9A4IAMzSzSLaizeGfsiBBQs7kzjIAQt3hAjN1eQLxyPkJXhPEVEB5NGl8J5lrsO1CsQnFcY9zUC39Nb9wjnmCy2J+fFwHbMm/aCK9jXfcpDasQsaxprN+8F1gjdXtDtBd1e0O0F/28vmFDyoKafSZ6syIB5jJKXJFvky/LwqvNprnRWHj/UvFY9JWqxzMvDY5r8Hj94r1NdOMx+0nQ7+QPgRrE38BAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "985",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "295817.2",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529315",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.96338959",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eSpm2+nEQFQYdSBIfSIWpoAzGRGoVS+t+NVre747m7eoTybI7DXYOEvT+bSl+Ccq3VgKD0xoUHyHqcZUQWaZbkHPOloEnBhYCp+XOrvldDhGOwMeqmg+5B4gQjOGjXhu5jCGYEQeWDCsY7kGlSMMwEzQhlIueCUgQnc53hlGGOYKdN24WvJ5lAsLX69WuTOMhEhmDtrY9n7mnt1LwB3dk/H9MAAAA=",
    Pbi3DGeometry:
      "0SUAAB+LCAAAAAAABADtWEtr20AQ/i97VoykfWjXOZUmUGgPoS30EHxwiEgEqlVctRCC/3tlPZx4V9/Oyr0uxsba1cz3zWNnlrl/ZXcP1feXXyVbs8/NQ/WtqatHlrC7ptq1v9n6/nX4222n192HHZK3lassTa/7n+7LDptJ7MN+v33pZK8yvhI61YlRK2W4TPJ0JVKeJf0GL96vcy3nlnNTCO/rmT5Tz0WW+/VYfPLC8H5D5kLNIiADQgUgAs0p1HknTRBCiryY9RO0YkAQWvG5OEzrttHTus3U1TMG7qTIClwwwGQAJeCEwaUUKkH6CDpjKcIUNsdLpBFSGzObS8v9AdPSwcDphzBIAy/P5HAMlxV1Ul3LQzHsyLpmUPY5mog6NHElCxd1khZXQAeZpBReVnBllKbf4EIPmrj29xv0PkSA1k29SGb6vKQFNimnqTmKLrTBdZ9QWW+DlHkvYXIqdJQEVfnfyHaCR0UiG4xQyhAdYdyQ3Wmz3IFUQbKAE25GCMGvaCbSgyLF9cAok4q47yCB0TZ1PDJHiWOkvJqgANUq3MIPSUG7YSpTrGbAgX04PdAVZjguUojBbqOVXwAiwLxBzRb7HJKCqpaawYsiH6LXveDbmLJ5WneKAa3JDvfFEPKYJx6BkztsAYcTKWFDQOsw2aUQTkZBK2DiQGxPfoCN//CtQxcfSsQKSdDgwX0h2O3BzQprckihngSzCvZiLEFioDy07cYNFDlkOVl8UwMbwfUIneSACxbihCRIaBcC9NDg2hlwRyDZBrdjXF6WFyQKg2xMAXca6JI4h4pzqDiHinOoOIeKc6g4h4pzqDiHOr8fxTlUnEN5ScU5lE8gzqHiHCrOoeIcKs6h4hwKuGSTsJtq+7Nsyz1bp6s0YV/K3VP7PD58bdptWzW78fFH9Xja+lRWT8/t+HBbl3/fv/ixqZtO4e5PXR82/wBpLV8r0SUAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "987",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529316",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.78655625",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzEkNmltPYkKgh6KCB5KDy2GdiEmUqNQSv/dYKseFG87+4bhZR2kJR7ai4IEtrbE1Oq2sgYIpBaNu0KSdcPpCxMeUMnC2ZwzQYXkEnryg8YhjXj8DYUU0X/42c1fAoumKVpv4R8rLM7KqQYSRhmBnTKVq8ewt65w6MWHeMTTG20UVrV7BsEjAmut7mN3ymgwZYLA0mrrd81N6z5/ACNp8L8VAQAA",
    Pbi3DGeometry:
      "/QgAAB+LCAAAAAAABACdVl1rgzAU/S95TiWxxlX7NLbBYHso22APpQ8tlTbgzHDZoBT/+9S6LJFcvRZRjMf7dXLv0fWZrHby7fSZkZQ8qZ18VbncE0pWShb6i6Tr8+W2htmyPkhF/5/MOGPL9lKfpNr8md2W5fZU2874PIgSIShnURAJLmjIgnkYC+pHhEguyIItXCQOR4A4xroKWdQigvGeTcTDscTgYsA4cGp9wPhCA8aVSBJsLXDGIMmmlAZJ4uCGJ65FE8R+7vBlA05wB7DY8nrChna6y+ep3XcbMFT1Qtuso1IyNTS7gYlgd8I0lqayMdLs4N7BUwBS640Ckw6Gh0oE23bQE2hxhQD5skIP+Wh9yB5xRt/LLKwJQ65Ai6nCMzQEE2UPO0/QxOLmCVRv0BVO7xEmYF4TPp7jRaKl0lENH/ET5ASpQP1S6n+Je7n9yHRWkpQFjJLnrDjoY7d4UXqrpSq65bvcG+gxk4ej7hYPefZjv3inclU7LL7zvNr8AsSSjLP9CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.9 /",
    "Flow State": "Turbulent",
    Friction: "7129922.40 /",
    "Friction Factor": "0.015427",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "2357",
    Mark: "419",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16803278.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "676622.8098",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "44",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "99.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529317",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.11774168",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jmzrdeooKgnoQCXoQH1YNHawtbAUi/veG1tv9zvkOtx6hvJrz8NQg4eivptK3oFxrNSAovXHhBbIelzMqK5rgtCDFWnDMRZLB1Py9Td+rIcox2Bn10EH3IAkmCE7ataGbgXEElQ8qGO9AUpzlJBc8YTwXaSF4bC/mvriUphEP2rRdmJmkDMHe6s9vzQhmhaAItt76+Mu9rZ2aL5GyRALSAAAA",
    Pbi3DGeometry:
      "/RAAAB+LCAAAAAAABADtVl1LwzAU/S95jiVpm7TZnkQFQR+GCj6MPWysbIHayKzCGPvvlq3r7MchzfRFKGVlyem95yb3c7ojk4V+2b4nZEQezEI/m1QvCSUTo7P8g4ymu+PfAmbj4iF7et654oyND6/iR/azk9j1ZjPfFrJXPPBCKamSXsSVoD7zAl8KetiPWVwHWHgEhFI1IOR+t4Qs9xsMQiiLot4MlU1KiO5TIEAwLrs5mhKVueh40FqoCQK9VVXnC4ODhFTBEYjimrHVvgqCbgEWhhbAj6MaUBnlyi0CX/XTdOIWPJJu1mKOhlV+rPiF5L05zidvqiqvqn8UVnGLuLFRUBU8H7x1mH/wcpEE5oChjvLPlrDtHIAAUgX95+pX7D4oASguKCKoDsMEhwDShCqCpVK0XGrzXEsAESBDYSBbuiEM8DaANLkXYOhQ6B8oATmQtTDKnJu6c191ZnCeZJzHCZylvx8n3K2y34jzdNC719unA+fqe0GzR+UXVllbZ/uL6aAvxzAdDNPBMB0M08G/nA5mlNzq+VuSJxsyYh6j5DHJVvm6XDyZfJ5rk5XLV72soPtEr9Z5ubhLk6+fH96Y1BQKs8803c++AdOK4l79EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "988",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "8",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "103242.6",
    R0: "16",
    R1: "6",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529318",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.59157705",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUEKwjAQRe8y6xiSNKZJXYkKgi5KEVyULloNbSAmUqNQSu9uaHU1/828z5Qj5I25DE8NGZx8Ywp9C7VrrQYEuTcuvCArxyVGZUUTzCWRGyXiFAlM1d/b9n09RDku9qZ+6KB7yAgmCM7ataGbgQkEhQ91MN5BRvE6JakSCROp4lKJeL2a++JSyiMetWm7MDPhDMHB6s+vzQhmUlEEO299/OXe1k7VFwzMDbrSAAAA",
    Pbi3DGeometry:
      "9xAAAB+LCAAAAAAABADtVk1rwkAQ/S97jmGT/TCrp9IWCu1B2kIP4kEx6EKalDQtiPjfG2KiTczrZtNeCkEUd19m3kxmd+bN92S20s+7t5BMyH2y0k9JpNfEIbNEx9k7mcz3x785TKf5hxyc887Io3Ra/ORfclhUZldputzltiOPuVwJ4Sjpckl9x6cu86VwCiCgQR2gvAAE9WQN4J7fbiHL/SaFEOpnT90pqqC4lO1ZoH2hVDtDw6CKFSWHQ0WOwH5nR1UKwhsfgUCyAhgH9UirfcVYuwHl3AAwX9WAU4FsubkfjLt5qrg5Z8ouWsjRjMoPlNeTvDPHOfOmq+pVdT2BpyMLqSGAPMHsIADvHXq12AJyoGhRWzHd1ItKQAB5QqWzLimsELRAFNbdAzZfeLcRgF2BbmDsEs2KGivXbL6IAEWKT6VxDMIDfgEgVz36LxyQsHjQArY6mDm6Fdbj3Ham9mCwVjH2SgJe1V9LCeuYzALKWht0nvRGbdCj/9qPetQeYaM1TrY/0AZdOQZtMGiDQRsM2uBfaoOFQ2708jXMwpRMqEsd8hDGm2xbLh6TbJnpJC6XL3p9gu5Cvdlm5eI2Cj+/P3idREnuMP6IosPiC8YLq7D3EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "989",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "8",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1567548.3",
    R0: "16",
    R1: "6",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529320",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.1639603",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUIedYmrkQFQRelCC5KF1VDG4iJ1CiU0n83at3NHc6dqUYozvY43A1o2IezLc0lNr51BhAUwfr4AF2NvzERgQWR+ZISgSXhGUz1n636vhmSTYuNbW4mmh40wQTBwfg2dp9AMykRlCE20QYPmmMqqFQsk1zmaqE4RXCy1xkzleLO2LaL30s5Ywi2zrzmNiOYE5LMOriQnvmnc1P9BmDUwGTSAAAA",
    Pbi3DGeometry:
      "dSIAAB+LCAAAAAAABADtWE1r20AQ/S97Vs1qtfqwcypNodAeQlvoIfjgEJEIFKu4aiEE//eKeOVEY72d2TSnZgkJ0fP47dvR7BtpLh/UxVXz/f5nrVbqc3fVfOva5lol6qJrtv0vtbp8OPw7fKzPhh+1T56Qd6nWZ49/hl+1X49fe7/bbe6H79qFraoiSbVd5DorEqMXmdZp8hzPTPmIp8bM4qXORPHWHnCbynhGPZWZ4La0xSw/0M/GI36hHjZvhAfx28Lkc/kh+jOTpXP8pziNn+rkeab368X8UP80nyyOeEg++X2hPHDrEh6oh9xHnVf/tl+mDgE/qjd+X1wdhtatn5/dL8W5fLL8xAeg/lAegp/o9PsSyy/1N7QuwOXnlPobwbN89L3MOp6lry+w8TL91hZLf3/h+o7Tw/LI9EOfqYzTb4oDjy599wvFy/0c9QuKE58vhssQ/0fxaL/iPFPfE8YjflMRPWXuxTlfpTjiYZ8fSJ8S59/Fl6QMi2XuC2fpES5rO6ycwHByczPrbm5VWC9OzXDER7MCPMfiGXFXPIH8w7YqWfwxDdWsHnH8aEpgXygPgfxP1TPND68fVc/JurPlMA+HZhPi6EwANTicoSdJEyeTcVqxHseDOgvboVDxoE5NDgValz0sMn74RIFwsTmgw8U8OaB1YTzHT0xJbFZMZxTrcTwv7qTTYxpqDpAf6Xwzkw30xiSceLzaZEM2wWDfEP/XyQbcb+DE49UnG/4JBnxDj5ONONnw+lKcbMTJhjw+TjbiZCNONuJkI0424mQjTjbiZENiVm9wsrFO1Hmzuav7eqdWeqET9aXe3vS37uJr12/6ptu6yx/N9fGjT3Vzc9u7i49t/ed54Ieu7QbC7e+23a//At57BS51IgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "991",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529561",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.20598144",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lz6HkR1NbT6KCoIcigofSQ4shXYiJ1CiU0nc32FrQi7ed/YaZyTvIKjy1NwUp7F2FmTOtdhYIZA6tv0Oad8MZDLGMRDzjS0ZZtKCSQ0++IBNJ8h/GQohfOMUOsPjUr5qmbMOG8NhgeVVeNZDSiBI4KKt9PYqj86XHMHuQZ7xMaKdQ1/4tJJ8T2Br1HL2chV4hCaydcSHXPozpixes1f/aEwEAAA==",
    Pbi3DGeometry:
      "1wgAAB+LCAAAAAAABACdVlFrgzAQ/i95ziQxzqh9KttgsD2UbbCH0gdLQxtwZrhsUIr/fVmXtmo8EosoJl/u++4ul9PlAS3W8m3/KVCBntRavqpKbhBGCyVr/YWK5eH/1cBkZi7U4svMDSVkdnyYG7Wrk9m8acq9seVpxHgSY0polBGKYxolJMlxd56nOf8DGGdpH8hpdgSyOMNBTNYgifmoQsJS2gdYdjvNJ0jaF9wEaZ9PLlXC09Gw7byTPzjjA23K8nx0Ky7AgOoMDBLiGJyicCRsFF4in4DjERwcCEC+gtr9nQgI+mqf3PAGu+13FjgtgSXu5QmcB5MEFn6ABSQRKA1taMBZnMwElQy0HmwPgQb+Yp1ek2CjCW1yAVRQeV/R5UIt/GcLtgAB6KMGuzudKhSAeoT3zPu+wG6iOoD5S7iX5YfQokEFiQhGz6Le6p0dvChdaqlqO3yXmzP0KOR2p+3goRI/3YV3qlKGsP6uqnb1CxvC/aPXCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "71",
    Mark: "422",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "390.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "82",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529563",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.75755471",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABAB9jk8LgkAQxb/LnJdFXV3/dIoKgjpIBB3Eg9KiA9tO2BaI+N1b0jpEdJs3v8d7rxggr/HYXxVksKMac9J9QwYY5ITG3iArhul0hljyUCYL3/N5EsQwsh9I8DRMv5FIo/9oDizftcuuq3rX7R5rrC7Kqg4yj3sM9so0tp3FgWxl0c2d5AnPH7RV2LT2JWQQMdho9Zi9gc9FLCSDFWlyueau9Vg+AdlSPUgLAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVld9rwjAQx/+XPGclaWt/+STbYLA9yDbYg/igGDTQNaPrBiL935fZ30kujYjGfHv95O5yuWwuaL3n7+cvhjL0LPb8TeT8gDBaC15U3yjbXJq/8jFZyg+q8aDcUUKW1x/5RfW2e21VlruzfDeOvDCgC0wJ9RI/xj71gjiI8L9OSDDWQxKmjZ6GE/vET7CNs5CjyT6So4mvcMIgolZ/oHUh/dZ1IR3iKPGGcjCkrZfdohqycMUEXirtxtlsOL2ucAb7aRZ0+8Z7nQ9xIN3RHyXLug75Ca2r+N+l2REz6w4UlrIt02WhGtHMgdKxxqTDHbe2w9hToFegFQOZazHZT5sh8cDxMct2iuY7JEObbe2MAGa2kc6aW0tP76+g7lbCCufWjmC4T6wcyN79nrF3BJ0D6Y6dReHoOnQMHXvC7D1p8F/e7w9898kqVqKMeASjF1Ycq1M7eRXVruKiaKcf/NA/emL8eKrayWPOfseG9yIXElj85Hm9/QMQRvDQkQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "647",
    Mark: "424",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3532.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "82",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529564",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.26178815",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjksLwjAQhP/LnmPIow9bT6KCoIcigofSQ8XQBmJWahRK6X832Frx5G1nv2Fm8g6ysz62NwUp7PCsMzRthRYIZKitu0Oad8PpDQGVQvIFZwFlwRx68kUzLmgiIvEPSprE4Q+cQkdUfKqXTVO2vt8/1rq8KqcaSBllBPbKVq4exQFd6bSfPMiTvkxoq3RVu7eIREhgY9Rz9ApOZSwjAis06HPtw5i+eAE5eGM4DwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVktLw0AQ/i973oZ9mSbpSVQQ9FBU8FB6aGloF2JWYhRKyX93U6N57SSTSmjIvL557MxsVyey3OqX43tMIvJgtvrZJHpHKFkaneYfJFqdfj6tmC3sQwpac2acscX5ZX+kWP+aXWfZ5mhtlSeF5JQz5TEl5lRwTzEV0iaf86uSL+fSb/GlpUt+IAKKwan0S7EDXkmf13zphQETk8KB3I6khfM7Hk8fJ1S9dGt2r2rOtDpuZ1x4ofBFv/5tSROrLWkWw2lzTsPppzTFgo266YYGJzpYAjhoIIL2uaDA/heaK1GgA+CiAZMDHgygf8l5gT6cbY/to9H5wakjIhodxEl94DQZFCCWCQiF2krj6siIXF3Z4aOnArZxSwbW+vQ5AjcpQh8XE3TzXbKRYRtYgrnqYKwJd3Wpb/8z3OrNW5zHGYmYxyh5jNN9fqiIJ5Nvcm3SinzVuz/Rfaz3h7wi7pL4q6l4YxJjAdPPJCnW32TM6wblCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.9 /",
    "Flow State": "Turbulent",
    Friction: "848560.75 /",
    "Friction Factor": "0.01493",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "5258",
    Mark: "425",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4461356.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "532767.7867",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "46",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "42.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529565",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.26368825",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjj0LwjAYhP/LO6chH6ZqnUQFQYcigkPpUDG0L8REahRK6X832NZBBLe7e47jshbSMx6bm4YEdu6MqTNN6SwQSB1af4cka3sZChGXlAnFF5GgajaR0JFfMAjOGP+igs6VEP/oOJyPB5Z1XTThRQjWWFy11zUkjDICe21LXw3m4HzhMRzv7QkvH7TVWFb+bWKhCGyMfg5dwamcypjAyhkXdu3DmC5/AV/fLeUVAQAA",
    Pbi3DGeometry:
      "DwkAAB+LCAAAAAAABACVVltLwzAU/i95bkvSdr3tSVQQ9GGo4MPYQ8fCFqiN1CiM0f9unJ3r5ZwkZXQ0/Xa+c//W9YmstuL1+MFJQR7lVrzISuyIR1ZS1OqTFOvT362G6VJ/SOtdn/iM0uX5S1+k3VzMbpqmPGpbn4VBnmWp54fBIosjL2RBHCXM81kUUJbnA4DGeQfQoUWojziTBpIkAQ0WaQx4mDJFaZSYYjL5RoGZzk0ASjVKPMrCDCxhD3BMsFeSXyp9o1vMrtW9UPWBIVcfGRYFtDmnMnFjJEOQWaGNqg8ieNB4bON0ug7MYrPGhmcK9M02A8ZWQxtpnQ3QhXO8rgMASouRC7WYozmW1gNU2HP3IRpSQQA+XGYNQbkcVMduYNn6iU6ZAHcFGZGBiGXlIDG2kKEmUDLmvwJ44VFlBwE7FywRZvGAF9hVVlyVaJiMfru4E+U7V7whBQ2oR554vVeH7vAsVamErLvjm9j9Qw9c7A+qO9xX/Lv/w1tZSU1Yf1VVu/kBb0TAkw8JAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.0 /",
    "Flow State": "Turbulent",
    Friction: "113973.37 /",
    "Friction Factor": "0.017034",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "3205",
    Mark: "426",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "365306.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "182800.6853",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "63",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "14.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529571",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.87259374",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkW1PbehIVBD0UETyUHiqGdiEmUqNQSv/dSKsgHrzt7BtmJu8gO9GhvSpIYWtPlFndVtYAg8yScTdI8244vWEieRREcp4gDyXG0LNvlkTJP4ZhjD9szBxY8a5eNE3Z+n7/WFF5UU41kAouGOyUqVw9ir11pSM/eZBHOn/QRlFVu5cIxBQZrLV6jF5ELkUwY7C02vpcc9e6L575Ed+XDwEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVVFrgzAQ/i95TiUaE6t9GttgsD2UbbCH0oeWhjbgzHDZoBT/+8Sps9Hj4hDFfLl8993lLtlcyHqvX88fimTk0ez1i8n1gVCyNrqwnyTbXH5/62m2qh9S0T9kETK2aj71S6ptt+ymLHfneu1CBDKUgqZRwONE0igKhOBLOsCjVIgGZ2EyxDmPeIM7MEDTm6dMTtFLJtIrPObxLDmQXyQsb7+InhGPWCaT8Xb4tXworJHbVKZT2W/hEU1n7mbBse/Vu/SdeoQH43f1QGGBOKQT8utmH+H5r55RXM7uYmkDmsK7mDEeXxxKD1TkiD1YPr5+oW3Emm4ujy8OlQPSpaA9xO/rFyi3uWcYQuMHQy0BnWyYPUDv6RU4H7Fjdh6NJwx1P9bN2BUKaqzv9zu9e1dWlSRjAaPkSRVHe2oHz8burDZFO3zTh37qQenjybaD+1x9Dw1vTW5qwuIrz6vtD8KDKLCRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6860",
    Length: "25",
    Mark: "428",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "41",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3090",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529572",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.96584239",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnRN9cwtDIytLY30jCxNTZVqdWggFwuz2rGoKLESaD9QwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhnCDc9MgUt5pGamZ5SAOJYWRsY6Sq45qWVQtUaGeiYWFkY6Ss75OflAc/NKc3JqYwGd+pNfDwEAAA==",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACtldFqgzAUht8l16nERKe1V2MbDLaLsg12UXphaWgDzgyXDUrx3Rer3Qzx4LEUUczvyZc/J8lxdSTLjXo7fEqSkSe9Ua+6UFtCyVKr0nyRbHVsX+1ntrAXqem/MgsZW5we9ib1+tzttqryg+07i4OEp5zOecDncUw5D6KExbTRUyZOeiQiR2/ajR6niaNDnC5eCC6G+CJKbqbonp+p/gF+Kng0xIF0kBMm4dB8z7qXN8AnOK6T/zCIUjt/j9PTnfz48a3/nu6sF4Izwvf8AOO680X4BPhu/i8fd8wPNK63LqhzAeUfEQ/xoXWBOCN59s4jinOtOgCt7/i5w3EQOmqfQH6mxk+tS9A+HK8/OA5in4+cd6++oTiX10/QD/T/gnQUB6Gj6ieizqPiW93+7+9V/iGNrEjGAkbJsyx3Zt81XrTJjdJl13xX279Pj1Lt9qZrPBTypx94pwttgeV3UdTrX9A0SDChCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2750",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6550",
    Length: "299",
    Mark: "429",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "183",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "41",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529573",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.07520838",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0W1tiPYkKgh6KCB5KDxVDuxATqVEopf9utFXqydvOvmFmshbSEx2aq4IEtvZEqdVNaQ0wSC0Zd4Mka/vTGyYCuZSRmM+QYygROjaCEZdxGP9jYYTyl41Ce5h/yhd1XTR+gX+sqLgop2pIAh4w2ClTumoQe+sKR350L490/qKNorJyLyGCKTJYa/UYvCjedQyWVlufa+5ad/kT+JGFexEBAAA=",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACdVt9rgzAQ/l/ybEVN4o/2aWyDwfZQtsEeSh8slTbgzHBuUIr/+7JqN1P98CxSMXf3fXeXy126OrLlRr0ePjI2Z496o150rrbMYUutiuqTzVfH5tOovYV5WO38S2a+5y1OL/Nj9foMuynL9GCwMz9w41j6ThK4geDCCXxXeCJxLEUi5a+CyyC2FTKOTorwQg6ZWoAQfjToQsjQRnARhRODgs7H8qM7H42qT8UDPpj5WdHbQ5Sf7Vu6ccjDXjE6YounI7d2o2/fZNCnbxIg8IzwX8aD0oLpojiBX7sA4zzXxtPLC9UX7Q9sEVQACJhaGeQAnWnaUaF0BxFBiGm0z8j1B/ZQTpsViIg0dWgISkzgUFpyQi8A82ExnthTWweORhKAEhG62CbOWGAOxLSLC/BMuX4NwPwTuFPpe1ZlJZt7ruewp6zYVft28ayrtFK6aJdvavunesjUbl+1i/s8++4a3upcG8LiK8/r9Q91RbxSuwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "2140",
    Mark: "430",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1308.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "41",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529580",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.12337687",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GPpw2u4oKgroQCboQL2YNHawtbAUi/veG1t15Ds/hVCMUjbkMTw05nHxjSn0LyrVWA4LCGxdekFfjEqOyEjglXGwkw0wKAVP917Z9r4boxmJv1EMH3UNOMEFw1q4N3QyUIyh9UMF4BznHNKFCslRwsZaZ5BTB1dwXl9IkRXDUpu3CzCRhCA5Wf35rxrAgNEOw89bHL/e2dqq/8QddVNEAAAA=",
    Pbi3DGeometry:
      "ShAAAB+LCAAAAAAABADtV9FqwjAU/Zc81xKbJm31aWyDwfYg22AP4oNi0UDXDtcNRPz3da7VGnNMIrKnIoo5Tc89ub33Hh1vyGgmX9cfKRmQx2ImX4pMzolHRoXMy08yGG/+vlaX6bB6ka13QHp9Soe7j+pNtpPmtpvVarqu7u1xX/QF95LAD3gceUHg84QKr40nnP/igvLkCA9ZuNvPWdzGWRgJHb7n70c2NBAHclBYKKfm4VTRo5fJWMB06gHLpWpOTtWEbR4KZXV2BDviaXBBa/VJG2aMMg18iMq0JHFsFRSx67UcUhYKCxYWhtHZoKpIcCaTdoUG0lvmAD1XoBI9blMZ6A/reqiTHKNqRTymqkfHQvxIj74JVdi2cpx6ZF+uqPPtCuFkUFjOFZMaMFwV2NCCqGMBrLYCmtyAxjToLf3CpAbZmorbTlZ1ICBc3+FwIKg0JvdFxzJlE6XBztdMdWZK8oWmbD1ATHGv4+KuP5Ucx7ejuV/Jxa9k124u7mhgaLvbpDclrLPwzsI7C+8s/B8tvPpjfien72mZrsiA+tQjT2m+KJf14rkop6Us8nr5Juf7Sw+pXCzLenGfpd/tjbdFVlSE+VeWbSc/PiDi80oQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1009",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "362.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529581",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.67103306",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNokt62qStRQdBFKYKL0kXV0AZiIjUKpfTfjS9wN2c4w1QjFEe9H64Kcti6oy7VyTe2NQoIFE5bf4O8Gj8xKDOkaRaJueSUS0SY6p+26PtmCG4oVrq5KK96yCMaEdgp2/ruBQwTQaB0vvHaWcgFZTFDyRMUmMlUCkbgoM//8kbptvNvjjEjsDbq8V1zTuM0QgJLZ1w4s3djpvoJT84ZC9IAAAA=",
    Pbi3DGeometry:
      "JR4AAB+LCAAAAAAABADtV02L2zAQ/S86e4P1LWVPpS0U2sPSFnpYcsiyZtfgxiV1C8uS/17Hdra2Vk+S9yxCQjyZvHl6Mxppbp/JzV39/elXRbbkc3tXf2ub+p4U5KatD91vsr19Hr/2P5fX/Yuciv+WK1qW18NH/yan3eVv747H/VP/3yu5UVbZwrINk5QXjG2kNcXMzKUZrJIvzdxqn7ffzKyUZ7OiihcJMS8opVUJXF5QEt05X4MC3GNcbBr4JIywlIcUMEzIOY7QpZzbL/4XuzYln7F03V/BCGYWdN4Gr7miIfdJStfdZRNxd9HRohDJdeiaaq80kDyleuFvJAtVwptxQOXASksrb60snZspoyHzysQiLcFaIQ6wQ40Be27UfCsLtmwfzh6EFRKBiTRQt2kBu5tvqBm0h+s4eYt7F4u18duhxoi9He1cTP5cjOVq7bAqfu4BZ7viY1wpx7iC08Gux34MGxrANyUTo93YRc+hbJEVyRgL8YFxlV3iWJV0cKLjd6IptbShbAF1QMnGCtwNinIFziQkMUwVSDlKIcCBZ97a1CL/SGqdFMJlARioMki5X3yYw1iFOORBUMQRoCMNUNQISXfzRDcbuLuJPqFzbYwZ7xvcjO7MhO6X2mgxoY/iqOHwMZwPkjHNRdJtxn+GwaB+jn0VqGlNTrcH/oANkAwWK9AA3tz8bAAMdvffTvxKwn6AEgX2PZbYzwaSj1TZq6r0S4y6E5ByZQKRBkAzVDZ+dLTUPLHmiTVPrHlizRNrnlhTtnieWEMXgTyx5ok1T6x5Ys0T66JY88SaJ9ZA2aRPrLuCfKj3P6uuOpJtuSkL8qU6PHSP08PXttt3dXuYHn/U9y8/farqh8duevjYVH/nju/bpu0BD3+a5rT7B9ADe20lHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1010",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529583",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.06759659",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNokyZt6kpUEHRRiuCidFH10gZiIjUKpfTfjS9wN2c4w1QjFEe9H64IOWzdUZd48o1tDQKBwmnrb5BX4ycGZSZomkV8rhhlSgiY6p+26PtmCG4oVrq5oMce8ohGBHZoW9+9IBaSEyidb7x2FvKYijRKleRMpirJlJQEDvr8L29Qt51/cyIyAmuDj++axZQnLCGwdMaFM3s3Zqqfn17au9IAAAA=",
    Pbi3DGeometry:
      "Jx4AAB+LCAAAAAAABADtV01r3DAU/C86O4s+LSk5lbZQaA+hLfQQ9rAhJjFs12XrFkLY/16vrXVs2SPZ6VWEhHj27Wg070nP7+6F3N6X359/FeSafK7uy2/VvnwgGbmtykP9m1zfvXT/Nh/Tm+aHnLJX5IpRetP+aX7JaXv52rvjcffcfPdKbbTIWWb5RgirM8420hienXFDxRnnQoxgF84VW4YzbVrcKjUX7y9ruFSzPPNyLuFL1TtYKLOGxQuPWIO2NMEln7UGWWBykQ95RE71EL/ET3Ank0q7iMbJEZLL/6Dv1XurOiuBmGXRiBvtCBiwirzPUq5lSLk0dhSuhQoWwUqaSM0srT14EJgdwiwPoG/K6MRGtNFIYXgw3P6ccm2ZHNaFzEcpQufOKwzAErmoJuQIR4mGhRH2EZUvqvbxkUGORUg8GG51Xrq2lre4dBePFa10rWlHn+fdRWWUaHElXby2LY+gLHSBIf4+XnLe8TepOOOMjXQKzXlID1xXaDHaL3P6I61y0hKV4UOdPQ4KE9iDuhliQYtGzARdwvcYeYZyHlsWNS2/ya3NLYpHuUU5RPtCPOhMRA6od5xRElGJIPWgRpBIRA9NQIUPeOABCidl0hydPeJ8MQ0vKqo6XPHuPcPmOvSaqMWFvqtxq0c1KJjOW1yx2ZbX1+x8EwMdHGjsyaXpcmLcorF4Twz0DHkcM8HfLPIY8cT0e28nwVcZ9Oo7yRQ4/dBkIAZpRx6AuoTewEttPn51DmM2eLbB2kF60H7TyJpG1iXnNo2saWRNI+vrmmlkTSNrGlnTyJpG1jSyppE1jawhk9PIGqydFSPrNiMfyt3Poi6O5JpuaEa+FIfH+sk9fK3qXV1WB/f4o3zoP/pUlI9PtXv4uC/+DgPfV/uqITz82e9P23/ET32mJx4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1012",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529585",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.40808242",
    Cost: "0",
    Pbi2DGeometry: "CAEAAB+LCAAAAAAABAB9jsEKwjAQRP9lz6GkMYE2nsQKgh6KCB5KDy2GdiFmpUahlP67kVYPIt529g0zUwyQ13jsrwY07KjGnGzfkAMGOaHzN9DFMJ3BIKNYpclSykiKRMHIfiHF0y/CpRL/yRRXvktXXVf1oTk8MqwuxpsONI84g71xjW9ncSBfeQxjJ3nC8wdtDTatf4mYS8FgY81j9goRhiwYrMlSiHV3a8fyCaDRBY8IAQAA",
    Pbi3DGeometry:
      "FwgAAB+LCAAAAAAABACVVdFKwzAU/Zc8x5K2Sbd2T6KCoA9DBR/GHjoWtkBtpEZhjP670SVuCcltpLQ0p7f3nt7cc7o6ouVGvBzeOWrQg9yIZ9mJLcJoKUWvPlCzOp5u9WOy0Aca8Rm5yglZ/F70ica1fe16GNqDfpdmpGIzTGlGiznDRZGxOq9xAM7npYZzUjAHJgBa1mVCiorMip+CjFAnmrE8ziPCOpI7xsSHTZJE2CRhtErhHSYY7p+lbWBG6nOsTWxBtx8WdasZ1OuGmyGpmDsbHgWzgRY99cEv5vYSpGDpmgbDed0dTWpD+genUXBjvXmIwWB7EgcT/Dx4pmICCW8TVA+ewAgL3wPAcZtyKAMHxzDmLuFguKDHDkwRlkiERcRCwkqfMkRA1bAJBfUQqZZgIbDU//MfCUt9ytNdl/YUDGs1LPdIwQt2+i97K9o3rviAGpIRjB55v1N7s3iSqlVC9mb5KrZ/j+652O2VWdx1/Osy8EZ2UifsP7tuXH8DivwE/BcIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6861",
    Length: "25",
    Mark: "431",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "52",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3091",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529586",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.40418238",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCkz0DA2MTK1NTPRMLY2MlWp1qC0VC7PWsagosRJoN1DAJTMxN7UktUjJykDPQEfJJzUvvSQDygnKL0ksyQQ6F8INz0yBS3mkZqZnlIA4lhbGZjpKrjmpZVC1RoZ6JhYWRjpKzvk5+UBz80pzcmpjAZlIa9ALAQAA",
    Pbi3DGeometry:
      "TQgAAB+LCAAAAAAABACdld9rgzAQx/+XPLsQ42nVPo1tMNgeyjbYQ+lDS0MbcGa4bFCK//uCs139cUmqophvzk/uzN25PJLFRr4dPgXJyZPayFdVyC0JyELJUn+RfHn8ezTTbG5OUgf/yk3I2Ly5mYvUq9Nrt1W1Pph3gbIkngUANDZHwDmFWZgGQMMoiyxywrPQwzqGpJEzHrkhmCeMx40MjLuXPEH67JjBiCfIkggEC751MAEAj3DswVuXDCmkKR8Ef5a7Sw6s+5DO7rjYmNzZHZcnmNzZnYF13+/O93ZFiUAwth3SD94nvxG20xph2zfN81ONZ6wXZGI1IJ5g5YpUgw/EKSPJZu8QVsjU7mNPe6Qp9WUfiDORx6sYab1ekKltHfHE/juysqd2NqTS7DV/XYe49Nv8m+/l+kNoUZGcURaQZ1Hu9L4dvCi91lKV7fBdbs9Tj0Lu9rodPBTi59LwThXKAMvvoqhXv0hLimVNCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2750",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6550",
    Length: "300",
    Mark: "432",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "183.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "52",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529587",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.94338471",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzEkaVLaehIVBD0UETyUHloMaSAmUqNQSt/dSOvfxdvOfsPMFD3ktT50FwkZbF2tc2c65SwgyJ22/gpZ0Y9nMMwow0ki6JxzLCIBA/owjglN2X8S8zT+Qd+BIyxfxYu2rbrQHh4rXZ2lly1kBBMEO2mVbyaxd77yOgwe5VGf3mgjtWr8U1DCGYK1kffJyyiOBEsQLJ1xIdfejBnKBzWvQNQNAQAA",
    Pbi3DGeometry:
      "hwgAAB+LCAAAAAAABACVVVFLwzAQ/i95zkqSpbXtnoYKgj4MFXwYe+hY2AK1kRqFMfrfjbVzwXrNpaWludx99/Uu+bI+kdVWPx/fFCnJvdnqJ1PrHaFkZXRj30m5Pv18umm2cDfp6MUy44wt+pd7SLc5hy3btjq62BkXSZ6nnEqZZKLgVPBknuXUt6fumrJLya9wAZKJPoDJAocEUirEvLenAsf1DDTOIKX8lxOUGkSCyzGQlWmGSxEsRz8hE8YLMfIfm7/hL1Y/aRjC71gIGbD6rQrRAKx+j8bOfzn75Q7+IQASV2mwkdPlm15CGH8AH5EWqBe4bjFsQCBUBIIRvIujlkJcz2GFQCzLKKmZjsAwCmhW1LZCyQaow+Fdj9JzVACGT+AMQ2lWlOyBZ11YUqPOTBfgTvUbXb0qq1pSsoRR8qCavT0Mg0djK6tNMwxf9O536k7p/cEOg9taffqO16Y2DrD5qOtu8wW5xN26hwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "5152",
    Mark: "433",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3149.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "52",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529593",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.43212501",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jVELwiAUhf/LfRZRU9fsKSoI6mGMoIexB1eyCaaxLBhj/z3Z6u1+h++cW41QNPYyPA0oOIXGluYWtW+dAQRFsD6+QFXjciaFY0qY2HCOORUCpvpvbfteD0lNwd7qh4mmB0UwQXA2vo3dDHSFoAxRRxs8KIpFRrJcrpjMcr7OpURwtffFpZQnPBrbdnFmwhmCgzOfX5sxLEja2wUX0iv/dm6qvzCBJNvPAAAA",
    Pbi3DGeometry:
      "zg8AAB+LCAAAAAAABADtV01Pg0AU/C97RrLL7kJpT0ZNTPTQqImHpoc2Je0mCKaiSdP0v4sC2uIbuhs5koamOzzmzX68N2W2Z9Oledq9JmzM7vKlecxTs2Iem+YmK97YeLavfpa3+aT8sIP3i1wIziffX+XFDvPmscvtdrErn1U+D3XkKeWrYKS9IPB1LGJP+YIH+hgOeRSUMNdcnURrLb6itQoJ+A+3GElMgrhpJSAlglskmkusT8hYUjDJ8T8dzWTaGatN4FpWsNCnyxpFJ3BQKZGRpOAmZQ2HXEmKZBR3pATcSEkrpeY67hCoRWSTshKIpmOpuyahYbfJo72kBYItRjAicZkOWlhwNBEJiKZ1o2oAW0wXGoAtz4lTNTRHk65tu41vgl26Bi0DNUzQpxAJWZQIBj0G9GhEAqLd+j/odqRBIdiyZdYFT8Oo+oAnniFpRwPddisIJt911mwPVee6OvmqW3NAGXtwYbc/N2692NGc+3DhfuzWzYXdjAhEu3Vuy6UaXHhw4cGFBxfuy4XLl+Nrs3hJimTLxtznHrtPsnWxqQcPebEoTJ7Vw2ez+rl1m5j1pqgHN2nycRx4lad5SZi9p+lh/gl25do0zg8AAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1017",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "362.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529594",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.97771972",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNo0iRt4kpUEHRRiuCidNFqaAMxkRqFUvrvxhe4mzOcYaoJitYcxqsGBTvfmlKfQuM6qwFB4Y0LN1DV9IlRYZgklC8Yw1zSFOb6Zy2HoRmjGou1aS466AFUghMEe+260L+AcJEiKH1ogvEOFME8SzIpUioyyXIpBIKjOf/LW226PryZ8RzBxurHd00pZhmJ3cpbH8/c3dq5fgIzdLBB0QAAAA==",
    Pbi3DGeometry:
      "cxwAAB+LCAAAAAAABADtV02L2zAQ/S86u0ayJVnKnkpbKLSHpS30sOSQZc2uwY1L6haWJf+9iuVkHWWe7PTSiwj50GT89ObN6GPuXtjtffPt+WfNVuxTd9987drmgWXstmu2/S+2unvxP93f/Ma92D57tbwRnN8MH+7N9uvjY293u82ze1bmXJkykzJX3GZFkStr3TAXWk2NSomDUeqKcKWtvJgiaFHpDE4WIAj3DSiEADFXufRxynPR7J4+4HQugLSFhqEeEXTpZj04V8JMnEPzSM0W5cSKMEYaWknzr9An0tKI6YwyQmOJL8IFkdBhXwF8SklhzTzlV++yGszmQACV0FUYdG3MIM+W7GgzQnjHUs0YF2UOiDanDp1SZKZiO6d8zL7ierBKiTcOkH0SYck+F8AuWeYzeUdmS61REEdQ8lF9AoQZMx1gwFmNGwj3ZlXqQbpS+O1GCA+i5QCtuBhAdOWTakQR2YUAtlLWY7vgiB2uGDAcTxUhAmY8BmlGb2sEPMTAgTeyO1qrqoBpAWqQtUgDkHMB2eh6AWICfVBa6RnjIodH0VX5o51B+uhExZFDjLio5GZCKx0mK7oi6NtYUARgldDA8fUQ1jKNQS8HWjhwV3Ib5KUYXCp/4nPu01ryyA3OeJGtd9XFgGu8s5ZKz18lYodicKQCYtZLL1R1Bkt7AxL0XRiqSYaN4kNESJCo+uR1Kzib6YUNckIvYSgpSQIQRsmiSo7WApCLOy/LFYCOF+5Fp0EnEESYGjt8oKbGLjV2qbG7FC01dqmxo66VqbFLjV1q7FJjlxq71Nilxu6/NXbrjL1vNj/qvt6xFc95xj7X28f+aRx86fpN33Tbcfi9eTj99bFuHp/6cfChrf9MHd91becAt7/bdr/+C2xS/ntzHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1018",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529596",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.71335305",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNI0iRt6kpUEHRRiuCidNFqaAMxkRqFUvrvxhe4mzOcYaoJitYcxquGHHa+NaU+hcZ1VgOCwhsXbpBX0ydGhWNKmFhwjoViCcz1z1oOQzNGNRZr01x00APkBBMEe+260L+ACpkgKH1ogvEOcopFSlIlEyZTxTMlJYKjOf/LW226PryZiwzBxurHd80oTjjjCFbe+njm7tbO9RO1KK5u0QAAAA==",
    Pbi3DGeometry:
      "BR0AAB+LCAAAAAAABADtV02L2zAQ/S86u0FflqzdU2kLhfawtIUelhyyrNk1pHFJ3cKy5L/XiezUUufJzh4XERLiyeTpzZuRRnP7zG7umm9PP2t2xT61d83Xdtvcs4LdtM2u+8Wubp/91/5nft2/2KH4Z3kjOL8+ffRvdliPf3u732+e+v/qldDGFlqvjDJlIcVKV5UsejOX5dFcSldNzYN3qSuxwGw8hpOKcI5W5GWlKAyayOi9kPZgNj34cpDIe0YSEE5s1oQiIHQunJxCKMPtxDx6x+aRHtduAcjARGmpX4x95h2uOMpHE1nkDJBBLCDyS6DPmTFWY9JKucDZqjKR8oswUvWxrMRQsRvuArMw2PqSFMbSgQDTZRBaQdw0Zyd0UAXaTJMC9lZUBTTGzBkUQwMzmVkgUlo7UKSgoqNdAWRKY4RWECAgXSkvnhqOFKeOpIWQHtoofwBVpTqaZWU8trYnEMVF4lyisc/ePaETtKyOVssDfspKiYmAFYUuw54mPO1kp4tbmtRmQm+UD9QeLQgqSQRCrjijHjjsQ1GBTEDUmRVB14l61GV5BN4gjyBjoFhpEBTlzM4L5aZThqqBpo1WBDsSYKPYQW3TIGB/JJMQ97VBEaNLMw3SWt/utPOXAmds6hLnRmzvbKeVZoTWJ3MpqF411iXZf1DbpemdoXXpc1D5FWe8QyJIKCBrOvQoRqQqiTHDOrpFJK8c4EIaZ4be1UhVQATQBqHT5YcUoU8d0vmyfM1EHuoEpzuSB4gwT4h5QswTYp4Q84SYJ8Q8IeYJMU+IRMbyhJgnxDwh5gnx//J75RPiumDvm82Puqv37IqveME+17uH7nF4+NJ2m65pd8Pj9+b+/NPHunl47IaHD9v6z9TxXbtte8Dd7+32sP4Lr+cHVAUdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1020",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529611",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.57495828",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjssKwjAURP/lrmPIq/bhSlQQdFFEcFG6aGloAzGRGoVS+u9GWgu6cXfnnmFmsh7SUp27m4QEDrZUqdVdbQ0gSK0y7g5J1o+nN0QcizDiqwUVmAkawIC+II/D+D/kwZL+wjl2hPmnft22Rec3+MdWFVfpZAsJwQTBUZraNZM4WVc45WeP8qKqGe2lqhv3FpQIhmCn5XPyMoYDwhFsrLY+1jy0HvIXPAPD9hIBAAA=",
    Pbi3DGeometry:
      "0QgAAB+LCAAAAAAABACdVk1rwzAM/S8+u8GJ8+X0NLbBYDuUbbBD6SGlpjVk8ci8QSn57zNZ1qxxhJVSWmLJek+WpZeuT2S1Va/HD0kK8qi36kVXakcoWWlVm09SrE+/j9bNlvZDWjpYFiFjy+7Hfkm7+Qu7aZryaGNzHsRZzukijIMojWgUBYkIBb2wizzvHIzTqf1hjrTHadY5kiScDHCIPQmlLItQmXKepJNIPGFiMqVzxPgQIBRYJShZkAJ7Ci4yMVXwwX4J5OyHcBz76OKuJx7Vwss8rtHgGF2cG+EcAuQGkgWRvBQgklMnX2GdJgNHaDYSzg6WD+xvRMTc9oMYvLOITxZWCKwDbE1QbBARs1vQPxeOoM1P16uNPgc0MZAEevfDOoFkhiQNLe9oHJwdlAjExPtesw7FYLf/D+5U+S6NbEjBAkbJk6z35tAvnrUpjdJ1v3xTu7PrQar9wfSL+0p+/994qyttAeuvqmo3P3FdjUfRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6861",
    Length: "25",
    Mark: "437",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "59",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3091",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529612",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.92420446",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzE0TYUYT1IFQQ9BBA+lhxZDuxCzUqNQSv/dSKt/4G3fzjAzxQCmxnN/t6DhQDUacn1DHhgYQh8eoIthOqNBSS5FtlwvRMbTlVIwsv+I5bd+03VVHzfExxarmw22A53whMHR+ia0M5woVAHj7AkveP1Je4tNGz4QkxWDnbOv2ZsKninJICdHMdY/nRvLN50ziAESAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiWJMVr7NLbBYHso22APpQ8tlTbgzHDZoBT/+7Jqa6PeEldEMffdfXeXu5wuDmi+lq/7jwyl6FGt5YvK5QZhNFey0J8oXRzqVwOTmblQhVvJhBIyOz7MjarlyeymLFd7Y5uEQSiEwBPKAzZNEsxYwGOa4F+A8ugIhBGZWkBEeQ2EkbAAkOpkwQQbdMG4iC8Bo8dHBgX6dubn7dwdVY8qjuOhxM/y3hZC+cG+7WrQgCfhAFMrt/ejr1/n0Mqt2rlpXPSdcDp5OeVgmIBfuwJOmn+H003LLjAUJnREgN13q3ueAmd1oV2GGt2P54qJABbMdcL+duDqE0js1yZQOGP1x88mqBE9RpAnk7vVoQEEjjg/omumKBgT+EkDAT8mt9xvjnrMe0+DGjB/Andy9Z7prEQpCQhGT1mx1btm8az0SktVNMs3uTlDD5nc7nSzuM+z70vFW5UrQ1h85Xm1/AFKtZPDuwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2748",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2748",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6548",
    Length: "301",
    Mark: "438",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "184.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "59",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529613",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.14792644",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdld9QUO0UFQR0kgg7iwWjRgW03bAtE/O9tqB0i6PbefI83L+8gO9OxvSlIYWfPlFndVtYAg8yScXdI826QPpAEHKMYFzPpxVxG0LNfMOSIIv6GQSyTf3CqLab3y6YpW7/BH9ZUXpVTDaSCCwZ7ZSpXj+ZgXenIzx7siS4ftFVU1e5tpAiRwUar55hFyYMIEwYrq63vNQ+t++IFnlHfAxMBAAA=",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVl1LwzAU/S95zkrSph92T6KCoA9DBR/GHjpWtkBtZFZhjP13q221bXKabIyN5Z7ec3Nycw9dHsliLV8O7zlJyYNay2dVyA2hZKFkWX2QdHls/tYwm9cfcqL/kRlnbP77U3/JadWlXe/32aHOTQIv4CKkMx54fsRD6nNPhNEVTX7WvhgCTDRAHMdDQPCYTlEFIRfmjCiKjDUgAHd1vg5cfEwVhH4yDUCqsfIgSoxn2MWd5XWlWybh+T6L+2fbUvWAIVUP6NrUqDBkNCr0GpgKAXhXsPiYanToegauMdbRnvoFtREAa2t9snUcNxbNn+0qwGly2K1rxw3zZ6GCGecYDNwVdB4IWKgMOiAAr5XFLiCVg8G4WiucDs2TYNzZLoZEetwyZQa/nWaCCboGi9UbBhw5N4jbiHRDmDYKaHcODuJoOQMN9TvDrcze8irfk5R5jJLHvNxWu3bxpKqskqpsl69y8wfd53K7q9rFXZF/9R+8UYWqCcvPojitvgE2vp+v5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "292",
    Mark: "439",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "178.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "59",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529619",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.98182548",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eQr9akTqKCoEMpgkPp0GpoAzGRGoVS+t8NrW53x3N35Qh5Yy7DU0MGJ9+YQt9C7VqrAUHujQsvyMpxkRGRHAtF+WZFBWZKSpiqP7ft+3qIcAz2pn7ooHvICCYIztq1oZsN5QgKH+pgvIOMYypoolia8ESqteIUwdXcF5ZSkSI4atN2YfZEMAQHqz+/NmM4IXFv562PV+5t7VR9ATSw7TfRAAAA",
    Pbi3DGeometry:
      "6hAAAB+LCAAAAAAABADtVs9rwjAU/l9yjiVN2troaWyDwXaQbbCDeFAsGuja4bqBiP/7Oo2dtv1MIh52KKKY9zXvfe/1/RpvyGimXtcfCRmQx3ymXvJUzQklo1xlxScZjDf7vyXMhuWHbOmfpOczNtz9lF+ynRyu3axW03V5NxZe0I8F7fmBJ0QYUc69UPqSHgNcxvEvELE+PwFEyOTuRhj6pzeCqN8KVDb8UmClCttArKBxDGhVIRN2bHnE2+VA0eWUmt5p04eXJH3NNYhPFFVyIfY+cM3pAPAoaJdXlgPRrimWdqaRBUypCl8o7bgGMjpruk4VO2fwoaEIyG1jAd8zZIoSwJQY0GVX1xrBhkmMNJmzHvkGLUBOqEJrcutMci2fKodRb7DNjEYvsew9RkK4F9cBY33CisZArU5gu4eazJPDetYYSaHJ2ACsu3GjbyAA9wHUORqqzHMc+meMLYyI7Wg0Z6Ex6BfPd+t2YzZ9rYXAfQlz7vvum8LVNoIrTn7njcB5DMILzqPCGL9uK+i2gm4r6LaCf7sVTCi5U9P3pEhWZMA8RslTki2KpT4858W0UHmmj29qXkEPiVosC324T5Pv4wdv8zQvFWZfabqd/ADBkJIG6hAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1033",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "362.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529620",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.5710919",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomqRN40pUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6sGCVt/NJU+BeVaqwFB6Y0LN5D1+IlRERRTwvh8RhhOCyFgan7eou/VEOVYrIy66KB7kAlOEOy0a0P3AsIziqDyQQXjHUiKCSO8SDNOuSjyghIEB3P+lzfatF14M+MCwdrqx3edppjlJHZLb308c3drp+YJ980jHNMAAAA=",
    Pbi3DGeometry:
      "aR8AAB+LCAAAAAAABADtV1tr2zAU/i96doN1l9KnsQ0G20PZBnsoeUipaQ1ePDJvUEr++7xY3iLZn2T3rSBCLtbJuX3n05HO7TO5uau/Pv2oyJZ8bO/qL21T35OC3LT1oftJtrfPw89eXF73L3Iq/q9c0bK8Pn/0b3LajWpvjsf9U69r+IZbbYsrKjZc8IKxjbSWF5frjKtBICX1BVKoeQ0osMb8FSiqVbHI92iJlnZZUKOl5QqKrrMEFZIxhdnBWB1MwjIVhYPpkl9aEpoab31UGAWcCunFOtEILUnmh/RiD1waHdcYgZ1oBDGlFUIXKDsc7GoXXOtZoGAShlNfwSgZZceLDUE6QYYvZT6T2hdQLuOC1bVGsMKskSG0jpKGKUjF/O0uRLxnQcokLSU776RzQEHIAYgfFKQIvqITgLwxUEgA84ZZlKNAOI2+vucWYV2wyp4VpBKDi96Hc0HZWWD672gHxC6YcAIpvPZkqF8lyQauoaCwbyYCS9bQWSJMjmB8aLtopdYsWj6EFOZzcgOErhG0+FyDmCMIIRFgWaEldHauLjdSWFDuoKowO2gJQo6KB7c9rGqaOCE3kW8YLNzFCA/oOh1suMOSRYL3Q8moT3/lrjHSZVcm7rKlFs4Dk0N6bKCBogOAnPUNc8lNCR6H2Pd8sMyOriUN+iZQQCEh+DCVERrIA8IbGYIK8NqDYIW9AxYONxWENwwKpp2i34SvCHDY0CCy64sKAUEQQkLBoGDieabOM3WeqfNMnWdqL+k8U+eZOnobzzN1nqnjlvJMPb9Z80ydZ+o8U0dhzTP1a52pdwV5V++/V111JNtyUxbkU3V46B7dw+e223d1e3CP3+r7f6IPVf3w2LmH9031+/KPb9um7Q0efjXNafcHjmIEz2kfAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1034",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529624",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.40718177",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACNjssKwjAQRf9l1jEkafqgrkQFQRdFBBelixZDOxATqVEopf9upLUgbtzNnXO5nLyHrMJTd1OQwt5WmFnd1dYAgcyicXdI8348fYELTpNI8uWCSyokD2Eg3zROgvgPGoQR/6Hz8kiLj8KqbcvOe/jHBsurcqqFlFFG4KBM7ZopHK0rHXr1MZ7xMqOdwrpx78CZFAS2Wj2nrhA0ZAGBtdXWz5qH1kPxAtrom4AWAQAA",
    Pbi3DGeometry:
      "JQkAAB+LCAAAAAAABAClVl1rgzAU/S95TiWJ3/ZpbIPB9lC2wR5KHyyVNuDMcNmgFP/7gnN1M97m6hDFeDzn3lxvTlyfyGorn49vBcnIvdrKJ1XKHaFkpWSl30m2Pn3fGpgtzUEa2j9ZcMaW7cWcpNn80K7qOj8aLhfcS6JA0AUPPBEJKoQXpjylf4E0SVqE+XSUwRM0EERxi4QhH6fY0V1pRSwWyIR9P4zGxfyQpeOJnTnWZGA1uGJgznAY/GzixI9H698DAy2LAUrZwPBT/if6sCzu8Fa9emT4KW2OPRk4AShnWMwdBhaza+Yss9198CKbIYYF4FrC3Y/hTG9MMIp7wU7J+YKZ4BG4a2FrwnBmNCdi3dgWOCdrt6G6EXBJgbbpZlywFHR40ATxe8MEKSwAuwnGGpx7th2mB8w/x43MXwtd1CRjHqPkoaj2+tANHpXOtVRVN3yRuzN0V8j9QXeD27L4/P3itSqVEaw+yrLZfAGrwKKcJQkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6861",
    Length: "25",
    Mark: "440",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "69",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3091",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529625",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.41421442",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABAC1jkEKwjAQRe8y61iSGjStK1FB0EUQwUXposXQDsSMxCiU0rsbafUG7ubN/8y8ogdd47m7G8jhQDVqsl1DDhhoQhcekBf9OMaCSEWy5FyuZkImaaYUDOxvaflVWHtfddEjLrZY3UwwHnKecAZH45rQTnCiUAWM6iNe8PqL9gabNnwgU/MFg501r6kb/0qlUgYbshTvuqe1Q/kGW/ttsxcBAAA=",
    Pbi3DGeometry:
      "OQkAAB+LCAAAAAAABAClVl1rgzAU/S95TiWJX6l9KttgsD2UbbCH0oeWhjbgzHDZoBT/+6Tazkyv3lZEMZ7ck3NzP+LySBYb/Xb4VCQhT2ajX02qt4SShdGZ/SLJ8li9ljCblRcp6N+XCWdsdnqUNylWZ7N5nq8PpS0X3ItDEdAJDzwxlZIK4QUxl/SEMFYhfsimLuLHokL8MHIRmO1sIyLRvYwIothBokD6V0uDBQw7eoUChLY2W+SHnVtwAdr7CTraI8CNDvcCKUUXWxNxN6fLpnKniTgRxZENL9OS9s9RFNIjGlTgRgdFNkpa21E3C2DRYFWBwUFZYCsHlQJwAMDywJKNayo90Rwsz4FVMMkEA9hcAoXdYHJLq4MzFtXR0Gy4yoA7Gtw5sWwjO3SPNvj8hBEsGw7BtmjcuYK1qZDyP+Rerz+UVTlJmMcoeVbZzu7rwYuxa6tNVg/f9fYCPSq929t68JCqn+bEO5OakjD7TtNi9QvHTWgPOQkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2750",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6550",
    Length: "300",
    Mark: "441",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "183.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "69",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529626",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.07760923",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzEkaVpLPRUVBD0UETyUHloM7UJMpEahlL67kdYfPHnb2W+YmbyHrMJDd1GQwNZWmFnd1dYAgcyicVdI8n48vYELTiM+X8y4pELyEAbyDRmNZCz+oEEY8R/6CR5h8RqQtm3Z+RX+scLyrJxqIWGUEdgpU7tmEnvrSod++CiPeHqjjcK6cU/BmRQE1lrdJ6+vDUIRE1habX2uuWk9FA+/S7K6FQEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiVqTNU+jW0w2B7KNthD6YOl0gacGS4blOJ/X9bZzcwcOS2ieHf5vvtyJhdXR7LcyOfDW0lycq828klVcksoWSpZ63eSr44/rybMFuYiLf3zzELGFqeHuUm7PsOumqY4GGwYhYEI53QW8iASETUm58a2/FmafgfiJEqpAxALnJuL+Ymf8cw1fpjXo4cnIsMJjeNEOKnihGVOTWfE/0mATHCRILVQCuwsWCB4Gg0r3vfbVEMESOUI2J/vsux2TTDp7Wr1A/YndEAcc4Hzg5phNn8emM2zScDKQLsEA4BTIJPDlQSXPUYXSIUDYFTBjWDCWpmyIuCGg13GI5qXD4HS5WmEE/bjEAIFvE11xMbydVUPAKUKcR6O6c5DBOQHj1Zc08Yf0ma8+Ye4kcVrqcuG5CxglDyU9U7vO+NR6UJLVXfmi9z+hu5Kudvrzritys/+wGtVKUNYf1RVu/4C3ouNQPUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "295",
    Mark: "442",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "180.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "69",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529627",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.39575541",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACFjssKwjAQRf9l1jEk08ZHXYkKgi6KCC5KFy2GNBATqVEopf9upK0bBXdz51wuJ2shLfWpuUlIYO9KnTrTKGeBQOq09XdIsrY/Q4Ejo1NEXE54TJELAR35SSOKsVh8UcFm4i8dl/NRYVXXRRM8wmOji6v0soaEUUbgIK3y1RCOzhdeB/U+nvXlg3ZSq8q/A2cxEtga+Ry6yGkkcE5g7YwLu/ZhTJe/ABruRc8XAQAA",
    Pbi3DGeometry:
      "KQkAAB+LCAAAAAAABACdVtFqgzAU/Zc8W0nSaKt9GttgsD2UbbCH0gdLpQ04M5wblOK/L6jTmt6bWCmWJqfn5J7c3Fw3Z7LeyffTV0pi8qx28k1lck88slYyL79JvDk3PzVMV/pDKq+fmTFKV/WXfki1/afdFUVy0lzGqR+EYunNmPA5CwKPM38e8KVXI4wvBoigImoQblDCloFqhZQtQErIwgheBEcsgU0wY1nHVBNB6EIsfswtEEJPQNvZA+ON9qHVYnOfiyAa5KbR6gFT64LSZa0xA3BaM8AyqJgFQUPDA7hSMzMAcfB1TDtdCqZEYEHwJBhpMwPADxTEQY+a0yheIDdtm3NzoNJxqeEcqHZcxQvFhhYiCji0IDMogB8Ox02Mi424vMdQHMcW6ATY/OgCGCpNuGigJmDXQhm3dDrLbYr2QAxwal1bwQG8isffMCO6NuBFv3c8yOQzLdOCxNSnHnlJ80N5bAevqkxKqfJ2+CH3HfSUysOxbAePWfp7+cd7lSktmP9kWbX9A1ImW4wpCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "296",
    Mark: "443",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "180.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "69",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529634",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.38750115",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG/7mps1NUENRBJOggHqyGDtYWtgIRv3tD6/be4/feq0Yorvo8PBXkcHRXXaqbb2xrFBAonLb+BXk1LjIgyJBmacrWK+SUySyDqf6Dm75vhkCHYKebh/KqhzyiEYGTsq3vZoMxgdL5xmtnIY8pchSSJSIWmUxljAQu+r6wiDwhcFC67fzsI84I7I36/NqMURGFva0zLlzZtzFT/QVv7S8k0gAAAA==",
    Pbi3DGeometry:
      "khEAAB+LCAAAAAAABADtVk1rwkAQ/S97jmGz+dZTaQuF9iBtoQfxoBh0IU1KmhZE/O9NNcaa9W0m0VMJorg+d+bNZD7eZMPGc/m6/ojYkD2mc/mSxnLBDDZOZZJ/suFks/9awHxUvNjWOP4ysDgf7T6KN9tOD9dusmy2Lu5awjIDzxHGwHJM23Y9QwjTDa3QOEFEGAS/iMd9cYrYLg93d1zXqt1xPP88UvmxAptqTeMHcsMMNEhpzeV1apC08AQAkK1LiJ0Js/RfPTXfLyk7wamtCrDtfSziwOyACM8BQOXesYGxIKT6h140xKpcuiGVshN6ev8KY02UTbGothBATwt+9pgwrIrGcsHBt49RzT2ucGiM0BQwSOwFM4N9XAfoFda+wY4FDscIuV7UwUMeVc20NFNcQZq7GHe+Bqk3El4W2Bhh9bRYV83U4I5VEfocV2cMRDQTA04Z1RpBGOBAmzONk0NfsoT6JDyDCxRDi+FE8H9FkdFF53XYGl3kxzVVxnXFRAeV0WGf4isdVk1zMnul0SuNXmn0SuPfKI2pwe7k7D3Ko4wNuckN9hQly3xVHp7TfJbLNCmPb3JRQQ+RXK7y8nAfR99//3ibxmlhMPmK4+30B5VRmT+SEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1041",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "362.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529635",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.42504751",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNoXm1SV6KCoItSBBeli6qhDcREahRK6b8bX+BuznCGqUYojmY/XDXksPVHU+pTaFxrNSAovHHhBnk1fmJUCCU4SxI+nxGOqZISpvonLvq+GaIdi5VpLjroHvIEJwh22rWhewERKUNQ+tAE4x3kDBNOhKKpYEKqTDGC4GDO//JGm7YLb+ZCIlhb/fiuKcU8I7FbeuvjmbtbO9VPyQlUytQAAAA=",
    Pbi3DGeometry:
      "myAAAB+LCAAAAAAABADtV8tq20AU/ZdZK2beD2cVmkChXYS20EXwwiEiEahWcZVACP73qvYojTQ+M7JCdkPIQzk+93nmau7NC7m+rX48/y7JknxpbqvvTV3dkYJcN9Wm/UOWNy+HPzuYnndfZFf8/88Zo/R8/6P7JrtVT7vYbtfPHZdxtjBWmOKMyYWQouB8oZwTxQDgQh8QpdgIUVIDDkactf8QzYwuJgbQG2PUTQ2tN3YKRbNTjWFKOrIgTRyyL5l0XCcqo5Xmb41Jw+wQ6CmviKFUDkIOOYExYdwwsve4MVKqBKevc8gZhzaBEriBeUZinuHGaA6qhrPRI4bVKiGa+aawzLD+px8MxtQQYUKlkBntxzWG+UNbEIDp41QkH44FKVMzDusoaSs9sMMZg5FAFrCSGEgq/6R5AfKPVAwiOH+UjLbWI9JTum57hNoDot2eo7T0brjS3g3je8R2v+MDM+Kni9ojSg452gybprhQidgiI5v1nN6as2NBwbd55Abgo1bG8HhDYdUiUk8ejrF3XOfImxF3INJP2AHcaWwNv4LnaABypmhg3OnIOYDWIl1AHcUDAittgqIC3QL/kYjxaceVwf4nxBycwnTX8DVUcTY8II7765HyedLUzVk70d+ouDrkyb02pKfwbs5Ou4Thl2rEPwi517lQbHSeIAPGBSuJRY7LAq/aMC5sC/YL36dgjSNzBnYSDyBUfRxZJP+kKkMhw5LhkCFnVpuxH1RNKLNIZLACednPy35e9vOyn5f9vOxPnD552T9+yc/Lfl7287Kfl/287Odl/7jI87J/vPp52f/wZX9VkMtq/atsyy1Z0gUtyNdyc98++IdvTbtuq2bjH39Wd6/Q57K6f2j9w1VdPr394KembjqDm8e63q3+Ak/MoeybIAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1042",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529637",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.0969009",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjj0LwjAYhP/LO8eSpGma1ElUEHQoRXAoHaKGNhATqVEopf/d+AVud8dz3NUjlEezH64aCtj6o6n0KSjXWg0ISm9cuEFRjx8ZEUJJkmPM5jPCEiqFgKn5gYu+V0OkY7Ay6qKD7qHACUaw064N3cuQjKcIKh9UMN5BQZIsx7nkKeW5ZEJyjuBgzv/wRpu2C2/PMoFgbfXj245nUkYZgqW3Po65u7VT8wQDEHv01AAAAA==",
    Pbi3DGeometry:
      "NyAAAB+LCAAAAAAABADtV01v2zAM/S86u4G+JaenYRswYDsU24AdihxS1GgNZPGQeQOKIv99TmwltZQn2e1xQtEiEUs+8pEUxdtncnNXf3/6VZEl+dzc1d+aTX1PCnLT1Nv2N1nePvcfOzG97n7IvjifXDFKr49/ul+yXzm1d7vd+qnTZZwtjJSquGJywZXURXcgreXFUUKpPEqEZmIscTpCThVoXvYopbWXVQJ8rTS/bAw6dlKZE4yTcKFnWwt0JpCGAw0lwgDaIDmamZEtoakZCQaF8Nw5TGU5zZJzSkgu3wbhgvCRHbvIpckKCACSBMmYi+ASp42MhyCYHWsYoVLlMd9WuqBmlGesdazHF9MJwatzHjCMo0+Z8s8jnKAwbMnHFSS1l0bUsX4FQUsT7r8AAwpwQUSKKEkwqnrQJWG7YRoTlrxjHDeMwbKBXdXNrMPlUIo+CMP6c276a88q0Z9zPWjI7sPBlqAsfiFCjJOG4qwH4bYXaOvduobzqFsI3EghxqEzF0h6SgezmHM1cvjMMK5fyFeksiPWsAdJluFACuhHZCLy09hgSIZTdX7msQbOPcwwqnpoKhJ7uq39jOD0RsoIxRLBx12PYSAzsFmgqUjnJTMWzmXHGZdKjgkwapjYh4F1DFOb5JPWOBzVN0VpvJI1nZGDQLHLg/Zc5GhuRp4S0OUTygBiHXpaw/crwiXmP81LEH6EfmgsHU3wZEo+stDLPcwkvEog+9ArHAimBVZyhDB8+0GdV2U5TY3PZmzZhq5hCvLqnlf36DMmr+5vQcire17dp3VsXt3z6p5X97y659X9ZUby6p5X97y6x6PJq/uIsP9gdV8V5EO9/lm11Y4s6YIW5Eu1fWgfhy9fm3bd1s12+Pqjvj+JPlX1w2M7fPm4qf6+/Mf3zabpDG7/bDb71T9+Wd4cNyAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1044",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529639",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.87498905",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNoXjWpK1FB0EUpgovSRauhDcREahRK6b8bX+BuznCGKUfIG3MYrhoy2PnGFPoUatdaDQhyb1y4QVaOnxgVQhMsUi4XM8IxVVLCVP3EZd/XQ7RjsTb1RQfdQ5bgBMFeuzZ0LyAiZQgKH+pgvIOMYcKJUDQVTEg1V4wgOJrzv7zVpu3Cm6lAsLH68R1TghmnHMHKWx+/3N3aqXoCm0NKP9MAAAA=",
    Pbi3DGeometry:
      "bSAAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+r+ycSlsotIfQFnoIPjhEJALVKq5aCMH/vWp2FUXSvt1Vcl2MjbXP8/VmdsZz/UiuburvD78qsiOf25v6W9vUt6QgV2197H6T3fWj/drD9LJ/kXMxnlwwSi+fPvo3Oe8HsXen0+Ghl2WcbrQseXHB5EZIUXC2EZqaYgLwbVn+R6Q2svCJSLlNPNfMAhRIeIwrqb26sFeDyJpIBkRIvlqbRybGGI7TgwgNSJtzozjVFmBKTZQtkGeRXtkUGFwOKKNcTGUociBuRtNtmsTI8kxi9CtZJIEwzMtqK5obwBcMRQshXfIpDyd/lHmLsmiNrarY+cVQxtGsDEsE1qc/QDMmACqDAAwfxqKpVhYpjQ63LAn8Gs/jqqJ9cdlKIbAoC8wkRpLLP6VbwPghY+AcBg8DUWpAzNZSrBwglY1Q0NIaEaK0iDUuuHQCHDRXGbfBzVRC9QE8IYK7SLQtvNFh7Be0b9QwqJgBozo2xJdjn/dJeOkyTiMiLFDe8SuxsI9Zxm0f8w+5xPRD+1AXnrmvST+WScj/NMsBK1AXjD9QGLgn4DTHimlesNg6TBi64JAVyGPU2fm9S8/VcnoNXAnFlItQu8ozwg1vEx3ryhgXpBuFjFmAMTUdnyUHjSdhfAbsI5+VnDugeEwEegbZDBU4YgbHjz2DyrAI/PuE/3HhDoOzGeg9KAHYswAB0dr01DMiDfsMRV6RZ2wFsonrDFnB4eet3tsx8laft3o/L3mrz1u9L/y81QMkb/V5q89b/YT+vNXnrT5v9YnjM2/1eavPW73Pijf8fUE+1IefVVedyI5uaEG+VMe77t49fG27Q1e3R/f4o759hj5V9d195x4+NtXflz983zZtr/D4p2nO+39UzJkubSAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1046",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529641",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.15169939",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0aSK1nkQFQQ9FBA+lhxZDuhATqVEopf9usLWIF287+4aZyTvIKjy1NwUp7F2FmTOtdhYIZA6tv0Oad8MZDIzyaMGWMyaoiBMBPflmjMvkL5OM/bIpc2DFp3rVNGUb+sNjg+VVedVAGtGIwEFZ7etRHJ0vPYbJgzzjZUI7hbr2bzHnksDWqOfo5ZwKKWMCa2dcyLUPY/riBTrHiz4PAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVU1rwzAM/S8+u8FO7Xz1NLbBYDuUbbBD6aGlpjVk8ci8QSn57zNptnwKOSMkxM/y05Ms2ZsLWe/16/lDkYw8mr1+Mbk+EErWRhf2k2Sby/XXTbOVe0hFW2TBGVvVH/eSavu77KYsd2e3lgchSzldcBEIsYxoGAYiiSTt4rFIa1zKZQ+XYVLjkejbQzyNvWRJNMUveZx0cckiPksP5BeJy9cvpmfII9J4MtwrPMoaENXAKw9lMpX9Fu/ztHg/CyP7Rv2Iv5GP8yD8Qz1QXGC8kE7Iby/7KM1/5YzS3NtdXCXUE361jPP44VB6oBrH7SF+P7/ALuItN5PGB4ZKAe1Q8LwAKtPLK1Bocw8vjMYLhpoBOtNwe4Deyyt0MuL3xlwePxzqfbyXkftzxN/B3f1+p3fvyqqSZCxglDyp4mhPzeDZ2J3VpmiGb/rwN/Wg9PFkm8F9rr67hrcmN46w+MrzavsD9VASSZEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3044",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6846",
    Length: "25",
    Mark: "445",
    Material: "Copper",
    "Middle Elevation": "3054",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "70",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3054",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3063",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529642",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.36926628",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCgz1DMyMja11DU30TMxNLJVqdWggFwuz2rGoKLESaD9QwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhnCDc9MgUt5pGamZ5SAOJamZuY6Sq45qWVQtUaGeiZm5iY6Ss75OflAc/NKc3JqYwFBG/9sDwEAAA==",
    Pbi3DGeometry:
      "WggAAB+LCAAAAAAABACdlV1rgzAUhv9LrlNJYtRqr8Y2GGwXZRvsovTC0tAGnBkuG5Tif1+wzq/lNHGIYp4c37wnniSbM1rv5OvpQ6AMPaqdfFGF3COM1kqW+hNlm/Pl1XSTlblQjXuyoISsmoe5Ub39/eymqvKT+ZYGJOURXlAe8ISnmLGAM44NjsOwwRGJ6QAvI36JTpMBBTS64IgtLdKch/EAh2yGD2BERzJeI173MZHglNlS7PBomoBcfAakAY8TS4o9H4v/5VOd8c9x60N8VBH+dqZ8NGM9Hs2NJXpiHkoWkAEwpAJ59yp/aOad4V6l7v6vrqQmhe0n88+lDnlxraZr4u7igLhPcQBe5kXP2XiAleHYYXwknNhv6dqdzIt27YyQE/spZKdeGk7styvarcyLbqg5qO9k/i60qFBGAoLRkygP+tg2npXOtVRl23yT+67rQcjDUbeN+0J8DwNvVaGMYPlVFPX2BzufjYBaCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6543",
    Length: "292",
    Mark: "446",
    Material: "Copper",
    "Middle Elevation": "3035",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2663.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "70",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3035",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3035",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529643",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.18251013",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjk8LgkAUxL/LO2+L+0dLO0UFQR0kgg7iQWnRhW1f2BaI+N1bUjtE0O3N+w0zk3WQlvrU3hQksMdSp2jaCi0QSFFbd4ck64bTGxgNeLRYzpigXIYCevKDSSoZl98sjv+xKTOfqldNU7S+3z82urgqpxpIAhoQOChbuXoUR3SF037yIM/68kE7pavavUXEQwJbo56jlzMq5iIisEaDPtc+jOnzF1ySSD8PAQAA",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACVld9PgzAQx/+XPnek0MIYezJqYqIPi5r4sOyBZc3WBKlBNFkW/nergFKOKzXLfvTL8em3d9xteyGbvXo+v0mSkXu9V0+6UAdCyUarsn4n2fbS/jSX2dq8SEP/lEXI2Prnw7xJs+tvu6qq/GzuDQOWcE4XIQ8iEXMahYHgSUiNziNbZmL1LYtwpEdL6qCksZgKX4l4kj7G8CVPHGawXTH9v9tiOsYZn5anUTqVtF73PFa/bYsRgfkWg2TykWpRBrqVBBjfmgd0DIPpnm7sFEMdc4ltO3bfp9iXM+cHOda4JDOVRSqINJWr3pDt6dCrrLB1nBgs3HtMuKsKMIjs+2xYFCBjT4y76RHM/IyYCXd3KxwpmO7b9TYH6u6+gTPLzcHioX/3iIZ+sJGL6W4O9O9sfJhmz3ngNT5s8+Y//Ublr7KWFclYwCh5kOWxPnWLR13ntdJlt3xRh99Ld1IdT3W3uC3k5zDwWhfaAMuPomh2X5TwWtaFCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "356",
    Mark: "447",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "70",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529646",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.11450679",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPIq62pK1FB0EUpgovSRaqhDcREahRK6b8bX+BuznCGqUYoGnMYrhpy2PnGlPoUlGutBgSFNy7cIK/GT4wKxSTlfDGjAotMSJjqn7bsezVENxZroy466B5yggmCvXZt6F5AqUgRlD6oYLyDnGMqaCJZmvBkLjPJKYKjOf/LW23aLryZCIZgY/Xju2YMCyYQrLz18cvdrZ3qJ+mcDZvRAAAA",
    Pbi3DGeometry:
      "fRwAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+a+WcShMopIfQFnoIPjhEJALVKo4SCMH/vWtZUr3bfVop0Nva+EPj8dv3ZmZnNXfv5Pa++vH2uyRrctPcV9+bunogGbltql37TNZ376ev9md6aZ/kkP21XDBKL7s3+yKHzfC3T/v99s3+l60YVya7YHIlheAZ5ytptMrO7VLJo10xfW5WVIbMwFvmsujM3LBifJgZgPZST9GSKmfZDBkD/D/+AAetC/lE1gUBkdJ+zqHj0qdaCHdZLo/mgucuzMk8eI/kT2YhPHDXDEDAkh5ImAmjVq6jf5IJWBLI4TbEE9ienMiSHjYIbFg8KhZqeoajXRs+VaSMuYKEMXOKCNW6X0SATiylntgISZ9MuAIAyjIqUBBI6uA+lpeXDm8zoiKIwkQ669yW5KcbBB6Ywc6LdAxv5wGpse3hNQEkFNSAderMmorOXCgTQjl1WKoHFNmjGJMf7dKonnohZihaGACAjsjkInfPRSbFwvMSnbTALIqOr6LsA0FCJ8IydSCRVOZe39YFn+jnyB2QRO6ATBgFFRsAiabX7QgzOoiTPaAUkEFZgpUf9gdkZpRsNBzuPdKowxQqlBn/wO7pKurKi/R8/4gYKl8xqoInOdWB/eMvitCjBz+823SWDUcGxRFtQ0QeBDgWGXdRAI4URe7ZfCpgL8NzHyhdJgnUIwIH7igbsXbmhQCgA5Q03aXpLk13Uew03aXpLk13abpL093H1aXpLk13abpL012a7s6z8f+mu01Grqrtr7It92RNVzQjX8vdY/vUX3xr2m1bNbv+8mf1MP70pawen9r+4rouX88dPzd1YwF3L3V92PwBXJQ+8X0cAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1048",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529648",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.99580599",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yi0zTXKSoI6jBG0GHsYCWbYBrLgjH23bM36Pa8/B6eaoDiaPf91UAO23C0pTlF7RtnAEERrI83yKvhIxNCMRGMzSeUYy65grH+YYuu031iU7Cy+mKi6SAnmCDYGd/E9mUo5QJBGaKONnjIKZ5KIpVgmZCKz5RI7cGe/+GNsU0b357wDMHamcd3nVHM0hTBMriQzvzdubF+ApfMRbzSAAAA",
    Pbi3DGeometry:
      "yRwAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+r9Y5lbZQaA4hCeQQfLCJSASqVVy1EIL/ezb6ir3s00qkx8XYWKPVmzdvZmc1D6/kelfevfwuyJr8rHflbV2VjyQj13W5b/6Q9cNr99fdppfuQ47Zh+WCUXrZ/rgvOW6Gx74cDtsX9yxbUc50dsHkShppM85WUhuZObsQeWtXVMpTu+UmaEfrtRCdnWk9A4dRR2OKj5TqDB/xH/D99QAH+YV8Yn6RDlIIPicuxH/0y3hnfyd4ijPYhRRn/L31I35vF0bJEM5gR359nN4v4vOhw2CXWk3xAX5hXD6+0E7vibiAX4iP4gI6xOtK9fuCdzxR3se4uGGtXXE9VVcIB9jjfObFC3lG4/LqIYqzVP/zuGB+x3rzdED7FNUDwon125n9CuY9WifI7ukfjWupbjP7QzRej7/Me7+5bHUQVump80gMOMZ09F3dvNM3XhuwlM1K40wZED6gM56alHcwTJ3tLv80xdGG7dwMqtnPqIOa6sKoUA7HnCujWntu+VSPR+sRTbQ+VlPozPRVjsXl64B6Ay4qlMUwTxxXOOtwS4MiCbNBNYtUQG9Qxtgge/TmYIM0UePHB2CeB2vf5jYYbswtOoeQ3X+/BG5j6sD3cl/9cHKhyEgd4BbBg6jQTkd0wI7GyUV0lkUFxQ/Do+Wxru/3KaRCDN/HSTNgmgFD51maAdMMOJXfNAOmGXCRbmkGDOGnGXDGrJRmwDQDphkwzYBpBvz/M+AmI9/K7a+iKQ5kTVc0I1fF/ql57i9u6mbblPW+v7wvH8dbP4ry6bnpL75Xxb/ThV/rqnaA+79Vddy8AT+j9L3JHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1050",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529650",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.87130009",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnFfRdV3BTlFBUAeJoIN4UFrWgW0nbAtE/O8taV0Kus2b7/HeKwcoGjz2VwU57KjBgkyvyQKDgtC6G+TlMJ3eEMQi5FKki4CHUmQCRvYbplLEXzBJsv9wiq3e9cuuq3u/wT/WWF+UUx3kURgx2CurXTuLA7naoZ89yROeP2irULfuJSRPGWyMesxe7rfwmDNYkSGfa+/GjNUTjNXqTBMBAAA=",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVttqwkAQ/Zd9XsNmc/PyVNpCoX2QttAH8UEx6EKaLWlaEMm/N2iSmh2PExElO5M5c2Z2Li4OYr427/uvVEzFs12bN5uZjZBibk1efovp4nB6rNVqVn9EJf8lI1+p2fGn/opq2ZrdFcVqX9uO/NALlC9H2ovDJJRae5H2tTzKA617ikhHJ4UO+haBCuU1JJ2MJxcNdDxJLrtwkMZBwnBCQSBKN3sGcghEgk7C+HL6OsXQ4DpODVIUh37/IhqkTuEgdXI3HcSgjYK6AEhQPpSSk3Aih1RhbG4Ibb4HI3GUcGzuBbGuWbK0zrgCpFCoMnHJXk8IahZ6d5xnwhV6Rpm9tX8xEGxTrn9pGcDG5goHOqd0B9egOyQgKzj4KRTcCMyqQOMDzXH6Pud58ODiJt3w1YKA8Brk9iMdE9w0gIMFOj+nW/9PeDCrz7RMCzFVnpLiJc235a45vNpyVRqbN8cPs+lUT6nZ7srm8Jilv+cv3tvM1oD5T5ZVyz+h7QUb2QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3064",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6866",
    Length: "25",
    Mark: "448",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "71",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529651",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.01675435",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6zQksUaoK1FB0EURwUXposWQDsSM1CiE0rsbaPUG7v4X8001QNniJT4MFHCkFkty0ZIHBiWhD08oqmGSaZDJnC+EXGeKL4XUMLI/dPUXven7JiZ+CnbY3E0wPRSCCwYn423oZnOm0ARML0/2irdfdTBouwSRXCilGeydec9bJXmuVzmDLTlKd/3LubH+AJSPKs8PAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABAClVd1rgzAQ/1/yHCUfVqt9GttgsD2UbbCH0gdLQxtwZrhsUIr/+5y1W6w5jRZRzO/ufveR3GV1RMuNfD18CJSgR7WRLyqTW4TRUslcf6JkdTz9VmKyqB5U4n/Eo4Qs6k/1onJ9NrspivRQ2Xo08FkYR9hj/ozQEDPmBzH+hTmhNcrZ3EBZNI9rmPHIhO0cZ+0gimdd6iAi3EQZpxZqII7eoC+ZOWM2ZcAhoN0b9EWG48Kzx9EuNfWDMAq6FTHwttOuwcmtadDaHhemIRedmNq5OQla5XfIor0FLgagBzAmqIBudQL6AdwJB32AH4wHIgJrZD2pbjQT299pe4cab/whAQXgKemfJgNEgwkA2m5ndtxsu65PoY63zms3mml3ATgPgbvKDruxOAkmToUBop4Eqnv9TqbvQosCJcQnGD2JfKf3zeJZ6VRLlTfLN7n9Ez0IudvrZnGfiW9T8VZlqiLMv7KsXP8AhwZ004kIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6543",
    Length: "312",
    Mark: "449",
    Material: "Copper",
    "Middle Elevation": "3055",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2847.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "71",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3055",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529652",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.97912796",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0SdOWehIVBD0UETyUHloM7UJMpEahlL67wdYfvHjb2W+YmbyHrMJDd1GQwtZWmFnd1dYAgcyicVdI8348vWHGBA1iFs5nnIaRZDCQbxhSLhL5F0qR/MJP7AiLV/2ibcvOb/CPFZZn5VQLaUADAjtlatdMYm9d6dDPHuURT2+0UVg37ikiLgmstbpPXs6oiEVEYGm19bnmpvVQPACTgldPEwEAAA==",
    Pbi3DGeometry:
      "4QgAAB+LCAAAAAAABACVVt9rgzAQ/l/yHCUx8UftU9kGg+2hbIM9lD5YKm3AmeHcoBT/96WtXXV65kKxmHx+d9+ddxdXR7LcqLfDZ05S8qQ36lUXaksoWWpV1l8kXR0vtwZmc/MjDb3teJyx+fnPXKRZX2mLqsoOhutx4bOYS+oFvoyZoAH3JZMz2gVCxqMTIGIR0T5jFp6BJEgoytSVIYN41IUUEe8DgYinCCOaoCiEEekUHugb2LcmEIxukEBYUz8K6QciCUfexQ34Z6rL6MkdMlq5Qx+XwBGWrC4Govq5ReyDhqBETUQHiYV821yA0dkaBko51EiY511fEeQBLmZc2SDaAknAaEK1MKI4nOsSnDZg0UBSQUs4AkYTOIb6AKb0QQYIgKPOuYusk9zGQKiaOPPcBzDAmADAc9XSxe5H9IlhvhfuVfaR13lFUuYzSp7zclfv28WLrrNa6bJdvqvtH/SYq92+bhcPRf7TffBOF9oYLL+Loln/ApUGhqbhCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "356",
    Mark: "450",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "71",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529655",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.26701127",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjU0LwiAcxr/L/+xEnXO5TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRhHKcEjpPGM4IFTA1P2zR92qIbAxWRl100D0UBBMEO+3a0L0MpVwgqHxQwXgHBcVZTnIpUiZyyWdSxPZgzv/wRpu2C29POEOwtvrxXTOGuUSw9NbHK3e3dmqeifcpJNAAAAA=",
    Pbi3DGeometry:
      "hxwAAB+LCAAAAAAABADtV11LwzAU/S957ka+284nUUHQB1HBB9nDhkULdZVZBZH9d+uyTLvmJK0PPoXhZm/Sc+85ubnJvf8kV8vy9uOlIDNyUS/Lm7oqH0hCrupy1byS2f2n+bcdpkfth2ySH8uEUXq0/Wr/yGZuXzterxcf7bsTJqdc5SKZ8KnSkiW8/VVcJduBlKnOQMa3diGodNnhfMo65lz6cYTk6bCAuEi8DHoe7AsACHrGIQ12DcRgNPOHhChYx5Tpb7vMuzCC/bLuw+9Ottgy5cyBcWh2e9wHKFwYB3HsyEvBB4QB/AEuBlqqPA9TAR4BNODi5B3OIGYCVALtArvwVqtWhW8zlak3gSAOsgcDGkIXBRki1U2AEMoY4Xt0wKLa7DqcD4uMMwswzOCqGqpJaL0D+QHtHekDrMZqNqAGhHgexs0zvXUqc24GNAMV8+cYMvNzaYSX2ti1Mps+09moFRwqAsAH4Vi+jJvgqf+w9LB127Xq5p9O/6QOOAvGkYJraKt2po2UinmKOZiMajyYHUoncBj29A1Q6kkA64Enn9AKOgP1EHOvuGc3oxRxBgTvdyDD0c2IKe1WFJzWAuQguCDg805rR+a35tTJNuQWHkBwoH93BK5DCqHLZm8FAAUkNBAIOIXogJV7s4NYQMHAiwuDGcUJKw/w4Qvest/jBVQIoPeKXmzxYosXWzwMHVs8bI0tXmzxYovnxY8tXmzxYosXW7zY4sUW7/9bvHlCTsvFc9EUazKjU5qQy2L12DztHq7rZtGU9Wr3eFc+7IfOi/Lxqdk9nFXF+++JJ3VVt4Crt6razL8Ail/88occAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1052",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529657",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.56689751",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/+xEnXPNTlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhokbP3RVPoUlGutBgSlNy7cQNbjR0YkoRynhM4ThjNCBUzND1v0vRoiG4OVURcddA+SYIJgp10bupehlAsElQ8qGO9AUpzlJC9EykRe8FkhYnsw5394o03bhbcnnCFYW/34rhnFaZwiWHrr45m7Wzs1Ty4FkVDSAAAA",
    Pbi3DGeometry:
      "vx0AAB+LCAAAAAAABADtV01Lw0AQ/S97Tst+J6knUUHQg6jgQXpoaaiB2EiNgkj/u2m6aZvdvG7U61Jamp3MvHkzs7M7z9/kbp4/fr1lZEJuynn+UBb5gkTkrsxX1TuZPH/v/tZielZ/yCY6rIwYpWfNT/0lm2mrdr5ez75q3RGTY0FZNOJjqdI04mwsdSyjZl1Q2QhiznoFSvSvuwqSx40CZXqYpZ1LSgreWecxU/0IgEOrYAP4DDnInnUYPAdYpaI3FNAjSEEkqgNNZdoVtJaEFB3BnoStYSBErGSvJVeAsFtnbWjsUxsPqdUwnyA0ZGcghK5fGEQPYUMITM+KByzwxOyUVsBbX1EVqO0LR/FTXA8rNLQlnHXokifXzjp01VPhbm1AS791ycvNybTR2JefnSB3/8LaQKZ8zQy2CFcAiwCXjS+0aKPC2nd3Koyh15QjwMwBD8FoExKZ6AZcpEp7Ti8qdvmIjSm6df/YK73rK+k2b4P4/T4iFgT0SfCke9QyJYadwfCYdwVMGadU+s9IoQ78B34orzwRutP+k5T3VvThXPBpuAcG0sBeQeY46qhwYUhQH4GNByUWewudgqWAux5KOSw3WNIwIui+aWgopnlvmuybQOtsvd5f6fDgOHGMxqy7xw3vWmDfORE4xEACeK2F2ChSMLS4On0hRLcvJ1BwigAIkJ33quj4BFsFjriX9lB6MBWYN9JASfI3T3tjwJ0EW2QYP8P4GcbPMH6G8TOMn2H8DONnGD/D+BnGz9O37DB+hvHzZKsI46d//JxG5DKfvWZVtiYTOqYRuc1Wy+rFPNyX1azKy5V5fMoXe9F1li9fKvNwVWSfxy9elEVZG1x9FMVm+gOtasOZvx0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1054",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529659",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.31886181",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjkELgkAQhf/LnLdFR1fRTlFBUAeJoIN4UFp0YNsN2wIR/3uLWpcIus2b7/Hey3vIKjp1Nwkp7E1FmVFdbTQwyAxpe4c076fTGRZ+yDEKxdKPeOwlAgb2AyaYfMEgiP+AY2zxrl+1bdm5De6xofIqrWwh9bjH4CB1bZtZHI0tLbnZkzzT5YN2kurGjiJCwWCr5HP2InKBPjJYG2Vcrn4oNRQv/CTnzhMBAAA=",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVk1rwkAQ/S97XsNm82XiqbSFQnuQttCDeIgYdCHNljQtiOS/N2iSmt08JyJKdibz5s3sfLg6suVGvR++MpawZ71RbzpXW8bZUqui+mbJ6nh+bNRi0XxYzf8lM1eIxemn+bJ63ZndlWV6aGxnru94wuVu6EQiDriUTiBdyU9yT8qBIpDBWSG9oYUnfH4NSUbzeNRAhnE07sJAmnsRwQkFgSjd7BnIIZAVdOSH4+nrFVOD6zl1SLGMhxfRIXUKE6mTW+kwDfooLBcACcqnUjITbsohVRibGUKX78lIFCUcm3lBpGuarFVnZAFaUKgycckSCUHNYt0d6dnkCj2jzN7avxgItinZv1YZwMYmCwc6t+hOrkFrSEBWcPBbUHAjUKsCjQ80x633Sc9TBxc56SavFgSE1yC5H60xQU4DOFig8wu6zf+EB5V+ZlVWskQ4grOXrNhV+/bwqqu0Urpojx9q26ueMrXbV+3hMc9+L1+817luAIufPK/XfwlYUTrZCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3064",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6866",
    Length: "25",
    Mark: "451",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "72",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529660",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.45018167",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xiSmkapq6KCoIsggovSRYuhHYgZqVEopXc30OoN3P0v5ptiAFPjpX9YyOBINRpyfUMeGBhCH56QFcMk42AhFV8KuZGar9NUwcj+0JVfdN51VR/5MdhhdbfBdpAJLhicrG9CO5szhSpgfHmyV7z9qoPFpo0QyUWSaAZ7Z9/zNpFc6ZVisCVH8a5/OTeWHzusiz4PAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACdVd9rwjAQ/l/yXEuSpj99km0w2B5kG+xBfFAMGuia0XUDkf7vq111iebasxSL+e7y3Xe5y3VxIPO1ett/SpKRJ71WrzpXG+KRuVZF9UWyxeHvb2Om0+YhtfePTBil0/bV/Ei9PG2bleVq3+ydMOHzKI09FvlJGAqPc1+k3hEOKGtRLpiB8jhJWzgIAhN2c5y94zh0UCdRZKIB53gdQMD+XHAB+3VccPCAuTI8wfYxuXMBAtpHzXwRxeKaxcDt5B0bWunmBqs8GKbBEJea7NxQBkgsGNoqAYJpvKar7Kwyg2KB+wBWAuGPaX9MpcEzcnY7jmbk9YeUDNywHm5Uk4AGXJcAgm71v20ogS04OIBwNCgDdCfcMw5FM3J+QvMQ+Fa5YRwLyoCbnsODHuV/hJvv+r1afchKliSjPvXIsyy21a5bvOhqVSlddMt3tTmbHqXa7qpu8ZDLH9PxTue6ISy+87xe/gJgri3xiQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6543",
    Length: "312",
    Mark: "452",
    Material: "Copper",
    "Middle Elevation": "3055",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2847.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "72",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3055",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529661",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.41131811",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjk8LgkAUxL/LO2+L6/q/U1QQ1EEi6CAeFBd9sO2GbYGI371FLaRLtzfvN8xM1kNa4qW7C0jgqEtMtexqrYBAqlGZByRZP53WsGKcOiHz1iygUcxiGMgSetTlkf8fsugXLmJHmH/qN21bdHaDfeywuAkjWkgc6hA4CVWbZhZnbQqDdvYkr1h90UFg3ZhRBK5PYC/Fa/a6jPKQBwS2Wmqbq55SDvkbVBLGZxMBAAA=",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVl1LwzAU/S95zkrSpB92T6KCoA9DBR/GHjZWtkBtpFZhjP53s61qQ3vorYyOJqfn3HN7b5Iuj2yxMS+H95xl7MFuzLMtzJZxtrCmrD9Ytjxebh0s5u7HGv43M5NCzM9/7mLN6od2XVXrg+POpApEIjWXcZCmccxDGWihr7gHRJE+ASpRsQ8kSXQG0jDlNKmWocNkMIRWsfSBUMuJpmDssfwmBB9z1ZdSSg0m3s73XyHMz4+tg1Cl0UA1OoAv1QH8N9JntGn0Y1zSoCiNheibgvlBALqFwb1qUJT+baqfH6w4dIsWDSoGen56kVAE2Oa0xqEsGBqB4mlk6dGbABHQPHH7QEqU/YZGoHiCbekDlNaHDAjAzW76KoJSRAbFFTz3pm/BkAEB4vkGpSYc0yeG+2a4Neu3vM4rlolAcPaYl7t63w6ebL2ujS3b4avZ/kL3udnt63ZwV+Rf3QdvbGGdYPlZFM3qG/lhgUjlCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "356",
    Mark: "453",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "72",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529664",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.92508706",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizrm5TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRGeU4IXROBc7TlMPU/LBF36shsjFYGXXRQfdQEEwQ7LRrQ/cylHKBoPJBBeMdFBSnGcmkSJjIJM+liO3BnP/hjTZtF96ecIZgbfXju2YMc4lg6a2PV+5u7dQ8AThnVHzQAAAA",
    Pbi3DGeometry:
      "mxwAAB+LCAAAAAAABADtV01P3DAQ/S8+h5W/7SynqlSqRA+IVuoB7WEREUQKm2obKiG0/500iYEkfnbSQ08WApGx82bem8nYc/NCrm7LH8+/CrIll/Vt+b2uyjuSkau6PDS/yfbmpf+3Xabn7Q85Ze+WM0bpefen/SWnnXvt0/G4f27fPWNyw1UuMqY3Jud5xvlGKa6ybsEwNVqwvLMLQaXPDvdTNjLnMowjJDfLAuIiCzKYeXAvACDoGYe02DUQg1EbDglRGBxbpeRfu8xHMLZd/2B28U92O3BrpfWBTMx+l28gY5cokp6/ZcIsCAR4BGwG6NzEuQCHABlx8TOPVpEVhnULAn0JLvkDI2p0Z6bSBIsI4iB7LKCFhFGYEVqTGoigrBN/Tgmk1pXYdD9sNv5awDiL22usOaGkh4sE2sfqx2itVG1ZM4hQnYXOre7datnFrjQD3fP9SOqjN6rXXurerlVfPIayNUlcLAPAB+E4vrI3Wxo+OANs/XatxiWozT+pA46FdaRgDt1+J6ViuKuDvajZg92xagLH4kzeGKOpArAjBMoJJdAbaICYP+GBzxlViDcgeNUDBY4uSUxpv6Lg2BagBMFFAR97WnsKvzUbL9uYW3gGoQXPNRK4jikE7p3zDAAKSGggEHAK0QEr77cOQgHtAucWxrKKEhYe4MMXgk1/xguoEEOf9rw07KVhLw17IeQ07KVhLw17a1RLw14a9tKwl4a9NOx5z6A07KVh738Pe7uMXJT7x6IpjmRLNzQj34rDffMwPFzXzb4p68Pw+LO8e1v6WpT3D83w8KUq/nzc+Lmu6hbw8FRVp90r9y7pMZscAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1056",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529666",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.03963266",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAURf/lrWNI2jQdXIkKgi5KEVyULqI+2kBMpEahlP67cQJ3dziXW49QHvV+uCIUsHVHXeHJK9saBAKl09bfoKjHjwzIjAsaMz7nkmZJImBqftii79UQ2BCstLqgxx4KRhmBHdrWdy/DuZAEKueV185CwWmSsjSXcSTTXGS5DO1Bn//hDeq282/PRERgbfDxXUecxmFKYOmMC2f2bszUPAHuUUBd0gAAAA==",
    Pbi3DGeometry:
      "vR0AAB+LCAAAAAAABADtV01r4zAQ/S86u0GftpSeSlsobA9ld2EPJYeUmtbgxiXrXSgl/73GkdLI0kNueysiJMQaS2/em9FIc/tKbu6a3y/PNVmSH91d86trm3tSkJuu2fR/yfL2df93MNPT4UN2xfvICaP0dPwZvmS3ctPOttv1yzD3hMmFoKxg5UKbquBsIctKFuOwoHIc11LHDVyZmTMkr0aDUnLmUtYnJnyneMVUHCJO4vD+FCC50BQ5NY7UC4CVEVEtoEeYg9DqGJtK44+7lYQUvsGRCGZYCFEpGV0qNCBs52yADZ1ygshSzXQKYUN6FkKUgs+kB7EhBuQ3VQTmuLa7xRm48xYmghreOJZQ8XJmssF9ERigV8mIBwbobjLTgxyBS33cqyTBIORuhgFxCnYyzBGwUqqqwVIRGGAi4NRJKQv3K9wB0/2K9EsuFBgwb8BCMLoXZIQWRpWJI4yKfSi0XYgOvvvk6L5SmCFms9h9VI0pAHRJcO0ft0yJmecwPOsDA1PWK/ZVnVAN/gS/eFC5FqVX/rXh0VR+PxeSM4IDA81APkHWWPF4xkIxQO1ApQYEFDsK/IEJAGscCjNKMZjFUAp4zXQcJAXhmZ7/B285ym94SuBzxWh/YzvibHqphOAQAxngdRZiI6mwuDgzUxriW9dUKtxAAAxIMH1JDLyCVQKrnsye2QRhPDBzNAMFKl0Gg+0BNxSsj7n7zN1n7j7jELn7zN1n7j6jyubu0yeXu8/P6ZS7T4917j5z95m7z9x9fv/uc1WQi2b9VPf1lizpghbkut489I/24WfXr/um29jHP839wXRVNw+PvX24bOv/xy+ed203LLj517a71RvalHv2vR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1058",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529668",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.1398303",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE026SFehIVBD0UETyUHiqGNhCzUqNQSv/dYKsXBW87+4aZKXrIT+bQXTVksKWTycl2NTlgkJNx/gZZ0Y9nMMyE5JhINVcRF6kUMLDfEFUqv2Acp//hGFu+6xdtW3VhQ3isTHXRXreQRTxisNOu9s0k9uQrb8LsUR7N+YM22tSNf4kEFYO11Y/Ji8gVCmSwJEsh192tHconyJ60CRMBAAA=",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVk1rwkAQ/S97XsNmkxg/TqUtFNqDtIUexINi0IU0W9K0IJL/3kVjanZ8TkSU7EzmzZvZ+XC+F7OVed99ZWIinu3KvNncrIUUM2uK6ltM5vvjo1OrqfuIWv5LBqFS08OP+4p6cTK7K8vlztkOwjiIVCgTFYRpHEqtg0SHWh7kkdYdRaKTo0JHXYtIxfIakk5H44sGejhOL7vwkEZRynBCQSBKN3sGcghEgk7j4eX0tYq+wbWcGiTtILoX0SC1Cg+plfvpIAanKKgLgATlfSl5CSdySBXG5odwyndvJI4Sjs2/INY1S5bWGVeAFApVJi7Z6wlBzULvjvNMuELPKLO39i8Ggm3K9S8tA9jYXOFA55Ru7xr0hwRkBQc/hYIbgVkVaHygOU7f5zz3HlzcpOu/WhAQXoPcfqRjgpsGcLBA5+d03f+EB7P8zKqsFBMVKClesmJTbZvDq62WlbFFc/ww61b1lJnNtmoOj3n2e/7ivc2tAyx+8rxe/AH4mJqH2QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3064",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6866",
    Length: "25",
    Mark: "454",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "73",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529669",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.71789104",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xiSNlZaV6KCoIsigovSRYshHYgZqVEIpXc30OoN3P0v5ptqgLLFS3hoKOBILZZkgyEHDEpC559QVMMk42AhFU+FXC8FT2Wew8j+0NVf9KbvmxD5Mdhhc9de91AILhictDO+m82ZfOMxvjzZK95+1UGj6SJEcpEkGYO91e95m0iuspVisCVL8a57WTvWH0DUP/oPAQAA",
    Pbi3DGeometry:
      "dwgAAB+LCAAAAAAABAClVd1rgzAQ/1/ybCUmtn70aWyDwfZQtsEeSh8sDW3AmeHcoBT/92XVrmpzydUhirmP393lcr8sD2Sxlq/7D0FS8qjW8kXlckM8slCyqD5Jujw0v1pN5/ohtXeWTAJK58ePfkm9OrndlGW2176TIPQ544E3pT5LothjzA8T71fMojixiHnIEMazJDoaB0nixADy4LSRxnHkDnjCGCBzxgxpQAGNGEDOTXJ8GiAqsZdtCRf44SwKDXV3FP2YBo8LpF5vMCHg2N0WYXKCFb1OGTyGVfQagKgaxAHkLpzLTUIceQjfbQ2Au1qJ3TXzcUahjBsUKA/zGJulGAyMHDx6dvaw44xkJtcYAJQ1FONgUApoxI3sjIMZx/xQJo77yob9L/KDh8/OBNcyx7kAfYvfyexdVKIkKfWpR55Esa127eJZVVklVdEu3+TmT/Ug5HZXtYv7XHx3DW9VrjRg8ZXn9eoHkLQ5jHcIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6543",
    Length: "312",
    Mark: "455",
    Material: "Copper",
    "Middle Elevation": "3055",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2847.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "73",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3055",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529670",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.08880441",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkSdOWehIVBD0UETyUHloMbSBmpUahlL67wdYfvHjb2W+YmbyHrNKH7qIghS1WOkPT1WiBQIbauiukeT+e3jALBGVxEM4lo0JGIQzkG4aUi0T+hTwR8gd+YkdYvOoXbVt2foN/rHR5Vk61kDLKCOyUrV0ziT260mk/e5RHfXqjjdJ1454i4pLA2qj75OUBFbGICCzRoM+1N2OG4gEeinJAEwEAAA==",
    Pbi3DGeometry:
      "wQgAAB+LCAAAAAAABACVVt9rgzAQ/l/ybCWJscb2aWyDwfZQtsEeSh8sDW3AmeGyQSn+78uqXevsmQuimPvx3eXu/OLyQBZr/br/UGRGHs1av5hSb0hEFkZX9pPMlof21anp3F2kic6SCaN0fny4mzSrk9tNXRd75zthSUwzJqKUxjzPZMRZnEguo0tFIviYXPAMZ56y1p6KHIMD58Py/KjIkikq8glpEEHK7GpGYGgICSpFl6lIpgy5t/FatHIR80SmA/OBuEM/y/+F9eP0W+YPAMr7LUNkBCv6TRt6DDbRb4J30xBOYA/gFnuKOjpbfmsQHRUWLBs41P6MQCCUPSIj8PsOnYjQ1sMEghvSACryOGBy8pFa+KcWQDAgZyOZAUH/WA9MVuNHHp7fgokSPCRxVIw/bn8d3P/AnS7elVU1mdGYRuRJVVu76xbPxhZWm6pbvunNn+pB6e3Odov7Un1fGt6a0jjA6qssm9UPn6rzs8EIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "356",
    Mark: "456",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "73",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529673",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.47676127",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizrlcp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0ZkRjlOCF2kBCdUSpjqH7bsezVENgZroy466B5yggmCvXZt6F6GUi4QlD6oYLyDnOI0I5kUCROZ5HMpYns05394q03bhbcnnCHYWP34rhnDXCJYeevjlbtbO9VPkvmNctAAAAA=",
    Pbi3DGeometry:
      "uRwAAB+LCAAAAAAABADtV01P3DAQ/S8+h5W/s15OVYtUqRwQrdQD2sMiIoiUbtA2RUJo/ztuHAPZ+NkJZ2vFLhnbM+/NTGY8Ny/k6rb+9fxYkQ350d7WP9umviMFuWrrffeXbG5e3L92mZ7bDzkW75IzRul5/2X/yHHrj305HHbP9uwZkyuujCgUtb+lLDhfKcVV0S+UTI0W1ryXC0FlSA73UzYSGxnXIyQv5wHioogymFjwB4AiaBlDmm0aOIPRdRwSojAYFsyY/3JpxmoMVR/EHv/Jbq9cSCMDSk7FYZNvCMcmEZKBf7kWM4AAi4CNUy0002kywCJQjciEqSfTyCLtISqBXgUffe8tznsxlWU0i6AeJE8CmkcYwUzRGidBSssi508pgdD6HDvdD6tNOBewntn1NVWdUNATSQLlI++naC312qxqkKJ6Cp2vtTPLjVvQDJTP957k9nPmfC+1k2vlXn9hNS8I4mw3AP0Aji9d1CiHnsZbZ4RuWK7VOAd1+Sn3gMawkBWMoj8g1OBNxSKVHe1GFR9tT+UU6I4TH6dYTdwAC0Mkq1AYg0gjzMJhj7zVKE+CgOCVD+U5ui0xG6ygT0H7FiATwY0Btz+tA/lvxWWQbsos7EVoIXCfBKZTHgIX0EAIAAfkaeAhYBVqB7TCbzzAgsoGDi9Es4gU9j3QDw/E6/+UGXBESv+k9uXZL89+efbLs18QUJ798uz3Ka/l2S+kP89+sSjm2S+ZVXn2i7bvPPvl2S/PfnMK67Yg3+rdn6qrDmRDV7Qgl9X+vnsYHq7bbtfV7X54/F3fvS19r+r7h254uGiqp48bv7ZNaxXu/zXNcfsK4Q7aX7kcAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1060",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529675",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.71846226",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yi07lcp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0ZkRjlmhC5SghmVEqb6hy37Xg2RjcHaqIsOuoecYIJgr10bupehlAsEpQ8qGO8gpzjNSCYFS0Qm+VyK2B7N+R/eatN24e0JTxBsrH581wnFLE4RrLz18czdrZ3qJxe1Hx7SAAAA",
    Pbi3DGeometry:
      "+R0AAB+LCAAAAAAABADtV8Fq3DAQ/RednUXSSLK1OZWmEEgPoS30EPawISYxOOuycQoh7L/X2JYTW35IaelNLFliz868mTejGc3NK7u+rX68/CrZll01t9X3pq7uWMaum+rQPrHtzevwbyfm592HnbK3N2eC8/P+q/tjp51T+3Q87l863TOhNsRFpvmGjDCZFBtlcpX174mrXqCsWhVIy3WkhpJ5LxDWRpoanJJ5QbP3Mhd6HQJE4RQ8hJAlDzrwHvLnI2tLq2xAl3AQVOgZOFd2LnCmSNFMMIWx1HAYlGu1asoXIPDJ3SU49GqiRBkd6RUERwE6DDIk4wKE4BgD0r6kBBZ6MRyZSSCdt7AWdPeL9xxqaeLqDZ4NXwC9CqXcF0B3g8XuFQk09XGvggF6KR81pkJcJso/zbBIkKlQc4MNwxfAWsDVEyAXnll8yr0zCzkMmvIEOHIQBwk+UEKqByerTWCccRKjYDDFO/dnXmk9NAzbJS4uwI9TssSAXpEs5tNXaIoby3D0+wKhnVfmX7lC7fgvAkSplQWZ2SworFwt6rchEdTwpgfSwF7ByDHtqHYhJaiVwN6DMou9hU7BWsCND6Uc1husacgIvIO6OLim1Tx59wLnrixAscPpgedNodT8mI+Rd4LlPRSBQwwkgFddiI2owuTiAg1xCG9jHlV4uwAYMMDg5dH3CjYMzHoo8vgAYT5w5EgDJSrYEf3jAQ8UbJVpN42CTrtp2k3Tbpp207Sbpt007aZpN027adpN026adtO0m/6X3XSXsYtq/1i25ZFt+YZn7Gt5uG8fxodvTbtvq+YwPv6s7ibRZVndP7Tjw5e6/P3+h5+buukMHp7r+rT7AylZnBH5HQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1062",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529677",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.40932946",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkaZtAPYkKgh6KCB5KDy2GdCEmUqNQSv/d0FYvCt529g0zU/SQ13jqbgoy2Lsac2c67SwQyB1af4es6KczGBZRQrlI0qWUlEkJA/nNIsHiLxjH8j8cU8t3+aptqy4sCI8NVlflVQsZo4zAQVntm1kcna88htGTPOPlg3YKdeNHIXhKYGvUc/ZyTlPOBYG1My7k2ocxQ/kCvQJSrxEBAAA=",
    Pbi3DGeometry:
      "rwgAAB+LCAAAAAAABACVVVFrgzAQ/i95TiXGadQ+lW0w2B7KNthD6YOl0gacGc4NSvG/T1p1mvgZS2lpLsl3313uvtucyXon309fKYnJs9rJN5XJPaFkrWRefpN4c77+rbfZsv6Qiv5bFi5jy8tP/SXVtr22KorkVN9duHeOx1wqhMOEoJw7PucBvZg9zvt23wuvdu4NznuuoBMwXITR2HEeRGIUfggT+u40G0AekLnR6bgZoeihCj8azVhnnxdTx6aBcQPmDTPf4HQbGlBn19NgXGgjMF0AJGifS0lLtWGHVGFseghttmcj2Sjh2PQHsrq2kjVKzFJ6JhCoSVir08kAHWI+m8WtwRP6RTm9rWUxDOpNS8+aj4+a2VYtyLNJdXbd6cKAOCFpN4GQ5k/PAiQXQK3N4xa3s2XKpmtzxweCgUPOMvxMQbD0PVQQ5LlPtZ7+DzL5TMu0IDFzGCUvaX4oj83iVZVJKVXeLD/kvtt6SuXhWDaLxyz97R+8V5mqAfOfLKu2f1DLva6vCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6866",
    Length: "25",
    Mark: "457",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "74",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529678",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.57747224",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jk0KwjAQhe8y6xiSWKzUlVRB0EURwUXposWQDsSM1CiU0rs70OoN3M37Yb5XDlA0eOkfFjI4UoMF+d5RAAEFYYhPyMphOrmw0IlcKr1JU2mMWcMo/pBVX/S26+qe+WzssL7baDvIlFQCTja42M7iTLGOyJMnecXbLzpYdC1DtFQmEbD39j1XjZbJKmUvJ0/8Nry8H6sPB6t2MA4BAAA=",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVlFLwzAQ/i95zkqSxmbdnkQFQR+GCj6MPXQsbIHaSI3CGP3vZms3G7uzV0dpae7r991dLrl0viOzpXnZvmsyIQ92aZ5tblaEkpk1hfsgk/mufvUwm/qLVPTHMuKMTQ8Pf5NqcaRdl2W29dwRl5FIUkWVioQQYypEJFMe0z0QM76385QngV2ocXogMKZCAFI6MaRMz7kQV5KH9liIYTGBrnuyG+C6J6aukoj5+ayPwO8JhLIDXYel4JFMlOwqtezhdHQJdRJtQlA6jFKfi05MYXYoAAoWdB2UAqH075i62QXFBoMFdwtYCxQDty0w9QZnClj9OKGLmgQUUe+++9MDatmAAG7dgEENZwxvXeDiRLUonBQKgHYM1AVRQhf1WahrgiceBOCUUACuz2IOBSSjBvy/wq3J3rTTJZmwiFHyqIu12zSDJ+syZ2zRDF/N6gTda7PeuGZwl+uv9oc3NrdesPjM82rxDWtn2xTdCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6543",
    Length: "312",
    Mark: "458",
    Material: "Copper",
    "Middle Elevation": "3055",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2851",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "74",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3055",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529679",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.77733172",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0SdvUehIVBD0UETyUHiqGdiEmUqNQSt/dYOsPXrzt7DfMTN5BdsR9e1GQwsYeMbO6rawBAplF466Q5t1wesOECRpIFs6kpDyaCujJNwwpF0n0F7IkDn/gJ3aAxat+3jRl6zf4xxLLs3KqgTSgAYGtMpWrR7GzrnToZw/ygKc3WiusavcUMY8IrLS6j17OqJAiJrCw2vpcc9O6Lx6W0JAqEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVlFrgzAQ/i95tpLEVK19GttgsD2UbbCH0gdLpQ04M5wblOJ/X1zdZqYfnkUqJt99393lLknXJ7ba6ufjW8YSdm+2+snkesc8tjK6qN5Zsj6dPy3Ml/Zhtfc3MxOcL79f9sfqzQ/tqizTo+XORODzSCgvinw5V8KTwldcLTwHkDJugCAKQhdQ1rIBYmtAk2oZSkaDLlQQCgcQCxFODAr6HsuP7nw0qp6U5DwaTLyd7y8hyu+fb+XLIJ4PVKMDuFIdwF2RPqNNo+/jnAZFacxFLyiYH04cRgudO9UgKF0eVH/RYcVhtGjToGIg++lFQh5gm9Mah7JhaARKTCNbj9wEkADmqccHUqKcNzQCISbcli5AaX3EwAA8zKfvIihFZFCigvfe9CMYMiBAvN+g1IRrumHY/ww3On3NqqxkCfe5xx6yYl8d2sGjqdJKm6IdvujdL3SX6f2hage3efbZNbw2ubGCxUee15svP7ogleUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "356",
    Mark: "459",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "74",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529682",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.43693301",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizuZmp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw0Sdr4xpT4F5VqrAUHhjQs3kNX4kRGZUY4TQhdCYMZYBlP9w5Z9r4bIxmBt1EUH3YMkmCDYa9eG7mUo5SmC0gcVjHcgKZ4LIvI0YanIeZansT2a8z+81abtwtsTzhBsrH5814xhntMEwcpbH8/c3dqpfgIFG7zy0gAAAA==",
    Pbi3DGeometry:
      "lR0AAB+LCAAAAAAABADtV01v2zAM/S86u4FEfdhOT8M2YEB3KLYBOxQ5pKjRGvDiIXULFEX++7zIzhpLT7J72EkIEsSiqcdHUqR488qub+sfL78rtmZX7W39vW3qO5ax67bedY9sffNq//Ziftl/2CH7t3IhOL88/vRfdtiMah/2++1Lr3sh1Ip0KbM8XwnDZUa00loW2VGQC30mKKQ8CqTkyivAGlycrZdah3eSivJ5RpEasBENB+OkgbaC4Niq2eDII4JExChIY8AmouKvQJViwq+U6kww0nA0RgzSJL1buQIEfjJ3Co6tGjxSCJppFMSG/CwEGaXn0YPYEALTQw6JZhtxa66W6NSccmRwYa7FcZ2bYK7hfaAgatJ82sDWGDcnPSL7LI6Dyw3GekzAqQYuUig78Fazq3O8rKE0CGcNWJ7GIU5tuftm144o5wkJKoyFlmTXjQTl901rsySsqVqXdtloWyBkbpYFdIE7IIbfprHKCVKWgtDBJhziDARGnyelKd7pJdhXllGD8RwVZDH41KhgJ0Dv4w6BFGIZBnus6+0YOccbsGYEUgwGFFgb4OdNgcBhBynjtwheJVHWwxuY0MbvVtj0pT8p4XUDd0tjvOehF+R+1hFo2LOQwHNTRdAxP6G7rScUfhLY39BNCBkhIG6oDECTUD3BoUYWLaWGw+BHgO+H24NLDfoihuDUxDRppkkzTZqg1qVJ03cy0qQZuz2lSTNNmsGApkkz2FfSpJkmzdBwkCbNeT0rTZpBbmnS/D+T5iZjn+rtr6qr9mzNVzxjX6vdffcwPHxru21Xt7vh8Wd9dxJ9qer7h254+NxUz29f/Ng2bb/h7qlpDps/aoUcxZUdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1064",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529684",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.25366484",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yiznRbp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0ZkRjlOCF1IiRljKUz1D1v2vRoiG4O1URcddA85wQTBXrs2dC9DKRcISh9UMN5BTvFcEpmJhAmZ8TQTsT2a8z+81abtwtsTzhBsrH5814ziJE4RrLz18czdrZ3qJ5O3t0/SAAAA",
    Pbi3DGeometry:
      "+R0AAB+LCAAAAAAABADtV01r3DAQ/S86O4s+bXlzKm2hkB5CW+gh7GFDTGJw12XjBELY/15hW07s8YvUlN7EkiX27MybefMhzdUzu7yufzz9rtiWXbTX9fe2qW9Yxi7b+tDds+3V8/CvE/Nz92Gn7OXNmeD8vP9yf+y082ofjsf9k9M9E3qjuMiKYiNzbTIpNjovdNa/V1z3AiPVqkCUSkdqaFn0AiltpKnBKWGFnL2XhTDrECAKr0AQQpYIdOA95I8im1KtsgFdwkEoa2bgXJdzgTeltJoJpjCWGh5DFUavmqICBD65uwSHXk2U6NxEegXBUYAeQ+VKxgUIwTEGpH1JCSx0O7TMJJDeW1gLxv3iNYdG5nH1BnuDCqBXoZRTAXQ3WOykSKCpv/cqGCBJ+agxFeIyUbSbYZEgU6HhBgcGFcBawNUTIBf2LO5y0rOQw6ApIsCRgziU4AMlrr37Li9NHjjOuBKjYDDFnftzr+wwMEqXuLgA30HJAgN6paSdn77CqLhjGR79VCCM98r8K1doHL8jQJRaaVU+OwtsKVeL+uWQCGqQ0wNpYK9g5Jh2VLuQEjRK4OxBmcXeQqdgLeDBh1IO6w3WNGQE3kF9HNzK1TyRe4F3V5Sg2OHp8cZ5U6h5m4+RO8HyHorAIQYSwKsuxEZUYXJxgYY4xLexJVV4uwAYMMDg5ZF6BQcGZj1YPdEBwnzgyJEGSlRwItL2gA0FR2XaTaOg026adtO0m6bdNO2maTdNu2naTdNumnbTtJum3TTtpv9lN91l7FO9/1V11ZFt+YZn7Gt1uO3uxodvbbfv6vYwPv6sbybRl6q+vevGh89N9fj6hx/bpnUGDw9Nc9r9AZ+gjuD5HQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1066",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529686",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.82247912",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjkELgkAQhf/LnJfFVtfSTlFBUAeJoIN4UFrWgW0nbAtE/O8tah0i6DZvvsd7L+8gq/DU3hSksKcKMzKtJgsMMkLr7pDm3Xh6Q8LDUMTLUHAZLCLo2U+UzOZfSMjkLxoCi3ftqmnK1nf7xwbLq3KqgTTgAYODstrVkziSKx36uaM84+WDdgp17QYRC8lga9Rz8grBIxkzWJMhH2sfxvTFC48qvZAKAQAA",
    Pbi3DGeometry:
      "LwgAAB+LCAAAAAAABACVVd9LwzAQ/l/yHEua/t6ehgqCPgwVfBh76FjZArWRWoUx+r8btZ3LeZd0jI3la/rdd5f7LqsjW27U8+GtYjN2rzfqSddqyzhbatV072y2Ov7+NY/F3HxYz/+Qq1CI+c+P+bJ+Pb62aNvyYN4tAlmkIY9kkIg85lIGcZJyg6ZxbqF5Jr/hLLbQNAk5RRGFuUQ2RzKLMGbAkYR54tCBi8Z1XBYQhwkSmGMiiuh/mUZ0Wi6jkIGjCLPzUo8cIww4RtjO3N58Eg2oUQ4CnSYD1tSGCXlELkD0UNOJHG4hVDb2Cbgj+vSBvvG0EyDBu4xqPk/uRL+Ds/GEtAVSIdECXmY8ggM3mNt24HQJN7p7AQ8IxE1qJ2hoQgY+fwEHPpXdsxp3OT5P7b3OaFNmim8ATRnqOAV153iuImBlj2cJ4xMhzwSa2/dGla9VV7VsJgLB2UPV7Lr9sHjUXdkp3QzLF7U9Pbqr1G7fDYvbuvo833ita20Im4+67tdf1TeZvy8IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3045",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6846",
    Length: "25",
    Mark: "460",
    Material: "Copper",
    "Middle Elevation": "3054",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "109.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "75",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3054",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3064",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529687",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.65567104",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCiz1jCzNDK2NjfTMTE2MlGp1qC0VC7PWsagosRJoN1DAJTMxN7UktUjJykDPQEfJJzUvvSQDygnKL0ksyQQ6F8INz0yBS3mkZqZnlIA4lqbmxjpKrjmpZVC1RoZ6JmbmJjpKzvk5+UBz80pzcmpjAcGLq5ELAQAA",
    Pbi3DGeometry:
      "KwgAAB+LCAAAAAAABACdlV1rgzAUhv9LrrOgMX61V2MbDLaLsg12UXphaWgDzgyXDUrxvy847dQmOalIpXk9PufNxzmuT2i1FW/HT44W6EluxassxQ5htJKiUl9osT79/dWPg6W+UIP/lZswCJbtTf9Qs+lfu63r4qjfzQlNGY4oSSIaYkoJoyzFOYnCjLrkNIk8omkatXLMKAwxG6F5ErYy9UjYIybghGUGG5Z8RoTNcm8ui2OQDEzblTAkLNFh03mf5VHCy+AJY7QrENqWcbgtgA+LOtqVi+Cx5/FCQzO0MIwqgJgshs+BtqDBaAsb2C2vdbKcUy/I3BqwODFXqFn1QECq5ZC5O4KLMbPXuA+7uQVNVA8EpJqL1thhPQizOrfZA/S5cZBnNjBbXQEVfl0/GNjWX957UXxwxWu0CEiA0TOv9urQDV6kKpSQVTd8F7vzo0cu9gfVDR5K/jMMvJOl1MDquyybzS/5O8ItKwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6543",
    Length: "292",
    Mark: "461",
    Material: "Copper",
    "Middle Elevation": "3035",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1261.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "75",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3035",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3035",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529688",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.03742965",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkCU1JPYkKgh6KCB5KDxVDuxATqVEopf9uaKvSk7edfcPM5B1kFzy1dw0p7N0FM2faylkgkDm0/gFp3o1nMCwiThWL1VJwKqMkgZ78oKJcCPkPKTZHs8gBFp/qVdOUbegPjw2WN+11AymjjMBB28rXkzg6X3oMk0d5xusX7TRWtR+E5DGBrdGvycsjKhIhCaydcSHXPo3pizeeZL8sDwEAAA==",
    Pbi3DGeometry:
      "fwgAAB+LCAAAAAAABACVVd9LwzAQ/l/y3JU06e89iQqCPgwVfBh76FjYArWRGoUx+r+b1apx7TUXSktzl/vuy13ubn0iq618Pr4JUpJ7tZVPqpY7EpCVko1+J+X69P1r1HRpHtIFf5JFROmy/5iXdJsfs6u2rY7GdhGxsKBJEXAWplnKAxaFPGd58E/BWTSriFmGNGC9h5jGBQ4IpJTErFdkPEW6HqBGLvIkmeYE+oaQoEMMXGOeRkgPjnCc5UXIuDn7xe6xtAe3xLZPJ4aVLjcyILYz5eYBiO0kjXdfsLbj7TziNIRPoMEszkZv7vYgdk9jOz0CUQKvK4IJiIMxwPCBys0r+T5pBjuC+xZ6dZZZAwwfV4fyqyJkKYKdF1HouBaOssAwcs0tZKvy63fQiHP3Up9JeTYw0/xGVq9Ci5aUNKQBeRDNXh+GxaPSlZaqGZYvcveruhNyf9DD4rYWn/bGa1UrA9h81HW3+QLFlzBtfwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "6748",
    Mark: "462",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "29183.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "75",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529691",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.66824243",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yyi5jTtFBUEdRgj6DB22Eo2wTSWBWPsu2dv0O15+T085Qh5Yw/D1YCGXWhsYU6x9q0zgCAP1scb6HL8yIQozJSgixnDIuMMpupHLfu+HhKagrWtLyaaHjTBBMHe+DZ2L0MpFwiKEOtogwdNcSaJVGLGhFR8rkRqj/b8D2+Nbbv49oQzBBtnHt81Y5gzLhGsggvpzN+dm6oncQqofNEAAAA=",
    Pbi3DGeometry:
      "tRsAAB+LCAAAAAAABADtV01r20AQ/S97Vs1+S+ucSlsopIfQFnoIPjhEJALVKo4SCMH/vVtZUqzNPK0celyMPzQav3lvdjS7c/3Crm6qn89/SrZml81N9aOpq1uWsaum2rUPbH39cvzpb/ML/2KH7NXyQXB+0X34Nztshr993O+3z/6/bqVUXmRKrowTeSblShe5zLxZGntqNsLm3iytpczI21kxMcvCYRBptF7ARJu8C0nzDrEHbxoEhERMloUE4rU2ZoYJ4N2HtEbLziz1qRz77/LVPPAOvAdsW6icAgnMdMgRZBoSMenFWyHNAiYgJJAzYDvj4nJASICN5NDiI+VjVU/QkmU/rPwgh1vdmZXTuHwQCDDPM1moEhCMyAlWfh7kvHyHcsBaDlU19Ub9hF55BLKsa0a6D1ji+YJA5mm+Y3LOStWyZz6iMuCtBM87s4/ZmZ2l2uO4wfQgxqpjvp3qeIsepHDLF22heIBNMxlValUceWuHd0CokjYrMSk2w8U7cgK6/VlywKKN3tYVxwz6b9iogTfq38B7vnzAVhcmNiInEA+eeVg+9KLRBJEcsMTgcUUFQTFBhzNQyOCQUwhDZRBsupYuNrDPo82LG6K+vVlTKiMhwU5Cm98c/OiQ8zkBx8S3+SZ5o8SCnNAhETYtBzzFgAloBfAgApicIwfmm8QG3vP9O5QDxEewgxaWJq80eaXJK01eafJKk1eavCZH5zR5pcnrRHyavNLklSavNHn9j8lrk7HP1fZ32ZZ7tuYrnrFv5e6uve8vvjfttq2aXX/5q7odb30tq7v7tr/4UpdPp46fmrrxgLvHuj5s/gJdY70RtRsAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1068",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529693",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.82651514",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yyizrm0U1QQ1GGMoMPYwUo2wTSWBWPsu2dv0O15+T089Qjl0e6HqwEF23C0lTlF7VtnAEEZrI83UPX4kQmRmElB5xnDIucMpuZHLfpeDwlNwcrqi4mmB0UwQbAzvo3dy1DKBYIqRB1t8KAozgtSSJExUUg+kyK1B3v+hzfGtl18e8IZgrUzj++aUZylKYJlcCGd+btzU/MEgnXrHNEAAAA=",
    Pbi3DGeometry:
      "tRsAAB+LCAAAAAAABADtV02L2zAQ/S86u8bWl6XsqbSFQntY2kIPSw5Z1uwa3LikbmFZ8t9rEiu1x/Mqp8ciQkI8Ud68NzMaae5exO198+X5ey024kN333zu2uZBZOK2a/b9D7G5ezl/HX4uboaXOGZ/LK/Korg5fQxvcdyGv70+HHbPw399Lr0tMyVzW0qTyTLXttKZz5U09mSWuuLMTrFmslpV7mQ2WsZBLky88VOztRw24H1ZTbAjIMRlxAxCRVwarRnxiAngrZSduSy0n5oDiNJqag68yeoRW1VGMyDUDFwGgsQlYBLEa2tWMAEugZwRW1klV8gBLgE2kEPEgzqpxrIPZnkmCFKsnZqFyki7onxAfRMzYBLJJTEDgpGKJZkHINcxicghuQyrQ1WRNJANCDIPQCLdB2xuYgYpBqGKRBDsNFDIZKcBlREQYgYqed6qMGfxytvTvvTG4pNEeidH8xmkkNVMjhtBinKFnOvEE2yeiZJqftSVRq04AcHpSsxlEZiYf48JaI/XyeGTJitXzTqy85IpzdCoI6sJQX41YsKDoMCiGmTFoz3Plw9KGiAI5IAUo6bE55JnAkuTzzy4+AXe1jkuDeTQDQQdX7Ggf6PDy7tJfV9UOj+/s/EuATYw8+c8cAliAq/OoNj+HipwmyExQRdtFhtFMHLdIkzA5kaBjahcIwfVIFCJssOnIdKr5uIREwCSJq+lyzR5YZdp8kqTV5q80uS1NKfJa3lhTZPXslGnyWtJME1euH+nyStNXv/b5LXNxNtm963u64PYFHmRiY/1/rF/Gh8+df2ub7r9+Pi1ebj89L5uHp/68eFdW/+aLnzTtd0AuP/Ztsftb+c9kjO1GwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1070",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529695",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.71743596",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkSX9sPYkKgh6CCB5KDy2GdiEmUqNQSt/dSKsgHrzt7DfMTN6DrPDYXRVksLMVSqu72hogIC0ad4Ms78fTG2YJFSkXizSmkeARDOSbBcH8H4vDhP+wKXNkxbt62bZl5/v9Y43lRTnVQsYoI7BXpnbNJA7WlQ795FGe8PxBW4V1414iYCEnsNHqMXk5pxETBFZWWx9r7loPxROJ/ShUDgEAAA==",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACdlV1rgzAUhv9LrlNJdH7EXo1tMNguyjbYRemFpaENODNcNijF/z5xam309MQhink9ec6HOcn6RFZb9Xb8lCQlT3qrXnWudoSSlVaF+SLp+vT3Wn9my/oiFT0rC87YsnnUN6k23bTbssyO9dxF7AXCD6iIvDCIE+r7XhiGnA71RIhGZ8GFHAaNypNLGaK05oKLKXjEYn+oRzdczAkG8ork5OoWC2fE8aN4Kt1et6s2ndbILefJVO072aJ0sl0Ey7wP3qJ3sWMYBG9FA+UE5gpFCbgdlR7h/DceOy37z2LVAfrBdSEjGDcZKg20ujF7AO/oFfqBSK/N5Tjr0EJAmhO0h/iufqGVNnfvwjiuOtAQwJZ23RqCuzoFNkbk1JgHcZOhvscaGTk3bfxZrs/0e5V9SCNLkjKPUfIsi705tIMXbTKjdNEO39Wu//Qo1f5g2sFDLn+Ghnc61zWw+M7zavML3Rilr4UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6861",
    Length: "25",
    Mark: "463",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "77",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3091",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529696",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.65407478",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnTN9YyMLEytLc30TC0sLZVqdWggFwuz2rGoKLESaD9QwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhnCDc9MgUt5pGamZ5SAOJYWxmY6Sq45qWVQtUaGeiYWFkY6Ss75OflAc/NKc3JqYwGMEmtPDwEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACtld9rgzAQx/+XPKdirMZon8Y2GGwPZRvsofShpaENODNcNijF/31B7eqvI+c6RDHfXD53uSSX1Ykst+r1+CFJSh71Vr3oTO0IJUutcvNJ0tWp/rXd/sI+pKQXZcZ8f1F97EvK9XnYTVFsjnbsLPZYzEOacC8SSUKDwAtjJqjVg0BElT6PRVtnCeOVHs07MoA5m/OAx2N4HrJRt5A+CGdi+CBf+HyUA+kQh9u8jM230XtpA8ME3Hayz7xQiGCIuejd7Azt6+hb9p3VcnNc/H48kN/udBH2EL+T/Sv8OuKB/PaWBXcooPQj7CE+tFwAx5Xm/ibHcf6rCEDLizh0KA5CR20TKJ6p9lOLErAN3bUHQ3HLjqM+qGwYzN/rJlQIgVtrXEZR3DKqaDprO8q8lu39fqc279LIgqS+51PyJPO9OTSNZ202Rum8ab6p3W/Xg1T7g2ka95n8bhve6kxbYP6VZeX6ByQ/xGiRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2750",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6550",
    Length: "300",
    Mark: "464",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "183.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "77",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529697",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.35540894",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0adPGehIVBD0UETyUHiqGNhCzUqNQSv/dSKvUk7edfcPM5B1kZ31sbwpS2OFZZ2jaCi0QyFBbd4c074bTG2aMUykFW8xjKkIuoCcTmNCQMfmPxVHCf9kkdIDFp3zZNGXrF/jHWpdX5VQDaUADAntlK1eP4oCudNqPHuRJX75oq3RVu7dgQcQJbIx6jl7OaCi4JLBCgz7XPozpixciPYbXEQEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACdVd9rgzAQ/l/ynEqiUaN9GttgsD2UbbCH0gdLpQ04M5wblOL/vqzazWgOzyKK+e7uux/JXdYnstqq1+NHTlLyqLfqRRdqRyhZaVXWnyRdn9pfI2ZL85CG/iMLztjy/DEvaTYXs5uqyo7GdsF9T8qQ0yTywiCW1OeeYCKhlkAmya8gCH1pC8LgjEcDGCRq9YXgsdOBCCPbIBI8mRkS6HsqO7zzyajGVH4UOzO/CEYlhPKzfcdewLkcbkUPtWh6uFWMsX6bwIi9DR9BM0E/DAdKCkwWChPwa5d/mufaeEZ5QbsL1QfqD6D8kPrcbQHoodOMOiWYtsAZICKa7C/0zgP6II6bERARatrgLDAxAcfRwhFdAKi7YXhSz20acCSiDDARAdfZvNHq1najuMvKTTPjwjX65ua/U9l7XucVSZnHKHnKy3196BbPus5qpctu+aZ2f6KHXO0Pdbe4L/LvvuKtLrQhLL+Kotn8AJKIo9GrCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "1699",
    Mark: "465",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1038.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "77",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529703",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.44674915",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABAA1jMsKwjAURP/lrmNIn9q6EhUEXZQiuChdpHpJL8REahRK6b8b2rqbmXOYaoCioWv/QsjhbBsq8e6kURqBQWHJuDfk1TBHr6zWPBZJtM1SnmyyDMb6r+26Tvbe9cOB5BMddpALLhhc0CjXTiWIGJTWSUfWLPRGjxkGQZwyOCGp1k1dxCGDo8bvoochT4Q/2Ftt/bf5aD3WPydxVUbBAAAA",
    Pbi3DGeometry:
      "ZRAAAB+LCAAAAAAABADtV9FqwjAU/Zc815I2TWv0aWyDwfYg22APsgfFooGuGa4biPjvq7Z2NetZEpE9FVHMSXruyc3NPTrdkslcPm/eUzIi92oun1QmF8QjEyXz4oOMptvqazlNx+WL7LwfZBBQOj58lG+yez0+drVezzbls4PEZyJknoj9OIwTLwx9LgLhtXA+FGKPxzQJ23gcBQeccx6crGfJsAtv+IMhs+GB/EAPigvxmodTZiOTc9YJd7OcK+bXpuqo9ZlElFcimQjaNA0eRpX4sJJzxA/ruvAmbMQ6efbzFnERP9TTZI0LK50Rjf+Mq+mE+zLp13kAbpsHdLxIJzh2QzWg3bruSs8yKlrEYyxysCtEj+SAm3gKW5eO41U5lixoALaVoPcLq+5i0gJbrIabriG6thDXrgNq4YjHaAWW1mHUAyxOx63brN4WAA6vOWgLOo/RitG+TPlEebAzOWO5GdJ8pkNbthFj1IsYuuuvJscW7mz0FzL0ixm3q6G7Whla79r1TXnrDb039N7Qe0P/f0Mv/7PfyNlbWqRrMqI+9chDmi+LVT14VMWskCqvhy9y0UzdpXK5KurBbZZ+tRdeq0yVhPlnlu1evwFUqFpZZRAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1075",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "362.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529704",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.89252888",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjMsKwjAURP/lrmNoY9OXK1FB0EUpgovSRdRLG4iJ1KtQSv/dqBXczcw5TDVAcdKH/oaQw86ddIlnUrYxCAwKpy3dIa+Gb/TKLOFCpHKRxVymWQZj/dOWXad67/phrdUVCTvIAx4w2KNtqH2XUMZzBqUjRdrZCR/15Z9uUTctfXokUwYbg89JF4JHSei3lTPOv9uHMWP9AhH5R+LDAAAA",
    Pbi3DGeometry:
      "Yx4AAB+LCAAAAAAABADtV01r3DAQ/S86O4s0+rI2p9AECu0htIUewh42xCSG7bps3UII+9/r2nJqK36ynbMICfHs2zdPb8aS5u6F3d6X355/FmzLPlX35dfqUD6wjN1W5bH+xbZ3L92/zcf8svlh5+x/5EJwftn+aX7Zedd/7ep02j83372wGylEnjmzMVKJjGijnZPZIK7JqjautRjFlbaTeBTPnfsXN8KabEnenkdwt0TPK89SvKZVPAg/qydYF9Tp/VGOTMwHkSs55FG2wQ3iPb6PE+V6qDPEv+ExZiTnnfRkycbwvZ0hPpQzhw/50bKgzpX85MSUPVC+s2N8bnSsG97Lg7oHdvPCLifpzCgupI7G15YX2AmWC2lAHNqM5FsuRi+1UrF3ETbJDM3clhpuDSgeFB26BuPRXl7+qk+uFpszHYcmI/XCx6XHS9O1LM9dGze8xWujurxa+rwk23guKLqzQX6junijY7jzOD2qiibfU0APzCs9vudxuZiqeniQwoPX69TWUqxcwB7UtHM9HmZFbqKmQi4j11DVQV7Eg46/tcVF+LniBkWEywI80GZQdOA+rOJck4TyQVqkEtAjF2DaOZnBKzRXFXiXU5JG9hDvLh/KL4tHr5xEwt9VpOmWRS29sLq1xwhadLUBhxlOO6mSuM+qKNj2J+FIDfIMdiwyAV7kptUDGggH9xTgJdoWQKXgboEsBmqQ+HibvelK4DBSiaxcW0HAD0yDjQPo0XLTQJsG2iUnehpo00CbBto00KaBNg20S3o8DbST+DTQxlSmgTZy408DbUx9GmjTQEu7jF2X+x9FXZzYlm94xj4Xx8f6yT98qep9XVZH//i9fHj96GNRPj7V/uHmUPwZAj9Uh6ohPP4+HM67v6Jpl3VjHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1076",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529706",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.36993349",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNo0yZN6kpUEHRRiuCidFH10gZiIjUKpfTfjS9wN2c4w1QjFEe9H64IOWzdUZd48o1tDQKBwmnrb5BX4ycGZZZRxiSfK0G5VAqm+qct+r4ZghuKlW4u6LGHPKIRgR3a1ncviLlICJTON147C3lMeRZlSiRMZCqVSggCB33+lzeo286/OeWSwNrg47tmMU1SlhJYOuPCmb0bM9VPOdejTNIAAAA=",
    Pbi3DGeometry:
      "TR4AAB+LCAAAAAAABADtV01r3DAU/C86O4u+JW9OoS0U2kNoCz2EPWyISQzuumzdQgj736v6q7bssew2RxES4tm3o/fmjSS/uxdye59/ef6ekT35UN7nn8sifyAJuS3zU/WD7O9emn/dx/Ta/ZBL8he5YpRe13/cL7kcuq/dnM/HZ/fdK7NjVook1TstJEs420lreeJwzq36gytu5BDv4pVUZhWudQ3bNJ0LnyxruJmjQel08WvT73Ct+CaeSXxAHlTXBE/ZnDxIBsGYHdIITc0Q7+IneJcmlekqnjYfIV3Z/8Hf5+8t26kJ0lkZjthRUUiEbfR9r7SRC8nz1Ixba4RacsJWmmXjrPYf3A+UjXCmF+B/7KuvJKo1ZA9PMSjBfEki1SN3SD3qE9qCnjsgTeDgmhx0CAf9hvZYlhKZGHne2zqo2hCNpxmsFRQlTaOlaE+hVDS+Ybah17Q5tawSNU5dp2t+Lmoe4RywcJoh/j5euCprfm7reE1HeQrD+VI+aF1mlRrVy5r4wN05kY1qOUyzx5E1gTzQspAHrBuSE10ansywXajtoXXRJeZdelvbi+Jhe1EfAT/igdsitEn9TY36CHwC80c+QXkiH0IdkP9BnmgbLbdlcn+08mgp+Ah39TR4W5U2y2+OrKUXuok3IxdqVrMLxWbvvt784DZDq84n2bNL3uC2WTUU7iWDJIOODWngF4sknqcJZe+9pQReatC7sNcotPuRxDAbUCuAkSmRNOhMA/FbOxhUYSwanj4BPSg3TrFxio1TbJxi4xQbp9gFz8cpdvB6H6fYOMXOrRun2DjFxil2hcRxio1T7KtNsYeEvM2P37IqO5M93dGEfMxOj9VT+/CprI5VXp7ax6/5Q//R+yx/fKrah3dF9msY+KYsSkd4+lkUl8NvQazKIk0eAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1078",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529708",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.50849666",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyHEpK1aT6KCoIcigofSQ4shXYhZqVEopf9usFXEi7edfcPM5B1kFR7bq4YUdlRhRrY15IBBRuj8DdK8G85giLhMFhMRczmbKujZN1GRUn+ZSsQvGxMHUrxrl01TtqE7PNZYXrTXDaSCCwZ77YyvR3EgX3oMcwd5wvMHbTWa2r9EImMGG6sfo1dKHks1Z7AiSyHX3a3tiyeCia/vCwEAAA==",
    Pbi3DGeometry:
      "PQgAAB+LCAAAAAAABACdVUtrhDAQ/i85W4lR19U9lbZQaA9LW+hh2YPLht2ANcXawrL435v6fmScWERJPme+eWRmsruS7UG8XT45iciTPIhXmYgjschWijT/ItHuWi3Vb7pRDymsDrlxKN2UH/WSYt+o3WZZfFG6ns1WlkN9m4VqwZjt+75jtajL3HWJMjfsodQJStR1LYygEQ0CpqFdr7we+qdp6ILeGhKEibV5H4YMnh9qYmvQfnKAPA6NuZ5Smea3g4ckLT6KeipfeT2lr/xGeVD+kT9gWBAO+AnaHeYdj/e//ozjGpws7qa29I0KF+EwQqG06Esak4a4zWxCRzffXss4TFDo6LF+1EtD3GY2gbJaMp0QChyESl4/tTBpgNrIIjD75sfnIgochDoa6VHk4huF3cHqLr4X8QfPeUYialOLPPP0lJ/rzYvM41zItN6+i2P765GL0zmvNw8J/+kL3slEKsL0O0mK/S+ylNc8PQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6867",
    Length: "25",
    Mark: "466",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "78",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529709",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.41788568",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xDSNtFSV1IFQRdFBBelixZDOhAzUqMQSu9uoNUbuPtfzDf1CFWHl/DQUMCROqzIBkMOGFSEzj+hqMdZxoHkUqh8kwjFszTLYWJ/6JovejsMbYj8GOywvWuvBygEFwxO2hnfL+ZMvvUYX57tFW+/6qDR9BGScJGqjMHe6veyTRMuV2vJoCRL8a57WTs1H/pJphwPAQAA",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACdVd9rgzAQ/l/ynEmi8Vf7NLbBYHso22APpQ+WhjbgzHBuUIr/+7Lqqqa9XhRRzJfLd99dLpflgSzW6m3/KcmMPOm1etW52hBKFloV1ReZLQ/Nr5lmc/OQmnbIDWdsfvyYl9Sr/2W3ZZntzVrhiSDmlLPQC/wgob7vidSPqMFZmBxx/2/cw/04bewZj/s4xHOyF2F6iT8IQ97Dg1hEo/RAfrG4HP2iemyeJIgvxdvhVt6AuEC/w/xzT0SxOOfp8GEezu0b/R0+3C+cB+O39FhxoTioE/Br5R/lmazHjmu4v5BO6FxA+cft3eof318oz0CdO/JM7gPgfqHn6yo/Wicg7lYnkJ6x9mP7ElSHaP9x5MHrHOo/UH9z45ncP0E90P0F4W48OO7WP/E+72bf4Oa+v1fZh6xkSWbMY5Q8y2Jb7drBi66ySumiHb6rzWnqUartrmoHD7n86Rve6VwbwuI7z+vVL6PN3kOhCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6543",
    Length: "313",
    Mark: "467",
    Material: "Copper",
    "Middle Elevation": "3056",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2854.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "78",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3056",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3056",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529710",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.26933357",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyGkSRppPYkKgh6KCB5KDy2GdiEmUqNQSv/dYFsPInjb2TfMTN5DVuGpu2lIYe8qzJzpameBQObQ+jukeT+ewSCplFwsIyYpS6SAgfxgMeUq+mZCJf/YnFnM1au2LbvQHx4bLK/a6xZSRhmBg7a1byZxdL70GCaP8oyXD9pprBv/ForHBLZGPycvj6hYCEVg7YwLufZhzFC8AF1T0lYPAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVld9LwzAQx/+XPMeStll/7WmoIOjDUMGHsYeNhS1QG6lVGKP/u9F2runl0oyydvn2+snd5XJZnchyK1+PH4IU5FFt5Ysq5Y5QslSyaj5JsTp1f/VrNtcXaelFuQkZm//d9I+06/Nni7reHPW3POBsltGQ8YDlPKZRGMRpnFCuHzwxdM54/qtncWraZ1FGcQ6P0txqH6ehjQ84PE5Chz/ovJh+5byojnHG8WrBlrZe9o3qnIUOMwuiJBxms+dcdJMzsDeyAO077wEf5SC6tz9mlqGO+Yn5M/a/S7M3ZsIdLCywLMa0WI0Ac3vpuGOCcN+l7THuFMC6d2IwcxCTe7fBxCPbxy5PUMa+YzK22O7OiGCmG+mEubv0QH9Fdd8SNjnXdgR4nrg5mL3/OePuCJCD6b6dxeRAHduGvj1h6py0+a/P9zu5eReNqEnBAkbJk6j2zaEfPKtm00hV9cM3uft/9SDk/tD0g/tSfA8Nb1WpNLD6Kst2/QPenwghkQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "356",
    Mark: "468",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "78",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529713",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.84975149",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNzEELgkAQBeD/MudlWdc1zE5hQVAHkaCDeFhr0IVtN2wKRPzvbWXQbd57H1ONUDTmONwQMtj7xpR4Ju1ai8Cg8MbRHbJq/J6BKK5Ekq4ikfBYxilM9Y+t+14PwYZiY/QVCXvIBBcMDuha6t4hitSCQelJk/Funk/m8r/u0LQdfbJQksHW4nPmUnK1lMHk3vrw3T2sneoXB2rfvcMAAAA=",
    Pbi3DGeometry:
      "vRwAAB+LCAAAAAAABADtV01rGzEQ/S86b41WH7uScypNodAeQlvoIfjgkCVZ2HiLuy2E4P9eYUuONdGz1j31IIKDdzz75s3M08fcvrCbu/7788+OLdnn8a7/Ng79PavYzdhvpl9sefty+Op+5lfuj+2qV8u7mvOr/T/3YbtVeO39drt+du+qhVRSVjXXC2GEqIRYaK3r6tRuldrbjWpO7VK7Lwk79BfS7O22MXNwZKP1WT5Ct9UM/kd86g9wUFzIJxcX1aGWehafmL/i2kRxlRV7/LaJcbz96B/4B7vDjfCpHeGguAQH8ZGNqqM65PiAuDAv1eqz+DSvXFyCD/NCdUD6MYFnsEuwLrweAp0gH97KObJC8qd2RCfXXmrP0SRhgRoQzKVsQFawucH/uKhJU+giRWLI4uQ227mbFek6KBswo+LnthK6BaBsc0uF2lG2afqq1p4+t4ewjXsNn0SKe/bWw+gDjOCBvUlqh2R1aRUQPqAjrVZxtkaYZMstkObM89jR8VWz/1AdfExclBXqoRI18Zdte253R/6IJvJHfAAO1BrSZq67dGPIbyRxF1G+KC/QLqj9tDtgAzWb1Xh8d3plL41OdeXN2W2COdJybtenp0TQvtQ22XRn14klRMLCozV7A0A3URIWVAfeRNFaBFVDRc5XJ24iqA7KKnePe0MnvaLxFSCd7aVZIWkCeNQr1JPcvkargOig6pTpr0x/s471Mv2V6a9Mf2X6K9Nfmf7K9Femv8QNvkx/ibBl+ivT3385/a0qdt2vn7qp27IlX/CKfek2D9Ojf/g6TuupHzf+8Ud/f/zpU9c/PE7+4ePQ/Tl1/DAOowPc/B6G3eovUKXiYb0cAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1080",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529715",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.11391129",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yyizrnNTlFBUIcxgg5jB1eyCaaxLBhj3z17g27Py+/hqScoW3MYrxok7HxrKn0KynVWA4LSGxduIOvpIyPCMSdpvqAkxQlLcpibH7YcBjVGNgZroy466AEkwQTBXrsu9C9DKRcIKh9UMN6BpDjNSFaIhIms4HkhYns05394q03Xh7cnnCHYWP34rhnFSZwiWHnr45m7Wzs3TwY6UojSAAAA",
    Pbi3DGeometry:
      "yRwAAB+LCAAAAAAABADtV01r3DAQ/S86u4ukkWR7cwppoZAeQlvoIexhQ0xicNdl6xRC2P9e469dK3qSTXsUS5Z4Vn7z5mk0o7l/Y3cP5ffXXwXbstv6ofxWV+UjS9hdXR6a32x7/9b/2/7Mr9oPOyVnywfB+VX31f6x02587fp43L+276qNUqlOBNcbkpQlUmyUSVXS2klTb9dEF3ZKjdOO1iuus95utF6AQ0YJLx+ZK3VpB/wnfHs9wEF+IZ+QX6SDzKRcwgfxH/1KI3p8rvIZzmgnRZf8rfVn/MFOqVYunNEO/L7DGfwiPmcdRrsy2scH+QVxvcMnQ9ITF/IL8ZHOQIdwXvHhXMiOJ9z3Ka7UiM6upfHkFcKB9iCfZfEinuG45vkQxlmrvxUX2t/pXM/Xw/qD8hzhhOrtwnoF60kwT5Dd0j8U12rdFtaHYLwWf8kHv0SdnXJtfP2Ixn7Uvt7Rl2lHX6h5Gci5WLKNS2VA+IDO1DW16GGEnp0uq5t6onXbW7xBtexf1EHNYmVUaA+n9dx0uUBZLn01Hq1HNNH6UE6hnmmrHIzL0gHVBpxUaBfdPHFc7l2HRxokiZsNylmgArwZ5kK62MMOnjppwgsRbIBcunK/tQtXuCG3qA9Bu32/BG5D6sB7ua2+mz4UGakDNhHBu6NCJx3eFsGJxpuL6KyLCorvhgfLw1XfigptShDfqndxBowzoKufxRkwzoC+uOIMGGfAVbrFGdCFH2fAOAPGGTDOgHEG9OZOnAFdUf2PGXCXsI/l/mfRFEe25RuesC/F4al5Hh6+1s2+KevD8PijfJx++lyUT8/N8PCpKv5cLrypq7oFPLxU1Wn3Fz0jHP3JHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1082",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529730",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.15082343",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNIbh9p6kpUEHRRiuCidFE1tIGYSI1CKf13o9XdnOEMU41QnPVxuCvIYe/OulQX39jWKCBQOG39A/JqnGNQFhypzDKxlEhRJglM9d9b9X0zBDkUG93clFc95IwyAgdlW999AJlAAqXzjdfOQs5pIpiQaYSpkHEm05TASV9nmQuWEdgp3Xb+yxhJAlujXr81chrFGLq1My6c2acxU/0Gw/ujhdMAAAA=",
    Pbi3DGeometry:
      "KSYAAB+LCAAAAAAABADtWE1r20AQ/S97VsRqV6sP51TaQqE9hLbQQ/DBISIRqFZx1UII/u9V9GVbs0+zcq9LSIg8nnlvZkfzlrl/FXcP5feXX4XYiM/1Q/mtrspHEYi7utw3v8Xm/rX/tzXL2/ZHHIPTJzeRlLfdn/ZXHLej27vDYffS+t5EKsyzLA1yFeo8jwIVhXGSZEFniOP8whBnidWgkyhiPFRyiSHbLy6HmrHSsXrz0KHUKrZj2PNY4QExOFYrijiEghitwcjEUqulPAaMKI9y63mMBpL5ZJjTpaGGE5w85ifoinHKg/Ug50FZuXo41AqWZCXG6QRntXLIQ+XGWPtqfUlgi84wljrRjuGQ4PVN7Y5BWXFvLc3cFYMcLc2DS5CG4sbSSJcbZA5v1PqZOAN3YLViyOBhqXtDW70+VGo4KUIeEAMmOGqUSePLCecqXlTuSKir86BFNF3VVSKz7nOTKCY/xoHVgjOyUneh4lR1Bi0NIxKDQWmdzAqCQiG2kBQWKATBhbIceB9Kx7pjpdNcWc/1TIGRR5+f1rIjpY3m7lbIgZMOKgSQE8wb9jNDyoKN0sMdAi83/Suj3iZvZ1D2FnHAgL1jl9+lqkNWMNTqPLLMRH3Zc71omDp6NJChwIeaH/n1GMpE6aLHVJK5B2HFehAMmCCmuxqD9BXMA7YPBF/oEmD4j+oSuvjlRKyQBw/uLBHOZXcXLhyKsAL6BNsK6jL24CBgH5K8oZiieqwni69uwOA8k+C77HLfQqyQBw9OMYCcOo9Qh9sCS9dVmfGAWT+SGAhWnvi7DayH31n5nZXfWfmdld9Z+Z2V31n5nZXfWfmdld9ZLcmv31n5nZXfWS2y8jsrv7NaNvidld9ZXbGz2gbiQ7n7WTTFQWxkKAPxpdg/Nc/Dw9e62TVlvR8ef5SPk+lTUT49N8PDx6r4e/7F93VVtwH3f6rquP0HF5YkwikmAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1092",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529731",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.41064416",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdlHXVDO0UFQR0kgg7iwWjRhW0nbAtE/O8tqR0i6DTz5nu8eXkH2Vkf25uCFHZ01hmZtiILDDLS1t0hzbth9YZZEHKBcbBIJI+kQOjZL4g88vMLIk9ixD9wii2m98umKVvfwR/WurwqpxpIBRcM9spWrh7FgVzptK89yJO+fNBW6ap2byExZrAx6jl6MeDhPJQMVmTI59qHMX3xAvQCr00TAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1rgzAU/S95jpKojR99GttgsD2UbbCH0gdLpQ04M5wblOJ/X9bZ1ejNNSKKyfGe+5V7cH0iq618PX4UJCOPaitfVCl3hJKVklXzSbL16e9Vw2ypL9LS647HGVueH/om7eZidlPX+VHbejzw0ySJaSr8SLCABtyPQsGpx0Of8TQ1ABalHcBMiyCmCJMGhBCgwSKOAA9jpjAOBRYT5tsKzHSOAVaqQeJhEiRgCXuAY4K9kvxSBbqoC34t7oWpt28y9QCzIpDFOY2hC4wJBmYENSg6BFijtUY1SKMr+gyqqaisCY7bNNVxrLHQ+E0dBNCBY6yO/QY1BGOyGszRFrzbAJNt3/XYmETAvvU04TJhY3LQlWkDfLRHQoQBrioxoIIAfLwgpcWprBZQHrjMg7NtFW0QmKQC1QCVCXBYHfXDVXHMPPQ/w53M34umqEnGfEbJU1Htm0O3eFZN3khVdcs3ufuHHgq5PzTd4r4svvsf3qpSacLqqyzbzQ8BywXj5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.1 /",
    "Flow State": "Turbulent",
    Friction: "715522.83 /",
    "Friction Factor": "0.015063",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "1230",
    Mark: "472",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "880018",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "487067.6154",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "43",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "39.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529732",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.00124308",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jEkaZtHXYkKgi5KEVyULqqGNhATqVEopf9uaHU3595zmWqE4mrOw1NDDkd/NaW+hca1VgOCwhsXXpBX43JGZUUZVlKKtWI4UYrCVP+9Td83Q5RjsDPNQwfdQ04wQXDSrg3dDIwjKH1ogvEOcoozQYTiCeNCpVLx2F7MfXEpTSMetGm7MDNJGYK91Z/fmlGcZEwi2Hrr4y/3tnaqv2A0x7TSAAAA",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVl1rwjAU/S95jiVp0o/o09gGg+1BtsEexAfFooGuHa4biPjf19mu9SOnbfRpUEQxvb333OTenHsmWzKe69fNR0SG5DGd65c01gtCyTjVSfZJhpNt8Tc3s1H+ITtaPxlwxkb7n/xLdtM/t5v1erbJfQfcdZTv+1S5jnQ9Tl3uiNAN6d4QhsGRIRB+YfACeWiQTCqjhxQ+pyYM6QYtkbpClEkJh3EWGLbRaFDKgHHuUWULt2fOFkVqQOgaqC6Sx8Nfg1Cq8JD8ONnK4PnK6CF8c6TquShqVwWqa2QHne9CsqBTqAI7d3A9r3uuTQAnKQkPnF8zsgVCvemTSOUxWfRf3bFm8CYDDIX2h04ckgE8WXhTETTscfO9a7+o570Pi4QuKiyefVVxjZAHxrCijwb+hXcbGiCTIzJoY4lzNm2rnoF/EQbKFnZz2zCEbX5ugKFsCRhWFTMzHKsAwpxrQ6fZDfRLZqq1ZLDXMRdoCUjZV2oJ+6Q6aChradB11LdrA3sGth31kBwhz7aMtuu1QUeAXhr00qCXBr00+LfSYErJnZ69R1m0JkPmMEqeomSZrcrFc5rNMp0m5fJNLyrTQ6SXq6xc3MfR9+GLt2mc5gGTrzjeTX8Af9+d6PkQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1093",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "24209.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529733",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.05292825",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jEkaZtHXYkKgi5KEVyULqqGNhATqVEopf9uaHU3595zmWqE4mrOw1NDDkd/NaW+hca1VgOCwhsXXpBX43JGZUUZVlKKtWKYKqpgqv/epu+bIcox2JnmoYPuISeYIDhp14ZuBsYRlD40wXgHOcWZIELxhHGhUql4bC/mvriUphEP2rRdmJmkDMHe6s9vzShOMiYRbL318Zd7WzvVXwCRidPSAAAA",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVl1rwjAU/S95jiXpR9ro09gGg+1BtsEexAfFooGuHa4biPjfl9lqnc1pm/o0EFFsTu899+Ym957Jlozn6nXzEZMheczm6iVL1IJQMs5Umn+S4WRb/NUwG+kP2dFqZcAZG+1/9Jfspgezm/V6ttG2A+45jLOQStfhIpDU5Y4XuREdcNeRUfQXCD1BCwspTwGf+dJo4XuCUxOH74ZNniwoyqA0IIQwpwGBIPTNHGcWRbSN6aFokSfjuoWjMglt4QbBHpC8sPD5WbAHIBDSaOEJs6fjus/+OjrWyJJaA16ZRZurgvu3RDzqHiskqIfkBWD/mpktGKqkzzxV29T1/FUnFpJDAB9+kB9ah/fOvLNNFogCxmq+dx0uaq0WEECecPGsqwprBC0gh137aOi/8G5DAHkyN4MuXaJW1dbq1fovJDdG2zja2oYhPOa1zmJ21aMBw6riIiELSIHShifNaqD3mqnWksFOx/TSEviqXqgl7INq3xB7adB11Ldog14d2HbUw+aI+2zLaLtYG3QkuEqDqzS4SoOrNPi30mBKyZ2avcd5vCZD5jBKnuJ0ma/Kh+csn+UqS8vHN7U4Qg+xWq7y8uE+ib9PX7zNkkw7TL+SZDf9AdGtfwr5EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1094",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "704746.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529735",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.71892651",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNIkzaPuhIVBF2UIrgoXVQNbSAmUqNQSv/daHU3ZzjDVCMUZ3Mc7hpy2PuzKfUlNK61GhAU3rjwgLwa5xiVRUKxklIs0xRnijKY6r+36vtmiHIsNqa56aB7yAkmCA7ataH7ACWCIih9aILxDvIEZ4IIxRnlQqVScY7gZK6znAgiEey0abvwZcoUgq3Vr9+aJpilNHZrb308c09rp/oNXwHpOdMAAAA=",
    Pbi3DGeometry:
      "ESYAAB+LCAAAAAAABADtWEtr20AQ/i97VsxqX5KcU2kLhfYQ2kIPwQeHiETgWsVVCyH4v1eR5JdmP83KvS4hIdJo5vvmsTPL3L+Ku4fq+8uvUizF5/qh+lZvqkeRiLu62ja/xfL+tf+3Fcvb9kfsk9Obm1TK2+5P+yv2q4Pau91u/dLq3qRqUeR5lhizcIUtEpUujHN50gmMKS4EJndegXZpymgod4kh2w+nTY1YaaPeNPRCamX8GH4/ZmhADI7VjCAOpiBGK7DSeWI15ceAYd5I+PJxEBDPj4IxXWpqyOBRY5zBUIyTH6wGyQdlFaoRECsYkpkYpwyOYhXghy2U9tbV/JDAEh1hTFWiHyPAweuLOhyDsuJOLfU8FIOklvrBOUhNcW3pQJdrZAEnan5PHIEHsJrRZHCz1L1AZ6o3lVluFCENiAEdPMwoa9RlhwsdXnTcEVNX+0GDaLuoW5u57r11ivGPUWBnwRlZqTtTxnTvtbTMjBgEVkszigewhLhCSng8AQTOkifbvSVnZEdKZ4XyJvVs/CKN3j2n+gZmNXevAt9zU4POAMgIeg1LeZqTBxo5h4sDXmv6w2JNZnqB8pdHAAasG//gnQo6ZAVNzfYjz23atwmXTgqO5XwQkHbAmxpn/HoMa3I7qXEMyViDsGI1CAZ0ENOdjUHqCvoByweCT1QJEPxHdAldfDgRK6TBg4dOh+CoB08sbIlwApMJFhWcx1iDg4BVSNyGYxSEYz5XfGMDguCGBA9yyDULsUIaPDjFAKM0uH8G3BNYuoFTGTeX+e1oGoGdTOylBgYj7qniniruqeKeKu6p4p4q7qniniruqUC2454q7qniniruqeKeKu6p4p6Ku7HFPVXcU016Hb6nWiXiQ7X+WTblTizlQibiS7l9ap6Hh691s26qejs8/qgej6JPZfX03AwPHzfl3/MP39ebujW4/bPZ7Ff/AAzIoRARJgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1096",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529736",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.50074561",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jkELgkAUhP/LO2/L+tZVtFNUENRBIuggHpQWXdh2w7ZAxP/ekuYhotub9w0zk/eQVerU3SSksLeVyqzuamuAQGaVcXdI8348vWERcMpQBEvBKPIYYSA/YBjSGIPkCyJNBOJ/OMcWn/pV25ad3+AfG1VepZMtpIwyAgdpatdM4mhd6ZSfPcqzusxoJ1XduLeIUBDYavmcvBhQHvOIwNpq63PNQ+uheAF1TcW5EwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVltLwzAU/i95TksuXW97EhUEfRgq+DD2sLGyBWojtQpj9L8btbqmPTlNKS1Nvp7v3HI+uj6T1U49n94KkpN7vVNPulR7QslKq6p5J/n6/PtqYLY0F2npZSfgjC1/HuYm7ebP7KqutydjG3ARZmma0AULhUwEFTyMZMxpwGXIeJZZAIuyDmC2hUgowmSAOI5Bg0USAR7GTDKRMRYT5tsJzHSOAU6qQeIyFSlYwh7gmWCvJIYqisJE8OxS3I6pv28x9QGrIqDFdxojFxgTDMwIyi46CDijdUY1SKMr+gyqqaicCY7bNNVxrLHQ+E0cBNiBZ6x+/YY1BGFyGszSFrTbEJNr3/fYWETQvvM0oTLhYvLRlWkDdLTHQoQBviphU4EAOl6g0qJUTgswD1Tm4dl2ijYITFHBaoDJBDysnvrhqTiDPMw/w43avhZNUZOchYySh6I6NMdu8aibbaN01S1f1P4fuivU4dh0i9uy+Ox/eK1LbQirj7JsN1/Xi3cA5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.8 /",
    "Flow State": "Turbulent",
    Friction: "382977.30 /",
    "Friction Factor": "0.015616",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "1681",
    Mark: "473",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "643803.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "349967.1014",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "54",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "28.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529737",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.18528836",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm3M6e4oKgnoQCXoQH1YNHawtbAUi/veG1tv9zvkOtx6hvJrz8NRQwNFfTaVvQbnWakBQeuPCC4p6XM6orCjDMs+zNedYyFTC1Py9Td+rIcox2Bn10EH3UBBMEJy0a0M3AxMIKh9UMN5BQXGakUyKhIlM8lyK2F7MfXEp5REP2rRdmJlwhmBv9ee3ZhQnKcsRbL318Zd7Wzs1X0jwH/vSAAAA",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVlFrgzAQ/i95TiXRGLV9GttgsD2UbbCH0oeWShtwOpwblNL/PledtjWfmvZpIKWl8bz7LrnLd99sR6ZL9br9CMmYPCZL9ZJEakUomSYqzj7JeLYr/uZmNsk/ZE/rJyPO2OTwk3/Jfv7ndpOmi23uO+K2FUgpqRCWZ/OA2txyfNunB4PveycGz5GFwfXEsUEwEWg9hCM51WEI2+uI1BeiTMqxGGeeZhuthiDQYDQ9qmzh9vTZokgtCH0D1UVyuf9rkIFbeAh+mmxlcGWg9XCkPlL13ClqVwWqa2QGne9CMK9XqAI7d7Bdt3+ubQBnKTkuOL92ZAOEetNnkcpjMui/umP14G0GGArtD504JAN4svCmImjY4/p7131Rm70Pi4QuKiyeeVVxjZAHxjCijxb+hXcbGiCTIzLoYokmm3ZVT8O/CANlC7u5axjCNm8aYChTAoZVxcwMxyqA0Ofa0mlmA/2SmWosGcx1zAVaAlL2lVrCPKkeGspYGvQd9d3awJyBTUc9JEfIsx2j7Xpt0BNgkAaDNBikwSAN/q00mFNypxbvYRamZMwsRslTGK+zTbl4TrJFppK4XL6pVWV6CNV6k5WL+yj8Pn7xNomSPGD8FUX7+Q80CuSL+RAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1097",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "12498.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529738",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.66316796",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUEKwjAQRe8y6xiSNG2auhIVBF2UIrgoXUQNbSAmUqNQSu9uaHU1/828z9QjlFdzHp4aCjj6q6n0LSjXWg0ISm9ceEFRj0uMyooyLPNcrDnHPE6Ymr+36Xs1RDkudkY9dNA9FAQTBCft2tDNwDIElQ8qGO+goDgVRMgsYZmQPJdZvF7MfXEp5REP2rRdmJlwhmBv9efXZhQnKcsRbL318Zd7Wzs1X/JHin3SAAAA",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVk1vgkAQ/S97XskCywJ6atomTdqDaZv0YDxoJLoJhcbSJsb437sKiso+YPHUhBg/2OfMm9nZnXmTLRnP5fvmKyJD8pzO5VsaywWhZJzKJPsmw8k2/6lgNlIvsqPlysBmbHT4UG+ymx7N7tbr2UbZDmzXYjbzKecWF45PHdtyAyegA9uxwiC4BHxX0NwiDM8BznioteCusKmOg6uvGk8GFEVQChBC6NOAgOdzPceVRR5tbXooWuRJu27gqEhCWTiedwD2se0tuH0V7BHwRKi1cIXe02mds0tHpxoZUivALbJocpVz70tkB+1jhQTVkFwP7F89swFDmfSVp3Kb2p6/8sRCcgjgww/yQ+vw3ul3ts4CUcBY9feuxUWt1AICyBMunnFVYY2gBeQwax81/RfebQggT/pm0KZLVKraWL1K/4Xk2mhrR1vTMITHvNJZ9K46NGBYVVwkZAEpUNrwpBkN9E4z1VgymOmYTloCX9UbtYR5UM0bYi4N2o76Bm3QqQObjnrYHHGfbRhtN2uDlgS9NOilQS8Nemnwb6XBlJIHOfuMsmhNhsxilLxEyTJbFQ+vaTbLZJoUjx9ycYKeIrlcZcXDYxz9nv/xPo1T5TD5iePd9A+6pIky+RAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1098",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "334920.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529741",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.29655364",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjssKwjAQRf9l1jFkkhbauhIVBF0UEVyULloMaSAmUqNQSv/dSOtr527unMvlFD3ktT50FwkZbF2tc2c65SwQyJ22/gpZ0Y9nKCSCRiji+QwF5ZimMJAPRM5olOA/FFnMf+j38AjLl8CibasuWITHSldn6WULGaOMwE5a5Zsp7J2vvA7iYzzq0xttpFaNfwZkESewNvI+dTlSEfOEwNIZF3btzZihfAAxjul1FQEAAA==",
    Pbi3DGeometry:
      "CwkAAB+LCAAAAAAABAClVtFqgzAU/Zc8p5LEaNU+jW0w2B7KNthD6UNLQxtwZjg3KMV/X9a5TUmuXi2iGI/n3JNr7o2rE1lu9fPxTZGM3JutfjK53hFKlkYX1TvJVqefWwuzhT1ITf+fzDhji/PFnqRe/9KuynJztNwkDCQPIzrjYcDTVFLBAyn5nHaAWMTfQBiJhPoYYYx7Lrg8C0kmUy/BDT3kSUZxijQrorlfirPI76phONMDlcDYoFsoBGoWXLBAJtxNehdoa3kpsJiLdL7hxQbaecFaa6WsC7S/o5fiEYMNwKZhtcE4sFpvrcCpAYsFR4GjIOPD2QTXP3IyoBaKgfQFVvKUFTNlXYC9B7eYR/WxfgbS10BPnFCVLgUEhvorvrwGG2wvAekKsT2O7NQuBQLAvRbXwEdt25Zg/yxu9OZVVaokGQsYJQ+q2FeHZvBoqk2lTdEMX/TuD7pTen+omsFtrj7bL16b3FjB4iPP6/UXG6W/HAsJAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "11298",
    Mark: "474",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6906.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "69",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529747",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.07702781",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzzE0CQ21nkQFQQ+lCB5KD6ku7UJMpEahlP67UettZt5jqhGKhk7DHSGHg2+oxEswrrUIDApPLjwgr8ZfjIrgiVZqtRCKCy01TPVfW/e9GaIbhy2ZGwbsIU94wuCIrg3dpwidpgxKH0wg72Z8putM5VIw2CO1XfiyTEoGO4uvWZeCK60yBhtvfXx3T2un+g3M8TvrwwAAAA==",
    Pbi3DGeometry:
      "LSIAAB+LCAAAAAAABADtWE1r20AQ/S97VsR+SZGcU2kLhfYQ2kIPwQeHiESgWsVVCyH4v1fEkiyt9HZGaU7tYmKi5/Hbt6PZGfndPInr2/Lr449CbMTH+rb8UlflnYjEdV3um59ic/N0+rf9WF61L3GMzsiFkvLq+a39E8dt/7U3h8Pusf2ujPNMJtGFMrFKdRppFZvUZNEYz9UJv0wWcWtMzonX0lw+x0u7GD/j6fRYm0xxY5JFPUg/EY/42XqIvM14EL9WyWJ+xvpVrGw6p5/DbvRYJEkyuVUv5ga6x2mkYUAyziGdEyDQv6RLApSM75qKZWrMX2zTW3OIHdUWvSWi4tZWqI+esdcpC5lJP/vstCPtK2mmVTAT6W0+DHoezfKyGGceydmqDrsxtjtm2p5o0hR2fk48T73UWnsnCDVZej0UD0s/bCsySzv5WdLRSO+2QDyzZYNx4MBuJ5fWrunwIBxulZth9+yz4hF/i1upJ3qsybw42UedvrvIw3k2cAYSM/39dnOjJgXY4soz7gh2tChnxjDErAx3tmpsd2dtYny42wEHvO9RgGeonB7vKmctf64NK35IgxPvTjcqfuhFYF9I50r+c+04+aH0o+qZrbtcDhBfm0+Aww6GyhPGU/zTvLHzSXRatp6+TlBnpoYTqh80o914xE+dFy4/mMUQ5/YHdL68zwyedWE8xe/UCbdfUZORq6fneekkdc/p2v6A+Bd1/keuBfqVxHYzXsu14LgTjN+E/5hrAXa5zsx4TdfCb08A3cG1CK5FcC2Ca7H0YBhci+BaBNciuBbBtTiXQ3AtgmsRXIuFOgmuBXYttpF4V+6+F01xEBsZy0h8Kvb3zUN38bludk1Z77vLb+Xd8NGHorx/aLqL91Xxexz4tq7qlnD/q6qO2z8FgjqRLSIAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1106",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529748",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.08075101",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjjELwjAUhP/Lm9OQpDSaOokKgg5FBIfSocWQBmIiNQql9L8b2qp0cnv3vuPu8g6ySp/bu4QUDq7SmTOtchYQZE5b/4A078YzGCLKsGCcrSIaYyoE9OgHCRZLkvxFjNMZm2cOtPiUr5umbMOC8Njq8ia9bCAlmCA4Sqt8PYmT86XXYfQoL/r6RXupVe0HwVmCYGfka/IyiuNFzBFsnHEh1z6N6Ys3ovofNBEBAAA=",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVk1Lw0AQ/S973ob9iPnqSVQQ9FBU8FB6SGloF2JWahRKyX93E6OubR6ZSEjIzpt5ebMzu5vlkS3W5unwWrCM3dm1ebSl2TDOFtZU9RvLlsevVweLubtYw38tMynEvHu4mzWr77DL/T4/uNiZVEGqIsVnUgcy1QlXMghFmPK/SKSiFtGxjk6QJIw7JFEJp7L1MaGKhz8T6kieIFrqydKwgNFEJykY1TbAFoqL4SnogYH5xIn6AkSQJo7irDa+3Wfy7f60DPh3aQzwt0lQaEboz+SgtJAdyUTf9WpAofmnnLO0cIWRULheQAGg/9TKAH7c1oROoa4QUghN1dhio3YAcAdm2oYBiKg7DCmEpgr3pY9QOh/5Izve2aavIcxFi6Hpwqfe1D0X+SM77VBDTBNP6DbG/TNcm/ylqIs9y0QgOLsvqm296wcPts5rY6t++Gw2P9BtYba7uh/clMWH73hlS+sIq/eybFaf4Rfx1eUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.0 /",
    "Flow State": "Turbulent",
    Friction: "113973.37 /",
    "Friction Factor": "0.017034",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "4239",
    Mark: "475",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "483104.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "182800.6853",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "63",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "14.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529750",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.26043275",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eQpOarTqKCoEMpgkPp0GpoAzGRGoVS+t+tWre747m7YoCstqf+biCFQ6htbi6x8o0zgCAL1scHpMXwkxOyoAxrpeRqwTAnVMBY/rl111X9BE/B1lY3E00HKcEEwdH4JrYfQwXnCPIQq2iDh5RiLonUImFC6qXSQiA42+sMM00R7I1t2vhdUowh2DnzmtuM4kQkCsEmuDCd+adzY/kGIvVyb9MAAAA=",
    Pbi3DGeometry:
      "6SMAAB+LCAAAAAAABADtWE1r20AQ/S97lsWutNLKzqmkhUJ7CG2hh+CDQ0QiUK3iqoUQ/N8rrLX1MTuakdJekiUkRBnPvHmzszPKu30WN3fFt6efudiIT9Vd8bUqi3sRiJuq2Ne/xOb2uf21Mcur5kscg+4vKyXl1elH8y2O27Pbu8Nh99T4rlQUrrPMBKso1CrLgkiFcRpnwUrFoVRmaDCJ26DjeE14ROuhh9RuDxsKZqV1Yg3JOnVgoDxmeKAYjKy4RexCoRjapI5aoTw6jCTTsfM8zgbA/GIYpwtD2RO8GMYnyMXoeJAeoLrQgIYaGdCSgKOF6XLBwdHCrOzRjorYw5AqXcac36IQA+1EFAPl8eKm5mOgZUdvLWTOxQAnCHlQBNEWRcfSOV3GIKNu1PyZCMGprGYMAHxYZsnJYJTNKk2pVeT0mGLu5tHbUalMhhOOu7zgugOhFvNwTGrVGiLd8jCSIkh6UNsA3TiAOVwTZ4OODGd/THo4ecwoO9hq3PeSSYw2K22y1hBnkwbG0B+NcEYohwfBgzyP3uZsWzSJlbYGxXxnABjuLuG8AQxrhWaFhlrEwzSfPJU9SiYNXe9aA7yDZCjQV4sxklimkx5dSUYeICvSA2CgBPF0Z2PAvnLzmGofFBzvEsywvLrAgF9ODBz1IMFRDyoUY1Jzs+otFmy2owZ3X03tQbQTSYxhussw0FcczMCdJegd5LyXYOCoBwmOelChGLuWm1Vvec3bzuh1XjZLCIxRum9Qk0H/iWOINf9Qk5kpvaA83oImQwkQXLHmv2oyDOmF5OE1Ga/JeE3GazJek/GajNdkvCbjNRmvyXhNxmsynFniNZnXoMlsA/G+2P3I6/wgNjKUgfic7x/qR/vwpap3dVHt7eP34v5i+pgXD4+1ffhQ5n/6H7yuyqoJuP9dlsftX1sdJyjpIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1108",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529751",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.5050941",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jkELgkAUhP/LO6+L+8zV7BQVBHWQCDqIB8VFF7bdsC0Q8b+3pHmI6PbmfcPMZD2kpTx3NwEJHEwpU6O62mggkBqp7R2SrB9PZ/BYQH0M2YpxGkXIYSA/oId0weL4CyJdhoj/4Rybf+rXbVt0boN7bGVxFVa0kPjUJ3AUurbNJE7GFla62aO8yGpGeyHrxr4Fx5DATonn5EVGgyjgBDZGGZerH0oN+QvI68vSEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1rgzAU/S95jpKoi9E+lW0w2B7KNthD6UNLpQ04M5wblOJ/X7a51ejNNSKKyfGe+5V7cH0mq516Pr0VJCf3eqeedKn2hJKVVlXzTvL1+ffVwGxhLtLSy07AGVv8PMxN2s2f2bKutydjG/AozKRMKRdhmkaCRjxMYsFpwOOQ8SyzAJZkHcBsiyilCJMBhBCgwVWaAB7GTHEaCywmzLcTmOkcA5xUg8RjGUmwhD3AM8FeSQxVEIUJl/JS3I6pv28x9QGrIqDFdxojFxgTDMwIyi46CDijdUY1SKMr+gyqqaicCY7bNNVxrLHQ+E0cBNiBZ6x+/YY1BGFyGszSFrTbEJNr3/fYWETQvvM0oTLhYvLRlWkDdLTHQoQBviphU4EAOl6g0qJUTgswD1Tm4dl2ijYITFHBaoDJBDysnvrhqTiDPMw/w43avhZNUZOchYySh6I6NMdu8aibbaN01S1f1P4fuivU4dh0i9uy+Ox/eK1LbQirj7JsN18sewxA5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.8 /",
    "Flow State": "Turbulent",
    Friction: "172442.69 /",
    "Friction Factor": "0.016494",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "5850",
    Mark: "476",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1008712.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "228500.8566",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "64",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "18.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529753",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.70107114",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2No0iZN4iQqCDqUIjiUDlFDG4iJ1CiU0ne3at3uju/uqgGKsz32dwMK9uFsS3OJ2jfOAIIiWB8foKrhJydkQSiWQuRLwrFgLIOx/nOrrtP9BE/BxuqbiaYDleAEwcH4JrYfQzhjCMoQdbTBgyKY5UkueUp5LjMhOUdwstcZppIg2BnbtPG7JChFsHXmNbcpwSlPBYJ1cGE680/nxvoN4qGjYtMAAAA=",
    Pbi3DGeometry:
      "6SMAAB+LCAAAAAAABADtWMFunEAM/Zc5s4hhBhg2p6qtVKk9RG2lHqI9bBSUINGl2tJKUbT/XhSGZcFjbEh7aUZRohCv/fw8Hpu8mydxfVt+ffxRiK34WN+WX+qqvBOBuK7LQ/NTbG+eul9bc3TVfolTMPxlI6Po6vlH+y1Ou97tzfG4f2x9NzIOc2OyQKZhrowMYhmqVJlgI1UYyWxsyBK3QSuVEx5xPvaItNvDhoJZaZ1YQ5KnDgyUxwIPFIORFbeIQygUQ2epo1YojwEjy+LUeR69ATA/G6bpwlD2BM+G6QlyMQYepAeoLjSgoSYGtCTgaGG6XHBwtDAre7STIg4YJkn0Oub8FoUYaCeiGCiPFzc1HwMtO3prIXMuBjhByIMiiLYoOpb6dBmDjLpRy2ciBKeyWjAA8GFpkmcMk8RdqDSlVpHTY465m8cw4UyeJuMJx11eYN3BUKt5OCa17DBUrDqPiCJIeZDbAN04gDlcE31JpFac/THr4eSxoOxgq3HfS2YxbFaZ6YaMMrMGxtCfjHBGKIcHxYM6j4vNaVs0TnqD5L0zQAx3lzDeACa1QrNCQ63ikUndXU6tZw1D7/YGcAfJUKCv1mPEqZr1GEoy8YBZUR4QAyWIprscA/SVm8dc+6DgeJdghvXVBQb8cmLgqAcJjnpQoRiTmpvVxWLBZjtqcPfV3B5EO5HEGKe7DgN9xcEM3FmC3kHOewkGjnqQ4KgHFYqxa7lZXSyvZdsZvc7rZgmFMU73FWoy6D9xDLHmL2oyC6UXlMdr0GQoAYIr1vxTTYYhvVA8vCbjNRmvyXhNxmsyXpPxmozXZLwmM4vhNRmvyXhNxmsy/5MmswvEu3L/vWiKo9hGYRSIT8XhvnmwD5/rZt+U9cE+fivvzqYPRXn/0NiH91Xx+/KDb+uqbgMeflXVafcHZmE/0ukjAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1110",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529754",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.24760231",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzE0iWltPYkKgh6KCB5KDy2GNhCzUqNQSv/dYGsPIt529g0zk3WQlvrU3hQksMdSp2jaCi0QSFFbd4ck64bTG2ZM0IBLthScyojNoSc/IAtpLBbsC3IaS87/wyk2/9SvmqZo/Qb/2OjiqpxqIAloQOCgbOXqURzRFU772YM868uEdkpXtXuLkEsCW6Oeo5czKiIRElijQZ9rH8b0+QuNC/gyEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1LwzAU/S95TkPSdP3ak6gg6MNQwYexh42VLVAbqVUYo//dqNU17c1tSmlpcnrP/co9dH0mq516Pr0VJCf3eqeedKn2hJKVVlXzTvL1+ffVwHxpLtLSy04gOF/+PMxN2s2f2VVdb0/GNhAhy9I0oTJki0RENBQskrGggZCMiyyzAB5lHcBtizChCJMB4jgGDRZJBHgYM8lExlhMmG8nMNM5BjipBonLNEzBEvYAzwR7JTFUImaZTMWluB1Tf99i6gNWRUCL7zRGLjAmGJgRlF10EHBG64xqkEZX9BlUU1E5Exy3aarjWGOh8Zs4CLADz1j9+g1rCMLkNJilLWi3ISbXvu+xsYigfedpQmXCxeSjK9MG6GiPhQgDfFXCpgIBdLxApUWpnBZgHqjMw7PtFG0QmKKC1QCTCXhYPfXDU3EGeZh/hhu1fS2aoiY5Z5ySh6I6NMdu8aibbaN01S1f1P4fuivU4dh0i9uy+Ox/eK1LbQirj7JsN18HTSSH5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.6 /",
    "Flow State": "Turbulent",
    Friction: "242307.70 /",
    "Friction Factor": "0.016095",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "4765",
    Mark: "477",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1154603.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "274201.0279",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "65",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "22.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529756",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.91208906",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8fQJOarTqKCoEMpgkPp0GpoAzGRGoVS+t+tWre747m7YoCstqf+biCFQ6htbi6x8o0zgCAL1scHpMXwkxOyIBRrpeSKJ5gRrWEs/9y666p+gqdga6ubiaaDNMEJgqPxTWw/hgjOEeQhVtEGDynBXCZSC0aF1EulhUBwttcZppog2BvbtPG7pChFsHPmNbcpwUwwhWATXJjO/NO5sXwDG0X8IdMAAAA=",
    Pbi3DGeometry:
      "sSMAAB+LCAAAAAAABADtWE1r20AQ/S97lsWuVl/rnEJbKDSH0BZ6CD44RCQC1SquWgjB/z0ikix7Z0czUtJDyWJiLI1m3rzd2Rnl3TyJ69vy++OvQqzFl/q2/FZX5Z0IxHVd7prfYn3z1P1szfKi/YhDMN5ZKSkvXr7aP3HYDG6X+/32sfVdqSg0eZ4FiQxjGWVBpEKd6jxYKR1KlZ0bssRtiLU2hEdkzj1k7PboQ8Gs4jjpDYlJHRgojxkeKAYjK+4ijqFQjDhLHWuF8hgxIp1Fzv0YDID50WCnC0P1O3g02DvIxRh5kB5gdaEBDWUZ0CUBWwvT5YKDrYVZ9VtrLeKIoZUxy5jzSxRioJWIYqA8Xl3UfAx02dFTC5lzMcAOQh4UQbRE0bY0pMtoZNSJmt8TITiV1YwGgDfLPHnBiE3ehUpTahQ5PaaYu3mMHU6n6rzBcWcXmHYg0mIWjj6tOoNJOxaZpOhRHuQsQOcNIA6HxGDIcsOZHpMeTh78VQcjjftSMgXR5aRj3T2fT91ntHuredORHA4EB3IrTkZmV52Rkao3KObLAsBwFwhj9FtLhWaFhlrEI1Nxfy6n7o9FO9wHh48KZBfUUoCW27THuBqWB8yJ8oAYGDt0OWZDwIpy05gqHBQcrw/MsHhxoQE/lhg46kGCox5UKEZ75mZ1Mk2who4a3HU1NfzQSqQwrHSXYaBvNZiB2UewE8h4E8GQMQcKGHt+Og49WXn5nMyqOZMYPcHL2gcBcZbqO9Rd0H/UGILMG+ouM+UVlMd70F0okYEryPxT3YUhr1A8vO7idRevu3jdxesuXndhvNR53cXrLl538bqL11287uJ1l/9Hd9kE4mO5/Vk0xV6sZSgDcVXs7puH/uJr3Wybst71lz/Ku6Ppc1HePzT9xaeq+Hv64Ie6qtuAuz9Vddg8AxVPDrexIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1112",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529757",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.57506272",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzEk26bBehIVBD0UETyUHiqGNhATqVEopf9usLUHEW87+4aZyTvIzvrY3hSksHNnnTnTVs4Cgcxp6++Q5t1wBsOMR5Sh4AspKY8Zh578gILRmKH8gkjnAvE/nGKLT/2yaco2bAiPtS6vyqsGUkYZgb2yla9HcXC+9DrMHuRJXya0Vbqq/VskKAhsjHqOXuQ0klFCYOWMC7n2YUxfvADW6cSUEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1rgzAU/S95jpKoNWqfxjYYbA9lG+yh9KGl0gacGc4NSvG/L9uyzujNNSKKyfGe+5V7cH0mq518Pr2VpCD3aiefVCX3hJKVknX7Tor1+fdVw2ypL9LR/52AM7b8eeibdJs/s6um2Z60bcCjMM8yQYUIecI4jXiYxCmnAY9DxvPcAliSG4DZFpGgCJMG0jQFDRYiATyMmWIRp1hMmG8nMNM5BjipBonHWZSBJewBngn2SqKpFkx/qat6Ka5h6u9bTH3Aqgho8Z3GyAXGBAMzgrKLDgLOaJ1RDdIwRZ9BNRWVM8Fxm6Y6jjUWGr+JgwA78IzVr9+whiBMToNZ2oJ2G2Jy7fseG4sI2neeJlQmXEw+ujJtgI72WIgwwFclbCoQQMcLVFqUymkB5oHKPDzbTtEGgSkqWA0wmYCH1VM/PBVnkIf+Z7iR29eyLRtSsJBR8lDWh/ZoFo+q3bZS1Wb5IvcX6K6Uh2NrFrdV+dn/8FpVShPWH1XVbb4A6EeJmuUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.6 /",
    "Flow State": "Turbulent",
    Friction: "482700.90 /",
    "Friction Factor": "0.015398",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "8150",
    Mark: "478",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3933795.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "395667.2728",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "55",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "31.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529759",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.59535487",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jU0LgkAYhP/Le94W9zX3w05RQVAHkaCDeNBadGHbDdsCEf97VnabGZ6ZKQbIanPq7xpSOPja5PoSKtdYDQQyb1x4QFoMPzkhC4ZUSSlWQlBElDCWf27ddVU/wVOwNdVNB91BGtGIwFG7JrQfw3iSEMh9qILxDlJGExEJxWPkQi2l4pzA2VxnGBUjsNemacN3SSIS2Fn9mtvIaMxjSWDjrZ/O3NPasXwDn0dUcNMAAAA=",
    Pbi3DGeometry:
      "3SMAAB+LCAAAAAAABADtWE1r20AQ/S97loVW33JOpS0U2kNoCz0EHxwiEoFqFVcthOD/XtWSLFuzTzNS2pOXkBB5MvPmzc7OKO/uRd3eF1+ff+RqrT5W98WXqiwelKNuq2JX/1Tru5f218bs3TRf6uAMn6y0590cfzTf6rDp3d7s99vnxnelfTdL08RJEjfwotjxtRvEQeqsdOB6Ork0JJHZEAZBxnj42aWHF5o9ulA0qzCMOkOUxQYMyGOGB8QQZCUt4hAKYoRJbKgV5DFg6NDTxvPoDYT5yTBOl4bqTvBkGJ+gFGPgwXqQ6lIDDDUywJKQo6XpSsHJ0dKsuqMdFXHA8H0/XcZc3qIUA3YixIA8Xt3UcgxYdnhrKXMpBjlByoMjCFsUjqU+XcEg427U/JlIwbmsZgwAPCzT6IgR+UkbKo65VWT0mGJu5jFMOD9u2uZiwkmXF1l3NNRiHoZJrVtDlrU8Eo8jyHmw2wBuHMKcronekOpEsj8mPYw8ZpSdbDXpe8kkRpuV/3e4HD3SSYNg6I9GuCCUwYPhwZ7H2eZsW1RnQfe5Fr4yEAhzkwheAEalQknBSEtYJDpsb6bOJg1D4/YGcgHZUKSpFmM0/NJJj6EiIw+aFedBMSBBWJLZGLSrzDymmgeCwyYBny+uLTXgewmwoQOLDT24UIIZLc3qbKWgqQ4N5qaa2oCwDTmMUbrLMODLDTJIBwm8gJI3EgQOPVhw6MGFEmxZaVZna2veXoa3edkg4TAu071CNQb++yaQaf6hGjNTdIE8rkGN4aQHqUzzX9UYgejC8bBqjFVjrBpj1Rirxlg1xqoxVo2xaoxVY6waY9UYq8ZcgRqzcdS7Yvs9r/O9Wnuu56hP+e6xfuoePlf1ti6qXff4rXg4mT7kxeNT3T28L/Pf53/4tiqrJuDuV1keNn8AjwAOkN0jAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1114",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529760",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.89534414",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzHkh6S0nkQFQQ9FBA+lhxZDGoiJ1CiU0nc32NqDiLed/YaZKXrIa3Pqbgoy2Pva5N522jtAkHvjwh2yoh/PaFhQjgkTdJkyTKVIYUA/YJJgToT8ggyngrH/cI4tP/Wrtq26uCE+Nqa6qqBayAgmCA7K6dBM4uhDFUycPcqzucxop4xuwltIJhBsrXpOXkYxT7hEsPbWx1z3sHYoXxHYJ0ITAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVltrgzAU/i95jpJ4iZc+jW0w2B7KNthD6YOl0gacGc4NSvG/L9vcavTkGBHF5PN855bz4eZM1jv5fHorSU7u1U4+qUruCSVrJev2neSb8++rhtlKX6Sjlx2PM7b6eeibdNs/s6umKU7a1uOBn6VpQrPA5yLOaMD9KBScejz0Gc8yA2BR1gPMtAgSijBpQAgBGsRJBHiYMoVJKLCYMN9WYKFzDLBSjRIP0yAFSzgAHBMclERTJYkfslhcitszDfcNpiFgVAS0+E5j4gJjgoEFQZlFBwFrtNaoRmn0RV9ANReVNcFpm+Y6jjUWGr+ZgwA7cIzVrd+whiBMVoNF2oJ2G2Ky7bseG4MI2reeJlQmbEwuujJvgI72VIgwwFUlTCoQQMcLVFqUymoB5oHKPDzbVtEGgTkqWA0wmYCH1VE/HBVnlIf+Z7iRxWvZlg3Jmc8oeSjrQ3vsF4+qLVqp6n75Ivf/0F0pD8e2X9xW5efww2tVKU1Yf1RVt/0Cdm9v0+UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.3 /",
    "Flow State": "Turbulent",
    Friction: "593560.73 /",
    "Friction Factor": "0.015217",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "4529",
    Mark: "479",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2688481.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "441367.4441",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "56",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "35.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529762",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.18620681",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2No0iZN6iQqCDqUIjiUDlFDG4iJ1CiU0nc3at3uju/u6hHKszkOdw0F7P3ZVPoSlGutBgSlNy48oKjHn4zIglAshciXKcWcZRSm5s+t+l4NEY7BxqibDrqHIsEJgoN2beg+hnDGEFQ+qGC8g4Jglie55CnlucyE5BzByVxnmEqCYKdN24XvkqAUwdbq19ymBKc8FQjW3vp45p7WTs0baEMl+NMAAAA=",
    Pbi3DGeometry:
      "iSMAAB+LCAAAAAAABADtWFFvm0AM/i/3TBFwwEH6VG2TJnUP1TZpD1UeUhW1SCxMKa1UVfnvY8kREsyHTfoybacoUThjf7bPZ8N3+6Zu7srvr78KtVDX9V35ra7Ke+Wpm7pcN09qcfu2/9uKg8v2o7Zev3IRBsHl7qf9qu2yU7vabFavre5FGPl5lhlPR77RxotCP46T3NutJ3l6vK716Lo2STZ9f2xO1oOYsXPqj071n3XtB6Exo/ZH/Rffj+wz/ojzZu0g++16lBuanwn/rf3EhPHoBnQCEvFBMHSVmrJ7dtAYbpoUow+D1SCJHQigKSqAKSGbSlMiBSf7Sr2yG0uTaDHSJI7Oi1xcnAOIiSqE4Y1H8e56lgPAjKOTSoOWQpC9I0EwwcHSRF2o85VpW4JzNLf/DZAFLs1oLLA3ZtkOIusMhcysAfcj+zA229DSPNGnZ1E2ncg0o4bODIHmLk32CDrcx6AzLjhOg238cLiQuGkz6xIStoHJRgXUgHEIk07ml/iZAwJ0LhmzbykmyBgB19xJq+YsEQUuCG4njsajrc0otoI0lT0YUAxYH9yYp4mCXkFT8+MI2pOwO5VaTwr6qu0E5PSxpkhRnY8RJeGkRp+SgQb1itOgGDBA6O58DFJXMA5YPhAcVwkSnJ9dIsCHE4FDDRYcanCmBD1a6lVvCnZ1KIB1BScg1GAxiLvzMeBDDViXdhJ4AiVPIwAbKrDYUIMzJZiyUq96U/PnMjzL8xsJi0Hc/T84FvSGxnAv4nWeY5nFpUy8Sf7bHIuAUJCSL1MBvptj4agUQRyOY3Eci+NYpmeN41gcx+I4llMFx7E4jsVxLI5jcRyL41gcx/KXcyxLT30sVz+LptioReAHnvpSrB+aR3vxtW5WTVmv7eWP8v4g+lyUD4+NvfhUFS/HN36oq7o1uH6uqu3yN8hurfiJIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1116",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529763",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.40142173",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9jk8LgkAQxb/LnLdFZ/1DdpIKgjpIBB3Eg9KiA9tu2BaI+N1b0jxEdJs3v8d7L+8hq+jU3SQksDcVZUZ1tdHAIDOk7R2SvB9PZ1j4gnsY+qsg4EGEMQzsBxTIY/HNkC9DxL9sDi0+5Wnblp1b4B4bKq/SyhYSj3sMDlLXtpnE0djSkhs9yjNdZrSTVDf2LSIMGWyVfE5e9LmIRcRgbZRxufqh1FC8AJhouOQRAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACVVl1LwzAU/S95TkvS1PRjT6KCoA9DBR/GHjYWtkBtpFZhjP53o1Zt2pvbjLF1uSf35H7kHro6keVWPx1fFSnJndnqR1PpHaFkaXTdvpFydfr5a2G2sB/S0X9LxBlbfP/YL+nWv26XTbM5Wt+IJ3GR5xlN0ziVSUYTHqdCchpxETNeFA7A0qIHmOthHwiTBaSUoMNFlgInTJlEJiQWE3a2FzjzcAzwUo0SF3mSgyUcAIEJDkpiqUQSZ2JQ255oYHZ4BnanHND+rxTG9AgNaA8Ox601ZPeF6YvHDb+vczDPTDy+vCZdmesv0kZo1vCuw/RBcQa1FxYLP493/1kagjUYIvLZwy6KQwOYfdcHVQIPT4hyzDtg8ztVGgwIUwKXCLJjowTKKEbkdQBTQCUcHGOvHoPADBM4+IgggIMZJhSByjJKwb4JXOvNi2pVQ0oWM0ruVb1vD/3iwbSbVpu6Xz7r3R90q/T+0PaLm0p9DDdemcpYwvq9qrr1JxiExdG7CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.1 /",
    "Flow State": "Turbulent",
    Friction: "294434.31 /",
    "Friction Factor": "0.015883",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "3574",
    Mark: "480",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1052307.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "304266.9301",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "66",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "24.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529765",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.98901724",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNI0jaPuhIVBF2UIrgoXVQNbSAmUqNQSv/daHU3ZzjDVCMUZ3Mc7hpy2PuzKfUlNK61GhAU3rjwgLwa5xiVBWVYSSmWiuNMKgVT/fdWfd8MUY7FxjQ3HXQPOcEEwUG7NnQfYEQwBKUPTTDeQU5xJohQPGFcqFQqzhGczHWWqSASwU6btgtfZolCsLX69VszipOUxW7trY9n7mntVL8B42KvVtMAAAA=",
    Pbi3DGeometry:
      "KSYAAB+LCAAAAAAABADtWEtr3DAQ/i86O8aWLK28OZW2UGgPoS30EPawISYxuOuydQsh7H+v48c+PPo88vYqQkLs8cz3zUMzYu5fxd1D+f3lVyHW4nP9UH6rq/JRROKuLnfNb7G+f+3/bcXJbfsjDtHpzU2aJLfdn/ZXHDaj2rv9fvvS6t6kMs6tXUW5iU2udCTTODPGRp0gy/ILQWaNU6BMmjIa0lxiJO2H86YmrFQm3zRUnCiZuTHcfizQgBgcqwVBHExBjFagE+OI1ZwfA0b7rJz5GAXE86NgSpeaGjJ41Jhm0Bfj5AerQfJBWflqeMQKhmQhximDk1h5+KFtnjvranlIYIlOMOYq0Y3h4eD1Re2PQVlxp5Z67otBUkv94Bykpri2NNLlGpnHiVreEyfgHqwWNBncLFUvUJntTa00N4qQBsSADo4zSqf2ssP5Di867oipq/2gQdRd1LXWsnuvjWT8YxTYWXBGNlGdqSztvVCJZobEINBylU8CgkwhtpAUHlAIgjPlSHhvyijbsVKrXDrzejaBkUbvn5GZ6d5rxd2tkAI3OugggJyg37CeGVIObOQerhB4uemPjH77oBNId4l4YMDacY/fuahDVtDUYj+s1WmfwFZzTnCs6FFAmgJvapry6zF0ZtJZjWNIphqEFatBMKCDmO5iDFJX0A9YPhB8pkqA4D+iS+jiw4lYIQ0e3HtEeIfdf3BhU4QVmE+wrOBcxhocBKxD4jccpigey8niqxsQePckeJZ97luIFdLgwSkGGKfeLdTjtsDS9Z3MuMEsb0kMBDue+LsNjEfYWYWdVdhZhZ1V2FmFnVXYWYWdVdhZhZ1V2FnNjd+wswo7q7CzmmUVdlZhZzUvCDursLO6Yme1icSHcvuzaIq9WCdxEokvxe6peR4evtbNtinr3fD4o3w8ij4V5dNzMzx8rIq/5x++r6u6Nbj7U1WHzT8ycM0DKSYAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1118",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529766",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.62932313",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzHkx7SknooKgh6KCB5KDy2GNhATqVEope9usLUHEW87+w0zk/eQVfrU3RQksHeVzpzpamcBQea09XdI8n48g2FBOSZM0BUlHMulhAH9gDLCMZXiCzIsBWP/4RxbfOrTti27sCE8Nrq8Kq9aSAgmCA7K1r6ZxNH50uswe5RnfZnRTum68W8RMYFga9Rz8jKKecwjBGtnXMi1D2OG4gXky/sfEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1rgzAU/S95jpKoVWOfyjYYbA9lG+yh9MFSaQPODOcGpfjfl61uNXpzjYjW5HjP/co9dHMm6518Ob0XJCMPaiefVSn3hJK1klXzQbLN+fKqYbbUF2npdcfjjC1/H/om7fbPbFXX+UnbejzwRZomlLPQF5GgAfejMObU46HPuBAGwPTvBWCmRZBQhEkDcRyDBoskAjyMmcIkjLGYMN9WYKZzDLBSDRIP0yAFS9gDHBPslURTidhPuFhci9sx9fcNpj5gVAS0+Elj5AJjgoEZQZlFBwFrtNaoBml0RZ9BNRWVNcFxm6Y6jjUWGr+JgwA7cIzVrd+whiBMVoNZ2oJ2G2Ky7bseG4MI2reeJlQmbEwuujJtgI72WIgwwFUlTCoQQMcLVFqUymoB5oHKPDzbVtEGgSkqWA0wmYCH1VE/HBVnkIf+z3Ar87eiKWqSMZ9R8lhUh+bYLZ5UkzdSVd3yVe7/oftCHo5Nt7gri6/+hzeqVJqw+izLdvsNgGL1s+UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.9 /",
    "Flow State": "Turbulent",
    Friction: "848560.75 /",
    "Friction Factor": "0.01493",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "2204",
    Mark: "481",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1869847.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "532767.7867",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "46",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "42.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "529767",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.63381071",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jEkaZtHXYkKgi5KEVyULqqGNhATqVEopf9uaHU3595zmWqE4mrOw1NDDkd/NaW+hca1VgOCwhsXXpBX43JGZUUZVlKKteKYqySDqf57m75vhijHYGeahw66h5xgguCkXRu6GRhHUPrQBOMd5BRnggjFE8aFSqXisb2Y++JSmkY8aNN2YWaSMgR7qz+/NaM4yZhEsPXWx1/ube1UfwEWl6HM0gAAAA==",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVl1rwjAU/S95jiVp2rTRp7ENBtuDbIM9iA+KRQNdO1w3EPG/r7Nd60dO2+jToIhienvvucm9OfdMtmQ816+bj4gMyWM61y9prBeEknGqk+yTDCfb4m9uZqP8Q3a0fjLgjI32P/mX7KZ/bjfr9WyT+w646ygpJVXSCbjyqcsdEboh3RvCMDgyBEIWBj/wDg0e85TRwxOSUxOG5wYtkbpClEkJh3EWGLbRaFDKgHHuUWULt2fOFkVqQOgaqC6Sz8Nfg1Si8PD4cbKVwZfK6CGkOVL1XBS1qwLVNbKDznfhsaBTqAI7d3B9v3uuTQAnKQkfnF8zsgVCvemTSOUxWfRf3bFm8CYDDIX2h04ckgE8WXhTETTscfO9a7+o570Pi4QuKiyefVVxjZAHxrCijwb+hXcbGiCTIzJoY4lzNm2rnoF/EQbKFnZz2zCEbX5ugKFsCRhWFTMzHKsAwpxrQ6fZDfRLZqq1ZLDXMRdoCUjZV2oJ+6Q6aChradB11LdrA3sGth31kBwhz7aMtuu1QUeAXhr00qCXBr00+LfSYErJnZ69R1m0JkPmMEqeomSZrcrFc5rNMp0m5fJNLyrTQ6SXq6xc3MfR9+GLt2mc5gGTrzjeTX8AbDDmrfkQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1119",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "28965.7",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529768",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.23691805",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jE0aZtHXYkKgi5KEVyULqKGNhATqVEopf9uaHU3595zmXqE8mrOw1NDAUd/NZW+BeVaqwFB6Y0LLyjqcTmjsiIUSyH4WjKcCZbC1Py9Td+rIcox2Bn10EH3UCQ4QXDSrg3dDJQhqHxQwXgHBcE5T7hkKWVcZkKy2F7MfXEJySIetGm7MHOSUQR7qz+/NSU4zalAsPXWx1/ube3UfAGL6eh00gAAAA==",
    Pbi3DGeometry:
      "+RAAAB+LCAAAAAAABADtVlFrwjAQ/i95jiVp0rTVp7ENBtuDbIM9iA+KRQNdO1w3EPG/r7PVOpuvberTQESx+Xr33eWSu2+yJeO5ft18RGRIHtO5fkljvSCUjFOdZJ9kONkWf3OYjfIP2dFqZcAZG+1/8i/ZTQ9mN+v1bJPbDrhwGGc+DZUjFXOpyx0RuAEdcNcJg+Av4AtFC4swPAUkk6HRQgrFqYlDun6TJwuKMqgcUEqZ04CA50szx5lFEW1jeiha5Mm4buGoTCK3cD1vDwRK7C0kPwv2AHgqNFoIZfZ0XJfsr6NjjSypc0CUWbS5Krh/S8SD7rFCgnpIwgP718xswVAlfeap2qau5686sZAcAvjwg/zQOrx35p1tskAUMFbzvetwUWu1gADyhItnXVVYI2gBOezaR0P/hXcbAsiTuRl06RK1qrZWr9Z/Ibkx2sbR1jYM4TGvdRazqx4NGFYVFwlZQAqUNjxpVgO910y1lgx2OqaXlsBX9UItYR9U+4bYS4Ouo75FG/TqwLajHjZH3GdbRtvF2qAjwVUaXKXBVRpcpcG/lQZTSu707D3KojUZModR8hQly2xVPjyn2SzTaVI+vunFEXqI9HKVlQ/3cfR9+uJtGqe5w+QrjnfTH9dTR5f5EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1120",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "858244.3",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "529770",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.48069989",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO4eQz9rGSVQQdChFcCgdooY2EBOpUSil/92odbs7nrurRyjP9jjcDSjYh7OtzCVq3zoDCMpgfXyAqsefTIjAgsh8SYnAhFIJU/PHVn2vh8SmYGP1zUTTgyKYIDgY38buY2gmJYIqRB1t8KA4poLKgmWSy7xYFJwiONnrDLMi2Z2xbRe/SzljCLbOvOY2o5hnPEewDi6kM/90bmreAFyqn9IAAAA=",
    Pbi3DGeometry:
      "dSIAAB+LCAAAAAAABADtWMFq20AQ/Zc9q2KlXcmycypNodAeQlvoIfjgEJEIFKu4aiEE/3tFLNneXb2dWffWLCYmeho/zY5m30jv9kXc3DXfn3/WYiU+d3fNt65t7kUibrpm2/8Sq9uXw7/DaXk1fMQ+OSHvMimvXr+GP7FfTz97v9ttnoff6lRXVZlkUqcyy4okz1JVqio5x7UsX/FFMYtrpZas+CI/xEs9G+/wjPloXZzhKl1WuZ7ln82fjkf8vHzoupk8iH/AF1K79XHyV7nK5vgd3Ik386R5zPt1Ib8nf7OeBI54nHrS60J1IK5r8njyse6jHE7/y3qpPgT8qN/odRF9GNq3BD+xXhf315PmN3XAk38oj4XbeRK6RPDz9Q1dF+Dsferom4WrYtK9TB14ytI3F8h4Xv5al0v/fCHmzpQPycPLH+pMlY/5K33AF9J7X0A8W8/RvHBwS+dLvQjSfxSP1suts6N7zHjEn1dmPlpVXtyvqy6OeMjnB2tOces/xS/MNhzgzBdO0iOcN3bIdALDrZur9Hhzl1r5cEcMJ3wSK8BzbJ4JH5snkH9YVsWKP5Whms2HG38UJbAuVIdA/lP3mPWh80fd41x3th3m4dBqQhztCZANDiforaJxi0kpLTefiQdNFnJCoeZBk9raFOi65Gbh8cMnCoRzxQFtLurJAV0XxlP8lihxxYqajNx8Jp6LJ6m5TUPFAfKjPN+Ks4HemHiOB42znQ2eg0G8IbqPLP+Hs+FZb5Dj4VnXhc4G4WDAN/TobERnw6dL0dmIzkZAfHQ2orMRnY3obERnIzob0dmIzgZDrN6is7FOxHWzear7eidWMpWJ+FJvH/rH8eBr12/6ptuOhz+a++OpT3Xz8NiPBx/b+s954Ieu7QbC7e+23a//AkjpsgV1IgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1122",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529776",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.36309055",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjcsKwjAQRf9l1mlokpqmcSUqCLooRXBRuoga2kBMpEahlP678QXu5s49Z6YeoTya/XDVIGHrj6bSp6BcazUgKL1x4QayHj9jRBJCcSFEPk8Iw4RTDlPzAxd9r4ZIx8XKqIsOugeZ4hTBTrs2dK9ASMYRVD6oYLwDSfAsT/OCM8rzIhMFj+3BnP/hjTZtF96XBGMI1lY/vjYlmEUVwdJbH5+5u7VT8wTycTZJ1AAAAA==",
    Pbi3DGeometry:
      "GR8AAB+LCAAAAAAABADtV01rGzEQ/S86r42+9kPOqTSBQnsIbaGH4INDlmRh6y3uthCC/3tlr2J5d/Uk2beCMDFZv52ZN08zkubhjdw/Nt9ff9VkRT53j823rm2eSEbuu2bb/yarh7fhXw3TG/0h+8z+smCU3hy/9B/Zr9/NPux2m1dtu2B8qaqqzBZMLPUrLONsKQrBjz9QVrExUubSjUghRchGUDG2oVJ5vTm4SVnkA5Ir7oqD83HY2Djx3iyDeAQrahnI0iWOlxpOhxcGKXgxluCECDHxNrWx6ZwQHc8dZgCwLxzf4Qwz41SNtQkzwwRgmpxK7g3jYBaK7xATpzmTBlda+d5TUr/r7Y+zSqND2zEmq3Ge0TWIG8cimFp8DcSQjuiCWd1gb9dwi8h0VgZTG7xJ4QKxCPYWvxnifcUisEA8NRWWGrd1cJOy6WAJ4jsuSgKYjyoNUrIjIhT1n6MHG1qZfLS0R2SmQVmafBQoN7y3XaTOLA7gdsinGI50lvPJSR5/xuO7hEWomCCF4tfrBnfxixPFi32QmhkJygocI/MDJmwzI41NMDW3M3+B4qKG2uA9B5Shd6nxssE8cXXgPsBFAKj5qx12CL4BTvORTIUuYFPSGpnWTfDkcZxWpnWkZu2WQCN5iAGOgxFw0fEzcMvmH1JwX4cVhXe9mWyetXaH8SYafT89u5nATQKvQYQClyQKixrH8awoXLfoHTSGGnaWZuU0K6dZOc3KaVZOs3KalYMSpFk5zcppVk6zcpqV06ycZuXri/o/m5XXGbltNj/rvt6RFV3SjHypt8/9i3n42vWbvum25vFH83SCPtXN80tvHu7a+u/5ix+7ttMOt3/adr/+BywEAioZHwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1126",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "80373.4",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "529777",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.74538698",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPoTZo+4kpUEHRRiuCidFE1tIGYSI1CKf134wvczQxnZqoRiqPeD1cFErbuqEt18o1tjQIChdPW30BW40cGZIaM5lmWzjGKaYQoYKp/4KLvmyHQIVjp5qK86kFGNCKwU7b13csgxgmB0vnGa2dBcooxipwlgossT3OOBA76/A9vlG47/17KOCewNurxbTOkPOGMwNIZF87s3ZipfgKyugaX1AAAAA==",
    Pbi3DGeometry:
      "kx4AAB+LCAAAAAAABADtV0tr4zAQ/i86u0YvP5SeyrawsD2UttBDySGlpjV44yXrXSgl/71KrMSxrU+WQ48iJMT5Mo9vZjSjef4kdy/l48efgizIr/qlfKir8pVE5K4u181fsnj+bL9qmF7qF9lG3S8XjNLL/Yd+k+3yIHa12aw+tOwF47HiKY8YlTFlLIk4i0UqeNRHJNsDWSKtgBRS+EokWvlOhErlq8v4JWWanCIiVjkHVgCVo8jQioeuoXkfBIbSYj9VuS0w0DMLlzzPWkCr6FlPFO8BR1UDCcNEaAI56wGtjTEAVUHjnbvQK9l3qo0IdMplG/ITVHjZME7NMN5VA+QHI4IrKzv4q8z5QYehUyapMpUlMlBZUzUHj0kHYMd88z7L4xFJW6k4Vc13C1OEqR+KwEYEi6IDpnR5tDvYOyzAqCZwKB0ISItvI+qYYPa+x8uDPCaiMtWGmNN9WISiU8NR6X+2WRFpixx6CxWyT1KBCoMNbDIuLivAsZ2y3HARCk3nqbkNLwcWgKfGMX5exFxj6BySIMk7+/IQZTO3j3MCDhAsAkcLEHF6BgOA6xKWskf6Rx3Goyv10uzMGfTMkU1oH8vAAsRV7hGa4Y1uyEYy5bxUWVzWiJo5YbqrzeDMSO2ylb4GkinzePRNXUic1+ORA/aQuaLsOM12Nq5L7XTIRkmGIbOTnHHlPHEL9gUcfcz+DJIwLZg+lgEZm9MyfQ4ZDlpYdMOiGxbdsOiGRTcsumHRDYuufTqHRbc/J8KiGxbdWetBWHTDojvnWhsW3e9bdJcRuS5Xv4um2JAFjWlEbov1W/NuHu7rZtWU9do8PpWvR+hnUb69N+bhpir+n/7xR13VWuH6X1Vtl18pdfaRkx4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1127",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "682704.4",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530080",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.02035246",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkgaZNPYkVBD0UETyUHloMbSBmpUahlP67wbaCePC2s2+YmWKAvDan/qYhhT3WJkfbN+iAQI7G+TukxTCdwRBLGrFYrTjjNFJSwEi+oeLiP5RS/cIldoLlUr/uuqoPG8IjM9VVe91ByigjcNCu8e0sjugrb8LsSZ7N5YN22jStfwspIgJbq5+zN6EJF4LABi2GWPewdixf2UWhnBIBAAA=",
    Pbi3DGeometry:
      "kwgAAB+LCAAAAAAABACdlV1rgzAUhv9LrjNJ/K69GmthsF2UbbCL0gtLQxtwZrhsUIr/femmdkZPTxyimNfjcz7MOa5PZLWVL8d3QTLyoLbyWRVyRyhZKVnqD5KtT7+35jGbm4PU9KLccMbmPxdzknrTvnZbVfnRvJvEXsSSGeWMezHjEU29NAxC2tMDPznr3Pf7OmfxWfd5QJ04jX0cRaP8JEz6ehxOCgdyi6Tl6vZ6NANKFKajyTb6oGhQVn23M+6P1r7TLUynW0Ww7dvwbX4bPspB+IN4gLQAGYoS8moVH+X8K5pBTtanRaOE+sFxI6McRx2qDrTFUXuI7+gX+opoy03lOOrAdsA6FLCG4G5Oob02bXihFEcd6ghoqKH2EN/RLzQd0SE7leOoQxMA7WjkDzrgX3Tzh1/I/E1oUZGMeYySR1Hu9aFZPCmda6nKZvkqd92jeyH3B90sloX4+mt4pwplgOVnUdSbb9MZnzSTCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2592",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2601",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2687",
    Length: "25",
    Mark: "494",
    Material: "Copper",
    "Middle Elevation": "2601",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "144.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "97",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2601",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2611",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530081",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.87034321",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1js0KwjAQhN9lzyH0L43Uk1RB0EMRwUPpocXQLsSsxCiE0nc30uobeJtvZtideoSqw7O/KyjgQB1WpH1PBhhUhMY9oKjHWYaCzHkuUrmOo5jnaSJhYv8Jm+/7jbWtDxuCscX2ppyyUEQ8YnBUpnfDAidyrcMwe8YLXn/RXmE/uA+IVGQMdlq9lu6KJ5kQDErSFM6ap9ZT8wZ6umo1EgEAAA==",
    Pbi3DGeometry:
      "hwgAAB+LCAAAAAAABACdlVFPgzAQx79LnytpgQJuT0ZNTPRhURMflj2wrNmaIDVYTZaF7243EFnldoUsW9Yfx7//O3rH8kAWa/W6/5BkRh71Wr3oQm0IJQutSvNJZstD89deZnP7ITX9I1ecsfnpx35Jvfq97aaq8r29N02CJBOUMx4kUZjSLEgzdk2PWERpwxkXfZ6KrOGcJX0OyHThIs4G5ZO4j8NwnBtgVywnv01RM+cyEU8GU+24UzEoJ2hbp/JhLMSQTsfPi/A//OS+w86DwlQwcceLkxPKAZPArk7lMZXJZpyknAeLuYRaYWTn+KmjHKgNcLb9VKZ2PeAFbaiL6ujpgLjn8YDsjI0fO4ag44fOG08dlEPtAM0zT53J8xLyA72pIO6pg3KviYlOdb/wI7dv9TuVv0sjKzJjAaPkSZZbs2sXz9rkRumyXb6pTXfpQartzrSL+0J+9wNvdaGtYPlVFPXqB6LXId+HCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "163",
    Mark: "495",
    Material: "Copper",
    "Middle Elevation": "2582",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "927.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "97",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2582",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2582",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530082",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.60802588",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAQhf/LnJdlV9E1O0UFQR0kgg7iQWnRgW0nbAtE/O8tqV0Kur033+PNy3vIKjx1Nw0p7KnCjExXkwUGGaF1d0jzfpQ+oGIeL0SwlEJ6EQUwsF8w5DJR4ReU6i+ca4v5/apty85v8IcNllftdAup4ILBQdvaNZM5kisd+tmjPePlg3Ya68a9TRxEDLZGP6dswmUkFYM1GfK19mHMULwAusqqLRIBAAA=",
    Pbi3DGeometry:
      "fQgAAB+LCAAAAAAABACVlV1LwzAUhv9LrmNJUvux7mqoIOjFUMGLsYuNlS1QG6lVGKP/3bjWds3JSTPGxvL29DkfOTlZnchyK9+OnznJyJPayldVyB2hZKlkWX+RbHVq/+rHbK4/pKGDcsMZm59/9Jc06//XFlW1Oep3kziIozChnPEgnkWCpgGPeEL/dCGikZ6GZznk8UiO2Yy6MEmUWu1TK92gCH4rXMFgTjH9OqeYbqcYiQoWcVvBet0vpd5piwm1XRJe1rHFDPoIM8ijCgDrNnYIxyiY7heMUWCo24PEnBrB9wX2okzGgqRkbMfYKdIb0BrrGWdKgO61pz3DXQDYeG4OZg9zcp8yGA92bjDdzYHxYzqy4c5xiFGmpueUubP54EzFdL8eNjDXTgM4bd0czN7/anEPBMjBdM/BYnCgbj+HXhNh4lq0RK7v8nu5+cjrvCIZCxglz3m5rw/d4kXVm1qqslu+y13/6DGX+0PdLR6K/OfS8E4VSgPL76Jo1r82IY36fQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "455",
    Mark: "496",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2584.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "97",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530083",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.14161426",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACNjlELgjAUhf/LfV7DuabDnqKCoB4kgh7EB6WhF9YWtgIR/3tDrfCtt3vudzh8WQdpief2riCBgy0xtbqtrAECqUXjHpBk3Xj6AhNUSB6tWMBpKCMOPfnBBQupjCX/hzK+nNHZ8ADzj8C6aYrWW/jHFoubcqqBJKABgaMylauncLKucOjFx3jB6xftFVa1G0IUCgI7rV5TV1ImWExgY7X1s+apdZ+/AQKIu2UUAQAA",
    Pbi3DGeometry:
      "rwgAAB+LCAAAAAAABACdVU1rg0AQ/S973siuRt2YU2kLhfYQ2kIPIQdDJFmwbrG2EIL/vRpt1canYxDFfTPz5s3OfqxPbLXVr8ePiAXs0Wz1i4n1jnG2MjrJPlmwPlW/hVksi4flvEFmUojl+VO8LN/8ht2kaXgsYqVrucrxuBSOZSspubKkcngHni9UCbvS7+K+XJS4JxacQlO528KVffS2nNtdXCpvihqQdbAmctJBLZcstu/3llrhlzOGamrSzqRtKb/M/2/mu4YWUdfQTENfwLmCvhTnEmhMwxl6JKHiEA6losytLhCZrpPUUxtqNJKK9gbsAgqY2h2YAC1tyoIh7RGCP03R8Gab0n4YAQ2jxwXkoRwv4+4kNWgxtnDacocB0IAOtskbBxER/GmK0GU2/aiFEdAwenVBHvq9W7oXt/+dDt+jLEpZICzB2VOU7LNDPXg2WZhpk9TDN737Mz1Een/I6sF9HH23HW9NbArC5CuO880PNoqtEq8IAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.5 /",
    "Flow State": "Turbulent",
    Friction: "795407.84 /",
    "Friction Factor": "0.015275",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "8675",
    Mark: "497",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6900315.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "425875.7923",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "41.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530084",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.39173242",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lo+hdbT6KCoIcggofSQ4uhXYiJ1CiU0nc32NaLgred/YaZyXsQFZ66m4QM9qZCYVRXGw0EhEFt75Dl/Xg6g8cCmnIeLj1O05hxGMgvyEIapck39KPoD5xji7l+1bZl5za4xwbLq7SyhcynPoGD1LVtJnE0trToZo/yjJcP2kmsG/sWSRAT2Cr5nLwLylwbgbVRxsXqh1JD8QLlyxvjEgEAAA==",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVlV1rwjAUhv9LrtOS1Novr2QbDLYL2Qa7EC8Uiwa6ZnTZQKT/fVntbNOek0bEj7w9ffLmnJ7j+kxWO/F2+sxJRp7kTrzKQuwJJSspSvVFsvX58lNfZgv9IjXtFI8ztmg+9JvUm//bllW1Pel7PR74acgS6sV+OucxTfyAhwFt9DjgPZ0ns4scBWk/nM05tWJ4EoPxLI0gvInhf182N9iumH7jrpiOYMyz8oilUM463elQ3a4Nhs/8UO/eT2WDueompgs3czAOb8wDdAyD6U5uBikGdMQltqvpvkuxE2baDXIosyKThcUKiPWUteBjvJNJx8ICvWPlYPE3TApraQEOprs9IgMOoCOPjq33McrUqJgMt/UsMFgw3an1BxhAt3YPMLisHCwesG8d04AfbO5iupUD+Le2/zjNTlPBbYgY5vX/+r3YfuQqr0jGfEbJc14e1LFdvEi1VUKW7fJd7K+XHnNxOKp28VDkP/3AO1lIDSy/i6Le/AJfJofeiQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "229382.34 /",
    "Friction Factor": "0.016587",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "1690",
    Mark: "498",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "387632.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "219466.6524",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "30",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530085",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.98918116",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzEkkZi2nkQFQQ9FBA+lh4qhDcSs1CiU0n832qr05m1n3zAzWQvpyRyaq4YEtngyKdqmRAcEUjTO3yDJ2v4MBiVoxHg8n/AplbGEjvwYZ5xKptQfUIgRHKW+WP4pX9R10YQF4bEyxUV7XUPCKCOw06701SD26AtvwuheHs35izbalJV/i5mQBNZWPwZvRLnkisASLYZYd7e2y59TjfsZEAEAAA==",
    Pbi3DGeometry:
      "rwgAAB+LCAAAAAAABACdVdtqg0AQ/Zd93siuxmueSlsotA+hLfQh5MEQSRasW6wthOC/11sTrR4diyjumZkzt93ZzZmtd+r19BGxgD3qnXrRsdozztZaJdknCzbn+rcQi1XxsJxfkYUUYlV9ipfl21+zmzQNT4WtaxqekD5fSMuwPd/lniE9i3dg27NL2JZuF/eEU+KO8DmFplY3hS2H6E25NLu46ZqzogFex3IiOx2Npc9iOcvBVGu8XzGU09WtFNKwhev2Kt8VtIj+WFzKMGRQZTDkokqBxjTuYSAklBzCcajAc6sLRKb/hTSQG2o0LB44G7gLyGBmd6ADtLUpG4Z0Rgj6tIjGD9uc9kMLKJgcF5CHMl6m1UnRoM3YwmnbHRpAARpssw8OIiLo0yKCl9n8UYsssGDq6oI89Hu3VC9u/zsVvkdZlLJAGIKzpyg5ZMdm8ayzMFM6aZZvan8RPUTqcMyaxX0cfbcVb3WsC8LkK47z7Q97xtidrwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "1.5 /",
    "Flow State": "Turbulent",
    Friction: "33029.99 /",
    "Friction Factor": "0.019742",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "8750",
    Mark: "499",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "288997.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "76336.22692",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "34",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530086",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.02002184",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjNEKgjAYhd/lvx5jU9vMrqKCoC5Egi7Ei5k/Olhb2ApEfPdWGXR3zvk+TjlCXuvTcEPI4OBqXeDFK9saBAK509bfISvHbwyKFFQsYrnijFMRRxKm6uet+14NQQ7DVqsreuwhY5QROKJtffcunCeCQOG88trZGZ9180/3qNvOfzpLIgI7g89ZT6lM2ZLAxhkXzu3DmKl6AYdQME7DAAAA",
    Pbi3DGeometry:
      "mRwAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+r+ScQlsotIeQBHIIPjhEJALVKq5aCMH/vXK063jX+7xSzouxkcajN28+V/PwRq4fm7vX3zVZkh/dY3Pbtc0TKch112z6P2T58DZeDn/Ty+FDdsWH5IJRevn+M3zJbuUeu9pu16/Ds0YvVMV4wSjbXxTlopRCFsdiTYXYyw2vfLnmPCpH+oKbvbxUbBqOkfIcHyZ8fUTfwofqCAaaBfKEWRQFysw0Oj59rYQ5MmtKOoq59GAOcqdu2R/kpfDgT+UAB5kNYBAdPwhJNsAqcqpS8jx8wCZlNsRHXoEooNLRwvG0cg46wuWcqsrzq1J6Wk2h0g/wAZ90dgN5kmdgF1QDgJlNB7mF0uv0bUefZMXvUFgNCZjElJ08pvycw6AhOYh9ao4EnRj3Nd0ovhyGGJHXYhSz8t2s4vFZamevVqq08jFm0sGUjr2JFk7g1bwYIHBERgrhJdYwFk34yfGJjlsgH/iMQTOfCw48Ieb5BXKodeWrc312tAN1RBKoAy4ABdYZgEll1p8I6fnh5w+6GieD0oRqPq6O2KBqTVe3/7p0YC+NjGYkPLEdTe17lRr14dHgin64iGd8rxBrHh2PZoifPPnRy2dgNx4eGE3Ug4g+CnM6PL5dgA/dSr7AhXzi7QwPfuDuXLdAcUL4uDocjImRFsYgjh5HybveNLN51ztjNu96pzh518u7Xt71JqDnXS/vennXy7te3vXyrjfr/TDvejN2vVVBvjbrX3Vfb8mSLmhBftab5/7F3tx0/bpvuo29vW+eDn99r5vnl97efGvrf8eKX7q2GwA3f9t2t/oPZLWZLJkcAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2601",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1165",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530088",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.17706296",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAQRf9l1iEkbZq0cSUqCLooRXBRukg1tIGYSI1CKf134wvczZl7Zm49Qdmaw3jVIGHnW1PpU1CusxoQlN64cANZT58xKoJjnqViQQnFPE0EzM3PWw6DGqMcF2ujLjroASTBBMFeuy70L6CUcQSVDyoY70BSnAkiiviJi4LlBY/p0Zz/5a02XR/eTFiCYGP143udY8poimDlrY9d7m7t3DwBhrtkN9IAAAA=",
    Pbi3DGeometry:
      "dxwAAB+LCAAAAAAABADtV11LwzAU/S95riOfbTqfRAVBH0QFH2QPE4sr1FVmFYbsv9t1XVxjTpPhaxgOe5qde87Nzcd9+ia3z+XD+r0gU3JdP5f3dVW+kITc1uWy+SDTp+/dv+1retp+yCb5RU4YpafdV/tHNrP9z85Wq/m6/W2WTlLGE0bZJBU8S/SES6WSLcxlj1MhDnEt3Dgar0TW4SpnITS5kuNyUs4PcaDe0FvDEQ0Ki3BfWJCENJMyRA6Svw+bqy3MtBiy7GDOuByKHw435D2shHLRGNwd1GIxQZEYk4Ie5zIdVeOOCixZ5EwyZ2YMOQoK6JEnlANvNaluLVAmRmfbuNJUbXFBs9FqQjwI98kJdItkem1ZleDlOTb7Q1tgbvd1NhyMFiaqBDeLb2sN3JzQfHvrA+FW4n2mjkpY4Hbg9WppF+3x0eFcbHPAMpGNHjt8zyNo2omneqdes4GpVPOACQzJAGJGSozTzijLxXA1Wecl9Alwpncw0/w/aUEb6JGm0OyZ4YqyLmzmPCzMfo7GI5lovLea0NFoZdnra5gGsB+genLPIJAILaEZdy9jWB9OMaBYgX10O2pfOKWjU1oDkWCHR8dcLpwlr3Pp9OqNCo4bANs3RxDVmxt007RT7xYPU4ySA8JCfmALLXCkBy1keIVBco6zhbPv5kfjPXu97QplwUtv8cTWLuQyHlu72NrF1m58ZmNrF1u72NrF1u6vqdjaje0HsbWLrV1s7Ub1xNYuiP6XZ5aQi3L+VjTFikzphCbkpli+Nov+4a5u5k1ZL/vHx/LFvLoqytdF0z9cVsXX4cDzuqpbwuVnVW1mPyV+pAx3HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1167",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530090",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.32884554",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAQRf9l1iEkTZs0cSUqCLooRXBRumg1tIGYSI1CKf134wvczT33zEw1QdGaw3jVoGDnW1PqU2hcZzUgKLxx4Qaqmj5jVATHPGNiQQnDSSpzmOuftxyGZoxyBGvTXHTQAyiCCYK9dl3oX4HSlCMofWiC8Q4UxZkgQnKWcCHTXPLYHs35X95q0/XhfSlnDMHG6sd3O8c0pRGtvPXxl7tbO9dPtMMXIdIAAAA=",
    Pbi3DGeometry:
      "WxwAAB+LCAAAAAAABADtV11r2zAU/S969oL1YVlOn8Y2GHQPpRvsoeQhpaY1ePHI3EEp+e9VYkf+yD2W8i5CQnyinHvuh650H97Z3WP16+1vydbstnmsfjZ19cQSdtdUu/YfWz+8d1/tz+mNfbFDMiCfeJrenD7smx0257993u+3b/a/uV7pTOYJT+WKm1wmZsUVl8kRN1JM8ExmFC64UIvri0xNcEPSO5qZHCGUPuFC0fRI/my94w/kcXYDcRQ2Z5cLKgpIDVCfFT2NUIUZWR1wkaoRz3z9Wf2A5wXN3+GIB9m95EF6UiOGMPjlILPIrYJnmP5SzbLZS3rk1TQKsHZkvyWEPMlENe540qzooyb4qHiCSgoVvsOBmNDU+kR6K3lSCYDlajFep6aZna9HXQRl3O1bxBPYpdD+dzidchB6XyzBHlxuIU46cDV0k3hdBU5p2aGW74hq+jgZ2npm+vWig6datM3/UXtOlg3qN+ExmPGTarThZ5ZCjTwNOzjRuexwbaa4yuX1kUEt9DqPQO7kGbdsVEFOmrl39UwgvRxIgSwwuKAaaf9RF0BdA6QOqgRq6BzBVkWuRlWEipQOALoczYQX+eItZSZRLF8K/GdBV+qCG3LDWFxjq/AsRzi6EyCrdGjwLRxU3nLE0P1nFhl4ZycjAzwKvKQNRzm9gWF8lz0N9AhEHTgKUkSnIqx/+ZSAqMRhbtFuHOausBuHuTjMxWGOuiHFYS4Oc3GYi8Mc2QXiMBeHuTjMxWGOcj94mNsk7Gu1/VO25Z6t01WasB/l7rl96R/um3bbVs2uf/xdPbmfvpfV80vbP3yry//jhV+aurGEu9e6Pmw+AOOT+NFbHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1169",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530091",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.45405618",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjT0LwjAYhP/LO8eQNGlN6iQqCDqUIjiUDlFDG4iJ1CiU0v9u6ge43R3P3VUDFCdz6G8actj5kyn1OSjXWA0ICm9cuENeDR8ZkRlNsORELChhOOFSwFj/wGXXqT7SMVgbddVBd5ATTBDstWtCOxlKeYag9EEF4x3kDFNOU5lkKUuFnEtGERzN5R/eatO04b0kGEOwsfr5bYupHaOVtz5+uYe1Y/0CI6gfqdMAAAA=",
    Pbi3DGeometry:
      "iR0AAB+LCAAAAAAABADtV01r4zAQ/S86u0FftqX0tGwLC91D2V3YQ8khpaY1eOMldQul5L+vmyixrc6zlD2LkBBrrHnvjWYkzd07u72vf739rdiS3bT39c+2qR9Yxm7betM9s+Xd++Fvb+aX/YftsmHkQnB+uf/pv2y3Ok77st2u3/q5F0IuTGlUJrhaSG1NZhZCC5VNDaVVH4Zc5aRBCqljZ1iRfxgMDUF4OpCSUheeQXJNQ0AZhxkERsAVAR4wwBgS4NxIMiKQlCfDam72BmFKNca2QuiJ4ejKn3GSYUuuJoYThmeAriD44AqxMtbKicFFBJOC2FCfkXkMxCAvFnuAgEFHAYFJZaVjK9W+aGANDK6sEi6ppCCTaj7ZYGkMuhGn6PU+g+wndXSCIEfnU8Lq4HJ7M+CuA/NgMIRdBXY2uFcQBi8R0FrAcVCrsVvOUKtIdXQhRahGCZJzN57b/XgBjqWRDDeey8Ow85MXU3ElnU9wh4oIB8SgKSmunYKSPnDnD2J41hOGQjtC6r9ihI+Wc4TBtbR5cYyo1OMJ6CxA70OeaAJkhDzhtIOugsvsbRkRm4y/nFg3IkUvHK4F6nXIB2VwOBTeDewTf1uGbkETpjJ424CniVcLUhi6pnpDMYcMAcI3B3iB9ZFRlHBcUYXSGmCww0HygUkArCzyMjhiBAod3xpIxecLg5kKANDrcO+M2/IiCAFPqcdMPWbqMVOPOVcaqcdMPWbqMVOPmXrM1GOmHjP1mLNxTT1m6jEHT6uMXdXrP1VXbdmSL3jGvlebx+7JPfxou3VXtxv3+Lt+OJm+VfXjU+cerpvqdfzi17Zpe4ebl6bZrf4BXKbt94kdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1170",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "625498.9",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530092",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.4693318",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAQRf9l1m1ImiZN6kpUEHRRiuCidNFqaAMxkRqFUvrvxhe4m3vumZlqgqLVh/GqIIeda3WpTr6xnVEQQeG09TfIq+kzBiUmCZIpFouYUMSYYDDXP3E5DM0Y7ADWurkorwbIMcIR7JXtfP8KhKQ8gtL5xmtnISeIZTiTnCY8k6mQPLRHff6Xt0p3vX9fEpRGsDHq8d0WiKQkoJUzLvyyd2Pm+gkAL42F0wAAAA==",
    Pbi3DGeometry:
      "Jx0AAB+LCAAAAAAABADtV02L2zAQ/S86O0GS9eXsqbSFQntY2kIPSw5Z1uwa3LikbmFZ8t9rYjVSVD1L2VtBhIR4JM28efNhzd0Lub3vvj7/aMmGfBzuuy9D3z2QitwO3X78STZ3L/PfaZneTB9yrJxkxSi9Of1MX3Lc/j325nDYPU9nV4yvG0FNtWL1WjSqMmsmWF2d5JrWvlzWMibnjIvl/YZLX26i6p2aSzicCzXLGRNR9Qj+5X6nP0+Ps5snR7Sd7Zqm4TEaEBwA32gzq5fSSN+uW+CNryg8cHbALRjdxE3MC1AVsh3RhDAxZTwyMiBBy8g7RSlbMBHBlLAdIRB5d8kGzCRuC0QKyhdS3kulmln6qPZ9y0oxVAlOjvBkhjmJM53bQVogf6/Ek+FYEOLwBOouKPaunKGivPaF+oIzHI89TpUUpagyl7uLw48czqyaDIdBcklq5UqfPFDxF47X+K1dRa08wKPr2QEdzyLYi67hIrQRx9Qoo6wi4ze1vFcseoM7uZQXcqHrVzEEe+y1bsFQ8lpYyyLa3IOmn9z/D1BwACLCmiDXyDdEBmoUsLOAaGKoEBIIG+5p8f0ovUD2IiLQxTGE3+jERSfAyVN3ioz3x1wJnJloRU1ytWQZ3wTgArpTIMOIJMgqTMcEd/AWFVIE54A4RcCx3PuedxkAJY6pTnic6xgMAfIY7Uehyex2GYgQR2VkXLRbRsYyMiYILCNjXF5GxjIylpGxjIxlZCwjYxkZy8gYpaiMjP/TyLityLtu970d2wPZ0DWtyKd2/zg+2YfPw7gbu2FvH791D+elD233+DTah/d9+9vf+Hboh0nh/lffH7d/APDAO9snHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1171",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "166110.7",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530093",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.40306223",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyHkj2rqSVQQ9FBE8FB6aDGkgZhIjUIpfXejrQW9eNvZb5iZvIOsMsf2qiCFna9M5m2rvQMEmTcu3CDNu+GMBiExEwlfUMLxnAoOPfqCnCWz/1Ay+cum1DcrPuXLpinbuCA+1qa8qKAaSAkmCPbK6VCP4uBDGUwcPciTOU9oq4yuw0tQIhiCjVWP0SuxFDRBsPLWx1h3t7YvnomKvrQQAQAA",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABACdVt9LwzAQ/l/yHEu69Fe6J1FB0Iehgg9jDx0LW6A2UqMwRv9301ptM3NNOsbW5bvL990ld0nXJ7TaipfjO0c5epBb8SxLsUMYraSo1AfK16efv9pMlvqDGjwgVyEhy+5Hf1Gz+Z12XdfFUc+NWLCIEopDQoMsZAlmAWM0xQaehh0e6YeB0yhr8TjJsBdP6x+SgFAS/xdoDVFsMrGFppgTEaQ8ldkc4cmArEQki605dwbb4gGpnSnTRZLaNmHATZ4BN5fC9B9lYAqMMnAzTSlYIoIyAzMGIwWEz/fAzXRRSLbUzE12LxHYIX6F7UHkawAXCax5jxmghq84uKfuTpxP5W2A6sPZvKA/KOCpDFXg3APOzeOHQ50CHXtOf4jfUxc6Pt03zFwePxw6GdyNPnXX2vgHXL8L3IrijSteo1yXFEaPvNqrQz94kqpQQlb98FXs/kz3XOwPqh/clfxr7HgjS6kJq8+ybDbf2PndWr0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "305.66 /",
    "Friction Factor": "0.028316",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3032",
    Length: "25",
    Mark: "500",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "14287.21803",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2968",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530094",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.11165191",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAC1TksKwjAUvMtbh5DYEGtciQqCLooILkoXLYb2QcyTGIVSencDrd7A3fyYmXKAosFL/7Bg4EgNFuT6ljwwKAh9fIIphwmmgFpxJYVcS5HxfCk1jOw/ZvWd34RQ9+lDEnZY3220AYzggsHJ+jZ2MzlTrCOm2xO94u1nHSy2XVqRXCvFYO/se47mfKF1xmBLjlKrfzk3Vh+VzzY7EQEAAA==",
    Pbi3DGeometry:
      "lQgAAB+LCAAAAAAABACtlV1rgzAUhv9LrjOJH1Vjr8Y2GGwXZRvsovTC0tAGnBkuG5Tif19WbWeChxxLEcW8OT55c5IclweyWMu3/acgBXlSa/mqKrkhlCyUrPUXKZaH7tV0s7m5SEv/lZuQsfnxYW7Srk6f3TZNuTffJjxI0iikIYuDPAtTygNu3umfHrJeD7mlJynv9DjJhzrEOcVzls/G+DyKsym662eqf4Afz/IxDCCDlCyOxmZ71t2sAS6hYa3k50GUpiOYgW4lZyT+aH+gW4uF4Pj4rh9gXGu6CJsA3s7+xcP63ECjuouCOhFQ8hHxEB9aFIjjy7J7ElGca1UAaHX9Zw7HQeiIXQK5mRg+rRxBW9BfdlAYxA73HXO3qqE4l1dN0A/0z4J0FAeho8omoryj4jvd/OPvZfkhtGhIwQJGybOot3rXN16ULrVUdd98l5tz16OQ253uGw+V+BkG3qlKGWD9XVXt6heb8M9QlQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "305.66 /",
    "Friction Factor": "0.028316",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2520",
    Length: "501",
    Mark: "501",
    Material: "Copper",
    "Middle Elevation": "2927",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "153.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "14287.21803",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2927",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2927",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530095",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.66780722",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGkTWp/PIkKgh6KCB5KDxVDuxCzUqNQSt/dSKsHEbzt7DfMTNFDfsJDd9WQwZZOmJPparLAICe07gZZ0Y+nN6iUq1ms5oGQXEZSwcB+wzhJ5DeUURj/h2Ns+a5ftG3V+Q3+scLqop1uIRNcMNhpW7tmEntylUM/e5RHPH/QRmPduJcIhAoZrI1+TN6EB1KkDJZkyMfauzFD+QSaftDWEgEAAA==",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVdFqwyAU/RefXdBo0iR9KttgsD2UbbCH0oeWSitkcWRuUEr+fbLFrDG50VBa6snN8Xj0HjcXtN7L1/OHQAV6VHv5okp5QBitlaz0Jyo2l7+/5jFZmg9q8D9yQwlZ/v6YL2q29rVVXe/O5l2eR5ynOaaERSxhHGdRTPMMG5wtWHyNU55SPFJvcbCeEtrDGcnn8HR6kqxXnrE5Ki2LqyZmyeSsIA+gnqcxDZA51+TBtIvMEI+Y5uBuvY+ns8fi7WZB/CDebpaFHRccNRDuqrGbBa7Kmt+fFlxsoDmQTMiEgZz+WfBO69lzH32YCV6PgUbx8kD1gY0I6QntIN+65p5B4CRPhxHAEZgJ49XTHRUYxmF96U0VICWgqPfyQPWhVwmkBwppCPfxeAJkcAk4LRiWB56rZEy8udfv5O5daFGjgkQEoydRHfWpHTwrvdNSVe3wTR66Rw9CHk+6HdyX4vu68FaVyhBWX2XZbH8Ac0GUtYkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "305.66 /",
    "Friction Factor": "0.028316",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2480",
    Length: "133",
    Mark: "502",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "40.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "14287.21803",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530102",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.41708664",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1zMEKwjAQBNB/2XMISROqrSdRQdBDKYKH0kPUpV2IidQolNJ/N7T1tjPz2GqA4kaX/oWQw8nfqMR7MK6xCAwKTy68Ia+G+YxEZzxRKtlIofh6JVMY67/bdp3pI47FnswTA3aQCy4YnNE1oZ2CVAxKH0wg75b1So95lFKnDI5ITRumLHTC4GDxu/CMZ1pGsvPWx9/uY+1Y/wDvsrBCwgAAAA==",
    Pbi3DGeometry:
      "vxAAAB+LCAAAAAAABADtVk1PwjAY/i89z6XbutHCyaiJiR6ImngwHCAs0GRuBqcJIfx3yxw4Rp+1JRw8LAS2PS993o+9X28bMp7Jl/VHSobkoZjJ5yKTc+KRcSHz8pMM3za/t0pMR+pDtt4fchVQOqp+1JdsJ/tj16vVdK3OMuGHLIm8gEa+oDxWNz6NaOw1BXwQJJWAxfxIIMJo4AlfCHU5OhCIRIdXGhQeJ3Y8kB8ZhBRDfEekcKYuNobyiHEtDnjOskfr2E5x891EUViHiIom0wGnCass5eII51HCtfhBcyhOiXaCkNtpRhqgRfvYsdjO0jBkUK/OUOxalwdaJiSwjQV8z9BWmADGzIBuu7vXDjlKY0hkzHvoHdKALEIF2sKtksm1fBpJjBqDVWLoGoll4zHZAztwCzcVJypmiLcKBHV4xGOcFJaTxWgPmoEnAqsGrO0VSIBrH3WLEyrzxIb+dQUWBsRhFHZmnlXEzx3m1s3FrPlC499903Lv8s6LwcUWgIsNetcFwH3gwROuY6EzeP0C0C8A/QLQLwD/bQGYeORWTt/TMl2RoYI88pjmi3JZPzwV5bSURV4/vsr5QXSfysWyrB/usvS7+cebIisUYf6VZdvJD2HGWxC/EAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1175",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "13.3",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530103",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.36626894",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjcsKwjAQRf9l1iEk9GFbV6KCoItSBBeli1SHdCAmUqNQSv/dqBXc3cfh3nqEsqXjcEMoYO9aqvDsldUGgUHpyPo7FPX4lQGJcx5LIZdSRDxbyBSm5set+l4NAQ7BhtQVPfZQCC4YHNBq372NTNKIQeW88uTsXJ/o8t/ukHTnPz5OMgZbg88Zz3kejhmsnXFh3D6MmZoXbhSnr8MAAAA=",
    Pbi3DGeometry:
      "zx4AAB+LCAAAAAAABADtV01r3DAQ/S86u4v1bW1OJS0U2kNoCz2EPWyISQzOumydQAj73yt/NSuhJ9t76EmEDfZoPPPmzUijuX0jN3fVz9ffJdmSr81d9aOpq3uSkZumOrR/yPb2bXi0y/mV/SOn7F3ygeb5Vf/P/shpN3328Xjcv9pvhdlwpnRGc74xVBb2YZNzbbLzhSI3NDMbY7h25UzL8AdwQVPVL0jFsmW+O1PWtzByEabe0Bp9LlbZQfpRPKHAINCOIivnlMWIEFJwx459duST/iSnOXWA+vq+Hc2Ug+dC+1xJE9WfCPX1fTxz+r59FBfiYaV9LnSQH4TfWpWOPpM0Wg+X2kH1Awt6YaGbwjhyySLitdmFbKJokR0kR9GCqFQhnCIpmLdJvVMJFcmsndjJGjockNxLOqINymeKefFmB/FCfoAcxQvwCzbJ6aCvhR7kZoxLMN2fwjkXvaFCTI4F7Reo0dHjDXngjI3ygp/rDw7fkQ79DgJCfrkxZ5np+4hSy1oqbsId1D5muxdiWUMkwfKdLXfPM2QVHdKIbZg1RDdyjAyhbrg2zWH9BVn2kokrG5lCIaOkwT0Oy2i+XPyKRK4RVLhrIRvQ9TxYf1/N5ghf9Zh0qn4grpMXfTNSRfROKqhmkwMxRJcPhhQf+es05+8+qNtBv2Gcgo9uDRNuVwD6CA4kDtYwZALe9gAkaAh+AC404P6DzguUMXCOQKbDaDD6uYrzKxTRA3Ai/QsyCTwA4mANYUgg5jQGpzE4YCeNwWkMTmNwGoPXbfY0BqcxOI3BaQwOl0sagwdm0xgcJy6NwWkM/p9j8C4jn6r9U9mWR7K1oox8Kw8P7eP48r1p923VHMbXX9X9v6UvZfXw2I4vn+vy5Vzxuqkba/DwXNen3V8/ldbczx4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1176",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "202.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530105",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.43575006",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjV0LgjAYhf/Lez3GpnObdhUVBHUhEnQhXmi96GBtYSsQ8b9nX9DdeQ7P4ZQj5I05DFeEDHa+MQWeQu1ai0Ag98aFG2Tl+ImzIlIqOOMLzmKqFZcwVT9v2ff1MMtzsTb1BQP2kDHKCOzRtaF7AU9kTKDwoQ7GO8g4TRRTqYwjqVKhUykJHM35X96iabvwZpFoAhuLj+9aUx6xhMDKWz9/ubu1U/UEFtcqgtIAAAA=",
    Pbi3DGeometry:
      "Ox4AAB+LCAAAAAAABADtV8uK2zAU/Ret3aC35MyqtIVCuxjaQhdDFhnGzBjcuKRuYRjy71X8SGzFR3JmOyIkxCc3R0fnXj3u3Qu5vS9/PP8uyJp8qe/L73VVPpCM3NblrvlD1ncv3Vf3M71xL3LIzsg7RulN++He5LAZ/vZ+v98+u//KfCW0yjNGxSpnymZ2xbUWmcOl4brFrWF6jCspZuMRzijrcCHZCIfjDjyWG7VAz4lnabw0V/Gg+Kgeb15Q5+CPpTlb4MOJx1grHM6EtZN4Hx90DrgN0wxyBpxT9Qp6P5xzwyduhtVEwiE7mhTw4Dp23xoulQqJH2W2hZWrk1ChXUeD6iZKv7C+z3hrTe4WbxxdllVkZMywSLYvcDjTsfbzOta0jeZSB/chVB2IJ7aPIv6l+0S0PGZh3/rYrLwlEjPNp4nheLIT9VryDlbcHNWYHhd5H25Zq1IL2dEPGc/NMZ5TOyvntE8g/iPfOF7TfCpTHlFFRVgNGPV0QjKp28rs48HJCU/aQaXNhZk9qfxkAXdQxSIeNC5yE9QUMhnZhmxGw8bs90+865I7H41Si1IYY/d5YhajzQhY72cwtn7gndGvEJQSwB9bQRd3RsCDVhCwE97dlDZz/gjF+5NG6m5e0obvmLrf7pz/bbzq4t3TpALz2YNvqNjY0ewNikQqwyfsqh8VxSM16CIPTQYmIH6oB/DEkgIugdNbAdgUQKbmVz90GCiBiUI4qEpgDBAZi16YPsAeqeyLJgnlFE01Na+vudyn5jU1r6l5Tc1ral7nTEvNa+DqnZrX1Lym5jXEn5rX0HUmNa9BntS8vonmdZORj+X2V9EUe7KmK5qRr8XusXnqH77VzbYp613/+LN8OP30uSgfn5r+4VNV/BsHfqir2hHu/lbVYfMf5z1DwjseAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1178",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "202.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530107",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.3224861",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkJa2knkQFQQ9FBA+lhxZDG4hZqVEopf/uSmtBL9529g0zk/eQVfbU3QyksMfKZui6Gj0wyND6cIc078eTDDLmsdJqKYXiQkYLGNgXTCKt/0Ni6hfOsSMsPvWrti072kCPjS2vJpgWUsEFg4PxdWgmccRQBkuzR3m2lxntjK2b8BYUHzHYOvOcvJprJRMGa3RIsf7h3FC8AOBr4qQSAQAA",
    Pbi3DGeometry:
      "fwgAAB+LCAAAAAAABACdVd9LwzAQ/l/yHEvSX1u6J1FB0Iehgg9jDxsLW6A2UqMwRv9301ltU+6WVMra5bvr991d75LViSy36uX4LklBHvRWPetS7QglS60q80GK1ennrzWzhb1IQ3vkijO2ON/sjzTr39eu63pztO/yLMpSkVLO0ojxORWREMmMOvCsRVOeu2iSxC2e5XMaQtK6c2afLBuzt3CauTQ8jvmEYBBRNKEpkhdCAWlYLsBMzwaoYmBKI9U8FgKqe48PWXrUqcDQeRC6yz0I3UuDsgOhYAmhiSIxwprjqvto/hENlJP7Sb2FQYcgpH8DaEINSHWQ1vZ6o+xhsuhH9I3aVJpgA9YO3ulE/VGBQGWs5abuXn6eMBweDHhP8/hizEGK2L7oOzCmcYThyPh7x/nCiQmR97g9zW/V5k0aWZPC9hAlj7Lam0O3eNJmY5SuuuWr2v2Z7qXaH0y3uCvl19DxRpfaElafZdmsvwF44JkpfwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3032",
    Length: "25",
    Mark: "503",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2968",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530108",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.99118309",
    Cost: "0",
    Pbi2DGeometry: "CQEAAB+LCAAAAAAABACtjksKwjAQhu8y6xCStrZSV1IFQRdFBBelixRDOhAzUqMQSu9uoNUTuPtfzDfNCHWHl/DQUMKROqzJBkMOGNSEzj+hbMZZxoFc8UKmyUaKjIsCJvbvqv1it8OgQmTHYIfqrr0eoBRcMDhpZ3y/mDN55TG+O9sr3n7VQaPpI0PyPMsY7K1+L9M1T/I8ZVCRpXjVvayd2g/NFvb9CQEAAA==",
    Pbi3DGeometry:
      "QwgAAB+LCAAAAAAABACtldFKwzAUht8l17Uk7Zqu3ZWoIOjFUMGLsYuOhS1QG6lRGKPvbljrjNnJTjqktDR/Tr78PUlOF3syX8mX3bsgJXlQK/msarkmEZkr2egPUi72/avppjNzkS76Va4YpbPDw9ykW/4Mu27bamfGsizOeZZGjE5imkdFXDBqWkZladKrbGrLWS+mptdSYUQfyygvIDBLEjZGd4yMcu1hc87YKQRWvYycT6DvPOpurmCLnkmtdE/jhPNThCVbKQGCD74t3VodlHGe7NjwTGh/YYA9GP4325dOiljxTOmuArrp4WSjsTAXXgKYgOXUPWIBlP851r6FxI9TGCdARzeEz8u46DFFxrfX8GISQgnYychBdipVCOXiOujzAv93YBVHoCpaBtEajcb2qvkj38rqTWjRkpLGNCKPotno7dB4UrrSUjVD81Wuj133Qm62emjc1eLLDrxRtTLA5rOuu+U3NB9nRUMIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2520",
    Length: "501",
    Mark: "504",
    Material: "Copper",
    "Middle Elevation": "2927",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "319.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2927",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2927",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530109",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.02637354",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkpumfp6KCoIcigofSQ4uhDcSs1CiU0nc30upBBG87+w0zUwyQ1/rYXxWksMNa52j6Bi0QyFFbd4O0GKbTG7ikUcTkkjNBhRQBjOQ3TOIw+oahlMl/OMWW7/qs66reb/CPta4uyqkOUkYZgb2yjWtncUBXOe1nT/Kkzx+0Vbpp3UtwFiwIbIx6zN6YcsESAis06GPt3ZixfAJ++6XmEgEAAA==",
    Pbi3DGeometry:
      "XQgAAB+LCAAAAAAABACVVV1LwzAU/S95jiVp+r2noYKgD0MFH8YeNha2QG2kRmGM/neDNnVNe5OMsrKc3p6ce2/vyfqMVjvxevrgqEKPcideZC32CKOVFI36RNX6/PdXPyYLfaEO/yM3lJDF703/ULcxry3bdnvS79I0ylNMCYtYyhJcRDEtC6zRLM+SS5wmGcWTaIOC0ZTFI5yRMpxl0JJROoovWLhEQ2JLiVnq3BRgmRWeZykLEHhdba0tyyLL52pl4eNoN8dQEoP33YG4Qdz0x+BW+pYYCLflmA4BKZmajzcFMg2oCiQPyn4iZNx855bOFvuIQxL31hSYBg/LfHTgpEFaQsfEl9O13xv02XrcBmIJnH0g3DNCgX4bOIleEwGMAbJzLw8UH3pcQHrm3XgedXM4DWPi89bohTiA56yYitZn9Z3YvnPFW1SRiGD0xJuDOvaLZ6m2SsimX76J/fDogYvDUfWL+5p/XwbeylpqwuarrrvND5YbLlldCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2480",
    Length: "193",
    Mark: "505",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "123.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530115",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.70209906",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wAAAAB+LCAAAAAAABAA1zEELgkAQBeD/Mudl2c3V0E5hQVAHkaCDeFhr0IVtN2wKRPzvLWq3ee99TDVC0Zjr8ELI4OwbU+KdtGstAoPCG0dvyKpxOQORMY+jRO2kUFxsYar/at/3egg0FAejn0jYQya4YHBB11I3BxkxKD1pMt6t6808llFKlTA4oWk7mrNQGwZHi9+VpzxVMpDcWx9+u4+1U/0Dc7GuxcAAAAA=",
    Pbi3DGeometry:
      "XRAAAB+LCAAAAAAABADtV1FrwjAQ/i957krSJrXRp7ENBtuDbIM9iA+KRQNdO1w3EPG/L9bO1ZqvTYawlyJK81363eV6d1+dbMl4rl427wkZkod8rp7zVC2IR8a5yooPMpxsD5faTEf6Q3beL3LFKB2VP/pLdtOf267X69lG38uEL7jkHqPcZzSS+sKnIRVe3UAHJcxFfAKzIGCe9KUMB6fbWWyCS3qNi8iOBtKbowFeETzYo5xFViHSMAyMuJHFORLjcfYu6w8jjKoYmQzrPEec8pJfxPIEp6EIjHjlN5DnNHtDENv5RfwwnkPOuLCLMqAx9GoKEx2rLXojDzLY5gE8XxAnfOyd9QAO7H6wZqpB3UKerjqHJwP8KBzUiw3cqoLc+qVWt+YJYFELpnlhNV3a44DDtYG3dyHqWYg3egGNbsTTKQGWktEZD1K2M4PVlDWOBWRAjW4eC2c0XRoMT9aWUpgKa41rrTerTP9JoG2HSLfXSyi66wuT6wx3lvoLSfqFpNtV0l2FDOx3nfctSevlvJfzXs57Of8XOdf/1W/V7C0pkjUZasgjj0m2LFbV4ikvZoXKs2r5qhZH032ilquiWtylyVd9402e5pow+0zT3fQb9tbDDl0QAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1183",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530116",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.48776442",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNzMEKwjAQBNB/2XMIiW2trSdRQdBDKYKH0kOqSxqIidRVKKX/btQK3nZmHlsNUDTm2N8Qctj7xpR4JuW0RWBQeOPoDnk1fM9AZMJTGc2WUsRcpDDWP7XqOtUHGoqNUVck7CAXXDA4oNPUvoNM5hGD0pMi4900n8zlf92h0S19cpwsGGwtPiee8UyKQNbe+vDcPawd6xeNBy7owQAAAA==",
    Pbi3DGeometry:
      "Lx4AAB+LCAAAAAAABADtV0tr3DAQ/i86u4vesjen0gQK7SG0hR7CHjbEJAZ3XbZuIYT975VfraXqk+0cehLLLuvx6JtvHhpp7l7I7X315fl7SfbkQ3NffW7q6oFk5LapTu0Psr97Gf7a1/TKfsgl+yt5wyi96n/sl1wO07K35/Px2a5laqd5UWSMyh1jkts/OyqMFcxeUGpUVuyKQhhXzlURXgBfmF6sNM/WWe6ArGVZqFWMeqAt+oJvwkH6UT4hxyBR00kF47EwGGWkg8KocOST/iS3tB2avr6PY1/M2LwSXesiqj7F0lP3uSyo++jIJRSCbfBa0UBkAHUtpZ4pc8WiJfAqkHC9wPJdV9aGujFRPCLdlk4QwLCTAAKIgZNh2tow5dRDzr2N6HUeUA+LMLHWGdr/SO7kORyusDRasWu3MnITRAWIkZNB4oZPUjZoGzkUp+D5IJeM9b2VCtnD5KOcd+SsnBUm2regASVGuXb6n1TzXAxHGGQDrdJpwXAUCq3XnJD4RO1I9t6qPJoqEB1YqYuV7RmG4USdF4UZBQ5GGhlGQOHTbVt2g9pLqfVyiNHDQMhRlCq4m2HtLNaIX4XIMmKKtijc09DyIlVnHy2lBt/TeEdkXuVsvF9w058yOo/eKA2n031E5INndADSegxRwdmaC0z4GINmwzSNGK0yzt1eCPQBGxg4WLooDMhdRAgCoQXgfgJuM+HegHIV7hkgxIgI9HSp0v4pTRSaIE2ovTWDQXQQMVw3CB66m8bWNLamsTWNrWlsjXWeNLaG3Exjaxpb09iaxtY0tqaxNY2taWz9T2PrISPX1fFb2ZZnsreijHwsT4/t0/jwqWmPbdWcxsev1cOfV+/L6vGpHR9u6vLXXPFdUzcW8PSzri+H309W0NUvHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1184",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530118",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.52538812",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNI2iZp40pUEHRRiuCidJFqaAMxkRqFUvrvxhe4mzOcYeoJytYcxqsGCTvfmkqfgnKd1YCg9MaFG8h6+sSoUIYFTZMFJRkmAubmZy2HQY1RjcXaqIsOegBJMEGw164L/Qso4ymCygcVjHcgKWaCiIKnCRdFlhecIzia87+81abrw5szliPYWP34rnNME8IQrLz18cvdrZ2bJwBgOebQAAAA",
    Pbi3DGeometry:
      "AR4AAB+LCAAAAAAABADtV01r3DAQ/S86u4sk68NKTqUtFNpDaAs9hD1siEkM23XZuoUQ9r/Xtuxdf+iNvTmLkBC/nX1682Ykee5f2d1D8ePld85u2Jfyofhe7otHlrC7sjhUf9jN/av/t/6Y39Y/7JRckHeC89v2T/3LTtv+a++Px91L/V2hN8a4RHC1EULJJNtIY9Kkhq3VtsW5HaLaqmA0wkUqPZ5KPcDRoj0Nl9otiulJ1gVrvp4iHEyrmKSCxPWGcG71isw9TbpxmWkWFWmWDcLnuJd4wTOSxYu54JLrN7BPw6W0cuDigpiFaEgOUgIGXEc+NUYqrQnpg6IK1eBaGKq7rmNBLUOyr2zpCyqzZk3hlFiBrywpspH2a6nUY5hIdCz9snt11sZLZcgzB/UG4qEPzDD7+vNhuTlC+Nx6OqvZBqFNm9PQOJXuWL7p47UQjRzb4Up28da1Mk2qfDzPPO5MEy95FtRzPiYQvzFmFG+4G+tMfVNpnpJ60Lrn+1CkbW924eCahNeql9mkK0XwhpqUC9kT7lnIAlZFZoKeQh4jz2DNwbK09/Pb7traonhQW1TDJfoJDW0yOo6A+YEakhuIeD2c9gjaWICf3kCBzgc8aAeF3UQvbdq5kDtGd6Yp7ZNSGflOqTvUyjZa+2hXOzLqPxe69fp2Xb6a7QqFho/3gu7WROFhKeBtHXobzh/liaSEWchSgPe++csAOAtQjdCex/4COUA8gEE3AmuwyIX4dfWD9GRfhwYjUFiYLX0Axfk0zqdxPo3z6fUljfNpnE/jfBrn0zifxvk0zqdxPo3zaZxPr5pPtwn7WOx+5VV+ZDd8wxP2NT88Vc/dw7ey2lVFeegefxaP548+58XTc9U9fNrn/4aBH8p9WRMe/u73p+1/RKQUOAEeAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1186",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530120",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.55937682",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfFlDHXTlFBUAeJoIN4UFrWgW03bAtE/O8tqUF06DTz5nu8N3kHWUWn9iYhhb2tKLO6VdYAg8yScXdI825YvWGGPE5CXKLgCz+hZ18MhZj/YwniD5syB1ZM1aumKVvf7w8bKq/SyQbSgAcMDtIoV4/iaF3pyL88yDNdPmgnSdXuLeIQGWy1fI5eweMoiRisrbY+1jy07osXZ4cDbA4BAAA=",
    Pbi3DGeometry:
      "PQgAAB+LCAAAAAAABACVVd9LwzAQ/l/ynJXUNm3SPYkKgj4MFXwYe9hY2AK1kRqFMfq/W2ura8jlB6Wl+XL57svl7rI+o9VOvpzeBarQg9rJZ1XLPcJopWSjP1C1Pv/+9tNk2T+ow//IIiVkOXz6F3Wbadl1225P/doFTQp2RTHlCcvTFPOkyMscX8AlL7gD5mkRYs1K9gMXnAaQAEpYOhhnLAvwOHGY1JRkFiGQRzsJJHvQVxLCAqg9Wx9hynlqsTbhkXuCDZc+kvnZeLghl7Oz8QiB4PnZmNaG7Hm0PXuEOKKiDYXVHT8zd4BKiCMJgu2Rsmer29aTfkEnAxVkjDiAIggGsgxoDD7rqHzyJLbZdOIEujuXG7ZXr73femzjKt3KDHXyCHGey8oNAwXtK1H31Qa3z/4uvpXbN6FFiyqSEIweRXPQx3HwpPRWS9WMw1e5/5u6F/Jw1OPgrhZfl4Y3qlY9YfNZ193mGyzoxQU9CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2844",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2853",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2939",
    Length: "25",
    Mark: "506",
    Material: "Copper",
    "Middle Elevation": "2853",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "114.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2853",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2863",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530121",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.32154218",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjs8KgkAQxt9lztui2Ypup6ggqINE0EE8KC06sO3EtgUivnsDWk/Qbb4/zO8rBygavPQPAxqO1GBBtm/JgYCC0IUn6HKYTi4slFRJmq5VLrM4h1H8O6q+2I33dc9sNnZY300wHnQkIwEn49rQzeJMoQ7Icyd5xdsvOhhsO2bEMkljJWBvzXvuZnK5UmxtyRK/dS9rx+oDQHyl8AoBAAA=",
    Pbi3DGeometry:
      "EwgAAB+LCAAAAAAABACdldFqgzAUht8l16nE1Wi0V2MbDLaLsg12UXrR0tAGnBkuG5Tiuy9zbg16kmNFFPPn+OWPOTlZnchyq16O75IU5EFv1bMu1Y5QstSqMh+kWJ1+X203W9iLNPSszGLGFu3D3qRZ/312Xdebo/12xiPORUZ5HmV5mtM8SllGf9Q44X5VJHGMxjKetLExDoAtzNO0VUUm0ME6Qo+bZvnQAjwYDIDtdsYEZ3OUG5xwYDQRXSWcD2bsyO54w+g+xFkNHO2R3QXBjXhkZ02GwX3X7p/G5+iBeOQwpG8bzWYPGQ0GwcHVGvmT4CwdwZiW/h4XcKbD6ggELsP5FaoEAcKkAhPMcLjs9FScgMuezQoX1RGMadXa4yJ4ugTAk0sXvKFCm/qSAnB2bE/YW7V5k0bWpGARo+RRVntz6BpP2myM0lXXfFW7/657qfYH0zXuSvnlBt7oUltg9VmWzfob5vECyBMIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "415",
    Mark: "507",
    Material: "Copper",
    "Middle Elevation": "2834",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1869.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2834",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2834",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530122",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.79130159",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfFFSZXO4UFQR0kgg7iQWnRgW03bAtE/O8taSFdus2b7/Hey3vIKjp1NwUJ7G1FmdVdbQ0wyCwZd4ck78fTGxYi5BKlWGHMIxkiDGwGkWMc/2US8YfNQkdYfMrXbVt2foF/bKi8KqdaSAIeMDgoU7tmEkfrSkd+9CjPdPminaK6cW+xDJHBVqvn5JVcoIgYpFZbH2seWg/FC8ytWXwQAQAA",
    Pbi3DGeometry:
      "VwgAAB+LCAAAAAAABACVVVFrgzAQ/i95TiWxTY3tU9kGg+2hbIM9lD5YGtqAM8Nlg1L870vVrdn0vIgo5vzy3edd7m5zJuudfjm9K7IgD2ann02u94SStdGF/SCLzbl5dZ/Z0l2kolfLhDO2rB/uJtX2Z9uqLLOT2zvhcSSF5FSkkZxxTmXE5yylvj1J5+mAPWaCh+FlIi92OQ2igeRIXrMLngR5bWm69IJNe9SAXgEaUH2tMuazOIgeCUJjF5FI0y68Y27Yr+Y/TnESL00oNeTRyxGqAzJ7CeqA/4v2w43+IcQxKtZgJofCN3x8AuD95LjL/kgB5xXXAZCEwHElUMGOyfy4FEO9AD+BwQ1lEI4rGe5Ko0ontPz622xAZeO9OgSOKkHGUlhLGtfWoAmGd8zgMXiBuyl9q7M3ZVVJFixilDyq4mCP7eLJ2MxqU7TLV73//XSv9OFo28Vdrr584I3JjSMsPvO82n4DxzaCV1cIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4503.82 /",
    "Friction Factor": "0.024878",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "2213",
    Mark: "508",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9964.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "25110.60096",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530125",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.38215162",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wAAAAB+LCAAAAAAABABNjMEKwjAQRP9lzzGk2kZbT6KCoIdSBA+lh1SXNBATqatQSv/dqBW8zcx7TNlDXptjd0PIYO9rU+CZlNMWgUHujaM7ZGX/jUGZJDyZSblMUr6IUhiqn7VqW9UFNQwbo65I2EImuGBwQKepeZcoiiWDwpMi492IT+byT3dodEOfLuIpg63F56inXIo5g7W3Pny7h7VD9QIde+EZwAAAAA==",
    Pbi3DGeometry:
      "yRoAAB+LCAAAAAAABADtV01r3DAQ/S86O4s/ZEvanEJbKLSH0BZ6CHvYEJMY3HXZuoUQ9r9Xu5ZbefxGjm85iJAQv5198+ZDI8/di7i9b749/6zFVnzq7puvXds8iETcds2h/yW2dy/Dv/bj9Nr+iFPyH7nK0vT68sf+itNu/NrN8bh/tt+9KjelMVlSmo1SqkjMpqpMmfiwNtUZNsZHtdTlHGVsM2NBlWX5MoOuUhUQIdMsWZY8UlNrTMK45JSEXaLIq1zBLFEdRHVRVb5Dq+aMVtWEw6HOdtTs0FTlPvEUxQzYG2HAGpQuvJiDErAzGIS0eeZYiYCgL5IaHAIOl2mIUhofLnF7j9XUUvodkenlPmHamMKMjmDpCBoWR/zBOmOGNRqYMHD5nPHYQCT39IDhYi9whKfhK0fLtK44SRiFWQ4efnKamPCCjU9QJjgsOFcDmtpPLay0RhxuPhaydOjFNhv85dkgWRegMWggq6LGzFiFVH7tjMrnFaV3Gb73OLS4SNNydSaYyb0iCqZIuW97fuIGLzJkZEFTxj9mwGlkKIJVo4d5aXxMKsSEh2XgYnAtDI2xCtx/4V6dvpOMiotCgdzTW3OQpuVEWnAY08nteliXEhTVomp+Cog7hnjh4mVe56YOmWTgzOEsY804neFcTL1hXhhG6OVopgAcR+7OhQrWxMCklyHGxswEC0wgGjLmhQxxB4o7UNyB+HDjDhR3oLgDxR2Iv8viDjSXFXeguANd4LgDxR3oLe9Au0S8b/Y/6r4+im26SRPxuT489k/u4UvX7/umO7jH783Dv48+1s3jU+8ePrT1H9/wXdd2lvDwu21Pu78+/8vryRoAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2853",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1188",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530127",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.56670564",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yim7q5TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRGcc8FWLOJc6phKn5UYu+V0NEY7Ay6qKD7qEgmCDYadeG7mUoZQJB5YMKxjsoKOYZyaRIE5FJlksR24M5/8MbbdouvD1hCYK11Y/vOseU0RTB0lsfv9zd2ql5Auk6w2jQAAAA",
    Pbi3DGeometry:
      "OxsAAB+LCAAAAAAABADtV01r3DAQ/S86O4tsSZa8OZW2UGgPoS30EPawISYxuOuydQsh7H+v6tWm2uk82dtbQYSE+Fl+em9m9DG3z+Lmrvv89K0Va/F+uOs+DX13LwpxM3S78btY3z4f//Wv5bX/EYfiD3JVSnk9/fG/4rA5ffZqv98++W+vzMqoui5Ms7LWqsKtKm1M8RuWtppg19QM7LQz86N1Y6bBZbOAIuhwtbQxXNclpwOoDqMpd5qETpmGQaDolNYpxjsQAmQ3TRnNWHrGGA0cZaVjOKgmgwNzaZRhOP6C2QlP6siESMfReKXrJTr4CXkrE3GpSy4alBjMxzMjJ8Q3KA+jmxiWQR9IrdM6ipLy38wWDShqCgMd6SRSmJeXLlOScZ7iMhkzXs6zGAaf1idJAF1yIOeAJL3dgOVMYT67fJzS0WPXFihfsraAwRkOAgODvOjKHlHp33odVtnUAaO0CfAkWrpzHWpazrWrlpi5zPk5Na9DuibagxqlZ485cIBSuKoCrNQ/RwNshRc4QbkyUV7L2jIb/ct+nBpKlbFjgQRAgcIJao41DRY3qBeQKaAPCOFzgjYfdjCvA9Qi6xvcXE6SlbJMAuiJGsQ5zVUov0Oj7dzoOi7nYNDD59cwdkJADWBwhIMZQUDQVZivsWSYwC2FBARdnFlq4CV5iaI62PWJQpo0uMwJCDQwCLLChj+5gRHXgJilyM1Tbp5y85Rykpun3Dzl5imGc/OUm6fcPOXmafbSnJun3Dwtd/JfNU+bQrzptl/bsd2LtVzJQnxodw/jY3j4OIzbsRt24fFLd//y6l3bPTyO4eFt3/6MB74e+sET7n70/WHzCyIAzNA7GwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1190",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530129",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.37455604",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkTeyfJ1FB0EMRwUPpocXQLsREahRK6bsbafWi4G1nv2Fm8h6yCo/dVUEKO1thZnVXWwMEMovG3SDN+/H0hhkXNGIiWkhBeTxPYCC/YRCG8gvGPJZ/4RhbvOuXbVt2foN/rLG8KKdaSBllBPbK1K6ZxMG60qGfPcoTnj9oq7Bu3EtwJgMCG60ekzehiWSCwMpq62PNXeuheAK5u8zbEgEAAA==",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACVVl1rwjAU/S95jiVp02r0aWyDwfYg22AP4oNi0UDXDNcNRPrfl7nWpTbHpBRLc29y77lfJy6OZL5Wr4ePnEzJo16rF12oDaFkrlVZfZLp4vj3adRsZh5S03/JiDM2O73Mj9TL9tjNfr86mLMjnkTjWMRUJBGfpJJyFrFYxvSkkGN5VshIpmlKewdsOdqfcW7LBUvC7diAJjzpGJKxCAfaicxG9KsQwmGpcwKaQkEw6YU6ONkux3GWCVf2enJ7f5ChJkmt/Fw25ADI26q18stU9AFBhY2oUzYYG5NO1yjkoBxBrCgZQxE59vf6CIh9AQxobJhsODy+8lzv4TDnvt6AqOCsw5pen1EXMV1WFRGWbySg5x7WoOFyDCNChPgK9ffQO6BHJuhu8JAP8htMYh7SQ3jQHYaYJPjuBLRwdfoRiSCnFkjzT+BOrd7zKt+TqeknSp7yclvtmsWzrlaV0mWzfFObs+ohV9td1Szui/zb3nirC20Mll9FUS9/ANVeBmG7CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2936",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3031",
    Length: "25",
    Mark: "509",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2967",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530130",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.64766165",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TksKwjAUvMtbx9A0JdW6EhUEXQQRXJQuWgztg5gnMQql9O4GWr2Bu/kxM+UAusFL/zBQwJEa1GT7lhww0IQuPKEohwnGwEJInish1pnkMlvlMLL/mNV3fuN93ccPUdhhfTfBeCgSnjA4GdeGbiZnCnXAeHuiV7z9rIPBtosrgqsszRnsrXnP2SVPlZIMtmQp1rqXtWP1AeibUrwSAQAA",
    Pbi3DGeometry:
      "bwgAAB+LCAAAAAAABAClVdFqgzAU/Zc8W0nUqbFPYxsMtoeyDfZQ+mBpaAPODOcGpfjvy6ztoss1tw5RzMnNyclN7snyQBZr+bJ/FyQjD2otn1UhN8QjCyXL+oNky8PxV3fTuX5I4/0iM0bpvP3olzSr07Drqsr3euyMhX7CE+5FoR+m8ZXHfU6518JBFLQwC7gNxkXTI3XEEwTHSciAI2bsBw54EiNmtK8mZSGzKQGmdKRkAHcCI8pSBPdFuntTpn4Qx+FfFhM3aWzxQ9zYIAw9hJt7ZJMDyRzgvW3CLMtMPWa5EI8rbUj9iPMOqUSE28kdO4jNGHCIMTSTKwTSAtQCAGNYEDh09lzWMUYz1ZecdQCYRx9GsWBwqLoBZ8bQTLZ9SIvjuhoh/4/vAcU3bgOXmcZZub69b2X+JmpRkYz61COPotzWu67xpOq8lqrsmq9yc+66F3K7q7vGXSG+zMAbVShNWH4WRbP6Br6iDOtvCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2425",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2425",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2520",
    Length: "501",
    Mark: "510",
    Material: "Copper",
    "Middle Elevation": "2926",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "319.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2926",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2926",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530131",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.56519018",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdl1aFNO0UFQR0kgg7iQWnRgW03bAtE/O9tqEF06DZvvsd7L+sgLenU3hQksLclpVa3lTXAILVk3B2SrBtOb5gFEReIuMSIo5DQs282l1L+Y2Ec4g+cQgeYT+Wrpilav8A/NlRclVMNJIILBgdlKleP4mhd4ciPHuSZLh+0U1TV7i0CgSGDrVbP0bvgQSRiBmurrY81D637/AWqjvM8EAEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVVV1rgzAU/S95tpKY1K8+jW0w2B7KNthD6YOloQ04M5wblOJ/n07nttTrvSKKOR5PDvcmJ5szW+/M8+lNs5Td2515srnZM4+trSmqd5Zuzt1r85mvmovV3i+yEJyvvh/Nzertz29XZZmdmn8XQvpcKeUp6UsRJF7sCxUK7x8eh8sJPBBJTOIrLuIWjyVNBrKjkqjFJU9oNjudC/0gicIxO9C0gAxov7MZyOWoDr2azrxhFEVjfAcf9AfcmRfTcbqFykO40y3UDoA73XLol1Vwqo9WDdKZW32gu9PVRBcVxgfkibNCRYOWMuoe0iHyUT/QVpy7GGY2HUgM4tKk5Q5GR7wg6TVzW9FDBMpk4u5Hs53IR/1MH2X09JqZgsDRR8xY2gHa0pvz/cZkr7rSJUu5zz32oItDdewHj7bKKmOLfvhi9sOnO20Ox6of3Ob68y/x2ua2ESw+8rzefgFRKBfckQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2384",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2480",
    Length: "193",
    Mark: "511",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "123.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2416",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530137",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.02468408",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVELwiAUhf/LfTbRaZrrKSoI6mGMoIexByvZBNNYFoyx/55s9Xa/w3fOrQYorvbcPw3kcAxXW5pb1L5xBhAUwfr4grwa5jMpC8qwFJSuOcNUZgrG+u9tuk73SU7BzuqHiaaDnGCC4GR8E9sJKENQhqijDR5yipeSSCVYJqTiKyUEgou9zy6lPOHB2KaNExOeIdg78/m1FVacpL1tcCG98m/nxvoLEmPKadEAAAA=",
    Pbi3DGeometry:
      "sRAAAB+LCAAAAAAABADtV11rwjAU/S95riXpVxp9GttgsD3INtiD+KBYNNA1w3UDEf/7Yq0znT2aiA97KKI05ybnJjf33lNHazKcytfVR0b65FFN5YvK5Yx4ZKhkUX6S/mi9e9RmOtAfsvEOSI9ROqh+9JdsxvtlN8vlZKXX9ljoc8GFF4U+S2PhMerTQAReZUgYaxiiKKoMKQsPBuELEexwTkUrbDrQeBzHJ2kgPdoP8gtgk0bjEQ1PbpMHUdCKI57Ld9M4lOnWvJaUaUdbAw/+hDkWJh7zpCZKwlZ873mLV55ZckxUeeZnPCMPaEem523k9H2f5GEsPevX3Cg8mtUJGkzI4BwLeM/wGlACYAOmcj0eDDnIYsiD5qMjgPkwA0BtItwmk1xrx8xg1BNssqIx37HnoP2gnoZwyAMqGeCoOmBrhzxovqukoJ6JtA8ZrLpvowKgAVYrbBVnqY5XwGNYBBYGxCYjbTLPKuKuMu7aWqDfK+m+8+uVe393fiW4nvRfS+Jdpd9d6uAKV02wCl4n/Z30d9LfSf+/kn79//9OTt6zMluSvoY88pQV83JRD55VOSmlKurhm5z9mh4yOV+U9eA+z77NibcqV5qw+MrzzfgHUAjvsbEQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1195",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530138",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.40872567",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNITJo0dSUqCLooRXBRumg1tIGYSI1CKf134wvczRnOMOUIeWMOw1VDBjvfmEKfQu1aqwFB7o0LN8jK8ROjMqMMS0HpgjPMuJIwVT9v2ff1EOVYrE190UH3kBFMEOy1a0P3ApoIhqDwoQ7GO8goTiSRSrC5kIqnSggER3P+l7fatF14M09SBBurH9+1woooBCtvfbxyd2un6gk5Vf6k0QAAAA==",
    Pbi3DGeometry:
      "WR4AAB+LCAAAAAAABADtV01r20AQ/S97Vsx+aT+cU2kChfYQ2kIPwQeHiESgWsVVCyH4v1eW1ook79uVA70tJnY0O3oz+97sx9y/kruH8vvLr4Ksyef6ofxWV+UjychdXe6a32R9/9r/2w7T6/ZDDtmb5YpRet19tX/ksDm99mG/3760714xsTI055kUK66UzBhdUaFUdhxQ1qhhwK6s5bKza6as9wU8oBibDOTSZsHYE6g2tjQ8mNMEaIk/FxfhIP9F+YwnhgJMKGrt3NogESccYYU92unUfWY+pSmk1SMzAnG5SMb5u7EHb5rn45COSJTJIm+E7Z8OmvxF2IM+RvN43m/e7e9RTWHC5XUZDCqWGPzSqh6oEaZLJ6d6mX2RqIDKGGdIbL8ZTXWe+lAc1BzNhvHgsgPVAVAW7aAe9MWbQ6w+oF17FzaY1FTVCGNzscNmONN55tTBqN6uhWNScNbbrej2WXrKRuSdncu8szMzpX6+5SF8qnVn18x4alUY3qWvXDXhdPxRTzDCuYtchA9MfMS6RIcB1k48KBcgCNUswkFxEaPouABEA+IQz0jGMP/zg+5SdZE/lBeqGItwhhRj2b8hAfLPRYwtI3hpPCsTJAwKEFlJnhsjQoJrCZGKL29MSi9Phpn+MMp1V19Kx66Z0vT+qvO31vFtRF+QVMTvNbHT+CwoSpKJXhst2BgeuYNs4FUe0+wnAQWA+QCYiCboOjhjE+0RXqXQToAoBqlAoZAdlSUqM5RmzH+phHBHDNa3p1lC0sIJp1429bKpl029bOplUy+betnUy6ZeNvWyqZdNvWzqZQN7ROpl3xHgP/aym4zclNufRVPsybo1ZeRLsXtqnt3D17rZNmW9c48/ysdh6FNRPj037uG2Kv6OHT/WVd0C7v5U1WHzD/xoucRZHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1196",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530140",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.66664857",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomjZp40pUEHRRiuCidBH10gZiIjUKpfTfrS9wN2c4w1QDFEez768ICrb+aEo8Be0ai0Cg8MaFG6hq+MRJmTFOpWBsnnDKk1zCWP+8RdfpfpKnYmX0BQN2oCIaEdiha0L7ApYKTqD0QQfjHShGUxnJXPBYyDzJciEIHMz5X96gadrw5iTNCKwtPr7rjLI4SgksvfXTl7tbO9ZPE4NiPtIAAAA=",
    Pbi3DGeometry:
      "VR4AAB+LCAAAAAAABADtV02L2zAQ/S86e4O+P7Kn0hYK7WFpCz0sOWRZs2tw45K6hWXJf69jK46j+Fl2Cz2JkBC/TJ5m3sxImvtXcvdQfH35kZM1+Vg9FF+qsngkGbmril39k6zvX7uvzc/0tnmRQ3ZGbhilt+1H8yaHzelvb/b77Uvz3xsmVpYqnkmxElSpzK641iI74kYzdsQl43yI9/ZOuFk4F7rFpTOj9uG6TLsxHuRPbz/T/xPOrVnEc2Uf0wfFFeDa2VF9kA7aGDPgYcLaS7yzv8K9n8zOpOncYZyqf6L33vNGvCHu1QTezDYH7Cgo4ORSdp8pqdS0846rob1ieroSFvJEK2dmBeKOcHIoj5NsEv/L3F7JicKN8QQ4lgGEJZ0bNjSXQbpQIwZlAnliG1i44aF1QdpxmUT0ROUMyj9oIhRutItC2WC4oIsk7+Sk3YZkTrihHb+x7Qamhexwa1jHb8SRh9pRf/o9A/H3MlDR0lPXmfOuqk77pqJi0h20rKUXNM6bR0/RsHisYGcvzzCqTSAOrFnIA5aNaDm+LwcSw0yhjEdWRUdZePQtTS2yR6lFKQT0gAb2Q6Q/w3YGGQQFAp1HBYK8RAUIRUB1D/yE/TOdk/Ds8Opwp+UFLrTHeXvxMNJGLo/W8+vWXAUVyE2LN8tM3mvgUYaWBW72J7fTbVaUXzdmH/qDZEMlG1EhjBaKPEoTDfbymhK71cALcZAr1P1IY+QOChbhqDKBOGhPGzdflsCYBKFkeAQdpwehpkk2TbJpkk2TbJpk0yQ7q/zTJJsm2TTJTq2bJtk0yaZJNk2yaZL9X5PsJiPviu33vM73ZE1XNCOf8t1T/ewfPlf1ti6qnX/8Vjz2P33Ii6fn2j+8L/PfQ8O3VVk1hLtfZXnY/AFX5F+2VR4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1198",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530142",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.33589101",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjk8LgkAQxb/LnLfFMf+wdpIKgjpIBB3Eg9KiC9tO2BaI+N1b1LpEdJs3v8d7L+8hq9Spu0lIYE+Vykh3NRlgkJEy9g5J3k+nMyxwyWM/iFaI3MMAYWA/oIiDbyji8D8cY4t3fdq2Zec2uMdGlVdpZQuJxz0GB2lq28ziSLa0ys2e5FldPmgnVd3YUUR+yGCr5XP2Ci4iRAZr0uRizUProXgBBvxTJhIBAAA=",
    Pbi3DGeometry:
      "fQoAAB+LCAAAAAAABACtVlFrwjAQ/i95riVpO2v0aWyDwfYg22AP4oNi0UDXDNcNRPrfF7VdbeOZr07FYpLLd9/lrt9lsmXjuXrbfCZsyJ70XL3qVC2Yx8ZaZfkXG062h79mmY/MlxVePdMTnI/2D/NjxbTadrtezzZmb0+EftwXwhPC5yLisv540pe7lb2JDELCRAbRwWQQUigxDz3UUShdIIEcuKgQfgT3eRD24YgAuoDJlfgiNoCr0+e7QxHRzdlENmwuP70G4cqVjKNGjiv4ct7CLOetM27bl9G24SkYah6hczJZ1gJFlPJ8FEDj/BEcjBEV23FqINcuqmdKBa9bCx2oZ8DEeWzIm2ltxrlZYZGYZFqupSGkA0QWukhHu34ASXHVKkLNigt5AU5pE8AT6JZtdKCLdmi0lMABHa29tQMxVG4d6vy/tkuAu+8X+A2kXTEdlI4QTzetOh5zl7tXs48kT9ZsaAraY89JtsxX5eBF57Nc6awcvqvF39JjoparvBw8pMnPseGdTrUBzL7TtJj+Ahsc2ht9CgAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3038",
    Length: "25",
    Mark: "512",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "21",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530143",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.11510425",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TssKgkAU/Ze7ngZvqamtooKgFhJBC3GhOIwXprlhUyDivzeg9QftzotzTjFAXtO1fyjI4MQ15Wx6zRYE5EzWPSErhgn6wAJXch0jbhAlRmkKo/iPWX7nt11X9f6DF/ZU3ZVTHWSBDAScldWuncmFXeXI357ojZqfdVSkW7+CMk7CUMDBqPecTeQyjCIBOzbsa+3LmLH8AOFxkg4SAQAA",
    Pbi3DGeometry:
      "gQgAAB+LCAAAAAAABAClVd9PgzAQ/l/6zAgtIi17Ms7ERB8WNfFh2QPLmq0JowarybLwv1sZcwU5e8wQfvTr9et317tjcSDzlXrZv0mSkQe9Us+6UGsSkLlWpXkn2eJw/LTT0dRepA7OyIRG0bR52JvUy9Oym6rK93bthMZhygQPKA1pIkQgQsHsq8GvKW1wxtMOHosGjlPegSGa1pyzQXJBu7hg8Sgx0K4+p7D7+vT0eXhMh9w9wf2gQW5B2zqx5yG7SpLfNC7uRmHI/lu9i5/PCsPiY++rcZ3C4JBKaF8n9hiaS+X03XLPFpI5XBDDoffbYpLef6xQXKDU9rNcXvaQFk85/cGOSAwAxuQFIGak+dgGBGUdptNgeDA4VAVQJ8Pw/KdTQnqAvxQAI1gQMKZRIro5wvwI2//5TOU7aWRFsiiMAvIoy43ZtoMnbXKjdNkOX9X6Z+peqs3WtIO7Qn66hre60Jaw/CiKevkFAdcnF4EIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "513",
    Mark: "513",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4871.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "21",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530144",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.75923981",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjkELgkAQhf/LnLfF1dzUTlFBUAeJoIN4MFp0YNsJ2wIR/3uLmhBdus2b7/Hey1pIL3hq7goS2NMFU9JNSQYYpITGPiDJ2uF0hpkIuOcHcikEF7GcQ8e+oYyjP6Af/MIptof5p35V10XjNrjHBoubsqqGxOMeg4Mypa1GcSRbWHSzB3nG64R2CsvK9kL6IYOtVq/RG3ERigWDNWlyseapdZe/AY+D+8YSAQAA",
    Pbi3DGeometry:
      "dQgAAB+LCAAAAAAABACdVV1LwzAU/S95zkrS2s89iQqCPgwVfBh76FjZArWRGoUx+t/Nulrtx2lSKS3NycnJuTe5yfpEVlvxcnzPSEIe5FY8y1zsCCUrKQr1QZL16fKru9lSP6Siv8iCM7asP/ol1eZn2HVZpkc9dsE9h7leQDl3eMxdGjk88mgH9uP4DPs87OJRzQ5YTG1UarbLfD4m7vIrt4u7UTjHC5h0MiLrSSe9DFW8MBoN9YIPE4Zi6k4bxNFY2lu4p9Li3RT06K35rnrr3aQyKT70AiICMLIIJu2l3SjzHzPDkNCiApOgCkDWAXveYgBttHvtNoaxCOzoRjfTtWS/2IiPcKuTAKmYDg47uskL2nk93LSxER3h6LSaWyBIx5Jv9ANup5mnJ6AD2OoWAiJW9+eZre/wW5G+ZSorScIcRsljVuzVoWk8SZUqIYum+Sp2bdd9JvYH1TTu8uzrL/FG5lILFp95Xm2+AeMBILF1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "206",
    Mark: "514",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "21",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530147",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.92603565",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAURf/lrWPo65D66kpUEHRRiuCidNFqaAMxkRqFUvrvxgnc3eFcbjlC3qjDcJWQwc42qpAnV5tWS2CQW2XcDbJy/EiPzDDiqUBcIHJMiGCqftyy7+vBwz5Yq/oinewhC3jAYC9N67qXQYwFg8K62ilrIEOepEFKIgpFSvGchG+P6vwPb6VqO/f2QRwy2Gj5+K6JU0jEYGW19V/mrvVUPQHeG3Qv0gAAAA==",
    Pbi3DGeometry:
      "XR0AAB+LCAAAAAAABADtV01v2zAM/S86u4Eo6yNKT8M2YMB6KLoBOxQ5pKjRGvDiIfMKFEX+e5XYzhJbT7J7VooENSmRfI8UZd6/sduH8ufrn4Kt2Pf6ofxRV+Ujy9htXW6bv2x1/9b+69T82v2xffZfckWcXx9/3Jft1/22T7vd5tXtvaJ8YcjKjGjBrZGZXVgrZHaU56RPcuILLmjZKixXfgXcoYkuFLkMW1pyYaIxObkWNgtiOHdwvh7YQX5hPFP8QibcBsVNGBgC0DkmZe1BLuwlMMrdvjN5D2C0vrNPSyu9doZy5Le3M/CL4ul5IFrmk+IBfiGuzr7gB83pMwkiCAG6QhABJbEaI+nsObmRFC6BE4VCHORS6nCJITtAHotnKl4YZxTXoDQidubyP8QF89uX3pAHdGRRPSA7U/rvhN4F8x6pEywf8B/DNZO3ya0igncUv9StX23Fsfdy0pHrKe8saUHHDEjVyoVqK8hIMyeTk5lA9lE8PWJpVQuAU/h+DSAGCqHkhYLrD3KEuutsbDCd/Q6jWlYvDYU6P9iJQgbLY3WG7tQx6VGII1JQz8CVBtPqjzUAzp8/fNpR3YCIUC1DLuC7llHGjwG9ZFh/rOhmwDek1t4zYbXxY445RlcVkI9fR5HjGEXwBdaTBpBoSDYiCXmGDhC4CZ0ABec/8jjhMLSZGHE+gAe4IXZXDLsZYiLqYGAnTZNpmkzTZJom0zSZpskQ/2maTNNkmibTNJmmyTRNpmkyTZNDO+uMfSk3v4um2LGVW5mxm2L71Dx3D3d1s2nKets9/iofT6pvRfn03HQPX6vi5Xzh57qqncHtv6rar98BD34bVl0dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1200",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530149",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.28682855",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAURf/lrWPo65A0dSUqCLooRXBRuoga2kBMpEahlP67cQJ3dziXW49QHvV+uCooYOuOulInL21rFBAonbb+BkU9fmRAZphQzhDniBQzIWBqftyi7+UQ4BCstLwor3ooIhoR2Cnb+u5lEFNGoHJeeu0sFEgzHnHBkphxkeaChfagz//wRum2828fpTGBtVGP7zqnmGJCYOmMC1/2bszUPAHyzNCl0gAAAA==",
    Pbi3DGeometry:
      "Qx4AAB+LCAAAAAAABADtV01r3DAQ/S86O4s+LXlzKmmhkB5CW+gh7GFDTGJw12XrFELY/x5nLW9sWW+lTXMJKCEfnh2P3nszI2mun8jVTfXz8U9JluSyual+NHV1SzJy1VSb9i9ZXj/1/3Yf0/Pum+yyV8sZo/R8/6v7IbvV8Nqn7Xb92L17xsRC54xljC04Zap4/crMgkulsr1LQdWLCzOF9NpF9zfC31Cu93YF4rtxLDTGjJjYBcu9eCKoDK+6SwVCziAE7DFquhBYt7RPHQQNUMkLk/shvGAdewwRGZdTe09q5t4vxJRQvjAzewQAC30GAAGz0nCZRyGLQACo9gsxybyKzSVA0oDwiJ+jB6wyaRvJ2qmFCaubCTHWT1AdV3KoS1w7wBPMs8sX4QyUulsXKM7JeEK8pukd3D3NP8uQ08yoMmJCnrDroS3EtaO6gHUU0Bv1LegD3LcRegSbzJUYigDIatrbdcemQ6aFPn5K5oJbe8+EmimeQu33jtzwUym+j07u+gCvNsaM98ZCyLhTHd0aXLtWyuLJ/0c/tFefygvmWYoxX5Zr7yF1ODuC/i5O4I/wwDhQZ8AL6RCxv0TsUiC7ED1CibIYs1GCVwE0WNhIKHSxG6hIJbyJcy4PB5wcFLz/1IGHFJdy0t8DXS6dq6t/WXjZQHZ0aUHrAnmgnLBOA7KhO5qrD5xGgD6AV/Au6aYd9T3UOcA3lhfSH/IF/igvof3P1QHFR/qkATYiZBpgj+wAaYBNA2waYNMAmwZY/xGSBtgoexpgj1/U0gB7LItpgE0DbBpg38Lr4w6wq4x8rta/y7bckiVd0Ix8Kzd37b19+N6067ZqNvbxV3V7+OhrWd3dt/bhS13+GzteNHXTBdw81PVu9Qxhg1mkQx4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1202",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530151",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.09285576",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjk8LgkAQxb/LnNdFc/3bKSoI6iARdBAPSosObDthWyDid29J7VLQbd78Hu+9vIeswlN3k5DCnirMSHU1aWCQEWpzhzTvx9MaHM/nIhLh0om564kYBvYLRjzxPfEFAxEFf+AcW8z1q7YtO7vBPjZYXqWRLaQudxkcpK5NM4kjmdKgnT3KM14+aCexbsxbhIuAwVbJ5+RNeOjHCYM1KbKx+qHUULwAJBZbBRIBAAA=",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVVctuwjAQ/BefTWSTtEnghNpKldoDaiv1gDiAiMBSGlc0rYQQ/14THsFkZ0kU5eHxZna83l1PtmI8Nx+b70wMxIudm3ebm4WQYmxNUf6IwWR7+HTTaugusZM10tNKDauHu8VuevpttF7PNu7fng6DO6217CWB0lEi0+A+TFJZ4VE/vMRj1T/gYejZR4mWHE+0fzfNozhNSHqfJnZvXg6Sj+R09QtwxHO13HSvmojaGW+3rFpOxRMHaeiAy+hXPDXu89S4H4amfSWfoAc0EG8n5yrKTRzJhMvy5Z+i3JLmphy4rKtdueWXlUnkFJdrBA2dgigz2RiggiC2ivHa1Ai9gkh2LU/Ig+qQrU9ix1HdshmC/BI6W2aaX/9ID+riBA/q7mzXR40BtWXCnvXbviGx/avDKUHToLOMO+KI6mfLHHQL4NXT6M73RzP7yspsLQYqUFK8ZsWyXB0Hb7aclcYWx+GnWZynnjOzXJXHwVOe/V0aPtjcOsLiN893039jlr7OkQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2844",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2853",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2939",
    Length: "25",
    Mark: "515",
    Material: "Copper",
    "Middle Elevation": "2853",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "25",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2853",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2863",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530152",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.40879034",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1Tt0KgjAYfZfveg4308yuooKgLiSCLsQLpaEfrH2xVjDEd2+g9QbdnT/OOdUAZYsX/1BQwJFaLEn7jgwwKAmNe0JRDRMMgUgkPBVCrKMlz7N8BSP7j1l/5zfWNj58CMIOm7tyykIR85jBSZnO9TM5k2schtsTveLtZx0Udn1YETzJpGSw1+o9Z3MuF2nKYEuaQq15aT3WH+36uRYSAQAA",
    Pbi3DGeometry:
      "gQgAAB+LCAAAAAAABAClVV1PgzAU/S99LqTlG/Zk1MREHxY18WHZA8vI1gSpwWqyLPx3ywZahGsvLgRCD6en597eXlZHstyI58NbQTJyLzfiSZZiSyhZSlGpd5KtjudX/Zkt9EUa+oM4nLHF6aFv0qz7aVd1nR/0XIf7bhCnCXViN4mSlKZuxOKYtnjIOW/xlDHPxANNa+kpH6CASs8OomRKPPE1YOKB588yAy1rCQq9rsXPSMf3+WS8PT7MGhQWtKyR+8T1gjAcqxj4IAkT/JN5k2/sFULGJv/bziAoDA7ZhNY1c4/Q+a+fUVzG3kI2gRMBJB/BxtS9fWvB1ADljZG54PBDbmyH6i99TIFAOKZAID9z+XObEVCAiJ6DUEHA0GGAOhpC5oJ+CXXA6X/VJIrQsKOYVmnt5wj2GdX/8xuRvxaqqEnGXEbJQ1Ht1L4bPEqVKyGrbvgitt+f7gqx26tucFsWnybxWpZSC1YfZdmsvwCXXr9QgQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "415",
    Mark: "516",
    Material: "Copper",
    "Middle Elevation": "2834",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3939.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "25",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2834",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2834",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530153",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.51135185",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LO6/L6rpqdooKgjpIBB3Eg9KiC9u+sC0Q8b+3pAbRodub9w0zk/eQVerU3SSksMdKZai7Gg0QyFAZe4c078fTGTyfUxbwaOnFNOGBgIF8wzBM/sMFE+EPnGNHWMz1q7YtO7fBPTaqvEorW0gZZQQO0tS2mcQRbWmVmz3Ks7p80E6qurFvEQWCwFbL5+RNqC/8mMAaNbpY89B6KF7C2Xj9EgEAAA==",
    Pbi3DGeometry:
      "dQgAAB+LCAAAAAAABACdVdFqgzAU/Zc8R0nUarRPYxsMtoeyDfZQ+mBpaAPODJcNSvHfF1vnFvWaWEQxx5Nzz70mN+sTWm3F6/GDoww9yq14kYXYIYxWUpTqE2Xr0+VVfyZLfaEa/yEeJWR5fugb1ZvfaTdVlR/1XI+GPgnCGHuJz8IkwcynLMQGHLO0gRc0MfEoZg0ekxS7yFzoAVnQMfmARoGBp4QEc9wAUSdzcg067WWgwlI6mukZHtYLyKgXNIrYaNk7vCfT4WYFevTOe0++M2+TmVQfmAFyglKFPAJBzbLbVK7yMiyv+VMBi9ZN4Ea3FQCiQzi0fh3XhnUfQHxgf0Bhgf86U2WeulsnsHiB+oYT2+IE6ibj63HS93D1AjDUe932hrWFu9GtbqBzaW7jhPgQ7nQCQSpunaCh6zP8TuTvXPEKZcQnGD3xcq8O7eBZqlwJWbbDN7HrPj1wsT+odnBf8O//xFtZSC1YfhVFvfkBBHjSbHUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "130",
    Mark: "517",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1229",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "25",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530156",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.02135613",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAYhN/lP6ch6ZI09SQqCHooRfBQekg1tIGYSI1CKX134wbeZvmGqScoW30YrwoK2LlWV+rkpe2MAgSl09bfoKinjwxIRBOcUUoXEcc5ywXMzY9bDoMcAxyCtZYX5dUABcEEwV7ZzvcvQ2nKEFTOS6+dhYLijBMuWBIzLtJcsNAe9fkf3ird9f7tSRoj2Bj1+K4FZoRzBCtnXPiyd2Pm5glwogUJ0gAAAA==",
    Pbi3DGeometry:
      "4RwAAB+LCAAAAAAABADtV01r20AQ/S97ls3uaj+dU2gLhfYQ2kIPwQeHiESgWsVVCyH4v1fRV2Rp366UW2AxMdF4PPPem/Hszu0zubnLfzz9zsiOfCnv8u9lkd+ThNyU+bH6Q3a3z+2/9cf0qn6Rc/Jq2TBKr5q3+o+c9/3Xrk+nw1P93Q1Lt0JZkWz01qZMJHarNOVJYzdMje3WqsYuBZUuO/RnjI3smjHjjSMl10vwCKoTH/5p/MEfxEF5IZ6FeYEOihvpx4Pwd3mNMvbFTvUlL2ONGNt7/FP/Pr5JrXTGmdpB3iHOJC/E0+vAqFqEB+VFvLr4hut0CS+UF8WHvIAOob4yRvMXu2TWW/dX3ZRu+ocLb1/BOMgewLOYL8IZ5DXph0CctfrPeKH69v028YfzB/QDjLNw3gbnFap7qE+g/VL/IK+Vui2dD0G+E/zCqjavtI1dW/dcHZ1T7XxQyjT+PG3tWrb9IwVfU8fFOqD4AM8wx7Rt8WvrPU89fN12LS/60Ag/Hg9+93mxkheq4+Av02aeS268cx75w/mP/AN9hc7Nmc4hXlMd0HzAfYXq6MaJebnrjn/XqE+ceOA9EPU5ukdxqZ16onNcgD5E9wd4Dirl6v/arp18Q3nReQTs83smyBvQB91L5/oD/FBnpA/IC+MDXuj3jvCguQHrC/Gs4wX1B/GRf2D+z3ghHULxp3Mv7oOL7u1xH4z7oJdX3Af9OOM+uGrexn0w7oO++0DcB+M+GKhj3Ad99/C4Dwb0j/vgm3i9331wn5CP+eFXVmUnsqNbmpCv2fGheuwevpXVocrLY/f4M78fPvqc5Q+PVffwqcj+jR0/lEVZBzz+LYrz/j9IWFWJ4RwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2853",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1204",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530158",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.60605332",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjckKwjAURf/lrdOQ1yFN60pUEHRRiuCidNFqaAMxkRqFUvrvxgnc3eFcbjVB0arDeJWQw862qpQn15hOSyBQWGXcDfJq+kiPBBjRBBEXQUoFFxnM9Y9bDkMzetgHa9VcpJMD5IwyAntpOte/DGLMCZTWNU5ZAznSJGVpxqOQp1ksMu7bozr/w1uput69PYtDAhstH9+1oBhjRGBltfVf5q71XD8BLIZMpNIAAAA=",
    Pbi3DGeometry:
      "zRwAAB+LCAAAAAAABADtV02L2zAQ/S86O0HflrOn0hYK7WFpCz0sOWRZs2tw45K6hWXJf6+x5awz0bOc9lQQISF+UWbevBmNNHcv7Pa++vr8o2Qb9rG5r740dfXAMnbbVPv2J9vcvQxfu5/5Tfdix+wVWQnOb/qP7s2O2/Fvbw6H3XP335VQayOEyFb52slcZW4ttTFZj2tuelwVJogXTi9ab2Te49YVi+x4PoXgdoprJ2zQPuB/Wk/sx+xQvzEc6kb92kKHdEB8IH/t7MSvcOoc9maE1Ge4p3+xfLAujDIhM5c48OpJUq+IzSiC1HYZnbBbFNRgXWgR1ObSOvCKzKOgiAiwkothR4w4H2mijFulpqIpni+rKFT5FEd8YsmlOOIZq2RaDMjOtXwicdH0+uXjhr5IC92gqByAnWijQg2A4ijtsEwicqK9iMqc7EUkW8wMxWG4YfpG8gE3uqeTq3z+HBJKDvjQHBx3hI/qm4B1cllc18pwbh7RMcq5aQ8rlF52jKJjmuLSeFypf5IH9NSr4wJp1IWaxitsHjxBXnt8bD3t/WA95IPihTqD8kQ6oO6AugnII+SJ+KC8wy4G8ovqCtUt0gFdC0f+TtlgXsgZfuJZhOsZNH94VnBtzravD7fDya0QuEX2AQ5vncgvkAfKCctwXjZ4VaL6wNt92D6KK3qlo3xQG4A6R8pkaVxIfxgvWA/yEm1vtPzRdkFtL02B8/suTYELvKYpME2BaQqM3J/SFDiHpylw9nqWpsD5Hp+mwHmeaQpc0vzTFJimwL+K6/+dArcZe1ftvpdteWAbvuYZ+1TuH9sn//C5aXdt1ez947fq4fTTh7J6fGr9w/u6/D1d+Lapm87g/lddH7d/ANG8BM7NHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1206",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530160",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.95059218",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzG0Ma2mnkQFQQ9FBA+lh4qhXYhZqVEopf9usLUgHrzt7BtmJmshPeOxuWlIYEdnTMk0JVlgkBJad4cka/vTG6Tg8TwUi0ko+VQKAR37gpGaqf9QhtEPHGN7mH/ql3VdNH6Df6yxuGqna0gCHjDYa1u6ahAHcoVDP7uXJ7yMaKuxrNxbxCJisDH6OXgVV7GQDFZkyMfahzFd/gICnTVrEgEAAA==",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABACdVlFrgzAQ/i95TiWx0Rj7NLbBYHso22APpQ8tlTbgzHDZoBT/+2LnpulyJg5RzHeX77tL7qKrE1pu5fPxrUA5uldb+aRKuUMYLZWs9DvKV6fvV2MmC3OhBvfIjBKyOD/MjZr1z7Srut4czVwWR2lGYzyjLJozzrCIhJhzbOE84y2exszGkzRtcU5THMTT+lMSEZpkfwVaQ8yEZWBEiEkRQcpjmU0RHg3ITUQyZ85ng2vxgNQulBPBhWsTetzm6XF7KWz/QQa2wCADP9OYgiMiKDMwYzBSQPhyD/xM/wrJmZq1yf4lAjskrLADiEIN4CKBNR8wA9QIFQf31N+J06mCDVB9eJsX9gcFwpShCpx6wAXwBOFQp0DHntcf4g/UhY5P/xdmKk8YDp0M/kYf+9a6+Hvc/AvcyM1roYsa5aakMHooqr0+dINHpTdaqqobvsjdr+mukPuD7ga3ZfE5dLxWpTKE1UdZNusvXIzN570IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3038",
    Length: "25",
    Mark: "518",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "27",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530161",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.57801689",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TksKwjAUvMtbx9BPYktcFRUEXRQRXJQuWgztg5gnMQql9O4GWr2Bu/kxM9UIZYuX4aFBwZFaLMkMHVlgUBJa/wRVjTMMAZFwmUqxWcWCp1mewcT+Y9bf+cK5ZggfgrDD5q69dqAiHjE4adv5fiFn8o3HcHumV7z9rIPGrg8rMV/nMmOwN/q9ZHOeCCkZbMlQqLUvY6b6A26H3KUSAQAA",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACllV1rgzAUhv9Lrq1Ek/jVq7ENBttF2Qa7KL2wNLQBZ4bLBqX435d1uqnzmFNEFPN68uQ1yTlZn8hqq56Pb5Jk5F5v1ZMu1I54ZKVVad5Jtj79vNrPdGkvUnt/yiKgdHl+2JvUm7bbVVXlR9uXh74IGPMWAfc5pYmX+ikLQu9bF7GY1JmIIkx8ZMPO8XESYziQHyZ4o6cpZtyWM+RTHoz6gcaFOJD/1ifjMcfwXfMwOW7ih1yI//PQ0XvjjsQPOb31QvAhvbdeCD+Q3luvkfih/978I/4X4kC6izP0j9r/EB8RD/Fd64idN2g/ozgz8gXyA+UFpKM4CB3ah656MsmZUa9ceQHVsaGO4iB0KN+huo3izDgXID+uc22SP6MeQvnoqg+X1pOOf3ve36j8VRpZkYz61CMPstybQ9N41CY3SpdN80Xtfj/dSbU/mKZxW8jPbuC1LrQFlh9FUW++AKIS/EWhCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "514",
    Mark: "519",
    Material: "Copper",
    "Middle Elevation": "2933",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4875.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "27",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2933",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2933",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530162",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.70282753",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0bfrrSVQQ9FBE8FB6aDGkgZiVGoVS+u4G23pR8Laz3zAzRQ95rU7dTUAGe6xVjrqTaIBAjsrYO2RFP57OwH3K0yRdLlhAI858GMgvyGnAoi8YxuwvnGPLuX7VtlXnNrjHRlVXYUULmUc9AgdhpG0mcURbWeVmj/KsLh+0E0o29i0iPySw1eI5eRPKQhYTWKNGF2seWg/lC5YISM4SAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVVV1rwyAU/S8+p0GjsV36NLbBYHso22APpQ8tDa2QxZFlg1Ly3+ea1CwfV28ICfF4PR6vnuv6TFY79Xb6TElCnvROvepM7UlAVlrl5RdJ1uf613TTpXlIFbTIjFG6vHzMS6rNddhtUWxPZqyIwphxHswYD6VgUbAImaQ3wQge0Zhd8Hgej+JQPI9FB2cimsJj9VDBOviCT5FpaXpyWMzmzmkhHki+lBIh00vjnlaEnMmRrHlxL0+dnha/7haS3+L1brXzdtIwlAPhPTl2t3rybXyd/cG00GohGiTuzbLzzEI0kCWgJA/ocbn3bjlkXDcPFI8vDJAepFW860Iehp6jB+kEjO5mAcLRZcR5vvHFC2cTrx0gd0I11s0DxeNrOKQHecV51zW1egFGxFWFiRffX7i53+/V9iMt04IkNKQBeU7zQ3lsGi+63JZK503zXe1t12OqDseyaTxk6c//wDudaUOYf2dZtfkFYKhsTZEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "206",
    Mark: "520",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "27",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530165",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.77437478",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomvSRuhIVBF2UIrgoXUS9tIGYSI1CKf134wvczQxnZuoRyqPeD1eEArbuqCs8eWVbg0CgdNr6GxT1+JEBETFNeCLmMyYoz/IMpubHLfpeDQEOwUqrC3rsoYhoRGCHtvXdyzAmUgKV88prZ6HglAmWyDgNo7nMJGcEDvr8D29Qt51/+0jEBNYGH9+2pKEQoqUzLnzZuzFT8wS9iehx0gAAAA==",
    Pbi3DGeometry:
      "5RwAAB+LCAAAAAAABADtV01r3DAQ/S86O4tkjT+0OZUmUEgPoS30EPawISYxuOuycQIh7H+vupbT1djPWh8LYsluPBq/efOhkebuXdze1z/efldiLW7a+/p729QPIhG3bb3rnsX67r3/1y7LS/sRh+Sf5EJJeXn8sn/isBle+7Tfb9/su5SuMlOY5ELRSusiMStj7I8nJpMmSq5kqpW3QLKcXoBv6KIsjgs60+dBUSoJkrLynNLkDB+O+FPqAAaZhXRmzMJA2BeyM+kw+jqjU7Na9eKcSg9mkA/qA/tBLjMfnssRDjDLYRCdovBiEGIDrAKn6G8O5uA5m5BZHjTkFYoCKp3M8RzkhbU3l/PSltCpX2R5n1FSqPK5HNEJJZfLQzS5XVAMCGYpHeQWyu6g74qNJ4VvUFQMIZiZTrugS7GUo5ghOQh9qIuwfQhcDW0TLke+IvJp7uQ5qWOLlXqMc9p6tU7dQg9ksrIHkrmTW8WwX8uigMARGcpK/6BMFY1TPnWC4jMXL+g+cOU8J+QDPCWW+oZSqYxfoEWuZzs80IdEkT7ig3BgpBFQOMt+fwg2JT+RiCeigxKGdgBQR3Rg6QbDMLo+fXhgtJ7KzOgMd1St3KMa6v78tBi2ACnr29TZrogm9xI3jAwELwPoPsoNowjBkMIkIBdQrIMx4paRAeRb8GbHGaH9De8EgNBiz1ASoAGgD3MT6nSj3AADCCdOhHEijBNhnAgn6cSJcG6DxokwToRz2nEijBNhnAjjRBgnwjgR/h8T4SYRV/X2V9VVe7G2mon4Wu0euyf38K3ttl3d7tzjz/rhY+lLVT8+de7huqleTxU/t01rAXcvTXPY/AF0dQ1f5RwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1208",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530167",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.12395063",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yi0+m2TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxkRnuCUpXw+oxwzmUmYmh+36Hs1RDgGK6MuOugeCoIJgp12behehlIuEFQ+qGC8g4LiVBKZC5YImfMsF7E9mPM/vNGm7cLbE54gWFv9+K4zTDllCJbe+vjl7tZOzROInJuY0gAAAA==",
    Pbi3DGeometry:
      "dxwAAB+LCAAAAAAABADtV8GK2zAQ/RedvUayZMvOnkpbKLSHsFvoIeSQsGbX4MYldQsh5N8rJ44di3mSw0JPYtnNejJ+8+ZppNGsjmy5rb4ffpVswb422+q5qasXFrFlU+3a32yxOl7+NV/zR/PDTtFoeRCcP57/mF92Wl9f+7Dfbw7mXZXEqpA6ehAqljrXUR4nKk0jY095WpztiufJrT1TOWlH/jJVF3vC1Rwc7aYjVXHrDulf4S1/hIPC0mZvVCSClHOSQuTHsCLr7CKXU5iLORGJmpCfeg/gvdmQo1CudhTUghmCIjKDBL09UZmLDgpL52SBCyVIZYZckQY0OkoJSeCppeyyEbiQzkoda4YXnV1y7aolBIPsPjYzc0UsvVlZZeDFuVN7Ky1yYccas7zRvgSFgHC8Z+vcwwksub9CgN3S3pvWnarNPBH82U7pJ7yPm+cdGy21s/HwK0zOz/7dx5l+Md37mXlt1iLOUgHBIzpjf+RZhyMKOd1Ydt/E6ZJ2w6fnWcj3yAOP0nvzAqs4LHpmdOzCarJtDCc78kc0kb+nqFCTtNX3ZGWJgA4GR1GhRaRpwqzAmsMdjWqEpoNqFtUCui6lFHnUszNQgHQvR/2BF2TVa0Em6osJug8w2/cEOqZTFHjrthUHxOGFCOiC4kJh6JzQ7kZ00C5GlxnE5s6saOkBOOnsO+XthJAATnALJIx2YbQLo10Y7cJoF0a7MNo5FzGMdnTbCKNdGO3CaDen+4TRLox2/2e0W0fsU7X5Wbblni14zCP2rdy9tm/9w1PTbtqq2fWPP6qX4asvZfX61vYPn+vy763jx6ZuDODuT12f1v8ATBDnUXccAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1210",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530169",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.4918438",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0MU1/PIkKgh6KCB5KDxVDG4hZqVEope9usLUgHrzt7DfMTN5BdtbH9qYghR2edYamrdACgQy1dXdI8244vSHiNJYiWcyYoHPBOfTkC0Yxk/+hYOEPnGIHWHzql01Ttn6Df6x1eVVONZAGNCCwV7Zy9SgO6Eqn/exBnvRlQlulq9q9heQhgY1Rz9Gb0EQyRmCFBn2sfRjTFy/KIENQEgEAAA==",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABACdVlFrgzAQ/i95TiWpqRr7NLbBYHso22APpQ+WhjbgzHDZoBT/+2LnpulyJg5RzHeX77tL7qLrE1pt5fPxTaAc3autfFKl3CGMVkpW+h3l69P3qzGTpblQg3tkRglZnh/mRs3mZ9pVXRdHMzedR1nCOJ5RFsUsZZhHnM8ZtvA0S1s8odTGF0nS4imJcRBP609JRChb/BVoDfM4sQyMcD4pIkh5LLMpwqMBuYlI5sz5bHAtHpDahXKa0cS1CT1u8/S4vRS2/yADW2CQgZ9pTMEREZQZmDEYKSB8uQd+pn+F5EzN2mT/EoEdElbYAUShBnCRwJoPmAFqhIqDe+rvxOlUwQaoPrzNC/uDAmHKUAVOPeACeIJwqFOgY8/rD/EH6kLHp/8LM5UnDIdOBn+jj31rXfw9bv4FbmTxKrSoUW5KCqMHUe31oRs8Kl1oqapu+CJ3v6Y7IfcH3Q1uS/E5dLxWpTKE1UdZNpsvGS1Irr0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3038",
    Length: "25",
    Mark: "521",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "31",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530170",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.07205435",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1Tt0KgjAYfZfveg1nsy27igqCupAIuhAvFId+sPaFrUDEd2+g9QbdnT/OOfkAWYXX/mEghRNVmJHtG3LAICN0/glpPkwwBFTMlViLzUJIvlRawcj+Yxbf+W3XlX34EIQ9lnfjTQdpxCMGZ+Ma387kQr70GG5P9Ib1zzoabNqwIvhKS8ngYM17zmoeyyRhsCNLoda9rB2LD7B6YoUSAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVd9rgzAQ/l/ynEr8GbVPZRsMtoeyDfZQ+mBpaAPODOcGpfi/L7O6Rec1p4hivly+++5yuWzOZL2TL6d3QVLyoHbyWeVyTyhZK1lUHyTdnC+/epot9UNq+ocsXMaWzUe/pN52y1ZlmZ30Wu45PGQ+XbiB4/OY08RJvCShP7ibuA0eMA0YeOB6Lc5iE4d4Ons/jKIxfj/ggYFHMY8n6YH82uJC+rXqGfIkfCzcDh5mDYgK9NrLfux4QRj+5zHwXhZG7Bv1Bt7bLQSPjX+gpx+XHQd1An572bfTzJYzDMvcXUgldCag7CPsUbWP2F0oy0CN43jm9wBwu66fravs1hqBYFSJAGImmk/tRkABWrsOisVe3VDPgXoahmZ2xwTVQPcVhKN4EDiqYyI6O8r+guv7/VZmb6ISJUmZwyh5FMWhOraDJ1VllVRFO3yV+9+peyEPx6od3OXiyzS8UbnShMVnntfbbwsgs1yRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "513",
    Mark: "522",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4871.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "31",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530171",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.91483861",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+Lu7qr2CkqCOogEXQQD0qLPth2w7ZAxP/ektqloNub9w0zk/eQVXjqbgpS2NsKM6u72hogkFk07g5p3o+nN8ScyoTL5YKFVEaMw0B+wYiGTH7BWIi/cI4t5vpV25ad3+AfGyyvyqkW0oAGBA7K1K6ZxNG60qGfPcozXj5op7Bu3FtILghstXpO3oQywWICa6utjzUPrYfiBerF5cYSAQAA",
    Pbi3DGeometry:
      "eQgAAB+LCAAAAAAABACVld9rgzAQx/+XPKeS+Fv7NLbBYHso22APpQ+WShtwZjg3KMX/fZm1VnNeTJFK8/X8+M2dd65PZLUV78evnKTkWW7FmyzEjlCykqKsv0m6Pp3/qstsqQ7S0Kuy4Iwt25P6kWZzue2uqrKjujdynYgnnC6454Q+d2nsuNx3qdLDOIqHOo+9Vk6iUTQLODVQov/lVHzAvAm6juEBjwxm0Kdi+m1PRXUEo+2VhyyZSFkv2+2pT0FL8R2Ph8NEdpReH1Ou4eMMgPCzdUBHMYhu6UZLMNQRl5gbzf0lw5aYOTfIprSCzJQVK990O5mLDdhWBi1rCgeBEYOE2w8Ic00hB9Mt3w2NA3XknTG2PEaZmxBz4cZmBQMF1e16XsNA3dw2cEqaOVg8tG+ezrBdkXE7LZspsLuNTQ860GoWWE2OkXH1HX8Q2Wde5xVJmcMoecnLfX3oFq+yzmohy275IXb9padc7A91t3gs8t9h4L0spAKWP0XRbP4ACzhJl3kIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "206",
    Mark: "523",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "31",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530174",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.30481348",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNoHm2auhIVBF2UIrgoXUQNbSAmUqNQSv/d+AJ3c4YzTD1CeTT74aqhgK0/mkqfgnKt1YCg9MaFGxT1+IlRERQLIsl8RjhmIhcwNT9v0fdqiHIsVkZddNA9FAlOEOy0a0P3AkJ4hqDyQQXjHRQME05SSbOUpbkUkhEEB3P+lzfatF14c8IpgrXVj+9aYkmlRLD01scvd7d2ap6uG3Di0gAAAA==",
    Pbi3DGeometry:
      "2xwAAB+LCAAAAAAABADtV02L2zAQ/S86a4O+LFnZU2kLhfawtIUelhyyrNk1uHFJ3cKy5L9Xje1tJOtZ9t4KIiTEo/GbNx8aaW6fyc1d/fXpR0W25GN7V39pm/qeUHLT1ofuJ9nePvd/3TK7dh9yov8kV5yx6/OP+5LTbnztzfG4f3LvGrExJdf0iquNlIbajbVCUU+srKCcbZjgpbegWBlfgG9IU5rzglTLkJRgCnJyci0sXeDCGT+mDmCQWUhnxiyMg3uhYGYZn4A/t/zSrrC9WJU+zCgf1Uf6g1yX1ocP5QgHmA1gIB3NSi8KCTrILPLKGDULH9BJmg3woVsoDKh45MBzlBvFZ5OutfX8UkovKipU/KEc8UmlN5SneE78ipcDxFnLB/mF8jvqD+UWpiXco6gcUjAzzXZFpwqTjoIG5SD4qVYS7EXgbGqrhHLkLWLP7MBeO4N/Gy3jegp02YG5GeQ9kFVFD6QG/kryBX6tiwICB1yELfzDUjA+zXnkFMXHLl6Qfdj0a6KDz4mVjsE0Mll4eTfFXIdH6ohmXB2ygTgwzNCvdIr97pBsSV4ascOID0gYqv64NioqVLbJIEyuTy/8rZTRzEyOcDOKPaapzh+eFGP9K+5ci53s3ClE9lFoF+EnbwLoOhraRQHCIYVJiLsAI50MUWgYhAi5lrzVTQjFNze8DMTprHYLZgAZQPq4Wc43uUkckAEQoDwM5mEwD4N5GMzD4LKbVx4G8zCYh8E8DOZhMA+DozwPg3kYnM3AfzAM7ih5V++/V111JFunScmn6vDQPQ4Pn9tu39XtYXj8Vt+/LH2o6ofHbnh431S/LxXftk3rAA+/mua0+wNacRQj2xwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1212",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530176",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.1471924",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yim+lcp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0ZEJFhQSRczynAqMgFT/eOWfa+GCMdgbdRFB91DTjBBsNeuDd3LUMo4gtIHFYx3kFM8F0RIniZcSJZJHtujOf/DW23aLrw9YQmCjdWP7zrDlNEUwcpbH7/c3dqpfgJZ3JpY0gAAAA==",
    Pbi3DGeometry:
      "sxwAAB+LCAAAAAAABADtV8Fq4zAQ/Red3SBZsiSnp2VbWOgeyu7CHkoOKTWtwRsvqVsoJf++duw4ltCTFPYqSpv6RX7zZjSa0Tx8kvvH+tfH34qsyV37WP9sm/qJZOS+rXfdK1k/fI7/9l/T6/6HHLIzcsUovT7+6X/JYXN67ct+v/3o31X5SiolsismVlxplelVLooiG3BdyiMuqM4XuBLaicP1rGQjnlMRwaMk1V49XJSGXaB/5rfXAx5kF+oJ2UVx4DzGLSh/NsvkgDPNTZoRzlkuTPXG8jP7BBe8cNHMuNuqTXOyCtXMMZjwXEivHGAWOGWxM8GcsTmxI6uAHjoFghBOKDkeCMq4b8cXiUPLAedUeRIK0iA8KCfSXSQz6JaVC0GeS8Nv+QV2d041czksOyAbIE+ozMaWKbDr4SQBuBn9sFsXRi2uMER4a8qnohhxrQc1iitfD+rxiUbT4/rh44jzwvBK9q9FbWJkFAA9kHNulVQOPKzk5tGyWqjHXYDzSWfJ/ys8qEtc6pd7F8+bLvs4DmaVs3uc6jtaD+s+4g8kFeqVdqMPeGUFARYGnFRoE93eQq/ce45PNMoRpxx47UO5gK5NQ51zRBP1bgFSEFwZUJMohHJlfo9rp7dBs6gJIdy6MyC7gejAu7gdfCAfRRmFB9lF/MgtdNKRHnSi4d0G6rnMLxR+QA+Wh8q+7RWKQoDeLo9p8EuDXxr8lnga/HxupcHPlw1p8PPSpMHPIycNfmnwS4NfGvwcd4Y0+Hn1pMEvgn5Bs8nITb39U3XVnqzpimbke7V77l6mhx9tt+3qdjc9/q6f5q++VfXzSzc93DbV+3Lh17Zpe8LdW9McNv8Avv3xu7McAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1214",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530178",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.40385012",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACNjk0LgkAURf/LW0+D48eEtpIKglpIBC3EhdKgD6Z5YVMg4n9vSBOiTbt337lcTt5DVuGpuylIYE8VZqS7mgwwyAiNvUOS9+PpCsITfBnIYLUQIQ9C34eBfVMZ/QFDEf3CeXekxUcgbduycxbuscHyqqxqIfG4x+CgTG2bKRzJlhad+BjPeJnRTmHd2HeQfsRgq9Vz6sY8lkIwWJMmN2seWg/FC8Ef03IUAQAA",
    Pbi3DGeometry:
      "5wgAAB+LCAAAAAAABACdVlFrgzAQ/i95TiWpMVb7NLbBYHso22APpQ+WShtwZjg3KMX/vtg5qy5nziKKyZf7vrvk7nR9Iqutej1+pCQmj3qrXnSmdoSSlVZ5+Uni9en31cBsaS5S0cvMjDO2PD/MTarNn9lNUSRHY8sZ90Jf+nTGheeLUNDIi6K5oH0gXIQ1IDkfAIGUNRAynyKpagvOPMZFYBGpkbkv+4hgUTTRL1B+NMRp6uNuAVxsYY/+jFh3EopxKC8D+5m08wOidn6wJb313Sh6At0gnExjChaPoMjAiEFPAeF/x+Bkusola2j9Y3ZuEVwu2BRHUOERcKPg5EeYgCpoefBkEUV5BdkEBMoUZx2PGIASSG0oG6f3PAQTEoAqB2yETgNIAasMNVTE52cyExaA+oW7+kc/yDaFy7z5a7hTyXtapgWJTXpR8pTm+/LQDJ51mZRK583wTe1a6CFV+0PZDO6z9Lu78FZn2hDmX1lWbX4AaA+yvOcIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3038",
    Length: "25",
    Mark: "524",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "33",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530179",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.47950084",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzEkmthaT6KCoIcigofSQ4shXYhZqVEopf9uoNU/8LazM8y8ooe8xkv3MJDBkWrMyXWWPDDICX14Qlb04xkDUkiuV0KvZ1LxRZImMLC/ueUXYdO2VRc54mOH1d0E00ImuGBwMt6GZhJnClXAiD7KK95+1sGgbeKM5MtUKQZ7Z95TNuVzpTWDLTmKtf7l3FB+AAGfF+MWAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEri79insQ0G20PZBnsofbA0tAFnhssGpfi/L7O2M603T0QUk8/vu7tc7uLyQBZr9br/kCQjj3qtXnShNoSShVal+STZ8nB8tTCb24vU9G9mxhmbNw97k3p1ot1UVb63XM64F/s8oTMeekGSJlR4wheC/gKRYFEDhMzOdICY+3ELsNQBIKkzI4jiuNdGECahA0TCH+kVaHwwQLzxQa+upOI07I/8BFwuIhggaNzNR+r5YRT1SHUAd0n6GE0cXYaTQYzUsI1Lr9wAUQDoLmjcyQdGaoJXVwE6OQfdBQsHzAeKgasPTM7htYLKACk1rWWAXg3W4P82UNsHBHDbB/RqPGN8IwO3KKpf4aRQAFg4YE/ESU3ru2AXBc9BCEBKoQBc38UcE0jGEbD/EHcqf5dGViRjHqPkSZZbs2sHz9rkRumyHb6pzRl6kGq7M+3gvpDf3Q9vdaGtYPlVFPXqB3M7Ckb1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "513",
    Mark: "525",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4871.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "33",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530180",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.96895871",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfFUXcNO0UFQR0kgg7iwWjRgW03bAtE/O8tqV0Kus2b7/HeyzvIznRsbwpS2NkzZVa3lTXAILNk3B3SvBtOb8AAuQyTxQxjHqEMoWe/YMRljN9QiPgfnGKLqX7ZNGXrN/jHmsqrcqqBNOABg70ylatHcbCudORnD/JElw/aKqpq9xYyFAw2Wj1H75yjwITBymrrY81D6754AW0520ISAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABACVVlFrgzAQ/i95TiWJmql9GttgsD2UbbCH0oeWShtwZjg3KMX/vlBdnfHOREqLyed9d9/l7tL1max26u30mZOMPOmdetWF2hNKVlqV9RfJ1uf20cBsaT6kof3OgjO2vPyYL2k2f2a3VbU9GVvOeBCnLKYLHgUhl4ImAY/5Db0AcSoGQBK2+zKJBvuSpXSSSXIhQQspzBuQC4tJ8EhMx4SKQGOa7RoDMCZbtWAxBxPYA57q+phapjCQER8eRcvUA0Omft9Kx8igEwF4wJhwwDMmO+NjAAsWV2epuGbcl8kdE6rOOiLbNVY2gAFWTy51Yxeeh90XpiMdQFM4qFALoCscHQlEhTYYCjioAB0ogBXC9DhFiZzz120wXZrAIEcBzyK3meaPD2CSO6hQixkXlWuAADcYBnjPIpsKALB29ZwgzusWEmH+K9yr7Ude5xXJWMAoec7LQ33sFi+63tZKl93yXe2v0GOuDse6WzwU+c//F+90oQ1h+V0UzeYXY5utqd0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "206",
    Mark: "526",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "33",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530183",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.40525408",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImqRt4kpUEHRRiuCidBE1tIGYSI1CKf136wvczRnOMNUAxdHu+6sBBdtwtKU5Re0bZwBBEayPN1DV8ImTQgnFQhIxn1GOWZZnMNY/cdF1up/sqVhZfTHRdKAIJgh2xjexfQGlPEVQhqijDR4Uw5RTIZNUMJHLTDKK4GDP//LG2KaNbyY8QbB25vFdSywTKREsgwvTl787N9ZPtLLxX9MAAAA=",
    Pbi3DGeometry:
      "pR0AAB+LCAAAAAAABADtV02L2zAQ/S86e40+RraVPZW2UGgPS1voYckhy5pdgxuX1C0sS/57RWxnY8nPsnMriJAQazwfb+ZppLl/ZXcP1feXXyXbsM/NQ/WtqatHlrC7ptq3v9nm/rX7a8X81n7YMXlbuRGc355+7Jcdt4Pau8Nh92J1BRdpplVyIyhVKk9MaoykZLRMRtqFlEtRjATEi2kB1FB5kZ8EipZZIskJxmTXM2mSBRBO9qdeB2aQWxjOjFuYB6ugeb4sHid+bbi+dCxN/76wfy4NDYKzwoDgLMjEyIO7Dg0hz64hGFKmpBglIxgScI2xUVHMevDAhTy7HjA4mA7EJN7HOghyEvMUVsWYS0TZIo6hveCtw4iCpfYEoVh9cIAb2NL6oBA+XO1BoyegWyJv90J2hAzNNOIVXcxjAEweFqA6BBuN2x8Q5OAO8gQINQKhCyE7QXZymnIuMt/UZZ/WxWCLOluGdCfIdQ+DlFiCb20+oAMYUsa5GR+ukgufBxOnLj6msUB1CcyuzRNsvevh4brqnMyICrkOHAhIAUWL3schAUszFISsDRfc6R/BvuVUFdYIosPVAzSHCiAmyOVgMrxL2BsMo9Rkkbzzf4jWCsY0Dx4V3uEybAwSFuHUxUAQTe8x1zk+oIN3CXS99X2jVOEr7sx+RVlEaQ/myi8tyhVEGLoj+kFNb31ccQj7CniQudAJriAuVKAb+tsDhoWSFSfOOHHGiTNOnHHiXHaNiBNnnDjjxHlVnuLEGSfOWYU4ccaJM06cq5n730yc24R9qHY/y7Y8sI19NWFfyv1T+9w/fG3aXVs1+/7xR/V4Fn0qq6fntn/4WJd/L19839SNNbj/U9fH7T+d6cDRpR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1216",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530185",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.30534723",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAQRf9l1jEkbZo0dSUqCLooRXBRuoga2kBMpEahlP678QXu5sw9M7ceoTya/XDVUMDWH02lT0G51mpAUHrjwg2KevyMUaGE4kySbD6jDKciFzA1P3HR92qIdlysjLrooHsoCCYIdtq1oXsBpYwjqHxQwXgHRfwmiJA8TbiQLJc8pgdz/pc32rRdeDNhCYK11Y/vdY4poymCpbc+drm7tVPzBEN1G+XTAAAA",
    Pbi3DGeometry:
      "qx0AAB+LCAAAAAAABADtV0tr4zAQ/i86u0Fv2+mptIWF9lB2F/ZQckipaQ1uvKTehRDy3ys/YjeyP0uhtyJCHtZk5ptvZqTRPO7Jw1P+e/c3I0tyVz7lv8oifyYReSjzTfVOlo/79qcR00vzIodoWLlglF42H+ZNDquj2tV2u94ZXUbZQskkiS6YXIg4iaNkwaVSUSPQrFmXNOGf1zVL00kBUlApVa2AU+llSQvOZn0SMj2FQCR6iJEGsAShsU9ObBgQIbzYYRI9NNO1gCXi1FC7zBmXFofT/w8A3boSasrQsA6AbUM9MvJoCEUn4FI7XELQgJuNwCSbDFIPAJEhAoo2CoZHjel2p1Bmx9WugKGUaFoLBI1nawxawgK3U77Eobce/Kz68DB1fjpsgijhfQlaCvB4QtUPDbkOZd/jDB41HnWDBHYmnOTOjZ7v2eHmbFGIVYdsPDAOxSKeb1z6aCihjUL91QiUPD0itFH0TKhvMCAEdKpvs1TXplgqrF1n91/MG6wbb1voVHw1UKixnM8OJbWvAm1CWkPH0y1naAhQAzkLFRyFhtrsKOAubqNgwHNjps5QToGvkBvKHN7vuGqAT7CSUUDwFZMqNkUDd38OvIWXKthWuBXa46YwAj7J2wMbti4osO8eENwVKXzft5MBaeCgo1DBvEIMxA+eB/gKivb9TMqxV+cSROmAEEDB3S9G9GCaXBCjAzIMnV7QYegMQ2cYOqedCkNnGDrD0OmX0DB0zjaWMHSGoTMMnWHoDEPnNx06VxG5yddvWZVtyZIuaETus81L9do9/CyrdZWXm+7xT/7ci35k+ctr1T3cFtn/z3+8LovSGNz8K4rD6gMVuq/rqx0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1218",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530187",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.02108383",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzE0aVptPYkKgh6KCB5KDxVDuxCzUqNQSv/dYKsgXrzt7BtmJu8gO+GhvWpIYUsnzMi0FVlgkBFad4M074bTG0QoeCLnE6F4qKSEnn2zWRhP/6BKRL90zB1Y8a5fNE3Z+g3+scLyop1uIA14wGCnbeXqUezJlQ797EEe8fxBG41V7V4ilhGDtdGP0ZvwJJaKwZIM+Vh7N6YvnoU2CjsSAQAA",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABACdVt9rgzAQ/l/ynEqiVk37NLbBYHso22APpQ+WhjbgzHBuUIr/+2Ln5o/mzFlEMd9dvu/ukouuT2S1Va/HD0kW5FFv1YvO1I5QstIqLz/JYn36fTVmtjQXqWiLzDhjy/PD3KTa/E27KYr0aObygHvCpzMeekEYh1R4QgQx7cJxEtdw5Ic9eB5FNRzziCJIam/OPMbnyQV5jfuh6OIhE2JCLIDoSEJ4zbFQrCwssWV6xi31smc0FE2CKLaWvTUMiFrDoAr9Gd0M+iLdHBBkoyq2uMAU4dzhgCH1i9VAkF0ZmD3H/qIjygU1Cm6Lu3mwOFwoqAHcM2ANvDq8tI7GnM6ExsEd4upm0B8WwEqDe3DaaeemQcFgqwDHoMsf5EcLgyeq41MzlQYHgweDs89HvrdW/tZg/gXuVPouS1mQhdlSlDzJfF8emsGzLtNS6bwZvqndv+lBqv2hbAb3mfzuOt7qTBvC/CvLqs0PmoEPIL0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3038",
    Length: "25",
    Mark: "527",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530188",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.57247656",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzE0bWNCPRUVBD0UETyUHloM7ULMSo1CKf13A63+gbednWHmlSMUDV6Gh4EMjtRgQXZoyQGDgtD5J2TlOJ8hIBLBlUrjzUqkPFFawcT+5lZfhLzv6yFwhMcO67vxpocs4hGDk3Gt7xZxJl97DOizvOLtZx0Mtl2YEXytpWKwt+a9ZDWPUykZbMlSqHUva6fqAyCt6RYWAQAA",
    Pbi3DGeometry:
      "5wgAAB+LCAAAAAAABAClVt9PgzAQ/l/63JFCy6/tyaiJiT4sauLDsgeWNVsTpAarybLwv1sZKB2cHC4EQvtx333X611ZHclyo54Pb5LMyb3eqCedqy2hZKlVYd7JfHU8vVqYLexFKvo7M/MZW9QPe5Nq3ZpdlWV2sLY+972EhSGd+cLjcRLT1Eu5H9BvII5FUAOCpakDpBFvAJZ0AZiqteBhFA364CIWDiD4NFGg7/H40L7HNPWIwsAfDrsFzlcQXnPIt5OLxAuEjbbP1AHc9RiyqMPoAk72MFTjPs5VOfFh5iGxsGsnGai4/6upF5yTblAsWDBgLjAWyMLA5BteKbACcFSXtQpQ1Wj5/e0DtXlAALN5QE2TDaa2L3B3oroUigkFgCUDNkIc1WXNFlQFnXwwgKPCAMhuizkckBYnwP413KjsVRpZkjnzGCUPstiZfTN41CYzShfN8EVtf6A7qXZ70wxuc/nZ/fBa59oSFh95Xq2/AE1PaRHnCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "514",
    Mark: "528",
    Material: "Copper",
    "Middle Elevation": "2933",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4875.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2933",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2933",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530189",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.27198198",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACNjk0LgkAURf/LW0+Db/wKW0kFQS0kghbiQmnQB9NM2BSI+N8b0oRo0+7ddy6Xk/eQVXTqbhIS2JuKMqO62mhgkBnS9g5J3o+nK6CPPEaMVwsMuB8IAQP7phgJ/w8aYPhL5+WRFh+FtG3Lznm4x4bKq7SyhcTjHoOD1LVtpnA0trTk1Md4psuMdpLqxr5DJEIGWyWfU3fJMcSYwdoo42b1Q6mheAEd/k66FgEAAA==",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACdVl1PgzAU/S997kjLN9uTURMTfVjUxIdlDyxrtiZIDVaTZeG/WxyCYC+9GAKhPZx7z6G3FzZnst7J59ObIEtyr3bySRVyTyhZK1nqd7LcnC+3BmYrc5Ca9jMLztjq+2JOUm9/aFdVlZ8MlwfcSzhP6IKHXhAmIU09ngZ0OJ+kSTMfmfEQiOK4AWKWUVykC8FnEbem8HnoD4GQZdk8TVDqaXP4zA5FtkAstZpuAcvrg8yNcvPYD6wL0QOjSD0wfB1jQudinKJz4Y40neGvJMgcaBqUCmQeL4Q70j8l2bwNlxrSitgpSIJ7HUACCEAVji4a92ZBM9yqXPtuVh0AjAkA1T3AQIg2hCMgFAFdCKxZhwcbAap+sItjNxKmZyIZCFXg925+/wUZIID7sIGBsB2kIZj/hBuZvwotKrJkHqPkQZQHfWwHj0rnWqqyHb7IfQfdCXk46nZwW4jP3w9eq0KZgOVHUdTbL5lMu1PZCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "167",
    Mark: "529",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1588.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530190",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.18993359",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfFcXULO0UFQR0kgg7iQWnRgW03bAtE/O8tqV0Kus2b7/H4sg7Skk7tTUECe1tSanVbWQMMUkvG3SHJuuH0BRTIUUixnGHEBcoQevaTCi5D/IKBFNE/OO3mk8CqaYrWW/jHhoqrcqqBJOABg4MylavHcLSucOTFh3imywftFFW1ewcZxgy2Wj3H7oJjjHMGa6utnzUPrfv8BVCL8jEUAQAA",
    Pbi3DGeometry:
      "swgAAB+LCAAAAAAABACVVk1rwzAM/S8+u8FK2ny0p7INBtuhbIMdSg8tDa0hi0eWDUrJf59psmSxLdshJNRP1vOTLMvdXsnmwN8unzlZkidx4K+i4EdCyUbwsv4iy+21/SnNbCUf0tABmQFjq9tHvqTZ/bmtq2p/kb4QQcCyLKUzmAcRxCFNA1hAQm+GOI1HhjRq8SRJRnjMMmplghAyo4d8wbiEwhTCPLRrQoNANU1eGjNgTGrUIVuAMYGDwTO6QVPLFAVxCKOdaIl6fMzTw0ou1OldADo7QoPiXmrURGs4ohINaqy+T7IfjVMNFtR4R9RVsSLR52PF4whLX8Brb4cStKfBUP12ItTBUP2Ok6drQs8RarAz6UFgOLL59o6J0Tg7rNvBWoyGTo0avKpa5ZnaIQxt2k6EOky4hBx9wnA5YQbPjqMS6ThyNP1ahfMSNemX/wDu+f4jr/OKLFnAKHnOy1N97gYvot7XXJTd8J0fe9Njzk/nuhs8FPnP/4l3ohCSsPwuimb3C2cdhtmzCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "212",
    Mark: "530",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2010.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530191",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.25334044",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzHkh7RaT6KCoIcigofSQ8XQLsREahRK6bsbbRV787az3zAzWQvpCQ/NVUMCW3fC1JmmdBYIpA6tv0GStf0ZDFxyymQs5xMuqRICOvIDGadRLMUfcKbGcBT7gvmnflHXRRM2hMcKi4v2uoaEUUZgp23pq0HsnS88htm9POL5izYay8q/RSQUgbXRj8E7pVzxmMDSGRdi7d2YLn8ClZ/EBxIBAAA=",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACdVl1PgzAU/S997khLx8fYk1ETE31Y1MSHZQ8sI1sTpAbRZFn474KgwuzZbhcCoT2ce8/t7b1leWCLtX7ev2UsYfdmrZ9MrjeMs4XRRfXOkuWhe21gMW8uVvO/mYkUYv79aG5Wr35oV2WZ7huuVNITKlJ8IpUX+JHPY0/Gio/ngzho5wMZHQEqnLZAKGacZqkj+CKQVhe+nPpHQDyL3DQh16eDc/B8WpHNkAjtQXeAZflgcAPfQnphpPz/iRgBQ0sjYLAcFkIXhcVFFwXJ0mkPFkkoODQPpSLPw0TQLF0myRYbSjXSCisF5gEyXBMEPcAdTto0tGIhMWiqztSd0z5ADAyc7x7QEK0NEQg0RWhrDgFaVUACAmCjcy8k3DMpDJoqeN6591/IgADhYIOGHA7nltD8J9zo9DWrspIlwhOcPWTFttr1g0dTpZU2RT980Ztf6C7T213VD27z7HP44bXJTWOw+MjzevUFhlgqd9kIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "8950",
    Mark: "531",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "84922.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530194",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.31930326",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomrRp4kpUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6sGCVt/NJU+BeVaqwFB6Y0LN5D1+IlRIZRgzlk6nxGGKS84TM1PXPS9GqIdi5VRFx10DzLBCYKddm3oXkAIyxFUPqhgvANJMWEkE2me0awQXFCC4GDO//JGm7YLb05YimBt9eO7FjgOYrX01scvd7d2ap7nQx7z0wAAAA==",
    Pbi3DGeometry:
      "Cx4AAB+LCAAAAAAABADtV01r4zAQ/S86u0FftqT0VHYXFnYPpS30UHJIqGkN3njJehdKyX9fkchpZPlJTs8iJLE9nnnzZkYjzdM7ud00D2+/a7IkP7pNc9+1zTMpyG3XbPs/ZPn0fry0YnptP2RffDy5YpReH37sl+xXg9rNbrd+s7pMsIUWlSqumFwIoQqzMMb++c+l4QWjC8oF8yWSaiDBOkJpdZCIUsy1JjmV2DUrqCQvZnE5YEwqIEsQGzsVw8YxsSrlbKdGNJSyF2fYgjkFKnxLg+CkMLA4CaTUHkQggKYQ9tgSdEqz0njxSDsFsDE9wcs4REAviT3GwPxgRFBNKePcHQSqlImC5tzjJ21IZ9UaXBlBrUGfkgkPBClnA6dQhUBLF/sE6eGaGjRcEQY5CpYxXJVJS7EWfVFbG5cBih96DhOR7DjjpYo4J1dRIICkAQlVSUeikuzQmamYsHTespXizEmOtkypj4LSOBrSvjqD36XxwADQJS0rf8vlbFxPcDOObOARiThGUac8g1zwJnMxSZhdVerKqwdVicTmADWgv1ADeoVMRYoR2pqReb+TzOhho9xC5tApmEK4QoACdArX9YyIBMezDyZGiMlUhUcC57EV+BSTe0ew2wxLRDJLcvKswKScXm4BOgRJHy/g6TdAR9GKBBivXUgFhj4drwAegURIJo+PoV+oEeBzBuL+CYqwhCEI1MDJSnbHICgQBJnKQ2rUUh5S85Aax85Dah5SEwe8PKTmITUPqXlIzUPqVArzkJqH1Dyk5iF12tSqIF+b9a+6r3dkaV8tyM96+9K/upu7rl/3Tbd1t4/N80n0vW5eXnt3862t/52/+KVrO2tw+7dt96v/zhrSnwseAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1220",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530196",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.16888029",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yi03Rbp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0aEMoql5MliRjlmMpUw1T9w2fdqiHQM1kZddNA95AQTBHvt2tC9DKVcICh9UMF4BznFc0lkJlgiZMbTTMT2aM7/8FabtgtvT3iCYGP147tOMeWUIVh56+OXu1s71U/SVm0a0wAAAA==",
    Pbi3DGeometry:
      "0R0AAB+LCAAAAAAABADtV01P4zAQ/S8+h8rOOLFbTitAQto9IFhpD6iHVkQQKTSoG5AQ6n/f0HxAPHlxqr1aCEQymXnznmdsz/2HuNnmv99fMrESP8ttflcW+YOIxE2Z76q/YnX/0fxbm+V5/SMO0debMyXl+fFP/SsO687tx36/ea99FamFMTqOzpRe6FjqyC5inSTRp8FKMo1B2njUQHo5bmAeKlk2HsaaWaH6rIgGDkZrOwoBafQeDMIbysX2vYcKMmiKk1E9cE6QhVLmO7iy5LxvI6lYDw0NC/Z9C6AScgGaQCMGgNylypBxSq0csU7nJoWwAbkGQGk1rhIHgMgAAXNz1UDVlHS90ryXXaqwAuJUD9QjaWZWGWwJZkBJedeaGWC23gpn1QFDnZ6Vl99wtbvPu45ni8T6F9YHDOXd0OAewQywEKCCfmlRq8IGcFsVEvdHcg2QOKRhqVVkSfSZlCEzfYQZ04aqDU0pSOtkpfQxVFo7ziR4siIuBErKSjU4cNWS9MyTGJ72TBFr+6z0f0oFt+GTCcKVNUlqBx6pGT99vg4HrwdLF3rArFCoCdlh6SJJ4E4CCw4uLWQOCcJiwBsf8kBZTRQ1agN4M+t5pFqNLhS7EHTpkgbVDs4OfJSSGjRHR5uOTcPbjAEjBPQe3UQQMNJoYjCApekVD96/HJkmRgmEgfh5b4ssKdj3UHI/77n0YMVi3nD90DL5905XEZgVDBXm0DCHhjk0zKGThjCHhjl0XquGOTTMoWEODXNomEPDHBrm0DCHzphD15G4zDfPWZXtxUouZCR+ZbvH6ql9uC2rTZWXu/bxT/7Qm66z/PGpah+uiuzt+4cXZVHWAXevRXFY/wO/ySjV0R0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1222",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530198",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.94297671",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNoTB9JXYkKgi5KEVyULqJe2kBMpEahlP67qQ9wNzOcmakGKE760N8Qcti5ky7x7JVtDAKBwmnr75BXw0cGhHFGIynFYsZiyjORwVj/wGXXqT7QIVhrdUWPHeQRjQjs0Ta+nQxjcUqgdF557SzknLKYJXKeJjwRMpOcETjqyz+8Rd20/r0kOCewMfj8tsXUDtHKGRe+7MOYsX4BYaal3tMAAAA=",
    Pbi3DGeometry:
      "nx0AAB+LCAAAAAAABADtV01P4zAQ/S8+h8qOncQupxW70kpwQIDEAfVQRASRQrMqAQmh/ndc6taN6xe7Pa4sBCKZzMx782XPwxe5fmzuPv/VZEouu8fmtmubJ5KR665Z9G9k+vC1+VeL6bn+IavMvjljlJ7//NG/ZDXbqv1aLuefWpdxNmFlzrMzJia8klUmJ3kuymwgEFTmawHLhVfACl7EauRUrDUkj7RkQDHBHA0ulN8FpGE0PD4CpjzOAwIYQ49zXvkCgjE5LKhSciPQnwxc54oPBFtTrsaOBa10cvYFOx+OAJqCzi1vhEqjKAYaMgQK+cb8Cp2DCBeWXqxvWwiQHgwIrCkm2UZQbnoGtYA1JarS1BRV3qIarTXYGFYAIcWm+wisB+T89QENHQ8JscPZdjTgzIFlYAVhU4G5BkeFRzCsAxRB+B5kInbgWAqQdGwbRZAGLKii5r2U69eqCpx6VFWVUaDyR2AMyYINIUl/PcEBFY4H9IFAMUa3LEr/gTt+EMOz3hNwxQ2k8rQ4jZwux5FDKaVSmLlfagt736PzAH0PgSIFBAgZGik+UK2hPB9MjfCccfOJ0wPYwbTBfgAKCBKs4mDVO7cwl0IZvnQMoWrBcUeEPVScdtBzyt9YWsBHfeNTOXyDgPfYA9/+QOH7LexREEAY8WCcDpMK4gTJRd4L9zD5+33kBgFYn0AOVCwsTJA4lJ/I2RcGhGKU1s20bgZKKq2bad0chZTWzbRupnUzrZunxCmtm2ndTOtmWjfTuvmfr5uzjPxu5q91Xy/JlE5oRq7qxXP/Yh5uun7eN93CPN43TzvR37p5funNw5+2/tj/8KJrO21w8d62q9k3izQDfJ8dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1224",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530199",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.9475159",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAQRf9l1jUkpmmTuhIVBF2UIrgoXbQ6tIGYSI1CKf134wvczT33zEw5Qt7ow3BFyGDnGl3gyde2NQgR5E5bf4OsHD9jUBhnhColFzPGiRBSwFT9xGXf10OwA1jr+oIee8gooRHs0ba+ewXG4iSCwvnaa2chY0SkNFUJnyepiqVKQnvU5395i7rt/PuS5DyCjcHHd1sSFrOAVs648MvejZmqJ1dPaRLTAAAA",
    Pbi3DGeometry:
      "Jx0AAB+LCAAAAAAABADtV01r3DAQ/S86O4sk63NzCm2h0B5CW+gh7GFDTGJw12XrFkLY/1537a68Qk/S5pCTCAnxSJqZN/M0mrl7Ibf37bfnnw1Zk0/9ffu179oHUpHbvt0Nv8j67mX6d1ym1+MPOVROcsUovT7+GX/JYfP/2M1+v30ez7Karai1prpi9UpxVpkVE6yu/skZt/VSLmsZknPGRXy/YHIpN0H1JzWeO5wLNck1FSH1yH1vv9Ofp8fZzZOjsDm70vBAGKA7yP1aT+qlNPIM72nBaHumyTvhEJwWuA2b4FFF0HRAE/JJUXoWjaRL0DQEx5TBFgLg4pYDBmC8/WggJpn5gkh9dBVRfkGl8XuKnuJLbFkUQzfByaE/uXlOe5pit88LpOdyj9Lg/ER7J1CFgQRwC1BTXg1DxcHJAQEgXxJRhbczUWIcAIg49/ZkYA6DYNROcinsUa7CD497pyifMah6knsOiVofIegwk2BNuiQang3gE+N6VqSMXWLOemrRS+7kTJzJha5fFyFQay9FhTJJDRfzArdBnnq1P7nfexPAfuwQAgwpBzkaDgUsFIhZKJU4NcgjkHtoGOQYUQsxF1AC9aC++1bHex3PTZ5sK9LPx3QJODPByzTKVdQyNAAXQFuBDYMY4cYe3ctE7FAn5UcIJjOoH+HK7PgWnQCoBijQSbzZuFACAGCcMFAl8upcxq1BisrIGLVbRsYyMkYNlJGxjIwxApSRsYyMuSfKyBhqTcvIWEbGMjKWkTGKq4yMbzEybiryvt3+aIZmT9Z0RSvyudk9Dk/zx5d+2A5tv5s/v7cPp6WPTfv4NMwfH7rmz3Lju77rR4W731132PwF0OFs4CcdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1225",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530200",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.08174263",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjkELgkAQhf/LnBdZ11bUTlFBUAeJoIN4UFrWgW0nbAtE/O9taR0i6DZvvsd7r+ghr/HQXRRksKUaczKdJgsMckLrrpAV/Xh6QxokkYjn4SwQcSRhYL9QmHDxhVIu/6ExsHzXLtq26ny3f6ywOiunWsh4wBnslNWumcSeXOXQzx3lEU8ftFGoG/cSsZAM1kbdJ+9zq0wYLMmQj7U3Y4byAePtYk0KAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVVdFqgzAU/Zc8Z5KoVWOfxjYYbA9lG+yh9MFSaQPODJcNSvHfl864mvQaY0u1Od6ce5Kbe1yf0GrL346fJcrRk9jyV1HxHcJoJXgtv1C+PnV/1WOyVF/U4gtyQwlZ/l3UD7Wbftpt0xRHNZcFWcIopnEQJtECqyHLovMtSrMhmqTna5wOsYwRdvlQPMrFaOiexwiJrrNZZNEiGxUG5wXROblAFCaw1hjH7HrDNOizAi2gm08zEo5suObqIwyuHjTXbYZq2Y4MINkI6qPG3FoThTXCuSzl3d56EbgUwEswy2CW0RU5XjCz+I5mc1BNdqNvu8K1hZvJivXUMPt8eZ9Ln5b3YJu0KH8TMw4EaBbOVpyWML4Mrx43OwUUBlqbdfxhw4NRZwPCnmvFOrNZymAGsIdn2D5MABq8y/XN0rjcADIWMNFAknq/3/Pio5Rlg3ISEIyey3ovD3rwImQhuaj18J3v/h89lnx/kHrwUJU/w8A7UQlFWH9XVbv5Be+R3TSRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2904",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2913",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2999",
    Length: "25",
    Mark: "532",
    Material: "Copper",
    "Middle Elevation": "2913",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "36",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2913",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2923",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530201",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.71266255",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xAaaezDlVRB0EURwUXpIsWQDsSMxCiU0rsbaPUE7v4X800zQt3hZXhoKOFIHdZkB0MOGNSELjyhbMZZxkHB83UhNiLlQmQZTOzfVfvFbr1XQ2THYIfqroP2UCY8YXDSzoR+MWcKKmB8d7ZXvP2qg0bTR4bgUhaCwd7q97LN+SqVkkFFluJZ97J2aj9JLp3pCgEAAA==",
    Pbi3DGeometry:
      "6QcAAB+LCAAAAAAABACdVVtrgzAU/i95dpLUeEn7VLbBYHso22APpQ+WhjbgzHBuUIr/fam6GuvRY0W85MvJl+9cclyfyGqr3o9fkszJs96qN52oHXHISqs0/ybz9an6NNN0YS5SOA1yxyhdlA9zk2Lzv2yZZfHRrBWuoNRzGHcZC0NHuBHl/vkVCHZGaRRwCxVsVqLCDxq0h6G2ZZ6IuryMR8JCvTAaqwHebdiLUbsNarhi4CHgWgW2Y9MTR3gvO7qRO+N+h+GCtvzt2JZqG9TOBMIwzNvW0PICQ0FlPbtZ0cVcmyDhygkra7AuuKLh6CK2I2oXyVpPGOAqxRmmnVZYw8CZGGBFsg6CeNJBATeY3tIrwFJCugK6HgHhUoZ7DUowqYPBCsD/Qw+KMyDoiA6G9NYRthVq/psPKv6UuczInLrUIS8y3eeHevCq8zhXOq2HH2p3mXqSan/I68FjIn9tw3udaEOY/iRJsfkD970r9ekHAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "475",
    Mark: "533",
    Material: "Copper",
    "Middle Elevation": "2894",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4508.9",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "36",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2894",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2894",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530202",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.28949289",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkpa2xnkQFQQ9FBA+lhxZDuxCzUqNQSt/dYOvfydvOfsPMZB2kJR7ai4YEtlRiSqatyAKDlNC6KyRZN5zeMJEBV5GScxlyoWQAPfvAGVcijv8gGYW/6DtygPmretE0Rev7/WOFxVk73UAiuGCw07Zy9Sj25AqHfvIgj3h6o43GqnZPEQcRg7XR99GrfJucMliSIR9rb8b0+QMyGHiMDgEAAA==",
    Pbi3DGeometry:
      "MQgAAB+LCAAAAAAABACVVV1rgzAU/S95TiWxfkT7VLbBYHso22APpQ+WhjbgzHDZoBT/+9S6meqNiYhiTk5Ozr25SbYXtNmLt/MnRyl6knvxKnNxQBhtpCjUF0q3l+tv3U1W9YMq3CMLSsiq/dQvqnZ/w9ZlmZ3rsQvqeyxkFNPAIywKMPMoW2IdpjSOGzik8Q1OkjBq8Igk2EGmo/skpJC8TwP/Fg9YMseNYdbJmJwnnfQyVlkmDAz1io8yZopJmzbxGImiYdp7VJfQuH30I2rreiTberYITKkODIARwCDsCpxKS69NYLaBYQCGJYMTYyhxQ25NbOecw7rGqrSuu0ttu/AdvEzvELelhbkwat3XsILLIWCn232YDgYNt5UvTIVR03kzawsYVRz4di/G22XO8QdyDaj1/oAV3G++hl7fv/ci++CKlyglHsHomRdHdeoaL1JlSsiia76Lw3/XIxfHk+oaDzn/0Yl3Mpe1YPGd59XuF3WI29QxCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "6908",
    Mark: "534",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "65547.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "36",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530205",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.02353778",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjssKwjAQRf9l1iEkNU2auBIVBF2UIrgoXUQNbSAmUqNQSv/d+AJ3c+aeYW49Qnm0++FqQME2HG1lTlH71hlAUAbr4w1UPX7GpEhccEnnlGFKhYCp+VmLvtdDUtNiZfXFRNODIpgg2Bnfxu4FlDKOoApRRxs8KIpzQYTks4wLyQrJU3qw5395Y2zbxTcTliFYO/P4XqcqhOUIlsGF9MvfnZuaJy0QmH7QAAAA",
    Pbi3DGeometry:
      "RxoAAB+LCAAAAAAABADtV01PwzAM/S85lylp0yYZJwRISHBAgMQB7bCJCiqVFY2CNKH9d0rTjmZ7zroDt2jaR93s+T3bceqnb3a7KB7W7zmbsutqUdxXZfHMInZbFcv6g02fvu3P5jY/bV5sE/1ZTgTnp+1H82abWf+3s9Vqvm7+ayY6VjISciI0j6PmMlO/n4nJhkaTpe2XToEVr82MGFgN14pEMIKrgxQSlUUU2x3UbikEgL4wgTGuoFgdp5JWgMn2zoRq3XDphFYq8WfdsnXXdrhc63gfYceKvfXMHG+Yw1ZxapKDHKA3QkWHy21UvCKgMwIWi4CC/RWStLwkrOYulX1oMlsFwkYIlwhGgFY/hRHCCGJ+EW5+/QjHBHcogshZXzaOXryncHohwJh252sgRCL9ScdWN7Z+DUeEZsz29Utz6abSOuO6taosAQjbs8AiiLSrFwuf2FLgsRmbnjF6ISpm0CuLdRsFI9V+KvszilIGrYlTTVocHQXc245RgfPTr7XEpBkm2O2ucCWmBZd66wMfRztR9Ctw1cL9S9QHzg3iRWlAWSA2H045ooDLDsvFzxvNhgV08elrEDPccnF35jLbr9vGqoA0vzPY9KHROXuxK28MiOezndjCnOHHChgEwhsOAlYBdyROJNp8xEMBQWC8BCK4MGB4rb/jOg0Ey/XDOgBhhAkjTBhhAEIYYfbyG0aYMMKEEWZoDSNMGGF8KQ8jTBhhwgjzjyPMLGIXxfwtr/MVm/IJj9hNvnypX7uLu6qe10W17C4fi+ftrau8eHmtu4vLMv8aLjyvyqoBXH6W5Wb2Ayvegi9HGgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2913",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1226",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530207",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.17715033",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjcsKwjAURP/lrkPIrTFp6kpUEHRRiuCidNFqaAMxkRqFUvrvxhe4m8cZphwhb8xhuGrIYOcbU+hTqF1rNRDIvXHhBlk5fmREFE2FwgVyiiglTNWPWvZ9PUQ0BmtTX3TQPWSMMgJ77drQvQwiFwQKH+pgvIMM6VwyqcQsEVLxVInYHs35H95q03bh7RlPCGysfnzXKUWOMwIrb338cndrp+oJAFyWk9AAAAA=",
    Pbi3DGeometry:
      "QxoAAB+LCAAAAAAABADtV11L5DAU/S957g75aJN0fBIVhN0H0YV9kHkYsWihTmW2CiLz3ze06ZrEk9TxOYhiT5Nzz/1Kem/fydVd+/vtuSFr8rO/a2/6rr0nBbnq293wl6xv36d/zWt6Yn7IofhAfjBKT8Y/5pccNvO20/1++2b21ista1awckWVLPSKl1VVGLDW1QhqzT+jrFRsaW3NqBrXMqUWGawEVtXCQUUtgQYo1y4NaJMEgbEkCmMTGOOqBP5iCVgulfLDGNPCxex+xksHtWL9pZaUVaL6TBCiwNQsyjcVEWCd5aVcVoBsQQcmUlYyEIGAFJuCtBEPfG9xFVRUuyidhOEkcvPSiYwwXbBUHLhqAxRrSOYsQLGyZCkG+cUMx2hIe+GlzS61refHPGgnnGFIkDo9cJMGKM5kJOvJeMHewVXq9Q70K73dRyOOQbFKT+7SMTNKqPjloBif0Kl9tZHpSuBjo0qzZcmHrzvrcWL7tdTuoVKLcvFywpdegGoxa/hmCPC5doQTODcVcz1jUoHzej5ak2sDYXgtlIAJIkUD6wu6C1sX1gfMTSTeyD5OAjSFlyIBsZqDvuJPjFms4CDcwVVohRkUlCI8aWOHsuBO1VrPDOpekNgY5sUovngj1mAYIt+muHOSwYl8U3hxiCQI8mIvkl87gQbcfDiSC4n/ihcwvpg3kgsY9fTRFJQv5MUMeYBZRPMAkweYPMDkASaayTzA5AHmyBDkASZeX3mAyQNMwloeYPIAYxk2BTlvt0/N0OzJmq5oQX41u4fh0T5c98N2aPudffzT3v9/ddm0D4+Dfbjomld34Vnf9YZw99J1h80/qViBJEMaAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1228",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530209",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.2874457",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaVpoPYkKgh6KCB5KDy2GNBCzUqNQSt/dYOvfydvOfsPMFD3ktTl0FwUZbLE2OdpOowMCORrnr5AV/XgGA6eMy3g+45JGUggYyIcxmkZc/GWSx7/sK3Nk5at60bZVF/rDY2Wqs/KqhYxRRmCnnPbNJPboK2/C5FEezemNNsroxj9FImICa6vukzelaSIkgSVaDLHuZu1QPgBCKtwQDgEAAA==",
    Pbi3DGeometry:
      "aQgAAB+LCAAAAAAABACdld9rgzAQx/+XPKeS2KhN+zS2wWB7KNtgD6UPloY24MxwblCK//tip2tac3oOqTRfz8/98C5ZHclyo18PH4rMyaPZ6BeT6S2hZGl0Xn6S+er4+9c+Zgt7kYqelQlnbHG62R+p1u1rN0WRHuy7PGBcRHTCRTAViaAykHKaUFdOZkktx6G4kKM4ruWExxQBqa05s0I068BrPRTS1QWTckQsgNOehPA++0LxUtjMl+lJ99TLn5HrlAVyysNO0V3Zgbiyk/+1dRv5NbyNHIHpoXdjARKC8oRC9Pu8qDkC849gfBmdPyiiLNAADLcuhoLRocJATY2xh/gYv9AHRAzZWA5KBzpheCpBawg+7BTos3G7FQYyKAODAGxhw9YAG+ES2AcRx8M4yLAMjDtifntORw/7LNtz+06n76pUBZnb1qHkSeW7ct8snk2ZltrkzfJNb/8ePSi925fN4j5T367hrcmMBeZfWVatfwDoyRo6aQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3038",
    Length: "25",
    Mark: "535",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "241",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530210",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.88484067",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xhabZpQV6KCoIsggovSRYshHYgZqVEopXc30OoN3P0v5ptyAN3gpX8YKOBIDWpyvSUPDDShD08oymGScZBwlSu5XqQZX0klYWR/6KovetN1dR/5MdhhfTfBdFAkPGFwMt6GdjZnCnXA+PJkr3j7VQeDto2QlOdKSAZ7Z97zVvFlJgSDLTmKZ/3LubH6AIpK77IOAQAA",
    Pbi3DGeometry:
      "JggAAB+LCAAAAAAABACdlV1LwzAUhv9LrrOQrt/blagg6MVQwYuxi46VLVAbqVEYo//d6Nqu6XJ6UhkdzdPTN+85OUnXJ7LaitfjR04W5FFuxYssxI5QspKiVJ9ksT6db/VjvtQ/UtMLmXmcL//+9EXqTfvaTVVlR/0uZymdeQHz4ySmKUt9b045SyI9+sUBT9MeTnnSYH3TYatCG+qHUWQR9oM46GE/Dt1t2OYbzcJtMsTDQCTQaVnya7FZIaieLlMmbB6EoZlix0zha2wqmIsyKmydzFh+Zw8DbFTogo1SXEebjqH8ABEAAyJ233iTA2XGopFuxhYPy2LQti4i/93EgBNkp4xpo30AYJc+AJxMi552qACbAD09XERQ7LJLASfTotFTD3Bi/7hA2EUEw8jBB3iYEHrG+qN7J7L3XOUVWXDGKXnKy706NINnqTIlZNkM38Sue/SQi/1BNYP7Iv/uB97KQmrB8qso6s0P98zhIyYIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "514",
    Mark: "536",
    Material: "Copper",
    "Middle Elevation": "2933",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4875.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2933",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2933",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530211",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.5231922",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk6Y+1nkQFQQ9BBA+lhxZDuxATqVEope9usK0HEbzt7DfMTNaBLPHU3hSksLclSqvbyhogIC0ad4c064bTGxhNAiGWMx7QOOQCevKDhTTg8TdbsOgfmzLzqXrVNEXr+/1jg8VVOdVAyigjcFCmcvUojtYVDv3kQZ7x8kE7hVXt3iIWEYGtVs/Rm1Ae8TmBtdXWx5qH1n3+Ao+pltUOAQAA",
    Pbi3DGeometry:
      "EQgAAB+LCAAAAAAABACVVV1LwzAU/S95zkrSj/RjT6KCoA9DBR/GHjYWtkBtpFZhjP53o23XNsnNImVlOb05Offentv1Ga124vX0wVGBHuVOvMhS7BFGKymq5hMV63P3Vz0mS3WhFo/IghKy/LupH2o3w7abut6e1F4SZCxL8YJGAYtpiLMgpHGIFRylyRSmWfSLxozNgklCMcyRk8wSnVt4NQKa0BQWAZxmh/9xmh22EWiJUUZyS3UG2CuLQUTHEQcRZdMKdxwXeMYxBo8p65GdYoPWTgDBXiLm1dRhmzbgNE1yX00PArcCIAut7u7eAU0C3OFsqU7tpc6rfYZBnCRAtK/VnT00SADY70WYk+iw5f2AHWzbfMXrcCRsO2Mi2GEP384JDNhpBGPUOEmAaCMV5yw1lAATEoCdJIZup4P1unr52mcIzESr7+ud2L7zhteoIAHB6IlXh+bYL55ls22ErPrlm9hfHj1wcTg2/eK+5N/TwFtZSkVYfZVlu/kBvyw1XBEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9488.35 /",
    "Friction Factor": "0.022685",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "206",
    Mark: "537",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1952",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "38168.11346",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530214",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.66100188",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNomrRJ40pUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6sGCVt/NJU+BeVaqwFB6Y0LN5D1+IlRSbDIBZ/PCMOUCw5T89MWfa+G6MZiZdRFB92DTHCCYKddG7oXEMJyBJUPKhjvQFJMGMmKNM9oJgpeUILgYM7/8kabtgtvTliKYG3147sucBzEaumtj1/ubu3UPAFFpOvG0QAAAA==",
    Pbi3DGeometry:
      "kRsAAB+LCAAAAAAABADtV01v2zAM/S86u4FkyR9KT8NaYEB3KLYBOxQ5pKjRGvDiIXULFEX++zRHWSyWz0qAHYUgH2box/dEijLv3sXtffvj7XcjluKmv2+/9137IDJx27eb4Vks7973P93f8tK9xC47Wi6UlJfjh3uL3epw26ftdv3m7pULq1WeXSiz0LrK7MJa9zW1GptnSi5krtXUbmTN2pG/rupqtOtCn4JjcmkQHWcuTZ5FuY/YjDOPASIiIjgiUu/ci5OIBLTr0t06ifjXy1ltHWJ488H5wNqbtQ2hiRmA8BEJBk/EKhd/qnyeCB8RiMmrOWSiJRKQQINV5aWDEqkJdFWYmaJUZRGoMYWNFw4obFI4LI9YGonECD0qhk06ADmPCVAD8hiWE8lAuO1QzuchcK88ud+EqQULjcz87oo0hXB3cQJjG4BscqAQ5LuwnnRp1Ngkpf4AcuyddVmW3r5HsUU9ongQ47wiYs7QzaMCCpVV4ZmWK/Mhs8xZB89GaNf7darn2PDUUWs/SxFIWV1oFSS4KjVuzMAZEATegAgPAksKoETzOd3tsd4SpAyJ5HmA5PC1zfoCHqgyo8rJ88yRuNWaSQM9ZD1HZ57qme/ZpMH76jbKCWJOXmUMt0VIRB46ck6Dx0ESkV8RuIBoowHiYGEji0Ji8thQ0fzjFWXCb1dwWPMiz1MDShBh896w3833KiqeB+dB0pyV5qw0Z6U5K81Zac5Kc1aas9KcleasNGelOSvNWf9xzlpl4qpd/2qGZiuWzjETX5vN4/DkL771w3po+42//Nk+/PvrS9M+Pg3+4rprXqeOn/uud4Cbl67brf4AxlL+VZEbAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1230",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530216",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.08085166",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yim6lbp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0aEYMmlWMwow6mQAqb6hy37Xg2RjcHaqIsOuoecYIJgr10bupehlHEEpQ8qGO8gp3guiMh4mnCRMZnx2B7N+R/eatN24e0JSxBsrH581xJTRlMEK299/HJ3a6f6CXCxmC/RAAAA",
    Pbi3DGeometry:
      "XxsAAB+LCAAAAAAABADtV8tu2zAQ/BeeFYMUKYlyTkFaoEB6CNoCPQQ+OIiQCFCtwlUKBIH/vZT1sMnukHKvJQw/tF7NzuwuSe3DO7t/rL+9/azYmt21j/XXtqmfWMLu23rX/WLrh/fhp/mbX5sXOyQny5Xg/Pr4Yd7ssJluu9nvt2/mXr7SaZFcCbWShS4SvUpVliXGKsv0aFZcp2fmUpNm4J3rAVulXAVBSmGcPEykKs+xadoTtONMY4CIiIg/IpAu5QItgPUUUOS9VWhpQQzWVKTK4mw5z8CjNZMZgTGZyXgOxBgP0DjJHs2pyj08qIBAiQMslKCyMQHT8QA0kEILD/ZMPrQ6F9JT2VN38LI3S17gpgEYtDlIZIlIxC+kxi56COSydFtyQCWnfrKlg0UHyk5j+DfJRbsNqG6wFWizneqAlkuStGiZBxVapDMlBrPWPY1CFp4zQ04Ymh+9+6/eLIWlJTc3Bau1RDeNC1jMBxrPexBRSmu5OOccUgjMcohYyn9PB9gOL1NDl2uubW4S10csqA1/2peBN+AHvP19A840J6t+MY5yepWjxiHLRZMDSuiygHioESgaoCGBbPAIM2NbpMFRXpL06H0abepcSaKpjVlRGkMRwYEBzPZpDkL6M4Ieft1kk3UETyx0SlBIkBKgBixdUGB6jeLHDcDkEjko3WQCaefAhu1sOEC6H9rBiONUHKfiOPW3lDhOxXEqjlNxnIrjVBynyMYhyxXHqThOxXHqPx2nNgn7UG9/VF21Z2u+4gn7XO2eu5fx4kvbbbu63Y2X3+un+a9PVf380o0XH5vq97njbdu0BnD32jSHzR87O71AXxsAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1232",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5024.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530218",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.29277982",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfF1FbWTlJBUIclgg7iQWnRgW0nbAtE/O8taR0i6DbvfY/3Ju9BVXjsrhpS2FGFikxXkwUGitC6G6R5P54+EPO5kMlylnARSwkD+4WSKIq+UBiH/9BYWLxns7YtO7/tjTWWF+10C2nAAwZ7bWvXTOJArnTo3x3lCc8ftNVYN+4lRLhgsDH6MWUllyLw1ooM+Vp7N2YonmqYpwcKAQAA",
    Pbi3DGeometry:
      "/QcAAB+LCAAAAAAABACVVV1rgzAU/S95TiUa61efyjYYbA9lG+yh9KGloQ04M1w2KMX/vrRzVq83UZFKc7yee3Jzz3V9JqudfDt9CpKRJ7WTryqXe0LJSslCf5Fsff77ax6zhblIRW/IzGdscb2ZH6k2/68ty3J7Mu+GXsCigM5iLwrTlPrMYwGnoefH8wZMvTT14wuYhH4n1OcJtTEEQcKxYI4xdygMGrG5TYQlG45OSGZBcYb23i6xaQTLc0Mn7LcmiDnnrZLVDFe0x9DEdjYMYmu5gNdCgaLDGnqFBCiuDJfQ1tsUcgTDgAZ0E52iw1NzhPbOB3jFZSBIgPtqwG74seG2AIfpzjeuTdw9NcqdFgrL4HDPE9AVuG2d7rDkg+qGHdbrWFwFPlIAAzpoLKjTCfiwA7HObEAZ7jDUTFMGrsWO+Gh1DVxgXYdHcZPjqVqyzLf0Xm4/hBYlyUx/UPIsioM+1osXpbdaqqJevst98+hRyMNR14uHXPy0A+9Urgxh8Z3n1eYXBpaGwP0HAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2942",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3037",
    Length: "25",
    Mark: "538",
    Material: "Copper",
    "Middle Elevation": "2951",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "144.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "95",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2951",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2961",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530219",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.00382037",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xhi7cu6EhUEXQQRXJQuWhrSgZiRGoVQencDrZ7A3f9ivikHkA1e/UNBASdqUJLxmiwwkITWPaEoh0mGQcwjkUabRcazdZLDyP5dVV/stu9rH9gh2GN9V071UAguGJyV1a6bzYVc7TC8O9kbtr/qqFB3gbHkab7KGByMes/bnEdxkjDYkaFw1r6MGasPy0KCtAoBAAA=",
    Pbi3DGeometry:
      "3wcAAB+LCAAAAAAABACdVd9rgzAQ/l/ybCVGbdQ+lW0w2B7KNthD6YOloQ04M1w2KMX/fZm1M+rp2SKK+XL33c9c1iey2sq346cgCXlSW/mqMrkjDlkpmesvkqxP51+zTRfmIaXTIDOP0kX1MS8pNxe1ZVGkR6MbuMznoTPjLo/DyIndmMXMMSidsz80YtwCWeRXoMdjC4UJalnOfd6n5fMgbFBvugewrdEQJtgadaCjHwVeP64L2skMFAJsy85s5LIgDDv6DWgH2xOtnG1QuwgYwyhvywUPkgTBAbdAU63MIgzXe9AOwC4X7BbcyHBmMVm8abGKwWkEG3QCw02HdKAQo8dhhBcp+wCKlR324ArR6XMCbiZkIuAEWI+CIwGcM6j+LdMLtg/fCzCKEmAoPr2wsYrLnlFzW97L9ENoUZCEutQhzyLf60O9eFE61VLl9fJd7v63HoXcH3S9eMjEjy14pzJlCPPvLCs3vxbDJGXfBwAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "513",
    Mark: "539",
    Material: "Copper",
    "Middle Elevation": "2932",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2916.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "95",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2932",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2932",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530220",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.5682491",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9jkELgkAUhP/LO2+Lq65rdooKgjpIBB3Eg+KiD7bdsC0Q8b+3pHko6PbmfcPMZD2kJZ67m4QEDqbE1KiuNhoIpAa1vUOS9ePpDCH1Q1+sFiygoeACBvLLBI15HHwhFi3/ozkx/xSv27boXLt7bLG4SitbSDzqEThKXdtmEidjC4tu8CgvWM1oL7Fu7FtEPiewU/I5eWPKOBMENkYZF6sfSg35C0Fxr4kMAQAA",
    Pbi3DGeometry:
      "/wcAAB+LCAAAAAAABACVlVFrgzAQx79LnlNJolZnn8Y2GGwPZRvsofTBUmkDzgznBqX43Zc5rcbcpUppaf5efrm73J2bM1nv5NvpMyMJeVI7+apyuSeUrJUsqi+SbM7/f/VjttIfUtNeWXDGVs2P/pJ62227Lcv0pPcGnmBLQRfc94IojGjs8ZBHNPB4FBpq7P+JccANdcluKIoQQm8CrH0IPWYIHgjMDew8RJ5zHibDjFGAgoUcyFInzwm7QUReHGqrS+YaQi8OAL04jHls2rg7hiIAUJ3ggJFHSwXdgh0wnW1zOAXg9ACKYJRs4yj4yi1buBBcMVjgCTfWARzx2pXrQCDGdhyuXrEyjFQ/LLsYY6cRFbpRfHiB26/NOactWlHW5MPk6zVpAOZ0sD3XHQjEePK8dzSyzUDkKcPAQFgq2EhTmtn9fgL81W/Te5l+ZFVWkoR5jJLnrDhUx3bxoqq0kqpol+9yf3n0mMnDsWoXD3n2MzS8U7nSwOI7z+vtL32/5YH/BwAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "1712",
    Mark: "540",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9730.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "95",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530223",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.7738428",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2zizOlcp6ggqMMYQYexgyvZBNNYFoyx7569Qbfn5ffwVCMUjTkMVw057HxjSn0KyrVWA4LCGxdukFfjR0aEYUo4XcwEFjLNYKp/1LLv1RDRGKyNuuige8gJJgj22rWhe5kkYRxB6YMKxjvIE5wKIiSfUy4kyySP7dGc/+GtNm0X3p4wimBj9eO7llhSGaOVtz5+ubu1U/0E5hKVu9AAAAA=",
    Pbi3DGeometry:
      "qRoAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+arXOqaSFQnsIbaGH4INDRCJQrOIqgRD837uWLTkrv1lZ17KYmOh5NPPezO7szt07u72vfr39KdmSfWvuq59NXT2wjN021ab9y5Z374d//c/82n/YLjshV4Lz6+7L/7Hdqn/t03a7fvPv6oXItcmu7MIqpTK3cE7YzKM2twMq+IJLIT0slUEwZc1zGcBKadqJ1NZNEPFoLruAkHTg+GQLPeBoBIfpaIRob2xoCphuH8yZYo9KF4jIc3VCB7qBbe+3kEaeexihMNrALIhGcOj1Gi0mOeBoWMXRb6GsnlKBo2G/hAqoeGKRWGv2qD1f1aca99nRHQWtHLFEiNcxGidwiTBIK64grG/UwZzUhhpwyfplE9gSnQGWl/Aw3fqmugiqZLTkEAxSO6FgTmYu2L4Tuj7SFU7k3S7jRnQNjwu693v44MH5iu5zq4oO5QcXgpuLq3ORYugXchi0FUZ3hIXT9GFFy8MwNwG8dzozGbhPz5GCCzU0VCG6hmq1ItsstiWaL7aNLhZ8NI2TGZUx1oz3MrVaiCohcpQQVFFqO+LqIxLUnYlYtMQdRPICZA6fkgquLHwmE01bFOfr2KMO6YuHw6cBRkeHMg4XzQR1dRsnGVIm7hwwF0Q8IhdYCd6omAXe6sS1gSAxQweRZOgY28Z78kgH1hx1PGpOaeZJM0+aedLMk2aeNPOkmSfNPGnmSTNPmnnSzPO/zjyrjH2u1s9lW27Z0ttl7Hu5eWyfjg8/mnbdVs3m+Pi7ehh++lpWj0/t8eFLXb5+NLxp6sY73LzU9W71D8qA3/apGgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2951",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1234",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530225",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.09628248",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yim9PNTlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhokbP3RVPoUlGutBgSlNy7cQNbjR0aE4YTwZD4TWBRZDlPzoxZ9r4aIxmBl1EUH3YMkmCDYadeG7mUoZRxB5YMKxjuQFGeCiIKnCRcFywse24M5/8MbbdouvD1hCYK11Y/vOseU0RTB0lsfv9zd2ql5Anfu6mvQAAAA",
    Pbi3DGeometry:
      "dRoAAB+LCAAAAAAABADtV01r20AQ/S97Vsx+aD/snEJbKLSH0BZ6CD44RCQC1SquWgjB/71rWXKk9ZuVHHJcQow1Xr15b2Z2dufuhd3elz+efxdsxb7U9+X3uiofWMZu63Lb/GGru5fjV/8zv/Z/bJ+9Wq4E59fth/9n+3X/2s1ut3n27+YLmdtldmUXdqld5vyj1pm3Km1bqzHq1SqsAVa8VnIjW6vOxRSCMLmmOTip5cAK+fa4wVqIgL0RHKLesGKnbD7JAfPtvDntDrjCfw4AjkYpZD6gO1p6Qu2MWulzgN6KfAUAnS/M4CS3s8rc0BSgMyQhQBW5ADHoULEvDIuDCOXG68OJYz1zoeg89iJyz8hbFbdkfWAEwhrnMEMbZjahYpTgCYQL4huogGnr62a0lGgMuEoxQrTpzWkixGaPJx5bx+GNq7ggOHO2cFzamK7krg2ZMwersMrSvV91vX+pTEvXv3rgK9xQhHFyMkFzBGNYTKE/lIw7IIilGm6K8VFFSYPWXBzryYm3hgE36UtU4AT1yRRKtt4s6N19l8VrMTO8Nlok+FgKIhlVESjGu5iqEpghyIxQgbOJNyGRecQBVx9UTFyflsKc8yVOR4uY4dsEcdpwc16+3qrPpU04w/0fWsP7F/QWDQNxOw3Di/gSgcRxgAkicJEKvDWJaxXchOQtAXOYr4KKL8KFa+PtN1CBox7FDZpRmmzSZJMmmzTZ0CrSZBMJTpps0ImQJptLw5AmmzTZpMkmTTZpsnmXyWadsY/l5lfRFDu24guesa/F9rF56h6+1c2mKett9/izfDj99LkoH5+a7uFTVfwbLvxQV7UH3P6tqv36Pyhxghx1GgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1236",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530227",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.04538345",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHE/pp6EhUEPRQRPJQeWhrahZiVGoVS+u4GWz3owdvOfsPMZD2kJZ66q4IE9lRiSrqryQCDlNDYGyRZP57OMJsL7onYX8qA+8EigIF9QSmiv9CLw/AXTrEjzN/1q7YtOrfBPTZYXJRVLSSCCwYHZWrbTOJItrDoZo/yjNUH7RTWjX2JyAsZbLV6TF7JZeTHDNakycWau9ZD/gQ3Iv9eEgEAAA==",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVd9rgzAQ/l/ynEmMThf7NLbCYHso22APpQ+WhjbgTHHZoBT/90Wnq9qcSRDFfHf57kfuLuszWm3F++nIUYae5Va8yULsEEYrKUr1hbL1+e9Xi8lCP6jGF+QmJGTRfvSL6k2/7b6q8pPeq0UBJWmEWRxEcUQxCxi7xSM4bNEkSsdwFIcNnlKGXVgadb0mYRpe0Tc4TegIp3ck9fAGsAqH5GFzxhUzC2PGUFuBKWXmmKZmGUmMie/xCUsPT1Iw0B45P2QfOW/hgekNzgAhQZFCPpptXufdwuPvjTGkyaFaEgP2gVsFW2ncBVB2oPK26YMGnC2DB2npOG8iDwFQFPM9CmqD7I5moaLzG2BWFkcc6AxgrM1rQ+SuRqHpaLk3PFlccWAIWJp65uo0kV9wfa8/ivyTK16hTJcRRi+83KtDt3iVKldClt3yQ+z+RU9c7A+qWywL/jNUfJCF1ITld1HUm1/NRjGriQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2943",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3038",
    Length: "25",
    Mark: "541",
    Material: "Copper",
    "Middle Elevation": "2952",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "144.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "96",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2952",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2962",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530228",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.14472624",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAC1js0KgkAQx99lztuyq26ZnaKCoA4SQQfxoLjowLYTtgWL+O4taL1Bt/8X85tigLzGq39oyOBENeZkfEsWGOSE1j0hK4ZJhsFCCh6rWG7WCY9lBCP7Q1d+0du+r3zgh2CP1V073UMmuGBw1rZ13Wwu5CqH4eXJ3rD5VUeNbRcgki/TFYOD0e95mvIoUYrBjgyFq/ZlzFh+AJjfzOgNAQAA",
    Pbi3DGeometry:
      "dQgAAB+LCAAAAAAABAClVVFrgzAQ/i95ziQmSo19GttgsD2UbbCH0gdLQxtwZrhsUIr/fZnaLaKn54oo5svly3eXu8v6RFZb/XJ8VyQlD2arn02ud4SSldGF/SDp+tT8umm2dA+p6B9yFTK2rD/uJdXmvOy6LLOjW+umAsHDhMooECGnMpCCx7SGYxH+wDxhiw5+hqXswABLYy1EFA6Ri0h0zZNIzNECbDruEXbTcS09lkXMB11t8V7AIJ+Abb2wJwGP4gEWH/dCMGBei/dx75gQLOPkPS2eRwgYkghs6ocdQ/MvMT2X/EMFRAJVAEQdYT2d7IgThcICZTWC5oJyh9RM1NIoPyY5IHw6OSA1M83ntR8o8zBtBkGDwaFCgLoYhueSLgnpAW4nAEawIODpLolo5NPWDezu8FudvSmrSpKygFHyqIq9PbSDJ2Mzq03RDl/17nfqXun9wbaDu1x9+YY3JjeOsPjM82rzDXZwF1p1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2419",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2513",
    Length: "514",
    Mark: "542",
    Material: "Copper",
    "Middle Elevation": "2933",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2922.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "96",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2933",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2933",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530229",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.91885804",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0NWljPYkKgh6KCB5KDy2GdiEmUqNQSt/dYOsPXrzt7DfMTNZBWuKhvShIYGtLTK1uK2uAQGrRuCskWTec3jBhIZVCsvmM0zAWAnryDQPKmYj+wimX/Ad+YgeYv+oXTVO0foN/rLA4K6caSAIaENgpU7l6FHvrCod+9iCPeHqjjcKqdk8RhYLAWqv76JWUCRYTWFptfay5ad3nD4tDzI8SAQAA",
    Pbi3DGeometry:
      "bQgAAB+LCAAAAAAABACdVdFqwyAU/RefbVCTtEn6NLbBYHso22APpQ8plVbI4sjcoJT8+8zq1jhzoxkhIR6Px3Ovel2f0Gorno9vHBXoXm7Fk6zEDmG0kqJW76hYn86/upss9YNafEFmlJDl90e/qN38DLtqmvKox84oi7I0ozhPIpaRBc4imsW4D8eUdWhKF9hm53mHz0mOA1QMnZGUDqgzmjAbTmI2xQsw50hAwVOOOXFF4oQOhnnGnWwBAVmTkiih6dzN+QW3VPr0Xvx/2ca6I26se1VGxR0rQEAQDDkcntLKuVflP1bceID1BJM1vPvhnEP8KWsBqUN7N2RfeE9AEN3vZfwcBa81RIfwgBoAqfhLRgjd7wWqJBbu39cQHcKBQjXteEAqIXSvF/hGmlg1h+kw7r98IJXQa7Oj67v7RpSvXPEGFSQiGD3weq8OpvEoVamErE3zRex+u+642B+UadxW/LNPvJaV1IL1R1W1my8o50VwbQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "744",
    Mark: "543",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4230.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "96",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530232",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.07386108",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPIs5q6EhUEXZQiuChdRA1tICZSo1BK/934AndzhjNMNUBxtPv+aiCHbTja0pyi9o0zgKAI1scb5NXwiUmZUIK55HSuBOaUwVj/tEXX6T65qVhZfTHRdJATTBDsjG9i+wJKRYagDFFHGzzkHFNBpWKZ5HKmpopTBAd7/pc3xjZtfDMRDMHamcd3rbDiTCJYBhfSl787N9ZPHsktOdEAAAA=",
    Pbi3DGeometry:
      "xRwAAB+LCAAAAAAABADtV01r4zAQ/S86u8EeyVacnsruwsLuobSFHkoOKTWtwRsvWe9CKfnvq9pyakt6UnzrQYQm9Wj85s2HRpqHN3b9WN+9/q7Yhv1oH+vbtqmfWMKu23rf/WGbh7fhX7WcXqoPOyYfkossTS/7L/XHjtvxtavDYfeq3lVLKyrTIinFiudc/a7KMk9mYpGJRD2nJMRsgdaUOxfgGzyjXs4LeR4SyZQjSkpc5Ibc7UEP71IHMMAqIuMxioKg1HPOzyNjkFfmsqlZTlpOfIZzkmv9kf1J3uN+4JtyhIPsWjiIT/b+fApDkA4yi9wqxdoDb7EJmLXgkVcgCqB2OB9YjmLp2hDTpKc5n3glJJ1TUqjuLXTAJpRaS+5naZkFleBGWUwGOYUyq/XHQjNTYu5PWAkhHE+XXdCjjJSjoAExiHyghVh7ELga2iSmHIYYsC9oYE9F0XfYVDha6bT18jynYaEHKmWmgeTAX0hn6Vh+LY0Dwgd0BMnpKUkkrZS7Tk983OIFqSNX+hkhB+AZscgxmEherOUk8VKx9fV2oI1IAnVIBuDgaoNIoQTPW0O4I5lZhB4jQiBfsP6d6pAPKtxQHKyr0+gAlZI7c2Mf3wNTJZ85Fuj91lmh659k4Uy9knPnPjLtIvzQNQBdRE2zKD44omhLAgdQnEMBsuy68bFn/uuczce9t+FdwO3tYq9gfSIDSB92Sm+Ls8OA8N04cQKME2CcAOMEGCdA/30rToBxAowToP+MiBNgnADjBBgnwDgB+g18mglwm7Cv9e5X1VUHtlGaCftZ7Z+7F/1w03a7rm73+vG+fjotfa/q55dOP3xrqn9TxS9t0yrA/d+mOW7/A8X2BKHFHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2952",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1238",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530234",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.33175181",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yi07m5TlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhoK2PqjqfQpKNdaDQhKb1y4QVGPHxmRGSWYpYzOJceMJjA1P2zR92qIbAxWRl100D0UBBMEO+3a0L0MpVwgqHxQwXgHBcVpRjIpWCIyyXMpYnsw5394o03bhbcnPEGwtvrxXeeYcsoQLL318cvdrZ2aJ9p/PX7RAAAA",
    Pbi3DGeometry:
      "eRwAAB+LCAAAAAAABADtV01r20AQ/S97Vs1+6sM5lbZQSA+hLfQQfHCISASqVRwlEIL/ezfyKpV253llAj0tIXE0Gr9582b2Y65f2NVN8/P5T83W7LK7aX50bXPLMnbVNbv+ga2vX47/2tf8wv6wQ/bP8kFwfjH8sb/ssBm/9nG/3z7b79pXK2WUyCq9kgVXWbmS2phssEuVD/ZSGsqutNCL/IX1e/UXchGMo2M/85n9FZaCR/Sdf4AfwQniRuxItiBupUtKBkQH0NfC5JOwolRzs4MRUs/sjr3v7tCFUYaCCe101JGkHxWyOWogdb6MDYgKchrAhRakMgE4CgrQYUqeBLBtCrcanJ07mrDenFcTyRQvlnQTavrADtjEChvYActIE/t9QKOcSyaa1Lyyo/u4kP2K+CsTdQLEiWxQaOUHdrrkSLSIlvQKRN3trUCUahTGlwxJDNpJq0EBWRUDm0IVp08ec4Sx9oE8L72k8mHl5/b1oqzOFMGHp9koaSbHo6iUXnJqokM5sKtyJKPeIQ3aRM/MCdWv4GbinhfUafG2oUe8A4q0O+ICYZDAsCdpCdBmgDYPUD9IE9EBhYJ7Fu2Ougk1K60BuiE57krmOVUS/6QeSSpN9jDY5vFRV5jZcnW5Wrt37yOjwnMd2dH9AIUF4uDbOOi/05qhy5AvDry80+KApCJXtqDgYClDiSO5LswJKQ9yhYWiCxLZ+3wJEDqQJs12J+Om2S7Ndmm2S7Ndmu3SbJdmuzTbpdkuzXbElT7NdifESbPdf5/tNhn73Gx/1329Z2u+4hn7Vu/u+nv38L3rt33T7dzjr+b27dXXurm7793Dl7Z+mjp+6trOAu4e2/aw+Qt/5jT8eRwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1240",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530236",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.3939505",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzzFkq5G2nkQFQQ+lCB5KD6kuaSAmUqNQSv/dqPU2M+8x1QBFY079nSCHg29MSZegnLYEDApvXHhAXg2/GBUUyGUm5GqGcy5lKmGs/+K661Qf7ThsjbpRoA5ywQWDIzkd2k/BpZQMSh9UMN5N+GyuE00yZLAno9vwZWmSMNhZek16ynGBGYONtz6eu6e1Y/0GHl48PsQAAAA=",
    Pbi3DGeometry:
      "USMAAB+LCAAAAAAABADtWE1r20AQ/S97VsyuvuWcSlootIfQFnoIPjhEJALFKq5aCMH/vUpsWdZon2Y2yalZjI21o5k3Mzs7I72rR3V5Xf14+FWqpfrSXFffm7q6UYG6bKpN+1strx73fzuxPu8+ahcMK2dG6/Pnn+6rdqte7cN2u37odI02i0RnWXBmokWS5EmQL0xsimAsyLNnQRLZBaEJpQpFkT4J8khoaO9SGMaGCMIitiPAIBgNiOHgFJPAqSWEYLLYmiYSQ5pFoQ2ArlsUiKu8pfHOvQYBBkHyKhBAU+PE8tFBZxnoqSXoEtnTQievi5qvSwSB6o8Pbr4uXeuYs89HTNb5nM4DWJoDisDZEBUQX/mGJcAQ9z4IjgTi02sBp4JU912xy96TqThjxgevIY0jiTv3ZyfR/IQafGINSYPATchEhyBysxfk3C4hDXHfh6PFIiATITKp26RACjBsYcqnbUJ4P7KfZiOHQpPNr/N9lwqQJf6Rgww04SYc7w91dFqUoTGMAguA1qXDSeCSuwbZ6NTsNzqNuxW8Pu2XvWDoZcBSX0q9wrGUXBFSUyQijSEdRGMyHTmFk5YFooPpcIY41hNJFBsErKcJNKwOJHDOLFxHhwW6BFsiA0CzJ8wq34uFDg2G4ARihxksJjjcp2cFgnOHSIyBn0WgQNo84LnjHzogNlTgEGjjEjY0dpYKHRpa8gtnLz277o0DQwNX3xWPgt7FXPiVt+NRhHwJ/wL6f/MoKGp3fuWteRSWL4FcgOdRPI8iaVieR/E8iudRXFLueRR2EzyPYn9o9zzKuGV5HkWSWc+jeB7F8yjvmEdZBepjtb4v23KrlnqhA/W13Ny2d4eLb027bqtmc7j8Wd0cRZ/L6vauPVx8qsu/pzdeNHXTGdz8qevd6h8ycmfFUSMAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1242",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530240",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.03191342",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkPJqzaJK1FB0EUpgovSRdTQBmIiNQql9N+NVndzhjNMPUJ5tsfhbkDBPpxtZS5R+9YZQFAG6+MDVD3OMSlcZpxgsiSYZZRLAVPz91Z9r4ckp2Jj9c1E04PCGUZwML6N3QcoLiiCKkQdbfCgWEY4ySVd5CwXspCMIDjZ6yyTAgsEO2PbLn6ZMolg68zrtxapImmxDi6kL/90bmrej2usb9IAAAA=",
    Pbi3DGeometry:
      "KSQAAB+LCAAAAAAABADtWF1r2zAU/S969oK+bMvp09gGg+2hbIM9lDyk1LQGLx6ZNygl/31uHCeRrKMr720gSkt9cnJ8dHV1r7h3L+z2vvn2/LNma/apu2++dm3zwDJ22zW7/hdb372M/w4f85vhhx2yC/JGcH5z/DP8ssNm+trb/X77PHxXV6tcqDITXK2krkxmVkIKkVl4pYpXXFXSh0tZmCi+EuKob1SczGhHal3ZOPe7Qe6DdKAebyYcs7mOX16YsvKFxvKueJH7xF18zrdNkjr2Rv27PHBvh9KhzxcVpMfHBplcJm9vFPCuBRdh8agQoORD8iDJqAAHc29ZphLa5DqXRTEoPjvwwPgyERt2HRK1hxSPUkEvRXjkcZy/1ZHPp/Olj7DmOlT0SXqceV3KUOsId5Szl7BInHNYSMpcj7jR+VFGlMHtAPzYYn3ev2JYzIgb8YrnpZ3BThHXRvhgpEK6BL0gUh7IgI3VudHXMpKbItRtEV9rba5XJZUOXkUQny7ATsGm/DvL9eYrbR6ZcToiyATUQItcXJ8HKfMiyCfk0VvjWhztZinfzRw1BlnlSgfwWTGe8HO1BDrT1p7oU34vU1dFoWL4lyjY/FmHJfiX0ghWhaKwUP+SO1Z4SPsoeWavBckA8KXhhDiqvcAOolPqTtBA6Y2LMdlmgEmgTjVJlDjomuAeCNSu4KoADnX8UVjqE9wtEBxZXNDxDN9/0EsBmZB26hnov1HVj+zifod+baqDO0d7aUmB+pF9hLxpkDefNLNJMxv6NpdmNmlmk2Y2oZadZjZpZpNmNjEm08wmdP1MM5s0s/Gpp5lNmtmkmU1MU00zG9xP0sxmfrT/h5nNJmPvm+2Puq/3bM1XPGOf691j/3R6+NL1277pdqfH783D+aOPdfP41J8ePrT1n2viu67tBsHd77Y9bP4CuYlECSkkAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1246",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530241",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.32699171",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjsELgjAYxf+X7zyGc86pnaKCoA4SQQfxoDTmYG1hKxDxf2+oFd66fe/7Pd57RQ95rc7dXUAGB1ur3OpOWgMIcquMe0BW9NPpDYzjmKdkRQKKwySmMKAfjFLMaMr/gIRGC7iIHWH5qV+3bdX5Df6xVdVNONFCFuAAwVEY6ZpZnKyrnPKzJ3lR1y/aCyUbN4o4ZAh2Wrxmb4IJIxzBxmrrY81T66F8A6Y8K8USAQAA",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACdVV1rgzAU/S95ziSx1Rj7NLbBYHso22APpQ8tlTbgzHBuUIr/fX50q6JHr0UUc3Jycu5NbrI6seXWvB0/IxayJ7s1rzY2O8bZ0pok+2Lh6lT/Ft1iUTws5xfkRgqxqD7Fy/L137DbNN0ci7GecnylJZdi5riBlDxwZDDjLXiugxL2pGrjSuoS94XmFJma7gpP9sm7cu62cRn4U9yAWQdjIk866KWr4irVG2qNdzOGYrpMO9eON9Oqk/gW3pBp4Zcc9NAr9z3ylXuKzKB61wyICcDII5i0kXiSzDVmuiGhZQUmUSGgvCP+tPVA6mgPE3YHqRYIfJKf4ZqiLzniI3z0REAqlANknE7xgvZfA6dsb0RHODq1ppYJ0iHwSX7QPTX1GEV8hI/eSEiFfpuW9OJOvzebjyiLUhYKR3D2HCX77HBuvNhskxmbnJvvZvff9RiZ/SE7Nx7i6KdJvLOxLQST7zjO17+cgSZdhQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.7 /",
    "Flow State": "Turbulent",
    Friction: "1034317.79 /",
    "Friction Factor": "0.015056",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "2481",
    Mark: "544",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2566035",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "489154.5067",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "47.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530242",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.42196167",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jFELgjAUhf/LfR5j01VqT1FBUA8iQQ/iw6yLDtYWdgtE/O8NtbdzzvdxygHy2lz7F0IGZ1+bAu+kXWMRGOTeOHpDVg5zDIpK+UrGm60UMY9UmsBY/b1d1+k+yGE4GP1Ewg4ywQWDC7qG2qlEawaFJ03Gu4XezGOGUqpAT2ialqYuVMTgaPG76AmXsUgZ7L314dt9rB2rH/rhkB/CAAAA",
    Pbi3DGeometry:
      "QhAAAB+LCAAAAAAABADtl09Lw0AQxb/LnmPYyab5055EBUEPRQUPxUNLQ7sQE6lRKKXf3bVNq9nkZbNB8BJKS/Iy+WU6szuvne3YdCGftm8JG7O7fCEf81QumcOmucyKdzae7Y6H6jKfqBfbOz/KBXE+OXyoN9u/nG673GzmW3WvH7sjEYcOceF6IcVO5Hp8RE5F9+PoWyffq+oRkdIpEk3hNKLQacBTwONOmFZ6PRkvDBuTRzpFQRP+GF5PEn0pkCXCIL0Vc06exCk8OGD8QNPLLEWJ1+I9Upe76IIfW1Wm0/exFIcRxtSzIWGTJKKXC0Q016zrU9vp9QofKOfKdFtltb6Ch2qycXWAOlZltKFQHY3xAI/2H9pQ2g4xFl7TjZxqo+z6Z2pIczRiW84CbXwa9qommyhwa2s6ap+xHSge8ZFZoPGveZdxGqDVjTgdJyhooqkrzdEQjowarShL57X1QEu87c8MW8cHM7eX4dtmYypCXyttd+TOBt5xiPZ0ZDBbkZUC+N/4dzt98O/Bvwf/Hvz73/1b/SG/lvPXpEg2bMxd7rD7JFsV6/LkIS/mhcyz8vRZLs+XbhO5WhflyU2afP4OvMrTXAGzjzTdv3wBEvuY+UIQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1247",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "130074",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530243",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.64588581",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMI+a1NPIkKgh5KETyUHqqGNhATqVEope9uaPW2M3zDViMUV3sengY0HMPVluYWG986AwiKYH18ga7G5UxEKMxJJteUcMyEymGq/27T982QcCp2tnmYaHrQBBMEJ+Pb2M2BZQjKEJtogwfNMRVUKpZJLnO1UpwiuNj7YikVCR+Mbbs4ZyIYgr0zn986x5QThWAbXEiv/Nu5qf4C5O2zitEAAAA=",
    Pbi3DGeometry:
      "QBAAAB+LCAAAAAAABADtV11LwzAU/S95riVpuzbdnkQFQR+GCj6MPWysbIHayKzCGPvvZrZzxuY0TRF8KaNjObk9ub1fZ53tyXQpnnavGRmTO7kUjzIXK+KRqRRF+UbGs331U23TifqQg3dGLhilk68vdZHD/HTb5Xa72Kl7o9QPOI08RkM/CJLE435AR8zT8CjlR5xFgY4zHiuc8dBkzkYs8Qz0LKZpJ5pW9qYzCUuNziOcM2air8ybTqKHAl4iGoS30pycD2k8qs3Do3UU/4JrJ8OK/Zd5wNRuB5ilCT/70vfMkFZPamRpusLjxMFFRF7XRmgMV+dD29mb0a1oTpHpWGGNnIJTddheGSiQOo7aCYXSbo/4UfuhftIbxB58Hbfz6MlyTKI1K2ZrSO44DfQBamtYHbayoP7WYJQ/ez6QPaBHWoGmvy5d9omAyhvxdJmgIH/WhJitETcSaVRLjqrrqn+O9K5/MVzVHszcXmLv6o0lCH2VtFWPO6t3t/nZV5DRWEVSitj/RsAt9IOCDwo+KPig4P+v4Op1/FosXrIy25Ix9alH7rNiXW7qxYMsF6WQRb18FqvvrdtMrDdlvbjJs4+fhlcyl4qweM/zw/wTbRmivkAQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1248",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "300654.7",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530245",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.82523087",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkPJozVJXYkKgi5KEVyULqpe2kBMpEahlP670epuznCGqUYozuY43BFy2PuzKfESGtdaBAKFNy48IK/GOUaFZYlkgi8ZFQlPtYKp/nurvm+GKMdiY5obBuwhpwklcEDXhu4DnEpOoPShCcY7yEXCUpZpvshEprTUghE4messM0kVgR2atgtf5kIT2Fp8/dYqViwu1t76+OWe1k71G2wngY7SAAAA",
    Pbi3DGeometry:
      "MyQAAB+LCAAAAAAABADtWF1r2zAU/S969oIl68vp09gGg+2hbIM9lDyk1LSGLB6ZNygl/31O4iaR7KMr7XWitNQnJ8dHV1f3inv3wm7v22/PPxu2ZJ+6+/Zrt2kfWMFuu3bb/2LLu5fTv8PH5c3ww/bFBXnDy/Lm+Gf4ZfvV69fe7nbr5+G7XC0s17bgZbUQsraFXXDBeeHgdaUPeFWLOVyIw3MEv+L8qG+rOJmTHSFl7eLlvBvkPkgH6vFmwjGb6szLc2vqudA43nVZ6zlxH5/yXZOkjrtR/y4P3Luh9OjTRQXp8bFBJtPk3Y0C3g2vRFg8KgQo+ZA8SDIqwMHcS8tUQptcZ1oUg+KTAw+Mp4m4sO+QqD2keJQKeinCI4/j9K2evLJ8PGDyiMtShqo+zY+zb4zioe4RbipnN4RKpHlYTYxVJ9xKddThJrgngB9bsc+bqA9H4ogPhgdcGTeNvUqueDUHIxXSJWgIkfJABmyt0Vxdy4jS6lDLRXwjTX29KlHJ4H0E8ekq7FVtyr+33PmMpd0jN15fBKmA2qi21fWBEELpIJ+QR2+Na3S0m1S+t+XKnFyqSmJ4UpBf8XPFnFc5b+xIHzc2TVzrWsbwLyFw+ZMmS/AvlXF+USgGifKXvHGCQ7pHiTN5LUgEgKdGE+Ko8AI7iE6pe0EDdTcuxmSPASaBOtUhUeKga4J/HlCvgqsCONSZj0KqT3SzgHhccQHHk7j+wJciOiHuFjTUf6PqH9nFgUUgTvVw73yn1hWoH9VIyJsGefPJg5s8uKEvc3lwkwc3eXAT6tp5cJMHN3lwkwc3eXCTBzd5cJMinwc3QXoe3OTBTR7chCz+L4ObVcHet+sfTd/s2LJclAX73Gwf+6fx4UvXr/u2246P39uH80cfm/bxqR8fPmyaP9fEd92mGwS3vzeb/eovP8uG7TMkAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1250",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530246",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.36309059",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjkELgkAUhP/LOy/Lrq622SkqCOogEXQQD0qLLmz7wrZAxP/eolZ46zbzvmHeZB2kpT63dwUJHLDUKZq2QgsEUtTWPSDJulH6gFjSQDKx4iz0Ig6hJz/IIypFIP+APBQzOKsdYP55v26aovUb/GGri5tyqoGEUUbgqGzl6smc0BVO+9mjvejrF+2Vrmo3mDiICOyMek1ZSXnEFwQ2aNDX2qcxff4GI61FcRIBAAA=",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACdVdFqgzAU/Zc8Z5JYrdE+jW0w2B7KNthD6UNLpQ04M1w2KKX/vrR1U9Gj1yJKcjw5OfcmN1kc2Hyt3/afKUvYk1nrV5PpDeNsbnRuv1iyOFya7reYuYcdeYXcSCFm54972XH5N+y2KFZ7NzaIPV+JgEsxcQ0pufKkmvAGHMTqBIcyauKRjE/4VMScInOh+yKUXfK+DPwmLtV0jBswa29M5El7vbRV/CjqDPWCtzOGYqqmlaGnAl+1Et/AazINvMpBB/3svkP+7J4i06veNgNiAjDyCCatJZ4kc42ZdkhoWYFJVAgo74g/bj2QOtrDhN1BqgUCn+Snv6boS474CB88EZAK5QAZplO8oP1XwynbG9ERjk6tsWWCdAh8kh90T409RhEf4YM3ElKh36YnurvT7/XqI7VpwRLhCc6e03xrd2XnxdiV1SYvu+968//rMdXbnS07D1n6Uyfemcw4wfw7y47LX4DCgMKFCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.2 /",
    "Flow State": "Turbulent",
    Friction: "935863.46 /",
    "Friction Factor": "0.015137",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "10192",
    Mark: "545",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9538111.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "464043.9057",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "44.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530247",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.46658447",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jFELgjAUhf/LfR5jU5NpT1FBUA8iQQ/iw6yLDtYWdgtE/O8NtbdzzvdxqhGKxlyHF0IOZ9+YEu+kXWsRGBTeOHpDXo1LDIrccCVTtZUi5lGSKZjqv7frez0EOQwHo59I2EMuuGBwQddSN5coZVB60mS8W+nNPBYoZRLoCU3b0dxFEjE4WvyuuuIyFhmDvbc+fLuPtVP9A55mgUPCAAAA",
    Pbi3DGeometry:
      "QhAAAB+LCAAAAAAABADtl0Frg0AQhf/Lnq3sqNE1OZW2UGgPoS30EHpIiCQLVktqCyHkv3ebmLSuPteVQi8SEvQ5fk5mduclsx2bLuTT9i1hY3aXL+Rjnsolc9g0l1nxzsaz3fFQXeYT9WJ750e5IM4nhw/1ZvuX022Xm818q+6lkSsCTzjEfdeLKHaE6/ERORU9iMW3ToFX1QWR0kn4TeE0oshpwFPI406YVno9GS+KGpNHOomwCX8MryeJvhTIEmGQ3oo5J0/hKTw8YIJQ08ss/RKvxXukLnfRfX5sVZlO38dSHAmMqWdDvk2SiF4uEL+5Zl2f2k6vV/hAOVem2yqr9RU8VJONqwPUsSqjDYXqaIwHeLT/0IbSdoix8Jpu5FQbZdc/U0OaoxHbchZo49OwVzXZRIFbW9NR+4ztQPGIj8wCjX/Nu4zTAK1uxOk4QUETTV1pjoZwZNRoRVk6r60HWuJtf2bYOj6Yub0M3zYbUxH6Wmm7I3c28I5DtKcjg9mKrBTA/8a/2+mDfw/+Pfj34N//7t/qD/m1nL8mRbJhY+5yh90n2apYlycPeTEvZJ6Vp89yeb50m8jVuihPbtLk83fgVZ7mCph9pOn+5QuPoQjTQhAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1251",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "117062.2",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530248",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.17548391",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMI+bepJ1FB0EMpgofSQ9XQBmIiNQql9N0Nrd52hm/YaoTias/D00AOx3C1pbnFxrfOAIIiWB9fkFfjciZCJVZEqzUlHDOhM5jqv9v0fTMknIqdbR4mmh5yggmCk/Ft7ObAFIIyxCba4CHnmAoqNVOSy0yvNKcILva+WEpFwgdj2y7OmQiGYO/M57fOMOVEI9gGF9Ir/3Zuqr8mRdop0QAAAA==",
    Pbi3DGeometry:
      "QBAAAB+LCAAAAAAABADtV11rwjAU/S957krS2jbVp7ENBtuDbIM9iA+KRQNdO1w3EPG/L67tXGxO0xRhL0UUc3Jzcnu/js72ZLoUL7v3hIzJQ74Uz3kqVsQh01xkxQcZz/blV7lNJ/JFDs4JuWKUTn4+5Jsc5vWx6+12sZNnWeAG3A8dRn3X86LI4a5HA+Yo+CjmR5yNPBVnPJQ4477OnAUscjT0LKRxJ5pW9qYzEYu1ziOcM6ajL82bTqKHAl4iGoS30tTOy1O1uX+0HoVncOWkX7KfmXtM7naAWRzxky997/Rp+aRalqYrPIwsXETkVW342nB1vrSdvRndkqaOTMcKa+QU3KrC5spAgVRx1E4olGZ7xI/aD/WT2iDm4Ku4mUdNlmUSjVnRW0Nyy2mgDlBTw6qwkQX1twKj/JnzgewBPdIKNP1V6TJPBFTeiKfLBAX5MyZEb424kUijWrJUXVv9s6S3/Ylhq/Zg5vYSe1tvDEHoq6StetxZvbvNz76CjMYqklLEfhkBN9APCj4o+KDgg4L/v4LLv+O3YvGWFMmWjKlLHfKYZOtiUy2e8mJRiDyrlq9i9bt1n4j1pqgWd2ny9dfwJk9zSZh9pulh/g21HkVcQBAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1252",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "253230.4",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530252",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.36688821",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NIYpMmdRIVBB1KERxKh1ZDG4iJ1CiU0nc3at3uju/uyhHyxpyGu4YMDr4xhb6E2rVWA4LcGxcekJXjT0ZkQRlWCZErrrCkCqbqj637vh4iG4OtqW866B4yggmCo3Zt6D6GCs4RFD7UwXgHGcU8JakSSyZSlUglBIKzuc4wUxTBXpu2C98lyRiCndWvuS0xTahCsPHWxy/3tHaq3nEuAofRAAAA",
    Pbi3DGeometry:
      "VSEAAB+LCAAAAAAABADtWE2L2zAQ/S86e4PlOLGUPZW2UGgPS1voYckhy5pdgxuX1C0sS/57XX8k9khvJKcfh0WEhHg8efM00sw47/ZZ3NwVn5++5WIj3ld3xaeqLO5FJG6qYl9/F5vb5+5rczu+bl7iGJ0tVzKOr9uP5i2O2+Fnrw6H3VPz2yuZLHQaq2ilFzqWKlKLJEll1NqlnNhlYjPL1VJz7krribta8ihTMjKVvX2ttY0M4u7ljtDdbPxSdsZB+EpqW3IA+x49W66Xtsz3drrYwUxJUphhpwY72Slf9J47725k0rADmKkZpcDYQIOlX1hjAymdfv9oynr033fnr9X79FF4dMgQPCD/R2fVFx0lGFUgXasXOt0mSp1fETh6oKV0BJ0NiK+OmW2MxuSp+BYw7m0teKo6KtLayEe9yuqNwO3Uh5ak1rEc7ZDfTKETiIBcRtxsplln1+vWPWN3gnV29GkwBegqSUWczFmm3U0dett4++XVGC+eDwIQvaOi0qTtB0qzZr4RG42VRzHdeep8zsezqzUr3UZdpZnfmJ6io+ntmLs0M4ALQplJfaWG4pKM/XQaBzNpCi4U0iwuAm9za/c9rX7ia9JgnA1gtBSw8hnQ9JhYOYPTAOLhXbeZL0oescKCsgYEBcIHBM4MhqNp+tA493TrYLC3XfvZQBMUeLPQU24zgdFTgs3sV+GgWtzz3RoSPFI4QgJvFsQ1y/yojObEnNGHandmpfPYlOHLVxLQHxanwvC3lIR5igEi/xKVBMe/aF+F4d8oCS7FwEE+KAlBSQhKwsQ7KAnQOSgJHk9fQUkISkJQEoKSwAUMSkJQEoKS8H+VhG0k3hS7r3mdH8QmXsSR+JDvH+rH/uJjVe/qotr3l1+K+9Otd3nx8Fj3F2/L/OfY8XVVVg3g/kdZHre/ALQz/ClVIQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1256",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530253",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.02189374",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzEksbVNPYkKgh6KCB5KDy2GNhCzUqNQSv/dYGsviredfcPMZB2kpT61NwUJ7LHUKZq2QgsEUtTW3SHJuuH0hhkXVEbRfCkDKoQU0JMfMJRUMh5/QxYE/+EUm3/qV01TtH6Df2x0cVVONZAwyggclK1cPYojusJpP3uQZ32Z0E7pqnZvsRAhga1Rz9EbUx7yiMAaDfpY+zCmz19OEbkiEgEAAA==",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVld9LwzAQx/+XPGclif2V7klUEPRhqODD2EPHwhaojdQqjNH/3XSrtoG7NGNsLN9eP/nmrnddn8hqq9+On4oU5Mls9aup9I5QsjK6br9IsT5d/trLbGk/pKOjsuCMLc8/9ku6zd9tt01THu29Cy4iGbOcyjgSQgqaR4LHgp71TPCJzvObi5wKOQ1nCadeDM8zMJ7JFMK7GJ7wzOsG2xXTr9wV0xGMe1aeMgnlbNSDDjXu2mMSaXfnuZPKHjPqDmYS7uQACO/NQ3QMg+lBbtwUQzriEtvVdT+mOAgz7wY5lFuR2cJiBcR6yldwAB9kMqywUO/4OFj8NZPCV1qIg+lhj4jLgXTk0fH0PkaZHRWz4Z6ehQYLpge1vouBdF/3QIPLx8HiIfu+MQ35weYupvs4kH9f+wNpDpoKQUPENW/f6/e6/FCtakjBIkbJs6r37WFYvJi2bLWph+W73v1felR6f2iHxUOlfqaBd6YyFlh/V1W3+QXxe4z1iQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.9 /",
    "Flow State": "Turbulent",
    Friction: "697358.43 /",
    "Friction Factor": "0.015392",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "10463",
    Mark: "546",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7296461.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "397249.7072",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "14",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "38.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530255",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.74524292",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPIoyZNXYkKgi5KEVyULloNbSAmUqNQSv/daHU3ZzjDlCPkjTkNdw0ZHHxjCn0JtWutBgS5Ny48ICvHOUZlQRlWCUlXCcc8URKm6u+t+74eohyLralvOugeMoIJgqN2beg+wIhkCAof6mC8g4zipSRSCc6EVEmqhEBwNtdZppKkCPbatF34MuMKwc7q12+dxopSBBtvffxyT2un6g0iNaxj0gAAAA==",
    Pbi3DGeometry:
      "YSQAAB+LCAAAAAAABADtWE1r20AQ/S97VszuavXlnEJbKLSH0BZ6CD44RCQC1SquWgjB/72yItnS7r6dlZPjYmys8fjtm9n5Yu5e2O199eP5d8nW7EtzX31v6uqBRey2qXbtH7a+e3n92v3Mr7sXO0RnyZXg/Lr/6N7ssBn/drPfb5+7/14JuSoUzyMVr1QSx1G+ElKIqJfnKp3K40La5FKmuUM/XnEuZ/h57IaZ05FKFb08LzJhpQPoe+ojfJKPp9tOOAg/z/LC4h5If4CXKhU27w9yw9xRrtOc45xva9TXbssXfqRP6BveN8zy06fdg9ywEH+8Lc09FP1YFZkteJa6AQWhjg+DDeATZl0Ws77oBhkiEw1jveCNK9TJu20yUIjyMpAkyxGVKEvLmn4uxce7XsByl7ziF13idXLFFdE9gD7Ct/KfdBUh0tN1+TYbszdNUS4nbzgtS5JeXyQ9jMjcd+VWJ0r4hGX35QjDhTrKk2zum1meTMRdBsx8YEPBJK1kHP0EoBMwxr0OMMWRuuR5SowodvXRpFwdychYESMK0ieqvVG9bXSArThWCTLmoTajHGGA5o0hFbjqycskdegDeBweoD9CDyM2CGcpe9U5t7+pOHHIz+E6yvWqReDo1exSeJ4UDv3BDYa+aZZb38RH7kE8F+LrwWOlj6IEHeuKBpv8De7U5SjlwLEghYhTveq6r4/9m4wdRidjayYobhzDANIn4FEY67ailgd62FKWcISyyb2LC8pOevgBx4KJizjVQLf3PK8C6G7kJEWvzukoE0vLCoXvbib0uAGmmbDPCfucsM8J+xxsVtjnhH1O2OeEfU7Y57j1wz4n7HNsI37Y54R9jk0e9jlhnxP2OWGf8177nE3EPlbbX2Vb7tmar3jEvpa7x/ZpePjWtNu2anbD48/q4fTT57J6fGqHh091+W+q+KGpmw5w97euD5v/0G2E7mEkAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1258",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530256",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.13865747",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jkELgkAUhP/LO2+LuqubdooKgjpIBB3Eg+KiD7bdsC0Q8b+3pHmSbm/eN8xM1kNa4rV7SEjgZEpMjepqo4FAalDbJyRZP57OsPIDGgvBNmFMBYsYDGQBcka5iBegx/l/OMfmv/pt2xad2+Aeeyzu0soWEo96BM5S17aZxMXYwqKbPcobVjM6Sqwb+xVREBI4KPmevGvqh74gsDPKuFj9UmrIP+PaNwUSAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVld9rwjAQx/+XPMeS9Hfqk2yDwfYg22AP4kPFoIGuGV02EOn/vla7tYG7NCKK+fb6yTd3vevmTNY79Xb6lKQgT3qnXnWl9oSStVa1+SLF5nz9211my+5DWjoqC87Y8vLTfUm7/btt1TTlqbt3wcNAxCyniQiyKI1oHoQ8DulFz0I+0XkeXeU0FNNwlnDqxPA8A+OZSCG8jeEJz5xusF0x/cZdMR3B2GflKRNQzkbd61Djrj0mjoI4E3Yqe8yoW5hJuJUDILw3D9ExDKZ7ubFTDOmIS2xX2/2YYi/MvBvkUHZFZguLFRDrKVfBAbyXSb/CQr3j4mDxt0wKV2khDqb7PSI2B9KRR8fR+xhldlTMhjt6FhosmO7V+jYG0l3dAw0uFweLh+y7xjTkB5u7mO7iQP5d7Q+k2WsqeA0R23z3Xr9X5Yc0siEFCxglz7I+mOOweNGmNErXw/Jd7f8vPUp1OJph8VDJn2ngna50B6y/q6rd/gK3tn/8iQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.4 /",
    "Flow State": "Turbulent",
    Friction: "616507.11 /",
    "Friction Factor": "0.015505",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "4955",
    Mark: "547",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3054859.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "372139.1062",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "35.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530257",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.35634735",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jEkTfpIXIkKgi5KEVyULqKGNhATqVEopf9uaHU3595zmXqE8mrOw1ODhKO/mkrfgnKt1YCg9MaFF8h6XM6orGiCBSfFmjPMU8Zgav7epu/VEOUY7Ix66KB7kAQTBCft2tDNkGQIKh9UMN6BpDjNSS4ylmS54IXIYnsx98WllEc8aNN2YWbCEwR7qz+/dYEpIwLB1lsfX7m3tVPzBQWhGhvRAAAA",
    Pbi3DGeometry:
      "QhAAAB+LCAAAAAAABADtV11rwjAU/S95jiVJP6NPYxsMtgfZBnsQHxSLBrpmuG4g4n9f0K61XY9p8GEvVSz29PbkeG/uPXW2J9Olet19pGRMHvVSvehMrQglU63y4pOMZ/vTV3OZTcybHGiNjDhjk+PBfMhh/nvbzXa72Jl7R1x4MhKSBr4XxNKniSdYyOkRD1hyjvNAnPBY8DOcJ35XOA95TDvoecTkRZpe7LUYnsSd4hHOZNRF3wyvRaIfBVQiGoT3oqnFx/EJD/1jeBC1KlXifkXfiBdcJpdxWZaq5KlK4rZsYl52mnpVFriIROxNMcLvzplt1X7sdYYbLHVmeu2yqq5gUaQFbu3uPAIYNRTKI4oH9EgkaihbA7YTj3DEgwrlUj9UEFBtwO04C9D4BL0KYDiEQWvbWr5dPluZ/sxPwI90ot1n8y60i9s44nGdoKCIaLACCwTkSCTaUY7O6+qBjvSujxmujo+68BrDd1Vjf7pxdPBejmw1cNch6ubIYNDBaXnZj67z737sg38P/j349+Df/+7f5g/5nVq8p0W6JWPmMUqe0nxdbMqTZ10sCqXz8vRNrapLD6lab4ry5D5Lv88Db3WmDWH+lWWH+Q/Gk3P9QhAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1259",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "75285.1",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530258",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.49646273",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV5jm2s6e4oKgnoQCXoQH2YNHawtbAUi/veG1tv9zvkOtxqhaMxleGrI4eQbU+pbUK61GhAU3rjwgrwalzMqK8qw5CTb8AQzLihM9d/b9r0aohyDvVEPHXQPOcEEwVm7NnQzMIGg9EEF4x3kFK9TkkqRMJFKnkkR26u5Ly6lPOJRm7YLMxPOEBys/vzWGaYJkQh23vr4yr2tneovAx1q+9EAAAA=",
    Pbi3DGeometry:
      "QBAAAB+LCAAAAAAABADtV11rwjAU/S95jiVJaz/0aWyDwfYg22AP4oNi0UDXDNcNRPzv62pnWpdjGnzwpYrVnt6enOTm3lOnOzJZyNftR0pG5FEt5IvK5JJQMlEyLz7JaLo7/Cwvs3H5JnuqkQFnbFwdyg/Zz/5uu9ls5tvy3gEXXsLjiAa+JwTjNPYEG3Ja4QGLmzgPxAFnSdjAeeybwvmQR9RAz0OWnKXpxK7FhCIxikd4JLiJvh2uRaJJAZWIBuGdaLR4FlRwEFbRv18tkTXuH9mb4YIn8Tk4Ll9NlmM+3MZMaunnWLSUKIocJCLythbhG5fLPmgndj3TNo1emU47TOcUjApguK3BnBCOygktJYpH/Egnqidb/Z0uPsIRD0yWWxJBVkA0InfsBqCBgoJFdQzbsLm+LWV/mj9bnv71TzM9Eom2n8260DY+xRGPUwcF+YONFfifmRspRHvJ0XVd/c+R3vURw9XtUQFeYvauauxPNk5O2smPre7t2j8dDRl1ONQnLW50oYF3o+8dvHfw3sF7B7++g5d/x+/k/D0t0g0ZMY9R8pTmq2JdnzyrYl5Ildenb3J5vPSQytW6qE/us/S7GXirMlUS5l9Ztp/9AKwRCANAEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1260",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "155728.2",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530260",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.49328046",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG/6Vzs1NUENRBJOggHrSGDtYWtgIRv3ur7Pbe4/feK0fIG30a7goyOLhGF+ria9saBQRyp61/QFaOPxmQBTIq40isECkmUsJU/bl139dDgEOw1fVNedVDFtGIwFHZ1ncfgzxJCBTO1147CxnSJI1SyZeMpzIWknMCZ32dYSaRwF7ptvPfJcEYgZ1Rr7ktKMYoCWycceHLPo2Zqjd8VDJE0gAAAA==",
    Pbi3DGeometry:
      "sSEAAB+LCAAAAAAABADtWNFq2zAU/Rc9u0aS3VhOn8Y2GGwPZRvsoeQhpaY1ePHIvEEp+fd5jpzako6unG0vnQgN9c3J8dHVvVfxuXli17f158dvFVuz9+1t/alt6juWsOu23nXf2frm6fhv/zG/6l/skDxHLgTnV8Nb/8cOm/Frr/b77WP/3Qsh0zLnKhEilbksEpWKXJTJEF+V5TR+mTnjUkg/XIlZXGVelrkYKXNxjAuhnOxIfBge8ZNywnJ2onGzq7JUrtQg7ZqcF4V0JF6HraWOcVOjSaP3aYQb+xTMrsUTeCuTVhzxzOMgCeb+WSrD7mrunylm3EAzZ5pdXPailq81tPgselDDbnak/U9KNZAbZBf0nrnMMHJrjwzlxIJQ2aF5okXS84doj6VzzLovoSe4jZGeghcDvyqPevLCP/0RHvEj/eMpwsV0t4LOFvsompOcKd2eq9nAI7LVUboilkTgibmNjgVrtWaf6HBfECpkziM4EB+SYvPICfxpAKi1kP76N7bwRYm5bA1aL4uN9sr25/uEHosuG1YphfDDATnYeuIMtvKCxCCeJeKzlMtspRsMRnUdTsKzLqJIprVyPnXGfXi9fAtvLcgPt+ndaUEil7JPKwZoR5WB7uqpAGf8/FQaKkEXIDEuOH1PgPaSkGM0SMpk1IOp64yjokFHkgdP8Zs6l/Kjo9YZDx0GoKOonwNIiwNN3tEN9lEQp12AiOdHotCT0dPPS/vfz65cs+Ul+w7gEYe2I/6O77DUYADiX6Tv4H/mDrYj/onvQBoMfvHRd4i+Q/Qdou8QfYfoO0TfIfoO0XeIvkP0HVz80Xf4r3yHTcLe1NuvVVft2ZqnPGEfqt1996AvPrbdtqvbnb78Ut+dPnpX1fcPnb5421Q/p8DXbdP2hLsfTXPY/ALAYGAAsSEAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1262",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530261",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.93303673",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NI0tTYOokKgg5BBIfSocXQBmIiNQql9L8bbOui4PbufcfdZR3IUp/am4IU9q7U0pm2chYQSKetv0OadcMZDDPKcCJEtKQck4gn0KNfkGLGmfiGhPM/cIrNp/pV0xRt2BAeG11clVcNpAQTBAdlK1+P4uh84XWYPcizvnzQTumq9m8xZzGCrVHP0bvANKYCwdoZF2Ltw5g+fwGJnVmpEgEAAA==",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVld9rwjAQx/+XPMeSxNpfPo1tMNgeZBvsQXxQDBromtFlA5H+7yu1s017l0ZEMd9eP/nmrnddn8lqp95PX5Jk5Fnv1JvO1Z5QstKqMN8kW58vf+vLbFl/SEU7ZcYZWzY/9ZdUm//b7spye6rvnXERpCFLKA8DNg9TmgSCh4I2eix4T+fJ/CJHIu2HswWnTgxPYjCepRGEtzF8wWOnG2xXTL9xV0xHMPZZecRSKGed7nWobtcGwwMRithKZYO56jamC7dzMA5vzAN0DIPpXm4GKQZ0xCW2q+2+S7EXZtoNcii7IpOFxQqI9ZSz4GO8l0nPwgK94+Rg8TdMCmdpAQ6m+z0iAw6gI4+Oq/cxytSomAx39SwwWDDdq/UHGEB3dg8wuJwcLB6w7xzTgB9s7mK6kwP4d7b/OM1eU8FviFjm6/f6g9p+SiNLkrGAUfIii4M5totXbbZG6aJdfqj99dKTVIejaRePufztB97rXNfA4ifPq80fGvLPnokIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.9 /",
    "Flow State": "Turbulent",
    Friction: "400427.08 /",
    "Friction Factor": "0.015939",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "851",
    Mark: "548",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "340791.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "295802.8793",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "22",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "28.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530263",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.45793982",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eQxDYfdRIVBB1KERxKh1ZDG4iJ1CiU0v9u1LrdHc/dlSPkjTkNdw0ZHHxjCn0JtWutBgS5Ny48ICvHn4zIgjKsEiJXC4Ellwqm6s+t+74eIhyDralvOugeMoIJgqN2beg+hvI0RVD4UAfjHWQUp4IIxZeMC5VIxTmCs7nOMFMUwV6btgvfJckYgp3Vr7ktMU2oQrDx1scv97R2qt6h5nrA0gAAAA==",
    Pbi3DGeometry:
      "myEAAB+LCAAAAAAABADtWE1r20AQ/S97loVWkq1d51TaQiE9hLbQQ/DBISIRqFZxlEII/u8V8sqRdmd2Rk5zaLsYG2s8evt2dj6sd/0srm6qb08/S7EWl81N9bWpq1sRiaum2rUPYn39fPza/ZxcdC9xiF4sC5kkF/1H9xaHzXDbu/1++9Tdu5BprPNERYsiLtQqjVQsc6mj3r7SemxfZqA9lanfXcmJXWVelCmZNM3l0S6lAtEx8jx/DJ+kw4vZCQZGV1orKDQYdwOul7IAAm/MzlYHu83RhjHnNLhb58RGN+QJfyeSjh3DmdqRINjn57DkrWqfn01mOEA7ZgZdrZQ+Y6/c5HPgkRyG0THur0lVJjYSXaT27G3ywJ0zspgTG8LSDusnhiTdf4jymNvHnHUJPuwyxvgUSdHjZ1r2OHnh7/6YP4aP8TfdSaWFHh8Xa7g4s8hGOZO821mzI7w+7kkRe/K7E30bGwvOZu06GcyS0+VhZ5g3K7j2uGH+LcCwDZN82bcIWXjNRFt2+qwfxnX3UvfF++Q7JJxWqjdLvzsIjRw7MX+doGBUMJw51LM4SbOVKS2Nm00ejuyTEqJhxunyCnStPO4mBLa7w8Xr7YIjO8IozkMfZQzMG0sMbEVPAoD2s6M45QgWAEbEdaZWA1099xN9kyYwaupwj4XMWHZgk8fjT8BbHOeiY+MUtLOLHisdcupjdCB3xqqIuxeFmm8sKi/PQPxp6KnjuXVPwFsc/wOxAXmuoTWIPyM2zFUVEPL/pNjgf9BmaxBvIjaQqoKffBAbgtgQxIYgNgSxAajuIDYAnTCIDUFsCGJDEBuC2BDEBjaVv0Rs2ETiQ7X9UbblXqyTOInE53J3196biy9Nu22rZmcuv1e3p58+ldXdfWsuPtblr7Hj+6ZuOsDdY10fNr8BcERXaZshAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1264",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530264",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.97716048",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jkELgkAUhP/LO6/LrqlrdooKgjpIBB3Eg+KiD7bdsC0Q8b+3pHmSbm/eN8xM1kNa4rV7SEjgZEpMjepqo4FAalDbJyRZP57O4HGfroVYbTinTAgfBrIAPUFFHC1AFgT/4Ryb/+q3bVt0boN77LG4SytbSBhlBM5S17aZxMXYwqKbPcobVjM6Sqwb+xWRHxI4KPmevDHlIRcEdkYZF6tfSg35B8pFzo4SAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVlVFLwzAQx79LntOSxK1puydRQdCHoYIPYw8bC1ugNlKjMEa/u+lWbQN3acbYWP69/vLPXe+6OpHlVr8dPxUpyZPZ6ldT6R2hZGl0bb9IuTpd/rrLbOE+pKWDknDGFucf9yXt+u+226bZHN29CRdpMWM55TxlUgqap4LPBD3rUvCRzvObi5yJYhzO5pwGMTyXYDwrMgjvY/icy6AbbFdMv3JXTEcw/ll5xgooZ4Medahh1w6TyFTmmZ/KDjPoHmYU7uUACO/MQ3QMg+lRbvwUQzriEtvVdz+kOAoz7QY5lF+RycJiBcR6KlRwAB9lMq6wUO+EOFj8NZMiVFqIg+lxj4jPgXTk0Qn0PkaZHBWT4YGehQYLpke1vo+B9FD3QIMrxMHiIfuhMQ35weYupoc4kP9Q+wNpjpoKUUPEN+/e6/d686GsakjJUkbJs6r39tAvXozdWG3qfvmud/+XHpXeH2y/eKjUzzjwzlTGAevvqmrXv4QV5CiJCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.1 /",
    "Flow State": "Turbulent",
    Friction: "309241.96 /",
    "Friction Factor": "0.016227",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "5750",
    Mark: "549",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1778002.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "257634.7658",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "26",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "24.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530266",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.38051247",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jFELgjAUhf/LfV7DTRdqT1FBUA8iQQ/iw6yLXlhb2ApE/O+tsrdzzvdxqhGKhk7DHSGHg2uoxIvXtjUIDApH1j8gr8ZfDEoiuYpVslqImCuVKpjqv7fuez0EOQxb0jf02EMe8YjBEW3ru08RS6UYlM5rT87O+EzXmcpMMNgjtZ3/slRKBjuDr1lPuUhExmDjjAvn9mnMVL8BuHJ6usMAAAA=",
    Pbi3DGeometry:
      "6SEAAB+LCAAAAAAABADtWE1r20AQ/S97Vox2tasP51TSQqE9hLbQQ/DBISIRqFZx1UII/u9VYsn2Sno7s0kubRYTEz2P374dzc7I7+pBXF5X3+5/lmIpPjXX1demrm5EJC6batP+Esurh/2/3cfxefcSu+iInMk4Pn966/7EbjV87d12u77vvqvVQhuVRmcyWRiTmyhfSC2LyMLz7Ak3ySyupOKFF0X6iOcJi2UvRiktbVwVepYdiXfHI362HHfOJjSAXWZ6LjW29lTmcoZ8DE/DbY0kjXWfns+OxNuZpHHEY6WS3BRS6V51QoPEWDfQJEa/ZK9E8SF6UGXknpzF51eqbm5ynxZMZ9FJPj3xQLkni42PRVL9h+bn8aB1Ec49ltN1R/yxMf056xL2yKMzV/en43n6daET5xRxDpdDlikWnniUtO6yF5/LPZ67bxaI53ZuNBimuLVdk6XGo9ODcCSemePJ2WdFz3MbqZJTKUpmLphsn6N2O09DPxpY0plJH6JTo04rT0npDKfIAcybK7QY33hbfJzu85vqDoDwpPMN+KEzzdIcSmYI70vGlz3VmhN/zIEdP55pRPixA83nBqn0pR/qZpQcQjyqm8mq83UAcc9cAhi0K7QoCneTjxLGyyPVUXlSDixo2lBTCBUNGsXjeMRPHREuP5i6EGc2BHSmiIcD+ASDwgl2u0SY7ck9/5hShhp+3rQcH0rfZgDowUbfgicBfv7wrYpX8iRY5gP5S++/9CTAXn2tilf1JAjzAYgPnkTwJIInETyJ4El4zPvgSQRPIngSwZPg5zJ4EsGT8GgIwZP4NzyJVSTeV+sfZVtuxTJexJH4XG5u27v+4kvTrtuq2fSX36ubw0cfy+r2ru0vPtTln9PAi6ZuOsLN77rerf4C7FDnr+khAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1266",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530267",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.37473492",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjk8LgkAQxb/LnLdFN9fUTlFBUAeJoIN4MFp0YNsJ2wIRv3tb2r9Tt3nze7z3shbSA+6as4IE1nTAlHRTkgEGKaGxF0iytj+dIeAiiqcjf8xlLKFjX0TwQIrwPxPil30SHyR/1c7qumhct3sssDgpq2pIPO4x2ChT2moQW7KFRTe3l3s8vtFKYVnZpwiFZLDU6jZ4I+5Lf8JgTppcrLlq3eV3SQbBlQoBAAA=",
    Pbi3DGeometry:
      "MQgAAB+LCAAAAAAABACdVdFqgzAU/Zc8p5JEo9E+jW0w2B7KNthD6YOl0gacGc4NSvHfp9OtWZNr4pBKczw599ybm2R9QqutfD6+FShD92orn1QpdwijlZJV846y9Wn4230my+5BLT4jC0rI8vvV/VC7+Zl2Vdf5sZsbBUykeEHDgIs0wSKgIsQayAXvQU4THRUk7tGYpNglMFAZ4dSUZTRiOsoS5u3AGgvOwCvURPzL+WEcWdIa0Mu62DPQgrEg4iw2S6vjusgf/jlnkz64NuUH3x4yk+qmGSAnAAY92oPqJfeR+Y8ZMyX7kkLlsjY7WHM7e9ZKQNr2rvXpClfnu7luH1O7x3+BIT6Eu/Y8pOE4IJxUpwd7j+moRwNDdAi3n0rztoFdw811+wBumLmHI8AHccetAml43YE9tbt/b2T+WjRFjTISEIweimrfHMbBo2ryRqpqHL7I3e+nu0LuD804uC2LT514rUrVCVYfZdluvgBQyTIIMQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.0 /",
    "Flow State": "Turbulent",
    Friction: "117192.43 /",
    "Friction Factor": "0.017512",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "11632",
    Mark: "550",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1363215",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "152672.4538",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "28",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "14.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530269",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.88740588",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jMsKwjAURP/lrmNoorEPV6KCoItSBBeli1Qv7YWYSI1CKf13o9bdzJzDlAPkNZ36O0IGB1dTgRevbWMQGOSOrH9AVg6/GJRY8likYjUTc65UomCs/t6663Qf5DBsSd/QYwdZxCMGR7SNbz9FLJViUDivPTk74TNdJypTwWCP1LT+yxIpGewMviY94WIhUgYbZ1w4t09jxuoN6fcQb8MAAAA=",
    Pbi3DGeometry:
      "pyEAAB+LCAAAAAAABADtWE1r20AQ/S97Vox2JevDOZW2UEgPoS30EHxwiEgEqlUcJRCC/3vlWFK92n07s2kOpV1MTPQ8fvt2NDsjv6tncXldf3v6WYmVuGiv669tU9+ISFy29ba7F6ur5+O//cfxef8S++g3cibj+Pzlrf8T+/X4tXe73eap/26uFlmSJdGZTBbLZbGMioVMZRlpeJG/4MvEiiupeOFlmR3wImGxHMUolUodV2VqZUfi3fGIny3HnTODBrDLPLWlRtdexP0iJvkcNsN1jSSNdp9ez47E65mkccSjpZLcFFLpXtWgQWK0G5jLUv7JXoniQ/Sgysg9OYvPr1Td3OQ+NZjOopPcPPFAuSeLjs9FUv2H5ufxoHURzj2W5rozvCjHBtcn7MCT5s7uT8bz9Gd54RwiztkyiSFIeNJRyvJUDdILecQL960C8dy+jcaCiWvbzbNYefR5EI7E81JsHHxWtJ26zDQhSuYOmG6dMxywk48FmnJmysfoQypP6k5J6QynyAHMmym0GN94/Z4ewSztLwFodLwRHzuDlWKolTF2rBUf4n4rihN/snVlkcINn9qObT9Qoyf5VCx6YijpqFjMVa03H+KemQQw6lBgURjuJJ8ljJdHqonypEwsaMBQgwcVDZq9xkFA6xIHhMkPnxEAzusE9vNEPAogJWD0uJhnrYfRkNxzjiFh6p+vGonzQ+h5+OGqNoX/g+UAft3wnYg3shxY3gL5Q+6ftBzAXn2diDe1HAhvAYgPlkOwHILlECyHYDkEy8Ej5cFyCJZDsBwccoLlECwHdicIlsPfaTmsI/Gh3vyoumonVvEijsTnanvb3Q0XX9pu09Xtdrj8Xt9MH32q6tu7brj42FSPp4Hv26btCbcPTbNf/wLPePJtpyEAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1268",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530270",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.39200666",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+Lu7ZqdooKgjpIBB3Eg+KiD7bdsC0Q8b+3pRWeur153zAzaQdJgaf2KiGGvSkwMaqtjAYCiUFtbxCn3XA6w5zTgEVsOWM+FQsBPfmx0DE/8P8zzidskvli2ad61TR56/rdY4P5RVrZQOxRj8BB6srWozgam1t0kwd5xvKLdhKr2r5FwAWBrZKP0RtRJlhIYG2UcbH6rlSfPQF6AZDhDgEAAA==",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACdVV1rgzAU/S95TiWJX6l9GttgsD2UbbCH0gdLpQ04M1w2KMX/vvixVtGr1yKKOTk5OfcmN9mcyXqn3k9fCYnIs96pN52qPaFkrVVmvkm0Ode/tput7EMKekUWnLFV9bEvKbb/w+7yPD7ZsZ5wAi45XXDX8eUypNLh0qUd2Jd+Cfs87OKSBSUesCXFyNR0wXw+JC+4J7q4CMUsN8CsYzGhJx310ldxA28w1BrvZwyK6TptaGE3cHuJ7+AtmS7/koMBeuV+QL5yj5EZVe+bAWICYNDj8KStxKNkbjHTDwlaVihhQCGAeYf4s9YDUof2MGJ3oGoBwUf5Ga8p/JJDfAifPBEgFcwBMk3HeIH2XwvHbG+IDuHQqTW3TCAdBB/lB7yn5h6jAB/Ep24kSAV/m5Z0e6c/qPgzMUlOIuYwSl6S7GCOTeNVm9gonTXND7W/dD0l6nA0TeMxTX7bxHudaiuY/aRpsf0DZ+xMDYUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "2.3 /",
    "Flow State": "Turbulent",
    Friction: "69112.03 /",
    "Friction Factor": "0.01836",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "9150",
    Mark: "551",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "632344",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "114504.3404",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "32",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "11.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530272",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.63624616",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG/zU3Z6eoIKiDSNBBPGgNHawtbAUifves7Pbe4/feKwbIanPq7xpSOPja5PoSKtdYDQQyb1x4QFoMPzkhC2RU8ShZIaeIUsJY/rl111X9BE/B1lQ3HXQHaUQjAkftmtB+DIo4JpD7UAXjHaRIYxlJJZZMSMUTJQSBs7nOMFNIYK9N04bvUsIYgZ3Vr7mdUOSoCGy89dOXe1o7lm9fo2fj0gAAAA==",
    Pbi3DGeometry:
      "wyIAAB+LCAAAAAAABADtWF1r2zAU/S96doPk+ENKn8Y2GGwPZRvsoeQhpaY1ePHIvEEp+e8zjpw4ko50nW4wilIS6pvro6Mr6Vzn3D6zm7v669OPiq3Yx/au/tI29T1L2E1bb7ufbHX7fPi3/5pf939sn5wiV4Lz6+Gjf7P9erztzW63eervvRLpQmVcJiJbpJxniVykaSaSIS7EWVykrrDIl8qXLpU6S5dLP8o5GZEJHS+UcpFB3EnpCD3MhlayEw7Cl0K5igPYa3S+zJSr8jpuTnYMmyRNmHGlxrixUlR0zd2fblXSigOY8zAqgbWAFkvasNYCmnT0+pkl0+hClOUFkyVvPwsfbTOED+i/aLdS0VGJ0Rm0JkuCN1fK5O6fEth9QFU0w6AI+U/ITCmzBg2QoR5jrHADelbmA4pwyvlEsZzZCBxwH5VJ5FJOVonWWsxGZIBcxtzW1PIQV1kx5Jf+xfCnBxQb9ANzosbBOIbLIlenV1jpKTc6p0OruNV/iE8KEP3ARWT8IBdS+eMBrba0N4Bj5/vpk5dj2uuGsCyHeedZSWvrcCDU+AMt26oY4IVgZk4jl/pEFqUnfty0Y9iUkhCMITGXoXMpC5x+LIGRbpPx51vwaE6oBvPgPRsIzAPtFEQAbwlX+NKqWnHKSXQSCJ+sEJXwnVRsulrPpn3qN+6uBdQf7D7Y5FG+H97kOBsdPc+4wkRVAQcz/CTiHBM8/ASGBNlekFBvpVGZNKp5rRjKwmwZCeCbPF+/AYJ+ZQWNkb9lgMwzOhD512iABH77U42Rf2OAhIyOAPlogMwpWjRAogESDRCCYkcDxIseDZBogEQDhFKDaICQT6KTQDRAfOofDZBogPzvBsg6Ye/qzfeqq3ZsxRc8YZ+q7UP3qC8+t92mq9utvvxW3x+/+lDVD4+dvnjfVL+niW/bpu0Bt7+aZr/+A3l5NdjDIgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1270",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530273",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.42494817",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzEkaWq1nkQFQQ9FBA+lh5aGdiEmUqNQSv/dYGsviredfcPMpB0kBZ7bm4IYDrbAxOq2sgYIJBaNu0OcdsPpDTMu6DKKgpUMqBCMQ09+QC6pYEx+QyblfzjFZp/6ddPkrd/gH1vMr8qpBmJGGYGjMpWrR3GyLnfoZw/yguWE9gqr2r3FXIQEdlo9R++C8pBHBDZWWx9rHlr32Qud1iujEgEAAA==",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVld9rwjAQx/+XPMeSxNpfPsk2GGwPsg32ID5UDBromtFlA5H+70u1Wxu4SyOimG+vn3xz17tuzmS9U2+nT0kK8qR36lVXak8oWWtVmy9SbM7Xv/YyW9oPaemgzDhjy8uP/ZJ2+3fbqmnKk713xkWUxyyj8TwSgnGaRYLHgl70VPCRzrP5VU5EPg5nC069GJ6lYDzLEwjvYviCp1432K6YfuOumI5g3LPyhOVQzgY96FDDrh2GxzaHLHZS2WEG3cGMwp0cAOGdeYiOYTA9yI2bYkhHXGK7uu6HFAdhpt0gh3IrMllYrIBYT/kKDuCDTIYVFuodHweLv2VS+EoLcTA97BFxOZCOPDqe3scok6NiMtzTs9BgwfSg1ncxkO7rHmhw+ThYPGTfN6YhP9jcxXQfB/Lva38gzUFTIWiIuObte/1elR/SyIYULGKUPMv6YI794kWb0ihd98t3tf+/9CjV4Wj6xUMlf8aBd7rSFlh/V1W7/QUfHLrZiQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.7 /",
    "Flow State": "Turbulent",
    Friction: "502866.72 /",
    "Friction Factor": "0.015703",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "8845",
    Mark: "552",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4447949.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "333970.9928",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "23",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "32.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530275",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.79222123",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzzE01dS0nkQFQQ+lCB5KD6ku7UJMpEahlP67UettZt5jygHymk79HSGDg6upwIvXtjEIDHJH1j8gK4dfDErEVaKWq5mYcymVhLH6a+uu031ww7AlfUOPHWQRjxgc0Ta+/RSRSMmgcF57cnbCZ7pONE4Fgz1S0/ovU3HMYGfwNemKi4VIGWycceHcPo0ZqzcKqhMswgAAAA==",
    Pbi3DGeometry:
      "gSAAAB+LCAAAAAAABADtV8Fq20AQ/Zc9K0Yraa1d5xTSQqA5hLbQQ/DBJiIRqFZx1EAI/vcqkeRqVzOzI+NTWEJC9Dx++2Y0O8O7fxN32/Ln659CrMS3elv+qKvyQUTiri53zbNY3b91/7Yfx5ftjzhE/5ELGceXH3/aX3FYD1+72u83r+1340WulYkuZLpQSqtIL2QmTTSGdf4BqxSCE5lwgo1ZvsM6ZVB0MpIkkxacmAxiRkST0Qg3UwhZJpcDZpZ5BpTD0myUVFNiF50EW+J8HOO3ciozItqqnRdGSMbF8+WCyCMPdDkQGeO3pZc6Pz1DssMQariXfKlQHTanGyleX3Zj1Fs3inhyjWHFsygs2FVHjxMvN4cEORKBmfdtcqTNnephVrU1eifJcnx4e6M5unWSL6kNQO2FQYeHgiMaqZM2shetZQdrKhc4mjl7kbE+ga2ZHBvNn9RgMJYiq6juhfbHwrw6U5aIROY46puC9swEObwr3FohrCL36Rmtxu2VSIkH+4hhlLMSvDLmRVsZpqZ7gcusfcZQd4YN8DBnQI6hNYbgrjXmMZtcM6KPidvRziaig48DBcwFkTeL+tgfdkFo0Uh/uAeCbxyDZ1UPRLHZAzceEkwSWzXiVY6cizwRQxMgQ9SzPpDmQBan2+nIkfQF4HHDSxKDeZccuS/kEsdORIJpZrsXWMOG3FksET3DKfvNuW3zLjhMDYr7zP4edhxc138Of89w8j5L9Zn8PZzhPNd/Pn9POnlYdPD3wd8Hf8/WHfx98PfB3wd/P26N4O+Dv4eCg78P/j74+/P6+3UkvpSb30VT7MUqXsSRuC12j81T//C9bjZNWe/6x1/lw/Gjm6J8fGr6h69V8TIOvK6ruiXc/a2qw/ofG5Qic4EgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1272",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530276",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.72074793",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0KbFpPYkKgh6KCB5KDy2GNhCzUqNQSv/daKvSk7edfcPMZB2kpT62VwUJ7LDUKZq2QgsEUtTW3SDJuuH0hhnjVEYyXMxYSEUsoCc/GNBIivgv4nyCppEvmH+ql01TtL7fP9a6uCinGkgCGhDYK1u5ehQHdIXTfvIgT/r8RVulq9q9xZwLAhujHqNXUiZYRGCFBn2svRvT509NJChxDgEAAA==",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACVVd1rgzAQ/1/yrJJoo9E+lW0w2B7KNthD6UNLQxtwZrhsUIr/++LHWqc5TRDF3Mfvfne5XDYXtN6Lt/MnRxl6knvxKnNxQB5aS1GoL5RtLu2vVuOlflDl3SQ+wXjZfPSLqu2f26osd2ft65MwYAmLPJ9EAWVp4rGANMu+nDJayylJBgqG41oR43SoAJBahxBTYgwRkkU4UIRJ6MgJCj2ZnEPkaUYGoChemJNuFYbygcndYuMgYTQdbUNf3EP5Z30txNi4YT+GbrjPY0whj2iYUzFLIXLGeL1yW2C40xhlAm4jUCXoDEC1Bu0dNgHABnt2vh0sm9/Gw4rRzCmy3W/AGhDPzwAAxG5kWDjYsAEbsKeY727AGBCDI8r1kIBANh5WjOBbym1umq0h8ew1BIC4XKS1g77T78XugyteogwH2EPPvDiqU7d4kWqnhCy65bs4XFWPXBxPqls85Pynb3gnc6kBi+88r7a/3THduoUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "229382.34 /",
    "Friction Factor": "0.016587",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "4165",
    Mark: "553",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "955348.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "219466.6524",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "30",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530278",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.09313928",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jFELgjAUhf/LfV7DLSdqT1FBUA8iQQ/iw6yLXlhb2ApE/O+tsrdzzvdxqhGKhk7DHSGHg2uoxIvXtjUIDApH1j8gr8ZfDErMZZTI1UIsuVKpgqn+a+u+10Nww7AlfUOPPeQRjxgc0ba++xSRKMWgdF57cnbGZ7rOVGaCwR6p7fyXpVIy2Bl8zXrKRSwyBhtnXDi3T2Om+g2fDWEpwgAAAA==",
    Pbi3DGeometry:
      "ISAAAB+LCAAAAAAABADtV1Fr2zAQ/i96doMlWZadPo1tMNgeyjbYQ8lDSk1r8OKReYNS8t/nxXZmKXenc+jLiggN9eXy6dPp9F2+22dxc1d/ffpRibX42N7VX9qmvheJuGnrXfdTrG+fh3/7j9Pr/iUOyb/IlUzT6+Nb/ycOm+lrb/b77VP/3Wwllc6SK6lXxhQmKVZKZTKZh1WZ/Q1LBUSl0SUjWdpjcqE5EAMNmUk3XFgDICOcqWQEmcuDrNIZCIJdljlQkDlrVZQAsBf1Uh1qAYD5kVyCCnJ1ShaIggBOuQI7gHlRi/kIIIX50ag0V5fujO4nBBlpnMA+qG5a1HoUcGh7LkKgcASwf2lhvgsAnFP2eJHCEcDlIMDLYWHG3Tpbzg3bfJKjwh4hJCS5405CyRzOMjeS0nhK+UcaAQQGZUQSVDky1maAsETt4WSOsoJ67QUdtc2s5mownApy5dXx7NpykmHkQjssZFaUeDiod24YwQ7NZndQcOo85ep83lfSZBbPpXHBIEf7AxyW5LrHZ+1wfJk1Fg97ijVFJ2GBMabOmMJDZyxBVtrocPJp226yP23o7ElDwK1g9JZAnzrDKUeINNIc/oLggcPRZcVDwnCXwwsiuTSwWyRW6UhVZJEYEWC1pwcG0hjImPSyYWi691nI2BRHJiXvesM3hZzXCA0kmQR2xYQlMfSkYpGYIC4ba95VW3S3sSURgq/XryOegmnjX8Svh415yDP9/34d3tcCF/9Sfp1y5jDZ6NcDFYp+Pfp1SuOjX+f+sIx+PfwLJvr16NcBGtGvR78e/Xr066/fr28S8a7efq+6ai/W6SpNxKdq99A9jg+f227b1e1ufPxW358++lDVD4/d+PC+qX7PE9+2TdsD7n41zWHzB2UrCmchIAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1274",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530279",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.0074679",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0aaO2nkQFQQ9BBA+lhxZDG4hZqVEope9utPXv5G1nv2Fm0hZkoffNWUECGyy0RNOUaIGARG3dBZK07U9vCGgsmJiNWEhFLKAjHxRRxsPoL+L8B30HPlD2qp3Xdd74bv9Y6vyknKohCWhAYKts6apB7NDlTvu5vTzo4xutlS4r9xRjLgisjLoN3illgk0ILNCgj7VXY7rsDvNunykKAQAA",
    Pbi3DGeometry:
      "MQgAAB+LCAAAAAAABACVVV1rwyAU/S8+26Am5qtPYxsMtoeyDfZQ+pDS0ApZHJkblJL/vnytTdAbDSEhHo/Hc69X3V7QZi/ez185StGz3Is3WYgDwmgjRam+Ubq99L9NN1k3D6rxDVlRQtbdp3lRvfsfdldV2bkZS7yEU45X1Pd4nEQ49mjs4zHKY96inEYTOCZhC4ckwXaNnswIpwZpRgM2gVnEFvgwTzgTiuN8cy40CT8MTAH2sJYkIJTbjIFHmR9oiR7DI40J+xq4Tu5c69Kda7vGnLJmwxyKGYXMGecbJdpBY7kNLRJgCYEcmescyjPAXpB+QBmoUnsZOJS6ne3gZHa/uK4uwAZg2y4HJOxHgpVsdwEU2Qi21y9ABmDgCFq2CQARO9vBCXS/LDsNzWwItlwlgITr9deSm/v3QWSfucorlBKPYPSSl0d1GhqvUmVKyHJofojDtespF8eTGhqPRf47Jt7LQjaC5U9R1Ls/FxqN9DEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.6 /",
    "Flow State": "Turbulent",
    Friction: "160944.77 /",
    "Friction Factor": "0.017055",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "967",
    Mark: "554",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "155604.9",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "181298.5389",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "29",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "17.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530281",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.76892906",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2No0jZN4iQqCDqUIjiUDlFDG4iJ1CiU0nc3at3uju/u6hHKszkOdw0S9v5sKn0JyrVWA4LSGxceIOvxJyOyIBSLLOFLkeGUUJiaP7bqezVENgYbo2466B5kghMEB+3a0H0MYXmOoPJBBeMdSILzIikESykrRMYFYwhO5jrDVBAEO23aLnyXOKUItla/5jbHJCMCwdpbH7/c09qpeQO6C2N40QAAAA==",
    Pbi3DGeometry:
      "dyEAAB+LCAAAAAAABADtWF1r2zAU/S96doPlj1pKn0Y3GLQPZRvsoeQhpaY1ePHI3EEp+e/zHNuxr3Qk2d2gFFFampubo3Ov7odzbl/YzV3x7flnztbsqrorvlZlcc8CdlMVu/oXW9++HP9t3g4vmh92CE6WMx6GF+2f5pcdNv3HPuz32+fms2c8WskkFIFMVrFMskCsoijhQWvnfGLnkc7M01ia3IWUE3cRm1GmZHjCO/u5lDoyiLuTO0K3s3FL2QkH4QsudckB7Dv0KJKRLvOdnQbbmylJCtPfVG8nN+WK3nE3uyuZVOwAZmpGKVAuUGHpdqxygZROd380ZX158CWxulcf18Kg4lPgAflX1aorOkow7EASqxM6vSZK3RwRKD00Uri2Dai3uTvmjjGuLWpAxbWB8WxrzUnTaX9RuHaQj2aV1huB66kPyyON+eiG3HaKsoGmIMuIq8M0O9qFkK1/ZrwKs7dlUoM9QOMkPTGYs1Daxzr01hJ3S62yYRyfBSD6kUscp+1IENJoNs9iZbZaUBR3M3Vz0sfr65jdqA00TTK3TT1FRwvcsnppZgAXhDKTeir6/sLmoRh7K5kKFgwyLJZAN+FI6D3ETrxVJkZ3BRyEA4KfhU0rBRAHJQHOxFevMy/MoWKHnaU9FHSK7VDgbkSxjFA3KqcZr98UYA7rawVtVeBtxqYEZ2Kjhwed2anv9e1jX/raA8FzhvlA4GzCsO02JyKjtTFnE6IuntnzZmxC8P1LC+gbjFVy+FfSwjwJAZF/j9KC5Wu1q+Twf6QFm4Rg0wS8tOClBS8teGnBSwtLngW8tOClBS8teGnBSwteWnDoZC8tvCVpYROwj8X2R17ne7YOV2HArvPdQ/3YvfhS1du6qHbdy+/F/fDW57x4eKy7F5/K/PfY8bIqqwZw91SWh80fL7ZQhXchAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1276",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530282",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.9144605",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABAB9jkELgjAYhv/Ld15jc7OpnaKCoA4SQQfxoDh0sLawFYj43xtpdSi6fe/3vLw8WQ9pqY7dRUICO1uq1OqutgYQpFYZd4Uk68fTF2Y0wLEQbEEJwzQSDAb0g8Ycs5iLb0g4/w8/u/lLYNm2Rect/GOtirN0soWEYIJgL03tmikcrCuc8uJjPKnqjbZS1Y17hnkQIthoeZ+6EaYhFQhWVls/a25aD/kDqYhXmRQBAAA=",
    Pbi3DGeometry:
      "swgAAB+LCAAAAAAABACVVl1rgzAU/S95TiVRq8Y+lW0w2B7KNthD6UNLQxtwZjg3KMX/vti6aeTemCKKuSf33C9zcH0mq516O31KkpMnvVOvulB7QslKq7L+Ivn6fH01MFuYizS0t8w4Y4vLw9yk2fy5LatqezK+Mx4GImYZ5SwKeJZGNAtCHof0AqQhHwI8i672JBSWA5tz6mYyBtiDiQQMMWLic566c0JDo8DNoVEAYxpVzRMmwAb2gGd1feiWScRBJOLU6mtL1NstnsF2qxfA9rYAiB2jwexe2diNhuxIllhUO/u+yV4009kgRdkTmR4tNkH0kLlGDgXwytNvtuA5chGhDrfJh2vCIBMK+H0rNhFkR74hlxJgNB7KMe3gOMCg0KCAlxLYPJDddZhAIXMRoQ5gBU79hnJC1RgFXExQES5NAJrtJxV+0jLK3/wB3Kvth6xlRXIWMEqeZXmoj93iRdfbWumyW76r/T/0KNXhWHeLh0L+DDfe6UIbwvK7KJrNL9v8suuzCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.5 /",
    "Flow State": "Turbulent",
    Friction: "795407.84 /",
    "Friction Factor": "0.015275",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "2680",
    Mark: "555",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2131683.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "425875.7923",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "41.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530935",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.38375999",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyGkoUlJPYkVBD0UETyUHloMbSBmpUahlP67wdaCePC2s2+YmWKAvDan/qYhhT3WJkfbN+iAQI7G+TukxTCdwZBIKliiVhGLqFCSw0i+YBJz/h9KqX7gEjvB8lO/7rqqDxvCIzPVVXvdQcooI3DQrvHtLI7oK2/C7EmezWVBO22a1r+F5ILA1urn7FWURyImsEGLIdY9rB3LF6qpxQ4SAQAA",
    Pbi3DGeometry:
      "kwgAAB+LCAAAAAAABACdVVFLwzAQ/i95jiWpabJ1T6KCoA9DBR/GHjpWtkBtpEZhjP53M43WkJ6XSmlpvly+++5yuayOZLnRj4eXmpTk1mz0g2n0llCyNLq1r6RcHb9+3TRbuIf0dEDOOGOLz497Sb/+XnbRddXBrVUyK5iaU854Jhkv6DzLhZQ0wM9zdcJ5IUKcM3nCc1HQJB5vL2dqlF+5cYBLMUkO5BYJK9Xt32oilkLMRoP1eJQ0KKrArRJ5Ppb7AQ9pBjxMQmTv5Uf8Xj7Og/BHeoCwABhSCXkNk4/z/EtNFFO4tbhK6DykFTLOk4ZD2YFKHLeH+NP8QruIH7mpPFCVQPZAB0gyx2tzWg1CbSSleeEsUCVPbV5p9vgJguwhHLqZIJ1TedJwqAPgJxq5QSP+AXc3/JWunmtbd6RkGaPkrm53du8H98ZWVpvWD5/09mfqpta7vfWD66Z+/214aRrjCNu3punXHz2oY82TCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "71",
    Mark: "556",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "390.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "81",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530937",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.07038291",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABACFjkELgkAQhf/LnJfFXXNNO0UFQR0kgg7iQWnRgW0nbAtE/O8taR0i6DZvvsd7L+8hq/DYXTWksKMKMzJdTRYYZITW3SDN+/H0hljxeagWIhBcJTCwH0R6EslvFqtQ/INjZvEuXrZt2fl2/1hjedFOt5AGPGCw17Z2zSQO5EqHfvAoT3j+oK3GunEvoWTEYGP0Y/ImXIpoxmBFhnysvRszFE9/fIcQDAEAAA==",
    Pbi3DGeometry:
      "TQgAAB+LCAAAAAAABACVVVFrgzAQ/i95ziRaTdQ+jW0w2B7KNthD6UNLpQ04M5wblOJ/X1Z1muQSU0QxXy5fvrvcXdZntNrxt9NngXL0JHb8VZR8jzBaCV41Xyhfn7tfOU2W8kEtHpGbkJDl5SNf1G6GZbd1vT3JtYwGLMsSHJIwoBnOgihMYvyH0nQxQWNKLyhj8QSN4gRbGdIopKZtuiApwKsyMJY5NMB6YQ3X7AaiMIPmG00ZEJ0B9fFi0NAxRBJNommEO44RV1lGXPXbsO91m/wWHivuq0eNrYHbdFr90vX3MfbmmdFj9Us/F3VfODtMazBrZnzSuX1Pdsg+dwT0bHezwNZ6vruqy9QB1wyMujlM1TbcdsqunmdjcXdIt6072/QuC6O+GauyXNsB9G7rZoGtvW6NmcrXbxMQ9e4eKouJ22rNr+qdN56pXN7N93z7UTRFjXISEIyei+rQHPvBi2i2DRdVP3zn+/+px4Ifjk0/eCiLn6nhnSiFJKy+y7Ld/ALGZBR5TQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "306",
    Mark: "558",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1673.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "81",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530938",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.38535085",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACNjsEKgkAURf/lrafBeTqmtooKglpIBC3EhdKgA9NM2BSI+O8NaoW7du++c7mcrIO0lOf2LiCBgyllalRbGQ0EUiO1fUCSdePpCoxTHvnhinlIl3GA0JMfXDCkfhTiPxTZnM6GB5h/BNZNU7TOwj22srgJKxpIPOoROApd2XoKJ2MLK534GC/y+kV7IavaDiFETmCnxGvqxhQZDwhsjDJuVj+V6vM39XZjphQBAAA=",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABACdVl1LwzAU/S957kq/kn7sSVQQ9GGo4MPYQ8fCFqiN1CqM0f9uqtWltGe9lbLS3HPvuecmN8nWJ7baqufjm2QZu9db9aQLtWMOW2lV1u8sW59+Pg3sLc3DGudsWfiet/x+mR9rNr9hV1WVH02sz12ehMLxvcCNk9RJ3SASZmibeRy3dp9HfXucJq09iLhDoencRRKP0hu8bw8EnyUHpL1cFDnrhJoBT8jFaLWdfTBpqCor78IP3DARwWD2+4DF1AfOMzEa0JYwmqKtgcY0kWEoCVYHASgW5bYWgsj0b1HD+tBqI7Foj8CVQAFzVwgmQP1NaRrSRiH40xRN7LgZDQAjIEA4NSAT6Zgh+NMUoY607MSmhxEQQGfc7O2DiAj+NEXoapt/6MIICEzeY5Bnxi1s3M1/gRuVv8paVizzXM9hD7Lc14du8KjrvFa67IYvavcH3Um1P9Td4LaQn7bjtS60ISw/iqLZfAEerfk8vQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.5 /",
    "Flow State": "Turbulent",
    Friction: "780658.76 /",
    "Friction Factor": "0.014994",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "8525",
    Mark: "559",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6655265.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "509917.7011",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "17",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "41.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530939",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.64680319",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjlELgjAUhf/LfZ5jmy7TnqKCoB4kgh7EB6Ohg7UbtgIR/3sjtZeC3u653+Hw5R1kZ31sbwpS2OFZZ2jaCi0QyFBbd4c074bTFwIuaDSXYhHENJE8hp78gjykjIXJN+XiL52Gi0lg2TRl6y38Y63Lq3KqgZRRRmCvbOXqMRzQlU578SGe9OWDtkpXtXuHmZAENkY9x25CBZcRgRUa9LP2YUxfvAC9eKXeFAEAAA==",
    Pbi3DGeometry:
      "swgAAB+LCAAAAAAABACVVl1rgzAU/S95VkmsmmqfyjYYbA9lG+yh9KGloQ04M1w2KMX/vtQ6Z+TemCKV5tzcc7+Sg+szWe3k2+lTkII8qZ18VaXck4CslKz0FynW5+tfY6YL85Am+EdCRumifZkfaTZ/bsu63p6Mb8jiKEnmPAh5lKeMB3kUc54HLT4fokmWXVFOLTy7OLtY4osjsJ/xFOQf8bA0cWWDRcXwW6NiOMYzqjZOUrBrPe5VVR+1ZWGziNJZbjXThm2egcFuA+TR5g9FQKlQg2dOdqshA5osGnpcRd9ub6rprJDyxiOamDQ6UeyauY4AwO+ZpeeYgQvlZsIcbtAP95ABIgz3Pi02E2RAj5FTFlCmaR2Z3O++0IDwYLi3MthMkMF9pwB5czNhDkARTjWHMsLkGcPdRFAJLl2A2u0nFz7qYqVvvgDu5fZDaFGTgkY0IM+iOuhjt3hRequlqrrlu9z3pkchD0fdLR5K8TPceKdKZQir77JsNr/8AePZswgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "223779.47 /",
    "Friction Factor": "0.016185",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "1540",
    Mark: "560",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "344597.1",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "262775.9851",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "32",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530940",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.14048316",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACNjkELgjAYhv/Ld15jm26onaKCoA4SQQfxoDTmYG1hKxDxvzfSwm7dvvd7Xl6eooe81qfuJiGDvat17kynnAUEudPW3yEr+vEMBUooFiIRywWNMCUsgQHNaEQwjzn7gxKWpr90vjzS8qOwatuqCx7hsdHVVXrZQkYwQXCQVvlmCkfnK6+D+hjP+vJFO6lV499BMI5ga+Rz6qaYUR4jWDvjwqx9GDOULxGqzYAWAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACdVtFqgzAU/Zc8p5LUGLV9GttgsD2UbbCH0gdLpQ04Mzo3KMV/X+rcZqsHb4YoxuM591xvbuLyyBZr83x4y9mM3du1ebKF2TDOFtaU1TubLY/ftw4Wc3ewmv89mUgh5s3Fnaxe/dCu9vvs4LhSyEDrRPOJDAORxpqnwVRpzc8BrdUJkJG6AJIkOgFTFXGiVMvQSTwcI47TCyCMpKcrGHwsQY/gY676UkqFw5m3QP8jwgS7wUMRRCqa9utxBnSlzoDuJxliNHkMxWjyoEmNxei7gglCANqFwbv1oEn921U/QVhzaBc2DqwHZPgXCsaAs500fWiNQ2LQXI31oMdkgAwIkNYSKEVbfUgMmis4RbsArQ0gAwJw6fPvKChFYtBcwX3Qf0GGDAiQtjso5bVtO4b7h7gx2Wte5Xs2E4Hg7CEvt9WuHTzaKquMLdvhi9n8Qne52e6qdnBb5J/dF69tYZ1g+VEU9eoLsP5y9vUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "8802",
    Mark: "561",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "80401.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530945",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.38170058",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyHkj9rWk6gg6KGI4KH00GJoAzErNQql9N2NVgt68baz3zAzeQ9ZZQ7dRUMKW6xMhrar0QGBDI3zV0jzfjyDQSVUqEjOOZM05krCQL6gFNHsP0xE8sum1BcrPuWLti27sCA8VqY8a69bSBllBHba1b55iz360pswepRHc5rQRpu68U/BmRIE1lbf317OqFQqJrBEiyHX3awdigfdDFJUEQEAAA==",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACdVt9LwzAQ/l/yHEvaxP7ak6gg6MNQwYexh46FLVAbqVEYo/+70bV2bXrkOkpLki/3fXdJ7tLVkSw36vXwIUlOHvVGvehSbQklS60q80ny1fHUtDBb2Ic0tB+5Chlb/H3sS5p1Z3ZT18XB2oosiETMach4kIZZbBsBz+KMDoAkPAFCpEOA24FfIGYhxVG1FoLzZFJDiKFBFtmJ85wCtX3xobW9TjlMLL2eDLsD3BWEwhtr8yhOJjejB0ZUPTBaEMeiDcOR6MJAMPkkHKfA+ODAIW8h7fFueJku98kNb7ThiJUCUwZ70BFUWABaKigD/PNBAaQyuKvepJxNhAbA8+HPYtgC1MCKg2dwfsFDUGEBMGXAUui3ADXQ4mBVRdw/86mwAFgsEKnvu5FdjTPA/jfcqeJdGlmTnAWMkidZ7cy+7TxrUxilq7b7prb/0INUu71pO/el/D6feKtLbQmrr7Js1j9U4JWP6QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "292.30 /",
    "Friction Factor": "0.027083",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3155",
    Length: "25",
    Mark: "562",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "17106.64354",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3091",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530946",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.05666591",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzyEkpNQ2nsQKgh6KCB5KDy2GdiFmJUahlP67kVb/wNu8mWF3qhHKFs/D3YCGA7VYkh06csCgJHThAboaZxkLSc4TKeRaCsWzlUxhYv8J6+/7jffNEDdEo8DmZoLxoAUXDI7GdaFf4EShCRhnz3jB6y/aG+z68IE8UymDnTWvpZtzpRhsyVI86p7WTvUbg0s6UhABAAA=",
    Pbi3DGeometry:
      "awgAAB+LCAAAAAAABACtVVFLwzAQ/i95riVpurbpnkQFQR+GCj6MPXQsbIHaSI3CGP3vxq2rhuSaVKW0NPddvvtyyV2WB7RYi6f9K0clupNr8ShrsUERWkjRqDdULg+nXw3juX5QF31bLgjG8+NHv6hbnaddtm2113NTFqdZQiKCaVzkJNM/MSU0i74AgnuAMBNIM3YCaFoYAEh1nsFwMXPGYAnNpwGWqunrgGLQWeFkguwwUU4T57oHwEohJBaMbWyG9qM2zWA1UmT5HtUPVmPLPAzjvKYGZzRjdR5hTloz078INq7AHctMedjhd+fX7w6yu3PvJhlPqFVqAST/WOTurQypphAej9V7JEAd07yndhn3mQvpJAE0ngM9Xr9Wgwog+VMHBPSAlxEIBPB4rAFd0N+iw9x7QN/c16J64Yq3qMQxjtA9b7Zq1w8epKqUkE0/fBabAbrlYrtT/eCm5h8/Ha9kLTVh817X3eoTeRW2+msIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2750",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "292.30 /",
    "Friction Factor": "0.027083",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2844",
    Length: "300",
    Mark: "563",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "87.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "17106.64354",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530947",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.71958772",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkbfrrqagg6KGI4KH00GJoAzErNQql9N2NtPWi4G1nv2FmigHyWp36m4QU9lirHHXfoAECOSpj75AWw3Q6g0ioCCOx4syjcch9GMkv6NMojr+gH3jRP7jElkt91nVV7za4x0ZVV2llBymjjMBBmsa2sziiraxysyd5VpcP2knVtPYtOBMega2Wz9mbUJ6IgMAaNbpY89B6LF/Ep/DPEgEAAA==",
    Pbi3DGeometry:
      "mQgAAB+LCAAAAAAABACVVdFqwyAU/RefXdDEJJo+jW0w2B7KNthD6UNLpRWyOLJsUEr+fdImba250VBa6snN8Xj0HhcHNF+rj/23RAV60Wv1rku1QRjNtaqaH1QsDqe/5jGZmQ9q8QW5o4TMjj/mi9pl/9p9Xa/25l0mIsYygSmJI57RBIso5kmKDZ7kSWzhRHA8VN/hYD0l9BqngqWTeHo9KbdglmWTZHY0t3JiwfOxaUEeQD7LYhqkc6rN9rxJlHM+YJuDO/Uens6fM95vF8QP4sftusC2DY4cCL+V028XuKyT/c684HJD7YF0QjbYepzj4JnXv+0+/lAffD4D7eLhgeqD2xHSE9xGnnVNPYfQcR4NJYAlPBuA8tHWCg7m0A71BQwQGFDue3ig+vB7BdIDBTaEj/P4k8S+ENxODE0Gz8UypN/c849q9SUbWaOCRASjV1ltm103eNPNqlG66oafanN+9CzVdtd0g6dS/l0XPuhSG8Lqtyzb5T8U22PqmQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "292.30 /",
    "Friction Factor": "0.027083",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2804",
    Length: "283",
    Mark: "564",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "82.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "17106.64354",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530954",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.39635983",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzyEkTahaT6KCoIdSBA+lh1SXdiEmUqNQSv/d0NbbzLzHlAPkNV37F0IGZ19TgfdgXGMRGOSeXHhDVg5zjIre8ESpZCuF4uuVTGGs/t6u60wf5TgcyDwxYAeZ4ILBBV0T2qlIxaDwwQTybqE3esxQSp0yOCE1bZi60AmDo8XvokvBldZrBntvfTx3H2vH6geIxnXwwwAAAA==",
    Pbi3DGeometry:
      "HxEAAB+LCAAAAAAABADtVk1rwjAY/i85dyVpsrTV09gGg+0g22AH8aBYNNA1w3UDEf/7gtbOmj5LKl4GRSpNnuT96vvxjDdkNFOv64+MDMijnqkXnas5CchIq6L8JIPxZv9qYDo0P7INfneuGKXD3Z95yHZyuHazWk3X5q5Iw0hIHjDKw5Qm1+YlFJzHwTGQxEzuAJE29tPIHDT7PJVNIGGpbAUOKrikzE8U1gGMgroxUEniQiR+1ibcnGwFkKjzrbL8q3TXX4nzqIoUTRuSaoBKsbc2Yg0g4TJpB2rdkrWKEpx5Koc6sFV1DOPY09woEn8qt8zFDrr8sEUhwD8k6JNDa2EuOJMEOt7dPyvqMKWhKHcRQAehDmgVrNlTwDutuhdUndOwYXgnid1ivJuS0yrcpk8BZ9HCMsfAad3AUQBFuaeK9xxyW4WmpgV4N2q7lSAAdwbQSixJzhkP3XPFFgbEf2o689Ad9POnv3/vcSu/HF/oTNK6j4IziMTl+MIlaUF3vtB9OsIb3YeHK4g9X+j5Qs8Xer7wb/jCJCB3avqeldmKDGhIA/KUFYtyWS2edTktlS6q5Zua19BDphbLslrc59n38cFbnWsjsPjK8+3kBzE7OOEfEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1288",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "157",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530955",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.71694464",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjFELgjAUhf/LfR5jl6mZPYUFQT2IBD2ID7MuOlhb2ApE/O+tMujtnPN9nGqEotHH4UaQwd41uqSzV7Y1BAwKp62/Q1aN3xiUaMkjFLhCIXm6wASm+uet+14NQQ7DRqsreeohE1wwOJBtffcuGCeSQem88trZGZ/05Z/uSLed//QoThlsDT1nHQWXKBMGuTMuvNuHMVP9Akheu6vEAAAA",
    Pbi3DGeometry:
      "vR8AAB+LCAAAAAAABADtV99r2zAQ/l/07AVLOklW+lS2wWB7KNtgDyUPKTWtIYtH5g1Kyf8+N5azSPZn2XkWoSH29X59991Jd//K7h6q7y+/SrZmn+uH6lu9qx5Zxu7qat/8Zuv71+5nK85v2g87Zv/fvON5fnP6av/YcdOr3R4O25dWl+xKCm0ynsuV5apof6yIOM8uBUVu+ZtAWm19gTBqXAMKDNcngbKUzXPuTEklzLyoelMLNCQtNAU1olENEsThOqykJJqEhBRJ3xSX2hOcNXoBz7kfbqgxMGWE9qO62ofUyk5rnNENNQZRRTUGPmCCEJLFPiSZcaxgHq1l5WuIQk6z5HpTkFeY7bPbwBbWFyglJgXLa47RhZlDU1AAM4cJ6oJ8+hQqaOdwkEH6xE3FBvJwlkBBSAYIIhbE2L5gMqDMMVZIADNHeZDoBdxpGGM7gXUJkjCnEZ7rzkdBvfOODCSEnZ6J0IcUwgkK6Wl0Pi/C1a5xUFTQubTWLxS1b+adzvg8d+ESt9MFRFBhTse7wPeNsYWTHYKO64dAh86hKXigLq840phR8aCwmOvIFMwcFhC3P2JVnDwhP6FvGC3sZYgIdB4PN+yzaJ3w7VGoyx7ogHt7XXTnluHTV13iRvQeqEuPOiZo6SC00ow2x+DQhGcjdg7CJemcW0HB0YE0YFQQQshoCAm+O6KooCmsge5D8AYFBwmsIJwwGHYQ1UQeUSYGzEVIwWCRxhWFhT4QhJBVOKrxvNP2nbbvtH2n7Ttt32n7Ttv3yMU8bd9p+07bd9q+0/adtu+0fafte5JVS7bvTcY+VNufZVMe2Dpf5Rn7Uu6fmmf38LVutk1V793jj+rxLPpUVk/PjXv4uCv/Xv7j+3pXtwb3f3a74+Yfb/arGL0fAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1289",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "202.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530957",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.46823269",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNIbJqXK1FB0EUpgovSRdXQBmIiNQql9N+NL3A3ZzjDVCMUR7sfrgY0bMPRluYUG986AwiKYH28ga7GT0wKU5hRQueUZFgKymGqf96i75shyalY2eZioulBE0wQ7IxvY/cCmvMMQRliE23woCnOBRGKZzMuFJOKcwQHe/6XN8a2XXwzyyWCtTOP71phKhlFsAwupC9/d26qn0/6TKjSAAAA",
    Pbi3DGeometry:
      "ex0AAB+LCAAAAAAABADtV11r2zAU/S969oK+LMnp09gGg+2hbIM9lDyk1LQGLx6ZNygl/32yYyexquPr7GkPorRUJzdHR+defdy7F3Z7X317/lmyNfvU3Fdfm7p6YBm7bapd+4ut716O//qP+Y3/YYfsjLwRnN/0f/wvO2zGr73d77fP/ru6WCmTF5ngalWI3GV+rDKPaitNjzorzBnNtYrExlHBxRFVWpxQMNvI4KTNCQ0nhiWx2i5miMcSGiarAMpGHxwvBLHiE4N1TnlUcqkn0SE+qhtxbcwsz6hlwIXzqfkH/lfxBXcTDyk9RDzkR+tCPlzJH/qjupTN6L/IbR8ucjlTYNeRxOuGoF5Q0We0F5FbtwBdmE/kH+UTleYQB8u8lH7euIZ3sbKjwkcNKgjEMn88xrmXHAtkLUTh0G5qNeF2oLwKeSgcrXQi3mh5hHNpOxI14KoYwp3oyaUdFjWmubB9vBVxMeOZgPiN0pN4qfOpTN2hQs+LAZOeLj2hzbEa8V0I7s1RnyuUjdxDYYqAK/ECRSzxOZGDqIyQs8gsZC6alzI9vNWuymg0GKQznjiKOSCh3EVHDnJ9mjtqt4DXXlgXKBOAndouwasPsMR3S9xG8BTLjX1tilc/3B/aHJfj9Nwz0QynmXe8jy76clZ+dFltxfzbjbpvJ1MigbmV051FxCMt8dc3chasH5FDMYCHygZ6zE3vebD5QZai2xzai5TANCE8Wo3Al7hEKnhZ7uLcREEHTQ7KZnyNqbnEsam5jF5oqblMzeUV/qXmcumxkJrL1Fym5jI1lzNHTmouU3OZmsvUXP7vzeUmY++r7Y+yLfdszVc8Y5/L3WP7NAy+NO22rZrdMPxePZw++lhWj0/tMPhQl38uA981deMJd7/r+rD5C9YDKQV7HQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1291",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "202.6",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530959",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.78715946",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnJdl19ZKO0kFQR0kgg7iQWnRgW0nbAtE/O9taEJdus2b7/HeyzpISzy1Nw0x7KnElExbkQUGKaF1d4izbji9QYY8VJFaSaG4kMECevYF50EU/YeeqV84xQ4w/9QnTVO0foN/bLC4aqcbiAUXDA7aVq4exZFc4dDPHuQZLxPaaaxq9xY+PmCwNfo5eqXgM6WWDNZkyOfahzF9/gLAiSxgEwEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABACdVd9PgzAQ/l/6XEkLHRvsyaiJiT4sauLDsgeWNVsTpAbRZFn4360IMmhvPQzhR++7ft/d0WvXJ7LaqpfjuyQpedBb9axztSOUrLQqqg+Srk+/nwZmS3ORmvaWK87YsnmYm9Sbbtp1WWZHM5fPgplIBOVMBIwvzDuIkjihA/u8MQuxGJqjKGyAmHGK4mkniCiaOwSEGLrzMOST4oFkL6aFVvWEY/GwHzdHsh1gl82d1lg3DpPEWf8eGBD15mEdRu5t/BZ7F7+f5iK9FQ2YFpyvO05Adlx/D81/w7HzGv1ef33ArsCtZwQRFnDXyL3Qfb4gNUoT/I2erptIggbA5eBvU3gGqIEVBxfd9N0MQYUFgA4B9jmfN8iOlAW3S+9xMpUGC0A7gr/BPeeqLXAGmJP/VmVvspIlSVnAKHmUxb46tIMnXWWV0kU7fFW7P+heqv2hagd3ufw6d7zRuTaExWee15tv80OWkasIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3155",
    Length: "25",
    Mark: "565",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3091",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530960",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.57255231",
    Cost: "0",
    Pbi2DGeometry: "CAEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCgxN9cwNjY2sDQ1M9AzMlWp1qC0VC7PWsagosRJoN1DAJTMxN7UktUjJykDPQEfJJzUvvSQDygnKL0ksyQQ6F8INz0yBS3mkZqZnlIA4lhbGZjpKrjmpZVC1lnrGxjpKzvk5+UBD80pzcmpjAbmhOp4IAQAA",
    Pbi3DGeometry:
      "GQgAAB+LCAAAAAAABACtVd9PgzAQ/l/6jKSlozj2ZNTERB8WNfFh2QPLmq0JUoNosiz871ZABuPag8wQfvS763fH1951dSTLjXo9fEgSk0e9US86VVvikaVWWfFJ4tWx/jRmujAXKb0TcsUoXVQPc5Ny/TftJs+Tg5nLQj8SIfcYnfk0Mi+fMy68X5jxoIbZdQ8Pa5RX5hNsYam9GRVzkJwFAZtmOE9nYvY2fiEYA3gssJ0mEjPwj1vDQDhLprbIHfnnPucDihbsCDNwrNJu0c4aOWe7GHuhwTDdH0ISgkj7yk4P5QwPBuprjO9vSE/M1cIKKQ1Nd8s3qCGU4t8qF161MYUyhgdBkdW3ZjHJeVrvgDfXmP6AsyAb11mh500Hp7ikp8G5WA4UC4xRODGkq2F9FndtYHPO3qnkXRYyJzH1qUeeZLYr9s3gWRdJoXTWDN/UtjU9SLXbF83gPpXfXcdbnWpDmH2labn+AQOoLQgZCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2750",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2844",
    Length: "300",
    Mark: "566",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "183.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530961",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.18416925",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LOy/Lrrnq2ikqCOogEXQQD0qLLmz7wrZAxP/ehtohgm5v3jfMTN5DVulTd1OQwh4rnaHparRAIENt3R3SvB9Pb+CCxjETS84CmkR8AQP5BRdUJlH8DSMh5D84xxZz/apty85v8I+NLq/KqRZSRhmBg7K1ayZxRFc67WeP8qwvH7RTum7cW3AWBgS2Rj0nr6RchoLAGg36WPswZiheICKF/xIBAAA=",
    Pbi3DGeometry:
      "bQgAAB+LCAAAAAAABACVVV1rgzAU/S95zkLiR/zoU9kGg+2hbIM9lD5YKm3AmeHcoBT/+8LUVo03iUilOV5Pzr3Xe7K9oM1evJ+/cpSiZ7kXb7IQB4TRRoqy/kbp9tL+VY/pSl2owTfkjlG6+r+pH2p2/WvrqsrO6l0WkijEjHok5szHCfFiX61DwiMejHCaxFiP7lAwmvneEGdJEC5g6bVwxkZ4wPkCjR3LVIuXxJFpV4BlVnnEQ99J4bLqDvf0SRLzSK+Whk+ijRxdTa543x+IG8TbDt3wcf6aGgif6ul7BOTUVl3bFcjVpS6QPij/sRKt/4Y9bV22MbvlbqsrMBNGlvlo53mDtDjPiiWnpd8c+O2aXQficfcAKN48S87e6zyTNj8BPALydgsPFO9+dkB65p15HjVx2Jxj7Pn6BLp5geXk0HWrs/tBZJ95nVcopYRi9JKXx/rULV5lndVClt3yQxyuj55ycTzV3eKxyH+HgfeykIqw/CmKZvcHy5iwXG0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2804",
    Length: "343",
    Mark: "567",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "209.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530967",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.2048027",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzyEkNq1ST6KCoIdSBA+lh1SXdCEmUqNQSv/d0NbbzLzHVAMUDV37F0IOZ99QifegnbEIDApPLrwhr4Y5RkWmPE0ytZVCcbGGsf5bu67TfVTjcCD9xIAd5IILBhd0JrRTkQmD0gcdyLuF3ugxQylVxuCEZNowdaFWDI4Wv4suBU+U2jDYe+vjuftYO9Y/5AdLCcEAAAA=",
    Pbi3DGeometry:
      "vRAAAB+LCAAAAAAABADtVl1rwjAU/S957krSxNbq09gGg+1BtsEexAfFooGuGa4biPjf12nsVpNjUhH2UqTS3NPer96ck/GGjGbyZf2ekQF5UDP5rHI5JwEZKVmUH2Qw3uxvK5gOqx/ZBr+WK0bpcPdXXWQ7Obx2vVpN19W7rBf2RCoCRkXIaJxWN6HgPAn+AjTZmUXasLIoYj92nsZNgLK+1X7wz2PK/DzhENaMUGBo33nhQvT98qScR3bA7ui8fIyqdNT6s/BY58lS3vBTA1TsA8QRawCU9yI7oCPHzOpIcOYZGkbAOeneJYlnqhHtnwxtJIuKc9VgOkKAfzvsnxpkCifAORqg5PaVGd1GMww9OYceFociwJTg9jwGvGep7Q6qxxgwg+dcmEziyTyObDADHwOO3Ql3MwaOtwjkeOjKLRfeAuPOCmmhAXizsckaCEA0YOUMw4tDtWFhrq7CVvjKoXP63M0+U9G9OcYd+EJHgJZnrbZEf8bR4FIngMsJffsTQFvVA8+3V4XTzevUv1P/Tv3tPNip/3+p/yQgt3L6lpXZigxoSAPymBWLcqkXT6qcllIVevkq5zV0n8nFstSLuzz7+vvgjcpV5bD4zPPt5BvEP10evRAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1296",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "362.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530968",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.52575874",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjMsKwjAURP/lrkNITB9SV1IFQRelCC5KF6le2gsxkRqFUvrvRq3gbmbOYaoRioaOww0hg71rqMSz17Y1CAwKR9bfIavGbwyKjHkq1WIlRcRFClP9s9Z9r4eghmFD+ooee8gEFwwOaFvfvYuME8WgdF57cnbGJ7r80x1S2/lPj+Ilg63B56xLwZVUCYPcGRfe7cOYqX4BmWT/ksIAAAA=",
    Pbi3DGeometry:
      "HR8AAB+LCAAAAAAABADtV11r2zAU/S969oK+FaVPpRsMuofSDfZQ8pBS0xq8eGTuoJT892q2nFm2jxX3taKkJLq6X+ceXenevZKb++LHy++cbMh1dV98r8rigWTkpir29R+yuXttvzoxvXB/5Jj9X/nEKL1o/rkPOW47tcvDYffidJlaaW5txqhcMSa5+7KSkrGsL6DUqH8CYbUNBVzZaQ0oMM2ysjI7z7U3JBQ358XUmVqgIfhCU1AjGtUoQRxug5QQUs4CYpSRoSEmdCA4aXQCF30Y7FBjZMpJ+jG924PWdl7hBOxAYRRRTGHkAeYG0VjqQis6hRJKQUup+9v5WswT4512AI8wt88lvaEDfJTis+tLi4wABQkjK2gdJYzi14apkClrNTiyw2aFmBK3FOu443YBBWH9AXhgeZ7S5597mDBCCK3DdKcTMLxbZn6/MS153Y5W0DRk15ipbj2s/Tpvqy85t/PNDrtQwgt02DelCkqj/flAIWHXtNNob1Vh7UTpR5ctvpx9oJLZ+aoBjDB944QPXWNQYbuGaEP0IN7QOTQFLsilhQb7Y2Ue1BPbnzYE84VlwwcdUSnKmCEnoWsYLDq48KRD39Fgg3MVKw9++nEhA84z/0Thpr2QDJt/qBpOu0eNWLepyZYBWnuQLGeTh2H0DEKXHvYNojXC+2YNbP1GiTRQUBBCSGSEB0wbxgRNQQ30vIHvIdA0YO1QN0F4w4Bw0lEGDimLUAKxwv1LCwrsI+wwk5AHlHKaltO0nKblNC2naTlNy2laTtNympbTtJym5dlg07ScpuU0LX+4aXmbkc/F7lde5weyoSuakW/5/rF+8j9uq3pXF9Xe//xZPJxEX/Pi8an2P76U+d/+xquqrJzB/XNZHrdvl1SZSx0fAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1297",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530970",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.31176027",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNI2iZp40pUEHRRiuCidJFqaAMxkRqFUvrvxhe4mzOcYeoJytYcxqsGCTvfmkqfgnKd1YCg9MaFG8h6+sSoUIYFTZMFJRkmAubmZy2HQY1RjcXaqIsOegBJMEGw164L/Qso4ymCygcVjHcgKWaCiIKnCRdFlhecIzia87+81abrw5szliPYWP34rgtM84wiWHnr45e7Wzs3T1lNX8zQAAAA",
    Pbi3DGeometry:
      "QR0AAB+LCAAAAAAABADtV01r20AQ/S86q2Z3tR9a51SaQqE9hLbQQ/DBISIROFZx1UII/u/Vpy1Z80ZyTz0sJiYaj96+eTOzu3P/Ft095N9ff2bROvpcPOTfil3+GMXRXZHvy1/R+v6t/bf6WdxUn+gYny3vpBA3zVf1Fx03/WvvD4fta/WuNCtrfSyFXkmpVexXSRJXRueMa6zCnW3GacKTtspEtdZEmZOVXqoHEMp4lkD/+ryjEctephy5lUfEaTp94EI4MxNjC5CsfGrrpZRQeuA8tbfEznZtLQfTMjnZZarlv8BP/L1IB9rN0plxh/AgKiTClfCX6iTCS4b9IK1S1+7SKFxV12HQJcMgLyjis02l9VrKuHSBfWkykXq8TLM5HplhlGPm53Y1ae2t0pTbVlA5IBRuH6SQl20H85VA2ady89FMm4HXaorD23GsY/a29zZS1ihJZ9eq83e+QVeujcrWq9R2bxt/J2k2/ZaA8G0d9cBfaTPmmbSVJDVLBy17OuJk0tYjPvjAIdkSrANVkjh/LpKEZKFKFGKQKyIBURkhYZFSMNFgXV7x6Yl2ZUKBO51POnNz0GMMXl+06SDdJ9lj2wVe7C4rAzURQOe7ZVLpAIXuFlJF+g5mvJ9KYk2nkzZtLKlmroWmsznV+Pqmlq2vZBjWmmfvbPPnrZtlZ8W46tWMO02EvGIjQenQUYiIB43C5gDd36bHO+h5lB/Q3FhcRAewB2ayCoEykOKM+6LkIXC2nKeDDUgpCJPbZsL8yMi8+MIY5scwP4b5McyPYX4M8+PgVh3mR3LdMD+G+THMj2F+ZHo+zI//w/y4iaPbfPuSldkhWouViKMv2f6pfO4evhbltsyLfff4I388/fQpy5+ey+7h4y77M3T8UOyKCnD/e7c7bv4Cm4pv80EdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1299",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530972",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.05516069",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdFpTHXTlFBUAeJoIN4UFrWgW03bAtE/O8tqUF06DTz5nu8N3kHWUWn9iYhhb2tKLO6VdYAg8yScXdI825YvWGGPE4iXKLgCz+hZ18MhQj/sQTxh02ZAyum6lXTlK3v94cNlVfpZANpwAMGB2mUq0dxtK505F8e5JkuH7STpGr3FnGEDLZaPkdvGPBIxHMGa6utzzUPrfviBRh9Y34PAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVVV1rgzAU/S95TiWpRhP7VLbBYHso22APpQ+WShtwZrhsUIr/fWJt16Xe3gRRzPHm3OPN/VgeyGKt3/afJcnJk1nrV1PpDaFkYXRtv0i+PBxfu89s1l2kpX/IhDM26x/dTdrVadu8aYp9t3ciolROBRUqkgnnlLMoZiKlF3imUnUTT5T0speZ7PFplvnwQHok782nKk183J5pXHrB4jE5oFuAB5R/lBkLqXzo0SgMuFCKj9lf4QP/CXf9ojzOaWH8oN//p4XJAXHntK7sHflO9LG/BWkCow9GGYumm1RQrYTyeOJA2IBcRqzR1PQ7K7BwwzRCLJ44lIBQG0HtAzMNTXy3TYXqxNodggN1DjRrzDq0K4yzg6MgSCM69xAcqn20lrE5eaPzdvP9XhcfpS0bkrOIUfJc1lu7GxYvxhZWm3pYvuvN+dNjqbc7OyweqvLn0vDOVKYjrL+rql39Aom3zYyRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3044",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3140",
    Length: "25",
    Mark: "568",
    Material: "Copper",
    "Middle Elevation": "3054",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "109.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3054",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3063",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530973",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.21770224",
    Cost: "0",
    Pbi2DGeometry: "CQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnRN9UyNzcysTS31LAwtlWp1qC0VC7PWsagosRJoN1DAJTMxN7UktUjJykDPQEfJJzUvvSQDygnKL0ksyQQ6F8INz0yBS3mkZqZnlIA4lqZmOkquOallUKWWesYGloY6Ss75OflAU/NKc3JqYwH2SW+nCQEAAA==",
    Pbi3DGeometry:
      "ZwgAAB+LCAAAAAAABAClldFOgzAUht+l1x1pBwXKroyamOjFoiZeLLtgWbM1QWqwmiwL725F1AY4bZUQCP05/frTnp5uzmi9k4+nF4EKdKt28kFVco8wWitZ61dUbM5fr+YzWZkLtfhXWVBCVt3D3Kjdfne7aJryZPouWMRYnmHGo4ynHFMSLVO2xJ86TZhLzxNKg+IJS7p4GoaB7MRp2ul5lgcN23NG/DTjU3agYSEMZL+3mTMSB/E90+Acl0cx4XQ0C5ZsjzqOHkKslfKjAdleJr8RQLbWaBw8dG3PuP8fAQgguyFD2wGZDrADwgG4c80CpwrK2QDKnC0BuIEyH9IDMH55OuPctcLBmFGInLkPlaeR7qf4ZWArQ4U4gDKnzgNuPKeUE//vIje96dzb/2/FwvZtTu0rWT4LLRpUkIhgdCfqgz72jXulSy1V3Tef5P7n042Qh6PuG9eVeLcDL1WlDLB+q6p2+wEsKtjLZwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "291",
    Mark: "569",
    Material: "Copper",
    "Middle Elevation": "3035",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1260.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3035",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3035",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530974",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.05013443",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzG00a1NPYkKgh6KCB5KDxVDuxATqVEope9usPUHL9529htmJmshPdK+uShIYGOPlFrdlNYAg9SScVdIsrY/vWEUCj6OohlKPo0FQse+GHKUMvzHYsQf9snsWf6qntd10fh+/1hScVZO1ZAEPGCwVaZ01SB21hWO/OReHuj0RmtFZeWeIhLIYKXVffBKLkKcMFhYbX2suWnd5Q/5oY0qDgEAAA==",
    Pbi3DGeometry:
      "PQgAAB+LCAAAAAAABACVVVFrgzAQ/i95tmKsUWOfxjYYbA9lG+yh9MHS0AacGS4blOJ/X2btmtXEOxHFu3z57ksud1kdyXIjXw8fghTkUW3ki6rklgRkqWStP0mxOp5+zXC0MA9pg4tnRqNo0X3MS9r1edpN05QHM3dG43CepgHjYZ5QGvAwjhMWWO6Mp3zEneYZBp1n+a87MSZM4lGS0w5MWYKIeOa4pmbR3CHEF9FN4pN90pdlHEENLL1zs5BxTgfoobvjvrj/hYRJ7NyA3L6QVm5AIT63nZsh+kq2vdvgGn0ck3bbl8nx/Rs7OzDaw40I6d4p92kFdbgpEGBQhadMp+R8WnJ9HQBx+NBtZAwNKxnvRdOKBll5zs6KqGmoOSPAkArg/kH1oWm9zHdZIfok+sYzaHMX38nyXWjRkCIKo4A8iXqn973xrHSppap7801u/4YehNztdW/cV+LbBt6qShnC+quq2vUP277R0D0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "4324.64 /",
    "Friction Factor": "0.023892",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "2063",
    Mark: "570",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "8919.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "30065.90219",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530977",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.87056279",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjEEKwjAURO/y1zEktQm2rkQFQRelCC5KF6l+0kBMpEahlN7dqBXczcx7TDVA0Zhjf0PIYe8bU+I5KKctAoHCGxfukFfDN0ZlJqiYS7kUGV3wDMb6Z626TvVRjcPGqCsG7CBnlBE4oNOhfRfOU0mg9EEF492ET+byT3dodBs+naUJga3F56RzRhMp4rb21sd397B2rF/gV0oGwgAAAA==",
    Pbi3DGeometry:
      "dRwAAB+LCAAAAAAABADtV01r20AQ/S97Vsxqv9c5hbZQSA6hLfQQfHCISASqVRy1EIL/e1RLciXtvl05h5yWkBA9j9+8+dgdzd0rub0vf7z8LsiaXNf35fe6Kh9IRm7rctc8k/Xda/dv+zG9bH/IIfuPXOSUXh7/tL/ksBm+drXfb1/a717IlbQ2z6Rdaa15ltMVZ1pnY9xYdcSlzse4EUb6cGif2yOsLF9CYxTVITnMGpYtkD/wO/aAB/mFeiJ+QRqYUYvUzNVzpcZemZIdrtSUZ8B7+0H9CaeaTfhnOOJBfh0epEcbPs5CTA5yC8ISVgbYHTERr07SUFAoCah1pLATnFoRLLoRYhyWtjbeUajvHRyJiVTWwSMi525BIwCWc8WgoFBle/vTYZ5VxDmeqBNiPJE7dvElNS05SBqAQeYjN4hzBFGokUPi4ChUoJ7pDqbtx//ctvMkOH24kD3eJd6ajibv1BvubRwnqnOzgPiBHKEnM7KlXTA60aTFOO9ECvau3MDZcFZMqIBsYp1THrjQvbZQn98a6UAsKLmIJ1xS5yaI3kCz2sFggRxQJNjvfnOkBjRqpK3nr0iDds61ryTunO5EGjEVGbnknaHQ97uRwlvxFte+YzN3i+hj0x69cM7douygbILkA/Uox7HkzL0CehBU+IXNI8Z3kuGw90s5NyKUd0QPzNF1GLrK3AQAcj9L2uwWHbS02QX8ps3Ox5M2u7TZpc0ubXZps0ubXdrs0maXNru02X3QZrfJyOdy+6toij1Z0xXNyE2xe2ye+odvdbNtynrXP/4sH04ffS3Kx6emf/hSFX/Hhp/qqm4Jd3+q6rB5A6mDqb91HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1301",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530979",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.63343266",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yi23TTTlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhokbP3RVPoUlGutBgSlNy7cQNbjR0ZkxjBLOZ8zgQsqYGp+1KLv1RDRGKyMuuige5AEEwQ77drQvQylGUdQ+aCC8Q4kxSwnueBpwnORFYLH9mDO//BGm7YLb0+yBMHa6sd3LXBCGIKltz5eubu1U/MEwd7Qx88AAAA=",
    Pbi3DGeometry:
      "MRsAAB+LCAAAAAAABADtV01r3DAQ/S86O4tsSZa1OYW0UEgPoS30EPawISYxuOuydQoh7H+v6tW22mGe7PRYREiIZmffvDcz+pi7V3F73315+d6KtbgZ7rvPQ989iELcDt1u/CHWd6/Hf/3H8tL/iEPx13JRSnk5/fG/4rA5fe1qv9+++O9emJVRdV0Yt7LWqsKtlHRl8dssbTWZG1cz5kY3Zt5bOzM5l24BRODR1NLG5rouOR6AdfCm2GkQGjJtBomiIW2jGO2ACKDtXBlFrLQnEJuPIJWtz7wDbeodsKvS02VAqJkPeQIhIRGTSXvV+EwsIAIiAjVHaGkWaAEBATLSQpSDHjHaxdi1Xybq22gdiXF+Nds5oLOpGfBIl5GaeXrpXiU15yHeRmNGCylj8D61E6kA3Xig6AAkfeiATU3NfHn5RKXTx24v0L90ewGFMyDEDBTyrCt7tEq/9mZlVeqeUdoE88Rak42upg5RpVsi5o3Sz7F5IrJxkURjZ287cI9Sc1UFs1L/nA1wGi4Xgkpl4rIqbtuH8zjhSFlxriA8QECZBO3G6QX7GjQKqBGgB3jw1UDnDuvM8wBdyMkGL5cTY6Usk356mwZujeZaExzO6Cg3uo4bOQj05vN3GBsRQAMzuL5BRJAR9BZmWyyZJvBCIflAD2cWGkhJvZ8oDW5vonwm5S3TAbIM5IGScLlPnVtEMoDlEPLclOemPDfluSnPTXluynNTnptwqfLclKpRnpvy3JRosTw3/T9z06YQ77rtt3Zs92ItV7IQH9vd4/gUFp+GcTt2wy4sv3YPfz760HaPT2NYvO/bn7Hj9dAPHnD33PeHzS+AouWEMRsAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1303",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2174.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530981",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.92654943",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkTfpjPYkKgh6KCB5KDy2GNhCzUqNQSt/dSKsXBW87+w0zk/eQVfrYXRWksMNKZ2i6Gi0QyFBbd4M078fTG2Zc0JiJeCEF5Uk4h4H8hkEUyS+Y8ET+hWNs8a5ftm3Z+Q3+sdblRTnVQsooI7BXtnbNJA7oSqf97FGe9PmDtkrXjXsJzmRAYGPUY/JyRoUUIYEVGvS59m7MUDwBPyrAQBMBAAA=",
    Pbi3DGeometry:
      "7QgAAB+LCAAAAAAABACVVl1rwjAU/S95jiVp00+fxjYYbA+yDfYgPlQsGuia0XUDkf73FVfb2vSYBlFMj/fec79OXJ/Iaivfj18ZSciz2so3lcsdoWSlZFF9k2R9+v/awGzZvEhN+ycLztjy/NG8Sb25mN2VZXpsbBfcc0JXuFR4Do/8mHLmCM8V9AzEYTwEPD8K6ZRFD0CLgPMrQHi+nauOVcS9a1exH9jR7RMcsRIiNATHrmAeLJ7F1r7qWmw3CMRkDXVgZDHDVVuqDugaCGMg4NLADhiXRGcFgRGrvoEwQRZPx4aJzy0VZAsrYk1qbKAPFXpuSsJi0GHJ4TKZmmQc6BnBTRMCWcHdh301bqwmVVpjoYYZdwMG1+jOXjNtMSErKGJw1O1vCF1g4NVhkiQY3ELdTHoIWcGbDiqMxTWL9OK2LEB9gZGHXJv/Dg8y/cyqrCQJcxglL1mxrw7t4VVVaSVV0R4/5K6DnjK5P1Tt4THPfoc/vFe5ahwWP3leb/4Asdsgy+0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3059",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3154",
    Length: "25",
    Mark: "571",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3090",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530982",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.88912708",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNjfXMzQwNrU2M9YxNLM2VanVoIxkLs96xqCixEugGoIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSCXQ2hBuemQKX8kjNTM8oAXEsLYyMdZRcc1LLoGot9YyBAs75OflAQ/NKc3JqYwGPxB3zEAEAAA==",
    Pbi3DGeometry:
      "bwgAAB+LCAAAAAAABAClVV1LwzAU/S95zko+ar/2JCoI+jBU8GHsoWNhC9RGahTG6H+3dp1LbdKbWUpLc09y7rk3NzfLA1qs5cv+XaAMPai1fFaF3CCMFkqW+gNly8Pxt4HJvHlQjc+WGSVk3n6aF9Wr07Lrqsr3zdoZ5UGcxikOecCT6ApTEnDKGG4BFrIWoCy1A/4ryNFFmMaeTCdRA6aI0h+ApXHk6dsVX0I5tatyOgdTNQA6uSGhiaePi+PoOU8Dzoc8Z6tJMpzbtxqbBtHareZeDSXYhfWsvS2CgjBTDYVmZxhPjoderzq3a/OY7iIf3SefHDmLFCaZeArsepyV7gRgHsBqrzS4RbhJpvUgoPKdzeEv4MEDWe2n2NmHYZKJjd6uB7ysRh38r79ZDx7UAi5rGIbq5va+lfmb0KJCGQkIRo+i3OpdN3hSOtdSld3wVW5+oXshtzvdDe4K8WVOvFGFagjLz6KoV9/cZLy/bwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2750",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2750",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2844",
    Length: "299",
    Mark: "572",
    Material: "Copper",
    "Middle Elevation": "3049",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "183",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3049",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3049",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530983",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.351947",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkaWpoPRUVBD0UETyUHloMbSBmpUahlL67kdYfvHjb2W+YmbyHrNKH7qIggS1WOkPT1WiBQIbauiskeT+e3jALOI0iHi5ESAWTMJBvFtK5lPIf4zEXP/ATOsLiVZ62bdn5Bf6x0uVZOdVCwigjsFO2ds0k9uhKp/3oUR716Y02SteNe4qACU5gbdR98sY0iEVEYIkGfay9GTMUD33DE9AQAQAA",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACVVV1LwzAU/S95zkqafqTZnkQFQR+GCj6MPXQsbIHaSI3CGP3vRtvpYnebW0pLc3p6crg3OVkdyXKjnw9viszJvdnoJ1PpLaFkaXRt38l8dexe3We2cBdp6R8yixlb/DzcTdr16berpikP7t9ZzKMs4wlNkyiJuaQy4kwW1MOLPBvDiyRD8VMWF994muc4HchPKoXDY5ni5j3p/NfnUuQX/UDzAjqg/84nl4XA6Qfq0OFJlAshhvwh3umf4d68YR2/Xwh9CPf6hfAD4H6/hvxBHbz6I+oG6UytP9DfUD3H11WYD+nj5oXqBq1nhH9IB8VH+IH249T1MLHvUG7g1ic+f8b5YT+hHJu6v9B5AuUzKgcQOY/iI/wEzjV0jk3MQ+gcxOUt/jx1fHfe3+jyVVnVkDmLGCUPqt7ZfT94NLa02tT98EVvfz/dKb3b235wW6nPc+K1qYwTrD+qql1/AVJ/71ahCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "2804",
    Length: "343",
    Mark: "573",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "209.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530989",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.76324619",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG5ubW7BQVBHUQCTqIB62hg7WFrUDE795QvL3f4/d45Qh5Y27DW0MGF9+YQj9C7VqrAUHujQsfyMpxiVHZUIaloHTHGaYyUTBVq7fv+3qIciyOpn7poHvICCYIrtq1oZuBMgSFD3Uw3kFGcSqJVIIlQiq+VUIguJvn4lLKI561abswM+EJgpPVv3VNMOMsRXDw1scv97V2qv6HVnYB0gAAAA==",
    Pbi3DGeometry:
      "GxEAAB+LCAAAAAAABADtVl1rwjAU/S95zkrSpG2qT2MbDLYH2QZ7EB8Uiwa6ZrhuIOJ/X6nVatezJs6XQRHF5PSe+9H7Nd6Q0Uy/rN8TMiAPZqafTarnhJKR0Vn+QQbjze5vAbNh8SFbWt9cccaG5U/xJdvJXux6tZquC9krLrwojmIqhcdVEFPOPCl8SUsg5PwEkFFUAoqLE0DEQbiTYHH7fUOFCFQHE1aBjIK60X2DSEgR/G5s5Eu/HYBUf7Spdq6h+vCOFGeiBCK/GfIgPgFCpiqqULQDe+UVIKVUrVRSsC7lUAe0qqFcyFB2UHGurJQfzIUOWvtRUyHgjJDAdw7fB0oGDGAqVwdx2FFOQyYogLxAAjgTUMFCwDap3MupzmjYLWxT5EjCuSNBq2DXgwCmQkWOAFg1eAxgKijhPoNgb0UTEwHWbbquDgjAWoaNpJPqpwT0wzK6MCQWKWqbid1hd5/9zr0Hqr7csuC8n7nPgTPWiAtuCxdcCty3BffRCCXch4dtEPttod8W+m2h3xb+zbYwoeRWT9+SPFmRAfMYJY9JtsiX1eHJ5NNcm6w6vur5AbpP9GKZV4e7NPk6fvDGpKYgzD7TdDv5Bo702uobEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1308",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 0": "30",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "15",
    "Nominal Radius 1": "16",
    OffsetHeight: "15",
    OffsetHeightTemp: "0.004101",
    OffsetWidth: "15",
    OffsetWidthTemp: "0.004101",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "362.8",
    R0: "15",
    R1: "16",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "530990",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.62297053",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjdEKgjAYhd/lv17DOd10XUUFQV2IBF2IF6t+dLC2sBWI+O5ZIXR3vsN3ONUAxdkc+zuCgr0/mxIvQbvGIhAovHHhAaoafnFSFoxTKRhbJpzyJJcw1rO36jrdT/JUbIy+YcAOVEQjAgd0TWg/wFLBCZQ+6GC8A8VoKiOZCx4LmSdZLgSBk7n+yzs0TRu+nKQZga3F17yOKGdxTGDtrZ/O3NPasX4DSZKYWNMAAAA=",
    Pbi3DGeometry:
      "rx8AAB+LCAAAAAAABADtV8tq3DAU/RetnUHSlSV5siptodAuQlvoIsxiQkxicMdl6hZCmH+vx9Y48eNYMllWhEnGPrmvc64e9/aZ3dwV359+5WzLPld3xbeqLO5Zwm6q4lD/Ztvb5+5rA/Pr5oedkpc3V4Lz6/ZX82Gn3cXs3fG4f2psrwRtLE9lomgjtVaJ4BtFmU3OgM6sfg1QluoWMEJnsxYY0EIMgNSKZDH42BWlQi1nNXYVYCFppStoEZxVXyCMMeaKiMQyJRdXlFHWAkLKgcUEuKRLKjMDALtyWanzi7fF6C14mg6DO3ZxVsEWOAYqEFOyOkavoDUyrI4Xi+bvGZDG04hrPcGu8oYIXwQ9U2S7pNKG4zAgWHHIrY9C3AkIgIVPyuh7h9v2vVVqecXC1kGegvfiSYgV+4uvdeD7sRTe6sZy+wictoEPwGWPq+DOk3bvjXbMkhQdkFG7c/OUXAhKW0CqNraSYqjFdPOEMbgxLWCEne1msrIrQ7tWW8gKBb+4Imdx7t7FQxkf4y7dHhDGePQDVMF+hp5QaMgtPn8g6ZBCSDoU1qfG9Bxdrzi0gIpDYb0xJq68tIMdDMoxVda3zuCNddo8UCYUwrfMZi6syBVcZohbfGcUTUFzVFlhu7MsNV27NRX7rrjKdhY66wqUrg5LXYNyCrs4eQ/3aWyYraBOJ0NiGANawKzgYIFZB4zgGDgr5MqnE759jtnFGwkQEG4XmHWYFBYQAqhzYR/CdL0WwcriHdSzCGamOag4LDyO3XHsjmN3HLvj2B1WeBy7PVLEsTuO3ctUxbE7jt1x7I5jdxy749j9343du4R9KPY/8zo/si3f8IR9yQ8P9aN7+FrV+7qoDu7xR3HfQ5/y4uGxdg8fy/zv6398X5VV4/DwpyxPu3+H4hgzrx8AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1309",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530992",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.97272866",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNoTJo0dSUqCLooRXBRukg1tIGYSI1CKf134wvczRnOMNUIRWMOw1VDDjvfmFKfgnKt1YCg8MaFG+TV+IlRmRGKBSdkwSimTAqY6p+37Hs1RDkWa6MuOuge8gQnCPbataF7AUk5RVD6oILxDnKCU5EIyemcC8kyyTmCozn/y1tt2i68maUZgo3Vj+9aYpIxgmDlrY9f7m7tVD8BSq4EFNIAAAA=",
    Pbi3DGeometry:
      "lR0AAB+LCAAAAAAABADtV11r2zAU/S96doO+rI/0aWyDwfZQtsEeSh5SalpDFo/MG5SS/z5/yImt6FhO9ypKS31yc3TvuUeS7/0ruXsov7/8KsiafK4eym/VrnwkGbmryn39m6zvX/t/m4/pbfNDjtkZuWGU3nZ/ml9y3Axfe3c4bF+a794wsTI055kUK0HzPLMrIbIW1YqxFpWM8zN6irXCRlEuVIdKqwOx09WYspcM4RxOsQvyHVBu9GIGL3Zeh3AVE1RZE9AhXLHSWo8YOOVyivfRF7jLjkullvH0uTAj2f/xu3hLzQR3GsJ8FscDflQXyvNqftcratl8/pbn43jW2GLGCVeyRJyzwHvI/1aOVcm1mcXf2tULFVGdMR4PRwqAqqS1Y28Ys2gHes6ALPNn1PQ8C68Y7DL2RERD5FzgdH/HoDqjO8bXC9QK9ovkvYq0ZxEDrmnPrk0bz7nuq2oeWc+uRYtrFs5mOB8Q/0kF2tFwmffhvLeSS5MzOZsNWtXQCUuul9yLU8cYwc75DSCyIhAFWBSyBJeM6AfOXU9X2B7U5siy6Lryr7cr+wnCQTvDjQPUYQ5o/8hmvNi8wd4BW4DEkS1Qish0UICwz0GOYK/MNmJ6KzhJuFVyhArlUN7dLMLI2XdA45hVF2w9N3Pd4sxGXuLgBRVeFKR4uoyt6hrBF8b72YTlAv6MCOAXCtUN0kQr9V47Yq8p8OXW6xPY5khgmA6qFuFhRwJtwMkVjr6qe5HyfbXQmBjmDtaYJs00aaZJM02aadKcc0aaNNOkmSbNNGmmSTNNmmnSTJNmmjRnuf0aNxn5UG5/FnVxIGu6ohn5Uuyf6mf38LWqt3VZ7d3jj/Lx9NGnonx6rt3Dx13xdxz4vtpVDeH+z2533PwDLyJ43ZUdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1311",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "530994",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.76391447",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/Lrq6KdooKgjpIBB3Eg9KyPth2w7ZAxP/eotYlotub9w0zU/SQ13jqbhIy2Nsac6s7ZQ0QyC0ad4es6KfTGxY8pEkg4iXnlHHBYSA/YJqIb5gm0X84xpbv+lXbVp3f4B8brK7SyRYyRhmBgzTKNbM4Wlc59LMnecbLB+0kqsaNIg4iAlstn7OXMxrGIiSwttr6XPPQeihfnkXuIhMBAAA=",
    Pbi3DGeometry:
      "swoAAB+LCAAAAAAABACtVk1rwkAQ/S97XsOuG/Ohp9IWCu1B2kIP4kEx6EKaLTYtiOS/N2jSaIfpvqCK4jqz897sTN7sbC+mS/u6+8jEWDy6pX1xuV0JKabOFuWnGM/2x5+1WU3qt6hk989AKzU5fNUfUc3bbTfb7WJX7x1oE8SR1lLrQOlQpd1LahWYKDTy4JMODeeTjqKjT2LYOLEZSRjLpN4wwzTx0uGhwmGU4GkhlBGfa3FGfBAs9phDHce+inY+lx1hR7nFSuPwvNYtQGsgUVsDOWmyo0mZQLCRWANKipaNGFi2LPh5Gl0p0EgAKTa/P2UCwH1s/2ucHn1M4gP9Dbh4jw55VMlmnBtJi43JVuZaosICIDLRR0pICyEa4+1YhB1JDX0OqFwhXJFpSgCQMdtnFLOihww8srkPO1yHfcJ96Wzm4gNXkR63FdJEfSSQ01WA20la9Q3wzi7eszLbirEKlBRPWbEuN83i2ZWL0rqiWb7Z1a/pIbPrTdks7vPs+9Tx1uWuDlh85Xk1/wHVh4HSswoAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3160",
    Length: "25",
    Mark: "574",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "23",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530995",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.9979273",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAC1TssKwjAQ/Jc9x5C1Pkg9FRUEPRQRPJQeWgzpQsxKjUIp/XcDrf6Bt3kxM0UPeU2X7mEghSPXlLPrLHsQkDP58IS06EcYAzNM5HqFuEGUuNQaBvEfs/zOZ21bdfFDFHZU3U0wLaRKKgEn421oJnLmUAWKt0d6pdvPOhiyTVxBqeYLAXtn3lNUy0RpFLBlx7HVv5wbyg8wNx56EQEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABAClVVFLwzAQ/i95zkrSoG26J1FB0Iehgg9jDx0LWyA2UqMwRv+7sXYu63rm6igtzXeX7767JJf5jsyW+nn7pkhB7u1SP1mjV4SSmdWVeyfFfPfz681s6h/S0AMy4YxN249/SbPYT7uq63Lr5064SLJU5pTzhF9ISTlLhBCctoZLzltDmmfHBiFbXGT5MQ4ydRPydDiA5D2DTMVISWDoaHb44FFVJ1S54IOJ7/GTCoL5gbGDtZCJYHKAKMTDcgz5f6cQ4oeVw7DE2PtqwqwwOKQSihvUH0PzXzn9tMLlhWQC52O49ghn1AGIryxUGnCLx2nO6gSQntjJ+isAYocAMGaDQHLG+o/vSdAWxLUeDBMGhw4F2NowRGd2T0gTdJFBOIIHAWO6J6bHY/w73N/8N7p8VU7VpGAJo+RBVWu36QaP1pVO26obvujVr+lO6fXGdYNboz5Dx2trrCesPoxpFl8+AK3cqwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "312",
    Mark: "575",
    Material: "Copper",
    "Middle Elevation": "3055",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2851",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "23",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3055",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530996",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.65002749",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+Lu7pL2ikqCOogEXQQD0qLPth2w7ZAxP/eohbSpdub9w0zk3WQlnhu7woSONgSU6vbyhogkFo07gFJ1o2nNywYpyJkYsUYZbGMoCdzGFIZL+V/yMNfOIsdYP6pXzdN0foN/rHF4qacaiAJaEDgqEzl6kmcrCsc+tmjvOD1i/YKq9oNQnJBYKfVa/LGlDMREdhYbX2seWrd52972n/8EgEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVV1LwzAU/S95zkrT73RPooKgD0MFH8YeOla2QG2kVmGM/nfjWrUhO/RWSktzcnJy7k1usj6x1VY9H99KlrN7vVVPulI7xtlKq7p9Z/n61P+abn9pHtbxP2QhfH95/piXdZufYVdNUxzN2IUIvDgUMRfCE1IEXHpBlCTcwmMpv3ERRzaenelBFHOSTE9PsvSieppKGw8McY4bNO1EVOR5J/w4OmGaXYx3wJ20obiseUMvkVniZH8EWzIj3EqDy+/tO/K9e4LMhLxjB0WFcGQTzWtln6DzTz9OXGh1kU9QFCD7gD13UYA62smULUIoCAqd4GairsgrjvgIJ50LSIdwjpD4BD9oB1o4YYcjPsLR+TW3UpAOiU/wA26tmccpoAOYdDcBGfLNaujmfr9RxWvZlg3Lfc/n7KGs9+1haDzqtmiVrofmi9r9dt2Van9oh8ZtVX6Oide60kaw/qiqbvMF44KaZpEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "356",
    Mark: "576",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "23",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "530999",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.38998238",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjU8LgjAYxr/Le15jr9PZ7BQVBHUQCTqIB62hg7WFrUDE794qhG7Pn9/DU46QN/o03BVkcHCNLtTF17Y1CgjkTlv/gKwcfzIgC+Q0FYgrRIqJlDBVM7fu+3oIcAi2ur4pr3rIGGUEjsq2vvsYxFgQKJyvvXYWMqRJylIpeCRSGS+lCO1ZX//hvdJt57+exRGBnVGvec0o5xwJbJxx4cw+jZmqNyDsDvHTAAAA",
    Pbi3DGeometry:
      "NR4AAB+LCAAAAAAABADtV0tv2zAM/i86u4HestLTsA0YsB2KbcAORQ4parQGvHjIvAFFkf8+x480ifWJ9mUnJcjDosmPH0lT4v0ru3sov7/8Ktiafa4fym91VT6yjN3V5a75zdb3r/3fVsxv2zc7ZG8rN4Lz2+6r/bDDZlR7t99vX1rdG6FWTnidCbHi3rW/fKW8sVknUMKeC7Q0/brnJriO7rdCXKwrJ6OGci7dLI+UtSKLc7iCeNNApiA49mouOAqIMsoT/CCNAVsY7zuBUpf8hDpqnglGGlONAUPkXodNTQQQfDR1DQ69GkMiRK5meoXAMcEBQ/Kj6PSayRX5geEgVxQdsvSEPppsBc4poi5O8ZSyE2iXE7UHTSEB6dV85thdmuB1wVCmludjQhDnfCzKSUjgkw2rBJqa26/pXoeLgSqfiOA6HyTBxUFc0FYo5lMe2vbg1ncCzXW4N5/ter0lK0WfDud6gTR9WTntlmV2QUQgBvRqJK696WkoRezSmHh4XZqL+tSCUz5FWIBuvJwezOuo4cwQ21zO3y6gMvQcalCFB/flSQJIqpPgwJYSKTyYZOBthB/IZaQPwEICXsHihiFBZzdnXJgGPKh44C3cRSIbq7XhB8VbFyZOgsO9DQkCx1wETsUKHYwD2UAZx1GHoQLYGALRm9MgoH+oD0SSjx1cSBXnBUFADWo7mfY5GBESY2IqTa6h83iaXNPkmibXmCBNrmlyTZNrmlzT5Jom1zS5psk1Ta5pcv1fk+smYx/K7c+iKfZszVc8Y1+K3VPzPFx8rZttU9a74fJH+XgSfSrKp+dmuPhYFX/Pb3xfV3VrcPenqg6bf0XRjMM1HgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1313",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531001",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.07267779",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjckKwjAURf/lrWPI65CYuhIVBF2UIrgoXbQa2kBMpEahlP67cQJ3dziXW46QN/owXBVksHONLtTJ17Y1CgjkTlt/g6wcPzIgM4yp4IgLRIqplDBVP27Z9/UQ4BCsdX1RXvWQMcoI7JVtffcyiAknUDhfe+0sZEhTwYTkccSFTOaSh/aoz//wVum282/PkojAxqjHdy1pxFICK2dcuLJ3Y6bqCTRWIAPRAAAA",
    Pbi3DGeometry:
      "OR4AAB+LCAAAAAAABADtV8tu2zAQ/BeeFYMvUaJzCtoCBdpD0BboIfDBQYREgGoVrlogCPzvZSw6sVcckUZ7CxPkofVqOTO7S3Jvntj1bfvt8WfDluxTf9t+7bv2jhXsum83wy+2vHka/3Uf80v3zXbFq+VCcH65/+V+2G51eO1qu10/uncvhFpURohCiIXkorSvX4VdKG5FsXexvHx2EbXVQbtyfxP8ay6rvb0E8WkcD02IWp3YlTBBPAlUDq/SpSIhJxAi9hQ1KQThlg6pg6ABKsbWJgxBamNOXHxI6VCf2kdWU/9xKSkqGYxD7SkQfMgJBARtVEfWDmEKtBQIiK1fygVOIQvFQeERQ6IILDXtu8nHN9rOl7hQ6piW1Tqt7lCrUDvAE8005YtwRuqdVgaKczaeGC+S34N/oPImKSItjUojJeQZex/aSKgdFQYspIjgqHVBI8y0boIg0TajGkMVANuKj/ZKm2e7qtT8YWmU9PaRiibbii33ZaeEPZfifxKKAgCAq7qujwUpq7TDHV0eqL0qSw/H/It+aLs+kxZMs1bHdN2yc2dHzJtiDLsjLDAMlBhwAhIkbC0JGxTIKwSPQKL8peyR4FUADZY00Ald7A5MdKmCaSMXhxeYElQ6OHDgAeUinDT2ga7U5O4aXhdeNJAdXVjQukAfqCcq04hs6H5G5YHTCJAH0IpdI2nWQc9DkSNsU1kh8SFb4A+SEtn4qAgoOhAnz64JIfPsOtv+eXadESfPrnl2zbPrTOvm2VVMZ688u+bZNc+uAZB5ds2za55d3/rsuirY+3b9oxmaLVvyBS/Y52ZzPzz4hy/9sB7afuMfv7d3Lx99bNr7h8E/fOiaP8eO7/qudwE3v7tut/oLamCS2jkeAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1315",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531003",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.27031702",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsELgjAYxf+X7zzHptOpnaKCoA4SQQfxoDh0sLawFYj4vzdSuxR0+973e7z38gGySp77m4AUDqaSmVF9YzQgyIzU9g5pPkynM3g0wIyzaOXFmFAWw4h+QY6TgLIvGDIe/oFLbLHUr7uu7N0G99jK8iqs6CAlmCA4Ct3YdhYnY0sr3exJXmT9QXshm9a+ReSHCHZKPGcvJdhPOEWwMcq4XP1Qaixer/wMXhMBAAA=",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1rwjAU/S95jiVporb1aWyDwfYg22AP4oNi0UDXDNcNRPrfl9WvttyTtohiPL3nnntzP1wc2Xxt3g9fKUvYs12bN5uZDeNsbk1efLNkcTx9dbCYuRcr+e2XkRRiVn24NyuXF7O7/X51cLYjqYKxlJKPokBIHXEpgjCeuvM/oENVB1QYqROgVMNCiUnIvVQ6ikkDPY0j2kWLSY3jSYcoGAYUNdw5AiBVO/Cx0HQKr0Df+G6iKqppECupm7dRUdWAJtUNaGWEsKjCoFwgJgz0FdVKOgFAtTi+VhiXpPdm6haF42tfU6dzv1qq2LxVSDGB6oRV608H7Bjq8nyuCanYNcrr8C7GVLBb/W1MlQHsb3/hQOeU3N412BwVUBXcARQVXA7+rQGHCBzplIXf+ZAJ5h95g/YMYIJL0bssqUHhHwhotCDXTanuP8ODWX2mRbpniQgEZy9pvi1258OrLVaFsfn5+GE2V+gpNdtdcT48Zulv/cF7m1lHmP9kWbn8A81WVPjlCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3044",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3140",
    Length: "25",
    Mark: "577",
    Material: "Copper",
    "Middle Elevation": "3054",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "27",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3054",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3063",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531004",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.44136141",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1js0KwjAQhN9lz2loKP1JPYkKgh6KCB5KDy2GdCFmJUahlL67kVbfwNt8M8Pu1CNUHZ6Hu4ISDtRhRWbQZIFBRWj9A8p6nGUoRCLhqRBiFeW8yAoJE/tP2Hzfr51rh7AhGFtsb8orB2XMYwZHZbXvFziRbz2G2TNe8PqL9gp17z8g0yxnsDPqtXQlT2IpGGzIUDhrn8ZMzRsyvHDpEgEAAA==",
    Pbi3DGeometry:
      "qwgAAB+LCAAAAAAABAClVd1LwzAQ/1/y3Jak6fq1J1FB0Iehgg9jDx0LW6A2UqMwRv93s9lquvbM1VH6cb+7/O4juevyQBZr+bx/EyQn92otn1QpN8QjCyUr/U7y5eH706jp3Fyk8X4Rn1E6Pz3MTZpVt+yqrou9WeszHkRJlnp+EqRxmnmMBmE8M7JRzBhjR0VGadhTRMbwuCBjfRgi6uyjOB11kPIk6SuikE8MCfTtym6Cc1dUQyrO2XjmneKshGB+oG9rL7KAU/Ma8Fh4rxoj9qcMbHtr5xA0LvrzcHpZYXAoTMivXX8Ez3/jGeRlbS8UJtQgQPUx5qgecO8uWB3omGN4LpsHUETO/vrTBeakQDjmpIARTV4wfT4BpxE1hBA8CBjqDXDEIXgum6HQUAR+Z+MwgsWNYuane8pjzFvY/PlvZPEqtKhJTgPqkQdRbfWuFR6VLrRUVSu+yM2P6k7I7U63wm0pPm3Da1UqQ1h9lGWz+gJ3vUmcqwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "292",
    Mark: "578",
    Material: "Copper",
    "Middle Elevation": "3035",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2663.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "27",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3035",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3035",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531005",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.57756269",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjk8LgkAUxL/LO6+LrrumdooKgjpIBB3Eg9KiD7bdsC0Q8bu3pP2hS7c37zfMTN5DVuGhu0hIYWsqzIzqaqOBQGZQ2yukeT+ezuAFjIowEHNvRuOQCRjINwwp53H0Fya+4D/wEzvC4lW/aNuycxvcY4XlWVrZQupTn8BO6to2k9gbW1p0s0d5xNMbbSTWjX2KiAkCayXvkzehLBCcwNIo42L1TamheAA2gPzHEgEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdVV1rgzAU/S95jhK/kmifxjYYbA9lG+yh9MFSaQPODJcNSvG/L51uM9Vbr0MUc3Jycu5NbrI6kuVGPR/eCpKRe71RT7pUW0LJUqvKvJNsdWx/bTdb2Ic09A/xAsYW3x/7kmb9M+yqrvODHesFoZ9EQUI94ctICJr6Ycw5dXAu0xMeJLGLx1ye8DBOKEqn43MpRvWFSB08ZSyc5QeadyIu7LxTfs51ZBqMhtvCg6wBUbmzRn4cSz7Mfg93dHq4k4Uhv3U/1G/tI3Qm9M/9QHGB8UI+oXn72Z+W+a+dQZqB1YVcQjUBZR/iz10VSB/ay6hdgqgJFB/h52JtYRcdoo/DuHMBkEEcIxj6tBtoA/ZhxPYep0MwdCLPLBJIBkNHuIHuq7knKcSHcNS9BOng71XLt/f7jcpfC1PUJGM+o+ShqHZm3zUetcmN0lXXfFHb3667Qu32pmvclsVnn3itS20Fq4+ybNZfjkjzRJEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "280",
    Mark: "579",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2553.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "27",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531008",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.15060438",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjckKwjAYhN/lP6ch6ZKlnkQFQQ+lCB5KD62GNhATqVEope9uVAreZvmGqSYoWn0a7wpyOLhWl+riG9sZBQgKp61/QF5NPxmQiCY4o5SuIo4FExLmeuHWw9CMAQ7BVjc35dUAOcEEwVHZzvcfQ2nKEJTON147CznFGSdcsiRmXKZCstCe9fUf3ivd9f7rSRoj2Bn1WtYExywTCDbOuHBmn8bM9RvQ1zPZ0wAAAA==",
    Pbi3DGeometry:
      "vR0AAB+LCAAAAAAABADtV01r20AQ/S97ls1+aD/knEpTKKSHkBZ6CD44RCQCxSquUgjB/z1rfdiVtE+76rEsISHSePbNm3me2bl/J7cPxY+3XznZkJvqofhelcUjSchtVezr32Rz/97+a830yv6QY3J5s2KUXjV/7C85bnu3T4fD7s36rphYpypLk5VeZ4KlCaNrwY1IGoNhamCQ2jQGmVLpNGAPxtjAoOcPkpLroJh4ZrJklsUY4+KBjoLgOKpQcJgQbpT2RAV5dOBG2Rcng5LDapjMpANDz2Pi0WMYkUn3URMDAj8fNQbHUfUpYVQFRgXBIcEOw3AtwghCcIiBCaKUeAVnjOaNgc1L4ZJCq6ZGVTaVs3LDR0HDfEwLWMNg/fTGCvEdtbwWY3qw2r0Gh5/HfQqpAx0U2p0D+hoUgVc22DCqhJ/ewgSG9w8/7zGLNFMttMwagxBazc8xa2j7h1Km9TjJ6GTQstWTTPmSsganA56PIjq3Op11HNytQLjnjn+m25CGykz5PycJjpel7GBJzw5SiDavdKiOyUiAHnhWQA+f0ODAnWbdS3CcEdhAoNJgWUGsM+yAEOB3HgrHHRO6VyLtw+sYl9qdVTj+U6RMePdAg1Mp55fCGrSbtBcazC73a8elFQH7sgSvudNCIAo43zBNCBtjIH6wFcCoYFdBxcYxLaWHi4EwoIdnVEzZwXx4ISatMW6fcfuM22fcPsPkFrfPoG0hbp9x+wwoa9w+58dL3D7j9hm3z7h9xu3z/9s+twm5LnYveZ0fyIauaUK+5fun+rl7uKvqXV1U++7xZ/F4Nn3Ni6fnunv4UuZ//v7g56qs7IH717I8bj8AGvGoWb0dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3054",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1317",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531010",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.46015823",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjckKwjAYhN/lP6ch6ZI09SQqCHooRfBQekg1tIGYSI1CKX134wbeZvmGqScoW30YrwoK2LlWV+rkpe2MAgSl09bfoKinjwxIRBOcUUoXEcc5ywXMzY9bDoMcAxyCtZYX5dUABcEEwV7ZzvcvQ2nKEFTOS6+dhYLijBMuWBIzLtJcsNAe9fkf3ird9f7tSRoj2Bj1+K4FjkmGYOWMC1f2bszcPAF1jhtE0QAAAA==",
    Pbi3DGeometry:
      "wxwAAB+LCAAAAAAABADtV02L2zAQ/S86O0FflqXsqbSFQntY2kIPSw5Z1uwa3LikbmFZ8t/rjZXUmehZCj1WhIT4RXkz82Y00ty9sNv75uvzj5qt2MfuvvnStc0DK9ht12z7n2x19zJ+HX7mN8OL7Yu/yEJwfnP4GN5svz7+7c1ut3ke/rsQalkKIYpFtbSyUoVbKu6Gx1dc8/KAK1cGcWd10vpSVgfcWJfE4/1xgpsprq0wQX7g/2k94Y/xULsxHOpG7RqnQzogf6D/2pqJXamNOcdHHlmZ8/Xe/8v1I78UlQzyXODIruehdpE/XgdprUrzB9iFcXn+12ykhAXMQnoUFpEBlrMbt8WR32g3n3aj1DQsp3VaWaHypzjyJ5ZeiiM/Y+VMywHxXOtPJK6L/Pr1x3K7yAvdpqgeAE+0XaE2QHGUd1gnET3RdkR1Trcj0i3GQ3EYb9j/UvIRL/XBrqrU/HEklBzxkUdr2h/UoX6UcGlxXa3DOT/yp1TWTuMtq7TTFJ3WFJelx5X6J3lAW702LJBF7dQ03MHsbI+PrKatP7wc+oJChRKDygQSoMaAGgnIIHQTuYMyDhsYyCyqKFSxQAZ0LTy6b5UJZoWc3yc3XbiQUd+H5wTX5dm+9eEOOLkWAruIH+Dw2onsAn2gnqgK52WD1yQqD7zdh/lRWLHbHHUHdAAocqRIUqNC4sNowfpwUmJ9jZY+2iqg3+UBcH7H5QEwzW4eAEMy5AEwD4Chgz0PgHkAnL1P5wEw4eqTB8A8AOYBcE6fPADOivx/D4Drgr1rNt/rvt6xFV/ygn2qt4/9k3/43PWbvum2/vFb83D66UPdPD71/uF9W/+eLnzbtd1AuP3Vtvv1H4DN1U3DHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1319",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531012",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.32604454",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2No0iTaOokKgg5BBIfSocXQBmIiNQql9L8bbC2Ig9u79x13l3UgS31qbwpS2LtSS2fayllAIJ22/g5p1g1nMDCKxYLQ5YwwHDNKoUdfkCfz5D9khP/AKXaA+ad+1TRFGzaEx0YXV+VVA2mEIwQHZStfj+LofOF1mD3Is75MaKd0Vfu3EJQj2Br1HL0kwrHgAsHaGRdy7cOYPn8BXcAZxhMBAAA=",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVt9rgzAQ/l/ynEq0Mf7o09gGg+2hbIM9lD5YGtqAM8Nlg1L83xeczvrjmnOIYvJ533eX3F3cnMl6p15PH5Kk5FHv1IvO1Z5QstaqMJ8k3Zx/Xy3MVvYiFe1mFj5jq/phb1JtW7ObssxO1pYHnoj9gC587i15xKnPvGUiEtoDojiqARGKPhAKUQMRjymOqrHg/rQED2K/B3CWJDOdArVd8eHFnV5NULF4KvB2fryEUHxD7TCJksnd6IABVQcMVmRk0YYx0mjCQDC5JEZOgfHBgYPeQuKD3XAz/d+pifj6O45YKqhosJnuZsLNg+sE5j/CApJASkN76i7J2UzIeTA33CV8xQKSwEmD2Te/12GokABYLGAXdFuAGmhxsKEizp75VFgAbBOIqnedxmONC8D+M9yp7F0aWZKUeYySJ1kczLEZPGuTGaWLZvim9n/Qg1SHo2kG97n8vvzwVufaEhZfeV5tfwDy35mS5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3161",
    Length: "25",
    Mark: "580",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "29",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531013",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.77219474",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1Tt0KgjAYfZfveo3pHOa6kgqCupAIuhAvlIZ+sPaFrUDEd2+g9QbdnT/OOeUIRYOX4WFAw5EaLMgOLTlgUBA6/wRdjjMMgSTmSqpks4oSLtN1ChP7j1l95/O+r4fwIQg7rO/Gmx604ILBybjWdws5k689htszveLtZx0Mtl1YibiIlWSwt+a9ZDMuRRYx2JKlUOte1k7VBxWhGLISAQAA",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABAClVt9LwzAQ/l/ynJXEpO3aPYkKgj4MFXwYe9hY2AK1kRqFMfq/G2er/XXNjVJamrvc933J5a5dnchyq1+O74qk5MFs9bPJ9I5QsjQ6tx8kXZ1+X52bLdxFSvpvmXHGFueHu0m5rsOui2JzdLHyKgi5EHTGZSAZm1POAiGkpD+OMA7HHSKMIlxE5CaeI+J5jIMCVYlQVo4kwZHXUD0OJvmwKpAchALXUcsVMpY4Du+WjJMngWAJ7+9Iw96iHpjfxWllD4EP2VupQ+iB7K28Dczv6m/lALFeCAey+3C6+nHVABFgAkAGXyqxWwceaxTQtMqBNIH1ATpQSAg7dCC9DWYUaFoP8xUJ2Nt6DhQSwg6VP9jRUUDTPhqQJu+3b5xiQpOEKtTbNC7uMs0luD+DW715U1YVJGUBo+RR5Xt7qAZPxm6sNnk1fNW7P9e90vuDrQZ3mfpqTrwxmXGA+WeWletvfNZ2ZssIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "313",
    Mark: "581",
    Material: "Copper",
    "Middle Elevation": "3056",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2854.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "29",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3056",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3056",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531014",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.96351522",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0aVpNPYkKgh6KCB5KDy2GdiEmUqNQSv/dYFsPInjb2TfMTNZBWuKpvSlIYG9LTK1uK2uAQGrRuDskWTec3iA4FXIhlzMWUiYkg578goKGLObfMJqzv3CKzaf6VdMUrd/gHxssrsqpBpKABgQOylSuHsXRusKhnz3IM14+aKewqt1bxDwisNXqOXol5SwSBNZWWx9rHlr3+Qtg3LdQEgEAAA==",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACVVdFqgzAU/Zc8W0k06myfxjYYbA9lG+yh9MHS0AacGS4blOK/L1Qzp/YmV0QxJzcnJzc5N5szWe/k2+lTkCV5Ujv5qkq5JwFZK1npL7LcnNtf001X5iFN0CMLRunq8jEvabZ22G1dFyczlkdhwuI4WLA4ZDxnQR5GEU+Ca3h6k13wJEuu4lB8nPABnmX5LB6rh3I2wHmaztJpecZ6mGm75oV4IP2p0YXR6eNxz8vDmKXRNG9+3MfT5qfH7X5h+S3e7lePD/Mw1QPhYz12v8b6bXyb/+m80HohHizuy7P73EI8kC+gPE/5sfn37TvkXzcPFI+vD5AerF9868Keh6Gvp/mE/O7mgeLx9cR9zvF1DOsXny8gn0L11s0DxePrOaQHe9/51jW3jkF+xNaHufegiTf3/b0sPoQWNVnSkAbkWVQHfewaL0oXWqqqa77L/V/Xo5CHo+4aD6X4+R94p0plCKvvsmy2v5y5JmWhCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "356",
    Mark: "582",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "29",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531017",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.30601235",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImvTpSlQQdFGK4KJ0EfXSBmIiNQql9N+NL3A3M5yZqUcoj3o/XBEK2LqjrvDklW0NAoHSaetvUNTjRwZERjQWsZzPuKQizVKYmh+36Hs1BDgEK60u6LGHglFGYIe29d3LcC4TApXzymtnoRCUSx7nURJGszzNBSdw0Od/eIO67fzbMxkRWBt8fNucUSGkJLB0xoUzezdmap5D2xkK0wAAAA==",
    Pbi3DGeometry:
      "xx0AAB+LCAAAAAAABADtV11r2zAU/S96doM+rmUrfRrbYLA+lG6wh5KHlJrW4MUj8wql5L/XS2Rvknwsp28FERJiXeuecz+le/vCru/q78+/KrZmX9u7+lvb1PcsY9dtvet+s/Xty+lvL+aX/Ycdsn8rF4Lzy+NP/2WHzbDtw36/fe73klzlpjDZhaCVUkUm+EoZbTJnnYz8KyCpyREQL6cFcIcqyiMGqVIvU0WS0ywrpQsPA5gxQIQbkCaIjUlFsKFDVJ7LhaR8M1RODrai07qm0tU0CIYNoxWDgOcehC+AqhB2oAmSKgrXH1FOCBpZR0ZFIAJOUezAg9A86BCYUrmlOwoKUDJjIpRKuAaSEcuSDZZGIICsohEPBFG6ATjKEajpfFLQPhjyYceQh36YgkKGORLVFOnPyxtbkAjQg1CAYhHtOn69IqujpRQIoNnQCKmtQJM4tmeup7vw2LeVklZgVZlTLCTXdl2JRead6w4IgBhRXrpHriQ9mQTBWYxPbyxQx3Uh3uglfMCcax0MqTBexhYmnz8X0A7MFu6ArKAq6HOoKh5wr3/EO5cbVcgVUkLRg0UB3keMYCpHfRFcyEYbjFKTEQovAZZsL3DIRk+K4GwZyoLEyb7wciCIJgvMx4YQ8dsEvOv62NBT0LcwGsgM6PO4p3xsBIHMi18TA1Kw6vFlApA63zwYDAiBNsAgRdtgGCWEAVWlETSNoPM5lUbQNIKmEXT+YpFG0GVdJ42gb3JHGkHTCDqvKo2gaQRNI2gaQd/ZCLrJ2Kd6+7Pqqj1b8xXP2FW1e+ge7cNN2227ut3Zxx/1/Sj6UtUPj519+NxUT/+/+LFt2l7h7k/THDavonayyccdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1321",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531019",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.71259146",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjckKwjAYhN/lP8eQpFnaehIVBD2UIngoPVQNbSAmUqNQSt/duIG3Wb5hqhGKo9kPVw05bP3RlPoUGtdaDQgKb1y4QV6NHxkRzrBIBJ/PKMeJShVM9Y9b9H0zRDgGK9NcdNA95AQTBDvt2tC9DKVcIih9aILxDnKKhSIqkwmTKuNpJmN7MOd/eKNN24W3J5whWFv9+K4zzIhAsPTWxyt3t3aqn1H75ZDRAAAA",
    Pbi3DGeometry:
      "bRwAAB+LCAAAAAAABADtV1FLwzAQ/i95riNt0qSZT6KCoA+igg+yhw2LFuoqswoi++92XbauMV+S4WsYG+vt9t33XS653NMPuV1UD9/vJZmS62ZR3Td19UwScttUy/aDTJ9+tl+7n+lp9yLrZLCcpJSe9h/dm6xnu7+drVbz7+6/PJtwxWRykvIJk4VM1IRRlSadPae56u2cFtmhXfDCakf+LOdbe0Z5CI5002FcHbpD+jt4wx/hoLB2szcqSgJjIaIQ+SFsKjb2jAsxxtF2KcbsDfc9vLanMrPCaDsMa+LswiI6+yxoe1EwFx8YF8gy4WnuUgWzANCRKJQET0GJfjdkgitnuQ6FQ9XGX3HuKigEg+w+NoFaEUuvKqMQvDhH5t6QZV/ZocwMd7Q7QSUgHO8JG3pEgTX3lwiwG8n3yjo2bYGngl/umH9Gddyi2JiZHNP/25c0TEF7f87zLX01rh2WqrBVDEsDwkd8hj5JRY+TS2f7xHKt9o6OpqnYf9IDT9MjZYFF3K+5SNk2qutkB96IInD31BNqkmbiPYrG+tGZ4KgmtHx2llAUWG24l1F12OmgagVVgK5LuY076tcCVB7o46g3UGWtd5lahfqCgs4DzOYdwR7TmRV47TYyDnjDyxBICwoL82KXBDY2YgN2MLrFIC5HarLnHYBbnT1nuyEHqXdCjzHiVBenujjVjQ6yONXFqc61O+NUF5a2ONXZ7g5xqnMsYpzq4lQXp7o41cWpzqI+cKqbJeSimr+VbbkiUzqhCbkply/tq364a9p5WzVL/fhYPe9/uiqrl9dWP1zW5deh43lTNx3g8rOu17NfjZvTRm0cAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1323",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531021",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.74105682",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0aZrWehIVBD0UETyUHiqGdiEmUqNQSv/dYGtBPHjb2TfMTN5BdsZje1OQws6eMbO6rawBAplF4+6Q5t1wekPMaSLFfDFjgoaCc+jJF4wTJv9DwaIfOMUOsPjUL5umbP0G/1hjeVVONZAGNCCwV6Zy9SgO1pUO/exBnvAyoa3CqnZvIXlEYKPVc/SygIZShARWVlufax5a98UL2dtKsBMBAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACdVl1rgzAU/S95TiXWmKh9GttgsD2UbbCH0gdLQxtwZrhsUIr/feJ01o/bXIcoxuM9537kXt2cyXqnX08fiiTk0ez0i8n0nlCyNjq3nyTZnH9vK5itqoOUtHuy8Blb1ZfqJOW2NbspivRU2cqlFwke04XPvYBLTn3mBXEoaA+QkawBwYM+EApRAzIIKY6qseC+lJMafCmiHsBZHM/0ChR3BYgXd3o1QcWiychbYJxEKMChuIx8MVmPDhhQdcAgJSOLNo6RRhsHgsqlMfIKDBCOHHQXEh/Ww031f68mAuzXHJErsHGwux1BhQXAXIFtgLAANbDiYGndzTmfCg2Au8TdzlcsQA2kOLgT548+DBUSABsHnIluC1ADLQ6OV8SnaD4VFgBHBmIAuL7OY40LoPqHuNPpu7KqIAnzGCVPKj/YY7N4Nja12uTN8k3v/6AHpQ9H2yzuM/V9+eKtyUxFmH9lWbn9AXu7XFT1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3160",
    Length: "25",
    Mark: "583",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "33",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531022",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.49738408",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5C0hdi6kioIuigiuChdtBjaBzFPYhRC6d0NtHoDd/NjZuoRqg4v4aGhgCN1WJEJPVlgUBFa/4SiHmcYAyrhSuZys5IZT9VawcT+Yzbf+a1zbYgforDD9q69dlAILhictO39sJAz+dZjvD3TK95+1kFjP8QVyUWSMdgb/V6iOU9FLhmUZCi22pcxU/MBaoytNBEBAAA=",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABAClVt9PgzAQ/l/63JF2ZRTYk1ETE31Y1MSHZQ8sa7YmSA2iybLwv1sRlG7cergQCL2v993PHiwPZLHWz/s3RVJyb9b6yeR6QyhZGF1U7yRdHn5eLczm9iI1/ZNMOGPz5mFvUq86tauyzPZWV04DOWOCTngYCBlLylkghOD0G+AJb4CQJYkDhHzaAix2AJCq0xCzKBq0IUIZ9oEolvFIr0Dj3gDRxv1enVAlcjDwTn6SQig82LRTjSQQLBlg6smddAzsb0LoyZ3aIXh8/Ef+uIH55aCfgF2nAn6af7tzHFa/wJCX4BGB0o9RwJ0DRIGhREO9jiO6aCyAVfMcs/MGvM0CiVG9Arkzdv/4AQV0I2IMoXj8zQ6NIHDIYXgumaKgR+AnDQRQTAg5aoxi5j1OoQXsn8CNzl5VpUqSsoBR8qCKbbVrF4+myiptinb5oje/0J3S213VLm5z9dnfeG1yYwmLjzyvV1+3Onq0uwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "312",
    Mark: "584",
    Material: "Copper",
    "Middle Elevation": "3055",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2851",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "33",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3055",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531023",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.58345865",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0aZPaehIVBD0UETyUHiqGNhCzUqNQSv/dYFsPInjb2TfMTN5BdtbH9qYghR2edYamrdACgQy1dXdI8244vSHmVM65XMxYSFmUMOjJLxjRkEn+DWMh/sIptpjql01Ttn6Df6x1eVVONZAGNCCwV7Zy9SgO6Eqn/exBnvTlg7ZKV7V7C8kFgY1Rz9GbUM5ERGCFBn2sfRjTFy8cERpYEgEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVld9rgzAQx/+XPKeS+CvVPo1tMNgeyjbYQ+mDpdIGnBnODUrxf1+wOhvPiylSMV/Pj9/cedfNmax38v30lZOUPKudfFOF3BNK1kqW9TdJN+fLpb7NVvogDR2UBWds1Z70jzTb/rG7qspO+lnhe4InnC544PFQXySeL0RCtR4vxdLQwzhu9UQYso6jFowIuT8ZH7FgCg84PAptdtD3YvqN70V1jDPerx9GU2nrZddt9WloMaEX8Ni/ymaHGXQTM+hmFmD8xT3goxxEd/ZjZhnqmE/Mz9h/l2ZnzowfbF/jssxUF6vidGvZaw7hjh7dSgvnghWDhLuPC3thIQfTXT8QkwN17MOxtz/GmR8Xc/H2xgXzBdVdB4DJgbq9geDYtHOweOjfPq5h4yLjd1q2U2CbW7sfNqLjVHAaIoZ3/f/+ILPPvM4rkjKPUfKSl4f62C1eVZ3VUpXd8kPu/2895fJwrLvFY5H/Xgfeq0JpYPlTFM32DzxOQkuRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "356",
    Mark: "585",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "33",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531026",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.49673136",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjV0LgjAYhf/Le73GXqfO2VVUENSFSNCFeKE1dLC2sBWI+N/TPqC78xyewykGyGp97G8KUti7Wufq7CvbGAUEMqetv0NaDJ84KSKgAiUuFxhSLhIBY/nzVl1X9ZM8FRtdXZVXHaSMMgIHZRvfzoAYxgRy5yuvnYWUUwwxkkEc8SiRQnIkcNKXf3mndNP6N7MwILA16vldI6Ocz5O1M246sw9jxvIFHJnGodMAAAA=",
    Pbi3DGeometry:
      "sx0AAB+LCAAAAAAABADtV8Fu2zAM/Red3UAyFclKT0U3YMB2KNYCPRQ5pKjRGvDiIfMGFEX+fW4ipZXkZzl3IWhSiyb5HklR4sMbu3ls7l5/12zFvnePzW3XNk+sYDdds+3/sNXD2/HfQcwvhw/bFx8rF4Lzy8PX8Mf2a6d2tdttXgddXS50JVRxIeSCSBeCL8gsVeGtS1O+C2S59NYlr0bX0fukq4MDSbqcZUiWXE4iIqVEMYeC8xArIEvQNwaV8I3CQUsyMzGFLIQRnmui47qsAktO4BROJKxAVSZwEQqgKeQ7tIRBKV75AUmBgr4hPa3ltIsQVNp36APzgxGBJUUW7kmgNU1XglLGJyh1Na/a4NaIBBBVMuWRIAk3JgiKBJs6HxUkCHPuNFwhhnmKtjIskqSlRHOe39miSoARxAKUjGTjCXcsop3cTJEA8oYsuLEslBSHBs3leCN2nVtou2wNGa2PhqQlIUnMYnduNKADhKg0S//ILYlGiyA6i+HhDdfpsCz4NCJEYeKAOZcbzCcnX2P4LSePBawB0SINiAqbQiGH/NLZDppHum15SZ1gjSCh5MEdAd5HZQbrOBmL8Dp2omCIRvMT3wC0W/exJk+J6Fxxm0KKI734ZiCkHNtekW/oIn2VgBfd0DeKFAwtzAVggUOeDlTgGsUJkUvfEGNMaMfjawQAdTY7mAnoASngZprqgHE8kA8YqDx45sEzD5558MyDZx48vQjmwTMPnnnwHL125cFzGlIePPPgmQfPPHgiU+uCfWk2v+q+3rEVX/CC/ai3z/2LffjZ9Zu+6bb28b55Oom+1c3zS28fvrb1v88vXndtNxjc/m3b/fo/cB/uuLMdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1325",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531028",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.90072089",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yim5vTTlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhokbP3RVPoUlGutBgSlNy7cQNbjR0aEJ5hTQeczynDKCw5T8+MWfa+GCMdgZdRFB92DJJgg2GnXhu5lKGU5gsoHFYx3ICnOOOEiT5OcC1aIPLYHc/6HN9q0XXh7whIEa6sf37XACckQLL318crdrZ2aJy6HySvRAAAA",
    Pbi3DGeometry:
      "qRwAAB+LCAAAAAAABADtV02L2zAQ/S86e4NsyfrInkpbKLSHpS30sOSQZc2uwY1L6haWJf+9tqN1Iq2epLDHipAPj5U3782MR5rbZ3Jz135/+tWQNfnc37Xf+q69JwW56dvd8Jusb5+PP8fb9Hp8kUNxslyVlF7PH+ObHDYvf3u332+fxv/KaiWk5MVVyVdMKlnoFaO6LCa70mK2c6qqM7vkymuH68vxe7ZXlCfgSEFVkA/j2vIL+C/47nqAg/xCPjG/KA6MpciC9Be3pZjsFRfCxjF2KRz69voTvrGXsvLivNiB31c4xi/ks4TB2JViQT7IL9Ll4tM6JAu5RfBQFghDvKrE/FRUgutQ2s+qh+ppveY8UFUQBtmjdBLlIppRWU41RHEuDb+jC6V3qTZ7PWw+oBwgTqzZpjYrkPZ4lQC7Hf64rEvDltYcEuTa/Cmvj3alJjOTNv3XW5SBUXRez7lpDqy26LBSp2UxNQwAH/A5bZlUzDi1DO2kAbnAzgxNzd4UHrRVXCjLn8RTzkXJjl4D/R2shm0fgEfqCe2V7lYfUWTrhz0BVxNKn18rFOXPNn6WUXV46cBzH6gCdGyaOpwnlmjf5qD20HEBbRA1l76aH+3KqzbqF21AyO6cF5DfSHjgYdwJPmCPooyig9wifKQKPOSIDnia4aEGsrlMFYo9gAfLI83e0YRCEAF32mKe+fLMl2e+PPOF6eSZL9xM8swXDFue+Xz4eebDScwzX575QgfrPPOlhCfPfL5Dzf88820K8qHd/myGZk/WdEUL8qXZPQyP5uJrP2yHtt+Zyx/t/XLrU9M+PA7m4mPX/D1f+L7v+hFw96frDpt/hH7lIqkcAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1327",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531030",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.70084709",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzEkTZpKPYkKgh6KCB5KDxVDuxATqVEopf9usLUgXrzt7BuGl3eQnfHY3jSksHNnzJxpK2eBQObQ+jukeTecocAZp4lQYjHjkgoZRdCTb6pkMv+DSh7/0ml5oMVHYdk0ZRs8wmON5VV73UDKKCOw17by9RgOzpceg/oQT3iZ0FZjVft3UFFMYGP0c+xyRoWSgsDKGRd27cOYvngBq8W97hcBAAA=",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABAClVlFrgzAQ/i95TiXOmKh9GttgsD2UbbCH0oeWShtwZrhsUIr/fcFZbTVXT4coxi/33XeX3MXlkSw26u3wmZKEPOmNetWZ2hJKFlrl5osky+Pfq4XZ3F6kpO2Xmc/YvHrYm5Srk9ltUawP1tZnvicDEdCZz72AS0595gVxKOglIiNZIYIHHSQUokJkEFIsW23DfSndfviNiC4RzuJ4tDZYwWCkYxQMa3OxscidgxPiyCgYaU+B4DJyr0+LdNlapJudnk0TT89PEw+GbdBPXxsc6ZUcwKpBBb31QbD9R5sr0s4+wOQNrix8LWDY8AicN7hKMDawH7wCeLURFTyFbQQC7x1E1V+zgf2gFcB7dEq3RLGhEbiy4D6KsIH9jFAAd2XMaTaFDY/A3QXTKQbPeoefM8T+l9yr9Udq0oIkzGOUPKf5zuzrwYs2a6N0Xg/f1baBHlO125t68JClP+cT73SmLWH+nWXl6hetjJ1JSQkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3160",
    Length: "27",
    Mark: "586",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "246.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531031",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.32478253",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzEk1R5ST6KCoIcggofSQ4uhXYhZiVEopf/uQqt/4J52doadVw5gG7z0DwcFHKlBS75vKYAASxjSE4pymFYOaKVlblS+XuiVzHhgFH9zqy/CJsa6Zw4+7LC+u+QiFEoqAScX2tTN4kypTsjok7zi7WcdHLYd12ipMpMJ2Hv3nrNGLpXRArbkid+Gl/dj9QGjhvGQFgEAAA==",
    Pbi3DGeometry:
      "HwkAAB+LCAAAAAAABAClVlFrgzAQ/i95TiUx6hr7NLbBYHso22APpQ+WhjbgzHDZoBT/+7LqWtN69VoVxfh5332Xy12cbcl0od82n4qk5Mks9KvJ9ZJQMjW6sF8knW3rRweziTtJRQ9vRpyxye7mLlLN/81uyzLbOFvOeJCE/IaOeBSE7qCcBUKMBf1DYsniGolF5CEJD5MaiSLhIyDbwYYx3u2HSyZ9JJbhxdpgBf2RXqKgX9spWzKOgDnYI8czCkcKK/DzIwPBJO8gawH+3HRZ7IJpW3j5xFD1+zhW5UeIAkC5oHMvJxiqAapOAvTSDsqF6whMCM4EWSuYtMPTBZYDkmtwFwGVIcrxvBvUOgIB3DqCdV1hck1vA9crsoHhyFAAWEdwk8RxDe7FYGOFt0oQQZKhAFwzRm0eWJMGcX8b9zr7UFaVJGUBo+RZFSu7bgYvxmZWm6IZvuvlHnpUerW2zeAhVz/tD+9Mbhxh8Z3n1fwXg0BOfh8JAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "314",
    Mark: "587",
    Material: "Copper",
    "Middle Elevation": "3057",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2865.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3057",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3057",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531032",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.53290158",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfFtV1FO0UFQR0kgg7iwWjRgW0nbAtE/O8tqV0Kus2b7/HeyzvIznhsbxpS2NEZMzJtRRYYZITW3SHNu+H0BhEIHoXxYiYkFyqJoWe/4JwLKdUXVEr+g1NsMdUvm6Zs/Qb/WGN51U43kAY8YLDXtnL1KA7kSod+9iBPePmgrcaqdm8RhYrBxujn6E14KJRksCJDPtY+jOmLF867jeQSAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVlFrwjAQ/i95jiXp2tTq09gGg+1BtsEexIeKQQNdM1w3EPG/L9jaarzzUqTS9Ot9d9/l7tL5ns2W5mP3rdmEvdilebelWTHOZtZU9Q+bzPfNrYPF1P3YgfdPRlKI6fHPXeywOJndb7fFztlKIaM0FykfySSSaZ7xPIplmvAjkObxBZAo1QBqnFwAcZLym1RKxgq0ULHMYB8+VZblRFSoDjSq4c4xAKW6Uq7GGZzEDggW2EXVUN1FMnFpPd+PhqoHPKoe8FJybdHqAHxgVDgQHJWX9msADRcX6Os4pT2ciowKF+hvlOccLR/AAqsrSiDgI3jPuxIlUgL0B0GFWgD9QTQnEBXaaihAUAE6UAAtBmK8olQBA5m2IEoUmO0oEFztHtXwWQLMdoIKtRhweFGzBDjVMCB8LHlUAIB2bfAsIQ9hSIf7hng0xZeu9ZZNRCQ4e9XVut60izdbF7WxVbv8NKsOetZmvanbxVOp/85ffLCldYTVb1keFv/sGnhy9QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "309",
    Mark: "588",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2826.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531039",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.29872766",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzE0SRu1nkQFQQ9FBA+lhxZDuxATqVEopf9usFEQL9529g0zk/eQVXjsrgpS2NkKM6u72hogkFk07gZp3o+nNzDB6JwvJiymIuYcBvLNZkJO/6AxS35pyB1Z8a5ftm3Z+Q3+scbyopxqIY1oRGCvTO2aIA7WlQ797FGe8PxBW4V1415C8oTARqtH8LKICplIAiurrc81d62H4gl16ZW1EwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEpS0/ijT2MbDLaHsg32UPrQ0tAGnBkuG5Ti/z5xWp3xmpMhivku9313Zy5xfSarnX49fSiSkkez0y8m03tCycro3H6SdH3+fa3MbFldpKQdMuOMLetHdZNy07rdFMX2VPnykAfJnM64CEIRCcpZECYyoX08iqMalwv5B19IWeORiCmGp5kv+Ci9mMe8jwuWJJPCgWQ9aWF1ffG4PCweSbeFnaoBaTmycSij8fp3liFXZxkWw/G5pOHotIlgyLwybmhwoldKAAcNRjD8Lgiy/4Q2luhgBWDKBvQOds17iXAwXCuoGfweoARaG/y0ng6dTISE4dXh7WnYA5TAasPrb+rGh2BC4nC3QLui1wPWmKAO77G+Q2g6ExaHdwl/03tO5BGNnqX6Z7jT23dlVUFSFjBKnlR+sMdm8Gzs1mqTN8M3vb+YHpQ+HG0zuM/Ud3/irclMRZh/ZVm5+QER2EVu5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3161",
    Length: "25",
    Mark: "589",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531040",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.76298458",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzEkTSW2nkQFQQ9FBA+lhxZDuhCzUqNQSv/dQKt/4G1nZ5h55QBFg5f+YSCHIzVYkOsteWBQEPrwhLwcpjMGpJJc6zRZL2TKlV5pGNnf3OqLsOm6uo8c8bHD+m6C6SAXXDA4GW9DO4szhTpgRJ/kFW8/62DQtnFGcpEsFYO9M+85m3ElMslgS45irX85N1YfW4stARYBAAA=",
    Pbi3DGeometry:
      "EQkAAB+LCAAAAAAABAClVt9PgzAQ/l/63JF2Lb+2J6MmJvqwqIkPyx5Y1mxNkBqsJsvC/y4iKBUOji0EQvtx333X611Zn8hqq5+Pb4osyL3Z6ieT6h2hZGV0Zt/JYn36eS1htiwvUtC/mRlnbFk9ypsUm8bsKs+TY2nLBfci5vt0xqUnwiiknHlCSEm/kTCU8wqRLI5dJA5EjbDIQQbYGhvhB0G/HyFD6SJSTJUGC0AEOkHAqLIulz/nwAI0SGc5B1IACnByE3uCxbyHqwW4C9NnUcXSBpxcYqjGffxX5QSImYfEwq6dhKDiPldTJzgn46BYuH7AZKBMsEWCSTm8WHAl4Lgu7h6gsvFKHHGD2kUggNlFsKrpFtM7GrhVkW0LxYUCwAqCOyOO6+IGDCoDD8cBBEeGAZAtGHVkYE1qpPy/uNHJq7IqJwvmMUoeVLa3h3rwaGxitcnq4Yve/UJ3Su8Pth7cpuqz/eG1SU1JmH2kabH5AtrVtHwRCQAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "313",
    Mark: "590",
    Material: "Copper",
    "Middle Elevation": "3056",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2854.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3056",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3056",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531041",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.64413441",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACNjlELgjAUhf/LfV5jm1PJnqSCoB4kgh7EB6WhF9YWtgIR/3sjLaSn3u653+Hw5T1kFZ66m4IE9rbCzOqutgYIZBaNu0OS9+PpCzzgNOY8Xi24pIEUAgYyp4xGMRN/UMnDXzpbHmnxUUjbtuy8h39ssLwqp1pIGGUEDsrUrpnC0brSoVcf4xkvX7RTWDfuHSIREthq9Zy6Syp4KAmsrbZ+1jy0HooXxpeGoBYBAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACdVlFLwzAQ/i95zkqypc3aPYkKgj4MFXwYe+hY2AK1kRqFMfrfjbbTxuXsRUpL0y/fd3e53KWrI1lu9OPhRZGC3JqNfjCV3hJKlkbX9pUUq2P36mC2cBdp6c+XCWds8fVwN2nXJ9pF05QHx+UznkjOJZ1wkcyEFDRPpiLLqA/IufwEeCp+Aamb6oCpSClSqmdkTjFoQ8rcBwTL80ivQONjAeKNj3oVkGLzYOQn4HwRoQB94yzJJJsG8jEEPKkh4C1JgNHFEbDRxYGSGrNx5hUYIBw56C5k3M8HRur/XgUChHIOrhVYOGA+QEZ8okAb0G5Hbh9M4SAZGK9GazBmMwCMPwBULwGlcG0JxcB5BWxRH8DVB8gAALi3x1cU3EVRDJRX4DkY35BBBgjgjjtQKubYdgz3D3Gly2dlVUMKljBK7lS9s/t+cG9sabWp++GT3n5DN0rv9rYfXFfqfTjx0lTGCdZvVdWuPwC4tJ/o9QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "317",
    Mark: "591",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2899.9",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531042",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.19292018",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjlELgjAUhf/LfV7DzWlpT1FBUA8jgh7EB6WhF9YWtgIR/3sjtZeC3u653+HwZR3IEk/tTUEKe1uitLqtrAEC0qJxd0izbjh9gYUBjYXgyxkTNGQxh578pCFlfJF80WjO/tNpOZ8UVk1TtN7DPzZYXJVTDaQBDQgclKlcPYajdYVDrz7EM14+aKewqt07xDwisNXqOXYTylkkCKyttn7WPLTu8xe/Mqs8FgEAAA==",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACVll1rgzAUhv9LrlOJX4naq7INBttF2Qa7KL2wVNqAM8Nlg1L873PTatVzmkhpafp43vORk5NuzmS9k2+nz4wk5Ent5KvK5Z5Qslay0F8k2ZybrzVmy/pFKtr/snAZW/5/1G9SbS9mq7JMT7Wt6zOHMyHowg0c3+UejR3PDQP6B0LBwwEIOG9AFPIB8IKQ3pTiXhzBFn4MupgoCRHfDgr3jYK5vnGAKY3T5pGAK9gB6/S6gjRSvuN6UXxd2laqByOpHgwLAhg0aUxd4EoYsA9qVHQAYNGiQY3TuBTdWskYE5reZJeGvtHWAQywnjKkB7iw3e5OyFAP4GAYpFALID3DqQQ2Az1kGDBJTfPAAdoJhqmKSlnMYbOFoT+nAxoH1q0+kpo/RoCrySCFWsy5swxzBJBCgfVIGkkBADu0tnPEePMCSdT/G+5l+pHprCQJcxglz1lx0Md28aJ0qqUq2uW73HfoMZOHo24XD3n2c/3gncpVLVh853m1/QUq/nX/6QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "362",
    Mark: "592",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3305.9",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "37",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531046",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.48522452",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPobdKmjStRQdBFKYKL0kXU0AZiIjUKpfTfrS9wN2c4w1QDFEez768aJGz90ZT6FJRrrAYChTcu3EBWwydOCjKkQvB4PkNOmcgEjPVPXHSd6id7KlZGXXTQHciIRgR22jWhfQEiTwmUPqhgvAPJKHJM8jhNWJLlImdI4GDO//JGm6YNb454TGBt9eO7xogyxjmBpbd+OnN3a8f6CWOVJYHUAAAA",
    Pbi3DGeometry:
      "7R4AAB+LCAAAAAAABADtV01v2zAM/S86u4E+aMtOT8NaYMB2KLYBOxQ5pKjRGvDiIfMGFEX++7xUdibLT1JyHIQgQRyG5HsUSZH3r+zuofn68qNma/axe2i+dG3zyDJ21zW7/idb37++fR3E/Hp4sUN2+uVKcH59/Bje7LAZ1d7t99uXQVcosSpVobMrQSuldCb4SlVFldkCquRfCcmCbAnxEkiwjtLl0Q+psoi1RpKTH9vwPPeD6IxuFlSgMQzAAy0EAMdG5bmMhjanozVJC4Aio8LVzNgomVQmNpOEqLTdOBJsDQJwjGFopcgrOzYR0BAAD08l84Abl2cYgOPHQxQHB+aargzqSaJRUZ0SR0qbKFUiNgtx6bhZiKGFs8CVBEG70GDiYGMXIMM8Pck26oz56ZyaW+64dsPGQo39nE7oJgeMJhTgkwl3KKekIf1wpbkSzB+R0QUZMgWJY1fnBejdU7/XWgojMdYqU895ZciQEnE0zw+MxwnEVVJhX96S5kkGr3XPKOCRqKNAiMsj5rmfzqaJT1nnpa2j9IAocKVgHQwa62Bs0JonN7G1iCSYdZqYRjc7aBwADAyeJy4aoAFx4TyPCIsz8J24VEotH9nCTGEwDxKbZfiece+msWxIvBFdGDYE0XINOgCwm4j5BE/WDgAYNU+kcUlDOvgIIqLmAEBuPDzDs+gCNNgePAMKisAlPHFKQzdYBZ9auHW6scF+oLW0FaetOG3FaStOW3HaitNWnLbiRVxpK05bcdqKF/M8bcVpK05b8X+0FW8ydtNsv9d9vWdrvuIZ+1Tvnvpn8/C567d90+3M47fmcRJ9qJun59483Lb173//+L5ru8Hg7lfbHjZ/AKRuePPtHgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1333",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531048",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.9013834",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yizulcp6ggqMMYQYexwyrZBNNYFoyx7569Qbfn5ffwVCMUR7Mfrhpy2PqjKfUpNK61GhAU3rhwg7waPzIiNKFYSs7mM8pxIjMJU/0DF33fDJGOwco0Fx10DznBBMFOuzZ0L0MpFwhKH5pgvIOc4lQSqUTChFQ8UyK2B3P+hzfatF14e8IZgrXVj+9aYUZSBEtvfbxyd2un+gkHYNtu0gAAAA==",
    Pbi3DGeometry:
      "xx0AAB+LCAAAAAAABADtV01L5EAQ/S99jkN/Jd0ZT6KCsB5kd2EPMocRgwbiRMasIDL/faOdZE1XXjrDHrcRxaRS9epVv+ruun1nN3flz7fngq3Zt/qu/FFX5T1L2E1d7poXtr59d/+2Zn7a/rBD8vfNieD89PNP+8sOm97tbL/fvrW+QomVMVomJ0KvtOQ6yVeK5yL5MFiujDNwKycNSufTBuIh0tx5GGsWhRqyUmrkYLS2kxCQxuBBIIKhfOzQe1hBAq1kOlkPnBNkIYT5Ci51lnkGF0qazPNwNKhDByGFkdORqAFh96EINk7KVURaq5ZmBcERvw6CpwvpQWiEgNn59UCSSvuGcQiZzgMyaD8Zkcu1Xig12BfEgJIKrjYxwGyDMif6gKGOzyrIz1vu/vtegWSVSBdDgcBQwW0N7hTEAJUASxiuLepW2AGkWyHzcCjfAJlDHlZ1JcmV+jAoo+ZPMmO6UK3BiUH7u4jQLpTIlxI8viQ+BsrKcjE6eGVqFh7I8NAnFbF2SEr/Y6ngTnwsP7iwJs3syEGB/aU/HELfk1SRA8wIRZqpOFQtqAbcRKDS4KJC3pAflAHe85AHympGzkD/8GY20Mi0mFwmchnos1UayBwdG/gYVWLUFj1t9dkutMEIMkJA79EtBAGjIs1MBkiZweLBu5dXpZlRAmEgeqGLIskJ9Tysd5j1UnJQr5g1XDywRsEt0y8HzAlFiiNoHEGXdX0cQeMIOn92xhF0vovjCBpH0DiCxhE0jqBxBI0jaBxB//sRdJOwi3L7VDTFnq35iifsutg9NI/dw/e62TZlvesef5X3g+mqKB8em+7hsipev354Xld1G3D3u6oOmz9z/Jw1xx0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1335",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531050",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.91360729",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjT0LwjAYhP/LO8eQNE3TxElUEHQoRXAoHaKGNhATqVEopf/d+gVud8dzd9UAxdHu+6sBBdtwtKU5Re0bZwBBEayPN1DV8JETQhnBGRFiPqMpZiIXMNY/cNF1up/oKVhZfTHRdKAIJgh2xjexfRlK0wxBGaKONnhQDNOUcplknPFcCskogoM9/8MbY5s2vpdyxhCsnXl82xInhCNYBhemK393bqyf1XqnFtIAAAA=",
    Pbi3DGeometry:
      "kx0AAB+LCAAAAAAABADtV1tLwzAU/i95riOXNknnk6gg6IOo4IPsYWLRQl1lVkFk/93OJd2a9lsyXw1jY83puXznmvPwTa4fy7uvt4JMyWX9WN7WVflEEnJdl4vmnUwfvjd/WzI9bj9klWxPjhilx78/7ZesZpbtZLmcf7W8TNCJVJQnRyydCKVVkk+41iLpEVKq+ZqgJBsnMMVDOThN14RUykBR1iqaOedpPq4CwrAcQxU+UQPdnnPowaFqoUbdgU1yQVClNgQmeU+3ULxH6ES5HAZFpnSfwaoYEKAkqLuzFhqV5mmPYD0CrcLKEb5WYpAGa1O4apsHEB30B8oobmyVm3JByd/JybLM5BPNxxPKk2iwKDoCMCk41AfY6qpGyYFFHW4VgIdC7bwOmw1MgY7gleTrZ7BHDAlOEkD3QQKMRHC36WAg3MFF5MeNYGS5NjC0Xp9L5pt4NDPWaqo3BCtJ9NHx8XSCzcnnDqgAWSSZZgaDBKPWN4PhnB96PBfGKvE3P+2ZLYfiQ0HNcs6Ma9uTXQY0ECADnBSQA9kEYSOXw5T1hnvQP7wNxwnqHtjAJhg7WBWIASYaTGZ/+jt3MReFAJm5nf6OscxqCJwV9j7ilARjoLgYqAgGvBp6h0CX2L5a4B58tYUBQPbji6fPQwPd0EUIXOidcGsSqHR4f0CgD8WG4oAVjL+P22do1/MVDnRRXDTjork3oeKiGRfNuGjGRTMumnHR9Nz/46IZF824aMZFcywAcdHcBf2vFs1ZQs7K+WvRFEsypROakKti8dy8mIebupk3Zb0wj/flU0e6KMrnl8Y8nFfF5+6Lp3VVtwIXH1W1mv0AyH6K35MdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1337",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531052",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.49080964",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGk6Q9NPYkKgh6KCB5KDy2GdiFmpUahlL67wVYPInjb2W+YmWKAvMZjf9WQwY5qzMn0DVlgkBNad4OsGKbTGxRPQ5ksgojLJIxhZL9QkAr5hZSI/6EpsHzXLruu6n23f6yxuminO8gEFwz22jauncWBXOXQz53kCc8ftNXYtO4lEhkz2Bj9mL2B4JEKFYMVGfK59m7MWD4BG252qwsBAAA=",
    Pbi3DGeometry:
      "PQgAAB+LCAAAAAAABACVVV1LwzAU/S95jiXpd7qnoYKgD0MFH8YeNla2QG2kRmGM/nej7WpzyU07SktzcnvuSW7O7fpMVjv5evooSUEe1U6+qEruCSUrJWv9SYr1uXs102xhLtLSf+SGM7b4e5ibtJvLZ8um2Z7MtyLIU8Epj4MwjRLKWZAkaUwNHGW5BYdJ+AvHmYXGWURxDsFDR7RgLHJRA5JYRMIjBEnphq9M6YYxErhKFnHHTvXovNVchHQcPGfheLd7jgG2OQbYXjqM7lVDbjcJBs9TArYVwJhAJCXU3e3rTBK/Emw5oAp2JSeC7ZLBsntNBjnc1vMaEikjYhoY7Us489z4T9k882Ik7u4y0XRAuRBPT5gGSQkEznWefYIRJUjTgYcS6UUI7HcH0hVhtD8lFIiQuC12VXtGONxt2NucYcH85nU3AHfCsTjzL76T2/dSlw0pWMAoeSrrgz72g2elt1qquh++yf0w9VDKw1H3g/uq/B4H3qpKGcL6q6razQ8uxakRPQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3104",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3114",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3200",
    Length: "25",
    Mark: "594",
    Material: "Copper",
    "Middle Elevation": "3114",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "38",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3114",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3123",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531053",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.74107421",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xA61FoTV6KCoIsigovSRYqhHYgZqVEopXc30OoJ3P0v5ptygKKmS/+woOHINRXs+oY9CCiYfHiCLodJxoGSq6XCNS4kYp7DKP5dVV/sputMH9kx2JG522A70IlMBJysb0I7mzMHEyi+O9kr3X7VwVLTRgZKzNJMwN7Z97xVMk0UCtiy43jWv5wbqw/zbj65CgEAAA==",
    Pbi3DGeometry:
      "EwgAAB+LCAAAAAAABACdVV1rgzAU/S95zkJSnRr7NLbBYHso22APpQ+WShtwZrhsUIr/fZl1bXQ3XiuimJObk3M/crM8kMVave4/cpKSR71WL7pQG0LJQqvSfJJ0eTj+2mk+tw+p6Rm5EpzPm499Sb36W3ZTVdnerpVMch5QETIh4pgKzsJoFlPJkkiKX5gnUejCUswaWF5HDuwjaa1FIBOAW4SJdOEgTsYr8WyJuDNyy2ElfZIwhpw8or1A+cLq2dCNtmQBt4t7HCe04/g/20byGXXzgjAM83Y1dNzAUFCZZzcnwphrEyT0nHASB+vyFDgcXsx4TB0jifNEwlOtOMXkAwzrGDoeQ8RI+kEQzz4s4RLby9oHWFdom0AZEBCubE/zQRmmdjVYBXyF+GCcA0FHtDWs444xbmF7w96p7D03eUVSzjglT3m5Nbt28KxNZpQu2+Gb2pymHnK13Zl2cF/k367hrS60JSy/iqJe/QDv2PJOEwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "352",
    Mark: "595",
    Material: "Copper",
    "Middle Elevation": "3095",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3211.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "38",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3095",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3095",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531054",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.16763484",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEksS1tPYkKgh6KCB5KDxVDuxCzUqNQSt/dYOvfydvOfsPM5B1kR9y3Fw0pbOiIGZm2IgsMMkLrrpDm3XB6w0QqPo2imQy4iKWCnn1YwmPxF8kw+EVfiQMrXsXzpilb3+4fSyzP2ukGUsEFg622latHsSNXOvSDB3nA0xutNVa1e4pIhQxWRt9Hb8KVr2OwIEM+1t6M6YsHKz75xAwBAAA=",
    Pbi3DGeometry:
      "IwgAAB+LCAAAAAAABACdVV1rgzAU/S95tpJYv/s0tsFgeyjbYA+lD5aGNuDMcG5Qiv99cbNrqvd6tYhiTk5Ozr25SVZHttyo18OHZCl71Bv1onO1ZQ5balVUnyxdHf9+TTdfmIfVzhmZCc4Xvx/zsnp9GnZTltnBjJ0Jz52HoSN8l8eh7ySu55umBQsRRQ0sAt+GeRKEDez5gUOLnNhhHEHaUZRcwH6cTHCCTDkczsgph510ReZJDEXZwp1UIeHYUyZuzPvpPqO2hMW1Iu9zG8993cYypTCse+kBjgJBYWfwbFaKKYVrPHSigFcOSQ9c40iGEfKExMPCWGmSq0+X9wg27WN4i4xaVpgLo/S2hiVGnAE0m/aBnAwWTBYuzIVR5MSZUvuYBs0mfWBXypSjD+QiKH1vwBLjrzvDNjfuncreZSVLlnKXO+xJFrtq3zaedZVVShdt801t/7sepNrtq7Zxn8tvm3irc20Ei688r9c/Zb3u+iMIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "6758",
    Mark: "596",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "61735.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "38",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531057",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.83118161",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yyiy3TaKSoI6jBG0GHs4Eo2wTSWBWPsu2fFoNvz8nt4qhGKxp6GuwEFh9DY0lyi9q0zgKAI1scHqGr8yYRInHNJV5RhSoWAqZ6pdd/rIaEp2Fp9M9H0oAgmCI7Gt7H7GEoZR1CGqKMNHhTFS0GE5IuMC8lyyVN7ttd/eG9s28WvJyxDsHPmNa8JZjwTCDbBhXTmn85N9RuLcXjY0QAAAA==",
    Pbi3DGeometry:
      "hxsAAB+LCAAAAAAABADtV01r20AQ/S97Vs2u9ts5lSZQSA+hLfQQfHCISASqVRwlEIL/exV9uNEyTyuduxgb63k8897M7MfcvrGbu/Ln65+Cbdl1fVf+qKvynmXspi4PzRPb3r71X9uf+UX7YqfsH/JJcH7RfbRvdtqNf/t8PO5f2//6jcutyoTaCMfzTPCNznWetbD0ZgJrZd5h7zQFA2vjxQQ2xmEnXnC7gIny2maYd+B7tKadgJCIybKQQLxyUs/IAbzHkMLaDjb5RI6y4gN85h1YD765cznhJIRByJHgNCRgchavvVzAhA6J5Ay+uTUL1NARkWughtYe6x7Z8dPc+JkCj4kyWnWwbVOBmwc4oeEIkUUaEb+ImqDsESfrsj1Rgwo5dtRUOlh7oOq0j2X75fy+g8obaQYAB8mOqFmVqGWLPSIyoK1VH5G7DtZSqZkjRA5OhNZ9uq3sYNn3CM/98pItk057BjxGjbkTPevczxx8UCMNy2mnvZutzgjYFtfJASUbrQd+3Dq8PdO2gB1tPN844HQLkxqREggHix11DqgXyQ+qIQuDliloBZIIaEogHdxqnLQUbXCwe5Ig2LTBDs+VIRq7hS0lMhKRPjxoNDjWQcD5hKBLYZhsupDg8kJnBIUEGQFy6NULykuuU3TtQDTWaEHJptMHrCN79nTTAcojrqc+0oiFL8lpxEojFtaeRqw0YqURK41YM8d1GrHSiJVGrDRipRHrfx2xdhm7LPe/i6Y4si3f8Ix9Kw4PzePw8L1u9k1ZH4bHX+X9+aevRfnw2AwPV1Xx8tHwS13VrcPDc1Wddn8BRXW4NYcbAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3114",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1339",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531059",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.34815769",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABNjU0LwiAcxr/L/yyiy+m0U1QQ1GGMoMPYwUo2wTSWBWPsu2dv0O15+T089Qjl0e6HqwEF23C0lTlF7VtnAEEZrI83UPX4kQmRuOCSzinDlAoBU/OjFn2vh4SmYGX1xUTTgyKYINgZ38buZShlHEEVoo42eFAU54IIyWcZF5IVkqf2YM//8MbYtotvT1iGYO3M47uWOCM5gmVwIV35u3NT8wSeUvpGzwAAAA==",
    Pbi3DGeometry:
      "ORoAAB+LCAAAAAAABADtV01r3DAQ/S86u4u+rI/NqbSFQnsIbaGHsIcNMYnBXZetWwhh/3tVW9tIypOc5CyWXdbj8Zv3ZkaS5+qBXF733+5/dmRLPo3X/ddx6G9IQy7H/jD9Iturh+Wvu00v3IecmkfLG0bpxfzjvuS0Oz/29njc37tn7cYoyxomN1Srxm4EdVfOaE07G43hT61MarbmaxnVsy/TehXBU2CtFYFVWAU4QLreNYEtAiTBilaYmyQY1xLoxRQwXarUYzAulQqNCwDXKnT1bBNfD8uZ5gAhsaJgZ4A4WIbCopcbI9YpwGBYg4el7aoEHAvDZjTEenErtNSEuErafCU5E6EIK+Vqh+DWTayYQ7FqiRUzK/ZjUmGM8BIOZRVx3byv75w46cmiwiWGAKU9BC/VxIpLmSl7MWFw+eA2jZcPFFZ+PrZmlEG22ix66VwboUWwDyYAmvHFugBIGa9gPneCYHZVwwvURqCYgFUm1NX++y2fUfjsS6xGnCm8MgV4a3u+BlyaloXCXKzs1lryTEhBVxgeP5/pF9haSClctbAxYFUymUbhcfphKOyKCOS6DUnFrxhnroKDZCfHoOflrKAH8Sab25AFD/rVK3PW8HDE0TAutuJDNxMN5iHzcgrXTDE5mfeJKA2ZAkFcLKL0opNQgAsPp3Gl7M/RAJOLcTOFQCkv7khJ60JUCFBnl1VrnV3yFOrsAnqhzi51dqmzS1Nnl9UU1Nmlzi5PpdbZpc4udXYpzy67hrzv9z+6qTuSLd3QhnzuDrfTnb/4Mk77qR8P/vJ7f/P/1seuv72b/MWHofsTOr4bh9EBHn4Pw2n3F35ji6E5GgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1341",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531061",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.4192845",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaVKwnqQKgh6KCB5KDy2GNhCzUqNQSt/dYOvfydvOfsPM5D1klTl0Fw0JbLEyGdquRgcEMjTOXyHJ+/EMBk4Zl2ox45JGUggYyIcxOo+4+MskV7/sK3Nkxat62bZlF/rDY2XKs/a6hYRRRmCnXe2bSezRl96EyaM8mtMbbbSpG/8UsVAE1lbfJy9nNIpVTCBFiyHX3awdigd6aL6wDwEAAA==",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACdlV1LwzAUhv9LrrOSrOnnrkQFQS+GCl6MXXQsbIHYSI3CGP3vxtppZnvI6SgtzduT53w0J1kdyXKjng9vkpTk3mzUk9FqSyhZGlXbd1Kujj+v7jNbuIu09E+ZccYW3cPdpF2fpl01TXVwc3nEuEjojIsoFpmgnEVxkRbU17M86/Q0Sc/0JE07PRM5xXB6e8FH8WKec18XrCgmhQO5DaSF9RuKZ8hh+Ui6J3lQNSCtM7csKmI+H1bf132Or/tlGLHvwh/hf4ePwQTw/8OB0gLThcIE/PrVR2AuDWeYlvd3MeUBegKzlhGYsAzVBlrgGHsAj/AK/EBEt03EIGRoFSB6E7YH8GGv0BqbunGhOAgd6gVoR0PYQ3yUX2hnxBwcUzkYHep9TDMHzs8B39Pd+X6jqldpZUNKFjFKHmS9s/t+8GhsZZWp++GL2v5+upNqt7f94FbLT9/w2mjjgPWH1u36C6Z9xyqRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3161",
    Length: "25",
    Mark: "597",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "232",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "39",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531062",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.42473076",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xhSozatK1FB0EURwUXposWQDsSM1CiE0rsbaPUG7v4X803ZQ9HgJTw05HCkBguywZADBgWh80/Iy36UcSC4Wql0PUsWXKYqhYH9oau+6E3X1SHyY7DD+q697iAXXDA4aWd8O5kz+dpjfHm0V7z9qoNG00ZIwsV8KRnsrX5P24xLkSUMtmQpnnUva4fqA/FsK6UOAQAA",
    Pbi3DGeometry:
      "UAgAAB+LCAAAAAAABAClldFqgzAUht8l12mIJFVjr8o2GGwXZRvsovTC0tAGnBkuG5Tiuy/btDbWYyJDFPN5/POf40lcn9Bqq16O7xJl6EFv1bMu1A5htNKqNB8oW5/+bu1jurAHqnFHZhGli9+LPVG9aV9bVlV+tO9SIvAs4oQlaYIjShjjHFOSxnb4wzkV4pILmjbc3nR8WKQNZvM4HhJnPOGXnCXzKWYGJx1PJ3RGn5O+DrcJDmXa8l65wPIGzSsIoyJycz0zV/oauwruJxoVHpzMaYdgDz3sFKnDTi2uo13HUH6ACIABkWHfAT0P1Nkb7uts3/fzJdJv3xCVf6xrwI1v0YzKexsCwCENAXmZGD51nwFWRMB2EiLjxSGLFvIyMTxgJwTcAP8fkIfI+LBnN4RcTIltuP0936r8TRpZoYwSitGjLPfm0AyetMmN0mUzfFW786N7qfYH0wzuCvl1GXijC20Fy8+iqDffUc9CIlAIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "313",
    Mark: "598",
    Material: "Copper",
    "Middle Elevation": "3056",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2854.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "39",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3056",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3056",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531063",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.75272868",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk6Q+2nkQFQQ9FBA+lh4qhXYhZqVEope9usK0HEbzt7DfMTN5BdsZje9OQwo7OmJFpK7LAICO07g5p3g2nNwg+D5RazGTAZZhI6NkPFvJAxuqLJSL6x6bMYqpeNk3Z+n7/WGN51U43kAouGOy1rVw9igO50qGfPMgTXj5oq7Gq3VvEKmKwMfo5ehOuZBQyWJEhH2sfxvTFCxD/iCEOAQAA",
    Pbi3DGeometry:
      "KQgAAB+LCAAAAAAABACVVV1LwzAU/S95zkr6/bEnUUHQh6GCD2MPHStboDZSozBG/7uprbZpcq+R0a05vTk5996eu+2FbPb8+fxWkYLciz1/EjU/EEo2gjfynRTby3CrHrO1+pCOTsjKZ2z9/aUu0u1+tl21bXlWe5mXJVlKV37o+VHu09wL0jSnCg7TWIOjJOnh/mcO97thkpxllujcRrxk8OMIkQGcZ4f/c54dtjIskwui2FahEXZMZJQxkERe6CfBrMwDyQRrJBM8pW2EDqINYjsDBDvK0Eq6hK3qgPOWooeSOjGgGqBEltXHWwj0CnAK2lmD21GgSxcNs6AkQLSr8dFGGiQA7Pg2aCRL2PaSIG62bf/T+HAoYkFjQNhhJxNrDAaMWsKYPCgJEG3kgg5XQwkwMQEYJTF0o1Y2CuvocJd5oOlW/7s3vHytZNWSgnmMkoeqOcrTuHgUspRcNOPyhR9+H91V/HiS4+K2rj7ngdeiFoqw+ajrbvcF3US99CkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "356",
    Mark: "599",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3249.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "39",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531066",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.2317487",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNImrRJ60pUEHRRiuCidBE1tIGYSI1CKf134wvczRnOMPUI5dHsh6uGArb+aCp9Csq1VgOC0hsXblDU4ydGhWCZSTGfUY6ZkAKm5qct+l4N0Y3FyqiLDrqHgmCCYKddG7oXUMozBJUPKhjvoGCYcprmSZayVOYiZxTBwZz/5Y02bRfeTHiCYG3147umBDPGOYKltz6eubu1U/MEQKLIudIAAAA=",
    Pbi3DGeometry:
      "cxwAAB+LCAAAAAAABADtV8FO4zAQ/RefQ2XHjhOXEwIkJDggdqU9oB6KiCBSaFAJSAj13/EGF5KJX5zuXq2qVTOZPL83Mx5nbj/Y9V31+/25ZEt22dxVv5q6umcJu26qTfvClrcfX3/tbX5sP2yX/FiOBOfH3Y/9st1q/9jJdrt+t8/yhZEiTY6EWkiZJ4IvpNEm6ZuVSf/aVapV36544bUjf5kXHb6ShZ6Do1KupvhInQ/x/fT38CN3AIOWhXSml0VRkFmWzqIzpF9o+3h/Wak6sykIjLPv3b/ZO7s0BJ7YEQ5YlsIAOkZYFoMoBOiAZZGqNJ9Ep6JCq1J4FGQQBVQ6BYXP/RtiXwpCZ0NZyog5JYUqn5aUn04wt1RtiOZIlr8WEM6hfJAslFxSaSQnZHvCUgigTHfYuS2KJhxFHtrBLgw1EbILvVqDm4S2BCQWlUFmHHmtRNdgufY2Utd4C621szsc0+3BzKEoKcKaDgoAQAY8cqtqcDqmSvtyTU9NeMpCu+zMQvxDVOCpcJAmlLoik0N/mZtsop0jd8QS+SM6AAdWGMIJpnbQDYINaJA/qBVwAZkC5e51BlRQpQblkzekH+pGSl86Rqe0Y2ntfUmB/k6PA1fxSnyJGh3dQinfviGLAvDQQY9eNcmiIDIwkmj/AfIowKHQkFX96FBU4F1tRAZsYnTK+6UeKAmVJEIH7rAfBhrZKAYAH+DEwS4OdnGwmwMfB7sptXGwi4NdHOziYBcHuzjYzZEfB7s42MXBbqqR/c9gt0rYWbV+Kttyy5Z8wRN2VW4e2kd3cdO067ZqNu7yT3X/feuirB4eW3dxXpdvfcfTpm4s4Oa1rnerTwywjMlzHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1343",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531068",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.90790046",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2ziNqfOTlFBUIcxgg5jByvZBNNYFoyx7569Qbfn5ffw1COUR7MfrhokbP3RVPoUlGutBgSlNy7cQNbjR0aEYMEEn88SijMuOEzND1v0vRoiG4OVURcddA+SYIJgp10bupdJEsoQVD6oYLwDmeCcE16wLGW8oKJgsT2Y8z+80abtwtsTmiJYW/34rguckhzB0lsfr9zd2ql5Ai84lC7QAAAA",
    Pbi3DGeometry:
      "VRsAAB+LCAAAAAAABADtV01r4zAQ/S86u0GyFFlKT2VbWNgeSlvooeSQUtMavPGS9S6Ukv9ex1+JzDzJ6VmEhHg8fvPezEjyPH+yu5fi8eNPzlbsV/VSPFRl8coSdlcV2/ovWz1/dn+b2/yy+bB9crRcCM4v25/my/br4bGr3W7z0TzLFybNkguhFjIzWWIXkluRNFZp09asuElPzNaQZuCtTYetUq6CIFY0Th4mUtlTbJr2AD1xpjFARETEHxFIl3KGFsB6CCj0wZoqrR2M3pxpl7TrPUL3ZpGlFEhvpiNOMbqIgMhReW82RnqIkBGRmCk0X3q00AERNBBDSw82jm77PdXKesp7bBFuD95WKdw5AIM2B4nMEYn4hdS4ZQ+BnJduRw4q5dBSrnaw9EDdaQz/VjlrzwHlDfYCbXZzHdByVpZmLfWgRIf1UonObMzBKjOH9PREGTAMb72V6ta6FA4RKWy4XLOE08CAxniwcd2CLDPPcYcUArPsAlr5/XSAHfEsMXS1xtJqIbuAeF+mfQE32tnfMuBMmyTUL8QVTS9w1DFkoWhuQAhdEBAPtQBFA7QirRq8wozQDmdwjluSHdii0YbOlSTauTErSmMoJDgsgNk9yUFIf0rQ2+8k2WQZwdsKnREUEWQEiKFXLagvuT7xewbgcY4YlGsyfbSzf5t2txqg2w/sQsRJKk5ScZKKk1ScpE6IxEkqTlIeGnGSipNUnKTiJBUnqThJdRDrhF0Xm995ne/Yii94wm7z7Vv93l/cV/WmLqptf/lUvI63fubF23vdX9yU+f9Txx9VWTWA239luV9/Af5sO/1VGwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1345",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531070",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.23846545",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdFXdtFO0UFQR0kgg7iQWnRgW0nbAtE/O8taR0i6DZvvsd7L+8hq/DYXTWksKMKMzJdTRYYZITW3SDN+/H0hpiHMlGLmeIyThIY2C+khBBfKIqjf2gMLN61y7YtO9/tH2ssL9rpFtKABwz22taumcSBXOnQzx3lCc8ftNVYN+4lZDRnsDH6MXnDgAspFIMVGfK59m7MUDwBaz0yDgsBAAA=",
    Pbi3DGeometry:
      "MQgAAB+LCAAAAAAABACVVdFqgzAU/Zc8pxJNZtQ+jW0w2B7KNthD6YOl0gacGS4blOK/L9tiq5fcTBHFnFzPPcnNua5PZLVVL8f3ihTkQW/Vs67VjlCy0qoxH6RYn/5e7TRb2ot09IIsYsaWvw97k27Tf3bdtuXRfiuihKUJXcgoFXlOYxaJxI5FFMurIcpzkf+gmYhHwbGkKEWSZNwTzL3MkIOnXKIysIQIPCsjBiMkYI1cJplnn3p41tIdh+ScX7bPUfQgoDjHjlcOo53oMTPG4Yen6QB7CmFEHiIEqHZ7OpEkrMS/GliBcRX/CR6VC9ooaC7A4LVc2IhICRG7wMoGE047M8EDNtG1fg5/Twl2GngyECeHveJPCMRNsxs4uIgOpNFAEn//weCwKZBOCKPDKaFAxHB+a83ryZg/keYb7MnQzSHfIs5H8g3V2f/vrSrfKlO1pGARo+Sxavbm4AZP2pRG6cYNX9XuPHVfqf3BuMFdXX0NA290rS1h81nX3eYbXBJl+jEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3160",
    Length: "25",
    Mark: "600",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "138.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "79",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531071",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.60346935",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACtjksKwjAQhu8y6xjSRq2tK1FB0EUQwUXposWQDsSM1CiE0rsbaPUE7v4X803Zg2rwEh4aCjhSg4psMOSAgSJ0/glF2Y8yDuY8Fct0Pct4li9WMLB/V9UXu+m6OkR2DHZY37XXHRSCCwYn7YxvJ3MmX3uM7472irdfddBo2shIuEilZLC3+j1tcy5FnjDYkqV41r2sHaoPsGRGowoBAAA=",
    Pbi3DGeometry:
      "CQgAAB+LCAAAAAAABACdVV1rgzAU/S95TiXxo9H2qWyDwfZQtsEeSh8sDW3AmeHcoBT/+zJnZ3Q3Xi2imJObk3M/crM5k/VOvZzeJVmQB71TzzpTe0LJWqu8/CCLzfn310yzpXlIRVtkxhlb1h/zkmp7WbYqivRk1oaeH4iIzoQnkiimnHlB4IfUwGzu/8CxL2zUj4Ma5SKxYQdHYy1EIABqMQ8jC+ZTdDg2HPZl1IbDMvoUccgBDy9wP0ygL44N7UgnXsAS3mNoQdvrf6a14ha1U4IxDPJ2JHDIEgQdssCtOtFFGKYr6DpgZwyW5ahrOLSo8YgCxpIGRxIu1BEU155bRz6GT8YQNZJ/B4rl36Fhiu2U1gFXFtoicAqsZMEOATcelODKjgZrcFwdDhilwFC8paHNdoRxA5t79Valb7KUBVkwj1HyKPNDeWwGT7pMS6XzZviq9n9T91IdjmUzuMvkl214ozNtCPPPLKu23xa4RX8JCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "312",
    Mark: "601",
    Material: "Copper",
    "Middle Elevation": "3055",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1703.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "79",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3055",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3055",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531072",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.86149205",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9jk8LgkAQxb/LnLdF1/92igqCOkgEHcSD0qID207YFoj43VvSPBR0mze/x3sv7yGr8NTdJKSwpwozUl1NGhhkhNrcIc378bQGnwtfRMuFK3gSeyEM7JdFPA5i7wu5YfIfzYnFp3jVtmVn2+1jg+VVGtlC6nCHwUHq2jSTOJIpDdrBozzjZUY7iXVj3iIUAYOtks/Jm3DhBj6DNSmysfqh1FC8AOi3uGwMAQAA",
    Pbi3DGeometry:
      "FwgAAB+LCAAAAAAABACVld9rgzAQx/+XPKeiMf7s09gGg+2hbIM9lD5YKm3AmeHcoBT/92XW1dTcZRFRzNfzk7tL7rI+kdVWvB4/SpKTR7kVL7ISO0LJSoq6/ST5+nR+VZ/9pbpIR0dlEfj+sn+om3Sbv99umqY4qn+5x/yY0UXAvCwNY5p5LIg45V6QRFcqj+NfNeXBlcx4RFEGY2kIWYcg24AkSYY6gs2IyLNmxGQEMg0yThMoU4M8K/SekXhppKa4pK9HjKJOGFU9bsO293iKRQig6uSCnkxDhR2DXZi4e06kG8HmAxjENOX6ZMjSG8bwhrCFYZKdFm5AWGI2N7EFgRibkdjKxsgyUgewbGNMnUZUcFUtzQwE/N/4rMb4zjKaISa7bE6dMKeczWZvQSDGzmeApaZNBiI79QUdYahwPbmVtf3UAlxWp+ydKN7LtmxI7ns+JU9lvW8Pw+BZtkUrZD0M38Tu8umhFPtDOwzuq/JbN7yVlVTA+ququs0PesjIQhcIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "1562",
    Mark: "602",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "8531.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "79",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531075",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.60001567",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2zinNO5TlFBUIcxgg5jByvZBNNYFoyx754Vg27Py+/hqUcoz+Y43DUUsPdnU+lLUK61GhCU3rjwgKIefzIiDFPC6XIhsJBZDlMzU6u+V0NEY7Ax6qaD7qEgmCA4aNeG7mOShHEElQ8qGO+gSHAmiJA8pVxIlkse25O5/sM7bdoufD1hFMHW6te8JjhNKUOw9tbHM/e0dmre+LftkdEAAAA=",
    Pbi3DGeometry:
      "qRsAAB+LCAAAAAAABADtV01P20AQ/S97NtF+rx1OCJAqtQfUInFAOQRhgSUTo9SthFD+e7d2bOJlnj967SoiwZPNzHtvZmd37t/ZzUNx+/aaszX7Wj0UP6qyeGQJu6mKXf2Tre/f23/91/zcv9gh+bCcCc7Pmzf/xw6b7mcX+/32zf9Wr4TVJjlzK6eUSgRfqUxniTc7607NWmrtzVIZyoxWcysHZmUtdiK1y2YgUdaYBOIOfXeraScgJEIyLyQgr4z/xEgA7i5kZtLGrORAb2vVibnHPVzd+U6lkYST0EyH7AEOQyIkHXmjxQwkICSgc/SdKqen6YCQwDeiQ5OfKh/nTGN2ZNl3me+k0i0Q7SSuHuQDmCeAzCNJ45sgE+R93McysQMyIJFdSQ1Xo2ZCpx05mdcyJ1oPSPB4NdDWodhTZJYJNWu7T3EcwBaZsM2O5KaBrbmW+Azx5tZH5vPciO1EY+atE8HNgozN5E77ppH0JFOjW9zS4rMPs6TNfFBpmmf/oAno84vogKT1vViIthf/VRK2aLAadW6werx8wCEXCjtOJyQPNjwsH5A0EiCkQ6YY7lZQEBQSdC0DhQyuN5KnlILguFV0sYETHrV6kRL17c0ZxXIiJDhGgDk84emQ45qgC2KoN40b3WNoTUBIpAlNB+xigAS0AnQHQUiW0EF6077B6vH+HdIB5Md9hy0szlxx5oozV5y54swVZy5CqDhzxZkLJy3OXGT5xJkrzlyfNYkz1+kd5H+duTYJuyq2L3md79mar3jCvuW7p/r5+PC9qrd1Ue2Oj3fFY//Vl7x4eq6PD9dl/vt04WVVVt7h7ldZHjZ/AJ46ZSupGwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1347",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531077",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.44690416",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABNjssKwjAQRf9l1jGkMU2auhIVBF2UIrgoXaQa2kBMpEahlP678QXu5sw9w9xqhKIxh+GqIYedb0ypT0G51mpAUHjjwg3yavyMUWGYEk4XM4GFTDOY6p+17Hs1RDUu1kZddNA95AQTBHvt2tC9IEkYR1D6oILxDvIEp4IIyeeUC8kyyWN6NOd/eatN24U3E0YRbKx+fK9lrJIiWHnr4yt3t3aqn0NM5ljPAAAA",
    Pbi3DGeometry:
      "axoAAB+LCAAAAAAABADtV01r20AQ/S97Vszuar/knEpbKLSH0BZ6CD44RCQC1SquWgjB/72bteRI8puVnEsvi4kdjcdv3puZ/ZjbZ3ZzV31/+lWyNfvc3FXfmrq6Zxm7aapd+5utb5+P//qv+bV/sUP2arkSnF+HN//HDpv+Z+/2++2T/61aSWWL7MqubKFdVqxyXojMW3Ntg9WY/NUqrAFW7Cu5kcGqlZhDEEZpmoOTWg6skG+PO/GFCDgawSEaDSt2uVWzHDDfLprT7gVXKmOGCJ3VmiHfse8Jt7MKKwFCZ4XRpgjHaJjDSXFndf6D5ICjQRVTXK5JETgYAYsTCQXHm8SJ0NTSqIIuZi9C5frFt1CKbBKMQFjjHBZow8xmVIxKPINwQX4nKnDd+tYZ+RLbA25UjBDd+pZsJcSSj1ceW8f5jau4JDtLlnFc25iv5C7kzJlgze2Q7/Rg6I6AIjeBrwrrWAk35JCLYrZCixRjXMyhP5yMCwiePXViUdKgVYljQznx1jTgnfoCEbg+fS1FLo/ByF0WemJW0DXaH/hYmiQxqmAsFi9gqj1gbSAxQgSuI15+RM0RB9x3SDBxfSqEOadLnIwWESMuE8RJw81543qrPpc2Ew3v/dA6vYDBaNE8ENfTSXoRXSKROA2wQAQuEgFXJXGlQguQvB5gBss1UMlFuNA3uumONeCMR1HHu1AaatJQk4aaNNSkoSYNNWmoOb9cpqEmDTVpqBmeNGmoiaQhDTX/e6jZZOxDtf1ZtuWerfmKZ+xLuXtoH7uHr027batm1z3+qO5PX30qq4fHtnv4WJd/h47vm7rxgLs/dX3Y/AOYQKIOaxoAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1349",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531079",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.41487895",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdl01XTTlFBUAeJoIN4UFx0YNsJ2wIR/3tLWoc6dJs33+O9l/WQlnjqrgoS2FOJKemuJgMMUkJjb5Bk/Xg6w2wuuCcifxlL7suFhIF9wViEf6EXBcEvnGJHmL/rV21bdG6De2ywuCirWkgEFwwOytS2mcSRbGHRzR7lGasP2imsG/sSoRcw2Gr1mLyu1g8jBmvS5GLNXeshfwIp9hvLEgEAAA==",
    Pbi3DGeometry:
      "0QgAAB+LCAAAAAAABACdVlFrgzAQ/i95ziQmThv7NLbBYHso22APpQ+WShtwZrhsUIr/faHVWY3Xi0UU777k++6S3OnyQBZr9b7/yklKnvVavelCbQglC61K803S5eH0amE2txepaee5CRmbHx/2JvWqnXZXVdnezrVQwFkiqIwCEQlOrS3kjNMeEJ78cdJ3iyg8+pM4pH5EzYyIMzGmEHF52/PzGUsmhQQqI7n5K2MhjTBJOZp0C7jrN56cqyxZPL4RLTAgat3OYvTHdykMBLoUUCZEYhgSmBucNBQrpOzuA8J0dUxucsONRlcJLBT/A45S+QPQQkEnHxsPCngrg3uKFONkogkAeDqw+r0wA9TwFgfP4PRGh1N5A0DBAA3w8miQ3VsW7KPI12YqjT8ANgi03LFvr6txBtj/gweVfeYmr0jKAkbJS15uza4xXrXJjNJlY36ozT/0lKvtzjTGY5H/ng+814W2hOVPUdSrP/bEJTnRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3066",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3161",
    Length: "25",
    Mark: "603",
    Material: "Copper",
    "Middle Elevation": "3075",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "138.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "80",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3075",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3085",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531080",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.53630353",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xiSRgutK1FB0EUQwUXposWQDsSM1CiE0rsbaPUG7v4X8001gG7xEh8GSjhSi5pctOSBgSb04QllNUwyDRZScLVScl0suZIZjOwPXf1Fb/q+iYmfgh02dxNMD6XggsHJeBu62ZwpNAHTy5O94u1XHQzaLkEkF1meM9g78563BVeikAy25Cid9S/nxvoDIIlf8Q4BAAA=",
    Pbi3DGeometry:
      "nwgAAB+LCAAAAAAABAClVU1rwzAM/S8+e8GOE/LR09gKg+1QtsEOpYeUmtaQxiPzBqXkv89N081dolpZCQ31k/z0JMvKfE9mS/W6e5ckJ496qV50qVaEkplWlfkg+Xx//GvNbGIf0tBf5IYzNmlf9keaxWnbbV0XO7vXmgIR8pRmUSB4SA9LESe0xWPBD3iYsuTccMKz7ByHiI7+QkR8MICIxJ8NaSTGKYIie1LDR/Yo6hMlcTicdGfoVw9MDortHEMWCJbxPo+LO7UYcG8zcHHn0BAsl8l7WpyUEDAkEQjqlh5D8y8xvZTccwVEQpcCKDvGHdH4iEOFKgN2N4LnugkAKfJdq8shMF0C4f4uAfWM9R87kaA2xM0dBBEGh+4FONYwRFdOTkgT9AGDcAQPAvaPTsx4R7h3uP3a36tiK42sSc4CRsmTrNZm0y2etSmM0lW3fFOrH9ODVOuN6RbTUn65jne61Jaw+izLZvENItdaFZ8IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2743",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2743",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2837",
    Length: "313",
    Mark: "604",
    Material: "Copper",
    "Middle Elevation": "3056",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1708.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "80",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3056",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3056",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531081",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.55847901",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzG0aVJtPYkKgh6CCB5KDy2GdiEmUqNQSv/dYGsRL9529g0zk3UgSzy1NwUp7G2J0uq2sgYISIvG3SHNuuH0hlnIaBTHy4RTNhcCevLNAspD8R9GfMF/4JQ6sPxTvmqaovUL/GODxVU51UAa0IDAQZnK1aM4Wlc49KMHecbLhHYKq9q9RcwEga1Wz9GbUBYKTmBttfWx5qF1n78AB3EHZRABAAA=",
    Pbi3DGeometry:
      "XwgAAB+LCAAAAAAABACdVdFqgzAU/Zc8p5LEqNU+jW0w2B7KNthD6UNLQxtwZjg3KMV/XzrtajTXxCGKOTk5OfcmuVmd0HIrX48fAmXoUW3li8rlDmG0VLKoPlG2OjW/upss9INqfEVmlJDF70e/qF5fht2U5eaox84oC8I4xikP2JwkOA0Y180OHFJ2RmnEsUFO0zPMeITdGhd2PE8s0kmSGigP2QQfwIRjsXhOOOqjrxFyaouwhXtpssdiTkgCTiNLrq+4odKld2Mf0BvjQ/XGuVvGId93AwUF4pBLYFYj706Zf7oZBGVfVjhl1u0PZx6gT1sQSB7YwD67w3EIfMhOH+MHyXedITqE+5QASMZZMXzYbi9AKTFgjx0N8SHcXqomnQtAw4Ps8gFeQxMrpp0O4x6XDiTje1dqtr6t7+TmXVSiRBkJCEZPothXh7bxrKpNJVXRNt/k7q/rQcj9oWob97n47hJvVa60YPGV5/X6B1zcPmdfCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "594",
    Mark: "605",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3246.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "80",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531084",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.42695099",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjj0LwjAYhP/LO8eQNElr4iQqCDqUIjiUDlFDG4iJ1CiU0v9u6we43R3PcVf2kJ/sobsZULALJ1uYc9S+dgYQ5MH6eAdV9h85IjNKMBOMLiTHjCYwVD9s2ba6G9kxWFt9NdG0oAgmCPbG17GZDKU8RVCEqKMNHhTDlFMhk1QwMZeZZBTB0V7+4a2xdRPfnvAEwcaZ57c9XWEiQ7AKLoxj/uHcUL0AyTL0IdIAAAA=",
    Pbi3DGeometry:
      "uR0AAB+LCAAAAAAABADtV99LwzAQ/l/yXEeaNE27PYkKgj6ICj6MPWysaKGuMqsgsv/duHRd2+RrOt+EMBy2t7vvvvuRy82/yd0qf/x6y8iU3JSr/KEs8jUJyF2Zb6p3Mp1/63+VmM7Uh+yC45uzkNLZ/kv9kd3ioHa+3S6/lK4STVhK4yCNJlzwOFDPPE1Y0BFEYfQriJiUHQFLmLAKoAYP2f49T9NxlpikfNApHic9CETjgGFqIFMQHHvlAkcR4SIWI53q01CYYQebi1rAeNdUI6g1GhqN4Nd2G6MvgKYguGkKehWqF62IuJ2C2JBfGiVDEKZPLmwTAtJDAYFFxbn2thFI0DXHUqCCd4qKRqOKDbaGiYB8cubbFDicNbFRgQBDf3AJsoPprjWaGuznyOhjXCBOU64DevzJ1i8EGEL0HqXCdeSYvYpYOxvJEOCQIxYx0yxYvMeOqLQfws2pzYVgWqDnGFXloC1JzSKS9ooy6Z0eEIiBnFJut4cuE6mtCIxhjKc3FkgdwJD9NU54wJxGDuZ0Xw2tIkhoMjwT0O+hp0gBeoQs4fKDplyp7h8dI86tfkoxb+QUSh3uCbsC9AlVsiscxm3swIGlkltzZLkAaF+VoEvONSnM2VL3BJOxvQyUgFu7y8CGEM6bBL7p9rFRpHBsUaciFjDkzkAZ0AACs3NcEC0+gabHNwnA+nRysGYhBFKAZ+nwEWiJBkIAlvzu6XdPv3v63XNcsfndc9ym4HfPkb3qd0+/ew4OGL97+t3T75627vK7p989/+3uuQjIZb58zapsS6Z0QgNym22eq5f64b6sllVeburHp3zdiK6z/Pmlqh+uiuyz/cOLsiiVwc1HUewWP6sZjWa5HQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3075",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1351",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531086",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.35296638",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjV0LgjAYhf/Le73G5qY2u4oKgroQCboQL7RedLC2sBWI+N9bX9Dd+XgOpxwhb/RhuCJksHONLvDka9saBAK509bfICvHjwzIjDMqYsEXSlLBI5iqH7bs+3oIbAjWur6gxx4yRhmBPdrWdy/DuUwIFM7XXjsLGadxylKViChJlZyrJLRHff6Ht6jbzr89kxGBjcHHd61oxGICK2dcuLJ3Y6bqCR6oWlXQAAAA",
    Pbi3DGeometry:
      "bxwAAB+LCAAAAAAABADtV01r3DAQ/S86u4ssyZK9OYW2UEgOoS30EPawISYxuOuycQsh7H+P6pVbrzTP1pJbECHZeDz75s2b0cfcvrCbu+b786+ardlVd9d869rmnmXspmt2/RNb374c/7Wv+YX9YYfsv+VDzvnF8Mf+ssNm/Nrlfr99tt+1r1aykHlWqZUwXGbVSvIqzwa7kHqwl6Kg7FLlKso//+tn/XMRBePo2E99Yh9gCXhE3/kH+As4QdwFO5ItiFupkpIB0QH0VV7oSVihtD61H3GE0af+jn7g7/BFbgSJE9hB3BHHjwv5DDKIspRxdFBYlNYRnhdRSaGoCB0m5YkAe8e4JeHwtarmi855NcmqUiqmpVDnB3bAZqm0gR2wXOhkvxNolHPJLCbllXb0HxvNL4m/PlErQJyFbQqt/8BO1xyptiAmvQhRe/uLEOW6iONrhjQGDaXkIIGozBBWGjl/ABVHGGsf2CtvUzB66ByZV3FZnauCj0/TkaKYHJOiMDGHJzqbA7ssRy7yDdKgffS8lFD5DC8m3pLcJdyGPu8b0CO9EQ+IgrSF7Uhmj/YBtG+AykGWiA0oEdyuaHfUR6hNSQnQDclRl0JrqiD+KT1ylIpsXrTD42POFCfr1OVq7d7FjwwLz3RkR3cDFBaog6/jdPvNa4YuQr428PJOawNymr+tBfWmlzHUdyHTyIyQ7CBTWCWyGvNbnp8/wqZ1SWPdbNw01sXETWMdIUIa6yI6OY11c+s/jXVprMOHZxrr0liXxro01pHX8TTWzWb6fse6TcY+NdufdV/v2ZqveMau691D/+gevnb9tm+6nXv80dz/e/Wlbh4ee/fwua3/TB0/dm1nAXe/2/aweQV9DbKDbxwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1353",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531092",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.8191135",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUEKwjAURO/y1yHkp4lp6kpUEHRRiuCidFE1tIGYSI1CKb271epu3vCGKQfIz/bY3w1ksA9nW5hLrH3jDBDIg/XxAVk5zHFShKYCGS6RcaqkUjBWf2/VdXU/yVOxsfXNRNNBxigjcDC+ie0HOFOcQBFiHW3wkCUUBUrNFzKRqVY6QQIne51lVCwlsDO2aeOXeaIJbJ15/daaYioUgXVwYfryT+fG6g1fec060gAAAA==",
    Pbi3DGeometry:
      "cSQAAB+LCAAAAAAABADtWNFq2zAU/Rc9e0GyZMtKn0o3GGwPZRvsoeQhpaY1ePHIvEEp+fe5qZ04so6u1GdRWuqTk+Ojq6t7xb17Ybf3zY/n3zVbsy/dffO9a5sHlrHbrtn1f9j67uXt3+FjfjX8sEN2Rj4Izq+Of4ZfdthMX7ve77fPw3eVWRVC6kzwfKULrTOzEpXS2RyvuCgGPOd55cQNV2F8YcpXXJVlkM7oR/Lqkq+FNC595J/gQ/1gP0TcFjpAvzRF5YqP5V/ysnDpL3Cbb/mkdS736936yL8VzwXf9kPxQ+MDfUbqW/uF/CvBhV8/LA4oD5E+yjcyzlQexuYtoU+vNzKelL5dB5D/WB0Lt31SdYnWD9NB70V46DldvtfSL6Zjlx/Lhr8rEOxA70rn/tZCtJzJDCUT4h3WF12oN9zk6hU3hfTuB+AH1/Fp/0pRjfjRZS681V1Vwom7VSiPqEeEqQMVtK2qqNRcRefS14gBXSlVzdeUG228MoBP12OrflPurcW6c5V0j9zYXRLlAeqqZSEuDkNlci+f1Ad4YNcj/cTyF8kjx4wthfThdjUe8XO1BDrT9o7wKcXj5GVZyhD+OQwW3262FP9UGsGyUBgi9c/pcxkf0j9Kn8V7QToAPDaeEIflF/iBfErfjpuzAIdG2d9qkEekTjVKlDvosmCfCdS04KoADnVcUYh16b5cADS0uKDT6b//gJciMqFtFzR3Ew4sf0QrBxaBONXIrbMdW1OgfmgroS4cxAUizXXSXCfkhpXmOmmuE5O3aa6T5jpprpPmOuHqaa6T5jpprpPmOkv9NNdJc50010lznTTXmessgrDJ2Mdm+6vu6z1b8xXP2Nd699g/jQ/fun7bN91ufPzZPJw++lw3j0/9+PCprf/NiTdd2w2Cu79te9j8B8Z43qhxJAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1359",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531093",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.06530697",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjkELgkAQhf/LnJdFJ1dZO0UFQR0kgg7iwWjRhW0nbAtE/O8taoW3bvPme7z38g6yiz61dwUp7OmiMzJtRRYYZKSte0Cad+PpDULwBGNchgHyREYIPfvBSHKxkMkfEMM5nMUOsPjUr5qmbP0G/9jo8qacaiANeMDgoGzl6kkcyZVO+9mjPOvrF+2Urmo3iBgFg61Rr8krOYYiYrAmQz7WPo3pizeEa0YvEgEAAA==",
    Pbi3DGeometry:
      "kwgAAB+LCAAAAAAABACdVdFqgzAU/Zc8ZxKtMWqfxjYYbA9lG+yh9KGloQ04M5wblOK/L25uVfTUaxHFnJycnHuTmyyPbLExL4d3zVL2YDfm2WZmyzhbWJOXHyxdHn9/XbeYu4dV/IRc+ULMfz7uZdXqb9h1UawPbqyUngqigPsi8FSc8MQLwijiHVgqVeO+DLu4SuIaD0LJKTINPYrVoLzr7+JBJCfZAdOeD4o864ibns5MRoPRNngvaSiq1rxh4slZonrJ7+AtnQ5+SsMQvbY/JF/bp8icV++ZQUEhHLkE07ZyT5K50E4vLLS2wCYqCJR7xJ+2JkgdbWTCDiEVBIFP8jNSWORFR3yEEw4GpEM6SAh8kh+0CVs4aZMjPsLRATa1WJAOgU/yg26tqQcq4iN89HpCKhPuVkd3N/ytWb/pUhcsFZ7g7FHnu3LfNJ5suS6NzZvmq9n+d91rs9uXTeMu019t4o3NrBPMP7OsWn0DHGyRDpMIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.7 /",
    "Flow State": "Turbulent",
    Friction: "1016414.28 /",
    "Friction Factor": "0.014798",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "1886",
    Mark: "606",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1916583.5",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "585683.7746",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "47.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531094",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.49880972",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzyEkNTW0nkQFQQ+lCB5KD6ku7UJMpEahlP67odXbzLzHVCMUDV2GJ0IOJ99QibdgXGsRGBSeXHhBXo1LjIrKeCpXeiNFwnWqNUz139v2vRmiHIc9mQcG7CEXXDA4o2tDN5dkzaD0wQTy7kevdF+glCrSI1LbhbkLlTA4WPz89IzLTKUMdt76+O3e1k71F3GNOx/CAAAA",
    Pbi3DGeometry:
      "cxAAAB+LCAAAAAAABADtV11LwzAU/S95riX9brYnUUHQh6GCD2MPGyszUBuZVRhj/91sTdWlPU1TfPChjI3m5Pbk5t7ce7L5nsxW/Gn3lpEJuRMr/ihyviYOmQlelO9kMt9Xj3KaTuWHHJwf5MKjdHr6kV9yWNSvXW63y518N2RuFLDE8ajvJglLHeb6cZo4Z3iUJEdczp/jKTvCYRy3mntR6LTR+2HUi6abveFMEMWtziPcj6NWfmXf8BLtCriJaBDeTVN77wUKZ+HJeypDeoZXXnpM0ev2adAPT2mVq9qfwevSyn/E0/BHMtv4CflVthiIW+91u/mb+1U8dXz6nrZGftG6Gm7kQfvScFRdKJ5Ge8SPqhFVl1YuxvhruJFHy5dtHo15QfaI37I9aC3VVL46buKB5a7hKI3GtCB7xI8kBImCpmjG9oCOOeLp2VZBGo1paTeH7Ei/0aGyFGRbZbSkt7192F4EUAseeBGw9ccQhqEKa1Lq3sres6MOVmrUaZHSIf6/UvZu/lHZR2UflX1U9n+n7PIf/DVfvmZltiUT6lKH3GfFpnxRgwdRLksuCjV85uvvqduMb15KNbjJs8/fhlciF5Kw+Mjzw+IL4URIdnMQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1360",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "35005.4",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "531095",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.58623415",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zVELwiAUBeD/cp9F1OlMe4oKgnoYI+hh7GGVbIJpLAvG2H9Ptnq75/AdbjVCcbXn4WlAwzFcbWlusfGtM4CgCNbHF+hqXM5EuMIZycWaEoalkBKm+u82fd8MCadiZ5uHiaYHTTBBcDK+jd0cWI6gDLGJNnjQGaacCsVykYmVkiqjCC72vlhKecIHY9suzplwhmDvzOe3VpgqLhBsgwvplX87N9Vfvk0auNEAAAA=",
    Pbi3DGeometry:
      "eBAAAB+LCAAAAAAABADtV11rwjAU/S95zkpa+6lPYxsMtgfZBnsQHxSLBrpmuG4g4n9ftNlHbA+3KXvYQxHFnNyeHO9N7omzPZsu5dPuNWdjdqeW8lEVcsU4mypZVm9sPNvXX/W0mOgXO/Af5MIXYnL60G92mH89drndLnb62TDzglSE3BeBl4yimOtxnCbcwqMkOeJJktl4EEdHPIzj1ng/CnkbfxBG3XgI/oaeJEtb9SM8zVrpTXhDJvpZSCbiQTjBY+SPhA6r48VJv9DTFl7r9LOavxGfjjrioi6X0dN73VTU+hFPY90jgYNOyG/qlYG8dV2X4G/m2fCY/HTdbuflRcue4fQ2Qem0cXS6UDrpeMSPTiM6XvZxodNv4zSPXS7HMtJlaQ+H7K7Nwe6p9OG1cZoHHXYbR1Wkq4LiET/yEOQJtqfRzQHtcsTTramiOtJ1QfGIH3k42leunuxqjq78rncQ17sAaML9rgKuaogs9Ld2wqo7W3u3ntrbqlGvhRaL+P/I2gn+wdoHax+sfbD2f2ft+m/8tVy85FW+ZWPhCc7u83JdbczgQVWLSqrSDJ/l6nvqNpfrTWUGN0X+8TvwShVKE5bvRXGYfwJFEwKweBAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1361",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1116824.2",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "531097",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.49867026",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkPIozFNXIkKgi5KEVyULqqGNhATqVEopf9utLqbM5xhqhGKsz0OdwMa9uFsS3OJjW+dAQRFsD4+QFfjHJNCBZaUsyUlDEshJUz131v1fTMkORUb29xMND1oggmCg/Ft7D7AiGQIyhCbaIMHzTHNqFBsIbjIlVScIjjZ6yxTSXIEO2PbLn6ZcYVg68zrt1aY5plEsA4upC//dG6q37w14NvSAAAA",
    Pbi3DGeometry:
      "eyQAAB+LCAAAAAAABADtWE2L2zAQ/S86u0Gyra/sadkWCu1haQs9LDlkWbNrcOOSuoVlyX+vkziJI+t5pD2LkBC9TJ6fZkYzYh7e2P1j/eP1d8WW7Ev7WH9vm/qJZey+rTfdH7Z8eDt+7X/mN/2L7bIL8kFwfnP46N9stzr97Xa7Xb/2/xVyYYQymeD5QkutM7sQptTZGDdcyB7PeW68uOVlmL2wao+XSgXxDHoKbq7ttSisjx/pJ+whf7Aewm8THsCvrDQ+/zj6Fe/d6OGf4K69o5PmuY7Xu/mRfsefE3tXD2Uf6h+oM5LfiRfS3y/zef4wP6A8RPwo30g/U3kYm7cEP73fSH9S/G4dQPpjeRzc1UnVJZo/jAc9F+Gh53T6XIdfGjGcu/xQN+bbAmUeqF5rKea7C9F1TnJIniD5sMhoI4+4zcs9bmUxGxRgH1zMT0FUpR3wg8pczJZ4KQov7mehNKJGEcYOWFBgtRJyzKLzYq4bA3NdajveU2736xkaYE8XZaeIU+qdzYJsJeUjOW6vRImAeqsyxdVpMDaftSf5AR7Y+0g9sfZu2KU+wqrfB4bdijzgl4rpZzkHd8BPwY1jV8qWIfYXHzj2br+l7M+V0b8r5IRI+kvqXHuHlI9SZ/JckAoAj3UnxGHtBXqgPcXv+s1bfUO9PN9nkEbETnVJlDvosuAeCdSx4K4ADnl8XohVCa4WCA4sLuB0Etcf9FBoTrA7FQ004cACSLRypBGxU63cOeCxhQXyh/US6sJBXCDScCcNd0IuWGm4k4Y7MXmbhjtpuDMtG2m4MxuUNNxJw5003EnDnXFw03DnKnXScMdvn4Y7abiThjtpuLPK2Md6/avqqi1b8gXP2Ndq89y9DItvbbfu6nYzLH/WT+efPlf180s3LD411b+x4V3btD3h5m/T7Fb/AShOeIV7JAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1363",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531098",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.48488441",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjsEKwjAQRP9lzyEkIdW2nkQFQQ9FBA+lhxZDuhATqVEopf9uaKvSm7edfcPM5B1kFZ7bu4IUDq7CzJlWOwsEMofWPyDNu/EMBplQETO54kzQZSIF9OQHeURjKeI/oOBzOIsdYPGpXzdN2YYN4bHF8qa8aiBllBE4Kqt9PYmT86XHMHuUF7x+0V6hrv0gFiIisDPqNXlDLY8kgY0zLsTapzF98QaPlMNtEgEAAA==",
    Pbi3DGeometry:
      "kwgAAB+LCAAAAAAABACdVV1PgzAU/S99rqQgH4U9GTUx0YdFTXxY9sCyZmuC1GA1WRb+u0XRQeCMiyEQenp6eu5tb7s6suVGPx/eFMvYvdnoJ1PoLeNsaXRp31m2Ov78um6xcA+r+Qm58IVYfH/cy+r177CrqsoPbmyYeoEUIfdF4CUy5a4ZxjHvwVGSNLgfhX08SWWDB2HEKTItPZbJqLzr7+NBHM2yA6Y9HxR51gk3A53LKB6NtsUHSUNRdeb1I0+GgRwkv4d3dHr4KQ1j9Mb+mHxjnyJzXn1gBgWFcOQSTNvJPUnmn3YGYaG1BTZRQaDcI/68NUHqaCMTdgipIAh8kp+JwiIvOuIjnHAwIB3SQULgk/ygTdjBSZsc8RGODrC5xYJ0CHySH3RrzT1QER/hk9cTUplxtzq6u+FvdP6qrKpYJjzB2YMqd3bfNh6Nza02Zdt80du/rjuld3vbNm4L9dklXpvCOMHyoyjq9RcO65UZkwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.2 /",
    "Flow State": "Turbulent",
    Friction: "919226.42 /",
    "Friction Factor": "0.014871",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "10192",
    Mark: "607",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9368550.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "555617.8724",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "44.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531099",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.2426285",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jMsKwjAURP/lrkNISt+upAqCLkoRXJQuUr20F2IiNQql9N8Nbd3NzDlMPUHZ0nV8IeRwti1VeHfKdBqBQWnJuDfk9bRGr8iIpzJOd1IEPImSBObm7+2HQY1e9sOB1BMdDpALLhhc0HSuX0oQM6isU46s2eiNHiuUMvT0hNT1bukiDBgcNX43PeMyCyMGhdXWf5uP1nPzAxUKKkPCAAAA",
    Pbi3DGeometry:
      "cxAAAB+LCAAAAAAABADtV11rwjAU/S95zkpa+5Hq09gGg+1BtsEexAfFooGuHa4biPjfF226zbSnaYoPeyiiNCe3Jzf35t4TZ3syXYqX3XtCxuQhX4rnPBUrQsk0F1nxQcazffkop9lEfsiB/iJXLmOT04/8ksO8eu16u13s5Ltu4HDf49RlnhNFMaex44U8omd4EEVHXM6f4zw+wn4YNpq7gU+b6D0/6ETTzl5zZhSEjc4j3AuDRn5lX/MS7Qq4iWgQ3k5Tee+GCo/9k/dMhvQML710Y0Wv2/NRN5yzMleVP73XZaX/iKfmj2S28RPyq2zFIG6d123nr+9X8VTx6XraavlF62q4kQftS8NRdaF4Gu0RP6pGVF1auRjjr+FGHi1ftnk05gXZI37L9qC1VFP56riJB5a7hqM0GtOC7BE/khAkCpqiGdsDOuaIp2NbBWk0pqXZHLIj/UaHylKQbZXRkt729mF7EUAtuOdFwNYfQxj6KqxJqTsre8eO2lupUadFSof4L6Xs7fyDsg/KPij7oOz/TtnlP/hbsXhLimRLxsxhlDwm2brYqMFTXiwKkWdq+CpWP1P3iVhvCjW4S5Ovv4Y3eZpLwuwzTQ/zbyhIfaJzEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1364",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "31503.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "531100",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.10074977",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMISZofU0+igqCHUgQPpYeqoQ3ERGoUSum7G1q97QzfsNUIxdWeh6eBHI7haktzi41vnQEERbA+viCvxuVMhAosiZZrShhWQimY6r/b9H0zJJyKnW0eJpoecoIJgpPxbezmwCSCMsQm2uAhzzDlVGgmRSZWWumMIrjY+2Ip5QkfjG27OGfCGYK9M5/fWmOquUCwDS6kV/7t3FR/AXzlcxvRAAAA",
    Pbi3DGeometry:
      "eBAAAB+LCAAAAAAABADtV9FqwjAU/Zc8dyWttmn1aWyDwfYg22AP4oNi0UDXDtcNRPz3RRu3xfZwk+LDHooo5uT25Hhvck+c7thkIV+27xkbsYdyIZ/LXC6ZxyalLKoPNpru6q9qmo/Vi+29X+Qq4Hx8/FBvtp+dHrvebOZb9WwQ+VEyiL2Ah74YRLGX+mGcCM/AIyEOuBCpiYdxdMCHcdwaH0RDr40/HEZ2PAR/Q49Ik1b9CE/SVnod3pCJfhaSiXgQTvBo+TFPT/H8qJ+raQOvdQZpzd+ITwaWOK/LpfV0XjfhtX7E01j3QOCgE/LreqUgb7brEvzNPGsenR/b7XZeXrTsGU5vE5ROE0enC6WTjkf86DSi42UeFzr9Jk7zmOVyLCNdlvZwyO7aHMyeSh9eE6d50GE3cVRFuiooHvEjD0GeYHoa3RzQLkc8dk0V1ZGuC4pH/MjD0b5y9WRXc3Tld72DuN4FQBPudhVwVUNkobu1E1Ztbe12PbWzVaNeCy0W8V/I2gn+3tp7a++tvbf2f2ft6m/8rZy/ZVW2YSPuc489ZsWqWuvBU1nNK1kWevgqlz9T95lcrSs9uMuzr7+BN2VeKsLiM8/3s2+ca3U1eBAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1365",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "940659.8",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "531104",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.06082747",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NIYpM0dRIVBB1KERxKh6qhDcREahRK6bubat3uju/uygHyizn1Dw0ZHPzFFPoaatdYDQhyb1x4QlYOPxmRBWU4SVK54gqnVMFY/bF119V9ZGOwNfVdB91BRjBBcNSuCe1kqOAcQeFDHYx3kFHMJZFKLJmQKkmVEAjO5jbDTFEEe22aNnyXUsYQ7Kx+z22FGZn2Nt76+OVe1o7VB9/w32PRAAAA",
    Pbi3DGeometry:
      "sSEAAB+LCAAAAAAABADtWF1r2zAU/S96doPt2JaUPo1tMNgeyjbYQ8lDSk1r8OKReYNS8t9nbNltrnT0kW4P20RIiE+uj46u7odzrx/Z1U3z+eFbzTbsfXfTfOra5pYl7Kpr9v13trl+nL4OP6eXw4sdkyfkIkvTy/FjeLPjdr7t1eGwexjuvcjyVVEInpRyJdNMJHKVC86TEc/kCc5LM57xym6fDgbP8KIy2y88RE9alhPOuTDyI/2e9ojfqcfTbwsP4hdSGP2D9Ct+vq7WJv/PON3vjFOdGo86rxmn5+XNr/S77Kk/NRzxEBz5gZ6jptNzXXqOmh51jprfFL/I5Dnb9Q1DSo+iDdEj9S+MWl9+5GWUjXS7nvT0sDT5jm2hIERFRsl01iRHroTWNrqsXY13RsOKJ+RIX4hJTSEdHQTYI34gXxUqUaXZyVl5NhzaoDSeM+VrbsvLCZfVCKf2XdmtXVUcdQm6WS1RZpxz6VX1kT2Q7+lj2oS8HxoQv5Ijinw0z+2wvVRrpdfOopk7tLtc/9TgpvjjQk7risKvoVN+FAqOBk29g+QgmkD566pS2ZZZ4DkuZ/g0qRwcJGjOoZ5cazadd35iSjVYTCkr2IV5y/68ND6MckEQmFfDR23Gw91GxMFMAjqAvXVFYGujcBZNHx0LCaiwZtgcHKD3AGMrMxEXRAyfG8y4V26DZHE3e6AF2DtWBdZ2Emcz89Oy0AT1PpDBQeluZ6by/pO5A/pH45xH/K65Q+h8Aen/V+cOjj/c3vOIPzR3cM4XHPrj3CHIa3HuEFDb4tzB0J7j3MGEx7mDBY5zB1tninMHTB3nDiGhEecOce5ge26Icwfbg81fP3fYJuxNs/ta9/WBbdJVmrAP9f6uv1cXH7t+1zfdXl1+aW6Xn97Vzd19ry7etvXP54avu7YbCPc/2va4/QV7U3G1sSEAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1369",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531105",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.01333475",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0SyNNPYkKgh6KCB5KDy2GdiEmUqNQSv/dYLUXBW87+4aZyXvIKjp2Vw0p7FxFmTNd7SwwyBxZf4M078czGGYCeZxIXKiYIyqEgf2AUnEVieQbCvwDp9jiU79s27ILG8JjTeVFe91CGvGIwV7b2jdvcXC+9BRmj/JE5wltNdWNf4k5SgYbox9vr+IoZMxg5YwLsfZuzFA8AUIaeGcSAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVctqwzAQ/BedFSML+ZlTaAuF9hDaQg8hh4SIROBaxVULIfjfqySua5ldWcHYWOPVaLSrHa9OZLlVb8dPSUrypLfqVVdqRyhZalWbL1KuTtdX+5nN7UVa+o/MYsbml4e9Sbv+m7Zoms3Rzp3FPBIiz2ghIs4LTouIZ1lBL3g+REWaXtGMOXhqJ3tZuJ0IxcdZAvKPeOJE+NRgq2L4ratiOMYz2i0XCZi1Hg/aVb/qmSUpooLFuZNLB3VYBriTAyj+rB1ix3gwPEiNk2EIx1Riq47U9xkO5JnUA+9qVJGJumL1w3oKrzfEHqQwqKpQ5/h4sPhbfMJXV4gHwwPPh8MD4di58XU+xhPgFJPxvq6FnAXDA7vf4YFwX/9A3uXjweIh/T6nhvRgzovhPh5IP+4AUJaDfCHARVzl9r9+rzYf0siGlCxilDzLem8O3eBFm41Ruu6G72rXf3qUan8w3eChkj/DwDtdaUtYf1dVu/4Ff8QSKYkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.9 /",
    "Flow State": "Turbulent",
    Friction: "683993.04 /",
    "Friction Factor": "0.015099",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "10463",
    Mark: "608",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7156619.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "475642.5726",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "16",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "38.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531107",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.64237159",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPIy6apK1FB0EUpgovSRauhDcREahRK6b8bre7mDGeYcoS8MafhriGDg29MoS+hdq3VgCD3xoUHZOU4x6gsKMNCpHIlOOZCSZiqv7fu+3qIciy2pr7poHvICCYIjtq1ofsAI5IhKHyog/EOMoqXkkiVcJZIJVKVJAjO5jrLVJIUwV6btgtfZlwh2Fn9+q0VpqmQCDbe+vjlntZO1RvVPh+30gAAAA==",
    Pbi3DGeometry:
      "eSQAAB+LCAAAAAAABADtWE2L2zAQ/S86e4NsybaUPS1todAelrbQw5JDljW7BjcuqVtYlvz3eh3bSSQ9jZyzCAnxZPL05kMzwzy8sfvH+sfr74qt2Zf2sf7eNvUTS9h9W++6P2z98Hb82v/Mb/sXOyQnyU3K+e3w0b/ZYTP97W6/3772/71Js5WUqkykWMlciESvUiXLZJDrLD+TZzxTTrnm0qufp7w4l8ui8ONc8hFcjfpcaicfxD9MH+KTfAL9NuMAfKEK5fQP4j/i94qpy/+T3LR3lFs8TZwpXpPcjFcw/sif0Lf8b9kVqE/6B/FciD/Fy/IPwV9IXbryZ6kfUB5a+CifAT5l17V5G4pv2UvcR9PeUHwzjiZ/yi4r34g6M/Kk6xJxX5bWN+tcgk/wvYZ1Twx1Q2hZDDj+toDUETpgP3eXNC3OoxXadawuZeBcSd9ymhJyUE/zd7HOhT8mfnWqlJ9IHtF5Kt/FWeot8LNclerSBS4URBFQwV3FCU6g2FE9ouiBeJkJZ+xOndKpPRmk5EBFl9qPgvSJem/VbycbZCnMU4KNfarbKpwEaOoY7wGXg77SWdh0YeDD/EBdEnkZ8UE4S/nnfYCGcIncJ58zdpKbdYvAserZtfg81x792Q+mvmUXoW/hI/8gngvxrfwB/FGeoHNxPrjlV/vTlMN7B85F94g4N6y4h3o5sNEAFIuLu6Wg1IEjAdIn4FEmm7aixudsZEs5oiHKKQ4tLuhy0sOP+1g0cxHH2vDOzhdYAf3dnOIY2j9hnVhaVyh8op+QU4d7pom7Had+3O3E3Y4LP+524m7nIt/ibsc/lsTdTtztxN1O3O148eNuJ+52luDH3U7c7cTdTtztxN0O2O1sEvax3v6qumrP1nzFE/a12j13L+PDt7bbdnW7Gx9/1k/zT5+r+vmlGx8+NdW/c8UPbdP2gLu/TXPY/AcHLMxfeSQAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "32",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1371",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531108",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.76844489",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+LrruadooKgjpIBB3Eg+KiD7bdsC0Q8b+3pHkSur153zAzWQ9pidfuISGBkykxNaqrjQYCqUFtn5Bk/Xg6w8pnlK8F24iYRkEYwEAWIA8oj+IF6LM/cI7Nf/Xbti06t8E99ljcpZUtJB71CJylrm0ziYuxhUU3e5Q3rGZ0lFg39itCJggclHxP3pgyX3ACO6OMi9UvpYb8A+/R9kASAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVV1rgzAU/S95TsWPaKp9KttgsD2UbbCH0gdLQxtwZrhsUIr/fWnrnJF7Y4r4kePNycm93uP6RFZb+Xb8FKQgT2orX1Uld4SSlZK1/iLF+nR9NK/DhTlIS/+RWRSGi8vFnKTd/E1bNk15NHNnURwwNuc0zQOeZAnNg5jznF7w+RBlWXZFeWjhmZnsZInNRCg+4inIP+KJUuZSg62K4beuiuEYz2i3MUvBrPW41676Vc8sLDH33M6lhVosA9zKARR/1g6xYzwY7qXGyjCEYyqxVUfq+wx78kzqgXc1qshEXbH6YT2F1xti91LoVVWoc1w8WPwtPuGqK8SD4Z7fh8UD4dh34+p8jMfDKSbjXV0LOQuGe3a/xQPhrv6BvMvFg8VD+l1ODenBnBfDXTyQftwBoCx7+YKHi9jKzX/9XpYfQouGFGEQUvIs6r0+dIMXpUstVd0N3+Wuf/Uo5P6gu8FDJX6GgXeqUoaw/q6qdvMLkjFyDIkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "7.4 /",
    "Flow State": "Turbulent",
    Friction: "604330.32 /",
    "Friction Factor": "0.015202",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "4955",
    Mark: "609",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2994522.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "445576.6704",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "22",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "35.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531109",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.8355689",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jE06fSRuhIVBF2UIrgoXUQNbSAmUqNQSv/d0Opuzr3nMvUI5VWfh6eCAo7uqit189K2RgGB0mnrX1DU43IGZcU4RcyzNcYUkziGqfl7m76XQ5BDsNPyobzqoYhoROCkbOu7GXhKoHJeeu0sFIwmWZSJNOZpJjAXaWgv+r64jGHAg9Jt52eOkBPYG/X5rQVlAhMCW2dceGXfxkzNF4vrvEXRAAAA",
    Pbi3DGeometry:
      "ZRAAAB+LCAAAAAAABADtV11rwjAU/S95jpL0wzb6NLbBYHuQbbAH2YNi0UDXDNcNRPzvC7ZG2+WYBl/2UERtTm9Pjrm598TZjkwX8nX7mZExeVQL+aJyuSSUTJUsyi8ynu2qS32bTfSL7OkJGXDGJocP/Sb79+NjN5vNfKufHfBgGCUspVGov0VIxTAYpQk94JG+OMOTRFR4IzoajazRPI6ojT2I4kssnbiNkkAH2JQjnCexlb8VbzSi32RXiVgQ3onFaE/jSnscHnAm0qbGCufCsDfj0/AyHrM6TzV+yojfvKGo9Tt4jB7OhY9OyN/UEwiwbq55O/Kf1rnFY9an41475hfNC/XAPQ7WE+GottB6onjEj3Si2nLVYnv9EY54YL788gjzgvKO+P26A+imqHphVcOuDKrd1QXaWXRl609HBfxIJ9qFLi9Du7mNIx7PrmrPIu61dk8E3Egj2lF+TuzriX7svmcO3xMArMLrTgC+elynHT9v7erRTk/37aWeHo16He6ZDm+60tM78vee3nt67+m9p/8vT9f/2e/k/CMrsw0ZsyGj5CkrVuW6Hjyrcl5KVdTDN7k0tx4yuVqX9eA+z37OA29VrjRh8Z3n+/dfRFBF1WUQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1372",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "20260.6",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "531110",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.13413404",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV7DzTndeooKgnoQCXoQH1YNHawtbAUi/veG1tv9zvkOtx6hvJrz8NQg4eivptK3oFxrNSAovXHhBbIelzMqK0IxY0W+ZimmjBOYmr+36Xs1RDkGO6MeOugeZIITBCft2tDNQDmCygcVjHcgCc7yJBc8pTwXrBA8thdzX1xCWMSDNm0XZk4YRbC3+vNbC0wEyxBsvfXxlXtbOzVfjVfMpdEAAAA=",
    Pbi3DGeometry:
      "bxAAAB+LCAAAAAAABADtV11rwjAU/S95jiWp6Uf0aWyDwfYg22APsgfFooGuGa4biPjfF2qN2vWYBl/2UERpTpPT03tz74nTLZnM1evmMyMj8qjn6kXnakEomWhVlF9kNN3uL81tNjYfsqNHZMAZG1c/5kt274dlN+v1bGPWDngYiDCOqRgGYcg4lUEYpwmtcGEuTvAkkXucJ9EpLszytvk8ErSNPxTRZZ6O/FZPwtJW/QhPW9kbs61K9FZIJeJBeEceq55zWeEirnAm03Ode5xLy38+Px1exoeyzlaNH7Pi99yI1fodPFZPGkU+OiH/uZ5Qgri5ntuR/xjnBo+NT6fddsgueipUA/c4iCbCUW2haKL5iB/pRNXlqsZm9BGOeGC2fLIIs9Kec8Tt2xlAP0WVCysa9mVQ6a4O0MyhK1d/OirgRzrRHnT5GdrLTRzxeHZUlEfcaZEvAn6kE+0rXz/2dUZfft/zh+85AFTjNe/qq8V95vFz164u7XR1337q6dKo5+HO6fCnK129I3/v6r2r967eu/r/cnXz7/1OzT6yMluTEQsYJU9ZsSxX9eBZl7NS6aIevqmFvfWQqeWqrAf3efZzOvFW59oQFt95vnv/BWwQ/fZvEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "8",
    Length1: "4",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1373",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 0": "32",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "16",
    "Nominal Radius 1": "10",
    OffsetHeight: "16",
    OffsetHeightTemp: "0.004374",
    OffsetWidth: "16",
    OffsetWidthTemp: "0.004374",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "578474.4",
    R0: "16",
    R1: "10",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "531112",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.46467048",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yGW246O0UFQR1Egg7iweqPDtYWtgIRv3uz7Pbe4/feKwfIL/rUPxAyOLiLLvDqa9sYBAK509Y/ISuHnwzIgnEax2myYowyoRSM1Z9bd13dBzgEW13f0WMHWUQjAke0jW8nw6QQBArna6+dhYxRkUSJkksuExWnSkoCZ32bYa4YgT3qpvXfpZRzAjuD77mtKI+mvY0zLnzZlzFj9QHEuu9Z0gAAAA==",
    Pbi3DGeometry:
      "SSIAAB+LCAAAAAAABADtWF1r2zAU/S96doPkj0hOn8Y2GGwPZRvsoeQhpaY1ePHIvEEp+e8zjpS0ko6unG0vQYSG+uTm+Ojq6l7n3D6zm7v269OPhq3Yx/6u/dJ37T3L2E3fboefbHX7fPh3/Jhfjy+2z07IleD8enob/9h+bb72ZrfbPI3fvRL5oiyVzIRY5GUus3qR86rKJlxK9RIXcunFZSXD8ap+hZdLgsfSo6TGRS29/Eh/ZDziJ/VE5u3Ig/j5KMyXH6Rf83Mpc1/+DW6v1+C2TodH75fB7f2K5tf6qXg7nw6OeCwc5cHeR0dn5H3tfXT06H108qb5RVXX56w3tg4dflRviB/p/8u6jeVHeUbn0VlvJL+9X45+Yl2oDlGfMTrJvkScl7n9zbkvoSf6XMO+p6qJX9UHPaok5giIR/xIv5kvXLzarsix44wpi+ZM9W63FQf1xXJSL3Jit4h4qpujaWEv1zktGhdCqajuD+OB/rg028Mo+uEB0Ws1qphaBpdBmOjYTgcO07jhYe1U6k+DTpdgcVisLOuowe7wo1IgBrWTHqQH8czUXxXCHLkAbArzCFsHi2CxCudc8oIH400K7HhnTUS8ww9Sg2TOpbcqB8lHFYLuiyvBj5+dTlsnPHFAD4gn74viCR6yyUbqOQ0D0JQBjuoHDS0YT/HbOmfzo0cPPx7ZG8DpIp8YgBh/OHFPEB0moaZhlJLTmJkzO+ERn90SwvTK23Au3cNAv41Ib+NfeRhzvQqk/1I9DOK3e7S38Z88DNKrIPQnDyN5GDHnPXkYycOg45OHkTyM5GF44ORhJA8jeRjJwwjhycO4HA9jnbF37eZ7MzQ7tuILnrFPzfZheNQXn/thM7T9Vl9+a++PH31o2ofHQV+875rfLwPf9l0/Em5/dd1+/QdooETlSSIAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1375",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531113",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.40420581",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0a6q2nkQFQQ9FBA+lhxZDuxATqVEopf9usK0XBW87+4aZSVtICjo1NwUx7G1BidVNaQ0wSCwZd4c4bfvTGyYCuVyEuBSSB1MZQcd+QcFR4vwbCvwHx9hsrF/Vdd74Df6xofyqnKohDnjA4KBM6apBHK3LHfnZvTzT5YN2isrKvcUMQwZbrZ6DN+IoQslgbbX1seahdZe9AIWWmOwSAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVdFqgzAU/Zc8p5K4aKp9KttgsD2UbbCH0gdLQxtwZjg3KMV/X7DONnJvTBHFHG9OTu7NPa5PZLXV78cvRXLybLb6zZR6RyhZGV013yRfn86v9jNb2Iu09ILMOGOL7mFv0m7+py3rujjauTMeR0LMJeUiYncio1kUS5nRDp9foyJNz6hkDp7ayV6W2E6E4rlMQP4RD0+ETw22KobfuiqGYzyj3cYiAbM24EG7GlbtWLgNjKWTSwd1WS64mwMgvtMOsGM8GB6kxs0wgGMqsVVH6ocMB/JM6oF3NarIRF2x+mE95ak3wB6kMKyqQOd4ebD4G3zCW1eAB8MDz4fLA+DYufF2PsYz7RST8d6uBZwFwwO73+UBcG//AN7l5cHiAf1epwb0YM6L4V4eQL/HAYAsB/lCiIs4yu1//UEXn6pRNclZxCh5UdW+OfSDV9MUjTZVP/zQu+HTk9L7Q9MPHkv1ex14b0pjCaufsmw3fwgRDgqJCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.9 /",
    "Flow State": "Turbulent",
    Friction: "391695.67 /",
    "Friction Factor": "0.015594",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "851",
    Mark: "610",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "333360.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "354176.3278",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "24",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "28.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531115",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.26047073",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jc8LgjAcxf+X73kOt3Q/7BQVBHUQCTqIh1lDB2sLW4GI/3tadnvv8XnvlQPktTn3Dw0ZHH1tCn0NyjVWA4LcGxeekJXDT05IRChOEsHXEceCCQlj9ec2Xaf6CZ6CnVF3HXQHWYxjBCftmtDOhrA0RVD4oILxDjKCUx5zyVaUcZkIyRiCi7ktMJUEwUGbpg3fJUEpgr3V76UtMY3nva23fvpyL2vH6gMZCKfd0gAAAA==",
    Pbi3DGeometry:
      "MyIAAB+LCAAAAAAABADtWNFq2zAU/Rc9O8Fy7UhKn8Y2GGwPZRvsoeQhpaY1ePHIvEEp+fd5jpQ0ko6unK0MOhEa6pOb46Orq3udc/3Irm6azw/farZk77ub5lPXNrcsY1dds+m/s+X14/7f4eP8cnixXXZEZjzPL8e34Y/tVuZrr7bb9cPw3Rkv5mUpRTYTcyEXRabmRV5V2YgLIZ/iXCy8uKhEOF6qE7xcEDyWHik0zpXw8iP9kfGIn9QTmbcDD+LPfwvz5Afp1/yq4sKXf4Pb6zW4rdPh0ftlcHu/ovm1firezqeDIx4LR3mw99HRGXlfex8dPXofnbxpfrmQ6pz1xtahw4/qDfEj/X9Yt7H8KM/oPDrrjeS398vRT6wL1SHqM0Yn2ZeI8zK1vzn3JfREn2vY92Q18l8oPvLIkpgjIB7xI/26X8lCqJP9ipw79pxyeM7U7/Zbvtev9jQFsV3hcKqbo2lhr9Y5LQbnUb0fRPulRybYHkTRDw6QX8spq33DyEUYJxq204AJHjc+rD+c+uOY0+WnpBzxUsWNde7dbjC00JB2coPUIJ6J6qsLbg6bCuGmMA+4dapIHqt2zuZXMhRu0mCFO2rC4Q47WhQSOY3+tHKAdFQg6J64EPz4uZm0VIKjBrR4o4k7+oODFERXjVFxbPv+FuyHUaGg2QTjCXpL42R29IDhx2N7ADpG9IMB0APiyfuieIKHnH+Reo6TZdq8hEd7cisg+G2d/4lxgX4QkYbG3zIuphoUSP9LNS6IH+zRhsYzGRekQUHoT8ZFMi5iznsyLpJxQYcn4yIZF8m4SMZF1KKScZGMixCcjIsQnoyLMP4PjItVxt406691X2/ZMp/nGftQb+76e33xsevXfdNt9OWX5vbw0bu6ubvv9cXbtv75NPB113YD4eZH2+5WvwCtJ2ncMyIAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1377",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531116",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.92238631",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LO6+Lu6hrdooKgjpIBB3Eg9KyPth2w7ZAxP/ekuZJ6PbmfcPMFD3kNV66h4QMjrbG3OpOWQMEcovGPSEr+vH0hoBxGqUxXzNGQyE4DGQBBoKKNFmAjP+Bc2z5q9+0bdX5Df6xw+ounWwhC2lI4CSNcs0kztZVDv3sUV7xNqODRNW4r0h4TGCv5XvyrihncURga7X1seal9VB+AMZOD8sSAQAA",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVdFqgzAU/Zc8R0lEjbVPZRsMtoeyDfZQ+tDS0AacGS4blOK/L22dM3JvTBHFHG9OTu7NPa5OZLlVb8dPSUrypLfqVVdqRyhZalWbL1KuTtdX+5nN7UVa+o9EnLH55WFv0q7/pi2aZnO0cyOexGlaCMp5zIRI6CxOhJjRC14M0TTPr6hgDp7byV6WxE6E4rnIQP4RD89SnxpsVQy/dVUMx3hGu03SDMxajwftql/1zBKJWBS5m0sHdVgGuJMDKP6sHWLHeDA8SI2TYQjHVGKrjtT3GQ7kmdQD72pUkYm6YvXDegqvN8QepDCoqlDn+Hiw+Ft8wldXiAfDA8+HwwPh2LnxdT7GE+AUk/G+roWcBcMDu9/hgXBf/0De5ePB4iH9PqeG9GDOi+E+Hkg/7gBQloN8IcBFXOX2v36vNh/SyIaULGaUPMt6bw7d4EWbjVG67obvatd/epRqfzDd4KGSP8PAO11pS1h/V1W7/gWjBs3diQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "5.1 /",
    "Flow State": "Turbulent",
    Friction: "302120.66 /",
    "Friction Factor": "0.015856",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "5750",
    Mark: "611",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1737057.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "308476.1564",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "28",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "24.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531118",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.33154771",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jFELgjAUhf/LfV5jTidpT1FBUA8iQQ/iw6qLXlhb2ApE/O/NsrdzzvdxqgGKC536B0IOB3ehEq9e28YgMCgcWf+EvBp+MSiJ5CpWyWoRxVykaQJj/ffWXaf7IIdhS/qOHjvIBRcMjmgb304lSpViUDqvPTk74zPdZiqziMEeqWn9ly2lZLAz+J71jEsxHWycceHcvowZ6w/tks/BwwAAAA==",
    Pbi3DGeometry:
      "gSIAAB+LCAAAAAAABADtWMFum0AQ/Zc9E2uB3QWcU9VWqpQeorZSD5EPjoISJGoqh0SKIv97qQ2ku8tjhjSndhUlDs/jt2+H2Rn8rp7F5XX17elnKdbiormuvjZ1dSMicdlUu/ZerK+eT/92b8vz7kccohfkLJby/Pin+xWHzfCxd/v99qn7rEpWSicmOovTlTRGRcUqkVpHFl7oIx5nZhLPdMaKj2V2xJVh8vR68szB0yyd1IP0E/GIn62HyJvHg/gTnU7mx9Zv4jye4vdwL97WSfI49+v1/Ei/nU8aRzx2Pun8IJ3Euh4P0mPfR512Mv5mv0QdIn5Ub/S+iDpcWrcEP71fG6fzSfB7fQDpX8pj455Ooi/R/DwetC7C2efUW9fh//16OncmOfLkam4u0PE8/apQ6ex8oebOkGeKh6kf5U3rvNefFyeeZP5+gXh2P0fzwsWd/erM6CX9H8Uj/ew8u32AGw/4dZyklp5cZrM42VedPgx46OcHWz87/0O80YlVh5kqZuMpfrgub+7QepbGO/ql6e+vKuI53O2HAz72q2mel/rp8aF+lvIbpVjxYx6ceHfeUfFjXwL5QTqX8o/14+SH0o/qx1t3uh4gvjSfCEd9DK0L4yl+J2/cfFL9lqtn4EHziJpTqH7QvHbjET91Xrj8YC5DnNsf0Pkinh/gcw6Mp/jtOmH3K2I+svUM9fzaeeqe06X9AfGj/f4v/gb63sT2Pd7K3+D5GPT3xH/V30D7Xep7vLG/QfgYSH/wN4K/EfwNv28EfyP4G8Hf8PUHfyP4G8Hf8Osh+BvB3wj+hl8nwd/A/sYmEh+q7Y+yLfdiLVcyEp/L3W171198adptWzW7/vJ7dTO+9amsbu/a/uJjXT7+Gfi+qZuOcPdQ14fNL0jjG/WBIgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1379",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531119",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.90423672",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdlnVRcO0UFQR0kgg7iwWjRhW0nbAtE/O8taVKnbvPme7z38g6ysz62NwUp7OisMzJtRRYYZKStu0Oad8PpDSHHRC5mwZwHAhPo2RdCHkYY/4cCpfyFU+iAik/1smnK1vf7x1qXV+VUA6nggsFe2crVoziQK532kwd50pcJbZWuavcWMUYMNkY9R6/kGEQhgxUZ8rH2YUxfvAB1EiNnDgEAAA==",
    Pbi3DGeometry:
      "TQgAAB+LCAAAAAAABACdVV1LwzAU/S95zkrapunHnkQFQR+GCj6MPXQsbIHaSK3CGP3vZrVqWO9tUiktzcnJybnJzc36RFZb9Xx8k6Qg93qrnnSldoSSlVZ1+06K9en713SzpXlIR/+QRcjYsv+Yl3Sbn2FXTVMezVgeRFlOF2EcsDwVNA8iLgS1UCH4GQ0TbqNZlpzRiCfUqTBwRZYCumma22ichN4e4Nkmo/CabdLDhQLnMRDbgF6sDhyFPVsU8CQS4xW2cVvFxu24AX7vG9DvnfvoOPRHfrC4MBzzic1rr7yPzj/9jOKC9xZzCec+tvYwe+6OYOpwBvvkh+sUuLluH5MnyXuXMT6GuysApuKqF26u2wecazbqk8kYH8PhOjXvPMAabq7bB3zzzK2WGB/D3XcNpuJ5OxquuZtvVPkqW9mQggWMkgdZ79vD0HjUbdkqXQ/NF7X77bqTan9oh8ZtJT9t4rWutBGsP6qq23wBYVfdxU0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.0 /",
    "Flow State": "Turbulent",
    Friction: "113973.37 /",
    "Friction Factor": "0.017034",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "11632",
    Mark: "612",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1325770",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "182800.6853",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "30",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "14.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531121",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.81867883",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzzEk0ba2nkQFQQ+lCB5KD1GXdiEmUqNQSv/dVOttZt5jyh7yC526B0IGB3ehAq9e29ogMMgdWf+ErOx/MSiJ4olM5Wom51zE8QKG6u+t21Z3QQ7DlvQdPbaQCS4YHNHWvhmLjKOIQeG89uTshM90m6hKJYM9Ut34L1sqxWBn8D3pKVdiPNg448K5fRkzVB+8F6UUwwAAAA==",
    Pbi3DGeometry:
      "PyIAAB+LCAAAAAAABADtWE1r20AQ/S97Vszqa1dyTqUJFNJDaAs9BB8cIhKBahVHLYTg/17hSHZ3tU8z6+ZQksXERM/jt29HszPyu3kW17f1t6eflViKq/a2/to29Z2IxHVbb7pHsbx5fvm3/1ie9y+xi47IWSzl+f6t/xO71fi1D9vt+qn/rk4WKlVpdBanC6lUFpWLROZ5ZOBlvsdjrZy4zjUrPpZ6j2eKyTPoKbSFpzp16kH6iXjEz9ZD5G3Cg/iTPHXmx9RfyLh08U/wSbypk+Sx7tfp/Ei/mU8aRzxmPun8IJ3EuhMepMe8jzou43/aL1GHiB/VG70vog5965bgp/dr4nQ+Cf5JH0D6fXlMfKKT6Es0P48HrYtw9jmdrGvhRTn2PZXseYpsdi6Q8Tz9Shez44UaO6McgoapHmVNZ8mgvihfeJL5uwXi2d0cTQsbt/arlUx8uj+KR/q5ababADce0JfKVFNIPYfTPdXCET/57GDKZ2d/jM+K0qhCnZWz8RQ/XJc3c2g9vvHW7R1UZv3yELX74IiP/cLNMRbOAB8Kx4e6307Cij9uP3GJYcePzci5JajSk/1YNGZuSPWoaKbrOosA4r7ZRDhsXWBdHE/wW3nj5pNqsVw9Iw8aQdRoQvWDBvTkVKB1idPC5IcPEgBnNgb32SKeFpAUNJZmua1WxOpQxBxk6Ti01ROHpn0uPfsBXtep8r3YF+hnEdvWeC37gmdT0D8D36p9gfbra2u8sn1B2BRIf7Avgn0R7AvHXAj2xdzdCvbFSQ8Pwb6YjQ/2RbAvgn0R7ItgX5CNIdgX/719sYrERb3+UXXVVizlQkbic7W57x6Giy9tt+7qdjNcfq/vDh99qur7h264uGyq338Hfmybtifc/Gqa3eoPrWHPQj8iAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1381",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531122",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.1603676",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNI0odtPYkKgh6KCB5KDy0NbSBmpUahlP53g62vk7ed/YaZyXpIS3XsLhIS2GGpUtRdjQYIpKiMvUKS9ePpDL6gIY/4YsY9ypmIYCAfOHfQC73/kIk4/oHfsSPMX/XLti06t8E91qo4SytbSBhlBPbS1LaZxAFtYZWbPcqTqt5oK1Xd2KcIRUBgo+V98sZU8MAnsEKNLtbctB7yB/MF6yQSAQAA",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACdVV1rgzAU/S95TiVqjB99GttgsD2UbbCH0oeWShtwZjg3KMX/vri5LaIHr0UUc3Jycu5NbrI+s9VOP5/ecpaxe7PTT6bQe8bZyuiyfmfZ+vzza7vF0j6s4f/Iwhdi+f2xL2s2v8Ouqmp7smNl4Ck/8fnCDz2RxoqnXiCV4j1cKdnifiT7eJJELR7IiJN0Or5K4lH9OE77eBj5s/ygeSfiIs874WegI2U4Gm+HD/KG4nLmjS0eqnCQ/x7u6PRwJw9j/Nb/mH7rn6QzoT/wg+JCOPKJ5nXyT9K50M8gLrS+yCeqC5R/xJ+7Lkgf7WfCPiHVBYFP8jNRX+R1R3yEE84HpEM6Twh8kh+0Dx2ctM8RH+HoHJtbL0iHwCf5QffX3HMV8RFOuKeQzpx71vLtfX+jt695nVcsE57g7CEvD/WxazyaeltrU3bNF73/67rL9eFYd43bIv90idemMFaw/CiKZvMFuq7hnKEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "2.3 /",
    "Flow State": "Turbulent",
    Friction: "67056.95 /",
    "Friction Factor": "0.017817",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "9150",
    Mark: "613",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "613541",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "137100.514",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "34",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "11.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531124",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.94653498",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NIYpo0dRIVBB1KERxKh6qhDcREahRK6bubat3uju/uygHyizn1Dw0ZHPzFFPoaatdYDQhyb1x4QlYOPxmRBWWY81SuKMeUSglj9efWXVf3EY7B1tR3HXQHGcEEwVG7JrSToSJJEBQ+1MF4BxnFiSRSiSUTUvFUCYHgbG4zzBRFsNemacN3KWUMwc7q99xWmJFpb+Otj1/uZe1YfQDnTbr+0gAAAA==",
    Pbi3DGeometry:
      "HyMAAB+LCAAAAAAABADtWMFq3DAQ/RednUVybEvenEpbKLSH0BZ6CHvYEJMY3HXZuoUQ9t9rbHk3kfw8o217aZWQEM+Ont6MRjPOu3kS17f158dvlViL9+1t/alt6juRiOu23nXfxfrmafyz/1he9d/ikJwsF0rKq+FX/yMOm2nZq/1++9ivvVDpKsuMTlS2SqXMknKVGq2Twa7KF3adz9uVLpb9Ze/wzJ4V8/5HHIePzPPRrrWZxUf8mf4In+TDzNsRB+Gb0szmB/G3+PIyK+fyP9ndeCe7y9PDsec12d3zYuNb/pS/m0/PjnAcO8qDe44eT+a+7jl6fOw5enmz+Er1G54RL7cOPXxUbwgf8f/NuuXiozyj++jFy8R3z8vjT8SF6hD1mYkn2ZeI+xLa37x9CT7sew37nikH/EznA06/bHmOAH+Ej/jbfqVyY16cF3PuuHPKwzmTv5e3NB/tZVYMdknERfhT/RzNCzde775Mdl3k5emLNQoYS1FUzOy7U4r9VoHwLR/VOwz+KWEnurnXnQkcz5/gH3Aqp4E4Fqo0eghdmYz3ArCwFaodYrZ7WUPUEE5gKJfFeOhZoRfMU/lOZuciEiBOQZ2FLY0pFryn8B1vl8myt4sNwgHBB2EvVA4IARUI2B7Xwbz9rHx6HDlXEPCilxJc6IVs6JBuHcz7CI76PLCD8kPDEbkvo3skA9HhG868nddPwL2kX0sAGeBP7Aq8l0HI4crjcoQJnMWoOQT2EgLdJfmfyCXo3zBSRvlTckmoLIL4/6tyCSETsGWUvySXkLIIwT/KJVEu4dz3KJdEuYTjH+WSoLeKKJdEuSTKJXQ4US6JckmUS6JcEuUSj+QmEW/q7deqq/ZiLVcyER+q3X33YB8+tt22q9udffxS3x0/elfV9w+dfXjbVD+fO75um7YH3P1omsPmF2BGlhgfIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1383",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531125",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.89415819",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaypaT6KCoIcigofSQ4uhXYiJ1CiU0n832NqLgredfcPMpC0kBZ2am4YY9q6gxJmmdBYYJI6sv0Octv0ZDBOJXM0jXKopRxQSOvYDSsVRCPUNJf6BY2z2qV/Vdd6EDeGxofyqva4hFlwwOGhb+moQR+dzT2F2L890GdFOU1n5t5hhxGBr9HPwLjjKSDFYO+NCrH0Y02Uvkd3q5hIBAAA=",
    Pbi3DGeometry:
      "iQgAAB+LCAAAAAAABACVVdFKwzAU/Zc8ZyWJabt1T6KCoA9DBR/GHjYWtkBtpEZhjP672VZrU+5NM0pLc3pzcnJv7unySBYb/Xb4VKQgT2ajX02pt4SShdGV/SLF8nh5dZ/Z3F2kof/IhDM2Pz/cTZrV37Tbul4f3NwJF4mU05zKm0QIxuksEXk+o2d82kdlll3QnHl45iYHWYSbCMXzPAX5Bzw8lSE12KoYfu2qGI7xDHYrZApmrcOjdtWtemLhMhGMSS+XHuqx9HAvB1D8STvEjvFgeJQaL8MQjqnEVh2o7zIcyTOqB97VoCIjdcXqh/UUXm+IPUphVFWhzgnxYPHX+ESorhAPhkeeD48HwrFzE+p8jCfCKUbjQ10LOQuGR3a/xwPhof6BvCvEg8VD+kNODenBnBfDQzyQftwBoCxH+UKEi/jK3X/9Xq8/lFU1KVjCKHlW1c7u28GLsWurTdUO3/W2+/So9G5v28FDqX76gXemNI6w+i7LZvULgEQwtIkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "6.7 /",
    "Flow State": "Turbulent",
    Friction: "492446.63 /",
    "Friction Factor": "0.01538",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "8845",
    Mark: "614",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4355782.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "399876.4991",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "25",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "32.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531127",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.14349364",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzzGk0ca2nkQFQQ+lCB5KD1GXNhATqatQSv/dVOttZt5jyh7yizl1D4QMDv5iCrySdrVFYJB74+gJWdn/YlAET1SyXM2iORdKLWCo/tq6bXUX3DBsjb4jYQuZ4ILBEV1NzVgiFccMCk+ajHcTPpvbRGUaMdijqRv6skRKBjuL70lPuRTjwcZbH87dy9qh+gBfSqZXwgAAAA==",
    Pbi3DGeometry:
      "GSEAAB+LCAAAAAAABADtWE1rGzEQ/S86b4z2QyvJOZW2UGgPoS30EHxwyJIsbL3F3RZC8H/v4miTSNF8KMmlQZiY7PP46Wk0msHv/FacXfTfb351Yi0+jxf9t3HoL0UhzsZ+N/0W6/Pbu3/nj+Xp/BKH4gE5KaU8Pb7Nf+KwWb72br/f3szflSttlC1Oynol27Yp7KqSShWPYauOcKnbGKyVZkSXUh/hpmWROCVG+3Ct65gSQDceDXAzleCpCkkA7krVsZx4uq0qVYT7CRxGewIpEv90nssN6PYySMIAiZdBMieAQHzJkARQ4h2aaY1+wS7RYgO4gaoit4MXW1ppotzkLj2YzCDOHV5uQHcaiQc/EYi2GZKbQwIsCcDcCxgu6XPXZmlhbXUkMQ3c1slojm5TzVzIbCBGhlNCkLB0A6kytnS6jb0jqbDTiUdzOzLQ7QM4aNTSmoT+HY+GdslMbHC5WdEAt2mUr8RIjcBUe/SbaZyEnPP+gGHm2+3SGuUVm24sMrwIbmhJzsgglaRF+7usrTvLxpYIHHS2BV66T5zkvk4c7Ookjdtqw4leNh9EB1OKiF7aTHw7gMAk7oc68XNC6AbqJFwyevIQnJbBOAw2pXgNQtEEt5cqbgbRrslV4goC6LHEgAHqBJiuYdkDS+K3gccdH6MQzLzzwN1B5zy0JBRNcPsFwew++ExjKnEkz5uAwQVMu/MAd1zgW/cKgJ8qTAvhVbwCjilA/iB7Y14BsMs0C+E1vQLUFAB0Z6+AnarsFbBJslfAGBnZK8heAX9yZ68AU5K9guwVwCefvQJ2681eQQTOXgGt5H/wCjaF+NBvf3ZTtxdruZKF+NLtrqZr9/B1nLZTP+7c44/+8v6jT11/dT25h49D9/dx4PtxGGfC3Z9hOGz+AbaK7l8ZIQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1385",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531128",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.22593185",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lz2lIUlubehIVBD0UETyUHiqGNhCzUqNQSv/dYKvSk7edfcPM5B1kZ31sbwpS2OFZZ2jaCi0QyFBbd4c074bTGwIuaJjEYhHwkHImEujJjzI6TyL5lzEh5YRNUgdafOqXTVO2foN/rHV5VU41kDLKCOyVrVw9igO60mk/e5AnffmirdJV7d4iFhGBjVHP0Sup4NGMwAoN+lj7MKYvXjH9Z8ISAQAA",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACdVU1LxDAQ/S85pyX9Sj/2JCoIelhU8LDsYZctu4HaSK3CsvS/m2rV2PZtp1Jamnkzb94kmWR1Ysutejy+5Cxjt3qrHnShdoyzpVZl/cqy1enr18BiYR7W8F+L4wmx+PyYlzXr77CLqtocTazj+W6QSJ87XuCKNJY8df1QSv4XkDJsAS8Ke0CSRC3ghxEnUnURMonHc8Rx2gOCyJupCiafKnBG8ilVQ6owDMYr74DhJMICreTCjZMoHayGbbZobLM1GSPerf4R7lY9geQ8d18JKAeYgUCQ0pp1Asm/lPTLgesJJMKWAHMO/ectBmCH+3d6YxAbgRJBUjTVUcRFB97ATDkRAA3xBKFEkBTBjWgBhG0OvIEZHlpzuwUSUSJIiuDtNe8gBd7ATLmcAM28K9ZEmPv+Sm2e8zqvWCZcwdldXu7rQze41/WmVrrshk9q9wPd5Gp/qLvBdZG/246XutCGsHwrimb9AanObYihCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "4.4 /",
    "Flow State": "Turbulent",
    Friction: "223779.47 /",
    "Friction Factor": "0.016185",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "4015",
    Mark: "615",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "898446.4",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "262775.9851",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "32",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "21.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531130",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.03124391",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jcEKwjAQRP9lz7GksQ22nkQFQQ+lCB5KD6ku6UJMpEahlP67qdbb7L7HTDVA0dC5fyDkcHQNlXj1ymqDwKBwZP0T8mr4xaAkkeBSrBfxMuJSJjDWf23TdaoPbnjsSN3RYwc5jziDE1rt2+mIZZoyKJ1Xnpyd8YVuMxVZzOCApFv/ZSshGOwNvmc9C+NTwdYZF8rty5ix/gDK7dRSwgAAAA==",
    Pbi3DGeometry:
      "uSAAAB+LCAAAAAAABADtWE1r3DAQ/S86O0aW5K/NKaSFQnsIbaGHsIcNMYnBXZetWwhh/3udjdyN5JnReMkhBBES4rfjp6fRaIa314/i6qb9/vCrESvxub9pv/VdeysScdW32+G3WF0/Pv87fizPxx+xT47IWSbl+eHP+Cv26+m1i91u8zC+a9JMaZOcZTqVRWGSOlVVWSYvYV3qJ7jMQTgrC060yg+wKcBon8QqkXnuwHVuIG5ENx2NcDOV0KnySWDuTJYGyomjW1U1QO2jXqyjLsDgHMxJvLBeJ3EBFGZwshbYBayMXM1jADW4R6RkoU7eHFlYCDNSQfROAmW1rAgp6tAOXQo6dzSzd4URzYs4vPP21ZG9JETN4oBXxGDWXfMXdOGymJpUkR84TE007lA0R3VW5BnZ/emhYJWESDi6kT6haivb6ANHJakzQKJZTRdu5h7qtmIzxrA7NBIMS+am1L/QrGiEu9KukkwRcLAdujDCHZrh7iThpdsG68IpsqwyeGyAGEY50yGgYkmse4Rl+XSEKq2r8S0cdhrZEZ7aDUzyXB5H2JbHIm6lc82JnrbuRTsDKRg99RVwO5jARdy2Qvyc0LqRGpkvCZ47jC7LHwIj5Q6viAVT1LM8MdNHd0qmEkuCjAJyniBFgszSWTTCTV4FJjc27JFZyrzwyMWhpzqiBIumuGc9htl66DnGVGJJTpl6s/u36MJjSyIC37n3RywJ8yuB1/D+LJMf8nnvw/vDe1vyjcCreX/S5cN6o/eP3p9BHb1/9P7R+0fvH71/9P7R+0fvH71/9P5v0PuvE/Gh3fxshmYnVjKVifjSbO+Ge/vwtR82Q9tv7eOP9vb/R5+a9u5+sA8fu+bvy8DLvutHwu2frtuv/wFr3zocuSAAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1387",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531131",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.51488903",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaSOmnkQFQQ9FBA+lhxZDG4hZqVEope9usPXv5G1nv2Fmsg7S0hzai4YEtliaFG1boQMCKRrnr5Bk3XAGA6NKcjmf8IhyJmbQkw+LKRdR/JcxodQP+8ocWP6qXjRN0Yb+8FiZ4qy9biBhlBHYaVf5ehR79IU3YfIgj+b0Rhttqto/xVRIAmur76NXUcFlTGCJFkOsu1nb5w/1qkL/DgEAAA==",
    Pbi3DGeometry:
      "TQgAAB+LCAAAAAAABACdVV1PgzAU/S997kiBUj72ZNTERB8WNfFh2QPLyNYEqUE0WRb+u0VRO+TQYgiEnp6ee257265PZLWVj8eXgmTkVm3lgyrljlCyUrJqXkm2Pn396m621A9p6S+y8Blbfn70S9rN97CLus6Peizz0siP6MIPPZbGgqZewIWgJiwE72A/4mdwkkQdHPCIOoj0bJHEY9pxnJ7BYeTPcAJCTqfjGHLayVCE83Asyx4eThVIxwjJPT8I+Z/5NmFDxISN5EfYne8R7c63g8i09tAJSAfAwCAIacy3g8i/nAzTAWsJDIKyB/MN2POWAWiDirUXhEPZ29kOTqb3juMSAzaA7XseiDicEHa2gxNQbAbsUMiADWBwKM3bDUDEznZwAu6deccjYAPYfsEAEfeLUbP13Xwl8+eiKWqSMY9RcldU++bQN+5VkzdSVX3zSe5+um4KuT80feO6LN5N4qUqlRas3sqy3XwAdy3B800IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "3.6 /",
    "Flow State": "Turbulent",
    Friction: "156752.00 /",
    "Friction Factor": "0.016613",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "967",
    Mark: "616",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "151551.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "217075.8138",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "31",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "17.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531133",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.55914525",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNud0dooKgjqIBB3Eg9bQwdrCViDid2+W3d57/N575Qh5o8/DQ0EGR9foQl19bVujAEHutPVPyMrxJwOyogxzniZryXFEGUzVH9v0fT0ENgQ7Xd+VVz1kBBMEJ2Vb382GijhGUDhfe+0sZBTHCUmkiJhIJE+lEAgu+rbATFIEB6Xbzn+XUsYQ7I16L22JGZn3ts648GVfxkzVBxTVvpzRAAAA",
    Pbi3DGeometry:
      "0yEAAB+LCAAAAAAABADtWE1r20AQ/S97VoxWH5bknEpbKDSH0BZ6CD44RCQC1SquGgjB/z1bWavEs/t2Vk56aZfg2H4eP72dndmR39WjuLxuvj38rMVKfO6um69d29yISFx2zbb/JVZXj4eX6uP4XP2JffSMnMk4Ph/+qYfYr/XX3u12mwf13TOZLLKsLKIqW6RVpp4XSVkU0YDL6ggvcjsui6U7PlYBL/BsaY+feIieOM8PeFGUVn6k3zMe8bN6PPM28SD+siqt+UH6R/4kqRJb/jVO16txqtPgGfdL43S/vPlH/Vw8zaeBIx6CozzQfTR0el6X7qOhZ9xHI2+6TuRJy/UuQ2mlQVVo0CP1r6xaX36UZdiNZLme9HSzDPnMslARwkNGWnvCCGd6ZfbZJq0lDtR4dzQ88cpqwNWLgSermAkC4hE/kK8HS57Ko73yHDjGgKI8J8o30pbkB7z88z31FLuXxYRz5ziaE3S5RqtovIgrr3MfxSP9nmmmc8j7vgHxj3rSNB/CEzfsPq2N05dhoeGMdi73zzPuUIJJmQxrlWXmN9MpP6oFZkbT7CA5iGam/HS5HBsOo7osNXrcVG4GUjEnEKuVVDhYr5sEUxnOYMpsX4l91XOIaYkAzaAS7FfE+23HT8meIRC2FNAC4pmrgmg3CXuE+mmZaNCJC3B7sYBxBILd1IbCWdzwdsKO+3S8vXv4OwCgBMS7rwmCnRzscPNSMrHMGoWgl2c1vpuZqPtPjAj0E4c1KN7KiJhrOCD9/6oRwfwC9zYo/pIRwRoOnIMQjIg5WQtGxIyzLRgRtuEcjAgrHowIFxyMCNdwCkZEMCJclRCMiGBE2BQGIyIYEQ4jYh2JD83mR93XO7GKF3EkLurtbX83vvnS9Zu+6bbj2+/NzfTRp7q5vevHNx/b+v5l4Puu7RTh9nfb7tdP0iedZNMhAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1389",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531134",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.92140692",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0a1JNPYkKgh6KCB5KDxVDG4iJ1CiU0n832KoHBW87+4bhZS2kR71vLgoS2LijTp1pSmeBQOq09VdIsrY/Q2HEkPKpwBmLkMZSIHTkB5WcjiWffEOGf+BnN38JzOu6aIJFeCx1cVZe1ZBENCKwVbb01RB2zhdeB/E+HvTpjdZKl5V/hhgFgZVR96ErKTLBCSyccWHW3ozp8gdM/ngSFAEAAA==",
    Pbi3DGeometry:
      "swgAAB+LCAAAAAAABACVVl1LwzAU/S95zkoa02btnkQFQR+GCj6MPWwsbIHaSI3CGP3vZlutS7k3zSgtzT29534lhy4OZL7Wb/tPRUryZNb61VR6QyiZG13bL1IuDudXB7OZu0hL/y2TlLHZ6eFu0i7/3G6bZrV3vpOUJ0JMJU0ZT/Ii47RIuJQFPQFTzyzy/GyWzAdy5x8m4s4V9EhlBscYUqWZCOaEhkaB60OjAEo1rJuLDG5hD0SW14c+EhUiuSmE9BrrWT2aC7vXC+j7Y/4QO8aD2aOy8foM2bEssaiD7PseR/KM5gNXNZjI2GSxAaKHDJ84yB+VZNRgwVMUIkIdrhOP0HhBJhSI3CgeEWTHNlBQBzCiKOEY9wgdYVBpUCBSDDwiyB46TqCWhYhQB7CEoIRDOaF6jAIhJqgIXBagXseJRYy2DJJ3fwD3evWhrGpIyRJGybOqt3bXLV6MXVlt6m75rjc99Kj0dme7xUOlfi4/vDOVcYT1d1W1y18OtiAvswgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "8.5 /",
    "Flow State": "Turbulent",
    Friction: "780658.76 /",
    "Friction Factor": "0.014994",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "2530",
    Mark: "617",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1975057.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "509917.7011",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "17",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "41.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531136",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.79529054",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPIo2mauhIVBF2UIrgoXUQNbSAmUqNQSv/d+gJ3M8OZmWqA4mj3/dVADttwtKU5Re0bZwBBEayPN8ir4SMnZEYZTpJMzilhWAopYax/4KLrdD/RU7Cy+mKi6SAnmCDYGd/E9mUoTVIEZYg62uAh55gmVCiWCi4yJRWnCA72/A9vjG3a+F7KOEewdubxbSvMiECwDC5MV/7u3Fg/AT1lUO/SAAAA",
    Pbi3DGeometry:
      "rR0AAB+LCAAAAAAABADtV0tP4zAQ/i8+h8qv+FFOqwVpJfaAdlfaA+qhiAgiZZtVCUgI9b9vaBNDHH/Y7WkPVkVLPJn5vnl47Ll5Jde39a+XvxVZkqv2tv7ZNvUdKch1W2+6R7K8eT3824vpef8hu+J95YxRer7/6v/IbjWqfdlu1y+97hnjC2EULxjlC11qXdgFp2UxXTeav62z/ico0Iqlalgr3wRSqVRTAyljhCfgBmAgNwaFOUTM0hw7JkAhnGMzFY4H5OR5IaXRe4GyJf8ALZkVk/XR0kxhdEJqwycCB+ELoCmE7SxBUlSziWAMCCaFsKF7lso0CEcqGdthQP9QRGBJSTHQ1eKwZeAGcKwotQcBtTZcVJFigzvDQSBS6Rk/gu3MP1QjyNQJrKCDMOW+Bmo7sBScIGop0thgr5gLpoWAA4gFKBfJbWfcr8Dr9K0UdRt7UZrDutrHVYDjzdkpRzulNXvBaEeJaWthDJQTalKxYEAASEkYMThRghM3dhTD434u0HxgdWqcYAs+2r9wTqWSw+uSisnr8FSAGpAr1AhTQnY+qb+gnXimp30j3me8dOLkBPnglIHiRgqIECzhhFB49zDPBcViVyGfqx6hk88HJ/A3g+FgWxkuIuAQI36JgDfZGXgwUjiyeIMiL2DQ45GapRVgYPeSb4fvrNB2h9mAnp/gYLhuIQJ4HyYpufvFGCFDeerMU+fnBZWnzjx1Rhpqnjrz1Hlc28lT5xHByFNnnjrz1Jmnzjx1hiOVp84Iwv80da4KclGv/1RdtSVLuqAF+V5t7ruH4eFH2627ut0Mj7/rOyf6VtX3D93wcNlUzx9f/No2bW9w89Q0u9U/TCOHFa0dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1391",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "625398.7",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531138",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.59180785",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjc0KwjAQhN9lz2lI2jRt6klUEPRQiuCh9JBqaAMxkRqFUvruxj/wNrPzzU49Qdnqw3hVUMDOtbpSJy9tZxQgKJ22/gZFPX1kQCIaY8bybBHRBBPOGczND1wOgxwDHQ5rLS/KqwEKggmCvbKd71+GUsYRVM5Lr52FguI0I5ngScwzwXLBQ3rU5394q3TX+/enPEkQbIx6fNsCxyRFsHLGhSl7N2Zunqfzg+TSAAAA",
    Pbi3DGeometry:
      "mR0AAB+LCAAAAAAABADtV8Fq4zAQ/RednSBZtiSnp7K7sLB7KG2hh5JDQk1r8MZL1rtQSv59jWPLsaRnqb30IkJCrLFm5s28GWke38jNvrp//V2SDfnR7Ku7pq6eSEJumurQ/iGbx7fz305Mr7oPOSXTyopRetX/dF9y2o7bro/H3Wu3d8XSdZYpmawYX1PKi6RYpzRP+nWp0tk6k6lbIAXz7ChoNhNkQnhUmU4pxc8CVnC3DQTD3KBNBGvStoMFKITaNpXMHRDoFILBlRhsCJFd2J7WuZhpsjaMKCZBkSu3iUEAVSHbtiboVJrJy4AEOIVsI3iMqkULtk8+03YEITwjIJhSfCyZTC3yf6IULc4CpsSMUsFcg5WhBcCp8Hz7vfXz3GAIVPUBr7z4jISbG1DPgTzQ5Q0UhTY12Ca0ALIA88YbV1irvpYzwnCjDi+jANgIXVfS/brM+3UOzjatKB8VCZX3Agu0YqwXMDeZUH8KjYWpHjmUSTEoyvN5poNPYXjSa4HghsDjFIQBu+8H8IGUcjZwowPjYqtxHnjftzwFG4A/WA/mHuAqCgTqGqDJgGQupMbtD8wYsAvfR+zCBEaRgBcwA4JgnjuQ5ay0aOE5G+zDZCgFlYKiUilftg0vCWgd3jawaXecFmYAWJ3eAMJrlhkonFUUKIQv+FI4XRFAsaOQ+2GHowO5gKhh8lCOQluf1yUUpThrxlkzsOjjrBkYwThrenDHWTPOmnHWfE8s4qwZZ804awICx1kz6PIQZ804a37SrLlNyNdq96tsyyPZ0DVNyM/y8Ny+DA+3Tbtrq+YwPD5UT1r0vayeX9rh4Vtd/rt88UtTN53Cw9+6Pm3/A3ieNhiZHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1393",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "166084.1",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531143",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.7858869",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGkS9M/T6KCoIcigofSQ8XQBmJWahRK6bsbbO1FwdvOfsPMFD3kZ33sbgoy2NFZ52S6miwwyElbd4es6MfTG6TkSSjDRSCQJygQBvYDYspTjL5gHOM/OMeWn/pl21ad3+Afa11dlVMtZIILBntla9dM4kCuctrPHuVJX2a0Vbpu3FtEKBlsjHpO3kD43ihksCJDPtc+jBnKF43axrcTAQAA",
    Pbi3DGeometry:
      "2wgAAB+LCAAAAAAABACVVl1PgzAU/S99RlLYgMKeFjUx0YdFTXxY9sCyZmtSqcFqsiz8dysDBOztBwuM9uye+9He020vaLNnr+cPigr0KPbsRXB2QAHaCFbJT1RsL9dXBeOV+qAm+Ju5iTBetQ91o2bXm63rujwr2yQJM5KSIMJxSGIcqxf1nWeBDshIkv4CZBFp52EDTPIpkKVLL6YhJnVNAZxZfM9c9Ez/YiILNWHyDTIBSZBlO3aI1cpk8hznYR6nmvK5ADama5XGQLdy7i4GoF26se9JOTRBwdHOo+rXbp7GYNAuhcY3mDdE5DhvLzi0OYweHPaA3YFrLezVhlrIzAQZ+DQpGJO7mlnT89+X8BY3yxZI5SMesIW58XyE3L2HrXIAKgt4WFioQAuvAwmMylGa7ek5Ks70FNG1q6uCWM8jXQ7qn8IdK9+ppDUqcIgD9ESrozx1g2chS8lE1Q3f2GGAHig7nmQ3uOf0e/zDW8GFIqy+OG92P+FzwRPbCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "3190",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "1133034.43 /",
    "Friction Factor": "0.014722",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3286",
    Length: "8262",
    Mark: "618",
    Material: "Copper",
    "Middle Elevation": "3200",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9361017.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "619958.9031",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3200",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3210",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "50.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531153",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.35256015",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TksKwjAUvMtbh5DUhn5ciQqCLoIILkoXLYb2QcyTGIVSencDrd7A3fyYmWoE3eJleBgo4UgtarJDRw4YaEIXnlBW4wxjQCmei7xYS5HwTGUZTOw/Zv2d33jfDPFDFHbY3E0wHkrBBYOTcV3oF3Km0ASMt2d6xdvPOhjs+rgieSpVzmBvzXvJFnyVFCmDLVmKte5l7VR/ALN+SDMSAQAA",
    Pbi3DGeometry:
      "rwgAAB+LCAAAAAAABAClVd9rgzAQ/l/y7CT+iEb7NNbBYHso22APpQ+WhjZgzXDZoBT/94VqZ9J58+wUTfJd7ru7XHJZHsliLV8P74Lk5FGt5Ysq5YZ4ZKFkpT9Ivjy2XSOmM/OSxuuRm4DS2elnPtKszmq3dV0cjC5jfmoeL6ChnzLTyfwozGLP4JzyrMXDhFl4yhPe4hFLbBzg6eenGR/kN60FxzSc5A5kdjQsnNlRd1yaKBiM9Qy7SwbFBBl1lz6gfhqz4DeRJXBXYVDj1PYKTrYwTAgTF0654aEEkLegbTsPCKL/uHQZnZ1r0FfofICpwCigjgIm2eAyDe96HM/1JQHyZuSw/UGO2SoQjtsqgD9T50+tUNBGHK9FKBoMDh4MqNqhiK4vpmBthC4yAEcSoQS4Yoqo/DiFFje3/1wWe6FFTXLqU488iWqrd93gWelCS1V1wze5+RE9CLnd6W5wX4ove+KdKpUhrD7Lsll9A6blK76vCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2749",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3181",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "1133034.43 /",
    "Friction Factor": "0.014722",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2844",
    Length: "432",
    Mark: "619",
    Material: "Copper",
    "Middle Elevation": "2749",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "488932.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "619958.9031",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2749",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3181",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "50.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531155",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.3743238",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jFELgjAUhf/LfR5jGktnT2FBUA8iQQ/iw6yLXlhb2ApE/O9NtLdzzvdxqhGKhq7DCyGDs2uoxLvXtjUIDApH1r8hq8YlBkVKnopU7SIR80QmCUz139v3vR6CHIYD6Sd67CETXDC4oG19N5doKyWD0nntydkV3+ix0lhFDE5IbeeXvlEMjga/q654LOaD3BkXzu3HmKn+AShEp6HDAAAA",
    Pbi3DGeometry:
      "MyIAAB+LCAAAAAAABADtWE1r20AQ/S97Vo0kW9pd5xTSQiE9hLTQQ/DBISIRqFZxlUII/u9RbPljV3o7s0pOZgmOrefx27ej2Rn73b2Km/vy18vfQszFdX1f/qyr8kFE4qYuV80/Mb973b1s344v2j+xiY7IlySOL7b/2ofYLPYfu1yvly/tZ7NsItM8jZI4ncgkzyM9SWftk4GnSr7jMpMmrnI1iKP4TG5xJZk8WimXnkRaOKG/F4/4Oz3seLQu2hfi7/ITZ5lLv9KJHOI/4mb+j7ipk+Yx79d4fqTfzCeNE3lg5wfpROsifqTHvI8qVnrcfnl1iPhRvdH7QnXoW7c8fnq/Fg+ZT8SP+gDS78tj1cNBJ68v0fxMHrAuxMl6RutauNRJx6Nn23OXz5xzgYzn6Ze5VO75gnBLD8nD0w/7zDTp9KfTLU+upfO+oHhuv2XPBavPZ17dfzgaaKdzjGYmMx7xq2zfMxJDD8DpnmrhiJ/7XcOdTTTRpuqADxagHznCeeOGFOMZbt1YqfUpPn0/cwa+K8s9bh+qfrzFYxXOWP52W+7wXRZ64aYaMtxkR5uCIv3ozbrxlI7K5oRmsA4A7JlHAIOeNbwkCqaZmQl0ZZtoyoACTQ7mBEL1gyYxvS5xKHj08AsDGsRkD0DHyMLRUEF6cDyLn9+T3D3ssC6px+L54LAc2wrgukjn2RsX6AeRr6HxWcYFz6Bg//A8O+MC7XekofFh44JpUCD9wbgIxgWjjwXjIhgXwbgIxoUr98G4CMZFnz0YF8G4CMZFfxAH4+JsjYtFJL6Wyz9FU6zFPJ7EkfhRrB6bp+7itm6WTVmvusvf5cPhre9F+fjUdBffquL/aeBVXdUt4eq5qjaLN13EhFczIgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1398",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531156",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.23905828",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACNjs0KwjAQhN9lzyE0sWlsPYkKgh6KCB5KDy2GNhCzUqNQSt/d0Na/m7ed/YaZyTpIS31srwoS2GGpUzRthRYIpKitu0GSdePpDTKiciYXLOBUxiGHnnyYEHQes38gZ7/wO3Vg+at82TRF6xf4x1oXF+VUA0lAAwJ7ZStXT+KArnDajx7lSZ/faKt0VbtBRFwQ2Bj1mLwx5UyEBFZo0MfauzF9/gQVzfboEAEAAA==",
    Pbi3DGeometry:
      "aQgAAB+LCAAAAAAABACdVV1PgzAU/S99rgQYbWF7Mmpiog+Lmviw7IFlzdYEqcFqsiz8d4uiK4NLLwuB0NPTc8+9/VodyXKjXg7vkszJg96oZ12oLaFkqVVpPsh8dfz9td3hwj6kpifkKgrDxc/HvqRe/w27rqr8YMcKHoiZoFEYByLNaBbECefURZkQDRyxpAOLLG3gOGHUr9GSeSqGpG13B445m2BkOOJoLsiA4z7ORWaMD+XYwud1ApJxQjIWpFnUr3YHd2Q6+Cn9IXpjfUi+8Y6RGVfvmYGSgnDIJRDWKTxK5kI7vbSAmQVcAlsAqjxAnzYhkDiwghGrA7EP/GyMl/HdhJ5riA/h/pMAkkEcHH42xguw7BwYtaohPoQDB9bEzQGo+NkYL8CVNPXshPgQ7ruAIBH0tWnJ9t6+VfmbNLIi8zAIKXmU5c7s28aTNrlRumybr2r733Uv1W5v2sZdIb9c4o0utBUsP4uiXn8DZ2htVGkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "6354",
    Mark: "620",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "34698.7",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "81",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531157",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.76438306",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjbsKwjAYhd/ln0NIay5NnEQFQYdSBIfSIWpoAzGRGoVS+u5GpeB2Lt/h1COUZ3sc7gYU7MPZVuYStW+dAQRlsD4+QNXjTyaEMVyQQi4zkmPBhICpmblV3+shwSnYWH0z0fSgCCYIDsa3sfuYLKMcQRWijjZ4UBlmggjJFzkXkhaSp/Zkr//wzti2i19PaI5g68xrXhMsKEvZOriQzvzTual5A/DmJGrTAAAA",
    Pbi3DGeometry:
      "zR0AAB+LCAAAAAAABADtV01v2zAM/S86e4asD0tKT8U2YMB2KLoBOxQ5JKjRGPDiIfMGBEX++1Q7VuOPZyntVShSxKHJx0dSpPjwTO625Y/j74KsyNd6W36vq/KRJOSuLvfNH7J6eO6+WjG9sX/klLz+8iGj9Kb9Zz/ktO7Vbg+HzdHqSplqSfMkoyxVUin7JVVCZsmLgGvRCZhmlwKlzLwAamiqTSfI8iBLKlfM45RWQwhE4xVjrIFMQXDslR8cRsS0bwR4BXn04JrRVqCpygemeoFS1olLHmMNh+EEXGWzppwAgU9M9eDQKxcSJ8g9TkFsxG8CoYXhi/wgOMaAUUcRCag31R0b3XmLS8Hxo1K2AmnMYrlBU1jgcyqYN/Q2gN+wRPyW3pCMET2Yb3f2hwq4U8EDgCz5O3Roa8Ntx1s5WDDKhZfe1REMbyFe3hMWjJ+xRaua6iw3y7OM9yGUMu9oGN0KhJBDfoyJoLwGBwQiQJ9cvnlryKjhyRvN4yXSQCBEHz/+3jDBGXMtO5hT976yTrbQnC/PBagBnYUa3kqDQ3cSdD/BYUBgA8GFBrMKfF1gB5KHTz0sHOAUqub5aOBLpxF8lgO+BCjgK75hwenJ+eypsAI2y9qPjSYY/H1yeUXQ3kDh6+4oFYgDjjiME8oqxgD0YDfAN1F06HG6sVPX8sPJQBhIwzstxuxglvwI4+4Yt9C4hcYtNG6hcQsNmtVxC41baAJuyXELjVto3ELjFhq30LiFxi00tAOvE/Kp3PwqmuJAVjSlCflW7J+a3fnhvm42TVnvz48/y0cn+lKUT7vm/PC5Kv5dvvixrmprcP+3qk7r/w7g2QXNHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1399",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "924448.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531159",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.24625142",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyG0semfJ1FB0EMRwUPpocXQBmJWahRK6bu72Frx5G1mv2F28h6ySp+6m4IU9ljpDE1XowUGGWrr7pDm/SgpICWPIz9Y+iLhiRQCBvaFYcw9IeQfuPBIyF84186w+LxftW3Z0QY6bHR5VU61kFKKwUHZ2jWTOaIrnabZoz3ry4x2SteNe5tQSAZbo55T1vd4FIUBgzUapF77MGYoXtPKqGoTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVltLwzAU/i95riXt1ibpnkQFQR+GCj6MPWwsbIHaSI3CGP3vZrW6XnLaE6S0JP36nfs56epEllv1cnyXJCMPequeda52JCBLrQrzQbLV6WdpYbqwF6mCy5uriNJF/bA3qda/tOuy3BwtN0lCzqJ5EMUiFAmzCxpyytKgA3DOzgBj6bwLpGlaAzzpMUBRDYPHgjl18BkXF2BGQxoJ4WkVqHzKQaRyjFUOUZQPPW8BwyA6HewrT3lI4zgZ5qMDtEV1gHZIXIzaD5eO2g+cqCkdXatAB0c9B811Ku/nY1rUv6xyOAjlHIwV2DhgPkCGf6JAHc5qR5fPdOOgGdNWYXrQpxhcjHEAM0tAUcixhGEgrXKVaB9A9gfIcAGjs92/o+ApimHgrALPQf+BDDJAAHXcgaK8ju0zw/5D3KrNmzSyJJkNY0AeZbE3h2bzpM3GKF0021e1+4PupdofTLO5y+VX+8MbnWsrsPjM82r9Dfr6qrH1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3190",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "1133034.43 /",
    "Friction Factor": "0.014722",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3286",
    Length: "3704",
    Mark: "621",
    Material: "Copper",
    "Middle Elevation": "3200",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4196372.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "619958.9031",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3200",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3210",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "50.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531164",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.35521227",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAQRf9l1iEkfeXhSlQQdFGK4KJ0ETW0gZhIjUIp/XdTpeBu7txzZuoRyos5DQ8NEg7+Yip9Dcq1VgOC0hsXniDr8TdGJM8xJ1ysaCKw4JzB1Czcuu/VEOG42Bp110H3IAkmCI7ataGbA6VZgaDyQQXjHUiKc0aYKNKkYCLjoojt2dz+4b02bRe+l3iaIthZ/V5sgtlsbLz18Zd7WTs1H7oNIFfSAAAA",
    Pbi3DGeometry:
      "wR0AAB+LCAAAAAAABADtV99r2zAQ/l/07AVZcnxS+jTWwqB7KNtgDyUPKTWtwYtH6hZKyf8+k8lKJeuT1T2LkBDrfD++T3cn3e0bu7lrf77+adiGXfd37Y++a+9ZwW76dj88sc3t27+/o5hfjB92LM4rn0rOL04/45cdt5Pa58Nh9zrqrtcrxZUuSqFXWtSiKPlKVVoWo4BIV65AUhkUECkR16hJuAJOddTULCqqTwpKqrALCGOmYV0km5p8p65DBq3rNa+DfOCYIAoqjUApcnBbwVq7pnyNCcZpXfIVL1U5d/FOAC1B3/NoYVAVOYTEg4r6RvAkl1EXbkwpvh0XUXQ+HyilxFQwxKtY+p8zqibDH9cOuuRUg3VhBSio5N1ejnY5zb38gJY+HtQiPG+3/fdhx4FpYAXQVHJXg43CCmAi4NRZ5DZUrCktx8KAwJNLKQE4gEFaG0a0Oq0LET/4FK+VUeDKCMjtFFwaGDKcU7BLJTIS8oGiIlVOppTT8dKPY3jkW4GuPEEl5X9yBfvwxwGCnVWilsZ3Bc4A/3BY1vCjRRowKGQpQjpIXMQHbiMo2/C+wmgRPJgIuOmh/UZB4YSGGQLvsB4M8qvPvwv4wRL5zXDh2JjdT0xdEIlwiY2CuGfkAa2DSwhyDCjClOK0jHIXvYr6JOFBAviAtCbfE88XB9QjIOGLuFPhoXTFqMN7B7couf8tRQQN5fkzz5+JRZ/nzzx/5vkzz595/szzZ54/8/yZElSeP/P8mefPPH+GDG0LdtnufjdDc2CbUVSwb83+YXg0D9/7YTe0/d48/mrvrehr0z48Dubhqmte3r/4pe/60eD+ueuO279TdHexwR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1402",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "924448.2",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531165",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.57924169",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjjELwjAUhP/Lm0NImjS1dRIVBB2KCA6lQ8XQPoiJ1CiU0v9usNVBHNzeve+4u6KH/ISH7qohg607Ye5MVzsLBHKH1t8gK/rxDAY1o5wrMedRSoVUMQzkN0wFl9+QSfEHHGPLd/2ibasubAiPFVYX7XULGaOMwE7b2jeT2DtfeQyzR3nE8wdtNNaNfwkVxQTWRj8mL2c0SZQksHTGhVx7N2Yon81oK0YTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVt9PwjAQ/l/6PJeW/Wg7noyamOgDURMfCA8QFmgyVzOnCSH7362wTbfbeQUCoXx8393X3l1ZHtliY14O7znL2IPdmGdbmC0L2MKasv5g2fJ4/uhgPndP1gS/31wJzuenN/dizaqjXVfV+uC4qQq51CoQMx1GcZoEgodSpnHwA8QqHQCKy/QEJFIOGSo5A5iU4EJPMoR7TMcYS6lI6f+zQn2gWV0eHANQKeBczbSc3MQe8DbYZ9VJ6UjEg/PopDoASPWM8ZaMGb0PEAOTwgHvrMC2jwE0Xdzg2Ee37f5SZFa4wfFBgeBo+QAGVle0QRDD+8z7EiW3BPQHKYUyQH+QzQmyQlsNBUgp4AMF0GIgxysqRQ5kmkGWKJjtKOBd7UDq8lkCZjsphTK8Ly96loBbDQP8xxKQAgDatd6zhLyEJ324/xC3Zv2W13nFMh7ygD3m5a7et4snW69rY8t2+Wq2PXSfm92+bhd3Rf7194c3trBOsPwsimb1DU53mHX1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3190",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "1133034.43 /",
    "Friction Factor": "0.014722",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3286",
    Length: "178",
    Mark: "622",
    Material: "Copper",
    "Middle Elevation": "3200",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "201973.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "619958.9031",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3200",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3210",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "50.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531191",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.9431761",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAUhP/LOy+Lrq3u2ikqCOogEXQQD0qLPth2w7ZAxP/ekualoNub9w0zk/eQVXjqbgpS2NsKM6u72hogkFk07g5p3o+nN/CEJlIslmEQ0ShiMQzkB2SCSiHlF2T8H5xji0/9qm3Lzm/wjw2WV+VUC2lAAwIHZWrXTOJoXenQzx7lGS8z2imsG/cWMeMEtlo9J6+gIQ8TAmurrY81D62H4gXBAMGqEgEAAA==",
    Pbi3DGeometry:
      "dwgAAB+LCAAAAAAABACVVV1rgzAU/S95ziTRqkn7NLbBYHso22APpQ+WhjbgzHBuUIr/fZmzflRvPhDFnNycnNzknmzOaL2Tb6dPgZboSe3kq8rlHmG0VrKovtByc/7/1d1kpR9U4x65oYSsmo9+Ub29DLsty+ykx8ZpkEacYUqiIIrCBLMgJDHFMzhNCG9wtpiFofCE8hEe09SDpldDklE8izxEdixXYkK6CI2zAjSAdh5RB402FsOcIQs443ySLztuo2kSM8Avu+RI3+N/2zTAhymYUQPhV3K6fRqr78KbxE9nBdYKkDjB1vwCZ8BAbt1rG7fT6q2phUrDRAOEexQepMbRlKyr8j140Pk1uA/E4m4EULihljwM2K0krZUNOQTk70YeKN7j/oD0OLmqdVVO1jE2/mmKnbzAdntMhetb/F5mH6ISJVqSgGD0LIpDdWwbL6rKKqmKtvku913Xo5CHY9U2HnLxMwy8U7nShMV3ntfbX9bie5h3CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "1152403.29 /",
    "Friction Factor": "0.014972",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "7820",
    Mark: "624",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9012198.2",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "517780.5918",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "50.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531199",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.27312312",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jMsKwjAURP/lrkNoYl+pK1FB0EUpgovSRdRLeyEmUqNQSv/dqHU3M+cw9QjlmY7DHaGAvTtThRevbWsQGJSOrH9AUY+/GJQk41kq1FJECy5jlcPU/L1V3+shyGHYkL6hxx6KiEcMDmhb332KSJOEQeW89uTsjE90nalUgsEOqe38l+VSMtgafM16zkUsFIO1My6c26cxU/MGAGYnc8MAAAA=",
    Pbi3DGeometry:
      "0yEAAB+LCAAAAAAABADtWE1rGzEQ/S86b40+1pbWOZW2UGgPoS30EHxwyJIsbL3F3RZC8H/v+kNZS6vRjNzQQytCQvw8fnozHs3Y7+aJXd82Xx6/12zJPnS3zeeube5Ywa67ZtP/YMubp+O/w9P8avhhu2JEXgnOrw5/hl+2W9mXvd5u14/Da+d6ttCVKARXM1lWpjAzKUtROLg21R4XMgSLuapI4RU/hBtFYzmKEaXwcMlNiB3SHg2H2Olq4iWb8kD83OhQcRz1piwXIXYfn4S7InEa5526mB3Q7lYSxwEat5B4TpDK+LFTHkCO8/7pxcD2B8li7QfxQ22GZxVtv8RuRdjxZF0cL2aUfnLzAe1pJA7sK0SGEEpOYoEOhXDivZye6tEraSdcpQ80IjjPrUo0nKZe70XHtkh0uVgxGAlJOlQxbcqTdC2PNDqaUTicOrSBlTCB3VHOVcKADwZDWdJKO73rpHCAXStjzrWI0lRRHB2b3pgFePBPBd4SIpX9OdlqKOlZ34l5qWPxGDsA0zYKLiY13ktWyWOJlZKLCO4PPQuPUylMYxvH4rZx0tj3JcTDxxq44ZNFhsSP8yecE6Qyjd62jVcZTDvUN5NDw30A4qm1BHBgaEFdCUTHud2K0eoYnak0GbYtgAGMbB+oWaD968cD9MjNoLIDqxbEiWMAuEnxjwPgoWB4lNzrC9pAwhYfTco4TC/ck/5lTB0C4Llhnf+DEQF92yEbFC9lRFAMB/yb3b9oREC5JhoUL2tExA0HSHw2Ii4oWjYishGRjYhsRATCsxERW3HZiMhGRDp9NiKyERHZv9mIyEbE3zQiVgV726y/1X29ZUs+4wX7WG/u+4fTg09dv+6bbnN6+LW5e37qfd3cP/SnB+/a+td54Juu7QbCzc+23a1+AyCOYbnTIQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "25",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1417",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "13",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "531200",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.92017263",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjkELgkAUhP/LOy+Lq+5qdpIKgjpIBB3Eg9KiD7bdsC0Q8b+3qBXeur153zAzeQ9ZhefuLiGBg6kwM6qrjQYCmUFtH5Dk/XQ6QyQoXzF/zbyA+rEIYCA/yCMah6H4A7IgXMBF7AiLT33atmXnNrjHFsubtLKFxKMegaPUtW1mcTK2tOhmT/KC1y/aS6wbOwrhcwI7JV+zN6aMs4jAxijjYvVTqaF4A5pABZgSAQAA",
    Pbi3DGeometry:
      "hQgAAB+LCAAAAAAABACdVV1rgzAU/S95ziSxfvdpbIPB9lC2wR5KHyyVNuDMcG5Qiv99fm0qevRaRDEnJyfn3uQm2wvb7NXb+TNiAXvSe/WqY3VgnG20SrIvFmwv9W/RLdbFw3LeIjdSiHX1KV6W7/6G3aZpeC7Guo5h+9LkUqwM05OSe4b0VrwHW75XwrZ0+7gr/RJ3hM8pMjXdFLYckzelZfZx6TlL3IBZJ2MiTzrpZahiuu5oqDU+zBiKqZ3Wdg3PspxB4nt4R6aHtzkYoVfuR+Qr9xSZSfWhGRATgJFHMGkn8SSZa8wMQ0LLCkyiQkB5R/xl64HU0R4m7A5SLRD4JD/TNUVfcsRH+OyJgFQoB8g8neIF7b8OTtneiI5wdGotLROkQ+CT/KB7aukxivgIn72RkAr9Ni3pxZ1+r8KPKItSFghDcPYcJcfs1DRedBZmSidN810d/rseI3U8ZU3jIY5+usQ7HetCMPmO43z3C3R9oq6FCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "5714",
    Mark: "625",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "32471.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "97",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531201",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.74442831",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjsELgjAYxf+X7zzGpsxNO0UFQR0kgg7iQWnMwdrCViDi/95QK7x1+973e7z3ih7yWp+7u4QMDq7WuTOdchYQ5E5b/4Cs6KczGBKGYyb4ikYpJiLmMKAfZBwLmkZ/QEqWcBE7wvJTv27bqgsbwmOrq5v0soWMYILgKK3yzSxOzldeh9mTvOjrF+2lVo0fRRIxBDsjX7NXYMooR7BxxoVY+zRmKN9y2GrgEgEAAA==",
    Pbi3DGeometry:
      "dwgAAB+LCAAAAAAABACVVV1rwyAU/S8+u6Cm5qtPZRsMtoeyDfZQ+tBSaYUsjswNSsl/n/lYm5Dc5IaQEI/H47lXr24uZL3X7+cvRRLybPb6zaT6QChZG53Zb5JsLvWv62ZL95CC3pA7ztiy+riXFNv/Yas8353d2EB6voxCykXssTCSNPJ45NMOvAhFCUsedvEg9ks8YDHFyNR0wSQfkhd8Ibo4D+aYASYdDQk755iTvoZwAQ7FWeP9dEERXWeVoRfxWPSS3sFbKh38loABemV+QL4yj5EZVe+bGQ5pGIUcAlO2so6SmW+lHw60ooBFqACgnEP8eWsBqUPbF7EzUGWA4KP8jJcTfsEhPoRPHAWQBuLgmGQjfEBbr4UjNjbEhnDoqJpbIJAOgo/yA91Mcw9PiA/hk5cQpIK/P0u6u8Uf9O5TWZWThHmMkheVHe2pabwau7PaZE3zQx+uXU9KH0+2aTym6rdNvDepcYLZT5oW2z/UoBycdwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "1152403.29 /",
    "Friction Factor": "0.014972",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2486",
    Length: "2298",
    Mark: "626",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2648295.3",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "517780.5918",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "50.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "531211",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.74225285",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1Tt0KgjAYfZfvegzbNN26kgqCupAIuhAvlIZ+sPaFrUDEd2+g9QbdnT/OOeUIRYOX4WFAw5EaLMgOLTlgUBA6/wRdjjMMgXXC00yKzUooHsWpgIn9x6y+83nf10P4EIQd1nfjTQ864hGDk3Gt7xZyJl97DLdnesXbzzoYbLuwEnMlpWSwt+a9ZAVXicgYbMlSqHUva6fqA3ZtBJgSAQAA",
    Pbi3DGeometry:
      "cQgAAB+LCAAAAAAABACdVctqwzAQ/BedVSErtvzIqbSFQnsIbaGHkINDRCJwreKqhRD87xWOk/i1lmyMjTVazc6uVqv1Ca228uP4LVCCXtRWvqtM7hBGKyVz/YOS9en8a6bp0jyoxDfkzqN0WX3Mi8rNZdl9UaRHs5ZzQhcLhj0WE+qHDIckiriHeUDCqMIjEsYtPOYVGoXUv6IwS2UdE8b8PrWB29TBJCmQU2tIzn4teno8nHJ/INwa7uQMzjDktpl5RuKARX2WC95NQs++Fn/DGztlI7GSd8R0Q7LjwyJhv63M22OdKacXVntnIZmDp2Ew8aOWrvU+uqVwTqCidiCZedwhJePHaJzdWhIA7FYRgJiJ5lMbD1Rv9g7jxmPHofqHOpgbz/wOCekZupsg1IVjHHVtj+Md3M36jJr7+1GmX0KLAiWUUIxeRb7Xh3rwpnSqpcrr4afcXaeehdwfdD14ysRf0/BBZcoQ5r9ZVm7+AZWamL1xCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "-10000",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "-10000",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "900",
    Length: "1504",
    Mark: "627",
    Material: "Copper",
    "Middle Elevation": "-8496",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "147",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-8496",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "-8496",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "532527",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.11961405",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "vwAAAB+LCAAAAAAABAA1jMEKgkAURf/lrafBSR3BVlFBUAuRoIW4GOuhD6aZsFcg4r83mO3uvedwqxGKhi7DEyGHk2+oxBsb11oEAYUnxy/Iq/EXg6KkSvRmpWKp0ySDqf5b2743Q1DDsCfzQMYe8khGAs7oWu7molItoPRsmLxb8JXuC81iAUektuO56nUq4GDxs9jrSMZKwM5bH67d29qp/gK27gw0vwAAAA==",
    Pbi3DGeometry:
      "5Q8AAB+LCAAAAAAABADtV1FLwzAQ/i957kqSNum6PYkKgj4MFXwYPmysbIHayqzCGPvvltpqF/slbRCfyuhYvl6/u9zl7luXR7JYq8fDa0Jm5DZfq4c8VRvikUWusuKNzJbHr5/lbTovP+Tk/SATRum8+iovcnpuHrvY71eH8lnmM8kib8ICX4Yep34gROy1URFGFS75GRwEcQWHjHeacxp6v8m5FL1YbOxaMDLujh3hkRCd9I29HibaFAoT8SDcxlPHH8ranMsKZjFrw02UrMu29NED5kHYDsTF4VTEJgrNYSSnA8ID3E0cERfuLi3crIuizkfvc6XVEbjUYBsL2I8GgxYCKbRYI27Ub6h/tH4w5vwMtDFoBRpYN1shgDliH9r1nTsCnanBZg7QxhqMqmYuBDBG3OY5K7s2ox170PToIBsHqXn6oILZagDMEbtZwvRUuQlJX2FzObA9/zgMlHA0Ul0lfFg0lgy46KNFYvsJsn1CugksmJtAqAD3n8ixhXuU41GORzke5fgf5Lh8Z75Sq5ekSPZkRn3qkbsk2xa7enGfF6tC5Vm9fFKb71s3idruinpxnSYfbcPLPM1Lwuw9TU/Pn64aAgnlDwAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "5",
    Length1: "2",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1435",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 0": "20",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "10",
    "Nominal Radius 1": "8",
    OffsetHeight: "10",
    OffsetHeightTemp: "0.002734",
    OffsetWidth: "10",
    OffsetWidthTemp: "0.002734",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "73954.3",
    R0: "10",
    R1: "6",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "532528",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.6482612",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jUEKwjAURO/y1zHkJ2lN60q0IOiiFMFFcVE1tIGYSI1CKb27wepu3vCYqUcoL+Y4PDTksPcXU+lraFxrNRAovXHhCXk9zjEqSlCh0my1QEHTRC5hOv+9dd83Q5RjsTXNXQfdQ84oI3DQrg3dF1AQqHxogvEOcqSS41IojkowlrFMFgtMCJzMbfYRZUpgp03bhS8zyQkUVr9/C5xRrjIksPHWxz/3snY6fwCc9oz81gAAAA==",
    Pbi3DGeometry:
      "4BAAAB+LCAAAAAAABADtVltrwjAU/i95jiVtmrTRp7ENBtuDbIM9iA+KRQNdM1w3EPG/r3S1Wy/HnDgf9lCkYs5nzq3n8s32ZLrUz7u3hIzJvVnqJ5PqFaFkanSWv5PxbP/9s4DZpPiQA/2RjHzGJuVX8ZDD/Hjtartd7Iq7Mfe4UoqOfO5JFkgaMI+HfkAbgB+pEojihjxiMu69AAK1JhaGFGXbrqrllBRhVMoV50hN1Y0gVj7SW+WLfgBSdUaqoDhq41XgsazknKuGphoIS3EgRVMsFQAcLctePUIopF3QgMVuwEKkokiI06Y7zkKxWYPoaAIBdD7AVw15C5WAtTSgqN2Da2ccrGNQlb3ygehgE5BTcJ+2AXxFubfRsZzBIYEukO6EQg8iu1fgsGsD9n51a/t2v4A7AVCE31/WrWP3Cdo6LTl2KHf6Cze27JOjv+fgpQLF5coJ4Fy7b1lkrv+w4LGTxurS5QiBM69xHvquPOFSdOBiW9+dDjjvP+iC+3o4nb2BCgxUYKACAxX4n1RgTsmNXrwmebIlY+YxSh6SbJ1vqsOjyRe5Nll1fNGrGrpL9HqTV4fbNPn8/cdrk5pCYfaRpof5F9LmDjDgEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1436",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "15",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "8",
    "Nominal Radius 1": "16",
    OffsetHeight: "7.5",
    OffsetHeightTemp: "0.002051",
    OffsetWidth: "7.5",
    OffsetWidthTemp: "0.002051",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "735.5",
    R0: "6",
    R1: "16",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "532529",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.4528251",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GPtQ5u4oKgroQCboQL1YNHawtbAUi/veG1t15Ds/h1COUV3MenhoKOPqrqfQtKNdaDQhKb1x4QVGPS4xKzjGnSbpeUY4FEzA1f23T92qIbix2Rj100D0UBBMEJ+3a0M1AOYLKBxWMd1BQnAoiZMZZJmSSyyxDcDH3xaU0iXjQpu3CzCRhCPZWf35rRjDLJUWw9dbHL/e2dmq+pGpQA9EAAAA=",
    Pbi3DGeometry:
      "shAAAB+LCAAAAAAABADtVk1rwkAQ/S97XsNmd/Olp9IWCu1B2kIP4kEx6EKaFJsWRPzvjbpqo3lxp3joQYLBncm8mdnMvpfBkvXH5nXxkbIueyzG5qXIzIRx1i9MXn6y7mC5/Vu5Ra+62IofLB1fiN7mVv3YargLu5nPR4sqNlaeCsOQd3zlRVr4XApPaV/ytSPwdd0RxWu7DKVuDICOUyShNW/LTYDaFqV8HdTtiVLtSMcRMk781mplFEXNbSCoP2wV7OMkuW1cBRZJRjUgmaiaXYbBBidJ4ib7IbG1h80wQZC0pYXwoJyTtFLoNpwKJnLKu6sTtOVavoWB8NRtQK8X1IneOpwGAENsC+4ynGcEBANQYzgDKAkdSuxwHSHqibGji9nAdSj2AWTCgTVBBoYOhIQOMrIjfoKyg4DcdeqcusCakLgguyv37tgC2QFJQbI4i3McgBqgar/DuLiqKXWz6UJO5hiY+nLCT/9+oTE99XPgQrJ/OXmnyT5R7+DjNEVw3bSr6F9F/yr6V9H/P6I/5OzOjN7TMp2zrvAEZ09pPi1ndvFclKPSFLldvpnJ3vWQmumstIv7LP3+/eBtkRUVYP6VZavhDzxopkiyEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "4",
    Length1: "8",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1437",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 0": "15",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "8",
    "Nominal Radius 1": "16",
    OffsetHeight: "7.5",
    OffsetHeightTemp: "0.002051",
    OffsetWidth: "7.5",
    OffsetWidthTemp: "0.002051",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "735.5",
    R0: "6",
    R1: "16",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "532765",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.17779818",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAQRf9l1iEkTZq0cSUqCLooRXBRumg1tIGYSI1CKf134wvczZ17zkw1QdGaw3jVoGDnW1PqU2hcZzUgKLxx4Qaqmj5jRKTAnNF0QQnHhNIU5vrHLYehGSMcF2vTXHTQAyiCCYK9dl3oX4FSLhCUPjTBeAeK4lQSmQuWCJnzLBexPZrzP7zVpuvD+1LGGIKN1Y+vnVDMoopg5a2Pz9zd2rl+AsXqLZ7TAAAA",
    Pbi3DGeometry:
      "8xwAAB+LCAAAAAAABADtV02L2zAQ/S86u0Zflq3sqXQLhfawtIUelhyyrNk1eOOSuoVlyX+vNnYUf+hJ6t4KIiSOR9LMmzejkeb2hdzcNd+ff9ZkQz53d823rm3uSUZuumbf/yKb25fhrxmmV+ZDjtlF8o5RenX6MV9y3J6XvT8cds9mbalyKViRMSpyLXXGWS6U4NmrXLGZuCykQyyFFL7ZpVE2nU7N06NlgUVKVZzklLvVI+yL+VZ/pB5rN1IOODubFZXWThYQHABfqFc1MqfMmJ+YHeRmesWnapbTz+itXDKn9kGMtACjcy0AixErXU0pCGFxGvW4VAjuUb/yyW91rh37NGcAJg077wU9ggTZfUkbUY2kiXLmVWQ+obS3coQoLrZBnP48diQDdPif8ATcWsd3tQDVERB5u2+hnsg6hQqAtQsC78mUEKPO/RgsJdYB5HHclgn7izJL0moAxOkJv9DUe2oJs35wQKhhYFEguBrxa3cOoQoUyYTDAoIkC82HAWNj5nTcYQpOaiuWap6Kmr+JIVBa3+AWjCWTbBwo2TpJ19U+vGCBFc2HkJAiRDXyDHKBCgWsLO5oIpwQEIwaLmloBcgvlLyQCnBFXLogmfbdalY4zcA8J0KHwer0GDeCQeLaUEZceA3jewAcQDcKYBlRhCjF2RjiDtyflgyh2z5iyO1X5CXvcg1AuxvzHPI30jEYAOwxWgFjE1nrwpggTakxTI2h5zBJjWFqDFNjmBpD535MjWFqDFNjmBrD6YrUGKbGMDWG7gD8L43hNiPXze6p7usD2dCcZuRLvX/oH8eXr12/65tuP77+aO7t0Ke6eXjsx5ePbf1nOvFD13ZG4f532x63fwEqzHL68xwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1450",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "533913",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.58587676",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv15j+2fO2VVUENSFSNCFeKE1dLC2sBWI+O4p5d35Dt/hFANktbn0Tw0pnHxtcn0LlWusBgKZNy68IC2GX5wUFDTiKDYrZDRRkYKxXLxt11X9JE/F3lQPHXQHKaOMwFm7JrQzCIacQO5DFYx3kHK6lkyqWGAsVZSoOCZwNfdF5orAUZumDTOj4pLAwerPf41IFYqEwM5bP525t7Vj+QV9dnK20wAAAA==",
    Pbi3DGeometry:
      "NSUAAB+LCAAAAAAABADtWE1r20AQ/S86K2K/P5xTSAuF9hDaQg/BB4eIROBaxVULIfi/dyutHUm7T7J8DEtIHHk0b2bezO7Ozv1rdvdQfX/5VWar7HP9UH2rt9Vjlmd3dbVrfmer+9fuXycm1+4nO+Rv31xRQq7bP+43O6yPajf7/ebF6TJecKpkfsVIoa2lOWOFZdzkTiAo405AC8IJ7wtOGtYSfZaAaWVbgbHCRjXGxiUxUSTolBc4JGllDGmhhRBoTjBBVGBbaB3lAzkFg1CK9gS8oFoOBR1SX6B7vvKCGEJnkGTfV5dMKuWFJkbBGcHf3j/yGr5/CvrM90N8GBpydKkBw4fpFEJPRSC09aWkGWsFSqlWgVOP5BLeft9RC/MPCwkBST5S4EZOx4CQUHbmajuIARjA601qOcwP9wJIK0oo5X0FJyBq0sLiUgUGoGEUAfYIJhTnLZ5ozDekFWQUKyA6ltYYeh/hz5JkDR0iwSpGewYTthNQ3doklKmpTQOeGvBgMrJvwQm0YZMC6JOvpl4U/Nz9JCAKnViQD4iEiILhQaSJXMxscgEUqhxMITYOKgcxiHy6gJC5A+rs4sRFiPjgUnsoogfbCjfHbtGoFoIS0X7CNhI3WpZ749S0XxBB5YXGoQa0wWm/uXUCx27bKM12vUHKcXOmvG3S2qTMTJKOFGAQy5EggcgE7BchFLSNGIdIQlgz0HA9rJiGgpcc7K3soKzo3KRW+kUGOmjoFV5MMH/wNEFeYUpgZifyhG4CwDheGrP5iFyBlD/zLQ/XRtgxeQ7/K9ABhcKMCek+529A44vFiSlDuIoyFbmvxaNATZnfp5zAsNheGIQHCZxfTeMosFOIWpgLZAKHh+sg3ppP9PJxyrFp6CwIG1pAKVpcNjhFqJhxEKgMMFSaHKXJUZocDYHS5ChNjuKnTZocpclRmhylyVGaHKXJUZocxQhMk6M0OUqTozQ5CneXNDl6N5OjdZ59qDY/y6bcZytSkDz7Uu6emmf/8LVuNk1V7/zjj+rxJPpUVk/PjX/4uC3/9l+8rbe1A9z92W4P63/KBvITNSUAAA==",
    Angle: "89.44°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "48",
    "Center Spacing": "47",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-266",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "41",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1463",
    "Maximum Size": "80",
    "Minimum Size": "80",
    "Nominal Diameter": "80",
    "Nominal Radius": "40",
    Offset: "60",
    "Overall Size": "80 mmø-80 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "41",
    Size: "80 mmø-80 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "33",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "543273",
    Name: "M_Water Closet - Flush Valve - Wall Mounted: Public - 6.1 Lpf",
    Category: "Plumbing Fixtures",
    temperature: "21.28898032",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jU8LgjAchr/L77zG/ujm7BQVBHUQCTqIB6uhg7WFrUDE795EvL08PA9vNUJxN9fhrSGHs7+bUj9C41qrAUHhjQsfyKtxmVFhHFOlthuusBCUw1Sv2q7vmyG6ERxM89JB95ATTBBctGtDBznFQkqKoPShCca7maSSSCU4E1IlmRICwc08F5mRjCM4adN28ZlhpliC4Gj1b60ZztI52Xvr45n7WjvVf3C1yFPSAAAA",
    Pbi3DGeometry:
      "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",
    Area: "1",
    "Calculated Heating Load": "100",
    "Cold Water Diameter": "25",
    "Cold Water Radius": "13",
    CWFU: "10",
    "Default Elevation": "430",
    "Design Option": "-1",
    "Elevation from Level": "430",
    Family: "Public - 6.1 Lpf",
    "Family and Type": "Public - 6.1 Lpf",
    "Flow Pressure": "172369",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "31",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Material": "<By Category>",
    "Sanitary Diameter": "100",
    "Sanitary Radius": "50",
    "Schedule Level": "Level 2",
    "Seat Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "Public - 6.1 Lpf",
    "Type Id": "Public - 6.1 Lpf",
    "Type Image": "<None>",
    Volume: "0.02",
    "Water Closet Material": "<By Category>",
    WFU: "4",
  },
  {
    ID: "543313",
    Name: "M_Water Closet - Flush Valve - Wall Mounted: Public - 6.1 Lpf",
    Category: "Plumbing Fixtures",
    temperature: "19.86672131",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld15DN93cOkUFQR1Egg7iYdXQwdrCViDif28i3l4enoe3HqG8m+vw1iDh7O+m0o+gXGs1ICi9ceEDsh6XGRVCcSrEdkNzXBAKU7Nau75XQ1QjOBj10kH3IBOcILho14YOZIoZ5ymCygcVjHczyXnCBaOEcZEVgjEEN/NcZJIUFMFJm7aLxwQTQTIER6t/a01wkc/J3lsfz9zX2qn5A+EjcozRAAAA",
    Pbi3DGeometry:
      "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",
    Area: "1",
    "Calculated Heating Load": "100",
    "Cold Water Diameter": "25",
    "Cold Water Radius": "13",
    CWFU: "10",
    "Default Elevation": "430",
    "Design Option": "-1",
    "Elevation from Level": "430",
    Family: "Public - 6.1 Lpf",
    "Family and Type": "Public - 6.1 Lpf",
    "Flow Pressure": "172369",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "32",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Material": "<By Category>",
    "Sanitary Diameter": "100",
    "Sanitary Radius": "50",
    "Schedule Level": "Level 2",
    "Seat Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "Public - 6.1 Lpf",
    "Type Id": "Public - 6.1 Lpf",
    "Type Image": "<None>",
    Volume: "0.02",
    "Water Closet Material": "<By Category>",
    WFU: "4",
  },
  {
    ID: "543319",
    Name: "M_Urinal - Wall Hung: 20 mm Flush Valve",
    Category: "Plumbing Fixtures",
    temperature: "22.64119796",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld15jbrq5dYoKgjqIBB3Eg9bQwdrCViDif29R3l4enpenmqBozXl8aFBw9K0p9TU0rrMaEBTeuPAEVU2/GRXKcCLlesUYThkRMNeLthmGZoxuBDvT3HXQAyiCCYKTdl3oQSU4zXmOoPShCca7L8kEEZIzyoVMc8k5gou5/WUpEBy06foYpjgRSYZgb/V7OTNMhUSw9dbHlHtZO9cfcYKc4tAAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "1",
    "Calculated Heating Load": "100",
    "Cold Water Diameter": "20",
    "Cold Water Radius": "10",
    CWFU: "5",
    "Default Elevation": "430",
    "Design Option": "-1",
    "Elevation from Level": "430",
    Family: "20 mm Flush Valve",
    "Family and Type": "20 mm Flush Valve",
    "Faucet Material": "<By Category>",
    "Flow Pressure": "103421",
    "Half Urinal Width": "225",
    Height1: "365",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "33",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Sanitary Diameter": "50",
    "Sanitary Radius": "25",
    "Schedule Level": "Level 2",
    "System Classification": "Sanitary,Domestic Cold Water",
    "System Name": "Sanitary 1,Domestic Cold Water 1",
    "System Type": "Undefined",
    Type: "20 mm Flush Valve",
    "Type Id": "20 mm Flush Valve",
    "Type Image": "<None>",
    "Urinal Height": "660",
    "Urinal Length": "445",
    "Urinal Material": "<By Category>",
    "Urinal Width": "450",
    Volume: "0.02",
    WFU: "4",
  },
  {
    ID: "543332",
    Name: "M_Water Closet - Flush Valve - Wall Mounted: Public - 6.1 Lpf",
    Category: "Plumbing Fixtures",
    temperature: "20.63500997",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld15Dv+nm7BQVBHUQCTqIB6uhg7WFrUDE/95EvL08PA9vNUJx19fhrSCHs7vrUj18Y1ujgEDhtPUfyKtxmUFBpGmCcrthknIeM5jq1dv1fTMEOYCDbl7Kqx7yiEYELsq2voM8plyImEDpfOO1szNJRSQkZ8iFTDLJOYGbfi4yRhkjcFK67cI1UpSYEDga9VtrpFk6J3tnXDizX2Om+g+rJWWd0wAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "1",
    "Calculated Heating Load": "100",
    "Cold Water Diameter": "25",
    "Cold Water Radius": "13",
    CWFU: "10",
    "Default Elevation": "430",
    "Design Option": "-1",
    "Elevation from Level": "430",
    Family: "Public - 6.1 Lpf",
    "Family and Type": "Public - 6.1 Lpf",
    "Flow Pressure": "172369",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "34",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Material": "<By Category>",
    "Sanitary Diameter": "100",
    "Sanitary Radius": "50",
    "Schedule Level": "Level 2",
    "Seat Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "Public - 6.1 Lpf",
    "Type Id": "Public - 6.1 Lpf",
    "Type Image": "<None>",
    Volume: "0.02",
    "Water Closet Material": "<By Category>",
    WFU: "4",
  },
  {
    ID: "543372",
    Name: "M_Water Closet - Flush Valve - Wall Mounted: Public - 6.1 Lpf",
    Category: "Plumbing Fixtures",
    temperature: "20.46011116",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld15Dv+nm7BQVBHUQCTqIB6uhg7WFrUDE/95EvL08PA9vNUJx19fhrSCHs7vrUj18Y1ujgEDhtPUfyKtxmUFBpGmCcrthKc2QwVSv2q7vmyG4ARx081Je9ZBHNCJwUbb1HeQx5ULEBErnG6+dnUkqIiE5Qy5kkknOCdz0c5ExyhiBk9JtF56RosSEwNGo31ojzdI52Tvjwpn9GjPVf5ZnBkDSAAAA",
    Pbi3DGeometry:
      "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",
    Area: "1",
    "Calculated Heating Load": "100",
    "Cold Water Diameter": "25",
    "Cold Water Radius": "13",
    CWFU: "10",
    "Default Elevation": "430",
    "Design Option": "-1",
    "Elevation from Level": "430",
    Family: "Public - 6.1 Lpf",
    "Family and Type": "Public - 6.1 Lpf",
    "Flow Pressure": "172369",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "35",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Material": "<By Category>",
    "Sanitary Diameter": "100",
    "Sanitary Radius": "50",
    "Schedule Level": "Level 2",
    "Seat Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "Public - 6.1 Lpf",
    "Type Id": "Public - 6.1 Lpf",
    "Type Image": "<None>",
    Volume: "0.02",
    "Water Closet Material": "<By Category>",
    WFU: "4",
  },
  {
    ID: "543378",
    Name: "M_Water Closet - Flush Valve - Wall Mounted: Public - 6.1 Lpf",
    Category: "Plumbing Fixtures",
    temperature: "19.43598264",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld15jfurm7BQVBHUQCTqIB62hg7WFrUDE/95CvL08PA9vNUHR6uv4UpDD2bW6VHff2M4oIFA4bf0b8mpaZlAQKc8w3m7iiHLJUpjr1dsNQzMGOYCDbp7KqwFyRhmBi7Kd7yEPiRARgdL5xmtn/yQVTEgeIxcyySTnBG76scjIspjASemuD9dIUWJC4GjUd62RZqkIbO+MC2f2Y8xc/wD02S+R0wAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "1",
    "Calculated Heating Load": "100",
    "Cold Water Diameter": "25",
    "Cold Water Radius": "13",
    CWFU: "10",
    "Default Elevation": "430",
    "Design Option": "-1",
    "Elevation from Level": "430",
    Family: "Public - 6.1 Lpf",
    "Family and Type": "Public - 6.1 Lpf",
    "Flow Pressure": "172369",
    Host: "<not associated>",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "36",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Material": "<By Category>",
    "Sanitary Diameter": "100",
    "Sanitary Radius": "50",
    "Schedule Level": "Level 2",
    "Seat Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "Public - 6.1 Lpf",
    "Type Id": "Public - 6.1 Lpf",
    "Type Image": "<None>",
    Volume: "0.02",
    "Water Closet Material": "<By Category>",
    WFU: "4",
  },
  {
    ID: "543393",
    Name: "M_Lavatory - Wall Mounted: 485 mmx355 mm - Public",
    Category: "Plumbing Fixtures",
    temperature: "21.96113296",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNt3m7BQVBHUQCTqIB6uhg7WFrUDE794svL334/d41QjF1ZyHp4Ycjv5qSn0LjWutBgSFNy68IK/Gf4wKSzBVar1iEjPCU5jqRdv0fTNEN4KdaR466B5yggmCk3Zt6CCnmCvKEJQ+NMF49yOSSCUSJqRKMyUEgou5zzLBHMFBm7YLc5EkSxDsrf4s0xRnhFMEW299fHJva6f6C9p31TvPAAAA",
    Pbi3DGeometry:
      "OiIAAB+LCAAAAAAABAC9WEtr20AQ/i86K0KP1a7knEpbKLSH0BZ6CD44xCQC1yquWwjB/73C1srS7n47s3JqQkI0o5lvXruamfvX6O6h+f7yax0tos/tQ/Ot3TSPURzdtc12/zta3L+e/u3Y6W33Ex3iM+UmS9Pb45/uNzostdi73W710snmIilkoeKbXCVVIUSciaRKyyzuGFmtso5RJWmanelFosoiPwrkhVQMBtYk6/r0vlT1+H1gkgehl5BJqWTJYIxUZUrkDmNlItK6YknQGCAgbIxzqDKR13QIiw6hdkZciNqZO/Q+yBDMaKh+/T7bXyRwArAjiuiEIhgJ0yC3fk+KSyVGtV0mhTOkI3qRqQABBGA4RpKRlhNd17pljfbX1G/T3YowHelx2u+xBzpwijNk2AkwrikLWyVKSqZEWJJnQeiAdJVfOiTYKfWEilYFwGFwQ/KEMNyXFT5AYQfFeV/gGxJcL17l/EPlvwUBKnVpciqCyZh9b3ogYKVwGQxwbn/BL2ySwQeHEsHXCUFndGhS9R1PmRdHelWVR7oUJ4FcVETHoCXM1gPRZyMjAQRgdQxaYHAhLYWTYXU3PXRWVnJC17ZmMq94mkijLAkSY3CDbNKg4xADOW52V5ZNZnWgRpP2AmYJY5iquF5Q3vEPBXVaVC6zqU2aURRimgo4ahj1b1kLvJsBjSQghDVIaYiBYSQVD6kaezj2mqGtHZJBqqKtMiVoDKPUGOCm5xADeY5uWlghcEpluIHyBDEsVWw3KPf4J4M6MoBh9aQjxrSLtSR0Y0+qmnGQsbVuo3xfGQAxHbIYCG6BSz4MpqmESaNWxp8JzrnHxTyR8GC4ixZa6zFqOsgz+it3ZD3QSBNCRrmGlkKLiLNiT8fUjEgyOOCwoIghH5pLMhhJ8icjZCPBZFxaB2gzhFZSFH325QRXDuE7rHBkovoc9UqssUgG44tDt6donUt+m7mKuHtwRquCGqtQH0iTqJs6/JsW/iViDLFkM8u2ij1ZQMeDZ/fQmf6/LxnCZ+c3nOivuGbg7z7gVI2qY7YXeAXAHasDVJEBCRyrodvhKxFUnLhfDZ7cg0f6K2wZwkfnNxzor7pmYC8/0FANv1UXuIFWAOFTNa2KikjoPY/9Dt+JuOpzGUcfmtXP9X69ixZpksbRl/X2af/cP3xt96t90277xx/N48D6tG6envf9w8fN+u/4xfftpu0Ubv9sNoflPxbGpAU6IgAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Cold Water Diameter": "15",
    "Cold Water Radius": "8",
    "Connector Height 1": "100",
    "Connector Width 1": "143",
    "Connector Width 2": "343",
    "Cross Length 1": "21",
    "Cross Length 2": "284",
    CWFU: "1.5",
    "Default Elevation": "865",
    "Design Option": "-1",
    "Elevation from Level": "865",
    Family: "485 mmx355 mm - Public",
    "Family and Type": "485 mmx355 mm - Public",
    "Faucet Length": "87",
    "Faucet Material": "<By Category>",
    "Flow Pressure": "55158",
    "Half Lavatory Width": "243",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    "Hot Water Diameter": "15",
    "Hot Water Radius": "8",
    HWFU: "1.5",
    Image: "<None>",
    "Lavatory Length": "355",
    "Lavatory Width": "485",
    Mark: "37",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Sanitary Connector Height": "29",
    "Sanitary Connector Width": "193",
    "Sanitary Diameter": "32",
    "Sanitary Radius": "16",
    "Schedule Level": "Level 2",
    "Sink Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Domestic Hot Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Domestic Hot Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "485 mmx355 mm - Public",
    "Type Id": "485 mmx355 mm - Public",
    "Type Image": "<None>",
    Volume: "0.02",
    WFU: "1",
  },
  {
    ID: "543403",
    Name: "M_Lavatory - Wall Mounted: 485 mmx355 mm - Public",
    Category: "Plumbing Fixtures",
    temperature: "22.58055731",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv15jc9M5u4oKgroQCboQL6x+dLC2sBWI+O5p4d05H9/hlAPkV3PunwgZHP3VFHgLtWssAoHcGxdekJXDP05KJCjXer2KJJVCcBirRdt0Xd1P7gR2pn5gwA4yRhmBE7omtJBxGmseESh8qIPx7kcUUzoRUaK0THWSELiY+ywzGhM4oGnaMBfFUkFgb/GzTCVNWcwJbL3105N7WztWXy0Ob4DPAAAA",
    Pbi3DGeometry:
      "OyIAAB+LCAAAAAAABAC9WN9r2zAQ/l/87Brbki27fRrbYLA9lG2wh5KHlJrWkMUj8wal5H+fiS3HlvXpTm4XSkujy913v3S6u7uX4Pa+/v78qwqug8/Nff2t2dUPQRjcNvW+/R1c3730/3bk+Kb7CY7h+eQqieOb05/uNzhuNNu7w2H73PGmMhK5UOFVmkVxniZhIqMizpKwIySlSk6ENC3UmSAilYm0I8hI5lIyCA5ReVn2DGWWTxmAUg6IgUN0BzJlEKai4qS0aNtpJ1TG4mBg2D3Cxji7Sqg4p10oOoTS7nIpS2v0IAOIEQ6qN8LIwLUZMfQIS6+ic0IQdoapkR3AEedMyUmCZ5Gwe3VCEIny4UAQpm30OZLTn+ukXyikbTYBlud2QfgcybEb4FAIWtD7GhKWQTAK1gJbRmUpmRyegV6FoT1SKKsd7KA6fEWLAuDQuz6BQhigajmuke91sZcOR71EtcYNwL9e7qKIcKkiykkNJmF1GXVAwJThEhjg3J6Dn+EkgQ8OOfwLC0lgNG65Gtqa4nRaFNnpNJeqP1ZZ4e4hNIfZjaDzlbj2ryPhi/ZBM4wEIRI7wWx1BmBR5GJ2rjUVZZzxJNFKmRw0hjaD7Nig4RADGW52WgudzMxAbSfDChgliGGK4lpBWce/ENRNUWmezHXSBCHkPBRw9jDyf6EtsG4FNOKAEIvJSkOMBCOoeGzV2HLm8VHXMRSkIFonk4PGMBKNAW7aDTHsdqMKC7MDjqwMI2CMIIYpimkEZRz/TlCXBRAWPemEMO9iFxy6sSdFrbjCWFu7Uq73BUDMpywGgp3hVU+CoSqh0qR9cUeCdedhfsw4HBj2pIXaOpSaj/KMrsruWQc0koSQUayhplAj4q4sp2NqRiQJHHCYUMSUD9UlCYwguYPhs5JgEl6bB2g3hJZS1Pnq4gRXDv5bLH9kIvss+UrssUgC48VhNKZgq0u+zVxB3JU44y2HTZWnDaRKVKX2f9P8XyLGpEg2snytuDMFNNxzZveb5P/zWsF/Xn7DKf6SqwX2vgNO0igv1lsBx37uKO0hinSI5ygNzfZfg6DkxJ2q97TuPcZfYLPgPzC/4Rh/wdUCe92BRmn4Rq02Ao79/rM0KYryh2+FR1b7b0FsmbkJgw/19mfVVofgOo7iMPhS7R/bp+HD16bdtnWzHz7+qB9G0qeqfnxqhw8fd9Xf6RffN7umE7j/s9sdN/8Am6QFOjsiAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Cold Water Diameter": "15",
    "Cold Water Radius": "8",
    "Connector Height 1": "100",
    "Connector Width 1": "143",
    "Connector Width 2": "343",
    "Cross Length 1": "21",
    "Cross Length 2": "284",
    CWFU: "1.5",
    "Default Elevation": "865",
    "Design Option": "-1",
    "Elevation from Level": "865",
    Family: "485 mmx355 mm - Public",
    "Family and Type": "485 mmx355 mm - Public",
    "Faucet Length": "87",
    "Faucet Material": "<By Category>",
    "Flow Pressure": "55158",
    "Half Lavatory Width": "243",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    "Hot Water Diameter": "15",
    "Hot Water Radius": "8",
    HWFU: "1.5",
    Image: "<None>",
    "Lavatory Length": "355",
    "Lavatory Width": "485",
    Mark: "38",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Sanitary Connector Height": "29",
    "Sanitary Connector Width": "193",
    "Sanitary Diameter": "32",
    "Sanitary Radius": "16",
    "Schedule Level": "Level 2",
    "Sink Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Domestic Hot Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Domestic Hot Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "485 mmx355 mm - Public",
    "Type Id": "485 mmx355 mm - Public",
    "Type Image": "<None>",
    Volume: "0.02",
    WFU: "1",
  },
  {
    ID: "543504",
    Name: "M_Lavatory - Wall Mounted: 485 mmx355 mm - Public",
    Category: "Plumbing Fixtures",
    temperature: "19.19669552",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GnPtwdhUVBHUhEnQhXlgNHawtbAUi/vdm4d05D8/hVCMUV3MenhpyOPqrKfUtNK61GhAU3rjwgrwa/zEqlGLOqFqvqMSUcAZTvXibvm+GKEewM81DB91DTjBBcNKuDR3kCeYqoQhKH5pgvPsRSaQSKRVSsUwJgeBi7rNMMEdw0KbtwlwkyVIEe6s/y5ThjPAEwdZbH5/c29qp/gKSYf4P0AAAAA==",
    Pbi3DGeometry:
      "cCIAAB+LCAAAAAAABAC9WFFr2zAQ/i9+do0sy7acPo1tMNgeyjbYQ8lDSk1ryOKReYNS8t/nJnbiSPp0Jy+E0jb2l7vvTneS7u7+Nbp7aL6//KqjRfS5fWi+tevmMYqju7bZdL+jxf3r4WMPi9v+J9rFpzc3qRC3+z/9b7RbjmLvttvVSy8r0yQrtYxvZJHkZZHHqUq0yNO4B3Kl9B5QotJToNK67IEySUslWQBQJROhZHWQePswkYBWQY5Bokx0phQLOKqSWVE6zNWJEClLgKYAK8KlmKyULMqKsYSyp9gDjkWvXDb5BFCUcFyDKapQt4HAwGAsLH5P6PEshmmRmwGFWibpm/wpxfMkc6/qCShSIUMkIIflHgOAqgZgTH7LqsFxi8J6DxR5AKQJOIFNgj4MSw4BOxbGyeUIUqEUTyI03nM4BokyKYtCOSS4YfUsFaUJcsPFDYgT5IDXG9xM4XsGHCKegxMeOxQHe5cRByRkJk5UOj947+eep1g/zBkuQFNzaw9+hpMAnxxKzDlXCIAk7+/PohqKiVwXe0DrfA+UZXYACukvJkYBqyyBwHxuKAE5zIJiFBjfi1w535uVz8gsc5mdAaOtUumUpYmyyPw+STC6QBVvyGVIAH22ii7DJCs3QAFKugCig/RbevgekK6x9wO1T/rcPbdpBET//ywOsAsxs94yFroXSO6TcHO4uqy9xNSPs7DCvmxCftzvIzCae4yGXxXHKouc5DhPNw65ldBuDp/n7mMWZomnT6b9gIHCHOYO5PvhdzBof/g3jgcw6tMTYFS0lsRY4zNUhW5nj7nAKs8lg04Mo+ViUACJ/7gdTGMpmybVDBUMxpmEUsSUAByenQnNBRxWd88pspxrC7k9miA3DDi2FhhF7Rm7Yab6RhJgkMMw0Y0/MJcEGHGiwhEwp+ACF8gFODWCAysSmH9WwXnEnCFXODmViXbuUmMuEiDJGSU5Gv3S9zVXE3N2zrngccEV7AZtFXV6h91z4ZcT3UPSNS7XJH7LgZwO7+XDm/xrjB5Cu+qLtfnXmzxwZyGo24a5Md8FMBhgN9tcPdRShHfa0OfQGYk7I317NLyXD2zyrzF6CG+nL9jkX3n0wByI+PpseATO9wOPBcL7bFKVf0lmnfFuz8MnJSBFl3H0oVn9rLt6Gy1EIuLoS7156p6Hh69tt+qadjM8/mgej9Cnunl67oaHj+v67/SL79t12yvc/Fmvd8t/VLFLonAiAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Cold Water Diameter": "15",
    "Cold Water Radius": "8",
    "Connector Height 1": "100",
    "Connector Width 1": "143",
    "Connector Width 2": "343",
    "Cross Length 1": "21",
    "Cross Length 2": "284",
    CWFU: "1.5",
    "Default Elevation": "865",
    "Design Option": "-1",
    "Elevation from Level": "865",
    Family: "485 mmx355 mm - Public",
    "Family and Type": "485 mmx355 mm - Public",
    "Faucet Length": "87",
    "Faucet Material": "<By Category>",
    "Flow Pressure": "55158",
    "Half Lavatory Width": "243",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    "Hot Water Diameter": "15",
    "Hot Water Radius": "8",
    HWFU: "1.5",
    Image: "<None>",
    "Lavatory Length": "355",
    "Lavatory Width": "485",
    Mark: "39",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Sanitary Connector Height": "29",
    "Sanitary Connector Width": "193",
    "Sanitary Diameter": "32",
    "Sanitary Radius": "16",
    "Schedule Level": "Level 2",
    "Sink Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Domestic Hot Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Domestic Hot Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "485 mmx355 mm - Public",
    "Type Id": "485 mmx355 mm - Public",
    "Type Image": "<None>",
    Volume: "0.02",
    WFU: "1",
  },
  {
    ID: "543513",
    Name: "M_Lavatory - Wall Mounted: 485 mmx355 mm - Public",
    Category: "Plumbing Fixtures",
    temperature: "20.44634043",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNufm7BQVBHUQCTqIB6uhg7WFrUDE794svL334/d41QjF1ZyHp4Ycjv5qSn0LjWutBgSFNy68IK/Gf4wKYzjlTK1XjGOeJBSmevE2fd8MUY5gZ5qHDrqHnGCC4KRdGzrIKU4VZQhKH5pgvPsRSaQSCRNS8UwJgeBi7rNMcIrgoE3bhblIkiUI9lZ/linHGUkpgq23Pj65t7VT/QVlGES00AAAAA==",
    Pbi3DGeometry:
      "byIAAB+LCAAAAAAABAC9WE1v2zAM/S8+u4Y/5K/2NGwDBmyHYhuwQ5FDihqtgSweMm9AUeS/T3CtxJH1RNLNgqJN42fykSIlkbx7CW7v2+/Pv5rgOvjc3bffuk37EITBbddu+9/B9d3L678ajm/0T7APj0+ukji+Gf7o32C/MmLvdrv1s5ZNkygrqzS8SrOoilUaJkp/5kmogVypagCKrMynQF1VpQZUpOKkZgFAVRppynqQyMq4mEpAqyDHKJFHcZEmLOCoqlDKYW4epal+gyPB4HAvCZtjslaqzgvGIqaaYwAcy167jPIJoDjhyIopaqnbQGBksFfWAxCaPMth2wQoYLjTKCnKepLoeZS5V/YIFEmcSiQgx8xBBgBVjYDZATOrjOczjjkAVHkAqAr44bEK+jEuOwTm8bDOMEegqvJUFZSQxnwJxyihorpWLgl2aD1rRamC5HB1BYGCHPCmgztKvnHAWeI5QeHpQ3EIthp1VkJy8nRlZAkXWH68ejhg+nABBjm3JOFnOwnwyaHEkkOGAEhyfaUW9VhhVEU2AFWVD0BZZq9AHfsrDCMwq1UgsJwbSkAOu8YwAuZ5liXO53Y5ZJj1Ak8fG0tVmVcsPZQ99vskgXGAqueQw5AAeDyrwWyD7LwAFSnpAIoM0m/r4dpPOsbeCdQOSfJqapF5HOvPkwjAlsTO9pmp0DkRNX7frd/Vbw0SU+AknLBDm1Af9rgBjLGHOPhVsayyyWmOkzRjkduJ7Obwee4+WmGGeDpmhh8wUJDD3nl8P/wOivaGf9N4AKs+PQJWRTuTMEU+Q5V0K3vMBVZ5rhZ0Wlg9F4MCSLzlVrCMpWyaVDBUMBi7H6aIJQE4PDsTmgs4Zi0+p7Byri3k9miC3DDg2FpgFLVn5h0z1TeSAIMchonu/IG5JMCIExUOwaCCC5whF+DgCE6tSGD5WQXnEUvmXHJyKhPnuUvNuUiAJGcUrGgGTN/XXE3MITrrgocFl9gN2irq9Jbdc/LLidE5kjUu2yR2u4Gclvfv8sb+EuMGaS99tub+UtMG7vQD9dgwM5Y6gIYB3Babq4daCHmHDTyWTkXcuejbndIeXtTa//9hg7yFPmNjf+lxA28I4uut4bH3Bj/gKEDeW5Oq/Euy6Fx3ey6fjoAUXYXBh3b9s+mbXXAdR3EYfGm2j/3T+OVr16/7ttuOX3+0DwfoU9M+PvXjl4+b5u/0xffdptMKt382m/3qH1tvSodvIgAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Cold Water Diameter": "15",
    "Cold Water Radius": "8",
    "Connector Height 1": "100",
    "Connector Width 1": "143",
    "Connector Width 2": "343",
    "Cross Length 1": "21",
    "Cross Length 2": "284",
    CWFU: "1.5",
    "Default Elevation": "865",
    "Design Option": "-1",
    "Elevation from Level": "865",
    Family: "485 mmx355 mm - Public",
    "Family and Type": "485 mmx355 mm - Public",
    "Faucet Length": "87",
    "Faucet Material": "<By Category>",
    "Flow Pressure": "55158",
    "Half Lavatory Width": "243",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    "Hot Water Diameter": "15",
    "Hot Water Radius": "8",
    HWFU: "1.5",
    Image: "<None>",
    "Lavatory Length": "355",
    "Lavatory Width": "485",
    Mark: "40",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Sanitary Connector Height": "29",
    "Sanitary Connector Width": "193",
    "Sanitary Diameter": "32",
    "Sanitary Radius": "16",
    "Schedule Level": "Level 2",
    "Sink Material": "<By Category>",
    "System Classification": "Domestic Cold Water,Domestic Hot Water,Sanitary",
    "System Name": "Domestic Cold Water 1,Domestic Hot Water 1,Sanitary 1",
    "System Type": "Undefined",
    Type: "485 mmx355 mm - Public",
    "Type Id": "485 mmx355 mm - Public",
    "Type Image": "<None>",
    Volume: "0.02",
    WFU: "1",
  },
  {
    ID: "545524",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.37343437",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzGkiU1DPYkKgh6KCB5KDxVDuxATqVEopf9upLWgJ/e0s2+YnbyD7IzH9qYhhZ07Y+ZMWzkLBDKH1t8hzbthDQbOqVRcLGYiokryOfTkCyqW/AHjSMlfOMUOsPi8XzZN2YYO4bDG8qq9biBllBHYa1v5ehQH50uPofYgT3iZ0FZjVfu3EGEIbIx+jt5IUCbjhMDKGRdy7cOYvngBHIUwPxMBAAA=",
    Pbi3DGeometry:
      "7QgAAB+LCAAAAAAABACdVk1rwzAM/S8+u8Efdb56GttgsB3KNtih9NBS0xqyeGTZoJT89zlb2pUkquwSEuI86z3JsuQsDmS+Nq/7D01y8mjX5sUWZkMomVtT1p8kXxz+Xh3MZu4iDf3/MuGMzX4f7ibN8mh2U1WrvbMVIopTIelE8kglIqZcRlIxQc+BlKWyBTifqlEgwEIlvAWEFFM/KtCrOGOqBVisEj9x0ALUUEKmo+6iawW6K7MsTAINI2XJuPYAOFKdgH4YHlS9BOIaIADGAXrVXyvcAtTopQMPPFyin0A8DHRxh9sNrKdwKl8AWkNoq6Pz0X2LKYNJQqsvmMgbALMNVr6HBahxdcUMussV7oJUvgBYS3jPQ3s62PP8+1H4gRJO5Q2AzcKj9LHD92Lvdv8Od2b1rmtdkZxFjJInXW7rXTd4tvWqNrbshm9mc4IetNnu6m5wX+jv84m3trCOsPwqimb5A8tbyQztCAAA",
    Area: "0",
    "Bottom Elevation": "182",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3984",
    Length: "38",
    "Loop Boundary": "No",
    Mark: "646",
    Material: "Copper",
    "Middle Elevation": "233",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "233",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "284",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545537",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.21750507",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xjSVFsSV6KCoIsigovSRYshHYgZqVEopXc30OoN3P0v5ptygKLBS/8woOFIDRbkekseGBSEPjxBl8Mk40CmPFNqvZA5l2K1hJH9oau+6E3X1X3kx2CH9d0E04EWXDA4GW9DO5szhTpgfHmyV7z9qoNB20ZIykWeMdg7856nScJzqRIGW3IUz/qXc2P1AZzK89cOAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVl1rgzAU/S95TiWJRqt9GmthsD2UbbCH0gdLQxtwZrhsUIr/fWF1ba1ec4eIYjzec+5H7tXVkSw3+vXwoUhGHs1Gv5hCbwklS6NL+0my1fF062A2cwep6eXJhDM2+724k9TrP7O7qsoPzlaEQRwLQSciCUQkQsqjYMokpw5IQpkOAzyexjgLyfkJYDJCUYFexWkjIROJ0j4zdSSipNcnWBpigqNonOUyxEn48+HR5kEi0r6EXIAb8R6LDlW7fAgNWLxVPoRTMNAqX4/BbRTtYiDChpkgwE/VSRSyM0ANjAWo4a0rNofQRkcSjWklyCOw7UEAx4QBoK3pmzjDRGNmmq9ZwFnXAXBMGAAaBcCERxKN+IZAHvm/hMMKYwYm3KPeyfH/WXMdhvtXmOv8XVlVkYwFjJInVe7svlk8G5tbbcpm+aa3Z+hB6d3eNotFob6vX7w3hXGE5VdR1OsfGvORGt0IAAA=",
    Area: "0",
    "Bottom Elevation": "-225",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "-225",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3575",
    Length: "938",
    "Loop Boundary": "No",
    Mark: "650",
    Material: "Copper",
    "Middle Elevation": "713",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "16",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "713",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "713",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545541",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.41149991",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xjyKErrSlQQdFFEcFG6aDG0AzEjMQqh9O4GWr2Bu//FfFMNULZ4iQ8DBRypxZJs7MgBg5LQhScU1TDJNFCaL/N8vVAZz7SWMLI/dPUXvfG+iYmfgh02dxOMh0JwweBkXBf62ZwpNAHTy5O94u1XHQx2fYJoLoVSDPbWvOetlHwlVM5gS5bSXfeydqw/pOecGQ8BAAA=",
    Pbi3DGeometry:
      "oQgAAB+LCAAAAAAABACllUtrwzAMx7+Lz2nwI++exjYYbIeyDXYoPaTUtIYsHpk3KCXffWbNmuWhWG0pLbEk//SvHMnLA1ms1ev+Q5KMPOq1etGF2hCPLLQqzSfJlofjo3XTuf2Q2mstM0bp/PfHfkm9+tt2U1X53u7lwo8izr0ZD/wg9ljgJzRknjXHIkynzCKNBCY+ZOxoFoKhQICeKG3wScgReU+UAd7GjemB0kIcWH8jVCQYvrsMjsTMjylPB5VozZ3EI9EDTPfEnHwobee8nHIgc+e0RsL76jvVR/xbGAQ53KhefZAdAGbA7ABzOA8TWUDgrcZhrugaQA3Y3aADBcI4oDfSNVemQddMLlePABOtZ8ZQ3Gao64HpjcJcfDdAalx32xT90nkId6JzPpw7T1r59r6/U/m7NLIiGfWpR55kuTW7ZvGsTW6ULpvlm9qcXA9SbXemWdwX8vt/4K0utAWWX0VRr34Arw03F6EIAAA=",
    Area: "0",
    "Bottom Elevation": "-233",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "-233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3567",
    Length: "946",
    "Loop Boundary": "No",
    Mark: "652",
    Material: "Copper",
    "Middle Elevation": "713",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "19",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "713",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "713",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545543",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.2555544",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0a9BaT6KCoIcigofSQ4shXYiJ1CiU0n830ir15Gl39g07k7WQlnRqbgoS2LuSUmca7SwwSB1Zf4cka/s1GBC5wBkuJzjnYcbQsRGccoxR/odCxuIXjt72MP/Er+q6aEKHcNhQcVVe1ZBEPGJwUFb7ahBH5wtPoXYvz3T5op0iXfm3EJFEBlujnoNXiJArFwzWzrjw1z6M6fIXG8NPZBMBAAA=",
    Pbi3DGeometry:
      "4wgAAB+LCAAAAAAABACdVk1rg0AQ/S973sjuuH7EnEpbKLSH0BZ6CDkYIsmCdYu1hRD877XGtgqZ+gzB4Pp8M29nZmdcHcVyY58Pb5lIxL3b2CeX262QYulsUb2LZHU83TawWjQ/Ucu/JzOt1KL9ay5Rr39oV2WZHhoukacpJDmjyNNhHEqtPW0UyT5Ahvx/AdJ+DDKCKGiBKMIs8aJUYFqAzBzzrQPfXOQbB/iAdGqJ5hrcH6uqvw3fo5jMGcIZ4OSiBwx9Q6b66UNc8MAgfYioYdARtWykBsmALHG+JyeDz/dIaEdqDWJwLiDXbADZMoc0saYwBqIKPMdIhfCFAFUIcIx5sZwhiIAo4kqTP5Ije5jQcdhujvUJZDCADEjV2ETE+90FrZOboVBznjCMvwnNF8ONTV+zKitFojwlxUNW7Kp9t3h0VVpZV3TLF7v9he4yu9tX3eI2zz77L1673DUGi488r9dfUjnXruMIAAA=",
    Area: "0",
    "Bottom Elevation": "-409",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3393",
    Length: "352",
    "Loop Boundary": "No",
    Mark: "654",
    Material: "Copper",
    "Middle Elevation": "-393",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "22",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-393",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-377",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545546",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.56538684",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5CmqZ+6EhUEXRQRXJQuWgzpg5gnNQqh9O4GWr2Bu/kxM2UPRYOX8NCQw5EaLMgGQw4YFITOPyEv+xHGgJRcKLlaz+SCS5EpGNh/zOo7v+m6OsQPUdhhfdded5ALLhictDO+nciZfO0x3h7pFW8/66DRtHEl5ZlSSwZ7q99TNkm4nIuUwZYsxV73snaoPnjfSN0TAQAA",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABAClVt9LwzAQ/l/y3IUk/d09iQqCPgwVfBh76FjYArWRGoUx+r8bbacN7S03R2lpvut9312ud+3yQBZr9bx/k6Qg93qtnnSlNiQgC61q806K5aG7tWY2twdpgz9kxhmb/1zsSdrV0e2qacq99RWCMpYEM5FSEYkw4BHNWMyDbzzN09MGnmQJziOPO5zFEY4JiikSeWeI0xgn3TO5CpzmOcumY4KkJ4lO5XCMlcchTsG3Gx5pTkXCwondGBgc6QmHEZNTOYwCaHBLh4hpEh9VbuwwysEtBCZriAnCfUSj3HANASpgPCAJX0Xx2we+4Eiqi5oIjApqFgjHEflw8L1EjBoP07+HGaJXoCnn4mgiBA6OAXC045gu+XiAMXk/gR6NiwYm1Ki+2XH2sBkmYf8QblT5Ko1sSMEoC8iDrLdm1y8etSmN0nW/fFGbX9OdVNud6Re3lfwcPnitK20J64+qaldfQacEB9MIAAA=",
    Area: "0",
    "Bottom Elevation": "-368",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "-368",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3432",
    Length: "1080",
    "Loop Boundary": "No",
    Mark: "655",
    Material: "Copper",
    "Middle Elevation": "713",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "22",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "713",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "713",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545547",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.79192301",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUELwiAcxb/L/2yizum2TlFBUIcxgg5jByvZBNNYFoyx754Vg27v9/g9Xj1CeTbH4a6hgL0/m0pfgnKt1YCg9MaFBxT1+ItRYQwTzvLlgknMSMphamZv1fdqiHIsNkbddNA9FAQTBAft2tB9gKYiQVD5oILxDgqKU0lkLhImZM6zXAgEJ3P9l3fatF34Mk8zBFurX/OaYhpLBGtvfTxzT2un5g2veS5X0wAAAA==",
    Pbi3DGeometry:
      "qR8AAB+LCAAAAAAABADtV01r20AQ/S86K2ZntV9yTqUtFNpDaAs9BB8cIhKBaxVXLYTg/15ZX/au9Fbr5roY25LHM2/mzcyO5v41uXsov7/8KpJ18rl6KL9Vu/IxSZO7qtzXv5P1/Wt32YjZbfNKjun5lxti7Lb9aN7JcTOovTscti+NLqdVnhud3nC94iJXKdGKK5alnK+Y4HkroNPFKLjQIEU8TGCY6DCYFLMaE3CjacYU9OpCIzCOCwFX+kpTE41FrmCAroBOFE258lBCXHHLFGXcWIJBYyro3SWtwywNThEJ+TaIMQrefFsQPbfIp2AFjAB5QnRcjTDkLsulPwgiaWsIqfz1cbWp5YoKLk5PywhpU2UM9wrekG+XXBj4silH4GEExddzOzY+GR3WrW7xQEuLJ97kjITYqBIwhcvcolKHzeF0GYo7wJDLIIwbdpki02lIylqfVC/Ish5Dq+7Ak1q0AlKDRt8BjM97NZwuEOOsITl1GCJvNbSw3SUhMq9XAPw0f/LcNmVOGiEjeVJVnBnL3VGAChdRhSsaWYLQy9yi8eNwjtMHK2EZG81Ed4pen3Cg4Us4zOs8BjTl65rFVnZaH+Z1vnR8UaDSgb7C6sR8IGzoLW6ypSxNBtBAFZfG2C2gh5HMu6caZYx/VmdyxOjqU+VOfXItWwHP5gfp2BxwLEJw5O4ZQ5ouUTJTgRqWV5BEX0UvU+JGDmlHpgLisJ+EAh6d0NO4m0B4wEDWoVMwbiiAlQuZwsfhrMb/JDaAEYtDX2tCjPnI4849u0DEnTvu3HHnjjt33Lnjzh137rhzz1ZC3Lnjzh137rhzx53bL4g792XkmzT5UG5/FnVxSNZsxdLkS7F/qp/7m69Vva3Lat/f/igfR9Gnonx6rvubj7vi7+Uf31e7qjG4/7PbHTf/AE/2pn6pHwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1494",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545550",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.24282968",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk29A/T6KCoIcigofSQ8XQBmIiNQql9N2Ntko9edvZb5iZvIPspA7tVUIKW3tSmdVtZQ0QyKwy7gZp3g2nNyBSjiHOZyioSFgEPZnAgGKM4j8MovCXTVLfrPiUL5qmbP0C/1ip8iKdbCBllBHYSVO5ehR760qn/OhBHtX5izZSVbV7Cc4EElhr+Ri9nFOWxDGBpdXW55q71n3xBBPI/04RAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABACdVk1rg0AQ/S97NrIfGldzKm2h0B5CW+gh5GDIkixYt1hbCMH/3k1qWy2Z+AyiuDO+mbczszMu9my+ss+7N8Mydu9W9skVds0CNne2rN9Ztth/v3o1n/mLNcGfZCI4nx0f/mbN8gd2VVX5zmOlDIWcymAio1Cl0zgQIhQiCrryKOHyrFwnCQbQcXSUx1xjlkhKSqmDnKeasPQPoLRQF7qGFXQ8WraSyxTbHkmqtw0VSi2jE4hTioOLjrznGjLUSx7ggZT3cgdQ6gcc4UqHqZcJyBTlfHwqyGwPRvZ8pUEI0gfmnIwhWeYQK9IUhkBYgecYKRK6FrAiQQ4yTZc0hSEgVkSFkidzcBdo1yH7OdQskMmAASBOQ/MQbXijOyc5P6HePGoSi8j/K9zY/NXUpmIZD3nAHky5qbft4tHVeW1d2S5f7PpXdWfsZlu3i9vCfHY/vHaF8wbLj6Joll9xsN2R3QgAAA==",
    Area: "0",
    "Bottom Elevation": "-417",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "-401",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3385",
    Length: "352",
    "Loop Boundary": "No",
    Mark: "657",
    Material: "Copper",
    "Middle Elevation": "-401",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "24",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-401",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-385",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545553",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.28313182",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5AmEWldiQqCLooILkoXLYb2QcyTGIVQencDrd7A3fyYmWqAssVLfBgo4EgtlmRjRw4YlIQuPKGohgmmgJRcaJmvF1JzrZSCkf3HrL/zG++bmD4kYYfN3QTjoRBcMDgZ14V+JmcKTcB0e6JXvP2sg8GuTyuKL1ciZ7C35j1ns4xLpSWDLVlKve5l7Vh/ANEGWtoTAQAA",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABAClVlFrgzAQ/i95tpLEWI19GttgsD2UbbCH0gdLQxtwZjg3KMX/vmzazaDXXCeimO+877vLeaerI1lu9PPhTZGM3JuNfjKF3pKALI0u63eSrY7trTXThT1IE/whM0bp4udiT9KsT25XVZUfrC/nIaXzYMZFKBLKAybClMYs+MYTmZw3RHIe4zxk3OJRFOGYoJgEl60hjQVOumNyFVgoJU3HY4KkR4nO5XCKNUoZTsG3Gx5pFvJI8JHd6Bkc6RGHAZNTOYwCaHBLh4hpFB9UbugwyMEtBCZriAnCfUSD3HANASpgPCAJX0Xx2we+4EiqSU0ERgU1C4TjiHw4+F4iRo2H6d/DDNEr0JRzcTQRAgfHADjacUxTPh5gTN5PoEdj0sCEGtU3Oy4eNv0k7B/Cjc5fVa0qktGQBuRBlbt63y0eTZ3X2pTd8kVvf013Su/2dbe4LdRn/8FrUxhLWH4URbP+AnFpMuHTCAAA",
    Area: "0",
    "Bottom Elevation": "-376",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "-376",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "3424",
    Length: "1088",
    "Loop Boundary": "No",
    Mark: "658",
    Material: "Copper",
    "Middle Elevation": "713",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "24",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "713",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "713",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545554",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.14140006",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzVELwiAUBeD/cp9NnDqn6ykqCOphjKCHsYdVsgmmsSwYY/89Kwa93XP4DrcaoTib43DXkMPen02pL6FxrdWAoPDGhQfk1fg7I6EUE07VckE55owxmOrZrfq+GSKOxcY0Nx10DznBBMFBuzZ0n5CkgiEofWiC8Q7yBKcZyZRgVGSKSyUEgpO5/uOdNm0XvpmnEsHW6te8TjCRMpq1tz4+c09rp/oNWNQgPtMAAAA=",
    Pbi3DGeometry:
      "fx8AAB+LCAAAAAAABADtV01r20AQ/S86K2Y/tbvOqbSFQnsIbaGH4INDRCJwreKqhRD83ytbK1sr6e2u41NhCYmjHc/Xmzc7mvvX7O6h+v7yq8yW2ef6ofpWb6rHLM/u6mrb/M6W96/dv62Y3LY/2T4/n9xQQm6Pf9rfbL/q1d7tduuXVpfRhTFa5TdMLIRSMqd0wbhgOWMLIpg5Crgi+iwYaHBtWJxAE9H54JzPakyca0VnTMGoBhqReQwEwsgLTU00gljBBMcCSuQcVh5IKCuYY4qSonAEvcZUYMOlsv2MMtVHRbTmV/o4aRjpurDg4qBiFaAHCBTE42IXffUo594kKJUjBSP8BLnUUphR0eT0tIyQLlCF9/yKYo+BhWkHLbnnHjRAbhbWE2kMcw3BRh2RBhoK3nWT2xG6RhzA8IVxRRRHPTHuLpR32NAIP5g1bK6CauvaWuJWwLlNjgjRCegxOUILq6EtCZT/joUuBhrHY9ZOiMP3lXBjpVQzb0jA9WHoGOOaKg4aMXN4QihG9CDY0zFiLEAJMxkZAn7DoOJpM0Qblw0SIKKeYAKOZ+blpQYavlLDis77gKZ8zRLs33HDg6rOssaXA2INjBTxEoOBXKNYcWuFKjSZNz1KQhfKZb/qpy/pJpdgbntNxjKXJx+00+Au/4WUx8SJUf53JDgFoW8U7dmFLroqMSUjNZygIIY+MocRGScOUUemIvIYvfWEX5PQa/e4fvBugajjoGDiUACZC6HCV+GsxlsqGwGJA6KvNaGP+czTej27K6T1Oq3XV7pI63Xc3EjrdVqv03qd1uu0Xqf1Oq3X/iUlrddpvU7r9X+zXq/y7EO1/lk25S5bkgXJsy/l9ql5tg9f62bdVPXWPv6oHk+iT2X19NzYh4+b8u/wi+/rTd0a3P7ZbParf3tA9ot/HwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-401",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1496",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545820",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.12162027",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI0p9IPYkKgh6KCB5KDy2GdiEmUqNQSt/dYGsvPXjb2W+YmbyHrMJL91CQwtFWmFnd1dYAgcyicU9I8348vSEQCQ3jdRByKnksYSBLJhhlK8kXLGKC/6NzbvGr37Rt2fkN/rHD8q6caiH1GQROytSumcTZutKhnz3KK95mdFBYN+4rIi4J7LV6T17BKY9YQmBrtfW55qX1UHwAD7JORRMBAAA=",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABACdVt9rgzAQ/l/ynEqiNVr7NLbBYHso22APpQ+WShtwZrhsUIr/+zK1/kBPc0UU45f78l0ud+f2QjZ7+X7+SkhEntVevqlUHgglGyUz/U2i7aV6NTBbm4sUtP2y4Iyty4e5SbG7mt3leXw2tgtXON6KhXThcSfgfkBd7vBAcDqOLEVQIYJ7AALblLQ9hAk0W6tNrPqI4Eu06oZtoC10vTkFMBvsj++7tqot2GYUuMxhYcBHdtQOsWCrpnSRa0wR67TIf0y7SH93RrXByEBbE9OBP41NGZ9RBfAewGwIxCIK8NmZWcfuhFisg9gdiyjAOTfDBtsgcxvWhqiJFp7ecnoncmG68sFsyLozYTOdp8i+gMh6ixoCVyS4/8ywwTbIPgdrQ9R4C08RtarfmUajgKg7Fn1uzB/zX/Ig489EJzmJDB0lL0l21Kd68Kp0rKXK6uGHPDTQUyKPJ10PHtPktzvxXqXKEGY/aVrs/gAcMgm3SQkAAA==",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "3544",
    "Loop Boundary": "No",
    Mark: "665",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "7",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545821",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.13075813",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI0l/rSVQQ9FBE8FB6aDG0gZiVGoVS+u4GW3vpwdvOfsPM5D1klbp0DwkpHLFSGequRgMEMlTGPiHN+/F0Bk9E1A/XHl/RJIwTGMiSJVT4frxAARP8D5xTi1/5pm3Lzi1wj50q79LKFlJGGYGTNLVtJnFGW1rlRo/yqm4zOkhVN/YrAh4T2Gv5nryCUx6wiMAWNbpc89J6KD6HDCiJEQEAAA==",
    Pbi3DGeometry:
      "HwkAAB+LCAAAAAAABACVVl1rgzAU/S95jpJojR99KttgsD2UbbCH0gdLpQ04M1w2KMX/vsxaP7pckyCK8eSenHuTnLg5o/WOv50+C5ShJ7Hjr6Lke4TRWvBKfqFsc768Kpgs1YUaPHzxKCHL9qFu1GyvYau6zk8q1guYH6YkwR5N/SSKExxQn8aMYj2yYPEFYTQEEDimpZ0ghDmzDdpYOkUYXTir7tn+aUuC0KQAZoPziaLAVrUFm0FB4gdhGGsKagOYqdoeY+A6ndZjDMDfZI6AaVV0qkDgVlU/kbd59BHtnOgGBzMHqawBc9nhlTI/iNVysBjFuirmysOba54LDnHcw6AyB+szp+m+VuFlP29uIJejs8zEzG5IR+O33t1mowA9Bz5c5rngEMczDFTmYN/mNK0taXri6IpvbzAWp5cuFfW3cc/zj0IWNcqITzB6LqqDPHaNFyFzyUXVNd/5voceC344yq7xUBY/4453ohSKsPouy2b7C5BMOBMfCQAA",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "3543",
    "Loop Boundary": "No",
    Mark: "666",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "8",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545822",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.78652348",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsELgjAYxf+X7zyHc1OHnaKCoA4SQQfxoDTmYG1hKxDxf2+ohZ26fe/7Pd57RQ95rc7dXUAGB1ur3OpOWgMIcquMe0BW9NPpDQGlOCKUrwKOCU9jGNACRglmjLP/kMb0Fy5jR1h+6tdtW3V+g39sVXUTTrSQhThEcBRGumYWJ+sqp/zsSV7U9Yv2QsnGjYKRFMFOi9fsjQgmLEwQbKy2Ptc8tR7KNxY3BTITAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVtFqgzAU/Zc8R0lisGKfxlYobA9lG+yh9MHS0AacGS4blOK/L1q7VczVa4dUm56ce05MctL1iay2+vX4oUhKHs1Wv5hc7wglK6ML+0nS9en81cFs7i5S0b9fAs7YvLm5D6k2F9pdWWZHxw2iKBQ8SmiQhHwWcyr4+dkBYi4bQLKYehkyniGBRIgGqEvixEddJSJC2q3deEvVPb2uLozeOEAAdAWKg3ZHSzXiIg6lTGT/tV8DHQ0fo3GFAjoz+D/xzgBR4uDIOzPoY4ClegDoChaHALAUOOejb3d4f6AYoAZOHBwguHZRrsBSOAbKFRwANy8G/LqCQwa1difl1TAD5woVfZP24PSNA2ZiL0tGAxk8DYYZKFe4c3BSIOOzHTxScUk96XR2DPcf4kFn78qqkqQsZJQ8qWJvD23j2djMalO0zTe9+4WWSu8Ptm0scvV93fHe5MYVLL7yvNr8APhS75D1CAAA",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "2062",
    "Loop Boundary": "No",
    Mark: "667",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545826",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.49428686",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1js0KwjAQhN9lz2lIfynxJCoIeggieCg9tBjShZiVGoVS+u5GWn0Db/PNDLtTjaBaPA93DRIO1KIiOxhywEAROv8AWY2zDIUoTXlS5OUqKnlcxBlM7D9h/X2/7vtmCBuCscXmpr3uQQouGBy1M75b4ES+8Rhmz3jB6y/aazSd/0AhspjBzurX0k0Ez0WeMNiQpXDXPa2d6jcTNPOfEwEAAA==",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACtVtFqgzAU/Zc8R0nUWGefxjYYbA9lG+yh9MHS0AacGS4blOK/L1jddMnFKx2iGE/OOTe5yY3rE1lt1cvxXZKcPOitetal2hFKVlpV5oPk69P51cJsaS/S0N8vAWds2T7sTZpNT7uu6+JouUEch1GWLmiQhTzlCY1YKJiIaAukImuBLIrGQMbSFlik/A8ASfWMxHbweiS2wzzAjWr2OECPRPiVoO+gkODcP+4ecKYQDBbyHiWDh5xdxR6lITCaKB+jHcaIMUwfSmrSw4kKNB8OHEUALUbZuMh7KibQ2skSbsuAycAxQA8wfZDU5KQ7WwAn9Y/FAsw4amPipFAAZvGAMc0mzK1f4OpElSmUEgqYLAhOJcRJXVZt4eIJnn0QgJPCAahyizodcIwzYP8bblXxJo2sSc5CRsmjrPbm0DWetCmM0lXXfFW7H+heqv3BdI27Un4NO97oUlvB6rMsm803zH2OAukIAAA=",
    Area: "0",
    "Bottom Elevation": "2450",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2634",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6250",
    Length: "184",
    "Loop Boundary": "No",
    Mark: "669",
    Material: "Copper",
    "Middle Elevation": "2450",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2450",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2634",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545828",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.61062523",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjkELgjAYhv/Ld55jc9OZnaKCoA4SQQfxoDR0sLawFYj43xtpYbdu3/s9Ly9P3kNWqVN3k5DC3lYqs7qrrQEEmVXG3SHN+/H0hYAxHFKWLANGcUIWEQxoRsMYc/4XFZHgv3S+PNLio7Bq27LzHv6xUeVVOtlCSjBBcJCmds0UjtaVTnn1MZ7V5Yt2UtWNewdOBYKtls+pG1JMOYkRrK22ftc8tB6KF0qD6uQXAQAA",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABACdVlFrgzAQ/i95jpKYEJ19KttgsD2UbbCH0gdLQxtwZrhsUIr/fcHqVpnXnCKK8fO7+7y73Lk+kdXWvB4/NMnJo92aF1uaHaFkZU3lPkm+Pp1vPcwW/iAN/XsSccYW7cWfpNn0tGVdF0fPjYSIEy4yGgkepypLacJjLlVKh8hNlgSQVHEsJ2NStIjiEm0N1pYJeUaYQqvurY34SRSgDVYAW4O/p1edJQLtJxydFklULOUoZxRp/QyQgQKctWFOkX5gZJBTpLYryGVORzn/ozPIDzKisLU5+QHrABHrQCXiOLAfrAI4ovBeQH4PbA3JQWq70ilm1M6cCrnSkXB1PbG/BThYbcFuOWefTtn18FxAdhfklEFykNrCk3ZKt5zRe+HpjO3xE2e95/j/kjtTvGuna5KzmFHypKu9O3SLZ+sKZ2zVLd/M7hd60GZ/cN3ivtTfly/e2tJ6g9VXWTabH1vWAjVJCQAA",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "2063",
    "Loop Boundary": "No",
    Mark: "671",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "1",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545831",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.01077963",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABAC1jsEKgkAURf/lrcdhdNTEVlJBUAuJoIW4UBrGB9O8sCkQ8d+b0PqDdu+8e7mcaoSyxfNwV5DDgVosyQyaLDAoCa17QF6N8+kLgZQ8SpNsHciQrzIZw8T+ltZfhaLvm8F7+McWm5tyqodccMHgqKx23QInco1Drz7jBa+/aK9Qd+4DqYhDBjujXks3EjwRScRgQ4b8rn0aM9VvI0mdRxcBAAA=",
    Pbi3DGeometry:
      "QQkAAB+LCAAAAAAABACtVtFqgzAU/Zc8R0mMxtQ+jW0w2B7KNthD6UNLpQ04M1w2KMV/X6i2U/QmWR2iGI/33JOb3KPLI1ps5OvhI0cZelQb+aIKuUUYLZQs9SfKlsfm1sBkbg5U498nASVkfrqYE9Wrc9hNVa0PJjZgLIx4InDAaJjyiOOIhAlJInxCBOENMhMRgHCResfwtEEEi33ZYG1nRJCY+SpIKAXyxAkg7RLyBzJYGjwdOA/MBivoF5SGlMzYWHG6SF/baMyQrbekfnncCpqZ+mnr162L9JZ0NGQwHTgNLA1mc+exsA3L5tk98MJ5xsB53It9RUUtruNg+y8HsWyqAZu76V1sfgi4ed1GZeeaaIfupoJ9coB4kvkhbvOwGKiDbapRw9o8vrCOPFNN19LVbse5xqU68zH/I3dy/Z7rvEIZCQlGT3m50/t28Kz0WktVtsM3ub1AD7nc7XU7uC/y7+6Lt6pQhrD8Kop69QP+W/vEQQkAAA==",
    Area: "0",
    "Bottom Elevation": "2450",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2634",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6250",
    Length: "184",
    "Loop Boundary": "No",
    Mark: "672",
    Material: "Copper",
    "Middle Elevation": "2450",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "1",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2450",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2634",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545832",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.93007819",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNzV8LgjAUBfDvcp/ncE73x56igqAeRIIexAetoYO1ha1AxO/esILe7jn8DreaoGj1abwryOHgWl2qi29sZxQgKJy2/gF5NX3OQCJKccIysYoowVzQFOb6B9fD0IxBh2Krm5vyaoA8xjGCo7Kd75cgqUBQOt947SzkBGc85pLRhHGZCskYgrO+/uO90l3vlywoRbAz6vVdJwSTgBBsnHHhmX0aM9dvVuzM/NQAAAA=",
    Pbi3DGeometry:
      "3x0AAB+LCAAAAAAABADtV01r20AQ/S97ls1+78o5lSZQSA+hLfQQfHCISASqVRwlEIL/e4WtVSutn3alaxdjY/l5Zt68mf2Y+w9y91D+eP9dkA25rR/K73VVPpKM3NXlvnkhm/uP89cWplftixyzv7+sGKVXp4/2TY5bZ/bpcNi9t7YrIdbcmjxbCbY2momMszWjuchOiFb2hFgmzRBxNpYqFYvkhp3jWCEv2/gMpDDAG+bmEKM4n+sN22B1fJuwbjhTHxFSA91wPkyMGGgmR4izEWObngFGrFDAm49ABjjOBDengaB8hLgq4DhzuLk4OTexmS6Kg7X28sH9pqgeIlLzUFdxq4aZcsli+21O92JuM/pNhFljBrh3sLcl3CIy9WrqbPoO8So3sba9VYK94R0Jx8EI7hCsaITWcG3j/cBfWViDCG8egjXA+RjGz0gu7ZmbNsPd/9L5ozpEqy4fFkJm7PH9jmRVPmStOmfhw3nOUW9cDWh0nhF18/LE3mCeuDgyH7WhYTZ0KIRt/BJgG8xtoqC4BrgNkTh4l8DVgaXGnDGzJe2BbSC1iWZH0uCLW5+N4ZeL5t8LHGWjqby82n0kfMvwTxfjDiQ9ShOHwYcYRvDFBBKAomGdF5QGpwmJhS+AfgHwio4oJ7wS+Dov6MEJBWAFkM4RG6QnDYyCnaVxNI2jM6/gaRxN42gkksbRNI5Gap3G0TSOpnE0jaNpHE3jaBpH/79xdJuR63L3q2iKA9nQNc3I12L/1Dx3D9/qZteU9b57/Fk+9tCXonx6brqHm6p4+/ePn+uqbh3uX6vquP0DL8d7Id8dAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1542",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545835",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.55019773",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjssKwjAQRf9l1mlI2vTpSlQQdFFEcFG6aDG0AzGRGoUi/XeDrVJ37ubOuVxO8YS8xmN/lZDBztSYG9U3RgOB3KC2N8iK53i6gsdTGgaJWHgBp3EYCxjIjPoRDdhfNGFp+EvnyyMtPwrLrqt65+Eea6wu0soOMkYZgb3UjW2ncDC2sujUx3jC8xdtJTatfQfBYwIbJR9T1+eUCxYRWBll3K6+KzWULzwQfTkXAQAA",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABACdVlFrgzAQ/i95jpIYF619GttgsD2UbbCH0gdLQxtwZrhsUIr/fcHq1lBPTxHF+Pndfd5d7lyfyGqr346fimTkyWz1qyn0jlCyMrq0XyRbn863DmZLd5Ca/j8JOGPL5uJOUm862m1V5UfHDfgivBFpTAPBw2SRRjTiIY9lQn1EpskIkkiO50SyQSSP0dZgbamIzwiTaAWdtSs/KYsFoA1WAFob+J5OdRoJtJ/x6DRIJEPBejm9SOPHQzwFWGuXOUX6gREvp0htIOLntJdz/T1efpAxgK3Nyc9AHYzGeqQSsRzYD04BHFF4LyC1wdaQHKQ2eG/PqZ0ZFQJ3JGxdT+xvIxycNkS3nLNPp/QqeC4guwtyyiA5SG3jk3ZKt5zTewemM67HT5z1juP+S+51/qGsqkjGQkbJsyr39tAuXozNrTZlu3zXuz/oUen9wbaLh0L9XL54ZwrjDJbfRVFvfgHawiyiSQkAAA==",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "2063",
    "Loop Boundary": "No",
    Mark: "674",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545838",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.37187544",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABAC1jsEKgkAURf/lrcdhRkczW0UFQS0kghbiQmnQB9O8sCkQ8d+b0PqDdu+8e7mcYoC8xnN/15DBgWrMyfQNWWCQE1r3gKwYptMXArnkKk2iVRBJvkgjBSP7W1p+FdZdV/Xewz+2WN200x1kggsGR20b185wIlc59OoTXvD6i/Yam9Z9IBFKMtgZ/Zq7oeCxiEMGGzLkd+3TmLF8A8X87qEXAQAA",
    Pbi3DGeometry:
      "LwkAAB+LCAAAAAAABAClVl1rgzAU/S95jpL4ET/6NLbBYHso22APpQ+WhjbgzHDZoBT/+7LOrn5dvVREMR7vOTf3mhNXR7LcqNfDhyQpedQb9aJztSWULLUqzCdJV8e/WwuzhT1IRS9PHM7Y4nSxJ6nW57CbsswONtbhiRtEXFDH526UxB71mBuy0KO/SMj4BCDiCBsR1UjsBzguOK8gFv4JiVng4/QvZD0ZEYbDmY0kALLBsznnHAlPIGUQpRnX5y5niT9QmQbQkR8K6XO1molRgeXbvUQlNoK0mzkY051NpzOYAoyQgQiCrF803KIBVXARsMhkm/G1hL9/LNnMVQZnBlsDjGDZcAj81SLMaYJtrgkiVhRsjz0Ey4ZDYO8Adwg028ydCM5teledUJnlt2OLetJtrjCoxlzs38edyt6lkSVJmcsoeZLFzuzrwbM2mVG6qIdvavsPPUi125t6cJ/L7+aLtzrXlrD4yvNq/QP3EgWnLwkAAA==",
    Area: "0",
    "Bottom Elevation": "2450",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2634",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6250",
    Length: "184",
    "Loop Boundary": "No",
    Mark: "675",
    Material: "Copper",
    "Middle Elevation": "2450",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2450",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2634",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545839",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.69185006",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNzc0KwjAQBOB32XMamqbmp55EBUEPpQgeSg9RQxuIidQolNJ3N1QFbzvDN2w9Qnk2x+GuoYC9P5tKX4JyrdWAoPTGhQcU9fg5I0mIxLlgdJlQgrmgOUzND676Xg1Rx2Jj1E0H3UOR4hTBQbs2dHOQVCCofFDBeAcFwQuecsloxrjMhWQMwclc//FOm7YLcxaUItha/fquM4JJRAjW3vr4zD2tnZo3G5mFe9QAAAA=",
    Pbi3DGeometry:
      "1x0AAB+LCAAAAAAABADtV01r4zAQ/S86O0HfUtJT2V1Y2D2UttBDySGlpjV44yXrXSgl/31Narm15SfLPhYREuK8zOjNm5E0c/9Krh6K25ffOdmSH9VDcVOVxSPJyFVVHOo/ZHv/+va1gelF8yKn7P2XFaP04vzRvMlp58wuj8f9S2O7Ypu11JJnK8HWliqVcbZmdCOyM2K1OCNGcd5HnI3RTMQiSrE3xAo5buMxUNRK4A1zc4hl0sz1hm2wOp5NhG44Uh9hRo/rhuNRwiGOgWZygDgbMbTpGGDECgW8+QhkgNfB3DoNBOUDby4LeJ0Z3Lp1NtzERrpknYDWw3hCNcp0H5GaT1UVF6YfKZcstt7mVC/mNqPexDRrzADXDva2hFtEpF6NOpuuQrzMBfa2t0ugN3wiBdbBCK4QrOi01nhvB84Db2dhRSO8+YpCDWA80rbXnGmZaTN1M1rdctZUttGwCWTOCe/OI6k173NWLPZqnnPRG7eM0jIy0Ji0DQMNyAYDBblRlIu+gWF26kaIsPHuCmgDmQWyiesJVSCUBR8P8EiBWQ5QRsQW1EUg+7j+AnWOpAl0x62vjbTjKfMago6zpVqNb3QPiWgv/FbBKWAZ9ZpWtE6giUBIoAUOMACyBZRekhyoNGQW0fz5OQhs6OmMwnbAV3p+GYaKDaYACB1x1o0UO9ofWLM0iqZRdGb7nUbRNIrGImkUTaNoGkXTKLpw5EijaBpFwZGWRtE0iqZR9HOMoruMfC32v/I6P5ItXdOM/MwPT/Vz+3Bd1fu6qA7t413x2EHf8+LpuW4fvpX5v49//FKVVePw8LcsT7v/aEmwWtcdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1544",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545842",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.20196325",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjkELgjAYhv/Ld55j06XOTlFBUAeJoIN4UBw6WFvYCkT87w21yFu37/2el5cn6yEt5aW7C0jgaEqZGtXVRgOC1EhtH5Bk/XS6ghcE2KdBvPYox5zHKxjQD/VDzDiJ/qEsZEu6WB5p/lHYtG3ROQ/32MniJqxoISGYIDgJXdtmDmdjCyud+hSvsvqig5B1Y8fAaIRgr8Rr7voUU0ZCBFujjNvVT6WG/A1dfGqfFwEAAA==",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABACdVlFrgzAQ/i95jpKoS9Q+lW0w2B7KNthD6UNLQxtwZrhsUIr/fcHqVplnThHF+Pndfd5d7lyfyWqnX08fiuTk0ez0iyn0nlCyMrq0nyRfny+3DmYLd5Ca/j0JOGOL5uJOUm862rKqtifHDeI4jHic0oBnYXYjJY14yBMhaR9JZeRBpOBoThbHDSJ4grYGa5NRckGYQCvorA344QLQBiuArcHf06lOoxjtxx+dBolEmGRMDnAGkcZPD+kpQFrr5RTpB0Z6OUVqG0GuczrI+f89vfwgYwBbm5MfuA78sfZUIpID+0EqgCMK7wWkNtgakoPUNtIpZtTOnAoZ6Ui4up7Y3zwcrDZvt5yzT6fsenguILsLcsogOUht/kk7pVvO6b3wdEb2+Imz3nHcf8md3r4rqyqSs5BR8qTKgz22i2djt1absl2+6f0v9KD04WjbxX2hvq9fvDWFcQbLr6KoNz9dl+QYSQkAAA==",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "2049",
    "Loop Boundary": "No",
    Mark: "677",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "3",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545845",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.52729579",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABAC1jssKwjAQRf9l1mlI04e2rkQFQRdFBBelixZDOxAzUqMQSv/dSKt/4G7O3MvllAMUDZ7dXUEOB2qwIO1aMsCgIDT2AXk5TKcvBFHEZZosV0GY8WwhYxjZ39Lqq7Du+9p5D//YYn1TVvWQCy4YHJVpbTfDiWxt0atPeMHrL9orbDv7gVTEIYOdVq+5KwVPRCIZbEiT3zVPrcfqDbfZFosXAQAA",
    Pbi3DGeometry:
      "QQkAAB+LCAAAAAAABACtVl1rgzAU/S95Vkm08atPYxsMtoeyDfZQ+mBpaAPODJcNSvG/L6hzit7mtg5RjMd77slN7tH1iay28vX4IUhKHtVWvqhc7ohDVkoW+pOk61Nza2C6NAepnL8nLqN0WV/MSarNb9hNWWZHE+sGgeeHPHZclngJZ6HjU49T7js1EtOwQeLIBxAeReiYMGqQyF9g2WBtHZIEAVYBZwzIs+CAtC7kAjJYGjwdOA/MBisYFpR5jCbBVHH6yFDbZMyYbbCkuDwIBfVMcdqGdesjgyWdDBlNB04DS4PZEHlgtnHZkN0DLxwyBs5jX+xrKgq7joXt3xwE3lQjNkTTW9hwCLh57UZ1nmumHdqbCvbJEYIkwyEI84AN1MI216hhbYgvrCXPXNM909V2x7nGpXrzMf8jdzJ7F1qUJKUedciTKPb60A6elc60VEU7fJO7DnoQcn/Q7eA+F9/9F29Vrgxh8ZXn1eYHiFhU8kEJAAA=",
    Area: "0",
    "Bottom Elevation": "2450",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2634",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6250",
    Length: "184",
    "Loop Boundary": "No",
    Mark: "678",
    Material: "Copper",
    "Middle Elevation": "2450",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "3",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2450",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2634",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545846",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.72458236",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNzV8LgjAUBfDvcp/ncE73x56igqAeRIIexAetoYO1ha1AxO/esILe7jn8DreaoGj1abwryOHgWl2qi29sZxQgKJy2/gF5NX3OQCJKccIysYqIxJInKcz1D66HoRmDDsVWNzfl1QB5jGMER2U73y9BUoGgdL7x2lnICc54zCWjCeMyFZIxBGd9/cd7pbveL1lQimBn1Ou7TggmASHYOOPCM/s0Zq7fFkWCfNQAAAA=",
    Pbi3DGeometry:
      "3x0AAB+LCAAAAAAABADtV01r20AQ/S97ls1+arXOqaSFQnsIbaGH4INDRCJQrOIqgRD837tVJFXy7pNWunYxNpafZ+bNm9mPuX0jN3fFj9dfOdmRL9Vd8b0qi3uSkJuqONa/ye727f2rhemVfZFz8u+XDaP0qvmwb3Led2YfTqfDq7XdCLHlmTbJhpmtUVQknG0ZNSJpkFRlyYbTLaVCj5HexkgVihjN3hHNJbBxGEgb2O8Nc2uQvzaS8UXepm386nhtAnTDmTqIkCnQDefDxAWDlMkBMrQRI5shA4xkQgFvY2SaAY6DuXUaCMovkK4KOM4Sbl0cw3VQpmvjYA2cfHC/KZqOEZnyua7imRpnyiUL7rcF3Yu5Leg3Mc8aM8C9g72t4RaQqVPTxmbYIW7l/Gvbu0qwN7wj4TgYwR2CFQ3QGq9t/37gXVlYg4DdxUGwBjgfbYvcIJl123BL9dzZmKrWm1GqzYfNIQv2+H5HypQZs1Ys+HBecNTrtj8s6dA8Z+rmzRN7g3ni4khz0YaaZXOHQoCNUwJsg7lNFBTXALchEgfvErg6sNSYM2a2pj2wDaQ20exIGnxx67NJGSiacy/oKUsjwWp3kIA7mHO6dAJIdZEmDoMPMYzgiwkkAEXDOq8oDU4TEgu4ADoFwCs6oJz+K4FX5xU9OKEArADSOWCzc6SBUbCzOI7GcXThFTyOo3EcDUTiOBrH0UCt4zgax9E4jsZxNI6jcRyN4+j/N47uE/KxODzldX4iO7vUE/I1Pz7Uj+3Dt6o+1EV1bB9/Fvc99DkvHh7r9uFTmb8M/3hdlZV1eHwuy/P+D3KArCzfHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1546",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545849",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.82868644",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjsEKgkAYhN/lP2+La+umdooKgjpIBB3Eg9KiC9v+YVsg4ru3qUXeus3MNwyTtpAU6tTcJMSwx0IlqJsSDRBIUBl7hzhtB+kKMxbRYB7y5VtEXHDoyA/1BfUF+4tGYTClk+WeZp8Lq7rOG/fDBRuVX6WVNcQe9QgcpCltNZoj2twqd32wZ3X5op1UZWV7w9mCwFbL59j1GWXcEwTWqNHtmofWXfYC5MZTtRcBAAA=",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABACdVlFrgzAQ/i95TiWJNlH7NLbBYHso22APpQ8tlTbgzHDZoBT/+zKrW0N7zSmiJH5+d19ylzsXBzJf69f9R0Fy8mjW+sWUekMomRtd2U+SLw7HoYPZzF2kof9vJpyxWftwN2mWPe2mrld7x53wLJrGaUJ/B1mqBBU84olU1EemSgUQJTmew2WLSJ6grcHalEiOCJNoBb21cz9ZHAPaYAWwNXg9vepUxGg/4d1pESEj0cv3OReR1o+HeAqw1k5jivQDI15MkdpgxIvpRc75erz4IPcAtjYmPlfyILjXgUzEcmA/OAXwjsJnAakNtobkILXBZ3tM7ozJELgiIfN6YH0LcJDawtVyzDkdcurhvoCsLsgug+QgtYU77ZBqOab2XunOuBo/sNc7jvsvudOr98IWNclZxCh5Kqqt3XWTZ2NXVpuqm77pzR/0UOjtznaT+7L4Pv3w1pTGGay+yrJZ/gCDxWLYSQkAAA==",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "2049",
    "Loop Boundary": "No",
    Mark: "680",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545852",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.14727762",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNLfVMLMyMrUEMS3MjE6VaHZrJxsKc4FhUlFgJdAdQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOh3CDc9MgUt5pGamZ5SAOGYGJoY6Sq45qWVQtUYGeqYGpkY6Ss75OflAc/NKc3JqYwFRbGVtFwEAAA==",
    Pbi3DGeometry:
      "LwkAAB+LCAAAAAAABAClVt9rgzAQ/l/ybCVRY6p9GttgsD2UbbCH0gdLQxtwZrhsUIr/+7LWtf46c0xESfy877vc5S6ujmS5Ua+HD0lS8qg36kXnaks8stSqMJ8kXR3PQwvThb1I5V3fzBili9PD3qRa/5ndlGV2sLYzlviRYLH3O0jmIvAC6nPKg9MLTpkD4EJgLUSNiCDCccF+RfM4PCNJGOL0r2Q9mZjzYc9GHADZ4NVcfObWFieDCM24PvMZTcKByDSAjvyQSZ+rlUyMCizfziXKsRGkncxBm+5qOpnBBGCEDEQQZP2g4YoGVMFZwCLONONjCe9/LNnEKoM9g1sDjGDZcAi8axHNycE2tQkiKgpujz0Ey4ZD4N4BnhBotoknEeyb+1R1qEzqt2NF7ew2/2hQjbXYv487lb1LI0uSUp965EkWO7OvJ8/aZEbpop6+qe0FepBqtzf15D6X380Pb3WuLWHxlefV+geRuZOjLwkAAA==",
    Area: "0",
    "Bottom Elevation": "2450",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2634",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6250",
    Length: "184",
    "Loop Boundary": "No",
    Mark: "681",
    Material: "Copper",
    "Middle Elevation": "2450",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2450",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2634",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545853",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.38383648",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNzc0KwjAQBOB32XMMTVPzU0+igqCHUgQPpYeooQ3ERGoUSum7G6uCt5nlG7YaoDiZQ3/TkMPOn0ypz0G5xmpAUHjjwh3yavjESGZE4kwwungHydMMxvoHl12n+qjjYW3UVQfdQZ7gBMFeuya0U5FUICh9UMF4BznBc55wyWjKuMyEZAzB0Vz+8Vabpg1TF5Qi2Fj9/K5TgklECFbe+vjMPawd6xdbMMv71AAAAA==",
    Pbi3DGeometry:
      "1x0AAB+LCAAAAAAABADtV01r20AQ/S97Vsx+S3JOIS0U2kNoCz0EHxwiEoFqFVcthOD/XtXWOrZ232jlaxYTI3kys2/evNnduX9ldw/195dfFVuyz+1D/a1t6keWsbu23nS/2fL+9fDYm/l1/2G77O2XK8H59f6r/2O7lXO72W7XL73vlSgX2mqZ/X8oS20yKRaCl2r/gy7s4aHUQp5bjj6Gq1iLMeJgyaUGPmMEhhcaRMPY9hbJF5yrfFY02ifMTsgnhjecqWcRuQ3zhvMxylkcAiv0yOJ8lOfjEGBLoQyI5lswArwOxuY4UFyeWE6rgNeZg82tU8o8OtNL1glzEMqH0qiw5xZt5ZSqpMrPM5VaROtthnoxthl6U9OoMQKsHRztEmwTmQY1uvc5VYhfOdzbXpfAaHhHItbBFqwQzGgE1+HepvcDr7MwoxHRfEYhBzAfXQzHnBUHZDYf7f2B08dhLvWQjZiwzNnh3X6k7UDFEfNwIscczTMO+twto42OTDSmbONECdpgoqA2hkt17pCLYupEiPDxzgroA5ER1cR6QgqEtODtAW4psMoEZATsAl0Q1cf6I3SOqCFux0OsQhWgZOMLwRvm0hjQ6GPL1PUieFU4MtCHAx3orUNcIpCFuAITCABtBNOXFAcyDZHFXP68GhANTVcUXweCTM+XISU2WAJAdMxe54sd9QfmLI2iaRQNiiqNomkUjdRoGkXTKEozmkbRNIqmUTSNokFgaRRNo2gaRd/zKLrK2Id6/bPqqi1b9gRk7Eu1eeqeh5evbbfu6nYzvP6oH4+mT1X99NwNLx+b6u/pP962TdsH3Pxpmt3qH+ox2TXXHQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1548",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545856",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.71355301",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lImv5ZT6KCoIcigofSQ8XQLsREahRK6bsb2ir15G1nv2Fm8g6yC57au4QU9uaCmVFtZTQQyAxq+4A078bTGTy+oKFIgqWXUC5CAT2ZQT+igon4P0zi8BfOYwdYfOpXTVO2boN7bLC8SSsbSBllBA5SV7aexNHY0qKbPcozXr9oJ7Gq7SACHhPYKvmavD6nPGARgbVRxuXqp1J98QZThMEsEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVl1PgzAU/S99LqQFLMiejDMx0YdFTXxY9sCyZmvCqMFqsiz8dwsyhdALF82yQXc4H4XeW9Znstqql9ObJCl50Fv1rHO1I5SstCrMO0nX5+9TC7OF/ZCK/v7jccYWzY/9kmpzod2UZXayXI9f+1dhElEv8XkkYhpwn8eC0x4geNQAERPUyaiPSMBK1EAtiTOfTJUEITJuLeGUSoLAnerCGMwDBMBUoDkYd1KqMQ+EH7IwHt72LtDzcDGaVDig+wT/Z96bIMocnHnvCboYoNQAAFOB5iAASsEVNXV3x+sDxwA9UObgBMG1i0oFSuEYqFRgDf59MeDXFdhkcGt3Vr8aZ6BS4VrfrBqcXzhgTxz0ksmGDO4G4wxc1aL2wVkNGd/b4S0V1aln7c72aN8hlio7SiNLkjKfUfIoi705tIMnbTKjdNEOX9XuB7qXan8w7eAul5/dC291rq1g8ZHn1eYLJID5kfUIAAA=",
    Area: "0",
    "Bottom Elevation": "2644",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6445",
    Length: "2062",
    "Loop Boundary": "No",
    Mark: "683",
    Material: "Copper",
    "Middle Elevation": "2650",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2650",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2656",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545859",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.88338582",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1jsEKwjAQRP9lz2lIaltqPYkKgh6CCB5KDy2GdiFmJUahlP67kVb/wNu8mWF3ygFUg+f+rqGAAzWoyPQtWWCgCK1/QFEOkwyFSC55kmeLVZRzmckERvafsPq+XztX92FDMLZY37TXDgrBBYOjtq3vZjiRrz2G2RNe8PqL9hrbzn8gE4lksDP6NXdjwVORxgw2ZCjctU9jxuoNugWJGRMBAAA=",
    Pbi3DGeometry:
      "3wgAAB+LCAAAAAAABAClVk1rg0AQ/S97XmXXrKsxp9IWCu0htIUeQg6GSLJg3WJtIQT/e60frRJfMhJEcec5b96MO6OrI1tuzOvhI2ERe7Qb82JTs2WcLa3Jik8WrY7NbQWLRXWwkv9bHCnEor5UJyvXndtNnseHyteRc1cFUnMndGWgJfeE6wvf47+ALySwBw2gpaICjV3pYGBX2vdHHVSoZzUQeh5JE0wChoCaOiYyAJm6JJTQNLGwgGey6HtIV4r57LRQPfswdh8YhBhhqtMb2EFoGAJqGrztMabT2OOaYBLDd0FhQqHP1Gl6PSj9gsSSnid1KqUcqH5wk9OYrmojqGlyCxOprtofeNjRqEh5QA+oCg5O2kQljRYIwMZH859IRcoDeiBV+IMIPkokIpIdtuuFCTJ55PRyqP4W7kz8nhRJziLhCs6ekmxX7NvFsy3iwtisXb6Z7R/0kJjdvmgX92ny3X/w1qa2Isy+0rRc/wAB1HEw3wgAAA==",
    Area: "0",
    "Bottom Elevation": "2450",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2634",
    Family: "Standard",
    "Family and Type": "Standard",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6250",
    Length: "184",
    "Loop Boundary": "No",
    Mark: "684",
    Material: "Copper",
    "Middle Elevation": "2450",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2450",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Top Elevation": "2634",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "545860",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.3685064",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzVELwiAUBeD/cp+dzLmc2lNUENTDGEEPYw9WsgmmsSwYY/89WQW93XP4DrceoTyb43DXIGHvz6bSl6BcazUgKL1x4QGyHj9nJAkROOeMLhOOCSM5TM3PrfpeDRHHYmPUTQfdg0xxiuCgXRu6OQjKEVQ+qGC8A0nwokgLwWjGCpFzwRiCk7n+4502bRfmzClFsLX69V1nBJOIEKy99fGZe1o7NW/tRlv/0wAAAA==",
    Pbi3DGeometry:
      "rRwAAB+LCAAAAAAABADtV01PAjEQ/S89L6Rf2y1wMmpiogeiJh4MBwgb3WRlDa4mxvDfXWCr7raPdk9eGoOwPKYz8+ZN23n8IvNVcf/5mpMpua5WxV1VFmuSkHlVbOo3Mn38On5sYDpr/sgu+f1mxCidHf41L7JbGLOz7Xb52diO2GQsleTJSI+ZFmnC2ZjRiUgOgFbiAAjKuoCxEM0XYUCasgOgmHRb9J2nVEv3UjAqA0y4GrgUtICU9C38XMEELYBlyskVzCMVBmid7y27QGsh+hbGOQT2786lbAA5hz5gVCZzQXkXMLRDH+FRGR8TngUmONwHzLyfxwklMtUBpOIe+XCRdRLkkgXqKlyiMKpgXQlvuNA5VAlcanhU3gQtJRoLIwarULhr+22AloKbDPYBASgGSKKXXdi1sM+txoEk+peySESZozykPh5RRyUolXmONK3aWLVsk2CngfBt2uwwUineiTVlgcdp+MmctS6ElGH5BRSplx+mCuXnLEVKuej8OmPas6d7LazNHlmAkHDloGzcKkNEwI5HewSqJw7VHdHg8uMqQ4lhGQM68FX1uFDGtbs+/bP7J1gtQff2Af81wDrUTd5ag9ayfODTHgD4Qoqdu6nC3A4vBuIWxeS/lFmk4z711Q+e3Ba3Q9V2QlSIcze1/n3L1jNoAMhTnPri1Benvjj1xakvTn1x6otTX5z6nLfJOPV5d6c49XVkH6e+OPV5OP+PqW+RkIti+ZLX+ZZM6Zgm5CbfPNXP7cNtVS/rotq0jw/F+ge6youn57p9uCzzj78/PK/Kqllw816Wu8U3KYVr6a0cAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1550",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545863",
    Name: "M_Pipe Cross: Standard",
    Category: "Pipe Fittings",
    temperature: "22.31048166",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjT0LwjAYhP/LO6ehSWpi4iQqCDqUIjiUDqmGNhATqVEopf/d+gVud8dzd+UAeW0P/dWAgl2obWFOUfvGGUCQB+vjDVQ5fOSEJJRjJjhZJERiKWgGY/UDl12n+4megrXVFxNNByrFKYK98U1sX4ZSyRAUIepogwdF8EykQnJGuZDZXHKO4GjP//DW2KaN7yVOBYKNM49vmxJMWEoQrIIL05m/OzdWTzBrKGjUAAAA",
    Pbi3DGeometry:
      "GTYAAB+LCAAAAAAABADtWUtr20AQ/i86y0ZPS0pOpS0U2kNoCz2EHBJiEoFrFdcthOD/XlXWe/bbmV2rPS0hIc6Xee7s7Ox+t6/ezUP59eXH1rvyPlYP5ZdqVz56vndTlfvjT+/q9vX8aw0H1/WXd/KHv6zCILhuftTf3umuE3tzONy/1LKraLNOiiDzV2GxLtIg9qNwHebxxlcjcRHPkCxKzkgQAhmqLQnDBtmEyQJ2imTDyBRRJkawtg7B2aEI9pr3gGpT+xYF6yCIc5DRuZ1adtNqO1vJzhJxtgnNJJaJZYooYwkag9ooiTYoA6MxsNLlPy7yvEXSqEUKbs0YO7LV7OqJrlqPCHyzkeF326Cty3SanHMdpynrNZIx6TjUN4yQXtSsj2GXgjKaeAzsdFU9rE9SZC3CtSKBGYyQVqBpEqxrFiKKBEQNkqdZPkU6z3pkVNQzmdH2BUiftR4ZFhR6kMYFsIN9I0ifHKLNxg5ZNwGC89Z7kCQZyA72DcfTePC37eVZOPWgkZkgk0jHyKiooikyrR2ZNuzBdBWU2prsjJE+OzZeQ9+Gg4TYwZFiOzgenAMcj66uY+Wm1xY8EOGrmjadrnZpqzaoarITqDbbcJTpTPPUcGbTSqhtyEt9Gr6yBHuEzF8CbVQGRGOQ/un2NGxeGjudZ2TGwQiefnAz5rUpZPTxyFZn1AZi9WwoaYXEjkGTFMy62DddazePx2JuNTn8BdouGWbwrEv2gm6ixR5YzPt4feBdRIPotImPRP6mprkn6WRYO/O9sMz68MOzVpt6RscAPpQNhnf2joCPPpO5iH8uMFnQIdHgiUX79KKdo8BNTD1LIuvI36gJSXXfGpD5xqUyXTlLkHmZSTyYPzxIfJtnjWqzsUO18QjO29QDVaVJfJvHYz4a2sTJ6+LzzI9/ODOcjNKO1udLreCVEQ1feCQBiKTS5DuHG6S0Q6tCGxpaTfauiTZ5L8IjPe5SEhliR+D1JXb4Hq69JMG7uBqQ9Aj+DOHfAvDh7rgqx1U5rspxVY6r6tfHsEs5rspxVY6r0vrmuCrHVTHzseOqHFfluCp1M3ZcleOqLh1mHFfluCol4rgqx1Upn1EuY4rU2mzf/G3YMht2iX/vNsmbDY/Gv0Pz7B+uHJu343/zdr3Eq/pFz/pymsKG9FiW2rAhfvC5uywlZGfnfxNzi5CG1rSlGQlrQ+kuSdyaE9p2DceA6r7zvXfl/fftcXvwruogfe/Tdv90fG4/fK6O98ey2rcfv5WPPfRhWz49H9sP73fb3+N/fFvtqlrh/tdud7r7A4q5GeAZNgAA",
    "Angle 1": "90.00°",
    "Angle 2": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    H: "35",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Converging/Diverging Tee/Wye",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1553",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "Overall Size": "15 mmø-15 mmø-15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "10",
    Size: "15 mmø-15 mmø-15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545865",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.89069312",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jUELgkAQhf/LnNdlV0XFTlFBUAeRoIN4WGtYB7bdsC0Q8b+3ld3ezPfxXjNB1dFpvCOUcHAd1XjxymqDwKByZP0Dymb6xaBEccaTPJOrqOAykynM7d9bD4MagxweW1I39DhAKbhgcESrff85ZJrmDGrnlSdnF3ym60JFkTDYI+nef1kYYLAz+Fr0WHKZiNCwccaFdvs0Zm7fuA7pHMQAAAA=",
    Pbi3DGeometry:
      "3SMAAB+LCAAAAAAABADtWE1r20AQ/S97ls1Ku5ZWzqm0hUJ6CGmhh+CDQ0QiUK3iKoUQ/N8jRbJUafQyoxR6WkI+lOeZN29ndkbMzbO6us2/P/3K1FZdlrf5t7LI71Sgrsr8UP1W25vn9s8a1hf1lzoFw39WodYXrz/qb3Xanc0+HI/7p9p2FcVra50NVm4dxqENonAdGp0EI8CZsAVSADS/ZRZp1AINl8zVOarGcgQ0vmc5oA7WAnLIo2IPkbiCHI2L2bOa6jDaJLPkPcBanHX0wDRcAiwnJ65gVFPl/xAujGpaibxAyIF1IOVERxKHbwuEgLhEIQesREEGuRJdXtQsB6+cuGJPl+UgLQPrWO5qWj7TcNlGxnPIXSFyDIibDCEnrlJnuqvWurLavD1YeAuxDqvj+c4gH179sbOuxDpwI9u49BVIXNwCMZMnZMC2SrYjEoA0V7uZP0LsCloAGfIzJ/1CboE4TGrMKCgXOwZguzFpVsgV/1JCJpc4Hb3FxrhRfbpow1iwHBCQT0c2quUWREdHHpnOYrhP1o6BSQvtgSGDiRsBPccUgK4g+ZAoFFWXjx4YahdFBcmRwPP94DmGviclHzKIBMIjgeWDOVCVQEAcLkwUf3EgObZgOGiiIMDV1YKejzMIJhQz6mCBwuE/c58QNXPJF1DAEQ8B7Ep6ndg3EvwChS0YDlI78rbADlp5VENvfe9opnd5eSPB5Ei538b4bYzfxvhtjN/G+G2M38b4bYzfxvhtjN/G+G2M38b4bYzfxvhtjN/G/J9tzC5Qn/L9z6zKjmqr1zpQX7PDffXQPVyX1b7Ky0P3+CO/66EvWX7/UHUPn4vsz98f/FgWZe3w8FgUp90LTXlf8t0jAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "9",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "22",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1554",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "Overall Size": "15 mmø-15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "9",
    Size: "15 mmø-15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "545866",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.59801037",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzVELgjAUBeD/cp/ncE7nZk9RQVAPIkEP4sOsoYO1ha1AxP/esILe7jl8h1tPULb6NN4VFHBwra7UxUvbGQUISqetf0BRT58zkIhSnLCMryKOCSMpzM3PrYdBjgGHYqvlTXk1QBHjGMFR2c73SxCUI6icl147CwXBWR7ngtGE5SLlgjEEZ339x3ulu94vmVOKYGfU67tOCCYBIdg448Iz+zRmbt582Y2+0wAAAA==",
    Pbi3DGeometry:
      "tRwAAB+LCAAAAAAABADtV01Lw0AQ/S97Tst+JbupJ1FB0IOo4EF6qBg0EBupURDpfzemWTWdPHdz87CIH/F1Pt6bmd3M7Qe7uCuv358LtmBn9V15VVflPUvYRV2umxe2uP3Y/dnC/KD9Ytvk5z8zwflB96P9ZtulMzvcbFbvre1Mqbm0Jk9mdi5UrhIp5oK3vzsgS20H5DIbAs7CqjQQyI3ogEzocQsSXCsz7gpm5QDFxURX0AJKQiy8WkGCBFA6G9cK8hBqGPzLcgA4C7Vv4YJD4Mty1BUBYHAYA2blmCsu91z1ssMY4Vm5GLk0gQSnx8Dq7vOAfZXybADoTHraR9p0QFBqEdhX4S0KswruK+VNFwaHXQJdTc/KT3C/gs7CNQMpFJxaMgbQFTxkYAwIwGaAInrVhVML55wMDmTudUUAyBzyMEJ2gJF2l1VmPLdalu5cWa17HsIDBJ/U34eMTfNBuqkIvFHDL2ezE91aHUjPWyZCD7pC9GAxdD7sNiOs52D3WhDNoQXMCpcPig67DSgChx9WA9UVJgtzmt4J0AIlhfsZ6AFfrByLdLxE5Bp3qSoLppgA3jcCcjv0rJUGI0ZCwAsIAvAVAsUGOkFdJxcCkkMZed/NiOBwUv21Qxc4EXZqo2HaQHCgq/fcImqAANBR3Pzi5hc3v7j5xc0vbn5x84ubX9z84uYXN7+g7SFufn/vD3HzG9D+P5vfMmHH5eqpaIoNW/A5T9h5sX5oHvuHy7pZNWW97h9vyvtv6LQoHx6b/uGkKt5+f/CorurW4fq1qrbLT6ywZRq1HAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1555",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "573298",
    Name: "Basic Wall: STB 30.0 Rot",
    Category: "Walls",
    temperature: "21.0007358",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzFk01TbehIVBD0UETyUHloMbSAmUqNQSv/dQG3Vk7edfcPMZB2kpTq1NwkJ7G2pUqvbyhogkFpl3B2SrBtOb5gJpJFgfIlM0BA5Qk++KAoacR7+pSEV8Tz4pZ/kkebjhFXTFK3f4R8bVVylkw0kjDICB2kqV7/F0brCKT99kGd1mdBOqqr2NYgUF4LAVsvn5A1YTGBttfWp5qF1n78AesV2/RUBAAA=",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABAClU1FrwjAQ/i+31zRc0rTW+iQ6GGwPooM9iA8VgwZqM7owKOJ/X5jRbpaSFAkJufvu7rvcXdYnWGzVe/MpIYdXvVUrXaodEFhoVZkvyNeny9XCOLELzqTVRAxx8nvYDefN1W1a10VjfSMmaMZ5QhgKmjDOCNIYx6SrZ4yKjFtEMJoJ5I8hfSxO39onVIzTuI3UeniRDsd/fYfDy933ir5IQzPyVyOsesG8g6p639Phk9PPElJzbzcCcg6ZUG8GwfPj6aJjsH9yroqjNLKGHCkSeJPV3hycsNSmMEpXTvxQuxv0ItX+YJzwXMrvv4YzXWobEJ5GqUjj2P79H7AqclZKBAAA",
    Absorptance: "0.1",
    Area: "28",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0 Rot",
    "Family and Type": "STB 30.0 Rot",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8235",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton - Rot",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 30.0 Rot",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0 Rot",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "8.41",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573299",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "22.8026135",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjlELgjAUhf/LfR5jc+qYPYUFQT1IBD2ID0pDB2s3bAUi/vcGlhAEvd1zv8M5pxyhaMxpuGnIYI+NKdAOLTogUKBx/g5ZOc5nMPCURqmSKy4ETVQqYSI/IIupVCr6hpJGiVB/4BJbferXfV8PYUN4bEx91V73kDHKCBy0a333Fkf0tTdh9izP5rKgnTZtF1o4p1zGBLZWPxevYIpAjhZDqntYO1UviiYKBBEBAAA=",
    Pbi3DGeometry:
      "hgcAAB+LCAAAAAAABACdVd9LwzAQ/l/iawz5sSZt9yS6IujDUMGH4UPHwhaojdQgjLH/3TDrLGvTa6S0NPfdfXdJvktWB7Rcm5f9h0Y5erBr82wrs0EYLa2p3SfKV4efXw/TuX/QEf9Zrhml89PHv+j49ht20zTl3scySbjMFGZ0RhLGGaZE0Az3zIyRWco7gBAkyaT6BxDI0JoV4YnIwuaE0FTykPmcdCJN0L8PBCOGK2KC8Ewm0f5TaTwglUjDwAVRb1sA/zH+oUJj+S/UAC/DeDU9tQX0HE47tgjTSOIEHk45tABAe8Z1yeQCu5WA/R1sHVCqUVTD2w3KrwcEI4KdDmoNpoIjJp+34DziVAqYof6Cztvo+YLAKYO/z+5M+a6dblBOCcXoUddbt2sHT9aVzti6Hb6azRm612a7c+1gUemvruOtrawnRFeLolCF8vfmNwxu/aGGBwAA",
    Absorptance: "0.1",
    Area: "30",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "3000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8778",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "9.06",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573302",
    Name: "Floor: STB 30.0",
    Category: "Floors",
    temperature: "22.64600958",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNDcz1LC3NrXUtzPXMTM1NlGp1ELJESWKT08WQjIVZ71hUlFgJdANQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhvCDc9MgUt5pGamZ5SAOJYWJsY6Sq45qWVQtboGembmpkAx5/ycfKC5eaU5ObWxANiSJfQTAQAA",
    Pbi3DGeometry:
      "LBoAAB+LCAAAAAAABAClWN9r2zAQ/l+0V0dIlm3Z6dPYGgbbQ9kGeyh5SGloDVk8MjMoJf/73MR245NOd3IoLfWn032n09n34/5V3D3UP1/+bMVSfG0e6h/Nrn4Uibhr6n37VyzvX8//dsvqpvsRx+QdWWilbk5/ul9xXA/bPh4Om5du7yLTssxUmmhjZF4WebJQsrC5SXQqK1ulSVVJVZXWwY3unlMXh/I4g+0ky6JwF2ijIPm44+0fm5bpuGJyaY2xbzuLzJQjnhpZ5vlJU5YZ7ch3uNIXzBfyE2ZMD+Umrp4B7/al2ho2jp0L+gH33GCp1rK7T/cEi0JaVWakPM3Av02U2xpZFNq6O0j/IaeD+IX/WPeA+ZvyKhYXUL8tZV5leaJVJnOdvl80+laNC86OXhX2pkMcpUY3oCahmmwmdW6qwEXrTFqrXXK4wxRSFyp1LgJ70Qd5iAeY0eBDbSK4MVudYBrdhNvkriCuvTAq9os4kXduW0mjKveuexhG5RmGoTTV4UehZoJwap6f0HXjgEPHQ7x37hmG99qjwLFTdCoLI4lrntcMPyFAKZNPd35GYSRwjjdFwxqmNvhlYX6eum2Kwm9qPJtfrz+G3GomjCOhHw7bqSEk5filCjkk5uikS9mOHhJjSC9MoiEUO7P/jaKk/Yz+MGBqdrIH5+R+RmAdohn9aoTtZpTpwVDlwlc0DhQFK/XgdVJ8ZYUwxCUsstLDCjp6gZNWwyibE9sAEq4/DbPQufVsWDsnocT2xNzmMJTaeGhE2xnEmak3gM5tpMniIhqNGAEE8fgyB637I0vvcMk2B53bFYW1g+KRhXIZMXl/wToHnduVkdpjKiTWUIEh76nr5qBzxyGEdn/NF0TnDnj82mMqSmyEEztSCmsHnR4LvXZ0B7tLbxfJhemZHTrjIQhie3H2CISzBZJgHTgXv26WQ7Hweo3ABGvO1AthwTogPk5z43tIFmZ7zuiHIPc6EZ/rze9tuz2IpZIqEd+2+6f2uX/43rSbtm72/eOv+nFc+rKtn57b/uF2t/13Kfip2TWdQvHhdrWyKyuO6/+scxXoLBoAAA==",
    Absorptance: "0.1",
    Area: "1669",
    "Calculated Heating Load": "166900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "300",
    "Design Option": "-1",
    "Elevation at Bottom": "-206",
    "Elevation at Top": "94",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "0",
    Image: "<None>",
    Perimeter: "292972",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "300",
    Type: "STB 30.0",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    Volume: "500.82",
  },
  {
    ID: "573316",
    Name: "Basic Wall: STB 30.0 Rot",
    Category: "Walls",
    temperature: "21.52821141",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaYJtPYkKgh6KCB5KDy2GNhCzUqNQSv/dQG3Rk7edfcPM5D1klTl3dw0pHLAyGdquRgcEMjTOPyDN+/EMhoXkNJZMrJSkEVcCBvIFuaSxEOoPVFQkifqFc+wEi6l+3bZlFzaEx9aUN+11CymjjMBRu9o3H3FCX3oTZo/yYq4z2mtTN6GFc8qXksDO6tfsjVhCYIMWQ6p7WjsUbwmLBcURAQAA",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABAClU8GqwjAQ/Jf1GkOSJr62nkQFQQ+iDzyIh4pBA7WRGgQR/92gefVZqWmR0NDd2cwsk83yAtO1+j0fJMQw1ms116naAIKpVpk5Qry8PH4tTLp2wRU9M21KSPe+2Q+uq79jvTxPzvZsm3IcMiaQ4DiggiGCAxKhtzSlmIfMApzikBP2BVCh4NJFtcAsisSTpqj3AWX+13SZ3ydb0X0FTbNefBbUMqymZAMfyxfYdEQqFfwm+9z3N+sfQ594zUH5fGeO3b63gUr20sgcYoIJgonMtmbngpk2iVE6c+FCbQpoJNV2Z1wwTOXpf2Ffp9oSQuunwztBYN/1DdsezHMmBAAA",
    Absorptance: "0.1",
    Area: "28",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0 Rot",
    "Family and Type": "STB 30.0 Rot",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8235",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton - Rot",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 30.0 Rot",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0 Rot",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "8.41",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573317",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "19.19577399",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjs0KwjAQhN9lz7H0J01rPYkKgh6CCB5KDy2GdiEmUqNQSt/dlWovCt5m9htmJ+9BVnjsrgoy2NkKpdVdbQ0wkBaNu0GW96OkwCzgXhqG8eIl4jTkMLBflAckRPJFAyGif3RqLj4Tlm1bdrSDDmssL8qpFjLf8xnslald8zYH60qHNH20JzxPaKuwbuhNxD0ukjmDjVaPKRz5dFlZbanW3LUeiieE/7tFFgEAAA==",
    Pbi3DGeometry:
      "WRYAAB+LCAAAAAAABAC1WFFr2zAQ/i/aqyskWZbj9GlsDYPtoWyDPZQ8pNS0hiwemRmUkv8+b7EzJ9KnO7mMkhLry9336e6sO/vuRdzeN1+ff9RiKT62982Xdts8iEzcts2u+ymWdy/Hrz2srvs/ccj+rVxppa7//us/4rAezd7u95vn3vZKW7kwpsj+fCkWxmZaS7swVeYjSuZqum5yaQqTuIzd+wg0wRTOVLm3brXUC1dlPV4VSge4cyvL0oVUYRttpHWlmfIo6WzhAsjJm5GVKziax/W0qGCTcGBGwZ5FBDFSF7bEvvywUBbpevkcY+q9wI8WOPU+ggsJe4vYkNq83dAsvi8cM2gTKlftXB5SNqz3OawWzls3Zf/76vxmoRDS16Re4qqi7KVSZWiHA/s0xucsPoK9MZBJXcxXEIlA8j6xstCdwdgnyAGuMpxpvxedr/MtItUE6o+hF+4RI3Pi758loCNS4aI7aDyIVKi4HdqTj6oanY9xOf56/JxFMiOdAd+Zc+7mgM18HnrImTP+8Hi4CObBCMrO/zk1uFMyb/ijThQawTyc6Yjo5mSf4VUmYreVteGeQY3LoZkFRwx7wwqOSIiHUp2mDXubMzlceEvoHCEE22Cei7jhaZflDWujbNJ4qI6blh+qqhhxw5WYkAUGklDxkWcLGknIDwNhTYozHpNPwcHOwKN16CEWN5fXvPFIEE3FJiR6iDRE6JmctR1q+A6N0hcCWEM2bonYBvNcBIf15gd7w9oomzQe9iM4Kz+4DNhxw+WWkAUGklDWs16BzagDBnLkWWfifbP5Xnf1XiyVVJn4VO8eu6fh4nPbbbqm3Q2X35qHE/Shbh6fuuHiZlv/mv7wXbtte4fizc1qVa5KcVj/Brfs+k1ZFgAA",
    Absorptance: "0.1",
    Area: "86",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "8600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8304",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "16.94",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573318",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "22.38711418",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lIbNI/T6KCoIcigofSQ4uhXYiJ1CiU0nc3UC0Igred/YaZKQbIazz1NwUZ7G2NudV9Yw0QyC0ad4esGKbTGwJJQ5bwZcAlZTLhMJIfUHCaLKL4GwoaSZ7+gXNs+alfdV3V+w3+scHqqpzqIGOUETgo07j2LY7WVQ797Eme8TKjncKm9S2hoCKKUwJbrZ6zOWT+s7ba+ljz0HosX15BPRcSAQAA",
    Pbi3DGeometry:
      "3BkAAB+LCAAAAAAABAClWE1v2zAM/S/a1TEkxx9xehq2BgO6Q7EN2KHIIUWN1kAWF6lRoCjy3+ctsWp9PJFKUKydRerxiRIpUnfv4va+/fX23IiluOnu25/dtn0Qibjt2l3/IpZ378f/DmJ5NfyIQ/IxMlNSXv3/NfwTh/U47fN+v3kb5s6KdC4XKpmpPK0qpRKl0nyR1YkjkMP3ZDirUlXUOdaf//tbegTZPK0LqQyoSsrKFWhOWZqXVeYxbgu0jSyty4JDNx8G6kUJl2dboPRj3cfHP/rIszC/8+CM0YKzQVBAQiGyNidoAR4aaJre6dGzeVoWqnbIjsMDQJXPC3t41NYbSuiPw44+CRRhQZXTI8bU58KowYN5kdn61gG2h9kwp2Efex9NqE/QvBif9I8+o/YOQ4GOAzYUnMGHctKtLYiYAW0gVnodY3Q6h96OzlHAnwFt6Ii73IY+DNECaMMR6JNoQznXn+N2PhSaAeliG5CVnZFJViFfmd4lLhyQo4hUzQaZ5g/AhHmbgCTEM4kysQlCafvrEXgBw+QWnw6dGefbIItMOMNN62GHcAs6Ln58FibrZ1JAu4+OYVSKny+ANmBCp0u0ehEouODl6jl/UyDO7WYYRjcVlc4gfxZ6GITIoGRT4Ef/4OJ1WCDADX3Sj15tMn3wO53LNpx7DpwSAHY5RyDPcJAPgAkVY+b9y2mu/IyccoGMdvLy5xv3lFax7qNqNOQQsujBM1Bdzqn9jeWxe4WY7sJrATb4AQsgsIL4fFcEGAEfBfjEhTkVtIAJear5LzustZJR41wRzluWBrKHg/cwgAm9h5iNN1mKQUZOc09WaaHHFT8raNzzrhPrPuKBiKxNz3AI6hjpzpeGOseG2Y+Tj3vxrOCMkA37lcDYWAaQVz/wbsEqJ7hAfD6MKoyO6kAOoJiQsUY+o8et1cJfJ+Jru/nT9M1eLGUqE/G92T32T6ePH12/6dtud/r83T5o0bemfXzqTx/X2+Z1qvil23YDoPh0vVpVq0oc1n8BL5nj8twZAAA=",
    Absorptance: "0.1",
    Area: "83",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "8300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8159",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "16.4",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573319",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "19.65293452",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkbZr+eBIVBD0UETyUHloM7UJMpEahlL67gWoPInjb2W+YmWKAvMZTf1OQwd7WmFvdN9YAgdyicXfIimE6vYELyngQLxc8oixKOIzkBxScJoGMv6GUSfoHzrHlp37VdVXvN/jHBqurcqqDjFFG4KBM49q3OFpXOfSzJ3nGy4x2CpvWt4SCChmnBLZaPWdzyPxnbbX1seah9Vi+ABPlcFsSAQAA",
    Pbi3DGeometry:
      "thYAAB+LCAAAAAAABAClWN1r20AM/19ur+5x5884fRprw2B7KNtgDyUPKTWtIY1HZgal5H+faRI39knWTwmlTa2fPk6KpZN0/2buHupfr38qMzffmof6Z7OuH01k7pp60/418/u3/b8d7K67H7OLPihX3rnr9z/dr9ktj2Kft9vVayfrU+t8XERXPrNJmsWRs4kro54cx9bnZTomH7m9t+ksJvgDQJTADHfkIk0yjpvSTvGnHV85yzlyoIYFjvpRwwJZH88ktUWRE0Cc2DJzPvRBD7A2WMDHNs2LmPCDA7rPMs8IzwOgd5ADVMbfw44b77+osar+DeGAQBULTJ2KNi4CrIMnEnk+K4nM2JOD93bIffJ6DvkDQJTADBN5IRgOCsqeHNS9ITlQwwJTJ6IMC2Q0PkTyDvlZ4CR5BYCoAxcY3yeW5lS0BFHohhKBKqJsgRIqP2hVYnSDVCSyehT2j6wehX0MiBK4cbZysMZZCaJgj6I7VkXUflBC5QetSqzLUgvDJPJkSyKkva5d05Ug7Nwot3TuqSqPucO0sGyzwpY1TYUUVGlaKLAQ6qsXblwIIToF6G9P4SsNWlMR0PuMF3+20RQBpJkVKh1rg+ncBDLSoIHDEVPQgvCJAJ5FIsAPO9wVid+257f8yN0JDiLIVS/MAlPNgXIE00xzYNdwkeeCDX1ayiFRt6n4PD6l6sx2G7ehWR+AEwi+7dCMk8JGZWoAPXN1hQDgdHqR54IN/XUtn0o9HSC7C3D8QfY8lw4BqlXL9EYFXxmxNlg/0NXXMjI39eqlaqutmTvrIvO92jy1z4eHH027autmc3j8XT/20NeqfnpuDw+36+rfKeOXZt10Cs2n28WiWBRmt/wPo7msybYWAAA=",
    Absorptance: "0.1",
    Area: "79",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "7900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8159",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "15.79",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573320",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "20.64494943",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkJramnkQFQQ9FBA+lh5aGdiEmUqNQSv/dQLUHEbzt7BtmJushLfHc3TQkcHAlps50tbNAIHVo/R2SrB/PYBCMSh6p1YxLqhYqhoH8gJLT5Tz6gpyyWPA/cIrNP/Xrti26sCE8tlhctdctJIwyAkdta9+8xcn5wmOYPcoLVhPaa6yb0CIklVGsCOyMfk5mwcJn44wLsfZhzJC/AOH6wJ8SAQAA",
    Pbi3DGeometry:
      "2B4AAB+LCAAAAAAABAClWU1v2zAM/S/a1TUkW7aT9DSsDQZsh2IbsEORQ4oarYE0HjJjQFHkv09LbTcT9UzKRdGP6Il8JE3JJHv7om7umh/Pv2q1Ul/au+Z7u2vuVaJu2mbf/Var25fXPx2sL92XOiZvKxdG68vTD/etjptB7OPhsH12srlOrSmXyYWxaVUZk+g018vkbblIc1tkZLnfbUxqF5kIAIr6ZbifAFmWut/WVzQsS/ezxMBjp25ZFiGPs9SWVUYVUQkIcKrkwBgOBBByFgipqmxeYAfl5DAksY91sEm2bJ3W5aIMaj/tJwArARiEy86pwlaB3aXJA0HAAFDUL5MwYzMhcTgMAxB6kOFkGUMtTi82IQnAWgUl5KrGWBGJiaADiQkOYNUcjvCjhak/dRRDqT+e6TxdFtoEbgEE5P/uwTJ0+foSkGMAqCoI9BxycmwuRx4VklNsiSpIPiXxep58jjHdEEBUYYkhD8WqoLksB5SgALIKhoQN+yhhUl3lhty447JOS1ucXZQj4J8/XiLM4HLK2IUlxMAeSOvfIDzgXy1ngFm4YEVIsByB8AGOIXw+xxAnuUS8HwMHMRc8JFItc/uRfpg0Xln/buL3RxVKYA6/LBYDkANm+XjgSWqSAz9khxggLxIfoOScKmgufPWAtmb6UuHr0/PqMe7CEvZpYiWg/Bc0C3E3KqMkLlTAHeb0At3w/ReRLbAY8ksbmJHwVcoeufjkZosIvnxi/ZjlubBE469lMJ2ZtQy1QwAaSuvu2YA8DfDtDucnswHIQTst2IKBSmzWcjwtXw3zrzoOkN84pIIRz/v4CloynAhXk9gqbpwZ3yXLyYkf83sHyAGtIqriR2Pi4pQPu8SP/2dCsKqEox9JPzA9r+HJIYd4GiZXBYdFM+pprvyXz5/JbFgSXWHYeQeRuXBizY9eWT/kQPR9FT9H59t7fgiJmnVsFfzfidhcOBRmyYkfkqFDuO+HHNAqooodbmNzoVXcf6YiumC/34SDMrYQhIOyKYkwB+60uWmjHIgnl3sOp7+8H9EOsjMGzqpNoq6a7VPd1Qe10qlO1Nd6/9A99h++td22a9p9//Fncz9Cn+vm4bHrP1zv6j/nGz+1u9YpVB+u1+tqXanj5i8v/Ht52B4AAA==",
    Absorptance: "0.1",
    Area: "83",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "8300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8189",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "16.55",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573321",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "19.01898234",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjssKwjAQRf9l1jE0bR5aV6KCoIsggovSRYuhDcREahRK6b8bqK26cjd3zmXmZB3IUp/am4IU9q7U0pm2chYQSKetv0OadcMYCoRTTAXjyxmNMaGEQY++qEgw50T8pQQTJuJf+rk80nxUWDVN0QaPsNjo4qq8aiCNcITgoGzl63c4Ol94HdSHeNaXCe2UrurwhgQvNo8RbI16TuUkWiBYO+PCWfswps9fd1h8bBYBAAA=",
    Pbi3DGeometry:
      "EAYAAB+LCAAAAAAABACtVN9LwzAQ/l/O1ywkbdra7mm4lYE+DBV8GD50LGyB2owuCGPsfzdqdbKYXaqjtPTu8n33g+8y38NsoR53GwkF3OqFetC1WgKBmVaN2UIx33/+2jAb2gcO5OgZcMaGHx/7wuH5CzZq22pnsTxNqEjyazIQEeWCJ4RHVKRZRNwIozHLCc9iytM8/QVxJiIoT+Lc5Tr14whvDrxebinfT7o5nMgpxsfl9IHmQJiOXSB+tNYeCHTqwbNFusDPh/F7p9pbNWcU6J2Sf2dC1PkPFV6oan+e/nv75z0I6SVUjQE9Bu8VokhfbnuzjlX1Io1soWCUEbiTzcqsO+Nem8oo3XTmk1p+h6ZSrdamMya1fP158EbX2hLC1aQsszKzN/gbTjQiDxAGAAA=",
    Absorptance: "0.1",
    Area: "10",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2800",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "3706",
    Volume: "2.95",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573322",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "22.96262257",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzF0m9iaehIVBD0UETyUHloMaSAmUqNQSv/dQLUHEbzt7Btmpughr/Wpu0nIYO9qnTvTKWeBQO609XfIin48gwFTRjERyXKGnKYpIgzkF+VIEy7YF+UU50z8o1Ny+ZmwatuqCzvCY6Orq/SyhSyiEYGDtMo3b3F0vvI6TB/lWV8mtJNaNaEG41CyiAlsjXxOZhYJAmtnXIi1D2OG8gVIV28mFgEAAA==",
    Pbi3DGeometry:
      "7gcAAB+LCAAAAAAABACtVd9PgzAQ/l/qa9f0AKmwJ6MjJvqwqIkPiw8sa7YmSA0Sk2XZ/25VYAR2lKIh/Oh9/XrX+47r6kCWa/W8f5ckJvd6rZ50pjaEkqVWeflB4tXh99PAfG4ucqQnyww4n/88zE2OrzXtuijSveGC8BmEUUhnnmAQhEABWHDlRfSEQMCEgCGEM5+37fhaATC4FF6PUdvBY0H4/bYy7PG6R9X33nAaJDBT/ajvpWvvM/pexiOYl+4ebVF17dj6Np1sfocyG4YgzmUWz7md45JbfDVcw5qDq4tzcD943dn0bddwJ7IR/wPGmF7b030M5Bjfo7VLjK1vF01celRH+QlquSC4nxHIiBp3UOZfIsA79Qjkj/3kbATm3LxV6ZssZUFizjglDzLflrtq8KjLtFQ6r4YvatNAd1Jtd2U1WGTysz3xRmfaLEguFkkiEmHO5y9Hphs27gcAAA==",
    Absorptance: "0.1",
    Area: "30",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "3000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8192",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "3706",
    Volume: "8.77",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573323",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "20.18812928",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAQhf/LnBfZXVtNO0UFQR0kgg7iQWnRgW03bAtE/O8NWFanTjNvvsd7k/eQVXjsrhpS2LkKM2e62llgkDm0/gZp3o8rGYQIuEqSRUhTRAoG9mEyDOZKyX8simX8w74yR1a8q5dtW3bUT4c1lhftdQspDziDvba1b17i4HzpkV4e5QnPE9pqrBsqof5oJiSDjdGPyRzyhMHKGUex9m7MUDwBkUsFXA4BAAA=",
    Pbi3DGeometry:
      "cAwAAB+LCAAAAAAABACdV99rwjAQ/l+y16ykadMafRqbMtgeZBvsQfagWDTgzHBlIOL/vrC22h+55DLEH/l6+XJ3ue8SFycyX6m341dBxuRJr9Sr3qk1oWSu1b78JuPFqfppHrOJeZEzvSK3MWOTvw/zJuePZtrd4bA8mrlxHDEhJU3Md5wJasbpiEvax1mUMEl5Eo2E4P9CIWYI5zySmbDY8yjNcj7kD8Qh/gZv2Zvp+cXPPl5F22IJRiHmS2aMR7m84sZOChYP7EG8ibTPA0QKZqDOJMQziKux7+Fee6SfXn+weQMqwbWH9irwonZehGq8GhMilzZrCHd4jbaGuF3xDNWYpGlm22NIjU57C3/lJX5dqOYq+2ENQfydGsVqzMIPrRuqYSjejv+QZlo45E8oDvF3cZ8moTOk20GRuEuZ0DmEOLecXS+ge7orHB8rKmfYHuLjR3Q0yH8oz5CyQpXYrXw/v3PfQ/l994+B4jynOMgP8IR2WtAf//0pNK5Ox0B0JNQtJ3RdROeE/Pwf7s6/ubk/qOVnURYHMmYRo+S52G/KbT140eWyVHpfD9/V+vLosVCbbVkPprvip214r3faEJKb6WyWz3LzD+EX87MGEnAMAAA=",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3900",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "7206",
    Volume: "5.25",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573324",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "22.78284976",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyGk6W/qSVQQ9FBE8FB6aDGkgZhIjUIpfXcXaitePO3OfsPMlgMUjT73dwk5HFyjC2d65SwQKJy2/gF5OUwrGoKAsliIFU6RpSmM5Mt4SLM45v8Zp0kUZj9syZxZNVevu67usR8PW13fpJcd5IwyAkdplW8/4uR87TW+PMmLvi5oL7VqsQT7kyjgBHZGvhZzyASBjTMOY+3TmLF6A0aQbMIOAQAA",
    Pbi3DGeometry:
      "bAwAAB+LCAAAAAAABAClV1FPwjAQ/i/1dS5dx9g6noxCTPSBqIkPxAcICzRBanAxIYT/boV2QrvjbhoCo9++fXc9el/LZMfGM/Wy/ahYyR70TD3rlZqziI21WtefrJzsjl/NbT4wL7aPfpHrhPPB4cO82f7NPXaz2Uy35tkkiXkmZWSussjzKBFxr5+Ln6vMpWhwYcb97MA740O4ufYKEeI8TrkM1Bu2jwPZOL5I4yLLwix9HInamiOkTc0FiNmxvo5PnakZy4wnob7FqbMCZ4vkA8WF9BsdEfd7aeFXzaJBjS0eREX4Vt3V+Awla7tf0FPB+F1zb8/SR4POQVT+mj3Qx6RKktB2XVJHtmucxEuTrEA7BlV3Oj4f0ietLpR9MXciG8qc6CWQzsla6YZjlXf8y2sOcnGsA2j9dTkm0BWBi/vdRcQh/WD36DpXZOcD92HMZaBdDqsb4krgfKFzAXJeQPld42J1COt21qHg+sFOB9D6gXQwZwDcCNMh7CL/0wechOzJiFeT43Y8JWGOR3bOo745td+p6XtVVxtW8phH7LFaL+qlHTzpelorvbbDVzVvbt1XarGs7WC4qr5Oibd6pY0guxqORvkoN/8OvgFV5hTmbAwAAA==",
    Absorptance: "0.1",
    Area: "28",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3900",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "7206",
    Volume: "5.45",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573325",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "20.99901589",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkadM29SQqCHooIngoPVQMbSBmpUahlP67gWpBPHjb2TfMTDlAcTbH/qYhhx2eTYG2b9ABgQKN83fIy2E6gyHJqOLJgkcRlXEqYSS/jMU0VUp8M0VlKvgfOKdWn/Jl19V9WBAea1Nftdcd5IwyAnvtGt++xQF97U0YPcmTucxoq03ThhYuKJeZILCx+jmbI6YIrNBiiHUPa8fqBU4IJhIQAQAA",
    Pbi3DGeometry:
      "Hw4AAB+LCAAAAAAABACtV99rwjAQ/l+y1y4kafpLn8amDLYH2QZ7kD0oFg04O1wZiPi/L1OjNs01l22IYi9333eX3F2u4y0ZTdXL5qMkPfJQTdVztVQzEpFRpVb1J+mNt4e/epn19YfsorPkmjPW3//oL9m9GbOb9Xqy0bZpTgueRlwkNE8FjzinMhdFZOSxpCwu0ojRmJ2lRrsllbnMWxjd2k2p4Qvzw8Ho9ITHNM1im9NIsSgdrI443Zwd2I5d0RiiSBNXPHt5U5sllGlHAKmNAWhLmnAwFpwfPq+RnkB+Oz00Uggb7TkU5+VZFjTJfrgsV4yYF5RLkZ1RbP3WgtfCYohjypJEoomNPhdUpplwWNgLAINVjl78U1lD+KAFLmJ/YKg6syoYIO1OwGYSAwfY2TF+F3pI13HXaSeCJxO7+wXW5Us3upGBbXYjQxtqi4WU7lw9LHiLJLys/oEDdBesOc8RQo02VI5LHLgzeE7n3NvABScQLifg3QR5jQU0yYBIYSNOK1PQGxF6NzquKVwEAQNTcwgCY/vjvIcmcBiAV6oXqTnk+G4kkBo/LSDnK3RiOGIAu5Snd4aUrSe/QXJw7PEvIBp3GLl+0bpTk/eyLtekxyiLyGO5mteL48NTVU9qVa2Oj69qdlq6L9V8UR8fBsvy61LxtlpWGpBcDYbDbJjpF7pvTVFg2R8OAAA=",
    Absorptance: "0.1",
    Area: "32",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "3200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8763",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "3706",
    Volume: "6.27",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573326",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "22.18560448",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkTdI/T6KCoIcigofSQ8XQBmJWahRK6bsbqBYEwdvOfsPMlAMUZ3Psbxpy2OHZFGj7Bh0QKNA4f4e8HKYzGJKUSsHkggtBlUwUjOQHZJIqHvFvmFGWxvEfOMdWn/pl19V92BAea1Nftdcd5IwyAnvtGt++xQF97U2YPcmTucxoq03ThhYeUa7SiMDG6udsFiwjsEKLIdY9rB2rF3rNHEUSAQAA",
    Pbi3DGeometry:
      "8gkAAB+LCAAAAAAABACVVk1rwkAQ/S/ba7rMJhvz4am0hkJ7kLbQg/SgGHTBZosNBRH/e5catWyczCwhITtvvvZl3pLZXkwX5m33VYtSPNmFebUbsxSRmFrTtN+inO2Prw6GsbvEIbpYbhXA+O/hbnH4OIXdbbfznYvNcqkT0JFKtISkGEUgEyiiizmRkKYaM6tY6lEWc4AuPwrwCqtCKh1n7kXqPOZ0hEaAlqmKlV/hZOb6kx1x/c8AyWkhIR85KiF1QKIvqc6Avwcf6HoiE3kfxzf3OkL8yUZD+8GpwMhDduAXvt5PoDhY3khJZNoowqihDQfCmAnQe1+oWZqnIfM/oJhjqt40DIwJWhwB6J1jcr0SQdTAp5oSIFeZ2KwOm3HC0UONMX8eGYxUSPEBVRDt8iPoo7Zfg5hzGmBTQgOML4hoKVwyZFc4uyRASp8PEMXdv9ODmX/Wbb0VJUiIxHPdrNp1t3ix7bw1tumW72Z5hh5rs1q33WKyqX/+O97bjXUJxc2kqrIqc/9ov+Wq7ePyCQAA",
    Absorptance: "0.1",
    Area: "33",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "3300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8850",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "3706",
    Volume: "6.53",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573378",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "22.72167165",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkad2aehIVBD0UETyUHloMbSAmUqNQSv/dQGtBPHjb2TfMTN5DVulzd1eQwsFVOnOmq50FApnT1j8gzfvxDAZcUslxxaOYskgiDOSXMaSIUnwzSReJ4H/gnFp8ytdtW3ZhQXhsdXlTXrWQMsoIHJWtfTOJk/Ol12H0KC/6OqO90nUTWoSgEZMJgZ1Rr8nMBY0xEQQ2zrgQbJ/GDMUbMWU4MhIBAAA=",
    Pbi3DGeometry:
      "bhYAAB+LCAAAAAAABAClWE1vEzEQ/S/muli212vvpicEjZDgUAEShyqHVF21K4UsCiukqsp/Z6FxoLafZ7Yoysc+j998eDwe5/pRXN0MXx6+92IlPow3w+dxN9yKSlyNw376IVbXj08/52F1Mb/EsfqLvNZKXfz5mN/iuAnT3hwO24d5rmtlp12laytV3c0/jLTOmyrgxktjap/gdS2bzvnKGNm5piNxxBPwhAfYQ+qtZdcoTfIbJ1vrbGrPCWfLI37k70J+bWVja5PIB5wrj/hDnOdv7x0jnq2sjWnZ8pAf5dtC/iDPxr3sbNNAPNZrlHTOpDASJ+gT/IkewAk74RSSB05ltJrWem4MCimof6cewjOpXMRjHuWlrjMlgLIHycd44E/0OmlblaZswBMehAP7oV4C58YtLO/CZY/FZ7faxnc5/MldIB/TF3iy8sjMoBfxI3muX4XwPA9nJxtvdGbd44HzwoQB3UqntMUzzroTHbHyMxUciHUklZikomcs9xzpgJ4nA3AG3w+q50F+IyJYMeIdDeOETm9Kc1ILSZ+J/mZBkc8rhimAfF7sQmISpaFQ6IuVg85JovlJzmWYw6gGvXw3IFsL5TVfjpkNE2lQwedsD4TKcWwPyY86TbahZD2ElxgCh0cW6DD+Y7PBQ4upmjxdyROLHGBsQ2OtLtw94ztXmECeV+zWLT3yyyZR12Q2jlxjxwI1wzBGeAJsAkim5/05ZKJUw86LrRqtM5UYGR8ip6kLYbJwzJsi4qEbQXIjosYYMuEJ5WBQrTebCF6z44vz0miTisnLwMLbUvI/Smwo6cFSl0mcKmGw9EDNhToMk5igogcYhwBxOtADjD1HOBjp2FTi3bD91k/9QayUVJX42O/vpvvTw6dx2k7DuD89fh1uz0Pv++Hufjo9XO76n/8Kvh1340woXl2u137txXHzCx7MtqVuFgAA",
    Absorptance: "0.1",
    Area: "56",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "5600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8343",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "6800",
    Volume: "11.07",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573379",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "19.9025912",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjssKwjAURP/lrkPIy/Thqqgg6KKI4KJ00WJoAzGRGoVS+u8GWguC4O7OPcPMFAPktT73dwUpHFytc2f6xllAkDtt/QPSYpjOYIhiLDgRa8oFJjyRMKIfkAi8oox+wwSTWMo/cIktP/VZ11V92BAeW13dlFcdpAQTBEdlG9/O4uR85XWYPcmLvi5or3TThhbGMCdJhGBn1Gs2U4aFjBiCjTMuBNunMWP5BhrATG8UAQAA",
    Pbi3DGeometry:
      "dgUAAB+LCAAAAAAABACdlN9LwzAQx/+X8zWGS5sma/ckuiLow1DBh7GHjoUtUBupQRhj/7tBayeL5bpR+uP66d33mnyTxR7mK/uyezdQwINb2WdX2zUwmDvb+A8oFvufx4BxGg44sOOba4E4/b6EEw7L37Sbtq12IVdPuExRMpFKjmmuWLhrrXIWAZFwqXRyBCLnQib6DICSZyIRwyASJ0sNttuDnONEqX8yTkGv0YOMY5bKM0A0VqcgFqdK0f9BjhXZ1fiJijQuH5Io43IN0lc0oM1A2SeaDxLQpibFB11CLufx7Y7XGL0MaIsOiIf9685Wb8abFgrkyODRNBu/7YIn5ytvXdOFr3bdo3tjN1vfBbPafP798NbVLhSEq1lZ6lKHffILuxRIt3YFAAA=",
    Absorptance: "0.1",
    Area: "61",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "6100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "9000",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "6800",
    Volume: "12.24",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573380",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "21.51200668",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjl8LgjAUxb/LfR5jf9SpPUUFQT1IBD2ID0pjDtYWtgIRv3sDTQiC3u65v8M5pxygaPS5v0vI4eAaXTjTK2cBQeG09Q/Iy2E6g4FlOI4FXVHOcZwlAkb0A5IEpyT9hpxgRjn7A5fY6lO/7rq6DxvCY6vrm/Syg5xgguAorfLtLE7O116H2ZO86OuC9lKrNrRQgqMsFQh2Rr5mM2U4SgRDsHHGhWD7NGas3mAVLeoUAQAA",
    Pbi3DGeometry:
      "iw0AAB+LCAAAAAAABAClV01PAjEQ/S/1Wpu2y37BySjERA9ETTwQDxA20ASpwY0JIfx3G90F3XZ2phoCYTv75vV1O2+6swObLszT/q1iQ3ZnF+bRbsyScTa1Zlu/s+Hs8P3XheXIfdiRn0culZSjrx/3ZceXFna12833DqtLkaa54iqRosw1V6UoClXy83gi0jLLudJikLkbPEB3XBdCZkXqZzoFughViEEhkwBFw621KLO09LlBCk8Fos5ngGSDFK0KMJUXABEoB30JXUCFKEDuHoAKErgBJQML1Qb8TD0ImSQDOBBKFUbIXKgk9PhAeX+WQZ8UKAOcbRsAOeiPCdkHLcAVilaJ9ud0CnTL2A80u9ZL1ZLjiG7J/IMD1NHxL48bBHiThcajRYAIjIJszqi46NUgM6CbPN4PUDPCycH939etVCwg7M3RFH0rFa87UgVmd2Dl0c0LLWKsW5EAv/peNAVhQSAK9LBBR8TLIHMQSh90HSyAdj7ctuP3CBrA3BM3SVpnwE+jkKdGdh6wweBnc+pUyRQR5wayP3Y43EvNjZm/VnW1Y0MpJGf31XZVr5uLB1vPa2O3zeWzWZ5Ct5VZrevmYrypPn7eeG031iVkF+PJJJ/k7uXpE2Xv2O+LDQAA",
    Absorptance: "0.1",
    Area: "24",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8165",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "4.76",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573381",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "22.73223724",
    Cost: "0",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaUx/PIkKgh6KCB5KDy0NbSAmUqNQSt/dQFuLJ287+w0zk/WQluraPSQkcLKlSq3uamsAQWqVcU9Isn48vWEVYLamwYYSgXlEBAxogSLGjHP6D4aYBiL6gUvsDPO5ftu2Rec3+MdeFXfpZAsJwQTBWZraNZO4WFc45WeP8qaqLzpKVTe+hRLM4yhEcNDyPZkpw1yEDMHOauuDzUvrIf8A6Eds3BQBAAA=",
    Pbi3DGeometry:
      "WTgAAB+LCAAAAAAABAC1mk+PFDcQxb9L5zpYdv+dXk5RwioSOaAkUg5oD4sYwUibHbSMkBDa754JGfewtn/zyuwiBGK6uuq57HK165Vff2levdn+9fnDprloXu7ebP/c3WzfNqvm1W57u//YXLz+8v9/D2L//PCnuV+dnjwL3j//+s/hb3N/FdV+vru7/nzQ7VwY5nkV/Oj6tR9XoXX9OLWr7Pns1uswr551rh1ClyuMzo/dkD9fu+C71vD+ESAE5/04WQRHS2F0Ywh9QTC7IfQF59rBTfNUMpVpHMFptJl3NE1t6+ZxYAUzwHGkCEALRwDmhY4AGAHkGq4oQuAy5AsnTWE4ZVHzhKYwMqMGOcjgZAqnpGISVUwhRrt2k38QC/WCI3jfuja0hc3aT66b+kJc9YMLYSyknFwj5hzvwjgXNsHgXTuVpiTXiIK1m8NYeN45PxX8zp7HVEQTlc9HtJQgx0WqmA6cQCkgUzSoCvcwDtSE4GhpUPlqRwWKD7KEq03v/yiAOHvoWkWEo4YKQAoODAKyhIloUZhc6P5LxdGJ3vVdXxLE+YvPI3Lv/PBAoBV+FEJcutF1rR8KCssKpRCZQGkgxjC4uf/68U4FSxSkplAjuLGbSw5mpiRGcO1YgDhFWio4xMu0tihkuSMVjIfTjC8MNtdQ2GiJBkVun5un8pRnQZjlFRlSWTZQ2EuWTQMkT4LmkCJTWTzXY1BqkTOVJoRFAeccNQCCvUMITBXkBXkNifYJNlL+ufj+rRdrmENwhtKins4Micbpk2T2g0yhg+k2zo8fuaUHGUQqIALtyXNzXgdtX70FGyBwYnlVCYJX1YyhU071lxIxOKQyQWRlyFR7KPaGKRQENCWn8jDRyAVxz3jXz3MBPAyunUuWlpo1xc4EGTGTYmeCqOHdeip9jnm0Z/wrm2I/yPHezW0ojHYhYdI07KbOlw6X6fspO5eGWvo8VvatG+ahMBkLZ5M8P/z0U8FQ9n7KLiXPyQ45jDN3Il+kIFIpqc9LdUGTcSo7rJuI4zXdjzm1JfcEbbuclTEHMoY+mbJvlmVU5Ll9uIsGCewpKqfPxBb+BrvWUhq6iwZB0Ezhh4+TOW0C2q/pvlzGat9/Km4pJVDuSlPCchQFO1bXnip14RTl/LDREnnM79fNKGZAAubMSJYQmlJpJkBsOa28EJhKMY/bj0+irWWOPuv7xjYbPy9/aGs/zBKXTiiqxyCPKGhJKlgPQTwmimIDp5PS2sjO62oXTeWjMrJfcrTSktULbDbxwb3+qG9v58rOMFUNj6kzEDzRQI6emVNiCjUHm0JIzjFVoDoYW2ZcOWvmG5sWZnBkvs/MCMwheo49AmuzkGhbqQA9BT0i60hl+8PqAjb+sDOMpAezIWQKv/M4qgryRh0ZDIcM880WM+Mi62qEqL9ugxi1NAljEwugO4bpNRmqsVCAbc8zhGdZcMZSkSHFPjbQv2SH7wxhwUklKl8VOVPMA41BGoyB5ApU2lgp8HUbsHTO77J7DEGDovJPt67S+MD+Ed02oL7Sd3SiGAKaYOQEEvHYeIRtcWYblQ1xrYp345BzxPxkLcWlpVqWoXolZK+QrkiJs0etfYVruLmoFloWgIaSMVvocqFsLujFPU5uLQhcej+xT/dE5XM1HvG+GVfQBcQKEK7hUqc8fCmKlO+H1t8oRQxsOGiBHJXUsIOr4riilke2T5YHj7jOmjKKGhw1Ugy8fasFclRSww4uGR8kdgic6SbNaKEpiWEHR40Egy9waIEcldKoAJd0kyao0q/SIxic9MOhBfXgqJFi0P0p9VwOSSlYgRUTpJijNM6QZNa0NJqSGHZw1Egx6q+T462c+qthdnDFQyHdhODUQaJOFPVH5fPEN4lL76dHBOz7aYEaklKowFbMlIHLegh+tWp+3V7/s9lv7poL7/yq+X1z+27//vjjj93+er/d3R5//r19u4h+22zfvd8ff7y42Xz69sVfdje7g8HmpxeXl9Pl1Nxf/Qto99ZYWTgAAA==",
    Absorptance: "0.1",
    Area: "56",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "5600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "22097",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "11.28",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573382",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "22.62113232",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lz3FJ0vTXk6gg6KGI4KH0UDG0gZhIjUIpfXcDrQVB8Laz3zAzRQ/5RZ26u4QM9vaicqu72hogkFtl3AOyoh9Pb1gEyEMWLBmPUIiAwUB+QBphQpP4G3IM05D/gXNs+alftW3V+Q3+sVHVTTrZQkaREjhIU7tmEkfrKqf87FGe1XVGO6nqxrcwiiJNYgJbLV+TmXEUUcwJrK22Ptg8tR7KN22eUe0UAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdU02LwjAQ/S/jNYYk/QhtT6IWQQ/iLuxBPFQMGqiN1CCI+N8NWnWxlqkSEjJ5mXmTN5n5CaZL/XvcKYhhbJb6x+R6BQSmRhd2D/H8dNs6mCVuwJk8T7qcseS6uAnnxd2tV5bZ0fl2PSoC7hHOJOVeKAkX1A+lIDVACBqFQfQEREh93+NfAI0cD0DQIArEm1B3oJbVK1ALhXLg5I3vQEO1zwqtBypie60a1f28tO1/SWtyXF1UEjTdzwuFq4tK8sLhenKgs62yqoSYUUZgooq13VTGzNjMalNU5p9ePaCR0uuNrYxhrg7/L/ZNblxA6AzTVKbS9f4FH3swNEoEAAA=",
    Absorptance: "0.1",
    Area: "19",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "5985",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "3.77",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573383",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.00298192",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/Lrr50tVNUENRBIuggHpQWXdh2w7ZAxP/eghZ26vbmfcPM5D1klTp3dwkpHGylMqu72hogkFll3APSvB9Pb1ggpyEKvkqQomAJDGQGOdIoDOO/UCxF8AtnsSMsPvXrti07v8E/tqq8SSdbSBllBI7S1K6ZxMm60ik/e5QXdf2ivVR141s4o5iImMBOy9dk5gHFKA4IbKy2Ptg8tR6KN/dGWcwUAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABAClU11rwjAU/S/X1zQkMbZpfRqbRXAPsg32ID60NGiga6QGQaT/fWHrtNtMbZCQkJuTe8/9XJ1gmau3405CAgudq1ddqgIQLLWqzB6S1en7amEytQsadHkJKCHTr8NuaNY/ag91nR2tbkA5FoyNUcwxFyRGlGEeRgz9AxjDcTiJUcApHnNB7wCcHGegoyEmgl1MdTT6gWscv4G/HLfJnXE4Tfl7NSQlAwvlzNWQAPsjv8bh3wz95F6F6s+V013/Qnl14iByO5NPKvuQRtaQEEwQPMtqY7at8KJNZpSuWvFdFWdoLtVma1phVspD9+OjLrU1CKNZmkZpZGf/ExsyYc9KBAAA",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8143",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.98",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573384",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "22.22041973",
    Cost: "0",
    Pbi2DGeometry: "GAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzFs2lTTehIVBD0UETyUHloMbSAmUqNQSv/dSGsPInjb2TfMTNZBWqpTe5OQwN6WKrW6rawBAqlVxt0hybrh9IYZZzSMF2zJMKKIPICe/KIhpyiE+KIBDQXj/+iUnH8mrJqmaP0O/9io4iqdbCBBigQO0lSuHsXRusIpP32QZ3WZ0E6qqvY17N3MOIGtls/RzJBGMc4JrK22Ptg8tO7zF1er8ZoYAQAA",
    Pbi3DGeometry:
      "8hIAAB+LCAAAAAAABACtV99rwjAQ/l+y1xrS340+jU0ZbA+yDfYwfHBYtODscGUg4v++YKt2zV1y6USU1q/ffXfXy+XyvmfTj+J195WzIXssP4qXcl0smMemZbGpvtnwfV9fKliM1IcdvMs/A1+I0fFHfdlhdqLdbrfzneIOIp+HMvU9X8RciChQFzwVMvBAJJYi+YtEMglrRP2BIHQOohNG3A8zH+JkipMEXhBwmcTSVUePFOOgOmGonk1SL4h4kvoS0AGQk7WQy1iAOjpit6b7hubt7LWeN1NGMQ/wjPbJG5qDM0dH8EjbSLeqYhhAk2OUaYxlUsYkFQOjh4jIMmlKM45Ayayt4S9Ae2kGTu00SDnGCSIoBVfBMmDiYA7Y44R0jBVwsRVwpRoBpdECOjULIsfa6BgDVXBKJ/7/yZiDcVHRGzGI/NHRtw9Ha12k09K6iB6PkWPXcfEa8QCvaOOGTPGgT64tOpQWia+DHkuHqtKjQ9Gr3bHbkDl4deAbuJ2D6/SK1NI9nEYLh3VIGmUt6/1/naCP1/hqc1lTzW5EWTnEzn7Fmcf6/k2FQT57kBoaBcF1iNsKcU4lItfxAG+d9A5JObMRcgAMq2rYCuGxq0agEwbOIQz4DjrkMw5urTWUdrx2O/04cGw6uG9uJzMbh4CQcm2rA0Ku8dohxUNGHOqacKBxO+og8RCQWmfmsfti/plX+ZYNBRcee8o3y2rV3DyX1bwqyk1z+1YsztBDXixXVXMzXuc/7QfvynWpDLKb8WSSTlJ2mP0CqnGZvPISAAA=",
    Absorptance: "0.1",
    Area: "39",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-572",
    "Calculated Heating Load": "3900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8865",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "220",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "4292",
    Volume: "11.24",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573385",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "20.13610552",
    Cost: "0",
    Pbi2DGeometry:
      "FgEAAB+LCAAAAAAABACFjssKwjAQRf9l1jEkpo+krkQFQRdBBBelixZDG4iJ1CiU0n830PpauZs75zJz8h5kpY/dVUEGO1dp6UxXOwsIpNPW3yDL+3EMhVlEMeeCLShjOBZJCgP6opTheZyKvzTCMae/8HN4gsVLYNm2ZRcswmKty4vyqoWMYIJgr2ztmykcnC+9DuJjPOnzG22VrpvwhUaYpoIj2Bj1mMqUBFOSIFg548JhezdmKJ7YASKuFgEAAA==",
    Pbi3DGeometry:
      "OAkAAB+LCAAAAAAABACtVl1LwzAU/S/xNQ1Jv9M9ia4I+jBU8GHsoWNhC9RGahHG2H83aKuzzWeR0tL09Pbce3LupesTWG358/GNgQLciy1/EjXfAQhWgjfdOyjWp+9bCeOFPMAZ/j4JCMaLr4s8wXkzhF23bXWUsUFMUEQzAkkUoYSmGQxjlGaEQgUSIZpgAgMSoTDJqCJmithj9DxTJEQ0TVQxBKOc0kTBMwfR8yiQGCU5UUlgART0I2DMoQUM+g/5ulQfI5znVBUzIP/jABOPURk/LXUkdgFUKVt09tp+PcvfnC/3WYeMq/FoGkOjTZtznLXWg06u9a/GpI2GxlSMNmV9lba9sSozwzXOKhvGqZ3eTX+3oeUAWC07xzL6RvdC3FvQZzrqG80HsQ8Ov1lrs/ocxKao/AO55dUr61gLCowwBA+s2XeHfvEouqrjoumXL3z3A90xvj90/WJZs4/LF29ELeQHwdWyLLMyk386nz8HBSg4CQAA",
    Absorptance: "0.1",
    Area: "36",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-572",
    "Calculated Heating Load": "3600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8727",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "250",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "4322",
    Volume: "10.42",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573386",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "21.68039116",
    Cost: "0",
    Pbi2DGeometry: "GAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkMf31JCoIeigieCg9tBjaQEykRqGUvrsLrb0oeNvZb5iZvIes0ufuriCFg6t05kxXOwsEMqetf0Ca9+OJhgUPaMKCaMVFSKVcchjIL8qQxiz8okImwT86JxefCeu2LTvcgY+tLm/KqxZSRhmBo7K1byZxcr70GqeP8qKvM9orXTdYwxmVSRwR2Bn1msxcUBlGgsDGGYfB9mnMULwBkH4laBgBAAA=",
    Pbi3DGeometry:
      "bgQAAB+LCAAAAAAABACdlF0LgjAUhv/L6XaNbfmRdhWVBHURFXQRXRgNHZgLG0FE/71RVvYhUxkOz57tnNftnesLzLZieT5w8GEit2IhE7EDBDMpUnUEf315vGpMerrBFb1H2pSQ3r3TD1w3z2X9LAvPem2b2tgjtosocbDVJQ6iDFuOy9AvYQx7ju0VCNPE6tBGpLxOkTDLs/9ne5B/2j7JbzZznWoKyr/HlK2eNtP5NNlRM6m21yaH1HOVSUG5D5o4sZ6vqyqo5gPTyX3V0fd2KMI9VzwDn2CCYMrTSMV5MJcqVEKmebgSuxcacxHFKg9GCT8VJw5kInVCaI2CwA1c/X+4AUbam/FuBAAA",
    Absorptance: "0.1",
    Area: "19",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "6085",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "3.89",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573387",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "22.82800635",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+Lb11dtJNUENRBIuggHpQWXdh2w7ZAxP/eguYhgm5v3jfMTDFAXqtzf5eQwsHWKre6b6wBArlVxj0gLYbp9AYUIcU4idcr5FQIRBjJL8oZRY7RF+UUozD5R5fk8jMh67qq9zv8Y6uqm3SygzSgAYGjNI1rZ3GyrnLKT5/kRV0XtJeqaX0NCylLOIGdlq/Zi4zyWDACG6utzzVPrcfyDUU5pwwXAQAA",
    Pbi3DGeometry:
      "vgsAAB+LCAAAAAAABACtVk1rAjEQ/S/pNYZMdjdh9VRapdAepC30ID0oLhqwptilIOJ/b2z9TiaJaxFdk7dv5mUmk8xgRfoj/br8rEibPJqRfjEzPSaU9I2e11+kPVj9/bUw79gPWdPDTAs47/z+2C9Zv+9ot4vFcGm5oDIGspS0BTlTCoCCYLlUgh4QoRjk0ofsOEKwUhblKUdxrqjIWFlw8HCyzVOWPmsOZ2/N8RNUgKjOgUGxmXERYTlQBBBXNW4NjwG+HpwTV+1qC1hDOXh+ElaakIXcGslKn4JzxMNxFMQRd1+fIx4FUWu4am8WIvVzjEgJKqS60e7FOaGcYplrEOtGfqLVeJ2feKwD68EV4CfFFcgl0cHPUV9tn8bgmINFJ35j+E5lzE+8si6p4NB6kmOwV40raLJ3cD//kYWANQfxndc4J3bTJnQBFyhIuDXRnKYhsVj7/MSQBD//kp8EbUlZSO5QmkTH8RO/6/GqT0ESepdTP7YPvtfDj6quFqTNGafkqZpP6ul28GzqYa3NfDt80+M99FDpybTeDrqz6vv4xTszM9Yguen2eqqnbL/9A+E9Tn2+CwAA",
    Absorptance: "0.1",
    Area: "57",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "5700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8342",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "7100",
    Volume: "16.84",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573390",
    Name: "Floor: STB 30.0",
    Category: "Floors",
    temperature: "20.17193471",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKgkAQht9lzuvimuFqJ6kgqINE0EE8KC06sO2EbYGI796GVoc6dJtvvp+ZP+8hq/DQXRQksKUKM9JdTQYYZITGXiHJ+3F0AU/4EY/mYuFJyUUgJAzsY/+Sv5z3JYvX+7Rty851cIsVlmdlVQuJz30GO2Vq20ywJ1tadLVHPOLprTYK68Y+IZbhjMFaq/uUFYKHMogZLEmTu2tuWg/FA4gD1K0TAQAA",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "1549",
    "Calculated Heating Load": "154900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "300",
    "Design Option": "-1",
    "Elevation at Bottom": "3500",
    "Elevation at Top": "3800",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "0",
    Image: "<None>",
    Perimeter: "365607",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "300",
    Type: "STB 30.0",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    Volume: "464.66",
  },
  {
    ID: "573418",
    Name: "Floor: STB 30.0",
    Category: "Floors",
    temperature: "19.53564216",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjrEKwjAURf/lzWlIopa0TqKCoEMRwaF0aDGkD2IiNQql9N+NtOqgg9u771wuJ+8gq/DQXhSksHUVZs602lkgkDm0/gpp3g1nKEScScoEj+eRlJQLLqEnH/wn/QWjb1q8FBZNU7bBIzxWWJ6VVw2kjDICO2W1r8ewd770GNSHeMTTG20U6to/QyKnEwJro+5jVwiaxLOEwNIZF3btzZi+eACnVregFwEAAA==",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "1551",
    "Calculated Heating Load": "155100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "300",
    "Design Option": "-1",
    "Elevation at Bottom": "7000",
    "Elevation at Top": "7300",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "0",
    Image: "<None>",
    Perimeter: "367101",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "300",
    Type: "STB 30.0",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    Volume: "465.35",
  },
  {
    ID: "573547",
    Name: "Floor: STB 30.0",
    Category: "Floors",
    temperature: "22.99251624",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKgkAQht9lzuuiKO2unaKCoA4SQQfxoLTowLYTtgUivnsbWh3q0G2++X5m/ryHrMJDd9GQwpYqzMh0NVlgkBFad4U078fRB4IoFFwpMQ+k5FGsJAzsY/+Sv1zwJYvX+0Xblp3v4BcrLM/a6RbSkIcMdtrWrplgT6506GuPeMTTW2001o17gpJJzGBt9H3KxgkXYqYYLMmQv2tvxgzFA37my24TAQAA",
    Pbi3DGeometry:
      "bBsAAB+LCAAAAAAABACtWE1v2zAM/S/a1RGkWP5Qehq2BgO2Q7EN2KHIIUWN1kAWD5kxoCjy36dtjrtJfiYlD0Wb5ol8lCjSJnn7LG7u2s9P3xqxEe+7u/ZTd2jvRSZuuvbYfxeb2+c//7pldeV+xDl7QVZaqavff9yvOO8uaq9Pp/2T010ZLWuj1pnOjdR5rTP3WVWlzValVEWpM6ulrQsb4GUhq9y+yOdO3fEgcR/XuTSVNpmtZanKMpAvHL3Va65ZH0bikD7eD1ADHo20AXe1MmupjS44KwOXtrKwlQlw91mpOsQDedLC2koz6RGo4dseLg/APv8Ao4MBcUDus1wujSlOeTneNyjg+UzgwOhkKExBRoH8rqxUtdP2WRD7RV4rIwu9prNmsOu7B+ySNOsAlVvGfqAGx8TC5wFJFZcxvu/Qhgh2cAW+0chM0pU7Y5E7d+hfiNYTK36kw5AeNeBCYITIDszEfyQD/6HMB6EdZJpbL51aGCzDQnDNHj4ejZD3t/8vPG6TxzI+P3jiPjvYC/TBRI4tOu0Y7JQvwzAJVoD7uTjYkZ9mF0f4r5N58cjjzrNEOAfwT+SWdy5wX8ygBXBQRRJGKXk/+HF0Io3ILIIbIg37R4MWoo8AnYeZ4O1HBntQtVE4GXbxgRq7V74FkG2UAXgPbANQgUznsBOCQQAf8RELUYXXdJlIl2q+9bnCclKD/YKPr11JDWQbFbskzqxFSDyx3UitgUg8sZSm64X0BXbligvt/1DFRFhJ6QDwzuiuAbLNPLVjVha0CAw7EbUt4/mKmhS/vwcFB/VyJ/G0qSFFH1vAofEgd+iJ+OPKzMgZ5vyABpAzC8n5KAAmQQOLquNkPK2dpuhRXUTiqQO8+U4sEeYNQymY1TxRcNIUl6jkk/FlY1xEj2psEl84pAd9dyK8aDofNwKg4FmTu0y8bfdfm745iY2SKhMfmuND/zh8+dj1+77tjsPXL+39uPSuaR8e++HL9aH58bfgm+7QOULx6nq7rbaVOO9+ArWOOHBsGwAA",
    Absorptance: "0.1",
    Area: "1584",
    "Calculated Heating Load": "158400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "300",
    "Design Option": "-1",
    "Elevation at Bottom": "10600",
    "Elevation at Top": "10900",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "0",
    Image: "<None>",
    Perimeter: "344001",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "300",
    Type: "STB 30.0",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    Volume: "475.22",
  },
  {
    ID: "573574",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "19.48832319",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjsEKwjAQRP9lz2lIbEJsPYkKgh6KCB5KDy2GNhCzUqNQSv/dQG3Fk7edfcPM5D1klTl3dw0pHLAyGdquRgcEMjTOPyDN+/EMhkjQZLmKuKSxkAsYyBfFjCoh/zBBleL8h02REyqm4nXbll1oD4+tKW/a6xZSRhmBo3a1bz7ihL70Jgwe5cVcZ7TXpm5CB+eUK0FgZ/Vr9sYsIbBBiyHVPa0dijcuXaPQCwEAAA==",
    Pbi3DGeometry:
      "5CIAAB+LCAAAAAAABAC1Wd9P3DAM/l+61xIlba4/4GnaOE3aHtA2aQ+IBxAnqMSuEztNQoj/fWX0elfHX+wcTAhEXeez4zjJZ/f8MTu76r4//Fplx9nn/qr71t9111menfXdevM7Oz5/fPl3eG1Php/sKd9Jjpy1J//+DL/Z08V22Pv7+8uHYaw1tnSL/MgtTOkXRW5NaducSmtTF2WdH3lTLVxLtQvTlqEykb6olqZ1bakD4HW98W3pqdR5Y11RM+KqagKHB3FbtqFFVxpbNGpwqr1FoeiCUd5HME9rXOHDCVHxiA3WURdv54xvCpgMSD1Iku0LNID3hs4/ro0CgFC0CQ4nlZgCO/k8k7b46oxEQKI/wC6IW7qjNIsPtoCWDFquTeNL93qPdHk4nljW1GV4UgTixrimfBa7yofHHq/tWrNorWO0OZBg+qOYB0HBKp5XY39zjo77AYWZ/WJwpQ5OuKIadrivQnCl+iimrkxi1hXgeGsa1zDzpPLxWrLGuyrc3ihayoWbzixlWkwZGgHiRyALIDoQRpkGk6No78EUZuOmRdk7CvitDTMQpEOw7hNQYoaDuFGUvTjzAU0GAg7hiWkjATYGDJA0A3FlvKlr57aBpuLAzbn6hD4XT77EtYObZC7fpe0MJlCnIRvFYegJPHBHHYOJYPHBwQ4hwzRs9DCJB5kuuNL7IMrj4TBd+zoneRRoVb3mAJ5yexUKMhrAUFYXFxMeM1+luTCgzTPliR3Ptan4RXlHjXVZh9wOcKQBKOggiun4NDh8fEFwxFkBdLAkvFGIrvXmIHDoOggkTgWwgnxTAtRgYE5AzOcwbxDciYBDam8ysD2iJuNtkxkCqFc4VVUzRteNmB9MUpPiUIfR+QgbLvHmDwUB2vFCW+lgGoiqtqecep52sECNV6IUhC05pdoSeDKfZRKItpyN00FQcAKuD+gO1I6Xpyq+muaJsiIG2JA1ikUKHiHbgH01ApXcRYRIaABsMKLiGF9jqE6NcV1YgINKO9kGLJJjI2DTD7TS0AhoA5MKBAVHoAVUNHElp5TMIk5PYPIrGYBU3YmbC/GXWH0QowLRPinPIRNqER4WNOol8SsYu9JijDgKJFNgzdHrHnb4RXmiVaRO4FF3X5TrSge5ShLsHsJIoVHpw56qJyDLyZSSPyfy8KjnIMoFdyR9rd04/wNfOVCDXqrF4gWd0DWGjby0XiaER61SUS64I+lr7cbZtMS936bXqKK88GtG3CT9VgK+3aj6g//FZFoBGBfHTF7k2cfu8udqs7rPjofrK8++rNY3m9vx4Wu/udx0/Xp8/NFdT68+rbqb2834cHq3+rOv+KG/6wfA7N3pclkv6+zp4i8uMqLv5CIAAA==",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "10889",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "4.55",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573575",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.02055148",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACNjkELgkAQhf/LnNdlV7dMO0UFQR0kgg7iwWjRgW0nbAtE/O8tWEq3bvPme7z38g6yC57au4YU9nTBjExbkQUGGaF1D0jzbji9IVA8WSyDMOSximbQswlJxSMl/oBynqgfOIUOqPhWr5qmbH2/f2ywvGmnG0gFFwwO2lau/ogjudKhnzzIM15HtNNY1b5DSi5jxWBr9Gv0RiJhsCZDPtU+jemLN1Uo4agNAQAA",
    Pbi3DGeometry:
      "EhEAAB+LCAAAAAAABACVV01Lw0AQ/S/rNV12s1tj6knUIuhBVPAgPVQMGqiN1CCI9L8bbKprMm9nltLSTGbfm9mPN7MPX+r6sb77fKvUTF02j/Vts6qfVKaum3rdvqvZw9fub/faHHcftc3+LBNrzPHPT/dV28V+2Mlms/zsxhptnJ1mkzzXhXfTrNBF7ops4vXh1JZ/dqOdKbOh986a69KNjE6XtnSMK2KzVvujfMzX+w+xGXcID7Kkg0wk9dqXzo/dEQxNKgtlF/aQMWa1RtvcjzIfmXtC67TJjzxv72G8NjYvuFD2qUPWIcx+AAKiZys5KUSbHKeYIT77dFpgYQNKe1h6ivLHDtzHkQTmgDLmjCipafk3AAFJc/olAMkC/GFaEGa8z0QwKC1hOENRCn0DJcC+MYBAvWLmHUSol4F5GER8mgAjAkGzmgQ+CpxQ4392OEBKEJtzeoHppURSwQuv4JTz3mztByUUzAcw07uNJqRlj62IQAaSCiW9WAmNELva7M5ISo4GZkMjsyAlBRZ0WBCRokrOoaiNQnYUarL2owGIACqJJDXRHAlSlhGLQuVPs0AS4rslrk7iop+0G7mtzhwKvl2jS0FCpaZhwe2DN0eiELcGMcaYhrN6H+3+4hVQelPhekueFbmL7h4Cu6gFFvSWUV7xdZDvoxeZOquXr1VbbdSsW8xMXVXr5/alf7hp2mVbN+v+8b5++n11UdXPL23/cL6qPkLH02bVdIDq4Hw+L+aF2i6+Acmry+MSEQAA",
    Absorptance: "0.1",
    Area: "15",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "5889",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "2.69",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573576",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "21.21736072",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzEkJrVNPYkKgh6KCB5KDy2GNhCzUqNQSv/dQLUggredfcPM5D1klTl1Nw0p7LEyGdquRgcEMjTO3yHN+/EMBkmlEnI5k5wm80UMA/llPKIsSvgXE1RxJf6zKbP4VK/atuxCf3hsTHnVXreQMsoIHLSrffMWR/SlN2HyKM/mMqGdNnUTSjinPJYEtlY/J69gisAaLYZU97B2KF7uZ0itDQEAAA==",
    Pbi3DGeometry:
      "PgcAAB+LCAAAAAAABACdVV1rwyAU/S/u1YpG09T0aWwNg+2hbIM9lD2kVFohiyOTQSn975M1XRdn/BghIfd4Peq9515XB7Bcy+f9uwAluFdr+aQauQEQLJVs9QcoV4fTrxnGc/OAI7wgE4Lx/PtjXnB8PU+77rp6b+YyxDhlcJJliEw5g4QgNss4tHGMKL6gJEeU5VkSOsZs48zYfDYdxYfshqVgNE9CQytSxAmnf3du4yf2MzqMVBwau6K9cxsfso+dZxjBkLc7hu4c/+fsQzRFUe6duU/nj5DPN6g7p3pDmknIuLceY6smpJxYPFSVY3HwZTk1NqGO4lZLqBrSqiRGG6FcxCg0Nj+h3jbaCZ39J4T7Ktl/Y1jM5h66lfWb0KIDJUYYggfRbvWuNx6VrrVUbW++yM3P0J2Q253ujUUjPn873qhGGUJwtaiqoirMffcFz2AUpD4HAAA=",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8159",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "4.65",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573581",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "20.15208617",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/Lrq7Z2ikqCOogEXQQD4qLLmz7wrZAxP/egiV26vbmfcPMZD2kpb50dwUJHLHUKZquRgsEUtTWPSDJ+vH0Bi5oKNhqvQgCGoswgoHMoKSRZPw/5EspfuEsdoT5t37TtkXnN/jHThc35VQLCaOMwEnZ2jUfcUZXOO1nj/KqqwkdlK4b38I55bEgsDfqNXlDJgls0aBPtU9jhvwN3zBd4xEBAAA=",
    Pbi3DGeometry:
      "mAgAAB+LCAAAAAAABAClVlFrgzAQ/i/ZaxoStY2xT2NrGWwPZRvsofTBUmkDzoxOBqX0vy90rtOaS06GKOaLd9+dfnfn8kgWa/16+ChIRh7NWr+YUm8IJQujq/qTZMvjz63d5lN7kBP9Q0aC8+n5Yk9yWv2a3e73+cHaioRNJqmioyhiMonHlLOYK2phFatxEJZMRrGkPS9CsCSNPAaSpUksXI4GEzjjv/bfwIqNFe/DUDQQfu0GjOayAVpgKfoJiIlKHAn4YIfzM+6KpmPQygtnADIACbS+exfu8gJPO9Tzv/BBAyxDqIyAogOcoF6CnxKp/GF68osyLGGEstFCCpcaMp4wg0cd4Q1kX8A0PD85WlQ+ZYKNHC1CZIFCbX/gGHK7h8ocgaOmE2J+eHnRVRceWnbC3+v8vaiLPck445Q8FdW23jWLZ1PntTZVs3zTm8vWQ6G3u7pZzMriq/3gnSmNdUhuZvO5nEv7J/EN1RLgBpgIAAA=",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1600",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.54",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573582",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.17934058",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzFk26TaehIVBD0UETyUHloMaSAmUqNQSv/dQLUgCN529g0zU/SQ1/rU3SRksHe1zp3plLNAIHfa+jtkRT+ewYApFSnD5QwFZWKBMJAfMIooFwn/ghGjmPD4D5xiy0/9qm2rLmwIj42urtLLFjJGGYGDtMo3b3F0vvI6zB7lWV8mtJNaNaEFkeKcE9ga+Zy8MUsJrJ1xIdU+jBnKFxnTcq4RAQAA",
    Pbi3DGeometry:
      "RgUAAB+LCAAAAAAABACtVN9rgzAQ/l9ur2m4xFinfRprZbA9lG2wh7IHS0MbsGa4MCil//tC6zpdiLFliOJ9d/fdDz+z2MN8qV53HxIyeNRL9aJLtQICc60q8wnZYn96tW6c2AsO5BcZMcTJ8WFvOLz/pN3VdbGzuSylcYqMjDiniYhigjTClDgwY1Tc8paDxTQSMb/C4alwgjlSNhbREWbjVJxp2o5OR06Gh8iFvTR9/fyBu0M58NAmg/HONj3fy9PPZd13o6/kDgjKw+2dM7iZ4QL5hxqXq98vqz44OFz4Rx248LAUA1LvFYuvrD2PpqrYSiNryJAigSdZrc2mMZ61KYzSVWO+qdXZ9SDVemMaY1bKr3bgvS61JYSbWZ4neWLPvW8aWswXRgUAAA==",
    Absorptance: "0.1",
    Area: "8",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2255",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "1.34",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573585",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "21.13775428",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjlELgjAUhf/LfV5j003TnqKCoB4kgh7EB8WhF9YWtgIR/3sDSwiC3u653+Gckw+QVXjubwpSONgKM6v7xhogkFk07g5pPkynNwSCyiQUqwWXlMklh5H8gEFAhYzEN5SUR7H8A+fY4lO/7rqy9xv8Y4vlVTnVQcooI3BUpnHtW5ysKx362ZO8YD2jvcKm9S2cUx4LAjutnrM3ZAmBjdXWp5qH1mPxAqItBOMRAQAA",
    Pbi3DGeometry:
      "RgUAAB+LCAAAAAAABAClVNFqwjAU/Ze71xiSNFnX+jSmZeAeZBvsQfZQMWigNlKDIOK/L2zpJrUxKaO05J5z7rnNzSWLE8yX6v24k5DDTC/Vm67UChDMtarNHvLF6WdpaTK2D5zRHzKihIy/P/aF82eb9tg05dHmMo5FlnA0ogInXDBEKeYPLENXBMEJuYAZw/Q+413Ya+PRt/AAfcoT4df3EbczPBUcLKwoFT0ba4kr/y7RMQr4h8p6/j5gE1c08mxvqz0lPe31Hl+wvfEH8v8RCRePmf8B0xAcqkF76Gu4t31BIm6GArBzt/fRRJVbaWQDOcEEwYus12bjgldtSqN07cIPtfqlnqVab4wLppU8XAqfdKWtIdxNiyItUnvvfQFcJrPARgUAAA==",
    Absorptance: "0.1",
    Area: "8",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2255",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "1.34",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573588",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.40312439",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzE0P1pST6KCoIcigofSQ4uhDcSs1CiU0nc3WC315m1nv2Fmsg7S0pzam4YE9liaFG1boQMCKRrn75Bk3XAGw0wyKlQsljMu6IIrAT2ZUCapVFL+Qfmc/8Jp8Bvm3wGrpinasCI8Nqa4aq8bSCIaEThoV/n6I47oC2/C8EGezWVEO22qOrQwRlksCWytfo5eESkCa7QYUt3D2j5/AZo84aATAQAA",
    Pbi3DGeometry:
      "rAgAAB+LCAAAAAAABAClVt9PgzAQ/l/qa2n6AyywJ6MjJvqwqIkPiw8sI1sTpAYbk2XZ/25VnIz1oI0hEO6ud98dd/3Kco8WK/W0e6tQju70Sj3qWq0RRgutGvOO8uX+59Wa6cxe6ID/NBGjdPb9sDc6vPy6XbVtubO+UcyIyKTAERfkkmcCUyJoZkWrF8mkWhLJhcTnYRgjccpHPFhMUs6TAA8YAyqCpSQWLD7XD7Gh9cdkQUNwFbCHP4ijDJ5wVxUjalf0L70zn75Dr7KTOMHx3ekPwnfafovhxRMpDoOAqTgn68TgiRA6cGEtnJgDABTY2tAmAkrya8g45MheCG6IlwEGmSCUcHz/rzfaBDhZ/+b7jbpfMwKn9J/sClFKIMNB8SGO9tD7MN80OY2iep/EU3xoT/0bVb5WpmpRTgnF6L5qNmbbCQ/alEbpphOf1fpouq3UZms6YV5XH/2F17rWNiC6mBeFLKT9u/gERSqqHawIAAA=",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8200",
    "Location Line": "Finish Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "2.94",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573589",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.18750641",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdlJzVZO0kFQR0kgg7iQWnRhW0nbAtE/O8tWFanbvPme7z38h6ySh+7q4IEdlTpjExXkwUGGWnrbpDk/Xh6wyxEHsg4WEqOsUQY2BfDiAvE+R8WRYvwl30yR1a8q9O2LTvf7x9rXV6UUy0kggsGe2Vr17zEgVzptJ88ypM+T2irdN34EkS/KWSwMeoxeQMhGazIkE+1d2OG4gnV3TOaDQEAAA==",
    Pbi3DGeometry:
      "AgQAAB+LCAAAAAAABACdU18LgjAQ/y7X6xxbajZ7ikqCepAKeogejIYNzIWNQMTv3ijLKNOMsbH73d3v/m2bDPydWKUnDi7M5E4sZST2gMCXIlZncDfZ/arVZKAX5KhEDErI4HboDfn24TZMkiDVvga1MWWsjximDqOIYJMw9I5Siq1+V+MWxSZzzH/xavYCLW1tu2eVHKV1Lf7B/Yq+cTdErM66mqNNFk11/zKBb91orqW2xgr+thOujfvjHGr68i3DNnNo8aaaY+q/NBbBkSuegEswQTDncagOhbCQKlBCxoW4FvunaspFeFCFMIn45dVwJCOpCaEz8TzHc/SfvQIQfWLeAgQAAA==",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8043",
    "Location Line": "Finish Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "3.13",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573590",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.1740602",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkpxpaT0UFQQ9FBA+lhxZDuxATqVEope9uoFrqydvOfsPM5D1kFZ67u4YEDq7CzJmudhYIZA6tf0CS9+MZDIuIUxkruRaCSiYiGMgM8iVlnIu/cKVi9QtnsSMsvvVp25Zd2BAeWyxv2usWEkYZgaO2tW8+4uR86THMHuUFrxPaa6yb0MI55SoisDP6NXkliwlsnHEh1T6NGYo3QJsEUREBAAA=",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABAClU1FrwjAQ/i/nawxJWxdTn0QtwvZQNmEPsoeKQQO1kRqEUvrfd2g3iy61ZZQ2vfsu33e5y61LiDd6VRwVhPBqNvrDpHoLBGKjM3uCcF1efxFmE3ygIjfPkDM2uXzwherrZ9s0z5MC9w75iHIpx8TzqM+8gDBcJHlwc06DsYdAwKkvhf8PwKFQuxvRL0KKG00jvh145G+67/mfyTqyd9D0y+V5CTq1xFmZLodqP+1fGv3b3i7euTFtNXIm2q8xvW5bB2Gct7lODsqqHEJGGYE3le3svjbejU2sNlltfurtL7RUere3tbFI1bkZODOpQUIYLKJIRALn+ht6v7L9JgQAAA==",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8043",
    "Location Line": "Finish Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "3.13",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573591",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.18715476",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaZr+eBIVBD0EETyUHloMbSAmUqNQSt/dQLUgCN529htmphhA1vrU3xTksHe1ls70jbOAQDpt/R3yYpjOYGAMi5RFy0U4eCw4jOgH5BSnTCTfMMIkzsQfOMeWn/pV11V92BAeG11dlVcd5AQTBAdlG9++xdH5yuswe5JnfZnRTummDS2UYppwBFujnrM3IhmCtTMupNqHMWP5AnGXUikRAQAA",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABACdU8uqwjAQ/ZdxG0P6sC9XohZBF+IV7kJctBg0UBupQRDx3x20Xr1qnSohycyczJnhJJkdYJyq6X4jIYKhTtWPztQCGIy1ys0WotnhYiIs2jjgyG6RpiVE+7zghOP8mtYpimSPubbNvcB2WNO1uBsGHhPcESF7Clu4B/YdgIbvOq0vgIoKZdjhohV6L2iuwFNHj8ADEcFPla3onqCp1wuhPSFYfWUqtfz8Euu/h9rF3ytKiEE2+tnF0JqSQvyrgP+tp5K1NLKASHDBYCTzpVmVzkSbxCidl+6vWvxBA6mWK1M6/Uzu7g92daaREBr9OPZjH//1CeGls44mBAAA",
    Absorptance: "0.1",
    Area: "19",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "5904",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "2.24",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573592",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "20.29644666",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkpv+eRAVBD0UED6WHiqFdiFmpUSil726gWvXkbWe+YWaLHvITHrqrhgy2dMKcTFeTBQY5oXU3yIp+PH1ACh4rmcxTydUsCGFgXyzkUajkP5YmIvpln86Rle/pRdtWnd/3xgqri3a6hUxwwWCnbe2al9iTqxz6l0d5xPOENhrrxo+ogAdRnDJYG/2Ywkp4Z0mGfK29GzOUT8Rq4D0OAQAA",
    Pbi3DGeometry:
      "+gwAAB+LCAAAAAAABACtV01rAjEQ/S/pdRuS/Yq7nkqrFNqDtIUepAfFRQPWFLsURPzvDX5E3WQySSmimNnZl7dvJjOz4y0ZTeXb5qshNXlSU/mqlnJGEjJSctV+k3q8PfzVl1lff8guOVtuOWP9/Y/+kt3H6ba79Xqy0ffylFaiSpOK0yzNi4RzmvfSKuGMioz3UDujGdPWDkqa0apg3PLOcipEaaNA/ho3L0Vq4Rt7F0f7lYXNx7AvaFlkHGFv0MO8o5RBsDtWoxeE0tX99PyBuhjdIRyITyBPMB4Q/xMfCB/Kp7N/1WOlrf3eaiLVtdtsrv3d6Gcunj0dClzv2UFxKO97Ijub9nZIF0ecvCwd+eFlCeGjPKF9O+o48sAfWftseiKI7hrIEo0tnguXNcHN3Z0fmNWN66lAMbuhWRdYTZBaCKEH5kpELflTz/oHPlB2efd1RzXuBAR7+2cFrDvHnhfcH+o23qeKnXUcVQayQ1XJqw+kA2rH+5l/msJ4hvZLrI8G6gbFHZ1uQqceqNthUxJ+Er19Aeym0BSGTWe4f+y+fh0Odv0O8SAnn03brEnNKEvIc7Oat4vj4kW1k1aq1XH5Lmfm0mMj54v2uBgsm59Lx3u1VBqQ3AyGQzEU+l3lF1Aq03L6DAAA",
    Absorptance: "0.1",
    Area: "15",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1500",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "3.07",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573593",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "20.52339334",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyGkpE1/PIkKgh6KCB5KDy2GNhCzUqNQSt/dhdqiF2878w0zWwyQ1+bc3zVkcMDa5Gj7Bh0wyNE4/4CsGKaTAoHgsQySlYq4CtMYRvbFyItk8J8pLkWU/LK5c2blPL3uuqqnfTK2prpprzvIBBcMjto1vv2IE/rKG3p5khdzXdBem6alERnyUMUpg53VryUsBTkbtEi17mntWL4Bk/lIsg4BAAA=",
    Pbi3DGeometry:
      "+gwAAB+LCAAAAAAABAClV99LwzAQ/l/iaw1Jf2XtnkQ3BH0YKvgwfNhY2QJzlVmEMfa/G1xbNen1S5WxsVyvX75+d7m7zo9sttRPh7eC5eyuXOrHcqtXLGCzUu+qd5bPj+e/5rIYmw87Bd+WSynE+OvHfNnppbntar9fHMy9MuSZysIgTXgaZyqQksejMAuk4CqSI2gXPBLGaqGEEc8SIR3vKOZKpS4K5W9w41SFDn5rt3GMX5q4fFr2Zp1EErBv0f28BykDsC1rqxeFYuvePL+nLq3uFA7Fx5MnGQ+Kf8OHwqfyqfFPjYzJyNa+traRsu02G9u/G73h0runo4C9p4XiKN//RHY21XZKFydOgKWTH4AlhQ95Uvta6jh5gCJrn83eCMJdPVnC2KJc+F0Turl350e/tRu3twIN2Q1mnWc1AbWQQvfMFe9a8see9W8+VHaBfbujOuwEeHqjWQF156HnBflT3QY81dBZx6kylJ2qSkAfSgdoR/0MTVOIp2+/RH3UUzcq7nC68Z16qG6HpiR0EkFfILspNYWh6Qz5D90X6XC2m3eIG714Lapiz3LBRcDui9262tSLh7JaVLrc1ctnvWov3RZ6vanqxWRbfPx0vC63pQFkF5PpVE2VeVf5BMo+OqT6DAAA",
    Absorptance: "0.1",
    Area: "15",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1500",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "3.07",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573594",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.34071056",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkGtumnkQFQQ9FBA+lh4qhXYhZqVEopf9uoNqDCN529g0zk3eQnfHY3gyksKMzZmTbihwwyAidv0Oad8MZDFJprmKhFhMluUwiDT37RaXieq7jL5rwREfTf3RMLj4Tlk1TtmFHeKyxvBpvGkgFFwz2xlW+fosD+dJjmD7IE15GtDVY1aFGhuxYMdhY8xy9M6EZrMhSSHUPa/viBa3+r78VAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdU1FrwjAQ/i/nawyJZm3aPolrGWwPZRP2ID5UDDXQNVKDUMT/vrC106nlWgkJuftyd1++S5ZHSNd6Ue8UhPBq1vrDFHoDBFKjS7uHcHn83TqYRW7AiZw9Y85Y9LO4CadVGzarqqx2sVwEVPhMkDF/olxIQRidsoDc+jmnQk4uEcEpl17wENJVpfVLKgNvci9Ti9zyukauc2E18Npdt8Ay9WWE9QJTb4hK3co+0tchr6Q/A0xfTBec79BO9VEY1+RfFfcnn3X2payqIGSUEXhTZW63jfFubGa1KRvzU2/+oBel861tjLhQh8uDc1MYlxBGcZL4ie/+/jc2nb7VSgQAAA==",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "4.73",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573595",
    Name: "Basic Wall: Lamelle 11.5",
    Category: "Walls",
    temperature: "19.72718155",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzFkadrYehIVBD0UETyUHloMaSAmUqNQSv/dQG3Fk7edfcPMFD3ktT53dwkZHFytc2c65SwQyJ22/gFZ0Y9nMESMCh6vFhhT5EsOA/kyTDhNEyH+Uk6FQPyhc+7Eyql+3bZVFzaEx1ZXN+llCxmjjMBRWuWbjzg5X3kdZo/yoq8z2kutmlCCSFFwAjsjX7M3YimBjTMupNqnMUP5BrzvxP4RAQAA",
    Pbi3DGeometry:
      "EjYAAB+LCAAAAAAABAClWl1v1TAM/S/l9RI1bfqR8cSnkOBhAiQepj0M7QquNHbRuEJC0/47Hettqd2T4wwhGHMc23FsNz7J2W1x+mX36fePbXFSvNt/2X3cX+0ui01xut9dH34WJ2e3D/8dhstnw5/ibjNTnvqyfPb3n+FvcXd+nPb85ubi9zC39q7sar956hvnQx82pavLuKlrVwbfUnLnuqruNq13dWwrTn8Q09aujVWvpDcuhsYrKYr+wN70LsSqMwpvw7DQUglBlvfBdXUMij26qitXFirpD+x959pQRS1d0kf26GIdGyM5Dj98qxaKdCIHtK5uW+1FSR6lAKWxcq2vlbsUeZQCtk6RUQAgMSwcZWh470Jf4ciDBsmsmQSBBIGhnS0ITgCJjPih75CPoFNlXE0TsiWBmIMaVJKibEwnNcoYFL0qB5g9sAzIxKYLg75GdSnXddgk5CToDCQp21ZYi9D+NK7xhtLF5JsjPlmPkZXIob6qna8a9S25p3e914J8VbkudOproidQQeuakT8FeZTuo/N9v2I+srJyZfT96rKWA+OEpnRl1eta6kN0oSv1etWEkR56V9e9+q7e0/uVU4vmPyrGFiFJwNLQuFCHtZhoXdsH7Tw14bjkaki+lT3TA+OEIaZD16gDH9xNRU/nHuRPbv8yXo7p+hgV65J0wM8jqTkwe8CA3DyYb/+qN3oluzgYdJjrwywLLVFlANtFvO2ofGdkDU2n/89wbhVUkpAFR+zFcJ6CaoOqAbN+KAzPsathdR1KSqwxsV9G57OSjPcEht28kOH01Xmvq/VI165aTphXIQRNyxaC1IAqG4I+1QbCP3ljcpOYMPlCrEDyy+/Hgl1Sdckn/oFmQk+vRLgcgduGt8G80Vg9WyJUjoImsUCzKOpfFQd85WpzQYhwSTCaJV1/Ac0DSFTCKuQSqCTfVzlOoVtl31x1SHxcNtNFAEkz6CH459ZzOWHuhheGKnaJF4jAnDq9NLtEO5dSZmAmzS5xuiV5al3T5KPDJrSJ0CWotNxXuX7V6Rq3CQmyOjhzVxG7QpMEXbqeLStXARZkXTDNBxAPKgapIGMYMteBnIDxiezBA1ZJ6SSF8qHnrNmergIwgc0bg1KJ5iQoteCiiKHRlnqCqs+6SnTvAyohuw5acjPZSzK7aQEV3MSdZTe4Z6EXapYvD+VeYuzgamv920ivtpb1n8nOg2nBN83EnWd3sN0xSm7TGYVxI/hInJAxhEwwaiVnnZ+CwsgedZLPk2MFo9Mw6DoEbuth02dkCLyiTh6C3BQUF30lgqYpKI7sEfIz5ZjBeIKII8gP9S5m4ILohWgXBeKFPwF2xPlJPBiADgx1JebkQ4aG05yYgS/04XkIXkqj28cE6p1srgHqnpgD9SSgxnw9+Re2cEb+8RuD+NBeaBbeY7SVhscTbCHGc2z6MIxTgST1Y1BKjNAD7fTtV/qQboYUluB45oszKB41bJROzGH8Vr3JMzU4PCOlFOVJdyvsmQNq3vOwJSQePUDidGKOubMmepMtFOh+oJF5TR5o2jld7GDe2z4oHgFglE7MYfxWvclOCLQ88I0Y6NXAi03rA08ChVKtiF2Ilx2lmU7MYfxWvcnGF/SsSGlma27FlJF0q1bELsSvw2mMTGwh7DadpiY22QbDSzHSZdufgtFrt/wrP6QCPisyDDCj6Ay7cgIbcJhB2kofDxJkJuMuVW7qI94tAhXwipUPMKP4DLNyMxRBII3pohZjKejBI3wUwwbE2rhqOEGqgA9v+AAzis8wKyfwD4eLhGaE43HcDwpiGuyq4QSpAr6M4QPMKD7DrJxAawhCA5rPN8Wr3cX37WF7U5wMVm+K99vrr4dv4y8f9oeLw25/Pf76eXc5Db3d7r5+O4y/vL7a/vqX8eX+aj8ILJ686V6/eBmLu/M/h/rvVBI2AAA=",
    Absorptance: "0.1",
    Area: "120",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "12000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Kalksandstein 11.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Lamelle 11.5",
    "Family and Type": "Lamelle 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "40911",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Lamellen",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Lamelle 11.5",
    "Type Comments": "Kalksandstein",
    "Type Id": "Lamelle 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "13.86",
    Width: "115",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573596",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.0869815",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjksLwjAQhP/LntPQPOjLk6gg6KGI4KH00GJoAzGRGoVS+t9dqFbEg7ed/YaZKQbIa33srwoy2Lla5870jbNAIHfa+htkxTCdaJARDaWIF4FkNOYJh5H8QiYkZSJhXzBgPKUJ59E//Iku3xOWXVf1uAMfa11dlFcdZCENCeyVbXz7EgfnK69x+iRP+jyjrdJNiz1YLaM4JbAx6jGbRYiflTMOY+3dmLF8AosuUhAWAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "448",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "44800",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "53604",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "573598",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.35314765",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzFsSmp/PIkKgh6KCB5KDy2GdiEmUqNQSt/dQLUigred/YaZyXvIKjp2VwUp7GxFmdVdbQ0wyCwZd4M078fTG2Yy4lESLgSGHFEGMLBfGEoeYyS/WMAliuQf+kQW7+pl25ad7/ePNZUX5VQLKXJksFemds1LHKwrHfnJozzReUJbRXXjSwTyeSwSBhutHpM5RiEYrKy2PtfctR6KJ4cwpp0PAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "49",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "4900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "15300",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3256",
  },
  {
    ID: "573600",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.56322085",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzFk+xPTehIVBD0UETyUHiqGNhATqVEope9uoLbqydvOfsPM5B1kZ3VsbxJS2NmzyqxuK2uAQGaVcXdI8244vWGGERVBEC+QhTTEiENPPhQ5nXMU/yCncRJHP/Ard6TFOGDZNGXrV/jHWpVX6WQDKaOMwF6aytVvcbCudMoPH+RJXSa0laqqfQ0yygUmBDZaPiezYIgEVlZbn2seWvfFC+VLUo4VAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "31",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "3100",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "9627",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3256",
  },
  {
    ID: "573602",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "19.99276683",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyFka5r+eBIVBD0UETyUHloMbSAmUqNQSt/dQG2LJ287+w0zk/eQVerSPSSkcLSVyqzuamuAQGaVcU9I8348vQEFjQTGa2SchhggDGSBIqEB5/gPhpTFIviBS+wEi6l+07Zl5zf4x06Vd+lkCymjjMBJmto1X3G2rnTKzx7lVd1mdJCqbnwLIsWIE9hr+Z69K5YQ2Fptfap5aT0UHxSSjCURAQAA",
    Pbi3DGeometry:
      "IiMAAB+LCAAAAAAABAClWdtq3DAQ/Rf11RWS7948lTZLoX0IbaEPYR82xCSG7bpsTSGE/HtN1+uNRzqaUZaQy05GZ86MZHkut8/q5q778fS7VSv1pb/rvve77l4l6qbv9sMftbp9Pv45/ttcjV/qJTlL3ltjrv7/GL/Vy+a07MPhsH0a16ZWV0XZJNbkurCpTYzOTJM44kpXaVYlttJpkbnquS5Lk1NxluuqqSpWewLPxt/GZrx8Qm90XpQFFTsUrdV5nWKfEB1xDE4GQHAwIRQHGjZGLsaZ4obCTOPJ+Qt5AgMYSMoIbDyLDxbkqc5KYx15YbQtUmoWaTvyo3qRaVMUpSNudGNTxydHPIGXqa5t6Rp15EeYsh5hXJtef6g0MignMXXzRJAwOe1FJDyCiY4XwgH0pbvHwEvpvA0dkUcxRjjwwTnTL7Spy/R0yqiY4i+0R6/Sosw94snZJYgjZ9W96LWuq8ZhPp+yJUjejFd93VDtUZzVHocIyKzswwAWEb95R8NiZ6Mdf3zEHfXwdopDDo8Lu4AcmFdPt38BpETDyS4AEYVA0jOPXAufP+k+zm4Jz7F7U0gXQAOAULQBFGgUi6zW+fiHZ0EsJ/Eh4u4M0TN2pm8a51Y7Zz5hsZNZMbGZYPw252yIgFD5DOLFnpM/gmK0qbKaqqeNLhsX/Jy6LlGk6gwXKp/UAcU53ydcqJym9bLoSrfOTVplex1/ZBZnYzYL+aAFyADaFIQjPVDRAeJuFngIwYFwdp5z4dLDP+PDUEgNu6Wn0DVxLMDDMeNA35ALgCmqDcHTEXe3AWzQhwBi/+UbdVNzBsH9FW4/BK8vIAZ3IDCJGg/+exfc0uChkfaUwtoA+43vLsAkqpYItxqCGEjbn+0L65QgPQZCQholW6A9AspxrooCINSkqD7l+jdhEAlvf1cAtXqEtTmBlhhErRuUy8MMHK6AHQ1YfmFOftMwC8BdwujMJ9pEdAMGmkaZQKBfBirqQOXMFO3IOekrHyYJuGPOQ9EAokAJuvgcXeGLVDYMYB7F4MPM7QC7Y5IXGPu6E05VUNLLWUXqsqENL7+sJhDbDSZObJrF1HZxeap47BZpFalfNuWC9WFs/Sm1G85lQWsBGeUmWbIeAiu/aH6G4GF3kpXLBoz8YI2xG853uexYMvtjsuMlP04cZRAoE2jU6WTlF834xGaFw41wyu90b8HsLJzF87MN7wgucmyL4OEUgZUzdBh9sV1hbREuUI7gm0R96ra/2qE9qNWYhiXqa7t/GB6nD9/6YTt0/X76+LO7n//1ue0eHofpw/Wu/fta8WO/60dA9e56va7WlXrZ/ANgGV6RIiMAAA==",
    Absorptance: "0.1",
    Area: "44",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "4400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "15997",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "7.64",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573603",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.17654611",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkTduYehIVBD0UETyUHloMbSAmUqNQSv/dhWpBELzt7Btmphggr82pv2nIYO9rk3vbN94BgdwbF+6QFcN0oiFSNFVpsuRC0ESlEkbyA7KYSqWiLygYZVIs/sA5tvzUr7qu6nEDPjamuuqgO8jQTuCgXRPatzj6UAWDsyd5NpcZ7bRpWmzhnHIZE9ha/Zy9gikCa289prqHtWP5AqxoauYRAQAA",
    Pbi3DGeometry:
      "phEAAB+LCAAAAAAABAClV01Lw0AQ/S/rNS6b76aeRC2CHkQFD9JDi0EDtZEaBJH+d1dNqtndtzNbKS3J7Ns3m3mTmen9h7haNrfvL7WYiot22dy0q+ZBROKqbdbdq5jef/xc6mV1pD9iG/1aDmOljr5/9Fds58O2481m8a73JpUsqiKP4jSVeVWUkZKpqqKdOU5lUaYT0zyg41hmk8SBtxbIHTzH2px8XQC0i92FV7lUkyJB7BbNgIf8cAf7/G4a88FSJdXPvbFjtzB2bOFt858wW2bo1sQXsoiz1DJXMqtK29yjbfZCZrlKnG6dx+zxwAz5eacnIgkjzw5asLa+Hb742PheGFeEgDR+Kf+vMODXL4JmCniCJJGlmjh26IU8yzLTw4AHjm00IPk2205zbcgcig0LJlEudQrFzEMiEhgCN/u49ltoGEmXKFAtXzRDteI+GH4CSpaAtPILaeFBsM3+SIWOfDG8pRi02T2zf4zes7OjJBxlPuPcIVVqr+EgbCJh9ttRYyJJYNF1djeODFS8cYkIqWIjdNjoSZZCkJoc0Sh1QEKETVrjmFCBBWbfnOsfgAMmS8/0BJo6l+ofxyWHq/B/HGSNZ8QKzlFGeWaF3T95kW2YdVzQNLgTJxSKPwXzpTV7KJQWtm/WDn+fDp8EApx75h9eJtI+yAVv5aGKNHzJQHEkzGQ20f/IRx7mkThtFs91V2/EVHNG4rJeP3ZP/c112y26pl33t3fNw27pvG4en7r+5mxVv/0FnrSrVhOKg7PZrJyVYjv/BD5wEaOmEQAA",
    Absorptance: "0.1",
    Area: "30",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "3000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8778",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "3.4",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573604",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.9724182",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyF0G03TehIVBD0UETyUHloMaSAmUqNQSv/dQLXqydvOvmFmih7yWh+7q4QMdq7WuTOdchYI5E5bf4Os6MczGJDThKNYIDIap3wOA/lAJmgsGP8PecLED/yOHWH5rl+2bdWFDeGx1tVFetlCFtGIwF5a5ZuXODhfeR1mj/KkzxPaSq2a0IJIMZkR2Bj5mLwsSgmsnHEh1d6NGconlBY61xEBAAA=",
    Pbi3DGeometry:
      "lBIAAB+LCAAAAAAABAClV11r2zAU/S/aqytky7Hi9Gl0DYPuoWyDPZQ8pNS0hiwuqSmUkv8+b05S2dKRjhdCQnx9dc61fD+O7t7F7X398+25Egtx09zXP5pN/SAScdvU2/ZFLO7e+7/dbXXZfcQ++bBcpEpd/vvpvmK/Oi77vNut37q1qZHZTJdJmmqZlcUsUVKrMskKmedKR81GmkybxEFJU5nPM7wgK2XR+5ELIAN6gFLqXM895iEv8P4IE9mnhY8XsAx9oFpJZdzH0rk0pTFR8wHcQTlGAxfMpSo90U8nAPF361TqpNuYFjgfSZF9avDIn8R3M634+8hupoXMnjQo+o1z82awwErAEdBkAm/8Y/zebFdhyDsSpQMDo/GV/3AFS+Emle1uvdyQ96neZpltPqXOCMWXUgNWMhqEHwsHwVsVEbQDfLfrDFCs2mfcc6ln5mz0sdmq/iG8dQPsGrs7KCKGGjGAjfbtEJjdxKT/j4IOYpP9O1xTwOzP+GgrpiQC1aFjbd47vuM5TQ17LwjwhlVH1W5MX8RA4nFj7RjQTOTMik4JSB6SSKB4p5c75EAKBCsZ2LKmNrk4NbeB1JbHGw7oLPi9+VtOrFtw05p8LXQfOe8EgvTcRH3ph0fnGMJOyU5CGAZ56WMqoUaJyXPO8YPVeBEhiuDRKYawU5KTUD1BXvqESog8PMljQ5ibE9TICU3o+DAgZSo9023aVSK+1OvfVVvtxKLzScS3avvYPh0uvjftuq2b7eHyV/1wuvW1qh+f2sPF9aZ6tR2vmk3TAYpP18ulWRqxX/0BQhiMJZQSAAA=",
    Absorptance: "0.1",
    Area: "17",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "6560",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "1.98",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573605",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.37721259",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjjELwjAUhP/Lm0NImtaYOhUVBB2KCA6lQ4uhfRATqVEopf/dQLWDDm7v3nfcXTFAXuOpv2lIYe9qzJ3pG2eBQO7Q+jukxTCdwSCWlKlkxaOELqRIYCS/jMVUKhV9s1hG4g+cU8tPedZ1VR8WhMcGq6v2uoOUUUbgoG3j27c4Ol95DKMnecbLjHYamza0cE65jAlsjX7OXsEUgbUzLqTahzFj+QJ2DIwiDwEAAA==",
    Pbi3DGeometry:
      "QAYAAB+LCAAAAAAABACtVN9LwzAQ/l/O1xjS9Hf3NOaKoA9DBR/GHjoWtkBtpAZhjP3vBtdM1zXkKlLaNN99+e4ud8nyAIu1fNm/CyjgQa3ls6rlBggslGz0BxTLw+nXmNnEPHAkP8htwNjk+2NeOK7ssmnbVnuzNswoy2MS8JhGWZQRRkOWE4sGIU3SsI9abhCYkV+z+7iPj/FpUJ4nMdqn5V+qsJiyLOFIbct2abv4w+rj8jmzo5SHg1t4MgzEeGnoCTngq/I73Y7J1OESk+gfw0Z0LSqM/yiltzSIXvYUeUxboI4LOiRXZ6A7BtWl6Lx8uPcC8+yn53xgOq2nbW7iO1m9CS1aKBhlBB5Fs9W7bvKkdKWlarrpq9ycTfdCbne6m8xr8fmbOFO1MoJwMy/LtEzNjf8FyrTc8EAGAAA=",
    Absorptance: "0.1",
    Area: "21",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "6363",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "2.44",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573606",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.43269754",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkpm2aehIVBD0UETyUHloM7UJMpEahlP67gWoPInjb2TfMTDFAXuOpv2nIYO9qzJ3pG2eBQO7Q+jtkxTCdwRApKlKeLLkQNFaJhJH8gCyiUqnFN5Rxqv7AObb81K+6rurDhvDYYHXVXneQMcoIHLRtfPsWR+crj2H2JM94mdFOY9OGFs4plxGBrdHP2SuYIrB2xoVU+zBmLF/CJnQWEQEAAA==",
    Pbi3DGeometry:
      "pggAAB+LCAAAAAAABACdVt1rgzAQ/1+y1ywkfkb7NLbKYHso22APpQ+WShtwZrgwKKX/+8Kqrk7PJCKKuY/f7y7eXVyf0Gor3o6fBUrRk9yKV1mKHcJoJUWlvlC6Pl1etZou9IXO+E9yyyhd/D70jc6b1u2urvOj9g0S4nMWYeb7JEyiGFPi0wR3Yi8kPPIYJGaMBNyzUbT4oMKaOOABdyBuPf4B0ZBQ7QCJBzCgYiqiMWKDGEyss49DnozEfxEP0PvWV+h9+4HC6GFHDEQP0gL2gyLpWw9gRqrN0sM6/nGYGdUwtT92RWv7SSY7a94GzKS0KlZT8kAkk+nA02b8s7k3jvsEdB+mU+Qz29k+c+Mkt286l8wN4YLkRoVdhRjE4PbZjW1ws93Pox6DPu8fRP5RqKJGKSUUo+ei2qtDs3iRKldCVs3yXew61WMh9gfVLJZl8X1teC9LqQHRzTLL4izW/xU/L8o10KYIAAA=",
    Absorptance: "0.1",
    Area: "30",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "3000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8778",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "3.4",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573607",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.94045938",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyE0Ma1pPYkKgh6KCB5KDy2GdCEmUqNQSv/dQLXqydvOvmFmih7yGo/dVUEGO1dj7kynnQUCuUPrb5AV/XgGA0+plDFfMB5TIYWEgXxgklIuBPsPZcLZD/yOHWH5rl+2bdWFDeGxxuqivGohi2hEYK+s9s1LHJyvPIbZozzheUJbhboJLYxRNhcENkY9Ju8sSgmsnHEh1d6NGconTF8LlxEBAAA=",
    Pbi3DGeometry:
      "0hYAAB+LCAAAAAAABAClWN9r2zAQ/l+0V1fYkh3L6dPoGgbbQ9kGeyh5SKlpDVk8MjMoJf/7tNV1bEmf7rQSmsan03efddL90O2zuLnrvj39bMVafOrvuq/9vrsXmbjpu8PwS6xvn19+2uH80n7EKTtLLoo8v/z3Zf/Eafs67f3xuHuyc3UpdVXrrFCVLE1psqKw/1WT6VzmtTbngVzq3Ipd/VHcyEKZ8iyuZa107atP8G/EmdhUqvDFLvfUl5r0MZ2lXfhaJJKReVMFgaCF4Cs7OMRyYjal/UHCvIhLJXOtPBBXPCo3UptiFeC9tEgtGDCKcdACp+F79Gf4YcNwBtcC4cKww8MOtNh1ZRpXXP09DoTwzG6J8Po2YfVKyabWK1+eBg54YzLIrJGmbgrGhHENXP1RnAwPcBqpqpV3njzxBBPWXxnZ+BsmGRySRzPCdl0ptQZslwTOh1mpwg9CESnCCJzJuf788C1wUuHD3D14P33FtAmSHgxkE0qPywGuCW8rzKRzx8bEI7YLEtofzuJPQYE1ARkA7KfINd9mrs2grhf73kQbT+Dhx1yUFlGAP4E2HVLpHZRGhBnE44cOlFt0+ToHCefqNGhQugLaZDm4VKaqPsaKMINWtKLE5UuoNKILTTpPkMpUucQoUZIDRqw6Q0kZhwWUaGGA5eZ90gLkxCr4kkktU1ak8wSdFcx+nAFmGwihICvQv+D2Amb3SIsEBiBb1FRFJtBdEnNt2W6KByY6nkb3WThPUUeFK49lQRQ76UjLqhq5Vwb8GwZO5UyKOdcX9IVEzCazn6AvQIi2+j8LRdBo81t4AAvKTI6c7uyhNtcqu3VgtOmojAA1ALuZSwrJnGsMVt6kq4rE25NtJj50ux/t0B7F2nozE5/bw8PwOD586Yfd0PWH8fF7dz8NfWy7h8dhfLjet7/nilf9vreA4t31ZlNvanHa/gEu9B870hYAAA==",
    Absorptance: "0.1",
    Area: "36",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "3600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "11997",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "4.13",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573608",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.06562103",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEktWmaehIVBD0UETyUHloM7UJMpEahlP67gWpBELzt7Btmphggr/HU3zRksHc15s70jbNAIHdo/R2yYpjOYBApTaXiSx4JmsiFgJH8gCymUqnoGyoaiST+A+fY8lO/6rqqDxvCY4PVVXvdQcYoI3DQtvHtWxydrzyG2ZM842VGO41NG1o4p1zGBLZGP2fvgikCa2dcSLUPY8byBdNzTXQRAQAA",
    Pbi3DGeometry:
      "ZgYAAB+LCAAAAAAABACdVd9rgzAQ/l9ur2lI1Gi0T2OrDLaHsg32UPpgaWgD1gwXBqX0f1/YbFdqwxkRxfu+3I/cXS6LA8xX+n3/qaCAZ7PSb6bWayAwN7qxX1AsDn+/jmZT98CR/CMTztj09+NeOC5PavdtW+2drpBUZjknnAnKZBoRRmOWkx7MOU1kdEFEwgGJHEF4PHRwTiORJl6YxzTKU+GDz05Rorex0Y7TLJYh8dxaf5Wba7hnxkuc7A91jMB4PpH+8WxsWDSIkbCGQio1DEZOiSdub7LCyxdk6nalwnvHqxHu3DtPwsYAenpHO0azhBLDuhSBO+tuXj/qaqesaqFglBF4Uc3Gbjvh1djKatN04oden6knpTdb2wmzWn1fLnwwtXEG4W5WllmZuXvhB3Kz449mBgAA",
    Absorptance: "0.1",
    Area: "21",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "6363",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "2.44",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573609",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.62155084",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEk/UlMPYkKgh6KCB5KDxVDuxATqVEope9uoFr15G1nv2Fmih7yEx66q4YMtu6EuTNd7SwQyB1af4Os6MczGFJFmZByznlMIyVSGMgHCkWjJOH/oZDx7Ad+x46wfNcv2rbqwobwWGF10V63kDHKCOy0rX3zEnvnK49h9iiPeJ7QRmPdhBbOKZcJgbXRj8kbM0Vg6YwLqfZuzFA+AQ7jSJoRAQAA",
    Pbi3DGeometry:
      "hAgAAB+LCAAAAAAABAClVl1rgzAU/S/ZaxYSrUbt09gqg+2hbIM9lD5YGtqAM8OFQSn97wud3ezMx3VFFHNz7zlHvR8u9mi+ki+7d4EK9KBW8lnVco0wmivZ6A9ULPbft2abTs2BDvjXcs0onR4v5kSH5Snspm2rnYlNchIl6QQzFpMoTxNMSUxzbMw5i5KgmRMexRwPUBgjkyxyB6QRyVjKbECjCWz6B/idOTPwadA5IPIvilPLacMVACUYiE95nFnE+8xD6KPZJqXv338mUICTwKq+/73PzeesDm9L1lwk3hkAZgiVj6PYHCCgl+ClBGb8fzIs6OyR4coKWymN3wAVH6il+LnBn8+XAy6d3rcMLLJgA7JyApr/ZUXpavEjR44V3tmXAHbIJIIMCy8vuG2HJ5SZ5neyehNatKighGL0KJqN3naLJ6UrLVXTLV/l+mfrXsjNVneLWS0++463qlYGEF3NypKX3Pw1fAEpVx3phAgAAA==",
    Absorptance: "0.1",
    Area: "8",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3102",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.92",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573610",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.34476859",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNIm/RhPYkKgh6KCB5KDy0NbSBmpUahlP53A30gXrztzDfMbNZDWqpr95CQwAlLlaLuajRAIEVl7BOSrB9PF/A4DXwWblYx5SKOYSBfLBLUZ9z7AwPKwh82l04on6e3bVt0bt8Ze1XcpZUtJIwyAmdpattM4oK2sMq9PMqbqhZ0lKpu3AYXVITRmsBBy/cS5sw5O9Toas1L6yH/ADhlPzEOAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "515",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "51500",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "48976",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "573612",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.81474694",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzyGErGltPYkKgh6KCB5KDy2GNhCzUqNQSv/dQG3Fi7edecPM5j1klTl3dw0pHKgyGdmuJgcMMjLOPyDN+/EMAYl8qZRcyYTHChcwsC9DxWPE+C9D5AIX+MOmzpkV0/S6bcsu7Adja8qb9rqFVHDB4Khd7ZuPOJEvvQkvj/JirjPaa1M3YURKHqkoYbCz+jWHUQRnQ5ZCrXtaOxRvOe0vYw4BAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "25",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "2500",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "3621",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "6906",
  },
  {
    ID: "573634",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.87362839",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzFs2vTXk6gg6KGI4KH00NLQBmIiNQql9N0NVCuCeNvZb5iZfICskqf+KiCFvalkZlTfGA0EMiO1vUGaD9PpDAuOlIeev2QYUETuwUh+0IDTGCP+BRMa+Tz8hz6Zxbt81XVl7xa4x0aWF2FFBylSJHAQurHtSxyNLa10oyd5lvWMdkI2rSthSMOYJQS2Sjxmc4yMEVgbZVyuvis1Fk9oqBciEQEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "49",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "4900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "15300",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3256",
  },
  {
    ID: "573660",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "21.07802957",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsELgjAYxf+X7zyGm5tTO0kFQR0kgg7iQWnoYG1hKxDxf2+gJp26fe/7Pd57xQB5rS79Q0IKR1ur3Oq+sQYQ5FYZ94S0GKbTG6IEU8bIhoQEM8JhRCsTMRY85n8Yw1HC4x+4hi6wXMqzrqt6v8A/dqq6Syc7SAMcIDhJ07h2FmfrKqf86Ele1e2LDlI1rW+hFIdBIhDstXzPZkIxiwRFsLXa+mDz0nosPz3MqWASAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "18",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "1800",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2900",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "6800",
  },
  {
    ID: "573662",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "19.34944357",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkTdI/T0UFQQ9FBA+lhxZDG4iJ1CiU0nc3UNviydvOfsPMFAPktbr0DwkpHG2tcqv7xhpAkFtl3BPSYphOb4hiHIlYbCjjmLAkhBGtMExwwDn9BxkmQvAfuMbOsJzrs66rer/BP3aquksnO0gJJghO0jSu/YqzdZVTfvYkr+q2oINUTetbaICpiAMEey3fi5mRBMHWautjzUvrsfwAMuBCehIBAAA=",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABAClU1FrwjAQ/i/naxauTdrY+jQ2i7A9yBR8EB8qBg10jdQwEPG/L8xq1VKSMkJC7r7L9+XukuUJpms1P+4lpPCh12qmC7UBAlOtSnOAdHm6bC2MIzvgTBrPS4A4+lvshPPqeuy1qvKjPRsnNBJhQALGKbIkJkgZJqTlDkLKYxESMaScIf8P0KFwcTfRjGIU8RtNE+8Cnvkf3C1+h2zH7Tto+t3FWQK/lnRWxiMpV7ZtDRfQrxA9uusn7PEMXcXwfChesva/vav8WxpZQYoUCXzKcmt2tfGlTW6ULmtzoTY3aCLVdmdqY1zIn/vAN11oSwiDcZaJTNh//QsjsmXpJgQAAA==",
    Absorptance: "0.1",
    Area: "10",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2900",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "3706",
    Volume: "3",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573663",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "22.35525872",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjkELgkAQhf/LnNdlzVXTTlFBUAeJoIN4MFp0YNsN2wIR/3sDptWp27z5Hu+9vIPsjMf2piCFnT1jZnVbWQMMMovG3SHNu+Ekg+dLLhMpF56ccT+UMfTsQwPBYxn+YT4FzKMf9pU60mKsXzZN2dIGeqyxvCqnGkgFFwz2ylSufouDdaVDmj3IE14mtFVY1VQTUEkUJww2Wj0ncyDos7LaUqx5aN0XL/PoZ7gSAQAA",
    Pbi3DGeometry:
      "CR0AAB+LCAAAAAAABACtWE1v2zAM/S/a1REsf8h2ehq2BgO2Q7EN2KHIIUWN1kAWD5kxoCj63yckdhJLehKZDcXamSL5SImiSN6/iruH7vvLr1Ysxef+ofvWb7tHkYi7vtsNv8Xy/vX4X7Oc3pgf8ZacKQuVpjeHX+afeFtPYu/3+82LkV2oQiqt82RRZFKVRZWkMk8b8ymb+kzMMtno0pAd9ryQVaUZAkf9eSoLdRCbw5L157IpU+XqifCzHQCGOuSTw0Q11zpw5leyaGo92mOW07LRNtnhVuZvnR34VXNBd+2cBDJZ6CpzBCZ6CMFnkUM+8WdS11lu85vz0rp2/bW5oRpoTwTYkMsi82yRszBtRWE+88KzdQAAGgR2DhoEjgYa6pwZ+/ShwBS9LsQYv45zk4SzEJWAGE7MnDDsk7iQSFVWMSSchbgfUCJgFfCDjxHYdlrwoGib6M4WRi4quNjOJRrZbfqY32SjGo9yPzfSDUznKbe5Q1ST23WpHN8R4KI0y7VytJzfMlv74eWwtUCyzxaEaSkZowXp5lkI/QcmIu0O3X5TiYnbsQfwX7wM/ots4Uazjg08ASBgZCjwF6lHamAuQBuH7IQOgw1yDj7OPyO7RShRjx38F/zAoICEF4FsklVX2ifMjXWgHoVEKH37ciZKsbAP8OZHToYNdDCRpDFjB5DE6v9Uq/r2BLx06NXx62bZRy2aIzsInwDOg4GUg+RNbWSC/keVzLn92wI7M1iWwfQGJSAGLORwAxtKrv6khSUgCG5XQ401M2fiYhXtCjYL5mWcOKEnhE4EbheUUFIrc7FxP81p2o6qpnIqdmfs8gvNNKJZkA8M+KF+4DE0NLCr0FQgwZ/kWG89vUlmxBN9rkUJdG5dfeXQLlJsoNoEHQUqM6+EJWonRR+pZWYjsJtyKIAh0GiBEN5WTOLZSRzDDm8wzfUX1xCYq5/c0IEAplkfIYcvx5k8z2u4lfZ23ig/wnr+WliSdvrLEp3usiH+wwCZ5cbs1aFP2eMz5/jslw09F0AQ9mHzhhFRXKD+X4c4ZOsjhQW/4gjfEaI94ftNHNvxtuCoe52Ij93mZzu0e7FMZZqIL+3uaXgeP772w2bo+t34+aN7PC19arun52H8uN22fy4ZP/Tb3igU725Xq2pVibf1X7MM2ZcJHQAA",
    Absorptance: "0.1",
    Area: "140",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "14000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "13789",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "27.79",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573664",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.11011545",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkaUmaehIVBD0UETyUHloMaSAmUqNQSt/dQFt/Tt529htmpughr/Wpu0nIYO9qnTvTKWcBQe609XfIin48gyFiCRaM8+UiiTFNRQoD+qI8xoxF/ynBhKTil36SZ1rOE1ZtW3VhR3hsdHWVXraQBReCg7TKN5M4Ol95HaaP8qwvb7STWjWhhlIcE8ERbI18TuaI4oRximDtjAvB9mHMUL4AOEVaIhgBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "16",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "1600",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2650",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "6800",
  },
  {
    ID: "573689",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "19.67080446",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAUhP/LO6/Lrq6t2ikqCOogEXQQD0aLPth2w7ZAxP/eglp06vbmfcPMFD3kFzx1dwUZ7O0Fc6u72hogkFs07gFZ0Y+nNwSCpsky4DGNRBzCQL4oYlSK+A8TVErOf9gcOaNyLl61bdX5dv/YYHVTTrWQMcoIHJSpXTOJo3WVQz94lGe8ftBOYd34Ds6oSBNJYKvVazLzkIqFDAmsrbY+2Dy1Hso3CmtmXA4BAAA=",
    Pbi3DGeometry:
      "vyQAAB+LCAAAAAAABACtmVFP3DAMx79L91qips21V3iaNtCk7QFtk/aAeABxgkqMTuw0CSG++wq79o4kv9o5JgTHxbH/tuMktnP2mJ1edt8ffq2yw+xzf9l962+7qyzPTvvubv07Ozx7/PfvQC6Ohp/sKd+OHNiiOHr5M/xmT+cj2/v7+4uHgbcwRWUX+YFdmMotytyWxtVNmQfjrVkubZsfOFMvnj99hsq0tq3C8dK0VUSOPzw/m4Q749rKhePWmcKWTZRQ18uI+gOhrdoItK1MUS6TMAKOUVSAIYKjuoWxpWtDDvRIwCAstHIlymFevWhRDM0P4mgkEAPo49srTFf7TbIL9ccNkhAWW8LrCBsxEoKVRGm0AnBy4R7q+uG9PwatH2M3Zukq+z+UUobmdMYVpql2XT4MVM6+fNraxc5Qn2NaPTQiIIwcrVm0RYSgBx/VZVHPi/RqD48GuoEj6pLFAN7E7oN6OA5cHfG5noO02iGAVmjHoIRdRtweEsbbsTDO1rFTgVZQ7/YpPjEYZtYcI1EZohM4aYUcjIFuR1HqgEv31c5BEj8WOEQpSoJgkO14+/7YwYi7RA8uWs4Gql2CG2cSNWMg2CEvlDNNY+3WuwEhUNfnmDB8wqSVyBEc4R5hu3E8USFH4MQNIVwPH4O00rtkSujIV6wVgvtODI8Mn6AWJWvlu306kKcUQ60uiUoHTwiGIN2U4moyUC8qyCpFgpdD+bvDGw7SeG/+lK57DMH4Zv42W9eGAVoQiBI5cCXQr3tgBJ4Ch5OjROsIANcIkBFBrdK+AGwCeZWjI3lJ55oCUqsiFIUcUvWHWoWEdFHa0pNaEkH0I0G7vek8IGipu+WJwdIvPl3bO5O6XrTjsPmDHKkGUPqGBVFCzkUnsgyOyRjWiJhnY/o2wyFVlercMV0rdUkbloK+KOo9KBoGoag4BxaomNFy2pMsSsEhRQmmumLRxRwyBjYePVHJrVaURAzYhKWCne9PKr/nMmNsCkDtn4yBtf8cB/ZCobtIHIjB+QyJQg5aQEWXW1Iq4Y6WrnvcAglXhFScituMb5v5Cka42udbyZDRphVNIJteOMTxtxUUalghMxMzOTGnl9JRfiKRCengyOFj4BOJTNCWOYraTgTfOwVlcPkZVaxm9BW4b+A+b7iAgW0VmSBqJXLowcUECt+a8G1DTv7FOkJqsnNrM7nbyxjYUZYJolYihx5cLHvkQknbPp17ZcM3Gong9zxlcOQIn5TSX8CgE5vc7dWDa4oxqXx7DX6eZx+7i5+r9eo+Oxzuyjz7srq7Xt9svnzt1xfrrr/bfP3RXU2kT6vu+ma9+XJ8u/qzO/FDf9sPArN3xycnzUmTPZ3/BXhIfXm/JAAA",
    Absorptance: "0.1",
    Area: "24",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "10889",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "4.17",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573690",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.42510634",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACNjs0KwjAQhN9lz2lI0tg/T6KCoIcigofSQ8XQBmJWahRK6bsbaLV487az3zAzRQ/5RZ+6u4IM9njROZquRgsEctTWPSAr+vH0hkDSNFkGQtBYhgsYyIy4pKFkf0AepfIHzqEjKj/Vq7atOt/vHxtd3ZRTLWSMMgIHZWvXTOKIrnLaTx7lWV+/aKd03fgOzqhMk5jA1qjXZOaCyigWBNZo0AfbpzFD+QbMQVjOEAEAAA==",
    Pbi3DGeometry:
      "4hEAAB+LCAAAAAAABACVV99rwjAQ/l+y1xiaNrVGn8amDLYH2QZ7GD4oFg04O1wZiPi/r5uta5t+zQXR2rvcffcjubu8n9h8ZV6Pnykbs8dsZV6ynVkzzuaZ2edfbPx+uvwt2MGk+LAz/6cMZBBM/n6KLzsvKrHbw2F5LGQDEUQy5oMwFImKYi61GI2k5gMlhvHv88oIhRomIbcESnoodNRBjoSWOnIvR7DFUw9jbcOWAm39rvUQADoMLPUFVkLpSNnrkR4AS7SmMr6NWtFlIGSotNtMLFAxlAhkmHQwIhGEI2VD2AxgbBUKaKyFXUkgTSB6GAD6gJD9baVjOJMH3IM5rSHLoVadyBcGlOgwqanKYtjJbmpqY3fFyQHRkb1+/64Y0HGE0XYDarK3IE0PPbBAk13HGstrlaN3eb+WWtXrp5dq6tW2wWib4wgbwkVqUJg91Vvmd1TzBh0KkBEcCUBZR+n1KNvoYLqLAkWCNFzA5gzDBBloRyJoVDwJHRdWEO8WjVLqOYGRdgZhJ3k7jABIhgK/QIGCQwTsv6hSU84yaZRDdGSqd09BAggAViOKa6QYEVymAZNMpZ18UhHp3zPuykaeLLz2JWXjO48JZVQE3cVvGAC60c2IQO81hj6C9MM6GgGhcTimT2eHpd+YnBMuBRxKEC9HFAZxIKdMuQ5w50UV9SMEvuDs3iw/0jw9sHGRZc6e0v0m35Yvz1m+zE22L1/fzPrKekjNZpuXL9Nd+l1feJftskIhu5nOZsksYefFDx+Fq0XiEQAA",
    Absorptance: "0.1",
    Area: "14",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "5889",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.49",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573691",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "19.16159292",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzEkbfrrSVQQ9FBE8FB6aGloAzErNQql9N0NtBZE8Laz3zAz+QBZpS79XUIKR6xUhrpv0ACBDJWxD0jzYTqdQVCR+GK9EpzGXhjBSH4ZDygLYv7FfJrwxP/PlsziU73purJ3/e6xU+VNWtlByigjcJKmse0szmhLq9zkSV5VvaCDVE3rSjhz4+KIwF7L12zmHhVh5BHYokYXbJ5aj8Ubvhi43xABAAA=",
    Pbi3DGeometry:
      "hgcAAB+LCAAAAAAABAClVVFLwzAQ/i/xNQtNm7amexJdEfRhqODD2MPGwhaojdQgjLH/bph16rnsrkhpk3z5ck3uvrvMdmy6tE/bV8MqdueW9tE1dsU4mzrb+jdWzXaf3TCdjMPD9vwbGckkGR8+4WX7+deyq65bbMNaJZTOFB+lqZCFVjy0usg1h7hMhSrK9IjLXGQqTwfjMfsQVzJ0LosoDu0HXqmy/JT9A07lQ/uZ0FJnf/cPcciH54I4lX/G/q/9QxzyoT8hTuXH/BmLO3ZeKj5Ub7F9xs6L+Q3jE/R5UueYrqg4lr/U/MJ0RcWx/I35AYv7UP9g9SemHyxfhuYRVSdYXKi6pcbrH/XzbH0bWvewuhH5b7jPbuzixXjTsSoRCWf3pl37TT94cH7hrWv74bNdHadujV1vfD+YNOb9J/HaNS4YZBeTui7rMtybH4T2jdGGBwAA",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8159",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "4.37",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573696",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "21.89836129",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkafqTehIVBD0UETyUHloa2kBMpEahlL67gVapJ287+w0zkw+QVerS3yWkcLSVyqzuG2sAQWaVcQ9I82E6vYFyHHCSrFeM4ZgHIYxoAQUOBaH/IY0E/4WL2AkWn/pN15W93+AfO1XepJMdpAQTBCdpGtfO4mxd6ZSfPcmrqr/oIFXT+hZKMBdJjGCv5Ws2U4Z5FDMEW6utDzZPrcfiDS+4NmIUAQAA",
    Pbi3DGeometry:
      "+ggAAB+LCAAAAAAABAClVl1LwzAU/S/xNQvpd9M9ia4I+jBU8GH40LGyBWojNQhj7L8bZje7Lbe5QUo/0tNzT245NzeLHZkv5ev2syYFeVRL+aIauSKUzJVs9RcpFrvfRwPzqTnInv69mQScTw8Xc5L9+5F223XV1nCDmKVpLugkDFkWRwkNQhanWUgNICKRYADB8jwQ9CqUuYs0ESOMjOVxFFhD+WsAeVxpHAHBEsFtADgrELgMBc7qBIAMtIYtjyAVsTUPB2DROAC2WZ0zBgkiGaAGmMfADJfAuTjMsPjqv3mADLQGptTA4gRDYX+JUxxfH/6Gc3oX43ZkGaAN5y5O9KzcGiP2cQPItQSzWI6Lexlu3LtwN/CxKLqcwf7h39UADXBlwADIdodpRQ5xn+JE9UGzh7iX1Uet644UnHFKnup2rTf94FnpSkvV9sM3uTpBD7Vcb3Q/mDX19/DDO9UoE5DczMoyKzOzV/kBVOTNi/oIAAA=",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1600",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.49",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573697",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "20.57353504",
    Cost: "0",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkMemfJ1FB0EMQwUPpocXQBmIiNQql9N0NtBYEwdvOfsPM5D3ISp+7u4IMDq7S0pmudhYQSKetf0CW9+MZDDTFIiV0taACE5FQGNAPyBjmIuJfkBFMI778A+fY4lO/btuyCxvCY6vLm/KqhYxgguCobO2bSZycL70Os0d50dcZ7ZWum9BCCeZpEiPYGfWazDSMiWKGYOOMC8H2acxQvAHmz5YpFAEAAA==",
    Pbi3DGeometry:
      "dgUAAB+LCAAAAAAABACtlFtLwzAUgP/L8TULSZq0pHsac0XQh6GCD8OHjoUtUBupQRhj/90wu4uLabopJW1Pvp5rz8lsA9O5fl6/K8jh3sz1k6n0AhBMja7tB+Szzferw2ToLtii486AEjLc3dyC7etebdQ05drpUomFJBQNGMMZTwSiDPM0Y8gD7ilTIY+ACpxwwa4AQR97wAimKU92gKaSH0ydgh9ReRpBU7+BoKnuqDxwnqAH+ocb1fCqG/yDwaguz+Nc4w8+og0X9BHMPFqr/u3zDz4un4+uhusG0QTj49y77PEWjY5BtH1Czt35davLN2VVAznBBMGDqpd21QqPxpZWm7oVX/TigO6UXq5sK0wq9Xn64dhUxhmEm0lRZEXmzskveQ9FaHYFAAA=",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2255",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "1.26",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573700",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "19.03774967",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkMemfJ1FB0EMQwUPpocXQBmIiNQql9N0NtBYEwdvOfsPM5D3ISp+7u4IMDq7S0pmudhYQSKetf0CW9+MZDIxjkS75akEFJiKhMKAfkDHMRcS/ocA0isUfOMcWn/p125Zd2BAeW13elFctZAQTBEdla99M4uR86XWYPcqLvs5or3TdhBZKME+TGMHOqNdkpmFMFDMEG2dcCLZPY4biDWDGxNMUAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdU02LwjAQ/S/jNYY0Ji2tp0Utgh7EXfAge6gYNFAbqUEQ8b/vsNYP7JapS8jH5GXmTd4kyzPMVvbrtDeQwMSt7KfL7RoYzJwt/AGS5fm6RFj0scGFPXa6gRD93wE7XL5vbh9lmZ3QVyqu455iXSl5EMaKBZKrMJKsBuAchzp+AIHmPaXlP4BGjjug0Y70H6FuQC2rV6AWiuSgyRvvQYZqnxVZD1LE9lo1qvt+adu/ktbktLqkJGS67xeKVpeU5IUD/+TQZjvjTQmJ4ILB1BQbv62MufOZt66ozIVd36GxsZutr4xRbo7PBwcudxgQOqM0jdII//4P3Sd/YEoEAAA=",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2255",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "1.16",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573703",
    Name: "Basic Wall: STB 20.0",
    Category: "Walls",
    temperature: "21.11257305",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0Mf31JCoIeggieCg9tBjaQEykRqGUvrsLrQVB8Laz3zAzeQ+y0ufuriCDg6u0dKarnQUC0mnrH5Dl/XiigXMaCp6uFniIMBIwkB9QMJrwKP6GS8rSP2wOLT7l67YtO1yAj60ub8qrFrKABgSOyta+mcTJ+dJrHD3Ki77OaK903WAJC6hIk5jAzqjXZGbYF8WcwMYZh8H2acxQvAH5L1+iEgEAAA==",
    Pbi3DGeometry:
      "OAQAAB+LCAAAAAAABACdU8GKwjAQ/ZfxGkMa09bUk6hFcA+yu7AH2UPFoIHaSA2CiP++g3ZV6papS0iYmZe8mbxJFieYL+3ncWcggZlb2g+X2xUwmDtb+D0ki9PVRFgMcMCZ3SPdQIjBZcEJ5+/fY8OyzI54VkoeKqlZVwVc6X7EAslVFEv2BGBAR6G+A2jEqhf+A2jMcQN6PNB/MVXxp5pq8ToPxU/mbbwBQdS6ILINpHZtNWrS9PV2tn8ZLVOTqpJikLW+2iBSVVKMWgb8gWObbY03JSSCCwZvplj7TeW8O59564rK/bKrGzQ1dr3xlTPJzeFx48jlDgmhM0nTOI3xp/8AsGJEezgEAAA=",
    Absorptance: "0.1",
    Area: "18",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 20.0",
    "Family and Type": "STB 20.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "5904",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 20.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 20.0",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "3.66",
    Width: "200",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573704",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "20.607992",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI2sT+eBIVBD0UETyUHiqGNhCzUqNQSt/dQFvFk7ed/YaZKXrIL/rU3RVksMeLztF0NVogkKO27gFZ0Y+nNwSCpsky4JJGQoYwkC+KGI2F/MMEjWPOf9gcOaNyLl61bdX5dv/Y6OqmnGohY5QROChbu2YSR3SV037wKM/6+kE7pevGd3BGk3CRENga9ZrMYURTyTiBNRr0wfZpzFC+AVYEQGgOAQAA",
    Pbi3DGeometry:
      "Eh4AAB+LCAAAAAAABAClWE1rGzEQ/S/qdS2klfbLOYU2ptAeQlvoIfjgkCVZcL3FXQoh+L9309qKK+ntjNYEh6xfZt5oNCu9mbsXcXvffXv+2Yql+NTfd1/7bfcgMnHbd7vhl1jevfz7c4TV1fgjDtnbNwut1NXfX+NHHNYns+v9fvM82i6sLAvdZAtdSGOLPMuNbAqlM62kzi0HMFqa0taZNlLltY1YWKl0XkUA38K5GqMq6xi5lY1pCgbgXFWytkZHLBpZNCoG+BZnUYF1sMN1rthJhOTGyqoqGwwEW+ss5pCDdcCoEAeMClcie2th+ZzlCrhipx2WzxkHIIfhQlfIIleyMl64dW6ncjWRErCD7HBPKYFRTQG6tIbhygGv4TYm4soHziyKxsRclbLRtoxktxijqiKHTGDBiQqQQ45G1rqO7bkPnCyMklaXkRcHpx2G6+/HqRiCdThgwoK5UQ7wUzKfHL5ROCWwGNB+BGk/cUAAL/ByclgMNMdE2pkbRb9REwUHDrKJQwYcGS5Xr/FrHcnVEYAW4To8VwEQHgAeEJC77KJwMTl7gWElcsMNgPD98KOCFm5rPQCnJJmDv/LwAPBcvd2cPrlvEepEysJxOFHkuXrTPj6HbxEqMt/CKRkKCLUPt65grjAHWkew8lAO+uRsVzC7ZJXgdbDTDi1IAJcPKrgASC/RUGxDIL35CV1BC6pRTAg33RWzSyVbZEZTPfsAIDmwHEQCEt+DCIAXCyaHNyfU1FBlwMtrwgKocOgKhpseFU0OdbvvCnZFdB8VuopbMMYiMCq/dpNd8WcytL6CTQPSu1OaIbUrojm45LCVmbqd461+Ogdc+RQ5HFMlDiAgB5YG9CgMuuIOz/iChTzb4REOyRltH7f/YABccobkpK5Ueg7HVq8Jepc9lKWBi4UwnzxhQp/eTSRouERZG3AkkEMLSggnAFRUtMXl8py87vBEmNZwsweN5ACCLyBpDjhCogEqKtqCTU6rV1rv+uT0TGb2LDwEvNZyxkAoeaTHAKioaAs2OUdTUyr8f/J1Jj50mx/t0O7FUkmVic/t7nF4Oj586YfN0PW74+P37sFBH9vu8Wk4Ptxs29/n//i+3/ajQ/HuZrWqVpU4rP8AkG+4ABIeAAA=",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "10889",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "4.7",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573706",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "21.65358213",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NI0rQ2dRIVBB2CCA6lQ4uhDcREahRK6X830Cp1cnv3vuPu8h5kpc/dXUEGB1dp6UxXOwsIpNPWPyDL+/EMBspxxEm6WjCGlzyKYUAzKHAsCP0PaSL4L5zFjrD41K/btuzChvDY6vKmvGohI5ggOCpb+2YSJ+dLr8PsUV709Yv2StdNaKEEpyxJEeyMek1mFmERE4pg44wLwfZpzFC8AXPXEFYUAQAA",
    Pbi3DGeometry:
      "+ggAAB+LCAAAAAAABAClVl1rgzAU/S/ZaxqiiR+xT2OrDLaHsg32UPZgqbQBZ4aTQSn97wurc7bL1RuGKMbjuedeOTfX1YEs1/p5/16SjNybtX4yld4QSpZG1+0HyVaH062F+dwe5Eh/n8wCzuffF3uS4+sP7bppir3lBpLFcaroLAxZIkVEQ8FUxANqASVUhABEwEQsU/onlJAsSWI1wkhYKkXgDOWvAdRxqdEDikWKuwAwKxC4DAVm1QMgA63hqiOIlXTWMQ64NE6AI6tzxqBAJAPUAOsYmOESOBcHGS5f/bcOkIHWwLQa2JxgKOQnmRZH94e/4aa9i3E7sg3QhptuTnRW0xoj9pkGkHsJZrMcF/cy3Lh3wWngZVF0O4Pzw3+qARrgzoABkOMOM4rGxb2aEzUH7T/ErS7eyrZsSMYZp+ShrLftrls8mrZotam75Yve9NBdqbe7tlssqvJz+OKNqYwNSK4WeZ7kif1X+QInf/Tc+ggAAA==",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1600",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "0.52",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573707",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "21.17817245",
    Cost: "0",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABACFjlELgjAUhf/LfV7jbjpRe5IKgnqQCHoQH5SGDtYWtgIR/3sDTQiC3u653+GcUwyQ1+rc3yWkcLC1yq3uG2uAQG6VcQ9Ii2E6vYElVCTI1ismKIqYwUh+QM5pKKLwC3KkLAqDP3CJLT/1WddVvd/gH1tV3aSTHaRIkcBRmsa1szhZVznlZ0/yoq4L2kvVtL6FIY15FBPYafmazTygiUBGYGO19cHmqfVYvgG6oLAdFAEAAA==",
    Pbi3DGeometry:
      "dgUAAB+LCAAAAAAABACtlFtrwyAUgP/L2asVjZpg+lS6hsH2ULbBHsoeUiqtkMWRyaCU/vdJl15WZ0y7EQw5fjlXz3G2gelcP6/fFeRwb+b6yVR6AQimRtf2A/LZ5vvTYTJ0D2zRcWdACRnuXm7B9nWvNmqacu10qcRCEooGSYIzzgRKGJbCbXiAcZxlqTwCKjDjIrkCBH3sQUIwTTnbAZpKfjB1Cn5E5WkETf0Ggqa6o/LAeYIe6B9uVMOrbvAEg1Fdnse5xh98RBsu6COYebRW/dvnH3xcPh9dDdcNognGx7l32eMtGh2DaPuEnLv761aXb8qqBnKCCYIHVS/tqhUejS2tNnUrvujFAd0pvVzZVphU6vP0x7GpjDMIN5OiyIrM3ZNfK7ER+3YFAAA=",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2255",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "1.3",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573710",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.09719826",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjlELgjAUhf/LfV5jm5upPUUFQT2MCHoQH5SGDtYWtgIR/3sDTQiC3u653+Gck/cgK33u7goyOLhKS2e62llAIJ22/gFZ3o9nMDCORRrx1YIKTERCYUA/IGOYi5h/Q4FpvBR/4BxbfOrXbVt2YUN4bHV5U161kBFMEByVrX0ziZPzpddh9igv+jqjvdJ1E1oowQmLEwQ7o16TmUU4FYQi2DjjQrB9GjMUbzyp4ucUAQAA",
    Pbi3DGeometry:
      "dgUAAB+LCAAAAAAABACllF1rwjAUhv/L8TaGNB+G1quxWYR5IdtgF7KLikEDtZEaBiL+94Wt1bE2JmWUlp4+ec/LOTnN6gzLtX47HRRk8GzW+tWUegMIlkZX9gjZ6vzz6jCZugsu6PZlnBAy/X64Gy4freyhrouT01KORco4GicCMy4oYhxLOUlRB1CGU0GSG6AUJ5OUd4E3lVfRgkEKyZnwK/rAfYXX4wqEWyhFT4Et6Hj8BZ1UQY+wubeOYKp48+g9Dyu85t62e7c22Pb4jfr/+ITNY/6PgVMSHLhBdfS33dvEIIifqyBoPNz59aSLvbKqhoxggmChqq3dNcGLsYXVpmrCd725ornS251tglmpPn8vfDSlcQlhNMtzmUt3Tn4BZeoOnXYFAAA=",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2255",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "1.3",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573713",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.60262589",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/LuuqmdooKgjpIBB3Eg+KiC9tu2BaI+N97oQlB0O3N+4aZyXpIS3XubhISONhSpVZ3tTVAILXKuDskWT+eaOCcioj7qwUeQSgCGMgPGHg04mL5DX3Kwlj8gXNs/qlft23R4QZ8bFVxlU62kDDKCBylqV0ziZN1hVM4e5QXVc1oL1XdYIvH3sURgZ2Wz8mMxXHIPAIbqy0Gm4fWQ/4CbJAP9BQBAAA=",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdU00LwjAM/S/xWku3bqubJ1GHoAdRwYN4mFi0MFeZRRDxv1t0fuAcmVJamr4mL31pFmcYr9TstJcQwVCv1FSnag0Exlpl5gDR4nzfWpi17YALeZ00Hcbat8VOuCwfbp08T07W13Vp0HI5aXoO9cJWQFxOQ585pARwjwoRhC/AboTH/T+ASo4nwCnzw+BLqAdQyuoTKIVCOXDyynegoepnhdYDFbG+VpXq/l7a+r+kNjmuLioJmu7vhcLVRSX54LA92VPJThqZQ8QoIzCS2cZsC2OiTWKUzgpzrtZPaCDVZmsKo5/K4/vFrk61DQiNfhyLWNjevwIOveWGSgQAAA==",
    Absorptance: "0.1",
    Area: "19",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "5904",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "2.17",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573714",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.74796738",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjksLwjAQhP/LnmPIg6YPT6KCoIcigofSQ8XQLsREahRK6X830NqDCN529htmpughv+Cpu2vIYO8umDvT1c4Cgdyh9Q/Iin48g2EhqeBMLrmUNEpVDAP5AZmisYq/oKBKKvEHzrHlp37VtlUXNoTHBqub9rqFjFFG4KBt7ZtJHJ2vPIbZozzjdUY7jXUTWjijiVAJga3Rr8ksJE0jxgmsnXEh2D6NGco3wa8G/BQBAAA=",
    Pbi3DGeometry:
      "JgoAAB+LCAAAAAAABACVlk9LwzAUwL9LvHYhadqk3U6iK4Iehgoexg4bK1tgNlKLMMa+u1FTp0vf8kJpSfrr+5u8l84PZLbSz/u3mozJvVnpJ7PTa5KQmdFN907G88PP0GI2sRc5Jqc3I87Y5Pthb3Jc9GLXbbvcW9mRoClnIuFc0ZJJnqSCljnjyQmktMjybAA4CZFRpWR5AkLQvJTKB7ygWWEHvioH8BKgjR7g3Y03DgMwiaBxMLsO+BIXVGWyuAA8G0xRlmcDueqBpwqWkF8pkTFxQF4F44jwCowDcrcHoI2oOMDI/695SqWQ6cCm7oHn1TnwVIHAqw+0cfyaB9cDXPNwHGANBgPEpwTdfeKbJd4rOHKwyYBtCdpwl6o2sji9+gD3Lro48aq8UgtLnHfReBtgSsKqwBMHfUYFO0PwEMZL4EGwlwS7D77UQK/ie2L8hgsCZ8P+b93q5Wvd1S0ZM8oS8lA3m27rJo+mW3baNG76ote/6K7Wm23nJtNd/fH3wxuzM1YhuZpWlaqU/a/7BDdCyzsmCgAA",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8178",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "4.77",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573715",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "20.57688252",
    Cost: "0",
    Pbi2DGeometry:
      "FgEAAB+LCAAAAAAABACFjssKwjAURP/lrmNI0odJXYkKgi6KCC5KFy0NbSAmUqNQSv/dQFsfK3d37hlmJushLdW5u0lI4GBLlVrd1dYAgtQq4+6QZP14esOChlhQFq0oXWJBYgoD+qIMCxawf5DjkJPgF35yZ5rPA9ZtW3R+hX9sVXGVTraQEEwQHKWpXTOJk3WFU374KC+qeqO9VHXjayjBnMUcwU7L52RmARYRoQg2VlsfbB5aD/kL2k11XBYBAAA=",
    Pbi3DGeometry:
      "PA8AAB+LCAAAAAAABACtV11PwjAU/S/1dTTtPjt4Mgox0QejJj4QHyAs0ASZwcWEEP+7VXGDrqfthiGQjbNz7+ntvbd30z25n8un3VtBhuS2nMvHci0XJCD3pdxU72Q43f9eKpiN1Id8Bs0/A87Y6OdHfcnnyx/tcrud7RR3wGPK8jAKOM9ozlIeRJxGaSyCAU8oz/O0QcKI5gnjwTcnDZPEjCBr/hzsJ4pplqW5QVuD2BQghFMuhDAhjGZxkpv8MPWIMCrAHOwHa8PW+kTHtqfdo6MjjTVddY2kNEm4SUBEQ85MWaAz6sVAU5DRYSk1ktI8FJ0z4BQ5UnZqrAmYxT9Ypb/kHl6OggyWD/dLB+B+ecSrQ2W2/QsaC3VhMOZEaje6MUMq6ZSmxvw50A1eTF2vLUT3jzmG/vMfq7Fw/P2499O7Y/gAoGJw/GH+WdLMI8/7+PG3hjvDOS3Le8csQwA+mGzp7BwpcAl04jhVtwMNeh3sjrjT2GYd5wSgW3P385Z/eM5BCnRiOwK6D1q4zWCk+2Is0mx9DuyM+9h0VZNbsTvHnOXXJ8g+JetR5nhow8d2h7nBA2mdTT0Gh16zvgfi1ObD8VdwbuM0KlBvoddy9lpUxZYMGWUBuSs2y2p1uHkoq1kly83h9lkuauimkMtVdbgZr4uP4wevynWpDJKL8WSSTTL1tvsFfIaPjTwPAAA=",
    Absorptance: "0.1",
    Area: "10",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3654",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "1.76",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573716",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.31146344",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkqUl/PIkKgh6CCB5KDy2GNhATqVEope9uoLUHEbzN7DfMTt6DrPS5uyvI4OAqLZ3pamcBgXTa+gdkeT/KEFhQjmmaihWlSRARgwH9okTgWMTxF11iwTj/R+fm4jNh3bZlF3aEw1aXN+VVCxnBBMFR2do3kzk5X3odpo/2oq8z2itdN+ENJThhIkGwM+o1hVmEU04ogo0zLhTbpzFD8QbbLyvJGAEAAA==",
    Pbi3DGeometry:
      "QgYAAB+LCAAAAAAABACllN9rgzAQx/+X22saEn8kjX0aa2WwPZRtsIfSB0tDG7BmuDAopf/7wuZWscaoRRTPj9+7XHJ3qxMsN+rt+CEhgSe9Ua86V1tAsNSqMJ+QrE6/rxaTmb3gjC5fJpSQ2c/D3nBe/8nuyzI7Wu2ExpgKwRAlDEdTwlAQYhETiq5JGGHOmagRyrEgjI4i7jgXEmEWxHHbCpqkRcMxiSPepnETr7ch5DrTJnGvbYymTqZBEPY509sy9deOfw+GxBmi6TpT3+64q7ejEr1V1UdzS5wx3eju7SH71kW8ndWSaV9vQ/Jx94+f9Kle/3xrxLGzeK6ygzSyhIRgguBZFjuzr4wXbTKjdFGZ72r7jx6l2u1NZSxy+VX/8UHn2jqEu0Wa8pTbmf8N7bH4mEIGAAA=",
    Absorptance: "0.1",
    Area: "11",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3482",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "2.01",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573717",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "21.62146202",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjksLwjAQhP/LnmPYpO96EhUEPRQRPJQeWgxtICZSo1BK/7uBPtCTt539hpnJe8gqeekeAlI4mkpmRnW10UAgM1LbJ6R5P57OsGIBRcbWDEPqxxjCQL4gpwn3+D8YUQz86BcusTMs5vpN25ad2+AeO1nehRUtpEiRwEno2jaTOBtbWulmj/Iqbws6CFk3roUhjXkYE9gr8Z7M3KNJgIzA1ijjgvVLqaH4ACPpOn4UAQAA",
    Pbi3DGeometry:
      "fBcAAB+LCAAAAAAABACtWNtO3DAQ/Rf3NVh2bk6Wp6qwqtQ+IFqpD2gfFhFBpGVTbaNKCO2/N0CaOBsfzzggtIjsYebMxZmLb57F1W398+l3JVbiW3Nb/2h29Z2IxFVT79s/YnXz/PZnB6vz7kcco/GbM63U+euv7iOOm/9inw+H7VMne6ZTqco4ibTKZVqoPEq0TPK0iF6QPM6yEYkTWWZKR3OZEdFSF0XhQlQnY0oOgi1IUmlMXjosGGVOLbC1cT21eVAMMM8Sf/hx43mKeKC2RMZaJQ4RI3OVuiKQy7gotQM4lbA4TJkZBjCoOrWK5ji1KtxBqAp6znEQkIeby+bg5ANw+I5Jz26kylLj0NUDVgqnElYUy853BzDYSwFWprJM5yEcQ9znqqaAJQE5oKqphJXCaazmuZ1Hlxl2yAH9oMnZsbKAadit4w7IPRKAw3MYgCoo0R33JC84ZnGOIrB3RmKXeJNmLpbxPXRomyK2DOZB2obWSCL2ENA3mQB/hpZFIthTG5ny2PULJNQrg3iW2QYswKfQl4RpqDnufERAcbIdkxhptWN+DEgp9Af2Pc9UAVqSB4DdDZB7513uCxpUIj5oFsc84eULWwALAd2xqfEmYMCAqhY3f9pcWhXbD88e5tvd8FvJfV8ZFvhmS1SbfWsLkPEM1mAK8LKg4rOkAC/wJnw88vhPDZ/zxYIaJWGOqXIZzkGTe1sSecSXvDD4coAapQNaUvjOTO0KsLvRHHA7pQH2BkNvF4v38oAqjYck3DzfMa1zLouWXJhBHjh10gD/fguKsNkD7gDYtxycpSPgdo+BkAsEZ+1Zdo9JIgHLDWMpJC3gzSrkdDG1YBOJi3r7WLXVQay60xiJ79X+vn3oH66bdtvWzb5//FXfDdDXqr5/aPuHy1311/7HL82u6RSKT5frtVkbcdz8A/NB+Wt8FwAA",
    Absorptance: "0.1",
    Area: "6",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3684",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "1.06",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573718",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.99678539",
    Cost: "0",
    Pbi2DGeometry: "GAEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NIWpukdRIVBB2CCA6lQ4uhDcREahRK6X830NpFwe3d+467y3uQlT53dwUZHFylpTNd7SwgkE5b/4As78czGBaUYL5M0hWlAtM0jmBAvyhhmDPOv2jMBPtH5+TiM2HdtmUXdoTHVpc35VULGcEEwVHZ2jeTODlfeh2mj/KirzPaK103oSaUiIgJBDujXpM5inGaEIpg44wLwfZpzFC8Ad0RFXoYAQAA",
    Pbi3DGeometry:
      "3gYAAB+LCAAAAAAABACdlVFrgzAQx7/L7TUNSY1G7dPoKoPtoWyDPZQ9WBragDPDhUEp/e4Lm90sGpOIKJ6/3HlJ/nfZnGC9lS/HDwE5PKitfFaV3AGCtZK1/oR8c/p9NZgszAVn9P9lRglZ/DzMDee3i9tt05RH42sQ5izOECUck5hxNI9wFhOK+iRimPMk6xDKcUYSOonY/9MlUZImY4TOMUtSOuLTzeDap0/cPiEZGJKymAVlcPEZiDawbtdkIJqdjOVmy8BJ/NbNpbeRmQbtgke03nxcSnTrLWjnrBnYq8ReWVMUP0Rc0cL6ga/ig8iEvjOlu0xZAzfx21Pf2vbTW6CqzDlxJ8t3oUUDOcEEwaOo9/rQGk9Kl1qqujVf5e4P3Qu5P+jWWFXiqztwqSplAsLNqih4wc159A1cBhtU3gYAAA==",
    Absorptance: "0.1",
    Area: "11",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3482",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "1.26",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573719",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.81197466",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACNjrEKwjAQht/l5hiStKlpnUQFQYcggkPp0GJoAzGRGoVS+u4GWqVubvff93P35T3ISp+7u4IMDq7S0pmudhYQSKetf0CW9+MYCguGUxaxFaUMi5jHMKAZpARzvvyHxomgv3R2eITFR2DdtmUXLMJiq8ub8qqFjGCC4Khs7ZspnJwvvQ7iY7zo6xftla6b8CUYCJYIBDujXlOZRTjlhCLYOOPCYfs0ZijelGedCBYBAAA=",
    Pbi3DGeometry:
      "hBIAAB+LCAAAAAAABAC1V01rAjEQ/S/pdQ3JfmR39VRapdAepC30UDwoLrpg3WKXgoj/vaFau0kzk8lCKRbX55s3H3Fm8npg00X9vH+v2JDdN4v6qdnUSxaxaVNv2w82fD2c3mpYjPQfO0a/nwykEKPvf/rFjrMf2vVuN99r7iDhsRRJJGXMizRLozjhZSZkpIG8zHICkEieqLSIBorHRSkdDMWzTConYDIupmyvkpTnuSpRcVPDz0A0gJSA7oaLK15qWw4GaAoRJ3rVicMU9wM5VzJ2HQYbuIhLwaVQrtOgkUQVLr/+cPzpwvRNlU4iwdQDiaQHSZDv4XGAjL8wyHEBit8VSVUh3QXzIK5kmpSOvgnYDGf0J8SVMVzeWcsAGSAzoIwdJWzLdS6JtkB1sluunmczLt0FZ/hNdbqkyeh0YhswGaBX/iT2MQWkPVzDDtA1BkwAZJA1KKUFDwNQc2RZANcLsLTEmvvFAyZNn5ZGa5CAB+SdyJ98cDhT5jxYYKI4ogG2AX/jILoLzhIkJf44yAECewRp9Qj/uZP3RBDwr5z0kUSYYuBWHR4iMVtIiIC/lEsA3oCDOhreHOEsBrYaahnRlRPwgHIvJA5rCmDf2UIvpch4B6efH8C9ouzaRPGgrYp4W0U3XcLw6zNK+3hAvISFL7v/JQ/ewMKnFhhJV3wWsdt6/la11Y4NBRcRe6i2q3Z9fnhs2nlbN9vz40u9vEB3Vb1at+eH8ab67H7xptk02iC7Gk8m+SRnx9kXlYa4sYQSAAA=",
    Absorptance: "0.1",
    Area: "4",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2327",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "0.43",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573720",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.26402151",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsELgjAYxf+X77zGNnFudpIKgjpIBB3Eg9LQwdrCViDi/95A8xBBt+99v8d7rxggr/W5vytI4eBqnTvTN84Cgtxp6x+QFsN0BsOK4zimfE0JxwlPEhjRD0gFpjJi31AyIf/AJbb81GddV/VhQ3hsdXVTXnWQEkwQHJVtfDuLk/OV12H2JC/6uqC90k0bWijBgnGBYGfUazazCMuYUAQbZ1wItk9jxvINY/BvcRQBAAA=",
    Pbi3DGeometry:
      "zgcAAB+LCAAAAAAABACdlVFrgzAQx79L9pqGxKqp9mlslcH2ULbBHkofLA1twJnhwqCUfveFzm0tyfViEcX48/x7x/9yiz2Zr/Tr7kORkjyalX4xjV4TSuZGt/aTlIv9z63DfOoOcqD/T0aC8+nx4k5yWP6G3XZdvXOxo5xlmcipEAmbpFlKxymTMi+oB5IxKzIuToBkBc/FFQDU8ACXjGephIGvkbA0n4Q1jiA+IqBRJJMimMc58CP8IkYCUMMHfh7nwNMAE0RBjDhmBjDz4UUcoIGY4fqShH73suHA3wWLGCr7cJdEayA9CBpuiEvACKydQZdgIKZW2H4FGQ7MHAUxvkK2vktFBFyCgZgexFsNHCzhbQkFA3afyGng5uK9rt+VVR0pOeOUPKl2Y7f94tnY2mrT9ss3vf5DD0pvtrZfzBr1dfrinWmM+yC5mVWVrKSbv9+RrtT/zgcAAA==",
    Absorptance: "0.1",
    Area: "11",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3482",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "1.21",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573727",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.80397908",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkNrZNPYkKgh6KCB5KDy2GdCEmUqNQSv/dQLUgCN529g0zU/SQ13jqbgoy2Lsac2c67SwQyB1af4es6MczGOKIxnKeLmdcULmQCQzkBxSc8jSW31BQljD+B06x5ad+1bZVFzaExwarq/KqhYxRRuCgrPbNWxydrzyG2aM842VCO4W6CS08FCeCwNao5+SNmCSwdsaFVPswZihfDZAOyhEBAAA=",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABACdU99rwjAQ/l/O1xguGvvLJ9EWYXso22APsoeKQQO1kRqEIv7vC1u7SV29OkJC7vty3x13l9UZ0rV+qw4KIngya/1qcr0BBqnRhT1CtDp/Xx2NU7fgwn6RoUCcfh1uw+WjcZuVZVY5X2/MvXAUsKEUXAReyJCPMWQ3sBBcBqMrQky4kIH8B9ERoYYlRx/FHzINcZNRm2gJEfpU2I7sCZl+uRC1f6xgBEzXkWx53xEhQ3f29vGh6j+fvYPf7zDRnJa6+28Lne2VVSVEyJHBsyq2dlcbL8ZmVpuiNt/15odaKr3d2dqIc3W6fjg3uXGCMIiTxE98968/ATtEKZUmBAAA",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "3.11",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573728",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.02136829",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk9HfrSVQQ9FBE8FB6aDG0CzGRGoVS+u4GqgVB8Laz3zAzxQB5Taf+piCDva0pt7pvrAEGuSXj7pAVw3R6Q4ocA4yWCxlyjDCBkf2AoeQyjfELouCBjNM/cI4tP/Wrrqt6v8E/NlRdlVMdZIILBgdlGte+xdG6ypGfPckzXWa0U9S0vkX64iRksNXqOXsDgQzWVlufah5aj+UL0BRBZhEBAAA=",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABACdU0sLwjAM/i/xWkurU9t5EnUIehAVPIiHiUULc5VZBBH/u0Xng42ZTUofydd8CXmsrjDd6MXlqMCHsdnouYn0FghMjY7tCfzV9fl0MOu6BTfy0dQ5Y93H4Tbc1i+zXpKEF2crJJVN2SJ1j1Mu2pIw2mSS5NScU080vgDeotwT3h9AgYenWrqLt0We5g1kI8oBGSKEH3FbED1GUyoWLPfVEoao0TziJS/ZIrjrwtpWb6rS/Vne+c8KY8XJsLt5G+jwoKxKwGeUEZioeGf3qTAzNrTaxKm41Ns3NFJ6t7epMIzU+ftj30TGEUJtGASdoOPm+g744WgvJgQAAA==",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "3.11",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573729",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.47864205",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0aWpMPYkKgh6KCB5KDy2GdiEmUqNQSv/dQLUHEbzt7BtmJu8hq/DU3TSksHcVZs50tbNAIHNo/R3SvB/PYGCcUymkWs6YoCpREgbyiwpG2WKuvmhMGU/4PzolF58Jq7Ytu7AjPDZYXrXXLaQRjQgctK198xZH50uPYfooz3iZ0E5j3YQaFpqlILA1+jl540gRWDvjQqp9GDMUL17kGRUVAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdU0uLwjAQ/i+z1xgyMdqHJ3EtC3qQ3QUP4qFi0EC3kRoEEf+7wW13pVqmSkjIzJeZbzKPxQlmK/N93GmIYWJX5stmZg0MZtbkbg/x4vR79bAY+AVn9q/poBCD6+E3nJeV2bAo0qO3RSl5oIKIdRRyDPsRE7wrInavR+QqlLcI9jiqUL2ENLFU+i5H2ZOPPFXIfVx1pO6L4qC5m35BeWobEVWLZ7NH6dtkle6D9p1D8zfX+5Vue6Z320dAVZ2qVo3Bz+S7SX+00wXEggsGU51v3LYUPq1LnbF5Kc7N+g/60GazdaUwzvTh9uHIZtY7hLdxkgRJ4Gf/ArSDxHVKBAAA",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "3.11",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573730",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.06922032",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NISmySOokKgg5FBIfSocWQBmIiNQql9L8baO0ggtu79x13V/SQ1+bc3RVkcPC1yb3ttHeAIPfGhQdkRT+e0UCZxIwTtlowiqlIJQzoF6UMy6XkX1RgIdPkH52Ty8+EddtWXdwRH1tT3VRQLWQEEwRH5XRoJnHyoQomTh/lxVxntFdGN7GGEsyk4Ah2Vr0mM00wS3mCYOOtj8Huae1QvgG9bYkzGAEAAA==",
    Pbi3DGeometry:
      "bgQAAB+LCAAAAAAABACdVF0LwiAU/S+3VxMV2+Z6imoE9RAV9BA9LJIS1owlQUT/Pan1QWu4DVG8Hu+9x3PV1RWmG7W4HCWEMNYbNdeJ2gKCqVapOUG4uj6nFiZd2+CGPittSkj3MdgOt/XLrZdl8cX6Ui4w9wlHbdrBlAccUYa55zNURBjDwuuIL4RTTANPNELK83yQAAfCY/+ivZAit1+kGM2dpwqD8vO4o9Xh5q6PW9E6upVr3aTade5OdQZVtHar42bdpHJVtHar85PHvtuBig/SyAxCggmCiUx3Zp8bM21io3Sam0u1fUMjqXZ7kxvDRJ6/N/Z1om1AaA2jyI98+z/cAYoNODFuBAAA",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "4.44",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573731",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.51950598",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/LPltdtVNUENRBIuggHpQWXdh2w7ZAxP/eguYhgm5v3jfMTN5DVqlzd5eQwsFWKrO6q60BAplVxj0gzfvx9IZQUFwirhbIaRImAgbyA3KkGEfJNwxZzP/AObb41K/btuz8Bv/YqvImnWwhZZQROEpTu2YSJ+tKp/zsUV7UdUZ7qerGtyCjPIkFgZ2Wr8mMAeWRCAhsrLY+2Dy1Hoo36n0t6BQBAAA=",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdk98LwiAQx/+X69XEW/vR1lNUI6iHqKCH6GGRlLBmLAki+t+TWr8bzhDF83PeV71zfoLRUkyPOw4RDORSTGQqVkBgJEWm9hDNT7epxqylG5zJc6WOjLWug+5wXty3tfM8Oeq9XkCxgUjqLlJs+iFBh7p+4JAv4Dg09L3wCdCj6DbdP0CpxgvwmHb8FeoGfpzqHXyFMmpUES+9hyGUzakM+bB/RCOo8rqGYrApH4N4ac7tC86mdiuKV8m5IVEfGvpPdkWy5YrnEDHKCAx5tlabwhhLlSghs8KcidUD9blYb1Rh9FJ+eHXsyFTqgFDrxXEQB/rvXwAPcWzISgQAAA==",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.92",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573732",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.7381447",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjlELgjAUhf/LfV7D2dycPUUFQT2MCHoQH5SGDtYWtgIR/3sDTQiC3u653+Gck/cgK33u7goyOLhKS2e62llAIJ22/gFZ3o9nMHCGU8Li1YJQLBLBYUA/ICWYpEx8Q46JWCZ/4BxbfOrXbVt2YUN4bHV5U161kEU4QnBUtvbNJE7Ol16H2aO86OuM9krXTWghEaYi5Qh2Rr0mM4kxZTxGsHHGhWD7NGYo3lTaCVQUAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdk02LwjAQhv/LeI0hiW3S1tOiFmE9yK7gQTxUDBqojdSwIOJ/N+zWD6xl6hISMnky8yaZyeIE05WZHfcaEvi0K/Ntc7MGAlNrCneAZHH6m3rM+r7BmdxXupyx/u/gO5yXV7ePssyO3ldJGnEpSDfglEcyJlzQQCpBakAIGsswvgMeUh5EwT9Ao8YNKMrjXvgi1BXUTvUMaqFQDVy88R5oqPanQvPx/iOiAH9dtBjalw8q3pjz9wuufe22FsdzjibqScP/yaHJdtrpEhJGGYGJLjZuWxlf1mXO2KIy52Z9Q2NtNltXGaNc/zxuHNjc+oDQGaWpSpX/+xcE82QZSgQAAA==",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.92",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573733",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.62136372",
    Cost: "0",
    Pbi2DGeometry: "GAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0NU2behIVBD0UETyUHiqGNhCzUqNQSv/dSGsvCt5m9g2zk3eQnfWxvSlIYYdnnaFpK7RAIENt3R3SvBukDzAmKEtEuJgxTmUkY+jJL8rZW8gvGol59I9OzcVnwrJpytbv8Ie1Lq/KqQbSgAYE9spWrh7NAV3ptJ8+2JO+TGirdFX7NyygXCYxgY1RzzHMQspFHBJYoUFfbB/G9MULXkWKFxgBAAA=",
    Pbi3DGeometry:
      "bgQAAB+LCAAAAAAABACdlF/LgjAUxr/L6XaNbelMu4pKgrqIeqGL6MJo1MBc2Agi+u6tsjf7I1MRZWe/7ZzH7dkWZ5is5N9pLyCAkVrJmYrlGhBMlEz0AYLF+dE0mHTMAxf06mlSQjr3j3nhsnxO66ZpdDJzKeWYtjlDTYfeGj6iDDvcY+ibMIZ97vo5Ql1MnbZTixTXyROXt9zf2R7kl7Z38p3NXqecguL/sWWrps22P3VW1E7KrbXNIdVcZVNQ7IM6Tqzm67IKyvnAtnMfdcy57ctoJ7RIISCYIBiLZKO3WTBVOtJSJVk4l+t/NBRys9VZMIjFMT+wp2JlEkJjEIZe6Jn74QrSJiCzbgQAAA==",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.92",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573734",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.33720288",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0bZqfehIVBD0UETyUHiqGNhATqVEope9uoLUHEbzt7DfMTNFDftGn7q4gg7276NyZrnYWEOROW/+ArOjHMxhIkmLBSbJcEIplKjkM6BelBBPB5BdlOKaC/aNzcvmZsGrbqgs7wmOjq5vyqoUswhGCg7K1byZxdL7yOkwf5VlfZ7RTum5CDYkwlYIj2Br1mswkxpTxGMHaGReC7dOYoXwDHtg5bBgBAAA=",
    Pbi3DGeometry:
      "bgQAAB+LCAAAAAAABACdlMuKwjAUht/luI0hiWl6Ww2jRRgXooILcVEx1EBthk4YEPHdDTP1grWkLaGhJ19yzt/kTzdnmO/U6vQtIYIvvVNLnas9IJhrVZgfiDbn/1eLSWwbXNBjZEgJif86+8Ble1v2UZbpya6lIw8HPh2hIaeYBiJElGEufIbqhDEcCi98ItTDlAe8F2mu8yACMx6Id9lupK7tldSzueu0UdD8Pe5sXbS5z6fPjrpJm712O6SLq9wKmn3Qx4ldfN1eQRsfuE/upY69t2OVHqWRJUQEEwQzWWTmUAULbVKjdFGFa7W/o6lU2cFUwSSXv88TP3WubUIYTJLET3z7f7gCWqBOyW4EAAA=",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.92",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573735",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.09588099",
    Cost: "0",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABACFjlELgjAUhf/LfV5j06mbPUUFQT1IBD2ID4pDB2sLW4GI/72BJgRBb/fc73DOyQfIKnXp7xJSONpKZVb3jTWAILPKuAek+TCd3sAFFqGI1ivKcMQDBiP6ARnFlMfiCwqCQxrzP3CJLT71m64re7/BP3aqvEknO0gJJghO0jSuncXZutIpP3uSV1Uv6CBV0/oWSjATPEGw1/I1m2mAWZwECLZWWx9snlqPxRsnOHJFFAEAAA==",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdk99rwyAQx/+X26sVNT9Nn0aXMGgfylroQ+lDQqQV0jgyGZTS/32ypT9oCJcMUTw/3n3VO7dnWBZ6ffpUkMDcFHplKl0CgaXRtf2CZHv+mzrMpq7BhdxXJpyx6e/gOlx2V7fXpslPzjeWVHoyIBOfUx6HknBB/TASpAOEoDIM5B1wnwax8P8BejWuQDLq8TDuhrqB51N1QCcUqoGK994DDzX4VHg+xj8iCtDXxYthcPng4r05H19wg2t3uDiaczxRTxruT77p/KisaiBhlBFYqHpvD63xYWxutalbc6PLG3pXen+wrZFW6vtx48xUxgWElzTLoixyf/8HAtlrgUoEAAA=",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8109",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.98",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573736",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.87865746",
    Cost: "0",
    Pbi2DGeometry: "GAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkMbZNPYkKgh6KCB5KDxVDuxATqVEopf9uoLUXBW87+4aZyTvILnhq7xpS2LsLZs60lbNAIHNo/QPSvBvOYOBsTlkk1HLGJVULFUNPflHJKU8i9UWlZOIfnZKLz4RV05Rt2BEeGyxv2usGUkYZgYO2la9HcXS+9BimD/KM1wntNFZ1qOGMSpXEBLZGv0YzF1RGsSCwdsaFYPs0pi/eItpL1RgBAAA=",
    Pbi3DGeometry:
      "bgQAAB+LCAAAAAAABACdlNEKwiAUht/ldGuiZltbV1GNoC6igi6ii0VSwpqxJIjo3ZNatWrDbchkx0/P+ae/W11hupGLy1GAD2O1kXMVyS0gmCoZ6xP4q+vz1WDSNQ1u6DPSpIR0H5154LZ+LeslSXgxaylpYeIwDzU5xbTjeIgyzB2XoX/CGPactpchtI0p7/BapLhOlnBOWH62J8nT9k3+s9nrlFNQ/D22bNW02c6nzo7aSbm9tjmkmqtsCop9UMeJ1XxdVkE5H9hO7qeOubcDGR6EFgn4BBMEExHv9D4NZkqHWqo4DZdy+0YjIXd7nQbDSJyzE/sqUiYhNIZB4Aau+T/cATdb5F1uBAAA",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7994",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.92",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573737",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.334639",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI2vTXk6gg6KGI4KH00GJoF2IiNQpF+u4GW6WevO3sN8xM8YS8xmN/lZDBztSYG9U3RgOB3KC2N8iK53g6gyc4DUTCF15AUyECGMgM8pAy/peFUfyLZplvVn6ql11X9a7fPdZYXaSVHWSMMgJ7qRvbTuJgbGXRTR7lCc9ftJXYtK6EMyrSJCawUfIxmblPRRT7BFZGGRes70oN5Quoc06QEAEAAA==",
    Pbi3DGeometry:
      "OAQAAB+LCAAAAAAABAClU99rgzAQ/l+urzEkGnXRp9FWCttD6QZ7KHuwNNiANcWGgkj/94XVtW5rnGGEhNx9ufvuV9YtLDfytTkISOBJbeSLKuUWECyVrPQRknV7uRqYpGbBGd00HiUk/TzMhvP7l9ljXeeNsfVoiCnnEfICzBkLEPUxi2If/QJ8H/Mo5MhjFAfsgf4DsHJcgZ5FGMU3Tz2DIf09gm/6H/7/5LVmYHPkGtCYSozsj61GI3IbzPkegfsADFG7tGe4StZYXRvkMnmjmM0PnMl8L7SoISGYIHgWVaF3nbBSOtdSVZ34JrdXaCFksdOdMC/Fqf9wqkplHMJknmVxFpuf/gFs+U1fOAQAAA==",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.93",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573738",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.63652611",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkafpjPYkKgh6KCB5KDy2GdiEmUqNQSt/dQKvUk7ed/YaZyXvIKjx3dwUpHGyFmdVdbQ0QyCwa94A078fTGxaS00AmfCUEFTKEgcwYDynj/1AkRPDLZpEjLD7V67YtO9/vH1ssb8qpFlJGGYGjMrVrJnGyrnToJ4/ygtcv2iusG9/CGZXLJCaw0+o1mbmgMooFgY3V1gebp9ZD8QavM4DgEAEAAA==",
    Pbi3DGeometry:
      "OAQAAB+LCAAAAAAABACdU1sPwTAU/i/Ha9e0tYvNk2CR8CBIPIiHiYYms8o0EhH/XcMworNK08u5fufWxRnGKzE77TlEMJQrMZWpWAOCsRSZOkC0ON+fWkzaesEFvTgOJaR9O/SGy/Jh1snz5KRtHephGoY+Ygwz10OUYdcPGPrk6yv0vRA5LsVNt0X/5Zv8P/klfZ+x5stRyaBa8A3iXfCJ8RvclIXRk31QNQpSq0HGOtVJrjLrbxC2M1CNbNWhqiqZQrXvj9X81YDWP7Ankh1XPIeIYIJgxLON2hbERKpECZkV5Fysn6IBF5utKoh+yo9lxa5MpXYIjX4cB3Ggf/oVL1wuoDgEAAA=",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.93",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573739",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.95645415",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNIavqwnkQFQQ9BBA+lhxZDG4iJ1CiU0v/uQh/oydvOfsPMZB3IUl/ah4IUjq7U0pm2chYISKetf0KadcOJhoXgdCkSvo44jeIghJ58QR5Sxv+wgDKxSn7ZHDrBfCrfNE3R4gJ87HRxV141kDLKCJyUrXw9irPzhdc4epBXfZvRQemqxhbOKEbHBPZGvUczD6jApQS2zjgMti9j+vwDqSvJxRIBAAA=",
    Pbi3DGeometry:
      "dgUAAB+LCAAAAAAABAClVN9rwyAQ/l9ur0bUmh+mT2NrGGwPZRvsoewhpdIKWRyZDErp/z7ZsnUkFS8bonh+fvepd+fqAMu1edy/aijh1q7Ng23MBggsrWndG5Srw9fUw2zuGxzJaSXhjM0/B9/h+PxNu+y6eu+5ieR0JgtOMk6zXKRECKqyVJERwAWVfkISnlKuVDYGgq6CjCEQZJwASQshZmdcDQAEAys+vqCgTKrijEYMGB93CAw1EOLY4/5DHB3zOCP+JPhAhZ79D4HCJlycERRHl9oEV9PTB1+10VKL5dWE+kCK+//r2tQv2ukOSkYZgTvdbt2uN+6tq52xbW8+mc0PdKPNdud6Y9Ho998br2xjvUO4WFRVXuX+n/wAyAuH/nYFAAA=",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.98",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573740",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.51506121",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0NTaxnkQFQQ9FBA+lhxZDGoiJ1CiU0n93oVXqydPuzhtmJ+8gq8y5vStI4eArk3nbau+AQOaNCw9I825Y0TDjjM65ZCuJcyES6MkExihK/o8JDPhlk9ABFp/n66YpW2yAwtaUNxVUA2lEIwJH5XSox+PkQxkMlh7Oi7l+0V4ZXeMXFlG+lILAzqrXaGYx5YmICWy89Rjsntb2xRu+5t+MEgEAAA==",
    Pbi3DGeometry:
      "OAQAAB+LCAAAAAAABAClU8EKwjAM/Zd47UZX5zrnSdQh6EFU8CAeJhYtzFVmEUT8d4NOp+K2Diltk5cmr03S5QUmazk/HwQEMFJrOVOx3ACBiZKJPkKwvDxENNMODriSHLEcSjv3BSdcV0+3bppGZ/S1mGM3fZf4uLW4Rxxmux5n5BtnzG57rTaxXARc3/nDUETxwt8cOAp5pNyhFP9B8Il/E1QzF76hMFTdOxkkwyx7hsQ1kvpZzroNUxTfJNflRai8qklLlnPXapnywmUc+AP7MtoLLVIIqE0JjEWy1btMmSodaamSTF3Izcs0FHK705kyiMXp/WBPxQoDQmMQhjzk+NNvXXhDtzgEAAA=",
    Absorptance: "0.1",
    Area: "19",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "6085",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.24",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573741",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.70298823",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEksbZJPYkKgh6KCB5KDy2GNhCzUqNQSt/dQOsPXrzt7DfMTN5DVpljd9WQwg4rk6HtanRAIEPj/A3SvB/PYIip4mq24FxSzmYwkA8Siko5F39ZJH/gV+bIilf1sm3LLvSHx9qUF+11CymjjMBeu9o3kzigL70Jk0d5Muc32mpTN6GEMxopmRDYWP2YzFzQKE4EgRVaDMHubu1QPAH5+54qEAEAAA==",
    Pbi3DGeometry:
      "AgsAAB+LCAAAAAAABACVVtFKwzAU/Zf4GkOSLk27PYluCPowVPBh+LCxsgXmIrMIY+zfDbrN2uY0CaWlubn3nJvb3JPODmS6MC/7j4oMyYNdmGe7MUtCydSabf1JhrPD76ub5iN3kSP9s1wLzkc/D3eT49s57Ga3m+9drGaC65IKUbiXjErJylyVtGUWkg1yLanImJBF1rUXTIos78BA/4zJUnrtSfgg+550/LQt/+CysL8quTcfr11mTAkpOjjOnutcdu0lU0oLH06UfwPfyxubf8g/Nf9UfFT/Jv6gaALlrFRcdSc6EReKdsRlbdERQXI3oXQmE8g7EWeoRiPEUbQDIAMKgAzpqwt2P6QA/QxzBQRA7eB26umr4L7/D4QCcIP6hQcJG6wcAur5muCjYSQY4G/26B4NVgkiRepezMYLbaTeIoUOBigAqQce7EGk3OiEQaqXLqCIGikSWnKPvMA1oyKFpT5ZF+KqFFPvHqVKqF3UcQGE0M/q/iXvzPy9qqsdGXLGKXmstqt6fRo82XpeG7s9DV/N8jJ1X5nVuj4Nxpvqq+l4azfWAZKr8WSiJ9r9s34DdxTHDQILAAA=",
    Absorptance: "0.1",
    Area: "22",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "7000",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.52",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573742",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.88733724",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEksbZNPYkKgh6KCB5KDy2GNBCzUqNQSv/dQFsPInjb2TfMTNFDXptzd1eQwQFrk6PtNDogkKNx/gFZ0Y9nMPCULiWTK84FFUJwGMgvmFIhefwNBV/E/+AcW87167aturAhPLamuimvWsgYZQSOymnfTOKEvvImzB7lxVw/aK+MbkILZzSSaUJgZ9VrMoe+KE4EgQ1aDMHuae1QvgF/n4exFAEAAA==",
    Pbi3DGeometry:
      "6AgAAB+LCAAAAAAABACVVltLwzAU/i/xNYYkXa97El0R9GGo4MPwoWNhC9RGahDG2H83anSO9ORC6SX5+p3vnJOT064OaLmWT/s3gRp0p9byUfVygzBaKjnod9SsDj+PBqZzc6AjPs1cMkrn3xdzouPLL+1qHLu94bKK5DWtMWOczBgt8de9KDk+ATlh5ayaACyDc1IXee0yXCDESBDPSZZVNcyY0gAYFWE0A+ddQ9C8FUhQDgExqeUsK6aCsPOuxBnBNeRKxxESpN1FDWmDDLdqzwHXFAiAqfW46wdikhu5yWLEA+WcsE6gU2EGoJEehofhreiIhESWYXo3iugVoUJIaKpgsYFOhRne7pIQBkwAFMC4Pfs1PTyvtxEVFUhH6hcDqtj05hXqgzH7a1Lc/DHcyO5VaDGihhKK0b0YtnpnBw9Kd1qqwQ6f5eYPuhVyu9N2sOjFx/8Xr1WvjEF0sWjbsi3Nn8knOIiflugIAAA=",
    Absorptance: "0.1",
    Area: "6",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1850",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.64",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573743",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.90347254",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jlELgjAUhf/LfR5jG+acPYUFQT1IBD2ID0pDB2sLW4GI/70LmhBEb/fc73DOKQbIa3Pu7xpSOPja5N72jXdAIPfGhQekxTCdaOARVYLLNeeCCiE4jOQHZDFNWCK/4YoKpf6zJbT8lG+6rupxAT62prrpoDtIGWUEjto1oZ3FyYcqGBw9yYu5LmivTdNiCWc0UokksLP6NZuxL4qlIJB56zHYPa0dyzc5nuh1EgEAAA==",
    Pbi3DGeometry:
      "YgUAAB+LCAAAAAAABAClVFFrwjAQ/i/naxaStDakPo3NMtAH2QZ7kD1UDBromtGFgYj/3ayrnWhDTkZo6N2X7y5395HlHhYr87r71JDDzK7Mi63MGggsrKndF+TL/e+vh9nELziQP88dZ2zSbv6Dw/uJdt805c5zeUqV4JJwLihLkpQIQVU2VuQcSDmTg0DL+DmQSYEDgqFaAB+KScqTbIBxAvDXjTJ6YEyFUgNldP6rQBf+PnPEf9WNUN5gaZFA6MToicYZodTRgYamEOo2ejpR5f9fGGjhY4uISeOmAQ1f6Va1xlSPb+tFBv9WPZryQzvdQM4oIzDX9cZtO+PZutIZW3fmm1n30JM2m63rjGmlv88PPtjK+oAwmhaFLKR/E48NWTwqYgUAAA==",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1650",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.59",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573744",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.67217726",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkoTZpPYkKgh6KCB5KDy2GNhATqVEopf/uSmsPInjb2TfMTN5DVplTd9OQwt5XJvO2q70DApk3LtwhzfvxRINgNEoSseRcUCEEh4H8gCymiin5DZWMF3/gHFt86ldtW3a4AR8bU1510C2kjDICB+3q0Ezi6EMZDM4e5dlcZrTTpm6whb/nKUlga/VzMmNfFEtBYO2tx2D3sHYoXvQbNYwUAQAA",
    Pbi3DGeometry:
      "dgUAAB+LCAAAAAAABACllFFLwzAQx7/L+RpDmnZJ2z2Jrgj6MFTwYeyhY2EL1EZqEMbYdze46jrWcIlSWnr95f7/JHfNYg/zlX7ZvSso4cGs9LNp9BoIzI1u7QeUi/3x1WE2dRccyOnLdcLY9Pvhbjgsf9Juuq7euVzOaFYUnCRM0iQVkiScZkJycgE4p4WYFCfgRrI0zf4AvB4DkEsxGZU6gpFZnYMLKdQjxBzZqxEpkcs8DiCzGjFHpNDSetfhXfkAnJuHAKSCMRleD6R347sEbbh/mXsriPw4Mdse6BFewRgPb1MHZvQe7vy60/WbsqqDklFG4FG1G7vtgydja6tN24evev2L7pXebG0fzBr1ORx4axrjBOFqVlWyku6c/AKtWUAYdgUAAA==",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1650",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.55",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573745",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.11129664",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyFk29jaehIVBD0UETyUHiqGNhCzUqNQSt/dSOvfydvOfsPM5B1kR71vLwpS2NBRZ2TaiiwwyEhbd4U074bTGyKeYBLOEAMuwlBCzz4MJxxRyP9Qooh/4FfqwIpX+bxpytYv8I+lLs/KqQZSwQWDrbKVq0exI1c67UcP8qBPb7RWuqp9CQouk2nMYGXUfTQ/+6I4YLAgQz7Y3ozpiwedh1DOEgEAAA==",
    Pbi3DGeometry:
      "/AkAAB+LCAAAAAAABAClVt1rgzAQ/1+y1ywk0amxT2OrDLaHsg32UPpgqbQBZ4aTQSn93xdWXdXm6tkifuR+uftdkvtwviOzpX7ffmUkJs9mqd9MrleEkpnRRfVN4vnu8GlhPrEX2dOj5FZwPvl72JvsF43afVmmW6sbMsFDRYWQjHueT+3bD0JJIyv3JEKuWBQJRft2pGQquFPgfCEY50F4CowlgBZwStAAPlNSuADIJRjom4KcauSgAp7CtQzfsh0Bj0klPQfQ4jgADo4LNVzr6GqAXnlMyGiUu3gNaK8G3W0dYEehFZ0dhv58R7p07ENyiPd6R4H5Q/kOpRdkB70RA7zwIePTd0yEgaaQuQWmEOguxtSFW+IqN53ogKIGIcfVM0S1Pks8IszOhivo6KiD66YiBsCRI5rsVdUE6qVjmztkHy7RGADV9lFNeYB7MKsxdaBNbv+iHnX6mVVZSWLOOCUvWbGuNvXg1VRppU1RDz/06h96yvR6U9WDaZ79tCc+mNxYg+RmmiRhEtq/tV8ToNxR/AkAAA==",
    Absorptance: "0.1",
    Area: "6",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2497",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.65",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573746",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.03838907",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9jlELgjAUhf/LfR6XTW1Te5IKgnqQCHoQH5SGDtYWtgIR/3sDTYigt3vudzjnFAPktTr3dwkpHGytcqv7xhogkFtl3APSYphOb+AoQsrXLAxxlXABI/lllGNM428mkFGR/GdLZvmpzrqu6n2/f2xVdZNOdpBSpASO0jSuncXJusopP3mSF3Vd0F6qpvUljGKUxILATsvXbGYBRlwEBDZWWx9snlqP5RvXBHI0EAEAAA==",
    Pbi3DGeometry:
      "HA0AAB+LCAAAAAAABACVV11rwjAU/S/ZaxbyUZtWn8amDLYH2QZ7GHtQLBpwZrgyEPG/L0zbubTXe4NUmtPTk3uT3I++7dl07l52nxUbsgc/d89+7RaMs6l3m/qLDd/2x9vwWI7Cjx34H3KtpBz9/oWLHd6b126229kuvJsLa2TOlTFiUOaWKy2y3Gre4lrkSg9gvBRFoUoe62gtynxQonxdCiuLsquTqg/Y3+pHuLRCmUt8op2NDmRPjEN8TL+xMwylDbQwlsZkrU6DY/wEPAt3IB7Pq4pwY7r0I9xhA+rx6lC9gvR7cIjfvwqXzae6BS9OVtAXLT4imEx89Bs8DpUWj0KugwPmU+2MQ4LqV89R6/UXtD9xXoiP6SdsL+TX+bajGRjbxtRtR/ShjAq5i2YwgA/pUzM5FnS0GE21HspU1DyO4QSdf25B9QbLbGlnE1SPEiRUFbFpqfzUqptaP1J1MD61a0BTEhTTUDeH4JD92Cmn1m9qNwRFEZjbMBwqadSuk9gFY/NCJSe166R20+R5ibkWxY/64Svjzs0+qrrasqEUkrPHarOsV6fBk69ntfOb0/DVLdpH95VbrurTYLyuvs+Jt37tgyC7Gk8mdmLD18wPsXFtgRwNAAA=",
    Absorptance: "0.1",
    Area: "24",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8165",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.74",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573751",
    Name: "Basic Wall: WC Trennwand 5.0",
    Category: "Walls",
    temperature: "21.52683019",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjksLwjAQhP/LnkPIq/bhSVQQ9FBE8FB6qBjaQMxKjUIp/e8GWl8nbzv7DTNT9JCfzKG7ashgiyeTo+1qdEAgR+P8DbKiH89g4JIKzuSc84jyWCUwkA8UkkapEv+hlMkv/I4dYfmqX7Rt1YUN4bEy1UV73ULGKCOw0672zST26CtvwuxRHs35jTba1E1o4YyqNIkJrK1+TGYuqJrFgsASLYZgd7d2KJ9olVyKFAEAAA==",
    Pbi3DGeometry:
      "zgcAAB+LCAAAAAAABAClVV1rgzAU/S/ZaxbyUT9in8ZWGWwPZRvsoezB0tAGnBkuDErpf1/YrNPV6LUiiteT6/Eez81dHdByrV/2Hwol6MGs9bPJ9QZhtDS6sJ8oWR1+bx1M5+5AR/z35JpROv+5uBMd305pN2WZ7V0uE4RLLjBjAWHRLMacExkGEp8BjJNZGHHMYsKZCKcAXo4aiEkgqQQAJw4uSMA4mwJAyOs6hIilH6grbxTYzvgPDGf4OJp1tDLOgMb/qAu8EPBydH1u2wxeX4El6fKVF4CZAeQrmFagjH5JvCKOd6LXcJf3oLdx4E7s4vACwC1jequNsmi/JINmGK8VSPZ+U4+SffzOACYfHhP9fT6qDUDkbi7e6exdWVWihBKK0aMqtnZXBU/GZlabogpf9aaG7pXe7mwVLHL11Vx4a3LjXoiuFmkapZGbv9+3TgifzgcAAA==",
    Absorptance: "0.1",
    Area: "10",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "WC Trennwand 5.0",
    "Family and Type": "WC Trennwand 5.0",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3165",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "WC Trennwand",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "WC Trennwand 5.0",
    "Type Comments": "Mauerwerk",
    "Type Id": "WC Trennwand 5.0",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.48",
    Width: "50",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573752",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.12274201",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyE0cZs29SQqCHooIngoPVQMbSAmUqNQSt/dQOvfydvOfsPMFD3kJ33orgoy2LqTzp3pameBQO609TfIin48g0FIyhHZnDGkMc44DOQDUVCeSvwPmYjlD/yOHWH5ql+0bdWFDeGx0tVFedVCFtGIwE7Z2jeT2DtfeR1mj/Koz2+0UbpuQguLKMo0IbA26jGZGacoEk5g6YwLwfZuzFA+ATv6rp0UAQAA",
    Pbi3DGeometry:
      "MyAAAB+LCAAAAAAABAC1WU1r20AQ/S/bq7roY7WynFNpYwrtIbSFHoIPDhGJwLWKKwoh+L9XSSx5Je3bmRGUkGDlefbNx2r1ZnT7rG7u6h9Pvyu1Vl+au/p7s6/vVaRumvrQ/lHr2+e3jx0cX3U/6hRd/vM+ieOr1z/drzpte7MPx+PuqbO1K53m5SpKEqNzk6VRkmpjizSaA6VerZLyBSgTOzfIO9wkxgNYnaVxzrHoKVJdGFN6nMp1ltvMYzEDLmGMvE1TXdq8DIQHKbgJcSi8iYLfh8yzdFAAzOysFgM55OB71Zc11zZfeSwguWAjkHGA5PIzQocRAMrXa3qpHoh1WhQFB+g5uozkxnO/mkJnhfGQG6tNwTJAYQw5hIHPnCKXgluBndzBApLDHCIApmSaQ5oblQlzAwq2T4sZFtQ7cM/47wA3iuRlbQzMvR0ZuOGNgUSn1sMwN+ijSLTNysxj4RSPAC5L+bkhBXTKyTkBeHLOSy0kn+Z82AiT8Ia9ib4Po2PXgqTm7hvkK13TQCXGCfedBgvDhkV18gESFYgDLAUDdG5vJgf0ask+92/nmVc04DzzCcCjNwigF3NGx3nhqaCrmwig5zDaZMZKOKAF5LjIo7GBI26nBhNgeQ6nYQyaDQF4I8rJA1mXksOtC70KlAOmfVQnn0wPhyHeCk41xpvK158si8LTATEZoE+weqgW/FNPLqDlYmdOwaIWtNTkWQjPW9i0BNocAEB35Uc35ykAmy95gOxc0ZHLleF4KdhScHQsXGqhhia9ZazEiyI0oaLmK8FTBz/7SGY4n4KnsFw/8GdgJPB/hAUkD98atJINaF9vLwAplnS8gBqJASxq0CAKTj6g3gjMSvxhsDQNkzxQPn8xxJ0cGnyARg5rAaQq0LyVsRAvrYwJcNBTwcnFmiRDxULLDFZ/zyiZXBDxhpMsYDwQkI+e4GRUPFHEoxbxcEZALpkuE895OPOWqCt2588duEtG9GMOOMHgAMzXAJyhMEEumUQSKhE2p5KWgfl2CTZd4kmM/JUQC2D265wxEO9lGAsgpCJ8ASkRsOyOHb7klL8nBhywy+cAhFekBZ9cMsgjhPgbxzZSn+rdr6qtjmod6zhSX6vDQ/t4vvjWtLu2bg7ny5/1/QB9ruqHx/Z8cb2v/rpf/Njsm25B9e56syk2hTpt/wHczwQ4MyAAAA==",
    Absorptance: "0.1",
    Area: "14",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "6997",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "1.6",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573753",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.02380069",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jsELgjAYxf+X7zzGpmubdpIKgjpIBB3Eg9LQwdrCViDi/95A81J0+973e7z3igHyWp/7u4IUDq7WuTN94ywgyJ22/gFpMUxnMDCOKSFiTeMYrxIuYEQ/IOFYEvkFmZD/2RJafsqzrqv6sCA8trq6Ka86SAkmCI7KNr6dxcn5yuswepIXfV3QXummDSWUYJZIgWBn1Gs20wgzLiIEG2dcCLZPY8byDZJMbfoSAQAA",
    Pbi3DGeometry:
      "fAYAAB+LCAAAAAAABACdVVFLwzAQ/i/naxaSNG1s9yRzRdCHoYIPw4eOhS1QG6lBGGP/3aidq12TpqO0JN+X3He5u1yXe1is1PPuXUIG93qlnnSp1oBgoVVlPiBb7n+HliZT+8ABnZAJJWT687EvHF6P227qutjZvTzBlhCIEoFplNgBwzwRDJ0RjOE0idMTEUU4Ti8inBotgotrN045pt+WXXhL2Yv3nO1S3ZhHLFj3uL5rpydA//CuHRfu8adXdwh3nSskkc7Uj/XIb2h0bXmUvbUVUKOBsTi7H65yHErnGEPdenS65FV2rR8tPKa7BF2F4LoYJJy+hnapoe4SHoyOgu3it6p4k0bWkBFMEDzIamO2zeRRm8IoXTXTF7X+o+6k2mxNM5mX8rO9cKZLbQ3C1TzPRS7s3+IL9ESGinwGAAA=",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8165",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.97",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573754",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.04956849",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjj8LwjAUxL/Lm0NI0jT94yQqCDoUERxKhxZDGoiJ1CiU0u9uoLWDDm7v3u+4u3KAotHn/i4hh4NrdOFMr5wFBIXT1j8gL4fpDIaYYibYilKOo5gLGNEvIwKnJE2+mYiy6A9cUqtP+brr6j4sCI+trm/Syw5yggmCo7TKt7M4OV97HUZP8qKvC9pLrdrQQgnmWZog2Bn5ms2UYS4ShmDjjAvB9mnMWL0B2uHDTxIBAAA=",
    Pbi3DGeometry:
      "OAQAAB+LCAAAAAAABACVU12rAiEQ/S/Tq1fULWW3p+i2BLeHqKCH6GEjKWFbY5MLEf33rLbvtV0RxTnjnHHm6OwAw4Wa7LcSIvjTCzXWqVoCgqFWmdlBNDtct9ZN2nbAET2QH0pI+7LYCcf5LayT58nexrYoZpwhSgSmAReIMtzkgqF3nDEc8lZ4x2kT07Pti7v4n3AehEEp0dVRcqNXxwdVZY46yV1VVDD5XOqrEFUNrN8nZ2d9NXW9DX8hfIrwTe0qoWYz6kj9VaC3DPYH/qpkI43MISKYIBjIbGXWhTHSJjFKZ4U5Vcu7qy/Vam0Ko5fK/+eDXZ1qSwiNXhyLWNiffgKr+98OOAQAAA==",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2300",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.79",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573755",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.24402416",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGkSZP+eBIVBD0UETyUHloMaSAmUqNQSt/dQGsPInjb2W+YmXKAotHn/i4hh4NrdOFMr5wFBIXT1j8gL4fpDAbOcRYzuooYwzwTCYzoByQCpyT9ggIzSvgfuMRWn/p119V92BAeW13fpJcd5AQTBEdplW9ncXK+9jrMnuRFXxe0l1q1oSUiOM7SBMHOyNdsjiiORUIRbJxxIdg+jRmrN2kL9dgUAQAA",
    Pbi3DGeometry:
      "zgcAAB+LCAAAAAAABAClVdFKwzAU/Zf4GkOSNi3tnkRXBH0YKvgwfOhY2AK1kRqEMfbvZrPttGl6M6S0JD05udzDOclyjxYr9bL7kChHD3qlnnWl1gijhVa1+UT5cv8ztDCd2Qcd8PnPNaN0dvrYFx3eOtpN05Q7yxWCZHHEMYsiIrIkxZyTLBEZdgDGSZyk/AywmIjjwGF0QDhjqgY7rhyrcQIcBk0Ji8a2AgFvjR5ISMSpGOljCPQ1OsBRdwiEM7w1nD6GgMOYavCvuiDDq67XDGDn4QBouHAzeDsHRYQZoHe9GQQNFw6AOYdj4A1OsEtgBhhOMFGXRw22KKiV1yUgAGsFShKeQfAsCffVv26D6dPn8mMpPGqDGvZevFPluzSyQTklFKNHWW/Mtp08aVMapet2+qrWPXQv1WZr2sm8kl+/F97qStsN0dW8KNIitffvNz5LS7TOBwAA",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8165",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "2.93",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573756",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.24876023",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkbZrUehIVBD0UETyUHiqGNhCzUqNQSv/dQGsPInjb2TfMTNFDfjGn7q4hgz1eTI62q9EBgRyN8w/Iin48g0EKyhIVLzkXNE6EhIH8gEzSlKXqG4pYyD9wji0/9au2rbqwITw2prppr1vIGGUEDtrVvpnEEX3lTZg9yrO5zminTd2EFs6oWKSKwNbq12TmERVSRQTWaDEEu6e1Q/kGYNYJnRQBAAA=",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACVU1FrwyAQ/i/XVyeaGKXJ09gSCutD2QZ9KHtIibRCGksqgxD63+fWbG3XihFRvPv0Pu8+b9XDYq3eu72EFF70Wr3pWlWAYKFVYw6QrvrT1sIkswOO6Ox5oIRkP4udcPz4vfbYtmVn73KGSSJiRInANOYC0QgzLiJ0A0QRnvJkegYow/TbEQ44OS4AFjN+N9QJuPOqa+AmlJdjDLkzD0+okFd59PAWcXytnNUNl9b5S8L1CMkjnNyZx8iSjNHcI9Q/DtuTz6rcSSNbSAkmCOay2ZjtYLxqUxqlm8FcquoPmkm12ZrByGv5eXnwSdfaBoRJXhSiELb3vwCjZLSWSgQAAA==",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2300",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.79",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573763",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.16506354",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/LPl1ttVNUENRBIuggHpQWXdh2w7ZAxP/eguYhgm5v3jfMTN5DVqlzd5eQwsFWKrO6q60BAplVxj0gzfvx9IZoSTFEXC2Q00gEHAbyA3KkKOLkG0ZM8D9wji0+9eu2LTu/wT+2qrxJJ1tIGWUEjtLUrpnEybrSKT97lBd1ndFeqrrxLcioCGJBYKflazIHIU0ihgQ2VlsfbJ5aD8Ub72j6FRQBAAA=",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdk10LwiAUhv/L6dZEm8u1rqIaQV1EBV1EF4ukhDVjSRDRf09qfW84Q/w4Pnpe9RwXZxiv5Oy0FxDCUK3kVCVyDQjGSqb6AOHifB8aTNqmwAW9ZuqUkPatMRUuy8e2TpbFJ7PX55h6lKI6o5gGzRZqeLjlE4p+gMcw56Z/AsqwHzTYH6BU4w34JGCFru6g4FSf4MeVVaOKeOk9LK5cTmWJh/sjWkGV17Ukg0v6WMRLY+6ecC65W1G8SswtgfrSMH+yJ+Od0CKDkGCCYCTSjd7mxkTpWEuV5uZcrp9oIORmq3Ojn4jj+8KuSpRxCLV+FPGIm79/BR6Y7TVKBAAA",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8109",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.08",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573764",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.5819776",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/Lrrq62ikqCOogEXQQD0aLLmz7wrZAxP/eguYhgm5v3jfMTNFDftGn7q4ggz1edI6mq9ECgRy1dQ/Iin48vUGGNEwSuVzwiAoZRDCQHzDilMs4/YaJEPwPnGPLT/2qbavOb/CPja5uyqkWMkYZgYOytWsmcURXOe1nj/KsrzPaKV03voUzKoNYEtga9ZrMQUhTwTiBNRr0wfZpzFC+Aee4m7MUAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdk10LwiAUhv/L6dZE25ZrXUU1groYFXQRXSySEtaMJUFE/z1p63vDGeLH8dHzque4vEC0FvPzgUMAY7kWM5mIDSCIpEjVEYLlJR9qTLq6wBW9ZpqUkO690RWuq8e2XpbFZ73Xd7DDmI+aLsXUb3dQy8Edj1D0AxwXM6b7J6Au9vyW+weo1HgDzPNoqasclJzqE/y4MmrUEa+8h8GVzakM8bB/RCOo87qGZLBJH4N4ZcztE84md2uK14m5IVBfGvpPDkS854pnEBBMEEx4ulW7wphKFSsh08JciM0TjbjY7lRhDBN+el/Yl4nUDqExDEMWMv33b3pviSRKBAAA",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8109",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.08",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573765",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.3115459",
    Cost: "0",
    Pbi2DGeometry: "GAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkMQ1JPYkKgh6KCB5KDy2GNhATqVEopf9uoLUgCN529g0zk/eQVebc3TWkcPCVybztau8AQeaNCw9I8348o4EShQXjYrWgHCeScRjQL8opplKob0oJJoSqf3ROLj4T1m1bdnFHfGxNedNBt5BGO4KjdnVoJnHyoQwmTh/lxVxntNembmJNLJFMSAQ7q1+TmS2xSghFsPHWx2D3tHYo3ov1NYkYAQAA",
    Pbi3DGeometry:
      "bgQAAB+LCAAAAAAABACdlF8LgjAUxb/L7XWNzZamPUUlQT1EBT1ED0ajBubCRhDRd+9SZpFJU8Q/158797gdXV1hulGLy1FCAGO9UXMdqy0QmGqVmBMEq+vzEjHr4gY38r7T5Ix1Hwfc4bZ+DeulaXTBsZz51HWES5qCU95xfeK0qN9mnBRJS1DPw/ObcEHbHUfUIuV9csIZZYz7P9RyUvBWIEW1/30sHJS/j4VaBW8W61NnRv8Ti7m2SEiFVFk4KM9BnSRWyHUFBxY5sFi5rz743Q5UdJBGphCgLoGJTHZmnxUzbSKjdJKVS7XN0Uiq3d5kxTCW588H+zrWKAiNYRh6oYf/hzsU+EVFbgQAAA==",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8109",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.08",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573766",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.96477586",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NI0jSmdRIVBB2KCA6lQ4uhDcREahRK6X830NpBBLd37zvuLu8hq/S5uytI4eAqnTnT1c4Cgsxp6x+Q5v14BgONYiyXNFotKMexZBwG9ItyiqkUyRcVmHEp/tE5ufhMWLdt2YUd4bHV5U151UJKMEFwVLb2zSROzpdeh+mjvOjrjPZK102ooQRLJiSCnVGvycwinMSEItg440KwfRozFG/9cv22GAEAAA==",
    Pbi3DGeometry:
      "bgQAAB+LCAAAAAAABACdlNFqgzAUht/l9DaGRKOx9mpsSmG7KN1gF2UXlgYNODNsKIj03RtaO0edREU0Hr/knN+cX3cNbPbyo/4REMGr2st3VcgDINgoWeojRLvmdmswWZkDzqh74lBCVteLOeH8dV/2VFVpbdZSz8chpx5yGMU0DJbI9fDSJxT1iccw52bsCGXYD102iwzX6UiAXRYG/2W7k762R9LPZq8zRsHw+9izTdFm78+cHbWTMXttd8gUV9kVDPtgjhOn+Hq8gjE+sHfuoY75bl9k+i20qCAimCB4E2Wm8zbYKp1qqco2/JSHX7QWMst1G8SFOP2d+KwKZRLCIk4SnnDzf7gA1ml1bG4EAAA=",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8109",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.08",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573767",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.60096041",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI+mesJ1FB0EMQwUPpocXQLsREahRK6bsbaJV68raz3zAzeQ+ywnN3V5DBwVYore5qa4CAtGjcA7K8H09vCGJOo1jwVcAZTVgKA5lBnlDG/zMeisUvnKeOtPjUr9u27PwG/9hieVNOtZAxyggclaldM4mTdaVDP3uUF7x+0V5h3fgany3CVBDYafWazGFElwnjBDZWWx9snloPxRvvHZlOFAEAAA==",
    Pbi3DGeometry:
      "XAQAAB+LCAAAAAAABAClVN0KwiAUfpfTrRNtP7Z1FdUI6iIq6CK6WCQlrBlLgojePalVi7JcIYrHz3O+86ezIwwXYnLYcoigLxdiLFOxBARDKTK1g2h2vG41TJp6wAk9ThxKSPOy6Amn+U2tlefJQes61Mc0DAOk72CfBKju4tAnFL0ArocZC0LkeBS7XoP+ARg57kBZg9Yb7GGrrPIFeUvzjLzwWHhgjMZs7BfXrHJjVzFzzuyi/Bz/W5rqjfGFvmLJPmbM6PEvBavYmTb8+pV2RLLhiucQEUwQDHi2UutCGEmVKCGzQpyK5R3qcbFaq0LopnxfvtiWqdQGodaNYxYz/RucAUwHNrRcBAAA",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.02",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573768",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.31222372",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk2x9qPYkKgh6KCB5KDy2GNhCzUqNQSt/dQKvUk7ed/YaZyXvIKn3u7gpSOFClMzJdTRYYZKSte0Ca9+PpDYtQ8iBM5AqRYxjBwGZMRlzIfyhGDH7ZLHKExad63bZl5/v9Y6vLm3KqhVRwweCobO2aSZzIlU77yaO86OsX7ZWuG98iBU8wThjsjHpNZgz4MhKSwYYM+WD7NGYo3vNcptQQAQAA",
    Pbi3DGeometry:
      "OAQAAB+LCAAAAAAABACdU1trwjAU/i/H1zQk6c3Wp+EswvZQVNiD7KHFoIHajBoEkf53g9baiemaERJyrt+5rs+Q5mJ1+uEQw4fMxVIWYgMIUilKdYB4fb59tZhM9IEaPTgOJWRyffSF+vtu9lZV2UnbOtTHNIoCxBhmno+YiyOfUPTMdz0chkGEHI9i1xvT//JN/lt+Rz9gzH046hj0C15B/BY8Y/wNbsrC6Mk+qAEFGdQgY52GJNeb9SsI2xnoR7bqUF+VTKHa98dq/gZA6w18F9meK15BTDBB8MnLrdo1xEKqTAlZNuSX2LSiORfbnWqIWcGPXcWpLKR2CKNZkoRJqDf9Aj9Khcg4BAAA",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.02",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573769",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.85713984",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjssKwjAURP/lrmNI+jKtK1FB0EURwUXpoqWhvRATqVEopf9uoA905eo+zjAzWQ9pidfuISGBkykxNaqrjQYCqUFtn5Bk/bg6wSrg1A8E37gZi3UIA/mCPKSM/2Ee9aNA/LLFdIb5HL5t26JzDdxjj8VdWtlCwigjcJa6ts10XIwtLLrS43nDakFHiXXjUjijwosEgYOS70ns+TQOGSewM8o4Y/1Sasg/mMHX4xIBAAA=",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABAClU0uLwjAQ/i+z1zQkfaWpJ1HLwnoQFTyIh4pBA7VZumFBxP9u2K1VLCEGCQmZ+TLzzSvrM8y2cnn6FpDDl9rKharkDhDMlKz1D+Tr8//VwGRgFlzQXRNQQgZ/h9lw2dzMhk1TnoxtQBNMOU9RTDHPWILCCPOEUNQDohgzlnIUGEUUZ/QNwMrRAZ1FiKM0zu6uOgsX0Od4Bp453OTWPKyu/KNyl+TlRllr5U7QlXmfw38YXOQejXLVyhquf6M8JvFFcvMnx7I8Ci0ayAkmCKai3utDK8yVLrVUdSuu5K6DPoXcH3QrTCrx+/hwpCplHMLHpChYwczfvwIekGg+SgQAAA==",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.02",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573770",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.60963545",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzFk0x9iPYkKgh6KCB5KDy2GNBATqVEope9uoFXqydvOfsPMFD3ktT53dwkZHFytc2c65SwQyJ22/gFZ0Y9nMCxipFEscJUKyqOYw0BmEBPK8C9LEZNfNgsdYfkpX7dt1YUF4bHV1U162ULGKCNwlFb5ZhIn5yuvw+hRXvT1i/ZSqya0IKOCp4LAzsjXZOYRXSYMCWyccSHYPo0ZyjcpQSdnEgEAAA==",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABAClU8kKwjAQ/Zfxmoakq60nUYugB1HBg3ioGDRQG6lBEPHfDVq1LqkNEhIyeZl5s85PMFry6XHHIIKBWPKJSPkKEIwEz+QeovnpdlUwaakFZ/R8sSghreuhNpwXd7V2nidHpWtRD9Mw9JHfxLbj2sh2cOgRij4Ax8VB4IfIcil23Cb9A9ByPICShk+p9zRV0qgGvnG8Au8cv8m1cWhNmXtVJyU1C6XNVZ0AqyP/xmHeDNXkRoWqzpXWXfNCGXViLXI1k12ebJlkOUQEEwRDlq3lphDGQiaSi6wQZ3z1gPqMrzeyEHopO5Q/dkQqlEFo9OI4iAM1+xcH3H1FSgQAAA==",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.02",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573771",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.36126349",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkbSppPYkKgh6KCB5KDy2GNBCzUqNQSv/dQKvUk7edfcPMFD3ktTl3dwUZHLA2OdpOowMCORrnH5AV/XgGw0JwGgvJV6mgQrIUBjKDPKGM/2UykdEvm4WOsPyUr9u26sKC8Nia6qa8aiFjlBE4Kqd9M4kT+sqbMHqUF3P9or0yugktnFEZLSWBnVWvyRzFNE0YJ7BBiyHYPa0dyjdudmRDEgEAAA==",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABAClU02LwjAQ/S/jNQ2JTW1TT6IWQQ+yu7AH8VAxaKA2UoMg4n83aFe7amqDhIRMXmbefM6OMF3In8NWQAxjtZDfKpNLQDBVMtc7iGfH69XApGsWnND9xaOEdC+H2XCa/6n1iiI9GF2PBphy3kGcYRYRjto+5gGh6AnwGQ7DDkceo9hnEf0AsHLcgIpGFETtu6mKRj3wiuM/8Mjxntwah9WUu1dNUtKwUNZcNQmwPvJXHO7NUE/uVKj6XFnddS+UUyc2IjczOZDpRmhRQEwwQTAR+UqvS+FL6VRLlZfir1zeoJGQq7UuhWEm9tWPfZUpYxBawyQJk9DM/hnzVLFBSgQAAA==",
    Absorptance: "0.1",
    Area: "26",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8028",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.02",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573780",
    Name: "Basic Wall: WC Trennwand 5.0",
    Category: "Walls",
    temperature: "22.20697903",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAUhP/LOy+L627q2kkqCOogEXQQD0qLPth2w7ZAxP/egmV16vbmfcPMFAPkNR77q4IUdrbG3Oq+sQYI5BaNu0FaDNPpDaGkSbIIl4xJKmTMYSQfyAUVXPL/MIqY+IHfsRMs3/VZ11W93+Afa6wuyqkO0oAGBPbKNK59iYN1lUM/e5InPM9oq7BpfQtjlMWCwEarx+zlgSSwstr6VHPXeiyfE/QJ6xEBAAA=",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABAClU00LwjAM/S/xWktrp3PzJOoQ9CAqeBAPE4sW5iqzCCL+d4NOHWr3gZSWJi99L03a5QUmazU/HyT4MNJrNdOR2gCBiVaxOYK/vDy2CLMODriSt6fOGevcF5xwXT2PdZMkPONZ4VDRdAXh3KOOhxtGBfPIl5tz6rQbCDDKXNH+B7AopO5MdKvFnTdNJj4f+ObPuj/5i2Qt2VtoquVSXIJSLbFWpsyl8m/7S6N62/PFSzcmr0bWRKs1ptJrKyGM/62vwr00MgEfcyYwlvHW7FJjqk1olI5Tc6E2L2go1XZnUmMQyVM2sKcjjYRQGwSBG7j4r28i7ibyJgQAAA==",
    Absorptance: "0.1",
    Area: "4",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "WC Trennwand 5.0",
    "Family and Type": "WC Trennwand 5.0",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1388",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "WC Trennwand",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "WC Trennwand 5.0",
    "Type Comments": "Mauerwerk",
    "Type Id": "WC Trennwand 5.0",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.22",
    Width: "50",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573781",
    Name: "Basic Wall: WC Trennwand 5.0",
    Category: "Walls",
    temperature: "21.57136422",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyE0TWO1nkQFQQ9FBA+lhxZDuhCzUqNQSv/dQLUHEbzt7Btmpughr/HU3TRksKcac7KdIQcMckLn75AV/XgGg0y4VKlciljxWSoVDOwHFJIncxV/QxWLf3CKLT/1q7aturAhPDZYXbXXLWQRjxgctDO+eYsj+cpjmD3KM14mtNNomtAiBBdpwmBr9XPyymjBYE2WQqp7WDuUL3qtyzoRAQAA",
    Pbi3DGeometry:
      "gRwAAB+LCAAAAAAABAClWE1v00AQ/S/L1Vj+9iY9IWiEBIcKkDhUOaSq1VoKMQoWUlXlv2MFJ2R3583MBiGgeR6/+dhp9s3cv5q7h/7by8/OLM2n4aH/Omz7R5OYu6Hfjb/M8v7174/T4+xm+mMOyT/kbZ5lN8d/pr/msD699m6/37xM75ZVWtZtmeRFnZY2K5M2bYuyTS7xylY2ydIyWySBuQ8XqbWNDVlmPDRvM1sRcF1VFFw2DUB9j/kitW0RWE9w0+QB9cmaiDsuQDp7VFtsf6x5nk//F0S9wgfMG+yBEPgxsyjXbOPAWOPOMSZQikdKGPQJRU/7RYFCJuaFanH8QZ0ZrASZshRpWIpjPD7cpO1ET8ATB7RGyYY+C1sANOBoJjPbUnhVZyHLbO7DZWrzOuzjEx6aN20ZdDFOnwuFqApIlC7i7DRsMfgA9Vi8Z1T6eMeoKaPOHJ3ifABUidiaak9sbgeKHzgW+g15AH1IOWZ/K6KahTwC4fvrHGhd5GReZ9zNyzX3Yf+X9wy7X0auNfJ5kaoQJCZik6IckNnC+L3mFMJB9v4JSlHG8kvphg9AREFPOeZ+eXhrHw6Viot77IFOmWFPhZ5RV+C6sDbP4Ip3QwnKiPiZVCER6ZhNVs8uhPPf/HT0sMqIh2tXd5qIa1d+ZgJFiIUBNxjT3LEGNDGQyJI1GJniuPGop7WNCBrqTfImY7+MBGOJ+YqhVU0ClLbLDe5ZXjv78lYiAWLYVVyqq/1KEtWwopT8QKnEwpy6AxWkRGXkRSyO6ZpNgEQFdwdwmA61KMwDDhbSG8zUBKrLjPK0c+5GpGt1RR5hVPJ5gI1BRLhxtxS/+oHFgLMBB0eUTnogXaeSgGT1pnpNyN/tau2HVFXsilC9zdT5VcsKDiaCUUgFjfYFzJJDYHyVXmUmbbQb1a1SdW7V+oKDwV5HK63AsAj2EgwsrRR5j3geR0sktPXUbdl0btVih4PRhk29gEEbA7SFYnFx7Xb1XiZu6aZeM+r8SmJQWjlfkK8T86Hf/OjGbm+WWZol5nO3exqf5w9fhnEz9sNu/vi9fzw/+tj1T8/j/OF22/2+NHw/bIeJ0Ly5Xa3aVWsO6z9rcV0dgRwAAA==",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "WC Trennwand 5.0",
    "Family and Type": "WC Trennwand 5.0",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "3715",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "WC Trennwand",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "WC Trennwand 5.0",
    "Type Comments": "Mauerwerk",
    "Type Id": "WC Trennwand 5.0",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.27",
    Width: "50",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573782",
    Name: "Basic Wall: WC Trennwand 5.0",
    Category: "Walls",
    temperature: "20.20308929",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjksLwjAQhP/LnkPIq/ThSVQQ9FBE8FB6aDG0gZiVGoVS+t8NVKuevO3sN8xMMUBem2N/1ZDBDmuTo+0bdEAgR+P8DbJimM5gkIoqmcoFF4LGLFEwkg8UKU2SSPyHkVK/8Dt2guW7ftl1VR82hMfaVBftdQcZo4zAXrvGty9xQF95E2ZP8mTOM9pq07ShhXPKY0VgY/Vj9kqWElihxZDq7taO5RNHB+E6EQEAAA==",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABAClU1FrwjAQ/i+31yykTSS1fRJnGbgHmQMfxIcWgwa6ZnRBkNL/vmOrM6itKRIScvddvu9yya1rWOT64/ilIIa5yfXSFHoLBBZGl/Yb4nX9t0WYJTigIWfPc8BY8rvghGZzOjapquyIZzmjTPKIBGFIJYsEYZSzMblyBwEVUYiAoHwk+SNAh0LrdqJHQjg0Tnw/cM3vui/578l2ZN9BMyyX+yXwepLOyvhcqv+2tzT6gWGFGPS6XsI+37C/GN4fxUMW++1FZ5/KqgpizJjAmyp3dt8a78ZmVpuyNVd6+w+9Kr3b29aYFergBk5NYZAQnmZpKlOJff0DSlNTsSYEAAA=",
    Absorptance: "0.1",
    Area: "4",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "WC Trennwand 5.0",
    "Family and Type": "WC Trennwand 5.0",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1388",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "WC Trennwand",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "WC Trennwand 5.0",
    "Type Comments": "Mauerwerk",
    "Type Id": "WC Trennwand 5.0",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.22",
    Width: "50",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573786",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.23418182",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsELgjAYxf+X7zzGpm5zdooKgjpIBB3Eg9LQwdrCViDi/95A8xBBt+99v8d7rxggr/W5vyvI4OBqnTvTN84Cgtxp6x+QFcN0BgPlWDLCVpSmOJKUw4h+wDjGTHLxDZmIoz9wiS0/9euuq/qwITy2uroprzrICCYIjso2vp3FyfnK6zB7khd9XdBe6aYNLZTgRKYCwc6o12ymEU64iBBsnHEh2D6NGcs3q2p/1RQBAAA=",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdk1FrwyAQx7/L7dWJmhiT9Km0CYPtoayDPpQ9JFQaIYslk0Ep/e6TNWuztsE4RPH8efdX71wfYFGqt/1OQgrPulRLXasNIFho1ZhPSNeH09RiMrENjuiy8kgJmfwMtsPx/ddt2rbF3vrSCCeccESDAPMkEogyHEaCoRvAGE4inlwAjXEYk+AfYFCjB7gI2N1QJ3DnVH/BTSinxhjxwXs4QvmcypEP/0d0gjGv6ygGn/JxiA/m3L/gfGp3pPiYnDsSdaVh/+RcFR/SyBZSggmCF9lsTdUZr9oURummM1dqc0ZPUm0r0xlZLb/6G2e61jYgPGR5LnJh//43ANyg0koEAAA=",
    Absorptance: "0.1",
    Area: "15",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "4665",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "1.7",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573787",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "22.8660918",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyHkx8a2nkQFQQ9FBA+lhxZDuxATqVEope9uoLUHEbzt7DfMTN5DVuG5u2tI4eAqzJzpameBQObQ+gekeT+ewSAk5XIRr7iUNErUEgbyAzJFlUrEN4y44H/gHFt86tdtW3ZhQ3hssbxpr1tIGWUEjtrWvpnEyfnSY5g9ygteZ7TXWDehhTMaCxUT2Bn9msyhOIkYJ7BxxoVg+zRmKN6TSR96FAEAAA==",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdU98LwiAQ/l+uVxPNNtt6imoE9RAV9BA9LJIS1owlQUT/e1Lr94YuRPHu8+47v9PFGcYrOTvtBYQwVCs5VYlcA4Kxkqk+QLg437cGJm0z4IJenjolpH1bzITL8hHWybL4ZGIbDFPWbCFKfNzyeICMI/AIRT8Aa2LO/eAFMIa9wOd/AKUcb4BHG7Qw1R0oqOoT+Ell5XAhL72HJVWVqiz9sIrorlWputVbW+WVOJK7qGuRxFpu9Ua5qGuR5IvD/MmejHdCiwxCggmCkUg3epsbE6VjLVWam3O5fkIDITdbnRv9RBzfD3ZVokxCqPWjiEfc/P0rHk6XgEoEAAA=",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8208",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.09",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573788",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.21402788",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjl8LgjAUxb/LfR5jf3I6e5IKgnqQCHoQH5SGDtYWtgIRv3sDTQiC3u65v8M5pxggr/W5vytI4eBqnTvTN84Cgtxp6x+QFsN0BsOK4YRKuaac40iKGEb0AxKBhZDsG3JMZcz+wCW2/NRnXVf1YUN4bHV1U151kBJMEByVbXw7i5Pzlddh9iQv+rqgvdJNG1oowQkTCYKdUa/ZzDiWEaEINs64EGyfxozlG8fMs9QUAQAA",
    Pbi3DGeometry:
      "SgQAAB+LCAAAAAAABACdU1FrwyAQ/i+3Vycam1jTp7E1DNqHsA32UPqQUGmFLI5MCiXkv1fatB3NwiVDFM/Pu+/8zlvVkObm4/CtIYaFzc27LcwGCKTWlO4H4lV93nqYzfyAhtxOHjljs9PiJzTri9tTVWUH7zsJ6JQrRTiL6DSUigSCqpBx0gHEhEoZqRsgBA1VJP8B9HJcAUG5ksEfoS5AJ6t7oBMK5cDJe9+BhhqeFVoPVMThWvWqO760w3/JYHJcXVQSNN3xhcLVRSW54/A9+WKyL+10BTGjjMBSl1u3a4036zJnbNman2ZzhV612e5ca8wLvf998dkW1geEh3mSyET63j8C4aKtiEoEAAA=",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8208",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "3.09",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "573789",
    Name: "CH/PH Stock 1",
    Category: "Rooms",
    temperature: "21.44035862",
    Cost: "285.798365",
    Level: "Level 1",
    Pbi2DGeometry:
      "jQEAAB+LCAAAAAAABAClkEELwjAMhf9Lzl3p0qndPIkKgh6GCB7GDhPLVqitzCqMsf9uYbqLQxBvefnCS16yFtKTOjRXCQls7UmlVjelNUAgtcq4GyRZ25d+IAgjKhAn8yAK6QwFQkfGKHI6xZj/Qr2hEHH0Hx296jv9TJS/oy/qumh8ft9YqeIinawhYZQR2ElTuuol9tYVTvmX9fKozgPaSFVWfk1MGSInsNbyMcxyFhNYWm29q7lr3eVPI8Rfz40BAAA=",
    Pbi3DGeometry:
      "qwcAAB+LCAAAAAAABACtVd9rwjAQ/l/ynIb86Fxan8YcDLYH2QZ7EB8qBg3EZnTZQKT/+4JWq67XpGyUluT7LvddkrvrbIemC/22/VAoR092oV+t0UuE0dTq0n2ifLY7DD1Nx/5BNW6RhFE63n/8i+r5cdldVRVbvzZhKZGc3+CECzLimcAZEYIJnKSMSJmlPYQf3HLJw8RJAySC4pQImu1xkUoG437A5Cg7w/v9QPbHSBv81w4C9pD/Hj9B+078+uDCR916kpSxSKL/OocE1S3RXg8YFHQeQLBQAsSk3nWKHSRAIrzvDldgbYHiQwsi1j4cEuQJSv04/B8bTaC6ovEY5cgcGFReF0RHL4hNwAiNUPuLxf+8CUhiaMcHy/RS2f/5JrrYKKcqlFNCMXpW5cqtm8mLdYXTtmym73p5oh6VXq1dM3kw6vvc8N4a6x2WX8bU8x9c6xVcqwcAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "46",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4600",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "1",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "27527",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "118.67",
  },
  {
    ID: "573790",
    Name: "CH/PH I 2",
    Category: "Rooms",
    temperature: "20.93733854",
    Cost: "397.1235695",
    Level: "Level 1",
    Pbi2DGeometry:
      "bwIAAB+LCAAAAAAABACl0rEKwjAQBuB3uTk9mjSpSZ1EBUGHIoKDOFQMbSA2UqNQpO9uQO3koHXL3XckcH92d8gPZtOeNWSwdAeTO9uWrgYCuTO1v0C2uz+PYSCiHCVjYhzRFOVIQUc+okAq0vQnDU2l5J/KUUjGh6hCOlL0e+MUpVR8sEUsQSbYD9jvbzi+Q9u/w500TdGGhENjZoqT9rqBLMaYwErXpa9exdr5wpvwKZ7l1hx7WmhTVuEVhTFjCYG51bd+NokVgamzLtxaX63t9g+9AU68bwIAAA==",
    Pbi3DGeometry:
      "3yoAAB+LCAAAAAAABACtWsFu2zgQ/RedHUIURUlMT8W2wAK7h6It0EORQ4oarQFvvMi6BYIg/76yFcn2zLwZMi2CBPFo9N7jDDkcUf78WL37svn48O+6uq7+2n3ZfNhtN1+rVfVut7nb/1ddf36c/h0v16/Gn+ppdbJc+bp+dfwz/lZPN/Ntr+/vbx/Ge69864amiaurJrgmNqvkQvBhdbL7zg19Wuytd8OQWu4fnU9pmP6JXWcCney5NyAGJGm2J+f75AtG0Lo4NK2FA/3nC7n+xSElgmoX6nS0hnbwwDqDm+YLKcRMoGsX22Z1FV2TQjiz1m1Kgvno3Dnfxt60ShAhuaEOw8Hc+xRNGTJyPxyGLUNcOmO+SZ08lHHWet8wZ2aenVPXtpI3sp+hLAJHcwyDhJ7FOYUEg2RIQcrHj23TDzQ7h5sHz0J7uNnzxGOzCnKZHwubePfOjysuGxoImcZOvM2CONnrMbneC4Wy/MJvqMWUgtam8gs2ObzD5nguseUXCsjhHbXrfMNVta4L0QvUwF9hCC76jkOBHQcQ94f13ufKLN39lFAD9RAKCF12I1WosXtz78tNdMIGZiM2HAT0I4CyZJPP8bVkyBhaQ2CYrRyA3lOBIU3LZXYEuyqHqFfkiPDUH8sBLZes0lCDWO3tQ7dbSUG8QhOSSwy3LXIDKveY2q5BlJvt7NlFmlSzDFFW/bPVgkhBbjj3WJO32Gk7t1wgDTSx/zIz9pcJXjJmeWy837cYWC9cWhheSMAa/EszncNgbuOZSptfy99cPGTGK7MIjEvOPSRmnXf2aqYXEBJr+bMahbyWiz//6h0ae7LRNfJnspfBQ/cidCXysnq9+yMRRj0QXljk2V4vDTBTxgpCMHkLulRl6Xq2gkYGyw5gzK4MoKs1gZPK7mXa4eSWQwZDoC97vr7VMgciQGdBdjeccTyY++Sg76gkKuMES7EJB3vbNfysiB3v5XmfwJvuONlj3Wm7uIauoGSiq6z62SSf0k2K4vrqwojJAwNQiigBdNdFNnh8tEt0q4lT7AAGRQUc5QLpYKCAU45hoRK0nIFCUOtn4anv7IPzLGcqJIWzjVcJrIwNQPKwLU5w1C7uf0uC+L44r30iHcGUsAL0swpCQyBnjkg3MgfMAASFBVVKSTiOIiAFQSzUgsotCq7YSC3aR3sz1ImpZC9WMt2JnNEemqgeBqgEGlA2g05tvhwiLcmULm6figEPkPZgmsuJsI8lhUYAv5Ei0tUUKnYAgwKD3qYh8WiwgFYOZKkYcFiDVaJjokV9n2IryCTvDjPdmZw+emHDFYIM8BFOLr5JbL63pSNbMkbPoJbCQIYAkcqoEcN5haHRAMmkQ7CSiewIB4YI1lRxAEpMETMKabEiWJtlqfDwZFyQoWZPL9x9Nud5n8Drlj/r4NfaAB2hZKJbrHlfDVhQuj4I9t7VvmfPAQpMEStAH81tkCIAskekW9lDdgCDAiN94QEoh1EElCCIZUqkAxkcWvlg+CT8vIfl7svos7yploueFEdWwoYYWdAqI/g6Cj7hntLD7fPyJ0FBMIWsAH0uIpcBgF/IIdr1xGE7gEGRQfUSaAdDBaQgjoVaUNEVNN6sqjeb23/W+/V9dT1uiqvq7/Xdt/335w/vd/vb/WZ39/zx0+brcunP9ebb9/3zh7fb9c9zxz92290IePdju326+R+HprR83yoAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "81",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "8100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "2",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "36257",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "210.09",
  },
  {
    ID: "573791",
    Name: "Stock 3",
    Category: "Rooms",
    temperature: "22.32847742",
    Cost: "434.260889",
    Level: "Level 1",
    Pbi2DGeometry:
      "gQEAAB+LCAAAAAAABACdkEELgkAQhf/LnLdlXTVcO0UFQR0kgg7iwWjRgW0nbAtE/O8tmNI1b/Pme8zMm7yD7Irn9qEhhQNdMSPTVmSBQUZo3RPSvBtKb1hEAU8SFa0Uj+NlBD37YUHMA6WS2UxKHgr5DxyvmQ/He4ox7rppytZn9o0tlnftdAOp4ILBUdvK1V9xIlc69G8a5AVvE9prrGq/RHEhZchgZ/R78oZCMdiQIT/Vvozpiw/uv0whgQEAAA==",
    Pbi3DGeometry:
      "7RoAAB+LCAAAAAAABACdWNtq20AQ/Rc9O8uudnVLnkpbKLQPoS30IfjBISIRuFZx1UII/veuLVuydubspQTH1vH4zNmZ2dnLw1t2/9h9f/3VZrfZ5/6x+9Zvu6dsld333W74nd0+vI0f7dfyzv5lh9WM3Cgp707/7Cs7rC8/e7ffb17tb29UIVTT1KtGFEVp7JvWSq8mOM+FlvmMGyXqujHJOKB3YGutTa0mFmnfmhk+W8/oNXUUCohdWApprDqrUlcWOMO6EbXUFjaiMaa6sq5qDi1MfkQLVRdhitHh0trPvBQHNPMUWAajWZXC5BVhtrCqVeVyWLixqWWsAQxIRpdAiQNXQpVlrBBkDByOHA4Mq5erdVK9tVTKBwMSpqwD08ihdqyhEH7OsfIcHe7sDzQXpYUxtuBcgQhHNMeylSUxR2oQ/dwFvPEKuQWZQ2qYjun0pGWakMoQv5vBBL8prTPWOigG0CS3/MR0BLI6waQzBPBQybtuSWMM8JAGFrRH+lkeso5M8HLF8Pc2ssyFzFlywEIXNS87WQj8gUEsgXxHN31+eoCo+/s76RColsjCntZpSAwcHsQP7QN9GOFMbbPjhePiKwHVEzAHSQlVJZNyZx+3nAwODOkRzf9VGmPOqYERRhlPCqV/oxK9PnlXV9SxaNibItdHPJd5+NwQZTxT5+UJV4WdPTjTHnIPSSS51yk8grBFIUXeFDT5Fi91U9CwAJIkjzxzWRZk6Pjg5Kj2Zs2DAxoUE/7EB5TzwwQe+QCm6QCbACAPLN+jaiPKuipcfeQEHGW8FGJEpVUZEVSeGnBEUQc8glM+vyu65Ibuc8YZT4QjmhSvgH1qHDQAfNoc6YG0ARiQoLCg/sgJx1EETkEQE7WgLstq9GygtJZuz8f3NFHGM7U0dIHAFzU8OSKJJA85jbtimljKSrObD6kqQ7UjliSnPLlFTd5wAQCpc5SHcodwQIPiwt2QIekoisAlCGKaEvbghmPLn9AuwpcNAF35xd5IOiFnnJ5EujMdjom/rOTJCR64NY0bf0A5jsDYGQj92AJCAfBqxFqATyQR5BS1OlY5dApYUKtD7KAcQarTbqUgDVNg61X2odv8bId2n93a9XCVfWl3z8PL+eFrP2yGrt+dH390T9NXn9ru+WU4P3zctn+vDd/3294S7v5st4f1P/jjFXHtGgAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "32",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3200",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "3",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "24028",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "82.29",
  },
  {
    ID: "573792",
    Name: "Workshop 4",
    Category: "Rooms",
    temperature: "19.16882887",
    Cost: "87.7979448",
    Level: "Level 1",
    Pbi2DGeometry:
      "+QEAAB+LCAAAAAAABAClkc0KwjAQhN9lzzG0Sf9ST6KCoIcigofSQ4uhDcREahRK6bsbqRZBQbS3nf2W2WU2bSEpxK45cYhhrQuRaNmUWgGCRAtlzhCnbV/agQkhOGCBP/U9TF2fQIdeoOfiKGLeCHi3D1n4A3R97DIWjYAfD/oGaUDZH/AtvuwZ86yu88ZmbRsLkR+54TXEDnYQbLgqTfUQW21yI+x7erkXhwGtuCgru4VhhxCKYCn5dZilDkMw11JbV3WRsstuQ8InC/kBAAA=",
    Pbi3DGeometry:
      "Jx0AAB+LCAAAAAAABAClWE1r3DAQ/S8+O0ayZFlKTqEtFNpDaAs9hBwSsiSG7bpst4UQ8t+rzWbX9miePgghIX47++Z5NDMa6fq5urobfjz9XlXn1Zfxbvg+rof7qq6uxmGz+1OdXz8f/vUfiwv/U73UE3Imhbh4/eN/q5eb49cut9vbJ//dM9k10jlbt21jetfXrlFKqvqEd7pRsmvnuDLKcTjiYe33ds502biWjbVOQ5z6TfGg96U4tReNEi6UM8FKW1kIA24Ki6bTba32Qu0M7K3dg6bV7QwV2lliq1xjheKMeYpXb6YRndBpCsYfT4wpGH8n4iUsTeP8ahF/sm+kMZTY20orewbWbR8yI46Dv0BGlHqpjtcMKJAMTjMqjUgJkGy0QkqM55bqjAeVKvJbVkt51kkxgCZW7gk41axymwyN2OR2uVIMHtVD5EfksPTUHssB7Y1XSdQU7CwHvG9s7wsrUIlwxKMb1xsV2EM9gJ9mIIpaym/Bjoz8LnbeUvwdkwDLj9pFLp49gSTimSqioH2fYNKp89INpgO1B/zJYkRpjsIQ+l3uS9EoBHv6CV7MJok2RceFpDlDjt6n1CkPBxtwNFiIBIQ2oTzYwkDMcf6SYSVR98FUkUhgbF9U91AnCD2Ww9dloUwkJzLlZE1LQY4Q/nAejttH+JcDdDKpiujBqkTUx3I2VzxfV8gp0Jg/Rb3jDIfSA7ahMA1c16q9eGtllzgAZVtP5K15DZhVvYoEMsYeYclkj3qFJ0CQGa3rwmr1uC/ujgkMYClyCaiN6YKXBwsX6o4uXAQHNCgq/BEfKAfvCVzyISwTAoYKoI+bNSbVyhhH5dGLiRxbqkJL/5wOKc8MOLKoEx75qxcw7ByWJeinx3onqrMmppgxoJ61DPrq7HItVcdXi0d5BhAN1BQ5yTh4vEs+dmVCUFtlBcJByPiDkwi6PLoYy7WeyIUO9wR8ZQbYEUsme8oruNbjB1Pjt3LFDqxC9poRj2iKvAJ2D+vWcSEAy0e0p5YP4YAGRYa7xkTSYRyBTxDGMinsWQMHlz3QTcLnLQDeUmcZB0qWRQ0jy3FjkjzyqE902w0uUQ6rE8DH8icxASRFHgH1sYPQZsnf0i9lR5cMwjwHCAhqk0A1eEneJR++MiGo0TICb+rq43D7a7VbbatzvwPW1dfV5mH3+Pbwbdzd7oZx8/b4c7g/ffR5NTw87t4ePq1X/+aGH8b16Ak3f9frl5v/5OTCFCcdAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "78",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "7800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "4",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "35549",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "204.21",
  },
  {
    ID: "573794",
    Name: "Leader 6",
    Category: "Rooms",
    temperature: "22.57888254",
    Cost: "366.8999242",
    Level: "Level 1",
    Pbi2DGeometry:
      "uQEAAB+LCAAAAAAABACdkFELgjAUhf/LfZ7DuWnOnqKCoB4kgh7EB6Whg7WFrUDE/97A8iWJ6u2e+x3u5Zysg7SUh/YiIIGtKWVqVFsZDQhSI7W9QpJ1w+gMHsNRSPjcIyGmLAygR1MwwvGM/84YwYzH0feQYk44/Z9NpfjE3uPnr5oWTVO0riu3WMniLKxoIPGxj2AndGXrp9gbW1jp6h3kUZ5GtBGyqt0Xjv0goAjWStxHL/U5gqVRxl3VN6X6/AFiyQlmuQEAAA==",
    Pbi3DGeometry:
      "rA4AAB+LCAAAAAAABAClV11rwjAU/S95riExbTX6NLbBYHuQbbAH8UGxaKBrh+sGIv73ha3VmOYmNw5RmtPbcz9670mcH8hspV73HwWZkMd6pV7qUq1JQma1qppPMpkf/i71bTbVH3JMzsiAMzb9/dFfclx0j93sdsu9flZQyaVIBjyjIs2GiaRCcL1OaZ5x6cFzOh5JLJxymspx3uGdUwsGWABrIPIOHg7pKBVZwqhgMhlSqa9BkOcy9YEGqRs1WBllgvd8nXKDYYMZgA1qN+piDr1ZRseM817x4+B/ts05oUv2c0o93Gnv70rbGmo/yGtnj40S194RRQAaCapNXN/hYrdqYM9mHHydTPTH7oI8qAe+UAKBw9xmEW1rCw5Y4+IOwm7ZAgLBGSPUBUimkyirIgAMkLTKDOoWyiUkf8A7c/v0Bxj3xqxO620/FmpS9LcDGzat/dEhtQ3gjpQHyBxgB/IMFsWRPW4k3S/Bb4zrJ6Ar3RzuMIBdDSgSdssMjEdggONCRKUZaO44bUUc8XBgfNcEePFnVPcshwfCSRvcL7yoxxvmeBI8LGPRa6QqyB1z3kbIbtg6fO7Hwx6X+q/fnVq+F02xIxNtkpCnoto023bxXDfLRtVVu3xT69Oth0Jttk27uC+Lb9Pwti5rTVh9leVx8QMr/rhcrA4AAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "21",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "6",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "21168",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "54.19",
  },
  {
    ID: "573795",
    Name: "Leader 8",
    Category: "Rooms",
    temperature: "20.57843689",
    Cost: "376.967677",
    Level: "Level 1",
    Pbi2DGeometry:
      "gQEAAB+LCAAAAAAABACdkM0KwjAQhN9lzzHkr2rrSVQQ9BBE8FB6aDG0gZhIjUIpfXcD1V4sIt529ltmdzZtQRb62FwVJLBzhZbONKWzgEA6bf0NkrTtyzBABSaUzRYTQbGI51Po0AikEeYiYr9DEcy4+J+NXfONfcbI3nGXdZ03IXNorHV+UV7VkBBMEOyVLX31Egfnc6/Dm3p50ucBbZUuq7AlxoQxjmBj1GOY5SRGsHLGBVd7N6bLnlYPo6uBAQAA",
    Pbi3DGeometry:
      "8w0AAB+LCAAAAAAABACtV9FqwjAU/Zc8x5A0qVp9GttgsD3INtiD+KBYNNA1w3UDEf99ZWu1JrnNbR2iNKen597eJCfX+YHMVvp1/5GSCXk0K/1iMr0mlMyMzotPMpkf/i7L23xafsiRnpGB4Hz6+1N+yXFRP3az2y335bNCMS6iER2ImEkVRzRhUgpJFVOJVCCsRHkxHgbgkziEA+pRxMQwUZQzyRMqOBORStrgkZJxO9yQ9qNNZcl4NHbhOmuY3cyjwW7CYbYvJFTAs8qYCwEWNsgPTVwH/Sp9P9/GQ3xs/mEcqDKUDpbuWUxQ7jZeL1S7NhAO6dQryuJD6QDyNj00g0DUnn5iVdjdrTbsYwdCWmzAwoCQ1kZAsv/p5f0GBpSki9thkoYsoC8eODJcf8TtdDus6+EOfqHjHjIOfsEP5YlbMJB8x+JDdCh56GURxfEWAWsakKGGJutandDkAhaBpEPySLvCqmMdGCpCx8MPaILQ8HUzjuux0HA/T+jW2aHh1qBhnw83u3i4jzch1Lt17yi/RfD9B2APtC1i+Q/qTi/f0yLdkQlnnJKnNN8U22rwbIploU1eDd/0+nTrIdWbbVEN7rP0u0m8NZkpBfOvLDsufgDyG79U8w0AAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "23",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "8",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "21746",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "60.19",
  },
  {
    ID: "573796",
    Name: "WC H 9",
    Category: "Rooms",
    temperature: "19.33312415",
    Cost: "398.9289978",
    Level: "Level 1",
    Pbi2DGeometry:
      "+QEAAB+LCAAAAAAABAClkUsLwjAQhP/LnmPI26aeRAVBD0UED9JDxdAGYiM1CqX0vxvwcbGI4G1mv2EXZvcdZAe7bc8GUlj5g828a0tfA4LM2zpcIN13DxkDVGClEj0ZUYm5kAx6NAAFxUIn6nfIGFYJ4//AKMaCy98h1VhqQv+BgyV8hR/15a+ap01TtLHrOJjb4mSCaSAlmCBYm7oM1dNsfCiCje952J09vtHS2LKKVzQmjHEEC2du7ywnGsHMOx+31lfn+vwOjXSBzvkBAAA=",
    Pbi3DGeometry:
      "zQ8AAB+LCAAAAAAABACll99rwjAQx/+XPNeQmLY2+jS2wWB7kG2wB/FBsWiha4frBiL+7ytbfy3t5S4VUeyn1+9dkrtLszqz5TZ5PX3EbM4e823ykqfJjnlsmSdZ8cnmq/Pf3/K2WJQfdvFaMpFCLH5/yi+7rOvHbo7Hzal8VmoeaCG9yXTKZ74KPM2VkspruAy48oNpw30ehpHuc0intvcl93UU1rw0C6Op6nHIHtUnxgP5bXhfXysdtFxwJXTrFsYy1D6KG20Ad7XNEVV4xiNfWXFXG8AdbQAPjRLKjVYlElIOTVaPD9pjuWfaQ7kE+a3tqXFC+uPnAcglaHrcUo8WvDEJvQJx5SMLH9U3ZofMRxY+pD9QE24cazhQ48UatbnuBA7pDMZviWdQ3yxS+rwRO5Id251iu4bJ67ZpDgri2KRBHYzqt94i6NzeObFkoxad2VH7m5N1XUCd/pZo13dsbuCO4KhvaeWu8aP2//Icy0PInto0qHk+ED9JB4oHy3PLDuvEr60vrE6hcVnW/ar1Atqk20vh2CTBOfHF1Y7JTpGKs73pkjGtXeDcdgAg43G9CJd3O7tclfCgvNv5Cqr6Iafl2fgu2bzHRXxkc8GFx57ibF8cqovnvNgUSZ5Vl2/Jrrn1ECf7Q1Fd3Kfxd9fwNk/zUjD7StPL+gecAJMtzQ8AAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "17",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "9",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "20828",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "45.11",
  },
  {
    ID: "573797",
    Name: "WC D 10",
    Category: "Rooms",
    temperature: "20.29590203",
    Cost: "465.9518223",
    Level: "Level 1",
    Pbi2DGeometry:
      "+QEAAB+LCAAAAAAABAClkT0LwjAQhv/LzTGk+aimTqKCoEMRwaE4tBjaQEykRqEU/7uBahdFlG733nPcwXNZC2mhd81ZQQJrV+jUmaZ0FhCkTlt/gSRruzIMMIJ5FMvpiEeYy0kMd/QBRgIzLujvkAocxWMxBFKKx5yJPyDDRMh4CPwk4St813d4aZ7Vdd4E16Gx0PlJeVVDQjBBsFG29NUzbJ3PvQ7v6eJeH3u0UrqswhWJCaUMwdKoWz/LiEQwd8aFrfZqzP3wAHeGI9H5AQAA",
    Pbi3DGeometry:
      "zQ8AAB+LCAAAAAAABAClV8FugkAQ/Zc942aXBQQ9NW2TJu3BtE16MD1oJEpCobG0iTH+e4kFXRcfs0tjNPJ4vHnMDjPLfM9my+x195myCXssl9lLmWcr5rFZmRXVF5vM939/69NiWn/YwTsjIynE9PhTf9nhvb3sZrtd7OprfcVFmETeKJA8SOLIS7hSUnlK8EBGSQf3Qy6jceiNfJ+PAxVSONI54TLkKgj9kw7wA+O2fOTH1Kd8mvyExzKWR359PvAEVyI50y9hnX1U77I12IKta2vOdTjiiQyiPrYeUmPrMM2+dvNoTc8qsZAS5pbkUzXpoN/Yv843cYpv65/GwXojO7b0a0uLzJsF3665kRyEkw+OqYMeTBTX5BOLiOJCn1RD6+Hr6SdxpIPut6fBorh6saF2YU9H8o4yV+ko+a2M2dVd8aFTg9I3Oo81bhsX8VHHG4pTcbuTya6zmXnojpsOflFtIC7UoXyaflC9IX3H/MN6cNSHdYj8U02vJ8/EyHFrqsSwgEMB+CGHkWsTppqzbVxX/wPq/D/rZbE9HQQPKioLeXpTDDNmEZToGD07dHu4P6jFtLTYpFvDw3odLW/x2oEK2HUQ0G81g+C+oPW78V22+EirdMsmgguPPaXFuto0B89ltaiysmgO37LV6dRDmq03VXNwn6c/OvG2zMtasPjO88P7L69utO3NDwAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "16",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1600",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "10",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "20428",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "42.73",
  },
  {
    ID: "573798",
    Name: "Elevator 12",
    Category: "Rooms",
    temperature: "20.17389932",
    Cost: "395.3857552",
    Level: "Level 1",
    Pbi2DGeometry:
      "vQEAAB+LCAAAAAAABAClkMEKwjAQRP9lzzGkSaqmnkQFQQ9BBA+lhxZDG4iJ1CiU0n83UFu8Wm87+4ZdZtIWZKHPzV1BAgdXaOlMUzoLCKTT1j8gSdt+DAbKcSwYX82iGDMeU+jQFyQ4mnP2D6Q0DIL/ACleLqIJbAgyHY5BsqGqdV3nTegrLLY6vymvakgIJgiOypa++oiT87nXoeJeXvR1RHulyyp8EZhQyhDsjHqNXkYEgo0zLly1T2O67A3Hbg78vQEAAA==",
    Pbi3DGeometry:
      "MwYAAB+LCAAAAAAABACllF1LwzAUhv9LrrOQr7q1uxoqCHoxVPBi7KJjYQvERmoUxuh/N2hXNR8k3SgtOU9O3nOSnpzVESw38vnwJkAF7vVGPmkltwCCpZaNeQfV6vgztNN4bh/QwV8yIRjPvz/2Bd36tGzRtvXBrqUcFSXjcEIpIlclhyVijDA4cFIgxgs6cIpmU+K7RzC2Jme+yonn+kfkY0m68hgxXPrqA56yGQ/giEjQ28mwpxxhUvoR3bwd7IkE8ciIQRzWSByIe9qxvzAulbhK8KziyQTVo1vK2mkiZi5PFVYWvvRqZVVRFk1FzGsVZ9V+rGsl+kSK513PkYX7P6jtwDeyfhVGtKDCCEPwIJqd2ffGoza1kbrpzRe5HabuhNztTW/cKvH51/FaK20Fmw+luvUXTwqKljMGAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "3",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "12",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "6860",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "7.72",
  },
  {
    ID: "573799",
    Name: "Workshop I 14",
    Category: "Rooms",
    temperature: "21.49994101",
    Cost: "150.9034104",
    Level: "Level 1",
    Pbi2DGeometry:
      "hQEAAB+LCAAAAAAABAClkMsKwjAQRf9l1jHkUftyJSoIuigiuChdpBjaQEykRqGU/ruBajcWEdzNnXOZmTt5B1mpju1VQgo7W6rM6rayBhBkVhl3gzTvhtIbOMUk4nQxo3NMgziAHk3AgOKIxex3GHIcJiz+B04d9BV+RinekZdNI1qf2zfWSlykkw2kBBMEe2kqV7/EwTrhlH/VIE/qPKKtVFXttySYMMYRbLR8jF5OEgQrq62fau5a98UTFNOaK4UBAAA=",
    Pbi3DGeometry:
      "VRwAAB+LCAAAAAAABAClWF1r2zAU/S9+doVk2ZbVPpVtMNgeyjbYQ8lDSkNryOKRZYNS8t+nxIljS/dI1y2lpT65OffcD13Jun/N7h7aHy+/V9l19qV7aL936/Yxy7O7rt3s/mTX96/9v+5jeeN+sn1+Qa6UlDfHP+432y/OX7vdbpcv7rtaCWm0yq9KJUzRFLkVWiud11rUtmgwriqhyqZM4QM/wlN+pdDShuY9PLZWTW0J6xHMsB5xV1oUujFOeS2sMeoMF8Laoj7CVSXtxdpo2QTWAE6TqKI0fO6ptTUuOCY3VDIET3GXUiijfWqHVo7N5wCwtsKUdZOwPuvzPdI6AHMvDzgM4Bj1VB3qYk7XnzqwkUql8dSqInhIPRG/YLWlFwqbHC39cHW+AebOFTS3InNoHBQHZ8wzjhyS3is4GGlslXE1VSNKWxjcZkx7GK0S2tYFm19XwpYV0fZayFLVIY7s36v/jAP9cDNEOlPL2dcZTqOjPTGIo00bzrqUOUkPaIi5y6O/bHM8e4+f2Lij/BEeWk+q6r7OYAubyvSyicYpokf2kB8sCmI/jPPTYSXloGrNrSLfng4LpQHMAOJYFXTJ6aQUt8f8dHeimQS68M1dy+3m8GTIjmtsn2xDnz88qMZnP/dI9d49xOef31dkvJAH5AH1/4yDDPPoF4fZI95bLE3hYjzghdV18g2HaT2QV7pfiVqb8cQAL0qAHbFw2RNewQsXvRq0cD1BxqpKVRDiEc1Mr4BdqcpQKQDl87UnyodwQENnBr7oIu0gVOAU5HGWFry0kUa05Q3aG5m80GBbB2JMHRtLcXKShM2d8Mm8ign6yMOHOTCVHj9Fsr0C9mGaTBMDSudLT5QO4YAGJQbNTVo6CBT4BFmcKQXNXiARHSl76Q63h75M3ScxradaDubufB6E5N8/AXJEwiSP+4xe1IUB9TUK8X4EBNK57wMJc8DeT5IwAaB2vvZE7RAOaOjMoLtNJB1ECnyCNM6RAt9ckUJ0LdErd3ipZfp+mGk9FeNw3dQqnVyanCZhk8d9gutxdJvSlyjE+xEQSEc0M70C9n6QhIkBtfO1J2qHcECDMgNGJpAOIgU+QRrnSQFjl1K4yLOP7fLXarfaZtdSyDz7uto87Z5PD9+63XLXdpvT48/2cfjo86p9et6dHj6tV//Ghh+6decIN3/X6/3iP1iT5xxVHAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "81",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "8100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "14",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "36067",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "209.7",
  },
  {
    ID: "573800",
    Name: "Workshop III 16",
    Category: "Rooms",
    temperature: "19.41625089",
    Cost: "351.593341",
    Level: "Level 1",
    Pbi2DGeometry:
      "iQEAAB+LCAAAAAAABAClkDELwjAQhf/LzTEkabRNnUQFQYcggkPp0GJoAzGRGoVS+t8NVNtV6Hbvvsfdvcs6kKW+tA8FKRxdqaUzbeUsIJBOW/+ENOuGMhgoYzjmsVgv6BJTnnDo0UQFwRFdJXMgpzhmCfsfThfNoeNN+S/2pmmKNmQPjZ0u7sqrBlKCCYKTspWvv+LsfOF1eNcgr/o2ooPSVR3WCEwYixDsjXqP3ogIBFtnXJhqX8b0+QeSTzwZiQEAAA==",
    Pbi3DGeometry:
      "6zAAAB+LCAAAAAAABACdmluL3EYQhf+LnsdCrWv3+skkgUDyYJJAHsw+rPFgD0x2wmYSMGb/e+TtGa1UXV9fBmPjqW6dc6qqVX3Th2/V+4+HP77+va/uql9OHw+/n46HT9Wuen86PJ7/qe4+fPP/nZubt/Of6nn3anljmubtyz/z3+r5/vrYu6enh6/zs66pOzPa3Rsz1Ka3/c7VXWe63WLvTT21tr3aTdvWUz+5WxqIIkU9/27cxmzs6C7mDW+pHeBXZmOmuhvbaVY51sPQuJV9bKx9sZu2nzS7myZTYt/g2HrOmAv727rrFTnUneFVmAw1wlsfnb6pzdQFMJ2bgz1HVdrn7oNzbbZd4lzUC1ayeum5nDoKK/HoW7sbateMMrxuDt7QGhnFtXmVuwzzFsS6plMowTz2fZtPCSCgZMFemy8h2cR1gRDhu5q3uUmZAxCvI+jtnZFCoDNA6xhRHWLoUF00xs0Fy7avDU1tG2O+R3AwU2DG/swwNzTO2JCBSrLO7Np6NF2fK5TQozq3DSvPVAd4siGpUlMqEjAv5vS/zEJbfLKnJksFR9UT4U1Prvm9s8Ws51aYivPt2YsVHFixVczatbyG+IIo9d6nKXC0p9c+IJYnyUttkbNhIhrKfJh+oowhnLcFddBATxCHMhkIpNf5UTQIt5V5NskgFlQpr/UHwhlqy0s6ZdrIMRYaLkQTI6OUgmJHLlOxChcTKXg5u18nu+265jZW6q+i88hl2rhTND7JnpvE5ICTBKm4hYL0rDAv9dfxad5N9cfCKN+Lm0qpvviJvXtit5d+9aDQRdxAUTo3rVqVPWjqiXB3mn5CF0VIOAWXB6RkNo9zFG8IKLTKlk2UYBEoZUeYfIAKyu1AUqruW7AVv2nvArTKHrhoC5RSQ2UGVZIaNQbkFI2rwhCTeHAWc47liEZV0TI+c/8TNxe8wdtROzc42780tK4bgwW5chCX2X8haNvON3TdZNcNdJAIBIiTSxAnzjhQlS+8HXq9YTCmC12IIBVTE0Nvh0mNBZ2fSh+S6YQGQopEiQ62wQd2mpgpqsWKsCygVNynLT7YxoaHweHxeW7/UNI0RktbioBwcvETxHy/AGvIVdqCJeG1YmxcSO4Es6mZYSk9IhiUTelCMpvYQEgYJKi2ugfkMfHy9U+pHqrZqFPf1F8dmBucGcLCptyjZPYXir4/MG9pA8/CWyDAR5hM/Cht6iJM2Xj5hCkNvlBIB5JbuAJqYvAlR4mEnsvQh2Qu8WhIR4pECe4jwQX2mYgpqKWC6JgPheL5n/dgbui7JudKNbe/kDQ3dHY0Ga4RAeLkEsSJ6aI3ci7sk6adJL8UC+lC5JS8kJoZfNVRYkHplD4k04kNhIRR0gsteEAuEy/f2xfqgXKtyozs86feTHLxS3fd2b0X8HFqg3Us37sDOqHkoidYUx8vCJ86Z1V7M/SjIp5gClkBvWmd0UIA6ZPaE+kjO8DokaFvRkg6eAqcEMYSKXjMQwrpyH5Rvlrb8rcnmb0DMauFKsdWx1YxcqHjjPDdDZ2OLvkR9qUCbIXHb22yWQF9qSPbsEDepPRE3sgOMBQYqpi6dHAUOCGKhVKo6oJEusfy0rcLV/jWKL/3VotYheJnTwBOIJngcc7od2OhQz5Hod0XgEB6/JIwmxXQfR0JAwC5k9oTuSM7wOiRga/1SDk4CpQQxQIl+qU766Orfq97uyRVum9mi2TvrRi5wqTI6tg6Ri52lBE+eKQPBXx2Qrt/+QPhBFPICui+hIRhgcRJ7YnEkR1gKDJQLEE6eAqcEMYyKVBwNYX3u+rHw8Nf+/P+qbpr6mZX/bp//Hz+cvnx2+n8cD6cHi8//zx8Wpp+3h8+fzlffvx03P+37vjD6XiaAR//PR6f7/8HbQYavOswAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "80",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "8000",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "16",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "35931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "208.5",
  },
  {
    ID: "573801",
    Name: "Workshop IV 17",
    Category: "Rooms",
    temperature: "19.11794356",
    Cost: "39.64579347",
    Level: "Level 1",
    Pbi2DGeometry:
      "jQEAAB+LCAAAAAAABAClkEELgkAQhf/LnLdld9RSO0UFQR0kgg7iQXHRhW03bAtE/O8tWF6SILrNm+8xM2/SDpJCntqrgBj2ppCJUW1lNBBIjNT2BnHaDaUzcD+kYTTH5czndIEhQk+mKA+oE/4vFD3KMfiTTl71nX4myt7RV02Tty6/a2xkfhFWNBAzyggchK5s/RJHY3Mr3csGeZbliHZCVrVbE1GG6BHYKvEYvR6LCKyNMm6qvivVZ0/1e5SRjQEAAA==",
    Pbi3DGeometry:
      "fx0AAB+LCAAAAAAABACtWVFr2zAQ/i9+do1kybaUPo1tMNgeyjbYQ8lDSkNryOKRZYNS8t+nxbGTSPfppDFKi313uu+7k3wnqfevxd1D//Xlx7pYFB+Hh/7LsOkfi7K4G/rt/mexuH8dH51a3Lqf4lCeJTdSiNvjH/dbHJbTsDe73erFjZXaVMa2dXkjm8q96NJWSklVylpVsm5iCi2rrjY1r5gxoCKGIU1rS1EpYa89IfkRgZEHVAn5pX9lq6bpWke0dQa6u5AbobqjvGnEpb1om4ayR3Laj+Mvrab8s7i262SCH9oe+5/z4NmPftxDp1sT2PvyiY8WlewUJ0ZeJpZ5Xpy4sbYOuIdy2h66p8jAJc5/FOc1aISUiYr4h5dDioaYRkRIoS8VkGU5NZVW2obQdVu1hlLAEbG4lTINgQGrIAJ3IzojdQZdiMFPExEgHUes0gK6Pis+JWxjSCjzHgZUsO2KcgXbFQRPaQ4Z9hmUUtpYspydIqIIjlyJKshUo7AQ8gNoCOSJ6AepEOe+lTrCxyBaJoMRcwVYsQUsoBs0JY+tn1u4OCEEHIExUMUjtgscBoiPJwXnL39ic0aA+LJbFrETCxfPaSvJjIhh5K9Dps8QyyqxM6V8mv4mOiPAqxH8Cg2yG+6kub6f3Mv+wxYiwPiXBUdHjnOFUgK/j5wtbnLrZeQZHcL/nFwM8qiorWoTjoSp9mcAI0aFUt1VeUGHMIQAHSUjsNCp59rZkZKS/o5s21kqCOgpExohOLmuNZkNNKN+DOyMQgXyBLNEn9thDDitCBllNZsRKAKRdIPueRGDESY8qIeXG6n2IaWujRayOAD2k+qfAcbXLXCrOU+br5hrhpcjZtOaAY0Q5uJzlQx89eSHwMxmRIE8wSTBggtCQCEjYJTTbEKwbiOmcAs7huAerGzC2hZeuaXae4z+DnCngzC24BoNAUA/qQAcMLrChOeFcdYCxVQuwhCSjyTMAIQwFR4iF2g6/RjY6YQK5AlmCVwBgxBwVhEwSmouIfpkHck1uEqZInAKrQR/AZ1u71FyCmVamZJrEiDiJxUgDoyv4uFN0DhphGIsF2GOoKdsaIQw1p0gF/j/CX4MzHRGFMgTzBKqtSgEFDMCRknNJYRKNkV0WRbv+tX39X69KxaiEmXxab192j+fXj4P+9W+H7an12/946z6sO6fnvenl/eb9e9Lw7fDZnAOt782m8PyD3ZdMV1/HQAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "17",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "31892",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "165.67",
  },
  {
    ID: "573802",
    Name: "Stock 18",
    Category: "Rooms",
    temperature: "19.7188821",
    Cost: "26.28852516",
    Level: "Level 1",
    Pbi2DGeometry:
      "xwEAAB+LCAAAAAAABAClkD0LwjAQhv/LzTEkafrpJCoIOhQRHEqHFkMbiInUKJTS/26g2sUiqNu99xx33JN1kJby0F4EJLA1pUyNaiujAUFqpLZXSLJuKN0A5THmIeHzGfUx5RGHHk1RTnHIIvYNDbijfvAfpQGOwvgnOPXPZ/ruIn9JWzRN0TpzrrGSxVlY0UBCMEGwE7qy9TPsjS2sdLKHeJSnEW2ErGp3JsaEMQ/BWon7OOuRGMHSKOO26ptSff4AFVgh08cBAAA=",
    Pbi3DGeometry:
      "1wgAAB+LCAAAAAAABACdVt9rgzAQ/l/ynIZE488+jW0w2B7KNthD6UNLpQ04M1w2KMX/fWHV1qpnziKKuc/7vrvc5XB5JIuNej98ZSQlz3qj3nSutoSShVaF+Sbp8nh6tTCf24tU9GKZCc7n/w97k2rVuN2V5fpgfUUomYyCkM5EwISMJU2Y7wufCplYgMs+cPEIWRwlTvuZSAoWebHXd+gCbg9IAkyiYeLM58m1XcRh0tjbIU21Q/yj9kkZ1MoxFwIDOCs6RAUWAhTH7OuE7yeE1GaCKoG239x8INNA05ySQwHjR6WbxUhMwwq1w0hIUOMDoWIjgoS7TYkHbp4OIFPgscQXUV8bBBBBQYcOL84Z92IxAXCfeNceOlsWPMGIrbqWAJkgB3wxps9M/Nb28gar5AwXMSfQU9ZhH1W2fwkPav2ZmawkqU2Hkpes2Jl9vXjVZm2ULurlh9qeoadM7famXjzm2W/7w3uda0tY/OR5tfoDhh7S59cIAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "37",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "18",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "25314",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "96.45",
  },
  {
    ID: "573803",
    Name: "MZR 20",
    Category: "Rooms",
    temperature: "19.61753907",
    Cost: "14.60581566",
    Level: "Level 1",
    Pbi2DGeometry:
      "dQIAAB+LCAAAAAAABACl0s1qwzAMAOB30dkT/l+cnko7GKyHMAY7lBwSahKDG4/MK4SQd5+hW9ZLIWQ3SZ+QQfJxhKJ2b8OHhRxeQu2K4IcmdECgCK6Ln5Afx2uYGh4kwywzcsOoQmm0gIncKOeojVarlCkUWph1KjHj/O7khSrRKLUcmUauzeN6ExKZyNhy/Nv+f3TeQvl74m3fV0O6cyrsXXW20faQU6QEDrZrYvuTvIZYRZe+xjV9d6eZnq1r2vSMQcq5IPDk7WXuFdQQ2AUf0tTuy/up/AY9OM0rdQIAAA==",
    Pbi3DGeometry:
      "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",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "156",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "15600",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "20",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "53244",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "407.19",
  },
  {
    ID: "573804",
    Name: "Archive 21",
    Category: "Rooms",
    temperature: "20.44436446",
    Cost: "478.7662144",
    Level: "Level 1",
    Pbi2DGeometry:
      "vwEAAB+LCAAAAAAABAClkMEKwjAMht8l51K61m7rPIkKgh6GCB7GDhuWrVBbmVUYY+9uYbqLQ0Rv+fOFhHxZB2mpDu1FQgJbW6rU6rayBhCkVhl3hSTrhtIPBBGmnIl5wGY4YHEAPZqAhGMSh/R7SAUORcj/gZTjMGL8Bzj1ykf4LiF/yVo0TdF6Y76xUsVZOtlAQjBBsJOmcvUz7K0rnPKSh3hUpxFtpKpqf0VgQilDsNbyPs4yIhAsrbZ+q7lp3ecPhAA/E78BAAA=",
    Pbi3DGeometry:
      "axEAAB+LCAAAAAAABACtV11LwzAU/S95riFp1q/5JCoI+iAq+CB72LBooa4yqyCy/27VrWuTnOSmyOhoTk/Pvbm9uTd5+GLXq+ru87Vkc3bZrKrbpq4eWcSum2rdvrH5w9ffbfdYHHc/to0OyJEU4vj3r7vYdrF/7WSzWX5278YFT4s0iaSacalyGRVcKakimfE4UYWB9/w44WmmEh/e64iEizyNDb6Ge/lIH/mpFE+KNIsEV6IY0EewEQWdPYK9bLu2VDz+udnBM54VInbB3TxzDzzQBvBQW/I87/zS4N5vDA+0ATzUBrBNG2ZdH8JcSGkzOsYR35fVmjsoGZHZw6xobiJ95CYO/b+YRTp7fvh0KfnkXZH2T6ilNrVuzHiaipkxJ4RDHcmzJDVjg/yBdnW+J/bIbmhdtZSEsT9a7nj5Prs6H/ULZHfPp/qJ9KfHARRYFJ6wejxWCW2y2lrx4r5mTfUH2gX9kdJkyeKGM5ReTYWR+GE5693auZwdZceug/hm/3SWZHK5oPJNfas/EMfzcpdTepzd34VaRsz9VdjKIm9INB1z2+Rs6dBPoBPqJ4wb0kc48hPnvx0n5FvYhhCUpIkwLZiO5kHY45PhaRnulw87taDPOjENXOcZMuw0Stne+k9RdPi/Cizx2OWGJ60yIB92YoQlzm50EbGzavlStuWGzQUXEbsq10/t825w07TLtmrWu+F99dg/uiirp+d2Nzivy48h8bSpm05w/V7X28U3K39z02sRAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "34",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "21",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "25274",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "87.46",
  },
  {
    ID: "573805",
    Name: "WC 23",
    Category: "Rooms",
    temperature: "19.65303642",
    Cost: "390.630242",
    Level: "Level 1",
    Pbi2DGeometry:
      "aQIAAB+LCAAAAAAABACl0kELgjAUB/Dv8s5jzM3ltFNUENRBIuggHoyGDpYLW4GI372BKV2K0tvefn+28d6SBuKTOtRXCRFszUnFRte5KQFBbFRpbxAlTbd0AUYwCZiYe4RjImYUWvSGApOQjzfKsS988bv5mFOPTUGPOeT0L2Q8mIQfHvQF+6aPx6HtaT/WRVVltZut21ip7CKtrCBycQQ7Wea2eBV7YzOr3HfoyqM6D7SRKi/cLSEmlDIEay0fQ5aREMHSaONOLe9at+kTlWCeO2kCAAA=",
    Pbi3DGeometry:
      "JxAAAB+LCAAAAAAABAClV01Pg0AU/C97xs1uFwq0J6MmJnpo1MRD00ObEkuCYCqaNE3/u1sFgWWHfWiaNmUY5r39mvdYHtlikz4d3hI2Y3fFJn0ssnTLPLYo0rx8Z7Pl8eevvi3m+sNOXoNcSCHm3z/6y06r+rHL/X590M8qwUWoIk+KgItoOvFirpRUnvK5CkLlSam4HwUNXvMngcb9iMw39SMu4gCHNeXHhvV5MJEWHIStYFMdJmkXR8kA9VoG4UBGw5N4GniCKxH32RXckKfniaOSu8rd4fQ12tKjAgLpepWNRFpwWxuwgbZ9jEC6pQFgi7S5TfDRCuMwbHDBIyElxpGOidd8uGvt8iEPxXmJqLgh74g6DDer0RFppt2EbWxHSIMNzjgIWbNpCRL9gzp4+7kCUzJwCIfjgaTNkZtuNRYnmiEy8gF+Z15cuMuELTqosKC4BLMks8nJENyVCFOrHL0Um15aD8qJD1ZXI/2BdKzy/QV3Wf5glsRszKhmXzMW/2vf1K97tFqD+K64I/Q7HoVqHJVPzd+Ng5YDpUOl032aWp9RUKA+ti1AfCA/dgFxc2T3aVAekZM66ECdejqRWaBd5uIjfZQPcVu6eodB1LV8o+ad2PIQS+m/5pzs/8RXkpa4fuu+TtevSZns2UxTPHaf5C/lrrp4KMp1mRZ5dfmcbn9v3Sbpy66sLm6y5LNNvCqyQgvmH1l2Wn0BGTEwIicQAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "15",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1500",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "23",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "24640",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "39.09",
  },
  {
    ID: "573806",
    Name: "Washing Room 25",
    Category: "Rooms",
    temperature: "20.14578593",
    Cost: "207.2400698",
    Level: "Level 1",
    Pbi2DGeometry:
      "+QEAAB+LCAAAAAAABAClkUELgkAQhf/LnJdFdzZb7RQVBHWQCDqIB6VFFzY3bAtE/O8tWF6SILvNm+8xw7xJWohzdWyuEiLYmVzFRjeFqYBAbFRlbxAlbV86A3rUm6NY+Mipj8KHjoxANqMiYL9ATjmGOAUKygQGEyAPqTvgLzgWwlf4GV/6jnlZ11njsnaNtcou0soaImcnsJdVYcuXOBibWeXe08uTOg9oK1VRui0h9RhDAhstH4MXvZDAymjjplZ3rbv0CY1rRpD5AQAA",
    Pbi3DGeometry:
      "dxMAAB+LCAAAAAAABACdV11r2zAU/S969oS+bEvp09gKg+2hbIM9lDyk1LQGLy6ZNygl/31q6zi1pKOPEhLsk+Nzj+6VruTrJ3J10/98fOjIhnwdb/of49Dfkopcjf1++kM210+vl/ZvdmE/5FidkQ+csYuXH/slx+3psY+Hw+7RPqsMlZo3FZeKcntV2XvJZSUZZa3UPq6p0NLyRU11I9I40lFUSSM9PvQD9Bc+iuviIC7yefYjaW2atmJUMvOGvoI99y57BSfZ65CctloYC3Pa8Fqc4Vo2z2xBmeLqBAsq2tojh1EoUQvOPTgRUFDV2Iu4RpgMlJeBr9mowmjG+WnVzFpL44mVkWsHyJ/42A6YFGGXmW7cqO6yKMXfu+yQvrvcS/HcNpPZxpSdkVJ4YQEM3RjKhVa+DHCDorr0VHJA2GRPRb0Q8tdzM4mniuLpJHtzmO+225yenS2OkhZt/blwqiJg/qGC+924bIKkdLztJd5EUDMCMihqae9COmi0/sYbtQlGlb0aEr3F2zqj6nCwYD+J6ITCFuxip1y6W3wcxzrumSBqE9GT8nm1RfZhzWFti4qVPIW+E44HBSkWVLaiecGF0U3qWJhHXqSNfk2LqJWKpCsujlRy1aNRwSkVT1QWgu1807XyvCOVwqBQvamNCWUgXDsWCAlLB+CwBsgJeC0IuwaDDIcECSx1gpoachjuLovzZ4Linkf3rS2T7ZjhVAstMrIbVkcquerRqJlvretJ5MHz8l87hyJFEYH03EG8wQcL5/lO1A2dPkIqMCeoUwaNw3GGQ4YzWGYE9dqQwW1FPve7393UHcjGblMV+dbt76b7+eb7OO2mftzPt7/62+WvL11/dz/NN5dD9+8t8dM4jFZw/3cYjtv/kihanHcTAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "15",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1500",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "25",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "16773",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "38.75",
  },
  {
    ID: "573807",
    Name: "Cleaning 26",
    Category: "Rooms",
    temperature: "20.96475121",
    Cost: "315.2400808",
    Level: "Level 1",
    Pbi2DGeometry:
      "hgEAAB+LCAAAAAAABAClkM0KwjAQhN9lzyHkrzWtJ1FB0EMRwUPpoWJoAzGRGoVS+u4GqvEqetvZb9jd2XKA4qQP/VVBDlt30oUzfeMsICictv4GeTlMZTBwicWM8TklCSYyZTCiDxQZ5pKm/0CWYCGF/B7Gg36H8aDqHXnRdXUfcofGStcX5VUHOcEEwU7ZxrcvsXe+9jq8apJHfY5oo3TThi0ZJoxxBGujHtErCaUIls64MNbejRmrJ+ZHupKGAQAA",
    Pbi3DGeometry:
      "OwUAAB+LCAAAAAAABACdlF9LwzAUxb/LfY7h5s9m1j2JDgR9GCr4MPbQsbAFajNqFMbodzdoOyU1JB2lpfeXk3MvJ6WrEyw35uV40FDAg92YZ1uZLRBYWlO7dyhWp59Xv4xzf0FLfskVQ5x/P/wN7brfdtM05dHvlTMqFJsShhOKasqJrwUT5Mz5hEolVc+FovKai/E85h/wmH7AkSpkbOgzll84Z9K/z2Esz80npg85pyj4sG0Ep6YJ9NFp/rcXM8q4kvk8tE+0zeahT3CI2Tx1KImUM9smv51QPy79mPzScPLa+j/RnSnftNMNFEiRwKOud27fFU/Wlc7Yuitfzfa8dK/Nbu+6YlHpz7/CW1tZb1h/VFW7/gKXYEebOwUAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "21",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "26",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "19085",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "53.75",
  },
  {
    ID: "573808",
    Name: "Cleaning 27",
    Category: "Rooms",
    temperature: "21.71601437",
    Cost: "280.932673",
    Level: "Level 1",
    Pbi2DGeometry:
      "hgEAAB+LCAAAAAAABAClkDELwjAQhf/LzSEksbFJnUQFQYcigkPp0GJoAzGRGoVS+t8NVOMqut2773F374oB8lof+6uCDHau1rkzfeMsIMidtv4GWTFMZTAkEqdcyAUlHBMxZzCiD+QCi1TSfyDjOBGJ+B7Gg36H8aDyHXnZdVUfcofGWlcX5VUHGcEEwV7ZxrcvcXC+8jq8apInfY5oq3TThi0SE8ZmCDZGPaJXEEoRrJxxYay9GzOWT1jCMFqGAQAA",
    Pbi3DGeometry:
      "OQUAAB+LCAAAAAAABACdlF9LwzAUxb/LfY7hpn/WpHsSFQR9GCr4MPbQsbAFYiM1CmP0uxu0nZISko7S0vvLybmXk9L1CVZb9XJ8l1DDg9mqZ6PVDgisjGrtB9Tr0++rW8alu6Anf+SKIS5/Hu6GfjNuu+665uj2lpzySjDCsKTIFxkRNM9ZTs48K2nBCz7yQtCq5GI+D/l7PKSfcKQcGZv6zOUXzhn1H3OYy1PzCel9nlFR5Ytp3xCPzePpg/OE/JFilUgn3pGeydz38c4wmcfOJJZxYt/ot+Pr52UfUF+cTkpX9x+6Vc2btLKD2gkIPMp2bw9D8WRsY5Vph/JV7c5L91LtD3Yo7rT8+i+8Mdo4w/ZT637zDaXVMPU5BQAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "17",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "27",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "17995",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "44.94",
  },
  {
    ID: "573809",
    Name: "Technology 28",
    Category: "Rooms",
    temperature: "22.82723029",
    Cost: "151.6357141",
    Level: "Level 1",
    Pbi2DGeometry:
      "uQEAAB+LCAAAAAAABAClkDELwjAQhf/LzSGkaROSOokKgg5FBIfSocXQBmIiNQql9L8bqO3iUnS7d9/jjvfyHrJKn7u7ghQOrtKZM13tLCDInLb+AWnej2MwcIFlxFcR4ThilMGAvhllOBGJWMyYxJTx5B9IGCaC0+VwzvErm/IXU03rti270FVYbHV5U161kBJMEByVrX3zESfnS69DvaO86OuM9krXTXgiMaE0RrAz6jV7YyIRbJxx4ap9GjMUb9Bilx65AQAA",
    Pbi3DGeometry:
      "CQ8AAB+LCAAAAAAABAClV1FvgjAQ/i99Zk0L0oE+mW3Jku3BbEv2YHzQSLQJg8WxJcb438cmIJZe78AYjXx8fHe9692V+YHNVvpt/5mwMXvKV/o1T/WaeWyW66z4YuP54fS3vC0m5YcdvTNyI4WY/P+UX3Zc1I9Nd7vlvnw2jLkfqpEnRchFpHwv5kEgA09FPJYKhhWXoR8SYT/ko2gU1XBj08ABFYgOud7gMuDqNog8wQMR/8FxKWGBG7Yfq9DCvoQxdktb+TySSnbgap0wuSXdIrdRlGyxB2TnLBEJKS0aJmxjIxvCYAOJB0zWbJqDtE1FXrw9rEBI8BwA9gCnjZV3KqEvPqwuLQV1KY8XoNMd1H2HfjuYHb6JY3yq/zgO9ArIHSrdVtSA72bjrhuGERsId8Tm1OlMHWBeQGYNOp5Bq9Wh0wtwxt6sELjfwHSvHw2XoYIlFd95/cJL1aHru3GzWyLhQWYTNTrAvDHh7nB3jieE3u195onCLUNIubMXD7QL8a/Rp2wpR99y8+kl0e9YSISvqx/SqZMOk40iGTfH1yDYvT3QExjh2E2GB9Uxrk44vwO7tG/V93uXIKIui+V75b1efiRFsmNjwYXHnpNsU2yri5e8WBY6z6rLd71ubj0merMtqouHNPlpE+/yNC8Fs+80PS5+AVhRn9IJDwAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "18",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "28",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "18323",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "47.63",
  },
  {
    ID: "573810",
    Name: "Washing Room 30",
    Category: "Rooms",
    temperature: "20.43295019",
    Cost: "5.447697288",
    Level: "Level 1",
    Pbi2DGeometry:
      "uwEAAB+LCAAAAAAABAClkMEKwjAQRP9lzyGkSZsm9SQqCHooIngoPVQMbSA2UqNQSv/dQLWXiojedvYNO8tkHaRHvW8vChLY2KNOrWlLWwOC1OraXSHJumH0Bi6wDPgsoBEWnAbQoyljIQ6Y+J6FEseRkP/Ad+98hJHEhMfxD3DSQP4qat40Revb8oulLs7KqQYSggmCrapLVz3FzrrCaV/wIA/6NKK10mXlQ3w+pQzByqj76GVEIlhYY/3V+mZMnz8AHC/VUrsBAAA=",
    Pbi3DGeometry:
      "VxIAAB+LCAAAAAAABACtWF1r2zAU/S969oRkfadPYy0MuoeyDfZQ8pBS0xq8eKRuoZT893mJl6ySjq4No6TEJzfnnvtpObdv7Oau/f76q2Erdt3ftd/6rr1nFbvp2+3wxFa3b8e348fiYvxj++qMfJBCXBz+jS+2X//92sfdbvM6ftcELqxzlawN97aWVeBKSVVZz4O0lVSaS+VPsA7cGR8SHJhT7BGMzJHXE07ZC65ESERGqOImWFdEz8QAfsdsFK9V+ENSc22dOcNOSZfANQ9BmQMstNQEDEgUD875xSSSW2nqRHcMZ60hd04JaBTQEGkVvJCSgolmi0lAJwOXS3qHsJ0l4x0HaLS58MzZXjp9UUQ0TuyUSD2UA+ijOpMzS6ic2plaTfEqG6fCqbTrEA55BBcuZQFqoNfYnshZ3ivUiNQAr8RAEjDlNN1Sx5DSfVRMDVBDmUfdBAuCVAJ6yJNvj3SBl/F55aa041iRmvgWVkwlKCAaZEyT9YpoMre3clTAHvKnh4SiTmT/H9ZiMS6UTtSwaNxwWL4O6oDXwVvymDPT+kRu9FFMbbQuiCyzI5a57IRXcFpE/aG9ycYq9ViHVDyiWegVsEtpbS4FoHyxdqJ8CAc0+czAgyrSDkIFTkEeF2nBywZpRKt10i658zp9IIkP9jOtIzFynBNf2nxl9jzLfHbCK3i0QaeDqU4JPq2CWDyiWegVsE8LJUkNKF+snSgfwgENygzanUA7CBU4BXlcqAUt4KzGBQ80S384AHdP4HFdsct287MZmh1bjWezin1ptg/D43TxtR82Q9tvp8sf7f3po89N+/A4TBdXXfPyr+GnvutHwu1z1+3XvwEKCFnhVxIAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "15",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1500",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "30",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "16702",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "38.45",
  },
  {
    ID: "574224",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.08751287",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkt8Z6EhUEPRQRPJQeWgxtICZSo1BK391AtSAI3nb2G2Ym7yGrzKm7aUhh7yuTedvV3gGCzBsX7pDm/XhGw4zNMWdMLimRmBDBYEC/KBeYckW/qUywkIn4R6fk4jNh1bZlF3fEx8aUVx10CynBBMFBuzo0b3H0oQwmTh/l2VwmtNOmbmINJZgpxRBsrX5OZk4WCNbe+hjrHtYOxQue9Jz+FgEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "27",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "2700",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "8880",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-570",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3136",
  },
  {
    ID: "574261",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.60734052",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjsELgjAYxf+X77yGc9M5O0UFQR0kgg7iQWnoYG1hKxDxf29gWp26fe/9Hu97eQ9ZpU7dTUIKe1upzOqutgYQZFYZd4c078fTBwiNcUgisSQ0wpwnEQzoQxeM4CQR7C8NMRM8/qFfzRMtpgmrti07v8MbG1VepZMtpAEOEBykqV3zFkfrSqf89FGe1WVGO6nqxr+hDLOYCwRbLZ9zmAbeWVttfa15aD0UL/ktdgkWAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "318",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "31800",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "54286",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "574558",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "21.18196604",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdF2UVXO0UFQR0kgg7iQWnRgW03bAtE/O8NmFanbvPe93jz8h6yCk/dTUMKe1dh5kxXOwsMMofW3yHN+/GkwEKGXKlELhdScBGpGAb2RUPJZSL/04AHKla/9NM80WKasGrbsqMdZGywvGqvW0gpxeCgbe2btzg6X3qk6aM842VGO411Q28ETYjihMHW6OccFgE5a2cc1dqHMUPxAswsBbwWAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "87",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "8700",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "8350",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "574646",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.97133342",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkJiZtPYkKgh6KCB6khxZDG4iJ1CiU0n93obbiydvOvmFmLh1kpTm1dw0p7H1pMm/byjsgkHnjwgPSSzecaOCMKrFYzgSnXMYKevJlkeQ0msvkL2WUxSr+oVPuyPKxftU0RYsb8LExxU0H3UCKLgIH7apQf8TRhyIYnD3Is7lOaKdNVWMJF1RIlRDYWv2azJzhZ+2tx1j3tLbP3/nNa9USAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "427",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "42700",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "40350",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575019",
    Name: "Workshop II 31",
    Category: "Rooms",
    temperature: "20.25257196",
    Cost: "372.9544179",
    Level: "Level 1",
    Pbi2DGeometry:
      "hQEAAB+LCAAAAAAABAClkDELwjAQhf/LzTEkaWqbOokKgg5FBIfSocXQBmIiNQql9L8bqMZVdLt33+Pu3hUD5LU69lcJGexsrXKr+8YaQJBbZdwNsmKYSm9IBRaRiBczGmPKUw4j+sA5xyQh9B/IKU5Yyr6H4aDfYTiofEdedl3V+9y+sVbVRTrZQUYwQbCXpnHtSxysq5zyr5rkSZ0D2krVtH6LwISxCMFGy0fwRkQgWFlt/VRz13osnxgwM6aFAQAA",
    Pbi3DGeometry:
      "SRwAAB+LCAAAAAAABACdWU1rGzEQ/S97XgtppdVHcgptodAeQlvoIfiQEJMsuN7ibgsh+L9XZL2OV5onaU1IsJ/Hb96MtDMj5e61un3ofrz83lRX1Zf+ofveb7vHqq5u+243/Kmu7l7Hl/5jfu1/qkP9jqwE59dvf/xvdVhPX7vZ7+9f/He1YtxwUa9Ey4SyqnZMSiHrE64EM41tJtw65qRrl+OIP+eXM8ndDBZWuyMceY3hvDXgNoop5aSHORNGvqPatapeSceM0jaEvXHrXFMIByQtU1Lq0CNChTVtqUOaA8oYqaMQx3wIzdqWu5DEw6JRhoCdMaIcPieZlATWUzSBEmANuUmSvJIzGO1uq5iRTr3jnFkuRK0dawxvIhzZQ37DtGpczI+eKuBXaya1NsU6ET/UGeJTXEA/rBZIZ6gnlwdQ1Ursj6Vhzo/wXLUjeEg9Cb/5ClZuXSwGFNkL4NI+g3ZUov+cB1WCJ/tY5kHP0aMNjjtTUmV6BYmmkExC3BZy5iQ9oCH6SHpJQBFEPES9LyumKKxCfmgft9MJDwaJuXmQzaWLC+0RP6ilSH5WT5genIaw9afSkw2rnJ4Oa2ErJuaFKA3HySBpn93lpbs510LDp6u05WZ4LsgbmR/EQwxg820S5DM7GuRa9IWj0NJ9BfcJiDfhl8wD2v8LGmPhKJGGLy21jR1hJ9po6I7OJ2XGE7UUXI/mvg7ippXkRhyF3CmXmRNlXOecEmT3aZ1xkfRcuSz2Cthb0ygqAeAIGWrPLB1qtCQNzgx9kKelw0iBT5DGZVLAgIAUko39pNzjSvL8HUSh9VyMx6XVie6dJkckheQpn+BGBA2t0xLFw+xbBQiU49F3kVNEPpaROHywcqHyzMohHNCgvND1kpZOBwpcwrusZUpAzUUC0dj2JtzDjfN0yeufYuO5FI9LaWwUT3SdRZMjklLypNP8bV4wvIxLFOPj8x+IxzQLvQL2sYrEKSAXL9aeWT00v5E0ODPgFpXWDkMFTkEeF2pBEybSiE5eJ+2W26hORde0hdaRGKNT03GaHJAUcid9wstrdGw+LVJw2zCVgXPlubuJQqeI/FRL5vGDhQuFZxYO4YAGpQUUTVI6HSdwCf+PsFAJKryEwnVdfezuf22Gzb664ozX1dfN7ml4Pr751g/3Q9fvjm9/do+njz5vuqfn4fjm03bz79zwQ7/tPeHu73Z7WP8HpJiAi0kcAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "31",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "31931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "166.31",
  },
  {
    ID: "575020",
    Name: "Basic Wall: STB 30.0",
    Category: "Walls",
    temperature: "22.02715296",
    Cost: "0",
    Pbi2DGeometry: "FgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0NmlNPYkKgh6KCB5KDy2GNhATqVEIpf/uQrUHEbzt7Btmpughr/Up3BRksHe1zp0JjbNAIHfa+jtkRT+eaGCJoFzIxXLG55RxJmAgvyjjVAqZflFOeSqSf3RKLj8TVl1XBdyBj42ursqrDrKIRgQOyja+fYuj85XXOH2UZ32Z0E7ppsWaGEuSVBLYGvWczHGEn7UzDmPtw5ihfAFUFOdHFgEAAA==",
    Pbi3DGeometry:
      "EgkAAB+LCAAAAAAABAClVk1rwzAM/S/eNTVWaidNehpbw2A7lG2wQ+khpaE1dPHIwqCU/vd5W/pBHEVuR0iILT89SZZkz3ZsutCv24+CpezRLPSL2eglC9jU6LL+ZOls9/drxWJsH7YPTjMDEGL8+7Ev288PsNuqyrcWC5HiUiWjYCBDDhJUACGXURwGrkTwoUjO54GDsiud+Wb9UPI4jrokLgf8rAXowBwkbRYcQbNgFnf43vJRchmr6KQJgMtR2CVxEMpyjCSqKRzyRAnokoQ8idQ5xo1wG4NLOngay1xMe+cd74/xouPSYzPKj9tMR8C1DfOG1uXuwOUsPRnTygzf+sL8wCqF0k9lKuqZp/2+leBtP9pneqqAzDUfzH946O7o09Ho3PXPdv8T4BrLqOzFdhmvNI/okxi6Ov1Z8O7g09Ov8YY8a0hvLj+FyOy3d4t7nb8XdVGxVHARsKeiXNXrZvBs6rzWpmyGb3p5FD0UerWum8FkU3ydL7wzG2MVsptJlsVZbO8w34fq43oSCQAA",
    Absorptance: "0.1",
    Area: "88",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "8800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 30.0",
    "Family and Type": "STB 30.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8285",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "6800",
    Type: "STB 30.0",
    "Type Comments": "Stahlbeton",
    "Type Id": "STB 30.0",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
    Volume: "26.29",
    Width: "300",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "575086",
    Name: "Basic Wall: Lamelle 11.5",
    Category: "Walls",
    temperature: "22.51300099",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnLfFVdfUTlFBUAeJoIN4UFp0YNsJ2wIR/3tLlocIur033+PNy3vIKjx2VwUp7KjCjHRXkwEGGaGxN0jzfpQuMBOSiySJFzLkgZA+DOwHfAkZRV805LHvyz90Ki4+A5ZtW3ZuhTussbwoq1pIPe4x2CtT2+ZtDmRLi274aE94ntBWYd24L0JwMQ8ZbLR6TNnASxisSJNrNXeth+IJf9vxOxMBAAA=",
    Pbi3DGeometry:
      "dBoAAB+LCAAAAAAABAC1WE1v2zAM/S/a1RUsfylOT1vXYcB2KLYBOxQ5pGjQGsjiITMGFEX++4zWTldST6S6DkWKmJL4qBdafOLlvbm46r7d/dyYpfnUX3Vf+213bTJz0Xe74ZdZXt4/fh2H89PxzxyyJ8uJy/PTh3/jxxxW87K3+/36blx74mrr2naRFd4ufNtmuS3zNmNmb31R+id7XdnS1QWbXtjGt56ZK9v6pmReZjuZ7kpbVRVzPpuZl2KcV1RqUBAj8DLNds5Wi6LlDLABRJlEJUTQRgSBMREPO2aOENGtresmMB9H9FrILrd1lTcpEYUBUEQwt4QdKFN0jp9Mn8KnTsBmMQnOt4568bYuF55Nnsy6yWHP43FiG1fwQCrblDWezuylrV3jmJvjAFswfqkb5kjgheUAShrkJ05OwH3YDtxMpCnNkPsjOQw3wjNe8h9QErNIl1yQJhQn+nWEE4a9uM9ejMouiqIOcHAcIBzQBcxOuaEDZAEhh8I+7VaOFCJLewuAhHcdDpb+klJAYD59yxRRpgEo9stGQFAs555PJwTRGhL3zcQAsRMvVGvMmESJzU6IbiNmhgnsmDBWRyUEsFuuraQByRPgLSEZ0B7QnoXfQOsmQjZIQ5BwQtYKyRyVIeFjFYqnkDgh57Xq3fm3KGISDtymiBnkVtqrqvStu6gJ7zsQwfHTQXmW6K5jukiEi6RSX+IqnVrVlf4F4YyKfZo0UPlGzIgMJNRIhbQM84Z0PJN4IjYShS/ZB796iqSkFBHpgqu/o0Nw2JeQVuA+AIo2vT4LdVh3+uHqDw6juFlsGij1kVThJVht40mSiFqRpcQVimC82qEgQYUVzGJL5ZUkkQSL2kSCBFSHqfUfL4igYgtmoeMUvePENaSyMaNrccURweUvrVmj7PioIONVPalHgmSKKEekfl1CzwApJDWE3KmSWigJ0aoxBOWGNJpofwRYZeZ9t/6xGTZ7s8xtnpnPm93NcDs9fOmH9dD1u+nxe3d9HPq46W5uh+nhfLv5/ffEs37bjw7Nmw/+/N1Zaw6rP+i9XjR0GgAA",
    Absorptance: "0.1",
    Area: "64",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "6400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Kalksandstein 11.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Lamelle 11.5",
    "Family and Type": "Lamelle 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "21175",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Lamellen",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Lamelle 11.5",
    "Type Comments": "Kalksandstein",
    "Type Id": "Lamelle 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "7.37",
    Width: "115",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "575394",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.79049459",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkNnRrPYkKgh6KCB5KDy2GdiEmUqNQSv/dQLUHEbztzBtmJ+8hq+jU3TSksHcVZc50tbPAIHNk/R3SvB/PEJCY8Hmk1HImFUeUEgb2i8YcRaK+oOASJf6BU2/xGbBq27ILK4KxofKqvW4hFVwwOGhb++Ytjs6XnsLwUZ7pMqGdproJbyLFVYwLBlujn1M4EsFZO+NCrX0YMxQvShuj4hQBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "26",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "2600",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2458",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575419",
    Name: "Basic Wall: Lamelle 11.5",
    Category: "Walls",
    temperature: "20.39407304",
    Cost: "0",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzFka9q09SQqCHooIngoPVQMbSAmUqNQSt/dQH/Ek7ed/YaZyTvIrurcPiSkcLBXlVndVtYAgcwq456Q5t1wesOSUcHD1QJDijzm0JMvw4jTJBLiL+VUCMQfOudOrJjq101Ttn6Df2xVeZdONpAyyggcpalcPYqTdaVTfvYgL+o2o71UVe1LkFGexILATsv3aMaA8kgEBDZWWx9sXlr3xQd7P9SnFAEAAA==",
    Pbi3DGeometry:
      "DjkAAB+LCAAAAAAABACtmk+PHDUQxb9Lc51Y7W73v80JkiAkOESAxCHaw0YZJSNtdtAyQoqi/e40MN2z6/LPVe6sUBCT4tUr21XV9rPffa3evj/8/uXPfXVV/Xx8f/jteHv4UO2qt8fD3emv6urd1///czbXL+d/qofd5W9e+Lp++d+/5j/Vw/UC+/7+/ubLjG29q4fW7174zvkwhp1vXOiHZte2rg6+txgmN45+2nWD6+r5t0B0owtTMyQRvvUJ8hzCyrGE27kpdF66kobFFUU1zIap7QyGpnFT3027oXej7xuJGIMb2inIqJBDIhbD4PrQTNIwedc3U4pcIM7kvp7Xtk/5+tcSQp1wJjHL4Kfguja1JEwjIefIeu/aKTWROMMSsaSQORuXgZSnKZPH+atzUFSc2FSgjIibwMqBrhCB/QQRFBWvh7k74OwuBlwokVePXKU5sKSx3LBtyMo9I7A+MlVIvjAs7hvmprX2P+xmdnKVgzqAHbEYSnqZ2jJxJMyCEefb71OLPhgcv70aDN8FPzvzAcYPIbe16wef8iYtizffu65P5Zj3wTV+SC2atKyY3vkxOdJNPOht7qzdEFIYaVkxnRsH3yYsXe3qZkz00PmHG5MfTh8mF4Y6saHIeSvArDydC21I7Tba3jVhTGwxE5jVMrq2Hbv0SCPLIwzMAc8ox8Yr181p3HqbZfHWh3lGuySPPePX+snkqN1y8cZ5jbVdUAuPoyZLzhtELdaUZyfTd9YcRW+ZCo5zx4JhHs4DXgWcUe69XKfZmntaWQZvmdnBmuOOxDUnetXKk+2W1pEaOlJBV+Y5sK0PrQJaCnr8BYNzLbrYJYLn8Mbd0jBvBXWa2bts2NVcsncd6byBHuZjSMYi50Bg1pWLLZdM1DHraq9ZpVvkF1BY1l4Ve5MWuXsqiFqMFOftcS0ApoRHZmLMw2vKPAV5sPJwhvBIebWZR66P/P48hzfOHc4QmYn6SDPZi944tky+FUTwLfPGmC1R45peTsB6Ggg1z5w5F10gpl9P0xGJRAjhN3J1kY9UhBA+IsPlwKwahDinGoRwZp1eOVdCtYuWHaddjlxzheQFK6iNAxEYFa6HTAZ1ruzJoE4ipShnCUXFBrMrtXCQgyfRXoNacXJF2RdKa2Xoihum9LWh+alXbrqobm0a3GaI3HD7EbnCSzpssMiRu6TTLgJjDrohzI1DiypedPuVm0BYv2sGRCyE67eQkSvU7fGDV3APp3FgVHwFiuPQo7IfrzISp0EWFZt0xFikhqJDYbG3ErGDj34sZJZI6uK4mBMySbrnAwQfS7fFpkbAUrdYBRTBLeK0GCljWARHbxlxYEtshgjswrlFbBf1gxKNBcMikcgQFJYsF2mxt4JHGbwtMdGUOit44YFNR998ZVS/DIaV9g3eMtorKZ+GPXyE4DcguCPPvGVJP1/IKLWsumZ0hNxtD9zCsDe+tchi0tffm3i2jIczDSPAq3l8GsBnFpwAhDwnyYYx5rI5nbSGZ0jaObngKKWdyrhgDF+TAqG3qDDjoPVnneqJ0S5lRXck5W9KmQNFCt2gRqUi7OTaiREPuPwsrvwcaxdb1DeSOjkiIg4UdAwGNSoNUUBul3rVky/Kl9oJHp/LGQyqdqrJsMwhzuN2g1XRZYSdfLN8wAoi6TwozhTI4shhJ0eEVQk1GNSoVISdXDtv4KmC321argH106j0pvN800Uk8/ATJoNFj82AKYhA14YselIcQVbR4seB5geF+vMDSwSMETz85Mdg0WMreQSiR6DrVhatK46AVVeLUsvedJ6SCBgjePh5iMGix2bAFESg62OsgnEEGQWVH2YXPOZmnpIIGCN4+CGmwaLHZsAURKBrkRb98mkE17vq9eHm8/60v6+u5pzcVb/s7z6ePp1//Ho83ZwOx7vzzz8OH1bTT/vDx0+n8483t/u/H/+Pr463x9lh9d2Pw5sfXk3Vw/U/BPZOTg45AAA=",
    Absorptance: "0.1",
    Area: "114",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "11400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Kalksandstein 11.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Lamelle 11.5",
    "Family and Type": "Lamelle 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "40911",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Lamellen",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Lamelle 11.5",
    "Type Comments": "Kalksandstein",
    "Type Id": "Lamelle 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "13.12",
    Width: "115",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "575429",
    Name: "Laboratory I 32",
    Category: "Rooms",
    temperature: "19.17687241",
    Cost: "81.10687087",
    Level: "Level 2",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzHkr6bWk6gg6KGI4KH0UDG0gZhIjUIpfXcDrV4sInjb2W/Y3dmshfSkD81VQQJbd9KpM03pLCBInbb+BknW9mUwcIqJ5HQ+oRGmIhbQoREoKJYsZr/DSGLK6V9w7KCv8DNK/oq8qOuiCblDY6WLi/KqhoRggmCnbOmrQeydL7wOr+rlUZ/faKN0WYUtM0wY4wjWRj0GL2VYTCVDsHTGhbn2bkyXPwGEhWyvhwEAAA==",
    Pbi3DGeometry:
      "NiAAAB+LCAAAAAAABACdWU1r3DAQ/S8+O0IftiUlp9IWCu0htIUeSg4JWRLDdl3SbSGE/Pdq413HtuZppBASsn478+bNSKMP/3yqLm/674+/N9V59Xm46b8N2/62qqvLod/t/1TnP5/GfwMsL8JP9Vy/PjlTUl68/Am/1fPVyezdw8P1Y7BtrVBGqfrMWOGlqrUSjfNtbZSQ1sTPp+83SljtdGywBngLRKFaoRrXxAZJwDWOBxYcEJhzRDKUFk1ndSycApTrPA/MOSCw4GiN8DZ88Ux1om2lnwPWSPcCeGvVK6CF97ojLCAAXRmhjbMlHDMLpRtLciyBnKjWrpiUNFK0wWkcFQSMF7bpXAEQuTrpCICyJo42fg4ZRhUlMSEKOh950yk9AYNL2ep4jq+f5zaFPOoDEFT41puMmKAFChZ6ms3XpafU1GebRX5QpAq2UVGtm5VBc8DyZdc76myw5WUD+UsTbPb8unEUWOAKWZySi5ZkqC8yWDOkMsUuQHRMiIIKlvYEATYfa270HDqCpUgFm97URBlMjgPYp94G8OOZWBtGgfGylJ751ALHWAAKHBOxrTgB0UYkHRQsLK8PcqzDzXJ12qEsMzLboaQrDqPCFoiDdwVzlZxPKNyF8pTAaFfDtIt4V7P0FI0FZFDeqeBwS3CDkZvgAAkh9r1sNaINMTufgEVWayUBKBBOtBKBICWJFgPJS8chWkvLj3+4k+Qkca3c6ZCiA6C96bKOTfkWE0drxlFijHXJ4cNyQFf5HCw5PHuCAWfC6tnQylWjNKkDuionhxxKtZZMCSxtpIMtLQSgK5CrxAEe6oDKITnMbmlUiXUThgt3DJMOJx1xrUBcqMCbFtivJoER+Slc2+XsCxJ1ghQRwMrIz0haRiIhU4tZU0ydhEsIGyyKCVIzqw2RKNxBSRUJbugJNlBEAUctHAfMXrpkSMFBCPdJY0YC4A/liqpB3JPlWyxTdbAIG77UXpOlgJ6yKTjq/LvMZTEIYJwZhArmSFdCDjnG2UckBNY10sHWFQLQFchVfPplZUDhkBsmtzAofFSHwcKT0KgiAI2ReXft+RbLqAJgXKeyco4ogKcCCo4avnuAR8axeAQw9hBCBXP6LCGHHGM7IjIF6xrpYOsKAegK5gr2YSQDCofcMLnFQaGODoLNuQCFbz7KgLfcvcLb7qxXtAVAtm70VgLdtL/1eZr3qq4+9Ne/NvvNQ3UuhayrL5vd3f7++OHrsL/e98Pu+PFHfztBnzb93f3++OHjdvNv/sX3w3YIDnd/t9vnq/+RKNezNiAAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "32",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "32067",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "151.02",
  },
  {
    ID: "575430",
    Name: "Laboratory II 33",
    Category: "Rooms",
    temperature: "22.50860259",
    Cost: "333.8553376",
    Level: "Level 2",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkDELwjAQhf/LzTEkMW1inUQFQYcigkPpUDG0gZhIjUIp/e8GWl0sIrjdu+9xd++yFtKTPjRXBQls3UmnzjSls4Agddr6GyRZ25fBEAkcEcnnExphyiWHDo1ATrFgkv0ORYwljdk/cOygr/AzSv6KvKjrogm5Q2Oli4vyqoaEYIJgp2zpq0HsnS+8Dq/q5VGf32ijdFmFLTNMGJsiWBv1GLyUYR4LhmDpjAtz7d2YLn8CJOUQ+YcBAAA=",
    Pbi3DGeometry:
      "KSAAAB+LCAAAAAAABACdWVFr3DAM/i95TkOc2HHcPo1tMNgeyjbYQ+lDS482cLuM221QSv/7THO5JbE+STlKS8866dMn25It37xk1/fd9+dfm+wy+9zfd9/6bfeQ5dl13+0Ov7PLm5fh3ygur+JP9pr/H7kwZXn19if+Zq+3o9q7/f7uOer6pmhNU+UXtS9CafLKFLYNLne+cGVr8bg1ha/aShacEKBgAXEaN64wNppMIFhBUwVZMMOAgilGQsNUhW18lRKnBKZtgiyYYkDBDMO7wtZ1EwVlYXw9HTetd2/jLoSJgi2a4CwjqEPhbdOqNKwNNYVN+wQRRmchNKHBQyS+jhCmKYL3JtVIBCNEFDhXBoWAMXUCN5X1pMZcoNGAPNQaw/Qteeh2E7//YvhLV6VZZDkOswhKO2JOiCyCi7Rkn6AGchZammzXuSVu54u5Qu8UyULMU1TmFmnQGHD61POdJDaY8dQCfWWCuV4uG0eCK0whjTG4YlkU6+gSgYuUWH9onxAE5SxtCQrEeCyx0Tg0BKeCc5Y/0yQRZNcBzFPnCeT1TNTRgWBawvmdTxVYUYOE4HxKCtYgII4JvFNwYmV+CThyV2VqrMjziEwKLz/j0CtOg8aQTcFYsfsJuTtjjk3BqYVbMz0Bzi0lawEprM9UcLkx2MnpU6QHAkKcDIXZIM6rgldQQ5VaSQEkCDfaGoIgJGIm0aeYNavkzNsfziTnrJKqHcaDccS9grhQqRVGhNqUzaARFzu3zyQEaEiNwCOLN1uioARr6Erjgg8EC7GarQGHGM5XlgwIvD8nPMRphTUWmGJiRbcHIA2GOMSGwV3tFDqlQGdBERhZRIGtS13nRa8x9yoK6rYxqpgjCGhJDcFDw04UrJbj5BFl9C2FJCTEuqvHxhBDMiLCAWc1YSHOKhRAUzBSKAkDGog3hGYajKt9Qukc+grq/ZFEHK9CtJj4SrTZ1Apzn6Kgrn2bkiO6hQgCWtJDCNianuDyxDRMHiEYEkjCgzG1HhxiDLmICAlskyY8xJmFh0hgiokV3VjFPBjmEBxGd71X8KoI3YWX5BOPtmyJnMe1xkVBMh8J+Oiub3RXYRgRCJEIxOcFfUR4GsydZcwwc4RJIpHiIfqKXELIwvVqzWMLTQJD619tkny7CBN8NwGLQOwd6dcTXIGapid87VgnOKffCjvcqlfZFQI1b/QSgbrr547zuLd59qG7+7k5bPbZZVmUefZls3s8PB0/fO0Pd4eu3x0//ugeTqJPm+7x6XD88HG7+Tv94vt+20eDuz/b7evtP11uWzMpIAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "48",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "33",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "27931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "111.89",
  },
  {
    ID: "575431",
    Name: "Cleaning 34",
    Category: "Rooms",
    temperature: "20.72400598",
    Cost: "496.8539294",
    Level: "Level 2",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkDELwjAQhf/LzTE0aWqaOokKgg5FBIfSocXQBmIiNQql9L8baHWxiOB2777H3b3LOkhLdWyvEhLY2VKlVreVNYAgtcq4GyRZN5TewDkmIowWMxJhwmIGPZqAjGBOY/o7jAUWofgLTh30FX5GyV+Rl01TtD63b6xVcZFONpAEOECwl6Zy9SgO1hVO+VcN8qTOb7SVqqr9FoEDSkMEGy0fo5dQzOacIlhZbf1cc9e6z58oAYUDhwEAAA==",
    Pbi3DGeometry:
      "NwsAAB+LCAAAAAAABACdVt9rgzAQ/l/ybEMStRr7NLbBYHso22APpQ8tlTbgzOjcoJT+7wubOo25/ChSae4z993dd15cndFyK15PHyUq0KPcihdZiR2K0FKKuvlExer891fBZKEudIn+LTNKyOL3pn7osu623RyPm5Pam3PMY55GszjDnNCIUZzkap1lmPLYYk8ozljO3EDPAAIaRW+nKaZJnkwprMCccTcw4gABI0eXBmU4mWdsBNB8zntgmHg4AHKYAWvm9loRnJKUTRXX7aDiUIs49VNZ8JTHHjGBO6BgQU+Dmo896WIECe4flDELp96mLnSmYeYA5fPWW48WbFt/wH+K6E3l9yYPWyHAFbSjK65zhDlnns5gq5RziJhjgihMwZo9gYCzHjo3ZAcdgVLYgrWfP5MKWvsAnFPXAUHnjPlFttYqDPCeIkE9Yj8WgwBPcltbgedJGHBNR4MzxOsbJQDwzhua9dD8utZu51VfoXdi81425REVBJMIPZX1vjm0i2fZbBoh63b5JnY99FCK/aFpF/dV+T188FZWUjmsv6rqsv4BeqQCVzcLAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "31",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "34",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "23931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "73.85",
  },
  {
    ID: "575432",
    Name: "Student Council 35",
    Category: "Rooms",
    temperature: "22.17473617",
    Cost: "267.6104416",
    Level: "Level 2",
    Pbi2DGeometry:
      "iwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzEkaeyfJ1FB0EMRwUPpIcXQBmIiNQql9N0NtHqxiOBtZ79hd2fzDrJSHdurhBR2tlSZ1W1lDSDIrDLuBmneDaU3JAQHNIwXMzrHlMccejQBOcURi9nvkJIAk5Al/9Gpm77TzzjFK/ayaUTrs/vGWomLdLKBlGCCYC9N5epRHKwTTvl3DfKkzm+0laqq/ZYEE8YCBBstH6OXMszDiCFYWW39XHPXui+eU5JfZ4sBAAA=",
    Pbi3DGeometry:
      "XyAAAB+LCAAAAAAABAClWdtq20AQ/Rc9K2JvumzyVNpCoX0IbaEPIQ8JMYnAtYrrFkLwv3cd2Y6lnbMz6xISYh3PnDkzu7MX3bwU1/f99+dfi+Ky+Dzc99+GZf9QlMX10K82v4vLm5fx3wCrq/BTbMu3JxdaqavXP+G32N4ezN6t13fPwVYrW6nG+PLCtpVXujS6cp2vS68qq5suev5m4HTVms7EFnNAYAJJdF1p17nYIgnsTFlgSoKRU5ZYijaVa1oTq6cA3TWeByYkGJmyNFXjnAkRN5VvW30K6NpoEui8sq9AXSsvAqCrI7k2riUt5gBvAXUILeowppqEPqcq3do4pvC89t7EDBCwvmpdKCVvsY8ppkYhQYIxVshMAGmKKFTRhEpPweBS1Sae5vPn0r4go94BQYWvvRXEBC1QsNDTyWydekrNfLZXyIMiVbB9imrfrAyaA5ZPXO95tLjh5SAZKxRu+ILlYy8zyxu0OWQZrtBYZ2wSsSSTxq9GIDJIQ8YMnGGET00UAASwL1yaZMzMlidOZ3pwwCZ2HiDYWRErx+grWrOYtkCsKIwFYICOiJVaGNPJJmEKRKolrg4bkYmKk/0GUyQYFLRAFKwn2LuJoKKdGaM7Xx+xWWWqQex3hBaQfG6B5zmxd2LGITA4p/2lBiJkp6UnFcL80sMh0a2I8wNbEtpC2q5pBIoUz7ekSC4vohKfeUSEg0Kmfj6xW6fbV8B424gOaXKLI8fuCzvA2rZLlp7lgK7kHCw5f9icC7S+owFVu4bUAV3lk0MOZbwmUwJLG+lgSwsB6ArkCp/YoQwoHHLD5GYGhddiGCxcDo8qOtUR9wupCxcWiIoRkR/CbRvBVgPXCBJEACtCno+0iEQ6jt1lTnFsIkw62FhRSJCZ2bDk3ODRIhLc8rvAqNnOKOCQhcOA2ZrnjCg4BuH2ZsxIALyuiXZH3KPJLaap2lmEjVpql8hSQE9iCo6audEk1I05J4BxZhAqoKt8csgxzj4iIbCukQ62rhCArkCu4LUwVAF1Q2qY27yY4FkdhgoP8aOGADirZNftcotpVAGwXaMlCUcMwJGcgSGG7x7gIW+sGwGM3YPQwJwXc8ghx9iIiDzBokY62KJCALqCuYIdGMmAwiE3TG52UKiXg2Bz38f8730qfL+Cb7oZ5OyXu2fQs28t4P37+UCa+rYsPvR3Pxebxbq4VJUqiy+L1ePmaf/h67C52/TDav/xR/9whD4t+senzf7Dx+Xi7+kX3w/LIThc/Vkut7f/AC84O2lfIAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "31",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "35",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "23931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "73.87",
  },
  {
    ID: "575433",
    Name: "Meeting Room 36",
    Category: "Rooms",
    temperature: "21.53738418",
    Cost: "193.9679896",
    Level: "Level 2",
    Pbi2DGeometry:
      "jwEAAB+LCAAAAAAABAClkEELwjAMhf9LzrW0Xd3mPIkKgh6GCB7GDhPLFqitzCqMsf9uYdOLQxBvefkeSV6yFtITHpqrggS29oSp1U1pDRBILRp3gyRr+9IbOA8pj0Mxn0hOIxEL6MgY5VPKZSx/oSygUrI/6ehV3+lnovwVfVHXRePz+8YKi4tyqoaEUUZgp0zpqkHsrSsc+pf18ojnN9ooLCu/ZkaZEAGBtVaPwcsFlWEkCCyttn6uuWvd5U9wLm7qjwEAAA==",
    Pbi3DGeometry:
      "MwkAAB+LCAAAAAAABAClll1LwzAUhv9LrruQpOnnrkQFQS+GCl6MXXQsbIHaSI3CGP3vBq1rt3hM0lFamj49531zwkm7PKDFWj7v3wQq0b1ayydVyw2K0ELJRr+jcnn4uTWYzM2Bumh4MqOEzL8v5kTd6jfsqm2rvYmlNMU0T1k04xRnLGcRo5jnRRINJM5wQegASIw5J5MALGIRK4YyzNOMnRITXAxknG0KgXVOCViagGoSnJBknIsmmPKc/0GcIcZYkRSxl/6oAGcxoAw8f68629YAAk/nMmuu2hwX2jJgkZBlcxNYxybnJYCteSSDS+DsaUsFBNYKeMj/axnI5mPA1dF+ph3TgXU8dkKP3eYSEugAmCncoVNIQK3D9hXXdyKMeDvw39oDmtfdcKC+f+86v/n+wCFu/kBuZPUqtGhRSTCJ0INotnrXDx6VrrRUTT98kZsjuhNyu9P94LYWn+MXr1WtTMLmo6671RdnSEFZMwkAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "31",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "36",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "23931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "73.85",
  },
  {
    ID: "575434",
    Name: "EDP 37",
    Category: "Rooms",
    temperature: "20.78187463",
    Cost: "403.1630821",
    Level: "Level 2",
    Pbi2DGeometry:
      "jwEAAB+LCAAAAAAABAClkE8LgkAQxb/LnLfF/admp6ggqINE0EE8KC26sO2GbYGI370FrUsSRLd583vMzJusg7RUx/YqIYGdLVVqdVtZAwhSq4y7QZJ1Q+kNhIRYhEwsZkRgwmMOPZqinOCIxvQXygSOI8L+o5NXfaefifJX9GXTFK3P7xtrVVykkw0kAQ4Q7KWpXD2Kg3WFU/5lgzyp8xttpapqv2aOA0oZgo2Wj9FLKOZhRBGsrLZ+rrlr3edPrKJo4Y8BAAA=",
    Pbi3DGeometry:
      "ZCEAAB+LCAAAAAAABACdWcFq3DAQ/RefHWNZli1tTqUtFNpDaAs9hD0kZEkM23VJt4UQ8u9V1mvX8cyTRiYkZPMy897MyKORfP2cXd12359+7bJN9rm/7b71++4uy7Orvjscf2eb6+fhVw+Xl/4re8n//+VCleXl6Yf/zl62o9m7x8ebJ2+rtClsq3R+odvClSqvVFFbZ3KlmsI02lBgsqhV0Va2YkwIIrCBNMoUqrY1YxJEmrIUIXMejLzlIeGoqqibtmJSwCLKNk6CzHkwsuCxhS+186qbwrWtmiGtD9BaDrGFrtsTYEzpJEDI18SvKm/M2iwQkQ2OJsFGN1Uo0LosVKsZZR4wzlUMC0a0K9q6sUKbQRkjgBeGSUbJmJ6zCbNQwaJHLfZ4eq+lmXsbuwAB5I1Dxn9CfDTOOC1Shm2gZuxs9jwvnAW7Q7yjJEgD0cRbGtvv4+EAHlzQhDVAROP+mICkbGx4jxDsOGOkKd6gzZRquLXjQIkJYQlmLb57AWWQhtUMnGEknhoiAALYFy5NUHNkUqLpDC4O3NdWI5KRjNlZzt7oxhZtEcymI7ABNNgZs7WLpc1GiwVCMyDyNo4wi3Bmg4q4brjnUhvMgyONF4F6Ywa8aA5CqpE2ZvaJ1idug3kSFOBuQKev6AoFFmu6ZKCeIX4QfzBKlGe4OgKdjZ5MBKXhTWS9HSA4TvzkJPAIciOq9fpDKF4fshwsnmqPOB/gK1I53YgOgUk2E09V6QHRurXBZSCgwc7kNDF+0YmWtE9raoAYdVpSJJqQtzUKME9tTcvnBp/3STyCUuPNBXkL5Q3dEeB4QjnACnCu12jDGzlWjYeZKR5bvjkMiu594gitD0Em1W0jnVhwcjANQQTXaAnJiYUTHCTGbrSgmfWcaG4EmrEyyB8bfrh0wqYLggnxi28raZdeZgxfFaKVET8DpKwzvDaD89IpNR5xynBNkr0VlNss0vZq4wfA0PwpYMG+xCwR9vjFKzfjD/nnkOGZobGEvK1RgHmGZ5PLDL7jJfEI6oxPQMhbKG/gKhuHE0oBFoBTvUIavD7AmtHFwhiNR2pdSt8ZJNgstHlE20bJ4sQ02JmcJsaPX6fgs+ZYTvYUeuo2NJr4yTVFQYhn6F1cbnCpSTyCUmMEe8N5Q90bRYMzgPlDr87SlaGdACgWXeTiVz3JyKqLZHyTL317nYIkZAC+goGvEtYDEfJtnn3obn7ujrvHbFMWZZ592R3ujw/nD1/7482x6w/njz+6uwn6tOvuH47nDx/3u7/zf3zf73vv8PBnv3/Z/gM/Ucm+ZCEAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "48",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "37",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "27931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "112.13",
  },
  {
    ID: "575435",
    Name: "EDP Management 38",
    Category: "Rooms",
    temperature: "21.26451244",
    Cost: "192.4396536",
    Level: "Level 2",
    Pbi2DGeometry:
      "jwEAAB+LCAAAAAAABAClkDELwjAQhf/LzTE0aUzTOokKgg5FBIfSocXQBmIiNQql9L8baHWxCOJ2777H3b3LOkhLdWyvEhLY2VKlVreVNYAgtcq4GyRZN5TeQJjAIuZ0MWMER1RQ6NEUJXPsBfuFhhxTJvh/dPKq7/QzUf6KvmyaovX5fWOtiot0soEkwAGCvTSVq0dxsK5wyr9skCd1fqOtVFXt18Q4oDREsNHyMXoJxYxHFMHKauvnmrvWff4EAxK+Eo8BAAA=",
    Pbi3DGeometry:
      "dyEAAB+LCAAAAAAABAClWU1r3DAQ/S8+O0ayZctKTqUtFNpDaAs9hD0kZEkM23VJt4UQ8t+rrtfeXWueZuQQEtZ5OzNvnj5mJN+8ZNd33ffnX+vsMvvc33Xf+k13n+XZdd9td7+zy5uX4aOH1ZX/yV7z438utFJX+z/+N3tdjWbvnp5un72trpqiNG2TX+imUKp0eakL07o616YtWteUUaQu/IORIMc4GJnHmRCjC1u2JREnQCabyhZOacJkDvAWOIhHdNu4XJeFaWx5boORvTcBEghAIudxKlfUtR3k1KWxJ4iPo53ZI3Wtzm1UU9epNiiOK1pVWdoGI5M3Z62muQUI9oZseA38B2ualuAWIqM3owptKwmAfY3ZpPvyQO1cSeRCIcgmEoYmJtkG+E3F81B1ojdo47m52lWR1Y4XdWASRImuXH4fAMxgGJIzcIYRXpqAAASwLzw0Uc7Mrp401ebcgoqzBEmqbLB+CWxG3YJqFADykieJjxWAzLAN5IydBdMjUtmSqqGYGsyGL8fRhgCnA+LgAU2YAwndRQIiaMmo+nlINKwsrDZEAWNtYBjsjKiGYmonvcUMCRUQeRu7qFk6J50Ku31hbtgGx+G94UlNcQv6RVaDJZkSnSQ7PkRXJrbBDAIbXBSJJoudoshkSbsQnaGYAFAgmidWGsyPSIknTgCC0QE2kjYHIjjThLUYzZRTRzTa7OkxCUnRIFjzflnpPVK6qhGeKxNsjnFaNSBVZdv4PBDEwd4S4ggYoPM43itdUWkNKolrrKPzwd7SGeA4HjGlodXBox3kIxhtjGBvWDd0V4DziWmNGWCtl3BD9Tw2CqianuTTqrNmOHYvg+9y8K48ZRoyGFnbRta4xC55UBgCYdNJEodLJ6bNtB8FYaZdh9WG5RxhhuNzPVDarR3IJkYg4aox3KrnYfCMxpODOw2kTTU8PXHfNIjjPzhdU/skddeYYDOT7b+NbwSjjaggDHYmD8PHx1e6uK0fhoA6xg4rh8oGe0tngOOMK5TSBg91kI9gqDGCvWHd4CU5SicmNSaApV5ADdwlxIYA3TKM2XjEVEp2T59kM+PmkapttHAIQJiYM3kYLn7sFQY+dg7DSSHDfkOJxh1i0xjgOMPuFWoTeyUT5MMOdQzB3rBueAOH6WAJMAEs9QJqsBoAzoL3G/jOewGy4P0KfsGF3y28BUlQAN5Fi1+0ywEm+CrPPnS3P9e79VN2qQqVZ1/W24fd4+Hha7+73XX99vD4o7ufoE/r7uFxd3j4uFn/Pf3i+37Te4fbP5vN6+ofUZCP5nchAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "31",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "38",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "23892",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "73.6",
  },
  {
    ID: "575436",
    Name: "Server Space 39",
    Category: "Rooms",
    temperature: "20.93846229",
    Cost: "294.3275441",
    Level: "Level 2",
    Pbi2DGeometry:
      "yQEAAB+LCAAAAAAABAClkMEKwjAMht8l51rW2rXbPIkKgh6GCB5khw3LVqitzCqMsXe3sOnFIai3/PlCQr5jC2mh9s1FQgIbW6jU6qa0BhCkVhl3heTY9qUfICzGTARsNiEhJixi0KExyggWNKLfUM48Dfl/lHAcifgnOPbPZ/ruIntKm9d13nhzvrFU+Vk6WUMS4ADBVprSVUPYWZc75WX38aBOL7SWqqz8mRgHlE4RrLS8D7OEYsYFRbCw2vq95qZ1lz0ApXwcXckBAAA=",
    Pbi3DGeometry:
      "ugwAAB+LCAAAAAAABAClV8tqAjEU/Zesx5CMmUd0VdpCoV1IW+hCulAcNDCdFDstiPjvDdbHdJKb3CiiGM/cnHvuK3G6JZO5et18VmREHvVcvehaLUhCJlo17RcZTbd/Xw3MxuZFdsn5lwFnbLz/MG+yez+a3azXs42x5bmgosjyZDAsqGQ8STkVpcwSLqQBmLCBk4XgtEjL1GFiIQgbkIZnlItSOEy8SOEU0we6LCAAkBy18JSKvEj/I7zM5Rnp6r8EgXkAxBeAQMwYzViWOjJjAfhk4uj3iNEiMznEOAabgC6De3XC39vLSkxcAUR4BogJ599Zm2E5AA+czogKsJyGyzkCiRk1+LllmRx1nodATstCOoCQxSnKCHYrM2EWb8TCg8Z2DUBANdd5hg5Nv23h6Ywa6MBekEirNVEmXhKnEr9E2C/EoQXvhhvAASTKg17MEJPJOxtjSzaC5poKQLVZ6N4Qh8S2c8TxiD5Q4wsd5LhiLPuaCXcxxAOXCwzffS8HAuTmj8Cdmn1UbbUmI0ZZQp6qZtmuDotn3c5apZvD8k0tTtBDpZar9rC4r6uf7oO3utZmw+a7rnfvv+uBaJG6DAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "37",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "39",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "25314",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "87.17",
  },
  {
    ID: "575437",
    Name: "WC D 40",
    Category: "Rooms",
    temperature: "22.37411877",
    Cost: "451.5489465",
    Level: "Level 2",
    Pbi2DGeometry:
      "9wEAAB+LCAAAAAAABAClkcsKwjAQRf9l1nFoXq2pK1FB0EURwYW4qBjaQGykRqGU/rsBHxtFfOzmzhlm4My6hWxrls1BQwoztzWZs03hKiCQOVP5I6Tr9lqGAR6hoLEa9ARFofoxdOQFpBK5kOxzyCTSOJH/QMYwEVx+ATlSpX5nrwy8Y8/qNnfFw7rOm+A5NMYm32uva0gjjAjMdVX48hYWzufehNdc48rsHmiqTVGGKwojxjiBidXn2yxlKOKEERg568Le6mRtt7kAZztF0fcBAAA=",
    Pbi3DGeometry:
      "whYAAB+LCAAAAAAABAClWNtqGzEQ/Rc9b4SkvXjlPJW2UEgfQlroQ/CDQ5ZkYest7qYQgv89wrXj1WU0MzYhIdqjM0ej0WVG92/i9qH/+fqnE0txMz70P8ahfxSFuB37zfRXLO/f/v/rYHXtfsSuOH250kpd7/+4X7FbHWmfttv1q+OaWupmURdXupaVVm1htKxaWxelcu3G5oGyqg0OzDVAwNMwpdTWWTJGtsrqmBABJ8KiKuskwQcIhKRC5dq2bWKvQ+BIKBfSKh33D75j3SPzVra61fuBug5VoY2smoU5MUJgztj7nGJ4AInha8ymzwcaaXXV5AFfHATCmKLi4CRGwVCyVrUBg4T2R1eHG5KtbUnbRciGDMVxUxAjNao0A3J8FgvfEug4yGBLUFZnxED3DFGDP4WUUdFNpacEPZuPjOhs5gOs898/5ukXw8Hz+DwPgRzDm12SOOh5WgNk5MTzDuZMnXkcsjToAGjKDxT7pkZDjgIfgwq02YOFDKF5C7V/oEvMKcLP8eiT1iGvYDPQJGTNE0cZXhTYHED9maOnmscvNBTAUslUjkQ/RsBbyD+RUA3QVMRIZKBnisMMSIME+AGnzG52iaDHSCJjzRuClME1BXoHpgQ4I9JguwERSBL86IGO05I9sHJiAWfuDZIGrQiD54q/N9ilIQtAxMk5xAU1I7imQXGQQdHg175+oCjiIINYkXMARBzJBMIrOXpjwQCwErqsHvAYsEbaC6hevcyJNCMjgaTE6LMWHeCII2Glp8v576hyPickPs1xX4OwBZN7jgHr43MBRHxViC/9+nc3dVuxVFIV4nu3eZqeD427cVpP/bg5NH/1jx/Qt65/ep4Oja9D92/e8fM4jM7g5mUYdqt3DwBvRsIWAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "16",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1600",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "40",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "20343",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "37.98",
  },
  {
    ID: "575438",
    Name: "WC H 41",
    Category: "Rooms",
    temperature: "20.90903568",
    Cost: "412.8831494",
    Level: "Level 2",
    Pbi2DGeometry:
      "+wEAAB+LCAAAAAAABAClkVELgjAUhf/LfV7DzU2dPUUFQT1IBD2ID0ZDB8uFrUDE/95A6yUJwbdz7ne4F85NW0gu6tTcJcSwNxeVGN0UpgIEiVGVfUCctr10AcJwEERiuSAc+4xT6NAIZAQzEQXTIaWYMzoLOhEyn0+HRGAuPDIHjpbwF/7Ul31qXtV13riu3WCj8pu0sobYwx6Cg6wKWw7maGxulXtPb8/q+kU7qYrSXRHYo9RHsNXyNWQJxSwIKYK10cbtrZ5ad9kbAT55tvsBAAA=",
    Pbi3DGeometry:
      "7hYAAB+LCAAAAAAABACtWN9r2zAQ/l/07Ar/kmOlT2UtDLaHsg32UPKQUtMavHhk3qCU/O/z1tSxJX26u1BC01ifP326O+lO0t2Lur1vvz3/bNRaferv26991z6oRN327W74pdZ3L68/Rzi9HD/qkJxaLrI0vfz/Nf6pw+aNdrXfb59Hbp5rU+Y2uShW2qZZkme6rK1JslJXVe23T++XY4OtK5/gAjQDSYw/VmVhTgSrzb8Xo4CtbUUDcw0IhDUyo4vS5L4ZMcDYrGAAMw0IuBq2GP9Pw81yXVar/KQRA7LKlixg0oDAUsMN1ASsdF0WBLDUgMBMAwJhy+lApdqkJpdEMMCIz5JxVNbYAq8btDy8dlea7AgRvCFB62auXTKQxCxISwLsKaYNu4ITWr42wqOS2wGdK3YVOdf4U8odlJej5QC/DnArikc42g1TNCupvwJuV0gCmu3Gm2ZQEvzBQu2YQyCD5RBYegXFGnZF2RfK6PFo8DVw6aWGGypAS3GvBnDKe1g8BizXPinO8S6/wpJAPIJ8J4aAeKD4GjC0sQiGU+75gGivR1ZAQjywq3pjEBowHh4DasidCBlQg2OgW7Ch5ZBBlHiPEdj+kl0B8UhXNGNhICxd75B3aQ25SxCDZQdMAMxThwQ4d31wNOTHKt5kYDGYhz0JwJwMHIA4m0oAUpzOJVBDfsZ+x0TGPvnzgbg4ZzO/2In6VzfwUO4Ckb2reLMblkYE+gJBsquE/lgyxP6g7t3ObSd0WQcb3vWdADh/nnE05PeTwmjTJ4LzbxvJyekAm0Rdt9sfzdDs1TrVaaI+N7vH4en48KUftkPb746P39uHCfrYtI9Pw/Hhpmv+zF/80Hf92OHud9cdNn8Bt2wdq+4WAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "17",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "41",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "20743",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "40.19",
  },
  {
    ID: "575439",
    Name: "Elevator 44",
    Category: "Rooms",
    temperature: "19.68246193",
    Cost: "176.9751174",
    Level: "Level 2",
    Pbi2DGeometry:
      "vwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzEk27S19SQqCHooIngoPbQY2kBspEahSN/dQH/war3t7DfsMpO+ISnUub1LiOFgCpUY3ZamBgKJUbV9QJy++9EZUFA/8sRqwX3qCR+hI1+QUR4I7x+I6IZI/ACRLkM+g41B5sMpSDZWtW6avHV9ucVW5TdpZQMxo4zAUdalrQZxMja3ylXcy4u6TmgvVVm5LxFliB6BnZavwcuRiiBEAhujjbtbP7Xusg+OYaghvwEAAA==",
    Pbi3DGeometry:
      "kQYAAB+LCAAAAAAABACtlN9LwzAQx/+XPGchSdP1x57ECYI+DBV8GHvoWNgCWSM1CmP0fzdo140212YqpaV3n9x9L79ueUSLtXo5vEmUowezVs9Gqw3CaGFUad9Rvjz+/DpMZ+5BNT57JozS2ffHvahencJuqqo4uFguSJxFAk84J2yaCcwZEWkW4xawmEQi5mfASZowTwDkp84WkSfRCYRHQBJgrV0JxomYJrwvcQGSKBVeAKYCIjrVtn5BKMt82t1p9IAnFQB+oQ0AKNPoQvU2A9yl64saSAUs4UBVgMbABANnPi4eDEKOYSD4h4sZfNwC/ePKgU3nDzcGbIRjTWcUhN/v6895R9z197kq9tLKCuWUUIweZbm1u8Z4MrawypSN+ao2LbqXaruzjXGn5eflwFujjUtYfmhdr74As03k2pEGAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "3",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "44",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "6860",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "7.72",
  },
  {
    ID: "575440",
    Name: "Stock 46",
    Category: "Rooms",
    temperature: "20.2634801",
    Cost: "458.7257971",
    Level: "Level 2",
    Pbi2DGeometry:
      "gwEAAB+LCAAAAAAABACdkE8LgkAQxb/LnLdl/6lpp6ggqINE0EE8KC26sO2GbYGI370FrUsS0W3e/IY38ybrIC3Vsb1KSGBnS5Va3VbWAILUKuNukGTdUPoBKjChLFrMBMUinofQowlIA8xFwH6Hwptx8T+buuYb+4yRv+Ium6ZofWbfWKviIp1sICGYINhLU7l6FAfrCqf8mwZ5Uuc32kpV1X5LjAljHMFGy8c4SxkWYcQQrKy23tfcte7zJ7bcR3ODAQAA",
    Pbi3DGeometry:
      "/REAAB+LCAAAAAAABACtWFFLwzAQ/i95riFJ03bdnkQFQR+GCj6MPWysbIXayqzCGPvvFm1dm+ZylyFjo7nLd1/ucr1ctjiy+Tp/ObxnbMoeqnX+XBX5hgVsXuVl/cGmi+PvY6MWs+bDTsFZciWFmP38NF92Wnaw6/1+dWiwmus01MGVjHgSxXGgJNeTNAqk5kKqxK0IdaRwRY8Ckg8YOrluxunEwmwqOkCY8FTI8XxDjk0f8YZcqEkDUIrLONWBVFzHiTojRooeItFhZEUMFRTEgKPzYsQtuFQ6dSuGFJCiRwHJ7fEAd64LueCRiBS4Q+h8NDWaJaVRGtKyFUl8kxw3BSFsq7IjIMd7WzG0BDoOIrwpKKk5QqAvDJHDP4SUVdFN2UOC1sAOYdZAX/n/FdnWN6z4OuY7eU0HiLXaFBusmBVguiWaVqfM/UXMmwmEmXHQQnagUu9bn63r8V0/FE7P8GApRU0dsNRdrsBaDyhCtqPTGTpwSSAAYrCd86RddlXSoQJjIANs3Q3inf+B588BIsjdBH62WHpHJFYgh78pEIF6Tj/SwebYR3FpECkcxD4bDIl/EP27fx+Fm5xQ+2nNv5fCSU0qYSCF/+UGfDlo9RPkIBzPmJz46kOtOdrEEeXYNQzjBS9P5K4S6TZRj4HWg/gPgO+90866DNhtvnrL6mzPpoKLgD1m5bbetYOnql7VeVW2w9d886e6z/Ltrm4Hd0X21Z94UxVVY7D8LIrT8htzZl+A/REAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "23",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "46",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "21746",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "54.31",
  },
  {
    ID: "575441",
    Name: "Admin 47",
    Category: "Rooms",
    temperature: "20.99178062",
    Cost: "352.6142871",
    Level: "Level 2",
    Pbi2DGeometry:
      "uwEAAB+LCAAAAAAABACdkEsLwjAQhP/LnmNoHn2knkQFQQ9FBA+lhxZDG4iN1CiU0v9uoNWLRdTbzn7DLjNpB0mhDu1FQgxbU6jE6LY0NSBIjKrtFeK0G0ZnmHEc+ETMZ8THjPsUejQFAxyF4nfGCeYiCr6HDAsi2P9sKsUn9h4/e9a0aJq8dV25xUrlZ2llA7GHPQQ7WZe2GsXe2NwqV+8gj+r0Qhupysp9EdijlCFYa3kfvYRiHoQUwdJo4+7WN6377AFuhWq6uwEAAA==",
    Pbi3DGeometry:
      "1BIAAB+LCAAAAAAABACdWE1r4zAQ/S86O0LyV6L0tGwLC91D2RZ6KDmk1LQGNy5Zd6GU/PcVaZzasp5mZEJDNR/vaUYaaZSHT3HzWN99vFViLa7bx/q2beonkYibtt51f8X64fPrX6tWF/YjDsm3ZKGVujh+2T9x2PRuP/b77Yf1zaTRJksW2VIapZNUy3xlimSRy7LQZiLvzXM7Nqtyau8qSAdAoAuZ5UU6tQ8pylytaMWAAslHDL08TeUyz4pEpzIvl1YvjR0FxLo0OSUegCP5CF1JlWkP6znakGLEABUDCiT3M5wTqmShCp8ifjE9UEcPS26K48bqFaVcLY1HDh0oiohJIe4v+cR+kMGxQ18MgIAPFHDo13TswK1Pcqo9UDyDi4TkMGhIzamJiQcsFrLuIBRvx1IOMOXwMO6R3MM4Vj77tHdvmVME4PIhrClSd/boPCfvBYeXxAH2nvl47UG47saiwkX2kfDuRvdcVK49dbGx8GOzxpgPF8ebh8Cqw3tlpoLdA7lz9dzM4ZMR7SHoQDJwTzlPc+FN9+z7PbZspl1cMGA0fwCDwpp2g3PQaXOOmKo87tIiHGrJuXuNSDH3YIrrz4mczc487wVBiHmURBKDz40IeYiV1SWx3jkR8jAzo8ARQexrCZU4q5YRfvy7Dp7VVIGCzoF6DuFnIOFAEhBt5Ex41BfG/8IAI46NjPqVZJ44TLpJxGW9fa26ai/Wdmsk4ne1e+5eToM/bbft6nZ3Gt7XT2fVr6p+fulOg6um+jc0/Nk2rQXcvTfNYfMf4LPkLdQSAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "21",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2100",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "47",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "21168",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "48.87",
  },
  {
    ID: "575442",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "21.44055626",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9jsELgjAYxf+X7zzG1nQ6O0UFQR0kgg7iQWnMwdrCViDi/97AVLp0+973e7z3ih7yWl+6h4QMjq7WuTOdchYQ5E5b/4Ss6MczGCjD8YrwteBYUC5gQAtLBKYsTv8ySgimIkl/4BS6wHIq37Rt1YUF4bHT1V162UJGMEFwklb55ivOzldeh9GjvOrbjA5Sqya0sAhHPBEI9ka+ZzMj4bN1xoVY+zJmKD8SJZKdEAEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "210",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "21000",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "20000",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575564",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.79355491",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyEkbdI/T6KCoIcigofSQ4uhDcSs1CiU0nc3UK2I4G1nv2FmigHyWh/7q4IMdljrHE3foAUCOWrrbpAVw3R6QxxRLhOx4ExQyQMOI/mFaUKljMUXSwLKeRj8ZZ/Q8l2+7Lqq9wv8Y62ri3Kqg4xRRmCvbOPalzigq5z2oyd50ucZbZVuWt8SCiqiOCWwMeoxm0PmPys06GPt3ZixfAL0wAuZEAEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "19",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "1900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "1815",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575589",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "21.28350647",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9jssKwjAQRf9l1iGkr/ThSlQQdFFEcFG6aDG0gZiRGoVS+u8O1BYEcTf3wT1TDJDX+tzfFWRwwFrnaPoGLTDIUVv3gKwYppMKnuBCJv4qTXgUxSGM7EfmcRn58juTPI2Dv9G8WM7gdddVPdHJ2OrqppzqICMGg6OyjWs/4oSucpoenuRFX5dor3TTEiMIeSjjlMHOqNdSDgQ5GzRIs/ZpzFi+AcRI8y0MAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "21",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "2100",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2105",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575613",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.95650356",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyHEpk1/PIkKgh6KCB5KDy2GdiFmpUahlL67gWpBBG878w0zWwyQ13jqbxoy2FONOZm+IQsMckLr7pAVw3T6gOAqkcEyXXAVBQpG9oNUxNM4Tr5QoLiMkn9oLiw/s6uuq3q/7Y0NVlftdAeZ4ILBQdvGtW9xJFc59O9O8oyXGe00Nq3fkCEPVZwy2Br9nMNSeGdNhnytfRgzli+7KtvzCgEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "80",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "8000",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "7826",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575707",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.10617638",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzGkJCZtPRUVBD0UETyUHloMbSBmpUahlP67gWpBBG8784aZLQbIa3PqbxpS2GNtcrR9gw4I5Gicv0NaDNMZApzRmKtoxSPKhZAwkl8mlzRRKv5iC05VIv+hubH8DGddV/VhPRgbU1211x2kjDICB+0a377FEX3lTXh4kmdzmdFOm6YNG1xQIVVCYGv1cw5zFpw1Wgy17mHtWL4AwuxmKQwBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "109",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "10900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "10556",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575790",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.66968576",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzFsm/THehIVBD0UETyUHiqGNhATqVEope/uQrUggred+YaZLXrIz/rY3RRksHNnnTvT1c4Cg9xp6++QFf14UkByxDRaBCEXQZTCwH7QLOYJpvILhYKjCOO/bKosP8PLtq06Widjraur8qqFDDky2Ctb++YtDs5XXtPDozzpy4S2StcNjQjJZZzMGWyMek5hgeSsnHFUax/GDOUL+Hpo1QwBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "60",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "6000",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "5799",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "10506",
  },
  {
    ID: "575873",
    Name: "Basic Wall: STB 25.0 WD 12.0",
    Category: "Walls",
    temperature: "20.9372277",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzyFkU9qm9SQqCHooIngoPbQY0kBMpEahlP67gdYeFLzt7BtmphygaPS5v0vI4eAaXTjTK2eBQOG09Q/Iy2E6gwE5TWLEVYQ0SXkKI/lliDQT6ReLqAjwL1syq0/1uuvqPvSHx1bXN+llBzmjjMBRWuXbWZycr70Okyd50dcF7aVWbShBRgVPBIGdka/ZzCOaxQwJbJxxIdg+jRmrN7dXcZkQAQAA",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABACVU9GqwjAM/Zf42lvaTVc3n+Reh6APooIP4sPEooXdVWYRRPx3g84pk5GN0tJz0pyEJF1fYbY1y8tRQwQTuzULm5odMJhZk7kTROvr84pmMcAFN/ZmfqQQg8eBG26bl9swz5ML+kqPBz0pmZQ87CvFPJ+HPYG4wvtdrlQQlrwveaC89nydfsn7vI+Gb52C/8qnwld1KH0ybl3+hE7jfIj6t60bxZP1JPreeE6IuHX9bTtXjeezYVyyv0RfKvr43/5M8q+dziESXDCY6mzvDgWYW5c4Y7MCrsyuNI212R9cAUapPn8+/LWpRUHojOJYxQr/9R2mgkc/JgQAAA==",
    Absorptance: "0.1",
    Area: "20",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "2000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Stahlbeton 25.0, Wärmedämmung 12.0 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "STB 25.0 WD 12.0",
    "Family and Type": "STB 25.0 WD 12.0",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "6000",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Stahlbeton - Ortbeton",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "STB 25.0 WD 12.0",
    "Type Comments": "Stahlbeton mit Wärmedämmung",
    "Type Id": "STB 25.0 WD 12.0",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "7.33",
    Width: "370",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "575874",
    Name: "Corridor 49",
    Category: "Rooms",
    temperature: "22.43479086",
    Cost: "297.6840703",
    Level: "Level 1",
    Pbi2DGeometry:
      "Mw0AAB+LCAAAAAAABACl119r2zAQAPDvoufskHS6ky57GutgsD2EMdhD6UPKTGpw45F5g1D63XehaQep7drnN9s/I5+l05+7fnCb2/r78Vfl1u5Le1tv2ua4a/du5TZtve9+u/X1w9OlvvAuJCgx0vvgEwiRe1wNIIUYZikBMsoiJYIochnUGxg9Gez8LwswAQ500AjFCEmCBUV7Ief5drqgEtNMDcy4UAkCMduUoWSZgZojvoQFliDny64fw6S5xWm+6TNMvlhQNPwcDRh1sIsnA6KHnAzGqI0GC4qHEMvAj4xi0OkjyGzSJBAKokmZIJEMjdpUfZ2c45hRp4PwIuyL6A095TYOzImpypB9STMQgXRGmS0EkHKxPo5aAE8iZsMAnOMMO8diNc0TTjLDdOZiKHZjXRipTLfnWIwmATAmmm7nWBaYFM/T7X8sNitAlPtzt8+yLkdIxWy9h7BxLJDQp0XIuuFHmo4sQDmGRdgT0CiSgNeTlAHTqVkfDYgFYkE2YNRNv9BAs6Oo20LmMDDYk/Gyfhiz14XHzXOB8uFw2B61StEHV/X2vuqqg1t78Cv3tdrvurvzzbe223a1FjZPtz/qny/0uap3d/oVHaAYceU+NdXfl3fRy8p9bJtWW93/aZrHm3+NlPjmMw0AAA==",
    Pbi3DGeometry:
      "fNUAAB+LCAAAAAAABACtnd2r5Ehyxf+X+3xblL6l2SdjGwz2w2Ib/LDMwyzb7DaMp824bViW+d8tVUm3lBHnF5lZbYYZ5p6KOnEi8kMpKTPqD397+/0fv/z7X//r89sPb//89Y9f/u3rz1/+9Pb+9vuvX3759t9vP/zhb4//3T6+/W775+239yfyqb3dfnf/z/bv228/nl/7u19//emv23fbWzP37fK+tk3fDeP72vR9279/aodm6brxvb0Nzdh2rftgHJtuXfUX1jFP1PbN2N2m93VpxnEecvBT5rrsHxtrA2esU26WqGlK7AtzOTb91K/yg+5WnGPK2dTM0ybHWh8qp6npb+NSKp60RBoLYjq1WzXPhr2qqdNO1sB9KhmbaVhnR2LgtrmN6/ret800d1lrrSSf3KHpXfcy3EwCnSjodPcPbAtBN8p3uoLh3i9Nt/STM+/WZlnGzuHT2ozz9qfF56UZ+tuw4VPTjt3o7VN82PGb5yc9IJ9kVmZhXpu237tFCpPIOpZxbW7TPDsWYn+msjD12m0G/l6vFBW5zfaPMjnZMZgMWD1HfBh3XTOsrb+0bn/voRmWdr8KXeCjE3zautptGTLWn7axfVvau495Fj6NFnIKsx7Ah0SATQ77LbXbbGwVTv02xFqP18VP1gcMYdok6gZ6NbfULZI+tKPtND2m53acJvHB1Czz6tUADCJNTE/2bQAsncuYSSTRD9slaBq810CNdFuSBvPBi3kIPPsP1HDVCYJEbH/2w20p7d3d5nK5+cEAYwdYaEitt6btls7TzLv6rU/a0bN17LXfUu6j2mbhpe/9B/gNcIGSdGTVEcC0sF3W59nTUPrbbSobxlU049xvnWctj/eJF3+BPDw1JQPg8gXCS2PAqNE1xIDdBT1Au9FogvbcQ5umdn7/NDfdfim6bZPDNu1vnXReO4sanwfqGuzET2rCU3KCTcYyTrXEI5zzapbaGjS01bxlkWSyl8Jm4ZD6M6hZTaS2Bg1tgfe4ZTO8KWruKFNbg4a22tv5AMIwHEtcx5u31bwnui2tt8YPGbb18bju986JrV18R7YZZSlv6O1jjR6KAGPNfKDG2N3VfcDdtM4RPI9LBQlY7zffD3Rs1mnuDahNgZcYMrYX9NO25FiXycHX5z+EP10SfCHX6JV6braW3S4C8/68Y32iy7hdqwFdtjX40pehKcNms+7LzLmZ+i6r4YFa3rbtemKwtlFsie02drrV6d1m8i1pPaEpQ4xahnF0UYCGE7V6x34aiaEmNql3nnb+yejd0HXqFsNrbDWqGU5vW0stqwmtzPThKwErSKXWs9849N5vAL06i8H0+8eISHWhggdqaO8DAgiMaRSXMh3H7cO5NaYOvSsYp/3xnx184744WceY4UiCY9DeNG+5hthbYnv2pVTD2ZlThrMzGVuNaobTW6rh6LqFtg9vOooSXqn3zE4/Nu26mERu4NQNnUl6aipB+v69KQvRh6xpm8Nug3VmUW2reKWyM41JEGdLGtMji6mpBOn797YpQk9ZSWAfzlKUbDWvUHYmd3+g0y52XAM6Nv3W8crQlOFoiA1dh2E2jeZQzfvQW6ZB8+qI7+h289UOo9UA6P5yyM04gKYMRx4227ldsxoeqOW9xwYM1jaKLbF99DNre/YzQFOGGLUM9z6ZRgEaTtTqvfd1YKiJLc1Z9qV/9HL/WJEvt7Yt/ICY4PYAFaGD4/4KJTkXodQaSaln+8a1/gP08fFB7q0u+jhf99bixZ7pC8LB9X11HVzgFMwluXmlXovnvBbuqXD09zdDNWipR3oVqVm6eX+suzqfhIMWqZuUoM9tcM5TX44f/KV+/Xux0Lztm2G4rzTMJAI4hgsyQQ66vTXjcH/CV4Yf9IVeAR62+/nRS8cXaGAP7PN28Vu8RGT/tMU6tZ2P9dP+CLKdlFD8xksRWBgigHgDmYeailTkPrhQpS896z/4rherOR/Hu976D/4fXzR7H4+3XbX4y2/6yYF5810Hf+/2AiD/eE9Vh8deK3cX3Jpbf33tfTgFOK8ltQcxwL6/By9FLXPssIWXoGS+vzIfVsdOONCARhKDXvvm1i2Ch3DLn/NLb4LJflt1DL1vbMSJZ1uN9KtvWn4zDfzWPp8H7Rd04g4H2hGx74cT7UI4xgtxkR70OzS3du1r8JQ/4xc22qDMqVnbYfL0hBMPyCQ5RL9luRVTF+GWPvZK8Nisw+jJx2Vb4XazZwd7ot9mhqH1sdImJ3I7tU2/Tr4Hoj3wFybnDArU02ZIEOnEZEQivjbdvifY8tC+KrJH/mlb404+mcS/bH/2qx/my9xMQ+cvH2T/3fpPHPRTvKTT6cnoRHzcbg28HNxmB/ZI3233Qb2YxXEbX7vv5BKB7d+4ra24QEXf+K4YThxiwK2CqNQJymaDP5iaaVHLH944Sd9gH30zL61aMpGPYWyGXqpaNotFrSLwG98fx8cHFAfvPkW5VlVWLm5AxG+Muyo1JvEDprrti16xCERV6MN9I5sSdF6fK3Ru94nW4i9vRCUHdm9sLZ7zm997S/z29qP4g6xr3HAcMNmdrR++8YPCrcUf3whUgY/afbjl9jlJxJTZuxvD+fbJfUFuqX0FzXmMz9Zo7qLNyHA656WTPxZ2G52Pi4qGYyVGNggBamONQo63uSXyUh1wWIvOPG3rpaFfnDyA44NTxpqUaO7N+rbNpOXwsXs7dAlH0sDa7QxP2qbQJQgEJcD9wo74nG0oQ3Po/fNFaKYB4Nw0kLjd/Um7WDhWYmSDEKA21ijk2gIZebEOcGjOl9fBhW0A1gZ2BxnSjNQpMdagBLhfOMCRsw1laA593KMILWsAsLawO4yStIuFYyVGNggBamONQq4tkJEX6wCHprhHHVzcBiVlSdxpHJuROiWJNSgBbn2GKD6FlLENZdScWSpCMw1QVnPmQR2fI4rR2F9hxYSUGk455eCMSyhzEFRpsAej7u2LeEaOP42l5bDb1J7lHPRlKrNqyGtaY6IWzzVK1j7ld7VPavGMX7LP86d5K8YzfqkkCPJ0zbLvq3F+Cc/qSe1RD/Bv9msr9o8GeMqf8UsFX8h+7Lcbl3Hy/IQTD+hEPcR/25u7FHbsGa9U+Yfsh67pp5tvRcSJB3SiHuDv12YYJ99LELf8Gb9U6ojs+6GZV9HqiBPP3My3tnf2qAf4nX0uD+AXK0RBySfS2Q3NNImrCOLEA3GhHuJvm3mc/D5xwsU55tAvlRErMH/J7bE+pEPRWRI+WB0H5E5W35n9gebH3CWNCx2K8wjXExXaozM/WAqt49jh2HaVS3kyvSxPD1tafuSXSaYzuFIEdfNChoamHZiucXjCcAa3ABdPOrnJFCZfSgJdCyDHdUHRldLXfIjg4tVg/T1J6PZF+rKgaEn5erA01opUFq+Z4iUfsQML5aZ0eZtNMa3O9Woe3BI9rHohkzQAYbahgQbXTZqcfOWQk8YWTMkMb1MnomgycE/TTFmJB+wqSJQoeRYqsC7VI014FF4cpdRtq0Yk0RgU5SkKNJaRu1IbKbWDa94NIEmk5FkgJE2fg8NO4qzDDmhIfBWdsNfTIHFlENJkuTdOphBCxhreawKJOYafsTYH8VOSs3BAxhhesJoaEJkgowRC7F5JlJJnhYkwU65iwWvpjlxaGFy6WiAl+XZtplqSbqnwSiIHA23gpY26J/2z2NwBF28aPD/wZetivH5DK26WxD2R6Juiwy9UeuCNvzLdtM0ZzGmrLjV+rVdqAdotTUmAjcaUG6KBaCk5xXuusz2RekN+e2XFbkMaNPoL1VtBCzY6ui/E47g4ONxMm89r4Rd4PzLtYObdxbRdl3yX7+/NRlG9OxyY8DQGnLqAEYSHN+DwDNFUHgjCS5FmLz1JYhYLz5ovl4vxtehL4rRwdyOQuCIxdxjPZ8FRJs4LBBQp9ySmuk0JtyWhs6hgDkdRg6OE8uhhXX+pPS1HR/qAHo6nUUzAUnvckWjoOGLhYblMgukILR25rWqn4oOvH5Nk4QHdl9QEx5SlV1QPwVLXptPaoJJidfWzMoM+ykxms65xmd7c0C06PDxylVETa/O8pXQ7nLVOHjngww/5gEIK8UU4TzitwpnREUVu5Ilyvg7PvivzZXNjbld7N2pgYoHXURC9zlVJ9ODT9EHlFOIkctLoqg+Hra+7Mj/fkg8GcEzpPht3zmTswNMjV8Y0ITEPlXxR2ZAEHrfA9mZXXzgN3TwHxUevJRuts1GaUrRp8GXP3yDfsIMdgte6YbLKNRoocdzQxKotfaHWEzaVWiNuJgFr1Tq5jqyjNN2HrwLSZdyWvvvIRtPXxXgw+Oeaps5rlNe62Y6mUltzOsNRPlFpY2Y2RepLrB21QrFyJLo0RekPmoqCnI8PXIX9jB70AESgv54fIga3rkx6WZpNq2RYqGqnY+cFUrYVS5YrtC4Dej1D+4LmmbnLVKcvsQZuP+fCfG7qu5fAluTMbVIQM3d1KkuJqxNvPJreAjmBPgf5ri0syzSqNCs2slROgebyokuqFgqnKq5hQLZTuPLtkULob9oYYndV5KMra/7UrTqj26YHfX1d8+Qa7x9Hlh2UzoRTpxuCV+9Fq6gh9o8VS0L90ZCmzqir6p7AlD/XCKZgfIk+71KRQJPlrOOj5oVRuhPoqk/le4lqM9fusPZU1JmlvslrXexUg9EVnE9TYh6jFdZ9jFl0IUtQAtSaw/8IQBhk5SP/mmiobqgWyNbmdwoiErAurWBajFPBWlP51v3OQxgSecWBrBo0l5iiV1jEfU6ztna4npQzM6SBP7ip/rjzaX7dI7l429n6Y3leWH4caNwPmIRrEfuDOiagwiLxmqUy5TJX2ZQ7JdG1lxrI5Oo0X3Xtb1t4PcOC9dtNe2YykKs+X9p2ciFJS9S4zHlZl/PDXM44J7er3E5zDk5pbVB7/FUXhik7yxbOvrgoND9xEyYUwypIBNSlN3pecJwrb+8da6mQing17ZeIcsULJND5g06isxBfWkmM8arHFjxDpYel8NwbHwiJD+xxr5fgjNvy12n68FkNGnrULwdzx9qyv7cKr9Gy3uJ3iMf5Rvjp2UI4clmyGx7Y02OchXCxU7KHw6MvwaHTiloa1+IVRb+MHB8Ge/nsWFLh5SU08ld8ui8oSlOIFvmrKVBUVGQqcx4ITg/VlBYrKg8XF7UDf1XlCZ932zVoib/stqe0hueLcOiy/KBAXH+0HA/98ouWbtr41m0NsKz2Z0Xdj0wX2X4Q9+P9zeIyjO5xl/tRa80MFGXMscOi3/c+KabboCJch8VrBooqf5J4nftRRK1byiiOWwpgzSFzQb92DpplfNqdzluFCHy7C9rgpfUhuZ+HxYqzP7peYmpFDK17eOOTqXgVQSFt7C36oXoXxqM9HHyO6lRytPWh1KFmPieGNBm6lYzkuJkA1hyQDJj4pGQdnnan81YlAmZOoY0PGveLHdPe9kBLTE/aofWj1J+0jYiBoYw48uf2IGr0pNgaxM1Zu/Xt5kTHuxvLHBLzNI+9iFu3lNEcNxXAmgOyYXapRpp1gNqfzlylCti0TOLUVuun5svI9sYnWmJrZVwHK0WiiTVDEW/kzp2W12jaXRx8DO2rYqSo8ieJz8khDVq1khMctxJswFccmAo99ynJEJ32prNWpQEmTy1Nl5XYBW9g191sB/owvUz2GctEwIa2sw/iuV0p4gWGMuLIn93WKsGkm/hiHvtoNoppt2yxM6K9Twc+YtlCqdywhTQqCXQSzDbgSK0OTXqTCauTAPuTSRns4b8L3netPevNOePr5J6zTWVsxuEm+5AZKMqYI4eusotG087i4PtwTjUjRZU/SfyYEFzUqqWc4ril4BiH4sBc6AlPaob4tDudtyoRMGUqbec9j9uefr9rSoe1s70+b8qYJrdBZqh+cqcUQmKgKGOOHaa7vyWY3K46dH+s4ASX7P8PTSXr/bGEj1e2UCo2bCCNSgKVArdvOVYrI5POZLrKFeB+ahAGO57vepNx7G0vT5hypqkIMzIxlYpYMpQSx/7MLneNph3FwY+RbEUDR5VDzfyYDFw6dEsZzXFTAaw5IBsw22nNOkDtT2euSgXMlyAODkbcNW/wsZHqqu5pfJ3kc7aJjA0e1mmwoTx314fMQFHGHDs05yE0mvQYD++j22kGiip/kvg+P/iodUsZxXFLAaw5ZC7coYlYs4xPu9N5qxCB5zlAGxxNOiTfOtfUH6aXOT9jaSXc9ro+2VwKXklQyhu7M+e8NJp2FQefozrRHB3xLfUnic9pwSRDt5JRHLcTwJoDcgHzntYs49PudN6qRMDEqbSdNz3+kPt+25SOaW97edKUM01uhMwobV1pyIgYGMqII3/uBL9GkztWX17h/nDBiMZaDBUOifn+fMLHrVvKaI6bCmDNAdkwJ+MjzTpA7U9nrlIF1LAgcaq0xVPzc2R72+tjp4ypFZGMVQpEEgNDGXHkz5Vg1WjaXRx8DO2L5NKKr7Gx4j2nBhOzaiWnN24mKC+rODATeuqTmnV42pvOWpUGmDuVtPPC5XdZ3y99/fio85de5Z7G17uGnG1yOduN+zk44RgyA0UZc+zQnHLWaLLw8PC+QnSao4P5pf4k8X2R6aPWLWUUxy0FsOaQuXBnb2LNMj7tTuetQgSeFgNt+vjXobifJvvc7cP0ctuQsbQKhrYNjjFFvJKhlDj2lx4+k2DaUSx6DulUcXCOrsyZpj2nBJMI2UKp3LCFNCoJdBJgttNqdWjSm0xYjQSYLJWy82LlS8DvV7t0HHvby61CzjS5gJmR2bqK+BExMJQRR/7cYSWNJgsNcYRpXxAa0XGJ/DKHxHxfVPq4dUsZzXFTAaw5IBumXkGkWQeo/enMVaqAghskTtbhOCVfhrWzvd4pZEythmSoUhyaGCjKmCOH9kcZJJh2Fose4/oqmAgqfEnWc1ow8YoWsmLDBtK/ViEIKAV6wpNqITLpTKarRgHMl0rYeanyZ+TvF7t7ESK76HjaXm8OMqbJBex+NnkOispExMBQRhz7M6fiNZqsMjy8rwOtZGCocqd47+tIH7NuJaM3biaANYfMhKsZEWtW4WlvOmsVGrCaBUiTFQcOxUMzLbO9u3zaXu4NcqapiP23TVpXmM0nUxFLhlLi2J85Tq7RtLM4+DGoreioNFWpQ838mBhcOnRLGc1xUwGsOSAbMPFpzTpA7U9nrkoFzJ0gDsoh3DVv8DB19urwNL7O9znbRMYGjzf/1vtZPiJkBooy5tihKSWh0UuPUfA2ulsvGjiqHGrmbYaYRNy6rYzmuK0A1hwyG64uSKxZB6j96cxVqMDqMyAOanWcmtd5smuSp/Fz4s/bWhlr37mZ3ydUMkuKUubYoan+pdG0xzj4HN6paOCocqiZzxnCpEO3ldEctxXAmgOyAVOg1qwD1P505qpUwCSqxLX4a0X7vVQ6uL3t5fFTzjS5QTLDtXU/DhQRA0MZceTPVabTaHITK6rb7U8ZjGiseVfhkJjvDyp83LqljOa4qQDWHJANU9Qv0qwD1P505ipVQAlOEqcqcz41X4a2N74+gMrZWhnJaKVQNDNQlDFHDt3P/Wg07TEOPkb3VTNSVPmTxOf8YKJWLeUUxy0Fv4ikODAXev6TmiE+7U7nrUoEzKBC24/vb//w5af//Pzt869vP9ya2/vbv3z+5c/f/nL88a9fv/307cvXX44//+PLnz4++qfPX/78l2/HH//48+f/vRr+/defv26Ev/zPzz//9uP/AT9/4J181QAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "474",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "47400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "49",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "237014",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "1235.73",
  },
  {
    ID: "575876",
    Name: "Cafeteria 50",
    Category: "Rooms",
    temperature: "22.07739892",
    Cost: "76.40418166",
    Level: "Level 1",
    Pbi2DGeometry:
      "yQIAAB+LCAAAAAAABAClkk0LwjAMhv9LzqX0w5Z1nkQFQQ9DBA/iYcOyFeoqswpj7L9bmIo4GH7ckjwhedu8uwaSzGzqk4YYli4zibN17kpAkDhT+jPEu6YLQwPlWDAix5xiQqWAFr2wUBNK/cwow3LEo8/ZXcu3jHEcCcH+YUy+vWGIcYkppT+i8GFcvQkZQA8df7DefYZYzw/7h20mVZXWwTuhMDPpUXtdQUwwQbDSZe6Le7J2PvUm2K1Lt+bwRAtt8iIsUZgwxhHMrb4+ezlRCKbOujC1vFjb7m+En4M7yQIAAA==",
    Pbi3DGeometry:
      "1SsAAB+LCAAAAAAABAClWk2P1DgQ/S85N5Ydx/kYTgiQVmIPaHclDmgOg2hBS800mm1WQmj++7o/0knselXlAGJEv6l+9apcKVecfPxVvf+0++fn9211V707fNr9fdjvPleb6v1h93j8t7r7+Ovy3/hr+zL+rZ43E/LCWfvy/CP+q57vx6+9enp6+Bm/W3vTh1BvvDPWtWEzGO+d3/jWOOc2rjZ1m6HR1g++521H4gi3zWQ8gynrRAYgKVE3Ywbw3KHzJtS2zeD4MQwDsk7kIRLaWlCScgMlV/i3uFG2g+m8726wNd4O2UJm6Mx2ZBhlLG0hel4vjiFZ8aVpIoEzLVFA0sIkzFDStERsY5zt4qI1Jrj+RhB9tS6c0KFpusk2VkOX2o5oML6LnwWGi7elbQlvY/om9EiZhpdWdkXr3nQutMPtT5qoejCucRnam7ofgg5NGc4iM1sOTRnOKeGk01+jXRAiYyPoht4nthGNBemx41h/wbdMUk9lO9iQexN4RzkakWoNhV9TBE/FxnfxqWf09nRZJ325DF63+/DcU0spgVdtM4g72WbKYMElv/Um3Pm2VAKrd82y+WeVwJKtN6Vgtih1LOKGpgB5Z+xwR/Im+6QCXD/lLmnpUUGHaqdWah4WrJOlxzAtT5yFlMTqWBbtC/RXHcy7ZPffM1++AV/gbFAcrZMtWLAmubM5aQEzWgVRt11yAU+DF1cjwBpzJwMKlx7kks9argS4VK7wNGqyq5DN56xWYA1XOBnoWYGQG+QBZI0rgpQ7m7853YgEVBLkBrrlZaVyLIlS5Rj0HtTAuHmUHQpBi8umU8Fa8g74uClZmGWTEV9wQ1qvmmVzaykEMHpmNxa/MTUqOyl3F8v1Wlx1VAgoYJjX5L6M5S690ZDrq8C7MIPoFgdFJl5EaOcXV3X1qDY/9qIPw5Tomj2YpabP+iR0zT4qHUSuQDV7a74ZtUPnT3Bt6zFAdK6lMR1pu7ruT7ALHbOxccSAQUfM+6OPA8GU6IOnArTOukwzN2hq/RHE3gx90xJR0+uUKOYXCsA0B5kLdLQJNJOJo93ReSsSQU5mUBsYYi+SY532XXpkCY6PBXSZ5QQe1cVa966Vpkx05E1SZzArWhU2qxkGfrniU+rLtS3FzaiDMmh/QBydDbqVkJKRP5oCtC7ATFcdvaygnAFMc4A6Arf/57jjyDB0ddp6sgcBKttFNk7Gda87V2CdALZiJ2oZ3FOcLNZzynP4XPBZKICjyCHFfL2U8mzQi5lo5hcTwDQHmQ3xwRmUT2eRdk0nca0g6SYJSgbnVGMksfaaVHPJc72M+BJgAk/qgq2z7syGJT7jJB1mMBuKKhlsJDAdYwtZUo+9Qp0NRihURLvmTsmyxIitiQwEuRbZ5F4J/NF1S5cAdyisLSOq5tBBT2183ydNAzxp1ZmOtI3zIb3gNc+OSR+ArNiHUgX/ODwL1TZNQ52gWZuFAs/VChwi5rYLnsgGvZSJZn4tAUxzgGyIbyCQ8ulYadd0EtcLkg/CkGTqfGyKZNZ24CsW9BsU4BTsEmDmb1Q370aqsMT3MEiHGcyEokwGGwlMx7WDzJmnVqFOBqsTCCI9A5Wr3pEBcQDPIpncKEHa6KKl1h9fDfQhMl1DRMHdb6o3u4dv2+P2qbqzxm6qP7ePX45frx/+OhwfjrvD4/Xjh93n26/+2O6+fD1eP7zdb/+bG74+7A+R8PHHfv98/z9CrOzd1SsAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "44",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "50",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "26380",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "113.67",
  },
  {
    ID: "575877",
    Name: "WF 51",
    Category: "Rooms",
    temperature: "20.33751915",
    Cost: "265.7078305",
    Level: "Level 1",
    Pbi2DGeometry:
      "iQEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzHkxxRST6KCoIcigofSQ4shDcREahRK6bsbqK1e1dvOfsPuzuYdZJU5tlcFKex8ZTJvW+0dIMi8ceEGad4NZTTMqMA84XJByRwLyij06IMyhhOZiL+oEJhJKb6A402/w/dFxRh72TRlG7PHxtqUFxVUAynBBMFeOR3qlzj4UAYT3zXIkzlPaKuMruMaiQljHMHGqsfk5UQiWHnr41R3t7YvnqeZpX6JAQAA",
    Pbi3DGeometry:
      "+BcAAB+LCAAAAAAABACtWF1r2zAU/S9+doVkWbKVPo1tMNgeyjbYQ8lDSk1ryOKReYNS8t+nOnG8SPfoo5TSUl9dn3N0pHst+/a5uLnrvz/96opV8Xm4678N2/6+KIubod+Nv4vV7fPxXzvMr+1PcSiXyJXg/Hr6Y3+Lw3q+7d1+v3my915VFdNGq1LwmilRidIwKYUszwNKscoYdY4LxaSWJjsOCbwBoZkRxpSmYRVXpuRMcmPDDRNav0S1tNlzVDPRioYI11XTlqZlXLUyinEkdJIj0I48oBqAICEB1UqzqpXSJbThhlvD3bBirWq8OaKwBzIJ8bOnyfhKQDbABiBBJU4Y7SpvgLOWC0Fst/yB12/pKMdcNbnxZGZ0g0vglnFu/K3ah4vvOZc+8Gpqr3RjzF75xm+gGRCQ16gSvSCm5vSwNEFLhV/mL7WcxrtUczSfxkc4aF4Y3+mKkfnmzst7KET9D+Jk4JNx2Ie851Fkw9Hp+T02VBokc6wxYiBgkbvEsDG6D+HIytDpuf0+qj6xkGL4qACIDiQlly962tbUsYNLavYCzuupKtpaVYGuFEFHKInoMVZwWKQrRTPdSLKCuGhqQjyCyWIF6DZcV4ayACyfoz22fCgOYJAz1NEYSYc+Ak5gY54Usldic+kSXpTLxu7LyHtEarYnphYmwVsKG2IkQQcZ4TsUeiwe18ePzx3AMSX4dE1nBehzH7mYP3z/c6SH1w3HAQwyBnVMWjqYKOAELmZKQV0XSEQHo0m6jauaa1ej/zKZln2pxcZro+vAqTSCjlAS0WOswc8A/pymZSLOK1MP8MUHD56prAD91EoIC8DyOdpjy4fiAAY5Q319QdKhj4AT2JgnhTyZYnPpI9+inFf+BnC+7SQme1J4w6sEawlsjJGGHaSEX7DQa+9xffz43AEuXUEomaQ0+NxFLqcPv/c5ysMLh+MABvmCGibQTs8UcAIXM6WgpktIXJfFh37zsxu7fbHijJfFl273MD6eLr4O42bsh93p8kd/fx761PUPj+Pp4uO2+/t/4vthO1jA3Z/t9rD+B04Ay0X4FwAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "34",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "51",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "34470",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "87.19",
  },
  {
    ID: "575883",
    Name: "Basic Wall: Lamelle 11.5",
    Category: "Walls",
    temperature: "21.22178589",
    Cost: "0",
    Pbi2DGeometry:
      "FgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0aUx/PIkKgh6KCB5KDxVDuxATqVEope9upLUHEbzN7DfMTt5BdsZje1OQws6eMbO6rawBAplF4+6Q5t0gfWDG5pQliVxIRmPJOPTkB3wLLsLwiwoacx7+oVNx8RmwbJqy9Sv8YY3lVTnVQBrQgMBemcrVozlYVzr0wwd7wsuEtgqr2n9hARVJHBHYaPUcw4xTISNOYGW19cXmoXVfvAD8vLxiFgEAAA==",
    Pbi3DGeometry:
      "fiEAAB+LCAAAAAAABACtWU1P3DAQ/S/uNWvFWefDy4lSqkrtAbWVekAcQKwgEiUVXVVCiP/etGQD8vjtG8MKFbqenXkz44k983L6YE4u+u/3v9ZmZT4PF/234aa/NIU5GfrbzW+zOn14+u8oLg/GH/NYPK8sXFke/P81/jOPZ1u1w7u78/tRd+Fq60JoitpbX/u2cJX1TVsVUhBs17nwLGicHb9YJzScrWvnpGDpbenbbodGjFFVtqmqpdQYBZVPYE/r45/Q1C8MuaXtah+kwixIQCcRls4679MupX2dNWIIGPacKJRzER/U4BixuxADVgLEoLUjMGBRwQC3aYemhGBXUaVNwR1ERcKqKuUTWk+7xJ4M/ATELrnShtrh4KQlpLBY2rpp89IHEo52e9zT0CXWg3Vdm8jG9vvx+sLZqvQJQ7NAaDwFJ9eDbbvKJ7MRkgfFrKF3CmFDiHGl6ZpUeJNAatTjbi8TtmBqURmE0VmfgEB7x8LWFyCrArWnCGAW6KsA78SUcBHernyQikIaEgOklmJLDRw5DpDlBJdnKhLgGAwFeQwLVF2H3nb/zjP5lMUCqSEi30rEaTGrxCdVrBGDiPii9diQrPbY2+eU0ACRUzwlCRCYLKyD8eMyoQJqSiQSJR4XEI4deIUwsCnqFayHDAykItuRWBCjy8Y7FsSmZIs7CeSEEgtiU7KTjQWxKdnJ0mTBQGQryzTy05uPIZu0V2cRgyMMvrdqDOrVHjBwHCi7O54p1Mnvuj7hhYSPUr0Kay4huQAznC/gBEY+HZF/boizCWHA+kUTC1oXPS88xUmTLJpheh3szyPShvOeiI5WonWGdzZttuNhTN2P7cWp9CCIFCDvJZgLeD9AwoHdyxk3uZpCU3ulDxwfnm9pN3cMP1SCtl0x+3B4PC7lxyIYIo1GxPjkg5CkQAhKOuo1XhFGBkj+HcjYU87p8utU3QmrWeCMdw4UHLackJvOJq0zMPL7Bdh6MHB8V1ABJ+LUMzK8wdRkHyJfGGmh9lUNQBouyJaQddj5qy87yKPjEY0K+DBNwRFXz2c3vbt6DNbcw8abCyCRqOfsIHUEWVQq4GTwGyg49hpB764egw+g8B0GE6gJODirvEHAwenrB8rq6AV7AIczBhsAuICAnxXmQ3/+c71Z35lVacvCfFnfXm2upw9fh835ph9up48/+stZ9GndX11vpg/HN+s/L794NNwMo0Hz7mN7/P4omMezvzSjVRx+IQAA",
    Absorptance: "0.1",
    Area: "65",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "6500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Kalksandstein 11.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Lamelle 11.5",
    "Family and Type": "Lamelle 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "23501",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Lamellen",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Lamelle 11.5",
    "Type Comments": "Kalksandstein",
    "Type Id": "Lamelle 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "7.48",
    Width: "115",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "575889",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.14888982",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NIY5o2dRIVBB2CCA6lQ4uhDcREahRK6X830NZFwe3d+467y3uQlT53dwUZHFylpTNd7SwgkE5b/4As78czGBYRw4zFK8Ew54LDgH4wgWNB0i+WUrr8A+fUYi5ft23ZhQXhsdXlTXnVQkYwQXBUtvbNJE7Ol16H0aO86OsH7ZWum9ASEcxEmiDYGfWazBHFjCcUwcYZF4Lt05iheANiKZSdEgEAAA==",
    Pbi3DGeometry:
      "YgUAAB+LCAAAAAAABACdVNFqwjAU/Ze71xjSrLVNfZLNMtAHmYM9iA8Vgwa6ZnRBEPHfvWyZutUYU0qa3HN7ziHhNPM9TJfqbfcpIYexXqqZrtQKCEy1qs0X5PP9zxLbbIAPHMgZ6UWMDb5fOOCw+KUNm6bcIbcXxTSOEyIETQTLSMRp3E85+Y9zTkU/EWccp4yJYNylf4lnnD9eNf7TaDNwTjIeIuVk2EYQo7Vvr9RthtPjnjN0nXm4g5PR0cITtOCAhCenlU0P7tr0PTqeDIQwOlp0/FGD8urMwPW8enDrgHfVsyo/pJEN5IwyAhNZr83GFq/alEbp2pbvanVqvUi13hhbjCq5vfzwSVcaBeFhVBRpkeKdeATC46XsYgUAAA==",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1500",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.57",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "575890",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.96010554",
    Cost: "0",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABAB9jjELwjAUhP/Lm2NIGpuQOokKgg5FBIfSocXQBmIiNQql9L8baW1xcXv3vuPusg7SUp/bu4IEDq7UqTNt5SwgSJ22/gFJ1g1nMCzoEnPGxEoKTFgsoUczpBGWQkZ/GSUEM8rFD5xSZ5p/69dNU7RhQ3hsdXFTXjWQEEwQHJWtfD2Kk/OF12H2IC/6OqG90lUdamhQhHMEO6Neo/kzK5YMwcYZF4Lt05g+fwORZ1rzFAEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "25",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "2500",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "8416",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3050",
  },
  {
    ID: "575892",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.70206376",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzEkreannkQFQQ9FBA+lh5aGNhATqVEope9uoFURwdvOfsPMZD2kpT51VwUJ7F2pU2e62llAkDpt/Q2SrB/PYJhxHFFJl5QwLIjgMKBfKAUWPKZfjGBO2fwf+kTmr+pV2xZd6A+PjS4uyqsWEoIJgoOytW8mcXS+8DpMHuVZV2+0U7puQgkNijCGYGvUYzLTCMuFjBGsnXEh2N6NGfInqEKvBRABAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "7",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "700",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2419",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3050",
  },
  {
    ID: "575938",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.23653361",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzEk/YmmnkQFQQ9FBA+lh5aGNhATqVEope/uQmtBEG87+w0zk/WQlvrS3RUkcHSlTp3pameBQOq09Q9Isn480bAIA8p4KNcyokJIAQP5AQWnK8GDL8joUkbxPzRH5p/qTdsWHfbjY6eLm/KqhYRRRuCkbO2bSZydL7zGyaO86mpGB6XrBjs4KiYEgb1Rr8nMAypjGRLYOuMw2D6NGfI3TSq/nhABAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "30",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "3000",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "10000",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3050",
  },
  {
    ID: "576005",
    Name: "EDP II 52",
    Category: "Rooms",
    temperature: "21.8148214",
    Cost: "189.7012213",
    Level: "Level 2",
    Pbi2DGeometry:
      "fwEAAB+LCAAAAAAABACdkM0KwjAQhN9lz2lokv6lnkQFQQ9FBA+lhxZDG4iJ1CiU0nc30OpBioi3nf2G3Z3Ne8gqeeyuAlLYmUpmRnW10YAgM1LbG6R5P5bO4AUEJwkPFhyTJGYwoBnmMRxG8e+MhJhwHv3N5m75xj4zFK+oy7YtO5fXNdayvAgrWkh97CPYC13bZhIHY0sr3YtGeZLnN9oKWTduCcc+pQzBRonH5CUUB1FMEayMMm6uvis1FE+vhEPOfwEAAA==",
    Pbi3DGeometry:
      "iwgAAB+LCAAAAAAABAClVV1rwjAU/S95bkPS79SnsQ0G24Nsgz2ID4pBA10zumwg0v++UFt1bT6uiGjN6e05J/fe3C4OaL4W7/svjkr0LNfiTVZigwI0l6JW36hcHI5/9W0y0x/UBmckpITMuh/9Re1yeOyuaVZ7/WyYUFwULAnCGKdZHkQUJwVL9TLHeXc1wgzTIo+98EBuw8fso3ga4STLow6Pk4Ja8Z4Hgl/qTnADv9O/Lf5aXU8efEUB1pDglKRalaaYMpZNcFi4Ns9SFjvNj5J/jLfQO3IDrO3JjhG32b/ZjjsLg+y5Rf7bGUrrKwoQt/GPt2uT9eCT7QIHgEXVAk+PuVvUYdLIA5b1TgWbTYh9yHQx8vhaCtr5vhNk25efBzatr80n8OT6Tgq09d09axmaHhLYWxU4v42S+s3+IFafXPEGlQSTAL3weqt2/eJVqpUSsu6XH2JzuvXExXan+sVjxX8vA+9lJTVh/VNV7fIPmQMBNIsIAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "32",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "3200",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "52",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "24024",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "74.29",
  },
  {
    ID: "576006",
    Name: "EDP III 53",
    Category: "Rooms",
    temperature: "20.51360545",
    Cost: "173.1633094",
    Level: "Level 2",
    Pbi2DGeometry:
      "eQIAAB+LCAAAAAAABACl0k2LwjAQBuD/Muc4NNNpm3RPy7og6KGI4EE8VDbUQGyWGoUi/ncDfpz0oL3N5BkmkDerE1Qbu+j/DZQw9Rtbedc3vgUBlbdt2EO5Ol3LODCSjIoo+xrJHFWh4SyeYobEafqWZii1zgcqY6aIP9IUNfOrxc+QJSqleQjGoiBF7+jjFYfoPbz1PeTvrqv7mHQ8GNt6Z4LpoEwwETAzbRO2t2buQx1s/BzXdmn/HjQxttnGWzQmRKmAX2eOt1lJyHlBAn6883Fve3DuvL4AF2Y8fnkCAAA=",
    Pbi3DGeometry:
      "KDQAAB+LCAAAAAAABAClW12P0zoQ/S95LlEcO068PCHula4ED+heJB7QPiyigkple7UUJIT2v+N+JG3sOTPjVGjZNmdnznw40/HE/fi7evdp8/7X/+vqrnqz+7T5b7fdfK5W1bvd5nH/vbr7+Pv0MsLNy/ivel5drrwwTfPy+F/8qZ7vR7FXT08Pv6LsC9vXfehWh9+hMavW1G44vHemHobgji/6dmgviHH10LYdgSBdWGJCUhGkarpeB+csYW4KiP5BTbmxXW26vj2+aL2l3OARZ60KuebByIwndce0tfOHv4yAdYNhgPjCDD7MEEEXFhmDNiFZ7hUymIfVppBJrG7qzsXfMZjB2tn1xoVAAv1wIOnq3sSwqwCo6gT42riu1wFHa4nrAjekSI2yoR4aOzCqTNRlWkIiAp2dJeRsbiqBrrOaTg6WIZPBwTtH8mcAFgE02OiDEkPFOAKu7QcC6GvjfR57eB0qGqnTvE8SBCBIQC9KJMxgiLWVF8+YoaZLEVw8hVKca/P10B/LQOiCJWgIhBNhWWhneDexZcxnxKQNf3os0YZtizIheI3VMxklj9JTYEGKEDKu7obWMdpIxHTxVtTEQC9TxHO2GiO5tsuneCIydj4lsRERSDMBaQuHDJY9kZs+4frIgK4TzZPAzNlKqyrg1rZnam5OldAdS4CuzdMit7TtS3rTAqRkx3TDxkj/+SJJ5HWa3eKNLXMiA1nYiMmdeW4aQKA3t1kmhYbaZ5xvJqJLnJC05ZwDlyYqEzj3yCIFvMVlkdwTzkfoSdY8n+sb0SLnMjM3iW2IxIJTyTqT7o8Ew5i8JBvJJPiZIzekC4rAaBFm0eYyFKzfMIApQOyKtCkvlyCshflGbuA7mo45dBAnAwV9SduJbzZYNxkRRXeL+9HU6AWmLdpiIGVLKpTqoxMUlbxE5ZtsKZrYMsbmbFwg0QMBeIPBNc4si3xcMAHpVEBLkt0v+eRB5gAS2r2TznWBXb8ecA5h2RGrSwZIywGvxczDov5OMWMuQG5oC2Se8iE73JLhAkJ84IWutQfA+ZaadRLjXLXEhaP1x1R2jacqUTq9gxycKjWHQM4M8FE/1sZXJODtob0nIoU0lTJDAu+7PBjcg4PUByGpHABVwTjBZw3IDeg35EaRLbcJNsbIWNQHjk6E3useyagf7iSpoLhPtgbbetZrORyQIgVkN7QBEb2g43FVVuYMV9VDDIhsLGkU5JY3jGmg2LJJusE5DlXBsglDhZYtXAjsnKJkRcE1CGcBp3hEoB2aQGSDeJKoF0lCFQHbdoZveyQaVlsBj2SB/hFrkhYCON0iVMTYnX8BNWY43oVZRGB+CTeE9HIAVAVDhR85Q0ew75AehXeBWXiIAQ2GU77Jkz50yqfqepHMrr4zwnBMwQKV6VkU/PjsAJgHXOcyG0hMlSXzBmsrtgDzXNepLDow0Zk7cqIhgHXhoDGFmnaGDTS2AAd6iW247AOruUGHtQ2xF+MOZaglLhyNI3ZvxJxD5oCq1BwyOTyGA+ZLvva9pYC+bkxPbGU4VaXkkCMCzpIRgZlN3ZAzCwGoCoYKHWWivWBCC6lhaIttouelOOJwjjo6Me/cCQntISpiznfyjiI/WTtv9Rnv0KEyQJADkhMF8RCcYMIxlpaMYqwgUjwkY7FNkBoaC7ONKyftBUMOVcHKCTngqoUrQZhOlywqsAyzE9CK81voyER6NlwvgM4PIUX6UxzYvwUHC+GxLfEMlj6IWKT0tJX+LJsmXPpjg8UGq7+kIFxfuqzE71ksB/S3BnuKdX4kF39vogDRLXfFYsA8S76Fgc/eXllwv6r+2jx8W+/XT9Vd3D+sqrfrxy/7r+c3/+72D/vN7vH89sPm8wT9s958+bo/v/l7u/55/Yevd9tdVPj4Y7t9vv8D6E1uNig0AAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "95",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "9500",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "53",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "39512",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "224.9",
  },
  {
    ID: "576007",
    Name: "EDP I 54",
    Category: "Rooms",
    temperature: "20.6751051",
    Cost: "5.732317851",
    Level: "Level 2",
    Pbi2DGeometry:
      "cQQAAB+LCAAAAAAABACl1M1KxDAQAOB3mXMckjRNk3oSVxD0UETwsOyhi6EbyDZSo1CWfXcHulXBi2lvSb6Qn8lMtido9v55fHNQw0Pc+yaGsYs9MGii79M71NvT1KQJV6JEzW11bRUqwy2c2S9UAo2xagVqiVxZk4HzgZajEVgqLTNQCiyMWmNFWen/2xyA5SglaimLDKQACGv1CtQCdSXLPJyeKxvpKoUyYgVS+CpqZODPiy21vOxZnq9/inY3F/fNMLQjVTgNbHx7dMkNUHPkDB5d36XDpfMUU5s8fQpT98W/ftO9892BdrHIKRMY3AX3eZkrJCoKOIPbGCKt23+EcN59AUuqIN5xBAAA",
    Pbi3DGeometry:
      "zRoAAB+LCAAAAAAABAC1WE1r20AQ/S97lpfVt+ScSlsotIfQFnoIPjhEJALVKq5aCMH/vYvljSXtvt0ZhRIcW/v2zZuZ/RzdvYjb+/b7869GbMXn/r791nftg4jEbd8eht9ie/cy/tSwutF/4hRdWzaxUjfnf/ojTjtDe3c87p81dxPnslB1GdWZzCpVR0msv+s82ugfaZVFVSzLNKuu7YaggTwrEjrBUshiWVV1ZgOrJSyCAYpEqqzmRZHmZeFqp/UPukQODinr9Ol+sS1tACto5KsZCAhYllYxRqdiWZRJTvB2Et88IXDe/Ic4kkQWSZJegbSUpf5G7Tg8DsCThoSgBD/ncLLBBcCZhcyJgFbMWzaWt65iPhD01jXPzwkxQJzITA+wB4CmNFCponCagosMis8YUHwKuMX5RwYUX051PkAfKMjAu6FDHAJ+ryyGzyu3hhkPFjDTCIuTAcuUWTh8gLMnsQ9rI13ndYrbfS6dU8uKjsYIa9jeovZldNzL0So7qD+jHcVl+lPzELI/ti8PQ2v1eiL2H6vIJWTIk6L5RhMS4McWDpoMWKbMFYcPhMXZ16slQclc5eM6jOu6sAEqYZpz/83OCpsh4SdABegsWxpKBMcOOvV60w2OBQyDbAoyLIDCcMdBZ0ANV67GQxAFGASsU209gwTAyJcMmETICIzgsqqbxAcDd0vAWgwVjkgatS8FwsowgQ5Ts82Crs0g+BU488Y64KzqkPYmInxWLjVchyUQhxf/0HsCOK6kGsJvihIgMfL1SaSU9/7kWk5RLSECHFcPYXmbovUnzyh0d2W8TkQeee0E78Dhdq//nsxRa5O5n9QSLliEsGtBdtnFIAQU1pfGQYD0WocG0MX59zryuem5tvKl3QwkQT3iie+eyQWKW3cXiQ/t/mczNEexVVJF4ktzeByeLg9f+2E/tP3h8vijfXiFPjXt49NwefjYNX+nHd/3Xa8NHv503Wn3DxwgZefNGgAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "176",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "17600",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "54",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "97351",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "460.23",
  },
  {
    ID: "576008",
    Name: "LIZ 55",
    Category: "Rooms",
    temperature: "22.10706991",
    Cost: "30.23301278",
    Pbi2DGeometry: "mQAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoqOhbEdi4oSKyECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSSbQDAg3PDMFLuWRmpmeUQLluOakliErdM7PyQcamFeak1MbCwDeR6aMmQAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "0",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "0",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "0",
    Number: "55",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "0",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "0",
    "Upper Limit": "-1",
    Volume: "0",
  },
  {
    ID: "576010",
    Name: "Copy 56",
    Category: "Rooms",
    temperature: "20.68346994",
    Cost: "295.1151872",
    Level: "Level 2",
    Pbi2DGeometry:
      "LwIAAB+LCAAAAAAABAClkU8LwjAMxb9LzrW06ez+eBIVBD0METwMDxPLLNRVZhWG7Ltb2JxXN29JfuGFvJe9ID3pfX1TkMDGnnRqTV3YEgikVpfuDkn2aku/MEE6jac44yykXMgIGvKFkoaCyfGMRxRjLgczEXjNiP/M/BMxCvwHoqRBIIbB1rjxsLfu+IlmXlV57fPxg6XOr8qpChJGGYGtKgt36ZqddbnTPtK2Pehzj9ZKFxd/JaYMURBYGfXsdjnSQIZIYGGN9brlw5jm+AaSAuoVLwIAAA==",
    Pbi3DGeometry:
      "QwwAAB+LCAAAAAAABAClVl1rwjAU/S95riEf/TD6NLbBYHuQbbAH2YNi0UDXDNcNRPzvC9baLXp7bxWpmnOac25zb2463bLJ3L5uPnM2Yo9ubl9cYRcsYhNny+qLjabb+q+nxdh/2C5qkYEUYrz/8hfbvTfTbtbr2cbPHShulFaR1DGXeigjJXk8NEnUEoIr44GGSHmmRXoBDhoERDhBKh6nmWpxzROTZke8FepPQBYALjKP10ImMfoEV4InItkbJMb/XkFAFiEuh365ZQrijQEUKhWn+h7TH+hA8YA6UFVgZRfog3hbEyRfME5IB/cllRyoj8QP6WPbEtIB9wydoHeEIMc9mlS7nWpCpTyOtTwl0BnNwhLMg1TgHvBSEVpY4AER8HNcExW6JHUXO2P+n6AnCiVAjxMi7GV4Nz5jTiT6m1M7LFkIjAlyABMONZ1LHLonkB0Idd57y4C9+XIcdT5fgNipHJ6mYF1ixy/1uMYLv88e6tm0oWC7lLqXA31boB9JKNFt7d/I7+zsI6/yNRsJLiL2lJfLanUYPLtqVllXHoZvdnGkHnK7XFWHwX2R//y98dYVzguW30Wxe/8FMiNOIUMMAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "24",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "56",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "22159",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "55.45",
  },
  {
    ID: "576011",
    Name: "Staff Rom 57",
    Category: "Rooms",
    temperature: "20.55633939",
    Cost: "179.8701448",
    Level: "Level 2",
    Pbi2DGeometry:
      "fQQAAB+LCAAAAAAABACl1EtLxDAQAOD/Muc45P2oJ1FB0EMRwcOyhy6GbiA2UqNQlv3vRrbqxT2kvWXmG5JhYLI5QLsLT9Obhwbu0y60KU59GoBAm8KQ36HZHE7HUnAhkCsmLhnVaKk1cCT/INcopWAVyNFxwdegkMiErUH23ZFxK1WgctrUqGQonGHrlCqkVPJKtdbJVeokWmVrkCnU1JklWJKcizVoURstlqArw6e2DqVUy+1MN2dtXqel9rfA259FvxrHbirbXhI3oXv12Y/QUKQEHvzQ5/0cPKbc5VA+iFP4HF5+6c6Hfl9ecUjLnAjcRv851zKOUhtO4DrFVO4dPmI8br8Ay7EJRn0EAAA=",
    Pbi3DGeometry:
      "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",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "133",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "13300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "57",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "47795",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "313.63",
  },
  {
    ID: "576012",
    Name: "Archive 58",
    Category: "Rooms",
    temperature: "22.51564676",
    Cost: "309.7924919",
    Level: "Level 2",
    Pbi2DGeometry:
      "gwEAAB+LCAAAAAAABAClkMsKwjAQRf9l1iHkUZu2rooKgi6KCC5KFy2GNhATqVEopf9uoA+3oru5cy4zcyfvIavUubtLSOBgK5VZ3dXWAILMKuMekOT9WHqDwJSIeE1phIOIcBjQh9EQrwRn/0AeYMoj+j2c7/mVLdcUc9y0bcvOZ/aNrSpv0skWEoIJgqM0tWsmcbKudMq/aZQXdV3QXqq68UtiTBjjCHZaviYvZTgIBUOwsdr6ueap9VC8Af/2NfGDAQAA",
    Pbi3DGeometry:
      "FwsAAB+LCAAAAAAABAClVl1rwjAU/S957kKStrbRp7ENBtuDbIM9iA+KRQNdM1w3EPG/L2y1ljS3uamI0tyT3HO/curiSOZr9Xb4LMiUPOm1etWl2pCIzLWq6i8yXRz/Hw3MZuZDTtHFcsMZm/39mC85Lc/Hbvf71cGczShnmYw4z2kimYgEp0ku06hrz1nc2vmEplksxgIQhcseJ5THOe/bGRXSrHsE9oELgD2BpuCCJpNMdICYpnKStUDrKdQOElgA1CDbbvbLVMb9/oQDQbPR7WjAbDCaslQ4WtcDgpvtnVhn4mFRga46/UZWfZDDHRXEYQ8bYpx9QL/sCHIL8HYQ33Pgcoy1o4Vi6GoMal2TGtoPsP9cVEi40Fpq+QcL5Jczdzy2f2C/Ny8gzl5egfFAvFD9Qf9QPIj3xrAuYCJ1Vg57L72pgSJyDYCjHuiaUwnDAXDAkNTQxce9E4cBbNawbkKqMNbuYTb/Mu/V6qOoiz2ZMsoi8lxU23rXLF50vaqVrprlu9q00GOhtru6WTyUxU93450utXFYfZflafkLe1T4yRcLAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "14",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "58",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "15273",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "32.75",
  },
  {
    ID: "576013",
    Name: "Meeting Room 59",
    Category: "Rooms",
    temperature: "21.09188132",
    Cost: "488.3431229",
    Level: "Level 2",
    Pbi2DGeometry:
      "wQEAAB+LCAAAAAAABAClkEsLwjAQhP/LnkPIo+nLk6gg6KGI4KH0UDG0gZhIjUIp/e8GWr1YRPS2M9+wu0zeQXZU+/YiIYWNParM6rayBhBkVhl3hTTvhtEHWIKFiOiM0hgHMeHQownIA0x5TL+HNMSJIOIfOPXQZ+g9wtgP8L2E4lnWvGnK1jfmjaUqz9LJBlKCCYKtNJWrR7GzrnTKlzzIgzq90FqqqvZXEuzvcwQrLe9jljIchBFDsLDa+r3mpnVfPACwd1o3wQEAAA==",
    Pbi3DGeometry:
      "SQsAAB+LCAAAAAAABAClVlFrwjAQ/i957kKS2tro09gGg+1BtsEexAfFooGuGa4biPjfF7e2lrTHXRSpmHzefXff5S6dH9hsZd72nzmbsCe7Mq+2MGsWsZk1ZfXFJvPD/08Hi6n7sGN03rmRQkz/vtzDjovG7Ha3W+6drUy5TkQSyXjEZZzJSEk+yrTbaAHBlXYbDaA0T5KxvAgAOTygZyEVH6Vj1QFinuh03AJnV+EAyAEBMnNhijhSgjsPHUBlXKRZcrLQiY4HJCFbgBwN0OcARUQL5XN0tArl6LkKztxZ6FN9evtgUF5lg07PcH6gq6HEA6MFlaI2AXhy6UBAa3qHJ2Bg1Am2gH+k6RaNiARyT3acA9aKMEk8DgiA87gmKkQSxymUGiD3AXqhUADkAOcbOvjgcMkASg5rhVcQ6nN/vuEcvdKieaC3BzZc8TTo+eGuiNxgBxImPgEIFB290cBmhi1QjstHJZ0DD5d+F6AAQu7eS+/N8iOv8h2bCC4i9pyXm2pbL15stayMLevlu1m30GNuNtuqXjwU+U/3j3e2sM5h+V0Ux8Uv2GmpMUkLAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "18",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "59",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "17209",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "43.62",
  },
  {
    ID: "576014",
    Name: "WC 61",
    Category: "Rooms",
    temperature: "19.01631468",
    Cost: "263.1440091",
    Level: "Level 2",
    Pbi2DGeometry:
      "vQEAAB+LCAAAAAAABAClkEELwjAMhf9LzqW03abrPIkKgh6GCB7GDhuWrVBbmVUYY//dwOa8yrzl5QvJy8s6SEt9bu8KEji4UqfOtJWzQCB12voHJFk3lDjAIyqkXHG2pDxYxNCTLxOMhlKKfyAXlAVB+DvkMQ2ZmAXHT+ay6Y/8E9S6aYoW08LGVhc35VUDCaOMwFHZytejODlfeI0BD/KirxPaK13VeERStB0Q2Bn1GmfRiowk9jbOONxrn8b0+RsQHbY3vQEAAA==",
    Pbi3DGeometry:
      "XwUAAB+LCAAAAAAABACtVNFKwzAU/Zf7HMNN2rqlexI3EPRhqODD2EPHwhaIjdQojNF/N2jbSWtIAlJaes/JuSfNPXRzhvVOPZ/eJJRwb3bqyWi1BwJro2r7DuXm/PPqaFy4C1pyQa4Y4uL74W5ot73spmmqk9OygnIhCGOcYpblhDOaz0VBehxnlGXXsws+pzly/ofAR3CkuRB82mogohV+c99uI3HXTxQimzqnEyHr8HF4LfqvTif+YRZjj8ks0omgeXzYBo9RnFPx6KSF8LHBeKixeMjXmxqvQfLRhQTpeY3dk/tbLVX1Kq1soESKBB5kfbDHrng0trLK1F35ovYDdSfV4Wi7YqXl5++Ft0Yb17D+0LrdfgGufyj5XwUAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "2",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "200",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "61",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "6155",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "6.15",
  },
  {
    ID: "576015",
    Name: "WC H 62",
    Category: "Rooms",
    temperature: "19.61673945",
    Cost: "42.93259706",
    Level: "Level 2",
    Pbi2DGeometry:
      "nwIAAB+LCAAAAAAABAClksFqwzAMht9FZyMsJ7WT7DS2wqA9hFHoIeSQMpMavHikbiGUvns12mbXJb0ISZ+QkPRXZyh3bjP8WChgFXauDH5oQwcCyuC6eICiOt9cLjBI0uQvbJASncFF/DFKMVdknoFEaJSkOVBhyr0nwAVqUukcmKHiFZ6CGd8x+T/TaDRlk9njW/PQ+Kn6IYXXvm8G1gMn3l3zbaPtoZAoBaxt18b9PfgMsYmOJXQLt+5rRB/WtXsekqNUKhGw9PZ0r/09mDZKwFvwgft2R+8v9RWYOft8nwIAAA==",
    Pbi3DGeometry:
      "iBYAAB+LCAAAAAAABAClWMtu2zAQ/BeeVYLU03JORVugQHMI0gI9BD44iJAIUK3CVQMEgf89rGvLNsXh7ioIHFsz5M5yxccu717VzX374+V3o5bqW3/ffu+79kEl6qZvN8Mftbx7/f/T0ebK/aldckI+WGOu9v/cR+1Wx24ft9v1i+tbaWuqOrE21bn7laRW54u6SM5wk2X5iNtc16mtZhJI4gKvdVZnxQn/911W6Tm+FzjivqsCHNm/wCcDCBEXCu47rSs7kxCKGzeerNwTdVFnUyI1ujDFadxzcSgwIazVVWosJo4S0Fc+IRAnJ6av4c9MVg9iVUANaAr14EeXDgkSj03DsKkQQfaQrzOhhjwktKlClzbNA+I+IXrncQJqjMRCp25dMAg4DjkhEF+4TSWD+KgAnWUTpHSpq9IuSHwqMA+ndMdTKQqP1pGXTJyr6kUZeMO1gg5+34y30tg4kVhQBx2y7x81XP8D7cP+x8MmkI22j+RFQTcF7UX2I+FErxeNK+oPNfdDOVdsUQTyw1hzaJ5FXIxMqEw293VRgMhdm2sIHhicA5wZPLE2OWoQPn/+BuoS9utkvWaxIe5Km0QbdZgk28gjTND5FVU0kN5CcemOhypNAR7VZUwAZJ9VsaKJJJ14yD5j56fw+ISXbAtE/Swh5m49HI35FwQzDw2swSnASIK/3EUZJHF2E2ZwIUXXDe9MsGGxBJWhr9AUFQwiMSRv5OQXH/C9oTsJbq5NtWdcejAV6KsmtgS8BmJUKnGcUF4l6nO7/tUMzVYtjTaJum42j8PT4eG2H9ZD228Ojz/bh5H62rSPT8Ph4UvXPJ83/NR3vTO4+dt1u9UbD4Lw0ogWAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "10",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1000",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "62",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "13455",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "22.42",
  },
  {
    ID: "576016",
    Name: "WC D 63",
    Category: "Rooms",
    temperature: "21.6563373",
    Cost: "22.95683357",
    Level: "Level 2",
    Pbi2DGeometry:
      "9wEAAB+LCAAAAAAABAClkc8LgjAUx/+Xdx5jm+mcnaKCoA4SQQfxoDR0sFzYCkT831toXZIQvL3v+zzej+9LWohzdWpuEiLYm1zFRjeFqQBBbFRl7xAlbR+6Aiaw73O6pIRj6gUhdGgE0hBT4k1mLuULImYwhhduo+mQERzywJ8DRw34C3+sSz8Wr+o6a5zPLrFR2VVaWUNEMEFwkFVhy0Ecjc2scq/p5VldvmgnVVG6KQITxjwEWy2fQ+37ioAzBGujjetbPbTu0hc5PTOw9wEAAA==",
    Pbi3DGeometry:
      "axMAAB+LCAAAAAAABACtmE1Lw0AQhv/LnuOym2Sbpj2JCoIeigoeSg8tDRqIidQoSOl/N9Z+ZvfNzAYprc0+nXl3Z79mnK7FZJE/fb9nYiTuqkX+WBX5UgRiUuVl/SFG0/Xf1warcfMSm+DYcqGVGm8/mrfYzPZml6vV/LuxDZUcJgMTaB3KWKskCLWMh6kJToGKovgIUmlMonsCqHEOjIxDFR/B799BEtquDuDEYivusjgHHItzjXZ3DyCURg/SbnCuAUE77LS4FXYljTInQCVSR4MEg8YyNWnkM7VtV9YMWsDHAmgMpVZRhydggIfn8LQPumXhliBD+D/izAXqA/jdBRY4uHDCfSVarhpJk6rU0m6381dOdzvyb7e3RmABNALfdlLZdUy4gS3RG/QQhzfAfirg9WMBHwu3hnVAkhrWtueMA4YEjoOMLv/OIAF/Bt0WXSHxHyDsVfcVZx0hcGr7A6hBBpFxXrQOVUdiwZVAx3Or3ZFp9esSNEAKeHAcC+ZVAl2heLCXM90pCGCnHCkpAWB3OeJkukGsc3IDWIAcBwf0Ta1hSP5lavmVAAn44uSGImoHH0CIs7O5gwYs8nxA3/3P0WDWi5xd23+fE1WsD+DvQc+klazxqMTbVxrnW74KODXll7ZkzcvPcslshF3Uw/qLFmeXqvQ/i/zTeCA+C8R1Pn/L6mwlRkqqQNxn5Uv9unt4qOp5nVfl7vE5Xx7QbZa/vNa7h5si+zr94VVVVI3D8rMoNrMfiIJHX2sTAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "10",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1000",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "63",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "13370",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "23.24",
  },
  {
    ID: "576017",
    Name: "Leader 66",
    Category: "Rooms",
    temperature: "19.73853942",
    Cost: "311.6627619",
    Level: "Level 2",
    Pbi2DGeometry:
      "wQEAAB+LCAAAAAAABAClkM0KwjAQhN9lzyFkk9I/T6KCoIcigofSQ8XQBmIiNQql9N0NtHqxiOhtZ79hlp28g+yo9u1FQgobe1SZ1W1lDRDIrDLuCmneDaM3CEY5Cj5DEVAUMUJPJiDGlCcY/gBZ5GPD+HsYhBQZi/6BU698hO8lFM+y5k1Ttr4xv1iq8iydbCBllBHYSlO5ehQ760qnfMmDPKjTC62lqmp/JaGMc0FgpeV99CKnQRhxAgurrc81N6374gH7+dZnwQEAAA==",
    Pbi3DGeometry:
      "HCAAAB+LCAAAAAAABAClWU1r3DAQ/S8+u0KSLVlOTqUtFNpDaAs9hBwSsiSG7bqk20II+e/Vftm7kp5mtKGk7OrtzJs3kkby+Pqlurobfjz/XlQX1Zfxbvg+Lof7qq6uxmG1/lNdXL/sPnpYXvp/1Ws9j7xTUl5u//N/1evNwez909Pts7dtpNCq0bVqWqEap2qtROt6U8+A/9D7gQPQWuFddWcBkCMAZotGmN76D1q0ttNHFgEQccQWAcCwCMmV6JzuPaCEVUYfA6axzgNayFa1M6CF7kzCAI1nHBmtVAIgqbffDcMTMoAMUzpiCt21nkI6IfXmFycWifEjA9eZJmWAxkMC05h+C7RtrxghQepNnqTOu+IGlRaBdljBnpTCSHPkSjkPKBsD0EL7aK3bTl5v+ubEou90PJ4zKAwKujpY8DlwquZNHLhib3vaFQRADkkZBdxIuOw8kLI4APx5IgHIcQCmYksCEcf5AJ88nA8YFcMVPMrI4zLkwECwGGhyHC50xSDPn6MMDkoH5CCvFuX3AT5A32viir/bHonjKb9vEmcKaQAokKfEyUhQwN2PZGeDDa4WzAKKyiH7OEvc5fKe4KrN5QPII8lhtPNVi5vBMNrE9YU3e6E8WFwwRbkr0iKhL7q35aNi6Qj3TJoj78rEE04vKrgMyfOdv8OjTQPXZ7GMxNPGqadwQaNxtJ7LqXMWSXV492U3WYkKxnPtW4Azo9Wi6bTdArp3lvNsyTaYGHq3myNt2jY7eSQFdMXnIMjhEy9cId4DqNt+w7UJGZlKX8qd4bCm75MZQfMaqqCmFY0jPyhLsPUAFEDNiDrTxCiOCZ72MFhQZicVm1+0KhFt3DjiWwRRKeG007ykIw7ois9BkPM7aadLLR7f149QBHZUSgwJ9nUoTgaY1FgDOafw3E57wlnC5TctIiMbUaO8FocEyziMFdxPNyJUtwU6aYPVB7qEfIs5qm53d7RWBwJBwxFyQFd8DoKc7sCG8qR26ccL61qTUIEflsuYMwR2/0QcJgNOaqSBnFQIQFcwT6CFjWRA3ZAbZfacmGC3AQWb7kIciVC9cqlYw6Y62yCMSDeWl25EABxx/RPEnFcV4ePoNG8hMFWOUw0ZV+XkkGMqQkFG0EugSAU1o6ijBRxl8oRLb1JDRjTkhoktDwoW8XS0qI8Pm730iwqyMU6+RKDJoQUkp1vp1NvtAoAgv6mrj8Ptr8V68VRdSCHr6uti9bB+3H/5Nq5v18O42n/9OdxP0OfF8PC43n/5tFz8O/7hh3E5eoerv8vl681/y/7XohwgAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "40",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4000",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "66",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "26124",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "93.5",
  },
  {
    ID: "576018",
    Name: "Secretary 67",
    Category: "Rooms",
    temperature: "19.15085748",
    Cost: "307.4893202",
    Level: "Level 2",
    Pbi2DGeometry:
      "ZwIAAB+LCAAAAAAABACl0jsLwjAQAOD/cnMIeTV9OIkKgg5FBAdxqBjaQEykRqGU/ncDVp0qPrZcviO5y2XbQr7X6+akIIOF2+vcmaZ0FhDkTlt/hmzb3pchQUgs4mRESYwplwl06GURxUyy340KzCMhvzHJU/4PDpTzBiOcCj7UyEfIRcCEfo6PN//VntXsHiMd13XRhLmGjakujsqrGjKCCYKlsqWv+mDlfOF1+Ar3cKMPT5orXVbhkhQTxjiCmVHXPpcyLGTMEEycceFcezGm290ArfAFbGcCAAA=",
    Pbi3DGeometry:
      "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",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "23",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "67",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "26588",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "55.17",
  },
  {
    ID: "576019",
    Name: "Doctor 68",
    Category: "Rooms",
    temperature: "22.88690215",
    Cost: "272.5836907",
    Level: "Level 2",
    Pbi2DGeometry:
      "3wIAAB+LCAAAAAAABACl0k1rwzAMBuD/orMR/lAUNzuVbjDYDqEUeig9pMykBjcemTcIpf99hn4cuq105Gb5EbYQ72oP9cYvhncHFbzEja9jGNrYgYA6+i59QLXaH4+5gS1OFD8oWaIybOEgfppmtMR0vxFqMnYMGsrjWHU/FoxGy2IM/raCm5gHkkVpxqAiNAXxv5AM8Rj8Y6AbeJ2R9TlK075vhpynfPHom51LrodKohTw6ro2bU/FPKYm+RzBY7n0bxd6dr7d5k8mKLU2Ap6C+zr1Ko3EpRYwiyHmd7vPEA7rb3poukHfAgAA",
    Pbi3DGeometry:
      "OCAAAB+LCAAAAAAABAC1WVFr2zAQ/i9+9oRtSY7dPo1tMNgeyjbYQ8lDSk1ryOKRZYNS8t/nJXFiS/fpTm5HSIj1+e67k6XT3fn2Obm5a789/WySq+RTd9d+7dbtfZImN1272f1Krm6fj397OLvuP8k+vYy8ybPs+vDTf5P9chB7u92unnpZWypdZDbNtVG5rvK0yJWpaptegEwVdT8wAKVRhdHVLABycEBeKFMuCl+VD2hl63LBAxcOCLgcVmlb6jTPjbJGF2MOo015ALT99+cCZHahSQBIQI4RkJe2vgCFWhhTk1YB8pHEVJVEAlolNHfkOQTgJELPhX5UqrB1RZhbqTovg+NTBjx+JoDAhOG82jygVpXJTRiYcGBgxAEB0u9s0W+Bfm8UmbKZJf2uba2p+XPHyfuR/mHcvb8oexdLQ9lD8g73S+1E+l8wD2h9ofmJXY9HPUOU8xx2AdeDueNyZje4++fEQEGEakcVlGA5XMDzj/cDkWOJeD/g6SU476Tk3JnKnttQFTw65cBrJA3O7MJUhgp/h7kSqHJml5eAHG5s4QGoyg0LIgCqos+pkFU0hxvMBbMLHy2cdgjABSdN++Qc1Lpipz18Qp9TGe9EdAH58mEByOEBQ4I1CmS0VVQS56miAagq3qoQuTDnjJEYOGBeOwUoc2cCkqT6CBCzC63yEnfPwbDnkCPKKpqDWAx8nSF8UExSCo2dDyCKcyAhUn1h0GX3GctB1V0MOVQl2ctCCdYqfMqjVMnN7KiaLMwRr4qqtcMOUkU4oyreKpjsIg6Rg9MHFVglTE7r+RF4tGD3Ew0LJsKgsAAFIIWwSh6Ne10GlgFICCjcijWem64c4bKFay2+quedmALQCWgsBLCxNDeO6ZKGT3zvKJ6c3d9MRysGEMZbSUEws0EMow4OLnyXx+3mwHakHHi9LSBvYbLA3CAS4IhtxKKQCphj0lumxR0DzD2VJBzxrfr/EAyZFwgxwNxsR8IhfLMAc7D4rE3y9mI+IM+JWWDuWwe2RmHLcdhqxa09r6PKNgM5jhAAzaULX9iCgapC5oLiGjXwA24wZTr3lkbuBdvLEXgRdptg4HruqCv8AoAhX6bJ+3b1o9k12+QqU1mafG42D7vH08WXbrfatd3mdPm9vT9DH5v24XF3uviwbv6Mb3zXrbte4eb3er1f/gWIT8KAOCAAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "28",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "68",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "28496",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 2",
    Volume: "65.75",
  },
  {
    ID: "576021",
    Name: "Meeting Room 69",
    Category: "Rooms",
    temperature: "21.76322675",
    Cost: "454.3511073",
    Level: "-1",
    Pbi2DGeometry: "mQAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoqOhbEdi4oSKyECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSSbQDAg3PDMFLuWRmpmeUQLluOakliErdM7PyQcamFeak1MbCwDeR6aMmQAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "0",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "0",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "0",
    Number: "69",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "0",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "0",
    "Upper Limit": "-1",
    Volume: "0",
  },
  {
    ID: "576022",
    Name: "Basic Wall: Lamelle 11.5",
    Category: "Walls",
    temperature: "19.38385541",
    Cost: "0",
    Pbi2DGeometry:
      "FgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzFk+5e2nkQFQQ9FBA+lhxZDG4iJ1CiU0nc30NbiydvOfsPM5D1klbx0DwEpHE0lM6O62mggkBmp7RPSvB9PZ/CRMu7jeoUhxSAOYCALxCigScT5XxpQzhF/6BI8w2IesGnbsnMr3GMny7uwooWUUUbgJHRtm0mcjS2tdMNHeZW3LzoIWTeuBRmNvSgmsFfiPZk9nyYhQwJbo4wL1i+lhuID1drb6RYBAAA=",
    Pbi3DGeometry:
      "LBwAAB+LCAAAAAAABACtWF1r2zAU/S/aqyusWP5Kn7auY7A9lG2wh5KHlJrWkMUjM4NS8t/nboldJJ3cI2eUNnWOr87RleR7fW6f1c1d++3pZ6OW6lN3137tNu29StRN1277X2p5+/zv3wFOL4cftU+mby5Mml7+/TP8qv3qGPZ2t1s/DbFZplNriuTC5NrYyiaLTNd5ahIPyIzOClu9fKZlZgIRua5tHgDyStt6URIRR45i+KyLBQEch6qsLrPaBjhcudlwZ1nUJyaIVPEpGTlgrmAEIveSKAL8UEdVMO1edsWZQ1WQAw7Fq4KbQeSAEVWpC7uoCeBIbsxwh7GhPYrGMsbqhSkDK2Ks0aYKnU8fGUezVqdVHkiYj4yjFVbbMg/xeMiYMzwdNwMyEjGYrOyUADfTU25m5POEAsgTsdYET4S2s3jgfPDCwcHgKXw1m5dvjHml2UUCNG7MtAscZNIsAYHd4bGMmfE0uzFYM84AVhDYnzwPztoJbVCBl4PA6XUQnGosANNESJPXGmrGO+pEzJzpwBgoejpTTsRUPd0FGEueMxcvwu/jHGDqNCTAb6UkwO+Y3HWk5wFn7vcmDuDNXEx7PAccakYS0VBwHvzSynJpVfM54Dxg2vFCwRMF34zkpp7du3i3I3L+XSr+cIrnHJLDThy+r8GHDATgOYfkEZ34GT0DE8J327hDj+iNcC1nFMA3DqZzPaM7InhwfworJn5OyQAmYTtanj3iIcJ6CdRLHd/+MQitgPCdpGdlRC8hGTmy6QU5YO2SAdpeghE0eUQxYD06WAyI8sG2V7zpBUuUyAEbMgJgrTjCz5TIIwrnbFcvotSyfRc21mRyGOFyoBaOAFijk/ABJfII94E2Dhl7UCy8jMWAzbE5BuUMK4NB/oelF6EgqjUTGz3C8JxjPzDIHAU4xuPB5hCBRHjLhOUqKiAaV9yeIgWrRL1v1z+avtmpZarTRH1utg/94+HiS9ev+7bbHi6/t/cj9LFpHx77w8X1pvn9+sarbtMNA6o3H8rrd1e12q/+AEMhY4QsHAAA",
    Absorptance: "0.1",
    Area: "124",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "12400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Kalksandstein 11.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Lamelle 11.5",
    "Family and Type": "Lamelle 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "40811",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Lamellen",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Lamelle 11.5",
    "Type Comments": "Kalksandstein",
    "Type Id": "Lamelle 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "14.28",
    Width: "115",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576028",
    Name: "Hall I 70",
    Category: "Rooms",
    temperature: "22.05810852",
    Cost: "283.6969251",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkE8LwjAMxb9LzrU07cb+eBIVBD0METyMHSaWrVBbmVUYY9/dwqYXhwje8vJ7JHnJO8hO6tBeJaSwtSeVWd1W1gCBzCrjbpDm3VB6g0DKIoHzGYYUgziAnkzAAGnEY/47DCOKAv+CUwd9hZ9RilfkRdOUrc/tGytVXqSTDaSMMgI7aSpXj2JvXemUf9Ugj+r8RhupqtpvSSjjXBBYa/kYvVzQJGRIYGm19XPNXeu+eAK+LjndhwEAAA==",
    Pbi3DGeometry:
      "hwYAAB+LCAAAAAAABACtVF1LwzAU/S95zkJu09KPPQ0VBH0YKvgw9tCxsAViIzUKY/S/G7XtJOWabEhpae7JPefe5tyujmS5UU+HV0kqcmc26tFotSWULI1q7BupVsefVwfzubtIR0+RGXA+/364m3TrIW3RtvXB5WY5AwFAZymwPCkSKhJW5klKR0AULINijAtgPBcXxFEBHxgzIGOQFilNBCszDqcMFBiogsCkqgnga0z6A1YWX1Vj/UV/KJ8IVf6/WoeECRBqDq0peNwo1fmHF3ZO0Mx9f5jJ46fCJ0JrPd+zIYnomoJzFG9BPwOligeCbo7uL97msf7HpIPzgvnp0vjfuu6vfq3qF2llSyrOOCX3stnZfb94MLa2yjT98lltR+hWqt3e9osbLT9+b7wy2jjC5l3rbv0JXYx5cocGAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "70",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "32067",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "159.98",
  },
  {
    ID: "576029",
    Name: "Hall II 71",
    Category: "Rooms",
    temperature: "22.44907761",
    Cost: "37.73486598",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzHkpyFpPYkKgh6KCB5KDxVDG4iN1CiU0nc30OrFIoK3nf2G3Z3NOkhP5tBeNSSwdSeTOtuWrgYEqTO1v0GSdUMZDEJiQVQ0n1GBaaQi6NEEjCiWTLHfoeKYS6n+gVMHfYWfUfJX5EXTFG3IHRorU1y01w0kBBMEO12XvhrF3vnCm/CqQR7N+Y022pRV2BJjwhhHsLb6MXoZx7EgFMHSWRfm1ndr+/wJ2jWYi4cBAAA=",
    Pbi3DGeometry:
      "hwYAAB+LCAAAAAAABACtVFFLwzAQ/i/3nIWkaWnaPYkKgj4MFXwYe+hY2AKxkRqFMfrfDdp20nImlVFakvv63XfXfNf1CVZb/Xx8U1DCvd3qJ2v0DgisrK7dO5Tr08/Sw2zpL2jJObLgjC2/H/6GdtPTrpqmOnquFFTkuSSLlNM8kQkRCS3yJCUDICTNuBziWU4zJtP5cVRgDAwMnlGe+kUiaJExfmagQJ8qCEyqmgBjjUl/nBbSE9H+oj/UOBGqfLlae8IECDWH1hQ8bjTV/MMLOydo5q4/zOTxUzFOhNY637MhieiagnMUb8ExA00VDwTdHN1fvM1j/Y9JB+cF89N/43/r+r/6ja5elVMNlIwyAg+q3rtDt3m0rnLa1t32Re8G6E7p/cF1m1ujPn+/eG2N9QnrD2PazRdr0ehGhwYAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "71",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "31931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "158.82",
  },
  {
    ID: "576030",
    Name: "Hall III 72",
    Category: "Rooms",
    temperature: "20.3698083",
    Cost: "342.900594",
    Level: "Level 3",
    Pbi2DGeometry:
      "iwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzEkadI/T6KCoIcigofSQ4uhDcREahSK9N0NtHqxiOBtZ79hd2fzB2SVOnQXCSlsbaUyq7vaGkCQWWXcFdL8MZTeEAc4EoLOZ1RgymMOPZqAnOKIxex3SEmCQ8bD/+jUTd/pZ5ziFXvRtmXns/vGSpVn6WQLKcEEwU6a2jWj2FtXOuXfNcijOr3RRqq68VsSTBgLEKy1vI9eFuBEEIpgabX1c81N6754AjyB0FSLAQAA",
    Pbi3DGeometry:
      "pQYAAB+LCAAAAAAABACtVNFqgzAU/Zc8pyGJsUb7NNbBYHso22APpQ+WhjZgzXDZoBT/fWFTW5S7GCmieHNyzr3XnOv6jFZb/Xb6UChDT2arX02hdwijldGl/UTZ+vz36mC6cBeq8WVlxihd/D7cjepNS7urqvzkuIymZM7FHM8EIwmXHEecpAkX+IJEksRMdoCMSBLHLHwdztBHOgqLCRNSYB6RNKbsigIjrZgfGVQ2APpZBj0ykkpHBHsc/bH6QmDm29XaEgaArzmwJu+Rg1JTjm+Ef/ymbnoE3R4yIAMtuOIp9vWmCajMP1jjHdlnwFohiNffAV2Ot/7YmQCTe4cI9Nd04P/U7p+/1PlRWVWhjBKK0bMq9/bQBC/G5labsgnf9a6DHpXeH2wTPBTq+3rjvSmMEyy/iqLe/AA/9nh0pQYAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "72",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "31931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "158.82",
  },
  {
    ID: "576031",
    Name: "Hall IV 73",
    Category: "Rooms",
    temperature: "19.76079337",
    Cost: "391.878324",
    Level: "Level 3",
    Pbi2DGeometry:
      "jwEAAB+LCAAAAAAABAClkE8LwjAMxb9LzrU07cb+eBIVBD0METyMHSaWrVBbmVUYY9/dwqYXhyDe8vJ7JHnJO8hO6tBeJaSwtSeVWd1W1gCBzCrjbpDm3VB6AyKjjGEyn2FIMYgD6MkUDZBGPOa/UBHSOELxH5286jv9TFS8oi+apmx9ft9YqfIinWwg9XYCO2kqV49ib13plH/ZII/q/EYbqarar0ko41wQWGv5GL1c0CRkSGBptfVzzV3rvngCy7vfdI8BAAA=",
    Pbi3DGeometry:
      "wwYAAB+LCAAAAAAABACtVdFqgzAU/Zc8pyHXKEb7NLbBYHso22APpQ+WhjaQmeGyQSn++8KmtRCyJFJEMZ6ce+7Vc3B9QqutfD1+CFSjR72VL1rJHcJopWVrPlG9Pv3dWpgu7YF6PD1ZAKXL34s9Ub8ZaTdd1xwtF1hBeAkML3IgZcYzzDJSlVmOJ4RxUgCfAKCEUqjmAH4RBzlzoCCQ8xxnjFQFhQuOHxmrRSBOby7i6DiDAqm4pf4zaPxLc2r55a/a8khxkeCU/s4iLOCvNudzRhgq7PRxUG8EElLj1PK3PMfPQZmEzsJJSzGnw/FXS0AirB4/aEoI4uPh1Q8Hyuuz+UBA3P4R7mTzLozoUG23YPQk2r05DItnbRojdTss3+TuDD0IuT+YYXGvxPflxluttC3YfinVb34AcmgFesMGAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "73",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "31931",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "158.82",
  },
  {
    ID: "576032",
    Name: "Hall V 74",
    Category: "Rooms",
    temperature: "21.95477352",
    Cost: "30.79821257",
    Level: "Level 3",
    Pbi2DGeometry:
      "jwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzEkafrrSVQQ9FBE8FB6aGloAzGRGoVS+u4GWr1YBPG2s9+wu7NZD2kpT91VQAJ7U8rUqK42GhCkRmp7gyTrx9IZqBdgxqNguaA+pjziMKA5yikOWcR+oQHHPPT/pLNXfaefifJX9FXbFp3L7xobWVyEFS0kBBMEB6Fr20ziaGxhpXvZKM+yeqOdkHXj1sSYMOYh2CrxmLzMw7FPKIK1UcbN1XelhvwJMjlOM48BAAA=",
    Pbi3DGeometry:
      "wwYAAB+LCAAAAAAABACtVdFqgzAU/Zc8pyGJUaN9GttgsD2UbbCH0gdLQxvIzHDZoBT/fWHTWghZEimiGE/OPffqObg+gdVWvh4/BKjBo97KF63kDkCw0rI1n6Ben/5uLYyX9gA9nJ4sCMbL34s9Qb8ZaTdd1xwtlxQMsTIv4IIRVFJOYUZRVVIGJyTjKCd8ArICUcZnAX4RBzlzSI4I4wzSDFU5JhccPzJWi0Cc3lzE0XEGJajilvrPoPEvzanll79qyyPFRYJT+juLsIC/2pzPGWGosNPHQb0RSEiNU8vf8hw/B2USOgsnLcWcDsdfLQGJsHr8oCkhiI+HVz8cKK/P5gMBcftHuJPNuzCiAzVGGIIn0e7NYVg8a9MYqdth+SZ3Z+hByP3BDIt7Jb4vN95qpW3B9kupfvMDo5lYEsMGAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "70",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "7000",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "74",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "33353",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "173.3",
  },
  {
    ID: "576033",
    Name: "Elevator 75",
    Category: "Rooms",
    temperature: "20.14053516",
    Cost: "78.45843557",
    Level: "Level 3",
    Pbi2DGeometry:
      "vwEAAB+LCAAAAAAABAClkEsLwjAQhP/LnmPIq2rqSVQQ9FBE8FB6qBjaQEykRqGU/ncDfeDVetvZb9hlJm0guepz/VAQw8FddeJMXTgLCBKnrX9CnDbdGAxM4EhysZrRCHMRMWjRFySYzgX/BzIWBil+gAwvF3QCG4JMh2OQbKhqXVV5HfoKi63O78qrCmKCCYKjsoUve3FyPvc6VNzJi76NaK90UYYvEhPGOIKdUe/eyziWEaEINs64cNe+jGmzD7TK/VO/AQAA",
    Pbi3DGeometry:
      "QQsAAB+LCAAAAAAABAClVtFqwjAU/Zc815CkrW3qk2yDwfYg22AP4oNi0UDXDNcNRPz3hdl2tc01ty2iNDmee05yc2+6PJHFRr0dP1OSkCe9Ua86U1vikYVWefFFkuXp8mhgNjMfcvb+Zyacsdnfj/mS86qizQ+H9dFwRUBD6QfehIfUD0Lh+YLKSASeARiXvhW4MASnURxGKAAI5VMWyqmFwWjkxzZXjPJpYAtVAUKYBxmgNACGoHHELfNDJIBlgAxIuyZ0TfWVALPRXp8JIUPGu5veAK7FOwxLKIDRWng933bbAK4PbgewhAKAAdoAAEUCl+2sMicAZql/Mbld3Ug4oHEjTcjNxYgjzydYAyMS5exIfYoDCYxoh6AGdHSR8z26ZAVwKuNY3Oht6GZYRYILuWflYxXcltDdqMuoGncbGHEjo10N6Koujf4LBF3Blxx4pvCu0HZBcfeWtBMFXtZ4YLhdtwb6bcRd49fi5n30Xq0/0iI9kIRR5pHnNN8V+3Lwoot1oXReDt/VtoYeU7XbF+XgIUt/mn+805k2AfPvLDuvfgF/Q4O4QQsAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "3",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "75",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "6860",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "7.71",
  },
  {
    ID: "576035",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "20.62337868",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkMW3SehIVBD0UETyUHloMbSAmUqNQSt/dQOvfydvOfsPM5D1klT52VwUp7FylM2e62llAkDlt/Q3SvB/PYKAJlkKwxYwxLPg8ggF9IONYShL9hzRO+A/8jh1h8apftm3ZhQ3hsdblRXnVQkowQbBXtvbNJA7Ol16H2aM86fMbbZWum9BCCeaJFAg2Rj0mM2WYx4IhWDnjQrC9GzMUT3shzzoUAQAA",
    Pbi3DGeometry:
      "xAcAAB+LCAAAAAAABAClVV1LwzAU/S/xNQtpmrRkexJdEfRhqODD8KFjYQvURmoQxth/N8xat9q73CKlH+npuef2fmW5J4uVfd69GzIl925ln1xl14SShbO1/yDT5f77McB8Fg5yoL9vJgnns+MlnOTw+kO7bppyF7iCsySTKZ0IwXKZKpoIJrNc0LBWUugBoM8Id50p/ZfRAWhGXDxliR6SALV7hM6QCj7lCgF0lkAA8gmSRr6PR0kypVN5BJJMy0FXz4E+AzQ1FI7LGnFTJ2VwGYi7i2aA2YtmA9TGNMZ/I4JuPjBP8UIfXwtQqEZ3K9hKYPpAANv4o6bUuQQ4vkAGqDH+/zDjCFnpmBJBzhH0kIzvGpiwj58jKPGwG97a8s1405ApZ5ySB1Nv/LZdPDpfeuvqdvli1x10Z+xm69vFvDKfpx/euMoFg+RqXhR5kYdd9wt90bZPxAcAAA==",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1525",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.85",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576036",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "19.6617864",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkadraehIVBD0UETyUHloMbSBmpUahlL67gda/k7ed/YaZyXvIKn3srgpS2GGlMzRdjRYIZKitu0Ga9+PpDSKkXEThYiYEjWUQwkA+MGD+95/xKJE/7Dt0hMWrfNm2ZecX+MdalxflVAspo4zAXtnaNZM4oCud9qNHedLnN9oqXTe+hTMqk3lMYGPUYzJzQWUUCwIrNOiD7d2YoXgCqzMY3BIBAAA=",
    Pbi3DGeometry:
      "+ggAAB+LCAAAAAAABAClVtFqgzAU/ZfsNQ1JqtHYp7FVBttD2QZ7KHuwNLQBZ4aTQSn994VONzu9TdIhGuPx5OR6b45Z7tFipZ937wpl6N6s9JMp9RphtDC6aj5Qttx/31qYzuyBDvj3yYRROjte7IkOrx3tuq6LneXymDAuYjzhnCTRNMaMk0gkHHNBJIuEDyBJmjKJB0PZVopYwowpJRETMoABa4BxWCZL2RAYiMOMThwCwuOAGd4aY3HYNhqNwwGMaByBsVmdMPoBngLBGnAcA40O6OXcwXBO9+9Q4KzGCu4U8Na4oBLDU+uqElgcNABwqYH58E+USxxcOBckygcANc67T7h40Ec8nw9wukHF4LcMvPIRXrv/NGTYr4I9EdYA/1E+gJ9ZehmZQzzkf+7lonYPcauLN9WoGmWUUIweVLVptm3n0TRFo03Vdl/0+ge6U3qzbdrOvFSf/RdvTGnsgOhqnudJnti9yhd53h8J+ggAAA==",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1713",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.55",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576037",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.96755152",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NI0tS0dRIVBB2CCA6lQ4uhDcREahRK6X83UK06ub1733F3eQ+y0sfuqiCDnau0dKarnQUE0mnrb5Dl/XgGA01xIgRbzBjDgkcxDOgDGcdJQuL/kM5T/gO/Y0dYvOuXbVt2YUN4rHV5UV61kBFMEOyVrX3zEgfnS6/D7FGe9HlCW6XrJrRQiqngCDZGPSZvRFIEK2dcSLV3Y4biCeRaHsERAQAA",
    Pbi3DGeometry:
      "ZgYAAB+LCAAAAAAABACdVd9rgzAQ/l9ur2lINGq1T6OrDLaHsg32UPpgaWgD1gwXBqX0f1/YnHO20csQxfv53cXvztUJlhv1cnyTkMGD3qhnXaotEFhqVZl3yFan71drZjN7wZn8aiacsdnXw95wXv+E3dZ1cbSxAaM8FiGZBAFNRBgRRkOWEivF0+BS3ffmnIppcMW/NaAjhoFDyqI09gHuRzSJBI3SUIyq2zROg7MiBzBSPXY+nfPkcSquFjpsuOy4q+7n94BFdOsARfb6r8qRTB72dkD6flMMy/4er5Pezgh/gqBHyGvanVUh9wMmlR9xUYtsfD8MUdFrGhHAdl/fqeIgjawhY5QReJTVzuwb4UmbwihdNeKr2rame6l2e9MIi1J+dB3nutQ2Idws8jzJE/tf+AR6r6g1ZgYAAA==",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1525",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.8",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576038",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "22.84486415",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk/aX1VFQQ9FBE8FB6aDG0CzErNQql9N0NVKuevO3sN8xMMUBe47G/KkhhRzXmpPuGDDDICY29QVoM0+kMXshlFIfLhefxOPBDGNkH+sL9/jMZJcEP+w6dYPkuz7qu6t0C91hjdVFWdZAKLhjslWls+xIHspVFN3qSJzzPaKuwaV2LlFzGAYONVo/Z64uEwYo0uVRz13osnw1xplMPAQAA",
    Pbi3DGeometry:
      "mAgAAB+LCAAAAAAABAClVl1LwzAU/S/xNQtJv9J2T6Irgj4MFXwYPnSsbIHaSC3CGPvvhtlp1/amN0rpR05y7znJvbnp6kCWa/W8fy9ISu71Wj3pUm0IJUutquaDpKvD96fp5nNzkSP9RWaC8/npYW5yfD2bXdd1vje2XshEJEM68zwmAz+knPk8oV7EEhFEk7Bk0vMlHXgRggWxBxv4nAUiSvAGMAMwgYTFIhZ9eMALjD6zArizfNgAyzDUb97BiH4bPOL8hI+p6Rp0p3WBuxJA+vv+W7gTW9voKZV9N6CasaS67MBSuKWbWxStqQBRAhsa2D3AwiPjYaUEt8IfooHpADnsZcSdHL10tvUHhaKDjstwVBTccvMf9RSsO251DXQPHSoIHFPuMAXJyos+dKeroDnhb1X+VjRFTVLOOCUPRbVtdm3jUTd5o3TVNl/U5qfrrlDbXdM2FmXx2R14o0ttHJKrRZbJTJo/iS87+Q7ZmAgAAA==",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1700",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.6",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576039",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "20.41822435",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNI0ldaT6KCoIcigofSQ8XQBmJWahRK6X830Po6edvZb5iZoof8pA/dVUEGWzzpHE1XowUCOWrrbpAV/Xh6A0+pTBIxnwlBkzCIYCAfKEIqJYv+Qx6n4Q/8jh1h+apftG3V+Q3+sdLVRTnVQsYoI7BTtnbNJPboKqf97FEe9fmNNkrXjW/hjEoRSwJrox6TWQQ0jRgnsESDPtjejRnKJydO6Q4UAQAA",
    Pbi3DGeometry:
      "ogYAAB+LCAAAAAAABAClVVFrgzAQ/i+31zREE820T2OtDLaHsg32UPZgaWgD1gwXBqX0vy9szrXO1AtDFM/P77678+5cHmCx0s/7NwU53JuVfjKVXgOBhdG1fYd8efi+dTCbugOO5PfJJGJs+nVxJxxff2g3TVPuHTdmNEoFJ5M4plLwhMScZgmLiLPT63gI6DO4oFKm2V9GB6AZ4+KcsiRLQ8T7jM6VoEnGBQLoXHkBb1RecTQwXquT6kZpJgbDvQwMZX4O9DWCxJGZe8XRmf8jD3S3jzO84uHfHNOJ52X3joGXEd4+6FEL2gzeqJC7BOMqvKmRqw+zSy63aNDUosTdrp/pcqesaiBnlBF4UPXGblvj0djSalO35oted9Cd0putbY15pT5OX7w1lXEO4WpeFLKQ7p/yCZqX+z+iBgAA",
    Absorptance: "0.1",
    Area: "4",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1525",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "0.78",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576040",
    Name: "Basic Wall: MW 17.5",
    Category: "Walls",
    temperature: "21.4844239",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNI0qYvT6KCoIcigofSQ8XQBmJWahRK6X830Po6edvZb5iZoof8pA/dVUEGWzzpHE1XowUCOWrrbpAV/Xh6g5CUR7Gcz4SgcRhIGMgHBsz//jMepeEP+w4dYfkqX7Rt1fkF/rHS1UU51ULGKCOwU7Z2zST26Cqn/ehRHvX5jTZK141v4YwmIkoIrI16TGYR0FQyTmCJBn2wvRszlE9NYxAbEgEAAA==",
    Pbi3DGeometry:
      "+ggAAB+LCAAAAAAABAClVl1PgzAU/S/1tWtaWiiwJ6MjJvqwqIkPiw8sa7YmSA0Sk2XZf7dxiGNwodUQPsrp6enl3h66OqDlWj/v3xVK0b1Z6ydT6A3CaGl0WX+gdHU4PVqYzu2Bjvj3zYxROv++2BMdX39o11WV7y03CAmLZIhnQUCk4CEOOElCynAQkYSJyAHgjPBIxLg3FBdEyiiBGZwSwWwHdwasAcaRkJjFrA/0xEFGKw4B/nHADGeNoTjsXQzGMQ4MaZyAgVl1GOcBdgFvDTiOS40WOMv5OGN6updDgbMaKrgu4KzhX4n+qZ2sElgcNABwqYH5cE7UpDi4cP6QKBcA1Bh3H39xr484ng9wul7F4LYMnPLhX7v/NGTYr7w9EdYA/1EugJtZOhnZuLjX/9zJRe0e4lbnb6pWFUopoRg9qHJb75rGo6nzWpuyab7oTQvdKb3d1U1jUajP8443pjB2QHS1yDKZSbtX+QJF37FH+ggAAA==",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Mauerwerk 17.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 17.5",
    "Family and Type": "MW 17.5",
    "Filter Tragend / Nichttragend": "Yes",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1700",
    "Location Line": "Core Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 17.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 17.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "0.57",
    Width: "175",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576041",
    Name: "WC H 76",
    Category: "Rooms",
    temperature: "22.19317124",
    Cost: "363.8206732",
    Level: "Level 3",
    Pbi2DGeometry:
      "+wEAAB+LCAAAAAAABAClkc0KwjAQhN9lzzHktzb1JCoIeigieJAeKoY2EBupUSil726g1YtFBG8z+w27MHtsIT2ZfXPVkMDGnUzqbFO4ChCkzlT+Bsmx7WUIUIGjKFazCZWYC8mgQyNQUCxUHP0OGcNRzPg/MIip4PJ3SBWWitB/4GgJX+FHfdmr5nld503oOgyWJr9or2tICCYItroqfDmYnfO5N+E9vT2Y8xuttSnKcEVhwhhHsLL6MWQZx0oSimDhrAt7q7u1XfYEzqYJpPsBAAA=",
    Pbi3DGeometry:
      "PhIAAB+LCAAAAAAABACtV1FLwzAQ/i95zkKbpF0zn0QFQR9EBR9kDxOLFuoqswoi++8GXbst6fXupoytS77efZe73OVy/yWuHqrbz9dSzMRF81DdNHX1KKS4aqpl+yZm91+/fz2cHPmPWMvtzCRNkqOfH/8V63kndrxaLT69rNYqL7SRE5sq64pcGq3cVFvZA6ZQWVr086lVeV44/jxIEAJewhmXyYl/Y2pNJrVRLkvSraoBoJdIc2cHJUIAl9jncCpz/hkDU1VYgwD7HCCwwwECiEusstZ7NQpHqlxR6O18miljMx0DoKYxiV9rQ4mByNL2TsjQKeIzhJqgeXDVIPVYKIbdQd9rqFUgRxckvgTodDCTO1VRJvMBerUIAgiVKXpdCxWBtobBwCUwCrJNIHUH9MGLCkUX7hAAOfgAyDEE7G/CHUA7axjriLYtyhGlBlliiAM0d3wd/EDBAOfUQACUHK0voK8OB3ByyFx+zsanOJlj4IQI+heUg11Z4eMJ5Bghx80FDzSiKtBcfnKCVo2YC1oVNIHkDRcBFHKkK2Cn2h/IKQWA2LPSgX8MLaf3RgAOOZJRaLdOB8glAwcGrjyHAn8pADgH+YYGZhQ/z/n3RiqAkZObPryXQFv58NaDNoNUAZQBNOmg3gr0x74E2x/AvRS9XGDz47xzKU6rxUvZlisxS1QixWW5fGqfN4Prpl20VbPcDO+qxx46L6un53YzOKvLj90XT5q68QqX73W9nn8D03PQ5j4SAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "17",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "76",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "20828",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "40.58",
  },
  {
    ID: "576042",
    Name: "WC D 77",
    Category: "Rooms",
    temperature: "20.58683776",
    Cost: "201.76688",
    Level: "Level 3",
    Pbi2DGeometry:
      "+wEAAB+LCAAAAAAABAClkcsKwjAQRf9l1jHk2Zq6EhUEXRQRXJQuKoY2EBupUSjSfzfQWrc+dnPnXGaYO9kD0qPZtxcNCWzc0aTOtqWrAUHqTO2vkGSPvgwGTrCgkZpNqMRcSAYdekMmMY1i+Q9kDMeCyy8gx0Sq6B8oKBZqGn0OxxB+h2MI+SvmedMUbcg6NJamOGuvG0gIJgi2ui59NYid84U34T29PJjTiNbalFXYojBhjCNYWX0fvOEcJQlFsHDWhbn1zdoufwKUjvLg+wEAAA==",
    Pbi3DGeometry:
      "PhIAAB+LCAAAAAAABACtV99LwzAQ/l/ynIUmTfpjPokKgj6ICj7IHjZWtFBXmVUQ2f9unWt1zb5dko2xsebr3XeXa767Pn6xm1l5//lasDG7qmflXV2Vc8bZTV0umjc2fvz6/dvC0Un7YSv+tzKSUXSy/mm/bDXpzE6Xy+lnaxtHQssk5yMthc6zhMdK5KnSvAfiTBiZ9esqFpHJE/91SDAEVC4ymUk+UkqkOjY/LnITyS2gtdQ90LsKAiDHNmBaD6nZD2xxqETkUic7LP4BjhaQowOkEbE2iisttFaxDcRS5Fmm/jIPByCHBfThWoAUaWbSnsPJ1XpLLAvM0W2ie1SQA4VL5uGV4O7ShucR4Kqz6E6tZTEEdtUjEIAcFtBpTOcJaYyzWA0dQeaO4fBYre1wTQ7GREoudGVpsT/grveDWrh3IGehQgbDGtHZQQvvmKCn4SkmKchGirOAbdE5b7rDHk4+lEi4uXazds7DOkzIld2TdwDbMgwtyHCtqKBEQg7vI471heTY1048o4I1t3bXGgJ9AP8Kuj2imBxykF3cedzCUZF50AA1e3sARywtOa27A+GPD+Jwkj4CIMldRjr41hEKhMvSQe9CBHAUpYazdyhAknsPgt4TNm6c4e8vQwvMAdJA880hWSALNEpT664jK7W+n3fC2Xk5fSmaYsnGkYg4uy4WT83z5uK2bqZNWS82lw/lvIcui/LpudlcXFTFx/8bz+qqbh0u3qtqNfkG8zcYcD4SAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "16",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1600",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "77",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "20428",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "38.41",
  },
  {
    ID: "576043",
    Name: "Reserve 78",
    Category: "Rooms",
    temperature: "21.05063543",
    Cost: "399.2854761",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkDELwjAQhf/LzWlI0qTaOokKgg5FBIfSocXQBmIiNQql9L8baHWxiOB2777H3b3LOkhLdWyvEhLY2VKlVreVNYAgtcq4GyRZN5TeEHAcCRovAipwyAWDHk1ATjGP59HvkHJMKJv9A6cO+go/o+SvyMumKVqf2zfWqrhIJxtICCYI9tJUrh7FwbrCKf+qQZ7U+Y22UlW13xJjwliIYKPlY/SyEMeCUAQrq62fa+5a9/kTCquxhocBAAA=",
    Pbi3DGeometry:
      "hwYAAB+LCAAAAAAABACtVNFqgzAU/Zc8x5DE2Br7NNbCYHso22APpQ+WhjbgzHDZoBT/fWFTOyJ3iWWIYu7JPedec66bM1rv9PPpTaEC3ZudfjKV3iOM1kbX9h0Vm/PPq4Ppwl2oxZdIwihdfD/cjdptn3bTNOXJ5TJBKONznAhGhMxnOOVEzrnAA5DmJGP5EE8EmWVMTo+DAj4wZLCMpCLjmKdEZpRdMkCgpwoCo6pGgK8x6o8Rmecc7i/6Q/lEoPL/1donjIBQc2BNweMGqaYfXtg5QTN3/UEmj58KnwisdbpnQxLRNQXnKN6CfgZIFQ8E3RzdX7zNY/0PSQfnBfLTtfG/dd1ffanLV2VVgwpKKEYPqj7YY7d4NLa02tTd8kXvB+hO6cPRdotVpT5/b7w1lXGE9UdVtdsvtznK24cGAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "45",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4500",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "78",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "27321",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "112.66",
  },
  {
    ID: "576044",
    Name: "Basic Wall: Lamelle 11.5",
    Category: "Walls",
    temperature: "21.76846981",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk6U+aehIVBD0UETyUHloMbSAmUqNQSt/dSKuCCN5m9htmJ+8hq9Shu0hIYWsrlVnd1dYAgswq466Q5v0ofWBGI0yFiOeUxJjHnMOAftCnYGEQfNEQJ4wFf+inuXhNWLRt2fkd/rBS5Vk62UJKMEGwk6Z2zWT21pVO+emjParTG22kqhv/hhIcioQjWGt5n8IswCIiFMHSauuLzU3roXgADB1EMBgBAAA=",
    Pbi3DGeometry:
      "njQAAB+LCAAAAAAABACtWk1vE0kQ/S/D1WlN94zHM+G0y4dWYg9oF4kDyiEICyyFeJW1VkIo/53OMmPjrnr9qgJCQfG8VL3qj2p3vZp3X5vX73dvvvyzbS6bV/v3u7/3N7sPzap5vd/dHv5tLt99/f5rhtun+V9zvzo9uYht+/T///JPc3+1mP12d3f9JdtexHWI0zSsYjuEfmyHVerCtG7j6gekC+M0TBWki6Eb+vGETP2DM8VkSmHs27VqMa7HpJG0YZq6XpocEcmCnC30rrj0kWzy2GNU5mucwtRtpKf5ufj7YRNSPymTOIxhiFEJNgOp65XhbfKEtGNULXRXi4Ukr0Slky8W9plaADRV5ufQ0XFXd3kZ+3E0LDjiwK5qCEqQ2q7GNjQC+77GAVQyEfNDZ4gfLhnckZh+6EPXDwr7Aoih9Js8x92vSIdKVDB9kS/MjgY4j8MRFbJgFI5jC3mqBNWHaZx8Jv6RI5KHX1Lfdcq+7kO7jsp5ugDCV0rZlbLm3ZgNtDxYAGGRPQ0pKROPKGox6Z7a0KV2VOYwhthvlNNkNhDPL7JFn5KyGfLVI6y1g+loIpEU8vGjnMALoPhqQ0yjitQCQzYw5Lyzk7azj4hiM+8teQTlZF9r+Za+P5AGMe/fjbLw0BMxsDtCmYNjBZ5gGuAcxBwwqhmwZwgMC6bOkiLCAuUUP2RgGjp84dypJAJyxo4H+7lRyxw4lEdEbOBxHDfuiamEjEnQMQS3BY4LbmOUjpWsE8mVb4UPmaAcdSWi2IjJXxBxpB9NxFSWiLCR39YzIL9jCwtBIr7oFgOxw88NhCM4j+IMLgzgVKFY8ayfFteA4DXEC0LXHUdgH2YlALyJMD9zZp5meRpSdpGObLNgV3Bry7OA7XkIQFc4LDgpkMQ/W3xS7GvFFlemKUlflO+ecSNXSokzI7KAnAGpzRQWApBV3BJWWQ8WBvLMlOLAjEg1rjSR8QotaQaEunb+XJlEIbOUiBKWkFnOJ0XOO5pFvIbIFZt3/5pDCwFAC6ni0PH5SSq+2NgdvtBGkQoWT0OyST3TiHKntn9RXDWEenPkNeapTCY7JOynB055tmAo6Tzpi6pSKavCcZwsitYDPh65dlsx0Vlor8Q1En3s+KCv6EMVpFRuDM6g2CMKM3PN8lPOuD6F+ImsYxCUmCMoKAmNhlUzkMLuyaoPmVVMeNnzA4gC1pVMaOYqMPOEZGMpcbHSokZhdcX0NWhREXIiVSZcCOaBki5qlaCrsR9AFJBaNKHg7fBkUfR3YakAOYp+lp0DR4Uus7Vx6COHUbGOvrfmMBQvjLn27gW+lz0Goe94WPIA5w6tdmuiLkVwbA7ty3VvLlfBEfXj7ueONcU7hEbtSDNWaeH+MANg8tvLPFwYslcFHOHaOfzHPfzmYOSwB0MBQ5+HyWj0ouToJcGumFu/dIiRVnLDPQ1elli4uCRggKHtVHA4tHQ7B+mSIa0V9jHMiryN2HwpJ89Rl43XOufPuVRMunjmdj7hhbI5fXnFHKqDglUhsEKgAO7bWkr6ErE0qgwtbap2/KKOHH2FxRW1g+cxtRiu7GgEWC9ggNzMsKfDAKhiGDjOCzv+nCiWOFYrAak0UX+CPJc6qV1dtCrEkMNADi0YOVKhve82219UthHzahVVvYQX19UMEEPD/SYGwGrfwFEU4waAtQ8cfTMruUE7gGoDCxc3CQyIvCtX+kMUUepcB0+pXViQUgn5uV6cPQKL4oJVGhDB1ap5vrv+vD1s75rLNrSr5s/t7cfDp/nDX/vD9WG3v50/vt19OEJ/bHcfPx3mDy9utv/9+IfP9jf77LB58nLz4vdnU3N/9Q360vYvnjQAAA==",
    Absorptance: "0.1",
    Area: "101",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "10100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Kalksandstein 11.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Lamelle 11.5",
    "Family and Type": "Lamelle 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "37189",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Lamellen",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-400",
    Type: "Lamelle 11.5",
    "Type Comments": "Kalksandstein",
    "Type Id": "Lamelle 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "11.58",
    Width: "115",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576054",
    Name: "Basic Wall: Lamelle 11.5",
    Category: "Walls",
    temperature: "19.34997058",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaRvTehIVBD0EETyUHloMbSAmUqNQSt/dQOvfydvOfsPM5D3ISh+7q4IMdq7S0pmudhYQSKetv0GW9+MZDDOGecTZghKOY0E4DOgDeYpZHNP/UCTz9Ad+x46weNUv27bswobwWOvyorxqISOYINgrW/tmEgfnS6/D7FGe9PmNtkrXTWihBAvGBYKNUY/JzCKcJoQiWDnjQrC9GzMUT+w1sqUUAQAA",
    Pbi3DGeometry:
      "ISAAAB+LCAAAAAAABAC1WU1r3DAQ/S/q1Ssk2ZbtzalNUwrtIbSFHsIeNmRJDNt12S6FEPa/10mzrj/0PE8JJSTEHs+8mdFYfjO6elCX1/W3+58btVSfmuv6a7Otb1SiLpt6d/illlcPf/9txeas/VHH5N+dhTXm7OlP+6uOq5Pa2/1+fd/qLqz2ua0Sa7zOSuMTl+oqNzaZCFKrU5+VycJpn3o31bDa5dYH7pe6CiGMnz8BOKtL53JCcLLkcm1zF4Ce+Jpmuih8haNDTvHp6CBQnqAGwh4nULxP2unSBxM+zqsYNHIJQkBLvFOwCmQMpOFKbXJvXyM4eZVlOjdVoGizQmc2DWj41jtjGMEJ3D9mPZARX2hv0kB8E0GnMbLUZQrFPQlPzBROCDKFnIIKk9R2lmAGYaYQNr16slMAgvYpuj5gEOLiIUvwFesHUeZFFazNJ0EAYqjQi24g6EcxrxEqwXlBh5FqWxUuIHC6tFUVEEAMZKqf9KEGwphoyJGPc4WyHiqRoQINEdhbBhC4EhAEXTsdBKgpGN1kkZCl0F40sMSvamcKCpBT8eBtAnLrbAw4Xc9i6eCUQAz4BvRYwnyAnUbrbvpIhiaCHhkYmhoLeqYAxoxXAHysESDJA0s9ojX7fIjODwxNBCGaSiaKXowQASOXj05thwHBoSkkGCddxqbjCxEtChsVyGT5Qq0Pp/EfIWLLXCx/8Dx0lVq6YZsBSzN+n4AYsNOFArizxG+EDDjcXOZbXXFzwQK4TyFwdu4gbZ3wvlyDw/6GoYrDhMOmkmGE0BTJbCEXhg0cY4qLg+5oYTshC1CfwXZXYiMPmTDfscgzAdTaIR4Xz/wgBCJ+eN4Cv3rRH2/ccKJuGhF3gumPgwj7ij+H9IgwyhS5b0aPIeELIL8wVKtErBD32eG/klGj5XkuKBNRhBE9xkVsM5aessDihzOWdDFnCy/sUuS5fPzBBsKA5FS+z50hwIE9CRzBYLgTGGbE/sLmWTxbiJ/vYww4/mAE3FEIdSIwDy5yNIrVxQ/Z5+le1LD0lRN+jAEHdIyAO6nAGjR4FOObJ49wxhlFgcnDDThHjZ/aQwx4KMEI5r2SNWhwmWgz1LwPvkrU+3r9Y3PY7NXSaJOoz5vd7eHu+eJLc1gf6mb3fPm9vulEHzf17d3h+eJiu/ndf/C82TatQfXmQ3Hx7rxSx9UffzbM2SEgAAA=",
    Absorptance: "0.1",
    Area: "62",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "6200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    Description: "Kalksandstein 11.5 cm",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Lamelle 11.5",
    "Family and Type": "Lamelle 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "21909",
    "Location Line": "Core Face: Exterior",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Lamellen",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Lamelle 11.5",
    "Type Comments": "Kalksandstein",
    "Type Id": "Lamelle 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "7.13",
    Width: "115",
    "Wrapping at Ends": "Exterior",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "576055",
    Name: "WC H 79",
    Category: "Rooms",
    temperature: "22.15999187",
    Cost: "318.7089759",
    Level: "Level 3",
    Pbi2DGeometry:
      "iwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzEkqU2behIVBD0UETyUHloMbSAmUqNQSt/dQH/wqt529ht2dzbrIC3Vub1LSOBgS5Va3VbWAILUKuMekGTdUHrDgmPBYrGiNMKCcAo9+oCU4IDH/D9KIkzCZfQNnY76Hc4n5VPsddMUrc/uG1tV3KSTDSQEEwRHaSpXj+JkXeGUf9cgL+o6o71UVe23CEwYCxDstHyNXhZgERKKYGO19XPNU+s+fwOpkI8viwEAAA==",
    Pbi3DGeometry:
      "5w0AAB+LCAAAAAAABACtl11PwjAUhv9Lr2vTdmUfcGXUxEQviJp4QbiAsECTuRqcJoTw360KDFbOeroZAqE8e/uenvWclcmWjOf6ZfOekyF5MHP9bAq9IJSMjS6rDzKcbP++WsxH9kV2tP7lSnA++v2wb7KbHmTX6/VsY7UWsShOYypEwjIeCxpJliVS0ZrwhPGBSmoSs0ymWRcAmzgkYSITkQWSqTgVVEYsG3BxBlI1UDU4mjQVJwCpAD3qeJuSU+JoxM/SuhLYB1hmM5VNIBVTSkYXst+F9LnJbtJcm8MyLxFI443A1Th7FhHBQRMSdYtPn+zA2wPOW5dNHbAeJzvN9hAO/qM5OYnx1w2k8JoHeZwnGCxatCJg5V4AtlIwqhAF2HwDw4Xr0SFek7DabjTrHv6tzQW2QZDz9PuzjN54ztPS/xQBTRBz4V1Qq3cmAySwTdu9DPUPLzDwrIIH3e8wxsNT3d6yx5iDCrB9dQX4AkYQ1HEPTXp2KoRP94Ntn1bV6oM40/iILwL7r+lWz97yKl+TIWeckse8XFar/eDJVLNKm3I/fNWLI7rP9XJV7Qd3Rf51euGNKYydsPwsit30G9H6HGHnDQAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "3",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "79",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "8712",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "9.02",
  },
  {
    ID: "576056",
    Name: "WC D 80",
    Category: "Rooms",
    temperature: "21.71814705",
    Cost: "154.7551926",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkEELwjAMhf9LzrWkq93YPIkKgh6GCB7GDhuWrVBbmVUYY//dwqYXhyDe8vI9krxkHaSlOrZXCQnsbKlSq9vKGiCQWmXcDZKsG0pvmHEaMOQLhhFFMY+gJxOQRTTGkP0AQyoEC/+Bkwd9hR9R8lfkZdMUrc/tG2tVXKSTDSRIkcBemsrVozhYVzjlXzXIkzq/0VaqqvZbYopBwAlstHyM3oDTWCAjsLLa+rnmrnWfPwGcrpW/hwEAAA==",
    Pbi3DGeometry:
      "pQ0AAB+LCAAAAAAABACtV1FrwjAQ/i95jiFJ09bq09gGg+1BtsEexAfFooGuHa4biPjfV6ZWbXq9i4ooxs8vn3e5+3KON2w0s+/rr5QN2HMxs29FZueMs1Fh8/KbDcab3dsKlsPqwbb8+ElPSTn8f6mebDs50O5Wq+m64vYCoZUMuFKxSGSkeKBFEmvDe5EIQxV1ADIWMjQxAThogICjEYggNqYCtOib0HAdiCSU6oThAjXDRH3VymgCOONco06JC+h+orqBc40OoNYAgfaUwNk9bGWEMTroTDvCQI/WS2MXB8RwAYzhETkKgMUA/iofBqABxtFMSbM5/QG8B1EDcAJ0arcFABiYuMMA3QcUd0qUzLhlSsA+B3Pl7wzkOMCuvRyg3AYN3yU3Z8sJNlz0yEA0fIoB0PBPYkclghp4gE2TwbLrYa+AhnPdETTArYjOcIU4yKBogOdBzNUl9wc4+1CBy4+WokEeo8BK9K9d/+GOCqDiFKcmD3dU4BpbwjX8p1fQAIj90aGBX3cIgIhX/3ke7PQzLdMVG0ghOXtJ80W53C9ei3Ja2iLfLz/svIaeUrtYlvvFY5b+nn7xvsiKasP8J8u2kz+rm3nmpQ0AAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "3",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "300",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "80",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "8652",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "8.76",
  },
  {
    ID: "576057",
    Name: "Anteroom 81",
    Category: "Rooms",
    temperature: "20.4691376",
    Cost: "387.4945133",
    Level: "Level 3",
    Pbi2DGeometry:
      "jwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzEkadOQehIVBD0UETyUHiqGNhATqVEope9uoD94ld529ht2dzbvILvpS/tUkMLR3XTmTFs5Cwgyp61/QZp3QxkMK0qwiLlcUyqwJAmFHv3SGCeM82WUCEx4LP6i01VL6HxVMUXfNE3ZhvyhsdPlQ3nVQEowQXBStvL1KM7Ol16Hlw3yqu8zOihd1WGNxISxCMHeqM/oZRGWnFAEW2dcmGvfxvTFFybg3/iPAQAA",
    Pbi3DGeometry:
      "aQQAAB+LCAAAAAAABACtk8GKwjAQht9lzjFMamNoPYm7IOhBVNiDeKg0aCDbLDUKIn13g3a3UjfYqoSETL78+YdksjzBdK0Wxx8JMYzNWs2NVikQmBqV2R3Ey9N16jD2XYOCVCsdhti/DK5DsfqVDfI8OTpth4W0F3BOGBM0wh4j3YBGIghJRVBQ5KG4IUhFyKPniN/nntQ1QZdGHNk/PhWpZ92G+H0ekyZZ+32ak9du9LHPKzfaJgO/5t7H/9rNyXvr+pkKaVM7tQzcv/1Qybe0MocYKRKYyGxjt2UwMzaxymRl+KXSPzSSarO1ZfCp5eF249Bo4w7M9loXqzN/+7ISaQQAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "4",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "81",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "8980",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "10.76",
  },
  {
    ID: "576058",
    Name: "Hall 82",
    Category: "Rooms",
    temperature: "22.91050238",
    Cost: "397.8596115",
    Level: "Level 3",
    Pbi2DGeometry:
      "wQEAAB+LCAAAAAAABAClkMsKwjAQRf9l1jHk0da0rkQFQRdFBBeli4qhDcREahRK6b8baHVjEdHd3DmXedyshfSo9s1FQgIbe1Sp1U1pDSBIrTLuCknW9qU3TBiOeMRmlAeYckGhQyOQCkxjzn6AJMIinMbfQ8b9HYH4B4698hG+h5A/w5rXddH4xHxjqYqzdLKGhGCCYCtN6apB7KwrnPIh9/KgTi+0lqqs/JYYE8Y4gpWW98Hrj4pDQhEsrLZ+rrlp3eUP9pcDY8EBAAA=",
    Pbi3DGeometry:
      "yQcAAB+LCAAAAAAABAClVV1rwyAU/S8+W/EjSTV9GmthsD2UbbCH0oeUSitkcWRuUEr++9yWj5EgakZIiB7PPd57vdfdFWwP6vnyJkEO7vVBPelSHQEEW60q8w7y3fX318J4ZR/QwGFmQTBe/XzsC5p9R7up6+JiuQuKMpZRSFiCCOMEMorEkiZwADBKqRgAyuzChM8CnBojoGfgDPF0Kb4nRIrJwHAChCMiGI0AOvEOmGzXa8rJ8PvRx4ogwTl1hz0iURNToX74GV6N8F15EzVheA+DUyMe8B44Z2ongNOPeCBcfBx2Zw1GlPPYlFs8tAzCNaZ++Bx07srblvwNYD4Q3hPHR/QfIYmvj2CN8DqPyKCz9c0HPOL2Xlyr4lUaWYMcIwzBg6xO5twOHrUpjNJVO3xRxx66k+p0Nu1gU8rPvwtvdamtweqjLJv9F4bEKJPJBwAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "65",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6500",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "82",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "32319",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "162.61",
  },
  {
    ID: "576059",
    Name: "Hall 83",
    Category: "Rooms",
    temperature: "21.67838629",
    Cost: "228.3718836",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzyHkp9WmnkQFQQ9FBA+lhxZDGoiJ1CiU0nc30OrFIoK3nf2G3Z3NO8gqfWyvElLYuUpnzrTKWUCQOW39DdK8G8pgYBzHlNEF5RGmPKHQowlIZjiJ5+J3GDGcUCH+gVMHfYWfUYpX5GXTlG3IHRprXV6klw2kBBMEe2mVr0dxcL70OrxqkCd9fqOt1KoOWwQmjHEEGyMfozfsFTGhCFbOuDDX3o3piycfL5MRhwEAAA==",
    Pbi3DGeometry:
      "nQYAAB+LCAAAAAAABACtVNFqwyAU/Zf77ERNsmr6VLrBYHso22APpQ8plVZwcWRuUEr+fbKlzaiIWkpIyPV477n35MTlARZr9br/kFDDo1mrF6PVBhAsjGrtJ9TLw9+rg8nUXdCjceWGEjL9fbgb+tUxbdZ1zd7lsgJXlFFEixLTglNUMCwmrEQjQHDFxAiUDHMqxEVAkCMGuAVREeqX8gByi3k1EXHgxBEEzjl8SSgWnLOwVhnqeqVC5NdsN7urqIjHjPTvEeTIB9LNcD5g0KIZbk+ePN+7UQ5/jtiAwa6if22wVIITY0DGkRGzaLpWySIGyRNkD54MlwMRcnfW36nmXVrZQU0wQfAk263dDcGzsY1Vph3CN7U5QQ9SbXd2CO61/P6/cW60cQXbL6371Q8uq9IsnQYAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "49",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4900",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "83",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "28358",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "121.83",
  },
  {
    ID: "576060",
    Name: "Hall 84",
    Category: "Rooms",
    temperature: "21.91818738",
    Cost: "437.0339106",
    Level: "Level 3",
    Pbi2DGeometry:
      "MQIAAB+LCAAAAAAABACl0ckKwjAQBuB3mXMIWbqk9SQqCHooIngoHiqGNhAbqVEope/ugMulIi63TL4hgf/PO8h2Zt0eNaSwcDuTOduWrgYCmTO1P0Gad7cjLkSKJjwacRZRFcYJ9GRoglGhgvhzk2hh/BcqymXAf0AZIKovMJCUJ7H4B1+F9xYHqW8f5YybpmixIbyYmuKgvW4gZZQRWOq69NV9WDlfeIOl3saN2T9prk1Z4ScJZUJIAjOrL/ddgTmEjBOYOOvw3fpsbb+9AtqOA3AxAgAA",
    Pbi3DGeometry:
      "DwoAAB+LCAAAAAAABACdVk1rhDAQ/S8525DEr+ielrZQaA9LW+hh2YPLym7AmmJtYVn87w2tqyVhmEREMfMy782o83B7IZu9ej1/1KQkj3qvXnSjDiQiG63a/pOU28vfrYHZyhxkiObIDWds9XsxJxl217R111Vnk5vElBe5iHicUB5LHsWCmnUSzQCjqShmIItpwdN8EQBqYIAwFCnjLpUDCGmAZAZwKjtjBhgVMslnQBogg+MsozLNCw8iCJiKtanALsAMtAsnAenuGo85LaQUDk9oHNX1fnq2wtJ4gDL4yYzAJAHW6g34i09zZ1PZ4xUwwk5VoHjweKEabh9Yg2BVqBWBVPjkoUCAD1oNgiYcYNsOla+DeDSIafhXBYqH2oi9HyTyB/x93vfDBZ+Hhy1YGguoEIO29/u/vOXSUAIuAXsCODLLAUTc/F3dqeq97uuOlIyyiDzV7bE/jYtn3Ve90u24fFOHCXqo1fHUj4v7pv7+v/FWN9oQtl9NM+x+AA/uNakPCgAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "59",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "5900",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "84",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "32266",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "146.01",
  },
  {
    ID: "576061",
    Name: "Hall 85",
    Category: "Rooms",
    temperature: "20.52246613",
    Cost: "100.1877454",
    Level: "Level 3",
    Pbi2DGeometry:
      "twIAAB+LCAAAAAAABACl0k1LAzEQBuD/Muc45HOTWU+iQqEeFhE8lB62NGwDcSNrWlhK/7uBVi+uQt3bTJ5hcph3dYRmE17Gdw81LNMmNCmOXeqBQZNCnz+gXh3PZRm40QIVWXErlEJDlYUTm1JukHMtr1TnSM9S0uiMuwaFQUFUzUDBK7SVtf9S4Uqhfts8rRpJSDNPJ6/3t/68/PorInfD0I4lJ+XhIbRvPvsBao6cwZPvu7y7NM8ptzmUaJ3b17D9poUP3a58Q8ilVAweoz9cZqVCMlwwuE8xlb39PsbT+hPu13SNtwIAAA==",
    Pbi3DGeometry:
      "7BAAAB+LCAAAAAAABACtV99LwzAQ/l/y3IWkv7M9iQqCPgwVfJA9bKxshdrKrMIY+98tuq61yeUunYyta75+910ul7v09cDmq/x5/56xKbuvVvlTVeRr5rF5lZf1B5u+Hn7/NrCYNR929LqRiRRi9vPTfNlx0dKudrvlvuFOQskDlUhPBgGPVJx4gc9V4ofeJEh5LNK4QQSPfCU7RIZcST8ycDqEzoF1zr6JiAsR+jpHhTyNUgNgNJamKjQYaxHN2Ah9mHKBiiUy8ArItHmkNx5xqVRsHZcq8ElITwNG+irDyfsBV5GQhlXpI3/DckZax0zGEIoUMU/iJLlUxjwZLWK6SrteHWe4LwjWRs1muGYUnRG+wR7AMYCzmcBxSBzr5sQ8gDkmHTipqYhDSSEgePKSAYK8Vh4lV2lztdZNswhoCt2F9BmSNXCvQPEhoDH0zawhoIo7QKglhPpzrv/gZMYgLpXJpWvhXuPImHraWYM5zh2VztDUR53aWsQ0F6OKpZvYbMFxsaq4eIz3YPjU+j+zcdBx6JqEfmrxAN+fWj6jZV4PDlo4HVToJdWQA5BjhvUcnJzdqkafMUID3ctwluMI/p7hglwSY1wHb8Hkw4c9/FhrcHmhso2PTyNQgdAqbON23YXHbvLlW1ZnOzYVXHjsISs39fZ081jVyzqvytPtS74+Q3dZvtnWp5vbIvvqP3hdFVVjsPwsiuPiGwwEEjfsEAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "95",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "9500",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "85",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "40039",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "238.31",
  },
  {
    ID: "576063",
    Name: "Preparation 86",
    Category: "Rooms",
    temperature: "21.64118869",
    Cost: "442.5964423",
    Level: "Level 3",
    Pbi2DGeometry:
      "eQIAAB+LCAAAAAAABACl0j0LwjAQBuD/cnM88tG0TZ1EBUGHIoKDOFQMNRAbqVEoxf9uwOpiEdQtl+e4g7zZtJDvzKo5achg7nYmd7YpXQUEcmcqf4Zs0z6OoWHABHKZqCETETKRMriRXhUoVZx8pREqxuV/ylKMUiq+UopSJvwnjTGJ6E8YnoJR8Q/2BvAR37PbPkMe1XXRhKTDxcQUR+11DRlFSmChq9IfumLpfOFN+ByPcm32L5ppUx7CGoWUc0FgavW16+UClaSMwNhZF+ZWF2tv2zuEv2K6eQIAAA==",
    Pbi3DGeometry:
      "jQsAAB+LCAAAAAAABAClltFqwjAUht8l1zHkJK1t9Gpsg8F2IdtgF+KFYtFA1wzXDUR894VNrSQ7JqlIpemXk/8/aU7S6Y5MFvp1+1GREXk0C/1iar0klEyMbtpPMpru/m4t5mP7I3vaPRkA5+PfP3uR/ewYdrPZzLc2dgCSibxQFKRkuRoWVAqmCpHRgQXApQUZA1lCB7oQnLiDQcYUiNwSznKh4B8ZF+AhMTIeCeeJOvPStD3zQlCAkmWl7SIkUzmHM32fuPoncpTxQoasyPh/Kq6xTgQ3hsqjKmHHnn4Px6iIt8r8Sb4Q45GIFxNc50mug+S6egpneg3pVdHAVFmKi4WL60SMlvBOIzIN6qR4C28EXQxeoy7BdfqQiF0CrV8X4Nn0IfH7RxCcRFDH0SBe3FsX6MkRPmuwoeK31P52vSmJThB1FT5MI46GK0iCvpsjulDSp+vCDtKn5sMx6ckkOAuvioRPuQQS0Lfftnd6/l611YaMOOOUPFXNql0fGs+mnbfaNIfmm16e0EOlV+v20Livq+/zjremNnbA5quu97MfX8uO140LAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "17",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "86",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "16679",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "42.65",
  },
  {
    ID: "576064",
    Name: "Hall 87",
    Category: "Rooms",
    temperature: "20.32193341",
    Cost: "445.622752",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkDELwjAQhf/LzTEkbVqSOhUVBB2KCA6lQ4uhDcREahRK6X830OpiEcTt3n2Pu3uX95BV6thdJSSws5XKrO5qawBBZpVxN0jyfiy9YcEo5lywpWCYcSJgQDMw5jimNPoB0ghTIeI/4OxBX+FHlOIVOW3bsvO5fWOtyot0soWEYIJgL03tmkkcrCud8q8a5Umd32grVd34LQKTIAgRbLR8TN4gxCIiFMHKauvnmrvWQ/EEFBd3I4cBAAA=",
    Pbi3DGeometry:
      "0QkAAB+LCAAAAAAABAC1Vl1rgzAU/S95jiHxa4l9GttgsD2UbbCH0gdLpQ04M1w2KMX/vtDpKs2uibZTFOO5Nyc59yS62KP5Sr7s3guUoQe1ks+qlGuE0VzJSn+gbLH/eTQwnZkTNfj4JmCUzg43c6Fm2aVd13W+M7lBxElKeYpFTGJOBY5CIq7CGAcxI5yLGAZSk8lY4gF0HCBgcbCEMCH+BsI0puJ4eMVYzJ4xh0GAgFOzMCIioczOsICOww2cqmwBFoezkmDGeHLQFBY5aAp/GzEiOA+HC3WWEzoCkBnUY3z5vDlGjdzbX6Dr+xnThZpEN7xknIDXQvbZTcZvRae1A93vBnoKOulAaYZ6BcUcTeeexAX3qP+ZEtgr6Owhy/ssTx+Vp/Qz1exnxYwZs1Nq/0+GP+AgN/9HtzJ/K3RRo4wSitFjUW30tm08KZ1rqaq2+SrXv9B9ITdb3TbuyuKrH3ijSmU6rD7Lsll+A6nvKtvRCQAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "87",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "31998",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "159.57",
  },
  {
    ID: "576065",
    Name: "Chemistry 88",
    Category: "Rooms",
    temperature: "21.31807347",
    Cost: "466.6222006",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzE0Py1JPYkKgh6KCB5KDxVDG4iJ1CiU0nc30OrFIoi3nf2G3Z3NO8hO+tBeFaSwdSedOdNWzgKCzGnrb5Dm3VAGw4wTLITk80RgyjiFHk1ATjFLuPgBkhgTKZM/4ORBX+FHlOIVedE0ZRtyh8ZKlxflVQNphCMEO2UrX49i73zpdXjVII/6/EYbpas6bJE4opQhWBv1GL2UYRlHBMHSGRfm2rsxffEEmBlDe4cBAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACtlt9LwzAQx/+XPLchP9qabE+igqAPQwUfxh46FrZAbaRGYYz+75bZall2SSqjtDT95O6b3F2OLg9osdYv+3eFZujBrPWzqfQGJWhhdG0/0Gx5+HntMJl3F2qTvy8pJWR+fHQ3aleD2XXTlPvONuUCF0QUSSEw4xlLOMPyimVJmlEshMxgkDHMi0xEgEEDBI4GzTGV8jzgOc1h4Gj4wFEDBMGQMI5lTqhr4YBBIwxOg+gARyOYKNBiujiYc0cczHl8lVAshWD+REXmfHAFaoA7n56oaI3wcqPLByzqscXEkPxLw38MgiDqcIINILJlnOYDrN0wGMXqvAa4c58rMFZxGuHlXrCXXHAfoCuwRH21C54oMIh+i0mVGAmC4sGQxPfdeBAQ7/4hbnX5pqxq0IxgkqBHVW/trh88GVtabep++Ko3v+he6e3O9oO7Sn2NJ96YynQO68+qalffCfrehfUIAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "64",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "6400",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "88",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "31998",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "159.63",
  },
  {
    ID: "576066",
    Name: "Physics 89",
    Category: "Rooms",
    temperature: "21.06912388",
    Cost: "269.2552935",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkMsKwjAQRf9l1jGk6cOmrkQFQRdFBBelixZDG4iJ1CiU0n93oNWNRRBX8zjDzL2TdZCW6theJSSws6VKrW4ra4BAapVxN0iybkhxYBZ4NI5FsMAo4nkIPZmAnNOIc/8H6IXUEyL6A04K+go/rOQvy8umKVr0jY21Ki7SyQYSRhmBvTSVq8fiYF3hFL5qKE/q/EZbqaoarwjKUDGBjZaPcZb7VITMI7Cy2uJec9e6z588yh4nhwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACtll1PgzAUhv9Lr0tTyldhV0ZNTPRiURMvll2wrNmaIDWIJsvCf7cqKK4cWnAhENqHc972fDSsjmi5kY+HF4EydKs28kEVcoswWipZ1q8oWx2/XzWmC32hBv/OeD6li6+HvlGz7swuqio/aFsv4CSmPMahT1KeRDhgJE1YiD09wXkawoAxEjMWOIBOAwSGhh8RP02HQRAmHLYwNDqLITBuYQ0JC0gaUd9crgE6DTs4DaIBDA1rokCL6eJgzg1xMOfuVfLpkrOZqf0LOlegBrjz6Yly1rAv17l8wKLuW0wMySyN8Tawgn80p/uRcZoPsHbtoBerYQ1w52OuwFi5adiXe8az5Iz7AF2BJTpWu2BHzRR3P+HcgVXcuo9J/eEILOL6H+JK5s+iFhXKKKEY3YlyV+/bwb2q81qqsh0+ye0PuhFyt6/bwXUh3vsfXqpCaYflW1E06w9ptwvD9QgAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "48",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "89",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "28033",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "119.49",
  },
  {
    ID: "576067",
    Name: "Auditorium 90",
    Category: "Rooms",
    temperature: "21.23957256",
    Cost: "336.0070281",
    Level: "Level 3",
    Pbi2DGeometry:
      "hwEAAB+LCAAAAAAABAClkDELwjAQhf/LzWlI0tYmdRIVBB2KCA6lQ4uhDcREahSK9L8baHWQIojbvfsed/cuf0BWqUN3kZDC1lYqs7qrrQEEmVXGXSHNH0PpDUFEMecimgtMeRJCjyZYQAmmjCe/UBpjKsTsLzp10zf2maV4RV60bdn53L6xUuVZOtlCSjBBsJOmds0o9taVTvlXDfKoTm+0kapu/BKBCWMhgrWW99HLQixiQhEsrbZ+rrlp3RdPSCArPocBAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACtVlFrgzAQ/i951pBEWxP7NLbBYHso22APpQ+WhjbgzHBuUIr/fWHTTtQziRuimO/L3Xe5u4Rszmi9U8+nN4lSdK936knnao8CtNaqqN5Rujn//BqarMyD6uAXCSkhq++PeVG9bc2uyjI7Gdsw4nhJ+DIQmPIkCiKGRcLiIIwp5lzEIG58Ysp44sK0GjDTV6ELTIUYxVnEKDh/qNBajDIWG0tOWITFgtBBtAP8ouDADLI4YPoqtkpB8+dow1Xvq8M19+kTigXnbHZ9e0zrDdaBMzCnYh46DlF7dBPc410b7+zM1JncGxb8D7vV9Qzp1wTqZBveydKof2jFE36gDLn4t8b5X+eJb/yT/QX3PrTmURyKCda2Wbifbz6MTd2eEa/94ITbtM0d4kZlr7KSJUoJJgF6kMWhOjaDR11lldJFM3xR+wt1J9XhWDWD21x+dide61wbh8VHntfbLzrEcN/1CAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "48",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "4800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "90",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "28024",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "119.13",
  },
  {
    ID: "576068",
    Name: "Auditorium 91",
    Category: "Rooms",
    temperature: "20.09029884",
    Cost: "480.8657003",
    Level: "Level 3",
    Pbi2DGeometry:
      "PwIAAB+LCAAAAAAABAClkc2qwjAQhd9l1nFIpok3qStRQdBFkQsuxEXF0AZiIzUKRXx3A/5slAted3PmO8zAOaszFBv32+0t5DALG1cE31WhAQZFcE08QL4638Zk6AmJmkgNelLgD2mCC3tHhUKSWfYRVSiM6X9JJSpN8n+Uo+L9D2CKQGsjv4FvU/ybvjawflQ1bNuyS32lxdiVOxttCzlHzmBumyrWd7EIsYwuVXyTS7d9oql1VZ3eGOREGYOJt6e7lzI0igsGo+BDutscvb+sr7FBXmY/AgAA",
    Pbi3DGeometry:
      "pQwAAB+LCAAAAAAABAClVt9rwjAQ/l/yXEOSNjXVp7ENBtuDbIM9iA+KRQNdM7puIOL/vtD1h7S95loRxeTLd99dcnfJ+kxWO/1++orJgjybnX4zid4Tj6yMTvNvslif//9amC3th1y8ZmbGGVsWP/ZLLpuKdpdl25PlznhAlRDSmwWczoUSni9oNBeBVyDSAr6ikqtm3o5DpsIuABGGJQqESyoC328Qu1SpKOjhgPI1hTMqWTiGATs2wuUqfBC43eEaaDPapoRPI8l44QyPonAICKhU1kaNIGy1KQ1Sxt4g7e3qItUWY6yBSOco3eHAFEQ4XY47Y2DOlG3rTbPhSq4pnEbKLhhOWWSWX9sCXJ6YHTgZhGf4fOrhwLleIrDOFGRUtTmKHY5mCuLW77Snypa70zmBrltQOaNbIFqjBtABgl65m/+EfjUCGaEPU9zN76aGOXAtg3UEnkznLnVnPiIvoEYKi4AOtykIdbhU2xR0S3RHgpxHv4bG3Sx90u4zH/+wcgLTE27Suxkz71C2b/4Hvf2M8zgjC0aZR17i9JAfy8Grybe5Nmk5/ND7GnqK9eGYl4PHJP69XnhvEmMNpj9Jctn8AX8YYyilDAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "78",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "7800",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "91",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "35512",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 3",
    Volume: "196.95",
  },
  {
    ID: "576071",
    Name: "Floor: FB 15.0 - Fliesen 50 x 50",
    Category: "Floors",
    temperature: "21.99402238",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQtTfRMjc2NrXXNjfVMjAzNlWp1ELJESWKT08WQjIVZ71hUlFgJdANQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhvCDc9MgUt5pGamZ5SAOCaWRoY6Sq45qWVQtYZGeiZm5kY6Ss75OflAc/NKc3JqYwGZyn/aEwEAAA==",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "422",
    "Calculated Heating Load": "42200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "3800",
    "Elevation at Top": "3950",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Fliesen 50 x 50",
    "Family and Type": "FB 15.0 - Fliesen 50 x 50",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "336382",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Decke - Estrich",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Fliesen 50 x 50",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Fliesen 50 x 50",
    "Type Image": "<None>",
    Volume: "63.25",
  },
  {
    ID: "576122",
    Name: "Floor: FB 15.0 - Fliesen 50 x 50",
    Category: "Floors",
    temperature: "19.24943569",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQtTfSMTIwMrXXNjfUMTQ0NlWp1ELJESWKT08WQjIVZ71hUlFgJdANQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhvCDc9MgUt5pGamZ5SAOCaWRoY6Sq45qWVQtUbGepamBkAx5/ycfKC5eaU5ObWxAMFRnsMTAQAA",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "432",
    "Calculated Heating Load": "43200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "7300",
    "Elevation at Top": "7450",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Fliesen 50 x 50",
    "Family and Type": "FB 15.0 - Fliesen 50 x 50",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "330488",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Decke - Estrich",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Fliesen 50 x 50",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Fliesen 50 x 50",
    "Type Image": "<None>",
    Volume: "64.73",
  },
  {
    ID: "576198",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "19.17074893",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnSN9MyMTMytdQ0N9UwtTEyVanUQkkTIYZPSRZeLhVntWFSUWAm0HyjgkpmYm1qSWqRkZaBnoKPkk5qXXpIB5QTllySWZAKdDOGGZ6bApTxSM9MzgJYYAu0wNTDRUXLNSS2DKzY2sNRRcs7PyQcam1eak1MbCwDrfsx8DgEAAA==",
    Pbi3DGeometry:
      "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",
    "Actual Number of Risers": "21",
    "Actual Riser Height": "176",
    "Actual Tread Depth": "282",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 1",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "21",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 2",
    "Top Offset": "150",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1600",
  },
  {
    ID: "576328",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "20.94386938",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnSN9MyMTMytdQ0N9UwtTEyVanUQkkTIYZPSRZeLhVntWFSUWAm0HyjgkpmYm1qSWqRkZaBnoKPkk5qXXpIB5QTllySWZAKdDOGGZ6bApTxSM9MzgJYYAu0wNTDRUXLNSS2DKzY2sNRRcs7PyQcam1eak1MbCwDrfsx8DgEAAA==",
    Pbi3DGeometry:
      "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",
    "Actual Number of Risers": "21",
    "Actual Riser Height": "176",
    "Actual Tread Depth": "282",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 1",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "21",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 2",
    "Top Offset": "150",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1600",
  },
  {
    ID: "576464",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "21.9733437",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjsEKgkAQht9lzuuypS5pJ6kgqINE0EE8KC06sO2EbcEivnsLlkEE3eaf72e+KXrIazy6q4IUdlRjTto1ZIBBTmjsDdKiH0dfCEK+iKNkGUiexDKEgX3Yf/SDBF+ofGuzrqucd/vFGquLsqqDVHDBYK9MY9tXOJCtLPp3x3jC84S2CpvWO2ZzLmMRMdho9ZjKoUgYrEiTP2vuWg/lE8rmWFEKAQAA",
    Pbi3DGeometry:
      "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",
    "Actual Number of Risers": "21",
    "Actual Riser Height": "176",
    "Actual Tread Depth": "282",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 1",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "21",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 2",
    "Top Offset": "150",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1000",
  },
  {
    ID: "576548",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "21.88698726",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjsEKgkAQht9lzuuypS5pJ6kgqINE0EE8KC06sO2EbcEivnsLlkEE3eaf72e+KXrIazy6q4IUdlRjTto1ZIBBTmjsDdKiH0dfCEK+iKNkGUiexDKEgX3Yf/SDBF+ofGuzrqucd/vFGquLsqqDVHDBYK9MY9tXOJCtLPp3x3jC84S2CpvWO2ZzLmMRMdho9ZjKoUgYrEiTP2vuWg/lE8rmWFEKAQAA",
    Pbi3DGeometry:
      "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",
    "Actual Number of Risers": "21",
    "Actual Riser Height": "176",
    "Actual Tread Depth": "282",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 1",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "21",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 2",
    "Top Offset": "150",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1000",
  },
  {
    ID: "576632",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "20.47214261",
    Cost: "0",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABACFjsEKgkAQht9lzuuyaspqJ6kgqINE0EE8KC06sO2EbYGI796CZRBBt/nn+5lvigHyGo/9VUEKO6oxJ903ZIBBTmjsDdJimEZX8BY8lNJfejFPojiEkX3Yf/SDeF+ofGuzrqt653aLNVYXZVUHqeCCwV6ZxravcCBbWXTvTvGE5xltFTatc/gB9yMZMNho9ZjLoUgYrEiTO2vuWo/lEyIPcnYKAQAA",
    Pbi3DGeometry:
      "nc4AAB+LCAAAAAAABACtXV2L7MYV/C+T141Qq/V5/WQSm0DyYJJAHsx9uMaLveB4g3MJGOP/HkmjmR21uk7V6RUhiV19VKe6zpFGox11f/vb5ZvvXv7563+eLx8uf3397uUfrz+9fH95unzz+vLz5/9ePnz72/Uf5+H6i/k/l9+f3pA/hrr+Yv2f+b+X3z/eDvvyl18+/TofO4xVbMf4FMJUNW1onupqrEN42uFT3UI8VE03Nhq+8CP8xt9W7RTbI0+K5+IRj4UjfqZf4VH0KP57fbP8ZLhSd6VP1Lwe/y2c9aeSV6mvUhfAH9pmmPHY9f0uPos3dRXGPlL8xo9wzn/Qv8Uj/RqO+FOc6Ufx5TrLfEP8yDcd1+rFcdtnHT+rP+1+0HE9bxxCgc5xPk7Dr/wIR311jVf6HPHYOOK39Ss8ih7Ff69vtp82flaf6Hl1/23c7k8lr1JfpS6Av47jch2YQhN28Xk8VPXYRIrf+RFO+Q/6t3ikX8QRf4JT/Si+WGeZb4gf+abjYr0obvus42f1p90POq7njTG4dTZV7KdGwxd+hKO+usUrfY54LBzxM/0Kj6JH8d/rm+Unw8/qEzWvx38LZ/2p5FXqq9Qly19X8/8PM972w/46lsfnCQ1jpPiDzjxO+RP993ikX8QRf4JT/Si+WGeZb4gf+abjYr0obvus42f1p90POq7nbaZQoHNq2lHDr/wIR311jVf6HPHYOOK39Ss8ih7Ff69vtp82flaf6Hl1/23c7k8lr1JfpS6Af4z18BSruon760Yeb6pxaCPF7/wIJ/wZ/Ws80i/jiD/BqX4UX6iz1DfEj3xTcbleBGc+q/hZ/cn6QcU9eZsuFJxH7VhHDb/yIxz11TVe6XPEY+OI39av8Ch6FP+9vtl+2vhZfaLn1f23cbs/lbxKfZW6AP6h6ZfrQDeMwy4+j8dqGOpI8Ts/win/Qf8Wj/SLOOJPcKofxRfrLPMN8SPfdFysF8Vtn3X8rP60+0HH9bxNCG6dbVXHbtTwhR/hqK9u8UqfIx4LR/xMv8Kj6FH89/pm+cnws/pEzevx38JZfyp5lfoqdQH8fdP0Mx5iu79u5PG26vs+UvzOj3DKf9C/xSP9Io74E5zqR/HFOst8Q/zINx0X60Vx22cdP6s/7X7QcT1vGEKBzm4KrYZf+RGO+uoar/Q54rFxxG/rV3gUPYr/Xt9sP238rD7R8+r+27jdn0pepb5KXQB/F8blOtCP0/66kce7qpsvHBS/8yOc8h/0b/FIv4gj/gSn+lF8sc4y3xA/8k3HxXpR3PZZx8/qT7sfdFzPG6JbZleFtp80fKYHMGqqW7jS5IAGw4icSBdYuBTBdZ9bhokMP6kz1LQe2y2cdaSSl5dVqAggb2dkxpu2i7v4PN5X7fLzYYbf+RFO+Q/6t3ikX8QRf4JT/Si+WGeZb4gf+abjYr0obvus42f1p90POq7nracCmUPdtBq+0gMYNdU1XGlyQGPBiNyULrBwKYLrPrdME238pM7Q0+q227jdkUpeXlahIoA8hno568e6HnfxeXyoYtc2FL/zI5zyH/Rv8Ui/iCP+BKf6UXyxzjLfED/yTcfFelHc9lnHz+pPux90XM9bd26Z/fJKmQTP5HkUddQWrTQ4YMEw4DZlcwouQ3Db5ZNhH8NPagg1re64AZMuFHKycvJK5OSN87/XCxy7/vEcTPCH+FA3PcUfJDZ1n4lPcBqP+JHOO0/q2CN8ZLfgY05gpRid5Qa6aZkkFgbb3tJ4YG4hXNZIjF6qNO12sUs5vdBI6FQVkqJ4oU9lWE9ahwKNY4idhq/0AEaNfQ1XzjJAY8GI3JQusHApgus+t0wT5U+O93SGnla33cbtjlTy8rIKFXkg76eqG5rweMpPIUxPQ6y6egrrdWnq2umI7+MRzxuOeBL8YVY7PTf9MVZ117VMD4xn/NAHMK+En/rwXv1H/NANG88VP/Lb8Yj/6M++f9J4kDfjjxaP9MC89756X143zz6en0coXqwj6h/n+evuEx2386J41p/leNl1gPGr/cnO63deB9D54sDNvPS6h/jF64D3+sk/d7znNcWLPu8Qv+O6YV5PFJ113Qa3zmF5S5fDGzuA0UXpGq5cq/I0BAf0pnZKomnhvjsdI04S/Kz2kPOK1tuw3ZM0p1JXWg/IvZ71w/IOb3u8GhzwYb5qjRPDH6eUxyl/OqktHKiXYMC9g7lyEF6osMguQA/s0mGxRhQ3/NXhsxrS6AEdlpOGegwFIqem7SR840c4aqc1XultxENwxG/qV3gUPYr/Xt+InyZ+Vp848sr+E9zsTyWvUl+lLoh/fbY8Lm/s7sKzcF+Fvpls+I0bwDZ3RvkajpTLOOLf41Q9Ci+UWeIZIkeeybhYKRsmBsv4KS1JukDG5axNaBr3adOOy+NYAd/YEQ5aaQ0XGhuw2DAiN7UrPFyN4LvTMNtHAz6lM/SUsukEt/pRSavUVCkH4l9/ETQub+PuLxB5vKuWl+Nt+I0dwIz8oH0LR9pFHNDvYKodRBdrLHEM0SPLHLhYKYpbHsvwOT1pdYEMqynjfJo5FU7Lm7S9Aq/kCAettIULfY1YTBzQE/EKjSJHcd5rmmWmDZ/THmJO3XgDtjtSSKkUVSkGoF/frZiWN2130Vm4rZblzS30jTmPEuKD6C0aqRZxQL+DmXIQXCzR7RbiRnY5cKlGDLbMleET2tCqvQxrCdumbpzquikEBd6oEZ7vnjWaNzLgsGHAbQpXaLgYwXGnW6aJGD2hIdR0qtsmbHSgkFEppFIDQL++gT4tL8x2u/A8Hqt26Aj8xg5gRn6QvoUj7SIO6Hcw1Q6iizWWOIbokWUOXKwUxS2PZficnrS6QIbVlF3TNk6FoV5eeB0kfKWHA6CbbvFCbyMaE0f8dAISkyJJqYDbOstSGz6nT8ScHvctnHSnklYrrlQUlGJd72seaNpuf8UAA838DxPF3zIgnCc4TOF2AJyDOoBS7HE+BxT/Hqll9sEU0D/XgFo7YcC03IGf1q9mbzhwOW/fjE2J0KFuGgm/JYADqMfWA5S2h0R0AKWwJyExaaKkSvgdZNaa+Gld40gsF4LgZrcqebVCS9VBKdY1mcOy6W/d7w4AA2H+5I4Uf8uAcJ7gMIXbAXAO6gBKscf5HFD8e6SW2QdTQP9cA2rthAHTcgd+Wr+aveHA5bxDbHwHrPiyre8wSPg1ARxAPbYdoLQ9JCIDKAWbhMSkiZIq4XfQtpbgp3WNnNhRCBMn3ark1QotVQelWPfNCevGwGF3ABiYT/Jx2dGXDbzlgANCjsM0bkfAeagDMEcyIMwDHvEeuYUmwhzQRNeAWkFhwLbdNXBi79pd4hrQk4+xj2VyxxAbbeCWAw7AhluPkE4DSEUHYA57HhKVpkqqh99E6q49cGL7uJLr9aADdu9KybWaS4WCOaZl/9OwbDAc9heZ/ECYqnH5AwUduOeAA0qOwzxuR8B5iAMwRzrA5wGPeJfcQhNhDmiia0CsoDJg2+4aOLF37S5xDejJp7aOJXKXbYXHURu45oADsOG2I6TTAFKRAZiDzUOi0lRJ9fCbSNxlAye2jyO5px5kgPWulFyruVSofI75klHHcVgG2n7YX/ryAzNVaBth4FFufkDJsZ/HwxFwHuIAzJEO8HnAI94lt9BEmAOa6BoQK6gM2La7Bk7sXbtLXAPk/LitTjMPNFPdPtVVrKcdPC2Pkzb4tlaLGwbcFrx8xx2bI0uKz0aHcbnvJvh9HR6Ap/xsVVO4vuYGh26IR5bDesEofqpijOGIo3W68XrT+VX1yfrF6rSoTDEt3tzB3MJG3kQA6cRbIJGt38StdtCWi3jrwPyWqUg/4kF6AE9y5lJ6tBMy3tEX7VQ/DeOCx34SdrZHMhHNHRc3Vg9VPTYWzwFf49evIYPAD+zB08rT0yubGA/4gRx0gSTh9icKvfo6taNSIYtRw4LG91vz6AH4QBRh9oF1/+CjuyMl25OhjWDwNqxku9tk+2m6vWDC491eDfFsn1ldFadWWNCYrYGebDxgs6DwgxhkPoo/i9/bDHjfjfzmJqR5Dk2C9Cfn+fHuDuHJSUF5Dneb1q0sujn13RCLSb1zQjTJpfGOJx/mKX77FKMlRPEgr1dm8uFMK5t8+Ks2HOIBjuQDd1A46ntkMv22gz77vbj325R4fuJqoc9zcg9kx6t5WbcJt4imfkc3o+4nt7iyTolfP4vQHb14py/ye89S/ZuHHa/mRRdD9E1I/oYk8tPrBrrRJd/YWLyal91E0i/MRL98kyruPa9+UWfxel55r2uC2w8saN7ivaVFnYV7Jzt2VyXbA9sPkmje4t1MRZ3Fu3XK+/kRHOkR7/uL988TdRbuD2d/2WNPP53fAeG2M/YT44IdmRi3b/a+L8ZsOt5tISwtR5bkOWiC6/GAPlnTP3lsesONvSvIBi1ZKw9fAkBa48mGsF3XUbw4KaQGq3SaYMP63jU2/r7TDJEX7lmhbLfGd3ZYjb//ka8cN3eUePvTpndHEu+ODOIOBazRjJ1rdvHCJSq7k5G4E43SDRI/0o/my/z31tf6czP5PZbnCPIn7TADnfJjMOXX0uIRXG6qyqICRxS+56T/SBy9cohfmkMvjBtrZejvIoO02CBAhA8AQpEgsC4iWKJqqIZ+PN5wgAXe4LJlnpRgER8wTbh8J1maOIkH80Q0ICtgARMFM2KbAIiLMMPNPQC7d7uc7EzRDSoIx+zW5hY4qyw+S4+dzIrPlw+fpzsa+vGEbmMSExy4+LGI34Mmb50nq0LQN/gSHvguElg/Ca9Jkl8Ahs5rH5/WUfqRHP2h6uHn5YQKHpGqgvZZ8zgrh7um1tsX4KUXu9xpd+A5wP1e7J2TDvfuFksmPHfqw1MWhNOtE73x6qSyatBOBGSZwGQpTrgaHlii1Vz7Nll12iQ5RDunSfcw2ZsIV0I3F5vPsGdF2uwqi68WeRJ84gF2sj+guDcZ2wDP99VbvjgUbeQlKi/arUrewIbg1q0nT1u4a4wss3hzFHkPBRMnXyp43rJ9C0SRJSvz6wt4myvQZ5WoF/GyZbM1gWXLQ6uLy5qw9eWWpixbzFUTWLJaKbvb5o9JpKcqPG3xaoGizOIl8OT1rwiO9IhfyopXmhJ1Fi6f5Fg7hSwNZD4l5Hnfs0KJKPU9i27or9Y7H/H6VxuQX5p2PaoufFHe8V3b8+6n9lhfSl7+oqP+OizJkfnTQekAnQd78cD7p10xvpQfv9iQ+9Uq+tMxfE1pj99dS3mQevSc08uP9Bf/jADk1Z72gm+MNFoUCXD6dCQ1hzzt5Y8D5QHFh49Plz+/fPr38+fnXy4f6qp+uvzt+ecfPv+4/cvfXz9/+vzy+vP2r/96+f4+9Jfnlx9+/Lz9y1c/Pf/vMfBPrz+9zoSXP3z19dfD18Pl94//B4QjmnKdzgAA",
    "Actual Number of Risers": "21",
    "Actual Riser Height": "169",
    "Actual Tread Depth": "296",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 1",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "21",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 2",
    "Top Offset": "0",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1300",
  },
  {
    ID: "576666",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.53702305",
    Cost: "0",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzFkbZum9SQqCHooIngoPVQMbSAmUqNQSv/dQG3Vk7edfcPM5B1kZ3VsbxJS2NmzyqxuK2uAQGaVcXdI8244vQF5SBMex4sZChphEkJPvmgcUM7xP43oPBD8l36SR1qME5ZNU7Z+h3+sVXmVTjaQMsoI7KWpXP0WB+tKp/z0QZ7UZUJbqara1yCjXGBCYKPlczILhkhgZbX1ueahdV+8AEHh1toXAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "8",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "800",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2650",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3256",
  },
  {
    ID: "576690",
    Name: "Stair 92",
    Category: "Rooms",
    temperature: "22.75101569",
    Cost: "199.973199",
    Level: "Level 1",
    Pbi2DGeometry:
      "igEAAB+LCAAAAAAABAClkM0KwjAQhN9lzzEk/UmbehIVBD0UETyUHloa2kBMpEahlL67gWrwqt529ht2d7YYIa/labgKyGBvapkbNbRGA4LcSG1vkBXjXDoDZTGOYp4uFxHFNE4CmNAHTUJMGWf/UcpwmvAvoL/pd+gvKt+xV31fDS67a2xkdRFW9JARTBAchG5t9xJHYysr3btmeZaNRzsh286t4ZgEQYhgq8TDe1NCKYK1UcaN1XelpvIJm+Kd3YoBAAA=",
    Pbi3DGeometry:
      "MwQAAB+LCAAAAAAABACtU00LwjAM/S8519I49+lJVBD0ICp4EA8bFi3UVWYVRPbfLTo/mA5XkdLSvNeXNE26OMM4EbPTjkMEQ5WIqZJiBQTGSqR6D9HifNsamrXNgJw8kQYy1r4uZkK+vMs6WRafjBZ9h6IXeqTRQoqu3yQhdRx0yJNAjwZ++MA9l7bcMLDHKwOUiUrFG8FowBA/uLInfr/u9xjFi9ji9SNXCUoByiWyxf/VGm/+yy9Xn7Duvm85/1y0mjmYH9gT8ZZrnkHEKCMw4ulabwpjonSshUoLcy5WD2rAxXqjC6Mv+fH1YFdJZRymBynz5QXvfT1pMwQAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "17",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "1700",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "92",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "19500",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "45.21",
  },
  {
    ID: "576691",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.29801441",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzEkmpaknkQFQQ9FBA+lhxZDuxATqVEopf9uoLbqxdvOvmFmsg7SEk/tTUMCe1di6kxbOQsEUofW3yHJuuEMhhkXVCghljMuacSVgJ58UUGV/I8iOl/I+Bd9Mkeaj+WrpinasCA8NlhctdcNJIwyAgdtK1+/xdH5wmMYPcgzXia001jVoYYzGkuuCGyNfk5myTgnsHbGhVz7MKbPX7V+8RMRAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "9",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2900",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3256",
  },
  {
    ID: "576715",
    Name: "Stair 93",
    Category: "Rooms",
    temperature: "20.418612",
    Cost: "18.13270611",
    Level: "Level 1",
    Pbi2DGeometry:
      "wgEAAB+LCAAAAAAABAClkD0LwjAQhv/LzWlImtgvJ1FB0KGI4FA6tBjaQEykRqGU/ncD1S4WQd3uvee4456sg7SUh/YiIIGtKWVqVFsZDQhSI7W9QpJ1Q+kGPMoxDQI292iAozCGHk1Bn2HOSfgT5RTzOAq+oTPMSET/gVPffGJvGvKXrkXTFK1z5horWZyFFQ0kBBMEO6ErWz/D3tjCSqd5iEd5GtFGyKp2V2JMfJ8hWCtxH2cjQimCpVHGrdU3pfr8AZcYnrPCAQAA",
    Pbi3DGeometry:
      "SwUAAB+LCAAAAAAABACtVFFLwzAQ/i/3nIaLiV3bPY1NEPRhqODD2EPLwhbIGqlRGKP/3aDtdJ0hbRkhofd9vfu43EdWR1gW6uXwJiGDB1OoZ6PVBggsjSrtO2Sr48+no3HqFtTkF4kY4vT7cBvqdZs2q6r84HKjW8oxYSRiMU0mKUkp54y7UFAWx9yP33AqBE4GEIJRkSbxiWiVu7i3ki9hbAsNjjRBxv7RHU5c7/YuJNqmhxPjJ+TV6E5iKD7aGyGBzkj7wSP95SketFcA7+vqrlMCvfa8sbARe9YP+/Ncwb1MC5XvpZUVZEiRwKMst3bXBE/G5laZsglf1eZE3Uu13dkmuNPy8++Pc6ONK1h+aF2vvwCxAnAmSwUAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "20",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2000",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "93",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "20408",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "52.68",
  },
  {
    ID: "576716",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.17031676",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyFkS9sk9SQqCHooIngoPVQMbSAmUqNQSv/dQG2LJ287+4aZKXrIr/rcPRRkcHBXnTvT1c4Cgdxp65+QFf14BgMXlCciWSHjlMtIwkAWmEoaxTH+gzFNMMIfuMROsJzq121bdWFDeGx1dVdetZAxyggcla198xUn5yuvw+xRXvRtRnul6ya0IKOpQElgZ9R7NguGSGDjjAu59mXMUH4AFv1LIRMBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "9",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2900",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3256",
  },
  {
    ID: "576740",
    Name: "Stair 94",
    Category: "Rooms",
    temperature: "20.5406885",
    Cost: "357.4835648",
    Level: "Level 1",
    Pbi2DGeometry:
      "wAEAAB+LCAAAAAAABAClkMsKwjAQRf9l1iHk0fTlSlQQdFFEcFG6qBjaQEykRqGU/ruBajcWQd3NnTPMMCfvIDuqfXuRkMLGHlVmdVtZAwgyq4y7Qpp3Q+kHwgSLiNEZ5RwTIQLo0QRkAocRFz9AEmIq2BcwinHASfAPnHrlI3yXULxkzZumbL0x31iq8iydbCAlmCDYSlO5+hl21pVOeclDPKjTiNZSVbW/kmDCGEew0vI+zsaEUgQLq61fa25a98UDOqp+8cABAAA=",
    Pbi3DGeometry:
      "QQUAAB+LCAAAAAAABACtlNFqwyAUht/lXDs5xpi06dVYC4PtomyDXZRepFRawcWRuUEpeffJlmRbimjCEMXzqb96/HFzhvVOPZ1eJRRwZ3bq0Wi1BwJroyr7BsXm/N11w7hwBRryQ64Y4uKrcRWabbfsuq7Lk1ubz2jKMSWMc4pCpGROOWecZHMq8oT5eSJolnMRzTGjTCQ97/cdcJ+Ob/7k83cc6QwZu9x3LP+vvA31u/uO5RPfxad/kf+xfKIfgvqDd4zmE33l0w/6KsRj/TzwSfC+kXkL+jBSP+jPv/ruP1qq8kVaWUOBFAncy+pgj23wYGxplana8Fnt+6FbqQ5H2wYrLT9+T7wx2jjB6l3rZvsJHBZ2EUEFAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "22",
    "Area per Person": "29",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load": "2200",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "1219",
    "Design Option": "-1",
    "Faktor Anrechenbarkeit": "0",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2750",
    Number: "94",
    "Number of People": "0",
    "Occupancy Unit": "By Space Type",
    Perimeter: "21800",
    Phase: "New Construction",
    "Phase Id": "New Construction",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    Putzabzug: "0",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "13.99 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2750",
    "Upper Limit": "Level 1",
    Volume: "57.56",
  },
  {
    ID: "576741",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.78901946",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNo+kibehIVBD0UETyUHloMbSBmpUahlP53A219nLzt7DfMTN5DVqlTd5OQwh4rlaHuajRAIENl7B3SvB9PZ2A8pILH8XLBEhoxEcJAvmgcUM7ZfxpRP0j4L/0kz7SYJ6zatuzcDvfYqPIqrWwh9ahH4CBNbZtJHNGWVrnpozyryxvtpKobV8Oc8jgnsNXyOZmZT0UkAgJr1OiCzUProXgB5TyXLhgBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "7",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "700",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2650",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3050",
  },
  {
    ID: "576765",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.63338426",
    Cost: "0",
    Pbi2DGeometry:
      "GAEAAB+LCAAAAAAABACFjl8LgjAUxb/LfV7DubmpPUUFQT1IBD2ID0pDB2sLW4GI372B2p+n3u65v8M5J+8hq9Spu0lIYW8rlVnd1dYAgswq4+6Q5v14egPhDCdciOWCxDgiCYMBfVFBMefkP41wSGP+Sz/JMy3mCau2LTu/wz82qrxKJ1tIAxwgOEhTu2YSR+tKp/z0UZ7V5Y12UtWNryEBppRxBFstn5M5ZJixkCJYW219sHloPRQvRJLDyBgBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "7",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 3",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "700",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2650",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3150",
  },
  {
    ID: "576789",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "21.45772468",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9js0KgzAQhN9lzzEYjWLsSdpCoT1IKfQgHpQGDaRJsWlBxHfvgtqfS287+w0zUwyQ1+rU3ySksLe1yq3uG2uAQG6VcXdIi2E60eAxTrngfOWxhEZMcBjJF+VUJP9RRIMwiX/RJ3Oh5VKedV3V4wJ8bFR1lU52kPrUJ3CQpnHtLI7WVU7h6Eme1eWNdlI1LdYwVH4cE9hq+ZzNLKAiEiGBtdUWg81D67F8AX8tjpQSAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "8",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "800",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2900",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3050",
  },
  {
    ID: "576813",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "19.17025043",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9js0KgzAQhN9lzzEYs4rak7SFQnuQUuhBPCgNGkiTYtOCiO/egNqfS287+w0zUwyQ1/LU3wSksDe1zI3qG6OBQG6ktndIi2E6ncFjSDFBXHkspiFLEEbyRZEm8X8U0oDH0S/6ZC60XMqzrqt6t8A9NrK6Cis6SH3qEzgI3dh2FkdjKyvd6Eme5eWNdkI2rathPuUcIwJbJZ6zOXDFGHACa6OMC9YPpcbyBd6D2nISAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "9",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 3",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2900",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3150",
  },
  {
    ID: "576837",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "21.10362765",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsELgjAYxf+X7zzGZm5zdooKgjpIBB3Eg9LQwdrCViDi/95ATTp1+973e7z38h6ySl+6h4IUjq7SmTNd7SwgyJy2/glp3o9nMIgEC5awNSXhECKCAS2QSxzFMf0HGY4lX/3AJXaGxVy/aduyCxvCY6fLu/KqhZRgguCkbO2bSZydL70Os0d51bcvOihdN6GFBkU4R7A36j2ZaYQlkysEW2dcCLYvY4biA0ClzvUUAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "8",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "800",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2900",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3050",
  },
  {
    ID: "576861",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.60641089",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsELgjAYxf+X7zzG3KZTO0kFQR0kgg7iQWnoYG1hKxDxf2+gJp26fe/7Pd57xQB5rS79Q0IKR1ur3Oq+sQYQ5FYZ94S0GKbTG0SMRRiHm4D4QwgKI1phlGDKefAPhpgnEfuBa+wCy6U+67qq9xv8Y6equ3Syg5RgguAkTePaWZytq5zysyd5VbcvOkjVtL4lIJgxHiHYa/mezZRjzilDsLXa+mDz0nosP+ELmhMUAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "9",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 3",
    "Base is Attached": "No",
    "Base Offset": "150",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "2900",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Level",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "3150",
  },
  {
    ID: "576926",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "21.37910881",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACNjsEKgkAQht9lzuvibuqSnaKCoA4SQQfxoLTowLYTtgUivnsLWkF06Db/fD/zTd5DVuGxu2pIYUcVZmS6miwwyAitu0Ga9+PoC4HkiYzUIhAzLmKpYGAf+Af7hYJvVrzUy7YtO+/3izWWF+10C2nIQwZ7bWvXTOFArnToXx7jCc9vtNVYN14iBJ+rWDDYGP2YykLyKFGSwYoM+cP2bsxQPAFARTEqEAEAAA==",
    Pbi3DGeometry:
      "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",
    "Actual Number of Risers": "20",
    "Actual Riser Height": "175",
    "Actual Tread Depth": "285",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 2",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "20",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 3",
    "Top Offset": "150",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1600",
  },
  {
    ID: "577000",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "21.21633851",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACNjsEKgkAQht9lzuvibuqSnaKCoA4SQQfxoLTowLYTtgUivnsLWkF06Db/fD/zTd5DVuGxu2pIYUcVZmS6miwwyAitu0Ga9+PoC4HkiYzUIhAzLmKpYGAf+Af7hYJvVrzUy7YtO+/3izWWF+10C2nIQwZ7bWvXTOFArnToXx7jCc9vtNVYN14iBJ+rWDDYGP2YykLyKFGSwYoM+cP2bsxQPAFARTEqEAEAAA==",
    Pbi3DGeometry:
      "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",
    "Actual Number of Risers": "20",
    "Actual Riser Height": "175",
    "Actual Tread Depth": "285",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 2",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "20",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 3",
    "Top Offset": "150",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1600",
  },
  {
    ID: "577187",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "22.43002523",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzyGkaZraehIVBD0UETyUHloMaSAmUqNQSv/dhWpBBG8784aZLQcoGnPqbwpy2PvGFN722jsgUHjjwh3ycphODIiE8iwVy4hTKeIFjOSXxRFlkUy+GJc04yL9y+bO6jO96rq6x300Nqa+qqA6yBllBA7K6dC+xdGHOhh8eZJnc5nRThnd4gjH7kRmBLZWPedwzNBZe+ux1j2sHasX8YbuMg4BAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "39",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "3900",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "5600",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "6906",
  },
  {
    ID: "577311",
    Name: "Curtain Wall: Standard",
    Category: "Walls",
    temperature: "20.96313253",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzyGkCUltPUkVBD0UETyUHloMbSBmpUahlP67gdaKF28784aZLQbIa3Pu7xpSOGBtcrR9gw4I5Gicf0BaDNMZAlzQlZR8HTGquIpgJF8mJI2FiP8zQRMW/6ClckblZ3jTdVUf1oOxNdVNe91ByigjcNSu8e0sTugrb8LDk7yY64L22jRt2OCcKqkSAjurX0tYsOBkaDHUuqe1Y/kGjPYhKAwBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "25",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "None",
    "Border 2 Type": "None",
    "Calculated Heating Load": "2500",
    "Cross-Section": "Vertical",
    "Curtain Panel": "None",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Standard",
    "Family and Type": "Standard",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "None",
    "Join Condition": "Not Defined",
    Justification: "Beginning",
    Layout: "None",
    Length: "3621",
    Number: "4",
    Offset: "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "0",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 3",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Unconnected Height": "6906",
  },
  {
    ID: "577501",
    Name: "Floor: FB 15.0 - Holzdielen",
    Category: "Floors",
    temperature: "21.0257154",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNTfQsLc0trXVNjfRMDSwtlGp1ELJESWKT08WQjIVZ71hUlFgJdANQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhvCDc9MgUt5pGamZ5SAOCaWRoY6Sq45qWVwtcYGljpKzvk5+UBT80pzcmpjAcS4QtYRAQAA",
    Pbi3DGeometry:
      "mBAAAB+LCAAAAAAABACdV8tuwjAQ/Bf3GiwbJyaBU9WHKrUH1FbqAXEAEUEkSioaVUKIf695pDTxrr2OEA9PNuPxGs9uJns2nhfvu6+cDdlzOS/eynWxYBEbl8Wm+mbDyf7801wWI/Nih+iK9KQQo9OHebPDtL7tdrud7cy9seJaZSrKUh6rWEWCK5FFMuE6UTLKJM9SoWvUxMZKk2K9vKofJyRUazNM0paGFgrHgrywMrdebb7jbEBSFpRJEEV4KTm7xCrJ9aBv6W2sQmneV7FsxcIozADnrGaQx7UN2rE9zZM0iVt6mygcC/OGrMK987CyVh7qHYL/D2B+m3rhFdeoL2epkBIgPsE2syvaw31d9pnbWqEr2s6za0okGlNi7UsH3WGpsjenASPcRCWWlTTg6+luTkmLhrmRfNtG5Yy2zK4Dd5huJIMegWGJRZS0dcOLt00dEQh7EeWMeOFQm0OIkQNChkMd30McdiC7Gy5CjPgCGcYndNc0hJhmfe7C2K2IOg2OCju6DGfNRYgR+/XCwUUeIfb4ug8O7Sq61REvHNzsIsSI61Lh4L7fTUx0ebjBDmnGveWjExzc/XuJkerrhkkTwrFg1ewId32aCizePpgwIRxL6pTIMDqhecK/L2afeZVv2VBwEbGXfLOsVpfBa1nNqqLcXIYfxeLv0lNeLFfVZfCwzn/+B96V69IQspvB4/HFDtNf/LfnY5gQAAA=",
    Absorptance: "0.1",
    Area: "251",
    "Calculated Heating Load": "25100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "94",
    "Elevation at Top": "244",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Holzdielen",
    "Family and Type": "FB 15.0 - Holzdielen",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "98527",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Holzdielen",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Holzdielen",
    "Type Image": "<None>",
    Volume: "37.66",
  },
  {
    ID: "577552",
    Name: "Floor: Sonnenschutz",
    Category: "Floors",
    temperature: "20.1200387",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjrEKwjAURf/lzWlI2tDaOokKgg5FBIfSocWQPoiJ1CiU0n830qqDDm7vvnO5nKKHvMZDd5GQwdbWmFvdKWuAQG7RuCtkRT+evhBwJqhIRTwPUkYTEccwkA/+k/6CwTctXwqLtq067+EfK6zO0skWMkYZgZ00yjVT2FtXOfTqYzzi6Y02ElXjniEKZ5zAWsv71OUhTXgUEVhabf2uuWk9lA+eAsG+FwEAAA==",
    Pbi3DGeometry:
      "3hUAAB+LCAAAAAAABACtWF1r2zAU/S/aqyL0FclOn8o+GGwPZRvsoeQhpaY1ZPHIzKCU/PcpnWMnupZ1JYeQYN+joyMcH+tc37+Su4f6x8vviqzIl+ah/t5s60dCyV1T79o/ZHX/+v/QwfzGfciBDpWF4Pzm7cd9yWF9ot3u95sXx5WKaSGXdKFYYfmSCsmsUIoKo5k0opwADBPGijjQS4TqnoISjEtV0IWWbsLSnClIppdaTSKaLY2RCGSQCQKeykIZt1JZjiDCIaU0kxxP5ozjIxiOr+OGWmk1FVyzgh8PesRdAcWLMaTjHAWtEBZyRpAoB+qUzCi3aOEopRwY7q8p3B0A6sN47Q64HiF4AIJxKfF27wlDy4JxM9x6VrGS6yJYXjJrCh2t97OH6pfTA4MoxrUYcxQATtaJAcBrft1TgOboFYCfAOV0a0KKh2AonsqIN04I9BNEPJ0JBHo9vgLojR4BfvKRwTUIBHg9vgLgkA6AngJAZ51IHbg8pgxc0tWBq/zxnXv84Zfl2GhvcsR+F/Raum2DW2f+ZhsxNLo+ezcPCaQ+kbxLkZoiQvOnPzuD/044OyWkkdgDNwG4RuTBPtQTgOy8lbGjJCFXyZvonSsJia5gIouGd66cfRCTbPFpGKOTs6/jczKGg88cKcic3I/RyUkw+G5loiMIZ5twHkpAZvUkUZ2cdJXUSUU5SckvAZnVGUZ1cjJuQs8YbPWCeTWYMxOA7D4ToZGalpE9cZyAi+/oemZTH58/vTFBNvuxrh7XIaDrV3qXEOmS0PW57ypwXRiyPOMFCbrzQ5YnJdeUfKg3v6q22pMVZ5ySr9XuqX3uTr417aatm113+rN+7KHPVf303HYnH7fV3/OB75tt4yYk7z7Z44cc1v8AWGLFzt4VAAA=",
    Absorptance: "0.1",
    Area: "119",
    "Calculated Heating Load": "11900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "100",
    "Design Option": "-1",
    "Elevation at Bottom": "3875",
    "Elevation at Top": "3975",
    "Enable Analytical Model": "No",
    Family: "Sonnenschutz",
    "Family and Type": "Sonnenschutz",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "175",
    Image: "<None>",
    Perimeter: "347792",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Gitterrost",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "100",
    Type: "Sonnenschutz",
    "Type Id": "Sonnenschutz",
    "Type Image": "<None>",
    Volume: "11.88",
  },
  {
    ID: "577724",
    Name: "Floor: Sonnenschutz",
    Category: "Floors",
    temperature: "21.78189745",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjjELwjAQhf/LzWlIa4i2TqKCoEMRwaF0aDG0BzEnNQql9L8badVBB7d79z0eX9ZBWuKhvWhIYEslpmTaiiwwSAmtu0KSdcPpC0EoJJexVPMgFnwqlYKeffCf9BcMvmn+Ulg0TdF6D/9YYXHWTjeQCC4Y7LStXD2GPbnCoVcf4hFPb7TRWNXuGSbRLGSwNvo+diPJw1hFDJZkyO/amzF9/gAacs+hFwEAAA==",
    Pbi3DGeometry:
      "3hUAAB+LCAAAAAAABACtWNFq2zAU/RftVRGSLMt2+jTWjsH2ULbBHkoeUmpaQxaPzAxKyb9PST07Vu+VdO0REux7dHVMrGOd47sXdnvffH/+VbM1+9zeN9/aXfPAOLttm333m63vXl4PHSyv3Icd+VhZKSmvzj/uy46bf23vD4fts+vVmTBK53yVibKQOddGqMpqrqwR2qoqAFihbKHiwECB1T2GTAmps5KvjHYTVvaCQQuTmyyIGJHb0+RRZKRBAY9llVl3pboCEOWQSttgj0dz0eMjKT0+jxta6MJwJY0opTsYEfcPZLKEkL7nRFgoVbztAZBoz1ueStjMXbRyLZUeO9ytKd0KCNSNa5QmDowMKDClOK89ZXlVCmnHpVdkopKmRMu5KGxpovVhdqw+nR4QSK7dkoUU5QGjdMIAoLVp3WOAxNEzAHrykXFtRhBIamF+UBuvCKQnH/FoAgik9dgVQNroEUBPU+RSNVEE0HrsCgCFnAFIUx4wSCdYB6QWZgZUcq4DqpqOH9QzHT4tx0Z7kyfsd6jW6LJFt84lm21Q0IT6wt0cI6A+kby/guoisPnpz0707uDeieRGwg88ErDc8qAk9Ce351DofgvlmLPV4OZxmd/EaebsnPitTPei+M41Zx9McbbpbjiFZ86+nu6TU3rSPQcNme/7U3jmOJj0tBJIBLi3wf0QCVmQSaI8c9wVKUlFe0jOj4QsSIZRnjkel5AZSRkw7DNJwOKciXJQ3fI0sJITLkZAtfVYSJ8f6rH56cEEvW1T6liqT0sIhPp/epcQTEmE+rJ3FWkpLLk8+wVJcvJLLgcoN5xdN9ufdVcf2FoKydmXev/YPfUnX9tu2zXtvj/90TwM0Ke6eXzq+pObXf3ncuCHdte6Cdm7j8Xpw46bv7/PBB3eFQAA",
    Absorptance: "0.1",
    Area: "119",
    "Calculated Heating Load": "11900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "100",
    "Design Option": "-1",
    "Elevation at Bottom": "7375",
    "Elevation at Top": "7475",
    "Enable Analytical Model": "No",
    Family: "Sonnenschutz",
    "Family and Type": "Sonnenschutz",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "175",
    Image: "<None>",
    Perimeter: "347792",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Gitterrost",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "100",
    Type: "Sonnenschutz",
    "Type Id": "Sonnenschutz",
    "Type Image": "<None>",
    Volume: "11.88",
  },
  {
    ID: "577773",
    Name: "Floor: Sonnenschutz",
    Category: "Floors",
    temperature: "19.03844896",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjrEKwjAURf/lzWlIbUxtnUQFQYcggkPp0GJoH8REahRK6b8badVBB7d337lcTtaBLPHQXhSksLUlSqvbyhogIC0ad4U064bTF4KQccoTLuZBwmjMhYCefPCf9BcMvmn+Ulg0TdF6D/9YYXFWTjWQMsoI7JSpXD2GvXWFQ68+xCOe3mijsKrdM0STWUhgrdV97EacxoJNCSyttn7X3LTu8wfc9omHFwEAAA==",
    Pbi3DGeometry:
      "3hUAAB+LCAAAAAAABACtWF1vm0AQ/C/XV3y6O44DnKeoH6rUPkRtpT5EfnAUlCC5pnJRpSjyf+8lxWDfsuwtRFZis3N7gwzDzvj2Wdzc1T+efldiLb40d/X3Zlffi0TcNPW+/SPWt8//P3pYXfmXOCZDZaWVunr95//EcXNquz4ctk++16TSapMlq1QWucqS1Mrc+XftrDROlxOAk9rlmgZ6CqweMKRaKpMWycoav2HpzhiMtJlNJxErM+dMBDLQoEDAskqdP1NTjiDaI6Vxkz0BzVlPiMT0hDx+aW5ym2hlZaH8hwHx30CqijGk63khzLXOYc8IQvZAnlK61J+09i2lGTr8pSn8HTBRt75RWRoYGFDgkuL13tMuKQup3HDr5akslS3Ccr8688eFhcuDOrl+ZPtzgWRSFYUbURQATtKhAKC1sB4wQHH0DEBPEDndmyQCpUbxj2jjhEA9QSSgmUCg1ukzgNroEaCnEBlUE4EArdNnABTSAVBTAOikQ9SB1ChmoJKuDlQV1jv1TJdDhROkEfMO1RpftujonD9sCUFH1xdPc4yA+0QKvgqui8D25z870auDeyeGG6EeeAzgLSwPSsJ/cgcOhe+3UI45owY3j8v8Jk4zZ3LilzLei+KTa84cjHG28W44hmfOXI/3yTE98Z6Dgyzx/TE8cxxMfFqZSAS4t8H9EANZlElInjnuipWkyB6W82Mgi5IhyTPH4zIyIyMDUj6TAbxBzkQ5uG75MrCyEy5GwLX1WEifH+qx/fnBBL1sl9RI7KbyBDeWxIV9cnmwPRZYouszf6sg9+fFrbgfVKjlUckvsjxJuUnEh3r7q2qrg1grqRLxtdo/tI/dwbem3bZ1s+8Of9b3PfS5qh8e2+7g4676e77wfbNr/Ibi3af85SWOm3+Z1EVj3hUAAA==",
    Absorptance: "0.1",
    Area: "119",
    "Calculated Heating Load": "11900",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "100",
    "Design Option": "-1",
    "Elevation at Bottom": "10595",
    "Elevation at Top": "10695",
    "Enable Analytical Model": "No",
    Family: "Sonnenschutz",
    "Family and Type": "Sonnenschutz",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "-205",
    Image: "<None>",
    Perimeter: "347792",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Gitterrost",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "100",
    Type: "Sonnenschutz",
    "Type Id": "Sonnenschutz",
    "Type Image": "<None>",
    Volume: "11.88",
  },
  {
    ID: "577894",
    Name: "Floor: FB 15.0 - Teppich",
    Category: "Floors",
    temperature: "19.86680353",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNDYz0LA0NLax1Lcz1TE3MzZRqdRDSRMpik9TFlI2FOcGxqCixEugOoIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSCXQ6hBuemQKX8kjNTM8oAXFMLI0MdZRcc1LL4GqNDSx1lJzzc/KBpuaV5uTUxgIASM1DOBUBAAA=",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "707",
    "Calculated Heating Load": "70700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "94",
    "Elevation at Top": "244",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Teppich",
    "Family and Type": "FB 15.0 - Teppich",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "469805",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Wärmedämmung - hart",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Teppich",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Teppich",
    "Type Image": "<None>",
    Volume: "106.08",
  },
  {
    ID: "577947",
    Name: "Floor: FB 10.0 - Fliesen 15 x 15",
    Category: "Floors",
    temperature: "21.52335085",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNDfXMDY2tdS2M9UwsDc2VanUQkkTIYZPSRZeLhVntWFSUWAm0HyjgkpmYm1qSWqRkZaBnoKPkk5qXXpIB5QTllySWZAKdDOGGZ6bApTxSM9MzSkAcE0sjQx0l15zUMrhaYwNLHSXn/Jx8oKl5pTk5tbEA0hVN+w0BAAA=",
    Pbi3DGeometry:
      "eh8AAB+LCAAAAAAABAClmV1r2zAUhv+LdusKyV+R0quyDwbbRdkGuyi5SKlpDVk8MjMoJf99XhIntqTzIaWlJX5y8h5JNjo6bx7exP1j++P1dyOW4kv32H7vNu2TyMR91277P2L58HZ8Obytbodfsc8u5EYrdXv4N/yJ/Wr82N1ut34dPlsoqRaFybQuZG7rKlOyUDYrjFS2gqiqpDJ1jtNRGMCO8ojzSpamNI60Qyca9f8X3pinFA+eK2srK6t0dqMrWZRV7uI8l7q25YgX0pSFj0tpi0GbGT3Bi7KoiJGAKevaWC8axMEBjtG86QDa4QEOV7XJC3eWZ1xqWVpTE2sSxpDIOEAPn6cz1Qajz2vCig5qR00HHmDoNgyPdzlcurfhjJ3bYKXRxr87tbS6rL2FnWBaBBgJI+UUV8PVovJEiOhrtBnjnqzJdGFDeP5AUCJONH0bpriQqrK1JzJiXnRYO2460ADB58QtDEZpHSgjM3ypFyj2y8ucu+p+dXDlZ9gvU7NwFxPhjnpgI5vzy/oeeGADQXWg+MBuRnF3h5rH+xyP544THr+7NeJ5/Rp15H6Zn/PLDoHrQONhzIuV1y+93vqzxkPp+Jyc15QHdpE5d59bf3tBdaD4wH505P4eyIu/Uj96/P7GieYNFPs5d+4jqA9wUMevs2zOmq9f3nF9v8DjHNCB5os3RUCBiqty4c4qrQvjFT6ap/d4SLGNKtpArxjXWTIPEFyMpQx3rcAZAThpcDGdkOqS8YMQn8f34JQ29zgFmAdEViCaebTjYiQl5Ta45Zc6ntA8weOAxKEzC58nOCsMcdaBkW7IGQ4NdfpO5xyzg8S8loLm8fYN2H/E9xkhlyXa78HF+U1MnBOERvM7JC7Hs1KOUmw7RfB4H4vsUdJ5kuWJi8c2ZIAtC2QlTVy8O+RzJCvlK7pHY6oFoXm8mwmJx/Y3lKHJsj854pxmF/LY6KxANNQpJvIrvFFmWx/B4x1ZsBeHvAE+x4xTwquFxLmGRJznS0Rz3Q4+x7KyPe+rLYf0LzwovyGdJ3y5QYlzzQ/gmxYiKxANlYN0DmddZeJDu/7V9M1OLIfOKhNfm+1z/3K6+Nb1677ttqfLn+3T+a3PTfv80p8uPm6av9PA992mGwTFu0+HH7Ff/QNKNLSreh8AAA==",
    Absorptance: "0.1",
    Area: "48",
    "Calculated Heating Load": "4800",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "94",
    "Elevation at Top": "244",
    "Enable Analytical Model": "No",
    Family: "FB 10.0 - Fliesen 15 x 15",
    "Family and Type": "FB 10.0 - Fliesen 15 x 15",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "65901",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Wärmedämmung - hart",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 10.0 - Fliesen 15 x 15",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 10.0 - Fliesen 15 x 15",
    "Type Image": "<None>",
    Volume: "7.27",
  },
  {
    ID: "577952",
    Name: "Basic Wall: WC Trennwand 5.0",
    Category: "Walls",
    temperature: "22.04298059",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAUhP/LOy/Lrrua2kkqCOogEXQQD0qLPth2w7ZAxP/egmV16vbmfcPMFAPkNR77q4IUdrbG3Oq+sQYI5BaNu0FaDNPpDUFC4zgMlpxHVIYsgJF8oJBUikT8hxGX4gd+x06wfNdnXVf1foN/rLG6KKc6SBllBPbKNK59iYN1lUM/e5InPM9oq7BpfQvnlC8kgY1Wj9krWEJgZbX1qeau9Vg+AfyzP9sRAQAA",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABAClU8EKwjAM/Zd4raW10+k8iToEPYgKHsTDxLIV5iqzCCL+u0GnDrVzQ0pLk5e+lybt6gzTjVqc9hI8GOuNmutYbYHAVKvEHMBbne9bhFkXB1zIy1PnjHVvC064rB/HemkanPCscKhouoJw3qJOkzUIo4J1yIebc+q0GwgwylzR/gewKGTuXHSLO+JFk4svBj758+53/l+yluwtNNVy+V2CUi2xVqbMpYpv+02jetuLxUs3pqhG1kSrNabSayshjP9toIKdNDIFD3MmMJFJaKLMmGkTGKWTzFyq7RMaSRVGJjOGsTzmA/s61kgItaHvu76L//oKlVDe0iYEAAA=",
    Absorptance: "0.1",
    Area: "4",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "WC Trennwand 5.0",
    "Family and Type": "WC Trennwand 5.0",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1388",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "WC Trennwand",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "WC Trennwand 5.0",
    "Type Comments": "Mauerwerk",
    "Type Id": "WC Trennwand 5.0",
    "Type Image": "<None>",
    "Unconnected Height": "3406",
    Volume: "0.22",
    Width: "50",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "577961",
    Name: "Floor: FB 15.0 - Holzdielen",
    Category: "Floors",
    temperature: "20.30173748",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnSNLPQsDCwsrXUNTfSMjIxMlGp1ELJESWKT08WQjIVZ71hUlFgJdANQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhvCDc9MgUt5pGamZ5SAOCaWRoY6Sq45qWVwtcYGljpKzvk5+UBT80pzcmpjAWTMdMIRAQAA",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "151",
    "Calculated Heating Load": "15100",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "94",
    "Elevation at Top": "244",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Holzdielen",
    "Family and Type": "FB 15.0 - Holzdielen",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "56234",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Holzdielen",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Holzdielen",
    "Type Image": "<None>",
    Volume: "22.67",
  },
  {
    ID: "578008",
    Name: "Floor: FB 15.0 - Fliesen 50 x 50",
    Category: "Floors",
    temperature: "22.91914969",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNDcz1zA3MLK11Lcz1jMzNlWp1ELLESWKR08WQjIVZ71hUlFgJdANQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhvCDc9MgUt5pGamZ5SAOCaWRoY6Sq45qWVwtcYGljpKzvk5+UBT80pzcmpjAZDztioRAQAA",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "640",
    "Calculated Heating Load": "64000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "94",
    "Elevation at Top": "244",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Fliesen 50 x 50",
    "Family and Type": "FB 15.0 - Fliesen 50 x 50",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "320620",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Decke - Estrich",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Fliesen 50 x 50",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Fliesen 50 x 50",
    "Type Image": "<None>",
    Volume: "95.98",
  },
  {
    ID: "578071",
    Name: "Floor: FB 15.0 - Holzdielen",
    Category: "Floors",
    temperature: "20.67460913",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNjfSMjc0srXUt9QwtzEyUanUQksTIYZHSRZeLhVntWFSUWAm0HyjgkpmYm1qSWqRkZaBnoKPkk5qXXpIB5QTllySWZAKdDOGGZ6bApTxSM9MzSkAcE0sjQx0l15zUMrhaYwNLHSXn/Jx8oKl5pTk5tbEAkwo3ug0BAAA=",
    Pbi3DGeometry:
      "UDAAAB+LCAAAAAAABAClWttu20YQ/Rf2VSW4vNN5KpoWBdqHoC3Qh8APDiIkAhyrcIUCQeB/L0WJsnbmnJldNUZsazx79syVe+H7b8W7D7s/v/69Le6KX/cfdn/sH3cfi03xbr97OvxT3L3/dvp1/nP1Zv4qXjavku9DVb1Zvs3/i5f7ddgPz88PX+exTVcOTTNsmlBWoe82VdlU06Zpy26ahk09laEN46s0VEOvpUiX4Y5tN27qsRxC10+Xf+4wMHGYdeaZGfWxrMcpfeLzsNCVzTB/PkubcuxDZw47MYtmC3XZNb09DJNcwAQHOIXt39CWU9sOGcajwHrGu2biCM3D6qnqdDSHaWyklOniyCdnCZktlF1XN6bFJzrZ4UZZ4s62kpTDFmmcJZTZIhW6GBe6mjj1xsgnWLwoqPzFRYZsg34g1c3qLb02zyUS8129g6tQSM91PI/p20Z1o/lnGGXNK10DF5eIwM2ZDUrXcCtm1mzS626PQmbCAOCJcVioFCQXTgK7yJJKb9WVfE+4sRS6GhcO1cW1mYObzJfEAs/GCgdHE3sHex1bYXejnHDbT+lXM8cqBFBwq1gYampTbFEnjjaaUocnZnIx3ZxSNdKTWJVszCTG1inhMBFRsLAdD8K8cAyG8cMGE8uI63W6r9qiEh1tEtaMJGBTqhqLmaSGFSYBwVbFHolFEnAmYsFgYmPHMg/mhZhayduUUzrQMuwHVq20onLqz9pJRJ7ya87QUEue2LDLCtbRTpyGFJGcJm92LNZP7KQpVchI0/IMdqNHiPhBTdJASUwSzSnmxBpXe8MYW4hxbPyq5QNJc7h5mgxrWCTJ7ClVSzKD+JLEyTcStc68LHFWCWInZRewbA6pYmPrlrgdS0kiV5y708tO2jTxrXuYtK6aLDaOnMhatimnsV2WA0MTer4QNLawFEKI8Q6JrEowsnEG0JZN1wAp2b5YDxi1qRvqetQssLSfhqW6+3Fw5yOeo4vzJG+sGIQI9h0+/SChEo4mYhOZQGCXYsrEPoJMnIQ5k+Q4sevK0A3GBiuyUC06hRgfMxFls/ebJ4RkBa2UhYXm0SO2BFJeM1cCV6EKR2ld1bzzpJSmigk2hCgTFyEMuwM6uiswMtu8UHHDl5VdBmXGwgiUuRpf5pg1uqpWzxZ+mJWgQICFGB93kQUXRjbP2Rd34/N7sqW5cdd4nb+KG5Yu7XGWzphtBgviWrpbTnJX9EjSnIxLDE8aJb4rNpEJBPYupkzsI8jESZiznz0r0ake07bMkd1qcyXEkd2esrPnT7qaJ2cSIufPxkaBlbrYEkj5NZ9j4KX/HaVDff1U8w8bkktaRA3bR5SJ5xBGRmtNHRY91aSPWExyDqASc9Ggz1ggyklb+H7oGtkjk6+MLQUCLMT4fo4cTGDk6/shdVtdtW3L7tzVAcX/OTg7I7eh6TQ3LG3GUbbYBBLUs8SHSd5aJ8eUkGvNO1UNLOJAxAYyhcC+xdmAzSPAxEU4o/zUWXled7yUjDrNp47yhDgy21M2zygTXwkiR4oi4a9aFwXGlhDKazYL4Koab+h+GfUsoobso8rEc9hHyX01ddglqthH+I2snLP4xFw06RMWRlj1hd2CLA6g7JcQlJRACPE1Z/dqGCNH7zTIVywWd3ovXkQZ7N5yXyeoYoGlx14pzqT41SpxHHFRkjOuH0mah/UaiiONstYVG8gUAjsUBxubR4CJi3DCkMw4kYtPjmjCnJDVFbcQRwZ6ynFueGIbGr+LKCyMIih1sSWE8ilvFfCxS8UnSvy9DKsuVUyQIVSZuAg7w2p/jm70PFFmG6/fueHLyi6TMmGhGN9vire7hy/bw/a5uKvKalP8tn36dPh8/vD7/vBw2O2fzh//2n28/OmX7e7T58P5w0+P23+vFX/cP+5nwOK74efjV/Fy/x/WmH/AUDAAAA==",
    Absorptance: "0.1",
    Area: "42",
    "Calculated Heating Load": "4200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "94",
    "Elevation at Top": "244",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Holzdielen",
    "Family and Type": "FB 15.0 - Holzdielen",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "30011",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Holzdielen",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Holzdielen",
    "Type Image": "<None>",
    Volume: "6.27",
  },
  {
    ID: "578097",
    Name: "Floor: FB 15.0 - Holzdielen",
    Category: "Floors",
    temperature: "19.21077355",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNjfSMjc0srXUt9QwtzEyUanUQksTIYZHSRZeLhVntWFSUWAm0HyjgkpmYm1qSWqRkZaBnoKPkk5qXXpIB5QTllySWZAKdDOGGZ6bApTxSM9MzSkAcE0sjQx0l15zUMqhaoK0mZuZGOkrO+Tn5QHPzSnNyamMBphqgtQ8BAAA=",
    Pbi3DGeometry:
      "VjMAAB+LCAAAAAAABAClmttu20YQht+FvWUJng/OVdC0KNBeBG2BXgS+cBAhEeBYhSsUCAK/eylStLy78+3MyjESRePh7D//HMgd7ofv2fuP+7++/bPLbrLfDh/3fx7u95+yPHt/2D8c/81uPnxf/zv/unwz/2RP+UXyY1WWb5Z/5r/Z0+122dvHx7tv87VNVwxNM+RNVZRV3+VVXbT9UOdNW3TTNOT1VFRtNb6UV+XQS3JZn+2PbTfm9VgMVddPz39Ml4oQqllvxsCujEU9TmkQzpdWXdEM5XSRN8XYV51y6YrSW3X+7Jpeu5QALyYDNLCUxn3VFlPbDomEyOHXCTE4ThGcP+up7KSID9PYhHLWpwxJyihctyq6rm4UFlZoV6WFnFGGVTfA4aWL3M+oCMpFHuiTfQgEEv6KHDGxsKgIeU+lKnsL7GC34LpNq/Nzkfn4N9aongP5uS/M3/u2Ebrd/FmNYR8R9KP2qcwC+6nrgnxLDQFnfN0wLoY+KLsOISIIFLqIXExJShmtYM2FvOmH+Ff7vhxCQSUY0adqT7WfhB/jRetyCVLciTeKC/mldb3U1NCeJl64PnVTI1XvJvddj+uzfb/UNH1xXSF0Lp4LD/F1w669ysPSd/F49oWU0fD4cYna1/iUU0ZzXQ4puE4uUiiEqtj0/erV9CnUSamB64bV6OKxh1pODbIfdgdH7qdGBI//ABO3Dzwjn6lxZ38j3U2rLtlFoASrmqsurUqjGySHNUNhxlTChy/Xwcsjt6ZvXYrKLFgqFQLIhYcC27phDKnNqa7r4SQ0hjDbVMT8pvzTSt7cCsKtr2vfl0OsDKUduZS6yCuWSvIKY0sQTKVN6ULEUuAM3ortNjV3tCePYP+n1HnQR+zy+L7Tvo80JZhBftU+9YrEtspftcmy9uUEeXwcR0/STTGN7fK4MTRVHzRj82ac7fhy2sTR4w/Zj8852qLpGlFOO6vofUvYhA51PUp4SN5Pw9If+nEwrEt88nbBys9mh/AQnzTvoTj6/JNcs092iGfCT/6SfeKN8FP+rDi7ouqG6HbQ9Td8BvblNG8j/fj9RZmn0rO9oO/7q81ryS8Z/5bnof2yKquTvC7rWBuzlXUYLnKL9Ik22Y7WVnX9zb5Ig/KWyxDd1CyMw2c8sSjGNw/LSrNKV9bhfSw2zDOpkHVfTvM+ehok+9rbjCUO9LaEdmVXb4OdZBdQknzpubN8ttwmoSHCeRRgJdC5/QnQoq+PDHKnUAxyzT7ZIcoJP/lL9ok3wm9IsA3yVI/WyYDLQrhl9OUuC7q+NuSwHsygYYxfIJvrbtRDffJLxn/Jft/+0k5P8qF2bqKGSUtCO/ADSt6SPrEp20nq1wmXOnfQgDOOVdpgzp6zcVcYj4jfNsPoh64Jmm7CMYC4Cln35fTalIY0ZN95JyecRCjbtuXzFeHE5nUzxs16WzWdhJLkzTgGfdsChvkmXq38bRAAmUy38hZcMO+Hh+Rx+2yHCKd0AXfJPLFGWWfIrg2x0z9tWbeuGg5CfblLgq4fn/XaD5PRYNavDqcJRuyTX4R/y/3AflmOVzXTpF7gB1T2lvWJTWItoVknXPocc+CMDvilvf2w56zmCuKJxVx4obrY9yd12vESQU52fLmD3/Bin+y7Z1bC4zQLz4ZjNk7CGw4sONks4CH5qQH7Azxclukk2qz0vLz9CXDih5B0uZPlBnncPtshlikbwF0yT6xRUlHyrDC9+VokqVb74dEFX+66q+u72aPLNft0DNb31w1vqE9+Ef41ywX7p6bnDd4ih3LiNR2GS3aL9Yk2oifeU3V9594V0hA92WmIbmoWavARTwj/Ns/e7e++7o67x+ymLMo8+3338Pn45fzlj8Px7rg/PJy//r3/9PyrX3f7z1+O5y8/3+/+e6n40+H+MBvMfhh+Of1kT7f/AxrCjaNWMwAA",
    Absorptance: "0.1",
    Area: "42",
    "Calculated Heating Load": "4200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "3800",
    "Elevation at Top": "3950",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Holzdielen",
    "Family and Type": "FB 15.0 - Holzdielen",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "30011",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Holzdielen",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Holzdielen",
    "Type Image": "<None>",
    Volume: "6.27",
  },
  {
    ID: "578407",
    Name: "Floor: FB 15.0 - Holzdielen",
    Category: "Floors",
    temperature: "22.28418944",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnQNjfSMjc0srXUt9QwtzEyUanUQksTIYZHSRZeLhVntWFSUWAm0HyjgkpmYm1qSWqRkZaBnoKPkk5qXXpIB5QTllySWZAKdDOGGZ6bApTxSM9MzSkAcE0sjQx0l15zUMqhaoK0mZuZGOkrO+Tn5QHPzSnNyamMBphqgtQ8BAAA=",
    Pbi3DGeometry:
      "VjMAAB+LCAAAAAAABAClmttu20YQht+FvWUJng/OVdC0KNBeBG2BXgS+cBAhEeBYhSsUCAK/eylStLy78+3MyjESRePh7D//HMgd7ofv2fuP+7++/bPLbrLfDh/3fx7u95+yPHt/2D8c/81uPnxf/zv/unwz/2RP+UXyY1WWb5Z/5r/Z0+122dvHx7tv87VNVwxNM+RNVZRV3+VVXbT9UOdNW3TTNOT1VFRtNb6UV+XQS3JZn+2PbTfm9VgMVddPz39Ml4oQqllvxsCujEU9TmkQzpdWXdEM5XSRN8XYV51y6YrSW3X+7Jpeu5QALyYDNLCUxn3VFlPbDomEyOHXCTE4ThGcP+up7KSID9PYhHLWpwxJyihctyq6rm4UFlZoV6WFnFGGVTfA4aWL3M+oCMpFHuiTfQgEEv6KHDGxsKgIeU+lKnsL7GC34LpNq/Nzkfn4N9aongP5uS/M3/u2Ebrd/FmNYR8R9KP2qcwC+6nrgnxLDQFnfN0wLoY+KLsOISIIFLqIXExJShmtYM2FvOmH+Ff7vhxCQSUY0adqT7WfhB/jRetyCVLciTeKC/mldb3U1NCeJl64PnVTI1XvJvddj+uzfb/UNH1xXSF0Lp4LD/F1w669ysPSd/F49oWU0fD4cYna1/iUU0ZzXQ4puE4uUiiEqtj0/erV9CnUSamB64bV6OKxh1pODbIfdgdH7qdGBI//ABO3Dzwjn6lxZ38j3U2rLtlFoASrmqsurUqjGySHNUNhxlTChy/Xwcsjt6ZvXYrKLFgqFQLIhYcC27phDKnNqa7r4SQ0hjDbVMT8pvzTSt7cCsKtr2vfl0OsDKUduZS6yCuWSvIKY0sQTKVN6ULEUuAM3ortNjV3tCePYP+n1HnQR+zy+L7Tvo80JZhBftU+9YrEtspftcmy9uUEeXwcR0/STTGN7fK4MTRVHzRj82ac7fhy2sTR4w/Zj8852qLpGlFOO6vofUvYhA51PUp4SN5Pw9If+nEwrEt88nbBys9mh/AQnzTvoTj6/JNcs092iGfCT/6SfeKN8FP+rDi7ouqG6HbQ9Td8BvblNG8j/fj9RZmn0rO9oO/7q81ryS8Z/5bnof2yKquTvC7rWBuzlXUYLnKL9Ik22Y7WVnX9zb5Ig/KWyxDd1CyMw2c8sSjGNw/LSrNKV9bhfSw2zDOpkHVfTvM+ehok+9rbjCUO9LaEdmVXb4OdZBdQknzpubN8ttwmoSHCeRRgJdC5/QnQoq+PDHKnUAxyzT7ZIcoJP/lL9ok3wm9IsA3yVI/WyYDLQrhl9OUuC7q+NuSwHsygYYxfIJvrbtRDffJLxn/Jft/+0k5P8qF2bqKGSUtCO/ADSt6SPrEp20nq1wmXOnfQgDOOVdpgzp6zcVcYj4jfNsPoh64Jmm7CMYC4Cln35fTalIY0ZN95JyecRCjbtuXzFeHE5nUzxs16WzWdhJLkzTgGfdsChvkmXq38bRAAmUy38hZcMO+Hh+Rx+2yHCKd0AXfJPLFGWWfIrg2x0z9tWbeuGg5CfblLgq4fn/XaD5PRYNavDqcJRuyTX4R/y/3AflmOVzXTpF7gB1T2lvWJTWItoVknXPocc+CMDvilvf2w56zmCuKJxVx4obrY9yd12vESQU52fLmD3/Bin+y7Z1bC4zQLz4ZjNk7CGw4sONks4CH5qQH7Azxclukk2qz0vLz9CXDih5B0uZPlBnncPtshlikbwF0yT6xRUlHyrDC9+VokqVb74dEFX+66q+u72aPLNft0DNb31w1vqE9+Ef41ywX7p6bnDd4ih3LiNR2GS3aL9Yk2oifeU3V9594V0hA92WmIbmoWavARTwj/Ns/e7e++7o67x+ymLMo8+3338Pn45fzlj8Px7rg/PJy//r3/9PyrX3f7z1+O5y8/3+/+e6n40+H+MBvMfhh+Of1kT7f/AxrCjaNWMwAA",
    Absorptance: "0.1",
    Area: "42",
    "Calculated Heating Load": "4200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "3800",
    "Elevation at Top": "3950",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Holzdielen",
    "Family and Type": "FB 15.0 - Holzdielen",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "30011",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Holzdielen",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Holzdielen",
    "Type Image": "<None>",
    Volume: "6.27",
  },
  {
    ID: "578433",
    Name: "Floor: FB 15.0 - Teppich",
    Category: "Floors",
    temperature: "21.99101998",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "FwEAAB+LCAAAAAAABACNjssKwjAQRf9l1mloQu3Llagg6KKI4KJ00WJoB2JGahRK6b8badWFLtzNnXO5nLyHrMJDd1GQwpYqzEh3NRlgkBEae4U078fTFTzhS54IEc+9OOKzIAphYB/8J/0FvW9avBQWbVt2zsM9VlielVUtpD73GeyUqW0zhT3Z0qJTH+MRT2+0UVg39hmCRAoGa63uU1dIHoSRZLAkTW7X3LQeigcV02zSFwEAAA==",
    Pbi3DGeometry:
      "G7gBAB+LCAAAAAAABACtnduO9FiOnd/l922VoPOh58rwAQbsi4FtwBeDvujBFGYKaHcZ7YKBwaDf3VIopIhN8iO5I9OGXf3vJXKRi9w7pMhM6h/+7cff/+Ov//Nf/88vP/7w47/+9o+//o/f/vzrP/346cff//brX37/vz/+8A//dv7PHW7/bv+/P/7202vl565t/+7x/+3/78ff/niZ/fu//vVP/7rb/tzNzdgv60/D1HTb+lPXN+O89D8d693aLcf63I/9G3BcuF/Z9zvQDxmLi2Ju2qkdNTBNzTot3Zc4nhZz1+z/ngqLbUes/Oy8iXpsm3bcrGCfDAjovJemm2dTKDPWYWvWdljzBpxE1wzj2pnCYo0gCSfts6pzs7TblKvRo6q7Rb8ORrk1ELnCJrTC9cmVK+6Es66Wp1qpLosaDW2Lq+TawnGFUvlNoiyYHBMMNExvpqtKyqB6N92eaF0yhEeFZTHtoSgG2q779ctqpOAZmASc2uNyI06b91xXVeN4qDGIAYvjZFxdNcr5WFfFvPpItyq0MLYFerot0psaCwFJREnXENeHalNwCt467gUO1RDDbY2KwuG5R8cbnGJ4WGGs17H+89BM86IP725spm41PjJ3YBvHlAVTPPaoMriy0BRn2ha17YkBiOmqhIr1dYvUj1VqTM2wN2zGgiiiChkMZ9IKAIa3Q9FkNpIGAgSgcMT83EGqbFcbawDq9tztSEz1J4nS/iEBbm3qVEwZXd0WsgqR2hXXfxMBqMepUadSf5F4LDcdAGOz9vvR/NgU08GlkN20W2djv2mbK8EjjmlYjSdTbXPmsp2xz6PxYPzzfrSMU9lU+1mzA1OzdNZzgZENI0/JLBakB4tPhCFnjsnZFTXZYy1d9QORh6MrjcdRR31lgiSX+FPTb9Yzr+UKLC6FJXDnnrYg5e9aqTQiA94oRn6QxmtrlxYYFSdeHe7tCtsXyY/ad6Wr4zTFdcnwdn3ZubcgVrfvB3Nn5eHZAA1unY9oqIrODuVdnclGikwhX0i6iy6OdKMyhWNhUzjBRk1U6lEfq6egvUfCrYAGaWnjw8/gDna0THDaT42hM7pt2qNZ9n8fPrtleF9fhnZ9uFzGeY0NHIbT06HYtuVi6od1MSw+cYVpnMCh/vL2qHy7Ok75cR114oe2U2twHGXq3+4B2cLhqI0qzLwmQczjrIcBoLq3RUmOUYUWyKGAvtl7Y1YdOnRNuwxev0lPbAEUXucCQPX7zmhR2ysN2aC3K6NH7FZgC+LwKm4DmOB3hku7Y5mbtZt7Tb5MzTgMuhf29W5dJl0nNHAYTk+yeZaxmbdpNClOCykhB4XkF4cix6jCPPLhXq5UNS4NZVe9uyoqzhYOR21UYeY1CUIeVz0MYBy3wfpgntp1dCqrDlDHwqTgHkGAlPreaG+lStGvNIzP5dOVqgaJ7lnYHF5UNoAJfme42Id4xGAe1Ovr1mzDNmmOG1AV3A/jbTAsbiBtgRxdOzTt3G8a2XZNtlZ3+76+P+P1WhIycClOV3J/7EA39Z3JcVpIdTEqh71thm5eK8JKZJIO+OVL1urWUe6dd19FX6OFS1IbVyL7qiQhl6sqymJqtlbfNnhVhB5CC2C4HGGXGgD09TcGe1monfDMQnUPCvvmqa4URoNCTAhget8YrbNt8JTBPKDRH18TW58gL8Q6esex/RBhHoUMU7Mu3WB469ZmGBd9Yu/rXbsXVp+mZOFynL7UadotzdyuxrPty0brjJE5EextOlsfl05siXwqor696ao99VQn97uzomvZxGWpjiyhQF2elM5VHW2zNMPcW+3JBeWW8myA5nLGnasR7vbvDvq00TvkSke3lKf07a26OsxTE3VcHs3zSdTch1wFjhp3wrjut2TmqX9+SW0dodue3zJbRxuZuCynM32yXYjevV4A7TwZX114EcxNP65zVWyJfKzYIJ/bmz7bLkH1GfrmrewPtnF5qmNLaFCXKeVz1Ufb7N66bTQ61CspNIhjgzSXM6t3GaF+/96gLxu9e650dE+x0m/eqqtj9S7Fxghn+r1Re/uKquDlAzthHptxmawIbkRlOm470hrfMGUQ5pHIcPycc7836vs9z2FS6zvHuK2v30npm8dXOfJyWCYvbdMOnXP98ath49RbUXbzNhq0xTK5gcvfogHvRZDx5eS9cPPz2MxTt2lxbiBtEcnpXF+E+s5sA1LR0BNV0nFUKXZxeTc2bXfclyEgteiGpu2Pr1+VBQLoqj1OEaNwt4XM+j3cIr138hJAV2jxFhVylOFmLJCjcLUfO9swaqmu9ez1sbSeRRHrG7W5roSNHGFRPU/1gpc6zcc9/v6B1R4/G337zdShb/pl3D972nU37bd3YOrb/gGM41b8BHdZe9MAPLVN3w295vaCAu43jnWZBiuocv3i7veg5rff1GVPlAZHS/kxB0WFHDcwDPudoeTYHewCzN37uXlI2O3c+/9ox25MKmJ4QmovJuC+KB7/NtLG7ITBnYQyePTBZuph64RyIAXFdFNTsNg4ihu6OW5BbCiVBQbVNdMwbRX7Plaw3e9v+7hG/eOGuHt8IzHuj6lvt6PNNrWTBm4LyY0AuroBVCrN4SQ+DcezAe5JaeC0OXjC/v88Jtxios9vPQQFKvsyEEDCoqSoLkXcOGbTmh88sF1ogx1PvMsBqA7cD5Z1M86o20LpFFoojj2NbRnrOPYEZ90gL3LRB2zxeR5sIcnvBBEQHHt52mXTUl3rkpquj6VlCx3rNHWjVjCKSclEjjhYigkpqETT1GzjI+1xv0mdNg3InXH9mqjaZNcv4apNlnJVfFoxx7Q/ga6DE64CHFcYFeSxV2HYH3Mti8cvP7p5lADmgeHuzwrTuPoWkgMSxDzeopoepmG4blTHX8DK1r2j8jpRkoPFUajF+FR8kYvtwVGhq0/CBRGR/E1EadEP22yGi3lg5k9XEsAEnaiwtNg+WEE7qv2OeHyUQxvg4XNvweS+uXaB0bro6vEL1hUHA1rgieFsKIgK80BXWFksYNf0s/3dwKNMKu/9tmpZFk1NBuPSDMtoHd/kiUIKDTyGMmlMAoOl/fpuUXA4fQ47n6JFipQF5pc8j7CjkPyZeFaQegWPrTdM5odDXKRc075ykPvLpo6rLQ9nZ29XHkXz2mzdbK7302ZkcRkY676BYpia/UHDSIKBsRmH0XJ1AXkL5KjWI5NG0ZoXhSz3m7Ly+pu6HkjHBK6qszi+vB63CgNkGJt2Wuw+OAFVpDfunMW0NetjKyoLcsUWyDE3Q398IZImZ4sL8MItRazPg1y9W5TAFVW6FzjzkCNN/kG4tS19/NBnbef5uOKcNXIDz0k/y/H36P2qLbbx+Dphq7CwOB7DHJbjT42taR0WABbEcf09s4qq75phHX9a9/8cvwbx8nROR1DXX9NYNDUYcBKOgmd2+wf2ulmhLsNo6Seu/6BEV6zIXIpEEaGo4J+0w6rdVUgGGif2RUnJ0fW3+lYN/LZQLYydhypV9/BzFIFev2a7GTEdw480g2NgMzghVTI8Ad0DKKwTLAZltt+VnVymkKKuybcTMQfqqYgwszgF4UgPqdym5198lmM572Ux0tC/3HEvZmDGBjaxnmd4AtfOlQzG3MIgJDWIUlxvAGImY2Bwh0oU7CorH6kR1dOISIy6DMqABmrG5tcI8o3hMMs5oXEV6gqNFMa4ziALtqBo9YDPVIXy7V0dKkWkR44GuuKeJk9sAPvkWsdaa7lpU3dqvvtzXY9Gvw3kuO/Ywqbg7OT47IhaT+KOYtJDvQMOPsycvN3qcS3oSK7ZRX4fMCAPA1TK+6yTk+KjMoWFTUdVnwdzOHn4AO4NDteQBHsBRbQz50LRiRfdAeig6IxUQ0WLU/5tbKnaZM8xp7nrDf9iCm2ZgAXYBkxgO7q0U4Ax2jXMWcyOFdQGYBvUikoE9SnAOjrS42yjukF9sAzEwCGhJz32u9zsRkxyAHZoAAwUE8rBDJicHGgtYlKAmpmdzNow+GYGUiPbrp4YNoCeqL+NcZzFpn5QPWd7vu/ecppkZOKxqBGiCRsKQM+aVJE9J0pqegmIMZdRVNbI0zDHjJQyLjnjszR4DdOMJUFPAISuMA0lY5QG1UOlp8eOJlvBCAlbQU4djSnsoK5ty2lIcmuyaRDWTaIAYwh2efLVmdgsHDEjHLKa+hzGhdvQmicfeUvIb21qQJzYOB+vAnJAeVRNUjNsS9XI4MkYrZ2uveLQ48aDfdfpOeuRVMQRW3Cl8mE5FpUFQeHDSvE2Nc5m88Sx5pM+AGNc7LlujHJ1DZjBmC97AWp8bmnx9hfkflBMbsyw9aOK80iHa01yLTV8GxOgXF1/ie9bMEd1VHHm+QQxD2OG7WUhZ3eHBYTucSxsCmN0dwhAS39rtGocdZmGah5HWzU9O1kNo0ExKgAwwW8NF9rNOWIwDzh7jFGnD8CYPHutq/GkroHHoEbVBhbGDNtPXTlpqCmrpStZJmvwrHJV1A8tPI7KqOLMaxKEPIwZtoG6xqhaP6rYAjkMQI4BD9oKPTkWNoUxujsAqKW/N1rQ1hjdHVTcmJ4dWgCHExUAmOA3houbwBiAXAIyKmsychJADglYU05PQE2cPZeNwaTu9ejfmFAbWqjRtZ+7giyM8aqlKyWgHjirPBV9gAbIUB9TmHfeFaZhjK4NtVUTaoOoQgvkMAA5Afyxbk6O9l25JiaJ17kAUAW/O17UV03tFr6MRrH7wTWxWby4bIBz/N6IaZuYw48FoiLrjPHLaaQigs4YYPpE9HzZG1ATRyMTj0WNpA1tjGG1X/DmpaMGqApvWk9j7Kv2VraUY8M8cd3YG2tQlynlYwyrDbU2RtKGscU2zGMhYkT4uW4NlI58uTYmi9PTjGA9vz1m0lnP9BbOdNtgc7g2No0bGSCc5zcHjTvHGl76RPRs2SdgTBuNTJjFGEebsFGDar/kjdIxhqcKb1pPY7Ss9ibqxjbM80lssQY13jgfY1BtQms1jjaMzRhonfZm2cgJ4SdgTZOOAnBtbBq3qwnBin570KynGuktvFmdA/3h2gCPGxsgnOk3R427xxp+LBAVmzV+OY3kI7AG9z4AY+ptaSCB0EAyGCOAFcM1clQyFOvWRF8fIE/GCGA3t16N+nXdw+UkhDEA270+jgaCNzXIahO4yUoPwYN38mIM6T03gDHftjCQ66GBYjCm/UqGIlRrsm5hIJWjdXRkTfv1k7OG+gYcaEF6WHOwA4tMVJiHLUleq9BVvh6YB3KgK2O26LlfjMGmJfA2hjLpCi3eRg+ce94YCXoCejZmuS4pjBmYgYExA/PypKZmhhZy+qyvRxyUSBsFNEaCivWkQczAscqiUu2Mca5BF6BF1B5Go0XcryFEOWWztQs7M9+Axszu86A3Zi8HjWZMEg9cGXPPfVe0LThxovCCshVBjpQrO1ypIbqyBlu/OCbda2yA/axHhofUau656ylOO01RrYfftlaweIJEDPyJJC1oG4ctKJMwhvSeR7Ax97YwkLGGBorBmPYbMagZvYJayIQWHyfBBpLamPZ7AsYIZ18PdoUWyEH5dcaY6AtQM6qTURmZgysMF6NCDqqHMUDwsW7MsDzXjcmTviM0MGYa+tR6SqbPYE0ivDypSYQnYMw+VUBxgFiTTEsOIyqwMEacKosSQA5MkCQx5j8W65LaGnrpOrJmW75CEiMpg7oakzv9lsJoMSpMg7jZUzU3c2AjZBRJSqUnh7r7O3SkFMR6G6NGg83n7DHY+bjBnSNBzTBXQBmVMZE83PlqHHoJKAuHHFwZo+ODBDGPkDxvgVFhHlgoJ/PaBDMnsUwQTzfYssao8nAbqAHqZeZqqyGA5Mbo+FehFuPZPMGh8wBXYVSYYF5dLC0C6MopLVSQ8nA+NGHfuI1onpXGPNcTMOaglhYKCC0khzWX9gSM0bCBhTGR90MOzoMADtcYz1pKokprDJNV5PVAMipyVZ+HMbA2MCAKa4J2CajKGnOvA0CP1r7W1bRq3wAZMNhqCj3lXFGXAjpZAzW6MmZxu+VOecKgTIo0dXWs2IGUhDVn9AmoKZ2lwdtwzZyBxSDGrt7rcsJpYEAMetbsuW4Mp42pAUBuPdk1FrAclyqo9bp5eXV9wL8eohoR6DmwyuKaHCspynUKCetGsVIDYDmvP8m3ADndO6hzpwdaxxbA4URVy6GHRftSkbSJWlCxRY3UGGyhhlynDIiYUyYGVBUMkBlSq23X2E8yY9yi2GG8U5wOk/Mq71nX9iBLHoNcASAHjn6OZkLjSN0KIEmOFnqmIk56rAACcrQIOSqGl0ZdguSvmWe0XjKkZ9Wp9RwvXa9GOtKox/S6z0vXR/6zU+r0eo6Xrqd6fb7u8xpjeBAQHVEzrslAsvxswvOvvoiEEbBNzFMxPM9C0hGwjR7Sx+MGq5AoArZJ8KQnYRlAmh5NcBd8BYjIeTD/PE/H+th15RxycT35udfJj1gv3lxBL0e4l8l7+d4K4/p+d2itm+85wPntBnC/fWXr51WH5ALT/jm8A/ttnvHMVVMb0C4p0s1rB+SoCsWBcEQNaD3ybrpBnSl6L10KlF7gYSbgNdEV6jq8/dEPd9dNYczvloDIOmFRdlG8HjNIQG2FK++y1AYFZodJPHteMczHiJEDWDs9Mvujja6KZ2eHFqigJ1Rw2kbXv2QiOagS1S+pSTdmmAOFZOdAo+v39XbsN31+aoPixVnWOjqSQPmar/iFGchwOxJv3rjX52UwHPGbOvD9DBK4PQ3taJyvLjC0xgHL5Cgs6ZfX6XaEMZGwdoW4oqIQtB76Jz+oNiWAGRMDSUcZYCtdoZbnntdjJ4XxigwJiKwTFqKVEkDMIQG1JcqzzOPABCGPV+sLjh3olrHiXExseVVAzA8tUENwFR++kcFLKFsPpxj1r/NJ92eUBkZFeYz81o/jA3VfX4ZO/1jq7friZsFaJz9ivfjA1q+yUOvkv7xTsAwe9xYWYL9UBN8FYgDlTZuKygWO54kdmNclQ+4ISwJmhSqf6FRInrRUIwpJlgKBkMH2hIJjEl7aGC2+RchOw+uoM9zjy7PF+E7B2l8nh/H6HwmIzBMWZUvF6zGDBMS+eOVdFtygwOwwiUf/GwyPJ4EdePw5WXQwxpveqJ2dHFqggJ5O7vEbX18+2xlqUB2q30qVbsswBQrJTIFetnN9mKqTVBsU9wrWOjqSQPlxrU4OA0CO8l5BWzzvLiwAXycFL1DSQHnnZkXFwPFgoU5ZJkd1nXd7pbUqH/CsqFBdKJRTWlkPBGIOdIWyYx6YOXKgiJgH9tUZrjwHvYY7OYxXcElAZJ6wEH2VAGIOCYj9IQ83jwMThDyubaA4ns8E6YMy3P5G/TA9tEAJwVV0GscG5aOeksMpRe1L8Sq6M8oCo4I0RuflXsfn676+Db160isM3u8dbIA8ifXiE9x66ZdYJ//vtw6bafC42bAA+zVd8auSZNLXLZmKygWOJ4wDWOYMuSMsCZgVqnzWUyF50lKNKCRZCgRCBtsTCo5JeGljtPDaOUrD66gr3Kmdx0Sr3RzGC6gkIDJPWJQtFa/HDBJQ++LKuyy4QYHZYRLP/lcMj0eDHRjnPnM4Zra9qp6dHlqghJ5S0QkcGpTPe5YiVIzKVz5W9GaYBIUUVLUz3hP4oNiBZeoG30RIaCHoTAJlJp3xlkIJIIdQ0TI5hbcQeBdi4v1zKv27S1VsPvI4eA/keHVIIgJPZlQzL5r4IFSBuUJj0TAwVRpGYhZwxvpzMq4AHDS/dRPScTvtjnropy7Tg+888jWxEtAKRBaqzYL1mEECer9cmaviSw5MD7O49oSiOE/RHelX8ZUdHKO5Q0EVEZJkG5TSVSw+rmMT8SlpaUOFqX61dbpR4zwoJsgCX0F7PH0O+rlDX188Wlvr5Eeslw+3mbcoE0P5YK0Nno/iFgDv6XXe7CuB8lsOKyoGjq/h1AMJk5O0zsubs0q9vnmhmFBbqJJTV1kNBGIOdIWiYx6YOXKgiJgHdtUVbvm44LXbyWG8aFkCIvOEhWirBBBzSEDtjvIBwOPABCGPexcIise3Z8azhPOW7nDzq/phemiBEoKr8CCOrn/JZMvhlAIbJN1r2DlBFhgUpGG9XvZhwe+dDd9tmwGQowTQQnLge5yrAJ8cLWIOKWIVkCRHC6zglwCf3HrpJgIXh/1K2irAJ0eLmMOQJA8kydFCcvB7SGsAnxwtYg4pYhUQkBuvNEXgwYFvR60CfHK0iDmkJFVAkhwtVD3opbRVgE+OFjGHargawCc33/7IyIMl8/rJFJKOgG0kD78MtgYI6NEkJpFaVgFJcrTgQn4R8fnNl4IyctNErxhNIekI2EbxdPha0jokioBtEjxK0TokHQHbcE2/iEQRWC9EZOTWgF4lWoVEEbBNgseqdgWSjoBtFA+/LrIOiSJgmwSPUrQOCSMwXtDGyMnDr3urQ6II2CbBo9SpQ9IRsI2uD79+sgqJImCbBI/uxCokisB6HR8jJ8+XXvv3SQRso3sHX1ZYh0QRsE2CR++SKiQdAdtwTb+IRBE4r5Zdm23sT2SZxwJQJuzsRtCZBJ4W3ltdFYIstzP1os8bGbrOdPbBK00t5PY2r+1shsbANJ0/uFzbtx9cevwoM6tZo9ntjCNjnaloXqFVbRhJ8LA3LAGnwxIwDQvK6XCr3UEPw9tvW/tNePOo9y4rRGsQ2+hui5EEj0L03rk00G2gbDhTyudtjwieHZmX8+f4/TbMhQ2/5ztxSKiacqZsw4qSt9QJHtu8dAN1vPp88tbwiu4N8+HYMJ9uaYa5t/bpjozrtOgj2TJ5Pil5CDqTwG0xt+tqHDoWgixPYD3e4rbZJuvxxgADMWyeAazNMJqSaeD21ffDZgaGQLeto3FOM7ujMUuZF+ym58BYZK4Yh6YKw0iCh7x5FYB0WAKPhgT1OhD77I65PDq5A99YyjPIQrQCsY3utRgJeQxEb5zyFHR4OFMvn3uHKJ6p64a6MzVzQKiKUqKeDQvKsiXO7tjmloDF4fJQ61Q1IjdVIh+ODfK5byLGtunexsS8Pqd3YFjnzjURNyQGwL4UIu4Gjl/A3LbyTl8hzCPuR7TNdQ9jIcpG3Ekq0TQg7hatyBzk8ayzI+PQpvhZaJazSjTxJGqFxkJT2bxSq+IwkuBhb1wEzoc1YB5WlPPBZjuDfvyVwWY96RhteLLs/2MZ59Xgf0OEAikb0W0pJMGjELF53iQQXWDZcKaUz7VHNM/1aHIg3VQ+vMLJGh4SVkE5T7ZhPclbeIJnTMRDqFbGqw33TUUXckeF6XBsmM99HyEluD+q1XFsmIh7EgNgXwoRNwTquLEQ5hG3JJbNeRujEcOmvJdUmql1cbtoxcXI+aSjjmhk91RmLSsUE4+hVmSsMteMY1OVYSTBQ97cGkA+rIHHQ4p6PUiddsasjk7swYtDHUIWIvJP2YheSyEhj4GInaOOQYeHM/XyOXeIxXM+mFQcqtEBYZWT0vRsWE4WLTi7MybiCdQShktDbVPVhNxQiXQ4NjufbWq251fixTP4Njdtv3Xq60Dj+gcDrpMfvX5d3019p7/psgBiuNbn8fojY2EwbKvtSVlc3OvWDqZKCrhcLcd/jaBwfewW/aWgR03CooBpnS4DjAmVxRphUKoWCIQc6Io0xzQwcaRADTENrOsdbfG9nNdrN0fx/ZYFqMxDC9VVIRByKEDtjeKbNY8DE8Q87k0gOdppnPVXdM4BGW99WUDMDy1QQ3CVOIYjg1soWw+nGNgi+W7D3gnScKLy6yo++W8G+QSiry/0k8voxgDKDOSttQUgRymfYXEKbgDKouxyLZNcL1vZiImBx2ErH0McapQWFcwLVX70GUGhtFgljEoVA4GQA12h6pgHZo4cKCLmQZU9o5WPA063nQzyvtoCyrwzFmVXZYCQQwHl5pB39B4HJoh5nJvA4DhPSHo0qN36RvUwO7RABcFVcAzH15efekoLpxDYHvlOw74JsnCisvNYxmYcN7319vVpsX5yZRg8GJx1dKSAy2I+ZjOp88MCkOMEpqY7Bv5aFtto/XjHsjjJp/34G3SHGOuXo6GzfoTlAf066YMWmR1lUcC8Thc3xYTCYo0wKFUKBEIOcOVoDnlQ4g4FSOi0GnXUGaw8BbHVLgZ5slhAmXbGouypDBBwGEC5M+SxxhyYoJPHuQUMjmmzfpyEJ2S08Y3yQXqOBUqISvmncMLg1onkwFpAh9Q0G7ZOmAZGFZRVPujeHOJ7NMuglNAAyJNcL5OQXxpZADGUAhoGp+QKMCzKNlc6GUDZzjooWn8ctfLLNWZmXVG/tEzFx54REuqKFcKYVCUQCDnAFSsOaVDeDgMo6DQa9tMdbPGlFzfaG0fxPZIFqMRDC9VTIRBwGIDaGMWXWMyBCTp53FtAcpwHpPw+jA/IzMaXFYQEHQsUEbWKT+HQovzsMyTBekCX1DQctk+YB0Zl5zHt/916Yw9OQ9N1xu/8WwYPCgbIk16/ru+HddEHiQUQw7W+DK3xC/A7MK7Wb8ZbFhf3tsybqZMCLlfrZPz6v7feW7/771GTsChgWqfLAGNCZbFGGJSqBQIhB7oizTENTBwpUENMA+t6R1schV6v3RzF2WIBKvPQQnVVCIQcClB7ozjYPA5MEPO4N4Hk6Maurzsj470vK4gJogWKCK4yB3FocWtlS+LUA7sk33DYPkEeTlRBacUz700hv1AzDEoJ5To6MoAyCfntkQUgR6mgYXFqbgDKomx1LZRcL/vZiImB3vqdQ4capUUF80KVH4BGUCgtVgmjUsVAIORAV6g65oGZIweKiHlQZc9o5bdgTredDPJ7JQso885YlF2VAUIOBZSbQ36p5XFggpjHuQkMjvOQlN+POYekv/eN8mF6aIESgqvoIE4YlJ99Sg6nFtgh+WbD1gnScKKy8xiOIdLngK9hnF670lgvru/7ppu38ZN18l+s0/XS//6fY3bax8suKVweOl/GYapfzlHC1YXvt3w+XfdY6fLI/dg147bOn6yneOl66f/nsZmnbvsi4FKjQUwh1asCkuRoITnaph06o8Mq1n1mMkgQFJuvYj3LS9cX/t8T+xxwqdEgppCndxWQJEcL+uj4wrrP3I1N2z3mBSSAB8UNSAWrgCQ5WiiOoWkfd91fAgJytMhwFFuyCsiTo0XJ8Zbg50BAjhYhhzzlq4AkOVpIjnH/5zB+ad1nJoOIQMpXsZ7ipetV2drjGyPjY7AKcKnRIEVRbsgaIE+OFgXHW36frvvMZBARyCO+Yj3FS9fjR8uXAJe6f/z9fLcfXEMzbfPiAudDxw20+1N7/8l6lpkMSoL9n3039F9Zd3np+ti/UK4KSFKjgaAY5+MvPZcvAj45WsQc7fHGoE+BJDlaSI47wS8BPjlaxBz92rTzOn0GJMnRQnLcm+ZLgE+OFjFHtzbj2g6fAUlytJAcx89tp3b6IuCTo0XMITdnFZAkRwv+lPkK4JMPXTMNxxecQ9+0Y/f2hWO3Px0eX4nu/2Pt335ob1mgqwtAVwq4LJa1P4G5mwoLBSDHCfRNv0yGQX/8rYe5Lq8/mftm6rvOEMoALk+Pvz+xQmJgOV4y+khz7BLkjrSoYFqoixuDspV1agQx6VrQesDAjlBx6g5MmhhIPWozbKdnqLvHacz12Unx+PekqV/rZc7x9aKVEkDEINfFhnjlLAqtLSg3yuHZ9Zph/0AbT6D48hwPxni/68pBeo4FCYhCRWdvwuKWihSBYmCD5DuN+iZMAkOyk+j2tKdu1GnvwLwcruVJalmcn6kOgK4UcFks2zLq48MCkOME9oTXzTjSuiPKwQaUxUm+d/owzYZWBnC5GrvnsSmjQmBYl04ftEzuqIsi5rW6yDEqUNcpFERl1AOBgMNxhbJjl2DmyIEiYsNhXz3DFeeh13BPDnHEWIDIPGEh+ioBhBwKEPtDnHAeByaIeTy3geaYt+t4zR2W8QGgKwgJOhYoImoVHcgJi1srkgTqgV1S03DYPmEeGJWdx+MXdZ7kReaP34mZyyMDLR4cDKArA7gs+mGb9VliAchxAcvQLabFY6qbBSiLi3xbFuNWyQIuV49pc1ZUDPRHU8hz1yNHdVHEvFaXBUaF6mKhMCpVDwRCDnSFsmMemDlyoIiYB5b2Ga44E72Ge3KIQ8YCROYJC9FXCSDkUIDYH+KE8zgwQczjuQ00Rzf2Xd1hGR0AuoKYIFqgiOAqPpATFrdWtiROPbBL8g2H7RPk4UTllPa4mWjX468W9Z8UHEBv/JHDu8FLQxMgT3r9lcR6rrd9v5WaC4AYXgK2q2nw+FVZC1AWr04/Xjpp6KSAV0MPmxUUrh+/NnKsd1un/1ArXyJHwLROr88/iAmVxRphUKoWCIQc6Io0xzQwcaRADTENrOsd7Tz3farXbo51mQaT/AJU5qGF6qoQCDkUoPbGlbkqubTABDGPexNIjsfvth/A0hp/pfzZ3pcVxATRAkUEV5mDOLR4ffyZkjj1wC7JNxy2T5CHE5Wdx+Nb4MnYg+dXrupota4f76+TAQBHYvm6ell7fYgY6+B9vL9IPm7a1fXHN8+rDSiL19f9bW8oZACXq+Hxiyo6KFxfukWftUyNmpJ4WZHunzJQQCArl8eOyCgDAj6D44nUxtbArJECBcQuw2a6oy2OP6/Lbo7iPLEAlXloIRsqWg8ZFKD2RHGUORSYHSZxdb9kmNdxqjkTMzteVg/ScyxQQlQqPHlDg1spUsQuBvVHTadh50RJUEh2Dsdf4y/Wb+xZQGlh/LZQHkCOEkALybE0XbtsX1r3mckgIpDyVayneOl6LNuXAJd6v19cHt+8dGPTPdrTAa5b6BuYxqH/DMiTo0XJ0e67blm+CATkaJHhKEWsAfLkaFFydE0/919aD5jJICCQvyNbsZ7ipeuN30oej69Cv7Du8tL1kX+pW8V6ipeuV/6X/f5yNApZBfjUaJChKDZhFZAnR4uS45Xfp+sBMxkEBMbv7mfXU7x0vfQ/Tc02Wh9lVYBLjQYxhTrQa4AkOVoYHPO0Dl8EQnK0iDnKU70GyJOjheS4E/wcCMnRIuBQn2g1QJIcLYyP03k4bh6/BATkaBFyGHcLeSBJjhbe3e/nQEC+NevjJ5dqGxjAyTE3Q//4S42vAAE5WoQc6nitAZLkaCE55rXZuvlL6z4zGUQEUr6K9RQvXW/476fNuHWoAiJqNIgpiu1VBeTJ0UJyXPl9uh4yk4FLIA/TivUUL12v/I/NOIxfBXxqNAgplHo1QJIcLRTH1AzTbHzkVAEBOVpkOMoNWQPkydGi5DiGFYzbF4GAHC0yHKWINUCeHC1k77bTYpW2BgjI0SLkMDZnHkiSo4W657w+078E+ORoEXOoW8saIEmOForj7UbxcyAgR4sMR3kzWgP45MdEyGVdj7D7dXj9+OBYn+fpWG+Xt8moxvXk514nP2L9vn4aHw9f6/Q2YdxYJ//3ejvutyGWQb+7NAFpcVIPu3jtYGhkAKerYwxlP686KheY+ke3t/2c4HZ0Jf2yOt3MZkSesFQhikgWAoGQwfaEcmMSTtYYrK0fZuG10xXtuL39jJT77OaYm6XdJoP8BYjEExZlQ8XrMYME1Ka48i7rbVBgdpjEs/sVwzxsD2Aa27Le5rGY2fKqeHZ2aIEKekIFh290/UsmkoMqQc2RbjNsmzAHCsnOodtvE+ZZJ72vt2O/6aNUG5wMzjo6ksDTYj6GQBqnigEgx+1q7BfjRNuBeRksV9riJu/WbjGU0sDtamhH45x1gaHV5yxzo7ioYYVUtysKCrWFMjmFldVAIOZAVyg65kGJIwVKiGlgU13Rlseg120nhzxcDEAknrAQXZUAYg4JqM1RHm0eByYIebw2geDYgW4ZK47JxOZXBcT80AI1BFfxWRwZvISy9XCKgS2S7jbsnSgNjArz2Hdku2e+jccvcr09ARpAaTH350fzRwBylABaKI6xa4Zx7b4GBORoEXKs+3+nZf4MSJKjheLo94V1/Mp6wEwGMcEyjOsn61leur70/5bY54BPjQYhhdqQNUCSHC3wNPgSEJGfzyXLfrjN/bsi5zPAvr6M21Ksi+vJT/EsYfkR68Uzxr4+DbN+HHpbJ//lw41l8HgcsgBpUT6AKo0MoHzOVFG5wPElyAG005Qgd4QlAbNCld9GqZA8aalGFJIsBQIhg+0JBcckvLQxWltBTMPrqDPc/ZZpeftemlvt5lj2s3AzuO91kXd4fdlO0XLoXayL/fDKtyy09k9ZUfSPpjfcP76x2IG+b8uvEM3jMN7qRsXs1NCCxPNEcs/c+PryOyhLDagC9ESytahZwvAhGjv653OHSve6w1dHpzYoHmCsdXQkgfIZQh0VBoAc5QOMtng+8liAtCifM7VSGigfJ62oGDi+71DHKpOjuihihVbl109WVKguFMoprawHAjEHukLZMQ/MHDlQRMwD++oMVx6BXsOdHOJs0esi7/B60VPheuhfrIt9IQ81h4ASsxO4el8RPL+dyB+P4aY3qobJoQXJB56iIzg2KL900nJwIagzkh1GHRNlQAHZGfzxpx//8dc//e9ffv/lrz/+sH+y/vTjv/3yl3/+/V+e//jvv/3+p99//e0vz3/+r1//6Yb+yy+//vO//P78x3/68y//7/3C//Dbn3/bHf74d//58X9+/O2P/x8nPxNCG7gBAA==",
    Absorptance: "0.1",
    Area: "806",
    "Calculated Heating Load": "80600",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "3800",
    "Elevation at Top": "3950",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Teppich",
    "Family and Type": "FB 15.0 - Teppich",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "556263",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Wärmedämmung - hart",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Teppich",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Teppich",
    "Type Image": "<None>",
    Volume: "120.92",
  },
  {
    ID: "578586",
    Name: "Floor: FB 10.0 - Fliesen 15 x 15",
    Category: "Floors",
    temperature: "20.0739562",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjj0LwjAQhv/LzWlISr+dRAVBhyKCQ+lQMbQHMSc1CqX0vxtp1UEHt3vuebl7ix7yI+67i4IMNnTEnHRXkwEGOaGxV8iKfhxdwJOSR2EQzrw45YkQCQzsY/+Sv5z3JcvX+3nbVp3r4BZLrM7KqhYywQWDrTK1bSbYka0sutojHvD0VmuFdWOfEKS+ZLDS6j5lpc+DKPYZLEiTu2tuWg/lA339lh8TAQAA",
    Pbi3DGeometry:
      "SDcAAB+LCAAAAAAABACtWk1v1EgQ/S/mOrT87elwQruLkOCAFqQ9oBwSMYKRshkURkgI5b9vJ5Pxut31ul7ZAREy9fzq9YeTruqqz7+LD9f7T7++74qL4t3hev/xcLP/UmyKD4f97fFHcfH59+nbAJevwt/ifvO/5WVVlq8ev4R/xf3lmfb67u7qV+AOrioHvwlfXNX0w6aqXdsP9eZsD5/LpmlHu3eNb7rUHv6v/VA9Am2gigDlCY2IUY6B1vm6GlJPOmO9BjGLaJkm6y3bt+GbhncTP453Z+vqML78tgHGTALZkSPjzKAf+F60ru+3fvOyrVzrt30K1LUb2gfqZDMb34kAdAUYg9u2TZUC4XPX1pIrlfEMGvZ5TICq960uPl3dmHEGqs41bVcTGhkAuJqMCg6Xnoc+8xjwrvNlJYzqDPAMqIFmXjeu8sLOnu3JO9I7X7W9ACBHiNCU4eexFxgQqL3bVlthzUdGMiiVQQ8XAxONaM2h+NRVzOjC50F4d0Yg2T7oCo6KmSAnPi4iBOhR6a6SmTMTjIHSbYe+S8/WEZgfBQ+/EB/EU6BzbV22FsYEiI4hPCq7ePi10D0cdYkrlfEMGsw85hFB+C2WnuRT7XipdE+rJcYFmREmC8URkAIcEnxB4FjhHoWfGe9rIYDtQiwkBJdnexIKAfsoQCunQZvvfCNFr492IZiLn4/doMcrIfY7AWnQyRLWShinIESpeV0hAYvsk53JCiA78lMJqQ4PmOccA0I2FQM8A2nAeQuRVQxMzqFRex4hngAhpkwA0lVmVLp4DAjBJsl4Bg1mHvFaCVlaDExCPtJVwmA2KgKk1CoGaAYWt08w40p+S6RYMAYShhCOnQAhgFMYQuiqjAq5ksLKPACHKwW7JIMerpCNRfbkrYIrBQHgSUqUktlFniBDytIWaiyYH3SFdkkI1Gb22bElRXBZT5AghXznwc6jTZawVmLVJKKTFEsLGc8JEBK0GJifytgVHBWchzqqRBxqCOkWyUg0IABdweEK0fxpy9PwP7InoRCwS1lBXhndzRLBKpVHoMtiQhc9j4LwpfZ1t/5c3kSbl5QagHOYevH2bMWCLzPM3NMZHyx9qNKQQCeVFmBpoYbRsGd4K6t+WENN8RhAEYcMe35pAUhxyJhroBzWYM8ra1VhJDBfPoOd0kXPE+eO1Z7V1Us9SZ4Lc2kLsLbOxCfyFkARt9TkFqbluIpnr/upqf8qIC8OGfbrBRNAikOGcFMBrzB4IC+u1/ehhv2uCVa5Lc0FUANeW/GAKq7X97mbIxPAi6uF/2Q/lgOquNLAYLmk5QFSHDLgibMKyIubyr35WzYTsLBsbb/iMwELa+aUhv0SbG1zg3ovuArIi0OG/e7RBJDiTKfLaT/QvS5vzytrbT9IAF0bE3ZKFz3/DBfAWuNSYrd0AiUS9orG2i4dqAErMxZAEVcbl6AGLCQxACkOGXT1xwQo4kyLkP1qWgV4cbXp5nwPJtdBTEBenGjsgRpc+QK145hbimB9BJVseHtWV+9YQv7n74wFIKUhYS4BS0IWQBFn+qjsFSwV4MXVDrxkO5YDijhkqBp8oQp2EqrikCEUmGDNiwcUcbWtFGoki2gBSHHIyJ0yywFVXGkcFGau1A4ZgBSHDLbSabDnlbVOTSQwXz6DndJFz8NtWwXkpC83xZ/7q393x91dcVG6clO8391+PX57+vD34Xh13B9unz7+s/8yQm93+6/fjk8f/rrZ/Zw++Mfh5hAcFi/ePP4p7i//AyjlPDhINwAA",
    Absorptance: "0.1",
    Area: "55",
    "Calculated Heating Load": "5500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "3800",
    "Elevation at Top": "3950",
    "Enable Analytical Model": "No",
    Family: "FB 10.0 - Fliesen 15 x 15",
    "Family and Type": "FB 10.0 - Fliesen 15 x 15",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "83241",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Wärmedämmung - hart",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 10.0 - Fliesen 15 x 15",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 10.0 - Fliesen 15 x 15",
    "Type Image": "<None>",
    Volume: "8.22",
  },
  {
    ID: "578639",
    Name: "Basic Wall: WC Trennwand 5.0",
    Category: "Walls",
    temperature: "21.64471304",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyFkV021nooKgh6KCB5KDy2GNhATqVEopf9uoK0HEbzt7BtmJusgLfW5vSuI4eBKnTrTVs4Cg9Rp6x8QZ91wBgPNuIwkrRGJExFCz37BJacVym+4QMJ/cIrNp/qkaYo2bAiPrS5uyqsGYsEFg6Oyla9HcXK+8DrMHuRFXz9or3RVhxYUHCMhGeyMeo3m0DeXETHYOONCsH0a0+dvUPNqohQBAAA=",
    Pbi3DGeometry:
      "wA4AAB+LCAAAAAAABACtV99PwjAQ/l/q62zajq0bPBmFmOgDURMfjA8QFmiCzOBiQgj/u1XGr63Xu4Ih/FiP777rtf3u+rZmw7F5WX0WrMseyrF5LudmwiI2LM2i+mLdt/X2pzWLnn2xTXQYuZZC9P4+7Jtt3newm+VytLJYFfNUpyqSUvGOFDr6/U61io4NSa4TjyHnWSbzqOVKKZ7GOqMgEi5ykTtdhXOA8wAQIHliEWnmCbfFgSJaBs1zKZTDVcaliB3jOwA9WhCxpWgnBBpHHAWkA2LwrNHWU3jGD4hEKukKth5vr0TDcKA48XQULAZoB3suBTQJkCHhcZy50pFwqTuZx5XDALoCyKFZgID2PtgbmmJ0inAZmgqCT7x5VvHkIq7oHGC4YEo8rpAkQoigcMGogHPpKSfICoavOYGDqLbhaoHrDiqe4N5p7jZQJHEEsj8v4cDlAtERAjlUTxDh8RwNf1tBL5aQQvvHCVMI5QUnQMwF5dxd0HuB2wkxENQZbxHITcXZBRzsmf6jj6OSE0QKa0fBcD3qjBgItQ+/BZDvJng7AFZ98HoQemkJ4KA2EARJd5Lbm+CdGX0UVbFkXcFFxB6LxbSa1Q9PZTWqTLmoH1/NZG+6L8x0VtUP/XnxffzH23JeWofsqj8Y6IG2N84f7DOw58AOAAA=",
    Absorptance: "0.1",
    Area: "2",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "WC Trennwand 5.0",
    "Family and Type": "WC Trennwand 5.0",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1850",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "WC Trennwand",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-400",
    Type: "WC Trennwand 5.0",
    "Type Comments": "Mauerwerk",
    "Type Id": "WC Trennwand 5.0",
    "Type Image": "<None>",
    "Unconnected Height": "3100",
    Volume: "0.1",
    Width: "50",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "578640",
    Name: "Basic Wall: WC Trennwand 5.0",
    Category: "Walls",
    temperature: "20.3346073",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjkELgkAQhf/LnBfZGUPNTlFBUAeJoIN4UFp0YdsN2wIR/3sDaocIus2b7/Hey3vIKn3u7gpSOLhKZ850tbMgIHPa+gekeT+ebMAwoCWFK0QKiAhhEL9gwgdG3xAp+Qvn2GKuX7dt2fEGfmx1eVNetZDKQAo4Klv7ZhIn50uvefYoL/r6QXul64ZbUAYYy0jAzqjXZOa+RRSTgI0zjoPt05iheAMeSPqiFAEAAA==",
    Pbi3DGeometry:
      "wA4AAB+LCAAAAAAABACdV11rwjAU/S/ZaxeS1JpWn8amDLYH2QZ7kD0oFg04O1wZiPjf183vNie5KaI1Pb333Jsm596Mt2w0NW+br5z12FMxNa/F0sxYxEaFWZXfrDfe7v9WsOhXH7aLzndupRD9/5/qy3YfR7O79XqyqWxlzFWm4khKxTtS6Ojv2tUqugSSTCcOIONpKrOo4Uop3o11SrFIuMhEZnUVzgHygBwJl7qTWi06sps6wrVYQFcwQZCHI1wQleaZFMpCnnIpYsv9o4GFIo5Te35wRmDiHld0DhjuPj/bFAJPyMDDEBArYmi+bqlSK8PhfvOl1oAz9ZWnJgM0aCbRlgIlgZ6HzHCamqvmBNS3pJ+jrmvX5DagLkY1cshBT9ABuF3hKQmfXZggncOzM7AYgcUTsDPoDP4KB1dCOOCpoiECWZdUuDmgOlN3DcGCWvpCoiJnjuTWIzwB289Xp5HSu7WQrpFu/wReX+XxAZRF7u8hYZcD15kHoCuOFyCU9dalErYUjuaL3P9QyQna6dNIGK6jQ4f1tS1AIA8v1f5+m3w2ad0nODSyLeAhr06CD2bymZf5mvUEFxF7zlfzcnEYvBTlpDTF6jB8N7MT9Jib+aI8DAbL/OfywftiWVQO2c1gONRDXZ04fwGlZSNMwA4AAA==",
    Absorptance: "0.1",
    Area: "2",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "WC Trennwand 5.0",
    "Family and Type": "WC Trennwand 5.0",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1850",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "WC Trennwand",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-400",
    Type: "WC Trennwand 5.0",
    "Type Comments": "Mauerwerk",
    "Type Id": "WC Trennwand 5.0",
    "Type Image": "<None>",
    "Unconnected Height": "3100",
    Volume: "0.1",
    Width: "50",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "578648",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "20.24312194",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjsEKgkAQht9lzsuyq+aanaKCoA4SQQfxYLTowLYTtgUivnsbWtKp2/zz/cw3eQfZGY/tTUMKOzpjRqatyAKDjNC6O6R5N4y+IGc8lAspAy7CMIKeTSgQPE5U8h9GUqgfOB0dUPFRL5umbL3fL9ZYXrXTDaSCCwZ7bStXj+FArnToXx7iCS9ftNVY1d4hBY/miWKwMfo5lt++WAUMVmTIH7YPY/riBfKAqDMQAQAA",
    Pbi3DGeometry:
      "qgcAAB+LCAAAAAAABACdVV1rwyAU/S/u1YmaT9OnsTUMtoeyDfZQ+pBSaYUsjkwGpfS/T7YsDUmMNyXkQ4/nXHM9XtcntNqqt+OnRBl60lv1qku1QxittKrMF8rWp79PC9OFvdAZX3puGaWL34e90XnzT7ur6+JouSwiAcOMcUKDIMScExFHAve67TuME445JaEQfAg4ZJzjBwCEEadJCmB0ACDDGWMMCBlNLv+dkkhQMQQGjDazfcbYdKcZ3uAW4CyIAYxODAejXdip7qFtptX9YcEAJK8gz3pDT7nD7ydQVv2rANN3//NsL01Jzc+Tc7rj1gcB05seUnH8Ug6XwwrRfM86GVfE8O3UvgxwF12bJVjlAJcfwClkz7wHVXxII2uUUUIxepbV3hyaxos2hVG6aprvatdCj1LtD6ZpLEv53R14r0ttBdHNMs+TPLFn6w9eJg+kqgcAAA==",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1639",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.6",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "578649",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.74692705",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjjELwjAUhP/Lm0NI0tqkdRIVBB2KCA6lQ4shDcREahRK6X830ip1cnv3vuPuih7yWp+6m4QM9q7WuTOdchYQ5E5bf4es6MczGBjBieBiSSnDJIpiGNAMpliIBfsPY0r4L5zFjrD81K/aturChvDY6OoqvWwhI5ggOEirfDOJo/OV12H2KM/68kU7qVUTWijBcSo4gq2Rz8n87ks4Q7B2xoVg+zBmKF/CQRZ7FAEAAA==",
    Pbi3DGeometry:
      "JgoAAB+LCAAAAAAABACVVt9LwzAQ/l/iawxJ+iNt9yS6IujDUMGH4UPHyhaojdQijLH/3aCrrluuuTC6Nv363ZfLXe6y3JPFSr/sPmpSkAez0s+m0WtCycLotv8kxXL/+2hhPrM/cqD/b64F57OfP3uRw9tAu+m6ame5krM0UxkVQjIeRTG19zhVksqEqVwpDJCzLBM5vTAlJcvTJJ9g5CxJlAhhgBqgHxlTXEQO4FwcZgziIBDuB8hAa7j8iAVXTj88wKBxMt0xcK7hmu6YAQKgKdCPiCVCuoCTmI8B0I+IpSqVIRrhpkDGBeBlgA6eA66EmzYFLrsLCN9RyEzEMJBlCR+PkJiPNcKLJagRnomgOJglYJEBYw5mCQYANaYrdbi433PMWk1P15+i6ELmXxLMVkPuj/DmhS/h3v4BaoB9EAMgGwum7nrEQ84+qBJuz1t3unqv+7ojBWeckse63fTb4+DJ9FWvTXscvur1H3Rf6822Pw7mTf11+uGtaYw1SK7mZalKZc9130+RZiEmCgAA",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2803",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.76",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "578704",
    Name: "Floor: FB 15.0 - Holzdielen",
    Category: "Floors",
    temperature: "21.27686287",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCnSNzPQsTUxMrXUNLfWMzSyNlWp1ELJESWKT08WQjIVZ71hUlFgJdANQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhvCDc9MgUt5pGamZ5SAOCaWRoY6Sq45qWVQtYZGeiZm5kY6Ss75OflAc/NKc3JqYwF/RhcJEwEAAA==",
    Pbi3DGeometry:
      "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",
    Absorptance: "0.1",
    Area: "155",
    "Calculated Heating Load": "15500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "3800",
    "Elevation at Top": "3950",
    "Enable Analytical Model": "No",
    Family: "FB 15.0 - Holzdielen",
    "Family and Type": "FB 15.0 - Holzdielen",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "81032",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 15.0 - Holzdielen",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 15.0 - Holzdielen",
    "Type Image": "<None>",
    Volume: "23.2",
  },
  {
    ID: "579067",
    Name: "Floor: FB 10.0 - Fliesen 15 x 15",
    Category: "Floors",
    temperature: "22.92414202",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKwjAQRP9lz2mIqVJST6KCoIcigofSQ4shXYhZqVEopf9upFUPevC2M2+YnbyDrMJDe9GQwpYqzMi2hhwwyAidv0Kad8MZApEUPFYymUeJ4omQMfTsQ/+Cv1j0BYvX+0XTlG3YEIwVlmftdQOp4ILBTjvj61HsyZcew+xBHvH0RhuNpvZPMVVywmBt9X3MypirmQjekiyFXnezti8eBrbylBMBAAA=",
    Pbi3DGeometry:
      "mDQAAB+LCAAAAAAABACtmltvEzEQhf/L8ppa670lW54QFyHBAwIkHlAfWjWCSKVBJUKqqv53TGnSrMdn54wNiIrN15kz9m60c/HXu+rDxebz7c91dVq9215sPm2vNpfVovqw3VzvflWnX+/+/Tfg+nn4W90vnj458XX9/OFH+Ffdn+3NXtzcnN8GWz+6fqz94sT3ru36ZtG0buzDBwfQNM4PY/cElm7VtSnQubEd+wew7No+CUhXMKoZ8WFYjQmLGQCi2lvMLZAUh+Eegcleheth1bQzoPOuG1eDwZWw2IcLwdwdjIHiKgGAK7QODBhXk21va9eFD+SNOoDYohndyq8SrprBjb4bEtt+BDhXMCpKfAr6cL3sE65Ui3INah2TvTre9jSIHx/dlbCAN6p1dT8qdzBtITQgQK7sC8RRoafkJFg04Tvow/dhrAefAE34ovRHFkvnR98mAHQFLXzt/N/fTJJ2CEuWzhib/6FTtppuWFExHzmbmhxtfxrUy/A8dUvCFY4LLkUNS6gfNhITQ2CEtxTRlzkFrfPep+7xAcQb07p22XVJAF0Bi8GFnUw9E4Pre59+JDWLco2idcTPChA/cgXuBwLipkNXMKqZO6hEJcT3mwgBH5XqKgH0BU6AzPU613XhA5lPPgKZVcUWsStoIXM9AkSZW2yRAIoFHy4D/r1IVXFRJMXgkAqpGhBAV6LqSIRLroNZeQygeFQ95YeLopLJUwzEQy2yKs0VtJB52B6IJJC2KNfIWIdIGzVxWSTFIL61WAMB7EqUIxZgX/kUiJInBrwF0oArl3lZDA5vgz0QSdEeyDxKNRF5pBrWnHqU31EERCxzT4MNH7SolQTYZ1PqjqlbKVzJ4oIiUdmT2jGDDdCxr59bzXT7RYIWg4RFlCM9BRxlVaqFyCeJqKB4lOsRAIQrMlDagg9XFEkCxHd9Zq+UTRSuRHFBgKjkSewVbQE07Ctn1jHZdr0bL5InNQPVgdp0Vy34ZJYH+XMIRsNeEXAdZkMXO663CkD5VIGuAg0ge6SBS9CcSjM9hyiYjkANSzULBy320Yy9YmZByVxI16ArTTh1s84b1Wq2ABDi0MJeMbOAFtfnpvAdZQeauD6nizX02lQH2UNCqGGvf/UhIT1WpDS4LgkeSjHi0AJ2F3JB+byR7g8ZQPawEzd1YKuJB+ogkh92xhp8nwuOYFVxaMH30niQPzFmNOztrNKTCGqfqwCo4tDC3kvjAS0OLeAbpwBo4sQEX5avWrtKBbw4tKA7XzxQxZmBN9SwN0NLp+1MwzEXlJ9AgBqwCa0DWhxa2PrGNPkfByCwjK1xjY9T5BzByGmQ04SKgDg1g3Vy2sfl53aY1noJoSLANjktfJpYIsA28KWUD3T5maM1oNU709FlgSquH0OCGrABrQJeHFoYuvgsIMT14ztQwz7SKT87pA9PcgEhrhynsk/SdECLQwvL+IsFqjh/ACvWsMze4LEw+0Ey+3yPBYS4fuIPatjHX6XHDfWJYD4gxKGFferIAkX8bFG92pz/WO/WN9Vp7epF9X59/W33/fHi43Z3vttsrx8vv2wuD+jtevPt++7x4vXV+vfxL77cXm2Dw+rZm4c/1f3ZH8g03fKYNAAA",
    Absorptance: "0.1",
    Area: "40",
    "Calculated Heating Load": "4000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Default Thickness": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "7300",
    "Elevation at Top": "7450",
    "Enable Analytical Model": "No",
    Family: "FB 10.0 - Fliesen 15 x 15",
    "Family and Type": "FB 10.0 - Fliesen 15 x 15",
    "Filter Tragend / Nichttragend": "No",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0",
    "Height Offset From Level": "150",
    Image: "<None>",
    Perimeter: "61980",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Slope: "0.00°",
    Structural: "No",
    "Structural Material": "Wärmedämmung - hart",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "150",
    Type: "FB 10.0 - Fliesen 15 x 15",
    "Type Comments": "Bodenbelag",
    "Type Id": "FB 10.0 - Fliesen 15 x 15",
    "Type Image": "<None>",
    Volume: "6.07",
  },
  {
    ID: "579611",
    Name: "Stair: Massiv - Stufen Naturstein",
    Category: "Stairs",
    temperature: "22.89154409",
    Cost: "0",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABACFjk0LgkAQhv/LnNfF9Vs7RQVBHSSCDuJBadGBbSdsC0T87y1oBRF0m3eel3mmGCCv8dhfJWSwoxpzUn1DGhjkhNrcICuGabQFJ+B+koiFE/E0jHwY2Yf9Rz+I84XKl3bZdVVv3Xaxxuoijewgc7nLYC91Y9o5HMhUBu27Uzzh+Y22EpvWOoTgaRwKBhslH3NZeDyIYo/BihTZw/qu1Fg+ARk3A1QMAQAA",
    Pbi3DGeometry:
      "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",
    "Actual Number of Risers": "18",
    "Actual Riser Height": "194",
    "Actual Tread Depth": "246",
    "Apply Nosing Profile": "Front Only",
    "Base Level": "Level 2",
    "Base Offset": "150",
    "Begin with Riser": "Yes",
    "Break Symbol in Plan": "No",
    "Calculated Heating Load": "0",
    "Design Option": "-1",
    "Desired Number of Risers": "18",
    "Down arrow": "Yes",
    "Down label": "Yes",
    "Down text": "AB",
    "End with Riser": "No",
    "Extend Below Base": "-150",
    Family: "Massiv - Stufen Naturstein",
    "Family and Type": "Massiv - Stufen Naturstein",
    Function: "Interior",
    Image: "<None>",
    "Landing Carriage Height": "200",
    "Landing Overlap": "0",
    "Left Stringer": "Closed",
    "Maximum Riser Height": "200",
    "Middle Stringers": "0",
    "Minimum Tread Depth": "200",
    "Monolithic Material": "Stahlbeton - Fertigbeton",
    "Monolithic Stairs": "Yes",
    "Multistory Top Level": "None",
    "Nosing Length": "30",
    "Nosing Profile": "Default",
    "Open Stringer Offset": "0",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Rebar Cover": "Bewehrungsabdeckung 1",
    "Right Stringer": "Closed",
    "Riser Material": "<By Category>",
    "Riser Thickness": "15",
    "Riser to Tread Connection": "Extend Tread Under Riser",
    "Riser Type": "Straight",
    "Show Up arrow in all views": "No",
    "Stringer Carriage Height": "200",
    "Stringer Height": "280",
    "Stringer Material": "Treppe - Holz",
    "Stringer Thickness": "50",
    "Text Font": "Arial",
    "Text Size": "2.5",
    "Top Level": "Level 3",
    "Top Offset": "150",
    "Tread Material": "Treppe - Naturstein",
    "Tread Thickness": "30",
    "Trim Stringers at Top": "Do not trim",
    Type: "Massiv - Stufen Naturstein",
    "Type Id": "Massiv - Stufen Naturstein",
    "Type Image": "<None>",
    "Underside of Winder": "Smooth",
    "Up arrow": "Yes",
    "Up label": "Yes",
    "Up text": "AUF",
    Width: "1300",
  },
  {
    ID: "580916",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.28309777",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jksLwjAQhP/LnkPIo29PooKghyKCh9JDi6ENxERqFErpf3ehtSCIt539hpkpBshrfe7vCjI4uFrnzvSNs0Agd9r6B2TFMJ1oiCRNeRivuJQ0TKMYRvIDCkaDWAbfMKAilf/ZElp+ytddV/W4AB9bXd2UVx1kjDICR2Ub387i5HzlNY6e5EVfF7RXummxhDOaiCghsDPqNZsFDg4ZJ7BxxmGwfRozlm81DWtEEgEAAA==",
    Pbi3DGeometry:
      "lAcAAB+LCAAAAAAABACdVVFLwzAQ/i/xNYY0aZu2exJdEfRhqODD2EPHwhaojdQgjLH/btC4SbtbblJaku++3H1p7i7zHZktzcv2XZOKPNilebatWRFKZtZ07oNU893P0Jv5xD9kT4/IdcL55PvjX7Jf/C676ftm69fmkpVJpmgiOBNFqqjwQMYTOjLIlCmVl0eDlCwr8/8YwBgHQ8pEKc/ieS4g+BAX5wWin8AB+kktipVplqGDQvSAj/gFk0IUI/7oFw9wKC5aT4g75IP+AT6kH+RH9MRTCkxC5AngHaEl4VIFe8RgXHBBrORjgqIFD5ZSJOvwjgbVBCpClhMWx/e+iNAzG0N23UgBxhpCPFvQp3xB975sz1FDiOBvtzvTvGmne1Jxxil51N3abcLkybrGGduF6atZHUz32qw3Lkymrf78S7y1rfUOydW0rlWt/C36BZbTY6mUBwAA",
    Absorptance: "0.1",
    Area: "13",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "1300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "4000",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "1.54",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "580917",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.04492358",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjsEKwjAQRP9lzyEkMca2nkQFQQ9FBA+lhxZDG4hZqVEopf9usFXqydvOvmFmsg7S0pzam4YE9liaFG1boQMCKRrn75Bk3XAGg5KUMzlbcsGoiOQCejKBMRVS8v9QKfHLJqlvln/KV01TtGFBeGxMcdVeN5AwyggctKt8PYoj+sKbMHqQZ3P5op02VR1KOKORUBGBrdXP0SxmNJ4zTmCNFkOwe1jb5y9bRAScEgEAAA==",
    Pbi3DGeometry:
      "pggAAB+LCAAAAAAABAC1VlFLwzAQ/i/xNYa0ydK0exJdEfRhqODD8KFjYQvURmoQxth/N8y6tSVpEkFKS3OX++4u9921qwNYruXL/kOAAjyotXxWtdwACJZKNvoTFKvDz6tR47m5wBFeJNcJxvPTw9zg+PZrdtO21d7YMorSnMAkxSjlNIMpQfkMJ5DNEOWYByhIggijHI6RCEVZxvIJA47yhMUYuDy4cuCIcGpXDDw7DXqhOhWRObgMQj1YcmAstaYwJbfAn8SWcAbbe3mNYCLhrcGP0M/yS4GntnuDHMI4grGwaiAOA/f3UUDj/eEMvPCh1I8llJ+XPhqP+yGmKF6xC3xykMR59VXKVZHAIMMPOITc/mOfZIGr76PoFD97Xa6HBs7ZGzsv/sVzWLcHyn2ezff+TlbvQosWFBhhCB5Fs9W7bvGkdKWlarrlq9ycVfdCbne6Wyxq8dXfeKtqZQDB1aIsszIz/xXfw2F+fKYIAAA=",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1567",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "0.3",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "580926",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.26930733",
    Cost: "0",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkaVrTehIVBD0UETyUHloMaSAmUqNQSt/dQH/Qk7ed/YaZKXrIa33pHhIyOLpa5850yllAkDtt/ROyoh/PYEg4poRHa8pWOOVxDAP6gilmnNN/UOCIMfELl9gZlnP9pm2rLmwIj52u7tLLFjKCCYKTtMo3kzg7X3kdZo/yqm8LOkitmtBCCRYsEQj2Rr4nM4twGhOKYOuMC8H2ZcxQfgDFk8/TFAEAAA==",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABACdU02LwjAQ/S/jNRvS9CNNexLXIuhB3AUP4qFiqIFus9QgiPjfN6ytSqUklZCQeTN5k7zJbC6w3Mnv86+ABOZqJ79UKfeAYKlkpY+QbC63rXGT1Ay4ogfy4RGS/i9mwnXbHhvXdX42Z6MYcy9CHmWYB2GIqI95SDzUxf0AMxZxFAWYcv99vI//jrfxMfYpjR88bbwFf+Hv4h1+a96++/fxDL2PTQfXuvTpY3uX5b0v/BZ8qA7O9XXNa/uHFh2c/4lbXtNvnzL/EVrUkBBMECxEVehDY6yUzrVUVWOu5f7umglZHHRjTEtxeg6cqFIZQhhNs4xlzPT1Hymsnc8mBAAA",
    Absorptance: "0.1",
    Area: "5",
    "Base Constraint": "Level 3",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1567",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Level",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "0.53",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "580928",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "21.44747541",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAB9jsELgjAYxf+X7zzGNuemdooKgjpIBB3Eg9LQwdrCViDi/95A8xDR7Xvf7/HeKwbIa33u7woyOLha5870jbOAIHfa+gdkxTCdwSA4ZjxKVjSKcJwKCSP6AZnEJIq/mWCU/mdLaPkpX3dd1YcF4bHV1U151UFGMEFwVLbx7SxOzldeh9GTvOjrgvZKN21ooQTzNJEIdka9ZjNlmAvJEGyccSHYPo0Zyzd/a15KEgEAAA==",
    Pbi3DGeometry:
      "dgUAAB+LCAAAAAAABACtVF1LwzAU/S/X1yykaZas3ZPMFUEfhgo+DB86FrZAbaQGYYz9d4NWt5KGXouUltyenHM/k/URVhvzdHjTkMOd3ZhHW5ktEFhZU7t3yNfH76WH2dw/cCLnP5OEsfnXx79wevmhXTdNefBcKSgX6YwkXNKZkMIvqJCKkwDgnGZymp2BNKXTTKoRQNTHBSB5knhbUc7TjlQLhFF1GVGpEIhKDUUVAD0JdgF8uIOMoLrRDkaj+nsePYyxPgYHLuojmjmmVsjx+Qcf488HRgo5cJhGIauL6SDyRGGq2+vc3183pnzVTjeQM8oI3Ot65/at8WBd6YytW/PZbH+hW212e9cay0p/XG5c2Mp6QbhaFoUqlL8nPwEiB88jdgUAAA==",
    Absorptance: "0.1",
    Area: "7",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "700",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "2000",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.76",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "580929",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.73491171",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyE0cUnaehIVBD0UETyUHloMbSAmUqNQSt/dQH/Qk7ed/YaZyXvIKn3pHgpSOLpKZ850tbNAIHPa+iekeT+ewSCQ4orjmnFBYxQIA/mCCeWI7B+UlPOV/IVL7AyLuX7TtmUXNoTHTpd35VULaUQjAidla99M4ux86XWYPcqrvi3ooHTdhBYWUUxiSWBv1HsyM05RSE5g64wLwfZlzFB8AJO75EIUAQAA",
    Pbi3DGeometry:
      "OAQAAB+LCAAAAAAABAClU02LwjAQ/S/jNYYk1sS2J1GLsHso7sIeZA+VBg3URmoQRPzvG9a2LpWQliUkZN5k5s1HZnuDdKc+rycJEbzpnfrQhcoBQapVac4QbW+Pq1WT2C64oycypoTEv4fdcP9uzOZVlV2tLZ/hkHJEGcezgAf2ggMuGOrijOGQT0PEA8wZpf9RuChavDUQmLGJeHpqDDz4C0EX7xL4mZ05OF0NjclbjL4NchXJn5sv6ReK4V/Axz2gRb5CuaId2qHev68fr53ApcqO0sgKIoIJgndZ7s2hFjbaZEbpsha/VN6q1lLtD6YWVoW8/H240IW2DmG0ShKRCDvpP1H7JWE4BAAA",
    Absorptance: "0.1",
    Area: "4",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "400",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "1467",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 3",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "3200",
    Volume: "0.48",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "591758",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.43996976",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjjELwjAUhP/Lm2NI0piWOokKgg5FBIfSocWQBmIiNQql9L8b2ip1c3v3vuPu8g6ySp/bu4QUDq7SmTOtchYQZE5b/4A078YzGBjDSczoasEIFhFbQo9mkGAuRPQHTHj8C+exAyw+9eumKduwITy2urxJLxtICSYIjtIqX0/i5HzpdZg9you+ftFealX7QXAaI9gZ+Zq8lGFBCUewccaFXPs0pi/en8jBbhMBAAA=",
    Pbi3DGeometry:
      "3wgAAB+LCAAAAAAABACVVtFKwzAU/Zc8ZyVt2rTbnkQFQR+GCj6MPXQsbIHaSI3CGP13w9Zqoz14y+hocnrOPTe5ven6xFZb83x802zB7u3WPNnK7BhnK2tq984W69Pl1sNi6X+s5T8zs1iI5fnPX6zd9LSrpimPnpskUZEnMZ8lIlK5lDxOIhWrjAdAKufjgMyLMyDjhAj0UqkK5/N5Ok7ICnWJLVKiKZgGjAFNdUrUeaTT55D5CZpVuH5BDiJKlZIjjCEQrNMQCIIHAIoxzI8UG4aApoLtHpP6HRt5gkkEm0FSApGnbwVtu5EnVGmU52EAUmS4fLDIKZ6gEolA8kR5gUm1AWuAUhuk9xdahUoUAs0TbJiTOwRmIAD29387wR+7UIrGILmCp870jgYZEKAdt1Bq0gHtGf5r4caUr9rphi1EJDh70PXeHbrBo3WlM7buhi9m9w3dabM/uG5wW+nP4YPXtrJesP6oqnbzBXTrPvrfCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "44",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "6",
    Flow: "0.7 /",
    "Flow State": "Turbulent",
    Friction: "46750.42 /",
    "Friction Factor": "0.017719",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3845",
    Length: "733",
    "Loop Boundary": "No",
    Mark: "687",
    Material: "Copper",
    "Middle Elevation": "50",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "34280.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "170015.6717",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "50",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "56",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591759",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.23513341",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkbay1nkQFQQ9BBA+lhxZDuxATqVEopf9utLUHEbzN7JvdnbQFWeCxuSpIYGcLlFY3pTVAQFo07gZJ2vbSBwJGwzgOFhM+p0KwEDryA3oRsWj6DV8Lf+B4Nvu8X9Z13vgOfrDG/KKcqiFhlBHYK1O6ajAH63KHvnZvT3ge0VZhWbm3EXxGYKPVY8jygEacCQIrq62/a+5ad9kTkWrVzBMBAAA=",
    Pbi3DGeometry:
      "yQgAAB+LCAAAAAAABACtVlFrgzAQ/i95TiUxUdA+jW0w2B7KNthD6UNLpQ04M1w2KMX/vqB205kv6hjFYr7L3X2X8ztdn8lqp55PbxlJyb3eqSedqz2hZKVVYd5Juj43t9bMlvZHKvqDLDhjy/rPXqTaXNyuynJ7sr4hC2SY0AVPAimZoDwMYhlTC4tEyD4ueNgYksjt4MYll6KPRyGnODGCRcQBH0B0EIjHkZsQZ9JdQesBDZAUyo3J4vK8pOxNzCzwu3FdvMtpuB/B9Sl18bZt8/PWpU0nNEzQa1zP0DRuEOjigHDECKbGnHAocBwjwkLngQSHGgGVMqnskWcAatofCTrMmRqQ07xx4g0zXSXw2fZOBhRoyiQZ2+9Vm2uGIXyybMfUBmWLBrE/EnKYM+ohpz+8A/yh5gyT/5gZYy8aZx32u+BGbV8zk5UkZQGj5CErDubYLh612Rqli3b5ovbfprtMHY6mXdzm2Wd347XOtQ1YfOR5tfkCc9qZa8kIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "44",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "6",
    Flow: "0.7 /",
    "Flow State": "Turbulent",
    Friction: "46750.42 /",
    "Friction Factor": "0.017719",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3845",
    Length: "355",
    "Loop Boundary": "No",
    Mark: "688",
    Material: "Copper",
    "Middle Elevation": "50",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "16618.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "170015.6717",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "50",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "56",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591760",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.98344853",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNzVELgjAUBeD/cp/XWFOns6eoIKgHkaAH8WHWRQdrC1uBiP+9YQi93XP4DrcaoWj0ZXgi5HByjS7x5pVtDQKBwmnrX5BX4+8MhHMqecw3K86oSDIBU724bd+rIeBQ7LV6oMceckYZgTPa1ndzkFFGoHReee0s5GuapCyVIuIilXEmhSBw1fd/fETddn7OgicEDgY/y5rT4HfOuPDJvo2Z6i8+4XNz0AAAAA==",
    Pbi3DGeometry:
      "aRwAAB+LCAAAAAAABADtV99r2zAQ/l/07AZZvyylT2MbDLqHsg32UPKQUtMavHikbqGU/O9zazuJZX2W1LeBCAmxT6f7vrvTne7mlVzfVr9e/pZkTa6a2+pnU1d3JCPXTbVrH8n65rX/24npZfchh+z05iKn9PL9p/uSw2ZU+7Tfb186XcZWRiieXTC6KnJaZDlbKcl59iZggk0FmXM5NfmyQEoxFfCcuTVGy5Tl7q3ckGZvFZOR+0AN6IxRI9BLkNog0IYZt5cQCV0MAiW1Olo+vdVoubYsHwVcyWVBpOXZPhiS0eec5wYGbwdgdUNiBXcbgNQiDUDOFoOF1NN9AqiCm6Cc1FrpXsNIM2EXnku+tISoIqLtg4sJwvyAzKNRBRC0IzjTCDymVvaDfdz1BFYyaBblAPZdgFPRMYUH+/ywuAlHFCwvZ5hhzMgBD+/rQN4xWWxajJuRQb8V1WxR4CsQVqExQvSWlZpCDe+W3sbLhS0Qyxx8EZpEE26CmMEgvCm+C0T3x5lfVvkO0LDdjTQgqoXIwZyBWYY84j7rzrqAgolxQjhx4cfLYX7hHAaOwHdQm4Ng4FwdNWy0UiwLIlr+2AFmxKX2GMfNHQngPQEbB77C3o0PB+KHQEXcwE4NGZ1UbwC9nXoUROfbQlpBrwPnhtcuLyjoqjTTBdyf00z3ActppkszXQDcNNOlmS6oYKWZLq7xppkuzXQuOGmmc48EaaZLM91/P9NtMvKl2v4p23JP1nRFM/K93N23D8PDj6bdtlWzGx5/V3dH0beyun9oh4evdfl8vvBzUzfdhrunuj5s/gHVFVj3aRwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1557",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "22170.4",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591761",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.02710447",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjUELwiAcxb/L/2wy57Rpp6ggqMMYQYexgyvZBNNYFoyx756sgm7v9/g9XjVC0ZjTcNcg4eAbU+pLUK61GhAU3rjwAFmNnxiVNMEZyehqEQNnOYep/nnrvldDlGOxNeqmg+5BJjhBcNSuDd0MguYISh9UMN6BpJhkhImUM8pysRSUIDib67+816btwsw8ZQh2Vr++a5JijmDjrY9P7mntVL8BmYQHXdAAAAA=",
    Pbi3DGeometry:
      "exwAAB+LCAAAAAAABADtV89LwzAU/l9y7kaapGk7T6KCoAdRwYPssGHRQm1lVmGM/e/WLtU1zdeknjwEmaz7+n587728l/e4Izfr/H77lpEFuarW+V1V5E8kIDdVXtbvZPG4O3xtYHrS/JF98PvLLKT0pP3XfMh+2YmdbjarbSPL6FxIyYNZ80UmNA5CNpc0DYMeECWyBSSLAqNExLkrkCYtwENmlhgY5zIyq4JedcBEPebXYTAmhgjyGgAs5uYQ6QxCoQCqgM44l6IPdBIDQBnnKWOOwHTjHUHolYiiPtAxH9gY9RW6xBNu1A/JTTeBWRs5gGpiqQqE4NyhJKNQqopp+BgrxlpK1qo0u+SeY3dfdcuwKqCq6V6Z2ZlTNnh3cNT18wkL3q4KthPYxSCg1wAMHwRgJiBBeEwgc/eWZWUOedAkPQCSpy0gmHbC9LEVCtnl4+BuJKwA6EGwkTIRH4A4icFotM1M9/ErlY1vt0d5wETB1GJViCDMB+WJMs5kr2GDRo4FYNSRBHQKq4JRh/zsKdfPv71jaJkdYY68+kstAAlYb7CmHU6BdpEa8AgblUbmv6NYc5cmbBSYcA8w06Zi3AAYQJZ7gPkGqttE8cERnZ4DyAt55X4V+0kzOqgj2XQa33+rLmwWSuD+59y1rF7BKPnlzi93frk79sgvd365s08Hv9z55c4vd36588udX+78cueXu/+23C0Dcp6vXrM625AFndOAXGflc/2iHm6relXnVakeH/KnH+gyy59favVwUWSfxy+eVUXVKCw/imK//AITDKgkexwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1558",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "22170.4",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591765",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.82095697",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx9AkpcS6kioIuigiuChdtBjaBzFPahRC6d0NtHoDd/NjZqoRyhYv4WEghyO1WJINHTlgUBI6/4S8GmcYAzLhqUjVZiXWXGktYWL/Mevv/HYYmhA/RGGHzd14M0Ce8ITBybjO9ws5k288xtszveLtZx0Mdn1cSXkmhWawt+a9ZIXkmVaKQUGWYq97WTvVH/6ryRsTAQAA",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABAClVktrwzAM/i8+u8GOk+bR09gGg+1QtsEOpYeUmtbgxSPzBqXkv8906SNzFWuEkIck69PLkrPYk/lKve4+JCnJo1mpF6PVmlAyN6q2n6Rc7H8/nZjN3EVaeuZMOGOzw8PdpF0e1W6apto53ZhFoihSOuFFlLC4oDyLBEs5dYLEkUN8kYkUtV6490Ehz2MMEOwRT0QnQHl6AvItiOSqS6BpEArMxtFXMc0SXHShdAybjqNpLoSfjjP/j2VfwQPqVy5sAeT3CofwaEDQq9wVDS+IfiHCUYNIsIkQkpcPXEtAFhDrQQOhkuLTB21wJNKIFgJ9Gmh4qIeQUCgBuDVD0yYANW6ihRoGHHW+AAeFaQBgIEATHgk05gyBPAqcgsP4I0Ym2Kih2fHvYXMZgvtDuFPVu7SyISWLGCVPst7YbUc8G1tZZeqOfFPrk+hBqs3WdsS9lt+XC2+NNg6w/tK6Xf4AlQbBz9MIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "66",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "66",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "6",
    Flow: "0.7 /",
    "Flow State": "Turbulent",
    Friction: "46750.42 /",
    "Friction Factor": "0.017719",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3866",
    Length: "1409",
    "Loop Boundary": "No",
    Mark: "690",
    Material: "Copper",
    "Middle Elevation": "1475",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "65858.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "170015.6717",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "1475",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "1475",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591775",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.01578926",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzE0TWtMPYkKgh6KCB5KDxVDG4hZqVEopf9uaKvUm7edfcPMZC2kF31q7goS2ONFp2iaEi0QSFFb94Aka4fTG0JOmZTLWRhRwWMGHZmwkEox53/AheC/cJLas/xTvqrrovEL/GOji5tyqoYkoAGBg7Klq0ZxRFc47UcP8qyvX7RTuqxcLyImCGyNeo1eFtOAy5jAGg36XPs0psvfBpeyixEBAAA=",
    Pbi3DGeometry:
      "vwgAAB+LCAAAAAAABACdVl1rwjAU/S95jiX9SGvr09gGg+1BtsEexIeKQQNdM7psINL/vqDtlrIeuZVia85NzjnNvbm6OrLlRr8ePhQr2KPZ6BdT6S3jbGl0bT9ZsTqev7qwWLiLtfwPmYVCLE4392Htul920zTlwa2N4iDMcz6LkiDLZM5DGYhEptzHk1SO4yI54al7kvCOJ5PhAJ9Ho9PT8IzHuSTZQfYBPXLT01BxxNPbn7snaZfBrvn2oyDP0nhk/iDg748fGCj7ASjhvxpJG0pAU4Msj1H9F0eu0GsMMkFigtqTk0HKNmQilNn0HE1mQpUM9xUtwF4pZ4iiQDq8pNqYzATaDKoYMB3SIz9X8l9snpSKn0yE2jlsAGgBVKBJw65E+OmZTETCScf/2n5xqRO7fwN3unxXVjWsEIHg7EnVO7vvBs/Gllabuhu+6e1v6EHp3d52g/tKffsTb01lHGH9VVXt+gcsluQDvwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "784",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "68",
    "Loop Boundary": "No",
    Mark: "694",
    Material: "Copper",
    "Middle Elevation": "790",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "519.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "790",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "797",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591776",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.24297222",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TssKgkAU/Ze7nobxKkq2CguCWkgELcSF0jBemOaGTYGI/96A1h+0Oy/OOdUIZUuX4aEhhyO3VLIdDDsQUDI5/4S8GmcYAohyjQluVpjILI0QJvEfs/7Ob/u+GcKHIOyouWuve8iVVAJO2hnfLeTMvvEUbs/0SrefddBkurCCMlZJJmBv9XvJRigzFacCCrYcet3L2qn+ABJnA2oTAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVl1LwzAU/S95zkqapp97EhUEfRgq+DD20LGwBWojNQpj9L8bXa1t19tcKWVl2ek9597c3NOtT2S1Vc/HN0kycq+36kkXakcoWWlVmneSrU/nrxZmS3uRmv79svAZW/7c7IfUm9+wq6rKjzaWcy9laUgXXHhxHKbUDz3GkoB+A0GSOgARhbgI0UhEPscxgUlxwc9AAjANA1qmC4lAjCcFaoNUYBlttoIJnIZ7R6bFuRezIBrZkg7QFx+LGFL1+oeRAIFe/zA5wUCvf2MRwyr63cDUDVKBgJtqWAduNkAJTAQk4WwregfBg46kmjVMYFbw7EMAkgoFgOfTaTzTVPPMzTk1oOtdADgqDAC5AuT2OKI57xMoI/dLcVJhlndC4+p0kH9bTqcG+5/hRuWv0siKZMxjlDzIcm8OzeJRm9woXTbLF7VroTup9gfTLG4L+dl98FoX2hKWH0VRb74AOOe/H+UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "72",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "72",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3872",
    Length: "702",
    "Loop Boundary": "No",
    Mark: "695",
    Material: "Copper",
    "Middle Elevation": "775",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5376.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "775",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "775",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591779",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.17070697",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUELwiAcxb/L/2wydW7TTlFBUIcxgg5jByvZBNNYFoyx756sgm7v9/g9Xj1CeTbH4a5Bwt6fTaUvQbnWakBQeuPCA2Q9fmJUKMWCpnS5oCnOM0Jhan7equ/VEOVYbIy66aB7kAlOEBy0a0M3g2AFgsoHFYx3IBkmKeGCZpzxQuSCEQQnc/2Xd9q0XZi5YAzB1urXd004TmKJYO2tj2fuae3UvAETwM+S0wAAAA==",
    Pbi3DGeometry:
      "XRwAAB+LCAAAAAAABADtV01Lw0AQ/S97TsN+Jdm0J1FB0ENRwYP0UDG0gdhIjUIp/e8Gk9Rms283uS+lpdnZmXlvZnYn83oky7f8+fCZkTm5L9/yp7LI30lAlmW+q77I/PXY/K3FdFF/yCn4X5kxShd/P/WXnFad2tV+vz7UupyHaRKLYMZlmCghAhaFVPEo6Ama5ZhKbTllYD8SxIz/CVIWByNdt6aEEqMwpbUBK9iBIajRYRqvATBBctBDFydeg7ay4JJfuqbtstT3DwSd605AOXMIdFMu17ohiCmKZJ/1wEMXcCdYMyaV8tTsAZKb6AGzhhxgNYlU9gUyYvayiVmklc3YcoIFqAsgKHe6dYETre4b1geyNB0TpAfTd9YQ5hzpBxVWv9PQxOsMCvQiQNFD6zANkBo4K4Cx+87SBZAzosBUew/IVDVhjRJ75+KytSRUYym2LxsJw1tGyLiPU9GxDXN67xWyMZVQKzWQHUANGUHEYAaYUH0NKaX97kYaONxQA6KCpmC4oSl3rvsn3XkvaOnErBGiqQVg3A3xwBJ2B0J/XzozSHhsTs+w67ZglRSmY9tfdjd72LyVEuZD1fcA+4u72ePXU801jBKM6/RMAHoI04gXLz3k8IzClLoatPM1yllmwDXcj28/55U1CAfyAU35aQ4cFz/N2bqEn+bGsPbTnJ/mrNXvpzk/zflpzk9zfprz05wpz36a89OcwYfJ1CogN/n6I6uyPZnTkAbkIdttqm378FhW6yovd+3jS/5+Ft1l+WZbtQ+3RfZzufG6LMra4O67KE6rX0zEclJdHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1563",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3098.3",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591787",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.58854254",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACNjkELgkAUhP/LO2/Lqq3L2ikqCOogEXQQD0qLLmz7wrZAxP/eohZ26/bmfcPMZB2kpT63dwUJHLDUKZq2QgsEUtTWPSDJuvH0hjCigZSrRSgoZ4JDT2YspFLE0R+Qy/gXzlIHln/K101TtH6Bf2x1cVNONZAwyggcla1cPYkTusJpP3qUF339or3SVe0GsQwEgZ1Rr8kbcMoiyQls0KDPtU9j+vwNM5nIxBEBAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACdVstqwzAQ/BedHSM/5FdOoS0U2kNoCz2EHBxiEoFrFdcthOB/r3DtVqKesAohwZr1zoy1q3U2Z7beyZfTe8UK9qB28lnVcs88tlay6T5YsTn/XOowX+oP670/ZBFwvhx+9Jf12ylt1bblSeeGkR/kubcIU1/EWeQFwuexSDwTD7JsHg/TAU94TMNHnlQEFi7iePb+KBIDHuWC5Af5R/zIz8RDxRHP5D8LQpJPtG+W/9DP0ySaSbAC5g6ZAUvaDGAN8+FI4lADurIKPUf1Xxy5gs9hFYNEBcXd60GqOGQitJp7lZyZUDfDjUUJ2CvlHFEUSAeY1BzOTGjWwJ5BCVABWbpa4eIYJfW9MxOa7HAQoASoQJOG04nwFnImIuGkIXDt1Lg0kfU/g1tZvlVd1bKC+9xjj1Vz6I7j4kl1ZSdVMy5f5f43dF/Jw7EbF3d19WXeeKNqpQmbz7rut9+oyF59ywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "784",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "68",
    "Loop Boundary": "No",
    Mark: "698",
    Material: "Copper",
    "Middle Elevation": "790",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "519.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "1",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "790",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "797",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591788",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.15918597",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TssKwjAQ/Jc9x1A3xkc9iQqCHooIHkoPLYZ2IWalRiGU/ruBVv/A27yYmbyDrKJLeBhI4cgVZWxDzQ4EZEzOPyHNuwHGAKJc4QzXE1xIrZSGXvzHLL7zm7YtQ/wQhR2Vd+NNC2kiEwEn42rfjOTMvvQUbw/0SrefdTBUN3EFpUItYG/Ne4xOUc6XSgnYsuVY617W9sUH4h2xGBIBAAA=",
    Pbi3DGeometry:
      "7QgAAB+LCAAAAAAABAClVt9PgzAQ/l/6zEhpiyvsyaiJiT4sauLDsgeWNVsTpAarybLwv1sdIjCO3kIIP8rHfd9dr3dldSTLjX45vCuSkgez0c8m11sSkKXRhf0g6ep4enQwXbiDVMH/m1lE6eL34k5Srf/MrssyOzhbxsKEJnEwY/MwFpIHURxS6u4/AJeJB4ikxFmIWoLzGMcEOsUEOwGxEDjthupMg4thr0BxkAqMo3E3YnOchn9KxsVZeCX50JS0gK74kEWfqpNAjAQIdBOIcQoGOgkcsuiH0U0HJnCQCgT8VP04cNUBSmAsIAlvXtEzCK50JNWkagK9gosfApBUKABcn97OM041rbt5qwZse2cAjgoDgG0BbPhIqkmbCuiVf28c15jUQqGi9faRixtPKwj373CrszdlVUlSGtKAPKpiZ/f14MnYzGpT1MNXvW2ge6V3e1sP7nL11f7wxuTGERafeV6tvwE3fzqr7QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "66",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "66",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3866",
    Length: "709",
    "Loop Boundary": "No",
    Mark: "699",
    Material: "Copper",
    "Middle Elevation": "775",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5423.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "1",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "775",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "775",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591792",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.64953384",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUELwiAcxb/L/2wydbZpp6ggqMMYQYexgyvZBNNYFoyx756sgm7v9/g9XjVC0ZjTcNcg4eAbU+pLUK61GhAU3rjwAFmNnxgVSrGgKV0taIY5Yxym+uet+14NUY7F1qibDroHmeAEwVG7NnQzCJYjKH1QwXgHkmGSEi7okjOei0wwguBsrv/yXpu2CzPnjCHYWf36rgnHSSwRbLz18cw9rZ3qNypqDrDTAAAA",
    Pbi3DGeometry:
      "pRwAAB+LCAAAAAAABADtV8tqwkAU/ZdZR5m3ia5KWyi0C2kLXYgLxaCB1BSbFkT894aY2M4kJ5MsC4MoZk7u49zHzNzFiczXyevxIyZT8pitk5csTTYkIPMs2eefZLo4Xf4WMJ0VH3IOfldGjNJZ+VN8yXlZi90cDqtjIcv5OJpoEYz4ZKyU0gFTYxpyFRgA5aIENJUmwJhsl4CAEKoEIqaDfsZrVSIUPb3SMux2t6EKStRe9ZeAXkGC0EYdKx6xbh5cctM4rQBpSzSA2ngNUM4cgK3KbdxWBb1SSprMGzbqsDvdRV6FEY/abUCCg21g5pAHrCsRSROQinWXj2bKKp++ZQUL0QagU+6U24DTW9s2rBGkabhPkB5M31WiroRGluyWhT3gVuXcjRv5g4BdCiiGaB0mA9KDPQN5u/cwG4C8EQ0WVnsCL1q9DK2adJ9nXFaaGL1o0t3LgDTcc4TUpqch7XuQDj+TC7olMKGd5GCGID2kCJGDeWAiNCWklN27OZLAIYcS0CuoCoYcqnLn2+76HvuElVbMHHk1vBBa34cewWJ2h8O+TV05SBm1J6l5FlfOKq3bWthcdl8C8JFOdXt7mRbgqeO+AsDLqG0aRgnGdXgmAD3kU48LmR1y2Kkwpa5j23m5cpYZMA3fx3ugc+NqhAPZgKr8xOcnPj/x+YnPT3x+4vMTX/tFyE98fuLzE5+f+PzE5ye+1gD+l4lvGZC7ZPUe5/GBTOmYBuQp3m/zXfXwnOWrPMn21eNbsrlCD3Gy3eXVw30af/998TZLs0Lh/itNz8sf7KJfaqUcAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1567",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3098.3",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591794",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.93433218",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNzVELgjAUBeD/cp/XsE03t56igqAeRIIexIdZQwdrC1uBiP+9YQi93XP4DrcaoWjMZXhqkHDyjSn1LSjXWg0ICm9ceIGsxt8ZCSFYkJRsVoTjjNIMpnpx275XQ8Sx2Bv10EH3IBOcIDhr14ZuDoLmCEofVDDegVzjjCdcMEoYF2kuGENwNfd/fNSm7cKcc0oRHKz+LGuCo9956+Mn97Z2qr+0mUYp0AAAAA==",
    Pbi3DGeometry:
      "zxwAAB+LCAAAAAAABADtV01r20AQ/S97Vszu7IdWzqm0hUJzCGmhh+CDQ0QiUK3iqoEQ/N8jKlmOJT3NKrfAYmy0fpqPNzM7u3P7Iq7vip/Pf3KxFt+ru+JHVRb3IhHXVbGr/4r17Uv72MDysvmIQ3L650JJefn/p/mKw+Yo9mm/3z43skSrzDidXFC6sta6RNHKea2TBvAZZS2gtX0LZJLUpAQGyFALOOPPAGT8pEopE+aVtYZxd6AKS/RehUpgryBBaKOPlSS9LCTGd4BWdCbRA3ZgnAdkpqZVdQA2Dm1Ar47Me8CRPQs7b4P1amRjlt07DEDakAQswx5Qvq0E42xY7ZjMURtB7+aLCqri9wDyKrzaoLs8wWGJsKrCvYIEUQZPu38oAVsP2gNQVUA3RjbCOwxbPhgY5oMluDyI4Y2EZT7ioch30fXtAUU2Y846pY75oI6HmwUWtOlj9+kTZXVr3Kh0/jxdfDT7LO0Ao9MggnyJjgmiWEGCMB+9hErbbUDSzzR2+Dof86EEWyLwzBwlg2c3iAfc/TPJgHlF7mKCSythRgJ5BSsalgi8WelmPckDXm5MStP1iQGkCp/yiqaZQxvsOYSB0U0CGWdjha/ywfnABJFX03sZxhxuWTa0+C4Gr1zh1YaMQwm+3Y8IopDwNpCqOAbGMTCOgXEMjGNgHAPjGBjHwDgGxjEwjoFxDIxj4Dur7cOMgZtEfCm2v/M634u1XMlEXOW7h/qxW9xU9bYuql23/FXc99C3vHh4rLvF1zJ/evvi56qsGoW7f2V52LwCjcD0tc8cAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1569",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3098.3",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591797",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.75817616",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGnGtzdooKgjqIBB3Ew6yhg7WFrUDE797CvL3f4/d41QhFYy7DU0MOJ9+YUt+Ccq3VgKDwxoUX5NU4x6hQiiVldLOiDAueUJjqxdv2vRqiHIu9UQ8ddA85wQTBWbs2dD9IGBMISh9UMN5BnuC1IELylHIhWSY5R3A1979MshTBUZu2CzNHPFj9WcYUc0LiYuetj1/ube1UfwHpgbIg0gAAAA==",
    Pbi3DGeometry:
      "0SMAAB+LCAAAAAAABADtWE1r3DAQ/S86O4ssWba1OZW2UGgOIS30EPawISYxuOuydQMh7H+PWVtOLfl5pOQqwiZrv8y8mdF8iLl9Ydd39c/nPxXbsu/tXf2jbep7lrDrtj50f9n29mX42sP8sv9hp+TtzUXK+eX5V/9hp50R+3Q87p97WSE2pZYquRDZJi9LnaRik8tUJD2gubAAJfQZyJReBqCEyMQcyFNClcq0p1VcqyTMj1ECczhWURKYHDoIOZxYcZ77eV5KmS96PgG2H46EsWoC7KO1AUzuqDLk0Crj+Rsweh5sLrbK4TCZiBwMCInxA3oO/TBAkfcvlgD/6MKkhhwwEyEHPKjwpCYlIAcMO6xax3PIQaao4wdZtbAMYDk75sJGhjjCeyIkp62C5Hburlgl04FDjr1SglBNJbgsABmwF+b8CsnVrC/A0UUOO0fVu91wI1iWg0BRZmcg6/+uHx8lQQ8PahTg3jpFRKfLMYSqbAnoB446nMDhlxLMofMByOZGofdkv3fvEYQm/4sHPAw46DIlB4lSqlldQgnIAVMkfDRCq1ZmZqAfTjkVXM67elEKPQNscyfAcPQ1rpZVWQAmn1TZ5NAq+zxIqzA5dNAuDtJBHBLIAR2EISErbSG6MEuIhPM/KAisFCcgJ8vZPxkg4J1X/h3fVrUyoHxnHcxdOP1J8hVzQznw5YYY/rgIfDvJyo0E2EReYUgKGoDVT17F4Ih3O8wH5/JH2giipjpu3MPEPUzcw8Q9TNzDxD1M3MPEPUzcw8Q9TNzDxD1M3MPEPUzcw8Q9TBhF3MME7GF2CftS739XXXVkW77hCbuqDg/d4/hw03b7rm4P4+Ov+n6CvlX1w2M3Pnxtqqf///Fz27S9wsO/pjntXgHQ/8eX0SMAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "9",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "22",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1572",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "Overall Size": "15 mmø-15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "9",
    Size: "15 mmø-15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591798",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.50334486",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNzVELgjAUBeD/cp/XmJvNzZ6igqAeRIIexIdZQwdrC1uBiP+9YQi93XP4DrcaoWjMZXhqyOHkG1PqW1CutRoQFN648IK8Gn9nJJTgNEnZZpVIzISgMNWL2/a9GiKOxd6ohw66h5xgguCsXRu6OUgmEJQ+qGC8gzzB64xkkjPKM5kKyTmCq7n/46M2bRfmLBhDcLD6s6wpjn7nrY+f3Nvaqf4CDRXGDtAAAAA=",
    Pbi3DGeometry:
      "oxwAAB+LCAAAAAAABADtV8tKw0AU/ZdZxzLvJHUlKgi6EBVcSBctBg3ERmoUSum/G8yjNcnJnQjuhmIxPbmPc+fM3LlPO3a7Sh+27wmbs+t8ld7nWfrMAnabp+vig82fdtW/JcxPyw/bB4dfTgTnpz9f5R/bLxqzs81muS1tJZ+pWMrgRMQzZa0IhJzZSKmgBLQ2pgKiSP4ClNXDFhAQWlWAsfExgIM3rrTgyikrFanxbLuekEGbk6sBTgmxgyHaQmkR62n10LoGlJC/LRrAdIOTAI/FsKsGQMFhDJjVgXkDWGmOq06HoJLqhxglNz0ArizigCTYvM9VpQJtjaNuZJnbT/UiOyoorHJK/jgpV6HBbB34ddTh4MpZ/ogfWLyDDDoGeK9C8UNX5BmMYzgfLbR2INBdDZrg9CI6nyA08y4PacK6urJqS9LERIcL2x1rah52HHA/n5vjpW2WNqqCaxGOdtE/NGQtaldh5MaPVGifH3IF+cHlaBeQ62oXSB6NnOjwdbLkPQtSIbBX9kpOsuvVA25+vBhoWVG2mN9kIWALkBSUMyoIvi3yMvshGrCHq1jIwWxHAOQKNvdQDvHGEagGBH7v3x6GA9NVwvd215UYIQeSGtzC+O6FdipdVXD3gteZCSIDoaEFfcT36aGCkDGgKz/w+YHPD3zSD3x+4PMDnyPgBz4/8PmBb7BX+oHPD3x+4PMD37Qt/88D3yJgF+nyLSmSDZvzGQ/YTbJ+KV7rh7u8WBZpvq4fH9PnFrpK0pfXon64zJKv4xfP8ywvHa4/s2y/+AYmASsGoxwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1573",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "22170.4",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591837",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.71779637",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/L7qqYdooKgjpIBB3Eg9KyLmz7wrZAxP/eoibUpdub9w0zk3eQVfrc3iWkcMBKZ2hahRYIZKite0Cad+PpDULQKBTJaiFCygPOoSdfcBkL/h+yOPllc+rAik/5umnK1i/wj60ub9LJBlJGGYGjtMrVkzihK532o0d50dcZ7aVWtRtEyGMCOyNfk5dHlAVJRGCDBn2ufRrTF2+wqT2qEQEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVl1rgzAU/S95tpKkplX7NLbBYHso22APpQ+WhjbgzHBuUIr/fcFpbdWDV0QxOZ5zP5J74+bM1jvzfvrSLGbPdmfebGr2zGNra7Lim8Wb8/+rg/nKXaz02pmZ4HxVPdzNym1Du8vz5OS4UvoqkJE3k4HPIz73hPJ5oBbeNSBEFA4DUkUVsOABEWiklkrcADwM5DCDq2p+HimaUzAMbAI61UiRASjVhBEKSfMWprAbRriUYpDRAp1UXYCu8RaANjrxjRuHNqBXnRXvK/VsI6dwGLerQVBCtqevBk7I5KIhMybsEXJy0Y6m5na0NKgEuEiwXMcZMAiiabg/xssYRwGlqAyCV7B5Tm4VmAELALX6sYbQ651AiEoY9wieiFObGiZAgHroQqkJ/cMx3D/Dg0k+daFzFnOfe+xFZ4fiWA9ebZEUxmb18MPsL9CTNodjUQ8eU/17/eG9Ta0TzH7StNz+Ad7yOQXlCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "784",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "100",
    "Loop Boundary": "No",
    Mark: "701",
    Material: "Copper",
    "Middle Elevation": "790",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "768",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "7",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "790",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "797",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591838",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.87341528",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1js0KgkAQx99lztuyjpZkJ6kgqINE0EE8KC3rwLYTtgUivnsLWm/Q7f/F/KYcoGjo0j80ZHDkhgq2vWEHAgom55+QlcMkwwBRrjHBzQITGakljOIPXfVF511X94Efgh3Vd+11B5mSSsBJO+Pb2ZzZ157Cy5O90u1XHTSZNkBQxipJBeytfs/bCGWq4pWALVsOd93L2rH6AAd7nW8PAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TuWMuhn7NNbCYHso22APpQ+WhjbgzHDZoBT/+7JVN0WvuSGiJH7e993lchfXJ7ba6ufjm2IZuzdb/WQKvWOcrYwu7TvL1qfz0MEwdxer+d+bWQgw/3m4m9Wb1uymqvKjsxUikCATPhNxEIYy5WESAKQR/waiVF4GQEJEs4gbCUhoRKhPIhZnQCSSJt1SDTWieNQpVBtlQsNovYXUDUga3hXxiIvgGqKrkRXpAH3xEYsBVTd9FAUU6KeP4hMOdNM3YjAIop8MStgoFQp4qQZhkCoDVaBYIAqenNKXD93kRKpJhYR6hZc9BhCpSAC2Nz0t5zLRpKbmqRa02Q0BEhMFQJsB2uSJVJMOEtQr73Ho0ZjUOJFq9XSP/3abbgTuX2Gh81dlVcUyCICzB1Xu7aGZPBqbW23KZvqid7/QndL7g20my0J9dj+8NYVxhOVHUdSbL/OSC9rdCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "72",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "72",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3872",
    Length: "702",
    "Loop Boundary": "No",
    Mark: "702",
    Material: "Copper",
    "Middle Elevation": "775",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5376.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "7",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "775",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "775",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591841",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.69976494",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkabU/nkQFQQ9BBA+lhxZDuxATqVEope9usK0XBW87+w0zk3UgSzy1NwUp7G2J0uq2sgYISIvG3SHNuuH0BiFoMmfBciZCygIRQU9+QUYjzr5gnMT8H5xi86l+1TRF6zf4xwaLq3KqgZRRRuCgTOXqURytKxz62YM84+WDdgqr2r1FyCMCW62eo5cLuuAsJLC22vpc89C6z1/BebbpEwEAAA==",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVlFLwzAQ/i95zkqSpp3dnoYKgj4MFXwYe+hY2AK1kRqFMfrfrbbT1vZrGkbHct/uu+9yuUs3Z7Le6efTmyILcm92+slkek8oWRud23ey2JzrnxXMltWHlPTPMuOMLX++qoeU24vbqijSU+UrRJCEVwmdCRmwUMwpF0HM44h+AyyUXSDkogaSCHggQEjxD2CSjgaHgIyAKKS2xyTjYU2R4MNZNA7IjhShwFApTG1UEAvmnA1VrgV0JQ14QKDepTbQVM4/uIw8RfVCdCrXsl8q12NqHJAdKUKBkR3yjG4FPDIogf4JGE0MnbApJXDtNGyecSbo4NGeUJNv3zqIppcfltkxQRGTzwiADlCT9/B2UE1pXOc0gReEgwp6+FxCUJX/7eSg8pm8qFcnzw7XjTmURPWGcKPTV2VVQRYsYJQ8qPxgj83i0djUapM3yxe9/4XulD4cbbO4zdRn+4/XJjMVYf6RZeX2CyH6/DLTCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "44",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "6",
    Flow: "0.7 /",
    "Flow State": "Turbulent",
    Friction: "46750.42 /",
    "Friction Factor": "0.017719",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3845",
    Length: "1013",
    "Loop Boundary": "No",
    Mark: "703",
    Material: "Copper",
    "Middle Elevation": "50",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "47337.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "170015.6717",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "50",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "56",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591842",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.29534788",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjFELgjAUhf/LfV5jTgW1p6ggqAeRoAfxYdZlDtYWdgtE/O8NM+jtnPN9nHqEsjXn4YFQwNG3psIrKactAoPSG0dPKOrxG4MiJc9lItcrmfBIpDA1P23T92oIbhh2Rt2RsIdCcMHghE5TN5c8zhhUnhQZ7xZ8Mbd/ekCjO5p7FscM9hbfix6lXISRwdZbH97dy9qp+QD4ijqTwwAAAA==",
    Pbi3DGeometry:
      "IRwAAB+LCAAAAAAABADtV01r4zAQ/S86u0FflqX0tOwWFtpD6S7soeSQUtMavHHJuoVS8t8rajtbyXqS07MIieMZzcwbzWhGc/tGru+a369PNVmTy+6u+dW1zT0pyHXX7Pp/ZH37Nvy1bHpuP+RQ/KecMUrPP37slxw2k9i3/X77amU5X+mKs+KMyxXVomClffCy+ExnQg0MRaXL4BULS0AGLT/ohqlikelJkbALFmGildBxsL4qKDGBWiyAQQH3kIVpm7hhUR8Ml9y1TEcG9SV8xmR6okurIEafKUqa9jUhSNpw43jtWzjudworhFSWMmgBOneyBeQ08gEmk6HauAxZsmjSaKXdpFmWSzC7XTrEk4yzR0/h9PGArABqTkWD3YJZN0kcY+8HZnY68SFMqkqW3FnJgAwv/iAMgIzOJnQNnxDgc7pUzQoG9BnkBjflQGZqoKuyivYrw8UIluuBoaJk5DOsL0y4QDVd1ie/0HEFHxgVjboGwwOdA4qAazAIRkjlCEgpo0UbrYebjQQgIqQpki9IVTLQ3kFfUhq8gOIOjUCdnALB9RARyuLkZnjXpKMD1AgVDNCs245ArYbAqXWpqRYf6dg6eKBc9bhtJvs7vI/6hsH2wP08ef9DnkE4qUuWv9HwWIaDmGrLyftSMquAYbQcFbpUfZolHDIAFOV5Lc9reV7L81qe15Y1hjyv5Xktz2t5XgvdAfO8FsniPK8t6+95XgsFMc9rVtGmID+a7d+6r/dkTVe0IFf17qF/HF9uun7bN91ufP3T3B9ZP+vm4bEfXy7a+uXzwu9d21mFu+e2PWzeAUxCvMIhHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1577",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3098.3",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591843",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.10701577",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGnHNzdooKgjqIBB3Ew6qhg7WFrUDE797CvL3f4/d49Qjl1ZyHp4YCjv5qKn0LyrVWA4LSGxdeUNTjHKNCKZaU0fWKMpyQDKZm0TZ9r4boxmJn1EMH3UNBMEFw0q4N3Q8SxgSCygcVjHdQJDgTREieUi4kyyXnCC7m/pdJniI4aNN2YeaIe6s/y5hiTkhcbL318cu9rZ2aL0xfsynRAAAA",
    Pbi3DGeometry:
      "sSMAAB+LCAAAAAAABADtWF1r2zAU/S96doMsyV/p09gGhe2hrIU+lDwk1LQGLx6pNygl/30msdVa8tGV2lcRGmqfXJ37fcW9f2XXu+b25U/N1uxHt2tuurZ5YAm77pp9/8zW96/nfweYXw4fdkze3lyknF+evoY/dtxMYl8Oh+3LICvEqqxkllwIteJSFEkqVrlMRTIAFRcGkInqBKisWgaghFBiDuQpcVSmKk+teJUlYXaMEpjD0oqSwOTQQMhh+Yrz3M/ytCjUouUaMO2wJCatNGCG1gQwuXXURA61mix/A0bLg9XFWlkcUyYiAwNcMtkBLYd2aIBny++9nQtzGlHAPIQUMEzhKU1KQA7odFizpuGQgsxPywyyZGEN4Fo2tIVNDFGE90PETeoEqc20degk0zNQivJcZBI4SlcfkIAc0AwdvULNWwKcWvScM4/6uBm2D8vyDAghToAqlTt8pAA5N6gpgNuqBmS27EN8lCEB7cBeh8M3/D6COap8DGBRzbSCANXs7TsEdZL/rQOGA045lcnR64WcVSaUgBwwSYLnIlTKMTADzTDLqeDS6OkiL2aAoax+r4NRSrV4kglAaq2rSQ11MmNBKgW5kXVmYZDWYX8gCmgd9Ad5n7IcC7ODSjTfEEHAUZKAmy5i7zSAgHdGBXR64yjHYPIccShp0cgnmR26hjE4LjTkwAfZ790+HLcQpBR9b6E4aACWPX3/gnPdai2fHcYf7yCQmWq0ce8S9y5x7xL3LnHvEvcuce/inFpx7xL3LnHvEvcuce8S9y5x7xL3Lks5G/cuce+CdN0k7Fuz/V339YGt+Yon7Ge9f+yfxodfXb/tm24/Pt41Dxq6qpvHp358+N7W/97/8GvXdsOB+79te9z8B7+OY5uxIwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "9",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "22",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1578",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "Overall Size": "15 mmø-15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "9",
    Size: "15 mmø-15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591844",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.54990999",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkMbZpPYkKgh6KCB5KDxVDuxATqVEopf9usNWDCN529g0zk3eQnfDQXjWksHUnzJxpK2eBQObQ+hukeTecwSAETWZsOp8ISSOlEujJb8jjWH5DlSj+Hw6xxbt+0TRlGzaExwrLi/a6gZRRRmCnbeXrUeydLz2G2YM84vmDNhqr2r+E5DGBtdGP0csFjTiTBJbOuJBr78b0xROjAbhoEwEAAA==",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVlFrgzAQ/i95thJjtNU+jW0w2B7KNthD6YOl0gacGS4blOJ/X7ZGu6nfTikt5j7vu+9yuUvXJ7baqufjW85Sdq+36kkXasc8ttKqNO8sXZ/OjxbmS/thtXexzALOlz8/9svqTeN2VVXZ0foK4SfhIvFmQvrxwj4Ewo+DOPK+AR7Kv0AYiDOQRMADAUKKDsCl929wCMgIiEJqe0wyHtYUiWA4C+eA7EgRCgyVwtQIQcF8Lgcr1wJdST0PCDS7dAFc5aYHl9FEUb0Qncq19qZyPSbngOxIEQqM7JCH2Ap4ZFAC3RNAJIZOGF0Caqdh81BM0GF0e0JNU/uWJBpbflhmcoIipvEjADpATZOHN0lFNy45TeAFQVJBj/GXEFQ1/XYiqcZPXtSro2cHdWMOJWH/Idyo7DU3ecVS7nOPPeTl3hzc4lGbzChduuWL2rXQXa72B+MWt0X++fvFa11oS1h+FEW9+QLVp/nM0wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "44",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4.5",
    Flow: "0.5 /",
    "Flow State": "Turbulent",
    Friction: "31826.46 /",
    "Friction Factor": "0.018246",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3845",
    Length: "156",
    "Loop Boundary": "No",
    Mark: "704",
    Material: "Copper",
    "Middle Elevation": "50",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4961.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "138237.0415",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "3",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "50",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "56",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "6.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591856",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.46989473",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaWN/PIkKgh6KCB5KDxVDuxATqVEope9usLWgF287+w0zk3eQnfHY3hSksLNnzKxuK2uAQGbRuDukeTec3iAElaFIFjMxpwkLQujJF4wjwf/DWPLgF06xAyw+9cumKVu/wT/WWF6VUw2kjDICe2UqV4/iYF3p0M8e5AkvE9oqrGr3FiGPCGy0eo5eLikLEklgZbX1ueahdV+8AP1beLMTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1rgzAU/S95thIz41efxjYYbA9lG+yh9MHS0AacGS4blOJ/X3A6q/bQK6IYj+ece2+Sq+sTW2312/FTsYw9ma1+NYXeMY+tjC7tF8vWp79bB/OlO1jt9U8WAefL5uJOVm862m1V5UfHFcKXoUi9hYj8JBKRF0ifhzLyBkAqAgAkogEiHlKBViqWwRCQkbzMiOOwAW5SSYwK5gE9YFSdFB2AUl0eSSCI4cIijvJIYud5iXEGDGvVAyPzHsAewwQJ5tADRjWa86nU1BxFBfMYzQdBCprPnw9cktkbh8qYsUro1YWLmlpdwv6gMuBEwV1LYEAPqjlcJYTtDKOCUlQGISrYlua3DMiAAGz6VzvDJFwoRWUQosIfyNkdDjIwQPwIQ6kZvcQx3D/Evc4/lFUVy7jPPfasyr09tIMXY3OrTdkO3/XuH3pUen+w7eChUD/nL96ZwjjB8rso6s0v97SBQ/UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "784",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "100",
    "Loop Boundary": "No",
    Mark: "705",
    Material: "Copper",
    "Middle Elevation": "790",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "768",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "790",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "797",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591857",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.54891062",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TssKgkAU/Ze7nobpKk7ZSioIaiERtBAXSoNemOaGTYGI/96A1h+0Oy/OOcUAeU2X/mEghSPXlLPtG3YgIGdy/glpMUwwBBDlGmPcLDCRK61jGMV/zPI7n3Vd1YcPQdhRdTfedJAqqQScjGt8O5Mz+8pTuD3RK91+1sFQ04YVlJGKtYC9Ne85u0SpVZQI2LLl0Ote1o7lBzw7EwMTAQAA",
    Pbi3DGeometry:
      "7QgAAB+LCAAAAAAABAClVl1LwzAU/S95zkqafndPooKgD0MFH8YeOha2QG2kRmGM/nejxtp2vc0dpawsO73n3Jube7r1iay28vn4JkhO7tVWPqlS7gglKyUr/U7y9en3q4HZ0lykof+/LHzGlj838yHN5i/sqq6Lo4nl3MtYFtEFj7004z71I4+xNKDfQJBmDiDmMS4itBJJEuKYwKR4yC2Qcpx2S3WmEYTjWYHiIBVYR5tuFEc4DfeWTItzL2FBPLIlHaAvPhYxpOo1ECMBAv0GYpKCgV4DxyKGZfTbgSkcpAIBN9WwDtx0gBKYCEjC2Vf0DoInHUk1a5rArODhhwAkFQoAz6fTeaap5rmbc2pA2zsDcFQYALQF0PCRVLNeKmBW7nfjtMYsC4WG1ukjFxtPpwjz3+FGFq9Ci5rkzGOUPIhqrw928ah0oaWq7PJF7lroTsj9QdvFbSk+uw9eq1IZwuqjLJvNF2Fo/DPtCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "72",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "72",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3872",
    Length: "702",
    "Loop Boundary": "No",
    Mark: "706",
    Material: "Copper",
    "Middle Elevation": "775",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5376.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "775",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "775",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591860",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.31183274",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEk6Y9pPYkKgh6KCB5KDy2GNhCzUqNQSt/dYKsHEbzt7DfMTN5DVuljd1WQwg4rnaHparRAIENt3Q3SvB9PbxCCJhELFjMRU8kiGMgvFlIZBPE3lInk/+CUWrzLl21bdn6Bf6x1eVFOtZAyygjsla1dM4kDutJpP3qUJ33+oK3SdeNeIuRzAhujHpOXCxpzFhJYoUGfa+/GDMUT75mmTREBAAA=",
    Pbi3DGeometry:
      "qQgAAB+LCAAAAAAABACVVVFrgzAQ/i95TiXGRNQ+jW0w2B7KNthD6YOl0gacGS4blOJ/n5t20zWfiUil+S733Zecd7c+kdVWPR/fCpKRe71VT7pUO0LJSqvKvJNsfer+tma2bB/S0D9kETK2/Hm1P9Jszm5XdZ0fW1/OgzRKUrrgcZAwSUMexGEs6TfOIjHCo5B3eCrt+wHOBR/jTNCpuAgX0i4HyPxPI2KrGslDq/p+O4CBFhATSUQnmpIigiSKYkuiBoaxHIsHNHS3MzT0yZofXMiZoi5CjDI2wM8pu2DqHRCOFKHACIc8k1eBvhak/yL/k8cCH5fP/buuGVXMNBHa712QUM+8SnXQ+GcdZne6TyIi/7JH26Gemf3ZQeRTqc72gWaAgwk5+A8ZqGju9HEQzWmyqDJ924RjIFpO0M79G5W/FqaoScYCRslDUe3NoV88apMbpat++aJ2v6a7Qu0Ppl/clsXncOO1LnVLWH2UZbP5AkIp9umpCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "44",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "3",
    Flow: "0.4 /",
    "Flow State": "Turbulent",
    Friction: "18582.82 /",
    "Friction Factor": "0.019086",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3845",
    Length: "601",
    "Loop Boundary": "No",
    Mark: "707",
    Material: "Copper",
    "Middle Elevation": "50",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "11166.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "103280.5482",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "50",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "56",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "591861",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.27087142",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjE0LwjAQRP/LnmOoabUfnkQFQQ+lCB5KD1GXdiEmUlehlP53Q63gbWbeY8oe8gudugdCBgd3oQKvrG1tEATkjiw/ISv7b/SKUjJVkVrN1FImcRzBUP28ddvqzst+2JK+I2MLWSADAUe0NTdjScNEQOFYMzk74TPd/ukeqW547EkYCtgZfE/6fCEDPwrYOOP8u30ZM1QfMwBUTsQAAAA=",
    Pbi3DGeometry:
      "mxwAAB+LCAAAAAAABADtV01P4zAQ/S8+h8rxV+xyQuxKK8EBARIH1EMrIogUmlUJSAj1vxO1SSGTvNjlxMFFrYgnM/PG82bsuf9gV6vi9v1/zubsoloVN1VZPLCEXVXFun5h8/uP/b+NmJ82f2ybfK2cpJyf7n6aL9suOrWzzWb53ugKMbOZSJMTYWZWa5mkesat0Ml3gePW7ASGq57AOqdHNbAgy9RO4FKTBDk/mJJWBqJSJp2GS01hjQ5VsAZGBQOEPrq9Ei6djMMJJfrOeSvgVGMg6Jx3AmWkR0BN+Z1TUwiVdcL1I6c+DtvuhQtRaa3GfcAAj/cBI0dxQF41pl1foHQ6TR9rLKFPKK0gEYkAggpIORH40VJQiCPI0vGYcHiQhp3GgQmDLNGSxZXpM+XvxoP8QQGlAsoGWocFC8PDNQPiDuhhtI3AuBFFRPPebr357LdWZ5PnmROyQ8v3lszkMgoa9pxUEqSWhx6kR5/Jjqu9qYxPBgczBMMDhlBwMA9OKtPXUEpNd3OoAbccakBUyNQEbZApb75p1Yf0CZJWfIIjVEcTYfR9iAiSOYD+5Db1FYMx4zkaHMUtVquVHKlgsuy9A+ATXXM5Wl3EAz5TvTcAfHulrsc3Ce/qD/IwGh2G5L+O0R3HdQoy6ju0/VcrH8mQZ/A67H/+pjWgH3CBLMVhLw57cdiLw14c9uKwF4e9OOzFYS8Oe3HYi8PeD/MQhz39S4e9RcL+FMvnvM43bM5nPGGX+fqxfmofrqt6WRfVun28Kx4Oon958fhUtw9/y/zt+4vnVVk1BtevZbldfAJB0c+4mxwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "790",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1581",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "3098.3",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591862",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "19.05962003",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGnGtzdooKgjqIBB3Ew6yhg7WFrUDE797CvL3f4/d41QhFYy7DU0MOJ9+YUt+Ccq3VgKDwxoUX5NU4x6hQiiVldLOiHGdCMJjqxdv2vRqiHIu9UQ8ddA85wQTBWbs2dD9IGBMISh9UMN5BnuC1IELylHIhWSY5R3A1979MshTBUZu2CzNHPFj9WcYUc0LiYuetj1/ube1UfwEpJdw70gAAAA==",
    Pbi3DGeometry:
      "aSMAAB+LCAAAAAAABADtWE1r3DAQ/S86O4ssS7a1OYW0UEgPoS30EPawISYxuOuydQoh7H+vWdtKLftppOZYERJijWbezGi+mLtXdntff3v5WbEtu2nv669tUz+whN229aH7xbZ3r8O/PZlf9j/slLydXKScX57/9L/stJvYro7H/UvPK8Sm1JlKLkS+KblKUrHJs1Qk/bnmYn6uhD6fS6VXz9F9IcXsPE/dcpTUXvpwrZIQ/cf7UL6tD3Ef4iK7kHzbP5znXvZqqYtVgw3BtmDBMalkCPZb2gQMvhA1gUOtJrvfCKPhwepirRYYU/AhAwNcMtkBLYd2mIgqCrlK8PcuCmYIgaIQIsBnCo1n6j4EgB6HmWobDSHI4LSNoJIVhj+sWrauqGwhhND6B5FplSC0Ha9YpywdzpVKh+zK1t1ksg4wIARshHk5mc9LAepPZD+zBf2zDUv3leXAoWV+JshSEm9HcdDdgqr9uJgaAi/9iixggFZgn6NmGzp0YACdD4Sci5lKkEBW98XAQErynDDQO8CeJlU2+lvns3SEHAgCxkZ4E4RKObpjoBmLPCp4Zg1dWs/ObW0NwbyFUsW6JIuAsY0oCxvpZL0FqRJGhtbZaUFah/0BMZB5yB10fi0dC+ODCDXvN0LnOCUBMpXDvkGAzj2Dybu2W3Icjci3p8FwhT2eBMfahkI4JhhyUoGB71s6HKMH0ooeVigMmgBTnh65YDtflJV3t+H31A8ITlbauFMJuR93Km5RcacSdypB9+NOxVm24k5lfVKJOxUvjrhT8bsfdypOjrhTiTsVl3VxpxJ3KqARxZ1K3Kn8BzuVXcI+1PsfVVcd2ZZveMI+V4fH7mn8+NJ2+65uD+Pn9/rBkD5V9eNTN358bKrff1+8bpu2F3h4bprT7g9Vdqg3aSMAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "9",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "22",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1582",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "Overall Size": "15 mmø-15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "9",
    Size: "15 mmø-15 mmø-15 mmø",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "591863",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.33551648",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NIYmybOokKgg5BBIfSocXQBmIiNQql9L8bbOsggtu79x13l3UgS31qbwpS2LtSS2fayllAIJ22/g5p1g1nMDCGxYLMlzMWY55QDj36BSMsuIi/YSIS+g9OsflUv2qaog0bwmOji6vyqoGUYILgoGzl61EcnS+8DrMHedaXD9opXdX+LTiNEWyNeo5eynBECUewdsaFXPswps9f1gBzbhMBAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVlFLwzAQ/i95zkqSpt26PYkKgj4MFXwYe+hY2QK1kRqFMfrfjbbT1vZrGkbHct/uu+9yuUs3Z7LeqefTW0aW5F7v1JPO1Z5QstaqMO9kuTnXPy3MVvZDKvpnmXHGVj9f9iHV9uJ2VZbpyfoKESThIqEzMQ/kgkvKRRDzOKLfAAtlFwi5qIEkAh4IEFL8A5iko8EhICMgCqntMcl4WFMk+HAWjQOyI0UoMFQKUxsVFFvHZD5QuRbQlTTgAYF6l9pAUzn/4DLyFNUL0alcy36pXI+pcUB2pAgFRnbIM7oV8MigBPonYDQxdMKmlMC107B5xpmgg0d7Qk2+fesgml5+WGbHBEVMPiMAOkBN3sPbQTWlcZ3TBF4QDiro4XMJQVX+t5ODymfyol6dPDtcN+ZQEvYN4Ualr5nJSrJkAaPkISsO5tgsHrVJjdJFs3xR+1/oLlOHo2kWt3n22f7jtc61JSw+8rzafgGH1Kkz0wgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "44",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "50",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.3 /",
    "Flow State": "Turbulent",
    Friction: "7653.65 /",
    "Friction Factor": "0.020757",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3845",
    Length: "162",
    "Loop Boundary": "No",
    Mark: "708",
    Material: "Copper",
    "Middle Elevation": "50",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1240.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "63557.26046",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "1",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "50",
    "System Classification": "Domestic Hot Water",
    "System Name": "Domestic Hot Water 1",
    "System Type": "Domestic Hot Water 1",
    "Top Elevation": "56",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593032",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.05081065",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xgmrVaoK6mCoIsigovSRYqhHYgZqVEIpXc30OoN3P0v5ptqgLKhS3gYyOHIDZVsQ8sOBJRMzj8hr4ZJxkGSygyzdLNQS6mSFYziD139RW/7XofIj8GO9N1400OOEgWcjGt9N5sze+0pvjzZK91+1cFQ20WISiQiZgL21rznsZKY4lpAwZbjXfeydqw/3WmZLg8BAAA=",
    Pbi3DGeometry:
      "swgAAB+LCAAAAAAABACtVlFrgzAQ/i95TiU2Glv7NLbBYHso22APpQ+WhjbgzHDZoBT/+7Jp66IeObshivm+5LvLXe50dSTLjXo+vEmSknu9UU86V1tCyVKrwryTdHWsXy3NFvYiFW2RScjY4udhb1KtT8uuyjI72LVTHogomdNJGAXhNKYhDxgPOf3GmeA1LoRwCB4nNRFHkUNASqcFbB4Pm2AzzscRPadG7wIyEYtIDClBOCyUiNngts9EL4CQs6BtNxUWZ8mAUIs7UepPr7fQ4m7ivDIe9a4zgFV3s34nAflO+C816/MGstrNCK42oNAjFkAGgKRAMr4o9yoSJ/SP3QDKMKLykEp+HHNWQH/Gzh/bm6DDiOhAOCH/afeVfK/B4YT+0kNBn8DPGUjglPw4po0imj1ufk3YP4Ablb1KI0uSsoBR8iCLndk3g0dtMqN00Qxf1PZM3Um125tmcJvLz98Tr3WurWDxkefV+gsAPJ7sswgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "220",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "220",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "66",
    Flow: "4.2 /",
    "Flow State": "Turbulent",
    Friction: "40577.92 /",
    "Friction Factor": "0.016342",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "314",
    Length: "3658",
    "Loop Boundary": "No",
    Mark: "714",
    Material: "Copper",
    "Middle Elevation": "3878",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "148424.9",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "212884.6973",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3878",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "3878",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593105",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.04541224",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzEkTYhtPYkKgh6KCB5KDxVDG4hZqVEopf9usFXqzdvOvmFm8g6yszm2Nw0p7PBsMrRthQ4IZGicv0Oad8MZDJGgMonEYsZjGqtIQk8mkFGp1B8w4VL9wknsAItP/bJpyjZsCI+1Ka/a6wZSRhmBvXaVr0dxQF96E2YP8mQuX7TVpqr9W0g+J7Cx+jl6uaAsFpLACi2GXPewti9eSV071BMBAAA=",
    Pbi3DGeometry:
      "0QkAAB+LCAAAAAAABAClVt9LwzAQ/l/ynJWk6Y+0exIVBH0YKvgw9tCxsAVqIzUKY/R/N3PdbOhOL66lpend9913yfWa+Y7Mlvp5+6ZISe7NUj+ZWq8IJTOjG/tOyvnu8OjMbOpO0tGfNxPO2PT75i7SLY6wq7attg4biygpYkEnXEYFE7w4HZJyETFZpHToI3MBGLI83xs4S2KkoafivKC+jEKcB0iZHmKLBCcKkxEcDtQ3Iv2HC8R+TJLHKQ/OBZxrP0kWJVl2DjE0eHM6MIA6PB8o3DBrjAxMNFCqXzC/s44UAUrh1LyFQzH9KSJ82cKrBFIK1SrGHwyAigxOKviZYDSBTCgARtMFjQFTR6h6CSwpTItApQWSBmJxSjFd/YIuhQMjGhP4wwpoTOPPF2INB6O0gn/84LYLI0ADblcBUoXsQ/YItz+60dWrsqolJYsYJQ+qWdtNP3g0trLaNP3wRa9Opjul1xvbD25r9Tl0vDa1cYTNR113iy9dEYok0QkAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "188",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "0",
    Flow: "0.7 /",
    "Flow State": "Turbulent",
    Friction: "54418.51 /",
    "Friction Factor": "0.020301",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "3989",
    Length: "922",
    "Loop Boundary": "No",
    Mark: "743",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "50190.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "71843.51833",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "26",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "201",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593108",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.16357554",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx9DYVEJdiQqCLooILkoXLYb0QcyTGIVQencDrd7A3fyYmXqAqsNLfGgo4UgdVmSjIQcMKkIXnlDWwwRTYJlxKWS+XgjFlVIFjOw/ZvOd33jfxvQhCTts7zpoD2XGMwYn7UzoZ3Km0AZMtyd6xdvPOmg0fVqRXEilGOytfs9ZkXNRrHIGW7KUet3L2rH5AE/SET0TAQAA",
    Pbi3DGeometry:
      "+QkAAB+LCAAAAAAABACtVtFqwjAU/Zc8x5KY1qb1aWyDwfYg22AP4kPFooGuGV02EOm/L7haV+ptblYVrTHnnntym3vS5YEs1up1/5GTlDzqtXrRhdoQShZaleaTpMvD7087zeb2TWp6/mfCGZsfv+yH1KtT2E1VZXsbO2WBSJKITrgMEiZ40r4k5XEgWMSpxYTTBAuRsfAOFfZ6jJUywnCiJPNQNJhEeApq+fuJRXhRKUYRyAqW7rQEOYtj7/W7ajesQgQ8monBep0hsJ4+TY++e/O98mIg3W3gpxmH6WyJC8G9FXdvq7tEIBOcwsU0VDFcN0LJEHgwgWsr4CsJdQ6SaURvgpoGTAXqSCQVagLcpS5Hc1CNc01X72DsdBDjncCzWSB7AY+ff7Be6+ADteJPd3zeqxs5aA4uvxrjdcB67XPUncrec5NXJGUBo+QpL7dm1wyetcmM0mUzfFObduohV9udaQb3Rf79F3irC20Jy6+iqFc/mUbYuPkJAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "210",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "210",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "0",
    Flow: "0.7 /",
    "Flow State": "Turbulent",
    Friction: "54418.51 /",
    "Friction Factor": "0.020301",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4010",
    Length: "1265",
    "Loop Boundary": "No",
    Mark: "744",
    Material: "Copper",
    "Middle Elevation": "1475",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "68815.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "71843.51833",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "26",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "1475",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "1475",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593109",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.05457726",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjV0LgjAYhf/Le73GdLoPu4oKgroQCboQL1YNHawtbAUi/veGIXR3nsNzOPUI5dWch6eGAo7+aip9C8q1VgOC0hsXXlDU4y9GJSU4SzK6XiUCCyFymJrF2/S9GqIci51RDx10DwXBBMFJuzZ0M0gqEFQ+qGC8gyLBOSdcMpoyLjMhGUNwMfd/+aBN24WZBaUI9lZ/ljXFhMdq662PX+5t7dR8Ab6DOcPSAAAA",
    Pbi3DGeometry:
      "1RwAAB+LCAAAAAAABADtV11LwzAU/S95riNpPprMJ1FB0AdRwQfZw8SihbrKrMIY+++G2Vab9LSZrwZR7M7uxzn33qT3YUuuH4u7zVtO5uSyeixuq7J4Igm5ropV/U7mD9vvfy1Mj+0P2SU/nxwxSo/3f+wv2S1as5P1ermxtimdcZOmyRHTM8OoShifMal4YgHBBN8DWmb8N9BZaKVEGKAbT1rLQQMvNrcOhjzBpDrAMKMPcwUtoCKexaRUkKAHCCkHtcI8lHKCU5H2gdYidSy64AigOmWDrnwABYcxYFYdc26l6LtqZEcxwrNqY9BsOCnP0+EhRsR1aMC2So3sA8zI8e6RTPU1FPaDoLYK71CYVXBbdQBMFwaHTQJdHZ5VAEGngq1F1wxuofDQulMAXcGTD8aAAGwGKOKkunBo8Zi7gwOZT7tyAcgc8qDafANZxvZzbuwHY3earUfjSknZ8FDjQPBB3R4y3Ii0ny4TWdCFGnw1CypYAzAZxm+6Ti4/5Aryg+UQnDoHuOF69GSfNnCPfGgBk8L1g6rDdkOKwPGH5YCVhcwhwcN7AVqgrHBLoxmA71YdDWPMYJ28y7zN1jCmBmfZAybfC7w7oiVubJ6Dg+bFgPcQBOCbBAyOtILq/qEekCDMauo1zVMdzmxAAcFd7or7h37DxKHqaPwnjzFPEpgVchU3wbgJxk0wboJxE4ybYNwE4yYYN8G4CcZNMG6CcRP8T5vgIiFnxfI1r/M1mdMZTchVvnquX5qHm6pe1kW1ah7vi6cOusiL55e6eTgv88/fXzytyso6XH2U5W7xBSOXc2LVHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1610",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "22524.4",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593133",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.6848986",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsELgjAYxf+X77yG25o6O0UFQR0kgg7iQXHoYG1hKxDxf2+keYig2/e+3+O9l/WQlurc3SQkcLClSq3uamsAQWqVcXdIsn48vYEyzLlYrhYkxiImEQzoB6QER4KLbxhyRv/AOTb/1K/btuj8Bv/YquIqnWwhCXCA4ChN7ZpJnKwrnPKzR3lR1Yz2UtWNe4uYMQQ7LZ+TlzAchDREsLHa+lzz0HrIX+N/Q/kTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVt9rwjAQ/l/yHEv6K2nr09gGg+1BtsEexIeKRQNdM7puINL/faHWrql3aUQU49f77r673IfrE1lt5fvxqyAZeVZb+aZKuSOUrJSsmm+SrU/nrxpmS/0iLf3/ZeEztuw+9Ju0m0vYXV3nRx0bhB5nPKQLP/HSxBfUDz0/ilOqgZhH3ARYFHSA4IkJhKGgNioexgKOiEQK5riiYjzg1qrw5Chwc3IcQKmmypmIErCJA+AscGhJRxX4nki1sFF3z1RjwKAaA0ZLoIhOB5ADp8IA96rMtkMAWi5a1VTHpe3uVLNVoQKvBjU7c3y02A7OXAYoh3O5jjOHvMROhUbcZDL2mUNUKOB8fUwqCEDvld0yUCoXk5mPsO85YEs44GwZJhUE2FcN8l07FRoB6bCbPrTnqIVjwAwV5Ax2y4C21tlLHN1nokP/h3iQ+WfRFDXJmMcoeSmqfXPoD6+qyRupqv74IXcD9FTI/aHpD49l8Tt+8F6VShNWP2XZbv4ABJt12PUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "66",
    Flow: "3.6 /",
    "Flow State": "Turbulent",
    Friction: "29465.35 /",
    "Friction Factor": "0.016796",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "858",
    "Loop Boundary": "No",
    Mark: "748",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "25274.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "178937.3611",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "10",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593147",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.47345835",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNImzaPuhIVBF2UIrgoXUQNbSAmUqNQSv/d+OhuznCGqUcoz+Y43DUUsPdnU+lLUK61GhCU3rjwgKIefzEqKcWMMLpcJAILIXKYmtlb9b0aohyLjVE3HXQPBcEEwUG7NnQfSATLEFQ+qGC8gyLBOSdcMpoyLjMhGUNwMte/nEmJYKdN24UvE4pga/VrHlNM8pQjWHvr45d7Wjs1byF9WyLSAAAA",
    Pbi3DGeometry:
      "BSYAAB+LCAAAAAAABADtWE1r4zAQ/S86u8GyLVtKT8tuYWF7KN2FPZQcUmpagzcuWW+hlPz3mthW1pKeR/ZZhIQ4LzNvvjQj5uGD3T1Wv95fS7ZlP5rH6mdTV08sYndNdWj/su3DR/+1g+Pr7sVO0eWXKx7H1+eP7s1Ou1Hsy/G4f+9kk3STx3kaXXG5KZRII55uYpEUUQeIXMkpkBfSCfAsJiREZkjEWTKryrKKC9EDWWediwP64S8BOWirvIOoVUEOUbhjBf3QHErywpmPEbA814BprqVqzKAGzAx6c2g/SAkrH6ZV/hJkrLC5izl0Bs1Y0X5IKYWzrpaHBJaoxQErEXJAB2Htehc1TU4C8NRannsnykrtcgctVWRbGs2lGxl5opb3RIuctMq/AeBmKVXPITjvVUn3xLkcZyCBPUd+6A4n02mD855d1rQzNa33wurTRZH1AO++nCV4Pu8eKUHOgou5Oe+BRPaATNT8kNBANg0IUoSMxTbh+YQ4SFV2wgdVMpM9kIjcmdjLAEYSo4NSqLyXyNW8KiRBzw5zEmCroOeookmjbG7kHyoReLcZzoxKhDoDqfK9wmTu2jSHAJy9KOLQJqhqhRc8HZInEj4L6HrWgNkSaFVGutdTqCRTsxI6IqaEbRQlYXNA/2BEFnMYRYW8wLUDqXGJIGB9bC0AnUpEDf5PE3sOBs9wLxhVQNH0ZziPUCXhOQxrj+TAtWcCeHyCcKwwF9/VEODdh+ABpm9YiBsJ0NQmA5qdvj2TvhuQtnoOYdgHVjQhmoMaR+RFBgYkbKjChipsqMKGKmyowoYqbKgcF4CwoQobqrChChuqsKEKG6qwoQobqsk8ChuqsKEKGyqfcbRuQ7WL2Ldq/6dsyyPbxps4Yrfl4bl9GR7um3bfVs1hePxdPWnoe1k9v7TDw01dvv3/x69N3XQKD//q+rT7BH3hy64FJgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "28",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1640",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "16",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593148",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.61117081",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+Luq66dooKgjpIBB3Eg9KiC9u+sC0Q8b+3pHaIoNub9w0zk/eQVerU3SSksMdKZai7Gg0QyFAZe4c078fTGQJGORfhcuGH1BexgIH8ggmNBWffMOIs+Afn2GKuX7Vt2bkN7rFR5VVa2ULqUY/AQZraNpM4oi2tcrNHeVaXD9pJVTf2LRLGCGy1fE5en1EvCiICa9Tocs1D66F4ATFHZckTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVttqg0AQ/Zd93sjq6nrJU2kLhfYhtIU+hDwYIsmCdUtqCyHk37tEY73MZDYEg+Nxztx2Di6PbLHW74evgmXs2az1myn1hnG2MLqqv1m2PDa3FhZz+2Mn/v9k5gsxP//Zi51WF7e7/T4/WN9AekooyWd+6PlpnHJfen4YpdwCkQrVEBBhcAZilQwBKWN+jUrJKIY9QmtDMSZUQgXqalZ4cBS4OTgOoFTjykUcJmATO8C5wK4lDVXixWkk+91tqXrAkKoHDFsCeDR1TGPgVBjgntWo7QCApotmNa7j0nZ3KjIrtMDJoMiZ46PFdpA6DEAM53RdZw5oCUGFetwiMsTMASoUcD4+IyoAQM8VIRkolYPI0B7Enk9lCQecJWNEBQDEqgG6S1ChHkAdhOgDe45KOAZQVIAyEJIBbK2zlriqz7AO+w3xoPPPoi72LBOe4OylqLb1rjVeTZ3X2lSt+aE3HfRU6O2ubo3Hsvjtv3hvSmMJq5+yPK3+AOxfLo71CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "66",
    Flow: "4.2 /",
    "Flow State": "Turbulent",
    Friction: "40577.92 /",
    "Friction Factor": "0.016342",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "1401",
    "Loop Boundary": "No",
    Mark: "751",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "56861.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "212884.6973",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593151",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.28348258",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zcEKwjAQBNB/2XMMTdbUtJ5EBUEPpQgeSg9RQxuIidQolNJ/N9R62xnesNUAxdWc+6eGHI7+akp9C8o1VgOBwhsXXpBXw++MhCMVDNl6wSSVUgoY67/bdJ3qI47FzqiHDrqDPKEJgZN2TWinwBNJoPRBBeMd5EjZkomMpwKFzFYZMgIXc59xhhEftGnaMGWJSGBv9WdeM6RJylMCW299fObe1o71Fyzkvk/TAAAA",
    Pbi3DGeometry:
      "phEAAB+LCAAAAAAABADtVktrwzAM/i8+u8GO83Da09gGg+1QtsEOpYeWhtaQxSPLBqX0vy80adY8FCvpbktLQy1F+mTLkr7FgczX6nX/EZIpedRr9aIjtSGUzLWK008yXRzyv5mazbIvOdJfyYQzNjs9sh85Ls9mN0my2me2trCcwBZ0wqUVMMGD8iMpFxbnAb18RUrpnuS2y2nVNhAnBXPsVgsmhUMNaEwGLs6rEa4RoPRF+44guef77QiFQSPYjp1CwYKuIIXRVbENlwueG/Dcke/IirwM1rO9NgMuhI+TC2ZfRjQcWTqe7PLUgJZu0CtUEKC8NI7benpoZCNCc9O5p/Mp4a9fPdEwdE1h9gRtrioHSw48VoQFBAEVKVRy9QJCJKKmQLiqpq53ShEZAi0giN59o6MLI0q8pujnFegPNTmYa0TmIAsIAjOSOiYgND3NfQasFIRTZMMGrwImm5AFCGEmEvBNvYIWDJnNV7GQ4YSpP1EBJ8JgptI/KOPZXEE8DEQCzzzQPX44k4BaPziEoZn6Z8zDADASj5F4jMRjJB7/kXgsKblTq/cwDRMyZRaj5CmMt+muWDzrdJUqHRfLN7UpVQ+h2u7SYnEfhd+XL97qSGcO468oOi5/AMJRRzKmEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "6",
    Length1: "3",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1643",
    "Maximum Size": "25",
    "Minimum Size": "15",
    "Nominal Diameter 0": "25",
    "Nominal Diameter 1": "15",
    "Nominal Radius 0": "13",
    "Nominal Radius 1": "8",
    OffsetHeight: "12.5",
    OffsetHeightTemp: "0.003418",
    OffsetWidth: "12.5",
    OffsetWidthTemp: "0.003418",
    "Overall Size": "25 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "8953.4",
    R0: "13",
    R1: "6",
    Size: "25 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "593330",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.53345488",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0Sf9ST6KCoIcigofSQ4shDcREahRK6bsbbJV68raz3zAzRQ95rU7dTUAGe1ur3OpOWgMIcquMu0NW9OPpDZThiLFwuaAEp5RwGNAMUszDhP+HnETJL5zFjrD81K/atur8Bv/YqOoqnGghC3CA4CCMdM0kjtZVTvnZozyryxfthJKNe4uUMQRbLZ6TlzAcxDRGsLba+lzz0HooX4GFJZgTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVl1rgzAU/S95TiUffvdpbIPB9lC2wR5KHywNbcCZ4bJBKf73pdVtil5ypYhiPJ57zjW5N65PZLXVr8cPRXLyaLb6xZR6RyhZGV3ZT5KvT+2tg9nSHaSh/08WnLHl5eJO0mx+aTd1XRwdV8ggklLSheBBKhJBuQw4CwUdAHGangEWi3gIyCy8AEmYUlyojsGlTCY1eBhl84Cxq/l5QBoZZ9FkKBCA7WapnM68A8YfEbI7FBdBFibZxHz0gUGoPjD4VhOMNo8JjTYPVCifxtgVJA5nDtoFNQbzcZW41xUoPp6o+YWDY6DmA2SAAK5qwVCowsExUK58NYhfDDADApC9BAyF6j44BsYV3JagtevNY7zaQcDXqT0VhWr6OAbKFbgPzm/IIAMEwAbgq/P52/aZ4f4h7nTxrqyqSc4CRsmTqvb20A2ejS2sNlU3fNO7P+hB6f3BdoP7Un33X7w1pXEBq6+ybDY/QjByk/UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "66",
    Flow: "3.6 /",
    "Flow State": "Turbulent",
    Friction: "29465.35 /",
    "Friction Factor": "0.016796",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "178",
    "Loop Boundary": "No",
    Mark: "755",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "5258",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "178937.3611",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "10",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593337",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.53751455",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0G+mfJ1FB0EMRwUPpoWJoF2IiNQql9N0NtvWi4G1nv2Fm8g6yMx3bm4IUdvZMmdVtZQ0wyCwZd4c074bTGxB5jLFYzDDiIaKAnv2CCZ9H8gsmKJJ/cIotpvpl05St3+AfayqvyqkG0oAHDPbKVK4excG60pGfPcgTXT5oq6iq3VvEUjLYaPUcvULyIMSQwcpq63PNQ+u+eAFTE4wtEwEAAA==",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVl1rgzAU/S95TiUmUat9GttgsD2UbbCH0gdLpQ04M5wblOJ/n6vW+XFvklFamnu8J/fk5h7cnMl6p15PHxlJyKPeqRedqz2hZK1VUX2SZHNu/zYwWzUfUtO/yMJnbHX5ab6k3l7TbsoyPTW5nHvLKKALHnkh5z71hefLIKa/cSHEGGCSXwAZTDKEiKiBKWZSggmxH4bwFhMmFvLQXBMmAivp3zsjcZRoJppFcgkeXw+4iutrapliT0Zi3IiWaQCMmAbx8XHMEzoVwBYIExp3LWl84PM4WiqqbSrhet7OTLaScG3TBtlbjbYUHTrLJQD2cC7XrdnA1JmJ0AR3S7E0G7AaDHC+NhMmAECHyOIRKJWDq9gzLKM99yEccHaJCRUwAMYRA2zWTIQmAC5rNHigItSuUcDMBGiw2AQwqc7+4eo4YxnNe8KdSt+zKitJwjxGyVNWHKpjt3jWVVopXXTLN7XvoYdMHY5Vt7jPs+/hg7c61w1h8ZXn9fYHsJr6IdkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "60",
    Flow: "3.4 /",
    "Flow State": "Turbulent",
    Friction: "27202.50 /",
    "Friction Factor": "0.016915",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "564",
    "Loop Boundary": "No",
    Mark: "757",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15347.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "171323.0053",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593356",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.45448459",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NoElOSOhUVBB2KCA6lQ4uhDcREahRK6X832NZBBLd37zvuLu8hq/SpuylIYO8qnTnT1c4Cgsxp6++Q5P14BgOlWFBBVgvGseSCw4B+QYl5LMg3lJTIf3COLeb6tG3LLmwIj40ur8qrFpIIRwgOyta+mcTR+dLrMHuUZ335oJ3SdePfQjCGYGvUc/KSJY4FEwjWzriQax/GDMULP0cfDxMBAAA=",
    Pbi3DGeometry:
      "yQgAAB+LCAAAAAAABACVVl1LwzAU/S95zkq/kn7sSVQQ9GGo4MPYQ8fCFqiN1CiM0f9uXbvZNLlJZGws5/aenJube+j6hFZb/nr8YKhEj2LLX0TNdwijleCN/ETl+jT87cPhsv+gDv8hiygMl+ef/ou6zSXtpm2rY58bx0GeEbxISFCQnOAoDTKaRfgXT5JEDcQkPQdSMssgaYEtTEWYpsaEIqLUvMWMieZJbtcEFQFJ+vfOAA4SaUXTghpP74L7lnZVNBAVAaF5pLRhYJoEFKYJrh6GnjDWYNgCYAJxX0nqces4KBWsbV7CeNzeRC5FcGnz/jgbDTYUHDjHFTDs4a3Wr9WGibMTgQn+duJotcFmoID3pZkxGQLgCDn8AaTycBR3hmOwNRMCcW+HUIn0y2+dLoO9WnnA53V3tdq6QQ/k0hBu59H1283BMJ/eruFpM0oJ/XvBHa/emWQtKsMgxOiJNXt5GBfPQlaSi2ZcvvHdNfTA+P4gx8V9zb6nD96KWvSEzVddd5sfT8TCGckIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "20",
    Flow: "2.2 /",
    "Flow State": "Turbulent",
    Friction: "12313.03 /",
    "Friction Factor": "0.018226",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "1100",
    "Loop Boundary": "No",
    Mark: "758",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "13547",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "111042.6886",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "5.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593406",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.21501538",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACtjksKwjAQhu8y6xja2BitK1FB0EURwUXposWQDsSMxCiU0rsbaPUE7v4X803ZQ9HgpXtoyOFIDRZkO0MOGBSELjwhL/tRxoEQfKnkeiZWXGYLGNi/q+qL3Xhfd5Edgx3Wdx20hzzhCYOTdia0kzlTqAPGd0d7xduvOmg0bWSkPFMyY7C3+j1t0zlPlRIMtmQp3nUva4fqA1TDJykLAQAA",
    Pbi3DGeometry:
      "wQgAAB+LCAAAAAAABAClVlFLwzAQ/i95zkraJs3WPYkKgj4MFXwYe+hY2AK1kVqFMfrfjWvdmtozV0dpSe7LfXeXu1y6PJDFWj/v3xRJyb1Z6yeT6w2hZGF0Ub2TdHlohhZmc/uQmp4lk5Cx+fFjX1KvftSuyjLbW90oCqZxHNNJNAsET2gYB6GUEf2WS9GIp1I6ci5aQNpBF4CITgphIgYtMB535bMwSUZ5BBn2RYa06/Wnz8M4Hwz4DPS3DogMtOzmgAeJiMRvoo7c2YqB9ccQOnI3Zwgin4GeQ25kfjnoKGC3lwM/0b8d6gfm5hjyFDweYA4wGqiDgMkytNtAxSOJLugJYNr8Z+1PC4iKgQFUyYAujVYY26nAokR0JCQTpu6hlgT1PBzRBV0V9Ai82UAAx4QBUH0VcwPgFBrA/g/c6OxVVaokKQsYJQ+q2Fa7dvJoqqzSpminL3pzgu6U3u6qdnKbq8/uwmuTG0tYfOR5vfoCFp7oEsEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "216",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "666",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "60",
    Flow: "3.4 /",
    "Flow State": "Turbulent",
    Friction: "27202.50 /",
    "Friction Factor": "0.016915",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4016",
    Length: "450",
    "Loop Boundary": "No",
    Mark: "759",
    Material: "Copper",
    "Middle Elevation": "216",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "12232.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "171323.0053",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "216",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "666",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593407",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.31942166",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjUELwiAcxb/L/2zi3NS5TlFBUIcxgg5jByvZBNNYFoyx754Vg27v9/g9Xj1CeTbH4a6hgL0/m0pfgnKt1YCg9MaFBxT1+ItRoRTngi0XVGKWcZia2Vr1vRqiGouNUTcddA8FwQTBQbs2dB9IUsYQVD6oYLyDIsFMECF5SrmQWS45R3Ay1395p03bhS/TiFurX/M4xYRRimDtrY9f7mnt1LwBCiHpGtAAAAA=",
    Pbi3DGeometry:
      "3x8AAB+LCAAAAAAABADtV0tr20AQ/i86K2bfj+RU2kKhPYS20EPwwSEiEbhWcdVCCP7vFVpJjlf+NGty6WExMdGO5/vmpdmZu5fi9r7+/vyrKq6Lz819/a3Z1g9FWdw29a79XVzfvYR/OzG76T7FoTyeXHHGbvqv7q84rEe1d/v95rnTFWLlpOPllfArZSUvuVwxY1XZCbywpwLOlOgFnLvzGkjgrD4916JHwtwxElecLxrlhPBp1o5QUGNmFamBrUIOYo4oVFwbmRYRrUx/bu2p35p58VoweREpoPMjkBPuRACYJ99iZmzS6LSX/jxSTI1sgs4NDNo7ngaEqOkwxc6hcExeOxsYjCBq42IkUEw0Q/rLMoVDmmCTYjZRkFg2sDqo+KVngnQ7duJY+8zrXsCJxoXKAyIlt98ZRWpPIcsGnUeJSPAteleo6CV3DtrnyAcvmAhIWgUnBPe9gveDTYb3AuatDxTKBoGQPTdzcoi3V4OGUokdE5GP7ckGCi4VJ4xCFMjaDmo4D8fGaeIyH7ybBE675eShOMFKhkiQGsQPX4KXpghHHHJDKHDnXJxsqDCeS22GnC5XLGYAxUHHGzQtlIdZRvHLheoSUsP8oGiA8MFp1atIYJhciB7EhzhQ4Tw+2RxmUycCIgyaRQIZSo67WrOg4b25bAifoLQd8xyuAubPjy7x8jEzlhxQoE0zL6CAMhZPl7FRmJvZscX5RChSI214xl6MCsaEcyGXienAovH84vJIThHRHWa+IUspfICT1/G8ji8D5XU8KUx5HU8U5HU8ZbLN63hex/M6ntfxvI7ndTyv43kdz+v4m8rjP17H12Xxod78rNpqX1yzFSuLL9XusX0aHr427aatm93w+KN+mESfqvrxqR0ePm6rv69/+L7ZNh3g7s92e1j/A6tIbTvfHwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "22",
    "Center Spacing": "22",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1659",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    Offset: "60",
    "Overall Size": "25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "25170.6",
    Radius: "16",
    Size: "25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "13",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593558",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.07692553",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABNjUELgjAcxb/L/7yGTrc5O0UFQR1Egg7iYdbQwdrCViDid28WQrf3e/werxqhaPR5eCjI4egaXaqrl7Y1ChAUTlv/hLwafzEohOCM0/WKCExTBlO9WJu+l0NQQ7HT8q686iGPcITgpGzruxnihFIEpfPSa2chjzHlERcsIYyLNBOMIbjo2798ULrt/JdJwL1R72WcYkbnbuuMC1/2ZcxUfwA0VCsT0AAAAA==",
    Pbi3DGeometry:
      "5R8AAB+LCAAAAAAABADtV01r20AQ/S97Vsx+fzin0hQK7SG0hR6CDw4RiUCxiqsWQvB/r6qV5Fjy2133WBYTE8145s28mR3t3L2S2/vq28uPkqzJp+a++trU1QMpyG1T7dqfZH336v/t1PS6+5BDcZRcMUqv+6/ujxw2o9m7/X770tlyvnKM2eKKu5WijhdMrrTiqugUlnPnFVKfyIVl5w2gwqheLp1wb+UYevJkuU2JyXHDwrHOHCGDY0iJBjAilBtEGFlSrov5IjI0sz2vhit5YjEqtLX6JIm5BVQsXBnNRRB8ym8ODqMaE5/kRoizniZsFBROYwZhjFFhTwg7namJdEjIGBSVvkO04eEevNQTaqk4QvJ5meS2E/ylgymTpkhvHNAfUf6SK5GQ9iyL47FXylt0HoOHFXY/8hQdvwghebBEugbK53WIprY4KzH20mdHLOlFEtwNpdbC9DEJ6WNSdFAI1xNuJBvSU9wruPRZUO57QNDZVJHCRoYmAh9LZDwfRnEdCQpBwGjVQBSjwsvZ6dxavoSH9BQ34JU3rx6CRq0MHUFkxB9+FV5cI0g5BIeu0Fvn4mojg1HOqBmmU6QHEABqjijhaGrBQixqio8XakyIDQuEIAB/4L5qVZeLj+g0IMQecI/coJ8D79HZsCAOegoHtODhfKChK+94/pkHFpSl3cLnGTg+5syHElsTtgCxxu8ti5BADkgRjxXeLRdBYXDHZ+NNxlzFLFLvzvh6PlKupZ9WUoswdIBbwNS/NMiFZYoMh2V2iI4oAPKUN/K0u3neyIPgeSPPG3mSIm/keSPPG3neyM85yht53sjzRp438ryR5408eD3/3zbyTUFuqu1z2ZZ7sqYrWpDP5e6xfRoevjTttq2a3fD4vXqYVB/L6vGpHR4+1OXvtz9839RN53D3q64Pmz+/jpnU5R8AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "22",
    "Center Spacing": "22",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1665",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    Offset: "60",
    "Overall Size": "25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "25170.6",
    Radius: "16",
    Size: "25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "13",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593648",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.72139481",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+L7eou2kkqCOogEXQQD0qLPth2w7ZAxP/ekhbSpdub+YZ5k/eQVXjqbgoS2NsKM6u72hogkFk07g5J3o+nDzBGYy6j1YJzGgrJYCAz6D0Ziv+Qx+EPnNWOsPi8T9u27PwGb2ywvCqnWkgCGhA4KFO7ZhJH60qHfvYoz3j5op3CunFvIVhEYKvVc8ouBeWSxQTWVlvfax5aD8ULiAveVxMBAAA=",
    Pbi3DGeometry:
      "7QgAAB+LCAAAAAAABACVVk1rg0AQ/S97NrLurl/JqbSFQnsIbaGHkIMhS7Jg3WK3hRD8792qbZU4dQZRHJ9vPpydt27ObL0zz6c3zZbs3u7Mky3NngVsbU3l3tlyc+5uPcxX/mBN8PdkEXG+ai/+ZM32h3ZV18XJc4UIc5nGwULKUPEsCaIklJmIghEQi+xfQIlEIhmJaAlcCaQnMCnJ0xZIRY6M3bu6iCHzPJ7OCgwOuYLr6NNVMlbIGHOfpAO8napkgjEBdDGGwCg4ytWwgagQIDBqICopCBg3cIJxWcaoHajCQVf0doAFkqcDRSC0j1AEuKBxnxY1GzgGKitwYulLhLwSQIFBLlyKVs0wMFnNyh59AAnKA+o6Ti9QWwSOgcpqbm8k6B5dQqHxR4k0QUe+Cf7f4cYUr9rpmi15yAP2oKuDO/bGo3WFM7bqzRez/4XutDkcXW/clvpz+OK1La13WH2UZbP9Amwhs2LtCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "1190",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "1200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "13141.11 /",
    "Friction Factor": "0.020283",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "4992",
    Length: "164",
    "Loop Boundary": "No",
    Mark: "763",
    Material: "Copper",
    "Middle Elevation": "1200",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2151.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "66232.21262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "1200",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "1210",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593660",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.27943669",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzGkTUO1nooKgh6KCB5KDy2GdCFmpUahlP67kVb/wNu8mWF3ygGKBs/9XUMGB2qwINsbcsCgIHT+AVk5TDIUYsmVTKP1QkqeSJHCyP4TVt/3edfVfdgQjC3WN+11B5nggsFRO+PbGU7ka49h9oQXvP6ivUbT+g8sV1HMYGf1a+5GiidKKAYbshTuuqe1Y/UGq7UDsxMBAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABAClVl1LwzAU/S95zkraNP3ak6gg6MNQwYexh46FLVAbqVEYo//daLvZ1t7mSin9SE5yzr25uTddn8hqq56Pb5Jk5F5v1ZMu1I5QstKqNO8kW5+aTwuzpb1ITX97Fj5jy5+HvUm9OU+7qqr8aOcG3BMiDeiCcy8UQUJ9Yd9M0G/AF9P9LIlQ45lIG4CzGEUEWsRjvwGiAKV8IRoqREk4bhIoDVJBTpxt5WkqcBLO5ZiUjjwe+vHf5ej095VHJgyJ+pFDKED9vcBhLAKBfuTGZgyd6AcC4TXIBAJOpqEXuJSAFBDjQQFnSNHLB25wHNOcFAJtAlMFBJBUGADcmu5qM001q6K5EwYsdUMASYUBoIIAVXgc0ZwzBLLIdQpO8s8omWCiOmvHv4tNxwX7h3Cj8ldpZEUy5jFKHmS5N4e28ahNbpQu2+aL2l2gO6n2B9M2bgv52R14rQttCcuPoqg3X1+lFtfTCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "909",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "1181",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "13141.11 /",
    "Friction Factor": "0.020283",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "4709",
    Length: "272",
    "Loop Boundary": "No",
    Mark: "764",
    Material: "Copper",
    "Middle Elevation": "909",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3569.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "66232.21262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "909",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "1181",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593668",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.74128586",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1js0KgkAQx99lztuyuoq2naSCoA4SQQfxoLTowLYT2xaI+O4taL1Bt/8X85tqhLLFy/DQoOBILZZkho4sMCgJrX+CqsZZhkEc8zxLNyspeSJFBhP7Q1d/0YVzzRD4Idhhc9deO1CCCwYnbTvfL+ZMvvEYXp7tFW+/6qCx6wMk4qmIJYO90e9lGyU8l+uEwZYMhbv2ZcxUfwAlalhUDwEAAA==",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVt9LwzAQ/l/ynJW06a90T6KCoA9DBR/GHjYWtkBtpEZhjP7vRltnG3rNSSktTb7e993lcpeuz2S1U8+nN0kKcq936kmXak8oWWlVmXdSrM/tq4XZ0l6koX8zi5Cx5c/D3qTZ/Jpd1fX2ZG2jKMhFFtIF50GcRDkN4yDnIqbfQBIJD8DyFGcR86wFOMtwVKBXWdLOpxFO+kLkKAhmGUZ9AqUhKjiKzlkuRIKT8K/HtHYa8DjMRlakBwzFxyxcqmH6MBog0E8fxicIcNI3ZuFGMUgGJmyQCQT8VG58yMoANTAWoIY/r9g1hDY6jmhOKUEegQUDAjgmBADuTUTPmaaa09cQFQM2PAfAUmEAoCEAbR5FM+MYAbzxH4VT/LMaJlij/s7x/17Ti8L+K9yo7as0siYFCxglD7I6mGM3eNRma5SuuuGL2l+gO6kOR9MNbkv52f/wWpfaElYfZdlsvgAuje083QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "723",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "1181",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "13141.11 /",
    "Friction Factor": "0.020283",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "4523",
    Length: "458",
    "Loop Boundary": "No",
    Mark: "765",
    Material: "Copper",
    "Middle Elevation": "723",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "6017.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "66232.21262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "723",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "1181",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593669",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.32646895",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/XmG5uzp6igqAeRIIexIdVQwdrC1uBiP+9hfl2z+E73HqE8mrOw1NDAUd/NZW+BeVaqwFB6Y0LLyjqcT4jSVOci2y9ohQzSgRMzcI2fa+GaGOxM+qhg+6hIJggOGnXhu4XkpwzBJUPKhjvoEhwJoiQnKZcSJZLzhFczP2PmZQIDtq0XZgzEwj2Vn+WNcNc0Gi23vr4zL2tnZovuVIXZNIAAAA=",
    Pbi3DGeometry:
      "ySUAAB+LCAAAAAAABADtWE1r3DAQ/S86O4ssybK1OZW0UEgPoS30EPawISYxOOuycQIh7H+vE3+tpX0eObkVsWSJPTvz5o1GM8Ncv7Krm+L3y9+crdlldVP8qsrilkXsqip29SNbX7+2/zZift582CEa35zFnJ+/fzV/7LDp1b7s99uXRleIlRE6ic6kXCVCmihWq1QkKnoTxLGaCnRs3gSZzPRJAdZILYhUz1vKhPR0SmcttDeLTgEiOD5RChAas0MQVph0Kk/Htf99b0fKRvPUQTiC3tdBYPtqa/Q+De+7o1sO4WjYgSV9ohQgAowTDMdiCCtM/dGRHJTkqRcyaclJPwiB0g8hIG4gXeH7pbjUe3RDHcKAAHWYvsSQHbJY2Y5CBQSwtOphZNIlBO3cEOwTby0pncXtLRTZbNvAGhAD0eiPTmVCTDoQ6ExkK7MNfYKEW2PSNr8Vj1tTiZLEIVEaZB0b+BktW4HhnSDRc41geJ+aaWSRIews9AlBYwjCkjOIJLLzKeVmwhr2cKwhWqdUYvQxvZlxAGmQTcKp+dArRBzdC9In/2kHJQgcOaTpNIyUxzeGHlJsCJQ4sMninol8wv16MYteoHT6XimyOJumsyOwC0IvgKbs8/44xHjHjJITCDuGjlPeGhgDhgpGZDmGlVTLacCsGk3BHKHSzT+4UADvJcImL7JvBMkeYyngM/K1hLrViODbc2GmwRmExkD0ZgTAFG6JH3AXzmvURAPvmHdlw2MWwCbnMt9KSLZQRwHWWl9LqBmPCL4DwmdKETW2OPSwAJlCAQk7qLCDCjuosIMKO6iwg5pzKeygwg7qVCMIO6iwg5qnF3ZQYQc1JR52UGEHNdtjwg4q7KDAmBV2UP/XDmoTsa/F9iGv8z1b8xWP2I98d1ffdw8/q3pbF9Wue/xT3A6i73lxd193D9/K/Pn4hxdVWTUGd09ledj8A9EyDm/JJQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "28",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1675",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "16",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593673",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.84818127",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFzT0LwjAQgOH/cnMMadLmo06igqBDKYJD6VA1tIGYSI1CKf3vBrW43R3Py1UjFGdzHO4actj7syn1JTSutRoQFN648IC8Gr9jJJRiKbLlgjGcMiJgqme26vtmiDYeNqa56aB7yAkmCA7ataH7LJRIBKUPTTDeQZ7gTBChOKNcqFQqzhGczPWHFYt4p03bhX+8tfo11ymWiYzJ2lsfn7mntVP9Bi6855/SAAAA",
    Pbi3DGeometry:
      "9hAAAB+LCAAAAAAABADtVltrwjAU/i95riVp0kv0aWyDwfYg22AP4oNi0UDXDtcNRPzvq1ovTfstTdnTKKKY8+Vcc26TLRnP1evmIyZD8pjN1UuWqAVxyDhTaf5JhpPt8W8B01HxITvnQhkwSkeHn+JLdtMT2816PdsUvJ7nRr4nnQHnrqBR4DDhRlwKZw8IHh4BTsMKEPoHOpfSv6ZLGnjNDDJkzSqAJEiHJp2d8L2oHVCqEIXNjaZq97FzyFYkCQNIEvJBUiHKuDJ+AFgR3z3AgqBqbAlEwvcbOTBwMiqSrKLCXvcp4qEnLG0KqGdlbE0F57xrPHTdQAV0+xIoJEnLQGPG6s4hOhRkjmsNQHWHA4s4oA6c5ca2onPAt4C5icsevJ71s5per3odi7fuHsbmq1U2pCNBuBVgADzpL1WEOJAO7Ld5iOgcMMshgIdq5waMZiR6vtrsRAqgreYJ1nae209VaxX2a4z9MmEo7ZarRAeLbIu++3SupZP1YmDffK3nvLn5wh1DZ/jDzQAB/WrQrwb9atCvBv9kNZg65E7N3uM8XpMhdalDnuJ0ma/Kw3OWz3KVpeXxTS3O0EOslqu8PNwn8ff1xdssyQqB6VeS7KY/t/DEj/YQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "717",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "6",
    Length1: "3",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1678",
    "Maximum Size": "25",
    "Minimum Size": "20",
    "Nominal Diameter 0": "25",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "13",
    "Nominal Radius 1": "10",
    OffsetHeight: "12.5",
    OffsetHeightTemp: "0.003418",
    OffsetWidth: "12.5",
    OffsetWidthTemp: "0.003418",
    "Overall Size": "25 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2100.5",
    R0: "13",
    R1: "10",
    Size: "25 mmø-20 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "593675",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.81772948",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2ziptPNTlFBUIcxgg5jByvZBNNYFoyx754Vg27Py+/hqUcoz+Y43DVI2PuzqfQlKNdaDQhKb1x4gKzHn4xImuJcZMsFpZhRImBqZmzV92qIbAw2Rt100D1IggmCg3Zt6D4mSRhHUPmggvEOZIIzQUTBacpFwfKCx/Zkrv/wTpu2C19PWIpga/VrXnNMWSIQrL318cw9rZ2aNwuK1XzSAAAA",
    Pbi3DGeometry:
      "+R0AAB+LCAAAAAAABADtV01r20AQ/S97Vsx+a9c5hbZQaA+hLfQQfHCISASqVVy1EIL/e9VqJUdjPe82JbfFxEQaz8ybNx+7c/PErm/rL4/fK7ZmH9rb+nPb1HesYNdtvet+sPXN0/BvL+aX/YcdiuObC8H55d+v/o8dNqPa1X6/fex1pVy50hQXSq10KXUh7EppURZ/3msTBJbLZQEXKk1DKTUIFC/TTAVQynnx/L3nWi+7AFEcFYiHqCXqOvYe80c9C2sX2YCQcBCKONdcy7lgNFXqucYYxqlG8KGVKhdNnQqg8xEudQ5RTZRYaRJRIec4wOBDa+MTA0TOsQ8YIKEEVpUPLTMJXEALa0HKcs6hsTqx3mBv0LaEqOIppwIIN17stEigqX9GFQ+QpnzSmPr/JFG0m1GRQFPx4QYHBhXAWoAcxsmFPQubgPQs5jBuigpg5CgOZ00QaDOgEsqcP85K6UbBMEm4VQSVHQaGcD4xwBdQQnwgVE6X5PT1yiUey/DopwLLJ1T6/7iC4/gFAcLUeqnnZ4Hw7uwhkaBB4SINiAqbwrTD2kWUoNsKnD0osxgtBAUTiAcf0oD1hmsaMQLvoFMcworlPJF7wREuB8UOTw983ngjZ20+Rt4LyD0UOIc+sABdSqBvRNWZXQEWaIxDfBujVOHtAlGFAky4PNJagO2PWY9WT3KAMB84cphBlKj4RKSUQB+Qq7yb5t0076ZnA8y7ad5N826ad9O8m+bdNO+meTfNu2neTfNu+rq76aZgb+vtt6qr9mzNV7xgH6vdffcQHj613bar2114/FrfTaL3VX3/0IWHd0316/kP37RN2xvc/Wyaw+Y3u1T9kvkdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "1200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1679",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "7782.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593677",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.63399979",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yi02lbp6ggqMMYQYexgyvZBNNYFoyx754Vg27Py+/hqUYoGnMa7hpyOPjGlPoSlGutBgSFNy48IK/Gn4xIwnDKJF0tGMOcEQlTPXPrvldDhGOwNeqmg+4hJ5ggOGrXhu5jKOUCQemDCsY7yClOJZGZYImQGV9mIrZnc/2H99q0Xfh6whMEO6tf81pgxqlEsPHWxzP3tHaq30Pe1/nTAAAA",
    Pbi3DGeometry:
      "DR4AAB+LCAAAAAAABADtV99r2zAQ/l/07AbJOklW+jS2wWB9KGthDyUPCTWtwYtH5g1Kyf9er/7R+ewvVlvYkwgJcb6c7r7vTifdzaO43BXXDz9zsRZfq11xVZXFrUjEZVXs619iffPYfm1ged68xDF5+eVMSXn+/NG8xXHTm304HLYPjW2qV0Y7lZxpvdKZV4myK03KJX8Ba+0zQFLpecDKNMzCZVkLaOnCluqjIpfSCJAO+IA8BgvuY3GpifNFAIvInJM3NC8JjArxIEd25JwkpSNgWMrR2KLnMbXofJDWbnapCYCd9+FOnMOoeklsasKiws4hwc4HkfFhBLEk0AckyCTBdaX6jdMDWRsuLobM67GIxlJgwcH9wQEUVUDOOYDCXa72SZVA5q+OKoAgy/lgMTSASaLYdoZVgpda7nCwZXDnqBiwiMvqwl2LtgHftZB5wI7iIkLmsODIdpIo20altDl9qmmfdkDXS6TVY4LetC1DZT6M4OslmfhAUTU82SHsdRZ4OsMbAAeMGqJS79MKNuQ3EISpVd6NTwPls5PHRIAFDxdZwKjwUlB2XLtIEthLYPdBqcXhwqhgBnHrQxaw4HBRI0ngXXTgQYbmE8WuBi/hWlDt8Pw4caRaPdrnPfMGYHdR4BxfJiAA7yXQOdLqxNAAS3RRRHgj41rhMQNphQgGXCB5McAGgGVfZh5KEOYDMscZRIla7olcEugDahWn1Dilxik1TqlxSo1TapxSdZxS45Qap9Q4pcYpNU6pMwTjlPrfp9RNIj4V2x95nR/EWq5kIi7y/V193z18q+ptXVT77vF7cTtAX/Li7r7uHj6X+Z9///ixKqtmwf3vsjxungCysF9HDR4AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "1200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1681",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "7782.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593903",
    Name: "M_Urinal - Wall Hung: 20 mm Flush Valve",
    Category: "Plumbing Fixtures",
    temperature: "22.15331589",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU8LgjAchr/L77yG23R/7BQVBHUQCTqIB62hg7WFrUDE796ivL08PC9PNUHRmvP40JDD0bem1NfQuM5qQFB448IT8mr6zahQholS6xVVWLI0g7letM0wNGN0I9iZ5q6DHiBPcILgpF0XesgJTiWXCEofmmC8+5JMJEJxRrlQqVScI7iY219WAsFBm66PYYqJIBmCvdXv5cwwFQrB1lsfU+5l7Vx/ALfSiWzQAAAA",
    Pbi3DGeometry:
      "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",
    Area: "1",
    "Calculated Heating Load": "100",
    "Cold Water Diameter": "20",
    "Cold Water Radius": "10",
    CWFU: "5",
    "Default Elevation": "430",
    "Design Option": "-1",
    "Elevation from Level": "430",
    Family: "20 mm Flush Valve",
    "Family and Type": "20 mm Flush Valve",
    "Faucet Material": "<By Category>",
    "Flow Pressure": "103421",
    "Half Urinal Width": "225",
    Height1: "365",
    Host: "Basic Wall : STB 20.0",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "41",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Sanitary Diameter": "50",
    "Sanitary Radius": "25",
    "Schedule Level": "Level 2",
    "System Classification": "Sanitary,Domestic Cold Water",
    "System Name": "Sanitary 1,Domestic Cold Water 1",
    "System Type": "Undefined",
    Type: "20 mm Flush Valve",
    "Type Id": "20 mm Flush Valve",
    "Type Image": "<None>",
    "Urinal Height": "660",
    "Urinal Length": "445",
    "Urinal Material": "<By Category>",
    "Urinal Width": "450",
    Volume: "0.02",
    WFU: "4",
  },
  {
    ID: "593952",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.93660709",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1jsEKwjAQRP9lzzG0TYM1nooKgh6KCB5KDy2GdiFmJUahlP67wVb/wNu8mWF3ygGKBs/9XYOCAzVYkOlbssCgILT+AaocJhkKieBSLOP1IlnxTKQSRvafsPq+z52r+7AhGFusb9prByriEYOjtq3vZjiRrz2G2RNe8PqL9hrbzn8gE4LBzujX3I0lT2UkGWzIULhrn8aM1Ruevz1uEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEo0xmn7NLbBYHso22APpQ+WhjbgzHDZoBT/96XTupl5XEIRxdyXu+9+5E5XR7LcqJfDuyRz8qA36llXaksoWWpVmw8yXx27Vwuzhb1IS38ls5ixxc/D3qRdn9Wum6Y8WN2ER4KJgs6SIsp5KmgsotRK6AngV3EHZCIfAbHo5CLLRnLQ0lkhTtJpBsb5CMjyNNAnkBsPz5sc98o1JYpkOvIBcHMIBgiSO9UQnOeTlgbAzch/jT6MAXDqh1vCKVyn3PBwAPQWJHergZu6wCs3QLfiuLu+WQ/uP4ghuF/BBOIantR4ibyLGt6tIAfe394HB9fwJscPJ3gGw0ceaAqcbN4jD+wlXMObHO9X37Ea/LmEGII/r+EDIZT6tN/+M9yq8k0a2ZA5ixglj7LemX2/eNKmNErX/fJVbQfoXqrd3vSLu0p+/d14oyttDdafVdWuvwGlS6Mw5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "909",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "935",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "13141.11 /",
    "Friction Factor": "0.020283",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "4709",
    Length: "25",
    "Loop Boundary": "No",
    Mark: "767",
    Material: "Copper",
    "Middle Elevation": "909",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "333.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "66232.21262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "28",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "909",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "935",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593953",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.86062408",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+Lrq6rdooKgjpIBB3Eg9GiD7bdsC0Q8b+3qIWdur2Zb5h5eQfZBU/tXUIKe3PBzKi2MhoIZAa1fUCad+PpAiygoQij5YIlVCQx9GTGGE0Cwf+yWPi/bNY5sOIzvWqasnX7zthgeZNWNpB61CNwkLqy9SSOxpYW3cujPOP1i3YSq9oOImKcwFbJ15T1OeWRs9ZGGVern0r1xRvi0NIIDgEAAA==",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACdVl1rgzAU/S95TiUaE7V9GttgsD2UbbCH0gdLpQ04M1w2KMX/vkzdZhYvXosoJsdzz7n5uHFzJuudej69FWRJ7vVOPelS7Qkla60q806Wm3P3amG2shdp6F/PImRs1T7sTZrtD+2qrvOT5UY8iJNY0kWUBSnjnIYiEJnk1AF4LFpACrc/jOK2P4kjiovUM2SYxqMSMkr+aUiRzjMFak+lN0N7ypQfSkg5nngP+GMI5edoR0HGrZQ/G0NgGGnY7wzICKHLYkSiywIVakrDMwWmBwKgW1DbmQxUqItdefk58w26Re0ZHAM1IiADBMCVjls8qE2DY6BcTe2/GWsBZIAAro6AoVCVB8dAuQJLErh2p/LwGSAAlT3UfsLUTxQB4wg8/WYXYpAAArhDDgw1p4p8M+x/w43KXwtT1GTJAkbJQ1EdzLFvPGqTG6Wrvvmi9r/QXaEOR9M3bsvic/jhtS61DVh9lGWz/QLZ27jY6QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "944",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "954",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "13141.11 /",
    "Friction Factor": "0.020283",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "4746",
    Length: "164",
    "Loop Boundary": "No",
    Mark: "768",
    Material: "Copper",
    "Middle Elevation": "954",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2151.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "66232.21262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "28",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "954",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "963",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593957",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.13146447",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCoyM9CzMTa11jSz1LIxNTJVqdWggFwuz2rGoKLESaD9QwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMkEOhnCDc9MgUt5pGamZ5SAOGaWJiY6Sq45qWVQtYYmQOssgWLO+Tn5QHPzSnNyamMBgmFEvw8BAAA=",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEpMjD/ap7ENBttD2QZ7KH2wVNqAM8Nlg1L835dV54zz5omIP3Kf9913ueR0cybrnXo+vWVkSe71Tj3pXO0JJWutCvNOlptz/WhhtrIHqeivZeEztrpc7Emq7Y/bVVmmJ+vLuRcHIqILnnixCCT1A3tPAvoNRLK2hzJ27JInNSDD0AFAptbD58FgCCZE156wkE/TBIYezQ4belxTjylOIn846xboTyCQHRzaLYX0pBDxX6aO3Z2OAYdLEh27WzoM02iInqZedggAFAuGdksxzjRDU3/G3WKDYsHdAtYC44HcFph6Q3MOrX4c0YwmASoa33f/RsAsGwjArhtQ1HSP6a0LXJyIFoWlwgDQjoF6PI5oRp8FFYFfPBDAMWEAZJ/FfBSQHjVg/xVuVPqamawkS+YxSh6y4mCOzeBRm9QoXTTDF7VvobtMHY6mGdzm2Wf3xWuda0tYfOR5tf0Ci62clt0IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "723",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "935",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "13141.11 /",
    "Friction Factor": "0.020283",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "4523",
    Length: "212",
    "Loop Boundary": "No",
    Mark: "769",
    Material: "Copper",
    "Middle Elevation": "723",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2781.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "66232.21262",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "28",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "723",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "935",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593958",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.14791123",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUMfaR5uRIVBF2UIrgoXUQNbSAmUqNQSv/dSO1u7uVcph6hvJrz8NQg4eivptK3oFxrNSAovXHhBbIe5zOSLMOcFetVJjDPSQFTs7BN36sh2ljsjHrooHuQCU4QnLRrQ/cLKacEQeWDCsY7kCkuWMIEzTPKBOGCUgQXc/9jIgSCgzZtF+ZMGIK91Z9lTTBleTRbb3185t7WTs0XkP3cktIAAAA=",
    Pbi3DGeometry:
      "oSUAAB+LCAAAAAAABADtWEtr3DAQ/i86O4tl2ZK8OZW2UEgOoS30EPawISYxuOuycQsh7H+Ps35L/jxyculBLLusNZ75ZkbzYm5f2M1d/vP5T8a27Kq8y3+URX7PAnZT5ofqiW1vX5q/NTm8rD/sFAwnFzwML88/9Zeddh3bp+Nx/1zzRtEmjWQSXERp/UepgMcbFSVx8EbgPJ4SJE/fCFpoOUvAHMqAUHJZko6Eo1JSN9DOVrQMEMHSiWKA0Ng6BGG4SSox79fu/U6OirmYvQiL0OnaE0xdTY5Op/68vbr1EBaH6VhSJ4oBIkA/QXeshjDc1F0daYMWceKETEqywg9CoPBDCMg2EK7wfC0udY4y1DIYGEBdpqthSA5ZrExFIQMCWFv1MDKpEoK2MgTrFDaStKqz75yFkV5sG5gDYiAzuqvTdeiMGxBoTGQnM+R8wAS7wqgmunWYNKKSWBBXRHGQVaw3L5WiIaRxS0jkUhvoz/X0GMnBukKVEDKGICRZU0giWp1UrCZGwwaOOaJGKS1FPDZvYRZAHGSHsAo+1AoZDpKCVMl90gHhAacNkbYMqeLjdKHnEz0fl2bUwPaKuyVSCXfq1UZ0BK3Cc5XQXE9j2SKYxaAjQFHGZb8fYcivVPMJgulCSydnDowBPQUdsh5jGlLrrYAxNYiCEUIFm7tvIQHlJIKmctjRfWRrmb6Pr8dREGhRg3zXPgtDDE4dNAYyboEAROE++A514YRGTTEwuZwrGpysADQ1iTnWP7Jpmu/D+uooCDTfQb7rPPCR8kNNKZZxmIBEIXf4fZPfN/l9k983+X2T3zctqeT3TS5Tjt83+X3T4iTn902L04bfN/l90yKG3zf5fZPfN42Lst83zU5ift/0/+2bdgH7ku9/Z1V2ZNtwEwbsOjs8VI/tw/ey2ld5eWgff+X3Pelblj88Vu3D1yL7N37xc1mUtcDD36I47V4BzsjrraElAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "28",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1685",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "16",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593959",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.88731691",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0SalJPYkKgh6KCB5KDy2GdiEmUqNQSv/dYKsHEbzt7BtmJu8hq/DYXTWksHMVZs50tbNAIHNo/Q3SvB/PYOCcSi7ZYsYVTZhUMJDfcB4z8Q0VZ+o/HGOLd/2ybcsubAiPNZYX7XULaUQjAntta99M4uB86THMHuUJzx+01Vg3/iWkEAQ2Rj8mL4tpIoUksHLGhVx7N2YonjzQTzETAQAA",
    Pbi3DGeometry:
      "yQgAAB+LCAAAAAAABACVVk1rg0AQ/S973ogf6/qRU2kLhfYQ2kIPIQdDJFmwbrG2EIL/vTZVm8z6soZgcGecNzM7+54uD2yxVq/7j5yl7FGv1Ysu1IZxttCqrD9Zujz83bZud97+WMP/LTPPdefHv/ZizaoPu6mqbN/G+r4TRyGf+YkjvTjhnnAiGXn81x4EwbnDD8XRIUISEYqEX0BKXCFGAxJPyvEUBEnGQXy5JtQEKunqzMAOgYymZSJHd6+3T21tqKgHioQXnI2hRxocBGmw082gAUMPRgqABO1TS6LbTe2wVNgbbaHb7slAtopwa3Q+dNDWAGOgxtGwUtSAgty1kRqNGjHOeN6aeeohs57KySKAgLBgWZXMoBDUByvpYHKj3Mn8pYcfFgXVjCIBlYPqZ2EXkl1DB2x5KelQXkTSK18DEAepve0tYIiDVQOgnKDUJ6W23wV3KnvP67xiqeu4nD3l5bbedYtnXWe10mW3fFObwfWQq+2u7hb3Rf59+uCtLnQLWH4VRbP6AZn7ZB3JCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "60",
    Flow: "3.4 /",
    "Flow State": "Turbulent",
    Friction: "27202.50 /",
    "Friction Factor": "0.016915",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "37",
    "Loop Boundary": "No",
    Mark: "770",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1015.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "171323.0053",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593962",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "21.3245818",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFzT0LwjAQgOH/cnMMadrmo06igqBDKYJD6RA1tIGYSI1CKf3vBrW43R3Py9UjlGdzHO4aCtj7s6n0JSjXWg0ISm9ceEBRj98xEkqx4PlyQSUWaZbD1Mxs1fdqiDYeNkbddNA9FAQTBAft2tB9FkoEgsoHFYx3UCQ454RLllLGZSYkYwhO5vrDMo14p03bhX+8tfo11xkWiYjJ2lsfn7mntVPzBgcTLGnSAAAA",
    Pbi3DGeometry:
      "6hAAAB+LCAAAAAAABADtVltrwjAU/i95zkraJm2jT2MbDLYH2QZ7EB8Uiwa6ZrhuIOJ/X6b1FvstpuxpFFHM+XKuObfhigwm6mX5npMeedAT9awLNSWUDLQqqw/SG662fw3M+uZD1vRAuQoZ629+zJesRzu268VivDS8URRkIpL0KpJBFkachjzIYsnpD8DjdAvEXJwAqdjSWRwf0yVLomYGmYbNKoAkSIcm7Z0QSXIZsFORiKzZVosBe4eMRZIwgCQhJyTjvOYQ4QYIs2QDhObiibE1kHEhGjkwUBuVSmPEsQp/3Tv3UhNJP5sS7mXrmYbYBLRlOCzVQAN0+hAmIMjOP2fC2r4hOhTkjKpNR0WHo4o4kAqc4M6WYnPAh4BpiSu++em8n9T1ctZ9KN+7b7j6rl3TkI4E4SaAAfCiv1QQ4kA6sN/u+WFzwByHAJ6nbVsvGo/o+c7HJlIAbXXPrktHuf889Vbhv8H47xGu2r50jWhhk2/Zt5/MZwnlvRT4d1/fGe/svnC7sO7/3U4A6N1O0O0E3U7Q7QT/YCcYUXKrxm95lS9IjwWMkse8nFXz+vCkq3GldFkfX9V0D93najav6sNdkX8dX7zRhTYCy8+iWI++AcS1g/PqEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "717",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "6",
    Length1: "3",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1688",
    "Maximum Size": "25",
    "Minimum Size": "20",
    "Nominal Diameter 0": "25",
    "Nominal Diameter 1": "20",
    "Nominal Radius 0": "13",
    "Nominal Radius 1": "10",
    OffsetHeight: "12.5",
    OffsetHeightTemp: "0.003418",
    OffsetWidth: "12.5",
    OffsetWidthTemp: "0.003418",
    "Overall Size": "25 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2100.5",
    R0: "13",
    R1: "10",
    Size: "25 mmø-20 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "593965",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.4304001",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjkEKwjAQRe8y6xiapkmbuBIVBF2UIrgoXUQNbSAmUqNQSu9uVAru5s1/w/x6hPJsjsNdg4S9P5tKX4JyrdWAoPTGhQfIevyNUUkpZjQny0UqcEEzBlMze6u+V0OU42Jj1E0H3YNMcILgoF0bug8QknEElQ8qGO9AEszyJBecpjwXWSF4TE/m+i/vtGm78OUkSxFsrX7N1yyWoQWCtbc+PnNPa6fmDQMFJlLTAAAA",
    Pbi3DGeometry:
      "pR0AAB+LCAAAAAAABADtV01P4zAQ/S8+h8pObMcupxWLhAQHBCvtAfVQRASRsg0qAQmh/ndCmwQ86YtdVtwsBKKezsd782HPzRu7vC3/vD4WbM7O69vyuq7KO5awy7pcNU9sfvO2+7cV8+P2h22Sz5Mjwfnx9k/7yzaLXu3Xer18bXXTbKayXCRHqZ3lNrWJUO1BZpIPgdZ6KzBcif0CLcMUcmN2gkyqIEt9TCbXqSPgOXABUQwaxIXX0si3V4AZdH1Lq+R+PmBQAIXMpXZdW505gsGS1q7GgGKksXOhU2X2WhoJsO8u2JFrGFPPh2oPQmLCriG6zoXOAtFBOqAHiM6lA9eT6NulF+TTRWBs5tInjQqsM9QU5BxE5M80OUeReut7VBkQ84Eh+aGRPA8KQ+3R7JDehYUBLflnGRwP1DeqAMyfn1jYpKjwaZci4AEtRCmEwGGlSd0xIuzWt+ZKT99emU07QWfKGknw7SwJEYTuYDqIfRSP0pJcs0bZwPsXXvFUoEQfk7H/wxIcvN+AB1MqbO4OfSHs1G0QoECjRRowKGwKco5LFjECJwgaOSitOFoYFMwfHHdIAdYarmdECHpoDiikTfdnyb3+P4PVoMzhfYEvGC6+tnePuj0nz0zgGr4X0Dl8eEDXiCa8CsDK9PIH31suTXB1QCwhcP6nISkB2PKQb3/NhGGDaYCgceJQgvwjkNABXUCe4sYZN86glo8bZ5iHuHHGjXPq0RY3zrhxHkRH3Din4cWNM26cceOMG+c0S3HjDBodP7txLhL2u1z+K5pizeZ8xhN2Uazum4fuw1XdLJuyXnUf/5Z3g+isKO8fmu7DaVW8fP3iSV3VrcHVc1VtFu9V69ArpR0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "954",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1691",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "7782.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593967",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "20.77624704",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yy6dTNTlFBUIcxgg5jByvZBNNYFoyx754Vg27Py+/hqUcoz+Y43DVI2PuzqfQlKNdaDQhKb1x4gKzHn4wIITgXbLkgBc5pxmBqZmzV92qIbAw2Rt100D3IBCcIDtq1ofuYNM04gsoHFYx3IFPMRCIKTgkXRZYXPLYnc/2Hd9q0Xfj6JCMItla/5jXDjNIcwdpbH8/c09qpeQNLUSTX0gAAAA==",
    Pbi3DGeometry:
      "kR0AAB+LCAAAAAAABADtV01v2zAM/S86u4EkS7KUnop1wIDtUGwDdihySFGjNeDGQ+YNCIL893mN7MSsn6W22E0I8mEq5CMfSUm83bObu+r77mfJluxzc1d9a+rqnmXspqk27S+2vN0ff3bL/LJ7sUN2klwIzi+fP7o3O6x6tavtdr3rdKVc2EJnF9J130ZmQi90ntvsn1xpv2DUtJxrEaWQ5/lRnisdZ8m7VDjpzuWOKzWJAEI4/Z8AhAxR4JAcc0eBhTGTXCCPcAg5xXYmHy94S8aMFYYgXih4CCO1nbL0Ug6he2cpNvJpoEMrE+kTwsbheQxDCUTRIWiMgKIjdMBycr5ThoUiUARSFmP+lNWRdQZbgjYjciqcbLoAvQ0XOa0PaOrVXgXjo+keFIYSpFkiLQzKA9kJ72ZoiyByWAOQvDCrsE9R6ZM2heQFDRE5ChqFYI32C8o9AxuuzeyxVUjby4+WnFUkNn7cIISIC+3VXBAA5JFVBTlhrXaRRy863Im8Y6t3Sb6LJbTtviE4mFEn1XjHF8LNHQURCsRZpAB9gpYg4bBcER3oLoK2GZRS6Cp0CaYO7nBIAZYZLmREB7xcDmEI56ZTRA7+k7sc1Dg8IvCZ4s4buw+7cJbcLwEyAoBydOOAyIilmes/LMwQfTM3rRFNeF5ANKHwwpdCWgOw4yHj4aKJCw5mAkcNc4dSFN4AKR8QAxKV5sw0Z863e5ozIxHSnDm7kObMSeA0Z6Y5M82Zac6cvl2mOXO+kNOcec5smjMn6ynNmfMp+s9z5ipj19X6qWzLLVvyBc/Yl3Lz0D76h69Nu26rZuMff1T3w9Knsnp4bP3Dx7r8c/7HD03ddAY3v+v6sPoL8ODx7ZEdAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "954",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1693",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "7782.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593977",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.05779936",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnDdRd9PFTlJBUAeJoIN4UFp0YNsJ2wIR/3tLmlCXbvPme7z38h6yCk/dTUECe6owI93VZIBBRmjsHZK8H09nCEMvkiFfLXjgxTwWMLAvGMtA/oeR4NEvnGNHWHzq07YtO7fBPTZYXpVVLSS+5zM4KFPbZhJHsqVFN3uUZ7zMaKewbuxbSM4ZbLV6Tt5AuF6xZLAmTS7XPLQeihd5Q78nEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVl1rgzAU/S95TsVoTaJ9GttgsD2UbbCH0oeWhjbgzHBuUIr/fa7VfsVDIkUUk+M5JzfJvXG2I9Olft9+KZKRZ7PUbybXK0LJ1Oii+ibZbHd4beBw0lykpqeeEQvDyf7R3KSed7S7slxsG24UBVxGMR3FLBBxxCgbByLiET0HeBom/wCX4+QCECxN90DKBfWS6hgiSXivh+BCDgPsUQ2OA3uMpeyXggCU4qw/8EO/NYV4sFfWQjLZuxpH4FrqxLiaKYvRRWF5dGG4pZwe1qigOYwcM6DH5Wrc4u0aFPK2lglPIUoanGbDpXwBOFUwBdwMvKt8zdHCDq8vbiW/frhB3ImMGcjC0xptweH1zq3k1w+zBdZBDway8LSGBdX/IPGX8gZgmfBIetdpbHucAc0/w4NefKpKlSQLg5CSF1Wsq03beDXVotKmaJsfenWEnpReb6q28Zir3/MP701uGsHiJ8/r+R9v0kpn5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "689",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "10",
    Flow: "1.7 /",
    "Flow State": "Turbulent",
    Friction: "7688.60 /",
    "Friction Factor": "0.019124",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "30",
    "Loop Boundary": "No",
    Mark: "771",
    Material: "Copper",
    "Middle Elevation": "689",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "233.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "85661.50265",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "17",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "689",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593979",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.84055395",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0WbVpPYkKgh6KCB5KDy0NbSAmUqNQSv/dYFsPInjb2TfMTNpBUqhze5MQw8EWKrG6rawBAolVxt0hTrvh9AbOqeCCrWbIaCgwhJ78gkgRw8U3jDiL/sEpNpvq102Tt36Df2xVfpVONhAHNCBwlKZy9ShO1uVO+dmDvKjyg/ZSVbV7C4FIYKflc/SyOV0KFAQ2Vlufax5a99kLnrYfHRMBAAA=",
    Pbi3DGeometry:
      "yQgAAB+LCAAAAAAABACVVt9LwzAQ/l/ynJW0adMfexIVBH0YKvgw9tCxsAVqI7UKY/R/N67dbJtcEikry3e57+5yuY+uT2i1Fa/HD44K9Ci34kVWYocwWklRt5+oWJ/6v8pMlupBHf5DFiEhy/NL/VC3ubjdNE15VL5RFGRpghc0DNKMpjiMg5SlIf7FKaVTQ5TEZ0OczDySOMcWppzEsdEhDxkzh5gxsYxm9pygIqCU/h0ZwEEirWiWM+PpXXDf0q4Z9UQ0oFTtGLehZxoZJkwjfHoYusNQgyEEwATivilNj1vHwVTB2uYlDMftTeTKCC5t3h9no8GGggPnuAKGGN7Z+rXaMHF2ItDBX04crTbIDGTwvjQzJoMBHCGHPoBUHori9nAMtiZCIO6tEFMi/fJbp8sgr1YecL+urlZZN+QDqTSE23n0/O3iYJhPb9XwlJlJCeq74E6U77zlDSpIQDB64vW+PQyLZ9mWrZD1sHwTu6vpgYv9oR0W9xX/Hm+8lZVUhPVXVXWbH3qRjpvJCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "45",
    Flow: "3.0 /",
    "Flow State": "Turbulent",
    Friction: "21917.14 /",
    "Friction Factor": "0.017249",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "474",
    "Loop Boundary": "No",
    Mark: "772",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "10380.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "152287.1158",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "593981",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.13000627",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNI0zyauhIVBF2UIrgoXVQNbSAmUqNQSv/d+OhuznCGqUYozuY43DXksPdnU+pLaFxrNSAovHHhAXk1/mJUKMWZ5MtFmmChCIepnrVV3zdDdGOxMc1NB91DTjBBcNCuDd0HkkwwBKUPTTDeQZ5gLolUIqVCKpYpIRCczPUvM6UQ7LRpu/BlwiiCrdWvec2wkClHsPbWxzP3tHaq35bp1n7SAAAA",
    Pbi3DGeometry:
      "8SUAAB+LCAAAAAAABADtWF1r2zAU/S96doP1YUlOn8o2GGwPZRvsoeQhpaY1ePHIvEEp+e9zY9mJLB0pzrMoLXVOrs65H75X3Ic3cv9Y/3j9XZE1+dI+1t/bpn4iGblv6133h6wf3oZ/ezi/7X/IITt9ckPz/Pb4p/8lh81odrffb197W8ZWWhUiu+F0pTRXGRUrpWSZvQNcaxuQjBqAW4DUJQ9bMF7YACt0+CglpA0oflRVUqpmHFRmIT8CFpiDzlRpFbQIBdHvIOQomXRiFXZjpChKxb3pGIEpHaPaCZirdY4aEzhZnBK4kGPy42QxS8dEPk/HSdUsHR4LwAEdhCFZzDEl8CxWl7khy7ywq+rqiLgFCjhwHSIO6B8qXFzQS5mjAHxhHbdxkiJZvdw7cFC0gY1aow0s8Cot74WAPK4KkruvEmySqhwAprQ5ikVGELKAHNDBaTYJZnW2wMyKTbnZSdd74YRQmGqT78E+Wmgedi9q4RkCoKUb92SRD58LZfvtDIcRkP1LZwUEHAS1Qkl4LgGK6EluuseWyvMByIWIXIOQhShMIdDS9C8ePgkZRCeG0/+hJug3quaYJpcaeQfLA15oFDdZ5fQIlDkPWyAKWDdo5OKQQ1HwqMVuKE1NLpgsDaAHgFEL6MtZGoDN+oFSkaOotvMt2bUUxkIWgtoWVMxiKGxRo8WZKGSBOWCoYESWc2i7qsZQATdg8UDuQI0A4KrgArnwxUSigEGI2htB1LZxxEGKorPKVeoXhEYSLCc4ibFFgAMVIHIbT1AQj+Vq8WUNAPFG4WktfgBfsZAoYBCg9rdBOEBx3wSN6IJRPNcKJIFJjJvK8jaEKeAUAV7Duw+KRtpLpb1U2kulvVTaS12U1bSXSnuptJfy3vXTXirtpdJeKu2l0l4q7aXSXirtpdJeyteI0l4qupfaZORjvf1VddWerPNVnpGv1e65ezEP39pu29Xtzjz+rJ8m6HNVP7905uFTU/07/+KHtmn7A3d/m+aw+Q+W//dT8SUAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "28",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1696",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "16",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "593982",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.51785138",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0idqknkQFQQ9FBA+lh4qhXYiJ1CiU0n832NqDCN529g0zk7WQnvHY3DQksHNnTJ1pSmeBQOrQ+jskWdufwcA5lVyyxYQrqngcQ0d+QMHoTMXiGyrO1B84xuaf+mVdF03YEB5rLK7a6xqSiEYE9tqWvhrEwfnCY5jdyxNeRrTVWFb+LaQQBDZGPwcvm9K5FJLAyhkXcu3DmC5/AXQ6OkoTAQAA",
    Pbi3DGeometry:
      "yQgAAB+LCAAAAAAABACVVl1rwjAU/S95jqVt+pX6JNtgsD3INtiD+FAxaKBrRpcNRPrf19XqmnpvGhHFnNt7cm5u7qGrI1lu5NvhU5CcPKmNfFWl3BJKlkpW+ovkq+Ppbxv25+2HNPQfmQW+P+9+2i9p1ue0RV0XhzY3DL0sjeks5B4P05QGkZcmaUD/cMaYGQjjqAtE8Sgjjji1MHE/isAEHiQJvMWIKclYZteEFYFJunlnBEeJropOeAKe3hl3Le2iqCNigRfzlBlt6JiGgSHTEDcOA0g41QBtgTChuKsk47gBHJWK1jYuoT9uZ6IpRXhp4/5MNhptKDpw9isA7eGs1qnV0MRZidCEG+zE3mrIZrCA86UxmaAAOkJ2f0CpXBxlOsM+2NcmhOLODmEQAZffNl2Qvdp40OcBd7XZOqQHc2kMt/IA+q3mAM2ns2u42YxZQvtecC+LD6FFTXLf8yl5FtVO7/vFi9KFlqrql+9yewk9Crnb637xUIqf4YN3qlQtYfVdls36FyHriBDJCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "55",
    Flow: "3.3 /",
    "Flow State": "Turbulent",
    Friction: "25381.55 /",
    "Friction Factor": "0.01702",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "509",
    "Loop Boundary": "No",
    Mark: "773",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "12916.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "164977.7088",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "594001",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.3569706",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzG0TX+SehIVBD0UETyUHloMbSBmpUahlL67wdaCXrzt7DfMTN5DVqlTd5OQwh4rlaHuajRAIENl7B3SvB9PZwgCmjARLRcsokkS+zCQLxiFgfgPeSzEL5xjR1h86ldtW3Zug3tsVHmVVraQetQjcJCmts0kjmhLq9zsUZ7VZUY7qerGvgVnjMBWy+fk9UMac8YJrFGjyzUPrYfiBezbDLcTAQAA",
    Pbi3DGeometry:
      "zwgAAB+LCAAAAAAABACVVl1rgzAU/S95TkWjSdQ+jW0w2B7KNthD6UNLpQ04M5wblOJ/n2vthx+nSRDF3OM99x5v7tX5nsxW6n33lZGUPOuVetO5WhNKZloV1TdJ5/vjbQP70+YgNb1YJoHvTw+X5iT14uR2V5bLXePLmCfDhNNJyL1YRIIGkScZj+g1IJOQ/wMiEV17HITjDhBomSSPkg4QcxaNA+zAJOIwtsrpRDSwQ3EoV5wSArC6owgpZGCVLBTXE8EjloyKuABdprMdMvXFDZiGAIrdU2fOqVtqi5RgZKiuWwizOBgblwKpQ2/DVLrhNrNtOwsqWFTXrWzrYPHKgQO0G0bHsOuciWwBuDvMHYw9YAznrek8G92Z7Oyo5dHUNz+P+O3iouY1foVceSztcDhYtLrp03tjGjd/Bw9q+ZlVWUlS3/MpecmKTbVtF6+6WlZKF+3yQ63P0FOmNtuqXTzm2e/1g/c61w1h8ZPn9eIPgtbmt88IAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "10",
    Flow: "1.7 /",
    "Flow State": "Turbulent",
    Friction: "7688.60 /",
    "Friction Factor": "0.019124",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "60",
    "Loop Boundary": "No",
    Mark: "774",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "460.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "85661.50265",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "16",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "594011",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.37756611",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzG0idW0nkQFQQ9FBA+lh4qhXYhZqVEopf9usK0HEbzt7BtmJmshPeOxuWlIYEdnTMk0JVlgkBJad4cka/vTG4TgSqhwMZGSR0LG0LFfMOIzNY++YSzC+B8cY/OxflnXReM3+Mcai6t2uoYk4AGDvbalqwZxIFc49LN7ecLLB201lpV7CyUlg43Rz8EbTv0WqRisyJDPtQ9juvwFtt4a/xMBAAA=",
    Pbi3DGeometry:
      "yQgAAB+LCAAAAAAABACVVt9LwzAQ/l/ynJW2afprT6KCoA9DBR/GHjoWtkBtpEZhjP7vxrWbbZNLImVl+S733V0u99H1Ca22/PX4wVCJHsWWv4ia7xBGK8Eb+YnK9an/q8zhUj2ow3/IIgrD5fmlfqjbXNxu2rY6Kt84DvKM4gUhAY1JgaMkyNIswr84IWRqiGlyNiR05kGTAluYijBJjA5FlKbmEDOmNCe5PSeoCCilf0cGcJBIKzotUuPpXXDf0q4Z9URUAWrHuA0908gwYRrh08PQHYYaDCEAJhD3TWl63DoOpgrWNi9hOG5vIldGcGnz/jgbDTYUHDjHFTDE8M7Wr9WGibMTgQ7+cuJotUFmIIP3pZkxGQzgCDn0AaTyUBS3h2OwNRECcW+FmBLpl986XQZ5tfKA+3V1tcq6IR9IpSHczqPnbxcHw3x6q4anzExKUN8Fd7x6Z5K1qAyDEKMn1uzlYVg8C1lJLpph+cZ3V9MD4/uDHBb3Nfseb7wVtVCEzVddd5sf5tcTyckIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "40",
    Flow: "2.9 /",
    "Flow State": "Turbulent",
    Friction: "20274.10 /",
    "Friction Factor": "0.017373",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "659",
    "Loop Boundary": "No",
    Mark: "775",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "13370",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "145941.8193",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "3",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "594020",
    Name: "M_Pipe Cross: Standard",
    Category: "Pipe Fittings",
    temperature: "19.1014593",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABNjUELgjAcxb/L/7zG3HTTdYoKgjqIBB3Ew6qhg7WFrUDE794khG7v9/g9Xj1CeTXn4alBwtFfTaVvQbnWakBQeuPCC2Q9/mJUKMW5yNYrluGcMpiaxdr0vRqiGoudUQ8ddA+SYILgpF0buhmoSBBUPqhgvAOZ4EwQUXBGuSjSvOAcwcXc/9yDNm0XZkxIyhDsrf4s4xRzwWK39dbHK/e2dmq+QuAi4s8AAAA=",
    Pbi3DGeometry:
      "OTgAAB+LCAAAAAAABADtWt9r2zAQ/l/87Ab/iC25fRrbYLA9lG2wh5KHlIbWkMWjywal9H+fW1tKLenznexkgyFKS+Lz3XenO59P+nr1GF1e118ffmyi8+hjc11/abb1TRRHl0292/+Mzq8eu4+tOLlof6Kn+HDlLE2Si5c/7W/0tFJqb+7v1w+tbpYtRF4V8VleLIQs0zhdLkSZ5bFLUEpZDASyvfH5usjdCrYlkcgXQVYs50HIoqrcCr3AwsaCDkIIUc6LDvqKAGAMokidy8SNQS4L0StkWacgO4Hwu58dg/JI5su8E5S5eBEsxWhsMsukWwAsMXyFq8SEwNEhZ2FOZS7SHqIr/VJW7oLVGjQGFAwL0Ei2vky75K0AK9mwpHInqry31OZwxFV0P/shPeShT7VQlZy0Fsd6k86DJUCmaG9hm2Nj4ACRu7Bv6bQK2ddTmY53OgYGEpgNB/Qh0iVvBSuGHrl8/jAocpkOBbpyDMFh/ZCGWiatobMKTFVpWvEEGgOFwbyuFhAiIwX2+tGxZSJ1LhMOWmFUhXSnQgnMZdLXTW8tSyp3WmDmjguhozAVLIG1UpZTBoSZC350SAEA4BhU7sxlImOwC1D1FOMJHnkmgAZVskbv0DGYTYtfmFYpW6YmB2GlIllmPiMdeT+Z64OrauAaTkm4BpTAHFSgJeQr9gnXH4AgLdnJVm9z4xUM2xPWgBiwbtSKcAcl0JWxSwgAR0e5ZGMjS7g+YMtUM7ExgdINysJAlUP1RmPFoUv4feAbg+9Q7D/aQEtwxEUQ2NLsIYkc4bEAjvAQfPzxsl+0YGeEBdxXNpx5yH0ixsYaFIb1sMAFxLsm7hhN7jbg0I8FaDKA2FCBQLD2J+AQgz1mUgcrOKkQgjocQmMm2MNZt0P77PFdC7Ap12rkiyRNHA/wq+vDbbND0EGzNAZlyTE1WMDX1wfHJ4woKAWIwHeJWD/bEEQY1CUMwneQ9Q56dMx0DY0IgeXS5NUgp25qGscIPAHLFKw/I6cjox6chpyCIzwU7MmNd4wK5mHvHjQ6izun95HQSJ+mdzN6l0NufzAGT8AyRfVxxp4dnkg4BYxOxHsjME4FEA0TuLvA3QXubjy6wN2xYgjcXeDuAnf3L7g7NhdHkXrH4+68KTocw//N3flSdNjQybg7SDOSpF7g7gJ3F7i7wN2N10fg7hxvlsDdBe4ucHeOAAN3F7g7xLZA8mQqTzaVlDopoTibi6NIPVuBOJ6eSnGCMptwzn2CI/YjnPvPIB0sDIrROQIP40m3eFNZ4FV7GlpqJlfm7+vfJCbns6UzqFrWBu+o1LUnRe3N/fv3oRlE/px/LljF0bt6/X2z39xH58kiiaNPm93t/q7/8rnZr/d1s+u/fqtvtOjDpr692/df3m83v1/f+LbZNq3B3a/t9mn1BzwQSJc5OAAA",
    "Angle 1": "90.00°",
    "Angle 2": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    H: "41",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Converging/Diverging Tee/Wye",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1698",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "Overall Size": "25 mmø-25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "16",
    Size: "25 mmø-25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "594028",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.5879075",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NIjG2TOokKgg5BBIfSocXQBmIiNQql9L8bbC3o4vbufcfdZR3IUp/am4IU9q7U0pm2chYQSKetv0OadcMZDHOGCSXRcsYizGMhoEdfkArxlyVJTH/ZFDrA/FO+apqiDQvCY6OLq/KqgZRgguCgbOXrURydL7wOowd51pcJ7ZSuav8WnDEEW6Oeo5cucMwZR7B2xoVc+zCmz1+9IRaHEQEAAA==",
    Pbi3DGeometry:
      "pQgAAB+LCAAAAAAABACVVctqwzAQ/BedHSP5Jds5lbZQaA+hLfQQcnCISQSuVVy1EIL/vWpqp/FjkERIiGa1s7PS7mp9IquteD1+lCQnj3IrXmQldsQjKylq9Uny9envrzbTpf6Q1vtHFozS5flHf0m76d1umqY4at8g9CmjsbcIY5+nLPRY5PMgjrxrQxoH0a8hyZIhnkTJvAM0dEw8jrKBgWdhPGtIg7OmJA1TK0090QSHySGtUBLWirLrkuAJZ1ZiYXKjJFiWzeZwwYc8PYxoxomNaSY4CDtKy6BmdMNGMSgoOpvh2ZtyQmEhPThicASGi5pWjm2LmZnQJboWra2DsXrA9nnYNCCmMh15rA2oIoxdih1QBMdadJ59zkR2OOhsNNNN2wG7XVDQp+b3xZHGDkdzwNzWphcVz1r95t+J4r1UZUNy6lOPPJX1Xh26xbNUhRKy7pZvYncxPZRif1Dd4r4qv6833spKasL6q6razQ+Bf0L7pQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "10",
    Flow: "1.7 /",
    "Flow State": "Turbulent",
    Friction: "7688.60 /",
    "Friction Factor": "0.019124",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "57",
    "Loop Boundary": "No",
    Mark: "776",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "441.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "85661.50265",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "12",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "594076",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.55042089",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+L7ort2kkqCOogEXQQD0qLPth2w7ZAxP/ekhZ26vbmfcPM5D1kFZ66m4IE9rbCzOqutgYIZBaNu0OS9+PpDYxRGQu2WnBJl4FgMJAZ5DSU8i+Lwyj6ZbPQERaf8rRty84v8I8NllflVAtJQAMCB2Vq10ziaF3p0I8e5RkvX7RTWDfuLQTnBLZaPSdvGNFYcEFgbbX1ueah9VC8AEtdMZgRAQAA",
    Pbi3DGeometry:
      "qQgAAB+LCAAAAAAABACVVdFqgzAU/Zc8W0nURmOfyjYYbA9lG+yh9MFSaQPODOcGpfjvyzpdzezBK1JpzvGee0+Sm6xPbLXVL8f3nKXswWz1syn0jnlsZXRZf7B0ffr9a2m+sA9rvAsyE5wvzi/7Y82mC1tWVXa0sUHgK5kE3ixUvhRKeiLy42AeeQ6hePJDSMv38ZiHV79HeKcTzyPlEqEAhBRnKZmECamkTmmAI2+wVlgSJKC71kQsY0ErFplzTIS+UGro4QI7Mj0YqLjGhjL/cZS1b2q8GGeBx4tBSZEnZ+rHPcE5QPrA1fU5GFmnwcYh9RdBh0igaYNbmRKAMpAyo4UhNddkJRqBNgWhT3EAyjB1O049/SYLUXDU3fBcpwSABJS8oF1J18xUIQoODoTxBh+7V/GRa+/9W5295XVesZT73GOPebmvD+3gydRZrU3ZDl/17o+6z/X+ULeDuyL/6n94YwpjBcvPomg239imOLapCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "10",
    Flow: "1.7 /",
    "Flow State": "Turbulent",
    Friction: "7688.60 /",
    "Friction Factor": "0.019124",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "70",
    "Loop Boundary": "No",
    Mark: "777",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "541.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "85661.50265",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "1",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "594098",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "21.06473207",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMMTfPTpp5EBUEPpQgeSg9RQxuIidQolNJ3N2q97QzfsPUI5dkch7uGAvb+bCp9Ccq1VgOC0hsXHlDU4++MJE1xnvHlgkosBKEwNX+26ns1RBuLjVE3HXQPRYITBAft2tB9AskFQ1D5oILxDgqKCSNcpoJTnstMUoLgZK4zZlIi2GnTduGbE4pga/VrHhOGRUYjWXvr4y/3tHZq3rLWbpHRAAAA",
    Pbi3DGeometry:
      "rSUAAB+LCAAAAAAABADtWMFq3DAQ/RedncWybEnenEpbKLSH0BZ6CHvYEJMY3HXZuoUQ9t/rer1OLfl5RuTQiwgJsUYzb2Y0mhHv9lnc3NVfn35UYis+tnf1l7ap70Uibtr60P0U29vn87+9OL3uf8QpeVm5kml6Pfzpf8Vpd1F7czzun3rdLNuU2mbJlSo3WkuVyHyjjSqTmSDLy0Fgl9eNlkyFtLSDQlbkTEujT8ZoR1AaswgBgyAUIEKAT1QCfVMIw8gMZGoehrHSLkJ4Ak/BcZZhyTm9V0CgIJzMegq+T5QGP0/Q2VAI9+xgFNYUBAI3H7A2EQSsQDrlsDTDBeHgOPDQ3JKn5DYKdnikJWfddZVqXbR9piEEjNbZ99cHdgUyy8frqM6tY32AUNuZAZSZLohBRE2oi0e0JVYIMHU21/IsUL3iYKevsrVDQwr8jn8pC5Vf1qUcYktzuToJbKaWswFNMbxFQ4ULgSzhs5ZFNreUa7s+x6FGquwsPKOtXDeFNOgO7groMNzAYTHTYUCvnPhgicDJbJXRsxtjetV1DRoDCphzk+FUuIZXVfLcKoq/2V4TOH18Wp66LDJ0OfBJMF2BMASrrObsf0mGs98d16TC1E5BaNDTQICpltwUkSGgUvKRQWFgQXBWoQA3bISNNSgMP4NoKLBzTk0q7C2EoOYtKij09vD2QwAYHFjHhlA2Al1Fz63lZXb3QVeXfFIBd/B+AsDvemhisvsk/SKA3kIM6kXgtYHABoSnO3sAka8XxmMksk5LCpF1iqxTEERknSLrtN5yIusUWafIOhHeRtYpsk6zGxNZp8g6RdYpKKuRdYqsU2SdIuu0uP+/sU67RLyr99+rrjqKbbpJE/GpOjx0j+PH57bbd3V7GD+/1feT6ENVPzx248f7pvr978a3bdP2Bg+/mua0+wOVyKoMrSUAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "28",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1701",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "16",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "594122",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.11061988",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzG0SWzTehIVBD0UETyUHiqGdiEmUqNQSv/dYGtBL9529g0zk3eQnfHY3hSksLNnzKxuK2uAQGbRuDukeTec3sAYnQuWLGY8oXEgGfTkC8YylP9hFArxC6fYARaf+mXTlK3f4B9rLK/KqQbSgAYE9spUrh7FwbrSoZ89yBNeJrRVWNXuLSTnBDZaPUdvKGgkuSSwstr6XPPQui9eJ/8HMhMBAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABAClVl1rgzAU/S95TiV+Ru3T2AaD7aFsgz2UPrRU2oAzw7lBKf73ZZ22VXuaK0MUc0/uufckuVfnezZbqdfdR8ZS9qhX6kXnas04m2lVVJ8sne//Xg0spuZiNT9ZJq4Q08PD3KxetG43ZbncGV/Pc8LAS/jET5zITSLuBo70woB3gETEv0Bk8HO7FP7F+cje8sgwSLqA7wIgcg9UUezHpJRapoEdaYO5wpQgANU1ImQkXVqySFxPhIyN/wURR3uP6GRHRH1xA6YBAEN3tdlT6u20PSUYGYrr7YNdHF4OGAPJA8th27nBYSLWnJ2IDMD1gwec4AFjUIPDPSKU3XgqeA6gB+ylVI//HEIbFbk7jmei2WHZw85P8EAhiKFRDRM+RqOZaHbUJaxFb/sAX2nK5g/hTi3fsyorWSocwdlTVmyqbTN41tWyUrpohm9qfYQeMrXZVs3gPs++zyfe6lwbwuIrz+vFDwh4xDnTCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "676",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "688",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "10",
    Flow: "1.7 /",
    "Flow State": "Turbulent",
    Friction: "7688.60 /",
    "Friction Factor": "0.019124",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "4477",
    Length: "73",
    "Loop Boundary": "No",
    Mark: "778",
    Material: "Copper",
    "Middle Elevation": "688",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "559.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "85661.50265",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "688",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "701",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "4.3 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "594380",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.9553682",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjcsKwjAURP/lrmPIo0ltXYkKgi5KEVyULlINbSAmUqNQSv/dqBTczRnOMNUIRWNOw11DDgffmFJfgnKt1YCg8MaFB+TV+ItRYRxLIvlqQRNMmYCpnrV136shurHYGnXTQfeQE0wQHLVrQ/cByoVAUPqggvEOcopFStJMcibTLFlmUiI4m+u/vNem7cKXWcSd1a95zDHhlCPYeOvjl3taO9Vv47q+zdEAAAA=",
    Pbi3DGeometry:
      "HyAAAB+LCAAAAAAABADtV01rGzEQ/S86b4w+V1rnFJpAoT2EttBD8MEhS7Lgeou7LYTg/16h/Yq1fpKcswhOvHqZeW9Go1nNwxu5f2x+vP6uyZp8aR+b7+2ueSIFuW+bffeHrB/e+q8Wptf2hxyLeeWKUXrtftkPOW5Gs5vDYftqbblYqbKSxRWTK1bpqmBixSRjhQVKZcQpQCV3gBTsvAUEaOm5UnYhSO67oqWWQVVK2b9JckdX0GKhKmqBVaEAIcciV1TxcBwzOVduXTBxalAy8x6Ywzg1QOuTI2oMOwEA8xycxwwlzVFrzc66WnAjUTCKkYJqXqV5QtzRRC0yDhMyxW0Ed4Asw/VxuStYUQkcyUdmAoTUg4VJBFJrB5VIQg5TtyMhcC+M+QiUTDqgkip8XOEZgK6SO/GSI7m7xKsHAv5+xAP0jk08h8l9JB64H4ZiqgesLweYsnSAoEMt0MoBjNEekGW/LrXjttEMfZjqwcB6SOufiHvqVVXPQbWUEVGIA6kVdEiIHF5M4Vf4FNwIcK4jm4fShKoZ1z/kRvmDlXbxFsGEQ27oCr6ALt9taDGVuVAuh0xU4aKFFOfrI55x2LzQVvibipTi0oTUcIsABcweusCWXBlPlOGB9EEC6AdanCeI9odF9s77ievxM4GEJlyBuZXgGoGpLruYT66MGXea6T5srcIDBpQbv7BAVX4cEIjKxTdOXxUm52OnS/UUM0i8T+Mr+5RzKofzqGSQOppZeGX/QIWkblJCl1jEh+TGOZCrPK7ncT2P60nceVzP43oe1/O4nsf1PK7ncT2P6yei8riex/U8rgcbYB7XPzSubwpy22x/1V19IGu6ogX5Wu+fu5fh4Vvbbbum3Q+PP5unCfpcN88v3fBwt6v/vf/HT+2utQ73f3e74+Y/yQW0Kh8gAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "22",
    "Center Spacing": "22",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1702",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    Offset: "60",
    "Overall Size": "25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "38864.3",
    Radius: "16",
    Size: "25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "13",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "594421",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.01886555",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUELwiAcxb/L/2zidDq3TlFBUIcxgg5jByvZBNNYFoyx754Vg27v9/g9Xj1CeTbH4a6hgL0/m0pfgnKt1YCg9MaFBxT1+ItRoQwLIthyQRMshZQwNbO36ns1RDkWG6NuOugeCoIJgoN2beg+kDDOEVQ+qGC8gyLBPCNZLhgVWZ7KXAgEJ3P9l3fatF34Mkkpgq3Vr3nNMOE0dmtvfTxzT2un5g1JJBlZ0wAAAA==",
    Pbi3DGeometry:
      "IyAAAB+LCAAAAAAABADtV02L2zAQ/S86e4Mk6zN7Km2h0B6WttDDkkOWNbsGNy6pW1iW/Pe6K8WJZT9L2dKbCAlxJjNv3uiNpLl9Jjd39denHxVZk4/tXf2lbep7UpCbtt51P8n69tl97c30un+RQ3H65YpRev3y0b/JYXN0e7Pfb596X16ulChZccXZSltpC1auqNKi+GugqhwZmOx/mPNggrFlgzRBKCr4rMcRXCor5kPBrEIDlZxfFgp6wJIcPdJrBQkOBtmXZq5WkIcsSwdulDHn4CdDyRcdBuJRg6VSvwp7oBfNiSk9oh1CTyJFc5qy4NQuYkxCQXBcQsQvqIcwzPOmanG5UQXjkZIVFRXnUssYBy4tSzOkVnDKO1QIJJ6owXhPQhJWyWMkMZJ/vFkDfaBIcGvBENAAhQArGC8tatfYnjPQgCVM7KQ4bUjCGOUMWruchJUvNWfcG4xw7Lhx+ufaYRihmPMIFGW0T8ro5Z0FYUutPIQdJQtzghAoWeVVYIQwPtD8YXwK1COODZ4dFC2ChmLGkRA2LGD8SEpdJFzzKDg+ScKz5+L1Rg6CeQdpxMiAFgOqHAgEs473cLAWcFmxaIE4MTbsbgiBCgivr5IGGyovzXKLQQgYCXkgCLyq8NoOIsGc8HUeJouGDNZ3g1ukUqZdtXEo64VguDukjZonPnigdOF5j7OCPLABpIvvnDArhHG+4/lQiXey8f///UI9ZGT0kbUF94YRdJxaiPAKfVy8RFg4UXqTdKEMUKg8sOeBPQ/seWBPEmce2PPAngf26V0/D+x5YM8Dex7Y88CeB/Y8sOeB/X8N7JuCvKu336uu2pM1XdGCfKp2D92jf/jcdtuubnf+8Vt9P5g+VPXDY+cf3jfV7/M/vm2btg+4+9U0h80fKSAyGSMgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "22",
    "Center Spacing": "22",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1704",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    Offset: "60",
    "Overall Size": "25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "27457.7",
    Radius: "16",
    Size: "25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "13",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "594422",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.18581615",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNI0+bRuhIVBF2UIrgoXUQNbSAmUqNQSv/dqBTczRnOMPUI5dkch7uGAvb+bCp9Ccq1VgOC0hsXHlDU4y9GhVIsBVsuaIIllxKmZtZWfa+G6MZiY9RNB91DQTBBcNCuDd0HkpQxBJUPKhjvoEgwE0TkPKVc5JnMOUdwMtd/eadN24Uvk4wi2Fr9mtcpJozGbu2tj2fuae3UvAGd5Vdw0gAAAA==",
    Pbi3DGeometry:
      "BSAAAB+LCAAAAAAABADtV01r3DAQ/S86O4u+rI/NqaSFQnsIbaGHsIcNMYnBXZetWwhh/3vdSPbGWj9Lmx4jQkLs8bw3bzQjaW6eyPVt/e3xZ0XW5FN7W39tm/qOFOS6rXfdL7K+eXL/9mZ62f+QQ3F8c8EovXz+0/+Sw2Zwe7ffbx97X85XRhhWXHC2spLpgokVVVoW/wy6nLxnpRLFnAOTjC0bOLdTA5V81mPgtoyZeSgUVPCelpyfBQQdUDoGh+Q0QW2jgWs2myYowkrtEmuUMS/JR4Ol5bLHqDtuEPx13KO+aFCWUzsRHnCfIMViOhXBlF5iOEVCzIgBiwvTIXpop3p5tWH+okjJBRWtzYV2kS4f2qg0Q3IGT3WH5YF0J1dgvCeRDGOkHqDEpPyjzRpWCIRCWwumgAZYCSiF0dSiVo3uOKM6mMHkVorrBjKM5coFVVonQ9ry2aDMYODOwI1rgFJ4GZYp5xFsCCWV7r3RSzsLpLZUOhFGeoYhWBQTpACxGmGFf8+NB5o/h49ISgUGpw7XLOJGxyQGQtQwgdETKXmNYBXEudE5Eh4856829BDWe2jLJwa0FlAeLBDYL9EmPml7uK6walFxwtKB0eLGABnEN9cgJi5MpMUQBUZCDogCLyu8scNoQVA4HzBaOF5Qz60knxrARRsiKaa97tKd0T3ksgeKFh/38PYPVSADihZeOXFMgOKIJF39U5V4JZt+/9+36VGzFcPWZea/nxAnCAvwzy+Ns5cHV3hUnEhkAEB5Qs8TepohT+h5Qs8Tep7Ql1s1T+h5Qp/jzhN6ntCX1zVP6AFSntAnJ26e0POE/tYm9E1B3tfbH1VX7cmarmhBPle7++7BP3xpu21Xtzv/+L2+G00fq/r+ofMPH5rqz8sPr9qm7QF3v5vmsPkLQznwLgUgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "22",
    "Center Spacing": "22",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "16",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1705",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    Offset: "60",
    "Overall Size": "25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "27457.7",
    Radius: "16",
    Size: "25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "13",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "594561",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.41560054",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjU0LgkAQhv/LnE1Wt+3DTlFBUAeRoIN4WG3QgW03bApE/O9tZdBtnvd9eCfvIS3p1N0QEji4kjKsWNvaIASQOrJ8hyTvv6dXYhkKoeLVREbhbCkUDMXPW7et7rzsgy3pKzK2kIhQBHBEW3PzBrlQKoDMsWZydqzPdPlv90h1wx+ee9wZfI525J/Lqc82zjg/bh/GDMULp0yq+cMAAAA=",
    Pbi3DGeometry:
      "YSUAAB+LCAAAAAAABADtWE1r3DAQ/S8+O4u+P5JTaQuF9hDaQg9hDxtiEsN2XbZuIYT979WuP2rZerKd3opYssQ70rx5b0ayNHcv2e19+fX5R5FdZx+r+/JLtS8fsjy7rcpD/TO7vntp/nVmcuM+2Sn/+8sVJeTm8uX+stO2m/bmeNw9u7mMbQzRPL/idGOo1DnlG0o0yz2D0upsYJwJzyCV5OtmdBhcugGeK8rFOgxliTwbiHQDFvGAGDiqFny5AbrqwhXEyn8U0efhZnIiPHDChTwbCJHMczUxdK46Q++qi6o3GDaSfTzDB3fhmqAjEFM/HnIYhzrnaMIAUpuVz4cGCICB+5kZGpDOGRRRjSNm7aUEhGyKRlLZGLRqELTRr1wV0BVj/gRhWTxa6AmoMbtQJyTmaY9WsBUjA9VCRKSN5NQSy/wZhNsIxvrywAjIAAsE80ZZxWWA0g13TVi1MK+QBiS+ttbQeIwwJ5QhQgVr0C/nyD5kqWldSUovBqOHJCb7xOK3Zy+sVsZDoFzxqAHG1FdUB95X1OzOApUah4sFga6AUpA3coShZ7e7SUygcqCCADv2BoMJh0GtVgQTX1udsNbCgsSOJdq0b2Lu+A4NnHQYrMEwahSVoE1UNjbhnK12LzLEXGgzpc2yBeBBQEEcBHPpHSrLeQMxfxYcnx6xhKsFgZojTxgbSTh/CB4FRaVq8q0lp8tOm261eYY+r2HRYbTrXUF+EQxsgPWJlgA+pUIM6ArKDiVZTRCGC8Dh6liSD3xN45YPF0EXrdQsnA7J3PY3IE6JHAvCll2H4HHYiyl2lJu97k2uVl3CpeDhEvF5QwWXLCfsaqR5WNrYuRolA5/doSuYcMQPJRxrC6OF2PBGC10hcFwKCBzyW5fXNa2Q1E9K/aTUT0r9pNRPSv2k0K6Z+kmpn5T6SamflPpJqZ+U+kmpnxRWN/WTUj8p9ZOC2P9vP2mbZ+/K3feiLo7ZNdmQPPtUHB7rp/bhc1Xv6rI6tI/fyofe9KEoH5/q9uH9vvg9HPi22lfO4eHXfn/a/gFZUkDBYSUAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "60",
    "Center Spacing": "60",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "54",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1711",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    Offset: "60",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "54",
    Size: "100 mmø-100 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "43",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "595349",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.65853593",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjkELgkAQhf/LnLfFdtXUTlFBUAeJoIN4UFp0YNsJ2wIR/3sbmlCn5jRvvsebl3WQlnhqbwoS2FOJKem2IgMMUkJj75Bk3bA6gxA88EW8nMmYR1IK6NkXDIPFH9CPYv8XTrEDzD/vV01TtK6DO2ywuCqrGkg87jE4KFPZehRHsoVFV3uQZ7xMaKewqu1bSDcMtlo9R+9cci8MGKxJk4s1D637/AViIekAEgEAAA==",
    Pbi3DGeometry:
      "2wgAAB+LCAAAAAAABACdVt9rgzAQ/l/ynEpM4s8+jW0w2B7KNthD6YOloQ04M5wblOL/Prups9HjYhHF3Jf7vrskd7o+kdVWvx4/FEnJo9nqF5PrHaFkZXRRfZJ0ffp7bWC2bC5S03/Lwmds+ftoblJvOrebssyOjS/nXiB5Qhci8WIeU194XPghHdrD0BdngIXBhT2KEn62+76IqQtR5yBkEkwqiCQWF4BMZDgrJkgay81dGQ1pRBVIISfT7oDRAkLZ2dphEE1vRQ9YTL3dWo/R/C6JkUKXBMqEKdgRgbmBABgrJG1vBM50fVB2evZeo8GCxeJ4xHEiZwBcJ/Ds4x6ghrM4uK14Rc6ncgbAE4IXMegBajiLg8dwfr/DqZwBqGigPojOBwVclcGGirbm2UTOANQp0MLHPsMjgSHQ/Cnc6exdVaokKfMYJU+q2FeHdvBsqqzSpmiHb3rXQw9K7w9VO7jP1fdw4q3JTUNYfOV5vfkB9Eg3SdsIAAA=",
    Area: "0",
    "Bottom Elevation": "182",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3984",
    Length: "35",
    "Loop Boundary": "No",
    Mark: "780",
    Material: "Copper",
    "Middle Elevation": "233",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "13",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "233",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "284",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "595371",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "22.696159",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA1jEEKwjAURO/y1zE0TY2mrkQFQRelCC5KF6l+0kBMpEahlN7dSOtuZt5jqgGKxlz6J0IOJ9+YEm9BOW0RCBTeuPCCvBqmGJU0peuVYJsFl1QIxmGs/96261Qf5TjsjXpgwA7yhCYEzuh0aH8l4yIjUPqggvFuxldznyiXUhI4otFtmPqSwMHiZ7YZpwnjnMDOWx/P3dvasf4CWJQE68MAAAA=",
    Pbi3DGeometry:
      "KzYAAB+LCAAAAAAABADtWU1PGzEQ/S97XqL1em2v4VS1lSq1B9RW6gFxABHBSmm2omklhPjvdbKbYDt+9hi4VLIQhOxk5s23x5mLx+r8evj+8GtZnVafx+vh27gabqq6Oh+H9eZ3dXrxOP1ryM2Z+ame6ucnJ6xpznZ/zG/1dLlne3d/f/VgeNt2IYXS9QnXi67v+prxRcuZqG2C4FJuCayRyiGoXrYzQdM4pGTdltAIwWiiDGH7nAt5pFQ3E3hNMgMSeq72hJ6EDRkgRLZ5xlE7hq7pWcRu40nd8YDPLYKrlEVwlaIQ3PBRwB37KEpB+5AkNxivshtyQAyorRs/ZMYLcq1XksV18iSlGWiSoHGUrIUEBEF6jt2XNppYYK8qSZgEsSIOE/zOcjAwv935BkJRaQyiHTGMRqiJoLXYFaVkO+8qxTI5oOVQFORIY8ATTmi965B9s2v0qhViei41nwiTeayVU44wMbVU2fvZFj4pfYBcQZBBa5mFDH0BbQbPoSAQhkhZ6E6KYOB0b0oxg4N4VDnqQnCY/UCr2InLtTqOnq2UHaQtXxuKKkHQEUMr1XH0KDOAr1JSkPf5pMk+cBAgEp9DSahGiRnBzVgluJgleedXy/tQimMGOAl6kpBOuEOgAj6UUd/ydrabO40RDrRH0wcSBQ7cl2BAV2FwRICi0nGCbRPGwwmglbYuA2Wa9iXt89lVNsKQP8hDZWH/yFY26Q+orZ8hh0L24w0IMVH7Dkycs2PgYVHQwJi6YSeaLBTsIGpqbYwLh2CaoZoJnXf2iPk5j0qy24h4BYR5bRodYLAIPrbl9H5+LkkI0B0QwXNHGBkixIyzKkZQjIMJZafg7kRkrTdoRDgoVhCxYV1YSkG7Y4XfmoN8biHa4UgOLbE25YLDdgQDC7WCoiAHVDcCHi583CrQdBTxSL8fs5iTuGgugwyZJUBT1g14GALXMR7ns80O6kqb8sOtxQz5+4qJ369JFwlLVMRPMX8Eh2RoBboSY/MIHOEj6SjYFGz41YWjFD7dwLX4+dLq5E1k3KZcsF1odF9G/oA6pW/ePgOyOg3tpQ38HgfOzUl3uO00MrRjjvwhh6KuG+58deF1Mzm1+HNR9o0oOWH5swYeBChXQUcUNg9eUJPXtLK0+q+XVvDK94bbrPyl1dstp8rSqiytytKqLK3K0qosrcrSqiytytKqLK3K0qosrex4l6VVWVqVpRXZirK0CgW2LK3K0qosrcrSqiytotBlaVWWVnljyxstrS7r6sNw9XO5Wd5Xp82iqasvy/Xt5m5+83XcXG2GcT2//THcHEiflsPt3WZ+83G1/Gt/8P24Go3A9Z/V6unyH+dDJncrNgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "54",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "67",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1721",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "54",
    Size: "100 mmø-100 mmø-100 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "595380",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.52830054",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjkELgkAQhf/LnDdR18K1U1QQ1EEi6CAelBYd2HbCtkDE/96EGtSlOc2b7/HmZR2kJZ7am4YE9lRiSqatyIKAlNC6OyRZN6xsCKUXKLWcSeVFsYqgF1/MV5H8D2Mpw184pQ4sn56vmqZouQEfNlhctdMNJL7nCzhoW7l6FEdyhUMuPcgzXj5op7Gq3VtIHgFbo5+jN+BOi7mANRniWPswps9fDr/TrBABAAA=",
    Pbi3DGeometry:
      "sQgAAB+LCAAAAAAABACdVVFrgzAQ/i95TiUx0Rr7NLbBYHso22APpQ+WShtwZrhsUIr/fXZTJ9HjYhHFfLl8311yd9mcyXqnX08fOUnJo9npF1PoPaFkbXRpP0m6Of/9NtNs1Tykpv/IgjO2+v00L6m33bKbqspOzdpQBFwpuhAqkErGlIsgFDymAzyOubjgLI6GcCSFvMCci4R60HT2Qqpoil6oRAzxJExmeAOpYkF5qiLOuCzLpQqnYu1wd8+AoBxVpqSY3Pp+wuHpcXcXRgu6AEYSXQQ4FarhOgVFB+Ggr6Cyeww41bU+ubG5B437CpWHb2KjRL44uElQ0qMLQAVvafBEsUKcTeSLQ5mBlS5gDtL76oKZN6+xoTS+OFQhQMfDzEF6X12wdyIteC6NLw42BLS+sft1pDCcaO7/O5295zavSMoCRslTXh7ssR08G5tZbcp2+Kb3/dRDrg9H2w7ui/x7aHhrCtMQll9FUW9/APn7De2xCAAA",
    Area: "0",
    "Bottom Elevation": "182",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3984",
    Length: "32",
    "Loop Boundary": "No",
    Mark: "781",
    Material: "Copper",
    "Middle Elevation": "233",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "1",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "233",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "284",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "596041",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.25594225",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzH0L5HUk6gg6KGI4KH0UDG0CzErNQql9N2NtBb05J529htmJ+8gO+OxvWlIYUdnzMi0FVlgkBFad4c074bVG6KIiyRSi1ksuFKJgp59QTmXf0ApwvAXTrEDLD7vl01Ttr6DP6yxvGqnG0gDHjDYa1u5ehQHcqVDX3uQJ7xMaKuxqt1bxH4YbIx+jt4w5oEUDFZkyMfahzF98QLZqozTEgEAAA==",
    Pbi3DGeometry:
      "0QgAAB+LCAAAAAAABACdVlFrgzAQ/i95TiUxmqp9GttgsD2UbbCH0oeWhjbgzHDZoBT/++ymrUaPnKNYmvsu33eX3F1dnchyq1+PH4pk5NFs9YvJ9Y5QsjS6sJ8kW53+ftYwW9QfUtGrZcYZW/x+1Q+p1u22m7LcHOu9YRjEUZjSmYiDNEkl5SIIBZe0CyShONuZjHvmNGLJ2c65SCiKqN0hojQeUxBpInp2GUsxKSRQ2ZMbXtkX0oBpzmI+mnQLDM4PSM5VlnM5fhEXoE909XcOw/VvUxgItCn4mXwSbkhgbiAAxgopu/fgZfp3TG5y7kUjjg9qFHSBI6iwAHRQUOV7/eFyQiqDd+ptxslEaACsDn//gjtADbQ4WIPTB52fCg0ADQMMQJ83yI6UBeeobyBPpUED4IBAtLvvv3eo0QHq94M7vXlXVpUkYwGj5EkVe3toFs/Gbqw2RbN807sL9KD0/mCbxX2uvruOtyY3NWHxlefV+geyAf930QgAAA==",
    Area: "0",
    "Bottom Elevation": "182",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3984",
    Length: "41",
    "Loop Boundary": "No",
    Mark: "787",
    Material: "Copper",
    "Middle Elevation": "233",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "14",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "233",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "284",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "605110",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.61981694",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv15jborTrqKCoC5Egi7Ei1k/Olhb2ApEfPdW2t055/s41QhFo8/DAyGHo2t0iVevbGsQCBROW/+EvBrnGBTOqcxYvF6JhEouYKr/2qbv1RDcMOy0uqPHHnJGGYET2tZ33xLzNCJQOq+8dnbBF32bqchYSuCAuu38r8skIbA3+F70SFAWSQJbZ1w4ty9jpvoDLoIg/cIAAAA=",
    Pbi3DGeometry:
      "uzMAAB+LCAAAAAAABADtWUtrGzEQ/i973hq9H8mptIVCewhtoYeQQ0JMsuDaJXULIeS/V17JzkqrT6v0VhChSa3JvL8ZjTKXT93FzfDt8ee6O+s+7W6Gr7vNcNv13cVu2O5/dWeXT/6/jkzO3Vf33L+cvKGEnI/f3L/u+erI9vbh4frR8TK2UlrZ/g2XK8N4T/mKSGv66bnSgh4InGqZEtiBQIVUfSyJ2QNBED7jyItCutG51dQG1TolmKCh0qaCiokkp4rwnNsxYeLdhBCpqDgvCJo6UUOAXsQRrBSFOCI3CNfMnxuuR4IRid+KME+gLCZYLUYVhI0qCGVelBWCe4K1sVFcjDooE6zO2mNEmAvJIeFWUu4JyqqRQxNTEIWho6VQwQ1/bqWNfz9yDzNo6yzwJvERCJSzgiDHKKxnMJKPBKKdaVFkBVWeQGQhFxW6cTQqvYPho0YWyyLVDDO3DJs0HEQxXl+qzLlEhNdghX1BE4RZoSIJcwgeCdSn7hDGEsRfXxSLKtLUga6Z4eCKqEL7KOAGhDDTgXOESBTC7HKWZoUEIgV6WuHiqUfI/KpCsYXNPOao7GlRbKG5y5WRllK+F70m4bOIVBYTjGHNtZ5eSvAagw5WzBqwapC5cGLSwnVLzxFXZsqhpaKeg7MA6dhaTT3WfbdwDMr4GtCE6tBffIPmNEiyTOcdJ0K8YGGqw0gzvWWAfwU3TuhRktKABY91S7xVyvhuyKlNJeXnNRdCNS3+F4IKGFGGFYL+mon3aC1MLPRvqnxiLk6sFlwFN5iY9iqgIhP0HAGM+knG85c4uvQLQyRoO4QpX5VaHocKU0bzIvwRCqo0V8EpISAf8kguPLgMszIQlAhtXhdLGHJAwP4DLhH+6rvBSXmNuXFIqjEOO85ROQwixBq0arkq0jJCrRZhpMrvmtd6zUsQ98cksRAKwL9C/1+++FKrpkEfRRFq6BgrImQUEkeIzo/z5YwBEhJJVis+P4+7WmTSiaFSdUEUNDZvFH6nQUH5cRs+TKB3h5+WH+cfGangKtgUAKV14Y1YyDUmyCPKzSkaBdWFGwnOiTBDp0EYZWiGgprpnEaRhVbBkC8+oqqNQg9UoLvwvMJZQn86AcCBXkC3Yc2jZ0wB5aAucIUh7/LhKIwUoObRNYIHB9DpXNOV0RRwskiIYJGpK6PF1pj2UjCPHaaQcB3EMUWtA95R+dZRKrqsahSLUnOCNuXDXTMXJHcdGuvw6w+prnhv1IEPgRX6gO5x5BsmQHRng1HINAIlQEBbvrTlS1u+8LZ8acuX2lJty5e2fGnLl7Z8acuXtnxpy5e2fGnLlwiXbfnSli9t+TI/r/kLY1u+tOVLW7605UtbvrTlS86mtnzJ3Nf/5/Llqu/eD9c/1vv1Q3dGVqTvPq+3d/v78OHLbn+9H3bb8PH7cHsifVwPd/f78OHDZv1n+ovvdpudE7j9vdk8X/0FA/C8k7szAAA=",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "65",
    "Center to End Label": "65",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "105",
    "Fitting Outside Radius": "52",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "52",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1749",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø-100 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "42",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "605120",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.25955555",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzEkxhZST6KCoIcigofSQ4uhXYhZqVEopf9upFUUL+5pZ9+wM1kHaYmH9mIggS2VmJJtK3LAICV0/gpJ1g1rMEwVl1rPJyricSQl9OybCfUH1Hqmf6D+ZPkrfNE0RRsahMMKi7PxpoFEcMFgZ1zl61HsyRceQ+lBHvH0RhuDVe2fQoVhsLbmPnql4iKOGCzJUnjrbtb2+QPnqPmoEAEAAA==",
    Pbi3DGeometry:
      "pwgAAB+LCAAAAAAABACdVVFrgzAQ/i95TiUx1Rn7NLbBYHso22APpQ+WhjbgzHDZoBT/+7JOnSSeiUMU893l++6S3GVzRuudfDm9C5SjB7WTz6qUe4TRWslKf6B8c/79NWayMg9q8B+yoISsLh/zombbTbuu6+Jk5sYsopzjBUuiNEkZpiyKGU3xAM/iC0zSZIhekYT+wJSyDAewdP5syZMRdsYzNoR5xtPwYCBRT0qhop5gHJolycZS7XB7ycZzckQJA1a+M1g8HewsguXfh28L9PF7mXwSdkhgbqABihVUdjbBx/TvmJzk7G32xgrVRvCx9hEF49AiAQfe4w7SB+uCuzldgXNpgnHwTPiKFpwAKgRLg+dublfzEoXiQIGMt7tpZ5A7VBTsmpPNdyZJMA62Al9l+65VR2FoMLf+rSzehBY1yklEMHoU1UEf28GT0oWWqmqHr3Lfm+6FPBx1O7grxdfQ8UaVyhBWn2XZbL8BEQ83+acIAAA=",
    Area: "0",
    "Bottom Elevation": "182",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3984",
    Length: "29",
    "Loop Boundary": "No",
    Mark: "788",
    Material: "Copper",
    "Middle Elevation": "233",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "233",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "284",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "605224",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "20.321408",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jckKwjAYhN/lP8eQpVviSVQQ9FCK4KH0EDW0gZhIjUIpfXej1dss3zD1COXZHIe7Bgl7fzaVvgTlWqsBQemNCw+Q9TjLiDCOMyGWC5bghHMOU/PHVn2vhsjGYGPUTQfdgySYIDho14buYwrCKILKBxWMdyA5pglNBctSnhYiFzy2J3Od4SyjKYKdNm0Xvj7PBYKt1a/fmhIsEpojWHvr45l7Wjs1b9Z0MebSAAAA",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-401",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4728",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4670",
    "Length 5": "143",
    "Length 6": "4772",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1757",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "605227",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.66229163",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv17D+W867SoqCOpCJOhCvNAaOlhb2ApEfPdM6+58h+9wigGyWp/7h4IUjq7Wubr6yjZGAYHMaeufkBbDEiclRIqRiNerkFOOiDCWf2/TdVU/yVOx09VdedVBGtCAwEnZxrczSEQCufOV185CipRxJpIwEihkEifICFz0bZGRoyRwULpp/cz4He+Nev/WLKCJ5CGBrTNuOrMvY8byA8tKIFXTAAAA",
    Pbi3DGeometry:
      "6RAAAB+LCAAAAAAABADtVl1rwjAU/S957ko+mjbVp7ENBtuDbIM9iA+KRQNdO1w3EPG/r1PrNOaQRvcyKKKYe3q/m3vPcEUGE/2yfM9IjzyUE/1c5npKAjIodVF9kN5wtf1bw7Rff8g6+JVcMUr7m5/6S9ajRu16sRgva10uQq54FFzxKIwSygPGQsai4EiuZLSRS6qOASHED0BTdQwIxYRVQ6SxtLpAljAAg2qyUEnSEtj54JSn9mhNDZgfrgg0hQCcuZGHiGWyNcXkxhStFQ/lPI6Tw2j3gJSM2xSQfBsSDVMV8cs8N8kJlkivkHisEo9YLR7is0px4hfahzk3RWpMud8/2Gno3ATcppyFPQ3XuHn2yrofxw7QRXWPFTM72AwTcJsy2+ff1xZdQhrQh//4MEaw+3KbgNMSmgaGHLa1RZOQBnSB9o5zixi52acHePOBjZZjF7bS3RmoAV2A1e9eW20Xuf8u9ecK3vzFn0PAUe3NIfyjan3XL93LliHgTQlaT97zVzycyE52caLxR6QAAh0p6EhBRwo6UvBfScEoILd6/JZV2YL0aEgD8pgVs2q+OzyV1bjSZbE7vurpHrrP9Gxe7Q53efZ1+OBNmZe1weIzz9ejb0eDHFTpEAAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-401",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "25",
    Length1: "13",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1759",
    "Maximum Size": "100",
    "Minimum Size": "32",
    "Nominal Diameter 0": "100",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "50",
    "Nominal Radius 1": "16",
    OffsetHeight: "50",
    OffsetHeightTemp: "0.01367",
    OffsetWidth: "50",
    OffsetWidthTemp: "0.01367",
    "Overall Size": "100 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    R0: "51",
    R1: "16",
    Size: "100 mmø-32 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "605228",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "20.24155728",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjUELgjAcxb/L/7yGc2u6dYoKgjqIBB3Ew6yhg7WFrUDE795IpNt7j9+PV41QNOYyPDVIOPnGlPoWlGutBgSFNy68QFbjHCOSUsyF2KxShhmlBKZ6wbZ9r4bIxmFv1EMH3YNMcILgrF0bul/JKUVQ+qCC8Q4kwessyQSnKc8EywXnCK7mPsOU0RzBUZu2C3/5YPVnsQnmRERl562PZ+5t7VR/AcZ43LTSAAAA",
    Pbi3DGeometry:
      "qhAAAB+LCAAAAAAABADtV11rwjAU/S95rqVJTNro09gGg+1BtsEeZA+KRQNdM1w3EPG/r9PW2Y9jmvk0KKK0J/eee5Ob3BOnWzKZ6+fNe0xG5N7M9ZNJ9IJ4ZGJ0mn2Q0XR7eMyHg3H+ITvvFxnQIBjvf/Iv2b2Wblfr9WyT+zLuS8mYN2BDfxh6lPphwJT3Ayt1QCPBKnhutsc5p232PKrCJTtXknfisfDX8wm5UC3pI1hQ2kp/tG/kCeYF0oQ8OICNqToDEdFiQanY80iq5GmiTEpxih8dhKCdcM6GlYQaDl0jR1KE55lqoSMqlUuqMECZkVAquiSwNUBjyiVRfY3sG69aZhgZDiAiNDWAw3MPlhTZI36QJjhm1mNZLwDCIRGsmHspcWmgB4zh2i1gn8XHGQ1gKtQArJ2h3jwtxauZY3ooLmgTn9c6tLcbeDuNa6dFtcSVQQ4oQHueeHO5irWzajrfBhwvJ46XBNiU/3xNcM6o60q4675Vx7sKv2uvdZZx2IKhCFrE62Ldt/D3st/Lfi/7vez/G9nP//jf6NlbnMVrMgr8wCMPcbrMVsXLo8lmmTZp8fqiF8ehu1gvV1nxcpvEX6eG1yYxOWH6mSS7129s7eogqhAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-258",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "25",
    Length1: "13",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1760",
    "Maximum Size": "100",
    "Minimum Size": "32",
    "Nominal Diameter 0": "100",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "50",
    "Nominal Radius 1": "16",
    OffsetHeight: "50",
    OffsetHeightTemp: "0.01367",
    OffsetWidth: "50",
    OffsetWidthTemp: "0.01367",
    "Overall Size": "100 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    R0: "51",
    R1: "16",
    Size: "100 mmø-32 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "605237",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "19.78922764",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jU0LwiAcxr/L/2yibupcp6ggqMMYQYexwyrZBNNYFoyx7561uj0vv4enGqE4m+Nw15DD3p9NqS+hca3VgKDwxoUH5NU4y4iwBAullgsmMSM8han+Y6u+b4bIxmBjmpsOuoecYILgoF0buo/JCKMISh+aYLyDPME0pVwxwROeKamS2J7MdYaFoBzBTpu2C18vpUKwtfr1W1OClZAZgrW3Pp65p7VT/QaQ+11K0gAAAA==",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4728",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4670",
    "Length 5": "143",
    "Length 6": "4772",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1761",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "605239",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "22.80240768",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNIepu+XIkKgi5KEVyULloNbSAmUqNQSv/d2OpuznCGKUfIG3UeHhIyONpGFfLqatNqCQRyq4x7QlaOS/RKgBQjEa9XQUwDJkKYqr+36ft68LIvdqq+Syd7yBhlBE7StK6bIUEkUFhXO2UNZEh5yEUaRAJFksYpcgIXdVtkDDEhcJCq7dzM+B3vtXz/1pxTxpnvtlZbf2ZeWk/VB8zOvLHTAAAA",
    Pbi3DGeometry:
      "/xAAAB+LCAAAAAAABADtVk1rwkAQ/S97TsN+xax6Km2h0B6kLfQgHhSDLqRJsWlBxP/eEBM12Tw2q70Ugihm3868mZ3szJvuyGSh37afERmRp3ShX9NYL4lHJqlOsi8ymu4Of3OYjvMP2XunlRtG6bj4yb9kP6vMbjeb+Ta35cLnikvvhoc+l1x4jPlMUu7VgCAMCiAM6+s0kMU6l8MawAIh2wzYQA3aGZAnDKCYyiQ4E6ojUFJwPmSt0RoWKD18HtATAnDejTTEIAgLgKqwcEWDQxonQCh1Fu1xXXAhWg0gUAVFGRXXcVeehBSOQfGhVG7RmhwhZxcdiMENKVDe1UFVnuwvIaw35G4CdlfWszXDrd8+dLT2/ZAA3VZbazHvBSpFfb2Do0bt3IvaoUTIAnK4d5BmE7Zf7yZgd4UbQgNAdbWXCe2HBHD2WCaJkRzsH+jlh466dmBYVHuJoAXmQDLAOsW6j3Xn0XqBcnBWM86KAvZsZ0XhGlPnW3/9iDa6wQXyoFsLvmLWw95sFRomx5+pAwj06qBXB7066NXBf1cHM4/c6/lHlEUbMqI+9chzlKyydfnwkmbzTKdJ+fiul0foMdKrdVY+PMTRz/nGuzROc4fJdxzvZ7+8pAjv/xAAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "25",
    Length1: "13",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1763",
    "Maximum Size": "100",
    "Minimum Size": "32",
    "Nominal Diameter 0": "100",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "50",
    "Nominal Radius 1": "16",
    OffsetHeight: "50",
    OffsetHeightTemp: "0.01367",
    OffsetWidth: "50",
    OffsetWidthTemp: "0.01367",
    "Overall Size": "100 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    R0: "51",
    R1: "16",
    Size: "100 mmø-32 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "605240",
    Name: "M_Pipe Transition: Standard",
    Category: "Pipe Fittings",
    temperature: "19.85927924",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15DnW5uXUUFQV2IBF2IF6t+dLC2sBWI+O5JIt2dc/g+TjVAcTXn/omg4OivpsRb0K6xCAQKb1x4gaqGOU5IwiiXcr1KBE2iLIWxXrBN1+l+YqdhZ/QDA3agIhoROKFrQvsrOWMESh90MN6BimkmIiE5S7iQaS45J3Ax9xlmKcsJHNA0bfjLe4ufxY4pTzNBYOutn87c29qx/gIiHZQO0gAAAA==",
    Pbi3DGeometry:
      "8RAAAB+LCAAAAAAABADtVt9rwjAQ/l/yXEt+NE2qT2MbDLYH2QZ7EB8Uiwa6drhuIOL/vs5ap62fadxeBkUUc5e77y6X3H2jNRlOzfPqLSZ9cp9NzVOWmBnxyDAzaf5O+qN1+bdQ00HxIRvvR9JjlA62P8WXbMaV2dVyOVkVtlz4Yci51+PK5wEXHmO+4hHzvhVRVMqlkkfyQJVyKoNT+5kUx/IKgIU6bOXIAlAPSAkZncwAKyRjJyH2Fo1YUXIgVugII9g81ZOQmpXnSrXaegoDqQ5jpULrQ/neQHAh2ikED46Cali0xdahVOc91bE1CyO3aCFGFZRQnP0O2wrRyLvyVD8o+xWs1xtiQwV2BfNDCtgMwNGi/RAAxopenvWp1kuB5NARrJ17UXGJoAXEcG0gsP/i140U2BXqB9ZG0WiolurV92MAOHbQVbYNQnTHG3LkyL0Bo5riCiEDiICCxffMdZ67D1VnxuDMYZypBGzXF1MJ55janoY7MbCO+dbEwLX5XjDlYVeG89E21P6AF9ggOl7Q8YKOF3S84H/zgrFHbszkNc7jJelTn3rkIU7n+WK3eMzySW6ydLd8MbO96i4280W+W9wm8efhxussyQqH6UeSbMZfEOM4qvEQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-250",
    Family: "Standard",
    "Family and Type": "Standard",
    HeightOffsetFromBase: "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length0: "25",
    Length1: "13",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1764",
    "Maximum Size": "100",
    "Minimum Size": "32",
    "Nominal Diameter 0": "100",
    "Nominal Diameter 1": "32",
    "Nominal Radius 0": "50",
    "Nominal Radius 1": "16",
    OffsetHeight: "50",
    OffsetHeightTemp: "0.01367",
    OffsetWidth: "50",
    OffsetWidthTemp: "0.01367",
    "Overall Size": "100 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    R0: "51",
    R1: "16",
    Size: "100 mmø-32 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    WidthOffsetFromBase: "3048",
  },
  {
    ID: "605338",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.1754222",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx9AmUWtdiQqCLoIILkoXLYb2QcyTGIVSencDrd7A3fyYmaIHXeOlexjI4Ug1arJdQw4YaEIXnpAX/QhjQEiuhJLrmVjxTKo5DOw/Zvmd33hfdfFDFHZY3U0wHvKEJwxOxjWhnciZQhUw3h7pFW8/62CwaeNKyjO1WDLYW/OesmnKlRSCwZYsxV73snYoP47fGJQTAQAA",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABACdVlFrgzAQ/i95TkWTqLV9GttgsD2UbbCH0gdLQxtwZrhsUIr/fUFtq85rThHFfHf33V3ucro+kdVWvR+/JFmQZ71VbzpTO0LJSqvcfJPF+lS/WrG/tBcp6RWZBb6/rB72JuXmbHZXFOnR2jLuhX4c0RlLvDkXIQ24x+KEWlwwwSs8CSzQwuec1foJFy0c5Dnrx3EYDfHHYcBaOBfBmHAgt860cG5d0fRZolAMJXvBe5sGZQW57e594AnO2ADPVdDbhgGLOoOWoFsvBJXbRz+qbnpuHAwWdN0rBIJqckz/kuvWGgwWOiFgKdwGyMOAKDbcHkDnY5kmzwW4cK4zd9sBomdgAapnoIjG6o+bVWBDOocSkgchAM8IOPeQTJMHKxwR8FkDcSQRQoAdrO7PANKgwu2/wINKP6WRBVn4nk/Ji8z35tAsXrVJjdJ5s/xQu4voSar9wTSLx0z+thXvdaYtYf6TZeXmD+zjQHW9CAAA",
    Area: "0",
    "Bottom Elevation": "-315",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "50",
    "End Middle Elevation": "-315",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "48",
    "Insulation Thickness": "0",
    "Invert Elevation": "3485",
    Length: "563",
    "Loop Boundary": "No",
    Mark: "789",
    Material: "Copper",
    "Middle Elevation": "247",
    "Outside Diameter": "51",
    "Overall Size": "50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000053",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "26",
    Size: "50 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "247",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "247",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "605342",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.25003092",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0jaamnkQFQQ9FBA+lhxZDuxATqVEopf9utFXqydvOvGF20haSAo/NVUEMO1tgYnVTWgMEEovG3SBO2/70gZBTEUmxmISSypAz6MgIzulMCP4fRlPxy0atb5Z9ni/rOm/8Am+sMb8op2qIAxoQ2CtTumoQB+tyh350L094/qKtwrJyL8GEiAhstHoMWcZoILn3VlZb32vuWnfZE6vxgagRAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiUxNTH2aWyDwfZQtsEeSh9aKm3AmeGyQSn+99lWN4MenhNRTD6/fHe5y52rE1luzevxIyUJebRb82IzsyOULK3J3SdJVqfrawWzRXWRkv7NzDhji8ujukm5bmg3RbE5VtxQBFJpSWehDmIt5pTzgPOY0zagudIXQClvXqlIjiI0CqGItL9SxMNRCrGYR2eAadEv0WWA2rXGaKM6BFCisTaUTEzz29vZOIikFD2EFgAR/H1qr9Q2qYdwdW6Kgh87jBOQTX4kMMb6kcAwQI3RoYCCPbSBA3mGYUASOGlw/8AUR3kBLoVjYKyCzzaYOZAGyIAB6HCjsnlKIQIVxpabf5/ILgEC4EqOKxOYpoBkoKwa6i/4cgczIADqq7gSPKJBnwnVv8Kd2bynLi1IwgJGyVOa792hHjxbt3HG5vXwzex+oYfU7A+uHtxn6Xf7w1ub2WrB/CvLyvUP0gcjLt0IAAA=",
    Area: "0",
    "Bottom Elevation": "-419",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "50",
    "End Middle Elevation": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "48",
    "Insulation Thickness": "0",
    "Invert Elevation": "3383",
    Length: "1489",
    "Loop Boundary": "No",
    Mark: "790",
    Material: "Copper",
    "Middle Elevation": "-393",
    "Outside Diameter": "51",
    "Overall Size": "50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000053",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "26",
    Size: "50 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-393",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-368",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "605388",
    Name: "M_Bend - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "22.56074705",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjUELwiAcxb/L/2zi1Olcp6ggqMMYQYexwyrZBNNYFoyx754Vg27v9/g9XjVCcTbH4a4hh70/m1JfQuNaqwFB4Y0LD8ir8RejQhnmlLPlgiqcMZ7CVM/equ+bIcqx2JjmpoPuISeYIDho14buA0yyBEHpQxOMd5AnOJVEKsGokIpnSggEJ3P9l3fatF34spAZgq3Vr3mdYCI4R7D21scz97R2qt+S5o7U0wAAAA==",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "59",
    "Center to Socket Bottom": "59",
    "Center to Socket Bottom Label": "59",
    "Center to Socket Bottom Not Found": "57",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "60",
    "Fitting Outside Radius": "30",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "30",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "59",
    "Length 2": "78",
    "Lookup Table Name": "M_Bend - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1807",
    "Maximum Size": "50",
    "Minimum Size": "50",
    "Nominal Diameter": "50",
    "Nominal Radius": "25",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "50 mmø-50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "50 mmø-50 mmø",
    "Socket Depth": "19",
    "Socket Entrance Diameter": "61",
    "Socket Insulation Depth": "19",
    "Socket Insulation Outside Diameter": "69",
    "Socket Insulation Outside Radius": "34",
    "Socket Outside Diameter": "69",
    "Socket Outside Radius": "34",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "24",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    "Wall Thickness": "4",
  },
  {
    ID: "605738",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "19.80471139",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jU0LwiAcxr/L/2yie3Fqp6ggqMMYQYexg5VsgmksC8bYd88xdnpe+D089Qjl3VyHtwYJZ383lX4E5VqrAUHpjQsfkPW42IgkAtOEbjdReZrlMDUrtut7NUQ2FgejXjroHiTBBMFFuzZ0c+AkoQgqH1Qw3oGkOC9IIViasEJkXDCG4GaeC8wYzRGctGm7MOeM8hTB0erfuiZYxB2Cvbc+nrmvtVPzB9HAQazSAAAA",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4728",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4670",
    "Length 5": "143",
    "Length 6": "4772",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1811",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "605740",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.92445505",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zGXpw5O0UFQR1Egg7iYdbQwdrCViDid29o3Z6X38NTjVA05jI8NeRw8o0p9S0o11oNCApvXHhBXo2LjAjLcCoY26yYxBlPBEz1n9v2vRoiHIO9UQ8ddA85wQTBWbs2dLPJhERQ+qCC8Q5yjmlChWSp4CKTa8kpgqu5LzAXCUNw1Kbtwuy5iPXB6s9vTSkmRCYIdt76eObe1k71F5gKYGHTAAAA",
    Pbi3DGeometry:
      "6RAAAB+LCAAAAAAABADtVk1r4zAQ/S86O0Ez+k5Py7aw0B7CbqGHkENKTWvwxkvqFkrJf69iO2tbq4l8XxMSohlpnt+b0Xg2n2z9WNx//MnZit1Wj8WvqiyeWMbWVbGvX9lq89n+9W5+5T/smPWWBXB+1fz4Lztuz8e+HQ67D38W7VJpLbIFuqVDARnAEozJhnbLDZ7sqAFHDiN1bD9hthrcyc4d2uwCrlaIjV1r1DG7NT6AtwvpgYYO43zEEwJ3sncI7g1axiLFD0QgehICGxIAwo5PSNuc4ArERdpJega7/WIskzGq2a6UmwbgOIgu0jhv1mEbSkg3jR0tFEk7CDWoJuGG4CQGUU+UfmmdAtakTr1DnR9VwURlqVyEOqVZ0zqN6yNZN2EgSiiSdrpBkMpGBfz3QqYRhG7sKPk4RRZ505sEx8tNK9kLnOQthObhbZHtM7lQ1xjCSVftQ7eRwhusm4pFcDCRHtXqaN5BqEFpKhiCp3tdtC9fSB4lVEibFKp3gGqlBeumSUsmIxRqQounhAorZELpBKEoqUjiyVctKS2lINk14wDzTDDPBPNMMM8E80wwzwTzTPDfzgTbjF0Xu995nR/Yymc7Y3f5/rl+6RY/q3pXF9W+Wz4UT39dP/Li+aXuFjdl/j7c+L0qKx9w/1aWx+0XeLFrYOkQAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "105",
    "Fitting Outside Diameter 2": "54",
    "Fitting Outside Radius 1": "52",
    "Fitting Outside Radius 2": "27",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "52",
    "Insulation Radius 2": "27",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "26",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1813",
    "Max Fitting Outside Diameter 12": "105",
    "Maximum Size": "100",
    "Minimum Size": "50",
    "Nominal Diameter 1": "100",
    "Nominal Diameter 2": "50",
    "Nominal Radius 1": "50",
    "Nominal Radius 2": "25",
    OffsetHeight: "50",
    OffsetWidth: "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-50 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size 1": "42",
    "Tick Size 2": "22",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "606526",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.07244509",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkWxpjPYkKgh6KCB5KDy2GNBATqVEopf9upLXoydvOvmFm8g6ySp/am4QU9q7SmTOtchYIZE5bf4c074YzGDCmHBOxnGFEGecCevIFBeUJ4j/I6BzjXzaljqz4lK+apmzDgvDY6PIqvWwgZZQROEirfD2Ko/Ol12H0IM/6MqGd1Kr2bxELjgS2Rj5Hb8SoWESCwNoZF3Ltw5i+eAHW5fmlEQEAAA==",
    Pbi3DGeometry:
      "wwgAAB+LCAAAAAAABACVVttqwkAQ/Zd9jmFnk71En0pbKLQP0hb6ID4oBl1Ik2LTgoj/3jWmzabsTAziZc9k5sxl5+DiyOZr+3r4yNmUPVZr+1IVdsMiNq9sWX+y6eJ4+enMfOZe7BR1yAQ4nzUf7s1Oy1+3m/1+dXC+IomV0BBNBMQchI6Ax1nKVdQYUuUZIAatEs/AY61DeNABGgeTpdnZIIQEOhKakzQXgwJ59uDSyAFurTzu8zeYK7hb3KfGcCxOk6rDhRH9VOmGhzIKlWBiJcF/XohMdHDXig5PZJ84cwAVh8v+2LSh42O4EL2hAUA6kFAie70eSjTt9SdLU+0RdyPoiJE4GC0Wnwrzvyz09mKdQ2815YAyoDPAhhYaPrrLZA3k8l8tF2ROlCD9w4cuNrJPATh4u9DNRwKRSjFKWsiUxogauTnYioxZHVLTQoFIHUdLwxjQlDBdDhooXaB1LWQIrie50ONEBinD/SO4s6v3vM73bMpjHrGnvNzWu/bwXNWr2lZle3yzmz/TQ263u7o93Bf5t//gbVVULmD5VRSn5Q/i7Q5KwwgAAA==",
    Area: "0",
    "Bottom Elevation": "-3980",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-3913",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "32",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3322",
    Length: "1532",
    "Loop Boundary": "No",
    Mark: "801",
    Material: "Copper",
    "Middle Elevation": "-3929",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "8",
    Size: "100 mmø",
    Slope: "1.05%",
    "Start Middle Elevation": "-3929",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-3862",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606527",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.03288881",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjlELgjAUhf/LfV7DTdPNnqKCoB4kgh7EB6OhF9YWtgIR/3sLNQiC3u653+Gck3eQnfHY3hSksLNnzKxuK2uAQGbRuDukeTec3sAFlZFkixmPaCJECD35BWMqEs6+oaRccvkPTrHFVL9smrL1G/xjjeVVOdVAGtCAwF6ZytWjOFhXOvSzB3nCywdtFVa1e4twHsUENlo9Ry8LqBSSEVhZbX2ueWjdFy8qK2wREwEAAA==",
    Pbi3DGeometry:
      "0ggAAB+LCAAAAAAABACVVl1rwjAU/S95jiEfbZPo09gGg+1BtsEexAfFooGuGa4biPjfl9ZOu86bXikWk9N77j3e3FNnezJdutfdR07G5NEv3Ysv3IpQMvWurD7JeLY/fg0wn4SLHOh5ZyQ4nzS38CGH+W/YzXa72IVYaZlUxtCRTJg2WlAhmNQqowHgXIkWsGkNcKVtD0BFGGbTRLWAUTUg0tREqcCqhGwDLBWcWWNFtFaQRxqdXSypE4GkAkWcajVZVu8rKZNoisvihhJnzGhuG8AmtgeoRhxPrexQRSO6wKl1NSCb5ELraAoQOIpr9k2zL3gSrakD9FQce/evJpDpnDqkrBuRqL4IMDUSQKjrihieCbBH6HMA5kB1FfcLQkd8gAgMwA8RVBE88XFLAZmuOR3QwRwwG5Apak9YQ4tPS9ToesDw3IF2g/OCqAFCNBG/xNgrVAvm/XeJH2RCeyU0nzjTuM5m/qoIfxDu3OI9r/ItGXPGKXnKy3W1aRfPvlpUzpft8s2tTtBD7tabql3cF/l398FbX/hAWH4VxWH+A6HM/LrSCAAA",
    Area: "0",
    "Bottom Elevation": "-3951",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-3893",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "30",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3352",
    Length: "635",
    "Loop Boundary": "No",
    Mark: "802",
    Material: "Copper",
    "Middle Elevation": "-3900",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "7",
    Size: "100 mmø",
    Slope: "1.02%",
    "Start Middle Elevation": "-3900",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-3842",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606528",
    Name: "M_Bend - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "22.36570202",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzcsKwjAQBdB/mXUsSdpoU1eigqCLUgQXpYtUhzYQE6lRKKX/buoD3M2de4YpB8hrfexvCBnsXa0LPHtlG4NAIHfa+jtk5fAZA+EyYpwtZ5xGqUwkjNWPrbpO9cGGxUarK3rsIKMRJXBA2/h2CvM05gQK55XXzr5rRgUXC5EwzoWgsSBw0pd/vUPdtH7KScwkga3B5/ec0UhSGszaGRe+2YcxY/UCk9aCA9MAAAA=",
    Pbi3DGeometry:
      "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",
    Angle: "89.99°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Center to Socket Bottom Not Found": "90",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-3912",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "98",
    "Length 2": "143",
    "Lookup Table Name": "M_Bend - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1832",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606531",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.57904445",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkTUObehIVBD0UETyUHloMaSAmUqNQSv/dSFtBENzTzr5hdooe8lqfupuEDPau1rkznXIWEOROW3+HrOjHNRiiFItY0OWCMZykPIEB/YIcM075NxQ4EpH4B+fYcn6/atuqCx3CYaOrq/SyhYxgguAgrfLNJI7OV16H2qM868sH7aRWjX8LFgbB1sjn5KUUE0piBGtnXMi1D2OG8gXTKOBtEwEAAA==",
    Pbi3DGeometry:
      "zQgAAB+LCAAAAAAABACVVt9rgzAQ/l/ynEpidGr7NLbBYHso22APpQ+WhjbgzHBuUIr/+7LVH7XxegmimJzffXd+d6erI1lu1NvhU5I5edIb9aoLtSWULLUq6y8yXx1Pt8bMFuYgDR12Zpyxxf/FnKRZd7DbqsoPBhtmAWOC05kQQZLGCeU8CLMoo8bAw/G+iEQytc84i649H4o0dSLoHFkRsTgLaZgGWRyJkYEnySSgYwCpLcOJAo4JBMAUaXIzFaxn1qhAcSBiHttCDPudEK2jwYA5anPDAQhDr9xgGCt3Rj3SwSGkCx3sWFsdLGoYAFGA788zC7SQQQa7BrA3fkHhoQSmNdTuiCMQ4DuA7Ijcux3Lzb020CoDpgDmCAK4zxmk7h0mWW9w7SCwF7GuRqYu5MhjTF//aNkRuU9jLDdwOAAGqEU9pob39/IPYP4N7lX+IWtZkTkLGCXPstzV+3bxouu8Vrpsl+9q25sepdrt63bxUMif8wfvdKGNw/K7KJr1L3jcjFDNCAAA",
    Area: "0",
    "Bottom Elevation": "-3944",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-3893",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "16",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3358",
    Length: "477",
    "Loop Boundary": "No",
    Mark: "803",
    Material: "Copper",
    "Middle Elevation": "-3893",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "3",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-3893",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-3842",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606532",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.49968417",
    Cost: "0",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACNjsEKwjAQRP9lzzEkqU1pPYkKgh6KCB5KDy2GNhCzUqNQSv/dhVavetvZN8xMMUBe23N/N5DBAWubo+sb9MAgR+vDA7JimE4yqIirVMarhZJcyETCyP6HcRRJgoInidI/YPmpX3dd1dMGemxtdTPBdJAJLhgcjW9CO4sThipYmj3Ji71+0d7YpqUWpbnSSjPYOfOazQsZ86VMUwYbdEjJ/uncWL4B88F0fRUBAAA=",
    Pbi3DGeometry:
      "AwkAAB+LCAAAAAAABACtVlFrwjAQ/i95riWJqW3q09gGg+1BtsEexAfFooGuGV03EOl/37F2s9q7Jroh1SZf7/vurskX53s2W5nn3VvGUnZvV+bJ5mbNAjazpqjeWTrfN7cA8yl8WB0cZkaC8+n3F1ysXvyEXZXlcgexchxKFU2CkeRholUSjEQUKqF1AIgScgyICPlEREeI1Eo1iJDxMUKytTE8jOMYkwFAJvI8BEvtgnJonSjWOBkJDHCNuUAb0AJIN+mUSX1oc3QgE/CEgt8eVwfodkwjEW0p3YhGo6nEh8kl0U+K1O4U7pcsKQFtl1gVZ0s7UiKV++9oYPeQraW2FQ0MUOGvlZh3tRzZA35U/2obx30f3IEuEY/FQ867105ympKLqBdAFOfhYRppE+JHAwjNhS91EnBZAmaGflx/9VzaQenjkESGyHADpwEf2/U8JZzn90kp8I/ixixfsyorWcpDHrCHrNhU23bwaKtlZWzRDl/M+he6y8xmW7WD2zz77D54bXMLhMVHnteLL+3NnFQDCQAA",
    Area: "3",
    "Bottom Elevation": "-12000",
    "Calculated Heating Load": "300",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-3995",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "-4700",
    Length: "8005",
    "Loop Boundary": "No",
    Mark: "804",
    Material: "Copper",
    "Middle Elevation": "-12000",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "28",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-12000",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-3995",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606533",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.01560836",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzEk6Y+1nkQFQQ9FBA+lh4qhXYhZqVEope9upNWDIHjb2W+YmbyD7ISH9qohhS2dMCPTVmSBQUZo3Q3SvBtOb1CKT0Wo5pNgxuNYRtCzX1B9wYCLMPmDvUKLd/miacrWL/CPFZYX7XQDqeCCwU7bytWj2JMrHfrRgzzi+YM2Gqval0geiChisDb6MXql9HsTyWBJhnyuvRvTF0+uuwsDEQEAAA==",
    Pbi3DGeometry:
      "2wgAAB+LCAAAAAAABACVVt9rwjAQ/l/yHEt+tok+yTYYbA+yDfYgPigWDXTNcN1AxP99ocu01V57ItXmvt533+VyV+cHMlu5t/1nTsbkya/cqy/cmlAy866svsh4fvi7DTCbhA850rNlxBmb1F/hIsfFv9t0t1vug68QSaaNpCNpE61kSrlMGJeKBsBaVduzzMpo10077vnwq4SpgTTlGkN0UnQZ2WQprwEjDI9A2icVzC1jVndqAmMPbtOl/SRWWWUiIHtD3JzFObTKKOchKyNaRIapaFcXRN0ObXurdEJHQPZFgOyNylnRKQnUegWcS9fWBGbXqIS2EeB9+wcyDW4gMgtUU0AlwpwBMACipujtA084gglyQPYQqAnueAjAUGGPB3g0B8dNDxXogR1pgw0DDpwrYJgK28bgRACHPIYK8sC+SEBVQy/DnggAEWpygu2KmCA3j5xmDuGfwr1bfuRVviNjljBKnvNyU23j4sVXy8r5Mi7f3foEPeZus63i4qHIf5oP3vnCB8LyuyiOi1/iNBrx2wgAAA==",
    Area: "0",
    "Bottom Elevation": "-231",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-231",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "8",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3569",
    Length: "398",
    "Loop Boundary": "No",
    Mark: "805",
    Material: "Copper",
    "Middle Elevation": "166",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "100 mmø",
    Slope: "122962.19%",
    "Start Middle Elevation": "166",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "167",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606534",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.65286269",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0TVrSehIVBD0UETyUHiqGNhCzUqNQSv/daKvUk7edfcPM5B1kJ31orwpS2OJJZ2jaCi0QyFBbd4M074bTG0JOuRDJfMYTKrmQ0JMJlDSOwvA/FAn7ZZPUNys+5YumKVu/wD9WurwopxpIAxoQ2ClbuXoUe3Sl0370II/6/EUbpavavQSXsSCwNuoxehmjAYsYgSUa9Ln2bkxfPAFDsyuTEQEAAA==",
    Pbi3DGeometry:
      "4AgAAB+LCAAAAAAABACdVl1rwjAU/S95jiVfjYk+jW0w2B5kG+xBfFAsGuia0XUDEf/7Ym1ng70xFVHMvT3nnhvvh/M9mq3M++4rQxP0bFfmzeZmjTCaWVNU32gy35++OjeZuhc64LNlRAmZ1h/ujQ6LFnZXlsudwzKecMHHeMR1MlZEYUoTSse4tgtd24WW7GhnXCjcBaQipR4AtLPaLiXTRzuRiuFg5CuKFNPSVwRKlR4RT1nDJFNPkiA07QLaFDoAgAiMDGqFIgzKQSUypdRjIpLrk4Mxj4kqqjxES3VGgA4i/Z+Oulg3Bm8c7YVEqOLCi8G0Q54c2lPlbkp4iJbqjACDg3JBqmsxQCo/D7BGwBihWgABYAjwRuDE+24dbKZwGuH2i+zXsKhgI/v2mJrqqULI0VsIYIvHVAg0FCKnSFDUkGkeM10uRwLo6J0u4MYAqWJ2TNxSCosasK1iZueAMdzbrMH27qUK7qXLNNzfhQez/MyqrEQTkhCMXrJiU22bw6utlpWxRXP8MOt/11NmNtuqOTzm2W/3wXubW0dY/OT5YfEHQmEMT+AIAAA=",
    Area: "1",
    "Bottom Elevation": "-443",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-392",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "8",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3359",
    Length: "1618",
    "Loop Boundary": "No",
    Mark: "806",
    Material: "Copper",
    "Middle Elevation": "-376",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "100 mmø",
    Slope: "1.00%",
    "Start Middle Elevation": "-376",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-325",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606535",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.26473283",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjssKwjAURP/lrmPIy0fqSlQQdFFEcFG6aDGkgZhIjUIp/XcjbQVBcHdnzjB3shbS0pyam4IE9r40qbeN9g4QpN64cIcka/szBpjETDK5nHCJqRQMOvQLzjCdT8U3XGApJP0Hx9p8fL+q66KJG6KxMcVVBVVDQjBBcFBOh2oQRx+KYOLsXp7N5YN2yugqvAXnXCDYWvUcspRiQkn01t762Ose1nb5CxO9NIoTAQAA",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVl1rwjAU/S95riVpUtvUp7ENBtuDbIM9iA8Viwa6ZnTZQKT/fdn6ZW3vboooJqfn3Hu8uTduzmS9U6+nj4wk5FHv1IvO1Z54ZK1VYT5JsjnXXy1MV/ZFKq/fWTBKV38f9k2qbUu7Kcv0ZLmB9CnlzFtw6TMpAo8xn4Yy8CzAgqt9RsXvfsDjeAAEUshZhDYCqDTKqQZiX4aCDwAWRWyS0cYAAWcbXPDoXwLsL46Wk9lCIQDfuIullQ7F2EW/3xajUboAMKURMDwgziG66vWA/T0mCZCJq1KMCbC7uhSj0KC5+SHmu4COB5KswwnsAFfbYLExE0i3QEIz2gsiQBm5NxHmDawoAEAnHJ9boJLDpEMYaNs5z8wZDQz2BDY7oDsEEQIJ7tcalJH77YV5c5816NQCJweiBDKGLuz/hDuVvmcmK0lCfeqRp6w4mGOzeNYmNUoXzfJN7TvoIVOHo2kW93n2ffngrc61FSy+8rza/gATzN0y2QgAAA==",
    Area: "0",
    "Bottom Elevation": "-444",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "8",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3358",
    Length: "920",
    "Loop Boundary": "No",
    Mark: "807",
    Material: "Copper",
    "Middle Elevation": "-393",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "2",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-393",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-342",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606536",
    Name: "M_Bend - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "19.85424231",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/XmDP3x56igqAeRIIexIdZQwdrC1uBiN+9hfl2z+F3uNUIRWMuw1NDDiffmFLfgnKt1YCg8MaFF+TVOJ+RUIoFZ8lmlUrMGJUw1Yvb9r0aIo7F3qiHDrqHnGCC4KxdG7pfYIILBKUPKhjvIE9wxgmXLKWMy7WQjCG4mvsfS5IhOGrTdmEeU4ngYPVnWSeY0Cyanbc+PnNva6f6CzGknijTAAAA",
    Pbi3DGeometry:
      "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",
    Angle: "89.43°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "99",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Center to Socket Bottom Not Found": "90",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-374",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "100",
    "Length 2": "143",
    "Lookup Table Name": "M_Bend - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1834",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606539",
    Name: "M_Bend - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "21.87762913",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjc0KwjAQhN9lzzEkaRuaehIVBD2UIngoPbS6tIGYSI1CKX13U3/AgYGd3W/YcoS80cfhhpDB3jW6wLOvbWsQCOROW3+HrBw/Y0CEolzw5SJSVEqhYKp+2Krv6yGwYbHR9RU99pAxyggc0La+m4NMI0GgcL722tn3makgGZQG85jASV/+4R3qtvNzjkXCCWwNPr9tzqiSSUpg7YwLz+zDmKl6AV2Su+fSAAAA",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Center to Socket Bottom Not Found": "90",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "98",
    "Length 2": "143",
    "Lookup Table Name": "M_Bend - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1836",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606542",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.27189656",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9jkELgkAQhf/LnDdxN9LVTlFBUAeJoIN4UFp0YNsJ2wIR/3sDWoegbvPe95j38h6yCk/dzUAKe6owI9vV5EBARuj8HdK8H08OqHmwiKRezlQYJHGiYRA/YfwNVaRGqOVfVLyrV21bdtzPxgbLq/GmhTQMQgEH42rfTOJIvvTIk0d5xssH7QzWDXdIydO0ErC15jmF2VNRogWsyRI/dg9rh+IFZJFephABAAA=",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABAClVt9rwjAQ/l/yHEOS/q5PMoXB9iDbYA/iQ8Wgga4ZXTYQ6f++bGau2l6aIsVq7ut9d5fLd3V1RMuNfDm8C5SjB7WRz6qUW4TRUslKf6B8dTz9NDCdmgs1+N8yYZROf2/mg5r1n9usrouD8eUB4VkY4glnhDKeYM5JGiQZNkAUUOYCKEkSTwfz9fN8moWZDxGYUsh4cAJiFnuFtlTdEGEU9+YExoaYoCJsrsbOU+4VYWA7+iLzs50xwuMsbdltgBZgiKJeAGRqN84nAgi0Oxd55QQDF63renSquOyER9kQEWQf4OnZJlgQUEchxQ33DRKiRwHgzoGH24/pFvmAOYFSB+wuolHthw+kY8h4MN00xhwicc63HmBAbyOkC04BcLB7UV17jHx5gFkNvQHdMa6pRk5MUKvu2TFq2HSLMP8Q5rJ4E1rUKKeEYvQoqp3e28WT0oWWqrLLV7k9Q/dC7vbaLhal+Go/eKdKZQirz7Js1t+7k/rl0wgAAA==",
    Area: "1",
    "Bottom Elevation": "-3865",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-3865",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3435",
    Length: "3526",
    "Loop Boundary": "No",
    Mark: "808",
    Material: "Copper",
    "Middle Elevation": "-339",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "30",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-339",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-339",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606543",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.3234315",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkTaumnkQFQQ9FBA+lh5aGdiEmUqNQSv/dSFtBENzTzr5hdtIOkgLP7U1BDAdbYGJ1W1kDBBKLxt0hTrth9YZgSWUo+WomGOXzhYSe/IKcChFF31DSQAbyH5xis+n9umny1nfwhy3mV+VUAzGjjMBRmcrVozhZlzv0tQd5wfKD9gqr2r2F8ENgp9Vz9HJOGWchgY3V1ueah9Z99gJZroAlEwEAAA==",
    Pbi3DGeometry:
      "wQgAAB+LCAAAAAAABACVVk1rAjEQ/S85x5CPXXejJ2kLhfYgbaEH8aC4aGC7KXZbEPG/N9TV7SaZJCKKmbfzZl7Gebg4ovlavR0+KzRBT3qtXnWtNgijuVZN+4Umi+P5q4Hp1LzQCfeREaN0+vdh3ui0vKTN9vvVweRySRhneCQoYeNCYsaIyESBeUlknokBwAoTl4RSMUzgMpMYJJKEi7L0JvCyGPsq2ESU0SzUEVQYbOimunAc4nEE01xy79WdgXRll8odkZEk8ry/0itRDwyI+rB1Fc7znQS7AEzkj6c3NLxrNw41CgqzBVxmkEoUbggW5owmNmNgloFFi03fKnFDr2lTdjcqQgQmpJtIZM4ec4GA5F+MxeQBoOUJ+wJIFDeSaEJ4nV1HgoFUY7CYXCC8WB5XDROBCa6GsJ+7HQH2HAAiTK6GmDtY932DayTazFCD+T9wr1YfVVvt0YQSitFz1WzbXXd40e2qVbrpju9qc4UeK7Xdtd3hoa5+/j94p2ttCJvvuj4tfwHErqEUwQgAAA==",
    Area: "0",
    "Bottom Elevation": "-444",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "24",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3358",
    Length: "356",
    "Loop Boundary": "No",
    Mark: "809",
    Material: "Copper",
    "Middle Elevation": "-393",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "5",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-393",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-342",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606546",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.7319654",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbx5C0tKV1JSoIuigiuChdtBjSBzFPYhRC6d0NtHoDd/NjZpoR6h4v4aGggiP1WJMJmiwwqAmtf0LVjDOMgSTlQmTJepVKnpcig4n9x2y/8xvnuhA/RGGH3V155aASXDA4Kav9sJAz+c5jvD3TK95+1kGhHuKK5GlSZAz2Rr2XrJS8EHnJYEuGYq99GTO1HztB7lITAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVk1rwkAQ/S97XsN+mE9PpS0U2oO0hR7EQ8SgC2m2pNuCSP57lxhtTDLuaAgG15d582Zn58XFnsxX6n33lZGEPOuVetO5WhNK5loV5pski/3hq4XZzF6kov+/TDhjs/pmP6RaHsPuyjLd2VghvCgKp3QiueeHIqBcekxOfSqkx4XkNRCxSA4C+IiQxzUQxMxHULVUdakY88UB8EOOSA4WaAEZBQOqwOSYveoCJ7m+kBGqwGvr6CXnXsiCeIDqCPSoBiJ6wHkHnTkuAJ0ODqgC5faA8w4iCuz0w1k5SIXZRGQd+PkA5WIiwBzO1qI3ETjteKrbJwpUdckAoInCUmEA8Ig63cdBNcrhnIMDuk8PQFIhxgBwBtD08VRjXiygKvcL0pFjjIvCU+v0kuvdp12H/Q/xoNLPzGQlSZjHKHnJio3ZNotXbVKjdNEsP9T6BD1larM1zeIxz37bD97rXFvC4ifPq+UfWcyk6/UIAAA=",
    Area: "0",
    "Bottom Elevation": "-232",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-232",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3568",
    Length: "405",
    "Loop Boundary": "No",
    Mark: "810",
    Material: "Copper",
    "Middle Elevation": "173",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "173",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "173",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606547",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.06898071",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNo0oehnkQFQQ9FBA+lhxZDuhATqVEopf/dlNbXydvOfMPs5B1kFR7bq4QUdrbCzOpWWQMEMovG3SDNu/H0AR7SaB4tZiGjIuER9OSLCZrEnP+HMRPJL/y0jqx4PV82Tdn6Bd5YY3mRTjaQBjQgsJdGuXoSB+tKh370KE94fqOtRFW7QYQiZgQ2Wj6mLGM0YIO3str6XnPXui+eqgLw3BEBAAA=",
    Pbi3DGeometry:
      "7AgAAB+LCAAAAAAABACVVl1rwjAU/S95riUfTZrqk2yDwfYg22AP4oNi0UDXDNcNRPzvi9quu5ibVEQxOd5zz729H84PZLYyb/vPkozJk12ZV1uZNUnIzJq6+SLj+eHy1cF04l7kmPQ3I0bp5Pzh3uS46Mymu91y72y5SLNcsmQkWCpzrhLGUiGZSM4A1wBgTOYA0FQLL+CxEGdAFVSeAKqUjlChqrLLPRf6dM+FkBHfLVPnomeSCojKKOUR3ygVGsZFrZY5g2pjSUcTAn3rVEkGAapEAYDORw+IDAC8KFSEisJUUebUhH2gAOfgATLN8ogqHCiAKpHpDFh0cfQWrfPuefTO0chRKhSIUcE4sCJBXQRrAbXAXKAJweP2JR1tp3AYkQYc2LJhVZFehsCQqrqhQL21jg2xASVyPfVuGpNBSbFpD4FgJ98+FLzzBV0cKNWQVTNwOYVVRRYgBIYMUHR6XwPelg31uJcptJw8Ubi/Dvdm+VE25Y6MaUoT8lzWm2bbHl5ss2yMrdvju1n/QY+l2Wyb9vBQlT//f3hnK+sI6++qOi5+ATaLNEXsCAAA",
    Area: "0",
    "Bottom Elevation": "-443",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-392",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3359",
    Length: "1578",
    "Loop Boundary": "No",
    Mark: "811",
    Material: "Copper",
    "Middle Elevation": "-376",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "15",
    Size: "100 mmø",
    Slope: "1.00%",
    "Start Middle Elevation": "-376",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-325",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606548",
    Name: "M_Bend - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "22.96457027",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUEKwjAQRe8y6xjSpE2auhIVBF2UIrgoXUQNbSAmUqNQSu9upHY3f/57M/UI5dWch6eGAo7+aip9C8q1VgOC0hsXXlDU4zxGhDJMSEbXK5ZgLkkGU7Nwm75XQ4TjYmfUQwfdQ0EwQXDSrg3dL/Bc5AgqH1Qw3kGR4EwQITmjXMg0l5wjuJj7H473ERy0abswyzTWe6s/i51gQlOGYOutj8/c29qp+QJr9uHd0wAAAA==",
    Pbi3DGeometry:
      "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",
    Angle: "89.43°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "99",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Center to Socket Bottom Not Found": "90",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-375",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "100",
    "Length 2": "143",
    "Lookup Table Name": "M_Bend - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1838",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606551",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.64562645",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaW2behIVBD0UETyUHiqGNhCzUqNQSv/dSFtBENzTzL5hd/IOsrM+tjcFKezwrDM0bYUWCGSorbtDmneD9AEhqZBCLmZeBNE8gZ78gjGN4lB8w4TKUPJ/cDpbTO+XTVO2voNfrHV5VU41kDLKCOyVrVw9mgO60mlfe7AnffmgrdJV7d4m8ENgY9RzzHJOGWchgRUa9Hftw5i+eAEhzU2vEwEAAA==",
    Pbi3DGeometry:
      "zwgAAB+LCAAAAAAABACVVstqwzAQ/BedFSHJb+dU2kKhPYS20EPIwSEiEbhWcd1CCP73isaPRPJaCiEPeT0zu+vVKOsTWm3l+/FLoBw9q618U6XcIYxWSlbNN8rXp/NPHaZL/UItHq8sGKXL/w/9Ru2mh93VdXHUWJ4Rxhle6O8gjlLMGKGMhpinJIvC4CrAkgTrJaWBAYgyjkGijPAgTScBFhPPwmwmAOfkLd0rmIAgDKaL6wEgE1gdT5PYq39uJki7o0pInIR8RAx9GgNXfbq4v+uTRWTkZCrATNPX4YxAZTBgKvSPzkp1qOH8ICxpsDaYyTtgjDiYlDUdLglwbG6Q8O2Hq+PQJnIQgQD/bQpldKujOJm85xKacKePgkS+xgEBnHvOw5BdfgIY0Exg3jdsB3cQgQD/4wnKyN+OXbX5G41xdthb1Nc1XIfQZA3638GDLD5FI2qUU0IxehHVvjl0i1fVFI1UVbf8kLsh9CTk/tB0i8dS/F7eeK9KpQmrn7JsN3+ZDw9WzwgAAA==",
    Area: "0",
    "Bottom Elevation": "-444",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "28",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3358",
    Length: "516",
    "Loop Boundary": "No",
    Mark: "812",
    Material: "Copper",
    "Middle Elevation": "-393",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "6",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-393",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-342",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606554",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.74610808",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/Lrk9dsVNUENRBIuggHpQWXdh2w7ZAxP/ehhZ26vbmfcPM5D1klTp1Nwkp7G2lMqu72hogkFll3B3SvB9PbwhCymORLBeBoCgEwkBmMKFxFAT/IUOMfuEsdoTFp37VtmXnN/jHRpVX6WQLKaOMwEGa2jWTOFpXOuVnj/KsLl+0k6pu3FsgYkhgq+Vz8nJOGWdIYG219bnmofVQvAAXqvEkEwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVk1rg0AQ/S973sh+qKvmVNpCoT2EttBDyMGQJVmwbrG2EIL/vWuirVYnjgSD63Nm3uzOvHF9IquteT1+aJKQR7s1LzYzO0LJypq8/CTJ+nS5dTBbuh+p6N+TBWdsef5zF6k2rdlNUaRHZyt8j4cqoguhPBapkHLuidiPaBeQQsoaYEHMR4EZFkrwGuBK4Ty1pAaeBAv8M8CZxMUG82MyisZIgbEnd2oAtGylL5ExkGlEXhgI8T94PAo4V6IHdFyNWwyB7vlhQoBA5/z8UVIg2yHQPT9Mev3TwOQNuprcwok0oN4ASYHVhrKAQqBCgzsIFjqGE+gK2UwYVnDrQ80ExphfCaC8oMp2hk5dFzYMoynBuwAzWg/fxH09AIUe00jgaEAOEwyryZk42CpQ8OZrJzhFUeo8YxzXSbhvhjuTvutSFyRhHqPkSef78tAsnm2ZlsbmzfLN7H6hB232h7JZ3Gf6u/virc2sc5h/ZVm1+QHPOBMq5QgAAA==",
    Area: "0",
    "Bottom Elevation": "-444",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "2",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3358",
    Length: "1367",
    "Loop Boundary": "No",
    Mark: "813",
    Material: "Copper",
    "Middle Elevation": "-393",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-393",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-342",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606557",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.25974842",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzFkE/pDPYkKgh6KCB5KDy2GNhCzUqNQSt/dQKvgQfC2s98wM8UAeW1O/U1DBnuqTU62b8gBg5yM83fIimE6g0FKnmAaLRcq4qlUCCP7CeNvqLiIpfoLhtjyXb/quqoPG8JjY6qr9rqDTHDB4KBd49tZHMlX3oTZkzybywfttGna0IJcoUAGW6ufsxeRJyJlsCZLIdY9rB3LF/3t55oSAQAA",
    Pbi3DGeometry:
      "0wgAAB+LCAAAAAAABACVVktrwzAM/i8+u8F2Xk56GttgsB3KNtih9JDS0BqyeGTZoJT895nUa15VrBISx/qsT5JlKVmfyGqr3o9fOUnJs96qN12oHaFkpVVZf5N0fTq/GpgtzUUa2kkWnLFl+zA3aTb/andVlR2NrhBeHIuILvzQi1koKPc9xiUVZmDSb+VJwBIr5wMArRDGvAWk8LmbqefSkEl4MmHBGZBJbAExYxuKzsiFH1/xaca2c59GFi6+RmEUuIO7OYahZUk5N+M4ETy08gnRVYWxvJe4qCMCLcyY7jKXMN8CYrQdgLMToJe6yB3eMBOJM2yYx7l9yBCQFQFlCHUEQAPOlKI2DzreOB5oPaZ8IH/AQgfkGB7UoQBPo7PDzDCBCrge5qwQsMVMAAQVsm7BFgB0dRQVrIH6coBeYb5/sA2YCtUu58rU2Tlu7zX9OMwfwoPKPvM6r0jKPEbJS17u64OdvOo6q5Uu7fRD7S7QU672h9pOHov8t7/wXhfaEJY/RdFs/gBWbC5M0wgAAA==",
    Area: "0",
    "Bottom Elevation": "-231",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-231",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "8",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3569",
    Length: "399",
    "Loop Boundary": "No",
    Mark: "814",
    Material: "Copper",
    "Middle Elevation": "168",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "10",
    Size: "100 mmø",
    Slope: "232383.12%",
    "Start Middle Elevation": "168",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "168",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606558",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.73072992",
    Cost: "0",
    Pbi2DGeometry:
      "EgEAAB+LCAAAAAAABABtzsEKwjAMBuB3ybmWdV1LN0+igqCHIYKHscPEshVqK7MKY+zdrVsVBW/584UkRQ/5SR26q4QMtvakcqu72hpAkFtl3A2yop9KPxBTTFkaz2eU4TQVDAb0hQJzFtOALPmDZESeMP6L49pgwlv5vr5o26rzL/jGSlUX6WQLWYQjBDtpateEsLeucsp/PcWjOn9oI1XduFeggscI1lo+wiwhOCKMIFhabf1ec9d6KJ/ACZ27EgEAAA==",
    Pbi3DGeometry:
      "3wgAAB+LCAAAAAAABACdVl1rwjAU/S95riUfzZc+jW0w2B5kG+xBfFAsGuja4bqBiP99scmcgdxohlTMPd57zs3HSWd7NF2a191HjcbosVual64xK1SgaWfa/hONZ3v308J4Yj/oUPxFRgTjyfBlH3SY/6bdbLeLnc2lrGQC02LEeCkxlwUhJeOUF0eASx0AhAjlADXEdUWqMA4mSD4AijJ+BPCFQrAkRyC40Mc4ZZX8n1SBqwA4MQisAqkVJiydAc6Gdk1obbs5F5uggNqOUSg7DYQ4gKnKzSvTHvCFqAzjjAUA1VpcqISFF4vd0hFbO0kBxSnxa8fU0IQi8oImpgNqVlltDuCB2Cu6oI5DK0lDcjAjnyOvD3CHgOTgJkxlwBzglICdQ33EN3S6j9xTluAAVQGnKQ6kNxy4tBAQ3e2Qg4GVEpaX55FJSbBtx4DkWc41hai7QDcGVCh1w2RdSUlFkM1D3gwbJ2jaWe6VPNzRUqlLKdKGfVu4M4v3uq+3aIxLXKCnul33Gz947vpFb7rWD9/M6gQ91Ga96f3gvqm/z/942zWdLdh+Nc1h/gPkw2OI3wgAAA==",
    Area: "1",
    "Bottom Elevation": "-443",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-392",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "8",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3359",
    Length: "1613",
    "Loop Boundary": "No",
    Mark: "815",
    Material: "Copper",
    "Middle Elevation": "-376",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "10",
    Size: "100 mmø",
    Slope: "1.00%",
    "Start Middle Elevation": "-376",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-325",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606559",
    Name: "M_Bend - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "20.89681969",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGnDq3dYoKgjqIBB3Ew6qhg7WFrUDE797CvL33+P149Qjl1ZyHpwYJR381lb4F5VqrAUHpjQsvkPU4x4hQirkg2XqV5pjTlMPULNym79UQ4TjsjHrooHuQBBMEJ+3a0P0K4wVHUPmggvEOZILzghSCpZQVIuOCMQQXc//DguQIDtq0XZhlGuW91Z/FTjCheYZg662PZ+5t7dR8AZOWWO/TAAAA",
    Pbi3DGeometry:
      "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",
    Angle: "89.43°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "99",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Center to Socket Bottom Not Found": "90",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-374",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "100",
    "Length 2": "143",
    "Lookup Table Name": "M_Bend - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1840",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606562",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.77259818",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TssKwjAQ/Jc9x5A2hT48iQqCHoIIHkoPLYZ2IWalRqGU/rsLrf6Bt3kxM+UIpsHL8LBQwJEaNOSGljwIMIQ+PKEoxxlyINYyiRO9XmkGWqUwif+Y1Xd+0/f1wB9Y2GF9t8H2UCipBJysb0O3kDOFOiDfnukVbz/rYLHteCWSaZanAvbOvpdsFMkky7WALTniXv9ybqo+NNXxWxMBAAA=",
    Pbi3DGeometry:
      "vQgAAB+LCAAAAAAABACdVktvgzAM/i85U5SQ8Gh7mrZJk7ZDtU3aoeqBqlEbiZGJZZOqiv++DGgLDC8GIR75HH+2Y8dhfSKrrXo9fkiyII96q150pnbEIyutcvNJFutT/WnFdGkvUnpXZMYoXVYPe5Nyc1a7KYr0aHUD7oc0jrwZ577gNPYY94N47llcBIJXeMgEa+MJD+r5yTxq4SDPeT6PWTLEz0UsWji31ka4A5l1hoUz6/KmzxKFYijYC95bNCgqyGx37dnvmw/wXAW9ZRjQqCNoCbr5QlC5bfS96obnxkFnQdO9RCCoJvv0J7hurkFnoR0CpsKtgNwMiGTD5QFUPpZpcl+AE+fac/8bQNQMLEDVDOTR2PnjehVYkM6mhORBCMA9AvY9JNPkxgp7BBxrII4kQgiwjdV9DCAVKtz+C9yp9F0aWZAF9alHnmS+N4dm8KxNapTOm+Gb2l1ED1LtD6YZ3Gfyuz3xVmfaEuZfWVZufgDrZ5KdvQgAAA==",
    Area: "0",
    "Bottom Elevation": "-298",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "50",
    "End Middle Elevation": "-298",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "48",
    "Insulation Thickness": "0",
    "Invert Elevation": "3502",
    Length: "546",
    "Loop Boundary": "No",
    Mark: "816",
    Material: "Copper",
    "Middle Elevation": "247",
    "Outside Diameter": "51",
    "Overall Size": "50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000053",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "50 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "247",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "247",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606563",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.20467789",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAB1jjELwjAUhP/Lm2NoElNNnUQFQYcggkPp0GJoAzGRGoVS+t+NtJU6uL1733F3aQuy0OfmriCBgyu0dKYpnQUE0mnrH5CkbX8GA11iHsdsNWMMszml0KEJZDheCD5C8hdyItgvnMT2MBvr13WdN2FDeGx1flNe1ZBEOEJwVLb01SBOzudeh9m9vOjrF+2VLiv/EZRwjmBn1GvwEoIjIRiCjTMu5NqnMV32Bla/XTcTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACdVl1rwjAU/S957kpukzSpPo1tMNgeZBvsQXxQLBromuG6gYj/fV1bP4K5t3VIxfR4zrm3SU463bHJwr5tP3M2Yk9uYV9dYZcsYhNny+qLjaa79mcN83H9YfvodOcGOB83X/XF9rMD7XazmW9rbmJilSoV3QgRS8F1BBDzLBNRA6SiARRI+APAJGkLKN0yTNYwIBE6oqU6htBgfEbnIaSWvocGTypJVdZXFWre0+AV5n1VXUqlmdd5IkF5wOEhngFYg0FzEafaHKXShqET1QKZ8qQSAbJjaE8KpAGPcejjjOH3cfJApfo8LqoyXHqM+r6hAaJcxNxw8Ocj45KW+n9VgQbBm6jWHF0+aFVD1pUP0A0ij4QAQp1TSzQsRe8orEHcA6sK32ohgJ7z0AxSQHgxoPt8yCq5TIbrsoSsCs/2EECHDBZLOBDatWiEo1JDjqKBhxddFXaqBQE6LNF4xQA8GbAsCUqRh1egj/od4t7OP/Iq37ARj3nEnvNyVa27wYur5pV1ZTd8t8sj9Jjb1brqBg9F/nP+xztXuFqw/C6K/ewXjX4bdPUIAAA=",
    Area: "0",
    "Bottom Elevation": "-417",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "50",
    "End Middle Elevation": "-377",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "4",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "48",
    "Insulation Thickness": "0",
    "Invert Elevation": "3385",
    Length: "1490",
    "Loop Boundary": "No",
    Mark: "817",
    Material: "Copper",
    "Middle Elevation": "-392",
    "Outside Diameter": "51",
    "Overall Size": "50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000053",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "11",
    Size: "50 mmø",
    Slope: "1.00%",
    "Start Middle Elevation": "-392",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-351",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606564",
    Name: "M_Bend - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "20.45778271",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV4y3XRuPUUFQT2IBD2ID1oXHawtbAUi/vcW4tv5zv0up5qgaPV1fCEoOLtWl3j3je0MAoHCaevfoKppiUFJWMQTzrYbFgKjAuZ69XbD0IxBDsVBN0/0OICiESVwQdv5/g9MpBmB0vnGa2dBxVEqqJAZSzIheS6zcL3pxypLTuCEuuv9wjTw0eB3/Y6jOM4lgb0zLozZjzFz/QP+dBzn0wAAAA==",
    Pbi3DGeometry:
      "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",
    Angle: "89.43°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "59",
    "Center to Socket Bottom": "59",
    "Center to Socket Bottom Label": "59",
    "Center to Socket Bottom Not Found": "57",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-376",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "60",
    "Fitting Outside Radius": "30",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "30",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "60",
    "Length 2": "78",
    "Lookup Table Name": "M_Bend - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1842",
    "Maximum Size": "50",
    "Minimum Size": "50",
    "Nominal Diameter": "50",
    "Nominal Radius": "25",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "50 mmø-50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "50 mmø-50 mmø",
    "Socket Depth": "19",
    "Socket Entrance Diameter": "61",
    "Socket Insulation Depth": "19",
    "Socket Insulation Outside Diameter": "69",
    "Socket Insulation Outside Radius": "34",
    "Socket Outside Diameter": "69",
    "Socket Outside Radius": "34",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "24",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
    "Wall Thickness": "4",
  },
  {
    ID: "606567",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.1392667",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkaRprPYkKgh6KCB5KDy2GNhCzUqNQSv/dSKvUk7edfcPMZB2kpT61NwUJ7LHUKZq2QgsEUtTW3SHJuuH0Bh5TGXG+nHFBuQwE9GQCBQ3kPP4PJYv4L5zEDjD/1K+apmj9Bv/Y6OKqnGogYZQROChbuXoUR3SF0372IM/68kU7pavavUUYCkFga9Rz9AaMLmLBCazRoM+1D2P6/AViehoLEwEAAA==",
    Pbi3DGeometry:
      "0AgAAB+LCAAAAAAABACVVlFrgzAQ/i95TiWJJlr7VLbBYHso22APpQ+WShtwZjg3KKX/fenaTqs5cyKKyefdfZfcd3F5IIu1ftt/5iQlT2atX02hN4SShdFl/UXS5eH8amE2sxc50mZmwhmb/T3sTY6rq9m8qrK9tRVJoKQQdCKiQEouKOeBUNOEtoGQS3kCWBhxJ4C3EErFJ4BLPsW5urLquYrCMKScBdNEhrjgYILKSQmM7F2oHnDmyu0HicLFQCYRBVzFSSd4EjsBZjm05xtPgEEPaHaPuWN3Q0Dzzd5FwskJ4tqdV046YGbNPsQSlzLoyrt6gymAkgA5gWWGsQBjeHfUs4RgjWNYgapA6gjDCtQqqCOwRsaXQqs63d0GdIJuTkO9zMvE2+HOAFpvWNXeyh/s6QjxgIcA8tjAkPIef71VAtvb2D55K88xTWO4ywBJ2N+De5195HVekZQFjJLnvNzWu8vgxdRZrU15Gb7rzT/0mOvtrr4MHor8p/3hnSmMdVh+F8Vx9QtfWxi90AgAAA==",
    Area: "0",
    "Bottom Elevation": "-452",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-401",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "2",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3350",
    Length: "1367",
    "Loop Boundary": "No",
    Mark: "818",
    Material: "Copper",
    "Middle Elevation": "-401",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "21",
    Size: "100 mmø",
    Slope: "0.02%",
    "Start Middle Elevation": "-401",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-350",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606570",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.84753836",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjj0LwjAYhP/LO8eSj7YxcRIVBB1KERxKh1RDG4iJ1CiU0v9upBS3u+M57qoRisZchqcGCSffmFLfgnKt1YCg8MaFF8hqnGVEKEtSQtlmRXGyFqmAqV64bd+rIcIx2Bv10EH3IHGCEZy1a0P3MynlBEHpgwrGO5AkyTjmIsvynJNcMMwRXM19hpng0R61abvwLx+s/izt+CGGCHbe+jjm3tZO9RcM0JYS0wAAAA==",
    Pbi3DGeometry:
      "KTMAAB+LCAAAAAAABADtWUtrGzEQ/i97dozej+QU2kKhPYS20EPIISEmWXDtkrqFEPLfK0tyLK3302pzFiVtrLHm8c03I6lz/dJd3fU/nn+vuvPuy/au/75d9/fdorva9pvdn+78+iX86sTkwv3pXhfHlTNKyIX/y/10rzeHbZdPT7fPbi/jS2kEW5wxsjRW2AV1/wqmF07AmRJeoIVK14U1fGydCSJmKYKWoSCapksiuB4xcSqATk2Ffaoqj5sumbLmNLzj+sBChQBpGgRRIRgEcRQMEKxQBXfg+KSlXmClDHEQIb1AOSS9gDOa7RA0qLLK8kzAuQ3GqfICqp3uvYBaHQREySp3nQkg0JxGAfWqKNVjbIORJ6QS5hCHMHuBZXQswJodlEWveBRILcuqNFVBwCTz7lLNgoCH1FrKM6xwPpBxWIDvCLC++o2i5dSiDGL6QEhOSM2sLbL9yCulvFfEwVokHCxOKRyXvVfG1w21By4Ass8vD2gCVSBsoMwcICzvgKWZdNZKCCsOAsxcZAP3HgQVam/45EC2IRMG4MLTCe6oaW+wIUKoYHHAckI9qRaSMRDLZ/98EBP2wIYIjzQUYG3dVBQUuj+9bTDOG3zhyhgdwjPh+5ZxlnQL933jFlI8eEy41gEoy134IeyoSUWfrJHlrn6A1kitsLPTQUQeuHXGM3JSV55+XQpPAypV2nZG0IiFH+BLeKNl0GQ4INQQcJjso7Ol4Ma+Pwgu9zU9XkFKpY0buPAss5TYkoXc05OmPXW7za4htdSI5/qMi/Kh34iYILZv8vvWzHmZyAgmiCv0CZlGbCoIUBBVRE5Io/lh3YRcW2mL5Qt3IL7O5yXiH+wD0DT0FcEBfJ1uKAOGw+aHWDb7ZYwfdqgFYXKgup75asU9DrqEMoo5gFqEYsqkAFrN4rqwqbNUCBHWtR62FDUhQJoGieCET6zb7NJxVORDON4tkhiAJrgBxACfVFAVfkyiB0QhPiGzWwo1WgQaqOgVs8EGEcW2/57kaR5vYSrGbWeYTs4PdJ3DSZImg4NII4s4wQsuMlHyCSCOsgq9xTf7Ag+AcewuSBL8jwCQPRhFIW7A/1IyxtNXAATVGK5KCMjo+Y9aFGz98KDC7VTnp7ZDXsVU0NjKrQmvGaqKlTTRH0+DwEGL7HShduLSiA6XUutHro6bRmDgxlzwCQCOchrJ/4bfoIJPL2KYA8g0dnbcdMFXdKaOK0K0nH6a5OtITwELkGl0E68sh4p3XZuZtJlJMb42M2kzkzYzaTOTNjNpM5M2M2kzkwzaNjMp3a3bzKTqMG4zkzYzaTOTjBxtZtJmJm1m0mYmJW/bzKTNTFibmbSZSdnZNjMpzExuFt3H/vbXard66s7Jkiy6r6vNw+4xfvi23d3u+u0mfvzZ37+JPq/6h8dd/PBpvfqXfvHDdr11Cjd/1+vXm/+k7cJSKTMAAA==",
    Angle: "89.40°",
    "Angle 1": "89.40°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "65",
    "Center to End Label": "65",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-3930",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "105",
    "Fitting Outside Radius": "52",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "52",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1844",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø-100 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "42",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "606576",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "21.39896322",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNt106xQVBHUQCTqIh1VDB2sLW4GI3z1FvL3f4/d41QDF3V77twEF53C3pXlE7RtnAEERrI8fUNWwxElhElNGt5uEYiEJh7FetV3X6X5yp+Jg9ctE04EimCC4GN/EdoacJRmCMkQdbfCgKOYZySQXIs+TlEmaIrjZ5yILQTmCk7FNG2dOGacIjs781jXBUvAcwT64MJ35r3Nj/Qe+WI+O0gAAAA==",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-3893",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4734",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4670",
    "Length 5": "143",
    "Length 6": "4779",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1847",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606578",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "19.28150978",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNt10dooKgjqIBB3Ew6qhg7WFrUDE795EvL3f4/d49Qjl3VyHt4YCzv5uKv0IyrVWA4LSGxc+UNTjEqPCJKaMbjcJxzkjDKZm1XZ9r4boxuJg1EsH3UNBMEFw0a4N3Qw5SySCygcVjHdQUMwzkkkh8zTjPJVpguBmnossBBUITtq0XZg5ZZwiOFr9W9cES8FzBHtvfTxzX2un5g+cc+V70gAAAA==",
    Pbi3DGeometry:
      "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",
    Angle: "89.97°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-3893",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4734",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4671",
    "Length 5": "143",
    "Length 6": "4779",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1848",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606580",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "20.05237955",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNnVzdooKgjqIBB3Ew6qhg7WFrUDE795EvL3f4/d49Qjl3VyHt4YCzv5uKv0IyrVWA4LSGxc+UNTjEqPCJKaMbjdMYEayFKZm1XZ9r4boxuJg1EsH3UNBMEFw0a4N3Qw5YRRB5YMKxjsoKM4EEZInjAuZ5pJzBDfzXGTOaYbgpE3bhZlTmicIjlb/1jXBMu4Q7L318cx9rZ2aPw9raXDSAAAA",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-393",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4728",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4670",
    "Length 5": "143",
    "Length 6": "4772",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1849",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606581",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "22.07681475",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zGps65dYoKgjqIBB3Ew6qhg7WFrUDE795EvD0vv4enHqG8m+vw1iDh7O+m0o+gXGs1ICi9ceEDsh4XGZFEYJrQ7SZNcZYSDlOzYru+V0NkY3Aw6qWD7kESTBBctGtDN5siSTmCygcVjHcgKWaccJGLIuOMMTK3N/Nc4DynDMFJm7YLs88SRhEcrf6ta4JFzgoEe299PHNfa6fmD4lsAZbSAAAA",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-3893",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4734",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4670",
    "Length 5": "143",
    "Length 6": "4779",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1850",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606582",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.37859769",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaRVTT6KCoIcigofSQ4uhXYhZqVEopf9upNWDCO5pZ98wO1kHaYnH9moggR2VmJJtK3LAICV0/gZJ1g1rMKg517GWi0mkuJxqBT37DfXsi2mutNJ/2RCav58vm6ZoQ4NwWGNxMd40kAguGOyNq3w9igP5wmMoPcgTnj9oa7Cq/UtEYRhsrHmMXim5kCJmsCJLIdfdre3zJx/7FtARAQAA",
    Pbi3DGeometry:
      "owgAAB+LCAAAAAAABACVVUtrg0AQ/i97NrIPEx85hbZQaA+hLfQQcjBEkgXrFrsthOB/76ZRG1fHWZFodh7fvGc3Z7LeybfTZ0YS8qR28lXlck88slay0F8k2Zyvfw2bLs1DKu+fMmOULv9e5keqbaO2Ksv0ZHR57FMqmDcT3GfzmHuM+TwOYs8wGO/SRSDCITplNBiT5yKKnAw0QD2P6OXLIz+eB6LDYGE4qNBYAE33GFcTsE+gAmwiChdDzk6M2qFA8WKwDjW5KUMLU9MRlDaucfFx9JuS1XS7Yo1VK/2IM73kW062ue9aBcUBeChlk7x3aFsI3i44muSOAefkI6WF5hqDAeWnLhrLH/ehRgJzbQesq4BBR2EgeddNgnU5uqpahtu4QFOHDC+6UgEY5xWMXUiWP+6LFgkMWgPDdGAc3dfD5FvwomBu/HuZfmQ6K0lCfeqR56w46GN9eFE61VIV9fFd7lvWYyYPR10fHvLs51bwTuXKABbfeV5tfwH5Jd0EowgAAA==",
    Area: "0",
    "Bottom Elevation": "-3944",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-3893",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "20",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3358",
    Length: "245",
    "Loop Boundary": "No",
    Mark: "819",
    Material: "Copper",
    "Middle Elevation": "-3893",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "4",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-3893",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-3842",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "606586",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.23392856",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zT0LwjAQgOH/cnMM+WhiWidRQdChFMGhdKga2kBMpEahlP53Y6vbvcdzXDlAfjGn/qEhg4O/mEJfQ+0aqwFB7o0LT8jKYR4jYQpLwdhqwTlOOFnCWP3duuvqPuK42Jr6roPuICOYIDhq14R2CiVSBIUPdTDeQcYx5VSkLFVSSSq4YgjO5jZjLpKYe22aNkzNJYKd1e/fMaWY0C/ZeOvjL/eydqw+nl3YU9IAAAA=",
    Pbi3DGeometry:
      "ExEAAB+LCAAAAAAABADtVl1rGzEQ/C96VoxWHyvJeQptoZA8hLbQh+AHhxzJwdVXnGshBP/3yFrZOcOt7g8cxsan8c7cjHTrfXgX94/tr7e/jViL2/6x/dl37ZOQ4r5vd8OrWD+809cEq+v0Egf5uXIFSl3nj/QWh82p7Ga/376lWh1WDtHIK2NWDqKRACsIGmUGPGTAKmOPgEYMclxhrNaXFSzgHFG5AEdAxWBlTRxdYjgC2oVIAHgCTCQqzOvGpsK8rpC0o3ZZAqy+YEKVqC+Y2IppieTC07qO2QVAtFRQgrLE4xCqrivmwNItaadLhSs5kYTxQMkiuBmNQmWjp7uKPpaK4i4En6mscjP22KA439NEn9JKwViaVWBPFBthLalp32xSCQh0OF25XRPDXLbsbkwlVfHNJsWckMrRYajYpFjflVbBZ8tFyDyVFQ0sGkZnQFt36ggldMDcp4zyttrAKi3BUIUzSBpoy8Zi0YiKAGXqTfJMlZgiAe4Uuy+x65ABbf2cQablscYZprO2RTBjbb7lzfXnif3jkmJ8s0kljfJ0AFC22uBMtvxuTEdVMc4mNX1EamdnmoqNijVe++flwmUz5BvozL/7Migsg8IyKCyDwjIoLIPCMigsg8JYYyPF13b7pxmavVirlZLirtk9Dy/l4kc/bIe235XL3+3TGfretM8vQ7n41jX/xz/80nd9Itz967rD5gPA622+ExEAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-392",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "105",
    "Fitting Outside Diameter 2": "54",
    "Fitting Outside Radius 1": "52",
    "Fitting Outside Radius 2": "27",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "52",
    "Insulation Radius 2": "27",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "26",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1853",
    "Max Fitting Outside Diameter 12": "105",
    "Maximum Size": "100",
    "Minimum Size": "50",
    "Nominal Diameter 1": "100",
    "Nominal Diameter 2": "50",
    "Nominal Radius 1": "50",
    "Nominal Radius 2": "25",
    OffsetHeight: "50",
    OffsetWidth: "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-50 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-50 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size 1": "42",
    "Tick Size 2": "22",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "606588",
    Name: "M_Tee Sanitary - PVC - Sch 40 - DWV: Standard",
    Category: "Pipe Fittings",
    temperature: "21.18852548",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GvpzOrqKCoC5Egi7EC6uhg7WFrUDE/95EvDvP4TmcaoTibq7DW0MOZ383pX6ExrVWA4LCGxc+kFfjEqPCFKaMbjdMYME5h6letV3fN0N0Y3EwzUsH3UNOMEFw0a4N3QwZ4ymC0ocmGO8gpzhJSaokZzJVIlNSIriZ5yJLSRMEJ23aLswsWNwerf6tY4IVzxDsvfXxyn2tneo/HP/VlNAAAAA=",
    Pbi3DGeometry:
      "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",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "98",
    "Center to Socket Bottom": "98",
    "Center to Socket Bottom Label": "98",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-3901",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "114",
    "Fitting Outside Radius": "57",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "57",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Length 1": "4734",
    "Length 10": "64",
    "Length 11": "44",
    "Length 12": "44",
    "Length 2": "4670",
    "Length 3": "98",
    "Length 4": "4670",
    "Length 5": "143",
    "Length 6": "4779",
    "Length 7": "162",
    "Length 8": "98",
    "Length 9": "0",
    "Lookup Table Name": "M_Tee Sanitary - PVC - Sch 40 - DWV",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1854",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    "Radius 1": "64",
    "Radius 2": "64",
    Size: "100 mmø-100 mmø-100 mmø",
    "Socket Bottom to Socket Bottom Run": "156",
    "Socket Depth": "44",
    "Socket Entrance Diameter": "115",
    "Socket Insulation Depth": "44",
    "Socket Insulation Outside Diameter": "128",
    "Socket Insulation Outside Radius": "64",
    "Socket Outside Diameter": "128",
    "Socket Outside Radius": "64",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size": "46",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
    "Wall Thickness": "6",
  },
  {
    ID: "606589",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.45455667",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdFd1UaO0UFQR0kgg7iwWjRhW0nbAtE/O9tqB0i6DZvvsd7L+8gO+tje1OQwo7OOiPTVmSBQUbaujukeTec3iDmHCMMFzMRcpnIBHr2C0qOSfQFkQsU+A9OscVUv2yasvUb/GOty6tyqoE04AGDvbKVq0dxIFc67WcP8qQvH7RVuqrdW8gYkcHGqOfoDQOOcSQYrMiQz7UPY/riBUiGnL8TAQAA",
    Pbi3DGeometry:
      "1AgAAB+LCAAAAAAABACVVk1rg0AQ/S973sh++LEmp9IWCu0htIUeQg4JkWTBusXaQgj+966uSYzNrBNEcec5b2acnaeLA5mv9fv+KyNT8mzW+s3kekMomRtdVN9kuji4WwuzmT1ITc+WCWds1l7sSerl0e2uLFd76yvSQEil6ETwQMYipJw3hoRagDHJOyBUDWANAzvGQQVpFMrOLuPGzgVTXiYwJy6ODpGknDXUwpcrSCRUEl/NqeeBYwKLOOfK09auksgXAaptLLIM0lg6II7EAIhcBJH2Q3s9+sCpdw0QuvcUJqE3Bgi4+hp77OpTLPEm1QMGZbjm/U8KpDrHFm0vJB8WAYZGAojq+kWMTwXYJPRGAGPg2op6g9AmH+EBHfBjBCQET7xfUyCiW/YGuC1HxAak8soTVtBGhsWndJd2xNSBcoOTghEJhIi8monSWCghxDfwCj/Ig1ZLcEJxunGb0lxUYX8RHvTqM6uykkxZwCh5yYpttesWr6ZaVdoU3fJDb07QU6a3u6pbPObZb//Be5MbS1j85Hm9/APrnkny1AgAAA==",
    Area: "0",
    "Bottom Elevation": "-3961",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-3902",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "32",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "3341",
    Length: "793",
    "Loop Boundary": "No",
    Mark: "820",
    Material: "Copper",
    "Middle Elevation": "-3910",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Reference Level": "Level 3",
    "Relative Roughness": "0.000026",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "8",
    Size: "100 mmø",
    Slope: "1.02%",
    "Start Middle Elevation": "-3910",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Top Elevation": "-3851",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Vertical Justification": "Middle",
  },
  {
    ID: "625406",
    Name: "Basic Wall: MW 11.5",
    Category: "Walls",
    temperature: "19.10924196",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0MU1/PIkKgh6KCB5KDy2GdiEmUqNQSt/dQGvRk7ed+YaZzXvIKjx3dwUpHGyFmdVdbQ0QyCwa94A078fTBxYspAFjq4SGUkgYyBcSjMZxIv4wFkfLXzZXjqj4DK/btuz8uje2WN6UUy2kAQ0IHJWpXTOJk3WlQ//wKC94ndFeYd34DS4pFzIisNPqNYUZp97iBDZWW19snloPxRvDvAUBDgEAAA==",
    Pbi3DGeometry:
      "JgQAAB+LCAAAAAAABACVk98LwiAQx/+X69WJtjXneopqBPUQFfQQPSySEtaMJUFE/3tS6ydtJqJ4H73vHee5OMN4JWenvYAYhmolpyqTa0AwVjLXB4gX5/vWHJO2GXBBL+JRQtq3xUy4LB9unaJIT8bXoy1MOQ8Rx60wCBFt4iBkTeQFFEcRD2zcjzCjPq/mX/pV/Kn/4jRi/i/9Wv4jz0/+pW+N+2ee1rh2XqXv+i61cR3qWfu+Dv1QVU9X7tpvtfrWOv/JLXHNf+vJdCe0KCAmmCAYiXyjt6UxUTrVUuWlOZfr59FAyM1Wl0Y/E8f3i12VKSMIjX6SsISZf30FlhsoGCYEAAA=",
    Absorptance: "0.1",
    Area: "65",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Calculated Heating Load": "6500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "MW 11.5",
    "Family and Type": "MW 11.5",
    "Filter Tragend / Nichttragend": "No",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0",
    Image: "<None>",
    Length: "8193",
    "Location Line": "Wall Centerline",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Mauerwerk - Ziegel",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "MW 11.5",
    "Type Comments": "Mauerwerk",
    "Type Id": "MW 11.5",
    "Type Image": "<None>",
    "Unconnected Height": "8000",
    Volume: "7.48",
    Width: "115",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "711538",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.168357",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkpqWknkQFQQ9FBA+lhxZDuxCzUqNQSv/dYKsgHrzt7BtmJu8hq/DYXQ2ksKMKM7JdTQ4YZITO3yDN+/EMhrniUuvFbB5xkWgY2DeSKvnLpJLyB06ZIyve1cu2LbvQHx5rLC/GmxZSwQWDvXG1byZxIF96DJNHecLzB20N1o1/iUgmDDbWPCavjLlQOmawIksh192tHYoneYwZdw8BAAA=",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACVVl1rgzAU/S95TiVR06p9KttgsD2UbbCH0gdLpQ04M1w2KMX/vuDUiXqaiCjm3OSca+5H3F3J9iDfLp8ZSciTOshXlcsjoWSrZKG/SLK7/r0aM1ubi1T0H1lwxtb1w9yk2rfLNmWZXsxaP/B4HNOFH3qcxxHlwmOhWNIezmIWTOJR6Nf4koVOeMuzEryPc1/EU/M5EzUcxMLFHeQ+oofutDyOOORp3I+47+Im2rWR+zxYTS/oDMMNag0j6c4ANYbfZhWHGtirQZhHTCNt5BT8jGEo7ExIe3408IZY4zdMNNd6sxK54mj/QIZbpuNkctWF4bGU3FwaVxxmha124QKoMDsh57bD+USuOCp00OZt0yG9qy7sSLfPnbk0zjhsCNb6th20t3qw+RO4l+lHprOSJMxjlDxnxUmfm8GL0qmWqmiG7/LYmR4zeTrrZvCQZz/9iXcqV4aw+M7zav8LnNqjWrsIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "26",
    "Loop Boundary": "No",
    Mark: "822",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2624.6",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711547",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.10809464",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkbYOmnkQFQQ9FBA+lh4qhXYhZqVEopf9usNWLgredfcPM5B1kJzy0VwMpbOmEGdm2IgcMMkLnb5Dm3XAGQxRzkYjZfBIlXCqpoWe/oRJSfkEd6f9wiC3e9YumKduwITxWWF6MNw2kggsGO+MqX49iT770GGYP8ojnD9oYrGr/EomcMlhb8xi9UnERa8VgSZZCrrtb2xdPExDGLhMBAAA=",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACVVlFrgzAQ/i95TiWxRqt9GttgsD2UbbCH0gdLpQ04M5wblOJ/X9ap24xfTxHF3Od99yWXu7g+sdVWPx/fMpawe7PVTybXO8bZyuiiemfJ+vTzamGxtBer+a9lJoVYnh/2ZvWmdbsqy/Roff25JxYy5DM/8KSSMZfKE5GS/BsIevZQBGe78uWwAwTCMP4PLKTPL8bGQBQNq0JqHaZAhcOi5rEankbrAQEoCgaHahETKUoJKYfS19n7mhwHCLQr1QFt+qbHbqY3XpQTop++DmjT51B1WYIAUgWDQwBSoRVBdlhLk6uSikAvObkPYH2TVNBjfEcgm8v0je5QwZnjGHCnU70CUtHdhfag6s9tbRAYXcpk/cFShi2apIIe448BqGr6+UBSjW8wRB+BbQERjTpo7H/DjU5fsyorWSI8wdlDVuyrQzN4NFVaaVM0wxe966C7TO8PVTO4zbPPvx9em9xYwuIjz+vNF5L4A1TpCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "106",
    "Loop Boundary": "No",
    Mark: "823",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "10743.9",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711565",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.56253577",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjU0LgjAcxr/L/7zGXk3XKSoI6iASdBAPWkMHawtbgYjfvWEF3Z6X38NTjpA35jTcNSg4+MYU+hJq11oNCHJvXHiAKsePjAjjmCRJtlowgSmRMFU/bN339RDZGGxNfdNB96AIJgiO2rWhm03KBYLChzoY70BxTAWVGUskl2m2zDhFcDbXf3ivTduF2UsW653Vr++aSky44Ag23vp45p7WTtUbsMyL89IAAAA=",
    Pbi3DGeometry:
      "/xcAAB+LCAAAAAAABADtVlFLwzAQ/i95ruOSNG2yPYkKgj6ICj7IHjZWtFBXmVUYY//dYtO5tfuaVkRfwthYc7273HdfLt/jht3M0/v1a8LG7Cqfp3d5li5YwG7ydFm8sfHjpvpbmmlSftg2+F454USTr5/yy7bT2u10tZqtS18hR5zLODgR4YhiE3A1oojCYH+dc82/DDLWBwYy4ug6l5wPjARS1xm0MMcDtQwo9eAMjUCkpK4Mipv9GsrA5rghpIZHHQoaYCgjTE8PW0d7u7Whf3KnB9oVApcMqcqBuKoMYXdfKdK1IZbWI+wMRTFZD5KHu9U6qjtrPcRA1rrKcKdAtEUsbLC2fE3Y93l42DxUNdwrDAUhV2Sr40p1H40dUIi2AKgOOqPckJxwUyg3RAoCgiJBB1hevS5j0Qun4fMAdxU2z3VYW6d7MDlhVwdDDgDE4xwhboSsDCKKqxGspSMSKLv31VMPeXjDtNCQkey+L/qPA6kcORAgMBS87XFyN4QNqOCmICIYQwQV9ICsdSICBVMTqf6j1ik2+p+xXX0oB+wfphsaCe5jhqRi+/xhVgGS/IDrveetk6F48LjE1G/Jc6eo/nt17qzBy3Mvz7089/Lcy3Mvz7089/Lcy3Mvz/9dnk8Ddp7OXpIiWbExjShg18nyqXi2D7d5MSvSfGkfH9LFznSZpE/PhX24yJKP/RfP8iwvAy7fs2w7/QQjQI7y/xcAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1862",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711567",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.24540888",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACNjk8LgkAQxb/LnLdlXRXRTmFBUAeJoIN4UFp0YNsJ2wIRv3tb2r9bt3nv93hv8h6yCvfdWUECG6owI93VZIBBRmjsBZK8H08XkD4Xcj6TAQ+lF8PAvpDksfP+gFHwyz6dD1K8hhdtW3Zu3RlLLE/KqhYSwQWDrTK1bSaxI1tadA+P8oDHN1orrBv7FIEXMVhpdZuyXsiFH4cMUtLkes1V66G4A0U6Pr4NAQAA",
    Pbi3DGeometry:
      "kQgAAB+LCAAAAAAABACVVd1LwzAQ/1/ynJUk/e6eRAVBH4YKPow9dCxsgdpIjcIY+98NW6ep5syF0tL87vK7y31leSCLtXrev0nSkHu9Vk+6UxtCyUKr3ryTZnk4/1oxm9uHHOkPMuOMzU8f+5Lj6rLtahjavd0r0oQJOhNZkheipDxPWJYX1IHTVPhgUfITXLAMAV9Iypy7cFFVPu3sjKZ1jnAEcBughhwZSXAwQDK6XXGB8A8I1MRtkdSC1x59VzAJiyuYGJ4IIBuTc6GMgzZAr9zc+pj+2AadAo/h5gHHBNmOzwYYkGD+fhUTpr8QNBgYip2/ssPaIDnKKpiYUKNFkmBgsBYQDQvpg/zRRRg3+aJpEDDU2P5RHtaGRxbGKjh/QjdLJAkGBlsf0cqBO/S/WWvv9xvVvkojB9KwhFHyIPut2Y2LR21ao3Q/Ll/U5lt0J9V2Z8bFbSc/XcVr3WlL2H903XH1Bfb3o6mRCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "30",
    "Loop Boundary": "No",
    Mark: "824",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3019.9",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711597",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.10842937",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzE0aUN/PBUVBD0UETyUHloM7UJMpEahlL67oa2Knrzt7DfMTN5DVuGxu0pIYGcqzIzqaqOBQGZQ2xskeT+dzsA5FQGPlwse0DAKfRjIF4x4xP6AvmC/8BM7wuJVn7Zt2bkN7rHG8iKtbCHxqEdgL3Vtm1kcjC0tutmTPOH5jbYS68aOImAhgY2Sj9nLBPX8WBBYGWVcrr4rNRRPPI385RMBAAA=",
    Pbi3DGeometry:
      "6QgAAB+LCAAAAAAABACVVl1rgzAU/S95thJd4lefyjYYbA9lG+yh9KGloQ04M1w2KMX/vtDqbNWDV4qtyfGcc+9Ncu3qxJZb/X78Uixjz2ar30yud8xjS6ML+82y1ely62A+dx9Wee3MLOB8fv5yF6vWDW1Rlpuj44ahL0WYerNQ+LGIpBdInwsZeTdALNNhIAnP8xEXtPlGKJbBLSDck4OMKLhI3aWSGBPMAnrgqGopOgClmjwS90sLF9Wwk0YSJsEQoZ3vVKoFOtZXALLopDfuDS1gUJ0F70v1vGFQMI3OYlCkkPnk1YAVmXxmiAT6BqFXFu5mamUJB4PKgIsEjyuBAT2o5nCHEA4yzgNKjWU+1gwpTWG61GQP2O1Hu0IvKihFZRCigu+g6d0NMiBAe/dCIXofcQT3v+FBbz6VVSXLuM899qKKvT3Ug1djN1aboh5+6N0/9KT0/mDrwWOufq8fvDe5cYLFT55X6z+DH+L66QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "87",
    "Loop Boundary": "No",
    Mark: "826",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "8776.6",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "24",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711659",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.27784744",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xiaVButK1FB0EUQwUXposXQDsSMxCiU0rsbaPUG7v4X803Rg67x0j0M5HCkGjXZriEHDDShC0/Ii36UcSAlX6rFeibnXGVCwsD+0JVf9Mb7qov8GOywuptgPOQJTxicjGtCO5kzhSpgfHm0V7z9qoPBpo0QwdVKpQz21rynrUi5FJlksCVL8a57WTuUH67xj2YPAQAA",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEqSGn/1aWyDwfZQtsEeSh9aGtqAM8Nlg1L83+em7TR45oqIYvxy33eXy11cnchyq1+PH4pk5NFs9YvJ9Y5QsjS6sJ8kW52a1xpmi/oiFf3/MuOMLf4e9U2q9dnspiw3x9pWiCBJ0pjORBjEsUwpnweCR4L+AhETHiCMJM5ChrwBIi5wVKBXsWy+JwCRO/9C5CqkMhn2CZQGqcAozs6GLMRJ+NdjXFsGjM/lwIp0gL74kIVL1U8fRgMEuunD+AQC/fQNWbhR9JKBCRtkAgE/lRsGsjJADYwFqOHPK3YNoY2OI5pSSpBHYMGAAI4JA4B7099zxqkm9TV/xYANzwWQVBgAaAhAm0fRTDhGAG/8R+EY/6SGCdaov3Nc32s6UdT/Cnd6866sKknGAkbJkyr29tAOno3dWG2KdvimdxfoQen9wbaD+1x9dyfemtzUhMVXnlfrH085RVTdCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6872",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6324",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4028",
    Length: "548",
    "Loop Boundary": "No",
    Mark: "827",
    Material: "Copper",
    "Middle Elevation": "-6872",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "55302.8",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "24",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6872",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6324",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711660",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.12817216",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GnG6v2lVUENSFSNCFeGE1dLC2sBWI+N9bH96d5/AcTjVCcdbH4a4gh70761JdfGNbo4BA4bT1D8ir8ReDwjlNUSwXPKEoIw5TPWurvm+G4IZio5ub8qqHnFFG4KBs67sPRIgRgdL5xmtnIY+oQIaZjLnELEkzKQmc9PUvJwwJ7JRuO//lWCQEtka95nVMmcDQrZ1x4cw+jZnqN4Upuv3SAAAA",
    Pbi3DGeometry:
      "Fy0AAB+LCAAAAAAABADtWE1v1DAQ/S85pyvbseO4PSFAQoJDBUgcqh5addVGWnZRWZCqqv+dsLG9Gzsv46TccFEr1rPzPZ4Zv6vn4vK2/fr0Y12cFx93t+2X3aa9K8rictdu9z+L86vn/r8dmV10/4qX8nhyxhm7OPzpfouXa8f25vHx5qnjFWLVaFWeCblqpGlKXq244rzszg1X9YDAGtaMErjQuhyRxJSWk5KQanheSTmuOSQgDc6kZA2R07UW+lR1RAhVe4bAufA8WZD3wdkaMYSEMEGRSVBSog/eJNWYA0EL1sdVymnNqqMPCJXpJUmhrSQtekJTTXPM9poyVnNZjZYla/hQkM2cNtoKIuob1rFzzhN8OJS11Yi6Jyg97jWToieonqCl7AMouJiOE9ZRi57w16EDgSniPiYrd+aKLqYHjpqLoR/IXKgDlg5qBmHUWW3Gq9MTUGJhJcDEwqsHjZrd6ygvyMYCc+FVk9mLKiSdgxQFyxPqWNB1UK+A2Ugu6PSMQ44os7DcYIHCy5+cqGj8hBmEEw4vCKYO/VOTlYu+b1Q1Hlo0G4z1QQtZD+LkJIWlYwQ3o3GKNwdIAAPr6B3hRfLihTNBehGJSubwhYPGK4x56sZ03MmqppdUSXPaEaCxqHAmKhPkAmcVVg6T9oYJd1n7q4cJ0L/ZymHQJ5RLmz/dcON/mtMRDHM/o1pcLpm23d2oYUsOM+DjCUWlWD5fHebg3O6LXA9mBhKFOdAbLbnp4HcMdV2X5Rs8CY93nfI02LG9Bt3InsGIoUO6shPNEiJJxDkW5ObZAkJgLLQJSSK9803US0LLkNuWTb3MVPQIct8H8tEx9WQK1cLNDCbB7UBa1KMFEM2fZAbCN5wC5DT5wPL32+kgV9tkr+nAhrphxKFR5A4ZiVpgFRnDqHOAKeqWgS6EatllDO5KVDhAAT4nNqNQMZxJsI36mdQVs0zqA8kMhHMTaUCrCbn+hMUxsffNdDshsqFuOLng8CaneiRqgVVkDNFQi9eqmcN/AbKcDPwuRoTxpg9VENhy8nNlAuIChNej0f8ORMaoEWlTRotHV5+MFme0OKPFg+xltDijxRktnjePM1qc0eK0VT+jxWOiMlqc0eKMFme0OKPFswKb0eKMFme0+H9Gi6/L4l178329Xz8W52zFyuLTenu/f7AfPu/2N/t2t7Ufv7V3nvRh3d4/7O2H95v179Mvvt1tdp3A7a/N5uX6D4s4tBcXLQAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "27",
    "Center to End Label": "27",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "29",
    "Fitting Outside Radius": "14",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "14",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1873",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "11",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711661",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.53029263",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzG0G01/PIkKgh6CCB5KDy2GNhATqVEope9uaKsHQfC2s98wM1kHolSn9iYhhb0tlbC6rawBAsIq4+6QZt14egMijTEOlzOcU874AnryA0YYfcMEw+QPOMTm7/pV0xSt3+AfG1VcpZMNpAENCBykqVw9iaN1hVN+9ijP6vJBO6mq2g0iZozAVsvn5A0ZDThyAmurrc81D637/AW/JSKSEwEAAA==",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVsFqg0AQ/Zc9b2R1V43mFNpCoT2EttBDyMEQSRasW6wthOC/16ZqktGXNQSDO+O8mdnZ93R5YIu1ftt/pixmT2atX02mN4yzhdF5+cXi5eH/tnaLWf1jFT9ZJq4Qs+NffbFq1YbNiyLZ17Ge50xDn0885QQy8LkrHVf5Ef+zSykvHUJ5R4fySYSUIb+CFAmlBgMiNwiGUxAkEXjB9ZpQE6ikmzMDOwTqNS1CNR3cvs4xtrmupg4p9MKLQXRIrYMitfbedpCAUxc0BUCC9rEl9Tac2GGpsDfaQrvfo5FsJeHe6ID6o7ZF9EdKD4edphQK8tdKbDRsxDr6vD3zyGNmP5djhQABYdGyqxklEdQIO+1gclruaAb3jz+sCkoahUJah0XQRjEkv1QN7Jkp9VBmyNUb3wgYCAq//Y1AZcKuBlBYYPKzcuvvhHudfKRlWrBYOIKz5zTflrtm8WLKpNQmb5bvetO5HlO93ZXN4iFLf84fvDOZqQHz7yyrVr+5QUHY2QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "64.5",
    Flow: "3.5 /",
    "Flow State": "Turbulent",
    Friction: "28891.70 /",
    "Friction Factor": "0.016825",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "11",
    "Loop Boundary": "No",
    Mark: "828",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "318.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "177033.7721",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "9",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711664",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.37797566",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15Dp266rqKCoC5Egi7Ei1U/Olhb2ApEfPdGIt2dc/g+Tj1CedXn4Ykg4eiuusKbV7Y1CARKp61/gazHOQaEMZqLbL1iKRU8ZjA1C7bpezUENgw7rR7osQcZ0YjACW3ru19hSUqgcl557SzImGYiEgVPGBdFmhecE7jo+wzHUcoIHFC3nf/Le4OfxU5oXLCcwNYZF87s25ip+QIhpBzK0gAAAA==",
    Pbi3DGeometry:
      "owcAAB+LCAAAAAAABADtVd9rwjAQ/l/yHEtybW1an4YbDLYH2QZ7EB8qBg3EZnTZQKT/+6JtNxd2pj4OJDT0vu9+cndkviezpXrZvUlSkAezVM9GqxWhZGZUZd9JMd+3v45mE3dIQ3+QEWdscrzcR5pFb3ZT1+XO2QJEIkvpCJIoE1lMeRwBHwM94HlPJAJ+ET0ep8PwFJKWyJK/DfzIPc6TI85zEAc8B563xJjDKdEbCCb4IBycfM6RHxnNNFTa4IxQR2iqwRqw9mC1+fpogGA/fU/BScJS8nHMEToZwZHBZg9rnK+PBwgW/Y/3LTR7gxfu8v5cN+66cRdsnHvxblW5lVbWpGARo+RRVmu76YQnY0urTNWJr2r1Td1Ltd7YTrjT8vNUcWq0cQ6rD62bxRcLd9pGowcAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "221",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "29",
    "Fitting Outside Diameter 2": "16",
    "Fitting Outside Radius 1": "14",
    "Fitting Outside Radius 2": "8",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "14",
    "Insulation Radius 2": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "7",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1876",
    "Max Fitting Outside Diameter 12": "29",
    "Maximum Size": "25",
    "Minimum Size": "15",
    "Nominal Diameter 1": "25",
    "Nominal Diameter 2": "15",
    "Nominal Radius 1": "13",
    "Nominal Radius 2": "8",
    OffsetHeight: "12.5",
    OffsetWidth: "12.5",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "17595.5",
    Size: "25 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size 1": "11",
    "Tick Size 2": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "711687",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.60585444",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjUELgjAcxb/L/7zGnG5zdooKgjqIBB3Ew6qhg7WFrUDE794whG7v9/g9Xj1CeTXn4amhgKO/mkrfgnKt1YCg9MaFFxT1+ItRoRTngq1XNMOCJxSmZtE2fa+G6MZiZ9RDB91DQTBBcNKuDd0MeZohqHxQwXgHRYKZIELylHIhs1xyjuBi7v/yQZu2CzMLKhHsrf4sa4ZJkjIEW299PHNva6fmC6vZ7i3SAAAA",
    Pbi3DGeometry:
      "6BcAAB+LCAAAAAAABADtVl1rwjAU/S95rqVN2iTq09gGg+1BtsEexAfFooWuHa4biPjf12njbOxJWhjbS5DJmuv9OOee3tzpjkwW6fP2LSEjcl8s0qciS5fEI5Mizct3Mprujv9W5mBcfcje+zkZhEEwPnxVf2Q/U25Xm818W/lS6g+D0BvQyBc8pF4Y+0HIYq86l5wez5kUjXMp288jOewVCCZWCSSTrXH0c5S4dwKIgMqwCUGwqN0QCdY0qFCSRx0N1lAs0gwKx4WHMlyUC5PDUFYcqipErpBxbYiPBsaFsa2cCuXADoZYcnMkoUKpmmLO68YqD1p7SN5Ns51RwBQoEuDJIFquER6bQcNSUSRIOI80B1Gn6C40pQ5IE1SgPblVzKoqmNygTUCJod3AAwKMqGzioJJ25KrzROheleLKoB6k5576hI3tT7qBQvB+Q4+YsXoMD8NzGDASwG29fPTrE94xJzqYoO29028M+0j4bmarzvUciA5DpHZ40AHpBvGEKoJsQGxYmcgDStaArh0Fosk+7eAKoo9B+/tlFdTFMNDhQQpRV1H3EB/wtYMl4Qw9JW6fsrrS4OxAwwal+LWd3LZK//VKbgXgVnK3kruV3K3kbiV3K7lbyd1K7lZyt5L/+0o+88hNOn9NymRDRoEfeOQhyVflun54LMp5mRZ5/fiSLk+muyRdrcv64TZLPs9/eF1kRRUw/8iy/ewLnKGLZugXAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1881",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711711",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.12405288",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACtjs0KgkAQx99lztvirppmp6ggqINE0EE8KC3rwLYTtgWL+O4taD1Bt/8X85tqgLLFi38oKOBILZZkvCYLDEpC655QVMMkw0BKnmfpeiETniY5jOzfVf3Fbvq+8YEdgh02d+VUD0XEIwYnZbXrZnMm1zgM7072irdfdVCou8AQPFtlMYO9Ue95K2IuxVIy2JKhcNe+jBnrDy+SxjwLAQAA",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiWJRq19GttgsD2UbbCH0gdLQxtwZrhsUIr/fW61nQbPXBFRTD7v++5yuYurI1lu9OvhQ5GMPJqNfjGF3hJKlkaX9pNkq+PptYHZorlITf9nZpyxxd+juUm9PpvdVFV+aGyFCNJ0ntCZiAIZi4TyMBA8FvQXiJnwAGEocBYy4icgSnFMoFOJbOdTgMk1uDC5EnOZDvoESoNMYBRnZ0XCcRL+9RjXlgHjoRxYkA7QFx+ycKl62cNIgEAvexifQKCXvSEDN4heLjBRg0wg4Kdyo8DVBSiBsYAkvEnFLiC0yXFEU8oI8ggsFhDAMWEAaF96u80o0ZR+5q0UsM+5AI4JA0B9AOruOKIp5wfkkf8QHFWY1C2hEvV2javbTCeG5h/hTufvyqqKZCxglDypcmf37eDZ2NxqU7bDN729QA9K7/a2HdwX6rv74a0pTENYfhVFvf4BQPlajNUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6872",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6324",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4028",
    Length: "548",
    "Loop Boundary": "No",
    Mark: "829",
    Material: "Copper",
    "Middle Elevation": "-6872",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "55302.8",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "20",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6872",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6324",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711712",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.56893198",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNI0zzauhIVBF2UIrgoXUQNbSAmUqNQSv/d+OhuznCGqUcoz+Y43DUUsPdnU+lLUK61GhCU3rjwgKIefzEqlOJM8uWCMsxZBlMzW6u+V0NUY7Ex6qaD7qEgmCA4aNeG7gOJlAmCygcVjHdQJJhLInORUiFzluVCIDiZ619mRCLYadN24cspZwi2Vr/mdYoJl7Fbe+vjmXtaOzVvmn4/rdEAAAA=",
    Pbi3DGeometry:
      "lSwAAB+LCAAAAAAABADtWN9r2zAQ/l/87AZJlmK5fRrbYLA9lG2wh5KHlobWkMUjywal5H+fO0tKLPnTyelgL6K01Drfj+/udHe+m+fi+q79+vRjXVwWH7u79ku3ae+Lsrju2u3+Z3F58zz825PZVf9THMrjyQVn7Orvn/63OKws25vd7vap5xVioWtVXgi5kKqRJa8WXHFevpxXUo4ITDM9SeCirssJSUzVMi4JqQbnDVfLSc0BAWlwJqVqCEAvq6UagfYJvmrH4IELzlMFWQzOVp8hIPgB8lVDSakYnFubnv5CUFoPfpUyqlk3qhoTqmYAx2phJInhXFdxhrmgSVv7DNBToBXrn0eCTOD6ZyMont4wjR04R3DekMZWblGreho1k2IgSGOt9QYXUTdFVFR6IAheDwSmiNuYqtsaK3gzMBiPOxDIWKQBZQ0qA77D2bKZzktHQCULJgGMKbx0yKj5VY5CQZYUGAlXa6jQBcmRzEBKgokJVJxRbECJgJFIzuT0YEOOIKgo02Bu4jufGqSg5fjRw10NDgVK+vBUtOeg91Ufq8m7jRqCMhiUlmp0ha0kP2+00Hwy0YJhARJAkzoBFweRPmvBQFAgAkmpDI6AGip0eOqIdBzCluYC11KclgJoK0qaSFaCQECbYNb0Ioyx9p4Otw4TILz5yqHPsXLjK1Xx016Lw52cH9ZYKWpThqpmVH99pzsUUBQydr4KzKGNo1itRnMjFAU50DCRWlfw1wl5J5OjCj7ujpeYABeMy1aDEiYDGzEGoWrTpizBl0SdI0GuS51B8I0FuqEkGp2tjk4SGG90s7SJKc6zFX3Q2PeBAnxOfAD5itG8hZ1nRxulq+kU8FtLMgOBLRIFNFSR30vKCzQ1rqaCpt3qZxjKejT+UWNhIGi2RaTvgqKBWqOtb1rU591D/5b4GYMUwHNi2gkUww4EK6jtQIoLPYnNrwDJDBQ4HAaEmpxpvNyIjHIzQdN+9TRDfyOTqP4dCJpvEuk91MnCkWlux5+9GE7f256/0EVGYdzEajj54yOypUIryVcvk//dDhivfkib8rJ3oornZW9e9uZlb172nhfsvOzNy9687M3L3uhon5e9edkbLTh52XvapfKyN+q/vOzNy97J8S8ve0/ez8vepDDkZe9/X/auyuJde/t9vV/viku2YGXxab192D+ah8/d/nbfdlvz+K29d6QP6/bhcW8e3m/Wv09ffNttul7g9tdmc1j9AYhIVxqVLAAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "27",
    "Center to End Label": "27",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "29",
    "Fitting Outside Radius": "14",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "14",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1883",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "11",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711713",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.27356176",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0aaxNPYkKgh6KCB5KDy2GNhCzUqNQSv/dYFsPInjb2TfMTNZBWupTe1OQwB5LnaJpK7RAIEVt3R2SrBtOb+CcxjxmyxlnVAq2gJ78goKKuRTfUHIm/8EpNp/qV01TtH6Df2x0cVVONZAENCBwULZy9SiO6Aqn/exBnvXlg3ZKV7V7izgMCWyNeo5eFtIg4hGBNRr0ufZhTJ+/AMrNpmoTAQAA",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVl1rgzAU/S95TiWaqNU+jW0w2B7KNthD6YOl0gacGc4NSvG/L6vW+XFvklFamnu8J/fk5h7cnMl6J19PHzlJyaPayRdVyD2hZK1kWX+SdHNu/2qYrfSHNPQvsvAZW11+9Jc022vaTVVlJ50bBN4yDuki8L1E+DH1ueeLMKG/cc75GGAiuAAinGRwHlMDU8KEABMSP4rgLSZMLAoic02YCKykf++MxFGimWgWiyV4fD3gKq6vqWUSnhYlRo1omQbAiGkQHx/HPKFTAWyBMKFx15LGBz6Po6Wi2qYSruftzGQrCdc2bZC91WhL0aGzXAJgD+dy3ZoNTJ2ZCE1wtxRLswGrwQDnazNhAgB0iCwegVI5uIo9wzLacx/CAWeXmFABA2AcMcBmzURoAuCyRoMHKkLtGgXMTIAGi00Ak+rsH66OM5ah3xPuZPae13lFUuYxSp7y8lAfu8WzqrNaqrJbvsl9Dz3k8nCsu8V9kX8PH7xVhdKE5VdRNNsfclBcANkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "66",
    Flow: "3.6 /",
    "Flow State": "Turbulent",
    Friction: "29465.35 /",
    "Friction Factor": "0.016796",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "767",
    "Loop Boundary": "No",
    Mark: "830",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "22611.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "178937.3611",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "10",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.9 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711716",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.78537938",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNI0/QVV6KCoItSBBeli6iXNhATqVEopf9usBR3M8M5TD1CedXn4Ykg4eiuusKbV7Y1CARKp61/gazHOQaEc5pnyXrFBU1EDlOzUJu+V0NAw7DT6oEee5CMMgIntK3vfoXHgkDlvPLaWZARTTKWFWnM06wQeZGmBC76PsMRE5zAAXXb+b+8N/hZ7JhGBc8JbJ1x4cy+jZmaLz7zmZrRAAAA",
    Pbi3DGeometry:
      "fwcAAB+LCAAAAAAABADtVVFLwzAQ/i/3nJUkS7eme5IpCPowVPBh7KFjYQtkjdQojNH/brq26oJn6qMwSkvvuy/f3XF3ZHmExVo/HV4U5HBn1/rRGr0BAgurS/cK+fLY/no3nfkHavKFjBils9PHv1Cv+mNXVVUc/FnOk2yakhEXScqZJGyccDbhpMFTLlrHhJ3hPX8qhsCyx8dC/sgPw/a4FFmDM8mzE84z1joCvOdTxobgson3m04YF8szWtjAhFAhLNNoBUhjsMLO6ah6tN4gbGx8sHRCHNPB5iE2J9i8Ye0K+Zh+rN7/uV7RYRu6Xn9ty2W9LusVydPfZte62CunKshpQgncq3Lrdp3xYF3htC0781lvPl23Sm93rjNujHr/TpxbY71g+WZMvfoAf7sC0n8HAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "221",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "29",
    "Fitting Outside Diameter 2": "16",
    "Fitting Outside Radius 1": "14",
    "Fitting Outside Radius 2": "8",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "14",
    "Insulation Radius 2": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "7",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1886",
    "Max Fitting Outside Diameter 12": "29",
    "Maximum Size": "25",
    "Minimum Size": "15",
    "Nominal Diameter 1": "25",
    "Nominal Diameter 2": "15",
    "Nominal Radius 1": "13",
    "Nominal Radius 2": "8",
    OffsetHeight: "12.5",
    OffsetWidth: "12.5",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "17595.5",
    Size: "25 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size 1": "11",
    "Tick Size 2": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "711719",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.51250714",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjFELgjAUhf/LfV5juilmT1FBUA8iQQ/iw6yLXlhb2ApE/O+NMujtnPN9nGqEoqHTcEfI4eAaKvHitW0NAoPCkfUPyKvxG4MSSy7SdLlaxIonKoOp/mnrvtdDcMOwJX1Djz3kggsGR7St7z4lk4pB6bz25OyMz3T9p3uktvOfnsQRg53B16xHCRdSSQYbZ1x4t09jpvoNq0fp2sMAAAA=",
    Pbi3DGeometry:
      "jxcAAB+LCAAAAAAABADtVl1rwjAU/S95riXNRz/0aWyDwfYg22AP4oNi0UJnh+sGIv73FZs4jT1NO7Y9BVFsbu65uacnyZnsyHiePW/fUjIk98U8eyrybEE8Mi6ydflOhpNd/bcK01H1IXvve2QQUDo6/FRfsp/qtKvNZratchn3KfMGTPgyEl4gfRpS4Z2McpEchnkUnw6HQdMoC5IeGM0FFXLMkiYIYxgU7INsQkRJUgdocN6j5HFzIGFGhoaCAQglaNwxQ3dxsVwd6F7cmgFX1Uys4GpcBrIOiNZ3GcpABWSk5ot2oJCrDJEYK9VQTGewHvq0NmCBByJt1p2hUVEhqtnhWQD3ClcJoRDRsa7BI9m+GY4UIUkgiqDqYG0oR7woUBvrCCoPIMEE2B4XUR0IZNyJqP5HAFwUJsqyQ80N3Vub8KX2ZhzyB7Y05ls3wUJen7kxbwOCTXe5Y/R5Di+TCx54yNuvhu7nAJeWGpAKCAUucjjfRp5BE1wQZgP1BmmCGVCrNjaaPZDJUfez1eonuu8q3RusgUUDZYZeqW1jAfd3sd+sWjLxf6DvzmerVZn4nLGYpV+w2e0W+d9cdvuanc12NtvZbGeznc12NtvZbGeznc12NvuPbfbUIzfZ7DUt0w0ZUp965CFdL8uVengsylmZFWv1+JItjqG7NFuuSvVwm6efpxOvi7yoANcfeb6ffgHYDt62jxcAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1889",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711720",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.03763387",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjV0LgjAYhf/Le72Gzn3aVVQQ1IVI0IV4YTV0sLawFYj43xuG0N15Ds/hVCMUV3MenhpyOPqrKfUtNK61GhAU3rjwgrwafzEqhGAp2HpFKGZUwlQv1qbvmyGqsdiZ5qGD7iFPcILgpF0buhlkRhGUPjTBeAd5iplIhOIZ4UJRqThHcDH3f/mgTduFmQVRCPZWf5Y1w0maMQRbb308c29rp/oLtI5rfdEAAAA=",
    Pbi3DGeometry:
      "fhcAAB+LCAAAAAAABADtVk1PwkAQ/S97LmS7H90tnIyamOiBqIkHwgFjA00qNVhNCOG/W2FXaOnrtgnxtCGCnenOzrx5O/umWzJ5TZ83HwkZkfv8NX3Ks/SNBGSSp6vik4ym28O/pZuOyw/ZBUfLIKR0vP8q/8huZpddrdfzTbmWsaEWOg4GTAyl0EEohzTkMvi1a30wKyor9og12mMa9gqDtrXhmRSNcWp2tG3P8CBMzMK4mr7iotkhFK86TCQdiW52VyAuanZbwtkC6zjLFW0NIzlqMCnBnqlQGAc/OHik2pqptbKReLx3SB21R1JcV1KSUWT6Kc2CiB8W6KgLTbuWADeAkRBIkKl2Zwu2bCsYIwTiQKi1rL6vDKKd6WWJCluAeOfe2kVgmxJsDmYkgKOlz2gFPFZUVbnHNOsIVMcR0CMng1QLbQBde9IStLQ/3i3oNU5u8LqOywTMvA1PCkBzAZTrul7qlyO6R444lL+NDatdC+7zr5hsZnZ1BwRESyBwk8MFADuAEewMhAJVBrkI3kccxYWBChBCzrkG1UV14LlPk4tFZ8e+XhrCDvQSkQgggU4ZTAfG70dq9yStcwuOCTCFkDS6kLp2yuJ/lteu9L289vLay2svr7289vLay2svr7289vL6wvJ6FpCbdP6eFMmajOiQBuQhWS2KpXl4zIt5keYr8/iSvv257pJ0sSzMw22WfJ++eJ1neRlw9ZVlu9kPpEFT134XAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1890",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711735",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.72596624",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkTatNPYkKgh6KCB5KDy2GNhCzUqNQSv/dYFtBL9529g0zk3WQlvrU3hQksMdSp2jaCi0QSFFbd4ck64bTGwJBuZTLWTCnccQF9OSLMRmL/1AyEf7CKXVg+VS+apqi9Qv8Y6OLq3KqgYRRRuCgbOXqURzRFU770YM868sH7ZSuavcWIV8Q2Br1HL08okzIiMAaDfpc+zCmz1/WIx0rEQEAAA==",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACVVt9rgzAQ/l/ynEoSjb/6NLbBYHso22APpQ+WShtwZrhsUIr/+4LT1aVecyKK+S73fWcud3F9Iqutej1+lCQnj3qrXnSldoSSlVa1+ST5+vT7as1saS/S0jOy4Iwtu4e9SbsZ3G6apjhaXxEGPMvoQsRBmglOuQxYJGM6xmMRT+Iylh0eswiFDzyJ5P/wLBWT85Mk6vAwk6h4oPghfjCengeLQzxD/CkXqDihdXPiZ1kaTjqcDc4KnQ2O9MgAaTgfhxAHNcConERfUl2Ig1GB3+EkA0MFic/PB7gk3gy6ewpZc34iJA4uILTL/Q6gAlYaTJG38mYTIXFwb/hrGHQAFWZvy7l9cT4RDgcLHur4fge4nyGlwe7kPYVmEyFxsDn4a9138F7ryPbP4E4V76UpG5KzgFHyVNZ7c+gHz9oURum6H76p3Z/poVT7g+kH91X5PZ54qyttCeuvqmo3P6ykp2HLCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "31",
    "Loop Boundary": "No",
    Mark: "831",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3100.5",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711742",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.49228288",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LO2/Lurou2ikqCOogEXQQD0qLLmz7wrZAxP/ektqloNub9w0zk/eQVfrU3RSksMdKZ2i6Gi0QyFBbd4c078fTG3hIGRfhcsFjmvCIw0B+QUlZzIIvKKX4B+fYYq5ftW3Z+Q3+sdHlVTnVQsooI3BQtnbNJI7oSqf97FGe9eWDdkrXjXuLKJAEtkY9J28gKAsTQWCNBn2ufRgzFC+yKCJHEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl9rwjAc/C55jiVJ23TWJ9kGg+1BtsEexAfFooGuGV03EOl3X1zbraW5xiCK8fr73eXPXVyfyWqnXk8fGUnJo96pF52rPaFkpVVRfZJ0fW6+GpgtzIvU9P+XGWds8fth3qTedGXLstyeTK0IAyYlpzMhg7mIBOVxwJKY0wsQMjkEJIsaQCagAgExj4bADRd0khwCiRBAFZI7ahXF0q4qnMf2eXQVEICqIDmUiyc4rSq5PMktO9gDhqosFRBo1qoHdDvoT95M0EfViGO4gz2g28FRq64CAlAVJIcAboWWBAPTq+tjA9xq2s7wMFjs7B8ADg7LgYOA4+xayB2xBP3hn1fQBjAAoD8guUXu9VZzBpkj4aDVLHnlCGSLnWFSOwIAkvtkiSN9oCp4scAs8blxHFkCkwGGzDUXiwHMf4g7tX3PqqwkKQsYJU9ZcaiO7eBZV9tK6aIdvqn9H/SQqcOxagf3efbdf/BW59o0LL7yvN78AO2oIDj1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "41",
    "Loop Boundary": "No",
    Mark: "832",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4182",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711748",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.97410142",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjU0LwiAcxr/L/2yiU/dip6ggqMMYQYexg5VsgmksC8bYd09WQbfn5ffw1COUZ3Mc7hok7P3ZVPoSlGutBgSlNy48QNbjR0YkYZgIypeLJMV5lnGYmh+36ns1RDgGG6NuOugeJMEEwUG7NnSzyRlHUPmggvEOJMOUU1EkqWAiL7KCUQQnc/2Hd9q0XZi9SGK9tfr1XVOBCeMMwdpbH8/c09qpeQNNBrv90wAAAA==",
    Pbi3DGeometry:
      "/RcAAB+LCAAAAAAABADtVl1LwzAU/S957kqaNB/dnkQFQR+GCj6MPWysbIXayqzCGPvvVptO1+40LQh7CcNhe3bvzT05NzmzPZkuk+fdW0zG5D5fJk95mqyIR6Z5khXvZDzbV/+WMJ2UH3Lwft+MAkonP1/lHznM67Cr7XaxK2MZ92mkuTdi0tci4F4gfCpp6J0AUfniG+BKnwIy5GeBiPJwYCpYvK6hWXQ+VRPAxQfXaKXiOqwAFrKTPmQIACYaQJ0KAjCVUn0j6j5ay62B/sWtEXBVkF0lqveK6+p9aNlZwVkF6EiaiLAzkxAmQMnGYnlQb6yJYAOFa2vCVgHKFgu9KVsllYkwJWoAt40WCzMhxrkIDKB092QciUL6QExhNaPaUJt4UaA2FBRUIEgEA2B3mguTKRK9eBp+HOBdhTzZRrU124O1CXd1MOeQQTjdmHOpzbRG1RFcZujMBPvuf/nUxzy8Y1qEcMm7b4zeBwIXlhKIEJQIXvgowE5gkye0JMwGag7SBCOgaK18IMvUIqr/SWu1Gv1H7NgfqgGFA5WG9tU2YtAqtmcPSup8heEi733S2rSJDxyri/o/d2631Bdx59Y+nDt37ty5c+fOnTt37ty5c+fOnTt37vxy7nzukZtk8RoX8ZaMqU898hBn62JjHh7zYlEkeWYeX5LVEbqLk/WmMA+3afz594fXeZqXCbOPND3MvwAbcT0B/RcAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1892",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711749",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.61168938",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzHkp6WmnkQFQQ9FBA+lh4qhXYiJ1CiU0nc32Cr15G1nv2Fm8g6yMx7bm4YUdu6MmTNt5SwQyBxaf4c074YzGISgSnC1mImEcik59GQCJWUsiv9DNmfqF05iB1h86pdNU7ZhQ3issbxqrxtIGWUE9tpWvh7FwfnSY5g9yBNevmirsar9W0Q8IbAx+jl6eUyZVDGBlTMu5NqHMX3xAr3KgIMTAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVl1rwjAU/S95jiVJ7adPYxsMtgfZBnsQHxSDBrpmdN1ApP99QdstxR69HVIxPbnn3Jv7ERcHNl+b1/2HZjl7tGvzYguzYZzNrSnrT5YvDqefDhYz92EN/3szkULMjl/uYc2yM7upqtXe2SoVZEpmfKKSQGQq5DIKxDSKuQ9IJRMAJOkRiMWUCrRUSSR7gEhjNWwhTgZhFtGcgmFgCehUR0UGIFUXRioVzVt4hP0wwkA40wGLHuAflQf0xX0Aa/jxUcShBvSql/EhpnNt4BQOw88GiQlpj8/GhQO5lr/zaiP1H42KBKAzRJVO2Y9LiqIMk0RovtFERADWB6WNsQXUGF2c42fkP6hoAGp8dAUQ9uOxRlKGM4pyK40mogFwTNCa/tptfGk2u/8Md2b1rmtdsVwEgrMnXW7rXbt4tvWqNrZsl29m8ws9aLPd1e3ivtDf/sZbW1hHWH4VRbP8ASD+LQTlCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "25",
    "Loop Boundary": "No",
    Mark: "833",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2544",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711765",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.1664897",
    Cost: "0",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACtjksKwjAQhu8y6xiaFI3Wlagg6CKI4KJ00WJIB2JGahRC6d0NtHoCd/+L+absQTd4iQ8DBRypQU0uWvLAQBP68ISi7EeZBlLypZqvZ1JxkSkY2L+r6ovddF0dEzsFO6zvJpgOioxnDE7G29BO5kyhDpjeHe0Vb7/qYNC2iSG4Wqmcwd6Z97QVOZdiIRlsyVG661/ODdUHRxct7wsBAAA=",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABAClVt9LwzAQ/l/ynIUkteuPPYkKgj4MFXwYe+hY2AK1kRqFMfq/G12nDe01N0ppafL1vu8ul7t0dSTLjX45vCuSkwez0c+m1FtCydLoyn6QfHU8vTqYL9xFGvo/MxOcL34f7ibN+mx2XdfFwdlKydI0S+hMJkxIkVARMSnmkv4Acy7HAZ7JCGcRX4kTwJFMoFNJ3M4nKU76zNSTyOJ00CdQGmQCo2id5akboySC6xHQjhkXUTywIB3AFx+w6FF52cNIgICXPYxPIOBlb8CgF4SXC0zUIBMIBKl6UeDqApTAWEASoaSiFxDa5DiiKWUEeQQWCwjgmDAAtC9D3WacaEo/C1UK2Od6AI4JA0B9AOruOKIp5wfkUfAQHFeY1C2hEg11jYvbTDcG949wq4s3ZVVNcs44JY+q2tl9O3gytrDaVO3wVW//oHuld3vbDu5K9dX98MaUxhFWn2XZrL8BPD2ydNUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6872",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6324",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4028",
    Length: "548",
    "Loop Boundary": "No",
    Mark: "834",
    Material: "Copper",
    "Middle Elevation": "-6872",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "55302.8",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "18",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6872",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6324",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711766",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.72601996",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GnM5X7SoqCOpCJOhCvFg1dLC2sBWI+N9bH96d5/AcTj1CedbH4a6ggL0760pdvLStUUCgdNr6BxT1+ItB4ZxmKJYLjjRiCFMzW6u+l0NQQ7HR8qa86qFglBE4KNv67gMRYkSgcl567SwUERXIME9jnmKeZHmaEjjp619OGBLYKd12/suxSAhsjXrN65gygaFbO+PCmX0aMzVvq2+ckNEAAAA=",
    Pbi3DGeometry:
      "gywAAB+LCAAAAAAABADtWE1v1DAQ/S85pyt/bpz2hAAJCQ4VIHGoemjVVRtp2aBlQaqq/nfSxvEmdp7HWThwsBCI9cQz82bGnvG7eioub5uvjz82xXnxsb1tvrTb5q4oi8u22R1+FudXT/1/OzG76P4Uz+Vx5YwzdvH6T/e3eL4etr3Z728eu71CrEylyzNRrRg3uuRyxTXn5cu6VGoiYIaZWQEXVVXOaGK6UnFNyDRYr7lez1oOBMiCcynVQgCa190XY9C+wDftNnjggvVURQMG56u/IRD4CfJNQ02pGFxY607+KlBVH1elopZNreVUIOseHKuE1cT7dSPjG5aCpn3Vsp6tyjXjU0VDeVdM9Yri5Q3L2IFzAhcNxa2JAbWu5lEzJXqBsihE75PgIhqmiAlpeoFhVS9gmjiNqbYHZwWve4G14EAgZ5EFVDXoGvADztb1fF06AbqyYBHAnMJDh5xafstRKMgrBWbC3TVU6oLiSN5AaoKFCUyccNmAKwJmIrmS05MNdwRJRZUGaxOf+dQkBS3Hzx7uanAo0MqHp6M9B32vu1zNnm3UEPQQcSXXkyM8aPLrxgjDZwstGBagADSpEbg4iPRZCyaCAhFoSt3gBKihwoCnjkjHIWxtD7CUcnwVQF9R0USqEiQC+gSrRml7uKRR41OHBRDecuMw5ti4jRWrx60WZzu5PAZflbChreTk9vVD7jBATcDVxQbgBlPbEXC9noyMUBPcgeaI1CsFP0zI45iaUPCsOx5fCps/KDsLxtZeLTwML3U9FviaqHWk6NhNFwsCZ4FtqIlE5+5FpwkMNqa2LlVCnuYresoM3wMDeJ16+niG0aSFg+emHSVENHjBi5LaQGCLZAGNU+RLaTjUgwlyUE0ETYfVMwyrHg1+5FzrK1rsEfnKDC4N1BSH3q64Oe0c+iyHXzHIAFyn5hzfMOo/8AJ1/afi9Ry04AJI3kBhw1lAoOlhZloakRluIWgqrL5hGG7kETn6+IoWe0TGDraxYFZa2u4X88HpdO3pPC5yCuMmGOHkN0eEnEJM5F9zyP+O+sWMD+lT5njnBp3M8WaON3O8meM9KdmZ480cb+Z4M8cbH+0zxxtxNXO8U0HmeDPHOx+/zPFmjnd28Msc7+j7zPFmjnfWo/+L470ui3fNzffNYbMvztmKlcWnze7+8GB/fG4PN4em3dmf35o7J/qwae4fDvbH++3m9/jDt+227RTufm23z9d/AJGFZnyDLAAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "27",
    "Center to End Label": "27",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "29",
    "Fitting Outside Radius": "14",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "14",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1898",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "11",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711767",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.53438849",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaa1pPYkKgh6KCB5KDy2GNhCzUqNQSv/dYFsPInjb2TfMTNZBWupTe1OQwB5LnaJpK7RAIEVt3R2SrBtObxCCSiH5ciZCKsNYQk9+wQVlXM6/YSx4/A9OsflUv2qaovUb/GOji6tyqoGEUUbgoGzl6lEc0RVO+9mDPOvLB+2Urmr3FjIICGyNeo5eHlAWiYjAGg36XPswps9faN3y/BMBAAA=",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABACVVstqwzAQ/BedFSPb8jOn0hYK7SG0hR5CDgkRicC1iusWQvC/V40d149dSSUkRDve0Y5WO3h9JqudfD19CJKTR7WTL6qQe0LJSsmy/iT5+tz+1TBb6g9p6F9k4TO2vPzoL2k217SbqtqedG4QeGkS0UXAvZRnKfVDz+dRRn/jYRiOAcaDC8CjSUYYJtTAlDHOwYTMj2N4iwkTi4PYXBMmAivp3zsjcZRoJpolPAWPrwdcxfU1tUyJx/w0GjWiZRoAI6ZBfHwc84ROBbAFwoTGXUsaH/g8jpaKaptKuJ63M5OtJFzbtEH2VqMtRYfOcgmAPZzLdWs2MHVmIjTB3VIszQasBgOcr82ECQDQIbJ4BErl4Cr2DMtoz30IB5xdYkIFDIBxxACbNROhCYDLGg0eqAi1axQwMwEaLDYBTKqzf7g6zliGfk+4k9t3UYuK5MxjlDyJ8lAfu8Wzqre1VGW3fJP7HnoQ8nCsu8V9Ib6HD96qQmnC8qsoms0PzBFqiNkIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "63",
    Flow: "3.5 /",
    "Flow State": "Turbulent",
    Friction: "28323.34 /",
    "Friction Factor": "0.016855",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "661",
    "Loop Boundary": "No",
    Mark: "835",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "18722.4",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "175130.1832",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "8",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711770",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.52207187",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjUELgjAcxb/L/7zGNnVzdooKgjqIBB3Ew6qhg7WFrUDE795IpNt7j9+PV49QXs15eGoo4OivptK3oFxrNSAovXHhBUU9zjEijOFcZOsVE5gSAVOzUJu+V0NE47Az6qGD7qEgmCA4adeG7ldYkiKofFDBeAcFxZkgQvKEcSHTXHKO4GLuM0xJyhActGm78Jf3Vn8WO8FUshzB1lsfz9zb2qn5Ag/iOqfRAAAA",
    Pbi3DGeometry:
      "bwcAAB+LCAAAAAAABADtVcFqwzAM/Red3WA5TROnp7EWBtuhbIMdSg8pNa0hi0fmDUrJv8/Nkm1Nqzo9DkpIiJ6enyQk4fkOZkv9vH1TkMK9Weonk+sVMJgZXdh3SOe771/n5mP3QMV+kQFyPq4/7oVq0R67Kcts684KESRxxAYiDniCDMNA4EiwPRyJYY2jOIAbNoYh9sJlKy+Hp/jdqK1MFMo9jlIkNS4cr3bw+ABvZUYc++BSoDyncxSXSNNXVc90KB0qTW/6VFeIsrp8Ut9T71Fcz/BQ6XRxQoYaBt+QnJ41slkdOqV+vtZ/uVa+Oeu9Vhd25LpW17Wik3S310Rnr8qqElIecAYPqljbTWM8GptZbYrGfNGrH9ed0uuNbYxprj7/Em9Nbpxg8ZHn1eILwK/noW8HAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "221",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "29",
    "Fitting Outside Diameter 2": "16",
    "Fitting Outside Radius 1": "14",
    "Fitting Outside Radius 2": "8",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "14",
    "Insulation Radius 2": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "7",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1901",
    "Max Fitting Outside Diameter 12": "29",
    "Maximum Size": "25",
    "Minimum Size": "15",
    "Nominal Diameter 1": "25",
    "Nominal Diameter 2": "15",
    "Nominal Radius 1": "13",
    "Nominal Radius 2": "8",
    OffsetHeight: "12.5",
    OffsetWidth: "12.5",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "17595.5",
    Size: "25 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size 1": "11",
    "Tick Size 2": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "711771",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.09094852",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjUELgjAcxb/L/7zGnG5zdooKgjqIBB3Ew6qhg7WFrUDE794whG7v9/g9Xj1CeTXn4amhgKO/mkrfgnKt1YCg9MaFFxT1+ItRoRTngq1XVOCECJiaxdr0vRqiGoudUQ8ddA8FwQTBSbs2dDPkaYag8kEF4x0UCWaCCMlTyoXMcsk5gou5/8sHbdouzCyoRLC3+rOsGSZJyhBsvfXxzL2tnZovhZ/IQNEAAAA=",
    Pbi3DGeometry:
      "fhcAAB+LCAAAAAAABADtVl1rwjAU/S95riVJ2yTVp7ENBtuDbIM9iA+KRQtdO1w3EPG/r9rY2drTtDD2FESxN71f554kZ7Yn02X8uvuIyJg8Zsv4JUviFXHINIvT/JOMZ/vyb7FMJ8WHHJxfy4hROjn9FF9ymJ/dbrbbxa7w5dxVvgqdEZcuo9JhgUuZFzhHu1KlmYeiZhe81R5SNigMSqvDU+UHbXGadpR2YHgQJuQsrJcvPb99wZdefUFHUsLvZzcF8vy6vWqh6VAtXNUKUsNIph50SXBmkvl6gZcLnpBdw1RKniN5J3ugRHcg6alaRYEQepyBdgj80kGJHizt3QFMACMhjCBRdeYK66CrYYwQiIOQPrZz+brUgPYm15mmcAKIdcbURvqeS4KzwXxsR6NjysABbikq68TjiveDqe/271+ShqmDMoCqAykJ5jkY7A7sWs9s8LoKi/z6pGUX9aMjAXRruFiurkV0g1QwMI+x1oE1bwTj3i8iiVZaN1MgKDoigVscOgD0AEpwNhAL2BpkI3JANMWtgR4QRsZzDWqL+oFn3FBmJjW3/lVvCD0wTsQjAAXaarAcGH8gsY2n6RW/4GEBziIkjf5IXZtk8X/La0P5Vl5beW3ltZXXVl5beW3ltZXXVl5bef3X8nrukLt48R7l0ZaMqUsd8hSl63yjH56zfJHHWaof3+JVtfQQxetNrh/uk+j78sXbLMmKgOlXkhzmP45Si2x+FwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1902",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711773",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.68842077",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNjFELgjAUhf/LfV5jc4phT2FBUA8iQQ/iw6yLXlhb2ApE/O8NM+jtnPN9nGqEoqHz8EDI4OgaKvHqtW0NAoPCkfVPyKrxG4MSKS4SGW9WUcqlSGGqf9q27/UQ3DDsSN/RYw+Z4ILBCW3ru7msVcygdF57cnbBF7r90wNS2/m5J5FksDf4XnSZcKFixSB3xoV3+zJmqj/o5XW6wwAAAA==",
    Pbi3DGeometry:
      "zxcAAB+LCAAAAAAABADtVlFrwjAQ/i957krSpEmrT2MbDLYH2QZ7EB8Uixa6drhuIOJ/X7Cp09avaWH4FESxd7273Jfvkm+6I5NF+rb9TMiIPBWL9LXI0iXxyKRI8/KLjKa76q9207H+kL33Z7lhlI4PP/pL9rM67HazmW91bMB9SkXo3QTKZ5wzj4U+lVR4pw4ai4Odq+jMzoKLZhoNTIPqmvxREF/M07KDuoPzN/JIISq7pOysAR4Bh1INR50KOmCqIOwbUbfRWm7t6F/cGgFXBaANdDcHM6OycojuPRWxrO2RCRDdmYSqIpjOcb7WWJltpaGpMYiu1h6sBQBfAf1adA0kM++bwrUDtwyXClMhvKUyzcVSdk/FESfEDYQTZjKqDXmJFwVqYzpBAoJMMAC2x2JeOZSu2Qeo4WcB3lYIlG1Sm5M9mJxwVwdDDgFEo40RN5Wj0FxREe9MBLvue+fUxzu8W1pgcMm7b4r+pwEPLTUQHDATuuJhgB3Ac5zQijAaqDcIE4yAhLXCgQRSA6X+Z6xVYPQfrmN3qAamDSQa2lTreAFl2Bo7TKfLBYYzvPcRa2MmPmus2umfdLhFPl9bhltW71S4U+FOhTsV7lS4U+FOhTsV7lS4U+FXVuEzj9yn84+kTDZkRH3qkeckX5Vr8/BSlPMyLXLz+J4uj67HJF2tS/PwkCU/py/eFVmhE+bfWbaf/QJZ696mzxcAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1904",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711783",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.97073981",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACNjs0KwjAQhN9lzzGksbE/nkQFQQ9FBA+lh5aGNhCzUqNQSt/d0FZFT9529htmJu0gKdSpvUqIYY+FSlC3FRogkKAy9gZx2o2nM3BOQx56yxkPqGCBgJ58QeHz6A8oosUv/MQOMHvVr5omb90G99io/CKtbCBmlBE4SFPZehJHtLlVbvYoz6p8o51UVW0H4XsBga2Wj8nrCcrmkSCwRo0u19y17rMneZSwjBMBAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVtFqgzAU/Zc8W4kxqbZ9KttgsD2UbbCH0gdLpQ04M5wblOK/LzidVXvwBlGMx3POvTfJ1e2Fbfb67fyZsiV7Mnv9ajJ9YB7bGJ2XX2y5vfzdWpiv7MEqr3syCzhf1Rd7smrX0tZFkZwtVwg/FnHgzUTkKxmHXqB8LtXc6wFBHANARDUw55IKNFKRCvqAkvI2IwxVDYQLRYwK5gE9YFStFB2AUm0ecSCI4cIiDvJQUixuMq6Afq06YGDeAdijnyDBHHrAqAZzPpYam6OoYB6D+SBIQXP3+cAlcd44VIbDKqFXFy5qanUJ+4PKgBMFdy2BAT2o5nCVELYzjApKTWY+1RMJS9Rdyt0DNv3JzjCKCkpRGYSo8AfSucNBBgaIH2Eo5dBLLMP+Q9zr5CMt04Ituc899pzmx/LUDF5MmZTa5M3wXR/+ocdUH09lM3jI0p/rF+9MZqxg/p1l1e4X6zwUZvUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6316",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4585",
    Length: "87",
    "Loop Boundary": "No",
    Mark: "836",
    Material: "Copper",
    "Middle Elevation": "-6310",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "8776.6",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "22",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6310",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6303",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711791",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.01322797",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAC1jksKwjAQhu8y6xjahBitq6KCoIsggovSRYuhHYgZqVEopXc30OoN3P0v5ptiAFPjpX9YyOBINRpyfUMeGBhCH56QFcMk40AIvtJqsxCaKykVjOwPXflF511X9ZEfgx1WdxtsB1nCEwYn65vQzuZMoQoYX57sFW+/6mCxaSMk5XqtJYO9s+95m0ou0qVgsCVH8a5/OTeWH9C3vKEPAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiWJpqb2aWyDwfZQtsEeSh8slTbgzHDZoBT/+7JpO3WeuSGimHze993lchfXJ7La6ufjW0YScm+2+snkekcoWRld2HeSrE/1q4PZ0l2kor8zM87Y8ufhblJtzmZXZZkena0QgVKLmM5EHMhIhZSHgeBzQb+BORMegCuFs5ARr4EwlDgq0KtY1vMyinDaF6a+xEKqYadAbZAKDOPsLRcxTsK/IOPaMmDchfN3RVpAV3zIok/VzR9GAwQ6+cM4BQLd/A1Z9MPoZAMTN8gEAn6qfhjI2gA1MBaghj+x2DWEdjqOaEotQR6BFQMCOCYMAO5Nf9MZp5rU2PwVA3a8PoCkwgBQR4A6PY5oylkCeeQ/EUcVJvVNsFL9/eP/HacVhvtnuNHpa2azkiQsYJQ8ZMXeHprBo7Gp1aZohi96d4HuMr0/2GZwm2ef7Q+vTW4cYfGR59XmC8+Cek3lCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "-6872",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "-6324",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "1.5",
    Flow: "0.9 /",
    "Flow State": "Turbulent",
    Friction: "100952.57 /",
    "Friction Factor": "0.019164",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "4028",
    Length: "548",
    "Loop Boundary": "No",
    Mark: "837",
    Material: "Copper",
    "Middle Elevation": "-6872",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "55302.8",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "100715.2126",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "22",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6872",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "-6324",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "10.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711792",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.00921396",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73GdG6v2lVUENSFSNCFeGE1dLC2sBWI+N9bH96d5/AcTjVCcdbH4a4gh70761JdfGNbo4BA4bT1D8ir8ReDEsc0RbFcxEgF5wKmetZWfd8MwQ3FRjc35VUPOaOMwEHZ1ncfiBAjAqXzjdfOQh5RgQwzyWOJWZJmUhI46etfThgS2Cnddv7LXCQEtka95jWnTGDo1s64cGafxkz1G7yDe9/SAAAA",
    Pbi3DGeometry:
      "WywAAB+LCAAAAAAABADtWEtr3DAQ/i8+O4skS7aUnEpbKLSH0BZ6CDkkZEkM23VJt4UQ8t9rqseuZX8e2emtIiTEM9a8RzP+rp6Ly9v269OPbXFefOxu2y/drr0ryuKya/eHn8X51bP9t2ezi/6neCmPlDPO2MXfP/1v8XLtj715fLx56s8KsdGNKs9Es6mF4CWvNlxxXvZ0w1U9YDDN9CSDi6YpJyQx1chZSUg1pFdSTmuOGUiDNylZw8hpKdWp5pgeK/avR55F5EQpwXpvZfx6RI8TExuDxCTZHoxR2li6qWwspZzVqnr2Kb0yVo4Ujm6MY+hq9sBCb0k7dd1M+as0k0NBLlmqYU4QUc6wbL1ngRFioaytqpbGMlQz6TOTwtKVpSteu2BwMRskrKEWlqGMtgymiOZL1e2NFZrbA1UVeQGMhRpgzaC+jyPOajNZlYGOcgqLAOYUdRs0afGlRvhA3CIoC0EtmbZRZaSfIEXBsoQ6lt8z6IKAiUgt5PRcowNxSmGVwbqEDZ+cpNGYibOHxhheAEwdeafmCha8bVQ1HVQwCIyPtWkGEfJyooIxgpvJAI12AkSfHkxHtwj7k/cpGH/Sg5Gk5BOhWtAURdFO24SOe1alrUGsqU77H1oKqmWmFkEaYDpRvTDpGor53rSdhhnQuYWqUbBnNEu35Cg2mKwwzwsqw6eONe7qrpvhhRtHPEQQioLmLteBT3AXq0YOpgCSBA+gD6vU+wR+e1C9uCCr4NPt2L3zvsW7cVCglC1AI4YuKO7GkmOMBBF0LMgPpRWMoa3QJCSIdC7ciUESWmb8nlvrapWp6NPFv4/kQzrxqTNSDJcrmIWw4Rg9WQGjgZJ8gHIOZwF5TX4bhZb2OujtNNVtOrKxbhhyaBS5Co5ErbCKjGF8dYDhGAa80XpdO8bARlw4QAGmE6tOpBeOIHSLhhHUl3LaPZB8gHBtJglg4yBXmrgwZha5hV4nxDXWjcYWHNXkDI8lrbCJjCAaaOO1aeHYX4H9JkOzqzFbvLlDFQT6m/jtgWGpaforseJ/hPJCmIeyJuO5Gc9N053x3Mn+yXhuxnMznssznpvx3IznZjw347kZz814bsZzM567MLIZz814bsZz/08897os3rU337eH7WNxzjasLD5t9/eHB/fwuTvcHNpu7x6/tXeB9WHb3j8c3MP73fb36Ytvu13XC9z/2u1erv8AgNJK3VssAAA=",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "27",
    "Center to End Label": "27",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "29",
    "Fitting Outside Radius": "14",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "14",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1905",
    "Maximum Size": "25",
    "Minimum Size": "25",
    "Nominal Diameter": "25",
    "Nominal Radius": "13",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-25 mmø-25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "25 mmø-25 mmø-25 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "11",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711793",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.35135904",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE06Y9tPYkKgh6KCB5KDy2GdiFmpUahlL67wVYPInjb2W+YmbyHrMJjd1WQwo4qzEh3NRlgkBEae4M078fTGaTksYzFYibnXCRhBAP7DYMg/GaJFMlfNoYW7/Jl25adW+AeaywvyqoWUo97DPbK1LaZxIFsadGNHuUJzx+0VVg39iVi32ew0eoxeYXPvUhGDFakyeWau9ZD8QRK+8MOEQEAAA==",
    Pbi3DGeometry:
      "rwgAAB+LCAAAAAAABACVVVFrgzAQ/i95TiVq1GqfyjYYbA9lG+yh9KGloQ04M1w2KMX/vqxTt148E5FKc5f77rtcvnN9JqudfDm9C1KQB7WTz6qUe0LJSslKf5Biff79a9xsYR7S0D/LLGRscXmZH2k2XdiyrrcnExtFwTxL6CzKgjBPUhrGQciTnP7Y4zi+djAeXRw8ARFxnNERpJxxPhiQh2k6nAIgsTRKxzlhRWCUJmdG7CiQVTTL+Hzw+HqHb3E9pw6J8+SqDx1QZwc4nRmeBdjeVwDhh2Ewsx8ZeM7AjHHESgLUuyP2hHGQQUsC/bAa69hv9c+6CE5JQiRUqi4NI83F9AW3O/P63SnXFfSWO4KDTyYswFvu/hFYCihHT5lad91K7MuoR8JGGT7jxvWEDVcoemdeKLRp+PgkRh0OIMhn6kDw1bf7kzFUgfn638rtm9CiJgULGCWPojroY7t4Unqrpara5avc9657IQ9H3S7uSvH1f+ONKpUBrD7Lstl8A9utjGevCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "181",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "25",
    "End Middle Elevation": "194",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fixture Units": "61.5",
    Flow: "3.4 /",
    "Flow State": "Turbulent",
    Friction: "27760.27 /",
    "Friction Factor": "0.016885",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "23",
    "Insulation Thickness": "0",
    "Invert Elevation": "3983",
    Length: "76",
    "Loop Boundary": "No",
    Mark: "838",
    Material: "Copper",
    "Middle Elevation": "194",
    "Outside Diameter": "25",
    "Overall Size": "25 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2110.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000113",
    "Reynolds Number": "173226.5942",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "7",
    Size: "25 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "194",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Top Elevation": "207",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "8.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "711796",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.20969893",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjUELgjAcxb/L/7zG3JzTdYoKgjqIBB3Ew6qhg7WFrUDE795IpNt7j9+PV49QXs15eGqQcPRXU+lbUK61GhCU3rjwAlmPc4wIpTgXfL2iAnPGOEzNgm36Xg2RjcPOqIcOugdJMEFw0q4N3a9QliKofFDBeAcywVwQUWSMZqJI8yLLEFzMfYYTklIEB23aLvzlvdWfxWY4KWiOYOutj2fube3UfAEYDt3o0gAAAA==",
    Pbi3DGeometry:
      "owcAAB+LCAAAAAAABADtVVFLwzAQ/i95zkqSNm3aPckUBH0YKvgw9tCxsAWyRmoUxuh/N7XtnNEz3aMwSkvvu9x3d9x9ZHFA85V62r9IVKA7s1KPRqs1wmhuVGVfUbE4dL/OTabuQQ3+QiaUkOnnx72oWQ5hV3Vd7l0sY5HIOJ6wLOI8TzGNI0ZThls8HxyM8G+OASfZOJyzpHMk6e8BfuYeT0SatTjNmWjxnNG8C4hjfuo4EgmSjMKZoH8S+ZnBSoOtja0IJAJLDfUAjQfszT8PJgg27TOFNgkq6QcOEYGbEV4ZYPfAwXnn4QRB+fxjvQV3b6zgzp/PRXEXxZ2hOHfjXatyJ62sUUEigtG9rDZ22xsPxpZWmao3n9X66LqVarO1vXGj5fvpwZnRxhFWb1o3yw9JKOawowcAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "221",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "29",
    "Fitting Outside Diameter 2": "16",
    "Fitting Outside Radius 1": "14",
    "Fitting Outside Radius 2": "8",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "14",
    "Insulation Radius 2": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "7",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1908",
    "Max Fitting Outside Diameter 12": "29",
    "Maximum Size": "25",
    "Minimum Size": "15",
    "Nominal Diameter 1": "25",
    "Nominal Diameter 2": "15",
    "Nominal Radius 1": "13",
    "Nominal Radius 2": "8",
    OffsetHeight: "12.5",
    OffsetWidth: "12.5",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "25 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "17595.5",
    Size: "25 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size 1": "11",
    "Tick Size 2": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "711797",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.05637809",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjdEKgjAYhd/lv15DN7c5u4oKgroQCboQL6x+dLC2sBWI+O6JIXR3vsN3OOUA+dWc+ydCBkd/NQXeQu0ai0Ag98aFF2Tl8IuTwhhNlVivmKKCcwFjtWibrqv7yZ2KnakfGLCDLKIRgRO6JrQzpDwhUPhQB+MdZDEVKlJaciaVTlItJYGLuf/LBzRNG2ZWTBPYW/wsa0GjmAsCW2/9dObe1o7VF5JzLw/SAAAA",
    Pbi3DGeometry:
      "txcAAB+LCAAAAAAABADtVktrwkAQ/i97TsNmk32op9IWCu1B2kIP4kExaCBNik0LIv73BpO1Zs2XTaB4WsRHZpzXN9/OzmxPpsvkbfcZkzF5ypfJa54mK+KRaZ5kxRcZz/bVz1JNJ+WLHLw/yU1A6eT4Ub7JYa7Nbrfbxa60Zcwf0cC7YdLnYci9gPs0KL9LuRKskgdBQ6xUqzhSoyFuYFTtnoug1Y0pR3EHB4AFMBU0KpBh1CqPZNiUa0dKRD0VNk9hZCh0ERcWWnGRLIwNXVnL0FkhZKXitUJVilDIzp4KJmuFFEcFV6Lbk9SudE5ciLqr2oKzykKJfnztXQUMgTwBnDoYKwzAeXfRMFXkCQIuIsNA1iH6E02zA8IEGWgPbiWzzgoG7+AmgKSj3cACFhgx1ayDKdYTq94ToX9WGqsO9iA+D+QnbOxw0DsgBOcbWpQCPYWj8zKgJ1C39eYxbk50v5zAoCPe3jnjurDPAzpq57gZAUGBHbVWhv6OCAMAQtkgHGBZmJDIAjIVl9ZaAgDIPuHQzmFOPvuRsrHo4vgblUHwUDdR2wAW8JihhLD/gay2D1WDYHBSoNGCIvzT7m3bma+8etuyd5u327zd5u02b7d5u83bbd5u83abt9u8r7l5zz1ynyw+4iLekjH1qUee42xdbOqHl7xYFEme1Y/vyeqkeoyT9aaoHx7S+Of8j3d5mpcOs+80Pcx/ARwer3S3FwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "14",
    "Center to End": "14",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-6310",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1909",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "44265.8",
    Size: "15 mmø-15 mmø",
    "System Classification": "Domestic Cold Water",
    "System Name": "Domestic Cold Water 1",
    "System Type": "Domestic Cold Water 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "711816",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.42639839",
    Cost: "0",
    Level: "Level 3",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNoXrapK1FB0EUpgovSRaqhDcREahRK6b8brOJuZjiHqUYoGnMa7hpyOPjGlPoSlGutBgSFNy48IK/GOUaEMswJZasFTXAmuYSp/nHrvldDhOOwNeqmg+4hT3CC4KhdG7pPyYREUPqggvEOcoJFmqSSC8k5SQnnSwRnc51hJjhFsNem7cJf3ln9+tqU4oylcdt46+OZe1o71W9RAUWX0wAAAA==",
    Pbi3DGeometry:
      "3w8AAB+LCAAAAAAABADtV01rwkAQ/S97jmF39ltPpS0U2oO0hR7Eg2LQQGqKTQsi/vcuZm0T8ZUIPZUgfmye82Ym7zmDkx0bz/Pn7VvGhuy+nOdPZZEvWMLGZb6u3tlwsqs/BpiPwoPtk58rA8H56PASnmw/PYZdbTazbYglmWqnKBkQT51XPiFKnbThXabSKhEAkXJDugkozfUhwpKVTYAUV2epYATMQY5Ei8qTdAcqQbKOIC2agFakz0ZAIFKFqoyyTQAml0pHKiFEqw+pY+dKmFaElb4GuGyVS77O7XS3WwhrAkS4ItQDvB1YPe9igKdOcuMU1sZqKXB2AbQ4AqdtoOTQ6JDqckvhqlAfyAfQglBXIAZ0IBQDMkH3wxTW111462zrdjhfa+GVoxOv2RpwplWUlqHdAyCN6yYrFAlR4apgH2ga4eFJxsQIbrqNW5hD2Viu6XKZHy+f9IBnMJpFkAoPKWhnWNX5LrAN4JSHoiIloAehEpgKGgf6/J+sYzhdLl/Hv/wA+nXcr+N+HffruF/H/Tr+83Uc/i3f5LPXrMo2bMhTnrCHbL2sVvHwWFazKi/X8fiSL76huyxfrqp4uC2yz+YXr8uiDITrj6LYT78Abo+uMN8PAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-313",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "79",
    "Fitting Outside Diameter 2": "105",
    "Fitting Outside Radius 1": "40",
    "Fitting Outside Radius 2": "52",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "40",
    "Insulation Radius 2": "52",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "26",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1914",
    "Max Fitting Outside Diameter 12": "105",
    "Maximum Size": "100",
    "Minimum Size": "80",
    "Nominal Diameter 1": "80",
    "Nominal Diameter 2": "100",
    "Nominal Radius 1": "40",
    "Nominal Radius 2": "50",
    OffsetHeight: "40",
    OffsetWidth: "40",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-80 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-80 mmø",
    "System Classification": "Sanitary",
    "System Name": "Sanitary 1",
    "System Type": "Sanitary 1",
    "Tick Size 1": "32",
    "Tick Size 2": "42",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "No",
    "Visibility 3": "Yes",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "712254",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.11420132",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjc0KwjAQhN9lzzEkTZs09SQqCHooRfBQeoga2kBMpEahlL678Q+8zex8s1OPUB7NfrhqKGDrj6bSp6BcazUgKL1x4QZFPX5kRCgjmBMh5jPKMOE8han5gYu+V0Ok42Fl1EUH3UNBMEGw064N3ctQmnIElQ8qGO+goDgTREjOEi5kmkse04M5/8MbbdouvD/ljCFYW/34tiVOSIZg6a2PU+5u7dQ8AQn1L/3SAAAA",
    Pbi3DGeometry:
      "ux0AAB+LCAAAAAAABADtV0tr3DAQ/i86O4se1sObU2kLhfYQ2kIPYQ8bYhKDuy5btxDC/vcaW6vEsr+MkksvYskSaVYz833zkOb6kV3dNN8fftVsyz53N823rm1uWcGuuubQ/2bb68fp30HML4cPOxVPOxeC88vxa/hjp9352Lvjcf8wnBWKbwy3trgQaiOkq4pqI7kuxn1l5WxfDOtVgTWCOFFW5UxQGkOoip1yTo0CbR2wAWAsDpxNpGs6204XIAqD7QH/Gh/QJ4yi1JOAG1M+hx32K+1mmuIDgdkgUAaY8AKoCtleakJOCe5mfNA+IdMQnSztiyaW6CjbSxuQ84gQnObOVwx3k7sw/4NXuqomgSjFDGBqrsHCCALoVHLAaW/JRI9TBGp6vVM0vjji8QnUdGAmBAHQlNzWYKcIApQHkECSWVitVM85g0D0JRcSjRqBMGLilWs77itwuT3dCpXzGEo5ChaotTCjQIB0Qj0qmY3IAHTJKO01WTOLUPpFDC/7IJAyEhBOYZ5QB34DvvWg6oorv89B849vBfpEfF2gE8gniBoyjjIWkYFaB2o1IKLYU+AQzADY41CcUY7hNEZcwIdmhMEI4jW0cNYuMoO6JJbXiq8IJ0FtOakI49AGEuDHLDQOqHphHoCZSXII31wxVXiCADYgvvQnYvAKdgnMOok8GSAKBwQO4wfClN4EyWqCzTEPn3n4TCv8PHwm2sjDZx4+1+s4D58Jz+A8fObh82348vCZh89VLvLwmYfPPHyC+P2X4XNXsA/N/mfd10e25RtesC/14a6/94uvXb/vm+7glz+a2yD6VDd3971ffGzrv89/+L5ru0Hh4U/bnnb/AJW/Som7HQAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1917",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "712285",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "21.47589687",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjc0KwjAQhN9lzzEkMU1NPIkKgh5KETyUHqKGNhATqVEope9u/APntDP77U41QHG0+/5qQME2HG1pTlH7xhlAUATr4w1UNXzGhFBCcSZJNp9QjlkSjPUPXHSd7hOdgpXVFxNNB4pggmBnfBPbl6GUCwRliDra4EGlbznJpZgykUs+kyJtD/b8D2+Mbdr49oQzBGtnHt9riRnJECyDC6nK350b6ycArV0/0gAAAA==",
    Pbi3DGeometry:
      "ux0AAB+LCAAAAAAABADtV01v2zAM/S86u4G+LFvpqVgLDNgOxTZghyKHFDVaA148ZG6Bosh/n+LITiP7Scp26UEtmsaiycdHUqJ490Zu7+sfr78rsiRf2vv6e9vUDyQjt2296f6Q5d3b4asR00vzS3bZceWCUXrZf5g/slsNalfb7frV6DLKFrksy+yCyQU3P5leCKpZ1gsUO6znTL1fV0zrWQFSyDXNDwIlyihLSnDm9YlpXpysIxIjxEQDWILQ2KcgNgwIK82XGKcgiwGb5Xov4FKpU0t2vVAOC1fhCGEFrOCzlsZ1BD2xNGAjn47hsIKyFAGfIDaiN8Ewjz52EBojoIijcERUGhV6r6GkDpTByK6Qcq+hzT9vpUFTWBD2KpY5dDeCoFMiEabOz4dLEKZ83PmOBjym0A6AhkKHc+yxho+ccOlAgZuLELvz4xd7ggRZuxyK3CIL1gtEccph2tuGHsal6DlIe4Dk8rScBHNTh3IaHw6IAb0aW67Uvam88LdizBusG2dtANX/Bgo1mLPJwaSOClSWB2h/U0DvI0/R+6EqQ712Eu0wMycU8Nzw1BhKKPAVk0N5w9sd1wxwCtYxCAi+atKczdLANwAOvMV3K9hZuBPcYU8YAZ8lHgaH3QsL3PsHBA/GCl/9nXRAGjjqKFQwsxAD8UPnAb6Hgo3vSTj26Vx6MBkQA2mEu4VDDyYpjOCckGn4jIJOw2caPr0IafhMw2caPn3s0vD5j+FIw2cUuTR8puEzDZ9p+EzD5zzGhxo+Vxm5rte/qq7akiVd0Ix8rTaP3ZN9+NZ2665uN/bxZ/0wij5X9eNTZx9umurl/Yuf2qY1BjfPTbNb/QVEQrnRux0AAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1923",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "712287",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.45009609",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jMEKwjAQRP9lzzEk1VZTT6KCoIdSBA+lh7QubSAmUlehlP67UettZt5jigGyypz7O0IKR1+ZHGvSrrEIDDJvHD0gLYZfDIoUksdKxOuZnHORJAsYy7+46TrdBzsMO6NvSNhBKrhgcELXUPspMk4iBrknTca7CV/MdaJSrRgc0DQtfdkyUgz2Fl+TrngkRTjYeuvDuXtaO5Zv9/H89MQAAAA=",
    Pbi3DGeometry:
      "vRwAAB+LCAAAAAAABADtV11PwjAU/S99nqQdW7fBk1ETE30gauID4QHCIksmMzhNjOG/W9gY0nJyWyX60hA+tsO9t/dwe8oZf7LRrHj4eMnZgN1Us+K+Kos5C9ioKpb1KxuMP5uPCuZD9WDrYH/nTHA+3L6oJ1tPdmHnq9X0Q8UKLnqxCKPgTPR7godpkPXCSMrgAOBRKjaAiIUGpJE8DrQRSRpapoLF8ara4rCGCYRZ5tiglkrKVB7tfA9oqTpA74MGYCq8Kmq5BkAWhzXMVWns4hpCZk1E1gCJSBogbAH7CLoPNCXGXMU/njcdQJkSLtoA2XSh3rZAxuMGkDLaAGlf5xb9fsas06ngD6vvDrhceqPpjDh3foLNTFJiwRWsoQMwFTm5Bld6KjVGlhvN2JqCZwe0C5XRsgZURKrzXSosrnQEbNBawOkazgJuRCB2cQTWN5QKRpAHEaljHVcyOphQBTiewDTrqASluQaAEiVhvwmIoviADp4mR4GudHvfOAa0+ziRXroTVj1ir4a2EbALOqIbHMv+4KLcTzMYgCpAPpB4wtqYKMQH3GH42IDFT/i/BvaBKXEdQ0wJPVS/1y/rUadkCh9ySBPIrU9NQndawtKueucqa5AMa5VysGzI5J3SL6KD/U/cn62L9e7Puz/v/rz78+7Puz/v/rz7+9Hfbu/+vPvz7s+7v/92f5OAXRbT57zOV2zAezxgt/nyqV60F3dVPa2LatlePhbzDrrOi6dF3V5clfn79y9eVGWlEi7fynI9+QKbbdWpvRwAAA==",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "24",
    "Center to End Label": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1925",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "712288",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.25974238",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABACNjssKwjAQRf9l1jEksdWmrkQFQRdFBBeli5aGdiAmUqNQSv/dYOtr527unMvlpB0kBR7bi4IYdrbAxOq2sgYIJBaNu0KcdsPpC3NBI8blYsKnlDMRQU8+kDNOQy6CPygTUv7Q7+EBZi+BZdPkrbfwjzXmZ+VUAzGjjMBemcrVYzhYlzv04kM8YflGW4VV7Z5hJkICG63uY1dSwcOAwMpq62fNTes+ewDdtvZLFAEAAA==",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACdVk1rg0AQ/S973siurp85lbZQaA+hLfQQckjIkixYt1hbCMH/3rW1raIPxyCKOx9v3jgzu67PbLUzz6c3zTJ2b3fmyeZmzzhbWVNU7yxbn39enVos3cVq/i9ZSCGW3w93s3rz63ZVltuT8419LxEy5QsZeCKNI556vooi3pNHkWrkMlR9eZKEjdxXISfhtPZREo/ix3HalwehnMUHxZ3Iixx3gs8AR6lgNN9WPvhuKK9OXCmkF0pfDQrQV3SQ+orOpxj1aHIYjdEkQYSaijFkBROECkgXBu8Ugwh1MathgqjikC0aFVgN5DC/SjAEanNK65DmhWBPYzQxeDN6AHpABWHzgEik3YZgT2OEmrIjJ/Y99IAKtNXNniAERLCnMUKH3Py9F3pABeFAg0hzTmRn7/4Mbsz2VVe6ZJnwBGcPujhUx3bxaKttZWzRLl/M/k91p83hWLWL21x/dg2vbW4dYPGR5/XmC4kaH9nLCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "1.5 /",
    "Flow State": "Turbulent",
    Friction: "31949.81 /",
    "Friction Factor": "0.0191",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "2810",
    Length: "8751",
    Mark: "840",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "279591.6",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "91400.34264",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "36",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "7.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "712436",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.91129228",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkadJiPYkKgh6KCB5KDy2GdiEmUqNQSv/dYKsXBW87+4aZyXvIKjx2Vw0p7FyFmTNd7SwQyBxaf4M078czGDjjVCm5mHFJRTJXMJDfMBJcfsFYJP/hGFu865dtW3ZhQ3issbxor1tIGWUE9trWvpnEwfnSY5g9yhOeP2irsW78S8RCEdgY/Zi8nNEolhGBlTMu5Nq7MUPxBMxKtdgTAQAA",
    Pbi3DGeometry:
      "SQkAAB+LCAAAAAAABACdVl1rwjAU/S95jiXpR2rrk2yDwfYg22AP4kPFoIGuGV03EOl/X9F+2F5v0opUTE/v6bm59564PpHVVn0cvyWJyYveqnedqh2hZKVVVvyQeH26/Kxgtqg+pKTdnRlnbHH+qi5SbpqwZZ4nxyqWM+4EEQvojPuOG0YB5czxXTGnZySI3B7iRYG4IGLu92N4GFIzm+CuuB0jXB4i7xmyecL3bNrwfHBt9yhAEZwN7IEXesHtHe2Q8Zl22ho2z+V+vz4NW4NAtjYG7A6IafOB70HZDMh4bbAKAMFVGzId5tNWYQLbCG2GTIeVg31gj4HVhr1jn23Ihk+93Q/wPsDnFMbYFUzoxBHdO8VDUDaD89k9Ec4c7i72OcUVQNXjpx5OCa4N90TIhrqlwUft04g7OfQQuwI4p7gCfLbvOGUMbPhZYj9loLvYPQR3JFzBterqf8mjSr5kIXMSM4dR8iqzfXGoF2+6SAqls3r5qXYt9CzV/lDUi6dU/l0/+KBTXRFmv2labv4B3vZqGEkJAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3065",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "9134.90 /",
    "Friction Factor": "0.021844",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "3160",
    Length: "13",
    Mark: "841",
    Material: "Copper",
    "Middle Elevation": "3074",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "116.8",
    "Reference Level": "Level 1",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "45700.17132",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "35",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3074",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3084",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.7 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "812876",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.91237131",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjcsKwjAURP/lrkPoMy9XooKgi1IEF6WLVC9tICZSo1BK/92KFXczwzlMNULRmNNwR1Bw8I0p8RK0ay0CgcIbFx6gqvEbZ4TllIs0WcWJpFHGE5jqH7fuez3M8Dxsjb5hwB5URCMCR3Rt6D4llyknUPqgg/EOVExzHnHJ0oRxmQnJGIGzuS5wzlMCezRtF/7yzuJrsTkVgsUENt76+cs9rZ3qN/1MWG3SAAAA",
    Pbi3DGeometry:
      "PjgAAB+LCAAAAAAABADtWcuKXDcQ/Ze77lz0foxXIQkE4oVxAlmYWYxxYzd0psOkYzBm/t26V5puXUlHUnuTRYSxcZ+uKVWdeqg09e7r9Ob94Y8vf++nu+m30/vD76fj4cO0m96cDo/nf6a7d1/9f93X5JX7Mz3vrsgPlJBX6z/u7/R8//JjPz49PXxxP6vkLJnZUWZnIjTb6dkYRXcOtpQsuJkNUzGupFQV3M5MmR4933csUp/gaibciFv0l/Wk7ppZaGtzPVd841YTRlq23mbyGd6QR9Z3yqdsRm4pyVaccs0XnPjYamkD7IBI3FJ/LJVax+YT5tUztqrhipsVZ1x7nPIOb7XhrMiOZS/eCutwd4io6UHySP8F54sfZqaGr94aqoK3dEkpa6g/lgfSmJQLO4TLnJyoUITyaohl66nUKo+HkGhhYo6lDdwTJmOnyqeiuoLWbNTHuAgZbu3qrDO7SsKN3KMUQSklDQ+4Yau8YaKSsSCEKOKofiAL5WaXwJZpU6sqEFlUbbDItVCl0DZaYIZ3cdZWAxLzxqK6NV+Rs+BYyKV1Wlf17gvYMKNjAfcoXVEHRNWwJMx6rLJrNTBTvZXKLaSLgwJlaQtB+QrSG/Q5QAEscNQQQAmiikV9DjDZSbyzsta7UasH2vsquZWtvVncym48JgQ7zWy50h1DWsgQJy99Y1QyiomZfagu0r7/OVgJnuelmbVlWXtCI1dj0EODZFY8yalbBjq0FxnD8j2+Zpd7pj3UlMMpo2tz5aoWDyAeKtYduzTnqNP7ruVwpddOTxjbpv0COD1CiU2VLGWQ9ZUsDQAMbEdn+n6waJG+BMP94u8dhwvu282mT/hT4+4ExDfMZ1NbqgYFMExJC+6oMUu/UHkSo4C3zQx3stPD7Yrz+tsPmQMCjuSRu+XshlkMIg7aRJev2RsmoxLUfatLpF0IMYZKCkUEyMMKB1wCcsrOQsou1xcTi3LLde1XALDsQWX2vbhfbl4gjZSD8gaW9zl6mfOBo6g1Ae19tyu6jTvw+i8RstwTRolYnjhySzinREV4Rk8Dx3rC1HMrntiJ7SnrafgVpSB4wiB7wAMpFQ9FiKwEQz16STRJC+M11yIkp6FhRFUhOU0l9RHHcBwH6q96zApLkp8aMV9+ecBANQ9FTm2Mgeob1iQM35YG3xvuNKwtG5cHg3NVu+umktr4lVXGW0wmxwJnUQ735vwLZ33EZ+0jwZtlX+Yym81QuwFXNRJvqrdKL7MZt34CgRVbnrauavylZC1NCpnp8JQtvqtDjaDaQVbiMb1jeOh1KhNHU1vzJkzJQVYC0q72EC1WecluSIX0lbgd5lo+pbaDqbtpOgr41iVg+41JX3YVhak3rA014PUCYt0kIM34sb6Dev6r9V1jvda9vqsfO7Z3Y3s3tneVEI7tXSVFxvZubO9qAR/bu7G9G9u7sb0b27uxvRvbu7G9G9u7sb2L8bG9G9u7sb3D1ozt3djeje3d2N6N7R22/f+9vbvfTT8fHv7an/dP0x2ZyW56vX/8eP4UPrw9nR/Oh9Nj+Pjn4cPlq1/3h4+fzuHDL8f951jwp9Px5BQ+/ns8Pt9/A4IIZXw+OAAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "90",
    "Center to End Label": "90",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "156",
    "Fitting Outside Radius": "78",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "78",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1936",
    "Maximum Size": "150",
    "Minimum Size": "150",
    "Nominal Diameter": "150",
    "Nominal Radius": "75",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "150 mmø-150 mmø-150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "150 mmø-150 mmø-150 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "62",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
  },
  {
    ID: "812884",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.09974481",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jV0LgjAYhf/Lez3GPtzm7CoqCOpCJOhCvNAaOlhb2ApE/O9Z1t15Ds/hlCPkjT0NdwMZHEJjC3OJtW+dAQR5sD4+ICvHJc6KFDhJJV9RpjFJFIOp+nvrvq+HWZ6Lra1vJpoeMoIJgqPxbew+QJmSCIoQ62iDh4xjmlChmRRcpFppThGc7XWRBSMawd7YtotfpiRBsHPm9VsrrJlKEWyCC/OXfzo3VW/j2C/60gAAAA==",
    Pbi3DGeometry:
      "Jw8AAB+LCAAAAAAABADtV11rwjAU/S957kpukuZDn8Y2GGwPsg32ID4oFi107XDdQMT/vrR21qy5qT+giNKe3p577slNLs4PZLbK3vafKZmQp3KVvZZ5tiYRmZVZUX2RyfxwurSP6dR+yDHqkBugdNr82C85Lv5eu93tlnv7rkxinmgVATMxZSbSMSQgIgcGqmpccxeWibAwAyGvwzX30jhJhZbiBAvFIhUbprSDc8pEx+KG61hwza7AdawMw1i6pBclySZcWa14SYjGLlow2ZRqglnPGo3mosYNSCcelNCWhyZJ0LIubyJ5nVcqFtKDxQ/zI/0BxvRp/lmPWYwVOyDSmgZGeuNdNeH269EMiUdK9a9gQKR/L6AeIJ5h/Ydsb29b9sRf0Ogmq+EQaIMhxxKoS2JUqqv2MQBYmCvhXSYOVIZourRcQ6Nd/98ijhwsfpgfOeOUkD4adKEch7FqB1W2fdOPd+VgJzfGMygfqda7hgGVXjUBFxDXsPMGmVJIY7rix5E5jsxxZI4jcxyZ48gcR+bgyLT/Ou+z5UdapTsyoTGNyHNabKpte/NSVssqK4v29j1bnx89ptlmW7U3D3n6cxl4V+alJSy+8/y4+AV/ITg+Jw8AAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "156",
    "Fitting Outside Diameter 2": "22",
    "Fitting Outside Radius 1": "78",
    "Fitting Outside Radius 2": "11",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "78",
    "Insulation Radius 2": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "39",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1939",
    "Max Fitting Outside Diameter 12": "156",
    "Maximum Size": "150",
    "Minimum Size": "20",
    "Nominal Diameter 1": "150",
    "Nominal Diameter 2": "20",
    "Nominal Radius 1": "75",
    "Nominal Radius 2": "10",
    OffsetHeight: "75",
    OffsetWidth: "75",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "150 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "150 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size 1": "62",
    "Tick Size 2": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "812887",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.96226833",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjT0LwjAYhP/LO4eSpE3TxElUEHQoRXAoHVINbSAmUqNQSv+78Qvc7o7n7uoJytYcxqsGCTvfmkqfgnKd1YCg9MaFG8h6+siIMJ7wnIgFoSLBGacwNz9uOQxqjHAM1kZddNADSJxgBHvtutC/DMEZRVD5oILxDmSakIwwQXOWskJwkRIER3P+h7fadH14L3EqEGysfnzbRWznDMHKWx+/3N3auXkCyEJNB9IAAAA=",
    Pbi3DGeometry:
      "sxYAAB+LCAAAAAAABADtVl1LwzAU/S95riVJ0yaZT6KCoA+igg+yh4lFC3WVWQWR/Xczm8225jTNg6hQxsZ6ent67839ODfv5Py2uHp7ysmMnFa3xWVVFnckIudVsayfyezmvflrbtN98yHr6AvZY5Tuf/6YL1nPt48drFaLN/NsKmPFNI8Y1zFViYxUzFQSdWCuN2jKRBfOUjGAcyayUTTgpYMs32FGw133sEiRZAZWsVa6TSMVZU6cG9Y2bmkAjFi0ue8wB3CPZRtS3/cdDmiQudt3lEiptGrwVLBPPNMDpyczLhs4EWljLoZoZJZa+5SrdmqotscnGm+SgOL4yoybBTvpzry/yDoFLzUX1lzxFgxCRZlBLMD3xLIkmfIXAWoPlHYqrC9UtM3d7wTNAcsXHBKsmLDDg80XFiryMrCHkfMoOd7u63VrWOm5zy+0hb292p3vKMFbZzbAZnbywUJ1xjlyA+3mMtoGvQwwobPB+T6usw3NILs7A4AF7EP0Tl++eolBrqD4QUQgL8jcXY6++JFm6eZl1Hj0rf1R/bILB2oNUBZgE7o72tcuQCV1uwgVi/v0A+t23GT0lBycFk5y/6JGxfKzMvkPCN9xSxlNxkCt6ZXVv6N8gZeT9J2k7yR9J+k7Sd9J+k7Sd5K+/076ziNyVCwe8zpfkRmNaUTO8uV9/WAvLqp6URfV0l5eF3e7Wyd5cf9Q24vjMn9tGx5WZWUIly9luZ5/AHaQ5qOzFgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1940",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "924596.4",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "812900",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.80122533",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyE0sf+eRAVBD0UED6WHFkO7ELNSo1BK391Ia9GTt539hpnJe8gqPHU3BSnsqcKMdFeTAQYZobF3SPN+PJ0hDLgfi2gpZMIXnvRhYF9wwaNQ/oUxjxL5y+bUiRWf8lXblp1b4B4bLK/KqhZSj3sMDsrUtpnEkWxp0Y0e5RkvM9oprBv7FgGDrVbPySgkT2IRMliTJhdqHloPxQvrDKZQDgEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACdVt9LwzAQ/l/yHEOaZv21J1FB0Iehgg9jDx0LW6A2UqMwRv93U1ddf117ldLS5Mv33V0vd+n6RFZb/XJ8VyQhD2arn02md4SSldG5/SDJ+nR+dTBfuouU9DJz5XG+/Hm4m5SbX9p1UaRHxw0WTEZeSD0RMxGHgno+E74X0CbAZQUIFkcdQAhZEfhCxhSlVBMkj+SABb+aaBIiFs73CbQ9LoU3PunVgFQU8qHIL0DvGwIBdo37LAzEQDYa822lJgFSaofRN3GOAqM0YaLnFBjeSNywt5BUOxvTUv/3aiBAMOPwRwSqBswGtH52liALwD7H7pzpisESpn1C1B5+GwCMEQDZQ0ApTDtCMjBeAZuzC2AqA2QAwEhPn19LYPdEMjBegaff7D4MEMB53BEHKc04qCuC+2e41embsqogCWeckkeV7+2hHjwZm1pt8nr4qnd/0L3S+4OtB3eZ+mouvDGZcYL5Z5aVm28DLs4W5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "157",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "3959",
    Length: "524",
    Mark: "843",
    Material: "Copper",
    "Middle Elevation": "233",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "149",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "233",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "309",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "812913",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.46995283",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1Tt0KgjAYfZfveow1Zzq7kgqCupAIuhAvlIZ+sPaFrUDEd2+g9QbdnT/OOeUIRYOX4WEggyM1WJAdWnLAoCB0/glZOc4wBNYxT9JIblZSc6ESCRP7j1l95/O+r4fwIQg7rO/Gmx4ywQWDk3Gt7xZyJl97DLdnesXbzzoYbLuworiKRcRgb817yaZcJVoz2JKlUOte1k7VB0vkVMESAQAA",
    Pbi3DGeometry:
      "mwgAAB+LCAAAAAAABAClVV1LwzAU/S95riH9WNt0T6KCoA9DBR/GHjoWtkBtpEZhjP53Y83sV26TTkpLcnJz7rk3N7frE1pt+cvxnaEMPYgtfxYF3yEPrQQv5QfK1qffoVomS/Wg2muRK5+QZfNRL6o3523XVZUf1d44xiQMA88PKCZR8jPANCS+Fy9wkjYLKU5of4HGDZwmJGrhCaLGnuIgiAz0Ch/QL2YKAj3bY5vh3KZqTBWTODIFrvFhAicSDvrunkSKo4TSMc8ZH2ZjZK8jaPHOudlIrOQDMcOY7LhZJOy3l317rBfKGYXVP1xIpvlyGDM/bepc+5OnCqcFLG4Hlss7AKTGcqMsDqy1AcBupQHJmWs/vxdBxefSctyY7Dh0HcCW5kb0r64JaTL+vkDYhWUade2Zlr7uaK5h9ae/5fkbk6xCGcHEQ4+s3MuDnjwJmUsuSj195bu/pXvG9wepJ3cF++oa3ohCKMLysyjqzTeeV/AUmwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "-8315",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "-8315",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.3 /",
    "Flow State": "Turbulent",
    Friction: "25.45 /",
    "Friction Factor": "0.020357",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "2585",
    Length: "1356",
    Mark: "844",
    Material: "Copper",
    "Middle Elevation": "-6959",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "34.5",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "57050.18619",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "7",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-6959",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "-6959",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "812969",
    Name: "M_Pipe Tee: Standard",
    Category: "Pipe Fittings",
    temperature: "20.77718346",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA9jUELgjAcxb/L/zzGnLq5dYoKgjqIBB3Ew6qhg7WFrUDE795E7PZ+j9/j1SOUN3MZXhoknPzNVPoelGutBgSlNy68QdbjEqPCcsyLlG4SKjDJOIWpWb1t36shyrHYG/XUQfcgCSYIztq1oZuBkRRB5YMKxjuQCc454YKllHGRFYIxBFfzWNyczXjUpu3Cf3uw+ruOKRYpSRDsvPXxyn2snZofJBy5g9EAAAA=",
    Pbi3DGeometry:
      "RSgAAB+LCAAAAAAABADtWE1r3DAQ/S8+u0ayLNtKTqUtFNpDaAs9hD1siEkM23XZuoUQ9r9X9cd+SH4aKWlpDiIk2H6eeTPj0cxkrh+Tq5v2y8P3JrlIPnQ37edu094maXLVtdv+R3Jx/Theaphd6p9knx6fvOKMXQ5/9G+yX81ir3e79YOWLWVW1SJPeV7ri6rQF5kSjKcakErJAahLIRcAleWCKT+JXBSDBCuq3EvVZJXKBKv4KaDKapECujEK2AyEIpuZAmAETe5Sh0HwxXggo5ATRsRFJoVYsskCZi+OgGHsCXD+8SwJSG5zQKvO/Taf2zZBBqQIexfsxDKF9VGDnYCZJrQkL+lc9gjTrIhwztQEnYOpTOa4vxN+z8nokR/IPHXBx9SbgX5OHd8jYHxRVP/Iggk1mdmHihM8cwG1WkvwWaL+o0rHUToBqAp6Yfeiitc+Tcqnrc2qHK3Ty49jEEuRT6qEHKIr6lw4HfSXIGugVfoLxcfvUfJikFBSCr9mUdWjQMEH7kKUys3tTXEwClFATZAbaIKhHQVUxkcClpfFCbN+LhQPyZyFTr/MMFmk35f1UB1ZzZTLIqgfmQoZfJuLj9f+cQq0ymdqhfnkmBn4DJSDBJdV2Ax14EDnhZqh7LBDq1wjX6AfRc3Pa702W50BZjWaANvcAzBzGKrsLKHIIQe06qhKe174qYISsx8QsGIV6gfkcFhlJhxMH0juypJl4Ml+2IDrcAKrkARNDiTs6KL+cBCYO00hhdsNLPG3KWwAdjN4bODMASVoDpC5NkA0XztU4daGz5/+FYY8/a6ZAFiFJOgKAyTsYgXmiMP7Y8fWAFO1E6CM9RnITQmLI3BIgoUqvErSHLDPmUDoTBe+waOGpJe4wQvwwnMz8JxV5zLFEzZ7L3ODRyyU/uECj/onNW7w4gYvbvDiBi9u8LxqYNzgxQ1e3ODFDV7c4MUNXtzgxQ1e3ODFDV7c4C0C/2mDt0qTt+36W9M3u+SCZSxNPjbbu/5+uvnU9eu+7bbT7df29gC9b9q7+366ebdpfp2++KbbdFrh9udms1/9BmyHS8tFKAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "79",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    L1: "92",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1142",
    "Maximum Size": "150",
    "Minimum Size": "150",
    "Nominal Diameter": "150",
    "Nominal Radius": "75",
    "Overall Size": "150 mmø-150 mmø-150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Radius: "79",
    Size: "150 mmø-150 mmø-150 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
  },
  {
    ID: "812970",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.03642716",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABAC1TksKwjAUvMtbh5A01mhdFRUEXRQRXJQuWgzpg5gnNQql9O4GWr2Bu/kxM+UARYOX/mEggyM1WJDrLXlgUBD68ISsHCYYA8uU65VKNjJZc7HQCYzsP2b1nc+7ru7jhyjssL6bYDrIBBcMTsbb0M7kTKEOGG9P9Iq3n3UwaNu4IjVPhdYM9s6857BUPFVKMtiSo1jsX86N1Qd2qzeaFAEAAA==",
    Pbi3DGeometry:
      "xQgAAB+LCAAAAAAABAClVttKAzEQ/Zc8x5C9dG99EhUEfSgq+FD60NLQBtaNrFEoZf/duMZ2b7OZrZR2mzOTM2cyyWSXR7LYyJfDuyAZeVAb+axyuSWULJQs9AfJlsffv8bM5+ZDKnpGrjzO5/WP+ZJq9TftuizXBzM3ihgPAp96fsp4GPs08MyTpzSasTipDQmL07YhjWo4iXl4hkeIav+U+X44QG/wDv1soiAwsju3CcFdqvpUEY/CocQt3l3AkQUHYzcr4QU/fl6f6GTorkd/hk2iYWjUzs3jDtCV1M0NYwC0jgRvVQKT9cWi+vm1qw2qHT4uw4Vw+KLPg6PMI+sD7nkMz+WdAdTjOGqOCIidAuHIjQJJmjxheqcCtyKmIyGpMAbwgIBdD0n1r84Kqhq840AYReOC0W3VdQEg/S1s3glu5fpNaFGSjDNOyaModnpvB09Kr7VUhR2+yu3JdC/kbq/t4C4XX03HG5UrQ1h85nm1+gbKgIboxQgAAA==",
    "Additional Flow": "0.0 /",
    Area: "3",
    "Bottom Elevation": "-6775",
    "Calculated Heating Load": "300",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "-6775",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "4125",
    Length: "5336",
    Mark: "845",
    Material: "Copper",
    "Middle Elevation": "-1439",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "148",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-1439",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "-1439",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "812974",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.03691616",
    Cost: "0",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjkELgkAUhP/LOy+Lu5rr2ikqCOogEXQQD0qLLmz7wrZAxP/ehtohgm5v3jfMTN5DVulTd1OQwh4rnaHparRAIENt3R3SvB9Pb4hDykMWLRlPqBCMw0B+QUE5k/IbiojJf3COLeb6VduWnd/gHxtdXpVTLaQBDQgclK1dM4kjutJpP3uUZ335oJ3SdePeYkFga9RzMjJOZcJiAms06EPtw5iheAFj8UknEAEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1LwzAU/S95jiVNa/qxJ1FB0Iehgg9jDx0rW6A2UqMwRv+7mWvt2rvrzSgrTU/PuV/JYYs9m6/06+6jZDl7NCv9Yiq9ZpzNja7tJ8sX++Ojg8XMXazlw5urUIjZ7839WLvsaTdNU+wcV0VBnCrFQ5kGSRJKHh5ehIo7QEYTQEZHIBJZNmaINOb/SSkVxWcZCRZjIiWDjMoKDY4ClwdHAVQKVC6u4+xsE3vAt8AheCeVBDI8PAzd7aQGYCJ1whjXARldHTAGKoUCvlmBtkMATRcNDuro2+4r5ZEVWiAYFDlzdLToGaQ2A4zhn67vzOFRo6RQxgUmQ80cSqGA//aZSEEA3VeUZaBSHiZDMqhzDm0JBfwtYyIFAeqoQeujpFAGrIMyfZgVauEoQEnBOijLgG339xJf9xnX4f5D3OnivbRlw3IRCM6eynpjt93i2djCalN3yze9/oMeSr3Z2m5xX5Xfpx/emso4wfqrqtrlD6hs+1n1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "157",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "150",
    "End Middle Elevation": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "147",
    "Insulation Thickness": "0",
    "Invert Elevation": "3959",
    Length: "473",
    Mark: "846",
    Material: "Copper",
    "Middle Elevation": "233",
    "Outside Diameter": "152",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000017",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "149",
    Size: "150 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "233",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "309",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "812982",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.54297556",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNo2jRp4kpUEHRRiuCidJFqaAMxkRqFUvrvxhe4mzOcYeoJytYcxqsGCTvfmkqfgnKd1YCg9MaFG8h6+sSosAzTgrEFSQVOKE9hbn7echjUGOVYrI266KAHkAlOEOy160L/gpwSjqDyQQXjHcgME0pykbI8ywvBRUYQHM35X95q0/XhzSShCDZWP75rkmLBWexW3vp45u7Wzs0TFGsEIdMAAAA=",
    Pbi3DGeometry:
      "8y4AAB+LCAAAAAAABADtmE1r20AQhv+Lzq7Zb+0mp9IWCu0htIUeQg4JMYnBtUvqFkLIf6+kXX/I0iNZvfSyhMSxxzsz78w7M6u5fimu7pbfnn8uiovi0+Zu+XWzWt4Xs+Jqs1xvfxUX1y/x30osLquf4nV2+OSNFOKy+VP9Fq83u2Nvn55un6uzTs9Lp8qZVGGuhTIzqedKSzc7CPw8yOBqgZDiWBDmsjS+R+DnZVDTNIHtAcHOtrGq30ZH0O/UGbh3mrQNUVEp1TEKJ43qFVQaTUuwM4ECVFUa6XtPoKCjimDsA0Wa6ACi2EfQGy1rgVZCNT6VbQvaKNkcEKFtQnkXhkwb7xyAUzYmz2vbCISzEV2ZVPla55GzZHt6ZAmec8m2d9G2MbpscVCYsq1JCRNprkKE4VSMoNYJnoyfe6vOKr3TVCBsK3Q0LbRo6sKUKXnkk7EN7kpgQlOTuowxJ2fH4tEtPTSB+UYYTE7yajJrmWuQJQqUreWNS8HKKEiRRV9HQ9shAsUcs0c8wJCzAPGBbUy39mksGOdbvUs1jaIyLUQ4J+Rjc6RbqziSMFDjqpSVusVNk/ivrGnhc7KmXi0wssGnnbbnGe+4S6rQKxyh6C7WsdUqxBOibA8fSCwSnTmFA5G4Q2RDFDiW0CkmNAnUDrd3rSuFV23TuyTB99kwVQzNYvZ0okt8XSJF3P0p3jzdiB2oCpPNVTxaYZ2apELCekEbeILH9+TegifQxtijwWFeyfq1CYlK7Ak1P9U8hEplI3CyfXeuO8PgiZPBLpWUMbMhloBM81uKalrUMQwh5UmVDXuEMPFEIpWNhpUzg7f5DnV2AmtTNIK1jaelH/gY1Rih0wGhE2A3GAmONoQID/DdB6/T5BSgnk4ZNg3oMM9jj76HkT76cDidx5huejAlGvSzlb5dDfcYpWDiQBBB+SGzeGCaP5gE4sXorbvDi7HVwGkykXpYoNBI6MqBTRqJ56TTaUK4xGGle6fQDjU61Z8GXdpoQAQb9cgwaJibJBlGVTj+EBx7hQOTr9ZjkT3NBSIfx4F7rlOAA4Mf3MWwI81pCk0sSO5wuDCDuyo1lOr60Va0b+BQj5MaEN+E0R/wH6qd2wPUHHtEjzCkaGpPx0hD6FD/ZGRTEaCn/HjRn7W8GM+L8bwY711v5sV4YyIvxvNi/Dh7eTGeF+N5MZ4X43kxnhfjeTGeF+N5MZ4X4y138mI8L8bzYvwIeV6M58V4Xoz/G7L/shi/mRXvl7c/FtvFU3Eh5mJWfF6sH7aP6c2XzfZ2u9ys09vvy/u96ONi+fC4TW8+rBZ/jr/4brPaVArXv1er15u/PPJAv/MuAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "84",
    "Center to End": "84",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "156",
    "Fitting Outside Radius": "78",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "78",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1143",
    "Maximum Size": "150",
    "Minimum Size": "150",
    "Nominal Diameter": "150",
    "Nominal Radius": "75",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "150 mmø-150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "150 mmø-150 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "62",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0.01",
  },
  {
    ID: "813045",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.03934521",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjkELgkAUhP/LOy/L7uqq2SkqCOogEXQQD0qLLmz7wrZAxP/ekuYhgm5v3jfMTN5DVulTd1OQwh4rnaHparRAIENt3R3SvB9Pb4gCGkomllxEdBHHCQzkB2QhlQmPv6EUAf8D59jiU79q27LzG/xjo8urcqqFlFFG4KBs7ZpJHNGVTvvZozzry4x2SteNe4tISAJbo56TVzAacAJrNOhT7cOYoXgB1oq9uxEBAAA=",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVk1rhDAQ/S85W0nUxI89lbZQaA9LW+hh2YPLht2ANcXawrL435tabRUzOwmiGF/mZWYyb+LmTNY79XJ6l6QgD3qnnnWl9iQga63q9oMUm/Pvq4HpylykC/6/XDFKV/3D3KTbjmbXTVOejK2Iw0QkPGCRCPM0zYKIhjHLWWAFRBz/AJxmqRUALZJMiDmQRtyTavSK82QOJCzydHekWngFxD3MB4nAKDhLc0dnUarLi9Mk5BlLlyl0AlCqPlNTYNg/jzVGoN+/KTBLicUrGFh4BUQxhtfvhmVpMG6Yyh3Ako4UNEgFigZMum0N991ASwHSOEIFWvj0EdArDz1hAXpUyUz+toKD+gJCBVr49B5EBl6Nz11RmHAAMQM9GqEB5nucAYA37mclEpZ/swOV6t4//I9QY2H+GW5V+SZb2ZCChjQgj7I+tMdh8KTbslW6Hoavav8H3Ut1OLbD4K6SX9OJN7rShrD+rKpu+w13Za3X5QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "6826",
    Mark: "847",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "150",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813091",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.94792775",
    Cost: "0",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAC1js0KgkAQx99lzsuyam5qJ6kgqMMSQQfxoLSsA9tO2BaI+O4taL1Bt/8X85tqBNXiZXhoKOBILSqygyEHDBSh808oqnGWYSATvsqk3ETxmoskhYn9oau/6LLvmyHwQ7DD5q697qEQXDA4aWd8t5gz+cZjeHm2V7z9qoNG0wWI5HmeMthb/V6mUcLjLMsZbMlSOOte1k71B1+cv0kOAQAA",
    Pbi3DGeometry:
      "2QgAAB+LCAAAAAAABAClVt9LwzAQ/l/yHEvSNOmPPYkKgj4MFXwYe9hY2AK1kVqFMfq/m9m6NaVnr47S0uTrffdd7nLp4kDma/Oyf9ckIw92bZ5tbjaEkrk1RfVBssWheXUwm7mL1PQ8c8UZm/083E3q5a/ZdVmu9s5WiSCSMqI8jAMmJOUiCJMkpcf5RKlmnonEA1QkG4CHqQdATCcDGfNhF0qJLiB5nE7TBLkeDQ7peVxRn4gl8WDQZ6C/fFBwoG8vESFzgBhg6gLd5Rg0OEbRBbzUYZhGPfQkecEh5mGpgGc/ERim/0vqx+alGtIK7hQwDygLzI5AZRpccKj0kVQXdQg4eeP77k8fmMqBAUzlgJomG0ztW2BpYtoTjglV/WB7AjsgjuqiLgurAs87EMBRoQBMn0WdCSiDFnD/Cbdm9aYrXZKMBYySR11sq107eLLVqjK2aIevZnOC7rXZ7qp2cJfrr+6HNza3jrD4zPN6+Q2+pRky2QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "250",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2383",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "4050",
    Length: "2132",
    Mark: "849",
    Material: "Copper",
    "Middle Elevation": "250",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "150",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "250",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2383",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813093",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.98982181",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNzUELgjAUB/Dv8s5jbE6nW6eoIKiDSNBBPMwaOlhb2ApE/O6tQuj23p/f+796grI1p/GuQcLBt6bSl6BcZzUgKL1x4QGynn5jJJzhtOB8RZMcE5bB3CxsPQxqjDYGW6NuOugBJMEEwVG7LvSfhZI0QVD5oILxDiTFWU5ywVnCc5EWgnMEZ3P9x3ttuj58mwQrEOysfi3XDFORRbPx1sdn7mnt3LwBLVyhyNIAAAA=",
    Pbi3DGeometry:
      "2RcAAB+LCAAAAAAABADtVl1r2zAU/S969oy+ZSdPoxsM1ofSDvpQ8pAS0xi8eGReIYT897qR63ayrq5cBuuDKC11TnSu7rlH1rk7kqv7+sfhV0UW5Ht7X9+0Tb0hGblq6133myzujvbfHqbL/oecstdPPjFKl+c//S85rV6Wfd7v14d+rRa5LLTOGDc5LbnImMhZqXjWA4oV/C+Ay7L0A0zIZ0AqxbwASAUWB6mmAETFdcHCxcEaOBXTxRkoCkcSJcRbYKDSeVkWOgrAqHrAMBUHjA26VCPg9BFB5V/haRCeIDcW0PZzLk14skoMighVWkCKINPYhSjsZrlmdoEeSmhp5yrDAw/sCWCC94rOAnPheDZGQCsrOaMa6RsTymUC2xhXMMYswCMdNZEWm4Uxdk9G8mBp3IHunsDhQc6cPVT4HM3tGl8QfejRLiY6xZ7UiWWjnQn6ae6ZB2eK3heO4oqZlyaMZaIq7GS8a/RqnVyU7gXjVyPisnAEV5xqn35gAb8YIA0YGoAFoHgBjYAtQVoArQUkmvXqi5ciPg05FSBXYOnCs1fERhPbYVMDz/NknNjUovMcqDdk1VnOBl+ssL9wJugmA9/dqGWwkPAP0/vHzOIRAXpync1Nve/O+/8ni0d0nrJ4yuIpi6csnrJ4yuIpi6csnrK4r8QqI1/q9c+qq/ZkQXOakctq99Bth4frtlt3dbsbHm/rzQh9q+qHbTc8fG2qx7dfvGibtifc/Wma0+oJ4wrVOdkXAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1149",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "813095",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.61579087",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/zzGNnVz6xQVBHUQCTqIB62hg7WFrUDE795KvD0vv4enmqBozWV8alBw8q0p9S00rrMaEBTeuPACVU2LjAhPcJpzvqFMYEalhLleue0wNGOEY7A3zUMHPYAimCA4a9eF/mfijCMofWiC8Q4UxZkgQvKEcSHTXPLYXs19gTNGJIKjNl0f/p6SFMHB6s+6ZlgKHrOdtz6eube1c/0FNbXGg9MAAAA=",
    Pbi3DGeometry:
      "uQ4AAB+LCAAAAAAABADtV8tqwkAU/ZdZp2HuPDO6Km2h0C6kLXQhLhSDDqSm2LQg4r93fFUTcga7bAkSzczJ3HPuI/ficM0GE/+yes9Zjz2UE/9cFn7KEjYo/aL6YL3hen8bYN4PH7ZJTjtXxHl/9xUuthkdj10vl+NVOGtkqoWkhIRNuRMyIZmGtUkCoEym6oCRYgdoLtpPIEBz5eoA55TEyMPvnlyQczWOzJgaEDayLWAVZa0nINAwJVJnjYqTW6vrcklnUVPKUSMk3LotILWrURBXcQYjszogpI26B2OriZocYSMAhpRoE4UpkCWoFpbIpQk/hRYWFYw55EDJQF5gaiQWhRYXDioEoBVKQsw4d043vFa2Tevp1VOZaFSa1rKVO4gXUQ7NXaPpSKfj9QG7kaEGh6bWCB5FYQpkCaqF796lzegsuLANo6hDDpgO6EeEHMhFwcX+oVLAxYNEQW6Yv38y+2AX+f3swxzd7OtmXzf7utnXzb4/P/vC/8BbP37Lq3zJejzlCXvMF7Nqflg8ldW48uXisHz10x/oPvezeXVY3BX51/mDN2VRBoOLz6LYjL4BKy33crkOAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "233",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "156",
    "Fitting Outside Diameter 2": "22",
    "Fitting Outside Radius 1": "78",
    "Fitting Outside Radius 2": "11",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "78",
    "Insulation Radius 2": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "39",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1150",
    "Max Fitting Outside Diameter 12": "156",
    "Maximum Size": "150",
    "Minimum Size": "20",
    "Nominal Diameter 1": "150",
    "Nominal Diameter 2": "20",
    "Nominal Radius 1": "75",
    "Nominal Radius 2": "10",
    OffsetHeight: "75",
    OffsetWidth: "75",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "150 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "150 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size 1": "62",
    "Tick Size 2": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "813327",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.6694058",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjssKwjAURP/lrkPIg/TlSlQQdFFEcFG6aDGkgZhIjUIp/XeDfSBu3N25Z5iZooe81ufuLiGDg6t17kynnAUEudPWPyAr+vEMBsFwlNB4RYnAqUgoDOgLchzzNP0HI0w4/YFL7AzLuX7dtlUXNoTHVlc36WULGcEEwVFa5ZtJnJyvvA6zR3nR1wXtpVaN/4iICQQ7I1+TlzHMEk4RbJxxIdc+jRnKN6KKYFkTAQAA",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVl1rgzAU/S95ziQmGhv7NLbBYHso22APpQ8tlTbgzHDZoBT/+2x1qx+5eqUUi/F47j039yMuj2Sx0W+Hz4TE5Mls9KtJ9ZZQsjA6s18kXh6r2xJm8/JHCnp5cuMzNj//lRcpVn+02zxfH0puyD058yPqs9BTUgSUc0/4gaAtQAXyBPCZ8NtAxMMzoDinOFM1QwgZOH2IIJQNQHqMh2qiKtD5WIBY5whVfVO+jByRX4D+JroD7DoXXiSUcuSjCbRMNYHWljgYVRwOH1UcKFNjPjqqwACHIgflup138zFu6hpV/QDBnIN7BTYOmA+QMT1RoA93taPLZ7xx0IxxVYgenFAMbsYQgJsloCnUWMIxUKrcJdoFUP0BMtzA0Gyf3lHgFMUxUKrAc3D6QAYZIIA77kBTU47tE6P8hrjX64/EJjmJmccoeU6ynd3Xixdj11abrF6+6+0/9Jjo3d7Wi4c0+Wm+eGdSUxrMvtO0WP0CMfaNqvUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2992",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3001",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6793",
    Length: "323",
    Mark: "851",
    Material: "Copper",
    "Middle Elevation": "3001",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1832.9",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "146",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3001",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3011",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813337",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.45631952",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGkiemfJ1FB0EMRwUPpocXQBmJWahRK6bsbbOtBBG87+w0zk/eQVfrU3RSksMdKZ2i6Gi0QyFBbd4c078fTG6SgUciiZcAkTUQkYCC/4ILKkCXfMBbiL5xji7l+1bZl5zf4x0aXV+VUCymjjMBB2do1kziiK532s0d51pcP2ildN+4tQi4JbI16Tl7OKY9FQGCNBn2ufRgzFC+2w1ROEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVltLwzAU/i95jiWX3vckKgj6MFTwYexhY2UL1EZqFcbofzezXe3t7CSMjqZfz3du+U66OpHlVr0dPzOSkie9Va86VztCyVKrovoi6erU3BqYLcyP1PT/yQ1nbPH3Zy5Sry9mt2W5ORrbQHpRFHDKWeAlMpJUCE8kQtA5QMrQPwMxT+QsAFpESSSGgB+EblRdVGGQDC24L93C7ajGUYlY8qvOQSowj1jEvl24OBXi3PeCkCUzRbQAcKqmVj2g7aC9jw5oOtgDhiWZRgUD46guHZzk0SXY9GPqHMwcprIG0LJjmxqkAoUDln3Gh3U/8M0A6RyjAi0cZgkYlb2i0ATtd8loAMxsOGgyYFSghcP0wWTgMvqsFYUKB5QzOKkxKtDC5TQAo7I+OfEE3UcfqFrrWeJ+pJ4tzDfEvdp8ZFVWkpR5jJLnrNhXh3bxoqtNpXTRLt/VroMeM7U/VO3iIc9++i/e6VwbwuI7z+v1L3S6vxX1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2992",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3001",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6793",
    Length: "420",
    Mark: "852",
    Material: "Copper",
    "Middle Elevation": "3001",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2384.2",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "146",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3001",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3011",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813557",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.88173083",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjjELwjAUhP/Lm2NI0sTaOokKgg5BBIfSocXQBmIiNQql9L8baZU6ub1733F3WQey1Kf2piCFvSu1dKatnAUE0mnr75Bm3XAGAxc4JiRZzijHjFMBPZrACCeEL/7DSMzpL5zEDjD/1K+apmjDhvDY6OKqvGogJZggOChb+XoUR+cLr8PsQZ715Yt2Sle1fwtKOEOwNeo5ehnDseAxgrUzLuTahzF9/gLqzNbzEwEAAA==",
    Pbi3DGeometry:
      "3wgAAB+LCAAAAAAABAClVt9LwzAQ/l/ynJWsP9PuSVQQ9GGo4MPYQ8fCFqiN1CiM0f/dbHbakB65MEpLc5fvvi/X3KWrI1lu5OvhQ5CKPKqNfFGN3BJKlkq2+pNUq+Pvq3GzhblIT/8tszlji/PD3KRfX2A3XVcfDDbNooKxks7maRTnMY3jiKdJTi17yfnJUWRpQScARV6WOHuaF2cGlvMpgMvsUcQzznFSkyTLJ0MlmXmZ0nRBOKsAQ8F5guSCHMh1JFHJUu7mfGy3IrkAKJBrtz7eVcxWOhDUdprGDuvjTSDcVYDckFowlJcDDOUpDCgjUGFg5oMEKGYwgeAmx2gCI6EAGE1w1Qfvj/BtAHcW3K4NaVIeBEqVr9+FV5+LgBze1hlQS77W6UGgVGEOvoAm7AIgO3iCorpzwFl8Api/hTtZvwstOlKxiFHyJNqd3g+DZ6VrLVU7DN/k9s/1IORur4fBfSO+xxNvVaNMwParafr1D44R21rfCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3136",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3152",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6937",
    Length: "547",
    Mark: "855",
    Material: "Copper",
    "Middle Elevation": "3152",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "349.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "145",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3152",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3167",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813567",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.82280408",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yGm5tudooKgjqIBB3Ew6qhg7WFrUDE797Qur3f4/d49Qjl1ZyHp4YCjv5qKn0LyrVWA4LSGxdeUNTjEqPCOM6pzNYrwjCVQsDU/L1N36shyrHYGfXQQfdQJDhBcNKuDd0MVGQIKh9UMN5BkWLCCJc04ykXMpcpQXAx90UmlEc8aNN2YWbC4nhv9ee3phTnTHIEW299PHNva6fmC+a+fzLTAAAA",
    Pbi3DGeometry:
      "iQ0AAB+LCAAAAAAABADtV01rwkAQ/S97XsN+70ZPpS0U2oO0hR7Eg2LQhTRbbFoQ8b83JNvUrBk39BxEcfOc994MszO4OKL52r4ePjI0RY9ubV9cbjcIo7mzRfmJpotj87WCyax6oRP+ezKhhMzqj+qNTsvfsJv9fnWoYoVMNCEpnlCRcKkoZiwxRBl8DrDUmBpQovtcUNkfAAKeSYtU4qvaLFWeSoh+oDVFWS+gJeMdgEvOrlJdRMAaoas2QU3qPLQ29HpJWipNVRMRlASsFawRRoAaYOZRKk6VpyJdcc606HV1AbRUXKQ1YIwY1gygOJw52AyhONgl0esBJxjajYrD3Q52SdgM8Ty8XcPl0LIz1QSI3qKHYwEUCAMAfvD2xXiYafyL0Kiv0aWhEGiZFNM1wOTQawxpQ17B0RJKx2cOOG3B9AKzUW1wdAKtMbzHxh0z7phxx4w7Ztwx4475/46p/tfc2dV7VmZ7NCUJwegpK7blzh+eXbkqrSv88c1uWughs9td6Q/3efZ9/sNbl7uKsPjK89PyBwGduRyJDQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3152",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "33",
    "Fitting Outside Diameter 2": "35",
    "Fitting Outside Radius 1": "17",
    "Fitting Outside Radius 2": "17",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "17",
    "Insulation Radius 2": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "9",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1160",
    "Max Fitting Outside Diameter 12": "35",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 1": "30",
    "Nominal Diameter 2": "32",
    "Nominal Radius 1": "15",
    "Nominal Radius 2": "16",
    OffsetHeight: "15",
    OffsetWidth: "15",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "30.8",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size 1": "13",
    "Tick Size 2": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "No",
    "Visibility 3": "Yes",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "813587",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.55762018",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkaTS1nkQFQQ9FBA+lh5aGdiEmUqNQSv/dSFsPInib2TfMTtpBUuC5vSmI4WALTKxuK2uAQGLRuDvEaTdIHxAhlYulWM0CL0IeQU9+QUE5Z/IbRtE/NpVm0/N10+StX+APW8yvyqkGYkYZgaMylatHc7Iud+hHD/aC5QftFVa1e5uACU5gp9VzzHJO5VxIAhurre81D6377AU30kqKEQEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVl1rgzAU/S95tpJGTdL2aWyDwfZQtsEeSh8sDW3AmeHcoBT/+9L5Ma3e3YRiMR7PuV+5N27OZL3Tr6cPRZbk0ez0i8n0ngRkbXRefpLl5lzfWpiu7I9Uwd+T2ZzS1e+fvUi1bWk3RZGeLDeOQiEXi2A2tzcRkwFjoeD2wRQg44hfAMmjZBKAGYyLIZBI6SfVeSViPmRQLv3cbaVGXokkFv8ah6WgOKSwgTq5i0shxuOQMSomkugAoFJNrnpAU0F3Gx1QV7AHDFMy9gp299qrtoKjODpGXY+xcThyUMoZQNOObWpQCmwcMO0TNpzrgW4GsM8xKZDhM0tAr5w7Cg/QeZdcDYCJDQdNBkwKZHhMH6wNfEafc0fhjQO2MzSpMSmQ4XEagF65n5xogP6jD+5a51nif6ReGPYb4k6n76pUBVnSkAbkSeWH8tgsnk2ZltrkzfJN7zvoQenDsWwW95n67r94azJjBfOvLKu2P7k6OKz1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3136",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3152",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6937",
    Length: "149",
    Mark: "856",
    Material: "Copper",
    "Middle Elevation": "3152",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "94.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "145",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3152",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3167",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813610",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.64498569",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1TksKwjAUvMtbxxDT9ENdFRUEXRQRXJQuWgzpg5gnNQql9O4GWr2Bu/kxM9UIZYuX4aEhhyO1WJIdDDlgUBI6/4S8GmcYAirimUzSzWod8SRWKUzsP2b9nS/6vhnChyDssLlrr3vIBRcMTtoZ3y3kTL7xGG7P9Iq3n3XQaLqwIrnMspjB3ur3kpWCKyUkgy1ZCr3uZe1UfwC3OdpDEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVtFqgzAU/Zc8pxKjJtE+jW0w2B7KNthD6UNLQxtwZjg3KMV/X2jtrMGrt4goxuM9597c5OjySBYb83740iQjz3Zj3mxutoSShTVF9U2y5fF862A2dwepaftkFjI2P13cSerVJeyuLNcHFxtHgRJRQmdhFIg0TChnQRwzTh0gVZqOAKFMcREyFmcgiSWKCsxKcSFPgGRCocRbKl9DKtWbFSwOUcF1XNIVjAuUBmJKhsV5ILkSPVPSAp54X4RP1e0gQgMW73YQkRUMdDvYF+HV4fUDUTlMBQEIKn+ukPsD1MBEgBrjrcVOIrjasVSTdhSYFWgAIICkwgDgEh13n2GqSQ43vnFA6/MBJBUGAJ0BMn0s1ZQPC5gV4gM5rDHFReFdO+4lt7vPVR3uH+LBrD91pUuSsYBR8qKLXbVvBq+2WlfGFs3ww2z/oSdtdvuqGTzm+vf6xXubW0dY/OR5vfoDpvzSo/UIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2430",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3128",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "637.75 /",
    "Friction Factor": "0.025571",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6230",
    Length: "698",
    Mark: "857",
    Material: "Copper",
    "Middle Elevation": "2430",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "444.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "21716.5714",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "145",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2430",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "3128",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813612",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.4946247",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jMsKwjAURP/lrmNo0zZ9uBIVBF2UIrgoXUS9tBdiIjUKpfTfjVp3M3MOU49Qnuk43BEK2NszVXhxyrQagUFpybgHFPX4i16JI54JmS4XYcRlEqcwNX9v1fdq8LIfNqRu6LCHIuABgwOa1nWfEuZpzqCyTjmyZsYnus5UhgmDHVLbuW9PpGCw1fiadRFwkUX+YW219e/mqfXUvAEjLMuhxAAAAA==",
    Pbi3DGeometry:
      "9zAAAB+LCAAAAAAABADtWU1vEzEQ/S973kbrb7s9IUBCgkMFSByqHlo1alcKWRQCUlXlv7PE3i97X+xNDxywKiqyE8+bN34ez3ZuXorr+/rr8491cVl8bO7rL82mfijK4rqpt/ufxeXNi/1va66u2p/iUA5PLkhVXR1/tf+Kw2237M1ud/fcruVspahS5QVhKym4Kmm1YkaLcmxQFWdHA6Fy3iCNKedcUc1MmisIjg2VIPPgnQFhBFHFMZwrQ4WcZR4a/BU+RtwQddXxSDAgHn4SF7hCKzoeWkliDUzY55WHzanlZwibGmjr+q9Bc3r0JDWzBiLsCk31dAVRFqPdt7RgPWyt+bJdii/wEUA6Bq15rAdD+9k6ss+VdNngxEGToyfN2yRY1tKJk85ng1tPmkqLIIziYwNekQwRHEqfneHdCmXpKcZOnm+IgYKCssFBodQqzdzmUa3dCn2eZqEOpJlXFNRBcukMz7ALlhpNZ1WOTz1UiKssUFMLNpz7BH1RIVcYHGEklBZvY1HNgXfGglMWXFhwn2A991YkZN0/A3Gpp4a7PCUJdzgUCbzcYRJhuN5BgycTlQt4hcM+aAhKV8QFJU/dM1oRZ1DaplCL0/fxQE8ZMd1x4XbccDKpk6rVjF3B+ewV3tPwJe33R1q0YrIGSsY6hKUnCDfcptQmE25Hr0NF6Kyozl/AY9rpWUhFxn0CTDpMIQoqvku+EqCotOwlUllXyiQ2xAEGcoUNUe1g8OWnxg+3ar9gMca9BdzwdIV0lxk8fb1CDDFzF01wxkCocQC/ICAJYtEuxwDs0sUMD3fsTCZvaaAmrzYnvNXC2uUnMF4nYm8mYc+Gwg2iMnpCg/PKJkoINmsIoo0aoCv/fos+7xx1jUAP7Uj4z5Ej9H3MTbtDwci4ckA/sPPCALzrvMw03Ur0jYltyQyNGKCcloMD2ggaNizSTPuxszcIBAQJRN8WAsmg9jSZw0AavQUibCwbpG/IAp0UTA8aoCvIDxqwK5Rb2JTAmgI7JVRUpGGTkjlg9/VayonKoQEpYTk0oo2g8aHXbFr4X1GucYeIeMTbVh8DtVDJNAbioC3B2DBamBHkCt6qgB6kDfzgngsaoCeU2DwaWD4aiP89P/YHzbjh/PHDPxkNBK/ReTQwQcijgQm7PBrIo4E8GohcWHk0kEcDeTSQRwMnU5hHA3k0cCrUPBrIo4HTUeXRQB4N5NFAHg3k0UAeDeTRwHy0/9to4LYs3tV339f79a64rFZVWXxabx/3T+7D52Z/t6+brfv4rX7oTR/W9ePT3n14v1n/Hn/xbbNpWofbX5vN4fYP3X8pV/cwAAA=",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "30",
    "Center to End Label": "30",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1168",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "813613",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.19701923",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACNjksLwjAQhP/LnmNI2tKXJ1FB0EMRwUPpoWJoF2JWahRK6X83tPV187Yz3zA7eQfZCQ/tVUEKWzphRrqtyACDjNDYG6R5N54uILkMZTSfSZ+HsYihZx8WOC9J5B/Qi8Mf+N06sOL1fNE0ZesWOGOF5UVZ1UAquGCwU6ay9ST2ZEuLbvQoj3h+o43CqraDCGTEYK3VY8p6gvueCBgsSZPrNXet++IJBOYZPBEBAAA=",
    Pbi3DGeometry:
      "kwgAAB+LCAAAAAAABAClVV1rgzAU/S95TiVRo2ifxjoYbA9lG+yh9MHS0AasGS4blOJ/X+rcltVcvW6I4v0+yb05WZ3IcqOeji+S5OROb9SjLtWWULLUqjKvJF+dPn+tmc3tQxr6o5lxxubtx76kWX+FXdV1cbSxPOAJT+mMR0GSZDENWRAJkVFXL+K01Ycspj7/MBEofSpEq4956PW/rDuGJwlRMP1JoijzgvFD92sBINN2cTDJuWJspSzj/b39ZXDTeyPOeHAGt0//LO4sDlcbKOB2y+MPpOmpIThA1ZHVXmaBOjy6n0ODjwoAK6BKQ4sDphSFCEiDcMeg8Sf5U9OxowPxBWIy8bQz5I1CM8ZeUw7V1OMAEVuPFIbJ1E/fQ94oNJjLahqh4rkZuvhQRDvlBrX+9oZfqOIgjaxJzgJGyb2sdmbfCQ/aFEbpqhOf1fbbdCvVbm864aaU767jtS61TVi9lWWz/gAFx7CEkwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2394",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "15",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "2.3 /",
    "Flow State": "Turbulent",
    Friction: "540573.80 /",
    "Friction Factor": "0.017662",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "11",
    "Insulation Thickness": "0",
    "Invert Elevation": "6195",
    Length: "12965",
    Mark: "858",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "13",
    "Overall Size": "15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "7008759.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000238",
    "Reynolds Number": "174119.6395",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "69",
    Size: "15 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2406",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "25.5 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "813616",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.15439911",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le72G+3LOrqKCoC5Egi7EC6uhg7WFrUDE/97QujvP4TmcaoTias7DU0MOR381pb6FxrVWA4LCGxdekFfjEqPCGZZUyvWKMJwKLmGq/96m75shyrHYmeahg+4hT3CC4KRdG7oZaJYiKH1ogvEOcoYJJ0LRVDCRKakYQXAx90UmVEQ8aNN2YWbC43hv9ee3pgmmGVMItt76eObe1k71F40mOs7TAAAA",
    Pbi3DGeometry:
      "zgsAAB+LCAAAAAAABADtVl1rwjAU/S95rpImaT70aWyDwfYg22AP4oNi0UDXDNcNRPzvy0y1JnhtxIftoZSWJqf33pybk0PHGzSa6df1R44G6NHM9Isp9BwlaGR0WX2iwXjjXi2Mh/ZC26SZ6aUYD3cPe6PtZB92s1pN1zaW0T5XKk16qX3hQiQE92kqReIBEjuApcQHWOoATmUkQCQ/nSooLogd/wLCfngUcJjPlGAnAZ4xl0nJLC4CKrHPRCRVPiApdYsl3GchmEtFlDpLrwEyoVwEo0ELpZcKXFUTQeve0swnzgk/vdqgBJgJ3D6wtxHaCVoF7UY7PVgJPu9mnu9aTpQkkdsKiTOMaCcBCiTQQYQIIRYQa1A3oAxiRdu6prYTtj+r11hOEHG5H0SYVFD8mhogj3/pwqAKL7dhEOhsuLPhzoY7G/4rG7Y/x3d6+p5X+QoNcB8n6CkvF9WyHjybalppU9bDNz0/QA+5XiyrenBf5N/HH96awtiE5VdRbCc/FxsGcM4LAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "35",
    "Fitting Outside Diameter 2": "16",
    "Fitting Outside Radius 1": "17",
    "Fitting Outside Radius 2": "8",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "17",
    "Insulation Radius 2": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "9",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1172",
    "Max Fitting Outside Diameter 12": "35",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 1": "32",
    "Nominal Diameter 2": "15",
    "Nominal Radius 1": "16",
    "Nominal Radius 2": "8",
    OffsetHeight: "16",
    OffsetWidth: "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "6899.1",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size 1": "14",
    "Tick Size 2": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "813619",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.51090987",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1zE8LgkAQBfDvMudtcdc/qZ2igqAOIkEH8bDVoAvbbtgUiPjdW9Ru8977MdUAxU1f+hdCDid30yXeSdnGIDAonLb0hrwa5tOTKOSZjJPNSoQ8iaM1jPXfbbtO9R77Yq/VEwk7yAMeMDijbaidgkwTBqUjRdrZZb7qx7wKGQsGR9RNS1MWkdcHg9+Fy4DLNMwY7Jxx/rv9GDPWP6aoZ2nEAAAA",
    Pbi3DGeometry:
      "NQsAAB+LCAAAAAAABADtVl1rgzAU/S95TiUf5ss+jW0w2B7KNthD6YOl0gacGZ0blOJ/X1DbTdvb2D2LKN4c7zm5yc3B+R7NlvZ195GhBD26pX1xuV0hjGbOFuUnSub75tXDZOovVOHfkQklZFo//I2qxSHtZrtNdz435pERMccTyiPJtMSMRDymDHcAqVQNSK67gCbqfAYIxLQBqFb4ojgTsgaUj8+NSxE3TEaLDiCMis9mgMCBimluBmmDc9KcN9Ux2a1O0XqcC3lZObxOgjZFMD/QoWKyIw1WfWTiopksM2pgBtggfSqobrA//r+yss1gxgyT7i8gyHT9JgUbCtqkk/LC2mDd4KR62uHNAw9x3w+uPS9BIvBwnwBB/xjezWEN0AdH5xydc3TO0TlH5ww7p/8HvbPpe1ZmW5SQiGD0lBXrctMGz65MS+uKNnyzqyP0kNn1pmyD+zz7/vvhrcudJyy+8rxa/AD3SSuLNQsAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "35",
    "Fitting Outside Diameter 2": "16",
    "Fitting Outside Radius 1": "17",
    "Fitting Outside Radius 2": "8",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "17",
    "Insulation Radius 2": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "9",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1173",
    "Max Fitting Outside Diameter 12": "35",
    "Maximum Size": "32",
    "Minimum Size": "15",
    "Nominal Diameter 1": "32",
    "Nominal Diameter 2": "15",
    "Nominal Radius 1": "16",
    "Nominal Radius 2": "8",
    OffsetHeight: "16",
    OffsetWidth: "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "55199.9",
    Size: "32 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size 1": "14",
    "Tick Size 2": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "813623",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.31618954",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNo82zqSlQQdFGK4KJ0UTW0gZhIjUIp/XfjC9zNDGdmqhGKo9kPVw05bP3RlPoUGtdaDQgKb1y4QV6NHxkRRnFGhJzPUooFZxKm+sct+r4ZIhyDlWkuOuge8gQnCHbataF7mZRxhaD0oQnGO8hTzGUilaBxU7FMCYHgYM7/8EabtgtvTzlDsLb68W0TgiXJYmXprY9n7m7tVD8BFONjb9MAAAA=",
    Pbi3DGeometry:
      "6ysAAB+LCAAAAAAABADtWE1r3DAQ/S8+O4v1LSWn0hYK7SG0hR5CDglZEsN2XbbbQgj571VWspuV/DTeHosICVnPaj7ezJuR5+qpubztvz7+WDfnzcfhtv8ybPq7pm0uh367/9mcXz2Ff724u/A/zXP798kZ67qLwx//2zxfj8fe7HY3j/6sFCvLtWnPmFgpZ2TL+cpwq1svMMawg0BbIeYFXL9+bo0WxIFEAG1jwWRjoe1Jk2F8mU9kFEZw+yKwQslZgTGWHdseT2hZeo4VjT79u2B0FvqENC2PzkinEsj9Nw8CIUu5sMpFyJ1gSS5MFJiQCy2JuBVTxwItbNkp+kQaH/SqEAeoTuN4PKEOJyznvJy/TNBpS3iFAqTdTUimbHjMVMifx/A4CuGCQGtxZFozZmZZ6QXBtOKiaGJKRqfUIWzlH5TqWSYwKanLlWOFC6YND6YtE2XEIX6nFyFEkPRKK2nmSypVhU+cmm4po6Ig8IBwyjSozcWgZ40N9+00PGgDG4dxoMjHUphqRKoEkpTgSkR0ldaB4FEwUUOwEKA1y6iRcQlqmgTShjCYLmd8OqBjFFK5hVGkJjDoZFWlEBaKhxgb8JaQI4ICRFDBSoAYwtYGTSCfcHkiJiPmo76NyxkSAA0ymn3kTJwaMQQEqoJIURMLXlUx/TLSIKxINmUlgqYcWYX4bpbedjrmZocZfj/QLoJru5hZx49PJC3aIMJiG06y2dnr54SbzayveTZbC8ap0V0TTshYCzhy5C70CtkwzunIQBfdla4YB7xEo8xip3CeEFSng5u9NEXOwrcput7yNxTU7lNVVrrk0pjwCecJG0cBno4uyZscxFFVclFBr+iYgTjwxZnN3jDTFgMzi8mMiEa3mMUTHt2SIDVhY8edhHx7gcMjGzesizZeamAZm0nSptWDVVF9Gi4JUthprOA9KVeFeijuumPkTM83UXxlThJVMA5sYNgXNx/YK8cGV7ABvQIdg25jsPdkPQbOOqgKDUG6s6OVG2RgRn+EFN0XUjJDzpJ1WJeydSm75NZRl7J1KVuXskX86lK2LmXrUnbeRF3K1qXsQvbVpWxdytalbF3K1qVsXcrWpWxdytalbF3K/v9L2eu2edfffF/v17vmvFt1bfNpvb3fP8QPn4f9zb4ftvHjt/5uEn1Y9/cP+/jh/Wb9+/UX3w6bwSvc/tpsnq//ACROgjvrKwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "24",
    "Center to End": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3152",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1177",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "813627",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.7339623",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAQRf9l1jE0bZomcSUqCLooRXBRuoga2kBMpEahlP678QXu5sw9M7ceoTya/XDVIGHrj6bSp6BcazUgKL1x4QayHj9jVGiGecqK+YxQnArOYWp+3qLv1RDluFgZddFB9yATnCDYadeG7gWE5gJB5YMKxjuQBOdFUgiWxZ+CcsEYgoM5/8sbbdouvJnQGK+tfnyv0xQXVOQIlt76WObu1k7NE88FJZrTAAAA",
    Pbi3DGeometry:
      "3ysAAB+LCAAAAAAABADtmE1r20AQhv+Lzo7Rfu8mp9IWCu0htIUeQg4JMYnAtUrqFkLIf+/WKznWxyPZOS8hIdJo5+OdeWd35+q5uLytvj/9WhXnxef6tvpWr6u7YlFc1tVm+7s4v3pO/0ZxeRF/ipfF65szUZYXuz/xt3i5bpe9e3y8eYprtVo6G/TiTOillKVbSLn0pfWLKPDGqI7AGSf+C1zwo+8HC7yxeloT2WZBzzaa2Av8idGhplDqZFtJpw9X7AXSlWJUoIwVh8bnBaiqFQy8QkHr7lAwZxxtDL3SwnTQDfHDnUAZ3RFQOqwRXYEKKX82NOlovTVHe2uMT6qEnXQKV3B85BXHgQVqXVqhhFZJEHUflUAZvO+qmsWqDwm5Szxz3skksDZ5q1LcQjTvje9E4bxyPQvJdBQ0prXuZANNOGcSHtq70fQxzbRNK6SaZpPXurHtVLI9CzkAeHoVIoTklJfWjZcUaqIVJ6dbtu9Da0GbadPImFnI+zlCJiEeBCC9Z/wg7NdKU/GLTvsCdnvpbcNu3axQYScoVetUUMfwAomEmrwsk0CV0YljqKfaKJQLXU0UBZngYqaKQgRJE1YaFw45S+ERUFwHiCB1NaYeQg4IYuEg6aFlH7FV9cLGPYyTN2di0IERD6YeAkV7FR5HkXuUb64QjGN+36PtbWBj/gTUO+gMtjHnRZg5P8sGXS926DodzGh73q/oE9aZ+OWkjf6u65wWo6l1ZrwWnIkg70yENk9eJk3GTAeO3qJTZMOX7T4TbEiCYCfDoNMzninYJ8oSInUqtAPGDq9FeJHqYY4XEEzGATdEN33EpiMqAW8/vQDfAC6tYBv9M0qrCm/nSD8sz9nM9hN4/A3rlU1UoNwUCFzsFri94wEJiYnbOILI+zvdf3Czcb6X2gjrTMsFzlLxTFTuHNEG1ETUESo+ZWICKU9kI0Iox+uNj914vAbjbINhn+s92CoH/Q37AnnF4zyqBQwDWwzmiVWNVy7GjUMAbviccawRzDhxmSjL2cjj2DyOzePY0RV5HJvHsXkcO5aLPI7N49jJKPI4No9j8zg2j2PzODaPY/M4No9j8zg2j2PzODaPY/M4lsex14viQ3Xzc7VdPRbn5bJcFF9Wm/vtQ/Pwtd7ebKt60zz+qO72ok+r6v5h2zx8XK/+Hn74vl7XUeHmz3r9cv0P6Fyxpd8rAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "24",
    "Center to End": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3152",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1180",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468.1",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "815270",
    Name: "M_Cap - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.98708373",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzGnG5z6xQVBHUQCTqIB62hg7WFrUDE797Cott7j9+PV01QtOY03jUoOPjWlPoSGtdZDQgKb1x4gKqmJUaEMyzylK4SKjHJBIW5/nHrYWjGCMdha5qbDnoARTBBcNSuC/2nUMYogtKHJhjvQCWYCSIkTykXMssl5wjO5rrAjBKJYK9N14e/vLP69bUp5lIwBBtvffxyT2vn+g2LSrrr0gAAAA==",
    Pbi3DGeometry:
      "tQkAAB+LCAAAAAAABAClVtFKwzAU/Zc815CmTZpsT6KCoA9DBR/GHjZWtkBtZFZhjP270Xa1pLnt3WRsLKc3J+eenITOD2S2Mi/795xMyINdmWdbmDWJyMyasvogk/mh/uses6n7kGP0h1zFjE1/f9yXHBenade73XLv5kpBpRAyirmmXCoecSp1JiKH65ipEC54DbM0Q8BhFklZotLzaRRVXHbxRnwPh+qD9LAan17/zA/Qn3CPfgSGWPwdqfG+So/Hqz+fJ1yP19marONaTyyyDMEPuaZiUdMkWiECiCtv2QGRUOwzlfABc/B4lsruumPHDVvf8qtUd2044Vj9UL/tukF++AhB+iF+KFRQeLA8oz4g+xrrFzwUUDyHc9i/2Wo/FdWJHKr3+oUOb4/fr/f23a0rnAD46vRy3tOJXReqP++q9dz31A+4HOwW6mrABaRrY5cVIL8JD9pkqB7iB8Pwz7B5l/DFIRndxoBO9w50a5ZveZXvyIRRFpHHvNxU22bwZKtlZWzZDF/Nun10n5vNtmoGd0X+1S28sYV1hOVnURwX30hBisu1CQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-10000",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "156",
    "Fitting Outside Radius": "78",
    Height: "78",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1181",
    "Maximum Size": "150",
    "Minimum Size": "150",
    "Nominal Diameter": "150",
    "Nominal Radius": "75",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "150 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "150 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "815983",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.07421877",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/zzG3ly6TlFBUAeRoIN40Bo6WFvYCkT87i2z2/Pye3jKEfLGnIeHBgVH35hCX0PtWqsBQe6NC09Q5fiTERGYM07XlAicEC5hqv7Ypu/rIbIx2Jn6roPuQRFMEJy0a0M3G5oyBIUPdTDegeKYCppkTCY8SbNVximCi7ktcMoFgoM2bRdmL7/13ur3smYEc5JJBFtvfTxzL2un6gOs4SPx0gAAAA==",
    Pbi3DGeometry:
      "gQcAAB+LCAAAAAAABADtlVFrgzAQx79LnjO5xJiofRrbYLA9lG2wh9IHS0MbyMxw2aAUv/uC2s1KbyLsUUTxfvnn7yWXw9WRLDfm5fCuSU4e3MY8O2u2hJKlM6X/IPnq2L6GYViEi9T0l1wxgEXzCDep16dp11VVHMJcEcUgUspAREIpSTlEsWCc9njCZMtlnPa5yKDlLFVnep6pSz6ofuDPY9ZyAazvc+IiTUTDFT/TC6n4RT3CE86yhkMm//ru2P4M1zU1nzEfNM8Bx/Z/bF2oHvGfWvep9UXzRHzQ8zDgWB1H64LpEX+0X+b+mvtr7q9/7a/wP7s1xZv2uiI5REDJoy53ft8FT84X3riyC1/N9mfoXpvd3nfBndVffeGNsy4Ylp/W1utv1NJKMoEHAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "22",
    "Fitting Outside Diameter 2": "16",
    "Fitting Outside Radius 1": "11",
    "Fitting Outside Radius 2": "8",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "11",
    "Insulation Radius 2": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "6",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1456",
    "Max Fitting Outside Diameter 12": "22",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 1": "20",
    "Nominal Diameter 2": "15",
    "Nominal Radius 1": "10",
    "Nominal Radius 2": "8",
    OffsetHeight: "10",
    OffsetWidth: "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1116763.3",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size 1": "9",
    "Tick Size 2": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "816080",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.27153252",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABAC1Tt0KgjAYfZfveozptKVdSQVBXUgEXYgXSmN+sPaFrUDEd2+g9QbdnT/OOdUIZYuX4aEhhyO1WJIdDDlgUBI6/4S8GmcYAqnkKlPxJhIJT4VcwcT+Y9bf+aLvmyF8CMIOm7v2uodccMHgpJ3x3ULO5BuP4fZMr3j7WQeNpgsrEV9LpRjsrX4v2VjwJMokgy1ZCr3uZe1UfwCry0z1EwEAAA==",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABAClVt9rwjAQ/l/ynJU0TewPn8Y2GGwPsg32ID4oBg10zeiygUj/96W2WtN6JFVEa+7rfXeXu3ztfI9mK/mx+xYoQy9qJd9VLtcIo5mShf5B2Xzf/DUwmZoPqnBnuQsJmR5+zBdVi6PbfVkud8aXR0E84SkOCQs4iSaYkoCFaYRrII3pAWAxZRYQ87ABkpBbAEh19OCUxxdj8Iil50BCEzYyKzC4s0Dv4O6sBlT19VLlJ2CwiVCBcHC7HzSoQw2ZOru9IcP7myI6u909N4+Lv5dPrzCnHcwTiNvrgZPn6nz6ddkthvIEjwnUAA8Hz7PgbjG01dC8exLdIg1g25xHzRHCOTCg3W9gwIxGO4yXKmgoPQTJk8k99pAcgYLnR3SLpoI5gY84EPBjctv9RNVD/T0dGsC8GTzK5ZfQokQZCQhGr6LY6G27eFN6qaUq2uWnXJ+gZyE3W90unnLxd37jg8qVISx+87xa/AN5HolmywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2424",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2984",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5682.85 /",
    "Friction Factor": "0.024154",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6224",
    Length: "560",
    Mark: "866",
    Material: "Copper",
    "Middle Elevation": "2424",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3183.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "28626.08509",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "146",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2424",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2984",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "816082",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.57629455",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jV0LgjAYhf/Lez3GPtx0dhUVBHUhEnQhXmgNHawtbAUi/vcW2t15Ds/hVBMUrbmMTw05nHxrSn0LjeusBgSFNy68IK+mJUZFcJyqlG0oSbAgXMJc/73tMDRjlGOxN81DBz1ATjBBcNauC/0PqJAMQelDE4x3kHNMEyoUk4KLTKWKUwRXc19lqjIER226PiycSAQHqz/rmhHMSZIi2Hnr45l7WzvXX5r4UxDTAAAA",
    Pbi3DGeometry:
      "YRwAAB+LCAAAAAAABADtV91LwzAQ/1/yXEfSpE07n0QFQR9EBR9kDxsWV6irzCoM2f9uqam6pL9d6sdbGBvLXe4zd5f87t7Y5aK82TwVbMrO60V5XVflPYvYZV2ummc2vXv7+Nuy+WH7Ydvoi3IgOD/sftov2856saP1er5pZRM5yXQiI8HVJOEyjWI+kVrraIchk7hjxHKYnuRqh6H0/v02HRpGjN6Ar+FeD1d+ke3q0SIXgwG7DFvACsCDATQBjwiy4ycySwWM4jIJxQY018ZAlnSM1DBSw/CX8A7CrgqnjGS7/lV99XSoSOjUCEj1EYRIO1/zVkPHSI0qJWKvo7NOyFsPcXLQU6qn7FSMjvjHTeubCTJFeCzY5Q1VkcVqH2evKVFceDkFe1GnmaHLbDDh2AQ1h+2wbU1ofnoIkIODGNEjfPIe0rYAzCyUwMMMqYIS9F1DXtN9S8b9dIoz/b04R9z4VNliG+SMdRhQlUjUjldK5KYF8kG6Y5tkQE29adPG9n6LTG1HAfhut4uGDhg4NP7i2iMBTMBcgJGJbxCQJZQN3FvwKsKm/+75gs4apmNU6eFs+BbTL2YWUd5OV6FOh6bhCPBvdacInOsRGh8/40aPsj0pISaTw/AFYeQr+cfwj35X/Tue268oALoA6AKgC4AuALoA6IYlAqALgM5jewB0AdAFQBcA3X8BulnETsr5Y9EUazblEx6xi2L10CzN4qpu5k1Zr8zytrz/ZJ0V5cOyMYvTqnj9vvG4rupW4eqlqrazdwtZv0NhHAAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "24",
    "Center to End Label": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1459",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "816083",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.47081805",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjksLwjAQhP/LnkNI+raeRAVBD0UED6WHFkO7ELNSo1BK/7vB1tfJ28x+w+zkPWQVHrqLghS2VGFGuqvJAIOM0NgrpHk/ShcIeJAk0VwKJ6JYwsA+LPR5LGfyPwwD8Qu/WkdWvJ4v2rbs3AJ3WGF5Vla1kAouGOyUqW0zmT3Z0qIbPdojnt5oo7Bu7NNEXshgrdV9ynqC+5LBkjS5VnPTeigebIsTSA8BAAA=",
    Pbi3DGeometry:
      "swgAAB+LCAAAAAAABAClVt9LwzAQ/l/yXEvapD/WPYkKgj4MFXwYe+hY2AK1kRqFMfq/m27dTGvOXJGx0Xz33Xd3ae6y5YEs1vJl/y5IQR7UWj6rSm5IQBZK1vqDFMvD6dGY6dx8SBv8IFcRpfPjj/mSdnV2u26acm98ecjzPA0iah6ymAcxDRmP4sDCE8rSIx7ZKM+j5ITOhjigcuGnjDnVszgZ4IzPJmQDRfXVhI3qy2asEyeZs9ozPto1d1WDqAkLs87r1+bbBktnwLe3wcnv8ndG6ApASfljjFKFioMNYLJgaPs1oKT+kVXkDv1Xf4A7DjUOymHyGwJDgMcbdWwQfYLiozLyNRz+BIAeoAEzNEAlzJTB8FEZQePHxnGnHvQADe4RN617ABE/258JeKFNnbUQHzZgLi9Qacrda/jmH8CtLN+EFg0paEgD8ijqrd71iyelSy1V3S9f5eZiuhdyu9P94q4SXzbxRlXKCNafVdWuvgG/XEtzswgAAA==",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.6 /",
    "Flow State": "Turbulent",
    Friction: "1010251.34 /",
    "Friction Factor": "0.015075",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "15005",
    Mark: "867",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15159280.1",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "483127.9625",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "46",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "816090",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.07826689",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjT0LwjAYhP/LO4eQpm3SxElUEHQoRXAoHVINbSAmUqNQSv+78Qvc7o7n7uoJytYcxqsGCTvfmkqfgnKd1YCg9MaFG8h6+siI5CnmgtNFQnIsRMZgbn7cchjUGOEYrI266KAHkAQTBHvtutC/TEIyiqDyQQXjHcgE55xwwVLKuMgKwRiCozn/w1ttuj68lzgVCDZWP75tSjHlvECw8tbHM3e3dm6ezelsmNMAAAA=",
    Pbi3DGeometry:
      "HhgAAB+LCAAAAAAABADtV01L60AU/S+zzguT+U5diQqCLsQnvIV00WLQQGykRkGk/93xZaw2yZlMUNHFUFqa3N5zc+6cO3N6+UzOluXF011BZuSkXpZ/66q8Igk5q8tVc09ml8/tVxume/ZFNsn7nT8ZpXv/P+ybbOZvafvr9eLJ5kqeGs5VklGZ5lzzhLGUZ4InNqB1vnOfGaZf75tMirAAFzL3IqHSwUjb+4rqz5EYR+L5K5RKacbyj1AuYDO0EgMBm8GzbBhqOAChbEAaNpwBAw5qS7DLoxOAUDCjzwN211CRtQGldBuwtXwLa4RsAzk3bUBrL5KhzLgManZoKOEeSknVZohp4nnXCEJCTwtXA3cKz4bl2RYXu01HxHGrEBTmYZRxUjAyTCOwubCJUjjmknWearQ4HLTeU4HiWKCTlxbP03TmMGP6+I/w6PfKIx+k3ckSxUs7ef5xr9A0464b7pCYbndjzr2axsSDT7r+4dE9brodYYbmg0u+PeuCNwYLJfw1UEswFDqAUQLuIWwVXCd4nCJ+HoGijiDleggiHqBV4ZvuuPMInrOOqvo1MD8oN3jcwAVEHYEDCGUIS0yWevieOy5QuPWgGp49F7ny7/f3v9uuj3kCuONON8ahfwl+2q53Rzna9WjXo12Pdj3a9WjXo12Pdj3a9S+w6/OEHJaL26Ip1mRGU5qQ02J13dy4i/O6WTRlvXKX/8qrbei4KK9vGndxVBWPH394UFe1BVw9VNVm/gJY8NfuHhgAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3001",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1159",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "816092",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.07648326",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjT0LwjAYhP/LO4eQpk3SxElUEHQoRXAoHVoNbSAmUqNQSv+78Qvc7o7n7qoJitYcxqsGBTvfmlKfQuM6qwFB4Y0LN1DV9JERYSkWUtBFQjLMSMphrn/cchiaMcIxWJvmooMeQBFMEOy160L/MrFGEZQ+NMF4ByrBTBAheUq5kFkuOUdwNOd/eKtN14f3kkxzBBurH982pZgygWDlrY9f7m7tXD8BzH+T+9IAAAA=",
    Pbi3DGeometry:
      "6RcAAB+LCAAAAAAABADtVl1L5DAU/S95rkM+mo+OT4sKwu6D6MI+yDyMWLRQpzJbBZH57xvbTkdjT5KCyD6EYYbpTXNu7rknybl+JRc31e+Xx5Isyc/mprpq6uqWZOSiqTbtX7K8fu3/2mF6bD9klx0iR4zS4+7HfslutZ/2Y7tdv9i5Uix0oXnGaL7Ilf3D+YJLndm44cZ0cclZMRXPjczfxbWSaiqOcFBehDPGEY7MKYvJi/CDOIp2OEJwOTnAC8U+Iu1nSGq8A/FQXOtpqHFgpMmFcgf2dcRDwRljgbB3Yuh1oXQXN0p4m6rEQAizL75lYCL3I41yKgzrZ9B+sUoNKYTq12Sk8DUcrwkB4cWGeoE06O6JMW646lMLE6g6yJMLBasYeWJ5rwLDI+XhEhvuhOrL1kx7UwcF+GlNnuYhac7uKt5IswsPz4jf97F1HLgK7VYo22h5Qk3N3ve4scH74iPn9hAeBt546JB47tVzuGxwpcIr0r1iBFWTdIQvDJdxIxibJNCXY5oPDIUsA5oAGfQwBdaECIHleZgKzXBEG+ZjriVyEyB9RDgNd6mxgjpIMNg7tLcnmhpqXqS18xCOJDtX5PCgxUqLOD/Q9YYOcyScSN/wVR7+f/Pk8Ub6cKfNdb9f4Pu/05OHK0+ePHny5MmTJ0+ePHny5MmTJ0+ePNqTrzJyWq0fyrbckiVd0Iz8Kjd37f3wcNm067ZqNsPjn+p2HDovq7v7dng4q8vn9y+eNHVjATdPdb1b/QOO++eN6RcAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3001",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1460",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2826.1",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "816161",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.18840842",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjUELgjAcxb/L/zzG3HRz6xQVBHUQCTqIB62hg7WFrUDE796wgm7v9/g9XjVB0ZrTeNeg4OBbU+pLaFxnNSAovHHhAaqaPjEqgmMqJFslJMUZYRzm+ueth6EZoxyLrWluOugBFMEEwVG7LvQLSJYjKH1ogvEOVIIzQYTkjHIh01xyjuBsrv/yXpuuDwtzmiHYWf36rinBLEGw8dbHK/e0dq7fjfmuZNEAAAA=",
    Pbi3DGeometry:
      "aRwAAB+LCAAAAAAABADtV8uK2zAU/Ret3aCXZTlZlc5AoV0MbaGLIYsMYxKDJx5StxBC/r3qRE7Hso4lZy1CQqyr+zj36ft4Ig9P9Y/ja0WW5Ev7VH9vm/qZZOShrffdL7J8PF3+GjJdmQ85Z/9PPjBKV28/5kvO657t4+GwORreQi0EZTJjVC5kzvKM04VQQmSGwItSDAks895nZYDAqBoSJON+jl51XnCvKGDT+Ljg+UxBkAO6o+eI9RME1xOkZl4/YRTcEnIq1Dt39MdGoP/+ldCrvgoyuqYJc1W7grBNBZcD1CMNvcPDxvptyoUs/RoguJkasF9dDDCblLRJoLWMS0xpz5USA3Tx6RTMTGhUfLhD1kLdMD+QpPk2BeGNwjfiYHGFOsp+IAj0OSgfEmASwKwJeRWVKSxsp1YA4vieFcYMIGhZWIP0pQ/wUk9OLhOGHsFFEtN88jzUgNw+U5ZWcSn4YDLGj8zQ9OW6zB2CnAYRCJCDDUlB0GAU+L9qfCMwMAfc9h1kcN2NGKBJSNKEt5Eo6A9Q6iAKMJoQNLRoZvzRdWQRzGGc9fCVaYQh52p6ULvWKpD0CrkvOMFHuJWeVg2nDCTAlwSoGzkKu3Z+MBA+aFT8+9d1IINCDUYvOKct4YZUg7ARA6z46L4VtAlISjtd2unSTpd2uklC2unSTpd2urTTebClnW7o7bTTpZ3OryLtdGmnm9e3btnp1hm5qzcvVVcdyJIuaEa+Vvttt7MP39pu09Xt3j7+rJ+vpM9Vvd119uG+qf68v/ipbVojcP+7ac7rvxm4aqJpHAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "16",
    "Center Spacing": "16",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "10",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1446",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    Offset: "60",
    "Overall Size": "15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5137219.8",
    Radius: "10",
    Size: "15 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "8",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "816163",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.66815233",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/zzGXnS6dYoKgjqIBB3Ew6qhg7WFrUDE756Z3Z6X38NTDVBc7Kl/GFBwCBdbmmvUvnEGEBTB+vgEVQ0/OSGZwIxlfEVJglPCBYz1n1t3ne4neAq2Vt9NNB0oggmCo/FNbGdDc4agDFFHGzwojmlCU8lEytNcZpJTBGd7W+CcJwj2xjZtnL341jtn3suaEcyJFAg2wYXpzL+cG+sPCgK2h9MAAAA=",
    Pbi3DGeometry:
      "pQcAAB+LCAAAAAAABADtVVFLwzAQ/i95juWSpUnbPYkKgj4MFXwYe+hY2AKxkRqFMfrfDW2nrdvZCj6W0tK7777v7no5ujyQxdo87V81ycidW5tHZ82GULJwpvBvJFsemtcAwzxcpKLfngsGMK8f4SbV6ki7LMt8H7hKRhxSykBEQipOOUQzwTjt+GPO0tqveNL1iyQWtR9S2YsXwM7poPE/9XmoowFS1RM6AiIFWQNy1mcIpeR5BgbETDYAS9TvybHuBqs9STGohBCwD3jiR7vGJj1IwDKgpY7OgM50UAkhYMd1/DH786SHMozubdq4aeOmjfvnjQv/vGuTv2ivS5JBBJTc62Lrd63x4HzujSta89lsvqBbbbY73xo3Vn90A6+cdUGweLe2Wn0CF+p38aUHAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "16",
    "Fitting Outside Diameter 2": "22",
    "Fitting Outside Radius 1": "8",
    "Fitting Outside Radius 2": "11",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "8",
    "Insulation Radius 2": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "6",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1457",
    "Max Fitting Outside Diameter 12": "22",
    "Maximum Size": "20",
    "Minimum Size": "15",
    "Nominal Diameter 1": "15",
    "Nominal Diameter 2": "20",
    "Nominal Radius 1": "8",
    "Nominal Radius 2": "10",
    OffsetHeight: "7.5",
    OffsetWidth: "7.5",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1251459.2",
    Size: "20 mmø-15 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size 1": "6",
    "Tick Size 2": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "No",
    "Visibility 3": "Yes",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "816181",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.91191231",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyGkNU21nkQFQQ9FBA+lhxZDuxCzUqNQSt/dYOvfydvOfsPMZB2kJR7ai4YEtlRiSqatyAKDlNC6KyRZN5zeoCY8UnI6D4TkUsUB9OwDY8VDMfvLIil+2XfoAPNX+aJpitYv8I8VFmftdAOJ4ILBTtvK1aPYkysc+tGDPOLpjTYaq9o9hQojBmuj76M3FHwSMFiSIZ9qb8b0+QPDShRIDwEAAA==",
    Pbi3DGeometry:
      "swgAAB+LCAAAAAAABACdVt1rwjAQ/1/ynJV8tbX1aWyDwfYg22AP4oNi0EDXjC4biPR/X9TqUu3Z6yiW5j5+97tL7uJ0SyYL87b51CQnT3ZhXm1hloSSiTWl+yL5dHv49Go29g+p6Z/khjM23r/8j9Szo9ttVc033jeRUZyoEeVMRSoVigoWScUFDRUxk8lewVtiNeLxQZydKSCgk0ciZXeEVMRthVTZIE5g6N7k8KF7OV1AiTjtzvuoOC8hkF4rdJpEgmWXWxHIA5jQOqxFl/WOfxf6jj4Cpxe/zRHICZRDLKGoYfEROP/mwzujXm0OqMhg06AcBm4LFAA+zphzgmoMnAeKU2+LYbcfsofkqDEBAeHmCsoDxQmcN6ECc+ghe0gOzLNhvQOhIOz7ucDX2bDhCliDctSNBQENu3a9h/8HcG/mH9rpiuQsYpQ863Ll1s3ixbq5M7Zslu9meVI9arNau2bxUOif0PDOFtYDlt9FUc9+AWPG53GzCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "3854",
    Mark: "868",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "48",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "816184",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.91115258",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrkNIkzaPuhIVBF2UIrgoXbQa2kBMpEahlP678QXuZoYzM9UERWsO41VDDjvfmlKfQuM6qwFB4Y0LN8ir6SMjwhlOJeeLhApMWAZz/cOWw9CMkY3B2jQXHfQAOcEEwV67LvQvk5CUIih9aILxDvIEZ4IIxRnlQqVScY7gaM7/8Fabrg/vJcUkgo3Vj2+bEkwlUwhW3vp45u7WzvUTc98sO9IAAAA=",
    Pbi3DGeometry:
      "8BcAAB+LCAAAAAAABADtVk1r4zAQ/S86e40+LMlOT6W7sNAewu7CHkIOKTWNwY2X1C2Ukv9ex1aSbqwnyVBKDyIkxBrPG83MG+ktXsn8tvrz8q8kM3Ld3Fa/m7q6IwmZN9WmfSSzxevwtzPTi+5Ddslp5Ruj9KL/6b5ktzy4XW63q5fOV4k0y5VKGNcp1UwmnKY8F0WyN0jJBgNTud0ghXhvkCznVgOGQsEh1Mlgh1JpUeQqKDjergeqM2jdQwlZZHYDF/8jHda11m5DMBLNAJIxmPRGSOP1QxLhSNDDZIHbx6lpeMZ7Bya4s63SLHPe44iMZi6cE6Ey2rdOCD04MG2QqEFinDubjbeEoNBe3Y2A/LOM5NEgFRsiU+1O21unMySQw+l9ng0BVMfTMG6M6urvBB/S3nu6gvv4N96Vo3eAmNN66pihqVkHeIROfGgOhyJ5hxQSNpSXmE/T5h33M+CeOGOZlCYEVUMMWggnkwPShneq/Ya03SwCTKT7orCUXHJtPQocEUBBIBJUDMABFtBRJ7QnUA6YHa6T1+P8GPLWY7oeGoVA/PAoDBtUMKOOHPS1D073uK/O9k2SdbDoKMRknkPNBcnmP0KsVxs8y13cCVYNHyfkv6gsDxfTRxkwVQN/gPT/RF3uyTvq8qjLoy6Pujzq8qjLoy6Pujzq8iBdvkzI92r1ULbllsxoShNyU27u27V5+NW0q7ZqNubxb3V3NP0sq/t1ax5+1OXz+xevmrrpADdPdb1bvgEfDk7C8BcAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1453",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "816188",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.68201697",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO4eQNB9t6iQqCDqUIjiUDq2GNhATqVEopf/dqHW7O567qyYoWnMa7xpyOPjWlPoSGtdZDQgKb1x4QF5NPxkRyTDPpFxRwrEgTMJc/7n1MDRjhGOwNc1NBz1ATjBBcNSuC/3HUCETBKUPTTDeQc4w5VSoRAomMpUqRhGczXWBqcoQ7LXp+vBdShOFYGf1a2knBDPCUwQbb308c09r5/oN3kHksdMAAAA=",
    Pbi3DGeometry:
      "1RwAAB+LCAAAAAAABADtV9FKwzAU/Zc815GkadrNJ1FB0AdRwQfZw8SihbrKrILI/t2yNp1LdnZTHYIQZLLu7N6T3Nycu3P3yS7vi5uPl5xN2Hl1X1xXZfHAInZZFfP6lU3uPtu3DcwPmz+2jNafHAjOD1f/mhdbTk3Y0WIx+2hidTxKtMoiwdUoUVxEko9iJWT0HVBZolYAH+sNIJFivBXoI1KZeaZC5Bgw5JDDAXQqh23QTqV4lmzdeQ/YqdYR1j5oAKaCq6KX6wAkOeRwVmVVF3NoLlsg7gCt4xWQGMA7gq4u6hKnr2QsfthwDgBT8bQDpGqBVKjVcjOtW4DHugXS1O8EnYMiU+Gjte8HWi591ZySDN75Pq4zWRK6VpDD7naYiu5d+2idVFztXhW+nFrLzbIL4UkBJZHceJcKqqtHBNyfr4LTHD9QcDsCFRcGYH0DmWAAOYdoFTMHK4xYmf4UWgycwGTRIQctujYAU3E1boFMpJvHlKmtwJrcAM4osACcyiE3d9mJ6AXROwLug4zo28d3g3BVw0fajgjEgUsCJBRPFVgrVBJ81eCAwuT7+32DzxyWZGgn4pLQffVrHfNvdkquEDfUBY/rT7aCmZqIe7juDZa3HQXxFitv+wYN3z69I5rxf+EEvR1tcILBCQYnGJxgcILBCQYnGJxgcILBCQYnGJzg/3eC04idFLPnvM4XbMJHPGIX+fyxfuoerqp6VhfVvHu8LR566CwvHp/q7uG0zN+/f/G4Kqsm4fytLJfTL3B3cOfVHAAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "24",
    "Center to End Label": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1458",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "816189",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.88063454",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KgzAQhN9lzyFEk6jYU7GFQnuQUuhBPCgNupAmxaYFEd+9odq/U287+w0zUwyQ13joLwpS2Noac6v7xhogkFs07gppMUynN0hOk1jyRcAEFVEcwEg+MOJUsET+h1KwX/gdO8HyVb/suqr3G/xjhdVZOdVByigjsFOmce0s9tZVDv3sSR7x9EYbhU3rniIKJYG1VvfZGzLKAwKZ1danmpvWY/kAxuykYREBAAA=",
    Pbi3DGeometry:
      "3QgAAB+LCAAAAAAABAClVlFrgzAQ/i95ziQxiVr7NLbBYHso22APpQ+WhjbgzHBuUIr/fWlru2i9ejKkYvLdfd9dkrt0viOzpXnbfmqSkie7NK82NytCycyaovoi6Xx3/HQwm7qH1PRv5oYzNj283I/Ui5PbbVlmW+erRJDESlDOZCDjUNKQBULykPqAYiI6ALw1LROujtOTDgARnT0iIfoV4lC1ASEno2ICpQeTw0sPxnRBFaq4P+8T0F1CIL2WdCQCyRJ1uRc+4BG17P3l6LXf59CrsM8BRTWs0QkVSg4GwGBBaX8nUFT/iIr3S18tF3DJwTrCeYzeJFADPuWoo4MqGJwHLqrB2sMfBdADBFA9BKTCdR2UBy4qsB35AK4IQA8QAFreyGqCaBD2iGjgO29sA4bsYQB1tYFU4y5o5+H+K9yb7ENXuiQpCxglz7pYV5tm8GKrrDK2aIbvZnWGHrVZb6pm8JDrH9/wzubWERbfeV4vfgGDmawV3QgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2390",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2400",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.2 /",
    "Flow State": "Turbulent",
    Friction: "1127025.83 /",
    "Friction Factor": "0.014989",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6192",
    Length: "2906",
    Mark: "869",
    Material: "Copper",
    "Middle Elevation": "2400",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3274819.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "511754.0476",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "47",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2400",
    "System Classification": "Hydronic Supply",
    "System Name": "Hydronic Supply",
    "System Type": "Hydronic Supply",
    "Top Elevation": "2410",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "49.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "817389",
    Name: "M_Cap - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.97477256",
    Cost: "0",
    Level: "Roof Level",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjT0LwjAYhP/LO4eQ9CNp4iQqCDqUIjiUDqmGNhATqVEopf/dSBW3u+O5u3qCsjWn8a5BwsG3ptKXoFxnNSAovXHhAbKeFhkRVmDCRbGiicAk4xTm5seth0GNEY7B1qibDnoASTBBcNSuC/3HUE4FgsoHFYx3ICnOedxjacK4yArBGIKzuS5wmmcJgr02XR/+5Z3Vr287wbwgMdp46+OXe1o7N2/A9VNW0gAAAA==",
    Pbi3DGeometry:
      "wQkAAB+LCAAAAAAABACdVlFrwjAQ/i957kISlybRJ9kGg+1BtsEexAfFooGuGa4biPjfl61dpiaXRJFK8/X63XeXu0unOzRZ6Jfte4WG6MEs9LOp9RIVaGJ0036g4XTX3drHZGR/aF/8I1eUkNHvn73Qfvb32nizmW/tu6XASg1UQZnCVHFVMCwkUUUpMS25iOASSyVZPu7xME47nFwL6nCrhwjl4xC/05+pB+KH8uDzK85kiL/Dff44DvH4eYvjvv5MvxC/p+d0v5J+OZUdzgZHeeakt2eUH9kDOLRfmXlO+w3phOvW0sv8fYnUPxFHfl2eiRSHOlP2iT719OTqh+KF+vdS/WH+ZD8m4zrXPl7n0LyC4o30BRRXvA79fuzyKbESNKDnB2elvy8+DsV1WR4CfkM64bnd74s/V4NzGOJx+XR+T+aM05m0h/iBcyFXPxRvcr6dpR/izz/Hz+VJ5uGyuX0Sb/Lc9HSG6tB+D93q+VvVVhs0JJgU6LFqVu26XzyZdt5q0/TLV710j+4rvVq3/eKurr4ODW9MbSxh81nX+9k3yxAqTMEJAAA=",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-10000",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "105",
    "Fitting Outside Radius": "52",
    Height: "52",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1461",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "817492",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.45725665",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzGpnNz6xQVBHUQCTqIB62hg7WFrUDE795CpNt7j997r5qgaM1lfGpQcPKtKfUtNK6zGhAU3rjwAlVNi4wIzzERMt/QRGLCBIW5XrntMDRjhGOwN81DBz2AIpggOGvXhf5nWCIogtKHJhjvQFGcibjH04QLyXLJOYKruS9wKolAcNSm68O/fLD6s7YJziSL2c5bH8/c29q5/gLDwOdr0wAAAA==",
    Pbi3DGeometry:
      "pzMAAB+LCAAAAAAABADtWUtvEzEQ/i97DiuP1+tHe0KAhASHCpA4VD20atSuFBJUAlJV9b/j7CPZXc+3djhxsBCIeOJ5fvNw5vqluLprvj3/XBcXxafdXfN1t2nui1VxtWu2+1/FxfVL919PFpf+T/G6Op28ISEu23/83+L1Zrj29unp9tnf1bYUxtkVSVdKsm5FVApJcuUJUlrjCbZ0moghuJKqanzec7KlNbVM4gRlA4IpXUWh6OEYCghVigiIGS3K2ilibDsRZhISCDFWgxVRwtyK+XlgRIQP+j5jGznZXXBVS9Ba2JagpO4Jpp7cELXqCEZPJNe27s61tS0nW7uWoG0volZ1VNfTsVBm5oqq5+OtORCM0jbd5hGURE8gK1tNnapUaFr0wkHyQFDatARhqkVOynVOkkKr1knKdhc0yZ5gp4jh4wBlg4w727j0XPc3jLdqKaAocDxklrwxF62r2i4A3By84iZwssLbvwgzkInWDn6iLnSmBwHE9/kZwctASbdULrsL3gxiPRipHKPymua/hIKP4MoLWCg00El8LUMtImobU9enXkVNCF44o5gFsIRugimBSwpbhJL9Ecaax8A/+29cL1EXwn0LVdjEVEnIITge+XyWLCs4KZARUzD787YEkiM1qhEjVoJoUlWcdC38iQRNLHc+0Q5mOKtGOBhpS2bk2/Q5MrRC1j2rOTglzbLedFFCw1nvwKDOkerxQaJmvs/ELjLazjG7ZDUybqrsyK8wpkrUE9C6Q2wX/TfVNoBgOPSgYIOmfU6bjzZhUrNRQpsImLGrgG+hUlg2ghSEGmCUhuUxoLSalHjr+/9iBuMbELRnYxNBMFIMuHyJKTv3RwTkTFmB6Ic1EFbN5Scwkxa4avJlFsIjmtvLbztY0xKqI4jpAgiAbbB9ofqLVDr5Wws99vfRGwPBumoyZ6adQ0YMwUgyrE5dPQtFdBew6GRGcZXwixN5A43X8BHCGjcau49GGNsRlOqt89p14CCug3CtZRZsTCCrpwSl5HnCj+MvnBCTozR76QQwiI/kEwlLOvFOT3jlB8rCGR4+tmHAobYwSvC3BD58Sz5PtXtIgNg7NYheamIcsxsah9yBRwmU97CJ4JEBVLvjAHBUqtIdgWah0HXF/4QS/rYygzM0Aw9jimZQI36kHAoCbFXpteU0nfKyExwyE4H7J3J6dHac4n9paoCjDww4fHVA4anaHmELOcFmDO2LjksBK+gRFHCIzsTUyCuXvHLJK5e4zXnlklcu3CiWVy555ZJXLnnlklcueeXCW51XLnnlkozlvHLJK5e8cskrl7xyySuXvHLJKxd+lMgrl7xy4cOXVy7/2crlZlW8b25/rPfrp+JClGJVfF5vH/aP/Ycvu/3tvtlt+4/fm/sj6eO6eXjc9x8+bNZ/xl98t9vsPMPt783m9eYv8eUFZKczAAA=",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "65",
    "Center to End Label": "65",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "105",
    "Fitting Outside Radius": "52",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "52",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1468",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø-100 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "42",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "817493",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.78269058",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TksKwjAUvMtbh5CW2E9ciQqCLooILkoXLYb0QcyTGoVQencDrd7A3fyYmXqEqsNLeGhQcKQOK7LBkAMGFaHzT1D1OMMYyAou8rJYJ2nJhcwTmNh/zOY7vxmGNsQPUdhhe9deD6AEFwxO2hnfL+RMvvUYb8/0irefddBo+riS80wmksHe6veSTXm5SgsGW7IUa93L2qn5AJNQqDMSAQAA",
    Pbi3DGeometry:
      "tQgAAB+LCAAAAAAABAClVt1LwzAQ/1/yXEOS9SPpnkQFQR+GCj6MPXQsbIHaSK3CGP3fDbOrW7Nrbkppae7jd5e73K+d78hsaV6275rk5MEuzbMtzYpEZGZN1XyQfL77eXVqNnUXaaNfyRVnbLp/uJu0i4PbdV0XW+ebZlSlIuJCUZ7GKhJUJUJGqaQsU9LJJZWSxb38YC6pEkogxHzC9+gszrhnPggaykVRwSdZMEdJucqyczgiThM/m95+kD0sh/KB4kJ5BnDGi8wZTVTMffxeMagnRn7SLs8BHXm4tWDo4Z6PFKdN8z1AKF8BJDUSHFSAUHAvMKMAFQphDsGPt/SCIp0/rVig/w452DQPKDCFISCMAjyTAYYJIf2dwkJTguY2JNAFMwKSA8TbISQ0QUOECxEl7quGhcHIweEcJYsQ0OgG3D/ArSnedKNrkjPKIvKoq3Wz6RZPtikaY6tu+WpWvepem/Wm6RZ3pf46NryxpXWA1WdZtotvnxsr2LUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "-10000",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-7671",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.0 /",
    "Flow State": "Laminar",
    Friction: "0.00 /",
    "Friction Factor": "0",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "900",
    Length: "2329",
    Mark: "870",
    Material: "Copper",
    "Middle Elevation": "-10000",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "0",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000026",
    "Reynolds Number": "0",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "130",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-10000",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "-7671",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "0.0 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "817500",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.13697327",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzGnG5u6xQVBHUQCTqIB62hg7WFrUDE795QvL33+L33qgmK1tzGtwYFF9+aUj9C4zqrAUHhjQsfUNW0yohwgUkuxS6hElNOOMz1xu2HoRkjHIOjaV466AEUwQTBVbsu9IsRTCIofWiC8Q5Uglke93hKeS4zITlHcDfPFU5ZRhGcten6sPiUJQhOVv+2NsE8IzE7eOvjmftaO9d//SIYYtMAAAA=",
    Pbi3DGeometry:
      "CREAAB+LCAAAAAAABADtVstq3EAQ/Jc5K6Jb8+z1KTiBgH0wSSAHs4c1FrZAXoW1bDBm/91jrZxkxNTkB8TixVJtP6qrZujrV3V10/18+d2qjboYbrofQ9/dqkpdDd1+fFSb69fTvxGms/hRx+rvm09MdDZ9xT913H6EfT4cdi8x1oWajDYVN1Jr42zFVAfyrnoHJKTvtTTv75mdzgZAgBy7BPDecVWq3Vj2E9A4ckkqM6f6AMTbuavACeAMxRq+FvKSTQUiCjXIMqc8xJwA1kmAb7RMtR3ZFHA2TLWDkUxEqakQZFGbpwjyNp26D6acydm0KRf+ww7Kl6UdS1OzCBAJRYdgvfNNFWSFnoIzh6OFPHBXecFL7QL5cFNIVzhDbDbID1kEOgGxQImAc2ABpmBTVRs+AcalhzUIn/wv8bpKACN2ksKbkI3A596TXxTXs0hm4TUdiRVTiUnVE611kSC8hhFxsotmOWqAD0bphkQ9YavlD3hp6HC2gAZ2Ql7w0uUC5YNN5XWFMywRRzIhhyAjYBbQa9A6qMS6I6w7wrojrDvCuiOsO8K6I6w7wqLEtlJfut1DO7YHtaGaKnXZ7u/G+/nh+zDuxm7Yz4+/uts/0Le2u7sf54evffv87w/Ph36ICfdPfX/cvgHSQvvuCREAAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "105",
    "Fitting Outside Diameter 2": "22",
    "Fitting Outside Radius 1": "52",
    "Fitting Outside Radius 2": "11",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "52",
    "Insulation Radius 2": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "26",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1471",
    "Max Fitting Outside Diameter 12": "105",
    "Maximum Size": "100",
    "Minimum Size": "20",
    "Nominal Diameter 1": "100",
    "Nominal Diameter 2": "20",
    "Nominal Radius 1": "50",
    "Nominal Radius 2": "10",
    OffsetHeight: "50",
    OffsetWidth: "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1307682.7",
    Size: "100 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size 1": "42",
    "Tick Size 2": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "817502",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.36039836",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzcsKwjAQBdB/mXUISax5uRIVBF2UIrgoXbQa2kBMpEahlP67USm4mxnOvVOOkDf2NNwNaDiExhbmEmvfOgMI8mB9fIAux9+YCJeYCCVXlCmspBQwVbNb9309JJwOW1vfTDQ9aIIJgqPxbew+CyUZQ1CEWEcbPGiKlyL18QXjQmVScY7gbK//eG9s28Vvk2AKwc6Z15wmWAiazCa4kJ75p3NT9QbOiu/m0wAAAA==",
    Pbi3DGeometry:
      "ARgAAB+LCAAAAAAABADtV01PwkAQ/S97rmS3u90POBk1MdEDURMPhgPGBppUarCaEMJ/t9AVbOlrt5qohw2BsH3MzM6bmd3Hw5qMH5O71UtMhuQqe0xuszR5IgEZZ8kifyXDh3X5tYDpqHiRTXB4csIoHe0+ijfZTD7NTpfL6aqwlXrAmOQBC83AcCYCRgeaKhkUAJVMVgClJNsBRjs919yErY5waFdPe0Bw8bMkuj2FYRQwTgeUSlPxtAO2FopGx8DWIoxYs6tGALraAlEYNltAwLraJ1jPowpAV9CiKQ9ErpaqBCRVO0Cw5jIdKq5YCWilrUW7Jx3Z+mlhKnsS1iAypQHXPVvn0CLAE9orLAWgCc5FMcTWItJVwmHWiCfsCmUhjSiLzULp1h6QWUQgVzZvIWt76owNR+xoUyA2bs2+VYVz1DttZNB/6FuTaKIJ0oF6tn9rwqL2nnk4kGiCIeMRNdaV1PYAVq29DPN2vtyOr4v6BVPnQynB268L5+NAKa7aY0BGsCt05SIL3DuIKrgpyAjMD7cnsoB9CxlBaUCmnM/abq3hPGXVrmqKAfNDHOLCwgJCSuBlAneFY/TudecDt7tD4dEDYyAxBbrqFwT9v5bnXUoAnrf9hbDjX4A/l+f17Xp57uW5l+dennt57uW5l+dennt5/j15PgnIeTJ9jvN4SYZFRQJyHS9m+dwubrJ8mifZwi7vk6c9dBkns3luFxdp/P71h2dZmhUOF29pupl8AHOufmABGAAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3200",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1472",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "924448.2",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "817531",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.85825137",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjkELgkAUhP/LOy/Lrmur2UkqCOogEXQQD0qLPth2w7ZAxP/ekualoNub9w0zk/eQVXjqbgoS2NsKM6u72hogkFk07g5J3o+nN8iYslCIFQ9iGoWRhIH8gCykLF5+Qc7lPzjHFp/6tG3Lzm/wjw2WV+VUCwmjjMBBmdo1kzhaVzr0s0d5xsuMdgrrxr2FDBYEtlo9J2/AqYiEJLC22vpc89B6KF64dzw+EwEAAA==",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABACVVtFOgzAU/Zc+V9IC0sKejJqY6MOiJj4se2AZ2ZogNYgmy8K/WxlDiveWDsJCe7in9/T2nmx1JMuNej18FCQjj3qjXnSptoSSpVZV80my1fH0amC2MDdp6d/MFWds0f2Yh7Trc9hNXecHE5vIgIlUUh7KQMQioSEP4ijh9BeIZWIDLE474FoIGwgFdTFxxlMogJsLXmHKFIkoceeEqkCTunxxDECp/gmPZCjBLRwAb4FDVh0ViwMmU6saHdN43mIaA9aOABEnGcASGBMOeCdlbzoAoNni+qYyzpvuTzWbFS5wWqb5imOFxdrPeRCgBbxz9as31H1OJjTgAm+ZqTZgOsi8/7GxiIB5tI3cNoEx+fjKbIC7tQEjwgFvl7CpoKPvbi/Iad1UaATktG6bh7JCTRsF3FSQDrdNQM3q7R+ejjPRYf4z3Kn8vWiKmmQsYJQ8FdWu2feDZ93kjdJVP3xT2wF6KNRu3/SD+7L4Hn94q0ttCKuvsmzXPyJYv1flCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.8 /",
    "Flow State": "Turbulent",
    Friction: "1229483.76 /",
    "Friction Factor": "0.014667",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "7516",
    Mark: "871",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "9240491.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "647018.215",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "49",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "52.1 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818199",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.77981702",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9jkELgkAUhP/LOy/LqqtudooKgjpIBB3Eg9KyLmz7wrZAxP/ekpZ06fbmfcPMFD3ktT51NwkZ7LHWOZpOoQUCOWrr7pAV/Xh6Q8xpkAq+DBinjAsYyMw45UIk/1FEF2n8g+bEiZWf4lXbVp1v94+Nrq7SyRYyRhmBg7TKNZM4oquc9oNHedaXL9pJrRr3FkkYE9ga+Zy8YUCjNEoIrNGgz7UPY4byBZf5X3cNAQAA",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABACdVlFrgzAQ/i95ziTRVGP7NLbBYHso22APpQ+WShtwZrhsUIr/fbFza6w5PYdUzH13393lcpeujmS5US+H95zMyYPeqGddqC2hZKlVaT7IfHX8+bQwW9iH1PQsueKMLU4v+yP1+tfsuqqyg7WdiYAnUlDORMBEmNCQB4KJlHYAzmcNECVR3AUiK2gAGUqKo2otGtznQkQxd4AoSCULJwYF+h7LD+scEZWHKhX9xM/y/hb687vwLQIhZdwvhit3iVy5ux0e/VMKHv7GDEMzQt8NB0prIF0oTK/fbgFGaf4fTj8tqL7Q/kAdAmw/pD61LAC9/zzjTgmiMZAG4xGNdxi68B71ATFmQgA8yFGDMMBF5D2JFwCqBSB9n3xoUk/uGXgmYixQMYFX2tTxCulDctS1BRFNunwbC/tP4FZlb7nJKzJnAaPkMS93Zt8unrTJjNJlu3xV2z/oPle7vWkXd0X+5Sre6EJbwvKzKOr1N3CmBEq7CAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "9.6 /",
    "Flow State": "Turbulent",
    Friction: "992653.42 /",
    "Friction Factor": "0.014815",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "15145",
    Mark: "880",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "15034186.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "578467.9581",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "47",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "46.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818204",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.86529161",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjUELwiAcxb/L/yyibum0U1QQ1GGMoMPYwUo2wTSWBWPsu2es6Pbe4/feq0coz/Y43A0o2Iezrcwlat86AwjKYH18gKrHWSaEF5gIWSwpk5jkgsLU/LhV3+shwSnYWH0z0fSgCCYIDsa3sfuYnAmKoApRRxs8KIoXIu3xjHEh80JyjuBkrzOcSSIQ7Ixtu/gvb515fduMYipphmAdXEhn/unc1LwBECojV9MAAAA=",
    Pbi3DGeometry:
      "zTMAAB+LCAAAAAAABADtWUtv00AQ/i8+h2hn39ueECAhwaECJA5VD60atZZCg0pAqqr+d1zbcbL2fN41R7QgKrLTnec3j81cPlcXN/W3p5+b6qz6tLupv+629W21qi529cP+V3V2+dz9tyGL8+Zv9bI6nrwhIc7bH82/6uXqcO3t4+P1U3PX+rVwwa9I+rV3Rq4krSmQWjUEKb1rCGFNSjHnfh0s0Smh5xTWknzI4QRFA4JbB0WM6MM5EjDVKCEgbbMlrznTDucTAUlCgtPRhgRhYkN8PDUhwQdeYGyjILsbQrSijSHXErS03Y1gXXRDGN3dIC8j2cabjiBNx0pa2xKs72Wo4NLaHr0htBudq56Rt61obY0Nwx+/yAMDrkRPCESt2tIGYg1N3HiVfSBop18JSjSyZlnp0PnMe9e6xljd3bAke4KJIcTHBQpHCbjcviXJLxWb+4sCycNpzjVjLYyzbgb9jYyGEiFNNwGZRyCfp94fPCZ9K1n1iIDQX54svAyYkHOltLvRmOHsP5WVofTm+i/dDBB4eQlzZQj6iS91oIFkGDeu+iOvgv6Efn15kWPgCb0FUwPXGbYy5btlbD4PhX/14rGAojaFGxsqubnpkkojNDuR0ZLjg8YIciJGsnSirYDNRR3ViIGTIIqqivSqxT6RoMhoqY1pbQheR/EflCUX+TVzxJwYIQ05FpKSRilvhDazg1vvv2mhI91jwyvLXJgGLjn1xmCdsRpZN9F18CsMqhYmAqw0ft6BY2VH+GNmIBRsvn8vafjJHkx6NFQYnQAz9hTyLdQKC4eQwlgDrPLxfASV1VGlV1rPZjG8AGG7HJ4AhclyMM2YWV0ZbyRxPq4sEP+wCsK6mXgfTxMDl01QaDE8EnZnvP5gXUsWSBBVjAJkHWphoAIjhY7+Vsqc+HvwxeFcvVp4MlDmnUNGDEEH4VmVuoo2FdFdwKKzGaVVwg9Q5A00XsNnCGvcydg9GKFUR9C6ty6oLlMM/2actJY40vCcvI3PrVeLBA8jL5wMsyMdTbwMAtJjeCRhTife3xnP/YmycG6HD20Ya6gtDBL8SoGN3pzLM80eoD//XGGCl5sSQ15D25A38AyBMh53DzwrgEI3tP5BK2c6Ao1CYYznvz6Zfq8ygjO0Aw9iOnau0cTPk305QB0qu6wc51JecIY3YgmwZyJ/pwfGGPxzowKceGCw0WsDys7X9oBZyAr2YGhfckaasIIeQfGGyMxOi7KFKVuYsoUpW5jZ+aRsYcoWpmxhJqWubGFAnSlbmLKFKVuYsoXJavhlC1O2MGULU7YwZQtTtjBlC1O2MGULU7YwjB1lC1O2MP/DFuZqVb2vr39s9pvH6kysxar6vHm429/3H77s9tf7evfQf/xe3w6kj5v67n7ff/iw3fw5/cV3u+2uYfjwe7t9ufoLBiK4ps0zAAA=",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "65",
    "Center to End Label": "65",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "105",
    "Fitting Outside Radius": "52",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "52",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1476",
    "Maximum Size": "100",
    "Minimum Size": "100",
    "Nominal Diameter": "100",
    "Nominal Radius": "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-100 mmø-100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "100 mmø-100 mmø-100 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "42",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818205",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.05692917",
    Cost: "0",
    Pbi2DGeometry: "FAEAAB+LCAAAAAAABAC1js0KwjAQhN9lzyEkofTPk1hB0EMRwUPpocXQLsSs1CiU0nd3odU38LazM8w31QRli5fxYSGHI7VYkhs78iCgJPThCXk1LScH4lSqJEs32mRSRYmGWfzHrL/47TA0I2/gR4HN3QY7QK6kEnCyvgv9Ks4UmoA8e5FXvP2sg8WuZ4rWDDFGwN7Z9xo2WsY6jQTsyBEX+5dzc/0BIeC3zBQBAAA=",
    Pbi3DGeometry:
      "3wgAAB+LCAAAAAAABACtVl1PgzAU/S99xqYtWFr2ZNTERB8WNfFh2QPLyNYEqUE0WRb+u81kCoPb3kVDIPQe7rkf5R5Y7Ml8ZZ53bwXJyL1dmSdbmjWJyNyaqnkn2WL/fetgNnMHaaNfywVnbHa4uJO0y6PbVV3nO+crFeU6TSMuNOUy0VEsqNRMRg5gqVYOUFQplvSBzkNRLbRAASKRl4cYLEn5hMc4eCgrTQWPU0S6KdVSTDA5O4/5RFJHh9MqIDuYEhTZ09kAU6jjglPJVTIO0QOGjcUAw80be5wRfFhfOPhJ4X37YPNGDhDRuDogJU/kSbunNrAbyKkA24TxAGOEdhXdKc9IIqn+Y+yh/ZsYe/9QBogwdvDV9AtOiOlPkuYfF6zWYYnw4wJqBKTjISa8XoPyC4rmGV88JBUGACc1pB8hqlAd7m/hxuSvRVPUJGOUReShqDbNtls82iZvjK265YtZ/0B3hdlsm25xWxaf/QevbWkdYfVRlu3yC1nI72TfCAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "-4311",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "100",
    "End Middle Elevation": "-4311",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "21.1 /",
    "Flow State": "Turbulent",
    Friction: "639.64 /",
    "Friction Factor": "0.015698",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "98",
    "Insulation Thickness": "0",
    "Invert Elevation": "6589",
    Length: "3375",
    Mark: "881",
    Material: "Copper",
    "Middle Elevation": "-936",
    "Outside Diameter": "102",
    "Overall Size": "100 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2158.7",
    "Reference Level": "Roof Level",
    "Relative Roughness": "0.000026",
    "Reynolds Number": "210556.6853",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "8",
    Size: "100 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "-936",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "-936",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818212",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.62729059",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyGbm5u6xQVBHUQCTqIB62hg7WFrUDE797Qur33+L33qgmK1lzGpwYFJ9+aUt9C4zqrAUHhjQsvUNW0yohwgZNcik1KBBaUMpjrP7cdhmaMcAz2pnnooAdQCU4QnLXrQr8YwSSC0ocmGO9ApZjlcY9TwnOZCck5gqu5rzBlGUFw1Kbrw+IpSxEcrP782iTFhOYUwc5bH8/c29q5/gKCnGT+0wAAAA==",
    Pbi3DGeometry:
      "DREAAB+LCAAAAAAABADtVk1PwkAU/C97rs1+f8DJqImJHoiaeCAcIDTQpLYGqwkh/HeXCurizhI8N6Sk2+HtzJt9fbzxhoxm5dP6tSADctfMysemKuckI6OmrNs3Mhhvvm49TIf+Q7bZz5MLRumw+/IX2U4OYZer1XTtY7XNqbMZ4zY30uiMs1wYITL/nDEtAkBS6XYA1UyHgNAyDUgh41sBbq6Y6QArhPoJMLmjxkWAnVrLAkAZLpMRgGOndp/GAeBeVgcoFap1nhOnl1JLDQ+3sq7bijnHgwih04fBpA7FCs5YylrqZGgUN54ymbahJiLWp2ekjXJDUTA95Efc8gQ1EJtyEGj6R31Aa62UR6LYCQClAchTjiALUXFiUTA/WGugtcD6gO8FlUetxZ9n8ljx8SkeGiI51Z0hmqowQmqTbl9MhAHW6hMdUoUUSnhO3L52h2FdRK2PsNLFyaOiUunFDUmZDrmRWtwi46rO7/QJc6lRRzXC7QkAuo7IoSXQRFygUBVM8Px/ZFS5qBb6KaGfEvopoZ8S+imhnxL6KaGfEv7WwiQj1+X0pWiLFRnQnGbkvqgX7XK/eGjaaVs29X75XM6/oduiXCzb/eKmKj5+//CqqRq/Yf1eVdvJJ594bqYNEQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "105",
    "Fitting Outside Diameter 2": "22",
    "Fitting Outside Radius 1": "52",
    "Fitting Outside Radius 2": "11",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "52",
    "Insulation Radius 2": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "26",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1479",
    "Max Fitting Outside Diameter 12": "105",
    "Maximum Size": "100",
    "Minimum Size": "20",
    "Nominal Diameter 1": "100",
    "Nominal Diameter 2": "20",
    "Nominal Radius 1": "50",
    "Nominal Radius 2": "10",
    OffsetHeight: "50",
    OffsetWidth: "50",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "100 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1424326.6",
    Size: "100 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size 1": "42",
    "Tick Size 2": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "Yes",
    "Visibility 3": "No",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "818215",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.40069443",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jMsKwjAURP/lrkNIah9pXYkKgi5KEVyULqJe2gsxkRqFUvrvRq27mTmHqUcoz3Qc7ggF7N2ZKrx4bVuDwKB0ZP0Dinr8xaCkiossV0spYi6kTGBq/t6q7/UQ5DBsSN/QYw+F4ILBAW3ru0+RSRoxqJzXnpyd8YmuM5W5YrBDajv/ZVmUM9gafM16JPkiVTGDtTMuvNunMVPzBsaxYf7EAAAA",
    Pbi3DGeometry:
      "cxwAAB+LCAAAAAAABADtV01P4zAQ/S8+h8iunQ+XE1pWWmk5IEDigHpoRQSRQrPqZpEQ6n8npPkgTl7HBvZmVf3ITGaeZzJ+7rt7ZZeb/OblT8aW7He5ya/LIr9nAbss8231ly3vXg8/azc/rV9sHwyWE8H5afNRv9l+1YWd7Xbrlzo2TkPORRIIrkKu0mAhQsWVDga7DLWWsnHIWAWjgIVOZhxDhEzqb7tUs9hH7C00RJg6ksilumkmESV6tuzWMU01RIyrIOwwEVyTxWKnDgIbQkwXNe4sROCxPNhlfUODoNPGITqHbQDZ1/npmI6TkuozYzbjQJki3dqlaGtQSeN4r6VxCNG0T8apsnlyMyNOpDr2TI1NAVdLbK+ZhjgX/vUtTDbEolMIwrDDRPTMmo0yUykljj4kvCE5X4xarmRkiQA5kCi7y4TZlI5A1dnyNYHwKb42I0BncQCkNJAI3U+cOTRz9W2KOoJqB1MttNtRSzccQpA0a5ImShSL+OBIdTxaU7ck094jd44J85sOlMmE7vevEdDbbQNQDdT9w8xY1waX5Hx6oQCIgByQMDE26BPsB9pc+JhA0N/3FwYWAQNc5w+PBzlPX+Ms2/kmmQmeZ5AF6N1OTEB/MiJoZ4pzpzIYYctMtnIMCrhvlYKzx/j/F3YO6tQLOy/svLDzwu54Ii/svLDzws4LOy/svLDzws5qj3phZ0fULsJuFbDzfP2UVdmOLXnIA3aRbR+qx/biqqzWVV5u28vb/L53/cryh8eqvfhZZM8fb/xRFmWdcPuvKParNwCUfYlzHAAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "24",
    "Center to End Label": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1480",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818216",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.0061435",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjkELgkAUhP/LOy/L6uqu2ikqCOogEXQQD0aLLmz7wrZAxP/ekmZ06vbmfcPMFD3kZ33sbgoy2OFZ52i6Gi0QyFFbd4es6MfTG6SgXKSLgEWURQkM5ItEQoNY/mOcpjL+YXPkhMpP8bJtq863+8daV1flVAsZo4zAXtnaNZM4oKuc9oNHedKXGW2Vrhv3FiKMCWyMek7eMKBcckFghQZ9rn0YM5QvWpUVxg0BAAA=",
    Pbi3DGeometry:
      "uwgAAB+LCAAAAAAABAClVktrwzAM/i8+e8FO3Lx6GttgsB3KNtih9NDS0BqyeGTeoJT89zldtrysWGGEhviT9EmyLLnrM1nt5MvpPSMpeVA7+axyuSeUrJQs9AdJ1+efTyNmS/OQirbIFWdseXmZH6k2v2bXZbk9Gdso9IIwoZwJjwk/oj73BBMJ7eKcL2o8iIKwhwdmXeOxH1MMT6Nfiy30Igh5iwdeEjN/VjiQW0daOL/ueMY8iRil28KjXbOmNXAbxh5fRJbt7wm6TD1BdydsFpcUbD5qQxyTy8UgKDC/qcTBaO3O+6VAMP0nKEt+QL3BnQLaBCoFoD6/QpAD6/lGHhpnn+DU3fE4+21G7W0GUzhiXkBEqLnjVsfFYzuIAxzZBKCFVTAxs2d3DTglEfqoiKBLbf60BS1AAeYGA5lm3MC1vvkncCu3b5nOSpIyj1HymBUHfWwWT0pvtVRFs3yV+z/RfSYPR90s7vLsq6t4o3JlCIvPPK8230t1xdS7CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "2503",
    Mark: "882",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "13668",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "82",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818363",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.93202712",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjUEKwjAQRe8y6xiSpk2buBIVBF2UIrgoXUQNbSAmUqNQSu9uVArO6s/nzZt6hPJsjsNdg4S9P5tKX4JyrdWAoPTGhQfIevzFiFBCcSZItlzQFCdxYGpmcNX3aoh0LDZG3XTQPUiCCYKDdm3oPgslaYKg8kEF4x3IaMtJLjhLeC7SQnCO4GSu//BOm7YLX5NgBYKt1a/5mmDGCoZg7a2Pz9zT2ql5AwSOJhbUAAAA",
    Pbi3DGeometry:
      "6RgAAB+LCAAAAAAABADtV11rwjAU/S957iRpPtro09gGg+1BtsEexAfFooXODtcNRPzv62y1XdKbpJuMPQRRrMd7cj9OcnMnOzSep0/b1wQN0V0+Tx/zLF2gAI3zdF28oeFkV30tYTwqX2gfNL9cEIxHh4/yjfbTo9nlZjPblrYEkwGXmAcXhA1IzKOA4AGlMQ0OCI/lAQkZZgCCqfyGiDAk3YiBDfQAZmsQkC3ksXD0wOC1A1sk+RfCCI27ERpFKtvRhoYWwJ2LckksSBOnyqYhTTTubLDNMRxTQRmrEMLDAyIiYSm1CGmdHMoqNskiC1vjGhFVQSWJaxtSr8OrOIVQTVQNmFwDyEw+24sDylPfvCenMSGVB9yaAHvSFDI4msaEhqISh+TdcXbIRk+0tTaCVQngavzq+g7iVB0zVBNWbf86m7Za3/gdLPqcDs7BtHJm39DwaessWpPO+p8OhkLb+42qQC6Paq5joerW0HqKNX5Dk4Ybrt6gIgLsWod2o1WAC96dTdM6UG4MZPBtBLQB82nIGugZmBo4TEPS7DbaweWQmx/cujrWAYVjv7/oZM5aa+nTXlD4HNBKbS1onyskXAJwmf6bAL7aGURoJQM7JNwIYDn1uImcdYz41yOB8y2+1SX737vPMnn8/UzgkAM/FPihwA8Ffij4rWj9UOCHAj8U+KHADwVnGQqmAbpOZy9JkWzQEA9wgO6T9bJY1Q8PeTEr0nxdPz6nixN0m6TLVVE/3GTJR/uPV3mWl4Tr9yzbTz8BhK5zcekYAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1481",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818367",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.14466389",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNjbEKwjAYhN/ln2NI0tQ0dRIVBB1KERxKh1RDG4iJ1CiU0nc3KgW3u+O7u2qEojGn4a4hh4NvTKkvQbnWakBQeOPCA/Jq/MmIUEJxKkm6WlCOE5EJmOoZXPe9GiIdg61RNx10DznBBMFRuzZ0H0MJZwhKH1Qw3kEe1wQRcskFyzhnPBMIzub6D++1abvwXRJMIthZ/ZrbBCeppAg23vp45p7WTvUbL0piWdQAAAA=",
    Pbi3DGeometry:
      "3xgAAB+LCAAAAAAABADtV01Lw0AQ/S97jmW/k9STqCDoQVTwID20GDQQG6lREOl/d2m2X0neJltBPSylpenrzuy8eTO78/BFrmf53edrRsbkspzlt2WRP5KIXJf5vHoj44ev+quB6bF5kWW0/eWIUXq8+jBvspysl50sFtNPs5ZRNlIxF9ERkyPBmYwYHUke86gTEVrWgJL7v6dKrwBNk7h7BTQ13PsGaXnZIlynP93ZEGMyTlaIZIp1IyI1i3fctICtmw0iOfc1pqnqBrAtu6TD/w92hq0NSHQidI0oGtdIqvoSTQWvkdj4q9f0GFOJtOmMZbofDRd2azK1a7S3nnZkA62hTePkOFhDNai0Cbj2n+xnDTPgYA1aw9FQWruRlOuhssFEYzrXgNCNIuzfQH/hDsinS7jemXYU2wEM4CWHdIj+aJqkOQSFFX2AcB2p9u8QrsqF1Q5TwFJboFInthGuk4O07mAAVjs6WPHh0SRGaN7URuNY8WgchgbA/9YNZMZlDR3fcImDTMgZzhk8cWGYLtFCaqCcHXHCaBBnHg26paZ24xxegR1Ca14ScJRYgviEwumE1ODaxNp0uPGvAY8GPUC2sDtBL79yt8e2Bve5fzgN+F/T8TXEcUE54M7/59NAK5wwDoRxIIwDYRwI40AYB8I4EMaBMA78u3FgEpGzfPqSVdmCjOmIRuQqmz9Vz/bhpqymVV7O7eN9/riBLrL86bmyD+dF9rH7x9OyKI3B+XtRLCffcn878t8YAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3074",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1930",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "5023.3",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818507",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.44146849",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABABNzMEKwjAMgOF3ybmUtupK50lUEPQwhuBh7NBp6Aq1lVmFMfbuVp3gLcn/kWqAorHH/oaQwz40tsRz1N44BAJFsD7eIa+G75iIzKhUarHkjNNsJiSM9c+tuk73CafDxuorRuwgZ5QROKA3sX0vnM0FgTJEHW3wUz7Zy3/doTVt/DQpFIGtw+fEFRWcJbIOLqTn/uHcWL8AkIwYL8MAAAA=",
    Pbi3DGeometry:
      "5RYAAB+LCAAAAAAABADtVl1r2zAU/S969oIkWx9On0ZXKGwPYRvsIeQhpaYxeHFJvUEI+e91Yjmz3Xssu9AyihMS4pOrq6ujc6WzPLDFXfpz/5iwOfua36U/8iy9ZwFb5Om2eGLz5aH6Wf7Nr8o3Owb/kE+C86vzV/lhx1U97PNut96XY42emUjKQHAxU7EOg3gmI62DJq4Vj0+4UKKNi0j14cbKQXngvJ48L3Ady9fU78ljhbEV3spiRfgStaFugHUCCqTHGx0KIpZG2xncKjrV1msjM9CxdLmINCNctFT2hFtOk1/Hx9ZUeKSic3xvlli5aGlaW2u4clulqmrMOClcqgd56CpJwr1y6sq7HF2FC9OE4VIBNSgNVbmVYeTQUgc+AUAWEVt15UbJ+PJqToOmJ7uFrgnNDZUzYgfp9nrtauHAEV0MthFQ42vBjjDHCRBt3shO9nZspzO9LGvjJtLljOcTVPeKF6x66CVUH/D0ZdDlQoSy55Af2upCmt7siAKUB12IKN5DWff+R+UAEsCiEDkgHsrTSwJyL21yBh6dvff/0A6ql0RrDKoDEAZ2z9s3yC11LwMkGpB/rIiHnJY+5fkPEXISr0EE0nlzA/2fGOIB1zZ9XI5xo70++50dMV3ZZIknSzxZ4skST5Z4ssSTJZ4s8Qe1xKuAfUnXv5Mi2bE5n/GAfUu2D8XGPXzPi3WR5lv3+Cu9v/x1m6QPm8I93GTJ32bgdZ7lZcLtnyw7rp4BmWhVKOUWAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1932",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818509",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "22.1892153",
    Cost: "0",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABNjc0KwjAQhN9lzyEkbZM08SQqCHooRfBQemg1tIGYSI1CKX134x94m9n5ZqeaoGjNYbxqULDzrSn1KTSusxoQFN64cANVTR8ZEcGxkJItKEmwYELAXP+45TA0Y4TjYW2aiw56AEUwQbDXrgv9y1CacQSlD00w3oGimAkiJE8TLmSWSx7Tozn/w1ttuj68P+VpimBj9ePbljghDMHKWx+n3N3auX4CrqWlAdEAAAA=",
    Pbi3DGeometry:
      "DxwAAB+LCAAAAAAABADtV8Fq4zAU/BedvUGSHUtKT6UtLLSH0i7soeSQUNMa3HhJvQul5N9rHClrK28s9S5CQjxRRjN6T096T5/sflv/+vhTsRW7bbf1Y9vUzyxj9229697Z6unz+LX/mV/0L3bI/iM/BOcXw0f/Zoe1+9vlfr/56P+ryoUyZpkJLhelWcrMLCRfZj2spZmgQkkKVqWYG10IOcGLspxhOZOidT7giguKHkg/G+7oY2nctLE4vWJu1qUy1BpANUh9rga451Mjrw6VekLiDXbKHawVSW1hQELP6HMAIaIcew/ooCcEXowpZqh9HfMz+tzAjGcd5Ym22a/yo0SUzqdMEfo4nhszthSbQSjPHY70xEU0pDKUt9MMQCzf0xJy5IXVHw7qBQi3gwFLZDFC29zhKNgwOQILSW+8+XJhpQOjcZsj6JPWrbm2eDlIycljx50vXDjhRg+4Z1PJQbgQdLrQBSbO/ZQaKdFSWZZC5WObkScjOHYdLIopPKsFrQpdMb/tiAyc0lLYSfOcSkSveoeGe1UdDAdagFGUW3Qi0u7R7qeTiI4bDAQpBAUZzIiiSWcQzE4Qe3Ar9JSXYu4WciZRebEPFHO/9tss15LcKlrms5MidoSDOwCcllwZeLtGWy6wYuCy460MCh5NDhxFXsdOBzfY52B5g04jLdGrjpyiIIESEFm7ApsDsaQ2LbVpqU1LbVpq01Kbltq0aPepTUttWvAWldo06iaa2rTUpqU2Lb5NW2fsut68VV21Zyu+4Bm7q3Yv3at9eGi7TVe3O/v4u34+/fSzql9eO/tw01T/xgOv2qbtCXd/m+aw/gKhBLtZDxwAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "19",
    "Center Spacing": "19",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "13",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1392",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    Offset: "60",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Radius: "13",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "10",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818592",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.79357993",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jV8LgjAUxb/LfV7DTVthT1FBUA8iQQ/iw8yLXlhb2ApE/O4Ntbfz58c5xQBZRbf+hZDCxVWU48Nr2xgEBpkj69+QFsMsAyK4SNRuJWIulFQwln9q33W6D2gIjqSf6LGDNOIRgyvaxreTkVvFIHdee3J2qe9Uz62Qa8HgjNS0fvLhicHJ4HfBpeBxsgnZwRkX1u3HmLH8AT4byd/CAAAA",
    Pbi3DGeometry:
      "3w0AAB+LCAAAAAAABADtV1FrgzAQ/i95TiWXxMS0T2MbDLaHsg32UPbQUmkDzozODUrpf58Y3VQ8nX2diGI+L99dvkvucHUiy419Pr7HZE7u3cY+ucRuCSVLZ9Psg8xXJ/+af2aL/CJn+ovMgLFF8chvcn6tpl0dDutjPhcC0FLTGYgAWCgoh0AyaWgdV1wVuOJQxzkY02WP4RWPkFrRHr9SebjJUqFSemOhZB2OWFRwayHqMFfQRYJYt7ixBfUHGBWoiHSDA4TwuFa8T5SKJRTS0xjoCXxQWgN8jFdEF6XBBwO8DgvjrY3ukXxwd7WEGRCg6fNS8m4WLM9IRlvaIoEPSY5oiyUacYqEiJws5FQIVXBLzjt9SiHCvrpQ0WjQnoY1FoocLqy6VKn7q1ekLoSRjyUKG3KVugBvbN2R9ayly8D6Wz4vZUdosFRjOW2pi8Q+JHq3ulimEZ9YiCPbEVYDR7cjZK1TO5ra0dSOpnY0taN/047yv6Ubu36Ls/hA5ixglDzE6S7bl4NHl60z69Jy+GK3P5/uYrvbZ+XgNom/6obXLnE5YfqZJOfXb3ThOGzfDQAA",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "22",
    "Fitting Outside Diameter 2": "35",
    "Fitting Outside Radius 1": "11",
    "Fitting Outside Radius 2": "17",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "11",
    "Insulation Radius 2": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "9",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1394",
    "Max Fitting Outside Diameter 12": "35",
    "Maximum Size": "32",
    "Minimum Size": "20",
    "Nominal Diameter 1": "20",
    "Nominal Diameter 2": "32",
    "Nominal Radius 1": "10",
    "Nominal Radius 2": "16",
    OffsetHeight: "10",
    OffsetWidth: "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "1918.2",
    Size: "32 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size 1": "9",
    "Tick Size 2": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "No",
    "Visibility 3": "Yes",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "818594",
    Name: "M_Pipe Elbow: Standard",
    Category: "Pipe Fittings",
    temperature: "19.06159479",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNokva2jStRQdBFKYKL0kXU0AZiIjUKpfTfrS9wN2c4w1QDFEez768aJGz90ZT6FJRrrAYChTcu3EBWwydOCuMRTTDO5jMmKEOOMNY/cdF1qp/sqVgZddFBdyAjGhHYadeE9gUsQUGg9EEF4x1IRpM0SnMUHNM8znJEAgdz/pc32jRteDNPCKytfnzHnFER85jA0ls/fbm7tWP9BJ/9Cm/TAAAA",
    Pbi3DGeometry:
      "iSAAAB+LCAAAAAAABADtV1tr2zAU/i96doPustOnshYG20PZBnsoeUipaQ1ePDJvUEr++1xbjmspn6y0ryLkYp2c26fv6OjcvZDb++rH8++SrMmX5r763tTVA8nIbVPt2j9kffcy/OzE9LJ7kUM2rVwwSi/7j+5NDptR7Wq/3z53uozTlaZFdsHEiktVZJytpCyy13WlZT4TCMlldkpDaGoWBNyIuRNqvUDvnOrTtnBcns5yKp5EanOusUklGjGY5VFAOQAMAyNzpnoJY7l8a8wTnFDRXM8ijjBGKZtF9iE3XVZ5WOcIs6fjh7aocg5oGJp3uOFcAdS8bArNB4FgPEwBL+YzbMUTbZm0gWISg39mhImUfIQAPsoQgAhjjiAADMxSdQuDLcnDZ9YJyrhkCliLPxsna1gCuRGAMwLoxRKIODgwBjFF6CGKdwFXzutf+9jUIBFqtGakjVqKXmCUVSlsH2C5GQJQXV8Mn53YzaQjqRok3UKvI0Yi8sIpahQaDqD7zkdWz1t3dFOfksm1IzmGjDkNQQuwHVvDEUQAjVuBuwWBDYXsiAgAd1a3G7+DA1gFcwDuNHICTQXqabnW/fMB7zPkE04G0wkHjWmLoUH+cciBGozcsmP3chGTKueWF8WYpBzuSJovNXxjmaSUvVXl2iVsMZynfOEiFuiq2D2KePIirHtlTKyKExgCEjN8GRQ3d4g8MhWRhnudirmC4bu+s434DMHQB0KD+UMBZjGGDJ+UQOX8LY7BxYESFir0AXNPMz4YS9KMHzaWZvw046cZP+42kmb8NOOnGT/N+EF2pBkf1FOa8dOMn2b8GfJpxk8zftSMv8nIdbX9Vbblnqzpimbka7l7bJ/sw7em3bZVs7OPP6uHo+hzWT0+tfbhpi7/vf3jp6ZuOoO7v3V92PwHjDsz0IkgAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "25",
    "Center Spacing": "25",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "19",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting Sizes",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1047",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    Offset: "60",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Radius: "19",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "15",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818608",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.76588153",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv17DOZ1pV1FBUBciQRfixayfOVhb2ApEfPdW2d055/s49Qhlq0/DHaGAg2t1hRcvrTIIBEqnrX9AUY+/GJQlp5wl6WrBOGUiFjA1f2/d93IIchi2Wt7QYw9FRCMCR7TKd5/C8iwnUDkvvXZ2xmd9nalgKYE9atX5b2eJILAz+Jr1mFGeZGHbOOPCu30aMzVvoxuaycQAAAA=",
    Pbi3DGeometry:
      "/TAAAB+LCAAAAAAABADtWcFq3DAQ/RefnWBpJNlOTqUtFNpDaAs9hBwSsiSG7bqk20II+fe6lrxrjfUse3voRYSEXY81M2/0ZjTKXL9kV3fN1+cfm+wi+9jeNV/abXOf5dlV2+z2P7OL6xf7sRMXl91P9pofn5yJorjs/3S/2evNsOzN09Ptc7e2onMptMnPxN8PdZ1Lca4KVedjgSDqBaS19AW1kGFBoWmdKmgce+WMK6100MZUgLyKIh9UKUE6iPwoYAAPAm4jLoCqOI4FghiOqQCqQis4DjLKPbfvS2XY+7LsBaIkX1BobVfUZa9IG+EESvQCpYj5VCkrkGKps75xKkW1bpuWrGA2wgE5spDhHtFTaqfIrjDKBUSQe171Bqjbsx52RVagiTHHSDOOBwnFBIZHkK+I20B5OcFXSeVWKBsoLWk2xaEN6BXkDvYKBFeWgyJjFVFRnUZbxANdylgpZDyI1y+YxaI2Y2cX5D0jAqwtkFML9pvZwLUeqcLGkY14deEbC8sOPDYWpBk8s+BGwZLOVsTDPkmBGNUXe7s+IgtOcUgS2HTAGCJ3J5kGcxNUC3iIw05o7JQVlLWaPWhI186pouyNUyV8VuFK4nacXGkjLwPIaGXB6QGcbXYqHT4cphhYe0TKGI+DpEs1W3cmm+dcXd1hwp2YUJAUK6snrGABWVTTbUBqqediDiMInYrvks8CSCfSsnYCR4+at1+gGeYGwnrg8zhpoOH1qeJnRE2l1090p0S4Cq3gBr8soaw7LrDHC5mYJuhtzARDDbiHybpSP0K2gMMwq3nGwVSMbym807GKvOBiHC5ak/gtKA/ocjjT2QFnfZ8q7ZLOCO2XapJBwdFZJzg4iwRQ1fFI4yuggKs6doIMx6HDQKrgCgzQ1JVXPZSszLwq2HNBG6VgqqiwK8yhppFtVoQp5wWQVScYR8iR8ZlupdS+jeGetH6joFcQR/S+MKEPalAX4JggRxdBZBzTB7Id4kCJgwFCAVQFAUIBVoWiC7sTWGRgxwSLjB4uPoOqoQU32mc7uQ4FPYdUWG8a4ga2cfaXwvgmqhOrN24UEYho8zqxAdupGIoJ6nCLgi1DX2E8kCp8xiJ0GDZSBVsw9BwrCgc2TQfWTwdw1wZbzKX/6fyHCcR/nQ5M7tJpOpCmA7P40nTA40GaDqTpQJoOpOlAmg6ENi9NB9J0IE0HwprSdCBNB9J0IE0H0nQgTQfSdCBNB8LZn6YDoxYlTQfi04GbPHvX3H7f7DdP2UVxXuTZp83uYf/ovnxu97f7pt25r9+a+4Pow6Z5eNy7L++3m9/jF9+227ZTuPu13b7e/AEU9F0x/TAAAA==",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "30",
    "Center to End Label": "30",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1051",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818609",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "21.17425404",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjssKwjAURP/lrmPIo61tXYkKgi6KCC5KFy2GNBATqVEopf9uSutr5e7OnGHu5B1klTq2VwEp7GylMqtbaQ0gyKwy7gZp3o2nDwQczyPCFzPKMaNJAj36wHjwwug/pCRkP/C7doTF6/2yacrWb/DGWpUX4UQDKcEEwV4Y6epJHKwrnfKzR3lS5zfaCiVrNwhKAoZgo8VjyjKKechiBCurre81d6374glSC9iwEwEAAA==",
    Pbi3DGeometry:
      "4QgAAB+LCAAAAAAABAClVlFrgzAQ/i95TiXRGKt9GttgsD2UbbCH0oeWShtwZrhsUIr/fWnnNiU5vTBEMXd+33255C6uTmS5Vc/Ht5IU5F5v1ZOu1I5QstSqNu+kWJ2+X62bLexFWvpnmXHGFpeHvUm7/oFdNc3maLEiiTLJEjrjScTzXNCYR0LwjA4cMpZnR5LGc+pDJBJnj7m4EAkmci/ADT2lSaQyR4qN08xPxVnqV9UhnOmBTGBsUC0UAjWL+TmlqXRyPrD3mXwAkMlxDJbvf7H7+cCJ6iVqYO8vng/gMoGxQbUg1VQMkGq0MsCEgJWBQoAxcMHBHIIbHTcPkAqFwKkCCzZ8k4TvBbC9oLZuUKcaR+BUTTS94AJ0AJB9qnmii2myeY4CcJoQJ19QF3YAgB08QlHNOegwtgD7v3CjNq+lKRtSsIhR8lDWe3PoBo/abIzSdTd8Ubtf112p9gfTDW6r8rP/4bWutCWsP6qqXX8BhFQsuOEIAAA=",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "1.5 /",
    "Flow State": "Turbulent",
    Friction: "2098.11 /",
    "Friction Factor": "0.021035",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "12026",
    Mark: "883",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "25231.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "52004.19636",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "60",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818614",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.70836992",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNom/SRuBIVBF2UIrgoXUS9tIGYSI1CKf134wvczQznMPUI5VHvhyuChK076gpPXtnWIBAonbb+BrIePzEgBaMs5ul8FnOaiKKAqflxi75XQ4DDsNLqgh57kBGNCOzQtr57laAKApXzymtnQcY0zaNcZCzJcsELkWUEDvr8D29Qt51/d5ZyAmuDj6+dxJTxPChLZ1w4s3djpuYJ0bR1HNMAAAA=",
    Pbi3DGeometry:
      "hSsAAB+LCAAAAAAABADtWE1v1DAQ/S85pyvb46+0JwRISHCoAIlD1UOrrtpIywaVBamq+t8Ja2e7sf3sLBcuFgKxdjIfb94bO3P13Fze9l+ffqyb8+bjcNt/GTb9XdM2l0O/3f1szq+e3X/HbXYx/mle2teVM87Yxf6f8W/zcj299ubx8eZpfNfSirhU7RmXK1Kat4KvpKV2XBdadvt1YVhynYSRR+ukJc8+H6wjv3B9sr/Q78GOkFwtiacYv2Dm7zoZLZIbkkjNPU9vSKOzG9jUIah/3pjCxVEhU8sTlFrw+QYpVyNtRa4YYwzet2Y0L4Z/fiKBNIW8qaP5hjQ2H1P5jTA9GBVOI81NPT2v7P55sp3MVy/Km43FycYE0ysFGwpMKuvWaQRuD7mZZzEC5gxJRTPXJLlNSlsK50F1BRevvNkbGkvY5clMzM43lMnzxnD/guUuCWKURxzhdzoDIYDloDprU4SKLMEXTi62oMmQ88CULLkGzFwOedTUUM8OsoMesGuYBcr7QIOJaVrPAYnELbn2pnTnxO03DroQwoEu5EJdREqCpg4bTLmoOrVQetZKl5+XUjmNwAUGvcSpCMIMdUoHBrp+hHig7CBQkAgQQdTVsAsUFGYn1DEQPurZmM2Q/+gMK4qveBy+9mAICDSFkCoeVuh+iqQXCwYhVVRSSBB0upUpCC9kwR1H2M4kTzH4PaCMB9aQA1YIOX9h3pwFkir0YHmXOnCF1jZZUjHyLcUBYclvaE2+QrKUNIgVxYRdjHJzupNOkEzbbBbwzoxqCmPCFQI4nQxs9KXgdYo/nso0i79GUCkCU6R5cEmcqwjXKOMb5HcytGW1RBCK5MUEfYdD2eGsFxY1/pKMCIiKChWMalqGaeFxju5DUI+wjUMAix8p+JIWjFw662sttVkm4IJQI9JkcC01ZTQECBBfABO6DkWWUMvETdbzjMiIJDvgrTgoUcZ32gVEfHGzga1x6mfYBQoJdIhS04KtJmop8ExDhhBfyz0cztKQ6CLBA5SKjSDiBpJpkX11wpqPv05Y64S1Tlh5nbDWCevR4VgnrHXCWiesSSLUCWudsGaRqhPWY6nWCWudsNYJa52wLoOpTljrhLVOWPMh1Qkr/88T1uu2edfffF/v1o/NOVuxtvm03t7vHvyPz8PuZtcPW//zW3932Pqw7u8fdv7H+8369/GDb4fNMBrc/tpsXq7/ALH88ICFKwAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "24",
    "Center to End": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1055",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818687",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.41796592",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkTWJpPYkKgh6KCB5KDxVDG4hZqVEopf9upFXqydvOvmFm8g6yszm2Nw0p7PBsMrRthQ4IZGicv0Oad8MZDFLRmLFkMeOSRpIr6MkEChqLRP2HQs35L5zEDrD41C+bpmzDhvBYm/KqvW4gZZQR2GtX+XoUB/SlN2H2IE/m8kVbbaravwVnMiKwsfo5eiNBuYoTAiu0GHLdw9q+eAHMM7iqEwEAAA==",
    Pbi3DGeometry:
      "vwgAAB+LCAAAAAAABAClVt1LwzAQ/1/ynJWk6feeRAVBH4YKPow9dCxsgdpIjcIY/d/NZqct6S1XRmlJ7uN3v1xyly4PZLFWr/sPSQryqNfqRVdqQyhZaFWbT1IsD79Dq2Zz+5CW/ktmnLH56WNf0q7ObjdNU+6tbxQHKWM5nfEoCJOQhiIIoySjA3meZUcFj9OcjjjwVHCcPErSU4RRczeuh4/VcxxRIeJkFErEduAyOts7KwCB4BxBZMEYyFWIIBV57Oa7Lx8guQ4QkCvvbdxVcQfJQAQeJqmv6G3ciL27AjAyxBWE8sYAoS4WBJQNqCAw9gA8IiqYOvBoY/iASCgHDCe40iefjOkHAOommLOKb0oX7RFsfL1taq259pDC2yQnVI6vSXo8UKww19uEdus6QHLgnkR0YfRtezS3fwN3qnyXRjakYAGj5EnWW7PrJs/alEbpupu+qc2f6kGq7c50k/tKfvcNb3WlLWD9VVXt6gdDYJWPvwgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3259",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3274",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "7060",
    Length: "598",
    Mark: "884",
    Material: "Copper",
    "Middle Elevation": "3274",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "365.5",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "128",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3274",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3290",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818704",
    Name: "M_Transition - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.06785001",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jVELgjAURv/LfV7DzU03e4oKgnoQCXoQH1YNHawtbAUi/veG1ts9H+dw6xHKqzkPTw0FHP3VVPoWlGutBgSlNy68oKjH5YwK4zinMluvCMNUCgFT8/c2fa+GKMdhZ9RDB91DkeAEwUm7NnQzUJEhqHxQwXgHRYoJI1zSjKdcyFymBMHF3BeZUB7xoE3bhZkJi/He6s+vpjHnNEew9dbHZ+5t7dR8AfOxAe3TAAAA",
    Pbi3DGeometry:
      "UQ0AAB+LCAAAAAAABADtV01rwzAM/S8+u8FfsZ32NLbBYDuUbbBD6aGloTVk8ciyQSn97/OSLGucqM4PCKGh1pPfk4xkkdUJLbfm9fiRojl6tFvzYjOzQxgtrcnLTzRfneq/DiYL96Az/rfMKCGL6uV+6Lz+23ZTFJuj2yviSBGS4BkVEY8lxYxHjOJLM0u0rsxS8S4gaDzkD5gbGhozha/IskQ2NEIMmdtoHDwE0DiWHYDHnF0h6vnDCt2I2sQUqeKnml49n5ZGUVn7Mz3uhGAFfweoAWYdpOJU1lSKd8U5U2Iwqh7QUnGRVEBCR5UAKA3nDRaBLw1UR6AX4NT8UIPCUH2D1eEXQSiDJlTGtRx12EzW7oqNa39QoLcDkgA7LsjEdJ2CkHLwkPox+UDLJF0J/QJMj+teSBkMFbxOfOXQPQPcq2BmXqRBXeCihApjbIFNc2SaI9McmebINEemORKaI+775M5s3tMyLdCcRASjpzTfl4dm8WzLTWls3izfzK6FHlKzP5TN4j5Lvy8db21mHWH+lWXn9Q//z2Z6UQ0AAA==",
    Area: "0",
    "Calculated Heating Load": "0",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3274",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter 1": "33",
    "Fitting Outside Diameter 2": "35",
    "Fitting Outside Radius 1": "17",
    "Fitting Outside Radius 2": "17",
    "Height Offset": "3048",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius 1": "17",
    "Insulation Radius 2": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Reducer/Coupling/Union/Increaser",
    Length: "9",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1063",
    "Max Fitting Outside Diameter 12": "35",
    "Maximum Size": "32",
    "Minimum Size": "30",
    "Nominal Diameter 1": "30",
    "Nominal Diameter 2": "32",
    "Nominal Radius 1": "15",
    "Nominal Radius 2": "16",
    OffsetHeight: "15",
    OffsetWidth: "15",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-30 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "143",
    Size: "32 mmø-30 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size 1": "13",
    "Tick Size 2": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    "Visibility 1": "No",
    "Visibility 2": "No",
    "Visibility 3": "Yes",
    Volume: "0",
    "Width Offset": "3048",
  },
  {
    ID: "818717",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.46608304",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzEkaWy1nkQFQQ9FBA+lh5aGdiEmUqNQSv/dSFsvCt529g0zk3aQFHhubwpiONgCE6vbyhogkFg07g5x2g2nN8iAhkyuZjygQrIIevKDSSrEN4v4IvwHp9RsKl83Td76Bf6xxfyqnGogZpQROCpTuXoUJ+tyh370IC9YftBeYVW7t+BMCgI7rZ6jVwSUz6MlgY3V1ueah9Z99gLmJ94yEQEAAA==",
    Pbi3DGeometry:
      "1QgAAB+LCAAAAAAABACVVltrgzAU/i95TiUXq7V9KttgsD2UbbCH0gdLQxtwZrhsUIr/fVm1zqYekyCK8cv5zv3E9QmttvLt+CnQHD2prXxVhdwhjFZKlvoLzden5tXAZGEuVOP/LxNKyOL8MDeqNxexZVXlRyMb8yhh8RRPKI9YTFLMeERTTvEQwOJkdgayGRsGQImE8msgYTSMqrOKZJZEoLEdkW0TnabZuGqQCvIipTz2MdZJ5FIdR4wNBtADcFM1keoByZUfIcqb7PWAYSKrBgcA26Yue7YXF4k2FzeqQa8hIn/AHfLRYgaJwHYBA36jwTMP7hIAO9tBBUqETA/QKu8+cjvoXR9W09uxhWaBgwbY7z1rxss+YMj59o+7TcDWBSeygwqUCJn6oFXe56PbwfAxB/Sp59wIPTT/9pt/hHuZfwgtKjQnEcHoWZR7fWgXL0rnWqqyXb7LXQc9Crk/6HbxUIif/sY7VShDWH4XRb35BQCs7bTVCAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3259",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3274",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "7060",
    Length: "299",
    Mark: "885",
    Material: "Copper",
    "Middle Elevation": "3274",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "182.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "128",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3274",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3290",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818728",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.60370165",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TssKwjAQ/Jc9x9A0GqSepAqCHooIHkoPLYZ0IWalRqGU/rsLrf6Bt3kxM+UARYOX/mEhgyM1WJDvHQUQUBCG+ISsHCbIgaWWxii9WSgtlUkNjOI/ZvWd33Zd3fMHFnZY3220HWSJTAScbHCxncmZYh2Rb0/0irefdbDoWl5R0qRrAXtv33M0VXKVaNZy8sS14eX9WH0ADlIP8xIBAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVt9rgzAQ/l/ynEp+qK32aWyDwfZQtsEeSh9aGtqAM8Nlg1L835d1ttPgmSsi/oif9313udzF5ZEsNvr18KFITh7NRr+YQm8JJQujS/tJ8uXx79HBbO4OUtP/NxPO2Px0cSepV2ezm6paH5xtLKM0mwk64TLiWRZTwaOEyRn9BUScBACRTHEWLGs0UpHiqECvUi5PgOAxQOVbXKg8jSmXcb9XoDhEBcdxdpdzluA0wlMyLO7ukvdNSQvoivdZ+FTdDGI0QKCbQYxXEOBlsM/Cj6ObD0zkIBUIhKn8AJH1AWpgLECNcGrRkwiudiTVqIoCvQILBwSQVAgAXKKI7jNMNabDIQoHbH0egKXCAGBnAJs+kmrUxgJ6Fd4ghzVGdVGwasO95Pru04rD/UPc6fW7sqoiOYsYJU+q3Nl9M3g2dm21KZvhm95eoAeld3vbDO4L9d3+8NYUxhGWX0VRr34ARReDMfUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2754",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "3251",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.8 /",
    "Flow State": "Turbulent",
    Friction: "611.31 /",
    "Friction Factor": "0.024515",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6554",
    Length: "496",
    Mark: "886",
    Material: "Copper",
    "Middle Elevation": "2754",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "303.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "26002.09818",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "128",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2754",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3251",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "1.2 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818730",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.83798833",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jFELgjAUhf/LfV7DOb2iPUUFQT2IBD2ID6suOlhb2ApE/O+tsrdzzvdx6hHKsz4Od4IC9u6sK7p4ZVtDwKB02voHFPX4i0FJJEcUcrkQkguMEabm7636Xg1BDsNGqxt56qGIeMTgQLb13aeIPMsZVM4rr52d8UlfZ4oiZbAj3Xb+21OMGWwNvWY9FlwmGTJYO+PCu30aMzVvYjsddMQAAAA=",
    Pbi3DGeometry:
      "uzAAAB+LCAAAAAAABADtWUtrGzEQ/i973hi9Vg/nVNpCoT2EttBD8MEhJllwvcV1CyH4v3ft1Xq9kr6V7B5KQZQ0sSbz/jQzmty/FncP9deXH6tiXnxsHuovzbp+LMrirqk3u5/F/P61+7Elk9v2X7Evh5MbSsjt8b/2q9gverY32+3ypeUVfFZJJsobymdUMlkyOhOS0fKcwChjBwJXkgUJgvOqDIniQsk0UVA5JlBmwsotAerwrIrq6EUpSXjQc4/gcbg64oSoqN6PBALyww1iuijIcfKDEt0RhOWoBB9zVKQLYuVI4kofz0X7/UAgrYAjgXHaEaQYc7BKdASiEq11dFMtL0xTnMNVAeIxoM3xeyAI03McCZIS0xOkVXEUJXVrQ+e36HSzCqSPCHPkkNQSSCvijIA50nV4N9NxUDLDLEfVJZaryTsOVWCjEHawUTC4VNkEcqk6Di2uBC7CgiSxiuRAIb2A+jfZWsslNUGo47uPMNLXF4iq9IxbBggFJAmqhioSyoubV1R3YONIv2Z+14JpgkXd4YgH3bsCUaSnWnt5RBL6OMQIbPAwhtBct+SCiwmrBWzjcBYajNLWJsamOw2x51p2ETyYMNWzBu+0EuOEmy7hzLYsewMkpdY7zXiwh58GIRfP7oQkDe/dPoMgrDmeqX6GUmdMmIkTBBk1YUBdz3EqeNGCrqqzIQEGPBw+aE88Py4EEJikMaojGG2rIwcQ8Jq0izIkaoIwCRqs+eKb4poqSGVVEHM+T+BEp0OjvxHg0g3QMEYHu4snCVkbV+EVAoA/iNcLFUDn0qGMH2PRy5ieVR/Lo5qc8KCFdWscwGh9iD1I/CkNmOpaJDlTIx8qwu09DR87pkbPw2K8dhYlWEF92z8d9/a7BCwIcUAXqLSSuNajqgglobEUatCqn0TG0abDM1JZwJhpAhpRLleNvEaqJ0YUMR60/iJH2CrkR/SJ4KqAU3qyG4Pj4FGBlSNrYUCgJHBf4KMMEsKC8IMJOo0EobDCYQQUrOCYAAsN4X2Tc5LJrDlKiDG8IQGl/2LdaEJBqvGDRI/L/bVlGhkEHIgOqE7KULtPtn9wGLxdoOqwpQBaUArsntAzSICi4LMMnGNBIKh5+X/F8j+6sY+uK+OE6//A8E+W/55Vefmfl/95+R8Gbl7+5+V/Xv6n5Skv//PyPy//8/LfB01e/uflfyAVefkfNDUv//PyP1F1Xv7n5T8WlJf/efnvOZCX///b8n9RFu/q5ffVbrUt5mRGyuLTavO0e7YfPje75a5uNvbjt/rxRPqwqp+ed/bD+/Xq9/kvvm3WTStw82u93i/+ADYlYni7MAAA",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "30",
    "Center to End Label": "30",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1067",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "32 mmø-32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818731",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "20.16473222",
    Cost: "0",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzEkaWptPYkKgh6KCB5KDy2GdiEmUqNQSt/dSOvfydvOfsPMZB2kJR7ai4IEtrbE1Oq2sgYIpBaNu0KSdcPpDZzySEbzCQ+o4HEMPfkwGdBwKuR/yFkofuBX6sDyV/miaYrWL/CPFRZn5VQDCaOMwE6ZytWj2FtXOPSjB3nE0xttFFa1ewrOpCCw1uo+egWnQShmBJZWW59rblr3+QMdpvXQEQEAAA==",
    Pbi3DGeometry:
      "twgAAB+LCAAAAAAABAClVlFLwzAQ/i95zkrSpq3dnkQFQR+GCj6MPXSsbIHaSI3CGP3vxlk1Nbn2wigtzeW7775cc5eujmS5kU+H14rMyZ3ayEdVyy2hZKlko9/IfHX8fjXTbGEu0tE/y4wztjg9zE269Y/bZduWB+PLI56LnM54EvGiEDTmkRA8p7Y9i7Mve5LGF9SDTzKMOebixCKYKHxwJ+qEGpFmBUplnOZeHs5Sr54e/39VEA0UFpIJ0GPUiyRKs1g4WR7YbSKfA8jkTAy+2Hmx7WTgRFlpGtjtr+ZzcJnA2KBakGoqBkg1VgtgPqBiwDiAEXChwQRCOxy1CIgIg0cpgmo0fG+EbwGonaA2bEBfGsWjFI03uOCKcxwg+0SnxBbPVKscg6P0TB9rQQ3XcQDs0AGJasMBB62Bm7+Aa1m+VLpqyZxFjJL7qtnpfT94ULrUUjX98Fluf6duK7nb635wU1cfNvBK1coQNu913a0/Abl2j0y3CAAA",
    "Additional Flow": "0.0 /",
    Area: "1",
    "Bottom Elevation": "2708",
    "Calculated Heating Load": "100",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "32",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "2.3 /",
    "Flow State": "Turbulent",
    Friction: "4346.27 /",
    "Friction Factor": "0.019366",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "28",
    "Insulation Thickness": "0",
    "Invert Elevation": "6510",
    Length: "12920",
    Mark: "887",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "32",
    "Overall Size": "32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "56152.8",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000089",
    "Reynolds Number": "78006.29454",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "61",
    Size: "32 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2740",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "3.6 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818736",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.99280309",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjj0LwjAYhP/LO8fQNGnaxElUEHQoRXAoHaKGNhATqVEopf/d+AVud8dz3NUjlEezH64aJGz90VT6FJRrrQYEpTcu3EDW40dGhFHMOaHzGaGY8JTD1Py4Rd+rIcIxWBl10UH3IBOcINhp14buZQjLBILKBxWMdyAJzvIkF5ymPBesEJwjOJjzP7zRpu3C29OMIVhb/fi20/iBkgLB0lsfx9zd2ql5AlOXuVbTAAAA",
    Pbi3DGeometry:
      "4ysAAB+LCAAAAAAABADtWEtP3DAQ/i85B+Tx23Cq2kqV2gNqK/WAOIBYQaTtpqLbSgjx3xvWyS6x/dlZrjWIx2bieX7z8Fw+NRc33ffHX6vmrPnc33Tf+nV327TNRd9ttr+bs8sn/+9AZufDd/PcHp6cEGPnu1/DT/N8NR179/Bw/TicleJUaxLtCYlTYkq0fPgryLYvBCLjCY54miCEe00wxFzhREiAwhHhIGOx8IkVJ+cWaVW2g0tmXghcWJ0kkB2EzoRPJ7QpEBCrvVZvJ+zVRcIhq+UGkuJmTuB691xqnQ+HE6NsRvNoTAeY8tEoKms1zQk6r1Lx/cA2qBK2ASDK0P7ADuacK5UNXUygvEbItqKmQX5pNzhtR+DCnzBGzUwgaTxBOzUTTeR0OrnJehnKWw1lvAKN8H5SA3iyaWSMnhOUsVnUGLKjcDu6xEoQC8p58Fj0Qf+VFSLNdRJNMSt44uhwMzdGVXsCZy6Pg0wCL/V4VNFwyY4MhDIgAdmBLD8gYQKItDKX3doOdM9pkLnLbiXnmSEcc4evnRqOLUySKK2WcN2/o7Q3jlweCIcTxhsnHS00LhCBQ1HEWlQ2YVBLTQSPJqFDoH3QUwgf0IWw3EERSKkMaGE9RyUB1XMIc5wXsLuVkrLYJ/MYhHygm8pNDI6uMA2DaEN4FDMpwgfqemUIwjEtnOuEVsn2Bmd8JkcPWusrDlfzA0HJ1nCWgSK4NclWTEKno8oGXVKIHQPk1BggWTAZKIr0AewlHxPOjFpayqsPZ2gUTaQQig3yz9EOjW5MlH483UxK6EpcTEAMQk5c8WBkDJMnHZ2M5KRpx7q0lB4h+5FNNG2jWznOs7S9iyMZXSYDzKFQwmRFkSwWkMWte8kgBLMRle+0G4s3FtwewoYi1XhAmmWFtZSkEXawhwuVGK4DItfnvYQGoJgNik6a/4Q14pLSEFkyEoeRgkpAcdDzy2oOLI/7ogYFQJVgvSgVMFx5ogKD/IRZIeiWqzlcsMEEzIQeeq1cHUKwoOwtQ7MuZOtCti5kk+/XhWxdyEajcV3I1oVsXciKupCtC9m6kF3S3epC1lecupCtC9m6kK0L2bqQTbeHupCtC9m6kP0fF7JXbfOhu/652q4emjN2ytrmy2pzt70fP3ztt9fbrt+MH390t3vSp1V3d78dP3xcr/6+fvF9v+4Hhps/6/Xz1T8IAW/R4ysAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "24",
    "Center to End": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3274",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1071",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818740",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "19.99669434",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjckKwjAYhN/lP8fQLE2aehIVBD2UIngoPVQNbSAmUqNQSt/duIG3Wb5hqhGKo9kPVw05bP3RlPoUGtdaDQgKb1y4QV6NHxkRzrAQhM1nhGOqsgym+sct+r4ZIhyDlWkuOuge8gQnCHbataF7GcJThaD0oQnGO8gJTmUilWBUSMUzJQSCgzn/wxtt2i68PeGxXlv9+K4pwySlEsHSWx/P3N3aqX4CcpO5ItMAAAA=",
    Pbi3DGeometry:
      "3yoAAB+LCAAAAAAABADtmFtr2zAUx7+Ln9Ng3eX2aWyDwfZQtsEeSh9aGlpDlowsG5TS7z43lpPY1k9O9ixKS60jncv/3KRz81Jc39ffn38tisvi8/q+/rZe1g/FrLhe16vt7+Ly5qX9tyGXV81P8To7rFyIsrza/Wl+i9fb7ti7zebuuTmr1dyWenYh9FzK0s2kmksxe1uteovibdfbspIuTujvl6ayKTZxmfHVoUjg3S074e0ZBgETVZkdoRGuj/fvCdKVIkpQxoqD2KllZNMRRhohoVN1TEiLRgljnbQwR4ykDo5RRh8tE/6V7y9r2YrtvN5peaK50hi/IyjtU+rgfrAqqg5qT/FTina/Elq1bKQ5zVuy8r7PKo3PwCzWFPNIimCEta2uWqgdQZvAyvieEVb4QaZ2woULMrQ+8gFKcKLZsENDexfxGeWStu1uaVUyWKzzwQKnggVOJtHmMD0z7hg80snaBpSog5AVnjjf1zYEbANISzCNK1PCIVGmER/6CDoH2ob4ISGBX9zoQ6SphkWvWEFeN3DKkNe6PaFcaF8uGOgqdUJKUAoBG6ODPmVTdU/g7oTrDKuO9qP2wD8Rw4AoAocBA4U4HhSgJ9qFFYk8D8hBBUvkGWmECYisMMmpPJ/QlYbxTu0q4bYpGaOSS5Akko2wwsYUv1pCroGrMTTQgKn2Rn1s5Iapu03/CjNsVcIbmboDexvg9GIHpzDSRWvw/kY4yE2RvOwPW2qDuo66UVgZjyFhwolKBYLysmXlXdJk0pRUIgFWmWBdZatWgKzSRsTvwXRdQI3IOQzS2bCOUnP8qMFn0BBvfEREHXGUCqLPB+rqdADg42Vg238AiydQxvDmsWeF72hKObZ80qsj5534UjqUDYhNSC4sJ1AfoHfDjQcTEa42iBtEGPQEaCDK9G2qlJsqqfHk5FDhOE1m1DARCGaseIAneYvcgvylrKJRRY6nizEJRv6I9GRxwTI4LF8sg62mioChhDKwhiBWCVbQS7Bww9sdso1eR4gSWQDRgQmKEvI4NMIkj0PzODSPQ/M4NI9D8zi0V6zyOHQihvM4NJ1neRyax6F5HBp1Yx6HRjTK49A8Dk1anseheRwayag8Ds3j0DwOPWscejsrPtR3Pxfbxaa4LOflrPiyWD1un8LH1/X2bluvV+HzR/2wJ31a1I9P2/Dxcbn4e7zx/Xq5bhiu/iyXr7f/AEAB6xjfKgAA",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "24",
    "Center to End": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3274",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "35",
    "Fitting Outside Radius": "17",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "17",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1073",
    "Maximum Size": "32",
    "Minimum Size": "32",
    "Nominal Diameter": "32",
    "Nominal Radius": "16",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "32 mmø-32 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "468",
    Size: "32 mmø-32 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "14",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818761",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.3505953",
    Cost: "0",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzyEkqYltPRUVBD0UETyUHloMbSAmUqNQSt/daH8QL9529htmJusgLdWpvUmIYW9LlVrdVtYAgtQq4+4QZ91wegNnWIR0uaKE44iHFHr0BReYRhH7BwUmAf2Bc+wE86k+aZqi9Rv8Y6OKq3SygZhgguAgTeXqURytK5zyswd5VpcZ7aSqavcRgnEEWy2fo5e9e0WAYG219bnmoXWfvwA1OWkUEwEAAA==",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABAClVltrgzAU/i95ziTeEmOfxjYYbA9lG+yh9MHS0AacGc4NSvG/z1a3esnRI6VYjJ/fOd/JucTVkSw3+u3wqUhMnsxGv5pUbwklS6Oz4ovEq2N9W8FsUf1ISS9PblzGFue/6iLl+o92m+fJoeKGnsMjV1CXhY7kfkA9zxGuCGkHkAE/ATzifhcQXngGZBhQnKmGIXzJrT5EEEUtgDvMC+VMVaDzqQCxzhGqhqZcLiyRX4DhJtoD7DsPHFdKz5KPNtAx1QY6W2Jh1HFYfNRxoExN+eipAgMcixyUa3fez8e0qWtUDQMEcw7uFdg4YD5AxvxEgT7s1Y4un+nGQTOmVSF6cEYx2BljAG6WgKZQYwnHQKmyl2gfQPUHyLADY7N9fkeBUxTHQKkCz8H5AxlkgADuuANNzTm2T4zqG+JeJx+qUDmJmcMoeVbZrtg3ixdTJIU2WbN819t/6FHp3b5oFg+p+mm/eGdSUxnMvtO0XP8C1QFLhfUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3115",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3124",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6916",
    Length: "463",
    Mark: "888",
    Material: "Copper",
    "Middle Elevation": "3124",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "2526",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "129",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3124",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3134",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818804",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.17513871",
    Cost: "0",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9jkELgkAUhP/LOy/Ltqub2kkqCOogEXQQD0qLPth2w7ZAxP/ektql6PbmfcPM5D1kFZ66m4IE9rbCzOqutgYIZBaNu0OS9+PpDWFAeSxWCxZQJqMIBvKDhTQWS/HF+H80JxZzcdq2Zefb/WOD5VU51ULCKCNwUKZ2zSSO1pUO/eBRnvHyQTuFdePeQvKQwFar5+TlnMpICgJrq63PNQ+th+IFQTGWyw0BAAA=",
    Pbi3DGeometry:
      "9QgAAB+LCAAAAAAABACVVltrgzAU/i95dhIvidE+jW0w2B7KNthD6YOl0gacGc4NSvG/L1SbqeTsJIiX+Hm+c8nJFzdnst7Jt9NnRQrypHbyVdVyTwKyVrLpvkixOQ+PGqYrfZA++HtzE1G6ulz0Sfrt1ey2bcuTtmVpGCdpGkQ0DSkXIojjMEtyHtgAnrP0AmSC2wHQgnE2BwRP/KhMVDFL5kCUMb9wDdUyqizV93+dg1RgHiITbuHiVIhzFuZJlliK6ADgVEOtJsB1Bp19GGCYwYnzeUksUYHAMiozg8s8jMUwHxbnYOYglTOAlx3sEsSHQzPgPpxLgpcdXFEIFWjhs2rBqJwVDk/Qv0XBbkeEDKTy0RLQAlmDPtruvJxxZQBFBtw/ECrQwmePAqNyVmo8QWf1WWwslrI7awm+R9ny0P8Q97L8qLqqJQUNaUCeq+bQHcfBi+rKTqpmHL7LvYEeK3k4duPgoa5+ph/eqVppwua7rvvtL6bucZj1CAAA",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "3115",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3124",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6916",
    Length: "570",
    Mark: "889",
    Material: "Copper",
    "Middle Elevation": "3124",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "3110.3",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "129",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "3124",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3134",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818815",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "22.16833633",
    Cost: "0",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABAC1TksKwjAUvMtbh5DUxkpdiQqCLooILkoXLYb0QcyTGIVQencDrd7A3fyYmXqAqsNLfGgo4UgdVmSjIQcMKkIXnlDWwwRTQOU8U0u1liLnQkoFI/uP2XznN963MX1Iwg7buw7aQym4YHDSzoR+JmcKbcB0e6JXvP2sg0bTpxXJZVFkDPZWv+dsJnm+WjDYkqVU617Wjs0HTGzKlhIBAAA=",
    Pbi3DGeometry:
      "ywgAAB+LCAAAAAAABACdVt9rgzAQ/l/ynIUY44/ap7INBttD2QZ7KH2wVNqAM8Nlg1L835dVuxn09BRRzHe5777LJaebM1nv1OvpIyMJedQ79aJztSeUrLUqzCdJNuf61Zr50l6kov/Ijcf58vKwN6m2V7dVWaYn6xtIJkTgU49Lxj0voMJjMvbpLx6EgcV9toi5aOO+lA2+kG0c4qnnW9z3wy6/xaWI2ngcxZP0QHGH88LHHdbT5YnisDffGu+uG5QXFNddf8HC0Pp1iVoGdyU6HtcUWga3ZhiqkRg9qtz8MAZQLhjcrQWGaq6qngTdgoNyoZMClgPhgDsTmIKDCwVtfyTT/P4AKho+eGMBMLsGNCB3DaRpssPUrgXuyvH2hCTCGMCTArVAJNP8Hgsqgj5yEI4kwhiQLRbxQcA5XHD7Z3Cn0vfMZCVJOOOUPGXFwRybwbM2qVG6aIZvav9nesjU4WiawX2efbcn3upcW8LiK8+r7Q/MI6EgywgAAA==",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2748",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "3107",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "0.6 /",
    "Flow State": "Turbulent",
    Friction: "5461.21 /",
    "Friction Factor": "0.023216",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6548",
    Length: "359",
    Mark: "890",
    Material: "Copper",
    "Middle Elevation": "2748",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "1959.6",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "34275.12849",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "129",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2748",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "3107",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "2.8 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818817",
    Name: "M_Tee - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.31025506",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkPIbR62dSUqCLooRXBRuqga2kBMpEahlP67kdbdnOEMU41QXM15eGrI4eivptS30LjWaiBQeOPCC/JqnGNUpKCJVHKNTFCGKGGq/96m75shyrHYmeahg+4hZ5QROGnXhu4HKFVCoPShCcY7yDlFgTJLlOQyzVYZRwIXc19kzFICB23aLswsFIG91Z9lnSDlKhUEtt76eObe1k71F6jo/znTAAAA",
    Pbi3DGeometry:
      "IRwAAB+LCAAAAAAABADtV01P4zAQ/S8+Z6M4dr7KCcFKKy0HBEh7QD0UEUGk0Ky6WSSE+t8xjUvb2C8eF8TJqmjJjGfezLNn4rl9ZZd3zc3L35rN2O/urrnu2uaeReyya5b9Pza7fR3+VerkRH3YOtpJfvAkOdl8qT+2nm/NTlerxYuyzWQshMwjnsg44TyLUh5LyUV0oJCCvytEmedWhUzV704h4qqoqkkLUwHB7Yodhge4diXyUlKiMl3xQlnaMjcUpsUoD4LC7gpGRVCY4drBCZnDBLfsQoxUDAhlLjdiocWpz2p6BqPzYUGoxCdP2laBPKVFXukslGBjkA2KLM+0p8EgkRVl48z9IXty7hsM1lVgFj588z66humEOIia6hJjohDC5Im1sDT4eS+tkhQRrMVU5FwreGHhewLC1ZdHSRueYC91G7j6hrNdk2Py6NYjC8gstkDtDG2RfT3hjeN6bX9EVOruJFSyeweTfgFwnViE4OiwFpaQo0IWhxGVmtWtwUg+Bp4WIy8D6l7lHqw35dPrUfT09alPUigY73cVNAAAkAX76x/iInbsLICyQ70ao37BJQVvLKDA85zZGSCemiMbkuMQm3JUyhAX1Tixlg933OxRENezeXn3KEjEZNcx5PQhy3nzPXrCI9ySvmNec7oK81qY18K8Fua1MK+FeS3Ma2FeC/NamNemVod5LcxrXzmvzSN23iye6r5esVkSJxG7qJcP/aN+uOr6Rd90S/34p7n/UP2qm4fHXj/8bOvn/YVnXdsph8v/bbuevwH9CI+iIRwAAA==",
    Angle: "90.00°",
    "Angle 1": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "24",
    "Center to End Label": "24",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Tee",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1077",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "20 mmø-20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818818",
    Name: "Pipe Types: Standard",
    Category: "Pipes",
    temperature: "19.336794",
    Cost: "0",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjkELgkAUhP/LOy/L6q6r2SkqCOogEXQQD0qLPth2w7ZAxP/ekpZ06vbmfcPM5D1kFZ66m4IU9rbCzOqutgYIZBaNu0Oa9+PpDTKhjAXxMmCCMpHAQGYWCcq5kH8Yp4s4+mFz5sSKT/WqbcvO9/vHBsurcqqFlFFG4KBM7ZpJHK0rHfrJozzj5Yt2CuvGvYUMIwJbrZ6TNwwoj7kksLba+lzz0HooXlssd2YPAQAA",
    Pbi3DGeometry:
      "5QgAAB+LCAAAAAAABAClVltLwzAU/i95jiFpst72JCoI+jBU8GHsoWNlC9RGahXG6H83ndX1ktOeIqWlOV+/c8m5pOsTWW31y/E9JTF5MFv9bDK9I5SsjM7LDxKvTz+vFuZLe5GKXiRXgvPl+WFvUm1+addFkRwt1w8Z5yKggivGlRdQTzDFVUQ7gBCLGpCB9LuAtIIaCL2Q4lQ1jBp3mVDSFy1Asijk3kynQNtT8WGNI7xyqIrUMPCLfLiF7vh6theKSan8YTY6QFtVB2jviItxDsNloybiNE2Z6DkFxjcWOOit23g3GwhN/3HKER+UcXCroKaBkgF9Pz9JkAV3mSMLB9EwSALCp+nWm1EELsKYHDM+IE3IQYQgIH1ylmUPQPYEyHACY8N8fhfBcxPDwHkFnnvzRzDIAAHU+QaqmnVM1wz7z3Crk7e0TAsSc8YpeUzzfXloFk+mTEpt8mb5qnd/0H2q94eyWdxl6Vf7wxuTGasw/8yyavMNJmvYquUIAAA=",
    "Additional Flow": "0.0 /",
    Area: "0",
    "Bottom Elevation": "2715",
    "Calculated Heating Load": "0",
    "Connection Type": "Generic",
    "Design Option": "-1",
    Diameter: "20",
    "End Middle Elevation": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    Flow: "10.2 /",
    "Flow State": "Turbulent",
    Friction: "1107967.26 /",
    "Friction Factor": "0.014738",
    "Horizontal Justification": "Center",
    Image: "<None>",
    "Inside Diameter": "16",
    "Insulation Thickness": "0",
    "Invert Elevation": "6516",
    Length: "4166",
    Mark: "891",
    Material: "Copper",
    "Middle Elevation": "2724",
    "Outside Diameter": "19",
    "Overall Size": "20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pipe Segment": "Copper - A",
    "Pressure Drop": "4615479.7",
    "Reference Level": "Level 2",
    "Relative Roughness": "0.000157",
    "Reynolds Number": "612743.0866",
    Roughness: "0.003",
    "Schedule/Type": "A",
    Section: "48",
    Size: "20 mmø",
    Slope: "0.00%",
    "Start Middle Elevation": "2724",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Top Elevation": "2734",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    Velocity: "49.4 /",
    "Vertical Justification": "Middle",
  },
  {
    ID: "818823",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "20.36677236",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNzcsKwjAQBdB/mXUISdqkTVyJCoIuShFclC5aDW0gJlKjUEr/3fgCd3OHc2eqCYrWHMarBgU735pSn0LjOqsBQeGNCzdQ1fQZI+EpZlzwBSUpJpRymOufWw5DM0YcF2vTXHTQAyiCCYK9dl3oXyHWGILShyYY70BRzDOSSZEwkck0l0IgOJrzP95q0/XhfUkmOYKN1Y9vmzEsBIlm5a2Pz9zd2rl+Ats+rNvTAAAA",
    Pbi3DGeometry:
      "AhgAAB+LCAAAAAAABADtV8GK2zAQ/RedXSPJkixlT6UtFNrD0hZ6WHLIsmbX4MYldQvLkn+vGtlO19GTZFpKDyIkRJrMG83Mk+fl5olc37afHr82ZEPe9bftx75r70hBrvt2P3wjm5sn99Wa6ZV9kWNx3nnBKL06fdg3OW4nt5eHw+7R+kpRcqlkwWhVmloWnJdKUV782tea2X1RUm5qj8E6mKp6ZuDC+A0QCsWGSM4AkaxB6LTQMEQUSemToa5k7TUoC/kcafKQIrifDKQ0Y2HDXKcl1NIwZ5EMBT2mNHDzuHIOVCgXwqhwV3k1dU/wUwim6jDUfCgqjfOoRg85xhDCnUprGew3PhRCwqcNdwOS8PJizPuGOoOuI2mHC3WJBJOYQ3DmQggmEgmyrGy0FVKwk6GW4dBhCnqOhHsHubm6qfgmrc077pB+71PTOJcqfFtDpE0lJ6bU6nuPGxudGIui63piLRUOSaogncNpo8EaGpMXE8YYfzniE2NZcmOT8hYQx0D1wFBo5kIPVEJcKnQoWBGYHyxV3GNJ20hF1isjTwxIkqjauEBKZdUcItI/eMM9jY32L1Xg4ZrDEKuZDh+3mG1RKDTi/E90SJ0V2uEvCvr/UZ+nqurzgFsthf/8L8A/FeiRzLNCzwo9K/Ss0LNCzwo9K/Ss0LNCX63QtwV53e6+NENzIBta0oK8b/b3w8O4+NAPu6Ht9+Pyc3s3m9427f3DMC7edM2P33/4qu96C7j/3nXH7U9OIXdBAhgAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3124",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1081",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818827",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.04078677",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjT0LwjAYhP/LO4eQxCZp4iQqCDqUIjiUDlFDG4iJ1CiU0v9u/QK3u+O5u2qA4uj2/dWChm08utKekgmNt4CgiC6kG+hq+MgJ4RlmXPA5JRwrlQkY6x+36DrTT/AUrJy52GQ70AQTBDsbmtS+DCUZQ1DGZJKLATTFXBKpxIwJqbJcCYHg4M7/8Ma6pk3vJckUgrW3j2+bMSxyShEso4/TWbh7P9ZPOujDHdMAAAA=",
    Pbi3DGeometry:
      "EhgAAB+LCAAAAAAABADtV11L40AU/S/zHMN8f9QnUUFwH2QVfJA+VAwaiI3U7IJI//uOzVhtktNMFHb3YShtk5zeO3PPnDtzevNKLm7Lq5engszIeX1bXtZVeUcyclGXy+aZzG5e20sP00P/Iuvs48kBo/Rw8+HfZD1/DztarRYvPlbJnDuRMapyJ4zIOM8NMyp7ey7sLqCtchvASBMHGOnY/lRo7OhMW4B/s4iRRMy5N0DnlHH3OVEAfITRcgDwEYKx4VTDAEzlAWX5cAQEQqr38np1dACYCkb068DcaiFbQGuzARQbXqZthBS2BZy/2ERQtz+V5ixEULszKy7CrLTS7Rh2knQ+FIISocnC1cBMwcbw3+3YcpdzWDYkCqaCnEvNghKsipIIohYyyIQLIuSdOY0ODbusNyc0OGRq8rrCZvpC5Shieu+P1THAFRYPEu50gaKl/ULvQ3ZhL2PajQ6puGn3Yq32SRrWHXvE9c+NzknT40NbyQYXfBsRvSloK/TeMTAfMBU8emEE5BA6DjQrTAksEOsTRUDh4gJRHZCr6C131HbE91lHVwNKhAVCEuHSQl1BSkADwjnBESZrPX7LHRUo3Hjw0YG3XKSqv+Ds/2OjPmYI4IY73RLH/hn410a928fJqCejnox6MurJqCejnox6MurJqH/TqM8zclIuHoumWJEZzWlGfhTL++Yh3Pysm0VT1stwe13ebaGzorx/aMLNaVX8/vzD47qqfcLlr6paz/8AKk61uBIYAAA=",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "3124",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1084",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "818873",
    Name: "M_Elbow - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "21.28405152",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyEktTa2nkQFQQ+lCB5KD6ku7UJMpEahlP67USt4m5n3mHKAvKZjf0PIYO9qKvDstW0MAoPckfV3yMrhG4OiEh7P5HwpheQqSRWM1c9bdZ3ugxyGDekreuwgE1wwOKBtfPsuUsQRg8J57cnZCZ/o8k93SE3rP0xFKYOtweekR5LPkkXMYO2MC+/2YcxYvQDMLxx4xAAAAA==",
    Pbi3DGeometry:
      "xhcAAB+LCAAAAAAABADtVlFPwjAQ/i99nqRru3WDJ6MmJvpA1MQHwgOEBZZMZnCaEMJ/t7oy2Ni3dj6oDw2BsbvetffdXe+b7Mh4nj5tXxMyJHf5PH3Ms3RBPDLO03XxRoaTXflXqelIfcjeO0oufEpH3z/qS/bTg9nlZjPbKlsZDrgUzPOpP5Ccc4/5A0FF7NUUUfQl52pBXR74QadC8FDYeYJbGzydySMash8FYfQkRByVCiZPPQlfPdvkYW155QaIgRceB37beiRv+jmE1Tx9FS7yA9aD40M4BeVhqQiZzphKREcmBadSy5nQBqzTk2BSW4SinjHKAp1Kpg8V9KuWYxTAEz4tyINFZTd6QdAyQVJE9QzhsBFQyBMMIlBRlgra2Qvm5oGpiOJS7rN61HBr0D+oXmHmIEq9U4paqHfM0KBvs8MQIErGLj3r675VCRPav+GNfd2cDgBwHsd6hzgK9a0bG+q4PWz7SVaNBzROmnBwqQy75oz1PcAlbUf8sAXEA7pC4xXvbQSwSSrgmRAeEEAIFLSANWvGA3KjBlC2V6yJVli3VxUc2gCmDhcayKmxvRApO287hDesjt41bnvJGgsT3zaAypkpASymX6Ds/4iB241+dMP2pbwmgv9nFByc03Fwx8EdB3cc3HFwx8EdB3cc3HFwOw4+9ch1OntJimRDhnRAPXKfrJfFSr885MWsSPO1fn1OF5XqNkmXq0K/3GTJx+nCqzzLlcP1e5btp595TKV9xhcAAA==",
    Angle: "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center Radius": "17",
    "Center to End": "17",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2724",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "22",
    "Fitting Outside Radius": "11",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "11",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Regular 45, 90 and 180 Elbow",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "1-Feb",
    "Maximum Size": "20",
    "Minimum Size": "20",
    "Nominal Diameter": "20",
    "Nominal Radius": "10",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "20 mmø-20 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "2825.6",
    Size: "20 mmø-20 mmø",
    "System Classification": "Hydronic Return",
    "System Name": "Hydronic Return",
    "System Type": "Hydronic Return",
    "Tick Size": "9",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
  {
    ID: "972753",
    Name: "M_Cross - Generic: Standard",
    Category: "Pipe Fittings",
    temperature: "22.47581322",
    Cost: "0",
    Level: "Level 2",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA1jMEKgkAURf/lrUdxHHXCVlFBUAuRoIW4GOuhD6aZsCkQ8d+b0nb33nO41QhFQ+fhgZDD0TZU4tUp02oEBoUl456QV+McvRLEWShkxteB4KFciQSm+i9u+l4N3vbDjtQdHfaQR2HE4ISmdd23cJEmDErrlCNrFnyh20yjTEoGB6S2c7+expzBXuN70WO+PGyttv7dvLSe6g/FMqqvxQAAAA==",
    Pbi3DGeometry:
      "jiQAAB+LCAAAAAAABADtVk1rwkAQ/S97jrL5NOqptIVCe5C20IN4UAwaSJNi04KI/72pGq07mexMzEHoIorJ882bmcw+Z7wRo1n8uv6IxEA8ZrP4JUviubDEKIvT/FMMxpv91wKWw+IlttbpTseWcrj7KN5iOylpN6vVdF1wO07Q9Tw3tDqu3e35Pc9y7K4d2J51jvQDf4eEKtCTXiUQyr7PjYXL40ip74Z9RAYgNanpG1BGc+Vv+hUdOAFKnSdAVaEgWDBQDKTgKUNEnwCDU5MbroM/0CZDQNehIOhIMTh4dy4bXboOpZ4GlRJ0WjAJugoBwMyLzMAHWu+QdArn2JANGtQYuPYeCF3lCYd9BSljSUcBjnmBYKUKFguXr1EBwY4p48X43IwJidl+D0msRECwEoAZA4QeTK8CYhGKYeRcJuBXh+J07JLHT+HQW0NpJz6AgIP0po2RpWvgNepPP19FGQv62dMSyEdCf4hQp1IYlCGmG6WeQjcXurcy/ovM5m82f7P5m83fbP5m8zebf/PNH1uWsPtXu/XXcMzab9Z+s/Zf/drPcU/dI2lTnD/wF1kBvyuhbzuVFAD457cVh4T30UAAALVDBKSrdJggj6uog0qvUZdWA6dDGZym6BuJDx7g1PSllWFl6OCVMrYmjk4btodS6GdPe1pRryIf4+b/XNUEwmHh+6pxe+P2xu2N2xu3/x9uP7HEXTx9j/JoJQayKy3xFKWLfHm4eM7yaR5n6eHyLZ4foYcoXizzw8V9En3//eFtlmRFwPQrSbaTH2V1DouOJAAA",
    "Angle 1": "90.00°",
    "Angle 2": "90.00°",
    "Angle 3": "90.00°",
    "Angle 4": "90.00°",
    "Angle 5": "90.00°",
    Area: "0",
    "Calculated Heating Load": "0",
    "Center to End": "21",
    "Center to End Label": "21",
    "Critical Path": "No",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "2650",
    Family: "Standard",
    "Family and Type": "Standard",
    "Fitting Outside Diameter": "16",
    "Fitting Outside Radius": "8",
    "Host Id": "-1",
    Image: "<None>",
    "Insulation Radius": "8",
    "Insulation Thickness": "0",
    IsCustom: "No",
    "K Coefficient": "0",
    "K Coefficient Table": "Converging/Diverging Tee/Wye",
    "Lookup Table Name": "M_Pipe Fitting - Generic",
    "Loss Method": "3bf616f9-6b98-4a21-80ff-da1120c8f6d6",
    Mark: "2-Feb",
    "Maximum Size": "15",
    "Minimum Size": "15",
    "Nominal Diameter": "15",
    "Nominal Radius": "8",
    "OmniClass Number": "23.60.30.11.14",
    "OmniClass Title": "Pipework Fittings",
    "Overall Size": "15 mmø-15 mmø-15 mmø-15 mmø",
    "Phase Created": "New Construction",
    "Phase Demolished": "None",
    "Pressure Drop": "0",
    Size: "15 mmø-15 mmø-15 mmø-15 mmø",
    "System Classification": "Fire Protection Wet",
    "System Name": "Fire Protection Wet 1",
    "System Type": "Fire Protection Wet 1",
    "Tick Size": "6",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Use Annotation Scale": "Yes",
    Volume: "0",
  },
];

export default advancedJson;
